export const DjangIOCache = {
    "ai_assistant": {
        "models": {
            "CopilotCustomization": {
                "__is_model": true,
                "__name__": "CopilotCustomization",
                "data_model": "ai_assistant.models.CopilotCustomization",
                "default_exclude_filters": {},
                "default_filters": {},
                "endpoint": "/api/copilotcustomization/",
                "fields": [
                    { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                    { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                    { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                    { "field_type": 3, "help_text": "", "name": "name", "verbose_name": "name" },
                    { "field_type": 3, "help_text": "", "name": "description", "verbose_name": "description" },
                    { "field_type": 3, "help_text": "", "name": "organization_name", "verbose_name": "organization name" },
                    { "field_type": 3, "help_text": "", "name": "organization_mission", "verbose_name": "organization mission" },
                    { "field_type": null, "help_text": "", "name": "organization_issues", "verbose_name": "organization issues" },
                    {
                        "field_type": 7,
                        "help_text": "",
                        "name": "user",
                        "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                        "verbose_name": "user"
                    },
                    {
                        "field_type": 7,
                        "help_text": "",
                        "name": "organization",
                        "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                        "verbose_name": "organization"
                    },
                    {
                        "field_type": 8,
                        "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                        "name": "limited_to_teams",
                        "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                        "verbose_name": "limited to teams"
                    }
                ]
            },
            "CustomizedSummary": {
                "__is_model": true,
                "__name__": "CustomizedSummary",
                "data_model": "ai_assistant.models.CustomizedSummary",
                "default_exclude_filters": {},
                "default_filters": {},
                "endpoint": "/api/customizedsummary/",
                "fields": [
                    { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                    { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                    { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                    { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                    { "field_type": 3, "help_text": "", "name": "summary_url", "verbose_name": "summary url" },
                    { "field_type": 3, "help_text": "", "name": "summary_text", "verbose_name": "summary text" },
                    { "field_type": 4, "help_text": "", "name": "object_id", "verbose_name": "object id" },
                    { "field_type": 3, "help_text": "", "name": "object_type", "verbose_name": "object type" },
                    { "field_type": 1, "help_text": "", "name": "is_default", "verbose_name": "is default" },
                    {
                        "field_type": 7,
                        "help_text": "",
                        "name": "copilot_customization",
                        "related_model": { "__module__": "ai_assistant.models", "__name__": "CopilotCustomization" },
                        "verbose_name": "copilot customization"
                    },
                    { "field_type": 3, "help_text": "", "name": "copilot_customization_hash", "verbose_name": "copilot customization hash" },
                    {
                        "field_type": 7,
                        "help_text": "",
                        "name": "user",
                        "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                        "verbose_name": "user"
                    },
                    {
                        "field_type": 7,
                        "help_text": "",
                        "name": "organization",
                        "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                        "verbose_name": "organization"
                    }
                ]
            }
        },
        "types": {
            "FeedbackType": {
                "__is_enum": true,
                "copied": { "key": "copied", "label": "Copied", "value": 2 },
                "thumbs_down": { "key": "thumbs_down", "label": "Thumbs Down", "value": 0 },
                "thumbs_up": { "key": "thumbs_up", "label": "Thumbs Up", "value": 1 }
            }
        }
    },
    "app": {
        "bill": {
            "models": {
                "Amendment": {
                    "__is_model": true,
                    "__name__": "Amendment",
                    "data_model": "app.bill.models.Amendment",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/amendment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentSource" },
                            "field_type": 4,
                            "help_text": "The source of this amendment",
                            "name": "source",
                            "verbose_name": "source"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the amendment was offerred.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentType" },
                            "field_type": 4,
                            "help_text": "The amendment's type, indicating the chmaber in which the amendment was offered.",
                            "name": "amendment_type",
                            "sheet_column": true,
                            "verbose_name": "Type of Amendment"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "Party of majority of sponsors",
                            "name": "primary_party",
                            "sheet_column": true,
                            "verbose_name": "Party"
                        },
                        { "field_type": 4, "help_text": "The amendment's number according to the Library of Congress's H.Amdt and S.Amdt numbering (just the integer part).", "name": "number", "verbose_name": "number" },
                        { "field_type": 4, "help_text": "The number given by rules.house.gov", "name": "rules_number", "verbose_name": "rules number" },
                        { "field_type": 4, "help_text": "The number given by the House if this is a House Amendment. House does numbers per bill, where congress.gov does overall.", "name": "house_number", "verbose_name": "house number" },
                        {
                            "field_type": 7,
                            "help_text": "The bill the amendment amends.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        { "field_type": 4, "help_text": "For House amendments, the sequence number of the amendment (unique within a bill).", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "", "name": "actions", "verbose_name": "actions" },
                        {
                            "field_type": 7,
                            "help_text": "The amendment an amendment amends, if that is the case",
                            "name": "amends_amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amends amendment"
                        },
                        { "field_type": 3, "help_text": "A description of the amendment.", "name": "description", "sheet_column": true, "sheets_tooltip_text": "Description of the amendments in your sheet", "verbose_name": "Description" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentStatus" },
                            "field_type": 4,
                            "help_text": "The amendment's current status.",
                            "name": "status",
                            "sheet_column": true,
                            "verbose_name": "Status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentRulesStatus" },
                            "field_type": 4,
                            "help_text": "The amendment's status according to rules.house.gov.",
                            "name": "rules_status",
                            "verbose_name": "rules status"
                        },
                        { "field_type": 2, "help_text": "The dms_id for each amendment, if applicable", "name": "dms_id", "verbose_name": "dms id" },
                        { "field_type": 5, "help_text": "The date that the amendment was last acted upon.", "name": "status_date", "sheet_column": true, "verbose_name": "Date of Last Action" },
                        { "field_type": 3, "help_text": "A title for the amendment.", "name": "title", "sheet_column": true, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The label for the amendment.", "name": "label", "sheet_column": true, "verbose_name": "Label" },
                        {
                            "field_type": 7,
                            "help_text": "The sponsor of the amendment.",
                            "name": "sponsor",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "sponsor"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The committee that sponsored the amendment",
                            "name": "sponsor_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "sponsor committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the sponsor of the amendment at the time the amendment was offered.",
                            "name": "sponsor_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "sponsor role"
                        },
                        { "field_type": 4, "help_text": "Number of cosponsors that a amendment has.", "name": "num_cosponsors", "sheet_column": true, "verbose_name": "Number of Cosponsors" },
                        { "field_type": 5, "help_text": "The date the amendment was offered.", "name": "offered_date", "verbose_name": "offered date" },
                        { "field_type": 1, "help_text": "", "name": "missing_data", "verbose_name": "missing data" },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the amendment was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region that the amendment belongs to.",
                            "name": "region",
                            "sheet_column": true,
                            "verbose_name": "Region"
                        },
                        { "field_type": 3, "help_text": "Full text of the amendment.", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "Number of words in this Amendment text, useful for fts vector heuristics", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "The sponsors of this amendment.",
                            "name": "sponsors",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Sponsor" },
                            "verbose_name": "sponsors"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this amendment has been tagget with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "AmendmentSection": {
                    "__is_model": true,
                    "__name__": "AmendmentSection",
                    "data_model": "app.bill.models.AmendmentSection",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/amendmentsection/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "root", "verbose_name": "root" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "parent",
                            "related_model": { "__module__": "app.bill.models", "__name__": "AmendmentSection" },
                            "verbose_name": "parent"
                        },
                        {
                            "field_type": 7,
                            "help_text": "related amendment text obj",
                            "name": "amendment_text",
                            "related_model": { "__module__": "app.bill.models", "__name__": "AmendmentText" },
                            "verbose_name": "amendment text"
                        },
                        { "field_type": 4, "help_text": "order inside amendment_text", "name": "order", "verbose_name": "order" },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 10, "help_text": "", "name": "section_vector", "verbose_name": "section vector" },
                        { "field_type": 3, "help_text": "", "name": "cleaned_text", "verbose_name": "cleaned text" },
                        { "field_type": 4, "help_text": "Total number of words in cleaned text", "name": "cleaned_text_length", "verbose_name": "cleaned text length" },
                        { "field_type": 3, "help_text": "", "name": "header", "verbose_name": "header" },
                        { "field_type": 3, "help_text": "", "name": "enum", "verbose_name": "enum" },
                        { "field_type": 3, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "", "name": "children_html", "verbose_name": "children html" }
                    ]
                },
                "AmendmentStatus": {
                    "__is_enum": true,
                    "failed": { "full_name": "Failed", "key": "failed", "label": "Failed", "slug": "failed", "value": 3 },
                    "offered": { "full_name": "Offered", "key": "offered", "label": "Offered", "slug": "offered", "value": 1 },
                    "passed": { "full_name": "Passed", "key": "passed", "label": "Passed", "slug": "passed", "value": 2 },
                    "withdrawn": { "full_name": "Withdrawn", "key": "withdrawn", "label": "Withdrawn", "slug": "withdrawn", "value": 4 }
                },
                "AmendmentText": {
                    "__is_model": true,
                    "__name__": "AmendmentText",
                    "data_model": "app.bill.models.AmendmentText",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/amendmenttext/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The related bill",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The related amendments",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        { "field_type": 2, "help_text": "unique dms_id and 0-padded version number (last 3 digits) for each amendment", "name": "dms_version_id", "verbose_name": "dms version id" },
                        { "field_type": 2, "help_text": "url of amendment text", "name": "pdf_url", "verbose_name": "pdf url" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentType" },
                            "field_type": 4,
                            "help_text": "The type of text",
                            "name": "text_type",
                            "verbose_name": "text type"
                        },
                        { "field_type": 2, "help_text": "The type of text", "name": "text_type_string", "verbose_name": "text type string" },
                        { "field_type": 3, "help_text": "", "name": "legis_num", "verbose_name": "legis num" },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "the version number", "name": "version_number", "verbose_name": "version number" },
                        { "field_type": 16, "help_text": "The date and time of this version of amendment text", "name": "modified_date", "verbose_name": "modified date" },
                        { "field_type": null, "help_text": "", "name": "data", "verbose_name": "data" },
                        { "field_type": 1, "help_text": "", "name": "most_recent", "verbose_name": "most recent" }
                    ]
                },
                "AmendmentType": {
                    "__is_enum": true,
                    "house_amendment": { "full_name": "House Amendment", "key": "house_amendment", "label": "H.Amdt.", "search_help_text": "House amendments", "slug": "h", "type_slug": "HAMDT", "value": 2 },
                    "senate_amendment": { "full_name": "Senate Amendment", "key": "senate_amendment", "label": "S.Amdt.", "search_help_text": "Senate amendments", "slug": "s", "type_slug": "SAMDT", "value": 1 }
                },
                "Bill": {
                    "__is_model": true,
                    "__name__": "Bill",
                    "data_model": "app.bill.models.Bill",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/bill/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        { "field_type": 3, "help_text": "The bill's primary display title, including its number.", "name": "title", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 8, "verbose_name": "Title" },
                        { "field_type": null, "help_text": "", "name": "titles", "verbose_name": "titles" },
                        {
                            "field_type": 2,
                            "help_text": "Bill's type and number without state abbreviation (e.g. HB 1, SB 24)",
                            "name": "label",
                            "region_specific_dict": {
                                "belgium": { "label": "Legislation #" },
                                "czechia": { "label": "Legislation #" },
                                "denmark": { "label": "Legislation #" },
                                "eu": { "label": "Legislation #" },
                                "france": { "label": "Legislation #" },
                                "germany": { "label": "Legislation #" },
                                "ireland": { "label": "Legislation #" },
                                "italy": { "label": "Legislation #" },
                                "netherlands": { "label": "Legislation #" },
                                "poland": { "label": "Legislation #" },
                                "spain": { "label": "Legislation #" },
                                "sweden": { "label": "Legislation #" }
                            },
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 8,
                            "verbose_name": "Bill Label without Title"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "BillType" },
                            "field_type": 4,
                            "help_text": "The bill's type (e.g. H.R., S., H.J.Res. etc.)",
                            "name": "bill_type",
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "sheets_display_key": "full_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the bill was introduced.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        { "field_type": 4, "help_text": "Bill number without the type or state abbreviation (e.g. 24, 214)", "name": "number", "overriden_column_data_type": 2, "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 8, "verbose_name": "Bill Number" },
                        { "field_type": 4, "help_text": "The bill's draft number (distinct from the actual bill number), if applicable.", "name": "draft_number", "verbose_name": "draft number" },
                        { "field_type": 2, "help_text": "If enacted, the public law number the bill becomes.", "name": "public_law_number", "verbose_name": "public law number" },
                        {
                            "field_type": 7,
                            "help_text": "The primary sponsor of the bill.",
                            "name": "sponsor",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "sponsor"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the primary sponsor of the bill at the time the bill was introduced.",
                            "name": "sponsor_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "sponsor role"
                        },
                        { "field_type": 4, "help_text": "Number of committees a bill has been assigned to.", "name": "num_committees", "verbose_name": "num committees" },
                        {
                            "field_type": 7,
                            "help_text": "The top term associated with the bill.",
                            "name": "top_term",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "top term"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "BillStatus" },
                            "field_type": 4,
                            "help_text": "A more specific status of the bill.",
                            "name": "current_status",
                            "verbose_name": "Detailed Status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "GeneralBillStatus" },
                            "enum_sorting_attr": "value",
                            "field_type": 4,
                            "help_text": "The current status of the bill.",
                            "name": "current_general_status",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_subcategory": 10,
                            "verbose_name": "Status Text"
                        },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill corresponding to the current_status.", "name": "current_status_date", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 10, "sheets_tooltip_text": "The date of the Detailed Status of the Bills in your sheet.", "verbose_name": "Detailed Status Date" },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill.", "name": "most_recent_action_date", "verbose_name": "Most Recent Action Date" },
                        { "field_type": 5, "help_text": "The date the bill was introduced.", "name": "introduced_date", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 10, "verbose_name": "Date Introduced" },
                        {
                            "field_type": 7,
                            "help_text": "The public organization to which the bill nominates the person(s) to join",
                            "name": "organization_nominated_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "organization nominated to"
                        },
                        { "field_type": 2, "help_text": "The CELEX number of this bill.             Only valid for EU legislation taken from Eur-Lex", "name": "celex_number", "verbose_name": "celex number" },
                        { "field_type": 2, "help_text": "The legislative procedure code corresponding to this piece of legislation.", "name": "procedure_code", "verbose_name": "procedure code" },
                        {
                            "field_type": 4,
                            "help_text": "Number of cosponsors that a bill has.",
                            "name": "num_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Number of Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of male cosponsors that a bill has.", "name": "num_male_cosponsors", "verbose_name": "Number of Male Cosponsors" },
                        { "field_type": 4, "help_text": "Number of female cosponsors that a bill has.", "name": "num_female_cosponsors", "verbose_name": "Number of Female Cosponsors" },
                        {
                            "field_type": 4,
                            "help_text": "Number republican of cosponsors that a bill has.",
                            "name": "num_republican_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 6,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Republican Cosponsors"
                        },
                        {
                            "field_type": 4,
                            "help_text": "Number of democratic cosponsors that a bill has.",
                            "name": "num_democrat_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Democratic Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of independent cosponsors that a bill has.", "name": "num_independent_cosponsors", "verbose_name": "# of Independent Cosponsors" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted to http://docs.house.gov (which is different from the date it was expected to be debated).", "name": "docs_house_gov_postdate", "verbose_name": "docs house gov postdate" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted on the Senate Floor Schedule (which is different from the date it was expected to be debated).", "name": "senate_floor_schedule_postdate", "verbose_name": "senate floor schedule postdate" },
                        { "field_type": null, "help_text": "", "name": "major_actions", "verbose_name": "major actions" },
                        { "field_type": 4, "help_text": "The number of days since a last major action was taken on the bill.", "name": "days_since_last_major_action", "verbose_name": "Days Since Major Action" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "most_recent_text", "verbose_name": "most recent text" },
                        { "field_type": 4, "help_text": "", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": 4, "help_text": "", "name": "amendment_count", "verbose_name": "amendment count" },
                        { "field_type": 4, "help_text": "", "name": "vote_count", "verbose_name": "vote count" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "last_action",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillAction" },
                            "verbose_name": "last action"
                        },
                        { "field_type": 2, "help_text": "For enacted laws, whether the law is a public (PUB) or private (PRI) law. Unique with congress and sliplawnum.", "name": "sliplawpubpriv", "verbose_name": "sliplawpubpriv" },
                        { "field_type": 4, "help_text": "For enacted laws, the slip law number (i.e. the law number in P.L. XXX-123). Unique with congress and sliplawpublpriv.", "name": "sliplawnum", "verbose_name": "sliplawnum" },
                        { "field_type": 2, "help_text": "The primary source for this bill's metadata.", "name": "source", "verbose_name": "source" },
                        { "field_type": 2, "help_text": "A link to the page on the primary source website for this bill", "name": "source_link", "verbose_name": "Source Link" },
                        { "field_type": null, "help_text": "A dictionary of post data used to make post requests for source links.", "name": "source_post_data", "verbose_name": "source post data" },
                        { "field_type": 1, "help_text": "", "name": "missing_data", "verbose_name": "missing data" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "enum_sorting_attr": "region_name",
                            "field_type": 4,
                            "help_text": "The region whose legislature the bill was introduced in.",
                            "name": "region",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_display_key": "region_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the bill was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": 2, "help_text": "The openstates_id for state bills.", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 16, "help_text": "Time this bill file was last updated in openstates API.", "name": "last_updated", "verbose_name": "last updated" },
                        { "field_type": 5, "help_text": "The last time this Bill or any of its associated objects was updated. This is used for figuring out recently changed bills and helping to manage alert dissemination.", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "Party of majority of sponsors. For Federal, party of the sponsor.",
                            "name": "primary_party",
                            "sheet_column": true,
                            "sheets_column_order": 3,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Primary Party"
                        },
                        { "field_type": 2, "help_text": "Slug of the bill label to be used in urls.", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 10, "help_text": "", "name": "title_vector", "verbose_name": "title vector" },
                        { "field_type": 4, "help_text": "", "name": "clean_title_length", "verbose_name": "clean title length" },
                        { "field_type": 2, "help_text": "", "name": "icon_url", "verbose_name": "icon url" },
                        { "field_type": 1, "help_text": "For Federal bills, whether this bill has been designated as an appropriations bill.", "name": "is_approps", "verbose_name": "is approps" },
                        { "field_type": null, "help_text": "", "name": "containment_array", "verbose_name": "containment array" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": null, "help_text": "", "name": "title_index", "verbose_name": "title index" },
                        { "field_type": 1, "help_text": "Whether of not bill text processed.", "name": "reprocessed", "verbose_name": "reprocessed" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "executive",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "executive"
                        },
                        { "field_type": null, "help_text": "The years this bill will be considered.", "name": "years_of_consideration", "verbose_name": "years of consideration" },
                        { "field_type": null, "help_text": "", "name": "cached_data", "verbose_name": "cached data" },
                        { "field_type": null, "help_text": "Represents the current state of this object, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        {
                            "field_type": 8,
                            "help_text": "Committees to which the bill has been referred.",
                            "name": "committees",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committees"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Subject areas associated with the bill.",
                            "name": "terms",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "terms"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The sponsors of this bill.",
                            "name": "sponsors",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Sponsor" },
                            "verbose_name": "Sponsors"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this bill has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "sheet_column": true,
                            "verbose_name": "issues"
                        }
                    ]
                },
                "BillSection": {
                    "__is_model": true,
                    "__name__": "BillSection",
                    "data_model": "app.bill.models.BillSection",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/billsection/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "root", "verbose_name": "root" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "parent",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillSection" },
                            "verbose_name": "parent"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The related bill.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "related bill text obj",
                            "name": "bill_text",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillText" },
                            "verbose_name": "bill text"
                        },
                        { "field_type": 4, "help_text": "order inside bill_text", "name": "order", "verbose_name": "order" },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 10, "help_text": "", "name": "section_vector", "verbose_name": "section vector" },
                        { "field_type": 3, "help_text": "", "name": "cleaned_text", "verbose_name": "cleaned text" },
                        { "field_type": 4, "help_text": "Total number of words in cleaned text", "name": "cleaned_text_length", "verbose_name": "cleaned text length" },
                        { "field_type": 3, "help_text": "", "name": "header", "verbose_name": "header" },
                        { "field_type": 3, "help_text": "", "name": "enum", "verbose_name": "enum" },
                        { "field_type": 3, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "", "name": "children_html", "verbose_name": "children html" }
                    ]
                },
                "BillSummary": {
                    "__is_model": true,
                    "__name__": "BillSummary",
                    "data_model": "app.bill.models.BillSummary",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/billsummary/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        { "field_type": 5, "help_text": "", "name": "created", "verbose_name": "created" },
                        { "field_type": 5, "help_text": "", "name": "modified", "verbose_name": "modified" },
                        { "field_type": 3, "help_text": "", "name": "content", "verbose_name": "content" },
                        { "field_type": 2, "help_text": "", "name": "summary_type", "verbose_name": "summary type" }
                    ]
                },
                "BillTerm": {
                    "__is_model": true,
                    "__name__": "BillTerm",
                    "data_model": "app.bill.models.BillTerm",
                    "default_exclude_filters": { "name": "all_terms", "name__icontains": "committee on" },
                    "default_filters": { "term_type": 2 },
                    "endpoint": "/api/billterm/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "TermType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "term_type",
                            "verbose_name": "term type"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 4, "help_text": "The id value used by NetworkX", "name": "term_id", "verbose_name": "term id" },
                        { "field_type": 2, "help_text": "A shorter abbreviation for the term for display.", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "Which icon to show for this issue.", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 1, "help_text": "", "name": "top_term", "verbose_name": "top term" },
                        { "field_type": 1, "help_text": "", "name": "current", "verbose_name": "current" },
                        { "field_type": 1, "help_text": "", "name": "new_bills", "verbose_name": "new bills" },
                        { "field_type": 1, "help_text": "", "name": "new_amendments", "verbose_name": "new amendments" },
                        { "field_type": 1, "help_text": "", "name": "new_votes", "verbose_name": "new votes" },
                        { "field_type": 1, "help_text": "", "name": "new_press_releases", "verbose_name": "new press releases" },
                        { "field_type": 1, "help_text": "", "name": "new_floor_statements", "verbose_name": "new floor statements" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "subterms",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "subterms"
                        }
                    ]
                },
                "BillText": {
                    "__is_model": true,
                    "__name__": "BillText",
                    "data_model": "app.bill.models.BillText",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/billtext/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The state text's Bill.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.text_version", "__name__": "BillTextVersion" },
                            "field_type": 4,
                            "help_text": "The type of text.",
                            "name": "text_type",
                            "verbose_name": "text type"
                        },
                        { "field_type": 2, "help_text": "The type of text.", "name": "text_type_string", "verbose_name": "text type string" },
                        { "field_type": 2, "help_text": "openstates_id", "name": "doc_id", "verbose_name": "doc id" },
                        { "field_type": 2, "help_text": "Url of version", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "PDF url of this text, on amazon.", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "Source URL of this bill, from a state website", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 3, "help_text": "URL to the AI summary of this bill", "name": "ai_summary_url", "verbose_name": "ai summary url" },
                        { "field_type": 3, "help_text": "The AI summary of this BillText.", "name": "ai_summary", "verbose_name": "ai summary" },
                        { "field_type": 3, "help_text": "The hash of the pdf_file used to generate the AI summary and cleaned text", "name": "ai_summary_processing_hash", "verbose_name": "ai summary processing hash" },
                        { "field_type": 21, "help_text": "The date the AI summary and cleaned text were generated", "name": "ai_summary_processing_at", "verbose_name": "ai summary processing at" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "the version number", "name": "version_number", "verbose_name": "version number" },
                        { "field_type": 1, "help_text": "", "name": "most_recent", "verbose_name": "most recent" },
                        { "field_type": 21, "help_text": "The date and time of this version of bill text.", "name": "modified_date", "verbose_name": "modified date" },
                        { "field_type": null, "help_text": "", "name": "data", "verbose_name": "data" }
                    ]
                },
                "BillType": {
                    "__is_enum": true,
                    "brazil_bill": {
                        "full_name": "Bill",
                        "key": "brazil_bill",
                        "label": "Bill",
                        "order": 1,
                        "search_display": "Bill",
                        "search_help_text": "Bills",
                        "show_in_enumeration": true,
                        "slug": "brazil-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [208],
                        "value": 27
                    },
                    "brazil_complimentary_bill": {
                        "full_name": "Complimentary Bill",
                        "key": "brazil_complimentary_bill",
                        "label": "Complimentary Bill",
                        "order": 2,
                        "search_display": "Complimentary Bill",
                        "search_help_text": "Complimentary Bills",
                        "show_in_enumeration": true,
                        "slug": "brazil-complimentary-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [208],
                        "value": 28
                    },
                    "brazil_conversion_bill": {
                        "full_name": "Conversion Bill",
                        "key": "brazil_conversion_bill",
                        "label": "Conversion Bill",
                        "order": 4,
                        "search_display": "Conversion Bill",
                        "search_help_text": "Conversion Bills",
                        "show_in_enumeration": true,
                        "slug": "brazil-conversion-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [208],
                        "value": 30
                    },
                    "brazil_draft_legislative_decree": {
                        "full_name": "Draft Legislative Decree",
                        "key": "brazil_draft_legislative_decree",
                        "label": "Draft Legislative Decree",
                        "order": 3,
                        "search_display": "Draft Legislative Decree",
                        "search_help_text": "Draft Legislative Decrees",
                        "show_in_enumeration": true,
                        "slug": "brazil-draft-legislative-decree",
                        "state_search_display": "Legislation",
                        "supported_regions": [208],
                        "value": 29
                    },
                    "brazil_proposal_to_amend_constitution": {
                        "full_name": "Proposal to Amend Constitution",
                        "key": "brazil_proposal_to_amend_constitution",
                        "label": "Proposal to Amend Constitution",
                        "order": 0,
                        "search_display": "Proposal to Amend Constitution",
                        "search_help_text": "Proposals to Amend Constitution",
                        "show_in_enumeration": true,
                        "slug": "brazil-proposal-to-amend-constitution",
                        "state_search_display": "Legislation",
                        "supported_regions": [208],
                        "value": 26
                    },
                    "canada_house_government": {
                        "full_name": "House Government Bill",
                        "key": "canada_house_government",
                        "label": "House Government Bill",
                        "order": 1,
                        "search_display": "House Government Bill",
                        "search_help_text": "House Government Bills",
                        "show_in_enumeration": true,
                        "slug": "canada-house-government-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [201],
                        "value": 16
                    },
                    "canada_private_member": {
                        "full_name": "Private Member's Bill",
                        "key": "canada_private_member",
                        "label": "Private Member's Bill",
                        "order": 0,
                        "search_display": "Private Member's Bill",
                        "search_help_text": "Private Member's Bills",
                        "show_in_enumeration": true,
                        "slug": "canada-private-member-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [201],
                        "value": 15
                    },
                    "canada_senate_government": {
                        "full_name": "Senate Government Bill",
                        "key": "canada_senate_government",
                        "label": "Senate Government Bill",
                        "order": 3,
                        "search_display": "Senate Government Bill",
                        "search_help_text": "Senate Government Bills",
                        "show_in_enumeration": true,
                        "slug": "canada-senate-government-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [201],
                        "value": 18
                    },
                    "canada_senate_private": {
                        "full_name": "Senate Private Bill",
                        "key": "canada_senate_private",
                        "label": "Senate Private Bill",
                        "order": 4,
                        "search_display": "Senate Private Bill",
                        "search_help_text": "Senate Private Bills",
                        "show_in_enumeration": true,
                        "slug": "canada-senate-private-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [201],
                        "value": 24
                    },
                    "canada_senate_public": {
                        "full_name": "Senate Public Bill",
                        "key": "canada_senate_public",
                        "label": "Senate Public Bill",
                        "order": 2,
                        "search_display": "Senate Public Bill",
                        "search_help_text": "Senate Public Bills",
                        "show_in_enumeration": true,
                        "slug": "canada-senate-public-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [201],
                        "value": 17
                    },
                    "eu_initiative": {
                        "full_name": "Initiative",
                        "key": "eu_initiative",
                        "label": "Initiative",
                        "order": 4,
                        "search_display": "Initiative",
                        "search_help_text": "Legislative Initiatives",
                        "show_in_enumeration": true,
                        "slug": "eu-initiative",
                        "state_search_display": "Legislation",
                        "supported_regions": [106],
                        "value": 14
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Senate",
                            "values": [2, 4, 6, 8, 12]
                        },
                        {
                            "display": "list",
                            "title": "House",
                            "values": [3, 1, 5, 7]
                        },
                        {
                            "display": "list",
                            "title": "Legislation ",
                            "values": [9, 10, 11]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Private Member Bills",
                            "values": [15]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "House Government Bills",
                            "values": [16]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Senate Public Bills",
                            "values": [17]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Senate Government Bills",
                            "values": [18]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Senate Private Bills",
                            "values": [24]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Legislation ",
                            "values": [25]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Hybrid Bills",
                            "values": [19]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Private Bills",
                            "values": [20]
                        },
                        {
                            "display": "list",
                            "title": "Public Bills",
                            "values": [21, 22, 23]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Proposal to Amend Constitution",
                            "values": [26]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Bill",
                            "values": [27]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Complimentary Bill",
                            "values": [28]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Draft Legislative Decree",
                            "values": [29]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Conversion Bill",
                            "values": [30]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Law Proposition",
                            "values": [31]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Bill",
                            "values": [32]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Popular Legislative Initiative",
                            "values": [33]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Bill",
                            "values": [34]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Law Proposal",
                            "values": [35]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Other Legislative Initiative",
                            "values": [36]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Royal Decree Law",
                            "values": [37]
                        }
                    ],
                    "france_bill": {
                        "full_name": "Bill",
                        "key": "france_bill",
                        "label": "Bill",
                        "order": 1,
                        "search_display": "Bill",
                        "search_help_text": "Bills",
                        "show_in_enumeration": true,
                        "slug": "france-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [205],
                        "value": 32
                    },
                    "france_proposition": {
                        "full_name": "Law Proposition",
                        "key": "france_proposition",
                        "label": "Law Proposition",
                        "order": 0,
                        "search_display": "Law Proposition",
                        "search_help_text": "Law Propositions",
                        "show_in_enumeration": true,
                        "slug": "france-proposition",
                        "state_search_display": "Legislation",
                        "supported_regions": [205],
                        "value": 31
                    },
                    "germany_bill": {
                        "full_name": "Bill",
                        "key": "germany_bill",
                        "label": "Bill",
                        "order": 0,
                        "search_display": "Bill",
                        "search_help_text": "Bills",
                        "show_in_enumeration": true,
                        "slug": "germany-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [203],
                        "value": 25
                    },
                    "house_bill": {
                        "chamber": 2,
                        "chamberless_name": "Bill",
                        "full_name": "House bill",
                        "key": "house_bill",
                        "label": "H.R.",
                        "order": 2,
                        "search_display": "Bill (H.R.)",
                        "search_help_text": "House bills (H.R.)",
                        "show_in_enumeration": true,
                        "slug": "hr",
                        "state_name": "bill lower",
                        "state_search_display": "House Bill",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3,
                        "xml_code": "h"
                    },
                    "house_concurrent_resolution": {
                        "chamber": 2,
                        "chamberless_name": "Concurent Resolution",
                        "full_name": "House concurrent resolution (H.Con.Res.)",
                        "key": "house_concurrent_resolution",
                        "label": "H.Con.Res.",
                        "order": 6,
                        "search_display": "Concurrent Resolution (H.Con.Res.)",
                        "search_help_text": "Concurrent resolutions originating in the House, which do not have the force of law",
                        "show_in_enumeration": true,
                        "slug": "hconres",
                        "state_name": "concurrent resolution lower",
                        "state_search_display": "House Concurrent Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5,
                        "xml_code": "hc"
                    },
                    "house_joint_resolution": {
                        "chamber": 2,
                        "chamberless_name": "Joint Resolution",
                        "full_name": "House joint resolution (H.J.Res.)",
                        "key": "house_joint_resolution",
                        "label": "H.J.Res.",
                        "order": 4,
                        "search_display": "Joint Resolution (H.J.Res.)",
                        "search_help_text": "Joint resolutions originating in the House, which may be used to enact laws or propose constitutional amendments",
                        "show_in_enumeration": true,
                        "slug": "hjres",
                        "state_name": "joint resolution lower",
                        "state_search_display": "House Joint Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 7,
                        "xml_code": "hj"
                    },
                    "house_resolution": {
                        "chamber": 2,
                        "chamberless_name": "Simple Resolution",
                        "full_name": "House simple resolution (H.Res.)",
                        "key": "house_resolution",
                        "label": "H.Res.",
                        "order": 8,
                        "search_display": "Simple Resolution (H.Res.)",
                        "search_help_text": "House simple resolutions, which do not have the force of law",
                        "show_in_enumeration": true,
                        "slug": "hres",
                        "state_name": "resolution lower",
                        "state_search_display": "House Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1,
                        "xml_code": "hr"
                    },
                    "legislative_decision": {
                        "full_name": "Decision (3D)",
                        "key": "legislative_decision",
                        "label": "Decision",
                        "order": 5,
                        "search_display": "Decision",
                        "search_help_text": "Legislative Decisions",
                        "show_in_enumeration": true,
                        "slug": "3D",
                        "state_search_display": "Decision",
                        "supported_regions": [106],
                        "value": 11
                    },
                    "legislative_directive": {
                        "full_name": "Directive (3L)",
                        "key": "legislative_directive",
                        "label": "Directive",
                        "order": 5,
                        "search_display": "Directive",
                        "search_help_text": "Legislative Directives",
                        "show_in_enumeration": true,
                        "slug": "3L",
                        "state_search_display": "Directive",
                        "supported_regions": [106],
                        "value": 10
                    },
                    "legislative_regulation": {
                        "full_name": "Regulation (3R)",
                        "key": "legislative_regulation",
                        "label": "Regulation",
                        "order": 5,
                        "search_display": "Regulation",
                        "search_help_text": "Legislative Regulations",
                        "show_in_enumeration": true,
                        "slug": "3R",
                        "state_search_display": "Regulation",
                        "supported_regions": [106],
                        "value": 9
                    },
                    "nomination": {
                        "chamber": 1,
                        "chamberless_name": "Nomination",
                        "full_name": "Presidential Nomination (PN)",
                        "key": "nomination",
                        "label": "Nomination",
                        "order": 8,
                        "search_display": "Nomination (PN)",
                        "search_help_text": "Presidential nomination before the Senate",
                        "show_in_enumeration": true,
                        "slug": "nom",
                        "state_search_display": "Presidential Nomination",
                        "supported_regions": [1, 10000],
                        "value": 12
                    },
                    "other_eu": {
                        "full_name": "Other",
                        "key": "other_eu",
                        "label": "Other",
                        "order": 5,
                        "show_in_enumeration": false,
                        "slug": "other",
                        "supported_regions": [106],
                        "value": 13
                    },
                    "senate_bill": {
                        "chamber": 1,
                        "chamberless_name": "Bill",
                        "full_name": "Senate bill",
                        "key": "senate_bill",
                        "label": "S.",
                        "order": 1,
                        "search_display": "Bill (S.)",
                        "search_help_text": "Senate bills (S.)",
                        "show_in_enumeration": true,
                        "slug": "s",
                        "state_name": "bill upper",
                        "state_search_display": "Senate Bill",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2,
                        "xml_code": "s"
                    },
                    "senate_concurrent_resolution": {
                        "chamber": 1,
                        "chamberless_name": "Concurent Resolution",
                        "full_name": "Senate concurrent resolution (S.Con.Res.)",
                        "key": "senate_concurrent_resolution",
                        "label": "S.Con.Res.",
                        "order": 5,
                        "search_display": "Concurrent Resolution (S.Con.Res.)",
                        "search_help_text": "Concurrent resolutions originating in the Senate, which do not have the force of law",
                        "show_in_enumeration": true,
                        "slug": "sconres",
                        "state_name": "concurrent resolution upper",
                        "state_search_display": "Senate Concurrent Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6,
                        "xml_code": "sc"
                    },
                    "senate_joint_resolution": {
                        "chamber": 1,
                        "chamberless_name": "Joint Resolution",
                        "full_name": "Senate joint resolution (S.J.Res.)",
                        "key": "senate_joint_resolution",
                        "label": "S.J.Res.",
                        "order": 3,
                        "search_display": "Joint Resolution (S.J.Res.)",
                        "search_help_text": "Joint resolutions originating in the Senate, which may be used to enact laws or propose constitutional amendments",
                        "show_in_enumeration": true,
                        "slug": "sjres",
                        "state_name": "joint resolution upper",
                        "state_search_display": "Senate Joint Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 8,
                        "xml_code": "sj"
                    },
                    "senate_resolution": {
                        "chamber": 1,
                        "chamberless_name": "Simple Resolution",
                        "full_name": "Senate simple resolution (S.Res.)",
                        "key": "senate_resolution",
                        "label": "S.Res.",
                        "order": 7,
                        "search_display": "Simple Resolution (S.Res.)",
                        "search_help_text": "Senate simple resolutions, which do not have the force of law",
                        "show_in_enumeration": true,
                        "slug": "sres",
                        "state_name": "resolution upper",
                        "state_search_display": "Senate Resolution",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4,
                        "xml_code": "sr"
                    },
                    "spain_bill": {
                        "full_name": "Bill",
                        "key": "spain_bill",
                        "label": "Bill",
                        "order": 1,
                        "search_display": "Bill",
                        "search_help_text": "Bills",
                        "show_in_enumeration": true,
                        "slug": "spain-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [211],
                        "value": 34
                    },
                    "spain_law_proposal": {
                        "full_name": "Law Proposal",
                        "key": "spain_law_proposal",
                        "label": "Law Proposal",
                        "order": 2,
                        "search_display": "Law Proposal",
                        "search_help_text": "Law Proposals",
                        "show_in_enumeration": true,
                        "slug": "spain-law-proposal",
                        "state_search_display": "Legislation",
                        "supported_regions": [211],
                        "value": 35
                    },
                    "spain_other_legislative_initiative": {
                        "full_name": "Other Legislative Initiative",
                        "key": "spain_other_legislative_initiative",
                        "label": "Other Legislative Initiative",
                        "order": 8,
                        "search_display": "Other Legislative Initiative",
                        "search_help_text": "Other Legislative Initiatives",
                        "show_in_enumeration": true,
                        "slug": "senate-regulation",
                        "state_search_display": "Legislation",
                        "supported_regions": [211],
                        "value": 36
                    },
                    "spain_popular_initiative": {
                        "full_name": "Popular Legislative Initiative",
                        "key": "spain_popular_initiative",
                        "label": "Popular Legislative Initiative",
                        "order": 0,
                        "search_display": "Popular Legislative Initiative",
                        "search_help_text": "Popular Legislative Initiatives",
                        "show_in_enumeration": true,
                        "slug": "spain-initiative",
                        "state_search_display": "Legislation",
                        "supported_regions": [211],
                        "value": 33
                    },
                    "spain_royal_decree_law": {
                        "full_name": "Royal Decree Law",
                        "key": "spain_royal_decree_law",
                        "label": "Royal Decree Law",
                        "order": 9,
                        "search_display": "Royal Decree Law",
                        "search_help_text": "Royal Decree Laws",
                        "show_in_enumeration": true,
                        "slug": "royal-decree-law",
                        "state_search_display": "Legislation",
                        "supported_regions": [211],
                        "value": 37
                    },
                    "uk_consolidation": {
                        "full_name": "Consolidation Bill",
                        "key": "uk_consolidation",
                        "label": "Consolidation Bill",
                        "order": 4,
                        "search_display": "Consolidation Bill",
                        "search_help_text": "Consolidation Bills",
                        "show_in_enumeration": true,
                        "slug": "uk-consolidation-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [204],
                        "value": 23
                    },
                    "uk_government": {
                        "full_name": "Government Bill",
                        "key": "uk_government",
                        "label": "Government Bill",
                        "order": 2,
                        "search_display": "Government Bill",
                        "search_help_text": "Government Bills",
                        "show_in_enumeration": true,
                        "slug": "uk-government-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [204],
                        "value": 21
                    },
                    "uk_hybrid": {
                        "full_name": "Hybrid Bill",
                        "key": "uk_hybrid",
                        "label": "Hybrid Bill",
                        "order": 1,
                        "search_display": "Hybrid Bill",
                        "search_help_text": "Hybrid Bills",
                        "show_in_enumeration": true,
                        "slug": "uk-hybrid-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [204],
                        "value": 19
                    },
                    "uk_private": {
                        "full_name": "Private Bill",
                        "key": "uk_private",
                        "label": "Private Bill",
                        "order": 2,
                        "search_display": "Private Bill",
                        "search_help_text": "Private Bills",
                        "show_in_enumeration": true,
                        "slug": "uk-private-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [204],
                        "value": 20
                    },
                    "uk_private_members": {
                        "full_name": "Private Members Bill",
                        "key": "uk_private_members",
                        "label": "Private Members Bill",
                        "order": 3,
                        "search_display": "Private Members Bill",
                        "search_help_text": "Private Members Bills",
                        "show_in_enumeration": true,
                        "slug": "uk-private-bill",
                        "state_search_display": "Legislation",
                        "supported_regions": [204],
                        "value": 22
                    }
                },
                "CollaboratorBill": {
                    "__is_model": true,
                    "__name__": "CollaboratorBill",
                    "data_model": "app.bill.models.CollaboratorBill",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/collaboratorbill/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        { "field_type": 3, "help_text": "The bill's primary display title, including its number.", "name": "title", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 8, "verbose_name": "Title" },
                        { "field_type": null, "help_text": "", "name": "titles", "verbose_name": "titles" },
                        {
                            "field_type": 2,
                            "help_text": "Bill's type and number without state abbreviation (e.g. HB 1, SB 24)",
                            "name": "label",
                            "region_specific_dict": {
                                "belgium": { "label": "Legislation #" },
                                "czechia": { "label": "Legislation #" },
                                "denmark": { "label": "Legislation #" },
                                "eu": { "label": "Legislation #" },
                                "france": { "label": "Legislation #" },
                                "germany": { "label": "Legislation #" },
                                "ireland": { "label": "Legislation #" },
                                "italy": { "label": "Legislation #" },
                                "netherlands": { "label": "Legislation #" },
                                "poland": { "label": "Legislation #" },
                                "spain": { "label": "Legislation #" },
                                "sweden": { "label": "Legislation #" }
                            },
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 8,
                            "verbose_name": "Bill Label without Title"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "BillType" },
                            "field_type": 4,
                            "help_text": "The bill's type (e.g. H.R., S., H.J.Res. etc.)",
                            "name": "bill_type",
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "sheets_display_key": "full_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the bill was introduced.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        { "field_type": 4, "help_text": "Bill number without the type or state abbreviation (e.g. 24, 214)", "name": "number", "overriden_column_data_type": 2, "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 8, "verbose_name": "Bill Number" },
                        { "field_type": 4, "help_text": "The bill's draft number (distinct from the actual bill number), if applicable.", "name": "draft_number", "verbose_name": "draft number" },
                        { "field_type": 2, "help_text": "If enacted, the public law number the bill becomes.", "name": "public_law_number", "verbose_name": "public law number" },
                        {
                            "field_type": 7,
                            "help_text": "The primary sponsor of the bill.",
                            "name": "sponsor",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "sponsor"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the primary sponsor of the bill at the time the bill was introduced.",
                            "name": "sponsor_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "sponsor role"
                        },
                        { "field_type": 4, "help_text": "Number of committees a bill has been assigned to.", "name": "num_committees", "verbose_name": "num committees" },
                        {
                            "field_type": 7,
                            "help_text": "The top term associated with the bill.",
                            "name": "top_term",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "top term"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "BillStatus" },
                            "field_type": 4,
                            "help_text": "A more specific status of the bill.",
                            "name": "current_status",
                            "verbose_name": "Detailed Status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "GeneralBillStatus" },
                            "enum_sorting_attr": "value",
                            "field_type": 4,
                            "help_text": "The current status of the bill.",
                            "name": "current_general_status",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_subcategory": 10,
                            "verbose_name": "Status Text"
                        },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill corresponding to the current_status.", "name": "current_status_date", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 10, "sheets_tooltip_text": "The date of the Detailed Status of the Bills in your sheet.", "verbose_name": "Detailed Status Date" },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill.", "name": "most_recent_action_date", "verbose_name": "Most Recent Action Date" },
                        { "field_type": 5, "help_text": "The date the bill was introduced.", "name": "introduced_date", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 10, "verbose_name": "Date Introduced" },
                        {
                            "field_type": 7,
                            "help_text": "The public organization to which the bill nominates the person(s) to join",
                            "name": "organization_nominated_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "organization nominated to"
                        },
                        { "field_type": 2, "help_text": "The CELEX number of this bill.             Only valid for EU legislation taken from Eur-Lex", "name": "celex_number", "verbose_name": "celex number" },
                        { "field_type": 2, "help_text": "The legislative procedure code corresponding to this piece of legislation.", "name": "procedure_code", "verbose_name": "procedure code" },
                        {
                            "field_type": 4,
                            "help_text": "Number of cosponsors that a bill has.",
                            "name": "num_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Number of Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of male cosponsors that a bill has.", "name": "num_male_cosponsors", "verbose_name": "Number of Male Cosponsors" },
                        { "field_type": 4, "help_text": "Number of female cosponsors that a bill has.", "name": "num_female_cosponsors", "verbose_name": "Number of Female Cosponsors" },
                        {
                            "field_type": 4,
                            "help_text": "Number republican of cosponsors that a bill has.",
                            "name": "num_republican_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 6,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Republican Cosponsors"
                        },
                        {
                            "field_type": 4,
                            "help_text": "Number of democratic cosponsors that a bill has.",
                            "name": "num_democrat_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Democratic Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of independent cosponsors that a bill has.", "name": "num_independent_cosponsors", "verbose_name": "# of Independent Cosponsors" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted to http://docs.house.gov (which is different from the date it was expected to be debated).", "name": "docs_house_gov_postdate", "verbose_name": "docs house gov postdate" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted on the Senate Floor Schedule (which is different from the date it was expected to be debated).", "name": "senate_floor_schedule_postdate", "verbose_name": "senate floor schedule postdate" },
                        { "field_type": null, "help_text": "", "name": "major_actions", "verbose_name": "major actions" },
                        { "field_type": 4, "help_text": "The number of days since a last major action was taken on the bill.", "name": "days_since_last_major_action", "verbose_name": "Days Since Major Action" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "most_recent_text", "verbose_name": "most recent text" },
                        { "field_type": 4, "help_text": "", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": 4, "help_text": "", "name": "amendment_count", "verbose_name": "amendment count" },
                        { "field_type": 4, "help_text": "", "name": "vote_count", "verbose_name": "vote count" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "last_action",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillAction" },
                            "verbose_name": "last action"
                        },
                        { "field_type": 2, "help_text": "For enacted laws, whether the law is a public (PUB) or private (PRI) law. Unique with congress and sliplawnum.", "name": "sliplawpubpriv", "verbose_name": "sliplawpubpriv" },
                        { "field_type": 4, "help_text": "For enacted laws, the slip law number (i.e. the law number in P.L. XXX-123). Unique with congress and sliplawpublpriv.", "name": "sliplawnum", "verbose_name": "sliplawnum" },
                        { "field_type": 2, "help_text": "The primary source for this bill's metadata.", "name": "source", "verbose_name": "source" },
                        { "field_type": 2, "help_text": "A link to the page on the primary source website for this bill", "name": "source_link", "verbose_name": "Source Link" },
                        { "field_type": null, "help_text": "A dictionary of post data used to make post requests for source links.", "name": "source_post_data", "verbose_name": "source post data" },
                        { "field_type": 1, "help_text": "", "name": "missing_data", "verbose_name": "missing data" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "enum_sorting_attr": "region_name",
                            "field_type": 4,
                            "help_text": "The region whose legislature the bill was introduced in.",
                            "name": "region",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_display_key": "region_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the bill was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": 2, "help_text": "The openstates_id for state bills.", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 16, "help_text": "Time this bill file was last updated in openstates API.", "name": "last_updated", "verbose_name": "last updated" },
                        { "field_type": 5, "help_text": "The last time this Bill or any of its associated objects was updated. This is used for figuring out recently changed bills and helping to manage alert dissemination.", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "Party of majority of sponsors. For Federal, party of the sponsor.",
                            "name": "primary_party",
                            "sheet_column": true,
                            "sheets_column_order": 3,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Primary Party"
                        },
                        { "field_type": 2, "help_text": "Slug of the bill label to be used in urls.", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 10, "help_text": "", "name": "title_vector", "verbose_name": "title vector" },
                        { "field_type": 4, "help_text": "", "name": "clean_title_length", "verbose_name": "clean title length" },
                        { "field_type": 2, "help_text": "", "name": "icon_url", "verbose_name": "icon url" },
                        { "field_type": 1, "help_text": "For Federal bills, whether this bill has been designated as an appropriations bill.", "name": "is_approps", "verbose_name": "is approps" },
                        { "field_type": null, "help_text": "", "name": "containment_array", "verbose_name": "containment array" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": null, "help_text": "", "name": "title_index", "verbose_name": "title index" },
                        { "field_type": 1, "help_text": "Whether of not bill text processed.", "name": "reprocessed", "verbose_name": "reprocessed" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "executive",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "executive"
                        },
                        { "field_type": null, "help_text": "The years this bill will be considered.", "name": "years_of_consideration", "verbose_name": "years of consideration" },
                        { "field_type": null, "help_text": "", "name": "cached_data", "verbose_name": "cached data" },
                        { "field_type": null, "help_text": "Represents the current state of this object, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        {
                            "field_type": 8,
                            "help_text": "Committees to which the bill has been referred.",
                            "name": "committees",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committees"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Subject areas associated with the bill.",
                            "name": "terms",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "terms"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The sponsors of this bill.",
                            "name": "sponsors",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Sponsor" },
                            "verbose_name": "Sponsors"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this bill has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "sheet_column": true,
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/newbill/"
                },
                "CollaboratorBillText": {
                    "__is_model": true,
                    "__name__": "CollaboratorBillText",
                    "data_model": "app.bill.models.CollaboratorBillText",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/collaboratorbilltext/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The state text's Bill.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.text_version", "__name__": "BillTextVersion" },
                            "field_type": 4,
                            "help_text": "The type of text.",
                            "name": "text_type",
                            "verbose_name": "text type"
                        },
                        { "field_type": 2, "help_text": "The type of text.", "name": "text_type_string", "verbose_name": "text type string" },
                        { "field_type": 2, "help_text": "openstates_id", "name": "doc_id", "verbose_name": "doc id" },
                        { "field_type": 2, "help_text": "Url of version", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "PDF url of this text, on amazon.", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "Source URL of this bill, from a state website", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 3, "help_text": "URL to the AI summary of this bill", "name": "ai_summary_url", "verbose_name": "ai summary url" },
                        { "field_type": 3, "help_text": "The AI summary of this BillText.", "name": "ai_summary", "verbose_name": "ai summary" },
                        { "field_type": 3, "help_text": "The hash of the pdf_file used to generate the AI summary and cleaned text", "name": "ai_summary_processing_hash", "verbose_name": "ai summary processing hash" },
                        { "field_type": 21, "help_text": "The date the AI summary and cleaned text were generated", "name": "ai_summary_processing_at", "verbose_name": "ai summary processing at" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "the version number", "name": "version_number", "verbose_name": "version number" },
                        { "field_type": 1, "help_text": "", "name": "most_recent", "verbose_name": "most recent" },
                        { "field_type": 21, "help_text": "The date and time of this version of bill text.", "name": "modified_date", "verbose_name": "modified date" },
                        { "field_type": null, "help_text": "", "name": "data", "verbose_name": "data" }
                    ],
                    "proxy_endpoint": "/api/newbilltext/"
                },
                "FullBillTerm": {
                    "__is_model": true,
                    "__name__": "FullBillTerm",
                    "data_model": "app.bill.models.FullBillTerm",
                    "default_exclude_filters": { "name": "all_terms", "name__icontains": "committee on" },
                    "default_filters": { "term_type": 2 },
                    "endpoint": "/api/fullbillterm/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "TermType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "term_type",
                            "verbose_name": "term type"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 4, "help_text": "The id value used by NetworkX", "name": "term_id", "verbose_name": "term id" },
                        { "field_type": 2, "help_text": "A shorter abbreviation for the term for display.", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "Which icon to show for this issue.", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 1, "help_text": "", "name": "top_term", "verbose_name": "top term" },
                        { "field_type": 1, "help_text": "", "name": "current", "verbose_name": "current" },
                        { "field_type": 1, "help_text": "", "name": "new_bills", "verbose_name": "new bills" },
                        { "field_type": 1, "help_text": "", "name": "new_amendments", "verbose_name": "new amendments" },
                        { "field_type": 1, "help_text": "", "name": "new_votes", "verbose_name": "new votes" },
                        { "field_type": 1, "help_text": "", "name": "new_press_releases", "verbose_name": "new press releases" },
                        { "field_type": 1, "help_text": "", "name": "new_floor_statements", "verbose_name": "new floor statements" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "subterms",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "subterms"
                        }
                    ],
                    "proxy_endpoint": "/api/billterm/"
                },
                "FullRelatedBill": {
                    "__is_model": true,
                    "__name__": "FullRelatedBill",
                    "data_model": "app.bill.models.FullRelatedBill",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/fullrelatedbill/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "related bill"
                        },
                        { "field_type": 2, "help_text": "", "name": "relation", "verbose_name": "relation" }
                    ]
                },
                "NewAmendment": {
                    "__is_model": true,
                    "__name__": "NewAmendment",
                    "data_model": "app.bill.models.NewAmendment",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newamendment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentSource" },
                            "field_type": 4,
                            "help_text": "The source of this amendment",
                            "name": "source",
                            "verbose_name": "source"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the amendment was offerred.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentType" },
                            "field_type": 4,
                            "help_text": "The amendment's type, indicating the chmaber in which the amendment was offered.",
                            "name": "amendment_type",
                            "sheet_column": true,
                            "verbose_name": "Type of Amendment"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "Party of majority of sponsors",
                            "name": "primary_party",
                            "sheet_column": true,
                            "verbose_name": "Party"
                        },
                        { "field_type": 4, "help_text": "The amendment's number according to the Library of Congress's H.Amdt and S.Amdt numbering (just the integer part).", "name": "number", "verbose_name": "number" },
                        { "field_type": 4, "help_text": "The number given by rules.house.gov", "name": "rules_number", "verbose_name": "rules number" },
                        { "field_type": 4, "help_text": "The number given by the House if this is a House Amendment. House does numbers per bill, where congress.gov does overall.", "name": "house_number", "verbose_name": "house number" },
                        {
                            "field_type": 7,
                            "help_text": "The bill the amendment amends.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        { "field_type": 4, "help_text": "For House amendments, the sequence number of the amendment (unique within a bill).", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "", "name": "actions", "verbose_name": "actions" },
                        {
                            "field_type": 7,
                            "help_text": "The amendment an amendment amends, if that is the case",
                            "name": "amends_amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amends amendment"
                        },
                        { "field_type": 3, "help_text": "A description of the amendment.", "name": "description", "sheet_column": true, "sheets_tooltip_text": "Description of the amendments in your sheet", "verbose_name": "Description" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentStatus" },
                            "field_type": 4,
                            "help_text": "The amendment's current status.",
                            "name": "status",
                            "sheet_column": true,
                            "verbose_name": "Status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "AmendmentRulesStatus" },
                            "field_type": 4,
                            "help_text": "The amendment's status according to rules.house.gov.",
                            "name": "rules_status",
                            "verbose_name": "rules status"
                        },
                        { "field_type": 2, "help_text": "The dms_id for each amendment, if applicable", "name": "dms_id", "verbose_name": "dms id" },
                        { "field_type": 5, "help_text": "The date that the amendment was last acted upon.", "name": "status_date", "sheet_column": true, "verbose_name": "Date of Last Action" },
                        { "field_type": 3, "help_text": "A title for the amendment.", "name": "title", "sheet_column": true, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The label for the amendment.", "name": "label", "sheet_column": true, "verbose_name": "Label" },
                        {
                            "field_type": 7,
                            "help_text": "The sponsor of the amendment.",
                            "name": "sponsor",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "sponsor"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The committee that sponsored the amendment",
                            "name": "sponsor_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "sponsor committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the sponsor of the amendment at the time the amendment was offered.",
                            "name": "sponsor_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "sponsor role"
                        },
                        { "field_type": 4, "help_text": "Number of cosponsors that a amendment has.", "name": "num_cosponsors", "sheet_column": true, "verbose_name": "Number of Cosponsors" },
                        { "field_type": 5, "help_text": "The date the amendment was offered.", "name": "offered_date", "verbose_name": "offered date" },
                        { "field_type": 1, "help_text": "", "name": "missing_data", "verbose_name": "missing data" },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the amendment was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region that the amendment belongs to.",
                            "name": "region",
                            "sheet_column": true,
                            "verbose_name": "Region"
                        },
                        { "field_type": 3, "help_text": "Full text of the amendment.", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "Number of words in this Amendment text, useful for fts vector heuristics", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "The sponsors of this amendment.",
                            "name": "sponsors",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Sponsor" },
                            "verbose_name": "sponsors"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this amendment has been tagget with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/amendment/"
                },
                "NewBill": {
                    "__is_model": true,
                    "__name__": "NewBill",
                    "data_model": "app.bill.models.NewBill",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newbill/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        { "field_type": 3, "help_text": "The bill's primary display title, including its number.", "name": "title", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 8, "verbose_name": "Title" },
                        { "field_type": null, "help_text": "", "name": "titles", "verbose_name": "titles" },
                        {
                            "field_type": 2,
                            "help_text": "Bill's type and number without state abbreviation (e.g. HB 1, SB 24)",
                            "name": "label",
                            "region_specific_dict": {
                                "belgium": { "label": "Legislation #" },
                                "czechia": { "label": "Legislation #" },
                                "denmark": { "label": "Legislation #" },
                                "eu": { "label": "Legislation #" },
                                "france": { "label": "Legislation #" },
                                "germany": { "label": "Legislation #" },
                                "ireland": { "label": "Legislation #" },
                                "italy": { "label": "Legislation #" },
                                "netherlands": { "label": "Legislation #" },
                                "poland": { "label": "Legislation #" },
                                "spain": { "label": "Legislation #" },
                                "sweden": { "label": "Legislation #" }
                            },
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 8,
                            "verbose_name": "Bill Label without Title"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "BillType" },
                            "field_type": 4,
                            "help_text": "The bill's type (e.g. H.R., S., H.J.Res. etc.)",
                            "name": "bill_type",
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "sheets_display_key": "full_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the bill was introduced.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        { "field_type": 4, "help_text": "Bill number without the type or state abbreviation (e.g. 24, 214)", "name": "number", "overriden_column_data_type": 2, "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 8, "verbose_name": "Bill Number" },
                        { "field_type": 4, "help_text": "The bill's draft number (distinct from the actual bill number), if applicable.", "name": "draft_number", "verbose_name": "draft number" },
                        { "field_type": 2, "help_text": "If enacted, the public law number the bill becomes.", "name": "public_law_number", "verbose_name": "public law number" },
                        {
                            "field_type": 7,
                            "help_text": "The primary sponsor of the bill.",
                            "name": "sponsor",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "sponsor"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the primary sponsor of the bill at the time the bill was introduced.",
                            "name": "sponsor_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "sponsor role"
                        },
                        { "field_type": 4, "help_text": "Number of committees a bill has been assigned to.", "name": "num_committees", "verbose_name": "num committees" },
                        {
                            "field_type": 7,
                            "help_text": "The top term associated with the bill.",
                            "name": "top_term",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "top term"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "BillStatus" },
                            "field_type": 4,
                            "help_text": "A more specific status of the bill.",
                            "name": "current_status",
                            "verbose_name": "Detailed Status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.status", "__name__": "GeneralBillStatus" },
                            "enum_sorting_attr": "value",
                            "field_type": 4,
                            "help_text": "The current status of the bill.",
                            "name": "current_general_status",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_subcategory": 10,
                            "verbose_name": "Status Text"
                        },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill corresponding to the current_status.", "name": "current_status_date", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 10, "sheets_tooltip_text": "The date of the Detailed Status of the Bills in your sheet.", "verbose_name": "Detailed Status Date" },
                        { "field_type": 5, "help_text": "The date of the last major action on the bill.", "name": "most_recent_action_date", "verbose_name": "Most Recent Action Date" },
                        { "field_type": 5, "help_text": "The date the bill was introduced.", "name": "introduced_date", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 10, "verbose_name": "Date Introduced" },
                        {
                            "field_type": 7,
                            "help_text": "The public organization to which the bill nominates the person(s) to join",
                            "name": "organization_nominated_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "organization nominated to"
                        },
                        { "field_type": 2, "help_text": "The CELEX number of this bill.             Only valid for EU legislation taken from Eur-Lex", "name": "celex_number", "verbose_name": "celex number" },
                        { "field_type": 2, "help_text": "The legislative procedure code corresponding to this piece of legislation.", "name": "procedure_code", "verbose_name": "procedure code" },
                        {
                            "field_type": 4,
                            "help_text": "Number of cosponsors that a bill has.",
                            "name": "num_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Number of Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of male cosponsors that a bill has.", "name": "num_male_cosponsors", "verbose_name": "Number of Male Cosponsors" },
                        { "field_type": 4, "help_text": "Number of female cosponsors that a bill has.", "name": "num_female_cosponsors", "verbose_name": "Number of Female Cosponsors" },
                        {
                            "field_type": 4,
                            "help_text": "Number republican of cosponsors that a bill has.",
                            "name": "num_republican_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 6,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Republican Cosponsors"
                        },
                        {
                            "field_type": 4,
                            "help_text": "Number of democratic cosponsors that a bill has.",
                            "name": "num_democrat_cosponsors",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "# of Democratic Cosponsors"
                        },
                        { "field_type": 4, "help_text": "Number of independent cosponsors that a bill has.", "name": "num_independent_cosponsors", "verbose_name": "# of Independent Cosponsors" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted to http://docs.house.gov (which is different from the date it was expected to be debated).", "name": "docs_house_gov_postdate", "verbose_name": "docs house gov postdate" },
                        { "field_type": 16, "help_text": "The date on which the bill was posted on the Senate Floor Schedule (which is different from the date it was expected to be debated).", "name": "senate_floor_schedule_postdate", "verbose_name": "senate floor schedule postdate" },
                        { "field_type": null, "help_text": "", "name": "major_actions", "verbose_name": "major actions" },
                        { "field_type": 4, "help_text": "The number of days since a last major action was taken on the bill.", "name": "days_since_last_major_action", "verbose_name": "Days Since Major Action" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "most_recent_text", "verbose_name": "most recent text" },
                        { "field_type": 4, "help_text": "", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": 4, "help_text": "", "name": "amendment_count", "verbose_name": "amendment count" },
                        { "field_type": 4, "help_text": "", "name": "vote_count", "verbose_name": "vote count" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "last_action",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillAction" },
                            "verbose_name": "last action"
                        },
                        { "field_type": 2, "help_text": "For enacted laws, whether the law is a public (PUB) or private (PRI) law. Unique with congress and sliplawnum.", "name": "sliplawpubpriv", "verbose_name": "sliplawpubpriv" },
                        { "field_type": 4, "help_text": "For enacted laws, the slip law number (i.e. the law number in P.L. XXX-123). Unique with congress and sliplawpublpriv.", "name": "sliplawnum", "verbose_name": "sliplawnum" },
                        { "field_type": 2, "help_text": "The primary source for this bill's metadata.", "name": "source", "verbose_name": "source" },
                        { "field_type": 2, "help_text": "A link to the page on the primary source website for this bill", "name": "source_link", "verbose_name": "Source Link" },
                        { "field_type": null, "help_text": "A dictionary of post data used to make post requests for source links.", "name": "source_post_data", "verbose_name": "source post data" },
                        { "field_type": 1, "help_text": "", "name": "missing_data", "verbose_name": "missing data" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "enum_sorting_attr": "region_name",
                            "field_type": 4,
                            "help_text": "The region whose legislature the bill was introduced in.",
                            "name": "region",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "sheets_display_key": "region_name",
                            "sheets_subcategory": 8,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the bill was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": 2, "help_text": "The openstates_id for state bills.", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 16, "help_text": "Time this bill file was last updated in openstates API.", "name": "last_updated", "verbose_name": "last updated" },
                        { "field_type": 5, "help_text": "The last time this Bill or any of its associated objects was updated. This is used for figuring out recently changed bills and helping to manage alert dissemination.", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "Party of majority of sponsors. For Federal, party of the sponsor.",
                            "name": "primary_party",
                            "sheet_column": true,
                            "sheets_column_order": 3,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Primary Party"
                        },
                        { "field_type": 2, "help_text": "Slug of the bill label to be used in urls.", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 10, "help_text": "", "name": "title_vector", "verbose_name": "title vector" },
                        { "field_type": 4, "help_text": "", "name": "clean_title_length", "verbose_name": "clean title length" },
                        { "field_type": 2, "help_text": "", "name": "icon_url", "verbose_name": "icon url" },
                        { "field_type": 1, "help_text": "For Federal bills, whether this bill has been designated as an appropriations bill.", "name": "is_approps", "verbose_name": "is approps" },
                        { "field_type": null, "help_text": "", "name": "containment_array", "verbose_name": "containment array" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": null, "help_text": "", "name": "title_index", "verbose_name": "title index" },
                        { "field_type": 1, "help_text": "Whether of not bill text processed.", "name": "reprocessed", "verbose_name": "reprocessed" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "executive",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "executive"
                        },
                        { "field_type": null, "help_text": "The years this bill will be considered.", "name": "years_of_consideration", "verbose_name": "years of consideration" },
                        { "field_type": null, "help_text": "", "name": "cached_data", "verbose_name": "cached data" },
                        { "field_type": null, "help_text": "Represents the current state of this object, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        {
                            "field_type": 8,
                            "help_text": "Committees to which the bill has been referred.",
                            "name": "committees",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committees"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Subject areas associated with the bill.",
                            "name": "terms",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "terms"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The sponsors of this bill.",
                            "name": "sponsors",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Sponsor" },
                            "verbose_name": "Sponsors"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this bill has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "sheet_column": true,
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/bill/"
                },
                "NewBillSummary": {
                    "__is_model": true,
                    "__name__": "NewBillSummary",
                    "data_model": "app.bill.models.NewBillSummary",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newbillsummary/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        { "field_type": 5, "help_text": "", "name": "created", "verbose_name": "created" },
                        { "field_type": 5, "help_text": "", "name": "modified", "verbose_name": "modified" },
                        { "field_type": 3, "help_text": "", "name": "content", "verbose_name": "content" },
                        { "field_type": 2, "help_text": "", "name": "summary_type", "verbose_name": "summary type" }
                    ],
                    "proxy_endpoint": "/api/billsummary/"
                },
                "NewBillText": {
                    "__is_model": true,
                    "__name__": "NewBillText",
                    "data_model": "app.bill.models.NewBillText",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newbilltext/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The state text's Bill.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.text_version", "__name__": "BillTextVersion" },
                            "field_type": 4,
                            "help_text": "The type of text.",
                            "name": "text_type",
                            "verbose_name": "text type"
                        },
                        { "field_type": 2, "help_text": "The type of text.", "name": "text_type_string", "verbose_name": "text type string" },
                        { "field_type": 2, "help_text": "openstates_id", "name": "doc_id", "verbose_name": "doc id" },
                        { "field_type": 2, "help_text": "Url of version", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "PDF url of this text, on amazon.", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "Source URL of this bill, from a state website", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 3, "help_text": "URL to the AI summary of this bill", "name": "ai_summary_url", "verbose_name": "ai summary url" },
                        { "field_type": 3, "help_text": "The AI summary of this BillText.", "name": "ai_summary", "verbose_name": "ai summary" },
                        { "field_type": 3, "help_text": "The hash of the pdf_file used to generate the AI summary and cleaned text", "name": "ai_summary_processing_hash", "verbose_name": "ai summary processing hash" },
                        { "field_type": 21, "help_text": "The date the AI summary and cleaned text were generated", "name": "ai_summary_processing_at", "verbose_name": "ai summary processing at" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.types.language", "__name__": "BillLanguage" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 4, "help_text": "the version number", "name": "version_number", "verbose_name": "version number" },
                        { "field_type": 1, "help_text": "", "name": "most_recent", "verbose_name": "most recent" },
                        { "field_type": 21, "help_text": "The date and time of this version of bill text.", "name": "modified_date", "verbose_name": "modified date" },
                        { "field_type": null, "help_text": "", "name": "data", "verbose_name": "data" }
                    ],
                    "proxy_endpoint": "/api/billtext/"
                },
                "NewSponsor": {
                    "__is_model": true,
                    "__name__": "NewSponsor",
                    "data_model": "app.bill.models.NewSponsor",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newsponsor/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "The original name given to this sponsor by a state website or EurLex (if EU).", "name": "state_name", "verbose_name": "state name" },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring person.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the sponsor at the time of sponsorship.",
                            "name": "role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "role"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring committee.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring public organization (mainly for EU)",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The bill being sponsored.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The amendment being sponsored.",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        { "field_type": 5, "help_text": "The date the sponsor was added. It is always greater than or equal to the bill's introduced_date.", "name": "joined", "verbose_name": "joined" },
                        { "field_type": 5, "help_text": "If the sponsor withdrew his/her support, the date of withdrawn. Otherwise empty.", "name": "withdrawn", "verbose_name": "withdrawn" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "SponsorType" },
                            "field_type": 4,
                            "help_text": "The type of sponsorship.",
                            "name": "sponsor_type",
                            "verbose_name": "sponsor type"
                        }
                    ],
                    "proxy_endpoint": "/api/sponsor/"
                },
                "Sponsor": {
                    "__is_model": true,
                    "__name__": "Sponsor",
                    "data_model": "app.bill.models.Sponsor",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/sponsor/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "The original name given to this sponsor by a state website or EurLex (if EU).", "name": "state_name", "verbose_name": "state name" },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring person.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the sponsor at the time of sponsorship.",
                            "name": "role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "role"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring committee.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The sponsoring public organization (mainly for EU)",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The bill being sponsored.",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The amendment being sponsored.",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        { "field_type": 5, "help_text": "The date the sponsor was added. It is always greater than or equal to the bill's introduced_date.", "name": "joined", "verbose_name": "joined" },
                        { "field_type": 5, "help_text": "If the sponsor withdrew his/her support, the date of withdrawn. Otherwise empty.", "name": "withdrawn", "verbose_name": "withdrawn" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.bill.models", "__name__": "SponsorType" },
                            "field_type": 4,
                            "help_text": "The type of sponsorship.",
                            "name": "sponsor_type",
                            "verbose_name": "sponsor type"
                        }
                    ]
                },
                "SponsorType": {
                    "__is_enum": true,
                    "author": {
                        "icon": "fa-certificate",
                        "key": "author",
                        "label": "Author",
                        "openstates_slug": "",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "brazil_sponsor": {
                        "icon": "fa-certificate",
                        "key": "brazil_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [208],
                        "value": 131
                    },
                    "canada_sponsor": {
                        "icon": "fa-certificate",
                        "key": "canada_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [201],
                        "value": 120
                    },
                    "committee_for_opinion": {
                        "icon": "fa-users",
                        "key": "committee_for_opinion",
                        "label": "Committee For Opinion",
                        "supported_regions": [106],
                        "value": 105
                    },
                    "council_configuration": {
                        "icon": "fa-users",
                        "key": "council_configuration",
                        "label": "Council Configuration",
                        "supported_regions": [106],
                        "value": 106
                    },
                    "france_sponsor": {
                        "icon": "fa-certificate",
                        "key": "france_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [205],
                        "value": 140
                    },
                    "germany_sponsor": {
                        "icon": "fa-certificate",
                        "key": "germany_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [203],
                        "value": 130
                    },
                    "org_nominated_to": {
                        "icon": "fa-star",
                        "key": "org_nominated_to",
                        "label": "Organization nominated to serve in",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "original_cosponsor": {
                        "icon": "fa-star",
                        "key": "original_cosponsor",
                        "label": "Original Cosponsor",
                        "openstates_slug": "cosponsor",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "other_cosponsor": {
                        "icon": "fa-star-o",
                        "key": "other_cosponsor",
                        "label": "Other Cosponsor",
                        "openstates_slug": "other cosponsor",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "primary": {
                        "icon": "fa-certificate",
                        "key": "primary",
                        "label": "Primary Sponsor",
                        "openstates_slug": "primary",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "rapporteur": {
                        "icon": "fa-certificate",
                        "key": "rapporteur",
                        "label": "Rapporteur",
                        "supported_regions": [106],
                        "value": 101
                    },
                    "rapporteur_for_opinion": {
                        "icon": "fa-certificate",
                        "key": "rapporteur_for_opinion",
                        "label": "Rapporteur For Opinion",
                        "supported_regions": [106],
                        "value": 103
                    },
                    "responsible_committee": {
                        "icon": "fa-users",
                        "key": "responsible_committee",
                        "label": "Responsible Committee",
                        "supported_regions": [106],
                        "value": 104
                    },
                    "shadow_rapporteur": {
                        "icon": "fa-certificate",
                        "key": "shadow_rapporteur",
                        "label": "Shadow Rapporteur",
                        "supported_regions": [106],
                        "value": 102
                    },
                    "spain_sponsor": {
                        "icon": "fa-certificate",
                        "key": "spain_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [211],
                        "value": 150
                    },
                    "uk_sponsor": {
                        "icon": "fa-certificate",
                        "key": "uk_sponsor",
                        "label": "Sponsor",
                        "supported_regions": [204],
                        "value": 110
                    }
                },
                "StateBillDocumentType": {
                    "__is_enum": true,
                    "amendment": { "key": "amendment", "label": "Amendment", "value": 1 },
                    "bill_analysis": { "key": "bill_analysis", "label": "Bill Analysis", "value": 16 },
                    "calendar": { "key": "calendar", "label": "Calendar", "value": 11 },
                    "changes_to_bill": { "key": "changes_to_bill", "label": "Changes to the Bill", "value": 10 },
                    "committee_and_related": { "key": "committee_and_related", "label": "Committee and Related", "value": 8 },
                    "enactments": { "key": "enactments", "label": "Enactments", "value": 24 },
                    "fiscal_note": { "key": "fiscal_note", "label": "Fiscal Note", "value": 4 },
                    "history_of_bill": { "key": "history_of_bill", "label": "History of the Bill", "value": 9 },
                    "legislator_statement": { "key": "legislator_statement", "label": "Legislator Statement", "value": 2 },
                    "letter_of_support": { "key": "letter_of_support", "label": "Letter of Support", "value": 5 },
                    "meeting_notices_and_agendas": { "key": "meeting_notices_and_agendas", "label": "Meeting Notice and Agenda", "value": 15 },
                    "minutes": { "key": "minutes", "label": "Minutes", "value": 22 },
                    "other": { "key": "other", "label": "Other", "value": 25 },
                    "policy_note": { "key": "policy_note", "label": "Policy Note", "value": 20 },
                    "reading": { "key": "reading", "label": "Reading", "value": 14 },
                    "report": { "key": "report", "label": "Report", "value": 17 },
                    "senate_fact_sheet": { "key": "senate_fact_sheet", "label": "Senate Fact Sheet", "value": 13 },
                    "statement_of_purpose": { "key": "statement_of_purpose", "label": "Statement of Purpose", "value": 18 },
                    "statements": { "key": "statements", "label": "Statements", "value": 23 },
                    "summary": { "key": "summary", "label": "Summary", "value": 12 },
                    "supporting_doc_opinion": { "key": "supporting_doc_opinion", "label": "Supporting Document - Opinion", "value": 6 },
                    "supporting_doc_research": { "key": "supporting_doc_research", "label": "Supporting Document - Research", "value": 7 },
                    "version": { "key": "version", "label": "Version of the Bill", "value": 3 },
                    "veto": { "key": "veto", "label": "Veto", "value": 21 },
                    "vote_history": { "key": "vote_history", "label": "Vote History", "value": 19 }
                }
            },
            "status": {
                "BillStatus": {
                    "__is_enum": true,
                    "act_adopted_commission": { "abbrev": "ADP_ACT_byCOM", "general_status": 110, "key": "act_adopted_commission", "label": "Adoption of act by Commission", "legislative_body": 1, "value": 1014 },
                    "adopted_commission": { "abbrev": "ADP_byCOM", "general_status": 101, "key": "adopted_commission", "label": "Adoption by Commission", "legislative_body": 1, "value": 1004 },
                    "adopted_council": { "abbrev": "ADP_FRM_byCONSIL", "general_status": 103, "key": "adopted_council", "label": "Adoption by Council", "legislative_body": 3, "value": 1011 },
                    "adopted_parliament": { "abbrev": "ADP_byEP", "general_status": 102, "key": "adopted_parliament", "label": "Adoption by EP", "legislative_body": 2, "value": 1012 },
                    "adopted_plenary_eesc": { "abbrev": "ADP_PLSL_byEESC", "general_status": 110, "key": "adopted_plenary_eesc", "label": "Adoption at plenary level", "legislative_body": 100, "value": 1002 },
                    "adopted_section_eesc": { "abbrev": "ADP_SL_byEESC", "general_status": 110, "key": "adopted_section_eesc", "label": "Adoption at section level", "legislative_body": 100, "value": 1003 },
                    "adopted_third_reading_council": { "abbrev": "ADP_R3_byCONSIL", "general_status": 107, "key": "adopted_third_reading_council", "label": "Adoption by the Council at 3rd reading", "legislative_body": 3, "value": 1013 },
                    "adopted_third_reading_parliament": { "abbrev": "ADP_R3_byEP", "general_status": 107, "key": "adopted_third_reading_parliament", "label": "EP adoption at 3rd reading", "legislative_body": 2, "value": 1092 },
                    "agreement_on_council_common_position": { "abbrev": "AGR_COMPOS_byCONSIL", "general_status": 103, "key": "agreement_on_council_common_position", "label": "Agreement on Council common position", "legislative_body": 3, "value": 1017 },
                    "amended_proposal_published": { "abbrev": "", "general_status": 110, "key": "amended_proposal_published", "label": "Amended proposal published", "legislative_body": 101, "value": 1200 },
                    "amended_proposal_transmit_to_council": { "abbrev": "TRS_toCONSIL_PROPAME_byCOM", "general_status": 102, "key": "amended_proposal_transmit_to_council", "label": "Transmission of the amended proposal to the Council", "legislative_body": 1, "value": 1163 },
                    "amended_proposal_transmit_to_parliament": { "abbrev": "TRS_EP_PROPAME_byCOM", "general_status": 104, "key": "amended_proposal_transmit_to_parliament", "label": "Transmission to EP of amended proposal", "legislative_body": 1, "value": 1169 },
                    "amendment_adopted_commission": { "abbrev": "ADP_PROPAME_byCOM", "general_status": 105, "key": "amendment_adopted_commission", "label": "Adoption by Commission of amended proposal", "legislative_body": 1, "value": 1005 },
                    "amendment_failed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-bookmark",
                        "key": "amendment_failed",
                        "label": "Amendment Failed",
                        "search_help_text": "Amendment Failed.",
                        "senate_general_status": 8,
                        "sort_order": [5, 4],
                        "state_code": "None",
                        "state_dc_label": "Amendment Failed",
                        "state_label": "Amendment Failed",
                        "state_other_label": "Amendment Failed",
                        "value": 87,
                        "xml_code": "None"
                    },
                    "amendment_passed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-bookmark",
                        "key": "amendment_passed",
                        "label": "Amendment Passed",
                        "search_help_text": "Amendment Passed.",
                        "senate_general_status": 8,
                        "sort_order": [5, 4],
                        "state_code": "None",
                        "state_dc_label": "Amendment Passed",
                        "state_label": "Amendment Passed",
                        "state_other_label": "Amendment Passed",
                        "value": 12,
                        "xml_code": "None"
                    },
                    "amendment_proposed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-bookmark",
                        "key": "amendment_proposed",
                        "label": "Amendment Proposed",
                        "search_help_text": "Amendment Proposed.",
                        "senate_general_status": 8,
                        "sort_order": [5, 4],
                        "state_code": "None",
                        "state_dc_label": "Amendment Proposed",
                        "state_label": "Amendment Proposed",
                        "state_other_label": "Amendment Proposed",
                        "value": 11,
                        "xml_code": "None"
                    },
                    "approval_by_committee": { "abbrev": "", "general_status": 110, "key": "approval_by_committee", "label": "Approval by committee", "legislative_body": 2, "value": 1201 },
                    "approved_commission": { "abbrev": "APR_byCOM", "general_status": 101, "key": "approved_commission", "label": "Approval by Commission", "legislative_body": 1, "value": 1018 },
                    "brazil_introduced": { "abbrev": "", "general_status": 140, "key": "brazil_introduced", "label": "Introduced", "state_label": "Introduced", "value": 1430 },
                    "brazil_passed_first": { "abbrev": "", "general_status": 141, "key": "brazil_passed_first", "label": "Passed First", "state_label": "Passed First", "value": 1431 },
                    "brazil_passed_second": { "abbrev": "", "general_status": 142, "key": "brazil_passed_second", "label": "Passed Second", "state_label": "Passed Second", "value": 1432 },
                    "brazil_sanction": { "abbrev": "", "general_status": 143, "key": "brazil_sanction", "label": "Sanction", "state_label": "Sanction", "value": 1433 },
                    "brazil_veto": { "abbrev": "", "general_status": 143, "key": "brazil_veto", "label": "Veto", "state_label": "Veto", "value": 1434 },
                    "budget_amendment_adopted_council": { "abbrev": "ADP_BUDAME_byCONSIL", "general_status": 110, "key": "budget_amendment_adopted_council", "label": "Council: adoption of amended budget", "legislative_body": 3, "value": 1053 },
                    "budget_signed_parliament": { "abbrev": "SIGN_BUD_byEP", "general_status": 110, "key": "budget_signed_parliament", "label": "Signature of budget by EP", "legislative_body": 2, "value": 1161 },
                    "budgetary_act_decision_council": { "abbrev": "DEC_BUDACT_byCONSIL", "general_status": 103, "key": "budgetary_act_decision_council", "label": "Council decision on budgetary act", "legislative_body": 3, "value": 1059 },
                    "budgetary_act_decision_parliament": { "abbrev": "DEC_BUDACT_byEP", "general_status": 110, "key": "budgetary_act_decision_parliament", "label": "EP decision on budgetary act", "legislative_body": 2, "value": 1112 },
                    "budgetary_act_opinion_council": { "abbrev": "OPI_BUDACT_byCONSIL", "general_status": 103, "key": "budgetary_act_opinion_council", "label": "Council opinion on budgetary act", "legislative_body": 3, "value": 1061 },
                    "budgetary_act_opinion_parliament": { "abbrev": "OPI_BUDACT_byEP", "general_status": 110, "key": "budgetary_act_opinion_parliament", "label": "EP opinion on budgetary act", "legislative_body": 2, "value": 1116 },
                    "calendars": { "abbrev": "", "general_status": 11, "house_general_status": 11, "icon": "fa-bookmark", "key": "calendars", "label": "Calendars", "search_help_text": "Placed on Senate calendar for future action", "senate_general_status": 11, "sort_order": 5, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 206, "xml_code": "" },
                    "canada_house_committee_consideration": { "abbrev": "", "general_status": 114, "key": "canada_house_committee_consideration", "label": "House Committee Consideration", "legislative_body": 110, "state_label": "House Committee Consideration", "value": 1358 },
                    "canada_house_first_reading": { "abbrev": "", "general_status": 114, "key": "canada_house_first_reading", "label": "House First Reading", "legislative_body": 110, "state_label": "House First Reading", "value": 1356 },
                    "canada_house_report": { "abbrev": "", "general_status": 114, "key": "canada_house_report", "label": "House Report", "legislative_body": 110, "state_label": "House Report", "value": 1359 },
                    "canada_house_second_reading": { "abbrev": "", "general_status": 114, "key": "canada_house_second_reading", "label": "House Second Reading", "legislative_body": 110, "state_label": "House Second Reading", "value": 1357 },
                    "canada_house_third_reading": { "abbrev": "", "general_status": 115, "key": "canada_house_third_reading", "label": "House Third Reading", "legislative_body": 110, "state_label": "House Third Reading", "value": 1360 },
                    "canada_royal_assent": { "abbrev": "", "general_status": 116, "key": "canada_royal_assent", "label": "Royal Assent", "legislative_body": 112, "state_label": "Royal Assent", "value": 1361 },
                    "canada_senate_committee_consideration": { "abbrev": "", "general_status": 114, "key": "canada_senate_committee_consideration", "label": "Senate Committee Consideration", "legislative_body": 111, "state_label": "Senate Committee Consideration", "value": 1353 },
                    "canada_senate_first_reading": { "abbrev": "", "general_status": 114, "key": "canada_senate_first_reading", "label": "Senate First Reading", "legislative_body": 111, "state_label": "Senate First Reading", "value": 1351 },
                    "canada_senate_pre_study": { "abbrev": "", "general_status": 114, "key": "canada_senate_pre_study", "label": "Senate Pre-Study", "legislative_body": 111, "state_label": "Senate Pre-Study", "value": 1350 },
                    "canada_senate_report": { "abbrev": "", "general_status": 114, "key": "canada_senate_report", "label": "Senate Report", "legislative_body": 111, "state_label": "Senate Report", "value": 1354 },
                    "canada_senate_second_reading": { "abbrev": "", "general_status": 114, "key": "canada_senate_second_reading", "label": "Senate Second Reading", "legislative_body": 111, "state_label": "Senate Second Reading", "value": 1352 },
                    "canada_senate_third_reading": { "abbrev": "", "general_status": 115, "key": "canada_senate_third_reading", "label": "Senate Third Reading", "legislative_body": 111, "state_label": "Senate Third Reading", "value": 1355 },
                    "change_of_legal_basis_commission": { "abbrev": "CH_LB_byCOM", "general_status": 110, "key": "change_of_legal_basis_commission", "label": "Change of legal basis by Commission", "legislative_body": 1, "value": 1023 },
                    "change_of_legal_basis_council": { "abbrev": "CH_LB_byCONSIL", "general_status": 110, "key": "change_of_legal_basis_council", "label": "Change of legal basis by Council", "legislative_body": 3, "value": 1024 },
                    "changes_following_entry_into_force_of_lisbon_treaty": { "abbrev": "CH_TLIS_byCOM", "general_status": 110, "key": "changes_following_entry_into_force_of_lisbon_treaty", "label": "Changes following entry into force of the Lisbon Treaty", "legislative_body": 1, "value": 1025 },
                    "commission_addendum": { "abbrev": "ADD_byCOM", "general_status": 110, "key": "commission_addendum", "label": "Addendum", "legislative_body": 1, "value": 1001 },
                    "commission_communication_on_council_position_first_reading_transmit_to_council": { "abbrev": "TRS_toCONSIL_CC_R1_byCOM", "general_status": 103, "key": "commission_communication_on_council_position_first_reading_transmit_to_council", "label": "Transmission to Council of Commission communication on Council\u2019s position at 1st reading", "legislative_body": 1, "value": 1166 },
                    "commission_communication_on_council_position_first_reading_transmit_to_parliament": { "abbrev": "TRS_EP_CC_POSR1_byCOM", "general_status": 103, "key": "commission_communication_on_council_position_first_reading_transmit_to_parliament", "label": "Transmission to Parliament of Commission communication on Council\u2019s position at 1st reading", "legislative_body": 1, "value": 1175 },
                    "commission_opinion_on_parliament_amendments_second_reading_transmit_to_council": { "abbrev": "TRS_toCONSIL_OP_R2_byCOM", "general_status": 104, "key": "commission_opinion_on_parliament_amendments_second_reading_transmit_to_council", "label": "Transmission to Council of Commission opinion on EP amendments on 2nd reading", "legislative_body": 1, "value": 1167 },
                    "commission_opinion_on_parliament_amendments_second_reading_transmit_to_parliament": { "abbrev": "TRS_EP_OPIAME_R2_byCOM", "general_status": 104, "key": "commission_opinion_on_parliament_amendments_second_reading_transmit_to_parliament", "label": "Transmission to EP of Commission opinion on EP amendments on 2nd reading", "legislative_body": 1, "value": 1170 },
                    "commission_transmit_to_council": { "abbrev": "TRS_toCONSIL__byCOM", "general_status": 103, "key": "commission_transmit_to_council", "label": "Transmission to the European Council", "legislative_body": 1, "value": 1176 },
                    "commission_transmit_to_european_council": { "abbrev": "TRS_toEURCOU_byCOM", "general_status": 110, "key": "commission_transmit_to_european_council", "label": "Transmission to the European Council", "legislative_body": 1, "value": 1177 },
                    "committee_consideration": { "abbrev": "", "general_status": 10, "house_general_status": 10, "icon": "fa-bookmark", "key": "committee_consideration", "label": "Under Committee Consideration", "search_help_text": "Under committee consideration for confirmation", "senate_general_status": 10, "sort_order": 3, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 203, "xml_code": "" },
                    "committee_discharged": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-minus",
                        "key": "committee_discharged",
                        "label": "Committee discharged",
                        "search_help_text": "Committee discharged",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Committee discharged",
                        "state_label": "Committee discharged",
                        "state_other_label": "Committee discharged",
                        "value": 63,
                        "xml_code": ""
                    },
                    "committee_of_ambassadors_decision": { "abbrev": "DEC_byACP_AMB", "general_status": 110, "key": "committee_of_ambassadors_decision", "label": "Decision of the ACP-EC Committee of Ambassadors", "legislative_body": 100, "value": 1070 },
                    "committee_opinion_first_reading_parliament": { "abbrev": "OPI_R1_byEP_CMT", "general_status": 102, "key": "committee_opinion_first_reading_parliament", "label": "EP Committee opinion on 1st reading", "legislative_body": 2, "value": 1096 },
                    "committee_opinion_on_assent_parliament": { "abbrev": "OPI_ASS_byEP_CMT", "general_status": 8, "key": "committee_opinion_on_assent_parliament", "label": "EP Committee opinion on assent", "legislative_body": 2, "value": 1099 },
                    "committee_opinion_on_budgetary_act_parliament": { "abbrev": "OPI_BUDACT_byEP_CMT", "general_status": 110, "key": "committee_opinion_on_budgetary_act_parliament", "label": "EP Committee opinion on budgetary act", "legislative_body": 2, "value": 1100 },
                    "committee_opinion_resolution_parliament": { "abbrev": "OPI_RES_byEP_CMT", "general_status": 8, "key": "committee_opinion_resolution_parliament", "label": "EP Committee opinion \u2013 resolution", "legislative_body": 2, "value": 1102 },
                    "committee_opinion_second_reading_parliament": { "abbrev": "OPI_R2_byEP_CMT", "general_status": 104, "key": "committee_opinion_second_reading_parliament", "label": "EP Committee opinion on 2nd reading", "legislative_body": 2, "value": 1097 },
                    "committee_opinion_single_reading_parliament": { "abbrev": "OPI_RSI_byEP_CMT", "general_status": 102, "key": "committee_opinion_single_reading_parliament", "label": "EP Committee opinion on single reading", "legislative_body": 2, "value": 1101 },
                    "committee_opinion_third_reading_parliament": { "abbrev": "OPI_R3_byEP_CMT", "general_status": 107, "key": "committee_opinion_third_reading_parliament", "label": "EP Committee opinion on 3rd reading", "legislative_body": 2, "value": 1098 },
                    "committee_report_first_reading_parliament": { "abbrev": "REP_R1_byEP_CMT", "general_status": 102, "key": "committee_report_first_reading_parliament", "label": "EP Committee report on 1st reading", "legislative_body": 2, "value": 1103 },
                    "committee_report_on_assent_parliament": { "abbrev": "REP_ASS_byEP_CMT", "general_status": 110, "key": "committee_report_on_assent_parliament", "label": "EP Committee report on assent", "legislative_body": 2, "value": 1106 },
                    "committee_report_on_budgetary_act_parliament": { "abbrev": "REP_BUDACT_byEP_CMT", "general_status": 110, "key": "committee_report_on_budgetary_act_parliament", "label": "EP Committee report on budgetary act", "legislative_body": 2, "value": 1107 },
                    "committee_report_on_single_reading_parliament": { "abbrev": "REP_RSI_byEP_CMT", "general_status": 102, "key": "committee_report_on_single_reading_parliament", "label": "EP Committee report on single reading", "legislative_body": 2, "value": 1108 },
                    "committee_report_resolution_parliament": { "abbrev": "REP_RES_byEP_CMT", "general_status": 110, "key": "committee_report_resolution_parliament", "label": "EP Committee report \u2014 resolution", "legislative_body": 2, "value": 1109 },
                    "committee_report_second_reading_parliament": { "abbrev": "REP_R2_byEP_CMT", "general_status": 104, "key": "committee_report_second_reading_parliament", "label": "EP Committee report on 2nd reading", "legislative_body": 2, "value": 1104 },
                    "committee_report_third_reading_parliament": { "abbrev": "REP_R3_byEP_CMT", "general_status": 107, "key": "committee_report_third_reading_parliament", "label": "EP Committee report on 3rd reading", "legislative_body": 2, "value": 1105 },
                    "committee_vote_first_reading": { "abbrev": "", "general_status": 102, "key": "committee_vote_first_reading", "label": "Committee vote", "legislative_body": 2, "value": 1209 },
                    "committee_vote_second_reading": { "abbrev": "", "general_status": 104, "key": "committee_vote_second_reading", "label": "Committee vote", "legislative_body": 2, "value": 1210 },
                    "common_position_adopted_council": { "abbrev": "ADP_COMPOS_byCONSIL", "general_status": 105, "key": "common_position_adopted_council", "label": "Adoption of common position by Council", "legislative_body": 3, "value": 1015 },
                    "common_position_confirmed_council": { "abbrev": "CONF_COMPOS_byCONSIL", "general_status": 110, "key": "common_position_confirmed_council", "label": "Confirmation of common position by Council", "legislative_body": 3, "value": 1037 },
                    "communication_of_council_first_reading_position_adopted_commission": { "abbrev": "ADP_CCPOSR1CONSIL_byCOM", "general_status": 110, "key": "communication_of_council_first_reading_position_adopted_commission", "label": "Adoption by Commission of its communication on Council\u2019s position at 1st reading", "legislative_body": 1, "value": 1008 },
                    "communication_on_action_commission": { "abbrev": "CC_AT_byCOM", "general_status": 110, "key": "communication_on_action_commission", "label": "Commission communication on the action taken", "legislative_body": 1, "value": 1026 },
                    "concertation_procedure_decision_council": { "abbrev": "DEC_PROCONCERT_byCONSIL", "general_status": 110, "key": "concertation_procedure_decision_council", "label": "Decision by Council on concertation procedure", "legislative_body": 3, "value": 1069 },
                    "conciliation_committee_convened": { "abbrev": "CONV_ofCMT_CONC", "general_status": 106, "key": "conciliation_committee_convened", "label": "Convening of the Conciliation Committee", "legislative_body": 4, "value": 1050 },
                    "conciliation_committee_convened_council": { "abbrev": "CONV_ofCMT_CONC_byCONSIL", "general_status": 106, "key": "conciliation_committee_convened_council", "label": "Convening of Conciliation Committee", "legislative_body": 3, "value": 1049 },
                    "conference_passed_house": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-share",
                        "key": "conference_passed_house",
                        "label": "Conference Report Agreed to by House",
                        "search_help_text": "The House approved a conference committee report to resolve differences. The Senate must also approve it.",
                        "senate_general_status": 4,
                        "sort_order": [2, 2],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Conference Report Agreed to by House",
                        "state_other_label": "Conference Report Agreed to by Assembly",
                        "value": 25,
                        "xml_code": "CONFERENCE:PASSED:HOUSE"
                    },
                    "conference_passed_senate": {
                        "abbrev": "",
                        "house_general_status": 4,
                        "icon": "fa-share",
                        "key": "conference_passed_senate",
                        "label": "Conference Report Agreed to by Senate",
                        "search_help_text": "The Senate approved a conference committee report to resolve differences. The House must also approve it.",
                        "senate_general_status": 3,
                        "sort_order": [2, 3],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Conference Report Agreed to by Senate",
                        "state_other_label": "Conference Report Agreed to by Senate",
                        "value": 26,
                        "xml_code": "CONFERENCE:PASSED:SENATE"
                    },
                    "conference_report_filed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-file-archive-o",
                        "key": "conference_report_filed",
                        "label": "Conference report [free text] filed",
                        "search_help_text": "Conference report [free text] filed",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Conference committee report filed",
                        "state_label": "Conference committee report filed",
                        "state_other_label": "Conference committee report filed",
                        "value": 69,
                        "xml_code": ""
                    },
                    "confirmed_by_senate": { "abbrev": "", "general_status": 12, "house_general_status": 12, "icon": "fa-bookmark", "key": "confirmed_by_senate", "label": "Confirmed by the Senate", "search_help_text": "Confirmed by the Senate", "senate_general_status": 12, "sort_order": 7, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 208, "xml_code": "" },
                    "considered_by_house": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-comment-o",
                        "key": "considered_by_house",
                        "label": "Consideration by House",
                        "search_help_text": "Consideration by House",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 72,
                        "xml_code": ""
                    },
                    "considered_by_senate": { "abbrev": "", "general_status": 11, "house_general_status": 11, "icon": "fa-bookmark", "key": "considered_by_senate", "label": "Considered by the Senate", "search_help_text": "Considered for confirmation by the Senate", "senate_general_status": 11, "sort_order": 6, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 207, "xml_code": "" },
                    "cooperation_committee_decision": { "abbrev": "DEC_byCMT_COOP", "general_status": 110, "key": "cooperation_committee_decision", "label": "Decision of the Cooperation Committee", "legislative_body": 100, "value": 1072 },
                    "corrigendum": { "abbrev": "CORR_byCOM", "general_status": 110, "key": "corrigendum", "label": "Corrigendum", "legislative_body": 1, "value": 1052 },
                    "council_agreement": { "abbrev": "AGR_byCONSIL", "general_status": 103, "key": "council_agreement", "label": "Council agreement", "legislative_body": 3, "value": 1055 },
                    "council_assent": { "abbrev": "ASS_byCONSIL", "general_status": 8, "key": "council_assent", "label": "Council assent", "legislative_body": 3, "value": 1056 },
                    "council_common_position_received_parliament": { "abbrev": "RECP_COMPOS_byEP", "general_status": 104, "key": "council_common_position_received_parliament", "label": "Receipt by EP of Council common position", "legislative_body": 2, "value": 1153 },
                    "council_conclusions": { "abbrev": "CONC_byCONSIL", "general_status": 103, "key": "council_conclusions", "label": "Council conclusions", "legislative_body": 3, "value": 1057 },
                    "council_decision_first_reading": { "abbrev": "", "general_status": 103, "key": "council_decision_first_reading", "label": "Council decision first reading", "legislative_body": 2, "value": 1205 },
                    "council_decision_second_reading": { "abbrev": "", "general_status": 105, "key": "council_decision_second_reading", "label": "Council decision second reading", "legislative_body": 3, "value": 1206 },
                    "council_decision_third_reading": { "abbrev": "", "general_status": 107, "key": "council_decision_third_reading", "label": "Council decision third reading", "legislative_body": 3, "value": 1207 },
                    "council_first_read_adopted_commission": { "abbrev": "ADP_POSR1CONSIL_byCOM", "general_status": 103, "key": "council_first_read_adopted_commission", "label": "Adoption by Commission of Council\u2019s position 1st reading", "legislative_body": 1, "value": 1006 },
                    "council_first_reading_position_received_parliament": { "abbrev": "RECP_byEP", "general_status": 104, "key": "council_first_reading_position_received_parliament", "label": "Receipt by the Parliament of the Council\u2019s position at 1st reading", "legislative_body": 2, "value": 1154 },
                    "council_of_ministers_decision": { "abbrev": "DEC_byACP_MIN", "general_status": 110, "key": "council_of_ministers_decision", "label": "Decision of the ACP-EC Council of Ministers", "legislative_body": 100, "value": 1071 },
                    "council_opinion": { "abbrev": "OPI_byCONSIL", "general_status": 110, "key": "council_opinion", "label": "Council opinion", "legislative_body": 3, "value": 1060 },
                    "council_position_approved_second_reading_parliament": { "abbrev": "APR_R2_POS_CONSIL_byEP", "general_status": 104, "key": "council_position_approved_second_reading_parliament", "label": "EP approval at 2nd reading of the Council\u2019s position", "legislative_body": 2, "value": 1094 },
                    "council_position_rejected_second_reading_parliament": { "abbrev": "RJ_R2_POS_CONSIL_byEP", "general_status": 104, "key": "council_position_rejected_second_reading_parliament", "label": "EP rejection at 2nd reading of the Council\u2019s position", "legislative_body": 2, "value": 1119 },
                    "council_resolution": { "abbrev": "RES_byCONSIL", "general_status": 110, "key": "council_resolution", "label": "Council resolution", "legislative_body": 3, "value": 1064 },
                    "court_decision_communication_published_in_official_journal": { "abbrev": "CC_CD_PUB_OJ", "general_status": 110, "key": "court_decision_communication_published_in_official_journal", "label": "Communication on court decision published in OJ", "legislative_body": 100, "value": 1034 },
                    "court_of_auditors_consulted_council": { "abbrev": "CONS_ofECA_byCONSIL", "general_status": 110, "key": "court_of_auditors_consulted_council", "label": "Consultation of Court of Auditors by Council", "legislative_body": 3, "value": 1038 },
                    "court_of_auditors_opinion": { "abbrev": "OPI_byECA", "general_status": 110, "key": "court_of_auditors_opinion", "label": "Court of Auditors opinion", "legislative_body": 100, "value": 1066 },
                    "court_of_auditors_own_initiative_opinion": { "abbrev": "OPI_OWINI_byECA", "general_status": 110, "key": "court_of_auditors_own_initiative_opinion", "label": "European Court of Auditors own-initiative opinion", "legislative_body": 100, "value": 1122 },
                    "court_of_justice_consulted_council": { "abbrev": "CONS_ofCURIA_byCONSIL", "general_status": 110, "key": "court_of_justice_consulted_council", "label": "Consultation of Court of Justice by Council", "legislative_body": 3, "value": 1039 },
                    "court_of_justice_judgement": { "abbrev": "JUDG_byCURIA", "general_status": 110, "key": "court_of_justice_judgement", "label": "Court of Justice judgment", "legislative_body": 100, "value": 1067 },
                    "court_of_justice_opinion": { "abbrev": "OPI_byCURIA", "general_status": 110, "key": "court_of_justice_opinion", "label": "Court of Justice opinion", "legislative_body": 100, "value": 1068 },
                    "data_protection_supervisor_opinion": { "abbrev": "OPI_byEDPS", "general_status": 110, "key": "data_protection_supervisor_opinion", "label": "Opinion of the European Data Protection Supervisor", "legislative_body": 100, "value": 1142 },
                    "debate": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-comments-o",
                        "key": "debate",
                        "label": "Debate",
                        "search_help_text": "Debate held",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Debate held",
                        "state_other_label": "",
                        "value": 73,
                        "xml_code": ""
                    },
                    "decision_association_council": { "abbrev": "DEC_byCOUN_ASS", "general_status": 110, "key": "decision_association_council", "label": "Association Council decision", "legislative_body": 100, "value": 1022 },
                    "decision_conciliation_committee": { "abbrev": "DEC_byCMT_CONC", "general_status": 106, "key": "decision_conciliation_committee", "label": "Conciliation Committee decision", "legislative_body": 100, "value": 1036 },
                    "decision_cooperation_council": { "abbrev": "DEC_byCOUN_COOP", "general_status": 110, "key": "decision_cooperation_council", "label": "Cooperation Council decision", "legislative_body": 100, "value": 1051 },
                    "decision_first_reading_parliament": { "abbrev": "DEC_RSI_R1_byEP", "general_status": 102, "key": "decision_first_reading_parliament", "label": "EP decision 1st reading or single reading", "legislative_body": 2, "value": 1110 },
                    "decision_on_budgetary_discharge_parliament": { "abbrev": "DEC_BUDDIS_byEP", "general_status": 110, "key": "decision_on_budgetary_discharge_parliament", "label": "Parliament decision on budgetary discharge", "legislative_body": 2, "value": 1144 },
                    "decision_on_follow_up_action": { "abbrev": "DEC_FUAC_byCOM", "general_status": 110, "key": "decision_on_follow_up_action", "label": "Decision on follow-up action", "legislative_body": 1, "value": 1074 },
                    "decision_third_reading_parliament": { "abbrev": "DEC_R3_byEP", "general_status": 107, "key": "decision_third_reading_parliament", "label": "EP decision on 3rd reading", "legislative_body": 2, "value": 1111 },
                    "decision_with_or_without_conciliation_council": { "abbrev": "DEC_CONC_byCONSIL", "general_status": 110, "key": "decision_with_or_without_conciliation_council", "label": "Council: decision, with or without conciliation", "legislative_body": 3, "value": 1054 },
                    "declaration_of_common_position_adopted_commission": { "abbrev": "ADP_DCLCOMPOS_byCOM", "general_status": 110, "key": "declaration_of_common_position_adopted_commission", "label": "Adoption by Commission of declaration on common position", "legislative_body": 1, "value": 1007 },
                    "declaration_of_common_position_transmit_to_council": { "abbrev": "TRS_toCONSIL_COMPOS_byCOM", "general_status": 103, "key": "declaration_of_common_position_transmit_to_council", "label": "Transmission to Council of declaration on common position", "legislative_body": 1, "value": 1168 },
                    "declaration_of_common_position_transmit_to_parliament": { "abbrev": "TRS_EP_DCLCOMPOS_byCOM", "general_status": 104, "key": "declaration_of_common_position_transmit_to_parliament", "label": "Transmission to EP of declaration on common position", "legislative_body": 1, "value": 1171 },
                    "defeated": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-times",
                        "key": "defeated",
                        "label": "Defeated",
                        "search_help_text": "Bill has been defeated.",
                        "senate_general_status": 8,
                        "sort_order": [],
                        "state_code": "",
                        "state_dc_label": "Defeated",
                        "state_label": "Defeated",
                        "state_other_label": "Defeated",
                        "value": 88,
                        "xml_code": ""
                    },
                    "discharged_by_committee": { "abbrev": "", "general_status": 11, "house_general_status": 11, "icon": "fa-bookmark", "key": "discharged_by_committee", "label": "Discharged by Committee", "search_help_text": "Discharged by committee", "senate_general_status": 11, "sort_order": 4, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 204, "xml_code": "" },
                    "discussion_with_council_or_prep_bodies": { "abbrev": "DIS_byCONSIL", "general_status": 110, "key": "discussion_with_council_or_prep_bodies", "label": "Discussions within the Council or its preparatory bodies", "legislative_body": 3, "value": 1081 },
                    "ecb_consulted_council": { "abbrev": "CONS_ofECB_byCONSIL", "general_status": 110, "key": "ecb_consulted_council", "label": "Consultation of the European Central Bank by the Council", "legislative_body": 3, "value": 1047 },
                    "ecb_opinion": { "abbrev": "OPI_byECB", "general_status": 110, "key": "ecb_opinion", "label": "European Central Bank opinion", "legislative_body": 100, "value": 1121 },
                    "economic_and_social_committee_consulted": { "abbrev": "CONS_ofESC_byCONSIL", "general_status": 110, "key": "economic_and_social_committee_consulted", "label": "Consultation of Economic and Social Committee", "legislative_body": 3, "value": 1040 },
                    "economic_and_social_committee_consulted_commission": { "abbrev": "CONS_ofESC_byCOM", "general_status": 110, "key": "economic_and_social_committee_consulted_commission", "label": "Consultation of Economic and Social Committee by Commission", "legislative_body": 1, "value": 1041 },
                    "economic_and_social_committee_opinion": { "abbrev": "OPI_byESC", "general_status": 110, "key": "economic_and_social_committee_opinion", "label": "Economic and Social Committee opinion", "legislative_body": 100, "value": 1083 },
                    "economic_and_social_committee_own_initiative_opinion": { "abbrev": "OPI_OWINI_byESC", "general_status": 110, "key": "economic_and_social_committee_own_initiative_opinion", "label": "Economic and Social Committee own-initiative opinion", "legislative_body": 100, "value": 1084 },
                    "economic_and_social_committee_resolution": { "abbrev": "RES_byESC", "general_status": 110, "key": "economic_and_social_committee_resolution", "label": "Economic and Social Committee resolution", "legislative_body": 100, "value": 1085 },
                    "ecsc_consultative_committee_opinion": { "abbrev": "OPI_byECSC_CMTCSL", "general_status": 110, "key": "ecsc_consultative_committee_opinion", "label": "ECSC Consultative Committee opinion", "legislative_body": 100, "value": 1086 },
                    "eesc_consulted": { "abbrev": "CONS_ofEESC_byCONSIL", "general_status": 110, "key": "eesc_consulted", "label": "Consultation of European Economic and Social Committee", "legislative_body": 3, "value": 1042 },
                    "eesc_consulted_commission": { "abbrev": "CONS_ofEESC_byCOM", "general_status": 110, "key": "eesc_consulted_commission", "label": "Consultation of European Economic and Social Committee by Commission", "legislative_body": 1, "value": 1043 },
                    "eesc_exploratory_opinion": { "abbrev": "OPI_EXPL_byEESC", "general_status": 110, "key": "eesc_exploratory_opinion", "label": "European Economic and Social Committee exploratory opinion", "legislative_body": 100, "value": 1123 },
                    "eesc_opinion": { "abbrev": "OPI_byEESC", "general_status": 110, "key": "eesc_opinion", "label": "European Economic and Social Committee opinion", "legislative_body": 100, "value": 1124 },
                    "eesc_own_initiative_opinion": { "abbrev": "OPI_OWINI_byEESC", "general_status": 110, "key": "eesc_own_initiative_opinion", "label": "European Economic and Social Committee own-initiative opinion", "legislative_body": 100, "value": 1125 },
                    "eesc_resolution": { "abbrev": "RES_byEESC", "general_status": 110, "key": "eesc_resolution", "label": "European Economic and Social Committee resolution", "legislative_body": 100, "value": 1126 },
                    "empowerment": { "abbrev": "EMPOW_byCOM", "general_status": 110, "key": "empowerment", "label": "Empowerment", "legislative_body": 1, "value": 1087 },
                    "enacted_signed": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-pencil-square-o",
                        "key": "enacted_signed",
                        "label": "Signed by Executive",
                        "search_help_text": "Enacted by a signature of the President.",
                        "senate_general_status": 6,
                        "sort_order": [3, 3],
                        "state_code": "governor:signed",
                        "state_dc_label": "Signed by the Mayor",
                        "state_label": "Signed by the Governor",
                        "state_other_label": "Signed by the Governor",
                        "value": 44,
                        "xml_code": "ENACTED:SIGNED"
                    },
                    "enacted_tenday": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check-square-o",
                        "key": "enacted_tenday",
                        "label": "Enacted: 10 Day Rule",
                        "search_help_text": "Enacted by the ten-day rule.",
                        "senate_general_status": 6,
                        "sort_order": [3, 5],
                        "state_code": "enacted:tenday",
                        "state_dc_label": "Became Law Without Signature",
                        "state_label": "Became Law Without Signature",
                        "state_other_label": "Became Law Without Signature",
                        "value": 46,
                        "xml_code": "ENACTED:TENDAYRULE"
                    },
                    "enacted_veto_override": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check-square-o",
                        "key": "enacted_veto_override",
                        "label": "Veto Overridden",
                        "search_help_text": "Enacted by a veto override.",
                        "senate_general_status": 6,
                        "sort_order": [3, 4],
                        "state_code": "bill:veto_override:passed",
                        "state_dc_label": "Veto Overridden",
                        "state_label": "Veto Overridden",
                        "state_other_label": "Veto Overridden",
                        "value": 45,
                        "xml_code": "ENACTED:VETO_OVERRIDE"
                    },
                    "end_of_applicability": { "abbrev": "APPL_END", "general_status": 110, "key": "end_of_applicability", "label": "End of applicability", "legislative_body": 100, "value": 1181 },
                    "end_of_procedure_decision_council": { "abbrev": "DEC_PROCEND_byCONSIL", "general_status": 110, "key": "end_of_procedure_decision_council", "label": "End of procedure: decision by Council", "legislative_body": 3, "value": 1088 },
                    "ep_amendments": { "abbrev": "AMEND_byEP", "general_status": 102, "key": "ep_amendments", "label": "EP amendments", "legislative_body": 2, "value": 1182 },
                    "ep_decision": { "abbrev": "DEC_byEP", "general_status": 102, "key": "ep_decision", "label": "EP decision", "legislative_body": 2, "value": 1183 },
                    "ep_position_at_1st_reading_with_amendments": { "abbrev": "AMEND_R1_byEP", "general_status": 102, "key": "ep_position_at_1st_reading_with_amendments", "label": "EP position at 1st reading with amendments", "legislative_body": 2, "value": 1184 },
                    "eu_initiative_abandoned": { "abbrev": "", "general_status": 111, "key": "eu_initiative_abandoned", "label": "Abandoned", "legislative_body": 100, "state_label": "Abandoned", "value": 1305 },
                    "eu_initiative_call_for_evidence": { "abbrev": "", "general_status": 111, "key": "eu_initiative_call_for_evidence", "label": "Call for evidence", "legislative_body": 100, "state_label": "Call for evidence", "value": 1301 },
                    "eu_initiative_commission_adoption": { "abbrev": "", "general_status": 112, "key": "eu_initiative_commission_adoption", "label": "Commission adoption", "legislative_body": 100, "state_label": "Commission adoption", "value": 1306 },
                    "eu_initiative_draft_act": { "abbrev": "", "general_status": 111, "key": "eu_initiative_draft_act", "label": "Draft act", "legislative_body": 100, "state_label": "Draft act", "value": 1303 },
                    "eu_initiative_in_preparation": { "abbrev": "", "general_status": 111, "key": "eu_initiative_in_preparation", "label": "In preparation", "legislative_body": 100, "state_label": "In preparation", "value": 1300 },
                    "eu_initiative_public_consultation": { "abbrev": "", "general_status": 111, "key": "eu_initiative_public_consultation", "label": "Public consultation", "legislative_body": 100, "state_label": "Public consultation", "value": 1302 },
                    "eu_initiative_suspended": { "abbrev": "", "general_status": 111, "key": "eu_initiative_suspended", "label": "Suspended", "legislative_body": 100, "state_label": "Suspended", "value": 1304 },
                    "eu_other": { "abbrev": "", "general_status": 110, "key": "eu_other", "label": "Other", "legislative_body": 101, "value": 1000 },
                    "european_investment_bank_opinion": { "abbrev": "OPI_byEIB", "general_status": 110, "key": "european_investment_bank_opinion", "label": "European Investment Bank opinion", "legislative_body": 100, "value": 1127 },
                    "european_monetary_institute_consulted_council": { "abbrev": "CONS_ofEMI_byCONSIL", "general_status": 110, "key": "european_monetary_institute_consulted_council", "label": "Consultation of European Monetary Institute by Council", "legislative_body": 3, "value": 1044 },
                    "european_monetary_institute_opinion": { "abbrev": "OPI_byEMI", "general_status": 110, "key": "european_monetary_institute_opinion", "label": "European Monetary Institute opinion", "legislative_body": 100, "value": 1128 },
                    "exploratory_opinion_economic_and_social_committee": { "abbrev": "OPI_EXPL_byESC", "general_status": 110, "key": "exploratory_opinion_economic_and_social_committee", "label": "Economic and Social Committee exploratory opinion", "legislative_body": 100, "value": 1082 },
                    "fail_originating_house": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-times",
                        "key": "fail_originating_house",
                        "label": "Failed House",
                        "search_help_text": "Failed in the House, its originating chamber",
                        "senate_general_status": 2,
                        "sort_order": [5, 0],
                        "state_code": "bill:failed:lower",
                        "state_dc_label": "Failed Council",
                        "state_label": "Failed House",
                        "state_other_label": "Failed Assembly",
                        "value": 27,
                        "xml_code": "FAIL:ORIGINATING:HOUSE"
                    },
                    "fail_originating_senate": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-times",
                        "key": "fail_originating_senate",
                        "label": "Failed Senate",
                        "search_help_text": "Failed in the Senate, its originating chamber",
                        "senate_general_status": 2,
                        "sort_order": [5, 1],
                        "state_code": "bill:failed:upper",
                        "state_dc_label": "Failed Council",
                        "state_label": "Failed Senate",
                        "state_other_label": "Failed Senate",
                        "value": 28,
                        "xml_code": "FAIL:ORIGINATING:SENATE"
                    },
                    "fail_second_house": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-times",
                        "key": "fail_second_house",
                        "label": "Passed Senate, Failed House",
                        "search_help_text": "Passed the Senate but failed in the House.",
                        "senate_general_status": 4,
                        "sort_order": [5, 2],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Passed Senate, Failed House",
                        "state_other_label": "Passed Senate, Failed Assembly",
                        "value": 29,
                        "xml_code": "FAIL:SECOND:HOUSE"
                    },
                    "fail_second_senate": {
                        "abbrev": "",
                        "house_general_status": 4,
                        "icon": "fa-times",
                        "key": "fail_second_senate",
                        "label": "Passed House, Failed Senate",
                        "search_help_text": "Passed the House but failed in the Senate.",
                        "senate_general_status": 3,
                        "sort_order": [5, 3],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Passed House, Failed Senate",
                        "state_other_label": "Passed Assembly, Failed Senate",
                        "value": 30,
                        "xml_code": "FAIL:SECOND:SENATE"
                    },
                    "failed_committee": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-times",
                        "key": "failed_committee",
                        "label": "Failed by Committee",
                        "search_help_text": "Failed by a committee.",
                        "senate_general_status": 1,
                        "sort_order": [0, 2],
                        "state_code": "committee:failed",
                        "state_dc_label": "Failed by Committee",
                        "state_label": "Failed by Committee",
                        "state_other_label": "Failed by Committee",
                        "value": 10,
                        "xml_code": "None"
                    },
                    "filed": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-exclamation",
                        "key": "filed",
                        "label": "Prefiled",
                        "search_help_text": "A bill has been filed.",
                        "senate_general_status": 1,
                        "sort_order": [0, 2],
                        "state_code": "bill:filed",
                        "state_dc_label": "Filed",
                        "state_label": "Filed",
                        "state_other_label": "Filed",
                        "value": 3,
                        "xml_code": "None"
                    },
                    "final_passage_under_suspension": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exclamation",
                        "key": "final_passage_under_suspension",
                        "label": "Final Passage Under Suspension of the Rules Results",
                        "search_help_text": "Final Passage Under Suspension of the Rules Results",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 70,
                        "xml_code": ""
                    },
                    "first_reading": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-file-audio-o",
                        "key": "first_reading",
                        "label": "First Reading",
                        "search_help_text": "Bill has undergone first reading.",
                        "senate_general_status": 1,
                        "sort_order": [0, 2],
                        "state_code": "bill:reading:1",
                        "state_dc_label": "First Reading",
                        "state_label": "First Reading",
                        "state_other_label": "First Reading",
                        "value": 5,
                        "xml_code": "None"
                    },
                    "first_reading_budget_discussion_council": { "abbrev": "DIS_BUDR1_byCONSIL", "general_status": 103, "key": "first_reading_budget_discussion_council", "label": "Discussion of budget by Council on 1st reading", "legislative_body": 3, "value": 1077 },
                    "first_reading_budget_discussion_parliament": { "abbrev": "DIS_BUDR1_byEP", "general_status": 102, "key": "first_reading_budget_discussion_parliament", "label": "Discussion of budget by EP on 1st reading", "legislative_body": 2, "value": 1079 },
                    "first_reading_partial_approval_council": { "abbrev": "APR_PARR1_byCONSIL", "general_status": 103, "key": "first_reading_partial_approval_council", "label": "Council partial approval on 1st reading", "legislative_body": 3, "value": 1062 },
                    "first_reading_position_adopted_council": { "abbrev": "ADP_R1_byCONSIL", "general_status": 103, "key": "first_reading_position_adopted_council", "label": "Adoption of Council\u2019s position at 1st reading", "legislative_body": 3, "value": 1016 },
                    "first_reading_second_chamber": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-file-audio-o",
                        "key": "first_reading_second_chamber",
                        "label": "First Reading in Second Chamber",
                        "search_help_text": "Bill has undergone first reading in the second chamber.",
                        "senate_general_status": 3,
                        "sort_order": [0, 2],
                        "state_code": "",
                        "state_dc_label": "First Reading in Second Chamber",
                        "state_label": "First Reading in Second Chamber",
                        "state_other_label": "First Reading in Second Chamber",
                        "value": 83,
                        "xml_code": ""
                    },
                    "first_reading_statement_of_reasons_council": { "abbrev": "ADP_R1_POS_byCONSIL", "general_status": 103, "key": "first_reading_statement_of_reasons_council", "label": "Council\u2019s position at 1st reading and statement of reasons", "legislative_body": 3, "value": 1065 },
                    "floor_scheduled": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-calendar-plus-o",
                        "key": "floor_scheduled",
                        "label": "Scheduled for Floor",
                        "search_help_text": "Bill Scheduled for Floor.",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Scheduled for Floor",
                        "state_label": "Scheduled for Floor",
                        "state_other_label": "Scheduled for Floor",
                        "value": 80,
                        "xml_code": ""
                    },
                    "follow_up_communication_parliament": { "abbrev": "CC_FUAC_byEP", "general_status": 110, "key": "follow_up_communication_parliament", "label": "Communication of the Parliament on the follow-up", "legislative_body": 2, "value": 1033 },
                    "france_in_progress": { "abbrev": "", "general_status": 161, "key": "france_in_progress", "label": "In Progress", "state_label": "In Progress", "value": 1441 },
                    "france_introduced": { "abbrev": "", "general_status": 160, "key": "france_introduced", "label": "Introduced", "state_label": "Introduced", "value": 1440 },
                    "france_promulgation": { "abbrev": "", "general_status": 162, "key": "france_promulgation", "label": "Promulgation", "state_label": "Promulgation", "value": 1442 },
                    "germany_in_force": { "abbrev": "", "general_status": 131, "key": "germany_in_force", "label": "In Force", "state_label": "In Force", "value": 1421 },
                    "germany_proposed": { "abbrev": "", "general_status": 130, "key": "germany_proposed", "label": "Proposed", "state_label": "Proposed", "value": 1420 },
                    "hearing_scheduled": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-calendar-plus-o",
                        "key": "hearing_scheduled",
                        "label": "Hearing Scheduled",
                        "search_help_text": "Hearing Scheduled for Bill.",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Hearing Scheduled",
                        "state_label": "Hearing Scheduled",
                        "state_other_label": "Hearing Scheduled",
                        "value": 48,
                        "xml_code": ""
                    },
                    "hearing_senate": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-gavel",
                        "key": "hearing_senate",
                        "label": "Senate committee/subcommittee hearings",
                        "search_help_text": "Senate committee/subcommittee hearings",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 55,
                        "xml_code": ""
                    },
                    "hearings_by_committee": { "abbrev": "", "general_status": 10, "house_general_status": 10, "icon": "fa-bookmark", "key": "hearings_by_committee", "label": "In Committee Hearings", "search_help_text": "In hearings by committee", "senate_general_status": 10, "sort_order": 2, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 202, "xml_code": "" },
                    "held_at_desk": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-hand-stop-o",
                        "key": "held_at_desk",
                        "label": "Held at the desk",
                        "search_help_text": "Held at the desk",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 66,
                        "xml_code": ""
                    },
                    "house_received": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exchange",
                        "key": "house_received",
                        "label": "Received in the House",
                        "search_help_text": "Received in the House",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 65,
                        "xml_code": ""
                    },
                    "house_reconsidering": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-gavel",
                        "key": "house_reconsidering",
                        "label": "House Reconsidering",
                        "search_help_text": "Reconsidering",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "House Reconsidering",
                        "state_label": "House Reconsidering",
                        "state_other_label": "House Reconsidering",
                        "value": 93,
                        "xml_code": ""
                    },
                    "implicit_replacement": { "abbrev": "RPL_IMP_byCOM", "general_status": 110, "key": "implicit_replacement", "label": "Implicit replacement", "legislative_body": 1, "value": 1129 },
                    "introduced": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-folder-open",
                        "key": "introduced",
                        "label": "Introduced",
                        "search_help_text": "Introduced but not yet referred to a committee.",
                        "senate_general_status": 1,
                        "sort_order": [0, 0],
                        "state_code": "bill:introduced",
                        "state_dc_label": "Introduced",
                        "state_label": "Introduced",
                        "state_other_label": "Introduced",
                        "value": 4,
                        "xml_code": "INTRODUCED"
                    },
                    "introduced_house": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-folder-open",
                        "key": "introduced_house",
                        "label": "Introduced in House",
                        "search_help_text": "Introduced in House",
                        "senate_general_status": 3,
                        "sort_order": [0, 1],
                        "state_code": "bill:introduced:lower",
                        "state_dc_label": "Introduced in House",
                        "state_label": "Introduced in House",
                        "state_other_label": "Introduced in Assembly",
                        "value": 50,
                        "xml_code": ""
                    },
                    "introduced_senate": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-folder-open",
                        "key": "introduced_senate",
                        "label": "Introduced in Senate",
                        "search_help_text": "Introduced in Senate",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "bill:introduced:upper",
                        "state_dc_label": "Introduced",
                        "state_label": "Introduced in Senate",
                        "state_other_label": "Introduced in Senate",
                        "value": 53,
                        "xml_code": ""
                    },
                    "joint_committee_decision": { "abbrev": "DEC_byCMT_JOIN", "general_status": 110, "key": "joint_committee_decision", "label": "Decision of the Joint Committee", "legislative_body": 100, "value": 1073 },
                    "joint_committee_decision_1": { "abbrev": "DEC_byCMT_CONJOIN", "general_status": 110, "key": "joint_committee_decision_1", "label": "Joint Committee decision", "legislative_body": 100, "value": 1131 },
                    "joint_committee_decision_2": { "abbrev": "DEC_byCMT_MIX", "general_status": 110, "key": "joint_committee_decision_2", "label": "Joint Committee decision", "legislative_body": 100, "value": 1132 },
                    "joint_council_decision": { "abbrev": "DEC_byCOUN_JOIN", "general_status": 110, "key": "joint_council_decision", "label": "Joint Council decision", "legislative_body": 3, "value": 1133 },
                    "joint_text_approved_conciliation_committee": { "abbrev": "APR_JT_byCMT_CONC", "general_status": 106, "key": "joint_text_approved_conciliation_committee", "label": "Approval by the Conciliation Committee of a joint text", "legislative_body": 4, "value": 1019 },
                    "judgement_or_making_of_order_delivered": { "abbrev": "DELIV_JUDG_ORDER", "general_status": 110, "key": "judgement_or_making_of_order_delivered", "label": "Delivery of the Judgment or making of the Order", "legislative_body": 101, "value": 1075 },
                    "left_unfinished": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-file-o",
                        "key": "left_unfinished",
                        "label": "Left Unfinished",
                        "search_help_text": "Left Unfinished",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Left Unfinished",
                        "state_label": "Left Unfinished",
                        "state_other_label": "Left Unfinished",
                        "value": 78,
                        "xml_code": ""
                    },
                    "markup_senate": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-file-text-o",
                        "key": "markup_senate",
                        "label": "Senate committee/subcommittee markups",
                        "search_help_text": "Senate committee/subcommittee markups",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 56,
                        "xml_code": ""
                    },
                    "member_states_initiative": { "abbrev": "INI_byEUMS", "general_status": 110, "key": "member_states_initiative", "label": "Member States initiative", "legislative_body": 100, "value": 1134 },
                    "monetary_committee_consulted_council": { "abbrev": "CONS_ofCMT_MON_byCONSIL", "general_status": 110, "key": "monetary_committee_consulted_council", "label": "Consultation of Monetary Committee by Council", "legislative_body": 3, "value": 1045 },
                    "monetary_committee_opinion": { "abbrev": "OPI_byCMT_MON", "general_status": 110, "key": "monetary_committee_opinion", "label": "Monetary Committee opinion", "legislative_body": 100, "value": 1135 },
                    "motion_to_discharge_committee": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-minus",
                        "key": "motion_to_discharge_committee",
                        "label": "Motion to Discharge Committee",
                        "search_help_text": "Motion to Discharge Committee",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 67,
                        "xml_code": ""
                    },
                    "motion_to_recommit": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exclamation",
                        "key": "motion_to_recommit",
                        "label": "Motion to Recommit",
                        "search_help_text": "Motion to Recommit",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Motion to Recommit",
                        "state_label": "Motion to Recommit",
                        "state_other_label": "Motion to Recommit",
                        "value": 77,
                        "xml_code": ""
                    },
                    "motion_to_recommit_failed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-times",
                        "key": "motion_to_recommit_failed",
                        "label": "Motion to Recommit Failed",
                        "search_help_text": "Motion to Recommit Failed",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Motion to Recommit Failed",
                        "state_label": "Motion to Recommit Failed",
                        "state_other_label": "Motion to Recommit Failed",
                        "value": 81,
                        "xml_code": ""
                    },
                    "motion_to_recommit_ordered": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-gavel",
                        "key": "motion_to_recommit_ordered",
                        "label": "Motion to Recommit Ordered",
                        "search_help_text": "Motion to Recommit Ordered",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Motion to Recommit Ordered",
                        "state_label": "Motion to Recommit Ordered",
                        "state_other_label": "Motion to Recommit Ordered",
                        "value": 79,
                        "xml_code": ""
                    },
                    "motion_to_reconsider": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-hand-stop-o",
                        "key": "motion_to_reconsider",
                        "label": "Motion To Reconsider Results",
                        "search_help_text": "Motion To Reconsider Results",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Motion to Reconsider",
                        "state_label": "Motion to Reconsider",
                        "state_other_label": "Motion to Reconsider",
                        "value": 71,
                        "xml_code": ""
                    },
                    "new_case_communication_published_in_official_journal": { "abbrev": "CC_NC_PUB_OJ", "general_status": 110, "key": "new_case_communication_published_in_official_journal", "label": "Communication on new case published in OJ", "legislative_body": 100, "value": 1035 },
                    "no_adoption_council": { "abbrev": "ADP_NO_byCONSIL", "general_status": 110, "key": "no_adoption_council", "label": "No adoption by Council", "legislative_body": 3, "value": 1136 },
                    "no_opinion_second_reading_parliament": { "abbrev": "OPI_NO_R2_byEP", "general_status": 104, "key": "no_opinion_second_reading_parliament", "label": "No EP opinion on 2nd reading", "legislative_body": 2, "value": 1137 },
                    "non_adoption_third_reading_council": { "abbrev": "ADP_NO_R3_byCONSIL", "general_status": 107, "key": "non_adoption_third_reading_council", "label": "Non-adoption by the Council at 3rd reading", "legislative_body": 3, "value": 1138 },
                    "non_adoption_third_reading_parliament": { "abbrev": "ADP_NO_R3_byEP", "general_status": 107, "key": "non_adoption_third_reading_parliament", "label": "EP non-adoption at 3rd reading", "legislative_body": 2, "value": 1113 },
                    "non_approval_conciliation_committee": { "abbrev": "APR_NO_JT_byCMT_CONC", "general_status": 106, "key": "non_approval_conciliation_committee", "label": "Non-approval by the Conciliation Committee of a joint text", "legislative_body": 4, "value": 1139 },
                    "non_approval_of_parliament_amendments_second_reading_council": { "abbrev": "APR_NO_R2_byCONSIL", "general_status": 105, "key": "non_approval_of_parliament_amendments_second_reading_council", "label": "Non-approval by the Council of the EP amendments at 2nd reading", "legislative_body": 3, "value": 1140 },
                    "non_approval_parliament": { "abbrev": "APR_NO_byEP", "general_status": 110, "key": "non_approval_parliament", "label": "Not approved by EP", "legislative_body": 2, "value": 1141 },
                    "not_adopted_council": { "abbrev": "ADP_ACTDENO_byCONSIL", "general_status": 110, "key": "not_adopted_council", "label": "Proposed act deemed not adopted", "legislative_body": 3, "value": 1149 },
                    "not_adopted_parliament_and_council": { "abbrev": "ADP_ACTDENO_byEP_CONSIL", "general_status": 110, "key": "not_adopted_parliament_and_council", "label": "Proposed act deemed not adopted", "legislative_body": 2, "value": 1150 },
                    "opinion_first_reading_parliament": { "abbrev": "OPI_R1_byEP", "general_status": 102, "key": "opinion_first_reading_parliament", "label": "EP opinion on 1st reading", "legislative_body": 2, "value": 1114 },
                    "opinion_or_view_delivered": { "abbrev": "DELIV_OPI_VIEW", "general_status": 110, "key": "opinion_or_view_delivered", "label": "Delivery of the Opinion or View", "legislative_body": 101, "value": 1076 },
                    "opinion_second_reading_parliament": { "abbrev": "OPI_R2_byEP", "general_status": 104, "key": "opinion_second_reading_parliament", "label": "EP opinion on 2nd reading", "legislative_body": 2, "value": 1115 },
                    "opinion_single_reading_parliament": { "abbrev": "OPI_RSI_byEP", "general_status": 102, "key": "opinion_single_reading_parliament", "label": "EP opinion on single reading", "legislative_body": 2, "value": 1117 },
                    "original_committee_report": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-bullhorn",
                        "key": "original_committee_report",
                        "label": "Committee report of an original measure",
                        "search_help_text": "Committee report of an original measure",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 62,
                        "xml_code": ""
                    },
                    "other": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exclamation",
                        "key": "other",
                        "label": "Action",
                        "search_help_text": "Action",
                        "senate_general_status": 8,
                        "sort_order": [5, 4],
                        "state_code": "",
                        "state_dc_label": "Action",
                        "state_label": "Action",
                        "state_other_label": "Action",
                        "value": 1,
                        "xml_code": "None"
                    },
                    "override_pass_over_house": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-exclamation",
                        "key": "override_pass_over_house",
                        "label": "Vetoed & House Overrides (Senate Next)",
                        "search_help_text": "The House passed a veto override, sending it to the Senate.",
                        "senate_general_status": 5,
                        "sort_order": [6, 0],
                        "state_code": "",
                        "state_dc_label": "Vetoed & Council Overrides",
                        "state_label": "Vetoed & House Overrides",
                        "state_other_label": "Vetoed & Senate Overrides",
                        "value": 40,
                        "xml_code": "VETOED:OVERRIDE_PASS_OVER:HOUSE"
                    },
                    "override_pass_over_senate": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-exclamation",
                        "key": "override_pass_over_senate",
                        "label": "Vetoed & Senate Overrides (House Next)",
                        "search_help_text": "The Senate passed a veto override, sending it to the House.",
                        "senate_general_status": 5,
                        "sort_order": [6, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Vetoed & Senate Overrides",
                        "state_other_label": "Vetoed & Senate Overrides",
                        "value": 41,
                        "xml_code": "VETOED:OVERRIDE_PASS_OVER:SENATE"
                    },
                    "parliament_assent": { "abbrev": "ASS_byEP", "general_status": 110, "key": "parliament_assent", "label": "EP assent", "legislative_body": 2, "value": 1095 },
                    "parliament_consulted_commission": { "abbrev": "CONS_ofEP_byCOM", "general_status": 110, "key": "parliament_consulted_commission", "label": "Consultation Parliament by Commission", "legislative_body": 1, "value": 1048 },
                    "parliament_consulted_council": { "abbrev": "CONS_ofEP_byCONSIL", "general_status": 110, "key": "parliament_consulted_council", "label": "Consultation of Parliament by Council", "legislative_body": 3, "value": 1046 },
                    "parliament_decision_first_reading": { "abbrev": "", "general_status": 102, "key": "parliament_decision_first_reading", "label": "Parliament decision first reading", "legislative_body": 2, "value": 1202 },
                    "parliament_decision_second_reading": { "abbrev": "", "general_status": 104, "key": "parliament_decision_second_reading", "label": "Parliament decision second reading", "legislative_body": 2, "value": 1203 },
                    "parliament_decision_third_reading": { "abbrev": "", "general_status": 107, "key": "parliament_decision_third_reading", "label": "Parliament decision third reading", "legislative_body": 2, "value": 1204 },
                    "parliament_first_reading_position_approved_council": { "abbrev": "APR_R1_byCONSIL", "general_status": 103, "key": "parliament_first_reading_position_approved_council", "label": "Approval by the Council of the EP position at 1st reading", "legislative_body": 3, "value": 1021 },
                    "parliament_rejection_information_second_reading": { "abbrev": "INF_RJ_R2_byEP", "general_status": 104, "key": "parliament_rejection_information_second_reading", "label": "Information concerning EP rejection on 2nd reading", "legislative_body": 2, "value": 1130 },
                    "parliament_resolution": { "abbrev": "RES_byEP", "general_status": 110, "key": "parliament_resolution", "label": "EP resolution", "legislative_body": 2, "value": 1120 },
                    "parliament_second_reading_amendments_approved_council": { "abbrev": "APR_R2_byCONSIL", "general_status": 105, "key": "parliament_second_reading_amendments_approved_council", "label": "Approval by the Council of the EP amendments at 2nd reading", "legislative_body": 3, "value": 1020 },
                    "parliament_second_reading_amendments_opinion_adopted_commission": { "abbrev": "ADP_OPR2AMEPE_byCOM", "general_status": 110, "key": "parliament_second_reading_amendments_opinion_adopted_commission", "label": "Adoption by Commission of opinion on EP amendments on 2nd reading", "legislative_body": 1, "value": 1009 },
                    "parliament_vote": { "abbrev": "", "general_status": 8, "key": "parliament_vote", "label": "Parliament vote", "legislative_body": 2, "value": 1208 },
                    "partial_adoption_council": { "abbrev": "ADP_PAR_byCONSIL", "general_status": 103, "key": "partial_adoption_council", "label": "Partial adoption by Council", "legislative_body": 3, "value": 1145 },
                    "partial_replacement": { "abbrev": "RPL_PAR_byCOM", "general_status": 110, "key": "partial_replacement", "label": "Partial replacement", "legislative_body": 1, "value": 1146 },
                    "partial_signature_parliament_and_council": { "abbrev": "SIGN_PAR_byEP_CONSIL", "general_status": 110, "key": "partial_signature_parliament_and_council", "label": "Partial signature by EP and Council", "legislative_body": 4, "value": 1147 },
                    "partial_withdrawl_commission": { "abbrev": "WDW_PAR_byCOM", "general_status": 109, "key": "partial_withdrawl_commission", "label": "Partial withdrawal by Commission", "legislative_body": 1, "value": 1148 },
                    "participation_in_intl_agreement_end": { "abbrev": "PRTC_INT_AGR_END", "general_status": 8, "key": "participation_in_intl_agreement_end", "label": "Participation in an international agreement end", "legislative_body": 100, "value": 1186 },
                    "participation_in_intl_agreement_start": { "abbrev": "PRTC_INT_AGR_START", "general_status": 8, "key": "participation_in_intl_agreement_start", "label": "Participation in an international agreement start", "legislative_body": 100, "value": 1185 },
                    "pass_back_house": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-sign-out",
                        "key": "pass_back_house",
                        "label": "Passed House with Changes",
                        "search_help_text": "The House passed the bill with changes and sent it back to the Senate.",
                        "senate_general_status": 4,
                        "sort_order": [2, 0],
                        "state_code": "",
                        "state_dc_label": "Passed Council with Changes",
                        "state_label": "Passed House with Changes",
                        "state_other_label": "Passed Assembly with Changes",
                        "value": 23,
                        "xml_code": "PASS_BACK:HOUSE"
                    },
                    "pass_back_senate": {
                        "abbrev": "",
                        "house_general_status": 4,
                        "icon": "fa-sign-out",
                        "key": "pass_back_senate",
                        "label": "Passed Senate with Changes",
                        "search_help_text": "The Senate passed the bill with changes and sent it back to the House.",
                        "senate_general_status": 3,
                        "sort_order": [2, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Passed Senate with Changes",
                        "state_other_label": "Passed Senate with Changes",
                        "value": 24,
                        "xml_code": "PASS_BACK:SENATE"
                    },
                    "pass_over_house": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-sign-out",
                        "key": "pass_over_house",
                        "label": "Passed House",
                        "search_help_text": "Passed the House, waiting for a Senate vote next.",
                        "senate_general_status": 4,
                        "sort_order": [1, 0],
                        "state_code": "bill:passed:lower",
                        "state_dc_label": "Passed Council",
                        "state_label": "Passed House",
                        "state_other_label": "Passed Assembly",
                        "value": 15,
                        "xml_code": "PASS_OVER:HOUSE"
                    },
                    "pass_over_senate": {
                        "abbrev": "",
                        "house_general_status": 4,
                        "icon": "fa-sign-out",
                        "key": "pass_over_senate",
                        "label": "Passed Senate",
                        "search_help_text": "Passed the Senate, waiting for a House vote next.",
                        "senate_general_status": 3,
                        "sort_order": [1, 1],
                        "state_code": "bill:passed:upper",
                        "state_dc_label": "Passed Council",
                        "state_label": "Passed Senate",
                        "state_other_label": "Passed Senate",
                        "value": 16,
                        "xml_code": "PASS_OVER:SENATE"
                    },
                    "passed_bill": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-check",
                        "key": "passed_bill",
                        "label": "Enrolled Bill",
                        "search_help_text": "The bill passed both chambers of Congress in identical form and goes on to the President for signing next.",
                        "senate_general_status": 5,
                        "sort_order": [3, 2],
                        "state_code": "",
                        "state_dc_label": "Passed Bill",
                        "state_label": "Passed Bill",
                        "state_other_label": "Passed Bill",
                        "value": 21,
                        "xml_code": "PASSED:BILL"
                    },
                    "passed_concurrentres": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check",
                        "key": "passed_concurrentres",
                        "label": "Agreed To (Concurrent Resolution)",
                        "search_help_text": "The concurrent resolution was agreed to by both chambers of Congress. This is the final status for concurrent resolutions.",
                        "senate_general_status": 6,
                        "sort_order": [3, 1],
                        "state_code": "bill:passed:concurrent resolution",
                        "state_dc_label": "Agreed To (Concurrent Resolution)",
                        "state_label": "Agreed To (Concurrent Resolution)",
                        "state_other_label": "Agreed To (Concurrent Resolution)",
                        "value": 20,
                        "xml_code": "PASSED:CONCURRENTRES"
                    },
                    "passed_constamend": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check",
                        "key": "passed_constamend",
                        "label": "Agreed To (Constitutional Amendment Proposal)",
                        "search_help_text": "The resolution proposing a constitutional amendment was agreed to by both chambers of Congress and goes on to the states.",
                        "senate_general_status": 6,
                        "sort_order": [3, 0],
                        "state_code": "",
                        "state_dc_label": "Agreed To (Constitutional Amendment Proposal)",
                        "state_label": "Agreed To (Constitutional Amendment Proposal)",
                        "state_other_label": "Agreed To (Constitutional Amendment Proposal)",
                        "value": 19,
                        "xml_code": "PASSED:CONSTAMEND"
                    },
                    "passed_jointres": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check",
                        "key": "passed_jointres",
                        "label": "Agreed To (Joint Resolution)",
                        "search_help_text": "The joint resolution was agreed to in the chamber in which it was introduced. This is a joint resolution's final status.",
                        "senate_general_status": 6,
                        "sort_order": [1, 2],
                        "state_code": "bill:passed:joint resolution",
                        "state_dc_label": "Agreed To (Joint Resolution)",
                        "state_label": "Agreed To (Joint Resolution)",
                        "state_other_label": "Agreed To (Joint Resolution)",
                        "value": 18,
                        "xml_code": "None"
                    },
                    "passed_simpleres": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-check",
                        "key": "passed_simpleres",
                        "label": "Agreed To (Simple Resolution)",
                        "search_help_text": "The simple resolution was agreed to in the chamber in which it was introduced. This is a simple resolution's final status.",
                        "senate_general_status": 6,
                        "sort_order": [1, 2],
                        "state_code": "bill:passed:resolution",
                        "state_dc_label": "Agreed To (Simple Resolution)",
                        "state_label": "Agreed To (Simple Resolution)",
                        "state_other_label": "Agreed To (Simple Resolution)",
                        "value": 17,
                        "xml_code": "PASSED:SIMPLERES"
                    },
                    "placed_on_house_calendar": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-calendar-plus-o",
                        "key": "placed_on_house_calendar",
                        "label": "Placed on House Calendar",
                        "search_help_text": "Placed on House Calendar",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Placed on Calendar",
                        "state_label": "Placed on House Calendar",
                        "state_other_label": "Placed on Assembly Calendar",
                        "value": 76,
                        "xml_code": ""
                    },
                    "placed_on_senate_calendar": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-calendar-plus-o",
                        "key": "placed_on_senate_calendar",
                        "label": "Placed on Senate Calendar",
                        "search_help_text": "Placed on Senate Calendar",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Placed on Senate Calendar",
                        "state_label": "Placed on Senate Calendar",
                        "state_other_label": "Placed on Senate Calendar",
                        "value": 86,
                        "xml_code": ""
                    },
                    "point_against_motion": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-dot-circle-o",
                        "key": "point_against_motion",
                        "label": "Point of order against a motion",
                        "search_help_text": "Point of order against a motion",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 74,
                        "xml_code": ""
                    },
                    "position_first_reading_parliament": { "abbrev": "ADP_R1_POS_byEP", "general_status": 102, "key": "position_first_reading_parliament", "label": "EP position at 1st reading", "legislative_body": 2, "value": 1118 },
                    "position_on_parliament_first_reading_amendments_commission": { "abbrev": "POS_AME_R1_byCOM", "general_status": 102, "key": "position_on_parliament_first_reading_amendments_commission", "label": "Commission position on EP amendments on 1st reading", "legislative_body": 1, "value": 1027 },
                    "position_on_parliament_second_reading_amendments_commission": { "abbrev": "POS_AME_R2_byCOM", "general_status": 104, "key": "position_on_parliament_second_reading_amendments_commission", "label": "Commission position on EP amendments on 2nd reading", "legislative_body": 1, "value": 1028 },
                    "position_on_parliament_single_reading_amendments_commission": { "abbrev": "POS_AME_RSI_byCOM", "general_status": 102, "key": "position_on_parliament_single_reading_amendments_commission", "label": "Commission position on EP amendments on single reading", "legislative_body": 1, "value": 1029 },
                    "pre_referral_info_document_parliament": { "abbrev": "REF_PRE_byEP", "general_status": 110, "key": "pre_referral_info_document_parliament", "label": "EP: document for information, pre-referral", "legislative_body": 2, "value": 1089 },
                    "prefiled": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-folder",
                        "key": "prefiled",
                        "label": "Prefiled",
                        "search_help_text": "Prefiled",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Prefiled",
                        "state_label": "Prefiled",
                        "state_other_label": "Prefiled",
                        "value": 91,
                        "xml_code": ""
                    },
                    "president_signed_parliament_and_council": { "abbrev": "SIGN_byEP_CONSIL", "general_status": 108, "key": "president_signed_parliament_and_council", "label": "Signature by the President of the EP and by the President of the Council", "legislative_body": 2, "value": 1160 },
                    "prov_kill_cloturefailed": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-times",
                        "key": "prov_kill_cloturefailed",
                        "label": "Failed Cloture",
                        "search_help_text": "Cloture (ending a filibuster) failed but can be tried again.",
                        "senate_general_status": 2,
                        "sort_order": [4, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 33,
                        "xml_code": "PROV_KILL:CLOTUREFAILED"
                    },
                    "prov_kill_line_veto": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-minus",
                        "key": "prov_kill_line_veto",
                        "label": "Line-item (Partially) Vetoed",
                        "search_help_text": "Line item vetoed by the President but the veto can be overridden.",
                        "senate_general_status": 6,
                        "sort_order": [5, 4],
                        "state_code": "governor:vetoed:line-item",
                        "state_dc_label": "Line-item (Partially) Vetoed",
                        "state_label": "Line-item (Partially) Vetoed",
                        "state_other_label": "Line-item (Partially) Vetoed",
                        "value": 36,
                        "xml_code": "None"
                    },
                    "prov_kill_pingpongfail": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-times",
                        "key": "prov_kill_pingpongfail",
                        "label": "Failed to Resolve Differences",
                        "search_help_text": "The House or Senate failed to resolve differences with the other chamber but can try again.",
                        "senate_general_status": 3,
                        "sort_order": [4, 2],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Failed to Resolve Differences",
                        "state_other_label": "Failed to Resolve Differences",
                        "value": 34,
                        "xml_code": "PROV_KILL:PINGPONGFAIL"
                    },
                    "prov_kill_suspensionfailed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-times",
                        "key": "prov_kill_suspensionfailed",
                        "label": "Failed Under Suspension",
                        "search_help_text": "Passage failed under \"suspension of the rules\" but can be voted on again.",
                        "senate_general_status": 8,
                        "sort_order": [4, 0],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 32,
                        "xml_code": "PROV_KILL:SUSPENSIONFAILED"
                    },
                    "prov_kill_veto": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "prov_kill_veto",
                        "label": "Vetoed (No Override Attempt)",
                        "search_help_text": "Vetoed by the President but the veto can be overridden.",
                        "senate_general_status": 5,
                        "sort_order": [5, 4],
                        "state_code": "governor:vetoed",
                        "state_dc_label": "Vetoed",
                        "state_label": "Vetoed",
                        "state_other_label": "Vetoed",
                        "value": 35,
                        "xml_code": "PROV_KILL:VETO"
                    },
                    "public_law": {
                        "abbrev": "",
                        "house_general_status": 6,
                        "icon": "fa-flag-checkered",
                        "key": "public_law",
                        "label": "Became Public Law",
                        "search_help_text": "Became Public Law",
                        "senate_general_status": 6,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Became Public Law",
                        "state_label": "Became Public Law",
                        "state_other_label": "Became Public Law",
                        "value": 60,
                        "xml_code": ""
                    },
                    "publication": { "abbrev": "PUB", "general_status": 108, "key": "publication", "label": "Publication at the Official Journal", "legislative_body": 100, "value": 1151 },
                    "publication_in_official_journal": { "abbrev": "PUB_OJ", "general_status": 110, "key": "publication_in_official_journal", "label": "Publication in the Official Journal", "legislative_body": 100, "value": 1152 },
                    "ratification_of_intl_agreement": { "abbrev": "RAT_INT_AGR", "general_status": 8, "key": "ratification_of_intl_agreement", "label": "Ratification of an international agreement", "legislative_body": 100, "value": 1187 },
                    "re_examined_proposal_adopted_commission": { "abbrev": "ADP_PROREEX_byCOM", "general_status": 110, "key": "re_examined_proposal_adopted_commission", "label": "Adoption by Commission of re-examined proposal", "legislative_body": 1, "value": 1010 },
                    "re_examined_proposal_transmit_to_council": { "abbrev": "TRS_toCONSIL_PROREEX_byCOM", "general_status": 110, "key": "re_examined_proposal_transmit_to_council", "label": "Transmission of the re-examined proposal to the Council", "legislative_body": 1, "value": 1164 },
                    "re_examined_proposal_transmit_to_parliament": { "abbrev": "TRS_EP_PROREEX_byCOM", "general_status": 110, "key": "re_examined_proposal_transmit_to_parliament", "label": "Transmission to EP of re-examined proposal", "legislative_body": 1, "value": 1172 },
                    "received_in_senate": { "abbrev": "", "general_status": 10, "house_general_status": 10, "icon": "fa-bookmark", "key": "received_in_senate", "label": "Received in the Senate", "search_help_text": "Received in the Senate for consideration", "senate_general_status": 10, "sort_order": 3, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 211, "xml_code": "" },
                    "referred": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-reply",
                        "key": "referred",
                        "label": "Referred to Committee",
                        "search_help_text": "Referred to a committee.",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "committee:referred",
                        "state_dc_label": "Referred to Committe",
                        "state_label": "Referred to Committee",
                        "state_other_label": "Referred to Committe",
                        "value": 6,
                        "xml_code": "REFERRED"
                    },
                    "referred_house": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-reply",
                        "key": "referred_house",
                        "label": "Referred to House committee",
                        "search_help_text": "Referred to House committee",
                        "senate_general_status": 3,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Referred to House committee",
                        "state_label": "Referred to House committee",
                        "state_other_label": "Referred to Assembly committee",
                        "value": 51,
                        "xml_code": ""
                    },
                    "referred_second_chamber": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-reply",
                        "key": "referred_second_chamber",
                        "label": "Referred to Committee in the Second Chamber.",
                        "search_help_text": "Referred to a committee in the second chamber.",
                        "senate_general_status": 3,
                        "sort_order": [0, 1],
                        "state_code": "committee:referred:after_passed",
                        "state_dc_label": "Referred to Committee in the Second Chamber.",
                        "state_label": "Referred to Committee in the Second Chamber.",
                        "state_other_label": "Referred to Committee in the Second Chamber.",
                        "value": 47,
                        "xml_code": "REFERRED_AFTER_PASSED"
                    },
                    "referred_senate": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-reply",
                        "key": "referred_senate",
                        "label": "Referred to Senate committee",
                        "search_help_text": "Referred to Senate committee",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Referred to Senate committee",
                        "state_label": "Referred to Senate committee",
                        "state_other_label": "Referred to Senate committee",
                        "value": 54,
                        "xml_code": ""
                    },
                    "referred_subcommittee": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-reply",
                        "key": "referred_subcommittee",
                        "label": "Referred to Subcommittee",
                        "search_help_text": "Referred to Subcommittee",
                        "senate_general_status": 1,
                        "sort_order": [0, 2],
                        "state_code": "subcommittee:referred",
                        "state_dc_label": "Referred to Subcommittee",
                        "state_label": "Referred to Subcommittee",
                        "state_other_label": "Referred to Subcommittee",
                        "value": 89,
                        "xml_code": "REFERRED"
                    },
                    "referred_to_committee": { "abbrev": "", "general_status": 10, "house_general_status": 10, "icon": "fa-bookmark", "key": "referred_to_committee", "label": "Referred to Committee", "search_help_text": "Referred to committee for confirmation", "senate_general_status": 10, "sort_order": 1, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 201, "xml_code": "" },
                    "referred_to_committee_parliament": { "abbrev": "REF_OF_byEP", "general_status": 110, "key": "referred_to_committee_parliament", "label": "EP: referral to Committee responsible and Committee asked for opinion", "legislative_body": 2, "value": 1091 },
                    "regions_committee_opinion": { "abbrev": "OPI_byCOR", "general_status": 110, "key": "regions_committee_opinion", "label": "Committee of Regions opinion", "legislative_body": 100, "value": 1030 },
                    "regions_committee_outlook_opinion": { "abbrev": "OPI_OUT_byCOR", "general_status": 110, "key": "regions_committee_outlook_opinion", "label": "Outlook opinion of the Committee of the Regions", "legislative_body": 100, "value": 1143 },
                    "regions_committee_own_initiative_opinion": { "abbrev": "OPI_OWINIbyCOR", "general_status": 110, "key": "regions_committee_own_initiative_opinion", "label": "Committee of Regions own-initiative opinion", "legislative_body": 100, "value": 1031 },
                    "rejected_council": { "abbrev": "RJ_byCONSIL", "general_status": 109, "key": "rejected_council", "label": "Rejection by Council", "legislative_body": 3, "value": 1156 },
                    "rejected_parliament": { "abbrev": "RJ_byEP", "general_status": 109, "key": "rejected_parliament", "label": "Rejected by EP", "legislative_body": 2, "value": 1155 },
                    "replacement": { "abbrev": "RPL_byCOM", "general_status": 110, "key": "replacement", "label": "Replacement", "legislative_body": 1, "value": 1157 },
                    "reported": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-bullhorn",
                        "key": "reported",
                        "label": "Reported by Committee",
                        "search_help_text": "Reported by a committee.",
                        "senate_general_status": 2,
                        "sort_order": [0, 2],
                        "state_code": "committee:passed",
                        "state_dc_label": "Reported by Committee",
                        "state_label": "Reported by Committee",
                        "state_other_label": "Reported by Committee",
                        "value": 7,
                        "xml_code": "REPORTED"
                    },
                    "reported_by_committee": { "abbrev": "", "general_status": 11, "house_general_status": 11, "icon": "fa-bookmark", "key": "reported_by_committee", "label": "Reported by Committee", "search_help_text": "Reported on by committee", "senate_general_status": 11, "sort_order": 3, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 205, "xml_code": "" },
                    "reported_favorably": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-thumbs-up",
                        "key": "reported_favorably",
                        "label": "Reported Favorably by Committee",
                        "search_help_text": "Reported by a committee with a favorable report.",
                        "senate_general_status": 2,
                        "sort_order": [0, 2],
                        "state_code": "committee:passed:favorable",
                        "state_dc_label": "Reported Favorably by Committee",
                        "state_label": "Reported Favorably by Committee",
                        "state_other_label": "Reported Favorably by Committee",
                        "value": 9,
                        "xml_code": "None"
                    },
                    "reported_house": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-bullhorn",
                        "key": "reported_house",
                        "label": "Reported by House Committee",
                        "search_help_text": "Reported by House Committee",
                        "senate_general_status": 3,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Reported by House Committee",
                        "state_label": "Reported by House Committee",
                        "state_other_label": "Reported by Assembly Committee",
                        "value": 52,
                        "xml_code": ""
                    },
                    "reported_senate": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-bullhorn",
                        "key": "reported_senate",
                        "label": "Reported by Senate Committee",
                        "search_help_text": "Reported by Senate Committee",
                        "senate_general_status": 2,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Reported by Senate Committee",
                        "state_label": "Reported by Senate Committee",
                        "state_other_label": "Reported by Senate Committee",
                        "value": 57,
                        "xml_code": ""
                    },
                    "reported_subcommittee": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-bullhorn",
                        "key": "reported_subcommittee",
                        "label": "Reported out of Subcommittee",
                        "search_help_text": "Reported out of Subcommittee",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Reported out of Subcommittee",
                        "state_label": "Reported out of Subcommittee",
                        "state_other_label": "Reported out of Subcommittee",
                        "value": 90,
                        "xml_code": ""
                    },
                    "reported_unfavorably": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-thumbs-down",
                        "key": "reported_unfavorably",
                        "label": "Reported Unfavorably by Committee",
                        "search_help_text": "Reported by a committee with an unfavorable report.",
                        "senate_general_status": 8,
                        "sort_order": [0, 2],
                        "state_code": "committee:passed:unfavorable",
                        "state_dc_label": "Reported Unfavorably by Committee",
                        "state_label": "Reported Unfavorably by Committee",
                        "state_other_label": "Reported Unfavorably by Committee",
                        "value": 8,
                        "xml_code": "None"
                    },
                    "request_to_initiate_concertation_parliament": { "abbrev": "REQ_INI_PROCONCERT_byEP", "general_status": 110, "key": "request_to_initiate_concertation_parliament", "label": "Request by EP to initiate concertation procedure", "legislative_body": 2, "value": 1158 },
                    "resolution_regions_committee": { "abbrev": "RES_byCOR", "general_status": 110, "key": "resolution_regions_committee", "label": "Committee of Regions resolution", "legislative_body": 100, "value": 1032 },
                    "returned_to_president": { "abbrev": "", "general_status": 13, "house_general_status": 13, "icon": "fa-bookmark", "key": "returned_to_president", "label": "Returned to the President", "search_help_text": "Returned to the President after being neither confirmed nor rejected", "senate_general_status": 13, "sort_order": 9, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 210, "xml_code": "" },
                    "rule_provides_consideration": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exclamation",
                        "key": "rule_provides_consideration",
                        "label": "Rule provides for consideration of",
                        "search_help_text": "Rule provides for consideration of",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 68,
                        "xml_code": ""
                    },
                    "rules_provides_consideration": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-exclamation",
                        "key": "rules_provides_consideration",
                        "label": "Rule provides for consideration of",
                        "search_help_text": "Rule provides for consideration of",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 75,
                        "xml_code": ""
                    },
                    "second_reading": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-file-audio-o",
                        "key": "second_reading",
                        "label": "Second Reading",
                        "search_help_text": "Bill has undergone second reading.",
                        "senate_general_status": 1,
                        "sort_order": [0, 2],
                        "state_code": "bill:reading:2",
                        "state_dc_label": "Second Reading",
                        "state_label": "Second Reading",
                        "state_other_label": "Second Reading",
                        "value": 13,
                        "xml_code": "None"
                    },
                    "second_reading_amendments_parliament": { "abbrev": "AMEND_R2_byEP", "general_status": 104, "key": "second_reading_amendments_parliament", "label": "EP amendments at 2nd reading to the Council\u2019s position", "legislative_body": 2, "value": 1093 },
                    "second_reading_budget_discussion_council": { "abbrev": "DIS_BUDR2_byCONSIL", "general_status": 105, "key": "second_reading_budget_discussion_council", "label": "Discussion of budget by Council on 2nd reading", "legislative_body": 3, "value": 1078 },
                    "second_reading_budget_discussion_parliament": { "abbrev": "DIS_BUDR2_byEP", "general_status": 104, "key": "second_reading_budget_discussion_parliament", "label": "Discussion of budget by EP on 2nd reading", "legislative_body": 2, "value": 1080 },
                    "second_reading_partial_approval_council": { "abbrev": "APR_PARR2_byCONSIL", "general_status": 105, "key": "second_reading_partial_approval_council", "label": "Council partial approval on 2nd reading", "legislative_body": 3, "value": 1063 },
                    "second_reading_second_chamber": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-file-audio-o",
                        "key": "second_reading_second_chamber",
                        "label": "Second Reading in Second Chamber",
                        "search_help_text": "Bill has undergone second reading in the second chamber.",
                        "senate_general_status": 3,
                        "sort_order": [0, 2],
                        "state_code": "",
                        "state_dc_label": "Second Reading in Second Chamber",
                        "state_label": "Second Reading in Second Chamber",
                        "state_other_label": "Second Reading in Second Chamber",
                        "value": 84,
                        "xml_code": ""
                    },
                    "self_referral_regions_committee": { "abbrev": "REF_SELF_byCOR", "general_status": 110, "key": "self_referral_regions_committee", "label": "Self-referral by Committee of Regions", "legislative_body": 100, "value": 1159 },
                    "senate_committee_discharged": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-minus",
                        "key": "senate_committee_discharged",
                        "label": "Senate committee discharged",
                        "search_help_text": "Senate committee discharged",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 58,
                        "xml_code": ""
                    },
                    "senate_committee_report_filed": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-file-archive-o",
                        "key": "senate_committee_report_filed",
                        "label": "Senate committee report filed after reporting",
                        "search_help_text": "Senate committee report filed after reporting",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 59,
                        "xml_code": ""
                    },
                    "senate_reconsidering": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-gavel",
                        "key": "senate_reconsidering",
                        "label": "Senate Reconsidering",
                        "search_help_text": "Reconsidering",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Senate Reconsidering",
                        "state_label": "Senate Reconsidering",
                        "state_other_label": "Senate Reconsidering",
                        "value": 92,
                        "xml_code": ""
                    },
                    "sent_to_executive": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-envelope",
                        "key": "sent_to_executive",
                        "label": "Sent to President",
                        "search_help_text": "The bill has been sent to the President.",
                        "senate_general_status": 5,
                        "sort_order": [5, 4],
                        "state_code": "governor:received",
                        "state_dc_label": "Sent to Mayor",
                        "state_label": "Sent to Governor",
                        "state_other_label": "Sent to Governor",
                        "value": 31,
                        "xml_code": "None"
                    },
                    "sequentially_referred": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-reply",
                        "key": "sequentially_referred",
                        "label": "Sequential committee referral",
                        "search_help_text": "Sequential committee referral",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 61,
                        "xml_code": ""
                    },
                    "signature_of_intl_agreement": { "abbrev": "SIGN_INT_AGR", "general_status": 8, "key": "signature_of_intl_agreement", "label": "Signature of an international agreement", "legislative_body": 100, "value": 1188 },
                    "spain_adopted": { "abbrev": "", "general_status": 172, "key": "spain_adopted", "label": "Adopted", "state_label": "Adopted", "value": 1452 },
                    "spain_in_progress": { "abbrev": "", "general_status": 171, "key": "spain_in_progress", "label": "In Progress", "state_label": "In Progress", "value": 1451 },
                    "spain_introduced": { "abbrev": "", "general_status": 170, "key": "spain_introduced", "label": "Introduced", "state_label": "Introduced", "value": 1450 },
                    "sponsor_remarks": {
                        "abbrev": "",
                        "house_general_status": 1,
                        "icon": "fa-volume-up",
                        "key": "sponsor_remarks",
                        "label": "Sponsor introductory remarks on measure",
                        "search_help_text": "Sponsor introductory remarks on measure",
                        "senate_general_status": 1,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 49,
                        "xml_code": ""
                    },
                    "start_of_applicability": { "abbrev": "APPL_START", "general_status": 110, "key": "start_of_applicability", "label": "Start of applicability", "legislative_body": 100, "value": 1180 },
                    "start_of_referral_or_authorisation_parliament": { "abbrev": "START_byEP", "general_status": 110, "key": "start_of_referral_or_authorisation_parliament", "label": "EP: official start of referral or autorisation", "legislative_body": 2, "value": 1090 },
                    "substituted": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-random",
                        "key": "substituted",
                        "label": "Replaced With a Substituted Wholesale",
                        "search_help_text": "Bill has been replaced with a substituted wholesale (called hoghousing in some states).",
                        "senate_general_status": 8,
                        "sort_order": [0, 2],
                        "state_code": "bill:substituted",
                        "state_dc_label": "Replaced With a Substituted Wholesale",
                        "state_label": "Replaced With a Substituted Wholesale",
                        "state_other_label": "Replaced With a Substituted Wholesale",
                        "value": 22,
                        "xml_code": "None"
                    },
                    "supplement": { "abbrev": "SUPP_byCOM", "general_status": 110, "key": "supplement", "label": "Supplement", "legislative_body": 1, "value": 1162 },
                    "third_reading": {
                        "abbrev": "",
                        "house_general_status": 2,
                        "icon": "fa-file-audio-o",
                        "key": "third_reading",
                        "label": "Third (Final) Reading",
                        "search_help_text": "Bill has undergone third reading.",
                        "senate_general_status": 2,
                        "sort_order": [0, 2],
                        "state_code": "bill:reading:3",
                        "state_dc_label": "Third (Final) Reading",
                        "state_label": "Third (Final) Reading",
                        "state_other_label": "Third (Final) Reading",
                        "value": 14,
                        "xml_code": "None"
                    },
                    "third_reading_decision_council": { "abbrev": "DEC_R3_byCONSIL", "general_status": 107, "key": "third_reading_decision_council", "label": "Council decision on 3rd reading", "legislative_body": 3, "value": 1058 },
                    "third_reading_second_chamber": {
                        "abbrev": "",
                        "house_general_status": 3,
                        "icon": "fa-file-audio-o",
                        "key": "third_reading_second_chamber",
                        "label": "Third Reading in Second Chamber",
                        "search_help_text": "Bill has undergone third reading in the second chamber.",
                        "senate_general_status": 3,
                        "sort_order": [0, 2],
                        "state_code": "",
                        "state_dc_label": "Third Reading in Second Chamber",
                        "state_label": "Third Reading in Second Chamber",
                        "state_other_label": "Third Reading in Second Chamber",
                        "value": 85,
                        "xml_code": ""
                    },
                    "title_amended": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-pencil",
                        "key": "title_amended",
                        "label": "Title Amended",
                        "search_help_text": "Title Amended",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "Title Amended",
                        "state_label": "Title Amended",
                        "state_other_label": "Title Amended",
                        "value": 82,
                        "xml_code": ""
                    },
                    "transmit_to_council": { "abbrev": "TRS_toCONSIL_byCOM", "general_status": 110, "key": "transmit_to_council", "label": "Transmission to Council", "legislative_body": 1, "value": 1165 },
                    "transmit_to_european_ombudsman": { "abbrev": "TRS_OMB_byCOM", "general_status": 110, "key": "transmit_to_european_ombudsman", "label": "Transmission to European Ombudsman", "legislative_body": 1, "value": 1173 },
                    "transmit_to_parliament": { "abbrev": "TRS_EP_byCOM", "general_status": 102, "key": "transmit_to_parliament", "label": "Transmission to Parliament", "legislative_body": 1, "value": 1174 },
                    "uk_house_of_commons_committee": { "abbrev": "", "general_status": 117, "key": "uk_house_of_commons_committee", "label": "House of Commons Committee Stage", "legislative_body": 120, "state_label": "House of Commons Committee Stage", "value": 1402 },
                    "uk_house_of_commons_first_reading": { "abbrev": "", "general_status": 117, "key": "uk_house_of_commons_first_reading", "label": "House of Commons First Reading", "legislative_body": 120, "state_label": "House of Commons First Reading", "value": 1400 },
                    "uk_house_of_commons_report": { "abbrev": "", "general_status": 117, "key": "uk_house_of_commons_report", "label": "House of Commons Report Stage", "legislative_body": 120, "state_label": "House of Commons Report Stage", "value": 1403 },
                    "uk_house_of_commons_second_reading": { "abbrev": "", "general_status": 117, "key": "uk_house_of_commons_second_reading", "label": "House of Commons Second Reading", "legislative_body": 120, "state_label": "House of Commons Second Reading", "value": 1401 },
                    "uk_house_of_commons_third_reading": { "abbrev": "", "general_status": 118, "key": "uk_house_of_commons_third_reading", "label": "House of Commons Third Reading", "legislative_body": 120, "state_label": "House of Commons Third Reading", "value": 1404 },
                    "uk_house_of_lords_committee": { "abbrev": "", "general_status": 118, "key": "uk_house_of_lords_committee", "label": "House of Lords Committee Stage", "legislative_body": 121, "state_label": "House of Lords Committee Stage", "value": 1407 },
                    "uk_house_of_lords_first_reading": { "abbrev": "", "general_status": 118, "key": "uk_house_of_lords_first_reading", "label": "House of Lords First Reading", "legislative_body": 121, "state_label": "House of Lords First Reading", "value": 1405 },
                    "uk_house_of_lords_report": { "abbrev": "", "general_status": 118, "key": "uk_house_of_lords_report", "label": "House of Lords Report Stage", "legislative_body": 121, "state_label": "House of Lords Report Stage", "value": 1408 },
                    "uk_house_of_lords_second_reading": { "abbrev": "", "general_status": 118, "key": "uk_house_of_lords_second_reading", "label": "House of Lords Second Reading", "legislative_body": 121, "state_label": "House of Lords Second Reading", "value": 1406 },
                    "uk_house_of_lords_third_reading": { "abbrev": "", "general_status": 119, "key": "uk_house_of_lords_third_reading", "label": "House of Lords Third Reading", "legislative_body": 121, "state_label": "House of Lords Third Reading", "value": 1409 },
                    "uk_royal_assent": { "abbrev": "", "general_status": 120, "key": "uk_royal_assent", "label": "Royal Assent", "legislative_body": 122, "state_label": "Royal Assent", "value": 1410 },
                    "union_calendar_assignment": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-calendar-plus-o",
                        "key": "union_calendar_assignment",
                        "label": "Union Calendar assignment",
                        "search_help_text": "Union Calendar assignment",
                        "senate_general_status": 8,
                        "sort_order": [0, 1],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "",
                        "state_other_label": "",
                        "value": 64,
                        "xml_code": ""
                    },
                    "vetoed_override_fail_originating_house": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "vetoed_override_fail_originating_house",
                        "label": "Vetoed & Override Failed in House",
                        "search_help_text": "The House's attempt to override a veto failed.",
                        "senate_general_status": 5,
                        "sort_order": [5, 6],
                        "state_code": "bill:veto_override:failed:lower",
                        "state_dc_label": "Vetoed & Override Failed in Council",
                        "state_label": "Vetoed & Override Failed in House",
                        "state_other_label": "Vetoed & Override Failed in Assembly",
                        "value": 38,
                        "xml_code": "VETOED:OVERRIDE_FAIL_ORIGINATING:HOUSE"
                    },
                    "vetoed_override_fail_originating_senate": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "vetoed_override_fail_originating_senate",
                        "label": "Vetoed & Override Failed in Senate",
                        "search_help_text": "The Senate's attempt to override a veto failed.",
                        "senate_general_status": 5,
                        "sort_order": [5, 7],
                        "state_code": "bill:veto_override:failed:upper",
                        "state_dc_label": "Vetoed & Override Failed in Council",
                        "state_label": "Vetoed & Override Failed in Senate",
                        "state_other_label": "Vetoed & Override Failed in Senate",
                        "value": 39,
                        "xml_code": "VETOED:OVERRIDE_FAIL_ORIGINATING:SENATE"
                    },
                    "vetoed_override_fail_second_house": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "vetoed_override_fail_second_house",
                        "label": "Vetoed & Override Passed Senate, Failed in House",
                        "search_help_text": "The Senate overrode the veto but the House's attempt to override the veto failed.",
                        "senate_general_status": 5,
                        "sort_order": [5, 8],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Vetoed & Override Passed Senate, Failed in House",
                        "state_other_label": "Vetoed & Override Passed Senate, Failed in Assembly",
                        "value": 42,
                        "xml_code": "VETOED:OVERRIDE_FAIL_SECOND:HOUSE"
                    },
                    "vetoed_override_fail_second_senate": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "vetoed_override_fail_second_senate",
                        "label": "Vetoed & Override Passed House, Failed in Senate",
                        "search_help_text": "The House overrode the veto but the Senate's attempt to override the veto failed.",
                        "senate_general_status": 5,
                        "sort_order": [5, 9],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Vetoed & Override Passed House, Failed in Senate",
                        "state_other_label": "Vetoed & Override Passed Assembly, Failed in Senate",
                        "value": 43,
                        "xml_code": "VETOED:OVERRIDE_FAIL_SECOND:SENATE"
                    },
                    "vetoed_pocket": {
                        "abbrev": "",
                        "house_general_status": 5,
                        "icon": "fa-times",
                        "key": "vetoed_pocket",
                        "label": "Pocket Vetoed",
                        "search_help_text": "Pocket vetoed by the President.",
                        "senate_general_status": 5,
                        "sort_order": [5, 5],
                        "state_code": "",
                        "state_dc_label": "",
                        "state_label": "Pocket Vetoed",
                        "state_other_label": "Pocket Vetoed",
                        "value": 37,
                        "xml_code": "VETOED:POCKET"
                    },
                    "withdrawn": {
                        "abbrev": "",
                        "house_general_status": 8,
                        "icon": "fa-times",
                        "key": "withdrawn",
                        "label": "Withdrawn",
                        "search_help_text": "Bill has been withdrawn from consideration.",
                        "senate_general_status": 8,
                        "sort_order": [5, 4],
                        "state_code": "bill:withdrawn",
                        "state_dc_label": "Withdrawn",
                        "state_label": "Withdrawn",
                        "state_other_label": "Withdrawn",
                        "value": 2,
                        "xml_code": "None"
                    },
                    "withdrawn_by_president": { "abbrev": "", "general_status": 14, "house_general_status": 14, "icon": "fa-bookmark", "key": "withdrawn_by_president", "label": "Withdrawn by President", "search_help_text": "Withdrawn from consideration by the President", "senate_general_status": 14, "sort_order": 8, "state_code": "", "state_dc_label": "", "state_label": "", "state_other_label": "", "value": 209, "xml_code": "" },
                    "withdrawn_commission": { "abbrev": "WDW_byCOM", "general_status": 8, "key": "withdrawn_commission", "label": "Withdrawal by Commission", "legislative_body": 1, "value": 1178 },
                    "withdrawn_following_entry_into_force_of_lisbon_treaty_commission": { "abbrev": "WDW_LIS_byCOM", "general_status": 110, "key": "withdrawn_following_entry_into_force_of_lisbon_treaty_commission", "label": "Withdrawal by the Commission following entry into force of the Lisbon Treaty", "legislative_body": 1, "value": 1179 }
                },
                "GeneralBillStatus": {
                    "__is_enum": true,
                    "adopted": {
                        "global_status": 3,
                        "key": "adopted",
                        "label": "Adoption",
                        "short_label": "Adopted",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 108
                    },
                    "brazil_introduced": {
                        "global_status": 1,
                        "key": "brazil_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 140
                    },
                    "brazil_passed_first": {
                        "global_status": 2,
                        "key": "brazil_passed_first",
                        "label": "Passed First",
                        "short_label": "Passed First",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 141
                    },
                    "brazil_passed_second": {
                        "global_status": 2,
                        "key": "brazil_passed_second",
                        "label": "Passed Second",
                        "short_label": "Passed Second",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 142
                    },
                    "brazil_sanction": {
                        "global_status": 3,
                        "key": "brazil_sanction",
                        "label": "Sanction",
                        "short_label": "Sanction",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 143
                    },
                    "canada_introduced": {
                        "global_status": 1,
                        "key": "canada_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 113
                    },
                    "canada_passed_original_chamber": {
                        "global_status": 2,
                        "key": "canada_passed_original_chamber",
                        "label": "Passed Original Chamber",
                        "short_label": "Passed Original Chamber",
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 114
                    },
                    "canada_passed_second_chamber": {
                        "global_status": 2,
                        "key": "canada_passed_second_chamber",
                        "label": "Passed Second Chamber",
                        "short_label": "Passed Second Chamber",
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 115
                    },
                    "canada_royal_assent": {
                        "global_status": 3,
                        "key": "canada_royal_assent",
                        "label": "Royal Assent",
                        "short_label": "Royal Assent",
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 116
                    },
                    "commission_proposal": {
                        "global_status": 1,
                        "key": "commission_proposal",
                        "label": "Proposed by the European Commission",
                        "short_label": "Proposed (EC)",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 101
                    },
                    "conciliation_committee": {
                        "global_status": 2,
                        "key": "conciliation_committee",
                        "label": "Conciliation Committee",
                        "short_label": "Conciliation",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 106
                    },
                    "confirmed": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_confirmed_statuses",
                        "key": "confirmed",
                        "label": "Confirmed",
                        "senate_statuses": "BillStatus.senate_confirmed_statuses",
                        "short_label": "Confirmed",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.confirmed_statuses",
                        "supported_regions": [1, 10000],
                        "value": 12
                    },
                    "council_first_reading": {
                        "global_status": 2,
                        "key": "council_first_reading",
                        "label": "First reading by the European Council",
                        "short_label": "First Reading (EC)",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 103
                    },
                    "council_second_reading": {
                        "global_status": 2,
                        "key": "council_second_reading",
                        "label": "Second reading by the European Council",
                        "short_label": "Second Reading (EC)",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 105
                    },
                    "enacted": {
                        "global_status": 3,
                        "house_statuses": "BillStatus.house_enacted_statuses",
                        "key": "enacted",
                        "label": "Enacted",
                        "senate_statuses": "BillStatus.senate_enacted_statuses",
                        "short_label": "Enacted",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.enacted_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 6
                    },
                    "eu_failed": {
                        "global_status": 2,
                        "key": "eu_failed",
                        "label": "Failed",
                        "short_label": "Failed",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 109
                    },
                    "eu_initiative_commission_adoption": {
                        "global_status": 3,
                        "key": "eu_initiative_commission_adoption",
                        "label": "Commission adoption",
                        "short_label": "Commission adoption",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.eu_initiative_commission_adoption",
                        "supported_regions": [106],
                        "value": 112
                    },
                    "eu_initiative_in_preparation": {
                        "global_status": 2,
                        "key": "eu_initiative_in_preparation",
                        "label": "In preparation",
                        "short_label": "In preparation",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.eu_initiative_in_preparation",
                        "supported_regions": [106],
                        "value": 111
                    },
                    "eu_unknown": {
                        "global_status": 2,
                        "key": "eu_unknown",
                        "label": "Unknown",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 110
                    },
                    "failed": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.final_status_failed",
                        "key": "failed",
                        "label": "Failed",
                        "senate_statuses": "BillStatus.final_status_failed",
                        "short_label": "Failed",
                        "show_in_enumeration": false,
                        "statuses": "BillStatus.final_status_failed",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 9
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "help_text": "Choose the bills that are currently in each of the six major legislative statuses. If you choose \"Passed Original Chamber\", you'll see every bill that has passed its first chamber, but has not gone further. If you'd like to see all bills that have at least passed their first chamber, select \"Passed Original Chamber\" and all subsequent milestones.",
                            "title": "Legislative Milestones",
                            "values": [1, 2, 3, 4, 5, 6]
                        },
                        {
                            "display": "list",
                            "help_text": "Choose the nominations that are currently in each of the five major nomination statuses. If you choose \"Left Committee\", you'll see every nomination that has left at least one committee, but has not gone further. If you'd like to see all nominations that have at least left committee, select \"Left Committee\", and \"Confirmed\". The \"Returned\" status includes all nominations with the final timeline action \"Returned to the President under the provisions of Senate Rule XXXI, paragraph 6 of the Standing Rules of the Senate\" and generally indicates a recess appointment.",
                            "title": "Nomination Milestones",
                            "values": [10, 11, 12, 13, 14]
                        },
                        {
                            "display": "list",
                            "title": "Initiative Stages",
                            "values": [111, 112]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Stages",
                            "values": [101, 102, 103, 104, 105, 106, 107, 108, 109, 110]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [117, 118, 119, 120]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [113, 114, 115, 116]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [130, 131]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [140, 141, 142, 143]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [160, 161, 162]
                        },
                        {
                            "display": "list",
                            "help_text": null,
                            "title": "Legislative Stages",
                            "values": [170, 171, 172]
                        }
                    ],
                    "france_in_progress": {
                        "global_status": 2,
                        "key": "france_in_progress",
                        "label": "In Progress",
                        "short_label": "In Progress",
                        "show_in_enumeration": true,
                        "supported_regions": [205],
                        "value": 161
                    },
                    "france_introduced": {
                        "global_status": 1,
                        "key": "france_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "supported_regions": [205],
                        "value": 160
                    },
                    "france_promulgation": {
                        "global_status": 3,
                        "key": "france_promulgation",
                        "label": "Promulgation",
                        "short_label": "Promulgation",
                        "show_in_enumeration": true,
                        "supported_regions": [205],
                        "value": 162
                    },
                    "germany_in_force": {
                        "global_status": 3,
                        "key": "germany_in_force",
                        "label": "In Force",
                        "short_label": "In Force",
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 131
                    },
                    "germany_proposed": {
                        "global_status": 1,
                        "key": "germany_proposed",
                        "label": "Proposed",
                        "short_label": "Proposed",
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 130
                    },
                    "global_adopted": {
                        "global_status": 3,
                        "key": "global_adopted",
                        "label": "Adopted",
                        "short_label": "Adopted",
                        "show_in_enumeration": false,
                        "supported_regions": [1000],
                        "value": 152
                    },
                    "global_in_progress": {
                        "global_status": 2,
                        "key": "global_in_progress",
                        "label": "In Progress",
                        "short_label": "In Progress",
                        "show_in_enumeration": false,
                        "supported_regions": [1000],
                        "value": 151
                    },
                    "global_introduced": {
                        "global_status": 1,
                        "key": "global_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": false,
                        "supported_regions": [1000],
                        "value": 150
                    },
                    "introduced": {
                        "global_status": 1,
                        "house_statuses": "BillStatus.house_introduced_statuses",
                        "key": "introduced",
                        "label": "Introduced or Prefiled",
                        "senate_statuses": "BillStatus.senate_introduced_statuses",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.introduced_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 1
                    },
                    "left_committee": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_left_committee_statuses",
                        "key": "left_committee",
                        "label": "Left Committee",
                        "senate_statuses": "BillStatus.senate_left_committee_statuses",
                        "short_label": "Left Committee",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.left_committee_statuses",
                        "supported_regions": [1, 10000],
                        "value": 11
                    },
                    "out_of_committee": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_out_of_committee_statuses",
                        "key": "out_of_committee",
                        "label": "Out of Committee",
                        "senate_statuses": "BillStatus.senate_out_of_committee_statuses",
                        "short_label": "Left Committee",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.senate_out_of_committee_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 2
                    },
                    "parliament_first_reading": {
                        "global_status": 2,
                        "key": "parliament_first_reading",
                        "label": "First reading by the European Parliament",
                        "short_label": "First Reading (EP)",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 102
                    },
                    "parliament_second_reading": {
                        "global_status": 2,
                        "key": "parliament_second_reading",
                        "label": "Second reading by the European Parliament",
                        "short_label": "Second Reading (EP)",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 104
                    },
                    "passed_first": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_pass_first_statuses",
                        "key": "passed_first",
                        "label": "Passed Original Chamber",
                        "senate_statuses": "BillStatus.senate_pass_first_statuses",
                        "short_label": "Passed First",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.pass_first_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 3
                    },
                    "passed_second": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_pass_second_statuses",
                        "key": "passed_second",
                        "label": "Passed Second Chamber",
                        "senate_statuses": "BillStatus.senate_pass_second_statuses",
                        "short_label": "Passed Second",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.pass_second_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 4
                    },
                    "received": {
                        "global_status": 1,
                        "house_statuses": "BillStatus.house_received_statuses",
                        "key": "received",
                        "label": "Received",
                        "senate_statuses": "BillStatus.senate_received_statuses",
                        "short_label": "Received",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.received_statuses",
                        "supported_regions": [1, 10000],
                        "value": 10
                    },
                    "returned": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_returned_statuses",
                        "key": "returned",
                        "label": "Returned",
                        "senate_statuses": "BillStatus.senate_returned_statuses",
                        "short_label": "Returned",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.returned_statuses",
                        "supported_regions": [1, 10000],
                        "value": 13
                    },
                    "spain_adopted": {
                        "global_status": 3,
                        "key": "spain_adopted",
                        "label": "Adopted",
                        "short_label": "Adopted",
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 172
                    },
                    "spain_in_progress": {
                        "global_status": 2,
                        "key": "spain_in_progress",
                        "label": "In Progress",
                        "short_label": "In Progress",
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 171
                    },
                    "spain_introduced": {
                        "global_status": 1,
                        "key": "spain_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 170
                    },
                    "third_reading": {
                        "global_status": 2,
                        "key": "third_reading",
                        "label": "Third Reading",
                        "short_label": "Third Reading",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 107
                    },
                    "to_executive": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_to_executive_statuses",
                        "key": "to_executive",
                        "label": "Sent to Executive",
                        "senate_statuses": "BillStatus.senate_to_executive_statuses",
                        "short_label": "To Executive",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.to_executive_statuses",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 5
                    },
                    "uk_introduced": {
                        "global_status": 1,
                        "key": "uk_introduced",
                        "label": "Introduced",
                        "short_label": "Introduced",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 117
                    },
                    "uk_passed_first": {
                        "global_status": 2,
                        "key": "uk_passed_first",
                        "label": "Passed First",
                        "short_label": "Passed First",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 118
                    },
                    "uk_passed_second": {
                        "global_status": 2,
                        "key": "uk_passed_second",
                        "label": "Passed Second",
                        "short_label": "Passed Second",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 119
                    },
                    "uk_royal_assent": {
                        "global_status": 3,
                        "key": "uk_royal_assent",
                        "label": "Royal Assent",
                        "short_label": "Royal Assent",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 120
                    },
                    "unknown": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.unknown",
                        "key": "unknown",
                        "label": "Other",
                        "senate_statuses": "BillStatus.unknown",
                        "short_label": "Unknown",
                        "show_in_enumeration": false,
                        "statuses": "BillStatus.unknown",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 8
                    },
                    "withdrawn": {
                        "global_status": 2,
                        "house_statuses": "BillStatus.house_withdrawn_statuses",
                        "key": "withdrawn",
                        "label": "Withdrawn",
                        "senate_statuses": "BillStatus.senate_withdrawn_statuses",
                        "short_label": "Withdrawn",
                        "show_in_enumeration": true,
                        "statuses": "BillStatus.withdrawn_statuses",
                        "supported_regions": [1, 10000],
                        "value": 14
                    }
                },
                "GlobalBillStatus": {
                    "__is_enum": true,
                    "adopted": { "key": "adopted", "label": "Adopted", "value": 3 },
                    "in_progress": { "key": "in_progress", "label": "In Progress", "value": 2 },
                    "introduced": { "key": "introduced", "label": "Introduced", "value": 1 }
                }
            },
            "types": {
                "language": {
                    "BillLanguage": {
                        "__is_enum": true,
                        "english": {
                            "code": "en",
                            "key": "english",
                            "label": "English",
                            "supported_regions": [1, 10001, 201, 204],
                            "value": 1
                        },
                        "french": {
                            "code": "fr",
                            "key": "french",
                            "label": "French",
                            "supported_regions": [205],
                            "value": 2
                        },
                        "german": {
                            "code": "de",
                            "key": "german",
                            "label": "German",
                            "supported_regions": [203],
                            "value": 3
                        },
                        "portuguese": {
                            "code": "br",
                            "key": "portuguese",
                            "label": "Portuguese",
                            "supported_regions": [208],
                            "value": 4
                        },
                        "spanish": {
                            "code": "es",
                            "key": "spanish",
                            "label": "Spanish",
                            "supported_regions": [211],
                            "value": 5
                        }
                    }
                }
            }
        },
        "blog": {
            "models": {
                "ArticleGroup": {
                    "__is_model": true,
                    "__name__": "ArticleGroup",
                    "data_model": "app.blog.models.ArticleGroup",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/articlegroup/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 4, "help_text": "The ordering of the object, lowest first", "name": "order", "verbose_name": "order" },
                        { "field_type": 1, "help_text": "", "name": "published", "verbose_name": "published" },
                        { "field_type": null, "help_text": "The Personas related to this. Select which Personas are related. Leaving this blank would select ALL Personas", "name": "personas", "verbose_name": "personas" },
                        {
                            "field_type": 7,
                            "help_text": "The feature that this article group is associated with",
                            "name": "feature",
                            "related_model": { "__module__": "app.blog.models", "__name__": "FeatureType" },
                            "verbose_name": "feature"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The learning module that this article group is associated with",
                            "name": "learning_module",
                            "related_model": { "__module__": "app.blog.models", "__name__": "LearningModule" },
                            "verbose_name": "learning module"
                        },
                        { "field_type": 2, "help_text": "Name of the Article Group", "name": "name", "verbose_name": "name" },
                        { "field_type": 1, "help_text": "Whether the Posts in this group should be consumed in order, one after another", "name": "has_order", "verbose_name": "has order" },
                        { "field_type": 1, "help_text": "Whether this group should be shown to all users, or just Org admins", "name": "is_admin_only", "verbose_name": "is admin only" },
                        { "field_type": 1, "help_text": "Whether articles in this group should be rendered with larger titles and icons", "name": "is_featured", "verbose_name": "is featured" },
                        {
                            "field_type": 8,
                            "help_text": "The feature flags that must be enabled in order to view/fetch this object.",
                            "name": "feature_flags",
                            "related_model": { "__module__": "app.featureflags.models", "__name__": "FeatureFlag" },
                            "verbose_name": "feature flags"
                        }
                    ]
                },
                "FeatureType": {
                    "__is_model": true,
                    "__name__": "FeatureType",
                    "data_model": "app.blog.models.FeatureType",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/featuretype/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 4, "help_text": "The ordering of the object, lowest first", "name": "order", "verbose_name": "order" },
                        { "field_type": null, "help_text": "The Personas related to this. Select which Personas are related. Leaving this blank would select ALL Personas", "name": "personas", "verbose_name": "personas" },
                        { "field_type": 2, "help_text": "Name of the Feature", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "The Title of the feature that shows in the header above the description", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "The url parameter for this feature, ex: 'account' for url '/help/account/'. Mandatory", "name": "short_code", "verbose_name": "short code" },
                        { "field_type": 2, "help_text": "The icon to display. Find an icon at https://fontawesome.com/icons?d=gallery&s=duotone and input here (e.g. 'search') ", "name": "icon", "verbose_name": "icon" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "FontAwesomeFamilyType" },
                            "field_type": 4,
                            "help_text": "The FA icon family for this feature",
                            "name": "fa_icon_family",
                            "verbose_name": "fa icon family"
                        },
                        { "field_type": 3, "help_text": "The description or summary of this Feature", "name": "description", "verbose_name": "description" },
                        {
                            "field_type": 8,
                            "help_text": "The feature flags that must be enabled in order to view/fetch this object.",
                            "name": "feature_flags",
                            "related_model": { "__module__": "app.featureflags.models", "__name__": "FeatureFlag" },
                            "verbose_name": "feature flags"
                        }
                    ]
                },
                "HelpCenterPost": {
                    "__is_model": true,
                    "__name__": "HelpCenterPost",
                    "data_model": "app.blog.models.HelpCenterPost",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "published": true },
                    "endpoint": "/api/helpcenterpost/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "", "name": "published", "verbose_name": "published" },
                        { "field_type": null, "help_text": "The Personas related to this. Select which Personas are related. Leaving this blank would select ALL Personas", "name": "personas", "verbose_name": "personas" },
                        { "field_type": 1, "help_text": "Specifies whether this post should show up on the homepage of /help/ (For example, we may not want to EU specific posts on the homepage)", "name": "homepage", "verbose_name": "homepage" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "HelpCenterPostType" },
                            "field_type": 4,
                            "help_text": "The type of Help Center post (FAQ or Step-by-step How-To)",
                            "name": "post_type",
                            "verbose_name": "post type"
                        },
                        { "field_type": null, "help_text": "The types of Product/Categories this post would apply to. (CMD + Click to select)", "name": "post_categories", "verbose_name": "post categories" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "HelpCenterGuideTagType" },
                            "field_type": 4,
                            "help_text": "A tag to track which features clients are using the help center for",
                            "name": "feature_tag_type",
                            "verbose_name": "feature tag type"
                        },
                        { "field_type": null, "help_text": "For How To posts, choose what icons you would like to display on the panel. (CMD + Click to select)", "name": "icons", "verbose_name": "icons" },
                        { "field_type": 2, "help_text": "Choose an icon for the help center. Find an icon at https://fontawesome.com/icons?d=gallery&s=duotone and input here (e.g. 'search')", "name": "fa_icon_name", "verbose_name": "fa icon name" },
                        { "field_type": 1, "help_text": "Indicate whether this post contains video content", "name": "has_video", "verbose_name": "has video" },
                        { "field_type": 2, "help_text": "The question the user may search for", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "ex: /help/how-to/21/power-search-functionality/, 'power-search-functionality' is the short code", "name": "short_code", "verbose_name": "short code" },
                        { "field_type": 3, "help_text": "For FAQ, this is the answer to their question. For How To, description of how user will find this post helpful", "name": "description", "verbose_name": "description" },
                        { "field_type": 17, "help_text": "", "name": "featured_image", "verbose_name": "featured image" },
                        { "field_type": 17, "help_text": "", "name": "downloadable_content", "verbose_name": "downloadable content" },
                        { "field_type": 4, "help_text": "How many times this post has been viewed by distinct users", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 4, "help_text": "How many times this post has been downvoted by distinct users", "name": "downvote_count", "verbose_name": "downvote count" },
                        { "field_type": 4, "help_text": "How many times this post has been upvoted by distinct users", "name": "upvote_count", "verbose_name": "upvote count" },
                        { "field_type": 3, "help_text": "All of this HelpCenterPost's text from its title, description, and text from its Steps", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 4, "help_text": "An optional override for the default ordering -- if this is defined, it will always show up before anything w/o an order.", "name": "order", "verbose_name": "order" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 16, "help_text": "", "name": "last_viewed", "verbose_name": "Last viewed by a user" },
                        {
                            "field_type": 8,
                            "help_text": "The feature flags that must be enabled in order to view/fetch this object.",
                            "name": "feature_flags",
                            "related_model": { "__module__": "app.featureflags.models", "__name__": "FeatureFlag" },
                            "verbose_name": "feature flags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Related posts to read after this post",
                            "name": "related_posts",
                            "related_model": { "__module__": "app.blog.models", "__name__": "HelpCenterPost" },
                            "verbose_name": "related posts"
                        }
                    ]
                },
                "LearningModule": {
                    "__is_model": true,
                    "__name__": "LearningModule",
                    "data_model": "app.blog.models.LearningModule",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "published": true },
                    "endpoint": "/api/learningmodule/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 4, "help_text": "The ordering of the object, lowest first", "name": "order", "verbose_name": "order" },
                        { "field_type": 1, "help_text": "", "name": "published", "verbose_name": "published" },
                        { "field_type": null, "help_text": "The Personas related to this. Select which Personas are related. Leaving this blank would select ALL Personas", "name": "personas", "verbose_name": "personas" },
                        { "field_type": 2, "help_text": "Name of the Learning Module", "name": "name", "verbose_name": "name" },
                        { "field_type": 4, "help_text": "The amount of time (in minutes) it will take to complete this Learning Module", "name": "length", "verbose_name": "length" },
                        { "field_type": 3, "help_text": "The shorter description for this learning module that fits on the inline in the listview.", "name": "short_description", "verbose_name": "short description" },
                        { "field_type": 3, "help_text": "The description or summary of this Learning Module", "name": "description", "verbose_name": "description" },
                        { "field_type": 17, "help_text": "The image displayed in the detail view, next to description", "name": "featured_image", "verbose_name": "featured image" },
                        { "field_type": 2, "help_text": "The icon to display. Find an icon at https://fontawesome.com/icons?d=gallery&s=duotone and input here (e.g. 'graduation-cap') ", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 3, "help_text": "The Title of the learning module that shows in the header above the description", "name": "title", "verbose_name": "title" },
                        { "field_type": 1, "help_text": "Whether to render a progress tracker for this learning module", "name": "should_show_counter", "verbose_name": "should show counter" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "ValuePropType" },
                            "field_type": 4,
                            "help_text": "The Quorum Value Prop associated with this Learning Module",
                            "name": "value_prop_type",
                            "verbose_name": "value prop type"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The feature flags that must be enabled in order to view/fetch this object.",
                            "name": "feature_flags",
                            "related_model": { "__module__": "app.featureflags.models", "__name__": "FeatureFlag" },
                            "verbose_name": "feature flags"
                        }
                    ]
                },
                "ModuleStep": {
                    "__is_model": true,
                    "__name__": "ModuleStep",
                    "data_model": "app.blog.models.ModuleStep",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/modulestep/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "The ordering of the object, lowest first", "name": "order", "verbose_name": "order" },
                        {
                            "field_type": 7,
                            "help_text": "The HelpCenterPosts within the LearningModule",
                            "name": "post",
                            "related_model": { "__module__": "app.blog.models", "__name__": "HelpCenterPost" },
                            "verbose_name": "post"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LearningModule containing the HelpCenterPosts",
                            "name": "learning_module",
                            "related_model": { "__module__": "app.blog.models", "__name__": "LearningModule" },
                            "verbose_name": "learning module"
                        }
                    ]
                },
                "Post": {
                    "__is_model": true,
                    "__name__": "Post",
                    "data_model": "app.blog.models.Post",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "published": true },
                    "endpoint": "/api/post/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "", "name": "published", "verbose_name": "published" },
                        { "field_type": 1, "help_text": "", "name": "featured", "verbose_name": "featured" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "BlogType" },
                            "field_type": 4,
                            "help_text": "The type of of blog post.",
                            "name": "blog_post_type",
                            "verbose_name": "blog post type"
                        },
                        { "field_type": 2, "help_text": "", "name": "side_image", "verbose_name": "side image" },
                        { "field_type": 2, "help_text": "Author to be displayed", "name": "author", "verbose_name": "author" },
                        { "field_type": 2, "help_text": "Author's email address", "name": "email", "verbose_name": "email" },
                        { "field_type": 2, "help_text": "Title", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "Subtitle", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 17, "help_text": "", "name": "featured_image", "verbose_name": "featured image" },
                        { "field_type": 17, "help_text": "", "name": "logo_image", "verbose_name": "logo image" },
                        { "field_type": 5, "help_text": "date", "name": "date", "verbose_name": "date" },
                        { "field_type": 3, "help_text": "Text that is displayed to summarize blog post", "name": "description", "verbose_name": "description" },
                        { "field_type": 2, "help_text": "Text for URL -- no spaces. Words should be lowercase and separated by '-'", "name": "shortcode", "verbose_name": "shortcode" },
                        { "field_type": 2, "help_text": "A string corresponding to the identifying characteristic of our Hubspot Endpoint", "name": "form_code", "verbose_name": "form code" },
                        { "field_type": 17, "help_text": "", "name": "white_paper", "verbose_name": "white paper" },
                        { "field_type": 3, "help_text": "The url that users are redirected to after filling out the gated content form. If blank, no redirect. Should be an absolute url", "name": "gated_content_url", "verbose_name": "gated content url" },
                        { "field_type": 3, "help_text": "The header text at the top of the gated content form. If blank, default is 'Download Case Study' or 'Download White Paper'", "name": "form_header", "verbose_name": "form header" },
                        { "field_type": 3, "help_text": "The subtext at the top of the gated content form. If blank, default is 'Fill out the form below to get the case study!'", "name": "form_subtext", "verbose_name": "form subtext" },
                        { "field_type": 1, "help_text": "Include a Company and Title field to the hubspot form on this gated content page", "name": "should_require_company_field", "verbose_name": "should require company field" },
                        { "field_type": 1, "help_text": "Include a Phone Number field to the hubspot form on this gated content page", "name": "should_require_phone_field", "verbose_name": "should require phone field" },
                        { "field_type": 3, "help_text": "Text that is displayed on single blog page", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "Hubspot Smart CTA code", "name": "hubspot_cta", "verbose_name": "hubspot cta" },
                        { "field_type": 2, "help_text": "(Optional) Custom CTA button text for gated content. If left blank, button defaults to 'Download'.", "name": "cta_button_text", "verbose_name": "cta button text" },
                        { "field_type": 1, "help_text": "For non gated content, display a full screen header with demo request form", "name": "should_use_form_header", "verbose_name": "should use form header" }
                    ]
                },
                "PostView": {
                    "__is_model": true,
                    "__name__": "PostView",
                    "data_model": "app.blog.models.PostView",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/postview/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "post",
                            "related_model": { "__module__": "app.blog.models", "__name__": "HelpCenterPost" },
                            "verbose_name": "post"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "PostVoteType" },
                            "field_type": 4,
                            "help_text": "How the user voted on a Post's usefulness",
                            "name": "vote_type",
                            "verbose_name": "vote type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        }
                    ]
                },
                "Step": {
                    "__is_model": true,
                    "__name__": "Step",
                    "data_model": "app.blog.models.Step",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/step/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": null, "help_text": "The Personas related to this. Select which Personas are related. Leaving this blank would select ALL Personas", "name": "personas", "verbose_name": "personas" },
                        { "field_type": 4, "help_text": "The order this Step will appear in this How To", "name": "order", "verbose_name": "order" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.blog.types", "__name__": "StepLayout" },
                            "field_type": 4,
                            "help_text": "How the description and image will be organized. Select 'Full Page' for images that should be large",
                            "name": "layout",
                            "verbose_name": "layout"
                        },
                        { "field_type": 2, "help_text": "Summarize the Step", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "Description of how to complete Step", "name": "description", "verbose_name": "description" },
                        { "field_type": 17, "help_text": "", "name": "featured_image", "verbose_name": "featured image" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "post",
                            "related_model": { "__module__": "app.blog.models", "__name__": "HelpCenterPost" },
                            "verbose_name": "post"
                        }
                    ]
                }
            },
            "types": {
                "BlogType": {
                    "__is_enum": true,
                    "behind_the_desk": { "form_url": "https://forms.hubspot.com/uploads/form/v2/2054723/54fae52f-30ba-491b-a390-ad86e0d2eda5", "gated_content": false, "key": "behind_the_desk", "label": "Behind the Desk", "meta_tag": 10, "singlular": "Blog Post", "url_pattern": "behind-the-desk", "value": 6 },
                    "best_practices": { "gated_content": false, "key": "best_practices", "label": "Public Affairs Best Practices", "meta_tag": 13, "singlular": "Blog Post", "url_pattern": "best-practices", "value": 7 },
                    "case_studies": { "gated_content": false, "key": "case_studies", "label": "Case Studies", "meta_tag": 12, "singlular": "Case Study", "url_pattern": "case-studies", "value": 5 },
                    "data_driven_politics": { "form_url": "https://forms.hubspot.com/uploads/form/v2/2054723/b99fbaed-239c-4102-bf47-432384822e30", "gated_content": false, "key": "data_driven_politics", "label": "Data Driven Politics", "meta_tag": 8, "singlular": "Blog Post", "url_pattern": "data-driven-insights", "value": 1 },
                    "help_center": { "form_url": "", "gated_content": false, "key": "help_center", "label": "Help Center (deprecated)", "singlular": "", "url_pattern": "", "value": 3 },
                    "other_gated": { "gated_content": true, "key": "other_gated", "label": "Content", "meta_tag": 11, "singlular": "Content", "url_pattern": "resources", "value": 9 },
                    "productivity": { "form_url": "https://forms.hubspot.com/uploads/form/v2/2054723/8075b2f0-590f-43d5-8e0d-4175cc154c4b", "gated_content": false, "key": "productivity", "label": "Productivity", "meta_tag": 9, "singlular": "Blog Post", "url_pattern": "congressional-activity-tracker", "value": 2 },
                    "public_affairs_dictionary": { "gated_content": false, "key": "public_affairs_dictionary", "label": "Public Affairs Dictionary", "meta_tag": 17, "singlular": "Blog Post", "url_pattern": "public-affairs-dictionary", "value": 8 },
                    "white_papers": { "gated_content": true, "key": "white_papers", "label": "White Papers", "meta_tag": 11, "singlular": "Whitepaper", "url_pattern": "resources", "value": 4 }
                },
                "FontAwesomeFamilyType": {
                    "__is_enum": true,
                    "duotone": { "code": "fad", "key": "duotone", "label": "Duotone", "value": 4 },
                    "light": { "code": "fal", "key": "light", "label": "Light", "value": 3 },
                    "regular": { "code": "far", "key": "regular", "label": "Regular", "value": 1 },
                    "solid": { "code": "fas", "key": "solid", "label": "Solid", "value": 2 }
                },
                "HelpCenterPostType": {
                    "__is_enum": true,
                    "faq": { "class_name": "", "external_link": false, "header": "Top FAQs", "key": "faq", "label": "Frequently Asked Questions", "store_slice": "faqPosts", "url_pattern": "faq", "value": 1 },
                    "how_to": { "class_name": "post-item", "external_link": true, "header": "Top How To's", "key": "how_to", "label": "How To", "store_slice": "howToPosts", "url_pattern": "how-to", "value": 2 }
                },
                "PostCategory": {
                    "__is_enum": true,
                    "european_union": { "background_position_y": "35%", "img_path": "apps/marketing-website/images/hero_images/resized/EU_banner.jpg", "key": "european_union", "label": "European Union", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/EU_banner.jpg", "url_pattern": "eu", "value": 6 },
                    "federal": { "background_position_y": "25%", "img_path": "apps/marketing-website/images/hero_images/resized/federal_banner.jpg", "key": "federal", "label": "Federal", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/federal_banner.jpg", "url_pattern": "federal", "value": 1 },
                    "grassroots": { "background_position_y": "50%", "img_path": "apps/marketing-website/images/hero_images/resized/grassroots_banner.jpg", "key": "grassroots", "label": "Grassroots", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/grassroots_banner.jpg", "url_pattern": "grassroots", "value": 4 },
                    "local": { "background_position_y": "50%", "img_path": "apps/marketing-website/images/hero_images/resized/local_banner_new.jpg", "key": "local", "label": "Local", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/local_banner_new.jpg", "url_pattern": "local", "value": 3 },
                    "stakeholder_engagement": { "background_position_y": "60%", "img_path": "apps/marketing-website/images/hero_images/resized/stakeholder_banner.jpg", "key": "stakeholder_engagement", "label": "Stakeholder", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/stakeholder_banner.jpg", "url_pattern": "stakeholder", "value": 5 },
                    "states": { "background_position_y": "0%", "img_path": "apps/marketing-website/images/hero_images/resized/states_banner.jpg", "key": "states", "label": "States", "thumbnail_img_path": "apps/marketing-website/images/hero_images/thumbnail/states_banner.jpg", "url_pattern": "states", "value": 2 }
                },
                "PostIcon": {
                    "__is_enum": true,
                    "getting_started": { "font_awesome_icon": "fa-star", "key": "getting_started", "label": "Getting Started", "tooltip_text": "Getting Started Resource: our team has chosen this article as particularly helpful for new users", "value": 1 },
                    "video": { "font_awesome_icon": "fa-video-camera", "key": "video", "label": "Video", "value": 2 }
                },
                "PostVoteType": {
                    "__is_enum": true,
                    "downvote": { "key": "downvote", "label": "Downvote", "value": 2 },
                    "upvote": { "key": "upvote", "label": "Upvote", "value": 1 },
                    "view": { "key": "view", "label": "View", "value": 3 }
                },
                "StepLayout": {
                    "__is_enum": true,
                    "full_page": { "key": "full_page", "label": "Full Page", "value": 2 },
                    "side_by_side": { "key": "side_by_side", "label": "Side by Side", "value": 1 }
                },
                "ValuePropType": {
                    "__is_enum": true,
                    "cartograph": { "key": "cartograph", "label": "Map", "value": 1 },
                    "change": { "key": "change", "label": "Change", "value": 3 },
                    "report": { "key": "report", "label": "Report", "value": 4 },
                    "track": { "key": "track", "label": "Track", "value": 2 }
                }
            }
        },
        "client_integration": {
            "iterable": {
                "types": {
                    "IterableExternalModel": {
                        "__is_enum": true,
                        "combined_campaigns": { "key": "combined_campaigns", "label": "Combined Campaigns", "quorum_model": "BulkEmail", "value": 1 },
                        "events": { "key": "events", "label": "Events", "quorum_model": "SendEmail", "value": 3 },
                        "users": { "key": "users", "label": "Users", "quorum_model": "Supporter", "value": 2 }
                    }
                }
            },
            "types": {
                "IntegrationRunSchedule": {
                    "__is_enum": true,
                    "custom": { "key": "custom", "label": "Custom Schedule (See Cron)", "value": 6 },
                    "daily": { "key": "daily", "label": "Daily", "value": 3 },
                    "every_15_mins": { "key": "every_15_mins", "label": "Every 15 minutes", "value": 5 },
                    "hourly": { "key": "hourly", "label": "Hourly", "value": 4 },
                    "monthly": { "key": "monthly", "label": "Monthly", "value": 1 },
                    "paused": { "key": "paused", "label": "Paused", "value": 0 },
                    "twice_a_day": { "key": "twice_a_day", "label": "Twice a day", "value": 7 },
                    "weekly": { "key": "weekly", "label": "Weekly", "value": 2 }
                },
                "SyncAllowedDataDirection": {
                    "__is_enum": true,
                    "bidirectional": {
                        "allowed_sync_directions": [3, 4],
                        "key": "bidirectional",
                        "label": "Bidirectional",
                        "value": 3
                    },
                    "only_export_from_quorum": {
                        "allowed_sync_directions": [2],
                        "key": "only_export_from_quorum",
                        "label": "Export Only",
                        "value": 2
                    },
                    "only_import_to_quorum": {
                        "allowed_sync_directions": [1],
                        "key": "only_import_to_quorum",
                        "label": "Import Only",
                        "value": 1
                    }
                },
                "SyncDirection": {
                    "__is_enum": true,
                    "bidirectional_export_first": { "help_text": "Create or update records going both ways, exporting to External Systems first", "key": "bidirectional_export_first", "label": "Bidirectional, Export to External First", "value": 4 },
                    "bidirectional_import_first": { "help_text": "Create or update records going both ways, importing to Quorum first", "key": "bidirectional_import_first", "label": "Bidirectional, Import to Quorum First", "value": 3 },
                    "quorum_export": { "help_text": "Create or update records in External System based on Quorum", "key": "quorum_export", "label": "Export to External", "value": 2 },
                    "quorum_import": { "help_text": "Create or update records in Quorum based on External System", "key": "quorum_import", "label": "Import to Quorum", "value": 1 }
                }
            }
        },
        "committee": {
            "models": {
                "Caucus": {
                    "__is_model": true,
                    "__name__": "Caucus",
                    "data_model": "app.committee.models.Caucus",
                    "default_exclude_filters": {},
                    "default_filters": {
                        "committee_type__in": [4, 5, 6],
                        "obsolete": false
                    },
                    "endpoint": "/api/caucus/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "Committee ID from Know Who", "name": "kw_comid", "verbose_name": "kw comid" },
                        { "field_type": 4, "help_text": "The LegComID of KnowWho's tblLegCom entry for this committee.", "name": "_ph_kw_leg_com_id", "verbose_name": " ph kw leg com id" },
                        { "field_type": 4, "help_text": "Leadership Connect's ID corresponding to an org, representing a committee.", "name": "_ph_lc_org_id", "verbose_name": " ph lc org id" },
                        { "field_type": 4, "help_text": "Legistorm's core_organization_id corresponding to an org representing a committee.", "name": "_ph_ls_core_organization_id", "verbose_name": " ph ls core organization id" },
                        { "field_type": 2, "help_text": "Information Evolution (consultants) unique identifier for Organizations also reused for committees", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.committee.models", "__name__": "CommitteeType" },
                            "field_type": 4,
                            "help_text": "Whether this is a Committee or a Caucus",
                            "name": "committee_type",
                            "verbose_name": "committee type"
                        },
                        { "field_type": 2, "help_text": "An alphanumeric code used for the committee on THOMAS.gov / House.gov / Senate.gov. / Whoiswho", "name": "code", "verbose_name": "code" },
                        { "field_type": 2, "help_text": "If a State Committee, it is the openstates code (if it has one -- many do not).", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 2, "help_text": "The name of the committee or subcommittee.", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "The name of the committee or subcommittee with the full state in it for searching.", "name": "search_name", "verbose_name": "search name" },
                        { "field_type": 2, "help_text": "The committee's majority website.", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "The committee's minority website.", "name": "url_minority", "verbose_name": "url minority" },
                        { "field_type": 2, "help_text": "A really short abbreviation for the committee if present. Has no special significance.", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "Know Who abbreviation", "name": "kw_abbrev", "verbose_name": "kw abbrev" },
                        { "field_type": 1, "help_text": "True if this committee no longer exists.", "name": "obsolete", "verbose_name": "obsolete" },
                        {
                            "field_type": 7,
                            "help_text": "This field indicates whether the object is a committee,in which case the committee field is null, or a subcommittee,in which case this field gives the parent committee.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        { "field_type": null, "help_text": "The keywords that describe this committee.", "name": "keywords", "verbose_name": "keywords" },
                        { "field_type": 3, "help_text": "Committee's physical address, from Know Who, or Who is Who", "name": "address", "verbose_name": "address" },
                        { "field_type": 2, "help_text": "Committee's phone number, from Know Who/Who is Who", "name": "phone", "verbose_name": "phone" },
                        { "field_type": 2, "help_text": "Committee's fax number, from Know Who", "name": "fax", "verbose_name": "fax" },
                        { "field_type": 4, "help_text": "The number of members in this committee.", "name": "num_members", "verbose_name": "num members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are male.", "name": "num_male_members", "verbose_name": "num male members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are female.", "name": "num_female_members", "verbose_name": "num female members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Democrats.", "name": "num_dem_members", "verbose_name": "num dem members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Republicans.", "name": "num_rep_members", "verbose_name": "num rep members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Independent.", "name": "num_ind_members", "verbose_name": "num ind members" },
                        { "field_type": 3, "help_text": "Committee meeting documents", "name": "meeting_documents", "verbose_name": "meeting documents" },
                        { "field_type": 3, "help_text": "Committee witnesses", "name": "witnesses", "verbose_name": "witnesses" },
                        { "field_type": 3, "help_text": "Cached info about chairs", "name": "chairs_string", "verbose_name": "chairs string" },
                        { "field_type": 3, "help_text": "Cached info about ranking members", "name": "ranking_members_string", "verbose_name": "ranking members string" },
                        { "field_type": 4, "help_text": "Manually edited relative rank of committee for display", "name": "rank", "verbose_name": "rank" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "Which Region this Committee belongs in.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 16, "help_text": "When the committee info was last updated by openstates.", "name": "last_updated", "verbose_name": "last updated" },
                        { "field_type": 16, "help_text": "The last time KW updated this committee's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 4, "help_text": "A Committee's whoiswho ID", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 2, "help_text": "Name from who is who", "name": "wiw_name", "verbose_name": "wiw name" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this committee has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/committee/"
                },
                "CaucusMember": {
                    "__is_model": true,
                    "__name__": "CaucusMember",
                    "data_model": "app.committee.models.CaucusMember",
                    "default_exclude_filters": {},
                    "default_filters": {
                        "committee__committee_type__in": [1, 3, 2, 7, 8, 9]
                    },
                    "endpoint": "/api/caucusmember/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 16, "help_text": "The datetime this record 'expired' or became no longer applicable.", "name": "expired", "sheet_column": true, "verbose_name": "expired" },
                        {
                            "field_type": 7,
                            "help_text": "The Member of Congress serving on a committee.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The committee or subcommittee being served on.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.committee.models", "__name__": "CommitteeMemberRole" },
                            "field_type": 4,
                            "help_text": "The role of the member on the committee.",
                            "name": "role",
                            "sheet_column": true,
                            "verbose_name": "role"
                        },
                        { "field_type": 2, "help_text": "Rank from Know Who", "name": "rank", "verbose_name": "rank" },
                        { "field_type": 4, "help_text": "", "name": "dem_rank", "verbose_name": "dem rank" },
                        { "field_type": 4, "help_text": "", "name": "rep_rank", "verbose_name": "rep rank" },
                        { "field_type": 16, "help_text": "The last time KW updated this committee member's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object for which the committee membership is applicable.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": 4, "help_text": "KnowWho's LegComMemberID for the tblLegComMember entry corresponding to this CommitteeMember. Corresponds to COMMEMID in Level-2 data.", "name": "_ph_kw_leg_com_member_id", "verbose_name": " ph kw leg com member id" },
                        { "field_type": 4, "help_text": "Leadership Connect's Position ID for the Position record corresponding to this CommitteeMember", "name": "_ph_lc_position_id", "verbose_name": " ph lc position id" }
                    ],
                    "proxy_endpoint": "/api/committeemember/"
                },
                "Committee": {
                    "__is_model": true,
                    "__name__": "Committee",
                    "data_model": "app.committee.models.Committee",
                    "default_exclude_filters": {},
                    "default_filters": {
                        "committee_type__in": [1, 3, 2, 7, 8, 9],
                        "obsolete": false
                    },
                    "endpoint": "/api/committee/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "Committee ID from Know Who", "name": "kw_comid", "verbose_name": "kw comid" },
                        { "field_type": 4, "help_text": "The LegComID of KnowWho's tblLegCom entry for this committee.", "name": "_ph_kw_leg_com_id", "verbose_name": " ph kw leg com id" },
                        { "field_type": 4, "help_text": "Leadership Connect's ID corresponding to an org, representing a committee.", "name": "_ph_lc_org_id", "verbose_name": " ph lc org id" },
                        { "field_type": 4, "help_text": "Legistorm's core_organization_id corresponding to an org representing a committee.", "name": "_ph_ls_core_organization_id", "verbose_name": " ph ls core organization id" },
                        { "field_type": 2, "help_text": "Information Evolution (consultants) unique identifier for Organizations also reused for committees", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.committee.models", "__name__": "CommitteeType" },
                            "field_type": 4,
                            "help_text": "Whether this is a Committee or a Caucus",
                            "name": "committee_type",
                            "verbose_name": "committee type"
                        },
                        { "field_type": 2, "help_text": "An alphanumeric code used for the committee on THOMAS.gov / House.gov / Senate.gov. / Whoiswho", "name": "code", "verbose_name": "code" },
                        { "field_type": 2, "help_text": "If a State Committee, it is the openstates code (if it has one -- many do not).", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 2, "help_text": "The name of the committee or subcommittee.", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "The name of the committee or subcommittee with the full state in it for searching.", "name": "search_name", "verbose_name": "search name" },
                        { "field_type": 2, "help_text": "The committee's majority website.", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "The committee's minority website.", "name": "url_minority", "verbose_name": "url minority" },
                        { "field_type": 2, "help_text": "A really short abbreviation for the committee if present. Has no special significance.", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "Know Who abbreviation", "name": "kw_abbrev", "verbose_name": "kw abbrev" },
                        { "field_type": 1, "help_text": "True if this committee no longer exists.", "name": "obsolete", "verbose_name": "obsolete" },
                        {
                            "field_type": 7,
                            "help_text": "This field indicates whether the object is a committee,in which case the committee field is null, or a subcommittee,in which case this field gives the parent committee.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        { "field_type": null, "help_text": "The keywords that describe this committee.", "name": "keywords", "verbose_name": "keywords" },
                        { "field_type": 3, "help_text": "Committee's physical address, from Know Who, or Who is Who", "name": "address", "verbose_name": "address" },
                        { "field_type": 2, "help_text": "Committee's phone number, from Know Who/Who is Who", "name": "phone", "verbose_name": "phone" },
                        { "field_type": 2, "help_text": "Committee's fax number, from Know Who", "name": "fax", "verbose_name": "fax" },
                        { "field_type": 4, "help_text": "The number of members in this committee.", "name": "num_members", "verbose_name": "num members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are male.", "name": "num_male_members", "verbose_name": "num male members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are female.", "name": "num_female_members", "verbose_name": "num female members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Democrats.", "name": "num_dem_members", "verbose_name": "num dem members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Republicans.", "name": "num_rep_members", "verbose_name": "num rep members" },
                        { "field_type": 4, "help_text": "The number of members of this committee that are Independent.", "name": "num_ind_members", "verbose_name": "num ind members" },
                        { "field_type": 3, "help_text": "Committee meeting documents", "name": "meeting_documents", "verbose_name": "meeting documents" },
                        { "field_type": 3, "help_text": "Committee witnesses", "name": "witnesses", "verbose_name": "witnesses" },
                        { "field_type": 3, "help_text": "Cached info about chairs", "name": "chairs_string", "verbose_name": "chairs string" },
                        { "field_type": 3, "help_text": "Cached info about ranking members", "name": "ranking_members_string", "verbose_name": "ranking members string" },
                        { "field_type": 4, "help_text": "Manually edited relative rank of committee for display", "name": "rank", "verbose_name": "rank" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "Which Region this Committee belongs in.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 16, "help_text": "When the committee info was last updated by openstates.", "name": "last_updated", "verbose_name": "last updated" },
                        { "field_type": 16, "help_text": "The last time KW updated this committee's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 4, "help_text": "A Committee's whoiswho ID", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 2, "help_text": "Name from who is who", "name": "wiw_name", "verbose_name": "wiw name" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this committee has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "CommitteeKeyword": {
                    "__is_enum": true,
                    "aging": {
                        "key": "aging",
                        "label": "Aging",
                        "search_terms": ["Aging", "elder affairs", "retirement"],
                        "value": 15
                    },
                    "agriculture": {
                        "key": "agriculture",
                        "label": "Agriculture",
                        "search_terms": ["Agriculture", "rural", "livestock", "farming"],
                        "value": 3
                    },
                    "banking_and_finance": {
                        "key": "banking_and_finance",
                        "label": "Banking and Finance",
                        "search_terms": ["financial", "revenue", "bonding", "insurance", "banking", "real estate", "business", "regulated", "licensure", "capital", "expenditures", "assets", "finance", "investment", "banks"],
                        "value": 7
                    },
                    "budget_and_appropriations": {
                        "key": "budget_and_appropriations",
                        "label": "Budget and Appropriations",
                        "search_terms": ["Appropriations", "ways and means", "budget"],
                        "value": 17
                    },
                    "commerce": {
                        "key": "commerce",
                        "label": "Commerce",
                        "search_terms": ["Commerce", "industrial relations", "business", "consumer", "tourism", "ports", "trade", "fish", "game", "corporation"],
                        "value": 4
                    },
                    "economy": {
                        "key": "economy",
                        "label": "Economy",
                        "search_terms": ["Economy", "tax", "fiscal", "revenue", "industry", "job"],
                        "value": 14
                    },
                    "education_and_children": {
                        "key": "education_and_children",
                        "label": "Education and Children",
                        "search_terms": ["Education", "youth", "Children", "social services", "families", "student", "school", "arts", "cultural"],
                        "value": 6
                    },
                    "energy": {
                        "key": "energy",
                        "label": "Energy",
                        "search_terms": ["Energy", "public utilities"],
                        "value": 2
                    },
                    "environment": {
                        "key": "environment",
                        "label": "Environment",
                        "search_terms": ["environment", "natural resources", "environmental preservation", "conservation", "water"],
                        "value": 18
                    },
                    "ethics_and_elections": {
                        "key": "ethics_and_elections",
                        "label": "Ethics and Elections",
                        "search_terms": ["ethics", "elections", "reapportionment", "redistricting"],
                        "value": 16
                    },
                    "health": {
                        "key": "health",
                        "label": "Health",
                        "search_terms": ["Health", "welfare", "human services", "mental", "substance", "recovery", "marijuana", "addiction", "alcohol", "drug"],
                        "value": 1
                    },
                    "judiciary_and_law": {
                        "key": "judiciary_and_law",
                        "label": "Judiciary and Law",
                        "search_terms": ["Judiciary", "Corrections", "safety", "Criminal justice", "homeland security", "security", "law", "civil", "jurisprudence", "codes"],
                        "value": 5
                    },
                    "labor": {
                        "key": "labor",
                        "label": "Labor",
                        "search_terms": ["employment", "workforce", "industrial", "labor"],
                        "value": 9
                    },
                    "military": {
                        "key": "military",
                        "label": "Military",
                        "search_terms": ["Military", "veterans", "defense", "armed services"],
                        "value": 8
                    },
                    "rules": {
                        "key": "rules",
                        "label": "Rules",
                        "search_terms": ["Rules"],
                        "value": 10
                    },
                    "technology": {
                        "key": "technology",
                        "label": "Technology",
                        "search_terms": ["Technology", "science", "space", "research", "telecommunication", "internet", "innovation"],
                        "value": 11
                    },
                    "transportation_and_housing": {
                        "key": "transportation_and_housing",
                        "label": "Transportation and Housing",
                        "search_terms": ["Transportation", "infrastructure", "housing", "community", "manufactured", "urban", "construction"],
                        "value": 12
                    }
                },
                "CommitteeMember": {
                    "__is_model": true,
                    "__name__": "CommitteeMember",
                    "data_model": "app.committee.models.CommitteeMember",
                    "default_exclude_filters": {},
                    "default_filters": {
                        "committee__committee_type__in": [1, 3, 2, 7, 8, 9]
                    },
                    "endpoint": "/api/committeemember/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 16, "help_text": "The datetime this record 'expired' or became no longer applicable.", "name": "expired", "sheet_column": true, "verbose_name": "expired" },
                        {
                            "field_type": 7,
                            "help_text": "The Member of Congress serving on a committee.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The committee or subcommittee being served on.",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.committee.models", "__name__": "CommitteeMemberRole" },
                            "field_type": 4,
                            "help_text": "The role of the member on the committee.",
                            "name": "role",
                            "sheet_column": true,
                            "verbose_name": "role"
                        },
                        { "field_type": 2, "help_text": "Rank from Know Who", "name": "rank", "verbose_name": "rank" },
                        { "field_type": 4, "help_text": "", "name": "dem_rank", "verbose_name": "dem rank" },
                        { "field_type": 4, "help_text": "", "name": "rep_rank", "verbose_name": "rep rank" },
                        { "field_type": 16, "help_text": "The last time KW updated this committee member's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object for which the committee membership is applicable.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": 4, "help_text": "KnowWho's LegComMemberID for the tblLegComMember entry corresponding to this CommitteeMember. Corresponds to COMMEMID in Level-2 data.", "name": "_ph_kw_leg_com_member_id", "verbose_name": " ph kw leg com member id" },
                        { "field_type": 4, "help_text": "Leadership Connect's Position ID for the Position record corresponding to this CommitteeMember", "name": "_ph_lc_position_id", "verbose_name": " ph lc position id" }
                    ]
                },
                "CommitteeMemberRole": {
                    "__is_enum": true,
                    "ad_hoc_member": { "key": "ad_hoc_member", "label": "Ad Hoc Member", "order": 49, "value": 102 },
                    "advisory": { "key": "advisory", "label": "Advisory", "order": 45, "value": 42 },
                    "alternate_member": { "key": "alternate_member", "label": "Alternate Member", "order": 51, "value": 45 },
                    "alternating_chair": { "key": "alternating_chair", "label": "Alternating Chair", "order": 13, "value": 19 },
                    "assistant_ranking_minority_member": { "key": "assistant_ranking_minority_member", "label": "Assistant Ranking Minority Member", "order": 34, "value": 32 },
                    "assistant_vice_chair": { "key": "assistant_vice_chair", "label": "Assistant Vice Chair", "order": 29, "value": 9 },
                    "chair": { "key": "chair", "label": "Chair", "order": 3, "value": 48 },
                    "chairman": { "key": "chairman", "label": "Chair", "order": 2, "value": 2 },
                    "chairman_emeritus": { "key": "chairman_emeritus", "label": "Chairman Emeritus", "order": 8, "value": 46 },
                    "clerk": { "key": "clerk", "label": "Clerk", "order": 44, "value": 37 },
                    "co_chair": { "key": "co_chair", "label": "Co-Chair", "order": 10, "value": 20 },
                    "co_dfl_lead": { "key": "co_dfl_lead", "label": "Co-DFL Lead", "order": 37, "value": 35 },
                    "co_vice_chair": { "key": "co_vice_chair", "label": "Co-Vice Chair", "order": 19, "value": 12 },
                    "democratic_chair": { "key": "democratic_chair", "label": "Democratic Chair", "order": 38, "value": 26 },
                    "democratic_spokesperson": { "key": "democratic_spokesperson", "label": "Democratic Spokesperson", "order": 40, "value": 41 },
                    "democratic_vice_chair": { "key": "democratic_vice_chair", "label": "Democratic Vice Chair", "order": 30, "value": 17 },
                    "deputy_chair": { "key": "deputy_chair", "label": "Deupty Chair", "order": 28, "value": 21 },
                    "dfl_lead": { "key": "dfl_lead", "label": "DFL Lead", "order": 36, "value": 34 },
                    "exofficio": { "key": "exofficio", "label": "Ex Officio", "order": 54, "value": 1 },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "leadership",
                            "values": [4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 34, 35, 49, 50, 2, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 46, 48, 51, 1]
                        },
                        {
                            "display": "list",
                            "title": "chairman_positions",
                            "values": [2, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 46, 48, 51]
                        },
                        {
                            "display": "list",
                            "title": "ranking_member_positions",
                            "values": [3, 31, 32, 33, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 34, 35, 49, 50]
                        }
                    ],
                    "honorary_president": { "key": "honorary_president", "label": "Honorary President", "order": 9, "value": 52 },
                    "honorary_secretary": { "key": "honorary_secretary", "label": "Honorary Secretary", "order": 43, "value": 53 },
                    "house_assistant_vice_chair": { "key": "house_assistant_vice_chair", "label": "House Assistant Vice Chair", "order": 26, "value": 10 },
                    "house_chair": { "key": "house_chair", "label": "House Chair", "order": 6, "value": 22 },
                    "house_vice_chair": { "key": "house_vice_chair", "label": "House Vice Chair", "order": 24, "value": 13 },
                    "interim_advisory": { "key": "interim_advisory", "label": "Interim Advisory", "order": 47, "value": 43 },
                    "interim_chair": { "key": "interim_chair", "label": "Interim Chair", "order": 11, "value": 27 },
                    "interim_co_chair": { "key": "interim_co_chair", "label": "Interim Co-Chair", "order": 12, "value": 28 },
                    "interim_member": { "key": "interim_member", "label": "Interim Member", "order": 50, "value": 44 },
                    "interim_ranking_member": { "key": "interim_ranking_member", "label": "Interim Ranking Member", "order": 16, "value": 33 },
                    "interim_vice_chair": { "key": "interim_vice_chair", "label": "Interim Vice Chair", "order": 31, "value": 18 },
                    "liaison_member": { "key": "liaison_member", "label": "Liaison Member", "order": 52, "value": 101 },
                    "majority_chair": { "key": "majority_chair", "label": "Majority Chair", "order": 4, "value": 25 },
                    "majority_spokesperson": { "key": "majority_spokesperson", "label": "Majority Spokesperson", "order": 35, "value": 39 },
                    "majority_vice_chair": { "key": "majority_vice_chair", "label": "Majority Vice Chair", "order": 32, "value": 15 },
                    "member": { "key": "member", "label": "Member", "order": 48, "value": 5 },
                    "minority_chair": { "key": "minority_chair", "label": "Minority Chair", "order": 17, "value": 24 },
                    "minority_spokesperson": { "key": "minority_spokesperson", "label": "Minority Spokesperson", "order": 46, "value": 38 },
                    "minority_vice_chair": { "key": "minority_vice_chair", "label": "Minority Vice Chair", "order": 33, "value": 16 },
                    "ranking_member": { "key": "ranking_member", "label": "Ranking Member", "order": 14, "value": 3 },
                    "ranking_minority_member": { "key": "ranking_minority_member", "label": "Ranking Minority Member", "order": 15, "value": 31 },
                    "republican_spokesperson": { "key": "republican_spokesperson", "label": "Republican Spokesperson", "order": 41, "value": 40 },
                    "secretary": { "key": "secretary", "label": "Secretary", "order": 42, "value": 36 },
                    "secretary_general": { "key": "secretary_general", "label": "Secretary General", "order": 7, "value": 50 },
                    "senate_assistant_vice_chair": { "key": "senate_assistant_vice_chair", "label": "Senate Assistant Vice Chair", "order": 25, "value": 11 },
                    "senate_chair": { "key": "senate_chair", "label": "Senate Chair", "order": 5, "value": 23 },
                    "senate_vice_chair": { "key": "senate_vice_chair", "label": "Senate Vice Chair", "order": 23, "value": 14 },
                    "senior_chair": { "key": "senior_chair", "label": "Senior Chair", "order": 1, "value": 29 },
                    "steering_committee": { "key": "steering_committee", "label": "Steering Committee", "order": 39, "value": 51 },
                    "sub_chair": { "key": "sub_chair", "label": "Sub-Chair", "order": 27, "value": 30 },
                    "substitute": { "key": "substitute", "label": "Substitute", "order": 53, "value": 47 },
                    "vice_chair": { "key": "vice_chair", "label": "Vice-Chair", "order": 18, "value": 49 },
                    "vice_chair_1": { "key": "vice_chair_1", "label": "First Vice Chair", "order": 20, "value": 6 },
                    "vice_chair_2": { "key": "vice_chair_2", "label": "Second Vice Chair", "order": 21, "value": 7 },
                    "vice_chair_3": { "key": "vice_chair_3", "label": "Third Vice Chair", "order": 22, "value": 8 },
                    "vice_chairman": { "key": "vice_chairman", "label": "Vice Chair", "order": 18, "value": 4 }
                },
                "CommitteeType": {
                    "__is_enum": true,
                    "eu_parliament": {
                        "abbrev": "P",
                        "eu": true,
                        "key": "eu_parliament",
                        "label": "Parliamentary Committee",
                        "supported_regions": [106],
                        "text": "Parliamentary Committee",
                        "value": 7
                    },
                    "eu_parliament_inquiry": {
                        "abbrev": "CI",
                        "eu": true,
                        "key": "eu_parliament_inquiry",
                        "label": "Committee of Inquiry",
                        "supported_regions": [106],
                        "text": "Committee of Inquiry",
                        "value": 9
                    },
                    "eu_parliament_intergroup": {
                        "abbrev": "IG",
                        "eu": true,
                        "key": "eu_parliament_intergroup",
                        "label": "Parliament Intergroup",
                        "supported_regions": [106],
                        "text": "Parliament Intergroup",
                        "value": 8
                    },
                    "eu_parliament_special": {
                        "abbrev": "SP",
                        "eu": true,
                        "key": "eu_parliament_special",
                        "label": "Special Parliament Committee",
                        "supported_regions": [106],
                        "text": "Special Parliament Committee",
                        "value": 10
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Committee",
                            "values": [1, 3, 2, 7, 8, 9]
                        },
                        {
                            "display": "list",
                            "title": "Caucus",
                            "values": [4, 5, 6]
                        }
                    ],
                    "house": {
                        "abbrev": "H",
                        "eu": false,
                        "key": "house",
                        "label": "House",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "House",
                        "value": 3
                    },
                    "house_caucus": {
                        "abbrev": "HC",
                        "eu": false,
                        "key": "house_caucus",
                        "label": "House",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "House Caucus",
                        "value": 5
                    },
                    "joint": {
                        "abbrev": "J",
                        "eu": false,
                        "key": "joint",
                        "label": "Joint",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "Joint",
                        "value": 2
                    },
                    "joint_caucus": {
                        "abbrev": "JC",
                        "eu": false,
                        "key": "joint_caucus",
                        "label": "Joint",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "Joint Caucus",
                        "value": 6
                    },
                    "senate": {
                        "abbrev": "S",
                        "eu": false,
                        "key": "senate",
                        "label": "Senate",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "Senate",
                        "value": 1
                    },
                    "senate_caucus": {
                        "abbrev": "SC",
                        "eu": false,
                        "key": "senate_caucus",
                        "label": "Senate",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "text": "Senate Caucus",
                        "value": 4
                    }
                },
                "CommitteeWitness": {
                    "__is_model": true,
                    "__name__": "CommitteeWitness",
                    "data_model": "app.committee.models.CommitteeWitness",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/committeewitness/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "verbose_name": "created" },
                        { "field_type": 3, "help_text": "The person's full name.", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "The person's first name.", "name": "first_name", "verbose_name": "first name" },
                        { "field_type": 3, "help_text": "The person's middle name.", "name": "middle_name", "verbose_name": "middle name" },
                        { "field_type": 3, "help_text": "The person's last name.", "name": "last_name", "verbose_name": "last name" },
                        { "field_type": 3, "help_text": "The person's honorific.", "name": "honorific", "verbose_name": "honorific" },
                        { "field_type": 3, "help_text": "The person's organization if specified", "name": "organization", "verbose_name": "organization" },
                        { "field_type": 3, "help_text": "The person's position if specified.", "name": "position", "verbose_name": "position" },
                        { "field_type": 3, "help_text": "What kind of witness if specified.", "name": "witness_type", "verbose_name": "witness type" },
                        {
                            "field_type": 7,
                            "help_text": "Links to a person object if the person is a congressman.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        }
                    ]
                }
            }
        },
        "custom_data": {
            "geodata": {
                "models": {
                    "CustomGeoData": {
                        "__is_model": true,
                        "__name__": "CustomGeoData",
                        "data_model": "app.custom_data.geodata.models.CustomGeoData",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/customgeodata/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 2, "help_text": "Type or name of the datum", "name": "name", "verbose_name": "name" },
                            { "field_type": 2, "help_text": "Address of the datum", "name": "address", "verbose_name": "address" },
                            { "field_type": null, "help_text": "stores the lon, lat of the data", "name": "coordinates", "verbose_name": "coordinates" },
                            { "field_type": 4, "help_text": "the id of the custom data type", "name": "type_id", "verbose_name": "type id" },
                            { "field_type": 2, "help_text": "Provided by the organization so that updates can be done easily for matching", "name": "unique_identifier", "verbose_name": "unique identifier" },
                            { "field_type": 2, "help_text": "", "name": "data_hash", "verbose_name": "data hash" },
                            { "field_type": null, "help_text": "", "name": "additional_info", "verbose_name": "additional info" },
                            { "field_type": 4, "help_text": "the related geography.models.State object id", "name": "state_id", "verbose_name": "State" },
                            { "field_type": 4, "help_text": "the related geography.models.District object id", "name": "district_id", "verbose_name": "District" },
                            { "field_type": 4, "help_text": "the related geography.models.UpperLD object id", "name": "upperld_id", "verbose_name": "UpperLD" },
                            { "field_type": 4, "help_text": "the related geography.models.LowerLD object id", "name": "lowerld_id", "verbose_name": "LowerLD" },
                            { "field_type": 4, "help_text": "the related geography.models.County object id", "name": "county_id", "verbose_name": "County" },
                            { "field_type": 4, "help_text": "the related geography.models.Municipality object id", "name": "municipality_id", "verbose_name": "Municipality" },
                            { "field_type": 4, "help_text": "the related geography.models.Country object id", "name": "country_id", "verbose_name": "Country" }
                        ]
                    }
                }
            },
            "manage_data": {
                "models": {
                    "CustomData": {
                        "__is_model": true,
                        "__name__": "CustomData",
                        "data_model": "app.custom_data.manage_data.models.CustomData",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/customdata/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 2, "help_text": "Name of the data type", "name": "category", "verbose_name": "category" },
                            { "field_type": 2, "help_text": "Source of the data (often same as category)", "name": "source", "verbose_name": "source" },
                            { "field_type": 2, "help_text": "Unique slug of the category", "name": "slug", "verbose_name": "slug" },
                            { "field_type": 1, "help_text": "Tells us whether the custom data is associated with a batch of data or individual piece", "name": "is_batch_data", "verbose_name": "is batch data" },
                            {
                                "field_type": 7,
                                "help_text": "Owner of the data type",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            { "field_type": null, "help_text": "The numeric fields of the custom data that can be summed, averaged, etc", "name": "numeric_fields", "verbose_name": "numeric fields" },
                            { "field_type": null, "help_text": "The non numeric fields of the custom data that provide additional information", "name": "non_numeric_fields", "verbose_name": "non numeric fields" },
                            { "field_type": 1, "help_text": "For Geographic Data only, Whether to show only the aggregrated totals forthe data or also show individual points on the map image.", "name": "show_only_aggregate", "verbose_name": "show only aggregate" },
                            { "field_type": 1, "help_text": "Tells us whether the custom data is cached in a batch data", "name": "data_is_cached", "verbose_name": "data is cached" },
                            { "field_type": 4, "help_text": "The position of the field", "name": "position", "verbose_name": "position" },
                            { "field_type": 2, "help_text": "An optional field that is used to group different stats together under the same header.", "name": "grouping_name", "verbose_name": "grouping name" },
                            { "field_type": 1, "help_text": "Whether a result from this custom data should show zeroes or not in the interface.", "name": "show_zeroes", "verbose_name": "show zeroes" },
                            { "field_type": 1, "help_text": "Whether a (State-level) custom data is force to show in District mode", "name": "force_state", "verbose_name": "force state" },
                            { "field_type": 4, "help_text": "The ID of the original CustomData object this object was duplicated from", "name": "original_id", "verbose_name": "original id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.custom_data.manage_data.models", "__name__": "CustomDataQueryOperations" },
                                "field_type": 4,
                                "help_text": "The type of query that should be performed on this geographic data. Only applicable for is_batch_data = False CustomData",
                                "name": "geographic_query_type",
                                "verbose_name": "geographic query type"
                            },
                            { "field_type": 3, "help_text": "The field of the custom data that will be used to perform the operation on the geographic data.  Only applicable for is_batch_data = False CustomData", "name": "geographic_query_field", "verbose_name": "geographic query field" },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to share Custom Data with people outside of their organization. Custom Data will only be visible to users that are on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Many to many for projects and permissions",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "All Bulk Upload Files that uploaded this piece of custom data.",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            }
                        ]
                    },
                    "CustomDataQueryOperations": {
                        "__is_enum": true,
                        "aggregate": { "key": "aggregate", "label": "Aggregate", "value": 2 },
                        "all_stats": { "key": "all_stats", "label": "All_Stats", "value": 5 },
                        "average": { "key": "average", "label": "Average", "value": 4 },
                        "count": { "key": "count", "label": "Count", "value": 1 },
                        "list_of_items": { "key": "list_of_items", "label": "List", "value": 6 },
                        "total": { "key": "total", "label": "Total", "value": 3 }
                    },
                    "FormattingType": {
                        "__is_enum": true,
                        "monetary": { "key": "monetary", "label": "Monetary", "suffix": "M", "value": 3 },
                        "numeric_percent": { "key": "numeric_percent", "label": "Percent", "suffix": "PR", "value": 2 },
                        "numeric_value": { "key": "numeric_value", "label": "Value", "suffix": "E", "value": 1 }
                    },
                    "GrassrootsCustomData": {
                        "__is_model": true,
                        "__name__": "GrassrootsCustomData",
                        "data_model": "app.custom_data.manage_data.models.GrassrootsCustomData",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/grassrootscustomdata/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 2, "help_text": "Name of the data type", "name": "category", "verbose_name": "category" },
                            { "field_type": 2, "help_text": "Source of the data (often same as category)", "name": "source", "verbose_name": "source" },
                            { "field_type": 2, "help_text": "Unique slug of the category", "name": "slug", "verbose_name": "slug" },
                            { "field_type": 1, "help_text": "Tells us whether the custom data is associated with a batch of data or individual piece", "name": "is_batch_data", "verbose_name": "is batch data" },
                            {
                                "field_type": 7,
                                "help_text": "Owner of the data type",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            { "field_type": null, "help_text": "The numeric fields of the custom data that can be summed, averaged, etc", "name": "numeric_fields", "verbose_name": "numeric fields" },
                            { "field_type": null, "help_text": "The non numeric fields of the custom data that provide additional information", "name": "non_numeric_fields", "verbose_name": "non numeric fields" },
                            { "field_type": 1, "help_text": "For Geographic Data only, Whether to show only the aggregrated totals forthe data or also show individual points on the map image.", "name": "show_only_aggregate", "verbose_name": "show only aggregate" },
                            { "field_type": 1, "help_text": "Tells us whether the custom data is cached in a batch data", "name": "data_is_cached", "verbose_name": "data is cached" },
                            { "field_type": 4, "help_text": "The position of the field", "name": "position", "verbose_name": "position" },
                            { "field_type": 2, "help_text": "An optional field that is used to group different stats together under the same header.", "name": "grouping_name", "verbose_name": "grouping name" },
                            { "field_type": 1, "help_text": "Whether a result from this custom data should show zeroes or not in the interface.", "name": "show_zeroes", "verbose_name": "show zeroes" },
                            { "field_type": 1, "help_text": "Whether a (State-level) custom data is force to show in District mode", "name": "force_state", "verbose_name": "force state" },
                            { "field_type": 4, "help_text": "The ID of the original CustomData object this object was duplicated from", "name": "original_id", "verbose_name": "original id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.custom_data.manage_data.models", "__name__": "CustomDataQueryOperations" },
                                "field_type": 4,
                                "help_text": "The type of query that should be performed on this geographic data. Only applicable for is_batch_data = False CustomData",
                                "name": "geographic_query_type",
                                "verbose_name": "geographic query type"
                            },
                            { "field_type": 3, "help_text": "The field of the custom data that will be used to perform the operation on the geographic data.  Only applicable for is_batch_data = False CustomData", "name": "geographic_query_field", "verbose_name": "geographic query field" },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to share Custom Data with people outside of their organization. Custom Data will only be visible to users that are on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Many to many for projects and permissions",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "All Bulk Upload Files that uploaded this piece of custom data.",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            }
                        ],
                        "proxy_endpoint": "/api/customdata/"
                    }
                }
            },
            "models": {
                "BulkUploadFile": {
                    "__is_model": true,
                    "__name__": "BulkUploadFile",
                    "data_model": "app.custom_data.models.BulkUploadFile",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/bulkuploadfile/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "Marks the object to be visible to users thatare on the partner organizations (organization.partners M2M)as well as the normal limited_to_teams users", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                        { "field_type": 2, "help_text": "the original file name of the upload (not the S3 UUID name)", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_data.types", "__name__": "BulkUploadFileExtension" },
                            "field_type": 4,
                            "help_text": "The extension of file being uploaded",
                            "name": "file_extension",
                            "verbose_name": "file extension"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_data.types", "__name__": "BulkUploadType" },
                            "field_type": 4,
                            "help_text": "The type of bulk upload file this is",
                            "name": "upload_type",
                            "verbose_name": "upload type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_data.types", "__name__": "BulkUploadSource" },
                            "field_type": 4,
                            "help_text": "The source where the bulk upload file comes from",
                            "name": "upload_source",
                            "verbose_name": "upload source"
                        },
                        { "field_type": 2, "help_text": "how each cell in every row is separated, e.g. with a CSV that would just be the comma", "name": "delimiter", "verbose_name": "delimiter" },
                        { "field_type": 2, "help_text": "the encoding of the uploaded CSV, e.g. utf-8, latin-1", "name": "encoding", "verbose_name": "encoding" },
                        { "field_type": 2, "help_text": "By default, we'll just use the Bulk Upload bucket.Occasionally, files can come in from other buckets like quorum-ftp-server", "name": "s3_bucket", "verbose_name": "s3 bucket" },
                        { "field_type": 2, "help_text": "the path to the Bulk Upload S3 bucket where the file is actually stored", "name": "s3_path", "verbose_name": "s3 path" },
                        {
                            "field_type": 7,
                            "help_text": "the QuorumUser who originally uploaded the file",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "the QuorumUser who originally uploaded the file, added September, 2018, so always None before then",
                            "name": "logged_in_as_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "logged in as user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "the Organization to which the QuorumUser who uploaded the file belongs",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 4, "help_text": "The number of data rows this Bulk Upload file contains, not including headers", "name": "num_rows", "verbose_name": "num rows" },
                        { "field_type": 4, "help_text": "The number of newly-created contacts via this bulk upload. num_created + num_updated = num_rows", "name": "num_created", "verbose_name": "num created" },
                        { "field_type": 4, "help_text": "The number of existing and updated contacts via this bulk upload. num_created + num_updated = num_rows", "name": "num_updated", "verbose_name": "num updated" },
                        { "field_type": 4, "help_text": "The number of unique records created/updated by this upload", "name": "num_unique_records", "verbose_name": "num unique records" },
                        { "field_type": 4, "help_text": "The number of rows that were unable to be parsed from this upload", "name": "num_failed_rows", "verbose_name": "num failed rows" },
                        { "field_type": null, "help_text": "a list of column names in the original file", "name": "file_headers", "verbose_name": "file headers" },
                        { "field_type": null, "help_text": "A dict of original file headers to quorum header enums", "name": "quorum_headers", "verbose_name": "quorum headers" },
                        { "field_type": 4, "help_text": "the size of the file in bytes, useful for verifying if it's under 2.5Mb, in whichDjango will store the file in memory instead of divide by chunks", "name": "size", "verbose_name": "size" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_data.types", "__name__": "BulkUploadStatus" },
                            "field_type": 4,
                            "help_text": "The status of this file",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        { "field_type": 21, "help_text": "date the processing for this Bulk Upload started", "name": "date_processing_began", "verbose_name": "date processing began" },
                        { "field_type": 21, "help_text": "date this data was parsed and added to the db", "name": "date_parsed", "verbose_name": "date parsed" },
                        { "field_type": 1, "help_text": "Whether or not we should use TIGER in geocoding the addresses in this bulk upload", "name": "use_tiger", "verbose_name": "use tiger" },
                        { "field_type": 1, "help_text": "Whether or not we should geocode addresses at initial upload time", "name": "geocode_address", "verbose_name": "geocode address" },
                        { "field_type": 1, "help_text": "True if we should use the append functionality of multi_options_list", "name": "should_append_to_multi_options_list", "verbose_name": "should append to multi options list" },
                        {
                            "field_type": 7,
                            "help_text": "The Integration Configuration that produced this bulk upload file.",
                            "name": "integration_configuration",
                            "related_model": { "__module__": "app.client_integration.models", "__name__": "IntegrationConfiguration" },
                            "verbose_name": "integration configuration"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                }
            },
            "types": {
                "AggregateDataCategory": {
                    "__is_enum": true,
                    "fields": { "key": "fields", "label": "Fields", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 3 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "name": { "key": "name", "label": "Name", "value": 1 }
                },
                "AggregateDataField": {
                    "__is_enum": true,
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "numeric_percent": { "can_match_multiple": true, "category": 2, "description": "This column is for any data field that is represented in terms of a percentage.  In the Districts tab, the name of this value will be the original header of this column.\nNOTE: Percentage values must be inputted using whole numbers representations. (e.g. 3 => 3%)", "key": "numeric_percent", "label": "Percentage Value", "value": 16 },
                    "numeric_value": { "can_match_multiple": true, "category": 2, "description": "This column is for any data field that is represented in terms of whole or decimal numbers.  In the Districts tab, the name of this value will be the original header of this column", "key": "numeric_value", "label": "Numeric Value", "value": 15 },
                    "region_id": { "can_match_multiple": false, "category": 3, "description": "The region this row maps to.  Can be either a state name/abbreviation or a district in the form ofPA-1, NJ-04, or CA-20.  This field is required.", "key": "region_id", "label": "Region Name", "value": 1 },
                    "region_type": { "can_match_multiple": false, "category": 1, "description": "The region type this row maps to. Leave blank for Federal (Senate or House). Use values 'sldu'for State Upper/Unicameral chamber, 'sldl' for State Lower chamber.", "key": "region_type", "label": "Region Type", "value": 2 }
                },
                "BulkBillCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Fields", "value": 2 }
                },
                "BulkBillField": {
                    "__is_enum": true,
                    "custom_status": { "can_match_multiple": false, "category": 2, "description": "Custom Status for this bill", "key": "custom_status", "label": "Custom Status", "value": 13 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "issues": { "can_match_multiple": true, "category": 2, "description": "A comma separated list of issue names or ids to associate with this bill.", "key": "issues", "label": "Issues", "value": 17 },
                    "priority": { "can_match_multiple": false, "category": 2, "description": "Your organization's stance on this bill, each entry of this column can only be either empty or one of the following words: Watching, Opppose, Support, Unimportant, None", "key": "priority", "label": "Priority", "value": 12 },
                    "quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum identifier of this bill.  Can be found by downloading a csv of bills or from the url of its Quorum page", "key": "quorum_id", "label": "Bill ID", "value": 1 },
                    "quorum_user": { "can_match_multiple": false, "category": 2, "description": "The email or username of the Quorum User this bill should be assigned to", "key": "quorum_user", "label": "User Assignment", "value": 15 },
                    "stance": { "can_match_multiple": false, "category": 2, "description": "Your organization's stance on this bill, each entry of this column can only be one of thefollowing words: Watching, Opppose, Support, Unimportant", "key": "stance", "label": "Stance", "value": 11 },
                    "supporter": { "can_match_multiple": false, "category": 2, "description": "The email or Unique Identifier of the Contact this bill should be assigned to", "key": "supporter", "label": "Contact Assignment", "value": 16 },
                    "text": { "can_match_multiple": false, "category": 2, "description": "Custom Description for this bill", "key": "text", "label": "Custom Description", "value": 10 }
                },
                "BulkCampaignCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Basic Info", "value": 2 },
                    "relations": { "key": "relations", "label": "Relations", "value": 3 }
                },
                "BulkCampaignField": {
                    "__is_enum": true,
                    "action_center": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "Action Center",
                        "feature_flags": [],
                        "key": "action_center",
                        "label": "Action Center",
                        "permission_enum": [],
                        "value": 13
                    },
                    "activated": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Activated",
                        "feature_flags": [],
                        "key": "activated",
                        "label": "Activated",
                        "permission_enum": [],
                        "value": 11
                    },
                    "campaign_subtype": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Subtype",
                        "feature_flags": [],
                        "key": "campaign_subtype",
                        "label": "Subtype",
                        "permission_enum": [],
                        "value": 9
                    },
                    "campaign_type": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Type",
                        "feature_flags": [],
                        "key": "campaign_type",
                        "label": "Type",
                        "permission_enum": [],
                        "value": 8
                    },
                    "completed": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Completed",
                        "feature_flags": [],
                        "key": "completed",
                        "label": "Completed",
                        "permission_enum": [],
                        "value": 12
                    },
                    "ignore": {
                        "can_match_multiple": true,
                        "category": 0,
                        "description": "Don't upload this column",
                        "feature_flags": [],
                        "key": "ignore",
                        "label": "Ignore Column",
                        "permission_enum": [],
                        "value": 0
                    },
                    "internal_only_name": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Internal Only Name",
                        "feature_flags": [],
                        "key": "internal_only_name",
                        "label": "Internal Only Name",
                        "permission_enum": [],
                        "value": 7
                    },
                    "long_description": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Long Description",
                        "feature_flags": [],
                        "key": "long_description",
                        "label": "Long Description",
                        "permission_enum": [],
                        "value": 6
                    },
                    "name": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Name",
                        "feature_flags": [],
                        "key": "name",
                        "label": "Name",
                        "permission_enum": [],
                        "value": 3
                    },
                    "quorum_id": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "Internal ID",
                        "feature_flags": [],
                        "key": "quorum_id",
                        "label": "Quorum ID",
                        "permission_enum": [],
                        "value": 1
                    },
                    "short_description": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Short Description",
                        "feature_flags": [],
                        "key": "short_description",
                        "label": "Short Description",
                        "permission_enum": [],
                        "value": 5
                    },
                    "slug": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Slug",
                        "feature_flags": [],
                        "key": "slug",
                        "label": "Slug",
                        "permission_enum": [],
                        "value": 4
                    },
                    "status": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Status",
                        "feature_flags": [],
                        "key": "status",
                        "label": "Status",
                        "permission_enum": [],
                        "value": 10
                    },
                    "unique_identifier": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "External ID",
                        "feature_flags": [],
                        "key": "unique_identifier",
                        "label": "Unique Identifier",
                        "permission_enum": [],
                        "value": 2
                    }
                },
                "BulkEmailCategory": {
                    "__is_enum": true,
                    "content": { "key": "content", "label": "Email Content", "value": 3 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 5 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "metrics": { "key": "metrics", "label": "Metrics", "value": 4 },
                    "people": { "key": "people", "label": "Email Senders & Recipients", "value": 2 },
                    "required_fields": { "key": "required_fields", "label": "ID and Required Fields", "value": 1 }
                },
                "BulkEmailField": {
                    "__is_enum": true,
                    "bcc_rcpts": { "can_match_multiple": true, "category": 2, "description": "A comma-separated list of email addresses that were included in BCC (max 20 total)", "key": "bcc_rcpts", "label": "BCC Recipients", "value": 10 },
                    "bounces": { "can_match_multiple": false, "category": 4, "description": "Number of emails that bounced.", "key": "bounces", "label": "Bounces", "value": 18 },
                    "cc_rcpts": { "can_match_multiple": true, "category": 2, "description": "A comma-separated list of email addresses that were included in CC (max 20 total)", "key": "cc_rcpts", "label": "CC Recipients", "value": 11 },
                    "clicks": { "can_match_multiple": false, "category": 4, "description": "Total count of unique clicks; click rate will be calculated", "key": "clicks", "label": "Uniuqe Clicks Count", "value": 16 },
                    "external_id": { "can_match_multiple": false, "category": 3, "description": "An External ID used to tie this email to an external system.", "key": "external_id", "label": "External ID", "value": 19 },
                    "from_address": { "can_match_multiple": false, "category": 2, "description": "The Name of the person from whom this email was sent, if available", "key": "from_address", "label": "Email Address Sent From", "value": 5 },
                    "from_name": { "can_match_multiple": false, "category": 2, "description": "The Name of the person from whom this email was sent, if available", "key": "from_name", "label": "Name Sent From", "value": 4 },
                    "from_user": { "can_match_multiple": false, "category": 2, "description": "The QuorumUser that sent this email, if available", "key": "from_user", "label": "Quorum User Sent From", "value": 3 },
                    "html_content": { "can_match_multiple": false, "category": 3, "description": "HTML Content of the Email", "key": "html_content", "label": "HTML Content", "value": 14 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "opens": { "can_match_multiple": false, "category": 4, "description": "Total count of unique opens; open rate will be calculated", "key": "opens", "label": "Unique Opens Count", "value": 15 },
                    "person_count": { "can_match_multiple": false, "category": 4, "description": "Total count of emails sent to Officials / Staffers", "key": "person_count", "label": "Total Email Count to Officials/Staffers", "value": 21 },
                    "quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum ID of this Bulk Email, if updating.", "key": "quorum_id", "label": "Quorum ID", "value": 1 },
                    "reply_to_address": { "can_match_multiple": false, "category": 2, "description": "The email address set as the 'reply-to' address for this email, if available", "key": "reply_to_address", "label": "'Reply To' Email Address", "value": 8 },
                    "reply_to_name": { "can_match_multiple": false, "category": 2, "description": "The Name set as the 'reply-to' Name for this email, if available", "key": "reply_to_name", "label": "'Reply To' Name", "value": 7 },
                    "reply_to_user": { "can_match_multiple": false, "category": 2, "description": "The QuorumUser set as the 'reply-to' individual for this email, if available", "key": "reply_to_user", "label": "'Reply To' Quorum User", "value": 6 },
                    "sent_datetime": { "can_match_multiple": false, "category": 5, "description": "The date & time this was sent. Required, must be in the past, and must be UTC.Any parsable date format acceptable, but recommended is 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' in UTC.", "key": "sent_datetime", "label": "Date/Time Sent", "value": 12 },
                    "subject": { "can_match_multiple": false, "category": 3, "description": "Email subject.", "key": "subject", "label": "Email Subject", "value": 13 },
                    "supporter_count": { "can_match_multiple": false, "category": 4, "description": "Total count of emails sent to Contacts", "key": "supporter_count", "label": "Total Email Count to Contacts", "value": 20 },
                    "unsubscribes": { "can_match_multiple": false, "category": 4, "description": "Total number who unsubscribed through this email.", "key": "unsubscribes", "label": "Unsubscribes", "value": 17 },
                    "user": { "can_match_multiple": false, "category": 2, "description": "The QuorumUser to be listed as having created this email", "key": "user", "label": "Creator", "value": 2 }
                },
                "BulkGrassrootsActionCategory": {
                    "__is_enum": true,
                    "delivery_details": { "key": "delivery_details", "label": "Delivery Details", "value": 3 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Basic Info", "value": 2 },
                    "relations": { "key": "relations", "label": "Relations", "value": 5 },
                    "utm_tracking": { "key": "utm_tracking", "label": "UTM Tracking Parameters", "value": 4 }
                },
                "BulkGrassrootsActionField": {
                    "__is_enum": true,
                    "action_center": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The action center the action is associated to",
                        "feature_flags": [],
                        "key": "action_center",
                        "label": "Action Center",
                        "permission_enum": [],
                        "value": 27
                    },
                    "call_duration": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Duration of phone call in seconds",
                        "feature_flags": [],
                        "key": "call_duration",
                        "label": "Call Duration",
                        "permission_enum": [],
                        "value": 11
                    },
                    "campaign": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The campaign the action is associated to",
                        "feature_flags": [],
                        "key": "campaign",
                        "label": "Campaign",
                        "permission_enum": [],
                        "value": 26
                    },
                    "confirmed": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "Whether or not the action has been confirmed in a campaign requiring approval",
                        "feature_flags": [],
                        "key": "confirmed",
                        "label": "Confirmed",
                        "permission_enum": [],
                        "value": 7
                    },
                    "custom_email_target": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "Specifies a non-standard email recipient for the action, such as organizations or custom targets beyond legislators",
                        "feature_flags": [],
                        "key": "custom_email_target",
                        "label": "Custom Email Target",
                        "permission_enum": [],
                        "value": 13
                    },
                    "date": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The date that the action took place",
                        "feature_flags": [],
                        "key": "date",
                        "label": "Date",
                        "permission_enum": [],
                        "value": 5
                    },
                    "delivered_timestamp": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "Records the time when the message was delivered",
                        "feature_flags": [],
                        "key": "delivered_timestamp",
                        "label": "Delivery Timestamp",
                        "permission_enum": [],
                        "value": 16
                    },
                    "http_referer": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The URL of the webpage from which the supporter navigated to take action",
                        "feature_flags": [],
                        "key": "http_referer",
                        "label": "HTTP Referrer",
                        "permission_enum": [],
                        "value": 17
                    },
                    "ignore": {
                        "can_match_multiple": true,
                        "category": 0,
                        "description": "Don't upload this column",
                        "feature_flags": [],
                        "key": "ignore",
                        "label": "Ignore Column",
                        "permission_enum": [],
                        "value": 0
                    },
                    "interaction_type": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The type of interaction",
                        "feature_flags": [],
                        "key": "interaction_type",
                        "label": "Interaction Type",
                        "permission_enum": [],
                        "value": 9
                    },
                    "message_status": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "Represents the current delivery state of the message, such as pending, delivered, or failed",
                        "feature_flags": [],
                        "key": "message_status",
                        "label": "Message Status",
                        "permission_enum": [],
                        "value": 14
                    },
                    "num_attempts": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The maximum number of attempts to deliver the action before marking it as failed.",
                        "feature_flags": [],
                        "key": "num_attempts",
                        "label": "Number of Attempts to Delivery",
                        "permission_enum": [],
                        "value": 15
                    },
                    "person": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The person who the message is targeted for",
                        "feature_flags": [],
                        "key": "person",
                        "label": "Person",
                        "permission_enum": [],
                        "value": 24
                    },
                    "points_earned": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The amount of points a supporter earned from this action",
                        "feature_flags": [],
                        "key": "points_earned",
                        "label": "Points Earned",
                        "permission_enum": [],
                        "value": 12
                    },
                    "public_organization": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The public organization the action is associated to",
                        "feature_flags": [],
                        "key": "public_organization",
                        "label": "Public Organization",
                        "permission_enum": [],
                        "value": 25
                    },
                    "quorum_id": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The internal ID of the action",
                        "feature_flags": [],
                        "key": "quorum_id",
                        "label": "Quorum ID",
                        "permission_enum": [],
                        "value": 1
                    },
                    "social_media_type": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The type of social media being shared",
                        "feature_flags": [],
                        "key": "social_media_type",
                        "label": "Social Media Type",
                        "permission_enum": [],
                        "value": 10
                    },
                    "subject": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The subject of the message",
                        "feature_flags": [],
                        "key": "subject",
                        "label": "Subject",
                        "permission_enum": [],
                        "value": 3
                    },
                    "submitting_org_name": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The name of the organization taking the action",
                        "feature_flags": [],
                        "key": "submitting_org_name",
                        "label": "Submitting Organization Name",
                        "permission_enum": [],
                        "value": 6
                    },
                    "supporter": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The supporter who owns this action",
                        "feature_flags": [],
                        "key": "supporter",
                        "label": "Supporter",
                        "permission_enum": [],
                        "value": 23
                    },
                    "supporter_action_type": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The type of supporter action",
                        "feature_flags": [],
                        "key": "supporter_action_type",
                        "label": "Supporter Action Type",
                        "permission_enum": [],
                        "value": 8
                    },
                    "text": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The text body of the message",
                        "feature_flags": [],
                        "key": "text",
                        "label": "Text",
                        "permission_enum": [],
                        "value": 4
                    },
                    "unique_identifier": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The external ID of the action",
                        "feature_flags": [],
                        "key": "unique_identifier",
                        "label": "Unique Identifier",
                        "permission_enum": [],
                        "value": 2
                    },
                    "utm_campaign": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Identifies the marketing campaign associated with the traffic source",
                        "feature_flags": [],
                        "key": "utm_campaign",
                        "label": "UTM Campaign",
                        "permission_enum": [],
                        "value": 20
                    },
                    "utm_content": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Differentiates between content variations or links in the same campaign",
                        "feature_flags": [],
                        "key": "utm_content",
                        "label": "UTM Content",
                        "permission_enum": [],
                        "value": 22
                    },
                    "utm_medium": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Specifies the marketing medium used, such as email, social media, or CPC",
                        "feature_flags": [],
                        "key": "utm_medium",
                        "label": "UTM Medium",
                        "permission_enum": [],
                        "value": 19
                    },
                    "utm_source": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Specifies the originating website or platform that directed the traffic",
                        "feature_flags": [],
                        "key": "utm_source",
                        "label": "UTM Source",
                        "permission_enum": [],
                        "value": 18
                    },
                    "utm_term": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Defines the keyword or term associated with paid search campaigns",
                        "feature_flags": [],
                        "key": "utm_term",
                        "label": "UTM Term",
                        "permission_enum": [],
                        "value": 21
                    }
                },
                "BulkPersonCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Personal Info", "value": 2 },
                    "misc": { "key": "misc", "label": "Miscellaneous", "value": 3 }
                },
                "BulkPersonField": {
                    "__is_enum": true,
                    "email": { "can_match_multiple": false, "category": 1, "description": "The official email of this person (Used for matching).", "key": "email", "label": "Email", "value": 3 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "is_unsubscribed": { "can_match_multiple": false, "category": 3, "description": "This column should be marked if this person is unsubscribed from bulk emails", "key": "is_unsubscribed", "label": "Unsubscribed", "value": 15 },
                    "issues": { "can_match_multiple": true, "category": 3, "description": "A comma separated list of issue names or ids to associate with this person.", "key": "issues", "label": "Issues", "value": 23 },
                    "name": { "can_match_multiple": false, "category": 1, "description": "The full name of this person in Quorum, for example 'Sen. Robert \"Bob\" Casey (D-PA)' or 'LA Rep. Mark Abraham (R-LA-036)'. Can be used for matching", "key": "name", "label": "Full Name", "value": 1 },
                    "personal_email": { "can_match_multiple": false, "category": 2, "description": "The personal email of this official or staff member to use for Outbox", "key": "personal_email", "label": "Personal Email", "value": 10 },
                    "personal_phone_number": { "can_match_multiple": false, "category": 2, "description": "The personal phone number of this official or staff member", "key": "personal_phone_number", "label": "Personal Phone Number", "value": 11 },
                    "preferred_name": { "can_match_multiple": false, "category": 2, "description": "The person's preferred name for Outbox", "key": "preferred_name", "label": "Preferred Name", "value": 12 },
                    "quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum Identifier of this person. Can be used for extremely reliable matching. Can be found by downloading a csv of people or from the url of the person's Quorum page", "key": "quorum_id", "label": "Quorum ID", "value": 2 },
                    "quorum_user": { "can_match_multiple": false, "category": 3, "description": "The email or username of the Quorum User this official or staff member should be assigned to", "key": "quorum_user", "label": "User Assignment", "value": 21 },
                    "supporter": { "can_match_multiple": false, "category": 3, "description": "The email, username, or Unique Identifier of the Supporter this official or staff member should be assigned to", "key": "supporter", "label": "Contact Assignment", "value": 22 },
                    "text": { "can_match_multiple": false, "category": 3, "description": "Custom Description for this official or staff member", "key": "text", "label": "Description", "value": 20 }
                },
                "BulkUploadFileExtension": {
                    "__is_enum": true,
                    "csv": { "content_type": "text/csv", "key": "csv", "label": "csv", "value": 1 },
                    "tsv": { "content_type": "text/tab-separated-values", "key": "tsv", "label": "tsv", "value": 4 },
                    "txt": { "content_type": "text/plain", "key": "txt", "label": "txt", "value": 5 },
                    "xls": { "content_type": "application/vnd.ms-excel", "key": "xls", "label": "xls", "value": 2 },
                    "xlsx": { "content_type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "key": "xlsx", "label": "xlsx", "value": 3 }
                },
                "BulkUploadSource": {
                    "__is_enum": true,
                    "bulk_upload_form": { "key": "bulk_upload_form", "label": "Bulk Upload Form", "value": 1 },
                    "client_automation": { "key": "client_automation", "label": "Client Automation Job", "value": 4 },
                    "integration": { "key": "integration", "label": "Client Integration", "value": 5 },
                    "manual_upload": { "key": "manual_upload", "label": "Manually Triggered by a Developer", "value": 2 },
                    "phone2action": { "key": "phone2action", "label": "Phone2Action", "value": 6 },
                    "sftp": { "key": "sftp", "label": "SFTP Integration", "value": 3 }
                },
                "BulkUploadStatus": {
                    "__is_enum": true,
                    "error": { "key": "error", "label": "Error Occurred During Processing", "value": 6 },
                    "finished": { "key": "finished", "label": "Finished Processing", "value": 5 },
                    "in_progress": { "key": "in_progress", "label": "Processing", "value": 4 },
                    "integration_created_ready": { "key": "integration_created_ready", "label": "Ready to Process - through Integration", "value": 8 },
                    "not_ready": { "key": "not_ready", "label": "Cancelled", "value": 1 },
                    "queued": { "key": "queued", "label": "Queued for Processing", "value": 3 },
                    "ready": { "key": "ready", "label": "Uploaded -- Waiting to be Processed", "value": 2 },
                    "received": { "key": "received", "label": "Received", "value": 7 }
                },
                "BulkUploadType": {
                    "__is_enum": true,
                    "aggregate_data": {
                        "can_multiprocess": true,
                        "category_enum_name": "AggregateDataCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Aggregate+Data+Upload+Template.csv",
                        "field_enum_name": "AggregateDataField",
                        "hide_in_ui": false,
                        "identifier_fields": [1],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "aggregate_data",
                        "label": "Custom Data - Aggregate",
                        "order": 2,
                        "permission_enum": [4],
                        "processor": "Custom Data",
                        "quorum_data_type": 79,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "datum",
                        "value": 7
                    },
                    "bill": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkBillCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Bill+Upload+Example.csv",
                        "field_enum_name": "BulkBillField",
                        "hide_in_ui": false,
                        "identifier_fields": [1],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "bill",
                        "label": "Bills",
                        "order": 0,
                        "permission_enum": [304],
                        "processor": "Custom Fields for Shared Models",
                        "quorum_data_type": 2,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "bill",
                        "value": 5
                    },
                    "bulk_email": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkEmailCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "BulkEmailField",
                        "hide_in_ui": false,
                        "identifier_fields": [12],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "bulk_email",
                        "label": "Historic Bulk Email Data",
                        "order": 8,
                        "permission_enum": [202, 205],
                        "processor": "Bulk Email",
                        "quorum_data_type": 44,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "outbox email campaign",
                        "value": 15
                    },
                    "campaign": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkCampaignCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Campaign+Upload+Example.csv",
                        "feature_flag": "ff_campaign_upload",
                        "field_enum_name": "BulkCampaignField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "campaign",
                        "label": "Campaigns",
                        "order": 22,
                        "permission_enum": [219],
                        "processor": "Campaigns",
                        "quorum_data_type": 47,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "campaign",
                        "value": 26
                    },
                    "disbursement_voids": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACDisbursementVoidCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACDisbursementVoidField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": true,
                        "key": "disbursement_voids",
                        "label": "Voids of Disbursements",
                        "order": 21,
                        "permission_enum": [8],
                        "processor": "QPAC Disbursements",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "void of disbursement",
                        "value": 23
                    },
                    "disbursements_to_custom_organizations": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACDisbursementToNonPacOrgCategory",
                        "counterparty_q_data_type": 42,
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACDisbursementToNonPacOrgField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 1, 3, 10, 11, 12],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "disbursements_to_custom_organizations",
                        "label": "Disbursements to Organizations other than Political Committees",
                        "order": 5,
                        "permission_enum": [8],
                        "processor": "QPAC Disbursements",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "disbursement to non-PAC Organization",
                        "value": 18
                    },
                    "disbursements_to_political_committees": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACDisbursementToPACCategory",
                        "counterparty_q_data_type": 114,
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACDisbursementToPACField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 6, 10, 11, 12],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "disbursements_to_political_committees",
                        "label": "Disbursements to Political Committees",
                        "order": 6,
                        "permission_enum": [8],
                        "processor": "QPAC Disbursements",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "disbursement to PAC",
                        "value": 17
                    },
                    "donations": {
                        "can_multiprocess": true,
                        "default_parser_kwargs": {},
                        "hide_in_ui": false,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "donations",
                        "label": "Donations",
                        "permission_enum": [0],
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "",
                        "value": 8
                    },
                    "gamification_points": {
                        "can_multiprocess": true,
                        "category_enum_name": "GamificationPointsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Template+for+Gamification+Points.csv",
                        "field_enum_name": "GamificationPointsField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "gamification_points",
                        "label": "Gamification Points",
                        "order": 7,
                        "permission_enum": [201],
                        "processor": "Gamification Points",
                        "quorum_data_type": 69,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "gamification point",
                        "value": 11
                    },
                    "geographic_data": {
                        "can_multiprocess": true,
                        "category_enum_name": "GeographicDataCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Geographic+Data+Upload+Template.csv",
                        "field_enum_name": "GeographicDataField",
                        "hide_in_ui": false,
                        "identifier_fields": [1],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "geographic_data",
                        "label": "Custom Data - Geographic",
                        "order": 3,
                        "permission_enum": [4],
                        "processor": "Custom Data",
                        "quorum_data_type": 79,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "datum",
                        "value": 6
                    },
                    "grassroots_action": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkGrassrootsActionCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Grassroots+Action+Upload+Example.csv",
                        "feature_flag": "ff_grassroots_action_upload",
                        "field_enum_name": "BulkGrassrootsActionField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "grassroots_action",
                        "label": "Grassroots Actions",
                        "order": 23,
                        "permission_enum": [201],
                        "processor": "Grassroots Actions",
                        "quorum_data_type": 69,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "grassroots_action",
                        "value": 27
                    },
                    "historic_fec_filings": {
                        "can_multiprocess": true,
                        "category_enum_name": "HistoricFECFilingCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "HistoricFECFilingField",
                        "hide_in_ui": false,
                        "identifier_fields": [2],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "historic_fec_filings",
                        "label": "PAC - Historic FEC Filings",
                        "order": 12,
                        "permission_enum": [8],
                        "processor": "QPAC Historic FEC Filing",
                        "quorum_data_type": 110,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": true,
                        "singular": "historic filing",
                        "value": 25
                    },
                    "historic_interactions": {
                        "can_multiprocess": true,
                        "category_enum_name": "HistoricInteractionCategory",
                        "default_parser_kwargs": { "sandbox": true },
                        "example_url": "https://quorum-static.s3.amazonaws.com/media/Template+for+Historic+Interactions.csv",
                        "feature_flag": "ff_historic_interaction_upload",
                        "field_enum_name": "HistoricInteractionField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 4, 26],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "historic_interactions",
                        "label": "Historic Interactions",
                        "order": 9,
                        "permission_enum": [6, 5, 7],
                        "processor": "Historic Interactions",
                        "quorum_data_type": 20,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "interaction",
                        "value": 10
                    },
                    "official": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkPersonCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Person+Upload+Example.csv",
                        "field_enum_name": "BulkPersonField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 1, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "official",
                        "label": "Officials",
                        "order": 11,
                        "permission_enum": [300],
                        "processor": "Custom Fields for Shared Models",
                        "quorum_data_type": 1,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "official",
                        "value": 4
                    },
                    "p2a_migration_action": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_action",
                        "label": "Phone2Action Migration - Action",
                        "order": 104,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 69,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action action",
                        "value": 104
                    },
                    "p2a_migration_advocate": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [1, 2, 5, 7, 20, 70],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_advocate",
                        "label": "Phone2Action Migration - Advocate",
                        "order": 101,
                        "permission_enum": [204],
                        "processor": "P2A Migration",
                        "quorum_data_type": 12,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action advocate",
                        "value": 101
                    },
                    "p2a_migration_alert": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_alert",
                        "label": "Phone2Action Migration - Alert",
                        "order": 105,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 20,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action alert",
                        "value": 106
                    },
                    "p2a_migration_alert_event": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_alert_event",
                        "label": "Phone2Action Migration - Alert Event",
                        "order": 106,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 113,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action alert event",
                        "value": 107
                    },
                    "p2a_migration_campaign": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_campaign",
                        "label": "Phone2Action Migration - Campaign",
                        "order": 102,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 47,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action campaign",
                        "value": 102
                    },
                    "p2a_migration_integration": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_integration",
                        "label": "Phone2Action Migration - Integration",
                        "order": 108,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 47,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action integration",
                        "value": 108
                    },
                    "p2a_migration_legislator": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_legislator",
                        "label": "Phone2Action Migration - Legislator",
                        "order": 103,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 47,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action legislator",
                        "value": 103
                    },
                    "p2a_migration_relationship": {
                        "can_multiprocess": false,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": true,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "p2a_migration_relationship",
                        "label": "Phone2Action Migration - Relationship",
                        "order": 105,
                        "permission_enum": [4],
                        "processor": "P2A Migration",
                        "quorum_data_type": 20,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "phone2action relationship",
                        "value": 105
                    },
                    "pacc_migration_custom_org_with_limit_type": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomOrgWithPacOrgTypePACCMigrationCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "CustomOrgWithPacOrgTypePACCMigrationField",
                        "hide_in_ui": false,
                        "identifier_fields": [51],
                        "is_pacc_migration": true,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_custom_org_with_limit_type",
                        "label": "PACC Migration - Custom Orgs WITH PAC Org Type",
                        "order": 52,
                        "permission_enum": [301, 204, 105, 104, 8],
                        "processor": "Custom Organizations",
                        "quorum_data_type": 42,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom organization",
                        "value": 55
                    },
                    "pacc_migration_custom_organization": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomOrgNoPacOrgTypePACCMigrationCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "CustomOrgNoPacOrgTypePACCMigrationField",
                        "hide_in_ui": false,
                        "identifier_fields": [59],
                        "is_pacc_migration": true,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_custom_organization",
                        "label": "PACC Migration - Custom Orgs without PAC Org Type",
                        "order": 53,
                        "permission_enum": [301, 204, 105, 104, 8],
                        "processor": "Custom Organizations",
                        "quorum_data_type": 42,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom organization",
                        "value": 54
                    },
                    "pacc_migration_disbursements_to_nonpac_organization": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACDisbursementToNonPacOrgCategoryPACCMigration",
                        "counterparty_q_data_type": 42,
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACDisbursementToNonPacOrgFieldPACCMigration",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 1, 3, 10, 11, 12],
                        "is_pacc_migration": true,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_disbursements_to_nonpac_organization",
                        "label": "PACC Migration - Disbursements to Non-PAC Organizations",
                        "order": 54,
                        "permission_enum": [8],
                        "processor": "QPAC Disbursements",
                        "quorum_data_type": 107,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "disbursement to Non-PAC Organization",
                        "value": 52
                    },
                    "pacc_migration_disbursements_to_political_committee": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACDisbursementToPACCategoryPACCMigration",
                        "counterparty_q_data_type": 114,
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACDisbursementToPACFieldPACCMigration",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 6, 10, 11, 12],
                        "is_pacc_migration": true,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_disbursements_to_political_committee",
                        "label": "PACC Migration - Disbursements to Political Committees",
                        "order": 55,
                        "permission_enum": [8],
                        "processor": "QPAC Disbursements",
                        "quorum_data_type": 107,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "disbursement to PAC",
                        "value": 51
                    },
                    "pacc_migration_individual_receipts": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACReceiptFromIndividualCategoryPACCMigration",
                        "counterparty_q_data_type": 12,
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Template+for+Individual+Contributions.csv",
                        "field_enum_name": "QPACReceiptFromIndividualFieldPACCMigration",
                        "hide_in_ui": false,
                        "identifier_fields": [100, 101, 103, 104, 10, 11, 12],
                        "is_pacc_migration": true,
                        "is_receipt": true,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_individual_receipts",
                        "label": "PACC Migration - Receipts from Individuals",
                        "order": 56,
                        "permission_enum": [8],
                        "processor": "QPAC Receipts",
                        "quorum_data_type": 107,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "individual receipt",
                        "value": 50
                    },
                    "pacc_migration_supporter": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomContactsPACCMigrationCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "CustomContactsPACCMigrationField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 101],
                        "is_pacc_migration": true,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_migration_supporter",
                        "label": "PACC Migration - Custom Contacts",
                        "order": 51,
                        "permission_enum": [204, 8],
                        "processor": "Custom Contacts",
                        "quorum_data_type": 12,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom contact",
                        "value": 53
                    },
                    "pacc_onboarding_supporter": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomContactsPACCSyncOnboardingCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "CustomContactsPACCSyncOnboardingField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "pacc_onboarding_supporter",
                        "label": "PAC Onboarding - Sync Custom Contacts",
                        "order": 70,
                        "permission_enum": [204, 8],
                        "processor": "Custom Contacts",
                        "quorum_data_type": 12,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom contact to sync",
                        "value": 70
                    },
                    "political_committees": {
                        "can_multiprocess": true,
                        "category_enum_name": "PoliticalCommitteeCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "PoliticalCommitteeField",
                        "hide_in_ui": false,
                        "identifier_fields": [1],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "political_committees",
                        "label": "State & Local Political Committees",
                        "order": 19,
                        "permission_enum": [213],
                        "processor": "Political Committee",
                        "quorum_data_type": 114,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "Political Committee",
                        "value": 21
                    },
                    "press_contact": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkPersonCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Press+Contact+Upload+Example.csv",
                        "field_enum_name": "BulkPersonField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 1, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "press_contact",
                        "label": "Press Contacts",
                        "order": 13,
                        "permission_enum": [105],
                        "processor": "Custom Fields for Shared Models",
                        "quorum_data_type": 120,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "Press Contact",
                        "value": 14
                    },
                    "public_organization": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomOrganizationsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Organizations+Upload+Example.csv",
                        "field_enum_name": "CustomOrganizationsField",
                        "hide_in_ui": false,
                        "identifier_fields": [6, 5, 1, 7],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "public_organization",
                        "label": "Custom Organizations",
                        "order": 4,
                        "permission_enum": [301, 204, 105, 104],
                        "processor": "Custom Organizations",
                        "quorum_data_type": 42,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom organization",
                        "value": 2
                    },
                    "quorum_public_organization": {
                        "can_multiprocess": true,
                        "category_enum_name": "QuorumOrganizationsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Public+Organizations+Upload+Example.csv",
                        "field_enum_name": "QuorumOrganizationsField",
                        "hide_in_ui": false,
                        "identifier_fields": [1],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "quorum_public_organization",
                        "label": "Public Organizations",
                        "order": 14,
                        "permission_enum": [301, 204, 105, 104],
                        "processor": "Custom Fields for Shared Models",
                        "quorum_data_type": 42,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "public organization",
                        "value": 13
                    },
                    "receipts_from_anonymous_individuals": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACReceiptFromAnonymousIndividualCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACReceiptFromAnonymousIndividualField",
                        "hide_in_ui": false,
                        "identifier_fields": [10, 11],
                        "is_pacc_migration": false,
                        "is_receipt": true,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "receipts_from_anonymous_individuals",
                        "label": "Receipts from Anonymous Individuals",
                        "order": 15,
                        "permission_enum": [8],
                        "processor": "QPAC Receipts",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "anonymous receipt",
                        "value": 24
                    },
                    "receipts_from_custom_organizations": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACReceiptFromCustomOrganizationCategory",
                        "counterparty_q_data_type": 42,
                        "default_parser_kwargs": {},
                        "field_enum_name": "QPACReceiptFromCustomOrganizationField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 3, 10, 11, 12],
                        "is_pacc_migration": false,
                        "is_receipt": true,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "receipts_from_custom_organizations",
                        "label": "Receipts from Organizations other than Political Committees",
                        "order": 16,
                        "permission_enum": [8],
                        "processor": "QPAC Receipts",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "receipt from an organization other than a political committee",
                        "value": 22
                    },
                    "receipts_from_political_committees": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACReceiptFromPoliticalCommitteeCategory",
                        "counterparty_q_data_type": 114,
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Template+for+Individual+Contributions.csv",
                        "field_enum_name": "QPACReceiptFromPoliticalCommitteeField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 10, 11, 12],
                        "is_pacc_migration": false,
                        "is_receipt": true,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "receipts_from_political_committees",
                        "label": "Receipts from Political Committees",
                        "order": 17,
                        "permission_enum": [8],
                        "processor": "QPAC Receipts",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "receipt from political committee",
                        "value": 19
                    },
                    "receipts_from_supporters": {
                        "can_multiprocess": true,
                        "category_enum_name": "QPACReceiptFromIndividualCategory",
                        "counterparty_q_data_type": 12,
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Template+for+Individual+Contributions.csv",
                        "field_enum_name": "QPACReceiptFromIndividualField",
                        "hide_in_ui": false,
                        "identifier_fields": [7, 5, 6, 10, 11, 12],
                        "is_pacc_migration": false,
                        "is_receipt": true,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "receipts_from_supporters",
                        "label": "Receipts from Individuals",
                        "order": 15,
                        "permission_enum": [8],
                        "processor": "QPAC Receipts",
                        "quorum_data_type": 107,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "individual receipt",
                        "value": 12
                    },
                    "removed_file": {
                        "can_multiprocess": true,
                        "default_parser_kwargs": {},
                        "hide_in_ui": false,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "removed_file",
                        "label": "Removed Files",
                        "permission_enum": [1004],
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "removed file",
                        "value": 28
                    },
                    "secure": {
                        "can_multiprocess": true,
                        "default_parser_kwargs": {},
                        "hide_in_ui": false,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "secure",
                        "label": "Secure Uploads",
                        "permission_enum": [0],
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "",
                        "value": 3
                    },
                    "send_email": {
                        "can_multiprocess": true,
                        "category_enum_name": "SendEmailCategory",
                        "default_parser_kwargs": {},
                        "field_enum_name": "SendEmailField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 3, 1, 7],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "send_email",
                        "label": "Historic Send Email Data",
                        "order": 10,
                        "permission_enum": [202, 205, 105],
                        "processor": "Send Email",
                        "quorum_data_type": 45,
                        "quorum_employee_only": true,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "outbox single email",
                        "value": 16
                    },
                    "staffer": {
                        "can_multiprocess": true,
                        "category_enum_name": "BulkPersonCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Bulk+Person+Upload+Example.csv",
                        "field_enum_name": "BulkPersonField",
                        "hide_in_ui": false,
                        "identifier_fields": [2, 1, 3],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "staffer",
                        "label": "Staffers",
                        "order": 18,
                        "permission_enum": [302],
                        "processor": "Custom Fields for Shared Models",
                        "quorum_data_type": 8,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "staffer",
                        "value": 9
                    },
                    "supporter": {
                        "can_multiprocess": true,
                        "category_enum_name": "CustomContactsCategory",
                        "default_parser_kwargs": {},
                        "example_url": "https://s3.amazonaws.com/quorum-static/media/Custom+Contacts+Upload+Example.csv",
                        "field_enum_name": "CustomContactsField",
                        "hide_in_ui": false,
                        "identifier_fields": [1, 2, 5, 7, 20, 70],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "supporter",
                        "label": "Custom Contacts",
                        "order": 1,
                        "permission_enum": [204],
                        "processor": "Custom Contacts",
                        "quorum_data_type": 12,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": true,
                        "should_send_confirmation_email": true,
                        "singular": "custom contact",
                        "value": 1
                    },
                    "tracking_db": {
                        "can_multiprocess": true,
                        "category_enum_name": "TrackingDashBoardCategory",
                        "default_parser_kwargs": { "sandbox": true },
                        "field_enum_name": "TrackingDashBoardField",
                        "hide_in_ui": false,
                        "identifier_fields": [],
                        "is_pacc_migration": false,
                        "is_receipt": false,
                        "is_refund": false,
                        "is_voiding": false,
                        "key": "tracking_db",
                        "label": "Tracking Dashboards",
                        "order": 20,
                        "permission_enum": [304, 304, 305, 207, 105, 310, 104],
                        "processor": "Tracking Board",
                        "quorum_data_type": 89,
                        "quorum_employee_only": false,
                        "records_can_trigger_pacc_sync": false,
                        "should_send_confirmation_email": false,
                        "singular": "tracking db",
                        "value": 20
                    }
                },
                "CustomContactsCategory": {
                    "__is_enum": true,
                    "address": { "key": "address", "label": "Address", "value": 3 },
                    "email": { "key": "email", "label": "Contact Method", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 6 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "misc": { "key": "misc", "label": "Miscellaneous", "value": 4 },
                    "name": { "key": "name", "label": "Name", "value": 1 },
                    "social": { "key": "social", "label": "Social Media", "value": 5 }
                },
                "CustomContactsField": {
                    "__is_enum": true,
                    "address": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's full mailing address. If specified, the remaining address fields can be left blank",
                        "feature_flags": [],
                        "key": "address",
                        "label": "Full Address",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 40
                    },
                    "alternate_address": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "An alternative full mailing address for the contact.",
                        "feature_flags": [],
                        "key": "alternate_address",
                        "label": "Secondary Address",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 50
                    },
                    "assignment_supporter": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The email of the contact to assign this contact to.",
                        "feature_flags": [],
                        "key": "assignment_supporter",
                        "label": "Supporter Assignment",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 74
                    },
                    "birthdate": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The contact's birthdate, in Month Day, Year; YYYY-MM-DD; or MM/DD/YYYY format.",
                        "feature_flags": [],
                        "key": "birthdate",
                        "label": "Birthdate",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 71
                    },
                    "charity_additional_information": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Name for the specific program of the charity",
                        "feature_flags": [],
                        "key": "charity_additional_information",
                        "label": "Charity Additional Information",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 86
                    },
                    "charity_address": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The charity address",
                        "feature_flags": [],
                        "key": "charity_address",
                        "label": "Charity Address",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 84
                    },
                    "charity_anonymous": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Whether the contribution should remain in anonymity (Y/N)",
                        "feature_flags": [],
                        "key": "charity_anonymous",
                        "label": "Charity Remain Anonymous",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 87
                    },
                    "charity_ein": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The EIN is a tax id assigned to a charity",
                        "feature_flags": [],
                        "key": "charity_ein",
                        "label": "Charity EIN",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 83
                    },
                    "charity_name": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The charity the contact selected as part of the PAC Charitable Match feature",
                        "feature_flags": [],
                        "key": "charity_name",
                        "label": "Charity Name",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 82
                    },
                    "charity_selection_date": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The date the contact selected a charity as part of the PAC Charitable Match feature",
                        "feature_flags": [],
                        "key": "charity_selection_date",
                        "label": "Charity Selection Date",
                        "org_admin_only": false,
                        "permission_enum": [8, 214],
                        "value": 85
                    },
                    "city": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The city the contact lives in",
                        "feature_flags": [],
                        "key": "city",
                        "label": "City",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 44
                    },
                    "country": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The country the contact lives in (default to the U.S. if the value is not specified)",
                        "feature_flags": [],
                        "key": "country",
                        "label": "Country",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 49
                    },
                    "email": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": "The primary email for this contact (used by Outbox)",
                        "feature_flags": [],
                        "key": "email",
                        "label": "Email",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 20
                    },
                    "employer": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The employer of the contact",
                        "feature_flags": [],
                        "key": "employer",
                        "label": "Employer",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 11
                    },
                    "extension": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's primary phone extension",
                        "feature_flags": [],
                        "key": "extension",
                        "label": "Home/Work Phone Extension",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 23
                    },
                    "facebook": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The contact's public Facebook username or URL",
                        "feature_flags": [],
                        "key": "facebook",
                        "label": "Facebook",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 61
                    },
                    "fax": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The fax number of the contact.",
                        "feature_flags": [],
                        "key": "fax",
                        "label": "Personal Fax Number",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 25
                    },
                    "firstname": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": "The first name of the contact",
                        "feature_flags": [],
                        "key": "firstname",
                        "label": "First Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 5
                    },
                    "ignore": {
                        "can_match_multiple": true,
                        "category": 0,
                        "description": "Don't upload this column",
                        "feature_flags": [],
                        "key": "ignore",
                        "label": "Ignore Column",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 0
                    },
                    "is_collaborator_supporter": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Is the contact a Collaborator contact?",
                        "feature_flags": ["ff_contributor_license_addon"],
                        "key": "is_collaborator_supporter",
                        "label": "Is a Collaborator Contact",
                        "org_admin_only": true,
                        "permission_enum": [221],
                        "value": 88
                    },
                    "is_grassroots_supporter": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Is the contact a Grassroots contact?",
                        "feature_flags": [],
                        "key": "is_grassroots_supporter",
                        "label": "Is a Grassroots Contact",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 77
                    },
                    "is_stakeholder_supporter": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Is the contact a Stakeholder contact?",
                        "feature_flags": [],
                        "key": "is_stakeholder_supporter",
                        "label": "Is a Stakeholder Contact",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 78
                    },
                    "issues": {
                        "can_match_multiple": true,
                        "category": 4,
                        "description": "A comma separated list of issue names or ids to associate with this contact.",
                        "feature_flags": [],
                        "key": "issues",
                        "label": "Issues",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 79
                    },
                    "lastname": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": "The last name of the contact",
                        "feature_flags": [],
                        "key": "lastname",
                        "label": "Last Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 7
                    },
                    "latitude": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The latitude of this contact's address. If provided, the longitude must also be present.",
                        "feature_flags": [],
                        "key": "latitude",
                        "label": "Latitude",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 47
                    },
                    "longitude": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The longitude of this contact's address. If provided, the latitude must also be present.",
                        "feature_flags": [],
                        "key": "longitude",
                        "label": "Longitude",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 48
                    },
                    "medium": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The contact's public Medium username or URL",
                        "feature_flags": [],
                        "key": "medium",
                        "label": "Medium",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 62
                    },
                    "middlename": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The middle name of the contact",
                        "feature_flags": [],
                        "key": "middlename",
                        "label": "Middle Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 6
                    },
                    "name": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": "The full name of the contact",
                        "feature_flags": [],
                        "key": "name",
                        "label": "Full Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 2
                    },
                    "notes": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Custom Description for this contact",
                        "feature_flags": [],
                        "key": "notes",
                        "label": "Description",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 72
                    },
                    "occupation": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The occupation of the contact.",
                        "feature_flags": [],
                        "key": "occupation",
                        "label": "Occupation",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 10
                    },
                    "pac_conditional_giving_level": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Add conditional giving levels to contract due to the amount of registries required per PAC.",
                        "feature_flags": [],
                        "key": "pac_conditional_giving_level",
                        "label": "Conditional Giving Level",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 81
                    },
                    "pac_eligibilities": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The value in this column should be 'yes'/'true' if a contact is eligible to donate to your PAC.",
                        "feature_flags": ["ff_restricted_gr_pages"],
                        "key": "pac_eligibilities",
                        "label": "PAC Eligibility",
                        "org_admin_only": false,
                        "permission_enum": [8, 215],
                        "value": 15
                    },
                    "password": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "Optional value that this contact's password should be set to. This will override the current password set by the contact (if any).",
                        "feature_flags": [],
                        "key": "password",
                        "label": "Password",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 76
                    },
                    "phone_number": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's primary phone number",
                        "feature_flags": [],
                        "key": "phone_number",
                        "label": "Home/Work Phone Number",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 22
                    },
                    "postal_code": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The zip code of this contact's address",
                        "feature_flags": [],
                        "key": "postal_code",
                        "label": "Zip Code",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 46
                    },
                    "preferred_name": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The preferred name to address this contact",
                        "feature_flags": [],
                        "key": "preferred_name",
                        "label": "Preferred Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 3
                    },
                    "prefix": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "This contact's prefix (eg. Mrs., Dr., The Honorable)",
                        "feature_flags": [],
                        "key": "prefix",
                        "label": "Prefix",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 4
                    },
                    "public_organization_names": {
                        "can_match_multiple": true,
                        "category": 1,
                        "description": "The organization associated with this contact. Note - only one name per column, but you may match multiple columns. Any names not found will be created in Quorum.",
                        "feature_flags": [],
                        "key": "public_organization_names",
                        "label": "Organization Name",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 12
                    },
                    "public_organization_quorum_ids": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "A comma separated list of Organization Quorum IDs for organizations associated with this contact. Any identifiers not found in Quorum will cause the row to fail.",
                        "feature_flags": [],
                        "key": "public_organization_quorum_ids",
                        "label": "Organization Quorum IDs",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 13
                    },
                    "public_organization_unique_ids": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "A comma separated list of Organization Unique Identifiers for organizations associated with this contact. Any identifiers not found in Quorum will cause the row to fail.",
                        "feature_flags": [],
                        "key": "public_organization_unique_ids",
                        "label": "Organization Unique IDs",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 14
                    },
                    "quorum_id": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": "The Quorum Identifier of this contact. Can be used for reliable matching. Can be found by downloading a CSV of contacts or from the URL of the contact's Quorum page",
                        "feature_flags": [],
                        "key": "quorum_id",
                        "label": "Quorum ID",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 70
                    },
                    "quorum_user": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The email or username of the Quorum user this contact should be assigned to",
                        "feature_flags": [],
                        "key": "quorum_user",
                        "label": "Team Member Assignment",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 73
                    },
                    "secondary_email": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The secondary email for this contact (for reference only, not used by Outbox).",
                        "feature_flags": [],
                        "key": "secondary_email",
                        "label": "Secondary Email",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 21
                    },
                    "secondary_phone": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's secondary phone number",
                        "feature_flags": [],
                        "key": "secondary_phone",
                        "label": "Cell Number",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 24
                    },
                    "state": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The state the contact lives in",
                        "feature_flags": [],
                        "key": "state",
                        "label": "State",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 45
                    },
                    "street_address": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's street address",
                        "feature_flags": [],
                        "key": "street_address",
                        "label": "Street Address",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 41
                    },
                    "street_address_2": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's second line of their street address",
                        "feature_flags": [],
                        "key": "street_address_2",
                        "label": "Street Address 2",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 42
                    },
                    "street_address_3": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's third line of their street address",
                        "feature_flags": [],
                        "key": "street_address_3",
                        "label": "Street Address 3",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 43
                    },
                    "suffix": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "This contact's suffix, like III, Jr., etc.",
                        "feature_flags": [],
                        "key": "suffix",
                        "label": "Suffix",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 8
                    },
                    "texting_opt_in": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The value in this column is 'yes'/'true' if a contact is opted in to receive texts from you.\nYou are responsible for ensuring that you have obtained written consent from all contacts you intend to subscribe to receive your texts.",
                        "feature_flags": [],
                        "key": "texting_opt_in",
                        "label": "Opted In To Texting",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 80
                    },
                    "title": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The title or job description for this contact",
                        "feature_flags": [],
                        "key": "title",
                        "label": "Title",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 9
                    },
                    "twitter": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The contact's public Twitter handle or URL",
                        "feature_flags": [],
                        "key": "twitter",
                        "label": "Twitter",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 60
                    },
                    "unique_identifier": {
                        "can_match_multiple": false,
                        "category": 6,
                        "description": " The Unique Identifier (ID) for this contact that is used internally within your company",
                        "feature_flags": [],
                        "key": "unique_identifier",
                        "label": "Unique Identifier",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 1
                    },
                    "unsubscribed_from_bulk_emails": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The value in this column is 'yes'/'true' if a contact is unsubscribed from your emails",
                        "feature_flags": [],
                        "key": "unsubscribed_from_bulk_emails",
                        "label": "Unsubscribed from Emails",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 75
                    },
                    "website": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's personal webpage",
                        "feature_flags": [],
                        "key": "website",
                        "label": "Website",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 28
                    },
                    "work_fax": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The work fax number of the contact.",
                        "feature_flags": [],
                        "key": "work_fax",
                        "label": "Work Fax Number",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 27
                    },
                    "work_phone": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The specific work phone number of the contact.",
                        "feature_flags": [],
                        "key": "work_phone",
                        "label": "Work Phone Number",
                        "org_admin_only": false,
                        "permission_enum": [8],
                        "value": 26
                    },
                    "youtube": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The contact's public Youtube username or URL",
                        "feature_flags": [],
                        "key": "youtube",
                        "label": "YouTube",
                        "org_admin_only": false,
                        "permission_enum": [],
                        "value": 63
                    }
                },
                "CustomContactsPACCMigrationCategory": {
                    "__is_enum": true,
                    "address": { "key": "address", "label": "Address", "value": 3 },
                    "email": { "key": "email", "label": "Email and Phone", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 5 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "misc": { "key": "misc", "label": "Miscellaneous", "value": 4 },
                    "name": { "key": "name", "label": "Name", "value": 1 }
                },
                "CustomContactsPACCMigrationField": {
                    "__is_enum": true,
                    "alternate_address": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "An alternative full mailing address for the contact.",
                        "feature_flags": [],
                        "key": "alternate_address",
                        "label": "Alternate_Address",
                        "permission_enum": [],
                        "value": 50
                    },
                    "city": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The city the contact lives in",
                        "feature_flags": [],
                        "key": "city",
                        "label": "HomeCity",
                        "permission_enum": [],
                        "value": 44
                    },
                    "email": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The primary email for this contact (used by Outbox)",
                        "feature_flags": [],
                        "key": "email",
                        "label": "EMail",
                        "permission_enum": [],
                        "value": 20
                    },
                    "employer": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The employer of the contact",
                        "feature_flags": [],
                        "key": "employer",
                        "label": "EmployerName",
                        "permission_enum": [8],
                        "value": 11
                    },
                    "fax": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The fax number of the contact.",
                        "feature_flags": [],
                        "key": "fax",
                        "label": "HomeFax",
                        "permission_enum": [8],
                        "value": 25
                    },
                    "firstname": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The first name of the contact",
                        "feature_flags": [],
                        "key": "firstname",
                        "label": "FirstName",
                        "permission_enum": [],
                        "value": 5
                    },
                    "ignore": {
                        "can_match_multiple": true,
                        "category": 0,
                        "description": "Don't upload this column",
                        "feature_flags": [],
                        "key": "ignore",
                        "label": "Ignore Column",
                        "permission_enum": [],
                        "value": 0
                    },
                    "lastname": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The last name of the contact",
                        "feature_flags": [],
                        "key": "lastname",
                        "label": "LastName",
                        "permission_enum": [],
                        "value": 7
                    },
                    "middlename": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The middle name of the contact",
                        "feature_flags": [],
                        "key": "middlename",
                        "label": "MiddleName",
                        "permission_enum": [],
                        "value": 6
                    },
                    "occupation": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The occupation of the contact.",
                        "feature_flags": [],
                        "key": "occupation",
                        "label": "Occupation",
                        "permission_enum": [8],
                        "value": 10
                    },
                    "pacc_companyid": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The Company ID in PAC Classic associated with this record.",
                        "feature_flags": [],
                        "key": "pacc_companyid",
                        "label": "CompanyID",
                        "permission_enum": [],
                        "value": 102
                    },
                    "pacc_individual_id": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": "The Individual ID in PAC Classic associated with this record.",
                        "feature_flags": [],
                        "key": "pacc_individual_id",
                        "label": "IndividualID",
                        "permission_enum": [],
                        "value": 101
                    },
                    "pacc_version": {
                        "can_match_multiple": false,
                        "category": 4,
                        "description": "The Version of this record in PAC Classic.",
                        "feature_flags": [],
                        "key": "pacc_version",
                        "label": "Version",
                        "permission_enum": [],
                        "value": 103
                    },
                    "phone_number": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's home phone number",
                        "feature_flags": [],
                        "key": "phone_number",
                        "label": "HomePhone",
                        "permission_enum": [],
                        "value": 22
                    },
                    "postal_code": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The zip code of this contact's address",
                        "feature_flags": [],
                        "key": "postal_code",
                        "label": "HomeZip",
                        "permission_enum": [],
                        "value": 46
                    },
                    "preferred_name": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The preferred name to address this contact",
                        "feature_flags": [],
                        "key": "preferred_name",
                        "label": "NickName",
                        "permission_enum": [],
                        "value": 3
                    },
                    "prefix": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "This contact's prefix (eg. Mrs., Dr., The Honorable)",
                        "feature_flags": [],
                        "key": "prefix",
                        "label": "Prefix",
                        "permission_enum": [],
                        "value": 4
                    },
                    "public_organization__pacc_organization_id": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The PAC Classic ID of the organization associated with this contact.",
                        "feature_flags": [],
                        "key": "public_organization__pacc_organization_id",
                        "label": "OrganizationID",
                        "permission_enum": [],
                        "value": 12
                    },
                    "secondary_email": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The secondary email for this contact (for reference only, not used by Outbox).",
                        "feature_flags": [],
                        "key": "secondary_email",
                        "label": "WorkEMail",
                        "permission_enum": [],
                        "value": 21
                    },
                    "secondary_phone": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's secondary phone number",
                        "feature_flags": [],
                        "key": "secondary_phone",
                        "label": "MobilePhone",
                        "permission_enum": [],
                        "value": 24
                    },
                    "state": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The state the contact lives in",
                        "feature_flags": [],
                        "key": "state",
                        "label": "HomeState",
                        "permission_enum": [],
                        "value": 45
                    },
                    "street_address": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's street address",
                        "feature_flags": [],
                        "key": "street_address",
                        "label": "HomeAddressLine1",
                        "permission_enum": [],
                        "value": 41
                    },
                    "street_address_2": {
                        "can_match_multiple": false,
                        "category": 3,
                        "description": "The contact's second line of their street address",
                        "feature_flags": [],
                        "key": "street_address_2",
                        "label": "HomeAddressLine2",
                        "permission_enum": [],
                        "value": 42
                    },
                    "suffix": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "This contact's suffix, like III, Jr., etc.",
                        "feature_flags": [],
                        "key": "suffix",
                        "label": "Suffix",
                        "permission_enum": [],
                        "value": 8
                    },
                    "title": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The title or job description for this contact",
                        "feature_flags": [],
                        "key": "title",
                        "label": "Title",
                        "permission_enum": [],
                        "value": 9
                    },
                    "unique_identifier": {
                        "can_match_multiple": false,
                        "category": 5,
                        "description": " The Unique Identifier (ID) for this contact that is used internally within your company",
                        "feature_flags": [],
                        "key": "unique_identifier",
                        "label": "ExternalID",
                        "permission_enum": [],
                        "value": 1
                    },
                    "website": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The contact's personal webpage",
                        "feature_flags": [],
                        "key": "website",
                        "label": "WebSiteUrl",
                        "permission_enum": [],
                        "value": 28
                    },
                    "work_fax": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The work fax number of the contact.",
                        "feature_flags": [],
                        "key": "work_fax",
                        "label": "WorkFAX",
                        "permission_enum": [8],
                        "value": 27
                    },
                    "work_phone": {
                        "can_match_multiple": false,
                        "category": 2,
                        "description": "The specific work phone number of the contact.",
                        "feature_flags": [],
                        "key": "work_phone",
                        "label": "WorkPhone",
                        "permission_enum": [8],
                        "value": 26
                    }
                },
                "CustomContactsPACCSyncOnboardingCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 }
                },
                "CustomContactsPACCSyncOnboardingField": {
                    "__is_enum": true,
                    "email": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The primary email for this contact (used by Outbox)",
                        "feature_flags": [],
                        "key": "email",
                        "label": "Email",
                        "permission_enum": [],
                        "value": 2
                    },
                    "ignore": {
                        "can_match_multiple": true,
                        "category": 0,
                        "description": "Don't upload this column",
                        "feature_flags": [],
                        "key": "ignore",
                        "label": "Ignore Column",
                        "permission_enum": [],
                        "value": 0
                    },
                    "quorum_id": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": "The Quorum Identifier of this contact. Can be used for reliable matching. Can be found by downloading a CSV of contacts or from the URL of the contact's Quorum page",
                        "feature_flags": [],
                        "key": "quorum_id",
                        "label": "Quorum ID",
                        "permission_enum": [],
                        "value": 3
                    },
                    "unique_identifier": {
                        "can_match_multiple": false,
                        "category": 1,
                        "description": " The Unique Identifier (ID) for this contact that is used internally within your company",
                        "feature_flags": [],
                        "key": "unique_identifier",
                        "label": "Unique Identifier",
                        "permission_enum": [],
                        "value": 1
                    }
                },
                "CustomOrgNoPacOrgTypePACCMigrationCategory": {
                    "__is_enum": true,
                    "billing_address": { "key": "billing_address", "label": "Billing Address", "value": 4 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 7 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Basic Info", "value": 1 },
                    "misc": { "key": "misc", "label": "Miscellaneous", "value": 5 },
                    "pacc": { "key": "pacc", "label": "PACC Identifiers", "value": 6 },
                    "shipping_address": { "key": "shipping_address", "label": "Shipping Address", "value": 3 },
                    "social": { "key": "social", "label": "Social Media", "value": 2 }
                },
                "CustomOrgNoPacOrgTypePACCMigrationField": {
                    "__is_enum": true,
                    "email": { "can_match_multiple": false, "category": 1, "description": "The organization's email in PAC Classic.", "key": "email", "label": "EMail", "value": 3 },
                    "fax": { "can_match_multiple": false, "category": 1, "description": "Fax number in PAC Classic.", "key": "fax", "label": "Fax", "value": 9 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore", "value": 0 },
                    "name": { "can_match_multiple": false, "category": 1, "description": "The name of this organization in PAC Classic.", "key": "name", "label": "FullName", "value": 1 },
                    "pacc_companyid": { "can_match_multiple": false, "category": 6, "description": "The Company ID in PAC Classic associated with this record.", "key": "pacc_companyid", "label": "CompanyID", "value": 102 },
                    "pacc_has_parent": { "can_match_multiple": false, "category": 6, "description": "Boolean for whether this organization HAS a parent in PAC Classic.", "key": "pacc_has_parent", "label": "HasParent", "value": 61 },
                    "pacc_is_parent": { "can_match_multiple": false, "category": 6, "description": "Boolean for whether this organization IS a Parent in PAC Classic.", "key": "pacc_is_parent", "label": "IsParent", "value": 60 },
                    "pacc_organization_id": { "can_match_multiple": false, "category": 7, "description": "The OrganizationID from PACC.", "key": "pacc_organization_id", "label": "OrganizationID", "value": 59 },
                    "pacc_parent_organization_id": { "can_match_multiple": false, "category": 5, "description": "The PAC Classic ID of the organization's parent, if any.", "key": "pacc_parent_organization_id", "label": "OrganizationParentID", "value": 52 },
                    "pacc_version": { "can_match_multiple": false, "category": 6, "description": "The Version of this record in PAC Classic.", "key": "pacc_version", "label": "Version", "value": 103 },
                    "phone_number": { "can_match_multiple": false, "category": 1, "description": "The organization's main phone number in PAC Classic.", "key": "phone_number", "label": "Phone", "value": 4 },
                    "shipping_city": { "can_match_multiple": false, "category": 3, "description": "City of the shipping address for the organization in PAC Classic.", "key": "shipping_city", "label": "City", "value": 22 },
                    "shipping_postal_code": { "can_match_multiple": false, "category": 3, "description": "The zip code of the shipping address for the organization in PAC Classic.", "key": "shipping_postal_code", "label": "Zip", "value": 24 },
                    "shipping_state": { "can_match_multiple": false, "category": 3, "description": "The state/province of the shipping address for the organization in PAC Classic.", "key": "shipping_state", "label": "State", "value": 23 },
                    "shipping_street": { "can_match_multiple": false, "category": 3, "description": "The street of the shipping address for the organization in PAC Classic.", "key": "shipping_street", "label": "AddressLine1", "value": 21 },
                    "shipping_street_2": { "can_match_multiple": false, "category": 3, "description": "The street of the shipping address 2 for the organization in PAC Classic.", "key": "shipping_street_2", "label": "AddressLine2", "value": 55 },
                    "unique_identifier": { "can_match_multiple": false, "category": 1, "description": "The unique identifier in PAC Classic.", "key": "unique_identifier", "label": "ExternalID", "value": 6 },
                    "website": { "can_match_multiple": false, "category": 1, "description": "The organization's website in PAC Classic.", "key": "website", "label": "Website", "value": 5 }
                },
                "CustomOrgWithPacOrgTypePACCMigrationCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Basic Info", "value": 1 },
                    "pacc": { "key": "pacc", "label": "PACC Identifiers", "value": 3 },
                    "shipping_address": { "key": "shipping_address", "label": "Shipping Address", "value": 2 }
                },
                "CustomOrgWithPacOrgTypePACCMigrationField": {
                    "__is_enum": true,
                    "email": { "can_match_multiple": false, "category": 1, "description": "The organization's email in PAC Classic.", "key": "email", "label": "Email", "value": 3 },
                    "fax": { "can_match_multiple": false, "category": 1, "description": "Fax number in PAC Classic.", "key": "fax", "label": "Fax", "value": 9 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore", "value": 0 },
                    "name": { "can_match_multiple": false, "category": 1, "description": "The name of this organization in PAC Classic.", "key": "name", "label": "OrganizationName", "value": 1 },
                    "pac_org_type": { "can_match_multiple": false, "category": 3, "description": "The PAC Limit Type from PACC.", "key": "pac_org_type", "label": "PACLimitType", "value": 52 },
                    "pacc_companyid": { "can_match_multiple": false, "category": 3, "description": "The Company ID in PAC Classic associated with this record.", "key": "pacc_companyid", "label": "CompanyID", "value": 102 },
                    "pacc_pacaccountid": { "can_match_multiple": false, "category": 3, "description": "The PAC Account ID from PACC.", "key": "pacc_pacaccountid", "label": "PACAccountID", "value": 53 },
                    "pacc_pacorganizationid": { "can_match_multiple": false, "category": 4, "description": "The OrganizationID from PACC.", "key": "pacc_pacorganizationid", "label": "PACOrganizationID", "value": 51 },
                    "pacc_version": { "can_match_multiple": false, "category": 3, "description": "The Version of this record in PAC Classic.", "key": "pacc_version", "label": "Version", "value": 103 },
                    "phone_number": { "can_match_multiple": false, "category": 1, "description": "The organization's main phone number in PAC Classic.", "key": "phone_number", "label": "Phone", "value": 4 },
                    "shipping_city": { "can_match_multiple": false, "category": 2, "description": "City of the shipping address for the organization in PAC Classic.", "key": "shipping_city", "label": "City", "value": 22 },
                    "shipping_postal_code": { "can_match_multiple": false, "category": 2, "description": "The zip code of the shipping address for the organization in PAC Classic.", "key": "shipping_postal_code", "label": "Zip", "value": 24 },
                    "shipping_state": { "can_match_multiple": false, "category": 2, "description": "The state/province of the shipping address for the organization in PAC Classic.", "key": "shipping_state", "label": "State", "value": 23 },
                    "shipping_street": { "can_match_multiple": false, "category": 2, "description": "The street of the shipping address for the organization in PAC Classic.", "key": "shipping_street", "label": "AddressLine1", "value": 21 },
                    "shipping_street_2": { "can_match_multiple": false, "category": 2, "description": "The street of the shipping address 2 for the organization in PAC Classic.", "key": "shipping_street_2", "label": "AddressLine2", "value": 55 },
                    "unique_identifier": { "can_match_multiple": false, "category": 1, "description": "The unique identifier in PAC Classic.", "key": "unique_identifier", "label": "ExternalID", "value": 6 },
                    "website": { "can_match_multiple": false, "category": 1, "description": "The organization's website in PAC Classic.", "key": "website", "label": "Website", "value": 5 }
                },
                "CustomOrganizationsCategory": {
                    "__is_enum": true,
                    "billing_address": { "key": "billing_address", "label": "Billing Address", "value": 4 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 7 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Basic Info", "value": 1 },
                    "misc": { "key": "misc", "label": "Miscellaneous", "value": 5 },
                    "pacc": { "key": "pacc", "label": "PACC Migration", "value": 6 },
                    "shipping_address": { "key": "shipping_address", "label": "Shipping Address", "value": 3 },
                    "social": { "key": "social", "label": "Social Media", "value": 2 }
                },
                "CustomOrganizationsField": {
                    "__is_enum": true,
                    "abbrev": { "can_match_multiple": false, "category": 1, "description": "An abbreviation for the public organization.", "key": "abbrev", "label": "Abbreviation", "value": 2 },
                    "billing_address": { "can_match_multiple": false, "category": 4, "description": "Full billing address for the organization.", "key": "billing_address", "label": "Full Billing Address", "value": 30 },
                    "billing_city": { "can_match_multiple": false, "category": 4, "description": "City of the billing address for the organization.", "key": "billing_city", "label": "Billing City", "value": 32 },
                    "billing_country": { "can_match_multiple": false, "category": 4, "description": "The country of the billing address for the organization.", "key": "billing_country", "label": "Billing Country", "value": 35 },
                    "billing_postal_code": { "can_match_multiple": false, "category": 4, "description": "The zip code of the billing address for the organization.", "key": "billing_postal_code", "label": "Billing Zip Code", "value": 34 },
                    "billing_state": { "can_match_multiple": false, "category": 4, "description": "The state/province of the billing address for the organization.", "key": "billing_state", "label": "Billing State/Province", "value": 33 },
                    "billing_street": { "can_match_multiple": false, "category": 4, "description": "The street of the billing address for the organization.", "key": "billing_street", "label": "Billing Street Address", "value": 31 },
                    "email": { "can_match_multiple": false, "category": 1, "description": "The organization's email.", "key": "email", "label": "Email", "value": 3 },
                    "facebook": { "can_match_multiple": false, "category": 2, "description": "The organization's public Facebook username or URL", "key": "facebook", "label": "Facebook", "value": 41 },
                    "fax": { "can_match_multiple": false, "category": 1, "description": "Fax number, if applicable.", "key": "fax", "label": "Fax", "value": 9 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "image_url": { "can_match_multiple": false, "category": 5, "description": "URL for a profile photo for this organization.", "key": "image_url", "label": "Image Url", "value": 53 },
                    "issues": { "can_match_multiple": true, "category": 5, "description": "A comma separated list of issue names or ids to associate with this organization.", "key": "issues", "label": "Issues", "value": 54 },
                    "medium": { "can_match_multiple": false, "category": 2, "description": "The organization's public Medium username or URL", "key": "medium", "label": "Medium", "value": 43 },
                    "name": { "can_match_multiple": false, "category": 7, "description": "The name of this organization.", "key": "name", "label": "Organization Name", "value": 1 },
                    "notes": { "can_match_multiple": false, "category": 5, "description": "Custom Description for this organization", "key": "notes", "label": "Description", "value": 50 },
                    "pac_org_type": { "can_match_multiple": false, "category": 1, "description": "PAC Org Type is used to label a PAC Organization for PAC reporting", "key": "pac_org_type", "label": "PAC Org Type", "value": 8 },
                    "parent_organization": { "can_match_multiple": false, "category": 5, "description": "The name of the organization's parent organization", "key": "parent_organization", "label": "Parent Organization", "value": 52 },
                    "phone_number": { "can_match_multiple": false, "category": 1, "description": "The organization's main phone number.", "key": "phone_number", "label": "Telephone Number", "value": 4 },
                    "quorum_id": { "can_match_multiple": false, "category": 7, "description": "The Quorum Identifier of this organization. Can be used for reliable matching. Can be found by downloading a CSV of organizations or from the URL of the organization's Quorum page", "key": "quorum_id", "label": "Quorum ID", "value": 7 },
                    "quorum_user": { "can_match_multiple": false, "category": 5, "description": "The email or username of the Quorum User this organization should be assigned to", "key": "quorum_user", "label": "Assignment", "value": 51 },
                    "shipping_address": { "can_match_multiple": false, "category": 3, "description": "Full shipping address for the organization.", "key": "shipping_address", "label": "Full Shipping Address", "value": 20 },
                    "shipping_city": { "can_match_multiple": false, "category": 3, "description": "City of the shipping address for the organization.", "key": "shipping_city", "label": "Shipping City", "value": 22 },
                    "shipping_country": { "can_match_multiple": false, "category": 3, "description": "The country of the shipping address for the organization.", "key": "shipping_country", "label": "Shipping Country", "value": 25 },
                    "shipping_postal_code": { "can_match_multiple": false, "category": 3, "description": "The zip code of the shipping address for the organization.", "key": "shipping_postal_code", "label": "Shipping Zip Code", "value": 24 },
                    "shipping_state": { "can_match_multiple": false, "category": 3, "description": "The state/province of the shipping address for the organization.", "key": "shipping_state", "label": "Shipping State/Province", "value": 23 },
                    "shipping_street": { "can_match_multiple": false, "category": 3, "description": "The street of the shipping address for the organization.", "key": "shipping_street", "label": "Shipping Street Address", "value": 21 },
                    "shipping_street_2": { "can_match_multiple": false, "category": 3, "description": "The street of the shipping address 2 for the organization.", "key": "shipping_street_2", "label": "Shipping Street Address 2", "value": 55 },
                    "twitter": { "can_match_multiple": false, "category": 2, "description": "The organization's public Twitter handle or URL", "key": "twitter", "label": "Twitter", "value": 40 },
                    "unique_identifier": { "can_match_multiple": false, "category": 7, "description": "The unique identifier used internally within your company to identify this organization", "key": "unique_identifier", "label": "Unique Identifier", "value": 6 },
                    "website": { "can_match_multiple": false, "category": 7, "description": "The organization's website. Used for matching if it exists.", "key": "website", "label": "Website", "value": 5 },
                    "youtube": { "can_match_multiple": false, "category": 2, "description": "The organization's public Youtube username or URL", "key": "youtube", "label": "YouTube", "value": 44 }
                },
                "GamificationPointsCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 }
                },
                "GamificationPointsField": {
                    "__is_enum": true,
                    "action_center": { "can_match_multiple": false, "category": 1, "description": "The id of the action center", "key": "action_center", "label": "Action Center", "value": 2 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "points_earned": { "can_match_multiple": false, "category": 1, "description": "How many gamification points this supporter earned", "key": "points_earned", "label": "Points Earned", "value": 3 },
                    "supporter": { "can_match_multiple": false, "category": 1, "description": "The Quorum ID or email of the contact receiving the points.", "key": "supporter", "label": "Supporter", "value": 1 }
                },
                "GeographicDataCategory": {
                    "__is_enum": true,
                    "address": { "key": "address", "label": "Address", "value": 3 },
                    "fields": { "key": "fields", "label": "Fields", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "name": { "key": "name", "label": "Name", "value": 1 }
                },
                "GeographicDataField": {
                    "__is_enum": true,
                    "address": { "can_match_multiple": false, "category": 3, "description": "Full address for this datapoint", "key": "address", "label": "Full Address", "value": 3 },
                    "city": { "can_match_multiple": false, "category": 3, "description": "The city of the datapoint's full address", "key": "city", "label": "City", "value": 7 },
                    "country": { "can_match_multiple": false, "category": 3, "description": "The country of this datapoint's full address", "key": "country", "label": "Country", "value": 10 },
                    "descriptive_name": { "can_match_multiple": false, "category": 4, "description": "The name that should be used to refer to this datapoint.  This field is required.", "key": "descriptive_name", "label": "Name", "value": 1 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "latitude": { "can_match_multiple": false, "category": 3, "description": "Latitude for this particular datapoint. Used to identify which state/district this data is in.", "key": "latitude", "label": "Latitude", "value": 11 },
                    "longitude": { "can_match_multiple": false, "category": 3, "description": "Longitude for this row of data. Used to identify which state/district this data is in.", "key": "longitude", "label": "Longitude", "value": 12 },
                    "numeric_percent": { "can_match_multiple": true, "category": 2, "description": "This column is for any statistical data that is represented in terms of a percentage.  In the Districts tab, the name of this value will be the original header of this column", "key": "numeric_percent", "label": "Percentage Value", "value": 16 },
                    "numeric_value": { "can_match_multiple": true, "category": 2, "description": "This column is for any statistical data that is represented in terms of whole numbers.  In the Districts tab, the name of this value will be the original header of this column", "key": "numeric_value", "label": "Numeric Value", "value": 15 },
                    "state": { "can_match_multiple": false, "category": 3, "description": "The state of this datapoint's full address", "key": "state", "label": "State", "value": 8 },
                    "street_address": { "can_match_multiple": false, "category": 3, "description": "The street address of this datapoint", "key": "street_address", "label": "Street Address", "value": 4 },
                    "street_address_2": { "can_match_multiple": false, "category": 3, "description": "The second line of each datapoint's street address", "key": "street_address_2", "label": "Street Address 2", "value": 5 },
                    "street_address_3": { "can_match_multiple": false, "category": 3, "description": "The third line of each datapoint's street address", "key": "street_address_3", "label": "Street Address 3", "value": 6 },
                    "string": { "can_match_multiple": true, "category": 2, "description": "This column is for any statistical data that is represented in terms of text or other non-numeric values.  In the Districts tab, the name of this value will be the original header of this column.", "key": "string", "label": "Text Value", "value": 17 },
                    "unique_identifier": { "can_match_multiple": false, "category": 1, "description": "Optional column for an ID that uniquely identifies this datapoint. Helps prevent duplicates.", "key": "unique_identifier", "label": "Unique Identifier", "value": 2 },
                    "zip_code": { "can_match_multiple": false, "category": 3, "description": "The zip code of this datapoint's full address", "key": "zip_code", "label": "Zip Code", "value": 9 }
                },
                "HistoricFECFilingCategory": {
                    "__is_enum": true,
                    "amounts": { "key": "amounts", "label": "Amounts", "value": 3 },
                    "dates": { "key": "dates", "label": "Dates", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "other": { "key": "other", "label": "Other Information", "value": 4 }
                },
                "HistoricFECFilingField": {
                    "__is_enum": true,
                    "amendment_number": { "can_match_multiple": false, "category": 4, "description": "The amendment number, if any.", "key": "amendment_number", "label": "Amendment Number", "value": 11 },
                    "amends_fec_id": { "can_match_multiple": false, "category": 4, "description": "The FEC ID assigned to the filing this historic filing amends, if any.", "key": "amends_fec_id", "label": "Amends FEC ID", "value": 10 },
                    "coverage_end_date": { "can_match_multiple": false, "category": 2, "description": "The start date of the reporting period for this filing.", "key": "coverage_end_date", "label": "Report End Date", "value": 21 },
                    "coverage_start_date": { "can_match_multiple": false, "category": 2, "description": "The start date of the reporting period for this filing.", "key": "coverage_start_date", "label": "Report Start Date", "value": 20 },
                    "description": { "can_match_multiple": false, "category": 4, "description": "A description of the filing.", "key": "description", "label": "Description", "value": 50 },
                    "election_date": { "can_match_multiple": false, "category": 4, "description": "The date of the election this filing is for, if election related.", "key": "election_date", "label": "Election Date", "value": 31 },
                    "election_region": { "can_match_multiple": false, "category": 4, "description": "The abbreviation of the state for which this election was held, if election related.", "key": "election_region", "label": "Election State Abbrev.", "value": 32 },
                    "election_type": { "can_match_multiple": false, "category": 4, "description": "The type of election this filing is for, if election related.", "key": "election_type", "label": "Election Type", "value": 30 },
                    "fec_id": { "can_match_multiple": false, "category": 1, "description": "The FEC ID assigned to this historic filing.", "key": "fec_id", "label": "FEC ID", "value": 2 },
                    "filed_date": { "can_match_multiple": false, "category": 2, "description": "The date the historic filing was actually filed.", "key": "filed_date", "label": "Filed Date", "value": 22 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "period_start_cash_on_hand": { "can_match_multiple": false, "category": 3, "description": "The amount of cash on hand at the start of the reporting period.", "key": "period_start_cash_on_hand", "label": "Period Starting Cash", "value": 40 },
                    "report_code": { "can_match_multiple": false, "category": 4, "description": "The FEC Report Code assigned to this historic filing. Acceptable values are: 'Q1' - 'Q3' (quarterly), 'M2' - 'M12' (monthly), 'YE' (year end), 'MY' (mid-year), 'TER' (termination), '12' (pre-election), or '30' (post-election).", "key": "report_code", "label": "FEC Report Code", "value": 3 },
                    "year_start_cash_on_hand": { "can_match_multiple": false, "category": 3, "description": "The amount of cash on hand at the start of the year.", "key": "year_start_cash_on_hand", "label": "Year Starting Cash", "value": 41 }
                },
                "HistoricInteractionCategory": {
                    "__is_enum": true,
                    "category_fields": { "key": "category_fields", "label": "Category", "value": 1 },
                    "fields": { "key": "fields", "label": "Fields", "value": 2 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "participants": { "key": "participants", "label": "Participants", "value": 3 }
                },
                "HistoricInteractionField": {
                    "__is_enum": true,
                    "amount": { "can_match_multiple": false, "category": 2, "description": "For donations, what was the amount.", "key": "amount", "label": "Amount", "value": 13 },
                    "duration": { "can_match_multiple": false, "category": 2, "description": "how long was the interaction", "key": "duration", "label": "Duration", "value": 11 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "interaction_date": { "can_match_multiple": false, "category": 2, "description": "The date this took place.", "key": "interaction_date", "label": "Date", "value": 10 },
                    "interaction_type": { "can_match_multiple": false, "category": 4, "description": "The id or name of the type of interaction the row represents, if the row was an interaction.", "key": "interaction_type", "label": "Interaction Type", "value": 2 },
                    "issues": { "can_match_multiple": true, "category": 3, "description": "A comma separated list of issue names or ids to associate with this interaction.", "key": "issues", "label": "Issues", "value": 25 },
                    "officials": { "can_match_multiple": true, "category": 3, "description": "A Comma separated list of official IDs or names that will be searched for using the Quorum search bar.", "key": "officials", "label": "Officials", "value": 22 },
                    "public_organizations": { "can_match_multiple": true, "category": 3, "description": "A comma separated list of Quorum organization names or ids.", "key": "public_organizations", "label": "Organizations", "value": 24 },
                    "quorum_id": { "can_match_multiple": false, "category": 4, "description": "The Quorum ID of the existing Note, if any.", "key": "quorum_id", "label": "Quorum ID", "value": 26 },
                    "quorum_user": { "can_match_multiple": true, "category": 3, "description": "A comma separated list of usernames or emails of Quorum Users involved.", "key": "quorum_user", "label": "Team Members", "value": 20 },
                    "relationship_type": { "can_match_multiple": false, "category": 4, "description": "The type of relationship the row represents, if the row was a relationship.", "key": "relationship_type", "label": "Relationship Type", "value": 4 },
                    "staffers": { "can_match_multiple": true, "category": 3, "description": "A Comma separated list of staffer IDs or names that will be searched for using the Quorum search bar.", "key": "staffers", "label": "Staffers", "value": 23 },
                    "supporters": { "can_match_multiple": true, "category": 3, "description": "A comma separated list of names or emails of Contacts involved.", "key": "supporters", "label": "Contacts", "value": 21 },
                    "text": { "can_match_multiple": false, "category": 2, "description": "The text of the note", "key": "text", "label": "Text", "value": 12 }
                },
                "IntegrationType": {
                    "__is_enum": true,
                    "iterable": {
                        "integration_class": "app.client_integration.iterable.functions.IterableIntegration",
                        "key": "iterable",
                        "label": "Iterable",
                        "source_type": 23,
                        "task_admin_fields": ["iterable_external_model"],
                        "upload_source": 5,
                        "value": 4
                    },
                    "nationbuilder": {
                        "key": "nationbuilder",
                        "label": "NationBuilder",
                        "source_type": 19,
                        "task_admin_fields": ["external_model"],
                        "upload_source": 5,
                        "value": 2
                    },
                    "salesforce": {
                        "integration_class": "app.client_integration.salesforce.functions.NewSalesforceIntegration",
                        "key": "salesforce",
                        "label": "Salesforce",
                        "source_type": 15,
                        "task_admin_fields": ["external_model", "sf_match_on", "sf_allow_multiple_rows_per_record", "sf_max_batch_size", "sf_store_ids_in_quorum"],
                        "upload_source": 5,
                        "value": 1
                    },
                    "sftp": {
                        "integration_class": "app.client_integration.sftp.functions.NewSFTPIntegration",
                        "key": "sftp",
                        "label": "SFTP",
                        "source_type": 22,
                        "task_admin_fields": ["sftp_delete_after_download", "sftp_file_path", "sftp_file_name", "sftp_encoding", "sftp_delimiter"],
                        "upload_source": 3,
                        "value": 3
                    }
                },
                "PoliticalCommitteeCategory": {
                    "__is_enum": true,
                    "candidate": { "key": "candidate", "label": "Candidate & Office", "value": 3 },
                    "contact": { "key": "contact", "label": "Contact Information", "value": 2 },
                    "fundamentals": { "key": "fundamentals", "label": "Fundamentals", "value": 1 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 5 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "treasurer": { "key": "treasurer", "label": "Treasurer", "value": 4 }
                },
                "PoliticalCommitteeField": {
                    "__is_enum": true,
                    "addr_city": { "can_match_multiple": false, "category": 2, "description": "The City of the Political Committee.", "key": "addr_city", "label": "Committee City", "value": 12 },
                    "addr_state": { "can_match_multiple": false, "category": 2, "description": "The State of the Political Committee.", "key": "addr_state", "label": "Committee State", "value": 13 },
                    "addr_street1": { "can_match_multiple": false, "category": 2, "description": "The Street Address of the Political Committee.", "key": "addr_street1", "label": "Committee Street Address", "value": 10 },
                    "addr_street2": { "can_match_multiple": false, "category": 2, "description": "The Street Address 2 of the Political Committee.", "key": "addr_street2", "label": "Committee Street Address 2", "value": 11 },
                    "addr_zip": { "can_match_multiple": false, "category": 2, "description": "The Postal Code of the Political Committee.", "key": "addr_zip", "label": "Committee Postal Code", "value": 14 },
                    "candidate_county": { "can_match_multiple": false, "category": 3, "description": "The Candidate County of the Candidate.", "key": "candidate_county", "label": "Candidate County", "value": 61 },
                    "candidate_district": { "can_match_multiple": false, "category": 3, "description": "The Candidate District of the Candidate.", "key": "candidate_district", "label": "Candidate District", "value": 62 },
                    "candidate_first_name": { "can_match_multiple": false, "category": 3, "description": "The Candidate First Name of the Candidate.", "key": "candidate_first_name", "label": "Candidate First Name", "value": 51 },
                    "candidate_last_name": { "can_match_multiple": false, "category": 3, "description": "The Candidate Last Name of the Candidate.", "key": "candidate_last_name", "label": "Candidate Last Name", "value": 53 },
                    "candidate_middle_name": { "can_match_multiple": false, "category": 3, "description": "The Candidate Middle Name of the Candidate.", "key": "candidate_middle_name", "label": "Candidate Middle Name", "value": 52 },
                    "candidate_office_identifier": { "can_match_multiple": false, "category": 3, "description": "The identifier for the Elected Office being sought.", "key": "candidate_office_identifier", "label": "Elected Office Identifier", "value": 60 },
                    "candidate_prefix": { "can_match_multiple": false, "category": 3, "description": "The Candidate Prefix of the Candidate.", "key": "candidate_prefix", "label": "Candidate Prefix", "value": 50 },
                    "candidate_state": { "can_match_multiple": false, "category": 3, "description": "The Candidate State of the Candidate.", "key": "candidate_state", "label": "Candidate State", "value": 55 },
                    "candidate_suffix": { "can_match_multiple": false, "category": 3, "description": "The Candidate Suffix of the Candidate.", "key": "candidate_suffix", "label": "Candidate Suffix", "value": 54 },
                    "committee_type_identifier": { "can_match_multiple": false, "category": 1, "description": "The Committee Type identifier for the Political Committee", "key": "committee_type_identifier", "label": "Committee Type Identifier", "value": 2 },
                    "contact_first_name": { "can_match_multiple": false, "category": 2, "description": "The Contact First Name of the Political Committee.", "key": "contact_first_name", "label": "Contact First Name", "value": 31 },
                    "contact_last_name": { "can_match_multiple": false, "category": 2, "description": "The Contact Last Name of the Political Committee.", "key": "contact_last_name", "label": "Contact Last Name", "value": 33 },
                    "contact_middle_name": { "can_match_multiple": false, "category": 2, "description": "The Contact Middle Name of the Political Committee.", "key": "contact_middle_name", "label": "Contact Middle Name", "value": 32 },
                    "contact_prefix": { "can_match_multiple": false, "category": 2, "description": "The Contact Prefix of the Political Committee.", "key": "contact_prefix", "label": "Contact Prefix", "value": 30 },
                    "contact_suffix": { "can_match_multiple": false, "category": 2, "description": "The Contact Suffix of the Political Committee.", "key": "contact_suffix", "label": "Contact Suffix", "value": 34 },
                    "email": { "can_match_multiple": false, "category": 2, "description": "The Email of the Political Committee.", "key": "email", "label": "Email", "value": 20 },
                    "fax_number": { "can_match_multiple": false, "category": 2, "description": "The Fax Number of the Political Committee.", "key": "fax_number", "label": "Committee Fax Number", "value": 16 },
                    "fec_committee_id": { "can_match_multiple": false, "category": 1, "description": "The regulatory agency issued filer identifier for the Political Committee such as the FEC Committee ID or the State-issued ID.", "key": "fec_committee_id", "label": "Filer ID", "value": 3 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 1, "description": "A unique value to identify this political committee in imports.", "key": "import_id", "label": "Import ID", "value": 7 },
                    "is_active": { "can_match_multiple": false, "category": 1, "description": "Whether the Political Committee is currently active.", "key": "is_active", "label": "Active?", "value": 5 },
                    "name": { "can_match_multiple": false, "category": 5, "description": "The Name of the Political Committee.", "key": "name", "label": "Name", "value": 1 },
                    "pacc_legislator_kw_pid": { "can_match_multiple": false, "category": 3, "description": "The KnowWho ID of the Candidate.", "key": "pacc_legislator_kw_pid", "label": "KnowWho ID", "value": 63 },
                    "parent_committee_identifier": { "can_match_multiple": false, "category": 1, "description": "The identifier for the parent Political Committee, if any.", "key": "parent_committee_identifier", "label": "Parent Committee Identifier", "value": 6 },
                    "party": { "can_match_multiple": false, "category": 1, "description": "The Political Party of the Political Committee.", "key": "party", "label": "Political Party", "value": 4 },
                    "phone_number": { "can_match_multiple": false, "category": 2, "description": "The Phone Number of the Political Committee.", "key": "phone_number", "label": "Committee Phone Number", "value": 15 },
                    "re_election_year": { "can_match_multiple": false, "category": 3, "description": "The Re-Election Year of the Candidate.", "key": "re_election_year", "label": "Re-Election Year", "value": 65 },
                    "treasurer_city": { "can_match_multiple": false, "category": 4, "description": "The City of the Political Committee's Treasurer.", "key": "treasurer_city", "label": "Treasurer City", "value": 82 },
                    "treasurer_first_name": { "can_match_multiple": false, "category": 4, "description": "The First Name of the Political Committee's Treasurer.", "key": "treasurer_first_name", "label": "Treasurer First Name", "value": 71 },
                    "treasurer_last_name": { "can_match_multiple": false, "category": 4, "description": "The Last Name of the Political Committee's Treasurer.", "key": "treasurer_last_name", "label": "Treasurer Last Name", "value": 73 },
                    "treasurer_middle_name": { "can_match_multiple": false, "category": 4, "description": "The Middle Name of the Political Committee's Treasurer.", "key": "treasurer_middle_name", "label": "Treasurer Middle Name", "value": 72 },
                    "treasurer_prefix": { "can_match_multiple": false, "category": 4, "description": "The Prefix of the Political Committee's Treasurer.", "key": "treasurer_prefix", "label": "Treasurer Prefix", "value": 70 },
                    "treasurer_state": { "can_match_multiple": false, "category": 4, "description": "The State of the Political Committee's Treasurer.", "key": "treasurer_state", "label": "Treasurer State", "value": 83 },
                    "treasurer_street_address": { "can_match_multiple": false, "category": 4, "description": "The Street Address of the Political Committee's Treasurer.", "key": "treasurer_street_address", "label": "Treasurer Street Address", "value": 80 },
                    "treasurer_street_address_2": { "can_match_multiple": false, "category": 4, "description": "The Street Address 2 of the Political Committee's Treasurer.", "key": "treasurer_street_address_2", "label": "Treasurer Street Address 2", "value": 81 },
                    "treasurer_suffix": { "can_match_multiple": false, "category": 4, "description": "The Suffix of the Political Committee's Treasurer.", "key": "treasurer_suffix", "label": "Treasurer Suffix", "value": 74 },
                    "treasurer_zip": { "can_match_multiple": false, "category": 4, "description": "The Postal Code of the Political Committee's Treasurer.", "key": "treasurer_zip", "label": "Treasurer Postal Code", "value": 84 },
                    "website": { "can_match_multiple": false, "category": 2, "description": "The Website of the Political Committee.", "key": "website", "label": "Website", "value": 21 }
                },
                "QPACAbstractDisbursementCategory": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank and Expense Type", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "recipient": { "key": "recipient", "label": "Recipient", "value": 1 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 9 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACAbstractDisbursementField": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 2, "description": "What is the amount of the transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "disbursement_type": { "can_match_multiple": false, "category": 4, "description": "The type of disbursement. Options are 'Other Disbursement', 'Non Reporting Disbursement', or 'Other Federal Operating Expenditures'. No other text will be recognized.", "key": "disbursement_type", "label": "Disbursement Type", "value": 53 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "expense_type": { "can_match_multiple": false, "category": 4, "description": "The FEC Code of the expense type.", "key": "expense_type", "label": "Expense Type", "value": 52 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize (Y/N)", "value": 17 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 14 },
                    "is_memo_entry": { "can_match_multiple": false, "category": 2, "description": "Report this transaction as a Memo Entry", "key": "is_memo_entry", "label": "Memo Entry (Y/N)", "value": 21 },
                    "is_reconciled": { "can_match_multiple": false, "category": 4, "description": "This transaction has already been reconciled.", "key": "is_reconciled", "label": "Has Been Reconciled", "value": 51 },
                    "occurred_date": { "can_match_multiple": false, "category": 2, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 13 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 9, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 9, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "transaction_method": { "can_match_multiple": false, "category": 2, "description": "What was the method of this transaction? (C - Check, O - Other)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACDisbursementToNonPacOrgCategory": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank and Expense Type", "value": 4 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 3 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "recipient": { "key": "recipient", "label": "Recipient", "value": 1 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 9 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACDisbursementToNonPacOrgCategoryPACCMigration": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank and Expense Type", "value": 4 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 3 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "pacc": { "key": "pacc", "label": "PACC Migration Fields", "value": 5 },
                    "recipient": { "key": "recipient", "label": "Recipient", "value": 1 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 9 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACDisbursementToNonPacOrgField": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 3, "description": "What is the amount of the transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "disbursement_type": { "can_match_multiple": false, "category": 4, "description": "The type of disbursement. Options are 'Other Disbursement', 'Non Reporting Disbursement', or 'Other Federal Operating Expenditures'. No other text will be recognized.", "key": "disbursement_type", "label": "Disbursement Type", "value": 53 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "expense_type": { "can_match_multiple": false, "category": 4, "description": "The FEC Code of the expense type.", "key": "expense_type", "label": "Expense Type", "value": 52 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize (Y/N)", "value": 17 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 14 },
                    "is_memo_entry": { "can_match_multiple": false, "category": 2, "description": "Report this transaction as a Memo Entry", "key": "is_memo_entry", "label": "Memo Entry (Y/N)", "value": 21 },
                    "is_reconciled": { "can_match_multiple": false, "category": 4, "description": "This transaction has already been reconciled.", "key": "is_reconciled", "label": "Has Been Reconciled", "value": 51 },
                    "occurred_date": { "can_match_multiple": false, "category": 3, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "public_organization__id": { "can_match_multiple": false, "category": 3, "description": "The Quorum ID of the Recipient Organization to which the disbursement was made.", "key": "public_organization__id", "label": "Recip Org Quorum ID", "value": 2 },
                    "public_organization__name": { "can_match_multiple": false, "category": 3, "description": "The Name of the Custom Organization to which the disbursement was made.", "key": "public_organization__name", "label": "Recip Org FEC Name", "value": 1 },
                    "public_organization__unique_identifier": { "can_match_multiple": false, "category": 3, "description": "The Unique Identifier of the Recipient Organization to which the disbursement was made.", "key": "public_organization__unique_identifier", "label": "Recip Org Unique Identifier", "value": 3 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 13 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 9, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 9, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "reporting_code_id": { "can_match_multiple": false, "category": 1, "description": "Quorum Report Code ID for this transaction", "key": "reporting_code_id", "label": "Quorum Report Code ID", "value": 5 },
                    "reporting_code_name": { "can_match_multiple": false, "category": 1, "description": "Quorum Report Code Name for this transaction", "key": "reporting_code_name", "label": "Quorum Report Code Name", "value": 6 },
                    "transaction_method": { "can_match_multiple": false, "category": 3, "description": "What was the method of this transaction? (C - Check, O - Other)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACDisbursementToNonPacOrgFieldPACCMigration": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 3, "description": "What is the amount of the transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "disbursement_type": { "can_match_multiple": false, "category": 4, "description": "The type of disbursement. Options are 'Other Disbursement', 'Non Reporting Disbursement', or 'Other Federal Operating Expenditures'. No other text will be recognized.", "key": "disbursement_type", "label": "Disbursement Type", "value": 53 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "expense_type": { "can_match_multiple": false, "category": 4, "description": "The FEC Code of the expense type.", "key": "expense_type", "label": "Expense Type", "value": 52 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize (Y/N)", "value": 17 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 14 },
                    "is_memo_entry": { "can_match_multiple": false, "category": 2, "description": "Report this transaction as a Memo Entry", "key": "is_memo_entry", "label": "Memo Entry (Y/N)", "value": 21 },
                    "is_reconciled": { "can_match_multiple": false, "category": 4, "description": "This transaction has already been reconciled.", "key": "is_reconciled", "label": "Has Been Reconciled", "value": 51 },
                    "occurred_date": { "can_match_multiple": false, "category": 3, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "pacc_companyid": { "can_match_multiple": false, "category": 5, "description": "The CompanyID in PACC for the Company that owns this Transaction", "key": "pacc_companyid", "label": "PACC CompanyID", "value": 105 },
                    "pacc_expensetypeid": { "can_match_multiple": false, "category": 5, "description": "The ExpenseTypeID in PACC for this Transaction", "key": "pacc_expensetypeid", "label": "PACC PacExpenseTypeID", "value": 102 },
                    "pacc_pacaccountid": { "can_match_multiple": false, "category": 5, "description": "The PACAccountId in PACC for the PAC Account associated with this Transaction", "key": "pacc_pacaccountid", "label": "PACC PACAccountId", "value": 104 },
                    "pacc_pacid": { "can_match_multiple": false, "category": 5, "description": "The PACId in PACC for the PAC associated with this Transaction", "key": "pacc_pacid", "label": "PACC PACId", "value": 103 },
                    "pacc_pacparenttransactionid": { "can_match_multiple": false, "category": 5, "description": "The PACParentTransactionId in PACC associated with this Transaction", "key": "pacc_pacparenttransactionid", "label": "PACC PACParentTransactionId", "value": 107 },
                    "pacc_pacreportcodeid": { "can_match_multiple": false, "category": 5, "description": "The PACReportCodeId in PACC associated with this Transaction", "key": "pacc_pacreportcodeid", "label": "PACC PACReportCodeId", "value": 106 },
                    "pacc_pactransactionid": { "can_match_multiple": false, "category": 5, "description": "The TransactionID for this transaction in PACC", "key": "pacc_pactransactionid", "label": "PACC TransactionId", "value": 100 },
                    "public_organization__id": { "can_match_multiple": false, "category": 3, "description": "The Quorum ID of the Recipient Organization to which the disbursement was made.", "key": "public_organization__id", "label": "Recip Org Quorum ID", "value": 2 },
                    "public_organization__name": { "can_match_multiple": false, "category": 3, "description": "The Name of the Custom Organization to which the disbursement was made.", "key": "public_organization__name", "label": "Recip Org FEC Name", "value": 1 },
                    "public_organization__unique_identifier": { "can_match_multiple": false, "category": 3, "description": "The Unique Identifier of the Recipient Organization to which the disbursement was made.", "key": "public_organization__unique_identifier", "label": "Recip Org Unique Identifier", "value": 3 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 13 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 9, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 9, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "reporting_code_id": { "can_match_multiple": false, "category": 1, "description": "Quorum Report Code ID for this transaction", "key": "reporting_code_id", "label": "Quorum Report Code ID", "value": 5 },
                    "reporting_code_name": { "can_match_multiple": false, "category": 1, "description": "Quorum Report Code Name for this transaction", "key": "reporting_code_name", "label": "Quorum Report Code Name", "value": 6 },
                    "transaction_method": { "can_match_multiple": false, "category": 3, "description": "What was the method of this transaction? (C - Check, O - Other)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACDisbursementToPACCategory": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank and Expense Type", "value": 4 },
                    "election": { "key": "election", "label": "Election Identifier", "value": 3 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 6 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "recipient": { "key": "recipient", "label": "Recipient", "value": 1 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 9 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACDisbursementToPACCategoryPACCMigration": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank and Expense Type", "value": 4 },
                    "election": { "key": "election", "label": "Election Identifier", "value": 3 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 6 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "pacc": { "key": "pacc", "label": "PACC Migration Fields", "value": 5 },
                    "recipient": { "key": "recipient", "label": "Recipient", "value": 1 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 9 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACDisbursementToPACField": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 6, "description": "What is the amount of the transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "committee__addr_state": { "can_match_multiple": false, "category": 1, "description": "The two-letter abbreviation for the State of the committee's address.", "key": "committee__addr_state", "label": "State Abbreviation", "value": 5 },
                    "committee__fec_committee_id": { "can_match_multiple": false, "category": 6, "description": "The FEC Committee ID of the Candidate Committee to which the disbursement was made.", "key": "committee__fec_committee_id", "label": "Filer ID", "value": 1 },
                    "committee__id": { "can_match_multiple": false, "category": 6, "description": "The Quorum ID of the Candidate Committee to which the disbursement was made.", "key": "committee__id", "label": "Quorum ID", "value": 2 },
                    "committee__import_id": { "can_match_multiple": false, "category": 1, "description": "The Import ID of the Political Committee.", "key": "committee__import_id", "label": "Committee Import ID", "value": 3 },
                    "committee__name": { "can_match_multiple": false, "category": 1, "description": "The Name of the Political Committee.", "key": "committee__name", "label": "Name", "value": 4 },
                    "committee__national_committee_type": { "can_match_multiple": false, "category": 1, "description": "The single-letter code for the type of national party committee, if applicable.", "key": "committee__national_committee_type", "label": "National Committee Type", "value": 8 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "disbursement_type": { "can_match_multiple": false, "category": 4, "description": "The type of disbursement. Options are 'Other Disbursement', 'Non Reporting Disbursement', or 'Other Federal Operating Expenditures'. No other text will be recognized.", "key": "disbursement_type", "label": "Disbursement Type", "value": 53 },
                    "election__id": { "can_match_multiple": false, "category": 6, "description": "The Quorum ID of the election related to which this disbursement is made.", "key": "election__id", "label": "Election Quorum ID", "value": 6 },
                    "election__pacc_election_key": { "can_match_multiple": false, "category": 3, "description": "The Election Key of the election. NOTE: Election Key is created by concatenating the Year, the two-digit Representing jurisdiction, and the type - e.g. 2022 Ohio Primary is 2022OHP; 2020 General is 2020USG", "key": "election__pacc_election_key", "label": "Election Key", "value": 7 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "expense_type": { "can_match_multiple": false, "category": 4, "description": "The FEC Code of the expense type.", "key": "expense_type", "label": "Expense Type", "value": 52 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize (Y/N)", "value": 17 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 14 },
                    "is_memo_entry": { "can_match_multiple": false, "category": 2, "description": "Report this transaction as a Memo Entry", "key": "is_memo_entry", "label": "Memo Entry (Y/N)", "value": 21 },
                    "is_reconciled": { "can_match_multiple": false, "category": 4, "description": "This transaction has already been reconciled.", "key": "is_reconciled", "label": "Has Been Reconciled", "value": 51 },
                    "occurred_date": { "can_match_multiple": false, "category": 6, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 13 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 9, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 9, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "transaction_method": { "can_match_multiple": false, "category": 6, "description": "What was the method of this transaction? (C - Check, O - Other)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACDisbursementToPACFieldPACCMigration": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 6, "description": "What is the amount of the transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "committee__addr_state": { "can_match_multiple": false, "category": 1, "description": "The two-letter abbreviation for the State of the committee's address.", "key": "committee__addr_state", "label": "State Abbreviation", "value": 5 },
                    "committee__fec_committee_id": { "can_match_multiple": false, "category": 6, "description": "The FEC Committee ID of the Candidate Committee to which the disbursement was made.", "key": "committee__fec_committee_id", "label": "Filer ID", "value": 1 },
                    "committee__id": { "can_match_multiple": false, "category": 6, "description": "The Quorum ID of the Candidate Committee to which the disbursement was made.", "key": "committee__id", "label": "Quorum ID", "value": 2 },
                    "committee__import_id": { "can_match_multiple": false, "category": 1, "description": "The Import ID of the Political Committee.", "key": "committee__import_id", "label": "Committee Import ID", "value": 3 },
                    "committee__name": { "can_match_multiple": false, "category": 1, "description": "The Name of the Political Committee.", "key": "committee__name", "label": "Name", "value": 4 },
                    "committee__national_committee_type": { "can_match_multiple": false, "category": 1, "description": "The single-letter code for the type of national party committee, if applicable.", "key": "committee__national_committee_type", "label": "National Committee Type", "value": 8 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "disbursement_type": { "can_match_multiple": false, "category": 4, "description": "The type of disbursement. Options are 'Other Disbursement', 'Non Reporting Disbursement', or 'Other Federal Operating Expenditures'. No other text will be recognized.", "key": "disbursement_type", "label": "Disbursement Type", "value": 53 },
                    "election__id": { "can_match_multiple": false, "category": 6, "description": "The Quorum ID of the election related to which this disbursement is made.", "key": "election__id", "label": "Election Quorum ID", "value": 6 },
                    "election__pacc_election_key": { "can_match_multiple": false, "category": 3, "description": "The Election Key of the election. NOTE: Election Key is created by concatenating the Year, the two-digit Representing jurisdiction, and the type - e.g. 2022 Ohio Primary is 2022OHP; 2020 General is 2020USG", "key": "election__pacc_election_key", "label": "Election Key", "value": 7 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "expense_type": { "can_match_multiple": false, "category": 4, "description": "The FEC Code of the expense type.", "key": "expense_type", "label": "Expense Type", "value": 52 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize (Y/N)", "value": 17 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 14 },
                    "is_memo_entry": { "can_match_multiple": false, "category": 2, "description": "Report this transaction as a Memo Entry", "key": "is_memo_entry", "label": "Memo Entry (Y/N)", "value": 21 },
                    "is_reconciled": { "can_match_multiple": false, "category": 4, "description": "This transaction has already been reconciled.", "key": "is_reconciled", "label": "Has Been Reconciled", "value": 51 },
                    "occurred_date": { "can_match_multiple": false, "category": 6, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "pacc_companyid": { "can_match_multiple": false, "category": 5, "description": "The CompanyID in PACC for the Company that owns this Transaction", "key": "pacc_companyid", "label": "PACC CompanyID", "value": 105 },
                    "pacc_expensetypeid": { "can_match_multiple": false, "category": 5, "description": "The ExpenseTypeID in PACC for this Transaction", "key": "pacc_expensetypeid", "label": "PACC PacExpenseTypeID", "value": 102 },
                    "pacc_pacaccountid": { "can_match_multiple": false, "category": 5, "description": "The PACAccountId in PACC for the PAC Account associated with this Transaction", "key": "pacc_pacaccountid", "label": "PACC PACAccountId", "value": 104 },
                    "pacc_pacelectionid": { "can_match_multiple": false, "category": 5, "description": "The ElectionID as entered in PACC for this Transaction", "key": "pacc_pacelectionid", "label": "PACC ElectionId", "value": 101 },
                    "pacc_pacid": { "can_match_multiple": false, "category": 5, "description": "The PACId in PACC for the PAC associated with this Transaction", "key": "pacc_pacid", "label": "PACC PACId", "value": 103 },
                    "pacc_pacparenttransactionid": { "can_match_multiple": false, "category": 5, "description": "The PACParentTransactionId in PACC associated with this Transaction", "key": "pacc_pacparenttransactionid", "label": "PACC PACParentTransactionId", "value": 107 },
                    "pacc_pacreportcodeid": { "can_match_multiple": false, "category": 5, "description": "The PACReportCodeId in PACC associated with this Transaction", "key": "pacc_pacreportcodeid", "label": "PACC PACReportCodeId", "value": 106 },
                    "pacc_pactransactionid": { "can_match_multiple": false, "category": 5, "description": "The TransactionID for this transaction in PACC", "key": "pacc_pactransactionid", "label": "PACC TransactionId", "value": 100 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 13 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 9, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 9, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "transaction_method": { "can_match_multiple": false, "category": 6, "description": "What was the method of this transaction? (C - Check, O - Other)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACDisbursementVoidCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "what": { "key": "what", "label": "Required Transaction Information", "value": 2 },
                    "what_voided": { "key": "what_voided", "label": "Identify the VOIDED Transaction", "value": 1 },
                    "when": { "key": "when", "label": "When was the Void?", "value": 3 }
                },
                "QPACDisbursementVoidField": {
                    "__is_enum": true,
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 4, "description": "The Import ID of this Transaction.", "key": "import_id", "label": "Import ID", "value": 3 },
                    "occurred_date": { "can_match_multiple": false, "category": 2, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 1 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "quorum_id": { "can_match_multiple": false, "category": 4, "description": "The Quorum ID of this Transaction.", "key": "quorum_id", "label": "Quorum ID", "value": 2 },
                    "voids_import_id": { "can_match_multiple": false, "category": 1, "description": "A unique value to identify this transaction in imports.", "key": "voids_import_id", "label": "Voids Import ID", "value": 13 },
                    "voids_quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Qourum ID of the send email, if updating an existing record.You must provide either this or Bulk Email ID for each row.", "key": "voids_quorum_id", "label": "Voids Quorum ID", "value": 12 },
                    "voids_reference_number": { "can_match_multiple": false, "category": 1, "description": "The reference number of the transaction being voided.", "key": "voids_reference_number", "label": "Voids Reference Number", "value": 10 }
                },
                "QPACDisbursementVoidPACCMigration": {
                    "__is_enum": true,
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 4, "description": "The Import ID of this Transaction.", "key": "import_id", "label": "Import ID", "value": 3 },
                    "occurred_date": { "can_match_multiple": false, "category": 2, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 1 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "pacc_pactransactionid": { "can_match_multiple": false, "category": 2, "description": "The TransactionID for this transaction.", "key": "pacc_pactransactionid", "label": "PACC TransactionId", "value": 104 },
                    "quorum_id": { "can_match_multiple": false, "category": 4, "description": "The Quorum ID of this Transaction.", "key": "quorum_id", "label": "Quorum ID", "value": 2 },
                    "voids_import_id": { "can_match_multiple": false, "category": 1, "description": "A unique value to identify this transaction in imports.", "key": "voids_import_id", "label": "Voids Import ID", "value": 13 },
                    "voids_pacc_pactransactionid": { "can_match_multiple": false, "category": 1, "description": "The TransactionID for the transaction being Voided", "key": "voids_pacc_pactransactionid", "label": "Voided PACC TransactionId", "value": 114 },
                    "voids_quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Qourum ID of the send email, if updating an existing record.You must provide either this or Bulk Email ID for each row.", "key": "voids_quorum_id", "label": "Voids Quorum ID", "value": 12 },
                    "voids_reference_number": { "can_match_multiple": false, "category": 1, "description": "The reference number of the transaction being voided.", "key": "voids_reference_number", "label": "Voids Reference Number", "value": 10 }
                },
                "QPACReceiptFromAnonymousIndividualCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 3 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 }
                },
                "QPACReceiptFromAnonymousIndividualField": {
                    "__is_enum": true,
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 17 },
                    "amount": { "can_match_multiple": false, "category": 3, "description": "How large was this transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "batch__name": { "can_match_multiple": false, "category": 2, "description": "The exact name of the batch to put the transaction in. If not specified a batch will be created for this upload", "key": "batch__name", "label": "Batch Name", "value": 18 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 16 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 13 },
                    "occurred_date": { "can_match_multiple": false, "category": 3, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 }
                },
                "QPACReceiptFromCustomOrganizationCategory": {
                    "__is_enum": true,
                    "bank": { "key": "bank", "label": "Bank Info", "value": 4 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 5 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 },
                    "who": { "key": "who", "label": "Received From", "value": 1 }
                },
                "QPACReceiptFromCustomOrganizationField": {
                    "__is_enum": true,
                    "account__nickname": { "can_match_multiple": false, "category": 4, "description": "The exact name of the bank account associated with the transaction, or blank to use default", "key": "account__nickname", "label": "Bank Account Name", "value": 50 },
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 16 },
                    "amount": { "can_match_multiple": false, "category": 5, "description": "How large was this transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "batch__name": { "can_match_multiple": false, "category": 2, "description": "The exact name of the batch to put the transaction in. If not specified a batch will be created for this upload", "key": "batch__name", "label": "Batch Name", "value": 17 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 15 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize", "value": 30 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 13 },
                    "occurred_date": { "can_match_multiple": false, "category": 5, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "public_organization__id": { "can_match_multiple": false, "category": 5, "description": "The Quorum ID of the Organization from which the receipt came.", "key": "public_organization__id", "label": "Contributing Org Quorum ID", "value": 1 },
                    "public_organization__name": { "can_match_multiple": false, "category": 5, "description": "The Name of the Organization from which the receipt came.", "key": "public_organization__name", "label": "Contributing Org Name", "value": 2 },
                    "public_organization__unique_identifier": { "can_match_multiple": false, "category": 5, "description": "The Unique Identifier of the Organization from which the receipt came.", "key": "public_organization__unique_identifier", "label": "Contributing Org Unique Identifier", "value": 3 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "receipt_type": { "can_match_multiple": false, "category": 2, "description": "The type of receipt. Options are 'Other Receipt', 'Non Reporting Receipt from Organization', 'Offsets to Operating Expenditures', or, if from a Bank, 'Bank Interest and Income'. No other text will be recognized.", "key": "receipt_type", "label": "Receipt Type", "value": 18 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 14 },
                    "transaction_method": { "can_match_multiple": false, "category": 5, "description": "What was the method of this transaction? (P - Payroll, C - Check, CC - Credit Card)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACReceiptFromIndividualCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 3 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 },
                    "who": { "key": "who", "label": "Received From", "value": 1 }
                },
                "QPACReceiptFromIndividualCategoryPACCMigration": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "pacc": { "key": "pacc", "label": "PACC Migration Fields", "value": 10 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 3 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 },
                    "who": { "key": "who", "label": "Received From", "value": 1 }
                },
                "QPACReceiptFromIndividualField": {
                    "__is_enum": true,
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 17 },
                    "amount": { "can_match_multiple": false, "category": 4, "description": "How large was this transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "batch__name": { "can_match_multiple": false, "category": 2, "description": "The exact name of the batch to put the transaction in. If not specified a batch will be created for this upload", "key": "batch__name", "label": "Batch Name", "value": 18 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 16 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 3, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize", "value": 30 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 13 },
                    "non_pac_public_organization": { "can_match_multiple": false, "category": 2, "description": "The name of the organization the contact is linked to (can be custom).", "key": "non_pac_public_organization", "label": "Custom Organization", "value": 19 },
                    "occurred_date": { "can_match_multiple": false, "category": 4, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 3, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "payroll_frequency_type": { "can_match_multiple": false, "category": 2, "description": "What is the payroll cycle for this transaction?  (B - Bi-Weekly, W - Weekly, M - Monthly, S - Semi-Monthly)", "key": "payroll_frequency_type", "label": "Payroll Cycle", "value": 14 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 15 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 3, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 3, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "supporter__email": { "can_match_multiple": false, "category": 1, "description": "The Email Address of the Contact who gave the receipt", "key": "supporter__email", "label": "Email Address", "value": 2 },
                    "supporter__firstname": { "can_match_multiple": false, "category": 4, "description": "The first name of the contact who gave a receipt.  Do not use with Full Name.", "key": "supporter__firstname", "label": "First Name", "value": 5 },
                    "supporter__lastname": { "can_match_multiple": false, "category": 4, "description": "The last name of the Contact who gave a receipt.  Do not use with Full Name.", "key": "supporter__lastname", "label": "Last Name", "value": 6 },
                    "supporter__name": { "can_match_multiple": false, "category": 4, "description": "The full name of the person who paid this amount.  Do not use with First Name or Last Name.", "key": "supporter__name", "label": "Full Name", "value": 7 },
                    "supporter__quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum ID of the Contact who gave the contribution", "key": "supporter__quorum_id", "label": "Quorum ID", "value": 1 },
                    "supporter__unique_identifier": { "can_match_multiple": false, "category": 1, "description": "The Unique Identifier of the Contact who gave the receipt", "key": "supporter__unique_identifier", "label": "Unique Identifier", "value": 3 },
                    "transaction_method": { "can_match_multiple": false, "category": 4, "description": "What was the method of this transaction? (P - Payroll, C - Check, CC - Credit Card)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACReceiptFromIndividualFieldPACCMigration": {
                    "__is_enum": true,
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 17 },
                    "amount": { "can_match_multiple": false, "category": 4, "description": "How large was this transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "batch__name": { "can_match_multiple": false, "category": 2, "description": "The exact name of the batch to put the transaction in. If not specified a batch will be created for this upload", "key": "batch__name", "label": "Batch Name", "value": 18 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 16 },
                    "exclude_from_limits_calc": { "can_match_multiple": false, "category": 3, "description": "Should this transaction be excluded from contribution limits calculations.", "key": "exclude_from_limits_calc", "label": "Override Limits", "value": 31 },
                    "force_itemize": { "can_match_multiple": false, "category": 2, "description": "Should this transaction be itemized.", "key": "force_itemize", "label": "Force Itemize", "value": 30 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 13 },
                    "non_pac_public_organization": { "can_match_multiple": false, "category": 2, "description": "The name of the organization the contact is linked to (can be custom).", "key": "non_pac_public_organization", "label": "Custom Organization", "value": 19 },
                    "occurred_date": { "can_match_multiple": false, "category": 4, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 3, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "pacc_companyid": { "can_match_multiple": false, "category": 10, "description": "The Company ID in PACC for the PAC associated with this Transaction; this is used to verify that data is going into the correct organization on upload only.", "key": "pacc_companyid", "label": "PACC CompanyId", "value": 102 },
                    "pacc_pacaccountid": { "can_match_multiple": false, "category": 4, "description": "The PACAccountId in PACC for the PAC Account associated with this Transaction", "key": "pacc_pacaccountid", "label": "PACC PACAccountId", "value": 104 },
                    "pacc_pacid": { "can_match_multiple": false, "category": 4, "description": "The PACId in PACC for the PAC associated with this Transaction", "key": "pacc_pacid", "label": "PACC PACId", "value": 103 },
                    "pacc_pacparenttransactionid": { "can_match_multiple": false, "category": 10, "description": "The PACParentTransactionId in PACC associated with this Transaction", "key": "pacc_pacparenttransactionid", "label": "PACC PACParentTransactionId", "value": 106 },
                    "pacc_pacreportcodeid": { "can_match_multiple": false, "category": 10, "description": "The PACReportCodeId in PACC associated with this Transaction", "key": "pacc_pacreportcodeid", "label": "PACC PACReportCodeId", "value": 105 },
                    "pacc_pactransactionid": { "can_match_multiple": false, "category": 4, "description": "The TransactionID for this transaction in PACC", "key": "pacc_pactransactionid", "label": "PACC TransactionId", "value": 101 },
                    "payroll_frequency_type": { "can_match_multiple": false, "category": 2, "description": "What is the payroll cycle for this transaction?  (B - Bi-Weekly, W - Weekly, M - Monthly, S - Semi-Monthly)", "key": "payroll_frequency_type", "label": "Payroll Cycle", "value": 14 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 15 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 3, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 3, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "supporter__email": { "can_match_multiple": false, "category": 1, "description": "The Email Address of the Contact who gave the receipt", "key": "supporter__email", "label": "Email Address", "value": 2 },
                    "supporter__firstname": { "can_match_multiple": false, "category": 4, "description": "The first name of the contact who gave a receipt.  Do not use with Full Name.", "key": "supporter__firstname", "label": "First Name", "value": 5 },
                    "supporter__lastname": { "can_match_multiple": false, "category": 4, "description": "The last name of the Contact who gave a receipt.  Do not use with Full Name.", "key": "supporter__lastname", "label": "Last Name", "value": 6 },
                    "supporter__name": { "can_match_multiple": false, "category": 4, "description": "The full name of the person who paid this amount.  Do not use with First Name or Last Name.", "key": "supporter__name", "label": "Full Name", "value": 7 },
                    "supporter__pacc_individual_id": { "can_match_multiple": false, "category": 4, "description": "The PACC IndividualID of the Contact who gave the receipt", "key": "supporter__pacc_individual_id", "label": "PACC Individual ID", "value": 100 },
                    "supporter__quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum ID of the Contact who gave the contribution", "key": "supporter__quorum_id", "label": "Quorum ID", "value": 1 },
                    "supporter__unique_identifier": { "can_match_multiple": false, "category": 1, "description": "The Unique Identifier of the Contact who gave the receipt", "key": "supporter__unique_identifier", "label": "Unique Identifier", "value": 3 },
                    "transaction_method": { "can_match_multiple": false, "category": 4, "description": "What was the method of this transaction? (P - Payroll, C - Check, CC - Credit Card)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QPACReceiptFromPoliticalCommitteeCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 4 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "special": { "key": "special", "label": "Special Transaction Info", "value": 3 },
                    "what": { "key": "what", "label": "Required Transaction Info", "value": 2 },
                    "who": { "key": "who", "label": "Received From", "value": 1 }
                },
                "QPACReceiptFromPoliticalCommitteeField": {
                    "__is_enum": true,
                    "additional_notes": { "can_match_multiple": false, "category": 2, "description": "The internal comment / additional notes associated with the transaction.", "key": "additional_notes", "label": "Internal Comment", "value": 17 },
                    "amount": { "can_match_multiple": false, "category": 4, "description": "How large was this transaction in Dollars?", "key": "amount", "label": "Amount", "value": 11 },
                    "batch__name": { "can_match_multiple": false, "category": 2, "description": "The exact name of the batch to put the transaction in. If not specified a batch will be created for this upload", "key": "batch__name", "label": "Batch Name", "value": 18 },
                    "committee__addr_state": { "can_match_multiple": false, "category": 1, "description": "The two-letter abbreviation for the State of the committee's address.", "key": "committee__addr_state", "label": "State Abbreviation", "value": 5 },
                    "committee__fec_committee_id": { "can_match_multiple": false, "category": 4, "description": "The FEC Committee ID of the Candidate Committee from which the receipt came.", "key": "committee__fec_committee_id", "label": "Contributing Org FEC Committee ID", "value": 1 },
                    "committee__id": { "can_match_multiple": false, "category": 4, "description": "The Quorum ID of the Candidate Committee from which the receipt came.", "key": "committee__id", "label": "Contributing Org Quorum ID", "value": 2 },
                    "committee__import_id": { "can_match_multiple": false, "category": 1, "description": "The Import ID of the Political Committee.", "key": "committee__import_id", "label": "Committee Import ID", "value": 3 },
                    "committee__name": { "can_match_multiple": false, "category": 1, "description": "The Name of the Political Committee.", "key": "committee__name", "label": "Name", "value": 4 },
                    "description": { "can_match_multiple": false, "category": 2, "description": "A note or a purpose that is attached to the transaction. Like a memo on a check.", "key": "description", "label": "Report Description", "value": 16 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "import_id": { "can_match_multiple": false, "category": 2, "description": "A unique value to identify this transaction in imports.", "key": "import_id", "label": "Transaction Import ID", "value": 15 },
                    "occurred_date": { "can_match_multiple": false, "category": 4, "description": "When did this transaction take place?", "key": "occurred_date", "label": "Date", "value": 10 },
                    "override_all_warnings": { "can_match_multiple": false, "category": 2, "description": "Should this transaction override every validation warning.", "key": "override_all_warnings", "label": "Override All Warnings (Y/N)", "value": 32 },
                    "quorum_id": { "can_match_multiple": false, "category": 2, "description": "The Quorum ID of this transaction.", "key": "quorum_id", "label": "Transaction Quorum ID", "value": 9 },
                    "receipt_type": { "can_match_multiple": false, "category": 2, "description": "The type of Receipt from the Political Committee.", "key": "receipt_type", "label": "Receipt Type", "value": 13 },
                    "reference_number": { "can_match_multiple": false, "category": 2, "description": "An identifier for the item, such as a check number.", "key": "reference_number", "label": "Reference Number", "value": 14 },
                    "refunds_transaction_import_id": { "can_match_multiple": false, "category": 3, "description": "The Import ID of the transaction that this transaction refunds", "key": "refunds_transaction_import_id", "label": "Refunds Transaction - Import ID", "value": 81 },
                    "refunds_transaction_quorum_id": { "can_match_multiple": false, "category": 3, "description": "The Quorum ID of the transaction that this transaction refunds", "key": "refunds_transaction_quorum_id", "label": "Refunds Transaction - Quorum ID", "value": 80 },
                    "transaction_method": { "can_match_multiple": false, "category": 4, "description": "What was the method of this transaction? (P - Payroll, C - Check, CC - Credit Card)", "key": "transaction_method", "label": "Transaction Method Code", "value": 12 }
                },
                "QuorumOrganizationsCategory": {
                    "__is_enum": true,
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 1 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "info": { "key": "info", "label": "Fields", "value": 2 }
                },
                "QuorumOrganizationsField": {
                    "__is_enum": true,
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "issues": { "can_match_multiple": true, "category": 2, "description": "A comma separated list of issue names or ids to associate with this organization.", "key": "issues", "label": "Issues", "value": 22 },
                    "name": { "can_match_multiple": false, "category": 2, "description": "The full name of this organization in Quorum, for example 'Abbeville CCD, Alabama' or 'Office of OK Rep. Dustin Roberts (R-OK-021)'. Can be used for matching", "key": "name", "label": "Organization Name", "value": 2 },
                    "quorum_id": { "can_match_multiple": false, "category": 1, "description": "The Quorum identifier of this organization. Can be found by downloading a csv of organizations or from the url of its Quorum page", "key": "quorum_id", "label": "Quorum ID", "value": 1 },
                    "quorum_user": { "can_match_multiple": false, "category": 2, "description": "The email or username of the Quorum User this organization should be assigned to.", "key": "quorum_user", "label": "Assignment", "value": 21 },
                    "text": { "can_match_multiple": false, "category": 2, "description": "Custom Description for this organization", "key": "text", "label": "Custom Description", "value": 20 }
                },
                "SendEmailCategory": {
                    "__is_enum": true,
                    "content": { "key": "content", "label": "Email Content", "value": 3 },
                    "identifier": { "key": "identifier", "label": "Identifier", "value": 5 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "metrics": { "key": "metrics", "label": "Metrics", "value": 4 },
                    "people": { "key": "people", "label": "Email Senders & Recipients", "value": 2 },
                    "required_fields": { "key": "required_fields", "label": "ID and Required Fields", "value": 1 }
                },
                "SendEmailField": {
                    "__is_enum": true,
                    "bounces": { "can_match_multiple": false, "category": 4, "description": "The number of times this email Bounced.", "key": "bounces", "label": "Bounces", "value": 10 },
                    "bulk_email_ext_id": { "can_match_multiple": false, "category": 5, "description": "The External ID of the existing Bulk Email this email is associated with.You must provide either this, the Bulk Email quorum ID, or the Quorum ID of an existing send email for each row.", "key": "bulk_email_ext_id", "label": "Bulk Email External ID", "value": 3 },
                    "bulk_email_q_id": { "can_match_multiple": false, "category": 5, "description": "The Quorum ID or External ID of the existing Bulk Email this email is associated with.You must provide either this, the Bulk Email external ID, or the Quorum ID of an existing send email for each row.", "key": "bulk_email_q_id", "label": "Bulk Email Quorum ID", "value": 2 },
                    "clicks": { "can_match_multiple": false, "category": 4, "description": "The number of Clicks this email has had.", "key": "clicks", "label": "Clicks", "value": 9 },
                    "email_address": { "can_match_multiple": false, "category": 2, "description": "The email address to which the send-email was sent.", "key": "email_address", "label": "Email Address", "value": 17 },
                    "external_id": { "can_match_multiple": false, "category": 1, "description": "The external unique identifier of the SendEmail record, if any. This may be provided instead of Quorum ID to identify the existing SendEmail record in Quorum.", "key": "external_id", "label": "External ID", "value": 18 },
                    "first_click": { "can_match_multiple": false, "category": 4, "description": "The date/time of the first click on this email. If provided, must be in the past, and must be UTC.Any parsable date format acceptable, but recommended is 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' in UTC.", "key": "first_click", "label": "First Click Date/Time", "value": 13 },
                    "first_open": { "can_match_multiple": false, "category": 4, "description": "The date/time of the first open for this email. If provided, must be in the past, and must be UTC.Any parsable date format acceptable, but recommended is 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' in UTC.", "key": "first_open", "label": "Fist Open Date/Time", "value": 12 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "link_dict": { "can_match_multiple": false, "category": 4, "description": "The link dictionary for the links clicked in this email.", "key": "link_dict", "label": "Link Dictionary", "value": 11 },
                    "opens": { "can_match_multiple": false, "category": 4, "description": "The number of Opens this specific email has had.", "key": "opens", "label": "Opens", "value": 8 },
                    "person": { "can_match_multiple": false, "category": 2, "description": "The Official/Staffer quorum ID of the sent email recipient.", "key": "person", "label": "Official/Staffer Quorum ID", "value": 16 },
                    "quorum_id": { "can_match_multiple": false, "category": 5, "description": "The Qourum ID of the send email, if updating an existing record.You must provide either this or Bulk Email ID for each row.", "key": "quorum_id", "label": "Quorum ID", "value": 1 },
                    "recipient_name": { "can_match_multiple": false, "category": 2, "description": "The name of the recipient as specified in the email.", "key": "recipient_name", "label": "Recipient Name", "value": 6 },
                    "sent_datetime": { "can_match_multiple": false, "category": 5, "description": "The date & time this was sent. Required, must be in the past, and must be UTC.Any parsable date format acceptable, but recommended is 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' in UTC.", "key": "sent_datetime", "label": "Sent Date/Time", "value": 7 },
                    "supporter": { "can_match_multiple": false, "category": 1, "description": "The Contact Quorum ID or email address of the supporter this email is associated with; Required.", "key": "supporter", "label": "Contact Recipient", "value": 4 },
                    "text": { "can_match_multiple": false, "category": 3, "description": "Text of the email.", "key": "text", "label": "Text", "value": 15 },
                    "title": { "can_match_multiple": false, "category": 3, "description": "Title of the Email", "key": "title", "label": "Title", "value": 14 },
                    "user": { "can_match_multiple": false, "category": 2, "description": "The Quorum User who sent this email.", "key": "user", "label": "Quorum User", "value": 5 }
                },
                "TrackingDashBoardCategory": {
                    "__is_enum": true,
                    "category_fields": { "key": "category_fields", "label": "Category", "value": 1 },
                    "fields": { "key": "fields", "label": "Fields", "value": 2 },
                    "ignore": { "key": "ignore", "label": "Ignore", "value": 0 },
                    "participants": { "key": "participants", "label": "Participants", "value": 3 }
                },
                "TrackingDashBoardField": {
                    "__is_enum": true,
                    "data_type": { "can_match_multiple": false, "category": 2, "description": "Tracking projects are organized by the Data Type they represent, such as Bill, Regulation, etc", "key": "data_type", "label": "Data Type", "value": 2 },
                    "gov_predict_search_terms": { "can_match_multiple": false, "category": 2, "description": "The Gov Predict search data the user is trying to track", "key": "gov_predict_search_terms", "label": "Gov Predict Search Terms", "value": 7 },
                    "ignore": { "can_match_multiple": true, "category": 0, "description": "Don't upload this column", "key": "ignore", "label": "Ignore Column", "value": 0 },
                    "name": { "can_match_multiple": false, "category": 2, "description": "The name of the Tracking Project", "key": "name", "label": "name", "value": 6 },
                    "show_carryover": { "can_match_multiple": false, "category": 2, "description": "Whether or not carryover legislation should be included in search results. Defaults to False", "key": "show_carryover", "label": "Show Carryover", "value": 9 },
                    "show_only_no_stance": { "can_match_multiple": false, "category": 2, "description": "By default, the system displays only items with no stance. This behavior has been replaced by the selection_criteria feature.", "key": "show_only_no_stance", "label": "Show Only No Stance", "value": 8 },
                    "user": { "can_match_multiple": false, "category": 2, "description": "The Quorum User can be identified by their email, QuorumID, or their Username.", "key": "user", "label": "Quorum User", "value": 10 },
                    "year": { "can_match_multiple": false, "category": 2, "description": "Relevant for Bill tracking projects, which are organized by the year of the legislation", "key": "year", "label": "Year", "value": 1 }
                }
            }
        },
        "custom_event": {
            "models": {
                "CustomEvent": {
                    "__is_model": true,
                    "__name__": "CustomEvent",
                    "data_model": "app.custom_event.models.CustomEvent",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/customevent/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        { "field_type": 2, "help_text": "The subject of the confirmation email set by the user", "name": "conf_email_subject", "verbose_name": "conf email subject" },
                        { "field_type": 2, "help_text": "The from email address the Confirmation Email should be sent from", "name": "conf_email_from_address", "verbose_name": "conf email from address" },
                        { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to DEFAULT_CONFIRMATION_SEND_FROM_EMAIL", "name": "conf_email_from_name", "verbose_name": "conf email from name" },
                        { "field_type": 2, "help_text": "The name that should appear when replying to a confirmation email", "name": "conf_email_reply_to_name", "verbose_name": "conf email reply to name" },
                        { "field_type": 2, "help_text": "The reply_to address of the email the Confirmation Email should be sent to", "name": "conf_email_reply_to_address", "verbose_name": "conf email reply to address" },
                        { "field_type": 2, "help_text": "The from email username the Confirmation Email should be sent from", "name": "conf_email_from_address_username", "verbose_name": "conf email from address username" },
                        { "field_type": 2, "help_text": "The username portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_username", "verbose_name": "conf email reply to address username" },
                        { "field_type": 2, "help_text": "The domain portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_domain", "verbose_name": "conf email reply to address domain" },
                        {
                            "field_type": 7,
                            "help_text": "User id of the person that created the custom event",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "FK of the last user that edited this custom event.",
                            "name": "last_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "last user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Owner of the data type",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 3, "help_text": "The name of the event", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "Name of the event venue", "name": "venue_name", "verbose_name": "venue name" },
                        { "field_type": 3, "help_text": "The address of the event", "name": "address", "verbose_name": "address" },
                        { "field_type": 3, "help_text": " URL Link to event", "name": "link_to_event", "verbose_name": "link to event" },
                        { "field_type": 21, "help_text": "The date and time of the event", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "If not null, participants of this event will receive a confirmation email after RSVP'ingsent to their email addresses",
                            "name": "email_template",
                            "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                            "verbose_name": "email template"
                        },
                        { "field_type": 21, "help_text": "The end date and time of the event", "name": "end_time", "verbose_name": "end time" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "Timezones" },
                            "field_type": 4,
                            "help_text": "The Timezone that the custom event's time should be displayed in",
                            "name": "timezone",
                            "verbose_name": "timezone"
                        },
                        { "field_type": 3, "help_text": "Description of the event to display exclusively to internal users", "name": "internal_description", "verbose_name": "internal description" },
                        { "field_type": 3, "help_text": "Description of the event to display on the event registration page", "name": "publicly_available_description", "verbose_name": "publicly available description" },
                        { "field_type": 3, "help_text": "Summary of the event to display on the events list page", "name": "public_summary", "verbose_name": "public summary" },
                        { "field_type": 2, "help_text": "The vanity slug provided for an event page. Will appear as /event/[slug]/", "name": "vanity_url_slug", "verbose_name": "vanity url slug" },
                        {
                            "field_type": 7,
                            "help_text": "The organization design used for this event",
                            "name": "organization_design",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                            "verbose_name": "organization design"
                        },
                        { "field_type": 3, "help_text": "Image url to be used in the header of the registration page", "name": "custom_header_image", "verbose_name": "custom header image" },
                        {
                            "field_type": 7,
                            "help_text": "The organization sponsoring the event",
                            "name": "sponsor_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "sponsor organization"
                        },
                        { "field_type": 1, "help_text": "If the external page should display the event details section", "name": "should_display_event_details", "verbose_name": "should display event details" },
                        { "field_type": 1, "help_text": "If the RSVP form should include a Maybe option", "name": "should_allow_maybe_option", "verbose_name": "should allow maybe option" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd Yes for an event", "name": "thank_you_page_text", "verbose_name": "thank you page text" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd No for an event", "name": "thank_you_page_text_no", "verbose_name": "thank you page text no" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd Maybe for an event", "name": "thank_you_page_text_maybe", "verbose_name": "thank you page text maybe" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "EventProcessingStatus" },
                            "field_type": 4,
                            "help_text": "Whether the Event\u2019s participants have been processed or need to be processed",
                            "name": "event_participant_processing_status",
                            "verbose_name": "event participant processing status"
                        },
                        { "field_type": 4, "help_text": "total count of the staffer participants associated with this event", "name": "staffer_total_count", "verbose_name": "staffer total count" },
                        { "field_type": 4, "help_text": "total count of the official participants associated with this event", "name": "official_total_count", "verbose_name": "official total count" },
                        { "field_type": 4, "help_text": "total count of the contact participants associated with this event", "name": "contact_total_count", "verbose_name": "contact total count" },
                        { "field_type": 4, "help_text": "total count of the press participants associated with this event", "name": "press_total_count", "verbose_name": "press total count" },
                        { "field_type": 4, "help_text": "total count of the team member participants associated with this event", "name": "team_member_total_count", "verbose_name": "team member total count" },
                        { "field_type": 4, "help_text": "total count of the staffer participants invited to this event", "name": "staffer_has_been_invited", "verbose_name": "staffer has been invited" },
                        { "field_type": 4, "help_text": "total count of the official participants invited to this event", "name": "official_has_been_invited", "verbose_name": "official has been invited" },
                        { "field_type": 4, "help_text": "total count of the contact participants invited to this event", "name": "contact_has_been_invited", "verbose_name": "contact has been invited" },
                        { "field_type": 4, "help_text": "total count of the press participants invited to this event", "name": "press_has_been_invited", "verbose_name": "press has been invited" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that attended this event", "name": "staffer_has_attended", "verbose_name": "staffer has attended" },
                        { "field_type": 4, "help_text": "total count of the official participants that attended this event", "name": "official_has_attended", "verbose_name": "official has attended" },
                        { "field_type": 4, "help_text": "total count of the contact participants that attended this event", "name": "contact_has_attended", "verbose_name": "contact has attended" },
                        { "field_type": 4, "help_text": "total count of the press participants that attended this event", "name": "press_has_attended", "verbose_name": "press has attended" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that attended rsvp'd yes", "name": "staffer_rsvped_yes", "verbose_name": "staffer rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd yes", "name": "official_rsvped_yes", "verbose_name": "official rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd yes", "name": "contact_rsvped_yes", "verbose_name": "contact rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the press participants that attended rsvp'd yes", "name": "press_rsvped_yes", "verbose_name": "press rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that rsvp'd no", "name": "staffer_rsvped_no", "verbose_name": "staffer rsvped no" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd no", "name": "official_rsvped_no", "verbose_name": "official rsvped no" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd no", "name": "contact_rsvped_no", "verbose_name": "contact rsvped no" },
                        { "field_type": 4, "help_text": "total count of the press participants that rsvp'd no", "name": "press_rsvped_no", "verbose_name": "press rsvped no" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that rsvp'd maybe", "name": "staffer_rsvped_maybe", "verbose_name": "staffer rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd maybe", "name": "official_rsvped_maybe", "verbose_name": "official rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd maybe", "name": "contact_rsvped_maybe", "verbose_name": "contact rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the press participants that rsvp'd maybe", "name": "press_rsvped_maybe", "verbose_name": "press rsvped maybe" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "StafferRsvpPermissionType" },
                            "field_type": 4,
                            "help_text": "Determines who the staffer should be allowed to RSVP for: themself, their member, or both",
                            "name": "staffer_rsvp_permission_type",
                            "verbose_name": "staffer rsvp permission type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The registration page desired for this custom event",
                            "name": "registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page"
                        },
                        { "field_type": 1, "help_text": "If any contact can register for the event. If false, event is hidden from the event list", "name": "publicly_accessible", "verbose_name": "publicly accessible" },
                        { "field_type": 1, "help_text": "For publicly accessible events, determine if event should be shown in event list", "name": "should_show_in_event_list", "verbose_name": "should show in event list" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "CustomEventPageLayout" },
                            "field_type": 4,
                            "help_text": "The layout of the Event RSVP page in Grassroots",
                            "name": "page_layout_type",
                            "verbose_name": "page layout type"
                        },
                        { "field_type": null, "help_text": "After RSVP-ing for an open event, these social media buttons will be displayed to share the event", "name": "social_media_share_platforms", "verbose_name": "social media share platforms" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The project for which the CustomEvent was made",
                            "name": "projects",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "projects"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this CustomEvent that participants should fill out when registering",
                            "name": "custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "custom fields"
                        }
                    ]
                },
                "CustomEventParticipant": {
                    "__is_model": true,
                    "__name__": "CustomEventParticipant",
                    "data_model": "app.custom_event.models.CustomEventParticipant",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/customeventparticipant/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        {
                            "field_type": 7,
                            "help_text": "The organization whose event this participant is attending.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "An official, staffer, or press contact corresponding to this event participant",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The event the participant is meant to attend",
                            "name": "event",
                            "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                            "verbose_name": "event"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "The data type of this event participant",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "RSVPStatus" },
                            "field_type": 4,
                            "help_text": "The participant\u2019s rsvp response",
                            "name": "rsvp_status",
                            "verbose_name": "rsvp status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "AttendeeStatus" },
                            "field_type": 4,
                            "help_text": "Whether the participant attended or did not attend",
                            "name": "attendee_status",
                            "verbose_name": "attendee status"
                        },
                        { "field_type": 1, "help_text": "For staffer participants (not including committee staff), we need to store whether or not the member they work for will attend as well.", "name": "boss_will_attend", "verbose_name": "boss will attend" },
                        { "field_type": 1, "help_text": "Whether or not this person has been emailed", "name": "has_been_invited", "verbose_name": "has been invited" },
                        {
                            "field_type": 7,
                            "help_text": "A team member corresponding to this event participant",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        }
                    ]
                },
                "CustomEventSafedSearch": {
                    "__is_model": true,
                    "__name__": "CustomEventSafedSearch",
                    "data_model": "app.custom_event.models.CustomEventSafedSearch",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/customeventsafedsearch/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The historical SafedSearch used to create CustomEventParticipants",
                            "name": "safed_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "safed search"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The event associated with this SafedSearch",
                            "name": "event",
                            "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                            "verbose_name": "event"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "The data type of this SafedSearch associated with a CustomEvent",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        { "field_type": 1, "help_text": "Whether or not this CustomEventSafedSearch has been evaluated for participants", "name": "processed", "verbose_name": "processed" }
                    ]
                },
                "GrassrootsCustomEvent": {
                    "__is_model": true,
                    "__name__": "GrassrootsCustomEvent",
                    "data_model": "app.custom_event.models.GrassrootsCustomEvent",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/grassrootscustomevent/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        { "field_type": 2, "help_text": "The subject of the confirmation email set by the user", "name": "conf_email_subject", "verbose_name": "conf email subject" },
                        { "field_type": 2, "help_text": "The from email address the Confirmation Email should be sent from", "name": "conf_email_from_address", "verbose_name": "conf email from address" },
                        { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to DEFAULT_CONFIRMATION_SEND_FROM_EMAIL", "name": "conf_email_from_name", "verbose_name": "conf email from name" },
                        { "field_type": 2, "help_text": "The name that should appear when replying to a confirmation email", "name": "conf_email_reply_to_name", "verbose_name": "conf email reply to name" },
                        { "field_type": 2, "help_text": "The reply_to address of the email the Confirmation Email should be sent to", "name": "conf_email_reply_to_address", "verbose_name": "conf email reply to address" },
                        { "field_type": 2, "help_text": "The from email username the Confirmation Email should be sent from", "name": "conf_email_from_address_username", "verbose_name": "conf email from address username" },
                        { "field_type": 2, "help_text": "The username portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_username", "verbose_name": "conf email reply to address username" },
                        { "field_type": 2, "help_text": "The domain portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_domain", "verbose_name": "conf email reply to address domain" },
                        {
                            "field_type": 7,
                            "help_text": "User id of the person that created the custom event",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "FK of the last user that edited this custom event.",
                            "name": "last_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "last user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Owner of the data type",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 3, "help_text": "The name of the event", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "Name of the event venue", "name": "venue_name", "verbose_name": "venue name" },
                        { "field_type": 3, "help_text": "The address of the event", "name": "address", "verbose_name": "address" },
                        { "field_type": 3, "help_text": " URL Link to event", "name": "link_to_event", "verbose_name": "link to event" },
                        { "field_type": 21, "help_text": "The date and time of the event", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "If not null, participants of this event will receive a confirmation email after RSVP'ingsent to their email addresses",
                            "name": "email_template",
                            "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                            "verbose_name": "email template"
                        },
                        { "field_type": 21, "help_text": "The end date and time of the event", "name": "end_time", "verbose_name": "end time" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "Timezones" },
                            "field_type": 4,
                            "help_text": "The Timezone that the custom event's time should be displayed in",
                            "name": "timezone",
                            "verbose_name": "timezone"
                        },
                        { "field_type": 3, "help_text": "Description of the event to display exclusively to internal users", "name": "internal_description", "verbose_name": "internal description" },
                        { "field_type": 3, "help_text": "Description of the event to display on the event registration page", "name": "publicly_available_description", "verbose_name": "publicly available description" },
                        { "field_type": 3, "help_text": "Summary of the event to display on the events list page", "name": "public_summary", "verbose_name": "public summary" },
                        { "field_type": 2, "help_text": "The vanity slug provided for an event page. Will appear as /event/[slug]/", "name": "vanity_url_slug", "verbose_name": "vanity url slug" },
                        {
                            "field_type": 7,
                            "help_text": "The organization design used for this event",
                            "name": "organization_design",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                            "verbose_name": "organization design"
                        },
                        { "field_type": 3, "help_text": "Image url to be used in the header of the registration page", "name": "custom_header_image", "verbose_name": "custom header image" },
                        {
                            "field_type": 7,
                            "help_text": "The organization sponsoring the event",
                            "name": "sponsor_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "sponsor organization"
                        },
                        { "field_type": 1, "help_text": "If the external page should display the event details section", "name": "should_display_event_details", "verbose_name": "should display event details" },
                        { "field_type": 1, "help_text": "If the RSVP form should include a Maybe option", "name": "should_allow_maybe_option", "verbose_name": "should allow maybe option" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd Yes for an event", "name": "thank_you_page_text", "verbose_name": "thank you page text" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd No for an event", "name": "thank_you_page_text_no", "verbose_name": "thank you page text no" },
                        { "field_type": 3, "help_text": "The text to display to a user after they have RSVP'd Maybe for an event", "name": "thank_you_page_text_maybe", "verbose_name": "thank you page text maybe" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "EventProcessingStatus" },
                            "field_type": 4,
                            "help_text": "Whether the Event\u2019s participants have been processed or need to be processed",
                            "name": "event_participant_processing_status",
                            "verbose_name": "event participant processing status"
                        },
                        { "field_type": 4, "help_text": "total count of the staffer participants associated with this event", "name": "staffer_total_count", "verbose_name": "staffer total count" },
                        { "field_type": 4, "help_text": "total count of the official participants associated with this event", "name": "official_total_count", "verbose_name": "official total count" },
                        { "field_type": 4, "help_text": "total count of the contact participants associated with this event", "name": "contact_total_count", "verbose_name": "contact total count" },
                        { "field_type": 4, "help_text": "total count of the press participants associated with this event", "name": "press_total_count", "verbose_name": "press total count" },
                        { "field_type": 4, "help_text": "total count of the team member participants associated with this event", "name": "team_member_total_count", "verbose_name": "team member total count" },
                        { "field_type": 4, "help_text": "total count of the staffer participants invited to this event", "name": "staffer_has_been_invited", "verbose_name": "staffer has been invited" },
                        { "field_type": 4, "help_text": "total count of the official participants invited to this event", "name": "official_has_been_invited", "verbose_name": "official has been invited" },
                        { "field_type": 4, "help_text": "total count of the contact participants invited to this event", "name": "contact_has_been_invited", "verbose_name": "contact has been invited" },
                        { "field_type": 4, "help_text": "total count of the press participants invited to this event", "name": "press_has_been_invited", "verbose_name": "press has been invited" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that attended this event", "name": "staffer_has_attended", "verbose_name": "staffer has attended" },
                        { "field_type": 4, "help_text": "total count of the official participants that attended this event", "name": "official_has_attended", "verbose_name": "official has attended" },
                        { "field_type": 4, "help_text": "total count of the contact participants that attended this event", "name": "contact_has_attended", "verbose_name": "contact has attended" },
                        { "field_type": 4, "help_text": "total count of the press participants that attended this event", "name": "press_has_attended", "verbose_name": "press has attended" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that attended rsvp'd yes", "name": "staffer_rsvped_yes", "verbose_name": "staffer rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd yes", "name": "official_rsvped_yes", "verbose_name": "official rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd yes", "name": "contact_rsvped_yes", "verbose_name": "contact rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the press participants that attended rsvp'd yes", "name": "press_rsvped_yes", "verbose_name": "press rsvped yes" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that rsvp'd no", "name": "staffer_rsvped_no", "verbose_name": "staffer rsvped no" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd no", "name": "official_rsvped_no", "verbose_name": "official rsvped no" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd no", "name": "contact_rsvped_no", "verbose_name": "contact rsvped no" },
                        { "field_type": 4, "help_text": "total count of the press participants that rsvp'd no", "name": "press_rsvped_no", "verbose_name": "press rsvped no" },
                        { "field_type": 4, "help_text": "total count of the staffer participants that rsvp'd maybe", "name": "staffer_rsvped_maybe", "verbose_name": "staffer rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the official participants that rsvp'd maybe", "name": "official_rsvped_maybe", "verbose_name": "official rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the contact participants that rsvp'd maybe", "name": "contact_rsvped_maybe", "verbose_name": "contact rsvped maybe" },
                        { "field_type": 4, "help_text": "total count of the press participants that rsvp'd maybe", "name": "press_rsvped_maybe", "verbose_name": "press rsvped maybe" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "StafferRsvpPermissionType" },
                            "field_type": 4,
                            "help_text": "Determines who the staffer should be allowed to RSVP for: themself, their member, or both",
                            "name": "staffer_rsvp_permission_type",
                            "verbose_name": "staffer rsvp permission type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The registration page desired for this custom event",
                            "name": "registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page"
                        },
                        { "field_type": 1, "help_text": "If any contact can register for the event. If false, event is hidden from the event list", "name": "publicly_accessible", "verbose_name": "publicly accessible" },
                        { "field_type": 1, "help_text": "For publicly accessible events, determine if event should be shown in event list", "name": "should_show_in_event_list", "verbose_name": "should show in event list" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_event.types", "__name__": "CustomEventPageLayout" },
                            "field_type": 4,
                            "help_text": "The layout of the Event RSVP page in Grassroots",
                            "name": "page_layout_type",
                            "verbose_name": "page layout type"
                        },
                        { "field_type": null, "help_text": "After RSVP-ing for an open event, these social media buttons will be displayed to share the event", "name": "social_media_share_platforms", "verbose_name": "social media share platforms" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The project for which the CustomEvent was made",
                            "name": "projects",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "projects"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this CustomEvent that participants should fill out when registering",
                            "name": "custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "custom fields"
                        }
                    ],
                    "proxy_endpoint": "/api/customevent/"
                }
            },
            "types": {
                "AttendeeStatus": {
                    "__is_enum": true,
                    "attended": { "key": "attended", "label": "Attended", "value": 1 },
                    "did_not_attend": { "key": "did_not_attend", "label": "Did Not Attend", "value": 2 }
                },
                "CustomEventPageLayout": {
                    "__is_enum": true,
                    "two_columns": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/double-active.svg", "column_width": 6, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/double.svg", "key": "two_columns", "label": "Two Columns", "should_use_icon_path": true, "tip": "Content is split into two columns. Best for events with images, videos, or long descriptions.", "value": 1 },
                    "two_rows": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/double-vertical-active.svg", "column_width": 12, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/double-vertical.svg", "key": "two_rows", "label": "Two Rows", "should_use_icon_path": true, "tip": "Content is split into two rows. Best for events with short descriptions.", "value": 2 }
                },
                "EventProcessingStatus": {
                    "__is_enum": true,
                    "created": { "help_text": "the event has been created", "key": "created", "label": "created", "value": 1 },
                    "processed": { "help_text": "the event participants have been processed", "key": "processed", "label": "processed", "value": 3 },
                    "should_process": { "help_text": "the event participants should be processed", "key": "should_process", "label": "should_process", "value": 2 }
                },
                "RSVPStatus": {
                    "__is_enum": true,
                    "maybe": { "custom_event_field": "thank_you_page_text_maybe", "key": "maybe", "label": "Maybe", "order": 2, "show_on_rsvp_form": true, "value": 3 },
                    "no": { "custom_event_field": "thank_you_page_text_no", "key": "no", "label": "No", "order": 3, "show_on_rsvp_form": true, "value": 2 },
                    "unknown": { "key": "unknown", "label": "Not Yet Responded", "order": 4, "show_on_rsvp_form": false, "value": 4 },
                    "yes": { "custom_event_field": "thank_you_page_text", "key": "yes", "label": "Yes", "order": 1, "show_on_rsvp_form": true, "value": 1 }
                },
                "StafferRsvpPermissionType": {
                    "__is_enum": true,
                    "both": { "help_text": "Can RSVP for themself and/or their Member of Congress", "key": "both", "label": "Both Themselves and Their Boss", "value": 3 },
                    "member": { "help_text": "Can only RSVP for their Member of Congress", "key": "member", "label": "Their Boss", "value": 2 },
                    "staffer": { "help_text": "Can only RSVP for themselves", "key": "staffer", "label": "Themselves", "value": 1 }
                }
            }
        },
        "custom_field": {
            "models": {
                "CustomFieldGroup": {
                    "__is_model": true,
                    "__name__": "CustomFieldGroup",
                    "data_model": "app.custom_field.models.CustomFieldGroup",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/customfieldgroup/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "Name of custom field group", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Custom Field groups are organized by the Data Type they represent, such as Bill, Supporter, PublicOrganization, etc.",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "User who owns this Custom Field Group",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" }
                    ]
                }
            }
        },
        "deduplication": {
            "models": {
                "PotentialDuplicate": {
                    "__is_model": true,
                    "__name__": "PotentialDuplicate",
                    "data_model": "app.deduplication.models.PotentialDuplicate",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/potentialduplicate/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 4, "help_text": "the object id of the object into which another object would be merged", "name": "merge_into_id", "verbose_name": "merge into id" },
                        { "field_type": 4, "help_text": "the object id of the object to merge into another object and subsequently archive", "name": "merge_from_id", "verbose_name": "merge from id" },
                        { "field_type": 2, "help_text": "Name of object that may be merged from", "name": "merge_from_name", "verbose_name": "Merge From Name" },
                        { "field_type": 2, "help_text": "Name of object that may be merged into", "name": "merge_into_name", "verbose_name": "Merge Into Name" },
                        {
                            "field_type": 7,
                            "help_text": "the organization to which the potential duplicates belong",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "the QuorumDataType of the objects to potentially be merged together",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        { "field_type": null, "help_text": "The fields that were parsed on and are the same between objects", "name": "overlapping_fields", "verbose_name": "overlapping fields" }
                    ]
                }
            },
            "types": {
                "DuplicatedFieldTypes": {
                    "__is_enum": true,
                    "address": {
                        "display_key": "address",
                        "field": "address",
                        "key": "address",
                        "label": "9",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 9
                    },
                    "birthdate": {
                        "display_key": "birth date",
                        "field": "birthdate",
                        "key": "birthdate",
                        "label": "4",
                        "string_field": false,
                        "valid_data_types": [12],
                        "value": 4
                    },
                    "email": {
                        "display_key": "email address",
                        "field": "email",
                        "key": "email",
                        "label": "10",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 10
                    },
                    "employer": {
                        "display_key": "employer",
                        "field": "employer",
                        "key": "employer",
                        "label": "7",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 7
                    },
                    "firstname": {
                        "display_key": "first name",
                        "field": "firstname",
                        "key": "firstname",
                        "label": "1",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 1
                    },
                    "lastname": {
                        "display_key": "last name",
                        "field": "lastname",
                        "key": "lastname",
                        "label": "2",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 2
                    },
                    "middlename": {
                        "display_key": "middle name",
                        "field": "middlename",
                        "key": "middlename",
                        "label": "3",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 3
                    },
                    "organization": {
                        "display_key": "organization",
                        "field": "organization",
                        "key": "organization",
                        "label": "6",
                        "string_field": false,
                        "valid_data_types": [12],
                        "value": 6
                    },
                    "phone_number": {
                        "display_key": "phone number",
                        "field": "phone_number",
                        "key": "phone_number",
                        "label": "5",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 5
                    },
                    "postal_code": {
                        "display_key": "postal code",
                        "field": "postal_code",
                        "key": "postal_code",
                        "label": "16",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 16
                    },
                    "public_organization": {
                        "display_key": "organization",
                        "field": "public_organization",
                        "key": "public_organization",
                        "label": "12",
                        "string_field": false,
                        "valid_data_types": [12],
                        "value": 12
                    },
                    "secondary_phone": {
                        "display_key": "mobile number",
                        "field": "secondary_phone",
                        "key": "secondary_phone",
                        "label": "11",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 11
                    },
                    "state": {
                        "display_key": "state",
                        "field": "state",
                        "key": "state",
                        "label": "13",
                        "string_field": false,
                        "valid_data_types": [12],
                        "value": 13
                    },
                    "street_address": {
                        "display_key": "street address",
                        "field": "street_address",
                        "key": "street_address",
                        "label": "15",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 15
                    },
                    "unique_identifier": {
                        "display_key": "unique identifier",
                        "field": "unique_identifier",
                        "key": "unique_identifier",
                        "label": "14",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 14
                    },
                    "website": {
                        "display_key": "website",
                        "field": "website",
                        "key": "website",
                        "label": "8",
                        "string_field": true,
                        "valid_data_types": [12],
                        "value": 8
                    }
                }
            }
        },
        "document": {
            "models": {
                "CommitteeTranscript": {
                    "__is_model": true,
                    "__name__": "CommitteeTranscript",
                    "data_model": "app.document.models.CommitteeTranscript",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/committeetranscript/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "Document": {
                    "__is_model": true,
                    "__name__": "Document",
                    "data_model": "app.document.models.Document",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/document/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "DocumentSection": {
                    "__is_model": true,
                    "__name__": "DocumentSection",
                    "data_model": "app.document.models.DocumentSection",
                    "default_exclude_filters": {},
                    "default_filters": { "root": false },
                    "endpoint": "/api/documentsection/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "source witness"
                        },
                        { "field_type": 2, "help_text": "", "name": "source_person_str", "verbose_name": "source person str" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "speaker_image_url", "verbose_name": "speaker image url" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CspanChannelType" },
                            "field_type": 4,
                            "help_text": "The CSPAN channel (1, 2, or 3)",
                            "name": "cspan_channel",
                            "verbose_name": "cspan channel"
                        },
                        { "field_type": 2, "help_text": "The CSPAN station id, which we get in the XML from TVEyes", "name": "cspan_station_id", "verbose_name": "cspan station id" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 16, "help_text": "", "name": "created_date_time", "verbose_name": "created date time" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 1, "help_text": "", "name": "root", "verbose_name": "root" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "parent",
                            "related_model": { "__module__": "app.document.models", "__name__": "DocumentSection" },
                            "verbose_name": "parent"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "document",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "document"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "section_type",
                            "verbose_name": "section type"
                        },
                        { "field_type": 4, "help_text": "order inside document", "name": "order", "verbose_name": "order" },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        { "field_type": 3, "help_text": "", "name": "cleaned_text", "verbose_name": "cleaned text" },
                        { "field_type": 4, "help_text": "Total number of words in cleaned text", "name": "cleaned_text_length", "verbose_name": "cleaned text length" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" }
                    ]
                },
                "DocumentSourceType": {
                    "__is_enum": true,
                    "axios": {
                        "data_type": 42,
                        "fa5_icon": "file-audio",
                        "fa5_icon_family": "far",
                        "key": "axios",
                        "label": "Axios",
                        "permission_enum": [1013],
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 12
                    },
                    "cbo": {
                        "data_type": 23,
                        "fa5_icon": "university",
                        "fa5_icon_family": "far",
                        "key": "cbo",
                        "label": "CBO",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "value": 4
                    },
                    "committee": {
                        "corresponding_filters": {
                            "source_committee_filter": {
                                "addedIds": [],
                                "deletedIds": [],
                                "querysetList": [
                                    {
                                        "committee_type__in": [1, 3, 2, 7, 8, 9],
                                        "obsolete": false
                                    }
                                ]
                            }
                        },
                        "data_type": 15,
                        "fa5_icon": "gavel",
                        "fa5_icon_family": "fal",
                        "key": "committee",
                        "label": "Committee",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "contact": {
                        "data_type": 12,
                        "fa5_icon": "child",
                        "fa5_icon_family": "fal",
                        "key": "contact",
                        "label": "Contact",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 7
                    },
                    "custom_contact": {
                        "corresponding_filters": {
                            "associated_with_supporter": {
                                "addedIds": [],
                                "deletedIds": [],
                                "querysetList": [
                                    { "archived": false }
                                ]
                            }
                        },
                        "data_type": 12,
                        "fa5_icon": "child",
                        "fa5_icon_family": "fal",
                        "key": "custom_contact",
                        "label": "Contact",
                        "permission_enum": [207],
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 9
                    },
                    "executive": {
                        "corresponding_filters": {
                            "source_members": {
                                "addedIds": [],
                                "deletedIds": [],
                                "querysetList": [
                                    { "most_recent_person_type": 3, "show_in_quicksearch": true }
                                ]
                            }
                        },
                        "data_type": 1,
                        "fa5_icon": "podium",
                        "fa5_icon_family": "far",
                        "key": "executive",
                        "label": "Executive",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 6
                    },
                    "gao": {
                        "data_type": 21,
                        "fa5_icon": "university",
                        "fa5_icon_family": "far",
                        "key": "gao",
                        "label": "GAO",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "value": 3
                    },
                    "legislator": {
                        "corresponding_filters": {
                            "source_members": {
                                "addedIds": [],
                                "deletedIds": [],
                                "querysetList": [
                                    { "most_recent_person_type": 1, "show_in_quicksearch": true }
                                ]
                            }
                        },
                        "data_type": 1,
                        "fa5_icon": "podium",
                        "fa5_icon_family": "far",
                        "key": "legislator",
                        "label": "Legislator",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 1
                    },
                    "non_member": {
                        "data_type": 1,
                        "fa5_icon": "file-audio",
                        "fa5_icon_family": "far",
                        "key": "non_member",
                        "label": "Other",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 100
                    },
                    "outlet": {
                        "data_type": 121,
                        "fa5_icon": "building",
                        "fa5_icon_family": "far",
                        "key": "outlet",
                        "label": "Outlet",
                        "permission_enum": [105],
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 11
                    },
                    "press_contact": {
                        "corresponding_filters": {
                            "source_members": {
                                "addedIds": [],
                                "deletedIds": [],
                                "querysetList": [
                                    { "most_recent_person_type": 9, "show_in_quicksearch": true }
                                ]
                            }
                        },
                        "data_type": 120,
                        "fa5_icon": "microphone",
                        "fa5_icon_family": "fas",
                        "key": "press_contact",
                        "label": "Press",
                        "permission_enum": [105],
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 10
                    },
                    "public_organization": {
                        "data_type": 42,
                        "fa5_icon": "building",
                        "fa5_icon_family": "far",
                        "key": "public_organization",
                        "label": "Organization",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 5
                    },
                    "staffer": {
                        "data_type": 8,
                        "fa5_icon": "address-card",
                        "fa5_icon_family": "far",
                        "key": "staffer",
                        "label": "Staffer",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 8
                    }
                },
                "DocumentType": {
                    "__is_enum": true,
                    "alcohol_and_cannabis_board_agendas": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "alcohol_and_cannabis_board_agendas",
                        "label": "Alcohol and Cannabis Board Agendas",
                        "placeholder": "Alcohol and Cannabis Board Agendas",
                        "proxy": "AlcoholAndCannabisBoardAgendas",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1023
                    },
                    "alcohol_and_cannabis_board_minutes": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "alcohol_and_cannabis_board_minutes",
                        "label": "Alcohol and Cannabis Board Minutes",
                        "placeholder": "Alcohol and Cannabis Board Minutes",
                        "proxy": "AlcoholAndCannabisBoardMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1024
                    },
                    "axios_article_free": {
                        "assimilated": true,
                        "feature_flags": ["ff_axios_documents_integration"],
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "axios_article_free",
                        "label": "Axios.com Content",
                        "permission_enum": [1013],
                        "placeholder": "Axios Content",
                        "precedence": 5,
                        "proxy": "AxiosArticle",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Axios.com content available in Quorum through your Axios Pro subscription.",
                        "value": 1153
                    },
                    "axios_article_pro": {
                        "assimilated": true,
                        "feature_flags": ["ff_axios_documents_integration"],
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "axios_article_pro",
                        "label": "Axios Pro Content",
                        "permission_enum": [1013],
                        "placeholder": "Axios Pro Content",
                        "precedence": 5,
                        "proxy": "AxiosArticle",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Exclusive stories through your Axios Pro subscription.",
                        "value": 1152
                    },
                    "brazil_amendment": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "brazil_amendment",
                        "label": "Amendment",
                        "placeholder": "Amendments",
                        "proxy": "BrazilAmendment",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 1141
                    },
                    "brazil_legislative_supporting_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "brazil_legislative_supporting_document",
                        "label": "Legislative Supporting Document",
                        "placeholder": "Legislative Supporting Documents",
                        "proxy": "BrazilLegislativeSupportingDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 1140
                    },
                    "cbo_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "cbo_report",
                        "label": "CBO Report",
                        "placeholder": "CBO reports",
                        "proxy": "CBOReport",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 23
                    },
                    "commission_communication": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "commission_communication",
                        "label": "Communication",
                        "placeholder": "Commission Communications",
                        "proxy": "CommissionCommunication",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1007
                    },
                    "commission_consultation_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "commission_consultation_document",
                        "label": "Consultation Document",
                        "placeholder": "Commission Consultation Documents",
                        "proxy": "CommissionConsultationDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1006
                    },
                    "commission_staff_working_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "commission_staff_working_document",
                        "label": "Staff Working Document",
                        "placeholder": "Commission Staff Working Documents",
                        "proxy": "CommissionStaffWorkingDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1005
                    },
                    "committee_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "committee_document",
                        "label": "Committee Document",
                        "placeholder": "committee documents",
                        "proxy": "CommitteeDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Written testimony from hearing witnesses as submitted for the record and other documents committees release to the public.",
                        "value": 17
                    },
                    "committee_opinion": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "committee_opinion",
                        "label": "Committee Opinion",
                        "placeholder": "committee opinions",
                        "proxy": "CommitteeOpinion",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 55
                    },
                    "committee_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "committee_report",
                        "label": "Committee Report",
                        "placeholder": "committee reports",
                        "proxy": "CommitteeReport",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 106],
                        "value": 34
                    },
                    "committee_transcript": {
                        "assimilated": true,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "committee_transcript",
                        "label": "Statements in Committee Hearings",
                        "placeholder": "Statements in Committee Hearings",
                        "proxy": "CommitteeTranscript",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Transcript statements made in committee meetings",
                        "value": 45
                    },
                    "constituent_email": {
                        "assimilated": false,
                        "icon": "fa-inbox",
                        "is_html": true,
                        "key": "constituent_email",
                        "label": "Newsletters to Constituents",
                        "placeholder": "newsletters to constituents",
                        "proxy": "ConstituentEmail",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "tip": "E-newsletters officials send to their constituent mailing lists.",
                        "value": 24
                    },
                    "council_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "council_agenda",
                        "label": "Council Meetings",
                        "placeholder": "Council Meetings",
                        "proxy": "CouncilAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1020
                    },
                    "council_committee_meeting_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "council_committee_meeting_agenda",
                        "label": "Council Committee Meeting Agenda",
                        "permission_enum": [212],
                        "placeholder": "Council Committee Meeting Agendas",
                        "proxy": "CouncilCommitteeMeetingAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Agenda for city or county council committee meetings.",
                        "value": 1016
                    },
                    "council_committee_meeting_minutes": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "council_committee_meeting_minutes",
                        "label": "Council Committee Meeting Minutes",
                        "permission_enum": [212],
                        "placeholder": "Council Committee Meeting Minutes",
                        "proxy": "CouncilCommitteeMeetingMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Written records of city or county council committee meetings.",
                        "value": 1017
                    },
                    "council_conclusion": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "council_conclusion",
                        "label": "Conclusion",
                        "placeholder": "Council Conclusions",
                        "proxy": "CouncilConclusion",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1011
                    },
                    "council_general_approach": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "council_general_approach",
                        "label": "General Approach",
                        "placeholder": "Council General Approaches",
                        "proxy": "CouncilGeneralApproach",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1009
                    },
                    "council_voting_result": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "council_voting_result",
                        "label": "Voting Result",
                        "placeholder": "Council Voting Results",
                        "proxy": "CouncilVotingResult",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1008
                    },
                    "crs_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "crs_report",
                        "label": "CRS Report",
                        "placeholder": "CRS reports",
                        "proxy": "CRSReport",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 22
                    },
                    "dc_letter": {
                        "assimilated": true,
                        "icon": "fa-paper-plane-o",
                        "is_html": true,
                        "key": "dc_letter",
                        "label": "House Dear Colleague Letter",
                        "placeholder": "House Dear Colleague letters",
                        "proxy": "DCLetter",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "tip": "House Dear Colleague Letters have not been updated since 4/1/2021 due to changes made by the US House IT/Security team. We are actively working to regain the data feed, and will remove the filter if/when we confirm that the dataset is no longer accessible.",
                        "value": 10
                    },
                    "ep_think_tank_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "ep_think_tank_report",
                        "label": "EPRS Report",
                        "placeholder": "European Parliament Think Tank Report",
                        "proxy": "EPThinkTankReport",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1001
                    },
                    "eu_amendment": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_amendment",
                        "label": "Amendment",
                        "placeholder": "EU Legislation Amendments",
                        "proxy": "EUAmendment",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1003
                    },
                    "eu_committee_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "eu_committee_agenda",
                        "label": "Committee Agenda",
                        "placeholder": "EU Committee Agendas",
                        "proxy": "EUCommitteeAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1012
                    },
                    "eu_initiative_call_for_evidence": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_call_for_evidence",
                        "label": "Call for Evidence",
                        "placeholder": "EU Initiative Call for Evidence Documents",
                        "proxy": "EUInitiativeCallForEvidence",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1100
                    },
                    "eu_initiative_evaluation": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_evaluation",
                        "label": "Evaluation",
                        "placeholder": "EU Initiative Evaluation Documents",
                        "proxy": "EUInitiativeEvaluation",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1102
                    },
                    "eu_initiative_fitness_check": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_fitness_check",
                        "label": "Fitness Check",
                        "placeholder": "EU Initiative Fitness Check Documents",
                        "proxy": "EUInitiativeFitnessCheck",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1103
                    },
                    "eu_initiative_impact_assessment": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_impact_assessment",
                        "label": "Impact Assessment",
                        "placeholder": "EU Initiative Impact Assessment Documents",
                        "proxy": "EUInitiativeImpactAssessment",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1101
                    },
                    "eu_initiative_parliament_own_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_parliament_own_report",
                        "label": "Own-Initiative Report",
                        "placeholder": "EU Initiative Parliament Own Report Documents",
                        "proxy": "EUInitiativeParliamentOwnReport",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1105
                    },
                    "eu_initiative_text_annex": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_initiative_text_annex",
                        "label": "Annex to the Text",
                        "placeholder": "EU Initiative Annex to the Text Documents",
                        "proxy": "EUInitiativeTextAnnex",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1104
                    },
                    "eu_legislation_supporting_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "eu_legislation_supporting_document",
                        "label": "Legislation Supporting Document",
                        "placeholder": "eu legislation supporting document",
                        "proxy": "EULegislationSupportingDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 57
                    },
                    "executive_order": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "executive_order",
                        "label": "Executive Order",
                        "placeholder": "executive orders",
                        "proxy": "ExecutiveOrder",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 64
                    },
                    "facebook_post": {
                        "assimilated": true,
                        "icon": "fa-facebook",
                        "is_html": false,
                        "key": "facebook_post",
                        "label": "Facebook Post",
                        "placeholder": "Facebook posts",
                        "precedence": 2,
                        "proxy": "FacebookPost",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 9
                    },
                    "fact_sheet": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "fact_sheet",
                        "label": "White House Fact Sheet",
                        "placeholder": "White House fact sheets",
                        "proxy": "FactSheet",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 75
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Axios News Articles",
                            "values": [1152, 1153]
                        },
                        {
                            "display": "list",
                            "title": "Statements",
                            "values": [5, 7, 107, 10, 18, 24, 45, 46, 108, 40, 43, 50, 52, 54, 56, 44]
                        },
                        {
                            "display": "list",
                            "title": "Social",
                            "values": [6, 9, 38, 39, 41, 5]
                        },
                        {
                            "display": "list",
                            "title": "Reports",
                            "values": [21, 23, 34, 22, 1034]
                        },
                        {
                            "display": "list",
                            "title": "White House Documents",
                            "values": [64, 67, 71, 73, 74, 65, 75, 1002]
                        },
                        {
                            "display": "list",
                            "title": "Legislative & Regulatory Documents",
                            "values": [27, 17, 101, 25, 103, 102]
                        },
                        {
                            "display": "list",
                            "title": "Parliament",
                            "values": [1012, 1013, 1105, 34, 55, 1001, 1003, 50, 52, 54, 56]
                        },
                        {
                            "display": "list,",
                            "title": "Council",
                            "values": [1008, 1011, 1009, 1010, 1020]
                        },
                        {
                            "display": "list",
                            "title": "European Commission",
                            "values": [1100, 1101, 1102, 1103, 1104, 43]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Supporting Documents",
                            "values": [57]
                        },
                        {
                            "display": "list",
                            "title": "State Regulatory Board Meetings",
                            "values": [1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033]
                        },
                        {
                            "display": "list",
                            "title": "City & County Meetings",
                            "values": [1014, 1015, 1018, 1019]
                        },
                        {
                            "display": "list",
                            "title": "School Board Meetings",
                            "values": [1021, 1022]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Documents",
                            "values": [1121, 1120, 1122]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Documents",
                            "values": [1141, 1140]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Documents",
                            "values": [1151, 1150]
                        }
                    ],
                    "floor_statement": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "floor_statement",
                        "label": "Floor Statement",
                        "placeholder": "floor statements",
                        "proxy": "FloorStatement",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Text transcripts of speeches Members of Congress give on the Senate or House floor as published in the Congressional Record.",
                        "value": 7
                    },
                    "gao_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "gao_report",
                        "label": "GAO Report",
                        "placeholder": "GAO reports",
                        "proxy": "GAOReport",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 21
                    },
                    "instagram_post": {
                        "assimilated": true,
                        "icon": "fa-instagram",
                        "is_html": false,
                        "key": "instagram_post",
                        "label": "Instagram Post",
                        "placeholder": "Instagram posts",
                        "precedence": 4,
                        "proxy": "InstagramPost",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 106],
                        "value": 39
                    },
                    "insurance_bulletin": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "insurance_bulletin",
                        "label": "Insurance Bulletins",
                        "placeholder": "Insurance Bulletins",
                        "proxy": "InsuranceBulletin",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1033
                    },
                    "letter": {
                        "assimilated": false,
                        "icon": "fa-envelope",
                        "is_html": false,
                        "key": "letter",
                        "label": "Letter",
                        "placeholder": "letters",
                        "proxy": "Letter",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Letters Members of Congress send to Members of the Executive branch such as when a group of Senators writes a Department Secretary.",
                        "value": 40
                    },
                    "live_transcript_document": {
                        "assimilated": false,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "live_transcript_document",
                        "label": "Live Transcript Document",
                        "placeholder": "live transcript documents",
                        "proxy": "LiveTranscriptDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Videos and text-searchable transcripts of floor proceedings, committee hearings, and press events on Capitol Hill.",
                        "value": 35
                    },
                    "local_meeting_transcript": {
                        "assimilated": true,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "local_meeting_transcript",
                        "label": "Local Meeting Statement",
                        "placeholder": "Local meeting statements",
                        "proxy": "LocalMeetingTranscript",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Text transcripts of speeches made in hearings in Local Regions",
                        "value": 108
                    },
                    "manual_committee_transcript": {
                        "assimilated": true,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "manual_committee_transcript",
                        "label": "Verified Transcript for Statements in Committee Hearings",
                        "placeholder": "Manual Transcript for Statements in Committee Hearings",
                        "proxy": "ManualCommitteeTranscript",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Manual Transcript statements made in committee meetings",
                        "value": 47
                    },
                    "medical_board_agendas": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "medical_board_agendas",
                        "label": "Medical Board Agendas",
                        "placeholder": "Medical Board Agendas",
                        "proxy": "MedicalBoardAgendas",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1025
                    },
                    "medical_board_minutes": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "medical_board_minutes",
                        "label": "Medical Board Minutes",
                        "placeholder": "Medical Board Minutes",
                        "proxy": "MedicalBoardMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1026
                    },
                    "medium_post": {
                        "assimilated": true,
                        "icon": "fa-medium",
                        "is_html": false,
                        "key": "medium_post",
                        "label": "Medium Post",
                        "placeholder": "Medium posts",
                        "precedence": 3,
                        "proxy": "MediumPost",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 106],
                        "value": 38
                    },
                    "meeting_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "meeting_agenda",
                        "label": "Council Meeting Agenda",
                        "permission_enum": [212],
                        "placeholder": "Council Meeting Agenda",
                        "proxy": "MeetingAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Agenda for city or county council meetings.",
                        "value": 1014
                    },
                    "meeting_minutes": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "meeting_minutes",
                        "label": "Council Meeting Minutes",
                        "permission_enum": [212],
                        "placeholder": "Council Meeting Minutes",
                        "proxy": "MeetingMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Written records of city or county council meetings.",
                        "value": 1015
                    },
                    "memorandum": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "memorandum",
                        "label": "Presidential Memorandum",
                        "placeholder": "presidential memoranda",
                        "proxy": "Memorandum",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 68
                    },
                    "motion_for_resolution": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "motion_for_resolution",
                        "label": "Motion for Resolution",
                        "placeholder": "motions for resolution",
                        "proxy": "MotionForResolution",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 54
                    },
                    "national_parliament_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "national_parliament_document",
                        "label": "National Parliament Document",
                        "placeholder": "National Parliament Documents",
                        "proxy": "NationalParliamentDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1010
                    },
                    "nomination": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "nomination",
                        "label": "Presidential Nomination",
                        "placeholder": "Presidential nominations & appointments",
                        "proxy": "Nomination",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 71
                    },
                    "nursing_board_agendas": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "nursing_board_agendas",
                        "label": "Nursing Board Agendas",
                        "placeholder": "Nursing Board Agendas",
                        "proxy": "NursingBoardAgendas",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1027
                    },
                    "nursing_board_minutes": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "nursing_board_minutes",
                        "label": "Nursing Board Minutes",
                        "placeholder": "Nursing Board Minutes",
                        "proxy": "NursingBoardMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1028
                    },
                    "omb_sap": {
                        "assimilated": true,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "omb_sap",
                        "label": "Statement of Administration Policy",
                        "placeholder": "office of management and budget: statement of administration policy",
                        "proxy": "OMBSAP",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Statements of Administration Policy express the Executive Branch\u2019s official position on legislation.",
                        "value": 1002
                    },
                    "other_local_meeting_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "other_local_meeting_agenda",
                        "label": "Other Local Meeting Agenda",
                        "permission_enum": [212],
                        "placeholder": "Other Local Meeting Agendas",
                        "proxy": "OtherLocalMeetingAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Agenda for city or county legislative meetings.",
                        "value": 1018
                    },
                    "other_local_meeting_minutes": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "other_local_meeting_minutes",
                        "label": "Other Local Meeting Minutes",
                        "permission_enum": [212],
                        "placeholder": "Other Local Meeting Minutes",
                        "proxy": "OtherLocalMeetingMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Written records of city or county legislative meetings.",
                        "value": 1019
                    },
                    "parliamentary_question": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "parliamentary_question",
                        "label": "Parliamentary Question",
                        "placeholder": "parliamentary questions",
                        "proxy": "ParliamentaryQuestion",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 50
                    },
                    "pharmacy_board_agendas": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "pharmacy_board_agendas",
                        "label": "Pharmacy Board Agendas",
                        "placeholder": "Pharmacy Board Agendas",
                        "proxy": "PharmacyBoardAgendas",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1029
                    },
                    "pharmacy_board_minutes": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "pharmacy_board_minutes",
                        "label": "Pharmacy Board Minutes",
                        "placeholder": "Pharmacy Board Minutes",
                        "proxy": "PharmacyBoardMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1030
                    },
                    "plenary_agenda": {
                        "assimilated": false,
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "plenary_agenda",
                        "label": "Plenary Agenda",
                        "placeholder": "Plenary Agendas",
                        "proxy": "PlenaryAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1013
                    },
                    "plenary_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "plenary_report",
                        "label": "Plenary Report",
                        "placeholder": "Plenary Reports",
                        "proxy": "PlenaryReport",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 1004
                    },
                    "presidential_action": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "presidential_action",
                        "label": "Presidential Action",
                        "placeholder": "Presidential Actions from the White House",
                        "proxy": "PresidentialAction",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 73
                    },
                    "press_briefing": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "press_briefing",
                        "label": "White House Press Briefing and Statement",
                        "placeholder": "White House press briefings and statements",
                        "proxy": "PressBriefing",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 65
                    },
                    "press_release": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "press_release",
                        "label": "Press Release",
                        "placeholder": "press releases",
                        "precedence": 6,
                        "proxy": "PressRelease",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 219, 221, 222, 239],
                        "tip": "Official statements that officials, committees, and organizations publish on their websites.",
                        "value": 5
                    },
                    "proclamation": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "proclamation",
                        "label": "White House Proclamation",
                        "placeholder": "White House proclamations",
                        "proxy": "Proclamation",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 67
                    },
                    "proxy_letter": {
                        "assimilated": false,
                        "icon": "fa-paper-plane-o",
                        "is_html": false,
                        "key": "proxy_letter",
                        "label": "House Proxy Letter",
                        "placeholder": "proxy letters",
                        "proxy": "ProxyLetter",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Letters designating, changing, and revoking the authority for remote voting by proxy.",
                        "value": 18
                    },
                    "public_utility_commission_agendas": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "public_utility_commission_agendas",
                        "label": "Public Utility Commission Agendas",
                        "placeholder": "Alcohol and Cannabis Board Minutes",
                        "proxy": "PublicUtilityCommissionAgendas",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1031
                    },
                    "public_utility_commission_minutes": {
                        "assimilated": false,
                        "icon": "fa fa-calendar",
                        "is_html": false,
                        "key": "public_utility_commission_minutes",
                        "label": "Public Utility Commission Minutes",
                        "placeholder": "Public Utility Commission Minutes",
                        "proxy": "PublicUtilityCommissionMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1032
                    },
                    "reg_document": {
                        "assimilated": true,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "reg_document",
                        "label": "Regulatory Document",
                        "placeholder": "Regulatory Documents",
                        "proxy": "RegDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Documents related to regulations including notices, filing forms, hearing minutes, etc.",
                        "value": 101
                    },
                    "school_board_meeting_agenda": {
                        "assimilated": false,
                        "feature_flags": ["ff_school_board_Agendas"],
                        "icon": "fa-calendar-plus-o",
                        "is_html": false,
                        "key": "school_board_meeting_agenda",
                        "label": "School Board Meeting Agenda",
                        "permission_enum": [107],
                        "placeholder": "School Board Meeting Agendas",
                        "proxy": "SchoolBoardMeetingAgenda",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Agenda for School Board legislative meetings.",
                        "value": 1021
                    },
                    "school_board_meeting_minutes": {
                        "assimilated": false,
                        "feature_flags": ["ff_school_board_Agendas"],
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "school_board_meeting_minutes",
                        "label": "School Board Meeting Minutes",
                        "permission_enum": [107],
                        "placeholder": "School Board Meeting Minutes",
                        "proxy": "SchoolBoardMeetingMinutes",
                        "show_in_enumeration": true,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "tip": "Written records of School Board legislative meetings.",
                        "value": 1022
                    },
                    "spain_amendment": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "spain_amendment",
                        "label": "Amendment",
                        "placeholder": "Amendments",
                        "proxy": "SpainAmendment",
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 1151
                    },
                    "spain_legislative_supporting_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "spain_legislative_supporting_document",
                        "label": "Legislative Supporting Document",
                        "placeholder": "Legislative Supporting Documents",
                        "proxy": "SpainLegislativeSupportingDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 1150
                    },
                    "speech": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "speech",
                        "label": "Speech",
                        "placeholder": "speeches",
                        "proxy": "Speech",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 43
                    },
                    "speech_in_plenary": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "speech_in_plenary",
                        "label": "Speech in Plenary",
                        "placeholder": "speeches in plenary",
                        "proxy": "SpeechInPlenary",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 56
                    },
                    "state_bill_supporting_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "state_bill_supporting_document",
                        "label": "State Bill Supporting Document",
                        "placeholder": "state bill supporting documents",
                        "proxy": "StateBillDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Legislative documents related to bills including fiscal notes, amendments, markups, etc.",
                        "value": 27
                    },
                    "state_executive_order": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "state_executive_order",
                        "label": "State Executive Order",
                        "placeholder": "state executive orders",
                        "proxy": "StateExecutiveOrder",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 25
                    },
                    "state_floor_calendar": {
                        "assimilated": true,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "state_floor_calendar",
                        "label": "State Session Floor Calendar",
                        "placeholder": "State Session Floor Calendar",
                        "proxy": "StateFloorCalendar",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "State Session Floor Statement Calendar",
                        "value": 103
                    },
                    "state_floor_journal": {
                        "assimilated": true,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "state_floor_journal",
                        "label": "State Session Journal",
                        "placeholder": "State Session Journal",
                        "proxy": "StateFloorJournal",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "State Session Journal",
                        "value": 102
                    },
                    "state_floor_transcript": {
                        "assimilated": true,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "state_floor_transcript",
                        "label": "State Floor Statement",
                        "placeholder": "State floor statements",
                        "proxy": "StateFloorTranscript",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Text transcripts of speeches Members of Congress give on the Senate or House floor as published in the Congressional Record.",
                        "value": 107
                    },
                    "state_of_the_state": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "state_of_the_state",
                        "label": "State of the State Address",
                        "placeholder": "State of the State Address",
                        "proxy": "Document",
                        "show_in_enumeration": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "State of the State addresses given to state legislatures by their respective governors",
                        "value": 44
                    },
                    "third_party_report": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "third_party_report",
                        "label": "Third Party Report",
                        "placeholder": "Third Party reports",
                        "proxy": "ThirdPartyReport",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 1034
                    },
                    "tweet": {
                        "assimilated": true,
                        "icon": "fa-twitter",
                        "is_html": true,
                        "key": "tweet",
                        "label": "Tweet",
                        "placeholder": "tweets",
                        "precedence": 1,
                        "proxy": "Tweet",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 6
                    },
                    "uk_amendment_paper": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "uk_amendment_paper",
                        "label": "Amendment Paper",
                        "placeholder": "Amendment Papers",
                        "proxy": "UKAmendmentPaper",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 1121
                    },
                    "uk_hansard_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "uk_hansard_document",
                        "label": "Hansard Document",
                        "placeholder": "Hansard Documents",
                        "proxy": "UKHansardDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 1122
                    },
                    "uk_legislative_supporting_document": {
                        "assimilated": false,
                        "icon": "fa-file-text-o",
                        "is_html": false,
                        "key": "uk_legislative_supporting_document",
                        "label": "Legislative Supporting Document",
                        "placeholder": "Legislative Supporting Documents",
                        "proxy": "UKLegislativeSupportingDocument",
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 1120
                    },
                    "us_president_transcript": {
                        "assimilated": true,
                        "icon": "fa-file-video-o",
                        "is_html": false,
                        "key": "us_president_transcript",
                        "label": "Statements from Presidential Appearances",
                        "placeholder": "Statements from Presidential Appearances",
                        "proxy": "PresidentTranscript",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Transcript statements made in presidential appearances",
                        "value": 46
                    },
                    "vote_explanation": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "vote_explanation",
                        "label": "Vote Explanation",
                        "placeholder": "vote explanations",
                        "proxy": "VoteExplanation",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 52
                    },
                    "white_house_speech_remark": {
                        "assimilated": true,
                        "icon": "fa-file-audio-o",
                        "is_html": false,
                        "key": "white_house_speech_remark",
                        "label": "White House Speech or Remarks",
                        "placeholder": "Speeches and Remarks from the White House",
                        "proxy": "SpeechAndRemark",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 74
                    },
                    "written_declaration": {
                        "assimilated": true,
                        "icon": "fa-microphone",
                        "is_html": false,
                        "key": "written_declaration",
                        "label": "Written Declaration",
                        "placeholder": "written declaration",
                        "proxy": "WrittenDeclaration",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 53
                    },
                    "youtube_video": {
                        "assimilated": true,
                        "icon": "fa-youtube-play",
                        "is_html": false,
                        "key": "youtube_video",
                        "label": "YouTube Video",
                        "placeholder": "YouTube videos",
                        "precedence": 5,
                        "proxy": "YouTubeVideo",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 41
                    }
                },
                "EPThinkTankReportSubtype": {
                    "__is_enum": true,
                    "at_a_glance": { "key": "at_a_glance", "label": "At a Glance", "text": "AT_A_GLANCE", "value": 1 },
                    "briefing": { "key": "briefing", "label": "Briefing", "text": "BRIEFING", "value": 2 },
                    "eu_fact_sheet": { "key": "eu_fact_sheet", "label": "EU Fact Sheet", "text": "EU_FACT_SHEET", "value": 5 },
                    "in_depth_analysis": { "key": "in_depth_analysis", "label": "In-Depth Analysis", "text": "IN_DEPTH_ANALYSIS", "value": 3 },
                    "study": { "key": "study", "label": "Study", "text": "STUDY", "value": 4 }
                },
                "LiveTranscriptDocumentSubtype": {
                    "__is_enum": true,
                    "cspan_transcript": { "key": "cspan_transcript", "label": "CSPAN Transcript", "value": 1 }
                },
                "LocalMeetingTranscript": {
                    "__is_model": true,
                    "__name__": "LocalMeetingTranscript",
                    "data_model": "app.document.models.LocalMeetingTranscript",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/localmeetingtranscript/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "ManualCommitteeTranscript": {
                    "__is_model": true,
                    "__name__": "ManualCommitteeTranscript",
                    "data_model": "app.document.models.ManualCommitteeTranscript",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/manualcommitteetranscript/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "NewDocument": {
                    "__is_model": true,
                    "__name__": "NewDocument",
                    "data_model": "app.document.models.NewDocument",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/newdocument/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "PresidentTranscript": {
                    "__is_model": true,
                    "__name__": "PresidentTranscript",
                    "data_model": "app.document.models.PresidentTranscript",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/presidenttranscript/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "RegDocument": {
                    "__is_model": true,
                    "__name__": "RegDocument",
                    "data_model": "app.document.models.RegDocument",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/regdocument/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                },
                "StateFloorTranscript": {
                    "__is_model": true,
                    "__name__": "StateFloorTranscript",
                    "data_model": "app.document.models.StateFloorTranscript",
                    "default_exclude_filters": {},
                    "default_filters": { "date__isnull": false },
                    "endpoint": "/api/statefloortranscript/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_record",
                            "related_model": { "__module__": "app.statements.models", "__name__": "CongressionalRecord" },
                            "verbose_name": "source record"
                        },
                        { "field_type": 4, "help_text": "Which order in the record did this particular statement take place.", "name": "position_in_record", "verbose_name": "position in record" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee_meeting",
                            "related_model": { "__module__": "app.events.models", "__name__": "CommitteeMeeting" },
                            "verbose_name": "committee meeting"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "witness",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness"
                        },
                        { "field_type": 2, "help_text": "unique open states api doc id for each document", "name": "openstates_doc_id", "verbose_name": "openstates doc id" },
                        { "field_type": 3, "help_text": "", "name": "title_wo_bill_slugs", "verbose_name": "title wo bill slugs" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "unique instagram post id for each instagram post", "name": "instagram_post_id", "verbose_name": "instagram post id" },
                        { "field_type": 2, "help_text": "the medium username of the user that created the post", "name": "medium_username", "verbose_name": "medium username" },
                        { "field_type": 2, "help_text": "unique id for each Youtube video", "name": "youtube_video_id", "verbose_name": "youtube video id" },
                        { "field_type": 4, "help_text": "number of views for this video", "name": "view_count", "verbose_name": "view count" },
                        { "field_type": 21, "help_text": "Last YouTube data refresh timestamp; used to schedule periodic updates.", "name": "last_youtube_update", "verbose_name": "last youtube update" },
                        { "field_type": 2, "help_text": "unique post id for each facebook post", "name": "facebook_post_id", "verbose_name": "facebook post id" },
                        { "field_type": 4, "help_text": "", "name": "like_count", "verbose_name": "like count" },
                        { "field_type": 4, "help_text": "", "name": "share_count", "verbose_name": "share count" },
                        { "field_type": 4, "help_text": "", "name": "comment_count", "verbose_name": "comment count" },
                        { "field_type": 2, "help_text": "Twitter's unique identifier for each tweet", "name": "tweet_id", "verbose_name": "tweet id" },
                        { "field_type": null, "help_text": "array of users (by id) mentioned in each status", "name": "twitter_user_mentions", "verbose_name": "twitter user mentions" },
                        { "field_type": 4, "help_text": "", "name": "favorite_count", "verbose_name": "favorite count" },
                        { "field_type": 4, "help_text": "", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 1, "help_text": "", "name": "is_retweet", "verbose_name": "is retweet" },
                        { "field_type": 2, "help_text": "Name of original tweeter (if this is a retweet)", "name": "retweets_user", "verbose_name": "retweets user" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "social_user",
                            "related_model": { "__module__": "app.social.models", "__name__": "SocialUser" },
                            "verbose_name": "social user"
                        },
                        { "field_type": 2, "help_text": "**DEPRECATED DO NOT USE** Unique question ID for each parliamentary question. Ex: E-001779/2017", "name": "question_id", "verbose_name": "question id" },
                        { "field_type": 2, "help_text": "Unique reference ID for EU MEP documents. Ex: RC-B8-0191/2017/rev. 1", "name": "reference_id", "verbose_name": "reference id" },
                        { "field_type": 4, "help_text": "Start time of transcript in a committee meeting (in seconds)", "name": "second_start", "verbose_name": "second start" },
                        { "field_type": 4, "help_text": "End time of transcript in a committee meeting (in seconds)", "name": "second_end", "verbose_name": "second end" },
                        { "field_type": 4, "help_text": "Ordered sequence of transcript, post-smushing. This sequence number is re-calculated after smushing to reflect combined JSON entries", "name": "sequence", "verbose_name": "sequence" },
                        { "field_type": null, "help_text": "Deprecated. Original sequences of transcripts combined into this document. These sequence numbers representthe original sequence assignments from FactSquared API", "name": "original_sequences", "verbose_name": "original sequences" },
                        { "field_type": 3, "help_text": "Name of the speaker. Can be a real name or unidentified", "name": "speaker_name", "verbose_name": "speaker name" },
                        { "field_type": 3, "help_text": "Full name of speaker, if available", "name": "speaker_full_name", "verbose_name": "speaker full name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_type",
                            "verbose_name": "source type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSourceFormat" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "source_format",
                            "verbose_name": "source format"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        { "field_type": 2, "help_text": "The email of the sender. Usually a staffer in the case of DC Letters", "name": "source_email", "verbose_name": "source email" },
                        { "field_type": 17, "help_text": "", "name": "source_file", "verbose_name": "source file" },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_url", "verbose_name": "pdf url" },
                        { "field_type": null, "help_text": "Mapping of language enum value -> pdf_url of the document in that language.", "name": "language_pdf_urls", "verbose_name": "language pdf urls" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old press release)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "", "name": "subtitle", "verbose_name": "subtitle" },
                        { "field_type": 3, "help_text": "The content of this document, as it will be displayed in Quorum.", "name": "content", "verbose_name": "content" },
                        { "field_type": 3, "help_text": "The raw content of this document, stripped of HTML and other entities. Used for searching and highlighting.", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 3, "help_text": "The original version of the document we grab. This could be full web HTML or the json of an entire tweet dict", "name": "original_content", "verbose_name": "original content" },
                        { "field_type": 3, "help_text": "", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 2, "help_text": "", "name": "content_hash", "verbose_name": "content hash" },
                        { "field_type": 4, "help_text": "Number of words in a document", "name": "length", "verbose_name": "length" },
                        { "field_type": 6, "help_text": "Positive/negative sentiment score (-1.0 to +1.0)", "name": "polarity", "verbose_name": "polarity" },
                        { "field_type": 6, "help_text": "Subjectivity score (0.0 to +1.0)", "name": "subjectivity", "verbose_name": "subjectivity" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The language of this document",
                            "name": "language",
                            "verbose_name": "language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The original language of this document (it may have been translated)",
                            "name": "original_language",
                            "verbose_name": "original language"
                        },
                        { "field_type": 5, "help_text": "", "name": "date", "verbose_name": "date" },
                        { "field_type": 21, "help_text": "", "name": "date_time", "verbose_name": "date time" },
                        {
                            "field_type": 7,
                            "help_text": "the legsession object in which the document belongs",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_type",
                            "verbose_name": "document type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of document:\n                FacebookPostType\n                PressReleaseType\n                CommitteeDocumentType\n                etc...\n            ", "name": "document_subtype", "verbose_name": "document subtype" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.models", "__name__": "DocumentSectionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "document_section_type",
                            "verbose_name": "document section type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": null, "help_text": "The list of Regions this document is associated to, e.g. [106, 204]", "name": "regions", "verbose_name": "regions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "event"
                        },
                        { "field_type": null, "help_text": "the json that we got from the API that this came from, i.e. the twitter response json", "name": "source_json", "verbose_name": "source json" },
                        { "field_type": null, "help_text": "media objects in the facebook post", "name": "media_json", "verbose_name": "media json" },
                        { "field_type": null, "help_text": "urls mentioned in a facebook post", "name": "url_json", "verbose_name": "url json" },
                        { "field_type": null, "help_text": "catch all for extra data", "name": "unstructured_data", "verbose_name": "unstructured data" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "Will this tweet be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "witness_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witness mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulation_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "docket_mentions",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this document.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "calais_mentions",
                            "related_model": { "__module__": "app.management.mentions.models", "__name__": "CalaisEntity" },
                            "verbose_name": "calais mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this document is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/document/"
                }
            },
            "types": {
                "Language": {
                    "__is_enum": true,
                    "afrikaans": { "abbrev": "af", "extended_abbrev": "afr", "key": "afrikaans", "label": "Afrikaans", "order": 0, "show_in_enumeration": false, "value": 49 },
                    "albanian": { "abbrev": "sq", "extended_abbrev": "alb", "key": "albanian", "label": "Albanian", "order": 0, "show_in_enumeration": false, "value": 51 },
                    "arabic": { "abbrev": "ar", "article_analyzer": "arabic", "extended_abbrev": "ara", "key": "arabic", "label": "Arabic", "order": 15511, "show_in_enumeration": true, "value": 25 },
                    "armenian": { "abbrev": "hy", "extended_abbrev": "hye", "intrado_abbrev": "arm", "key": "armenian", "label": "Armenian", "order": 0, "show_in_enumeration": false, "value": 34 },
                    "bengali": { "extended_abbrev": "ben", "key": "bengali", "label": "Bengali", "order": 67, "show_in_enumeration": false, "value": 30 },
                    "bulgarian": { "abbrev": "bg", "extended_abbrev": "bul", "intrado_abbrev": "bul", "key": "bulgarian", "label": "Bulgarian", "order": 58, "show_in_enumeration": true, "value": 2 },
                    "chinese": { "abbrev": "zh-Hant", "article_analyzer": "smartcn", "extended_abbrev": "zho", "key": "chinese", "label": "Chinese", "order": 70314, "show_in_enumeration": true, "value": 32 },
                    "chinese_simplified": { "abbrev": "zh-Hans", "intrado_abbrev": "zhs", "key": "chinese_simplified", "label": "Chinese (Simplified)", "order": 0, "show_in_enumeration": false, "value": 35 },
                    "croatian": { "abbrev": "hr", "extended_abbrev": "hrv", "key": "croatian", "label": "Croatian", "order": 76, "show_in_enumeration": true, "value": 11 },
                    "czech": { "abbrev": "cs", "extended_abbrev": "ces", "intrado_abbrev": "cze", "key": "czech", "label": "Czech", "order": 91, "show_in_enumeration": true, "value": 4 },
                    "danish": { "abbrev": "da", "extended_abbrev": "dan", "intrado_abbrev": "dan", "key": "danish", "label": "Danish", "order": 214, "show_in_enumeration": true, "value": 5 },
                    "dutch": { "abbrev": "nl", "article_analyzer": "dutch", "extended_abbrev": "nld", "intrado_abbrev": "dut", "key": "dutch", "label": "Dutch", "order": 2697, "show_in_enumeration": true, "value": 17 },
                    "english": { "abbrev": "en", "article_analyzer": "english", "extended_abbrev": "eng", "intrado_abbrev": "eng", "key": "english", "label": "English", "order": 3268508, "show_in_enumeration": true, "value": 1 },
                    "estonian": { "abbrev": "et", "extended_abbrev": "est", "intrado_abbrev": "est", "key": "estonian", "label": "Estonian", "order": 29, "show_in_enumeration": true, "value": 7 },
                    "filipino": { "extended_abbrev": "fil", "key": "filipino", "label": "Filipino", "order": 0, "show_in_enumeration": false, "value": 47 },
                    "finnish": { "abbrev": "fi", "extended_abbrev": "fin", "intrado_abbrev": "fin", "key": "finnish", "label": "Finnish", "order": 37, "show_in_enumeration": true, "value": 22 },
                    "french": { "abbrev": "fr", "article_analyzer": "french", "extended_abbrev": "fra", "intrado_abbrev": "fre", "key": "french", "label": "French", "order": 15566, "show_in_enumeration": true, "value": 9 },
                    "georgian": { "abbrev": "ga", "extended_abbrev": "kat", "key": "georgian", "label": "Georgian", "order": 3, "show_in_enumeration": true, "value": 10 },
                    "german": { "abbrev": "de", "article_analyzer": "german", "extended_abbrev": "deu", "intrado_abbrev": "ger", "key": "german", "label": "German", "order": 24802, "show_in_enumeration": true, "value": 6 },
                    "greek": { "abbrev": "el", "extended_abbrev": "ell", "intrado_abbrev": "gre", "key": "greek", "label": "Greek", "order": 415, "show_in_enumeration": true, "value": 8 },
                    "gujarati": { "abbrev": "gu", "extended_abbrev": "guj", "key": "gujarati", "label": "Gujarati", "order": 0, "show_in_enumeration": false, "value": 52 },
                    "hebrew": { "abbrev": "he", "extended_abbrev": "heb", "key": "hebrew", "label": "Hebrew", "order": 0, "show_in_enumeration": false, "value": 36 },
                    "hindi": { "abbrev": "he", "extended_abbrev": "hin", "intrado_abbrev": "hin", "key": "hindi", "label": "Hindi", "order": 0, "show_in_enumeration": false, "value": 37 },
                    "hungarian": { "abbrev": "hu", "extended_abbrev": "hun", "intrado_abbrev": "hun", "key": "hungarian", "label": "Hungarian", "order": 92, "show_in_enumeration": true, "value": 15 },
                    "icelandic": { "abbrev": "is", "extended_abbrev": "isl", "intrado_abbrev": "ice", "key": "icelandic", "label": "Icelandic", "order": 0, "show_in_enumeration": false, "value": 38 },
                    "indonesian": { "abbrev": "id", "extended_abbrev": "ind", "intrado_abbrev": "ind", "key": "indonesian", "label": "Indonesian", "order": 0, "show_in_enumeration": false, "value": 39 },
                    "italian": { "abbrev": "it", "article_analyzer": "italian", "extended_abbrev": "ita", "intrado_abbrev": "ita", "key": "italian", "label": "Italian", "order": 5491, "show_in_enumeration": true, "value": 12 },
                    "japanese": { "abbrev": "ja", "article_analyzer": "kuromoji", "extended_abbrev": "jpn", "key": "japanese", "label": "Japanese", "order": 16786, "show_in_enumeration": true, "value": 33 },
                    "korean": { "abbrev": "ko", "extended_abbrev": "kor", "intrado_abbrev": "kor", "key": "korean", "label": "Korean", "order": 0, "show_in_enumeration": false, "value": 40 },
                    "latvian": { "abbrev": "lv", "extended_abbrev": "lav", "intrado_abbrev": "lav", "key": "latvian", "label": "Latvian", "order": 81, "show_in_enumeration": true, "value": 13 },
                    "lithuanian": { "abbrev": "lt", "extended_abbrev": "lit", "intrado_abbrev": "lit", "key": "lithuanian", "label": "Lithuanian", "order": 67, "show_in_enumeration": true, "value": 14 },
                    "luxembourgish": { "abbrev": "lb", "extended_abbrev": "ltz", "key": "luxembourgish", "label": "Luxembourish", "order": 0, "show_in_enumeration": false, "value": 41 },
                    "malay": { "abbrev": "ms", "extended_abbrev": "msa", "intrado_abbrev": "may", "key": "malay", "label": "Malay", "order": 0, "show_in_enumeration": false, "value": 42 },
                    "maltan": { "abbrev": "mt", "extended_abbrev": "mit", "key": "maltan", "label": "Maltese", "order": -1, "show_in_enumeration": true, "value": 16 },
                    "marathi": { "abbrev": "mr", "extended_abbrev": "mar", "key": "marathi", "label": "Marathi", "order": 0, "show_in_enumeration": false, "value": 50 },
                    "norwegian": { "abbrev": "no", "extended_abbrev": "nor", "intrado_abbrev": "nor", "key": "norwegian", "label": "Norwegian", "order": 98, "show_in_enumeration": false, "value": 29 },
                    "other": { "abbrev": "other", "article_analyzer": "icu_analyzer", "extended_abbrev": "other", "key": "other", "label": "Other", "order": -2, "show_in_enumeration": true, "value": 9000 },
                    "persian": { "extended_abbrev": "fas", "key": "persian", "label": "Persian", "order": 428, "show_in_enumeration": false, "value": 26 },
                    "polish": { "abbrev": "pl", "extended_abbrev": "pol", "intrado_abbrev": "pol", "key": "polish", "label": "Polish", "order": 259, "show_in_enumeration": true, "value": 18 },
                    "portuguese": { "abbrev": "pt", "article_analyzer": "portuguese", "extended_abbrev": "por", "intrado_abbrev": "por", "key": "portuguese", "label": "Portuguese", "order": 13275, "show_in_enumeration": true, "value": 19 },
                    "punjabi": { "abbrev": "pa", "extended_abbrev": "pan", "key": "punjabi", "label": "Punjabi", "order": 0, "show_in_enumeration": false, "value": 45 },
                    "romanian": { "abbrev": "ro", "extended_abbrev": "ron", "intrado_abbrev": "rum", "key": "romanian", "label": "Romanian", "order": 172, "show_in_enumeration": true, "value": 24 },
                    "russian": { "article_analyzer": "russian", "extended_abbrev": "rus", "intrado_abbrev": "rus", "key": "russian", "label": "Russian", "order": 10754, "show_in_enumeration": true, "value": 27 },
                    "slovakian": { "abbrev": "sk", "extended_abbrev": "slk", "intrado_abbrev": "slo", "key": "slovakian", "label": "Slovak", "order": 63, "show_in_enumeration": true, "value": 20 },
                    "slovenian": { "abbrev": "sl", "extended_abbrev": "slv", "intrado_abbrev": "slv", "key": "slovenian", "label": "Slovenian", "order": 20, "show_in_enumeration": true, "value": 21 },
                    "spanish": { "abbrev": "es", "article_analyzer": "spanish", "extended_abbrev": "spa", "intrado_abbrev": "spa", "key": "spanish", "label": "Spanish", "order": 26781, "show_in_enumeration": true, "value": 3 },
                    "swedish": { "abbrev": "sv", "extended_abbrev": "swe", "intrado_abbrev": "swe", "key": "swedish", "label": "Swedish", "order": 110, "show_in_enumeration": true, "value": 23 },
                    "tamil": { "abbrev": "ta", "extended_abbrev": "tam", "key": "tamil", "label": "Tamil", "order": 0, "show_in_enumeration": false, "value": 46 },
                    "thai": { "abbrev": "th", "extended_abbrev": "tha", "key": "thai", "label": "Thai", "order": 0, "show_in_enumeration": false, "value": 44 },
                    "turkish": { "abbrev": "tr", "extended_abbrev": "tur", "intrado_abbrev": "tur", "key": "turkish", "label": "Turkish", "order": 568, "show_in_enumeration": false, "value": 31 },
                    "urdu": { "extended_abbrev": "urd", "key": "urdu", "label": "Urdu", "order": 70, "show_in_enumeration": false, "value": 28 },
                    "vietnamese": { "abbrev": "vi", "extended_abbrev": "vie", "intrado_abbrev": "vie", "key": "vietnamese", "label": "Vietnamese", "order": 0, "show_in_enumeration": false, "value": 43 },
                    "welsh": { "abbrev": "cy", "extended_abbrev": "cym", "key": "welsh", "label": "Welsh", "order": 0, "show_in_enumeration": false, "value": 48 }
                }
            }
        },
        "events": {
            "models": {
                "DateRangeType": {
                    "__is_enum": true,
                    "future": { "is_future": true, "key": "future", "label": "Upcoming (Including today\u2019s date)", "order": 1, "show_in_enumeration": true, "value": 2 },
                    "next_month": { "is_future": true, "key": "next_month", "label": "In the Next Month", "order": 2, "show_in_enumeration": true, "value": 3 },
                    "next_week": { "is_future": true, "key": "next_week", "label": "In the Next Week", "order": 3, "show_in_enumeration": true, "value": 4 },
                    "this_month": { "is_future": false, "key": "this_month", "label": "In the Last Month", "order": 7, "show_in_enumeration": true, "value": 6 },
                    "this_quarter": { "is_future": false, "key": "this_quarter", "label": "In the Last Three Months", "order": 8, "show_in_enumeration": true, "value": 7 },
                    "this_week": { "is_future": false, "key": "this_week", "label": "In the Last Week", "order": 10000, "show_in_enumeration": false, "value": 5 },
                    "this_week_exclusive": { "is_future": false, "key": "this_week_exclusive", "label": "In the Last Week", "order": 6, "show_in_enumeration": true, "value": 11 },
                    "this_year": { "is_future": false, "key": "this_year", "label": "In the Last Year", "order": 9, "show_in_enumeration": true, "value": 8 },
                    "today": { "is_future": false, "key": "today", "label": "Today", "order": 4, "show_in_enumeration": true, "value": 1 },
                    "tomorrow": { "is_future": true, "key": "tomorrow", "label": "Tomorrow", "order": 9999, "show_in_enumeration": false, "value": 9 },
                    "yesterday": { "is_future": false, "key": "yesterday", "label": "Yesterday", "order": 5, "show_in_enumeration": true, "value": 10 }
                },
                "Event": {
                    "__is_model": true,
                    "__name__": "Event",
                    "data_model": "app.events.models.Event",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "excluding_custom_events": true, "full_events": true },
                    "endpoint": "/api/event/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        { "field_type": 3, "help_text": "", "name": "address", "verbose_name": "address" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that owns this event.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that sponsors this event.",
                            "name": "sponsoring_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "sponsoring organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization's point person for this event.",
                            "name": "point_person",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "point person"
                        },
                        { "field_type": 1, "help_text": "If the event lasts all day", "name": "is_custom_all_day_event", "verbose_name": "is custom all day event" },
                        {
                            "field_type": 7,
                            "help_text": "The creator of the event.",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        { "field_type": 3, "help_text": "Deprecated. FactSquared's slug for the meeting. Required to find all transcripts made in a meeting", "name": "fact_squared_slug", "verbose_name": "fact squared slug" },
                        { "field_type": 2, "help_text": "\n            Link to the committee meeting video in S3 public bucket, available to access in Quorum frontend.\n            Ex: https://s3.amazonaws.com/federal-committee-transcripts/d2761be7-b29d-46f1-bcc6-55cda0c5c217.mp4\n        ", "name": "video_url", "verbose_name": "video url" },
                        { "field_type": 4, "help_text": "Total duration of the meeting, in seconds converted from integer minutes. Will be greater than or equal to last transcript timestamp", "name": "duration", "verbose_name": "duration" },
                        { "field_type": 4, "help_text": "Deprecated. Number of transcripts entries made in the JSON response from FactSquared API", "name": "original_number_of_transcripts", "verbose_name": "original number of transcripts" },
                        { "field_type": 4, "help_text": "Number of transcripts made in the meeting. Assigned after smushing together meetings", "name": "expected_number_of_transcripts", "verbose_name": "expected number of transcripts" },
                        { "field_type": 2, "help_text": "Link to the full committee meeting transcript in S3. Uploaded during transcript procesing", "name": "full_transcript_url", "verbose_name": "full transcript url" },
                        { "field_type": null, "help_text": "A mapping of transcript sequences to the time a transcript begins. Mapping for all transcripts in meeting. Key: sequence, value: second_start from the CommitteeTranscript (Document) objects", "name": "sequence_time_cache", "verbose_name": "sequence time cache" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "FactSquaredCommitteeMeetingParsingStatus" },
                            "field_type": 4,
                            "help_text": "Deprecated. The current status of committee meeting parsing from FS. Used internally for parsing only",
                            "name": "fact_squared_meeting_status",
                            "verbose_name": "fact squared meeting status"
                        },
                        { "field_type": 3, "help_text": "\n            The local path of a downloaded video on the Update server, ideally saved to settings.DATA_PATH.\n            Should contain the slug of the video within the local path.\n            Ex: /webapps/quorum-site/quorum-site/quorum_data/videos/ssju-20210617-100000-123456.mp4\n        ", "name": "local_video_path", "verbose_name": "local video path" },
                        { "field_type": 3, "help_text": "\n            The unique string identifer for transcription jobs with rev.ai. Used to map a CommitteeMeeting\n            to the transcription job by the data provider.\n        ", "name": "revai_job_id", "verbose_name": "revai job id" },
                        { "field_type": 3, "help_text": "\n            The source url of CommitteeMeeting video. Should be the external URL accessible via web browser.\n            Ex: https://www.youtube.com/watch?v=cFSWIaVHzRk\n        ", "name": "source_video_url", "verbose_name": "source video url" },
                        { "field_type": 3, "help_text": "\n            The file name of the finshed transcript file object in S3. Should be the meeting slug with .json extension.\n            Ex: ssju-20210617-100000-123456.json\n            ", "name": "transcript_s3_file_name", "verbose_name": "transcript s3 file name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "MeetingVideoPipelineStatus" },
                            "field_type": 4,
                            "help_text": "The current status of video in download pipeline",
                            "name": "meeting_video_pipeline_status",
                            "verbose_name": "meeting video pipeline status"
                        },
                        { "field_type": null, "help_text": "The transcription pipeline status for each step", "name": "transcription_pipeline_history", "verbose_name": "transcription pipeline history" },
                        {
                            "field_type": 7,
                            "help_text": "\n        The Election which this event supports, e.g. the VA-09 or VA-10 Republican Congressional Conventions\n        would be ElectionDates applying to the \"Virginia Primary Convention\" Election.\n        ",
                            "name": "election",
                            "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                            "verbose_name": "election"
                        },
                        { "field_type": 21, "help_text": "", "name": "when", "verbose_name": "when" },
                        { "field_type": 21, "help_text": "", "name": "end", "verbose_name": "end" },
                        { "field_type": 1, "help_text": "Bool returns true if the event has been cancelled, Null by default", "name": "is_cancelled", "verbose_name": "is cancelled" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old committee meeting)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "HearingStatus" },
                            "field_type": 4,
                            "help_text": "The current status of hearing",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "What region does this event relate to?",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The congressional district this event is tied to, if applicable.",
                            "name": "district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "district"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CongressChamber" },
                            "field_type": 4,
                            "help_text": "What chamber does this event relate to?",
                            "name": "chamber",
                            "verbose_name": "chamber"
                        },
                        { "field_type": 3, "help_text": "", "name": "subject", "verbose_name": "subject" },
                        { "field_type": 3, "help_text": "", "name": "description", "verbose_name": "description" },
                        { "field_type": 3, "help_text": "The original version of the event we grab. This could be HTML or json.", "name": "original_content", "verbose_name": "original content" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.models", "__name__": "EventType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "event_type",
                            "verbose_name": "event type"
                        },
                        { "field_type": 4, "help_text": "Sub-type used to differentiate within proxies", "name": "event_subtype", "verbose_name": "event subtype" },
                        { "field_type": 3, "help_text": "Where the meeting took place", "name": "location", "verbose_name": "location" },
                        { "field_type": null, "help_text": "Stores any extra info needed by the model", "name": "extra_info", "verbose_name": "extra info" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "corresponding_session_end",
                            "related_model": { "__module__": "app.events.models", "__name__": "SessionEnd" },
                            "verbose_name": "corresponding session end"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 2, "help_text": "", "name": "search_date", "verbose_name": "search date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "AvailabilityStatus" },
                            "field_type": 4,
                            "help_text": "The current availability status of committee meeting",
                            "name": "availability",
                            "verbose_name": "availability"
                        },
                        { "field_type": 3, "help_text": "Field where we place additional information about a committee hearings status that is scraped in", "name": "status_text", "verbose_name": "status text" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulations",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dockets",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "dockets"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of People (Officials or Staffers) related to this event.",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of Bills related to this event.",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of Votes related to this event.",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this event.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Events that are related to this event.",
                            "name": "related_events",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "related events"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Witnesses that will be at the event.",
                            "name": "witnesses",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witnesses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this event has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "EventType": {
                    "__is_enum": true,
                    "alcohol_and_cannabis_board_meeting": {
                        "icon": "fa fa-calendar",
                        "key": "alcohol_and_cannabis_board_meeting",
                        "label": "Alcohol and Cannabis Board Meeting",
                        "order": 2,
                        "placeholder": "Alcohol and Cannabis Board Meeting",
                        "qcal_class": "alcohol-and-cannabis-board-meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 36
                    },
                    "board_meeting": {
                        "icon": "fa fa-gavel",
                        "key": "board_meeting",
                        "label": "Board Meeting",
                        "order": 6,
                        "permission_enum": [212],
                        "placeholder": "Board Meeting",
                        "qcal_class": "board-meeting",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 32
                    },
                    "call_in": {
                        "icon": "fa fa-phone",
                        "key": "call_in",
                        "label": "Call-In",
                        "order": 11,
                        "placeholder": "Call-In",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 11
                    },
                    "committee_meeting": {
                        "icon": "fa fa-gavel",
                        "key": "committee_meeting",
                        "label": "Committee Meeting",
                        "order": 1,
                        "placeholder": "Committee Meeting",
                        "qcal_class": "event-cal-committee-meeting",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "value": 4
                    },
                    "congress_in_session": {
                        "icon": "fa fa-gavel",
                        "key": "congress_in_session",
                        "label": "Congress in Session",
                        "order": 3,
                        "placeholder": "Congress in Session",
                        "qcal_class": "congress-in-session",
                        "supported_regions": [1, 10000],
                        "value": 5
                    },
                    "council_meeting": {
                        "icon": "fa fa-calendar-o",
                        "key": "council_meeting",
                        "label": "Council Meeting",
                        "order": 6,
                        "permission_enum": [212],
                        "placeholder": "Council Meeting",
                        "qcal_class": "council-meeting",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 31
                    },
                    "custom": {
                        "icon": "fa fa-calendar-o",
                        "key": "custom",
                        "label": "Custom",
                        "order": 999,
                        "permission_enum": [204],
                        "placeholder": "Custom event type",
                        "qcal_class": "custom-event-type",
                        "value": 16
                    },
                    "delegation": {
                        "icon": "fa fa-plane",
                        "key": "delegation",
                        "label": "Delegation",
                        "order": 20,
                        "placeholder": "Delegation",
                        "supported_regions": [106],
                        "tip": "Delegations in EU",
                        "value": 20
                    },
                    "election": {
                        "icon": "fa fa-pencil-square-o",
                        "key": "election",
                        "label": "Election Date",
                        "order": 23,
                        "placeholder": "Election Date",
                        "supported_regions": [1],
                        "value": 23
                    },
                    "eu_council_meeting": {
                        "icon": "fa fa-gavel",
                        "key": "eu_council_meeting",
                        "label": "Council Meeting",
                        "order": 21,
                        "placeholder": "Council Meeting",
                        "supported_regions": [106],
                        "tip": "All EU Council meetings, committee and working group meetings, etc",
                        "value": 26
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislative Meetings",
                            "values": [4, 26, 1, 35, 5, 1000, 31, 32, 34]
                        },
                        {
                            "display": "list",
                            "title": "Dates and Deadlines",
                            "values": [3, 2, 23]
                        },
                        {
                            "display": "list",
                            "title": "Custom",
                            "values": [16]
                        },
                        {
                            "display": "list",
                            "title": " State Regulatory Board Meetings",
                            "values": [36, 37, 40, 38, 39]
                        }
                    ],
                    "floor_schedule": {
                        "icon": "fa fa-calendar",
                        "key": "floor_schedule",
                        "label": "Floor Schedule",
                        "order": 2,
                        "placeholder": "Floor Schedule",
                        "qcal_class": "event-cal-floor-schedule",
                        "supported_regions": [1, 10000],
                        "value": 1
                    },
                    "interview": {
                        "icon": "fa fa-microphone",
                        "key": "interview",
                        "label": "Interview",
                        "order": 10,
                        "placeholder": "Interview",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 10
                    },
                    "lobbying_deadline": {
                        "icon": "fa fa-gavel",
                        "key": "lobbying_deadline",
                        "label": "Lobbying Deadline",
                        "order": 7,
                        "placeholder": "Lobbying Deadline",
                        "qcal_class": "lobbying-deadline",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 7
                    },
                    "lower_crossover_deadline": {
                        "icon": "fa fa-gavel",
                        "key": "lower_crossover_deadline",
                        "label": "House Crossover Deadline",
                        "order": 6,
                        "placeholder": "House/Assembly Crossover Deadline",
                        "qcal_class": "crossover-deadline",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 28
                    },
                    "medical_board_meeting": {
                        "icon": "fa fa-calendar",
                        "key": "medical_board_meeting",
                        "label": "Medical Board Meeting",
                        "order": 3,
                        "placeholder": "Medical Board Meeting",
                        "qcal_class": "medical-board-meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 37
                    },
                    "national_press_club": {
                        "icon": "fa fa-microphone",
                        "key": "national_press_club",
                        "label": "National Press Club",
                        "order": 12,
                        "placeholder": "National Press Club",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 12
                    },
                    "news_conference": {
                        "icon": "fa fa-microphone",
                        "key": "news_conference",
                        "label": "News Conference",
                        "order": 15,
                        "placeholder": "News Conference",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 15
                    },
                    "nursing_board_meeting": {
                        "icon": "fa fa-calendar",
                        "key": "nursing_board_meeting",
                        "label": "Nursing Board Meeting",
                        "order": 4,
                        "placeholder": "Nursing Board Meeting",
                        "qcal_class": "nursing-board-meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 40
                    },
                    "open_meeting": {
                        "icon": "fa fa-bullhorn",
                        "key": "open_meeting",
                        "label": "Open Meeting",
                        "order": 21,
                        "permission_enum": [310],
                        "placeholder": "Open Meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 1],
                        "tip": "An open agency meeting about a regulation",
                        "value": 25
                    },
                    "other_type": {
                        "icon": "fa fa-calendar-o",
                        "key": "other_type",
                        "label": "Other",
                        "order": 24,
                        "placeholder": "Custom event type",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 1000
                    },
                    "pharmacy_board_meeting": {
                        "icon": "fa fa-calendar",
                        "key": "pharmacy_board_meeting",
                        "label": "Pharmacy Board Meeting",
                        "order": 5,
                        "placeholder": "Pharmacy Board Meeting",
                        "qcal_class": "pharmacy-board-meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 38
                    },
                    "plenary_session": {
                        "icon": "fa fa-handshake-o",
                        "key": "plenary_session",
                        "label": "Plenary Session",
                        "order": 17,
                        "placeholder": "Plenary Session",
                        "supported_regions": [106],
                        "tip": "Plenary Session in EU",
                        "value": 17
                    },
                    "prefile_deadline": {
                        "icon": "fa fa-gavel",
                        "key": "prefile_deadline",
                        "label": "Prefile Deadline",
                        "order": 6,
                        "placeholder": "Prefile Deadline",
                        "qcal_class": "prefile-deadline",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6
                    },
                    "prefile_start": {
                        "icon": "fa fa-gavel",
                        "key": "prefile_start",
                        "label": "Prefiling Opens",
                        "order": 6,
                        "placeholder": "Prefiling Opens",
                        "qcal_class": "prefile-start",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 27
                    },
                    "presidents_agenda": {
                        "icon": "fa fa-calendar",
                        "key": "presidents_agenda",
                        "label": "President's Agenda",
                        "order": 18,
                        "placeholder": "President's Agenda",
                        "supported_regions": [106],
                        "tip": "President's Agendas in EU",
                        "value": 18
                    },
                    "press_conference": {
                        "icon": "fa fa-microphone",
                        "key": "press_conference",
                        "label": "Press Conferences",
                        "order": 19,
                        "placeholder": "Press Conference",
                        "supported_regions": [106],
                        "tip": "Press Conferences in EU",
                        "value": 19
                    },
                    "public_affairs": {
                        "icon": "fa fa-users",
                        "key": "public_affairs",
                        "label": "Public Affairs Event",
                        "order": 8,
                        "placeholder": "Public Affairs Event",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 8
                    },
                    "public_hearing": {
                        "icon": "fa fa-bullhorn",
                        "key": "public_hearing",
                        "label": "Public Hearing",
                        "order": 21,
                        "placeholder": "Public Hearing",
                        "supported_regions": [106],
                        "tip": "Public Hearings in EU",
                        "value": 21
                    },
                    "public_utility_board_meeting": {
                        "icon": "fa fa-calendar",
                        "key": "public_utility_board_meeting",
                        "label": "Public Utility Commission Meeting",
                        "order": 6,
                        "placeholder": "Public Utility Commission Meeting",
                        "qcal_class": "public-utility-board-meeting",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 39
                    },
                    "q_and_a": {
                        "icon": "fa fa-comments",
                        "key": "q_and_a",
                        "label": "Q&A",
                        "order": 14,
                        "placeholder": "Q&A",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 14
                    },
                    "regulatory_hearing": {
                        "icon": "fa fa-bullhorn",
                        "key": "regulatory_hearing",
                        "label": "Regulatory Hearing",
                        "order": 21,
                        "permission_enum": [310],
                        "placeholder": "Regulatory Hearing",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 1],
                        "tip": "An agency hearing for regulations",
                        "value": 24
                    },
                    "school_board_meeting": {
                        "feature_flags": ["ff_school_board_Agendas"],
                        "icon": "fa fa-gavel",
                        "key": "school_board_meeting",
                        "label": "School Board Meeting",
                        "order": 6,
                        "permission_enum": [107],
                        "placeholder": "School Board Meeting",
                        "qcal_class": "school-board-meeting",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 34
                    },
                    "session_end": {
                        "icon": "fa fa-hourglass-end",
                        "key": "session_end",
                        "label": "Session End Date",
                        "order": 5,
                        "placeholder": "The end of a legislative session",
                        "qcal_class": "event-cal-session-end",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "session_start": {
                        "icon": "fa fa-hourglass-start",
                        "key": "session_start",
                        "label": "Session Start Date",
                        "order": 4,
                        "placeholder": "The start of a legislative session",
                        "qcal_class": "event-cal-session-start",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "signing_deadline": {
                        "icon": "fa fa-gavel",
                        "key": "signing_deadline",
                        "label": "Governor Signing Deadline",
                        "order": 6,
                        "placeholder": "Governor Signing Deadline",
                        "qcal_class": "signing-deadline",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 30
                    },
                    "special_events": {
                        "icon": "fa fa-calendar-o",
                        "key": "special_events",
                        "label": "Special Events",
                        "order": 22,
                        "placeholder": "Special Events",
                        "supported_regions": [106],
                        "tip": "Special Events in EU",
                        "value": 22
                    },
                    "state_floor_event": {
                        "icon": "fa fa-calendar",
                        "key": "state_floor_event",
                        "label": "State Floor Schedule",
                        "order": 2,
                        "placeholder": "State Floor Schedule",
                        "qcal_class": "event-cal-floor-schedule",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 35
                    },
                    "upper_crossover_deadline": {
                        "icon": "fa fa-gavel",
                        "key": "upper_crossover_deadline",
                        "label": "Senate Crossover Deadline",
                        "order": 6,
                        "placeholder": "Senate Crossover Deadline",
                        "qcal_class": "crossover-deadline",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 29
                    },
                    "us_president_address": {
                        "icon": "fa fa-calendar",
                        "key": "us_president_address",
                        "label": "Presidential Appearance",
                        "order": 1,
                        "placeholder": "Presidential Appearance",
                        "qcal_class": "presidential-appearance",
                        "supported_regions": [1, 10000],
                        "value": 33
                    },
                    "vignette": {
                        "icon": "fa fa-picture-o",
                        "key": "vignette",
                        "label": "Vignette",
                        "order": 9,
                        "placeholder": "Vignette",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 9
                    },
                    "white_house_event": {
                        "icon": "fa fa-university",
                        "key": "white_house_event",
                        "label": "White House Event",
                        "order": 13,
                        "placeholder": "White House Event",
                        "qcal_class": "custom-event-type",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 13
                    }
                },
                "InternalCspanEvent": {
                    "__is_model": true,
                    "__name__": "InternalCspanEvent",
                    "data_model": "app.events.models.InternalCspanEvent",
                    "default_exclude_filters": {},
                    "default_filters": { "display_on_site": true },
                    "endpoint": "/api/internalcspanevent/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "", "name": "cspan_event_page_url", "verbose_name": "cspan event page url" },
                        { "field_type": 16, "help_text": "The date and time that this specific airing of the program was played", "name": "start_date_time", "verbose_name": "start date time" },
                        { "field_type": 16, "help_text": "The time that this specific airing of the program ended", "name": "end_date_time", "verbose_name": "end date time" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CspanChannelType" },
                            "field_type": 4,
                            "help_text": "The CSPAN channel (1, 2, or 3) that this specific entry aired on",
                            "name": "channel",
                            "verbose_name": "channel"
                        },
                        { "field_type": 4, "help_text": "Length of the program in minutes", "name": "length", "verbose_name": "length" },
                        { "field_type": 3, "help_text": "A summary of the content of the program", "name": "summary", "verbose_name": "summary" },
                        { "field_type": 5, "help_text": "The date that the actual event (committee meeting, hearing, etc) in the program happened.\n        Multiple airings of a program have the same happened_date, since the actual event happened on the same day.", "name": "happened_date", "verbose_name": "happened date" },
                        { "field_type": 3, "help_text": "", "name": "short_title", "verbose_name": "short title" },
                        { "field_type": 3, "help_text": "", "name": "speaker_names", "verbose_name": "speaker names" },
                        {
                            "field_type": 7,
                            "help_text": "The Hosting Organization for a program can sometimes be matched to a committee.Committee",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        { "field_type": 3, "help_text": "The name of the Hosting Organization. We store this even if we are able to match the name of the hosting organization to a committee.Committee", "name": "hosting_organization_str", "verbose_name": "hosting organization str" },
                        { "field_type": 2, "help_text": "The id of the program for this entry in the CSPAN schedule", "name": "program_id", "verbose_name": "program id" },
                        { "field_type": 3, "help_text": "The category of the program", "name": "category", "verbose_name": "category" },
                        { "field_type": 3, "help_text": "The format of the program", "name": "format", "verbose_name": "format" },
                        { "field_type": 3, "help_text": "The location where the actual event in the program happened", "name": "location", "verbose_name": "location" },
                        { "field_type": 5, "help_text": "The date that the program first aired on CSPAN", "name": "first_aired", "verbose_name": "first aired" },
                        { "field_type": 16, "help_text": "The date and time that this program was first aired", "name": "first_aired_time", "verbose_name": "first aired time" },
                        { "field_type": 1, "help_text": "", "name": "first_created", "verbose_name": "first created" },
                        { "field_type": 1, "help_text": "", "name": "display_on_site", "verbose_name": "display on site" },
                        { "field_type": 1, "help_text": "", "name": "matched_to_existing_event", "verbose_name": "matched to existing event" },
                        { "field_type": 1, "help_text": "", "name": "event_has_finished", "verbose_name": "event has finished" },
                        { "field_type": 1, "help_text": "", "name": "should_skip", "verbose_name": "should skip" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "related event"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The important people that appeared in the program",
                            "name": "people",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "people"
                        },
                        {
                            "field_type": 8,
                            "help_text": "People that appeared in the program that we did not have Person objects for",
                            "name": "other_people",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "other people"
                        }
                    ]
                },
                "NewEvent": {
                    "__is_model": true,
                    "__name__": "NewEvent",
                    "data_model": "app.events.models.NewEvent",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "excluding_custom_events": true, "full_events": true },
                    "endpoint": "/api/newevent/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        { "field_type": 3, "help_text": "", "name": "address", "verbose_name": "address" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that owns this event.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that sponsors this event.",
                            "name": "sponsoring_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "sponsoring organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization's point person for this event.",
                            "name": "point_person",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "point person"
                        },
                        { "field_type": 1, "help_text": "If the event lasts all day", "name": "is_custom_all_day_event", "verbose_name": "is custom all day event" },
                        {
                            "field_type": 7,
                            "help_text": "The creator of the event.",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        { "field_type": 3, "help_text": "Deprecated. FactSquared's slug for the meeting. Required to find all transcripts made in a meeting", "name": "fact_squared_slug", "verbose_name": "fact squared slug" },
                        { "field_type": 2, "help_text": "\n            Link to the committee meeting video in S3 public bucket, available to access in Quorum frontend.\n            Ex: https://s3.amazonaws.com/federal-committee-transcripts/d2761be7-b29d-46f1-bcc6-55cda0c5c217.mp4\n        ", "name": "video_url", "verbose_name": "video url" },
                        { "field_type": 4, "help_text": "Total duration of the meeting, in seconds converted from integer minutes. Will be greater than or equal to last transcript timestamp", "name": "duration", "verbose_name": "duration" },
                        { "field_type": 4, "help_text": "Deprecated. Number of transcripts entries made in the JSON response from FactSquared API", "name": "original_number_of_transcripts", "verbose_name": "original number of transcripts" },
                        { "field_type": 4, "help_text": "Number of transcripts made in the meeting. Assigned after smushing together meetings", "name": "expected_number_of_transcripts", "verbose_name": "expected number of transcripts" },
                        { "field_type": 2, "help_text": "Link to the full committee meeting transcript in S3. Uploaded during transcript procesing", "name": "full_transcript_url", "verbose_name": "full transcript url" },
                        { "field_type": null, "help_text": "A mapping of transcript sequences to the time a transcript begins. Mapping for all transcripts in meeting. Key: sequence, value: second_start from the CommitteeTranscript (Document) objects", "name": "sequence_time_cache", "verbose_name": "sequence time cache" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "FactSquaredCommitteeMeetingParsingStatus" },
                            "field_type": 4,
                            "help_text": "Deprecated. The current status of committee meeting parsing from FS. Used internally for parsing only",
                            "name": "fact_squared_meeting_status",
                            "verbose_name": "fact squared meeting status"
                        },
                        { "field_type": 3, "help_text": "\n            The local path of a downloaded video on the Update server, ideally saved to settings.DATA_PATH.\n            Should contain the slug of the video within the local path.\n            Ex: /webapps/quorum-site/quorum-site/quorum_data/videos/ssju-20210617-100000-123456.mp4\n        ", "name": "local_video_path", "verbose_name": "local video path" },
                        { "field_type": 3, "help_text": "\n            The unique string identifer for transcription jobs with rev.ai. Used to map a CommitteeMeeting\n            to the transcription job by the data provider.\n        ", "name": "revai_job_id", "verbose_name": "revai job id" },
                        { "field_type": 3, "help_text": "\n            The source url of CommitteeMeeting video. Should be the external URL accessible via web browser.\n            Ex: https://www.youtube.com/watch?v=cFSWIaVHzRk\n        ", "name": "source_video_url", "verbose_name": "source video url" },
                        { "field_type": 3, "help_text": "\n            The file name of the finshed transcript file object in S3. Should be the meeting slug with .json extension.\n            Ex: ssju-20210617-100000-123456.json\n            ", "name": "transcript_s3_file_name", "verbose_name": "transcript s3 file name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "MeetingVideoPipelineStatus" },
                            "field_type": 4,
                            "help_text": "The current status of video in download pipeline",
                            "name": "meeting_video_pipeline_status",
                            "verbose_name": "meeting video pipeline status"
                        },
                        { "field_type": null, "help_text": "The transcription pipeline status for each step", "name": "transcription_pipeline_history", "verbose_name": "transcription pipeline history" },
                        {
                            "field_type": 7,
                            "help_text": "\n        The Election which this event supports, e.g. the VA-09 or VA-10 Republican Congressional Conventions\n        would be ElectionDates applying to the \"Virginia Primary Convention\" Election.\n        ",
                            "name": "election",
                            "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                            "verbose_name": "election"
                        },
                        { "field_type": 21, "help_text": "", "name": "when", "verbose_name": "when" },
                        { "field_type": 21, "help_text": "", "name": "end", "verbose_name": "end" },
                        { "field_type": 1, "help_text": "Bool returns true if the event has been cancelled, Null by default", "name": "is_cancelled", "verbose_name": "is cancelled" },
                        { "field_type": 2, "help_text": "The primary key of the object that this was created from (i.e. an old committee meeting)", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (crs report number)", "name": "external_pk", "verbose_name": "external pk" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "source person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "source committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "HearingStatus" },
                            "field_type": 4,
                            "help_text": "The current status of hearing",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "source staffer"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "source_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "source public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "internal_cspan_event",
                            "related_model": { "__module__": "app.events.models", "__name__": "InternalCspanEvent" },
                            "verbose_name": "internal cspan event"
                        },
                        { "field_type": 2, "help_text": "", "name": "source_url", "verbose_name": "source url" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "What region does this event relate to?",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The congressional district this event is tied to, if applicable.",
                            "name": "district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "district"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CongressChamber" },
                            "field_type": 4,
                            "help_text": "What chamber does this event relate to?",
                            "name": "chamber",
                            "verbose_name": "chamber"
                        },
                        { "field_type": 3, "help_text": "", "name": "subject", "verbose_name": "subject" },
                        { "field_type": 3, "help_text": "", "name": "description", "verbose_name": "description" },
                        { "field_type": 3, "help_text": "The original version of the event we grab. This could be HTML or json.", "name": "original_content", "verbose_name": "original content" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.models", "__name__": "EventType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "event_type",
                            "verbose_name": "event type"
                        },
                        { "field_type": 4, "help_text": "Sub-type used to differentiate within proxies", "name": "event_subtype", "verbose_name": "event subtype" },
                        { "field_type": 3, "help_text": "Where the meeting took place", "name": "location", "verbose_name": "location" },
                        { "field_type": null, "help_text": "Stores any extra info needed by the model", "name": "extra_info", "verbose_name": "extra info" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "corresponding_session_end",
                            "related_model": { "__module__": "app.events.models", "__name__": "SessionEnd" },
                            "verbose_name": "corresponding session end"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 2, "help_text": "", "name": "search_date", "verbose_name": "search date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.events.types", "__name__": "AvailabilityStatus" },
                            "field_type": 4,
                            "help_text": "The current availability status of committee meeting",
                            "name": "availability",
                            "verbose_name": "availability"
                        },
                        { "field_type": 3, "help_text": "Field where we place additional information about a committee hearings status that is scraped in", "name": "status_text", "verbose_name": "status text" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "regulations",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dockets",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "dockets"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of People (Officials or Staffers) related to this event.",
                            "name": "person_mentions",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of Bills related to this event.",
                            "name": "bill_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The records of Votes related to this event.",
                            "name": "vote_mentions",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "amendment_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "committee_mentions",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Terms mentioned in press releases etc.",
                            "name": "issue_mentions",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "issue mentions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Hashtags used by social media",
                            "name": "hashtags",
                            "related_model": { "__module__": "app.social.models", "__name__": "Hashtag" },
                            "verbose_name": "hashtags"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Documents that are related to this event.",
                            "name": "related_documents",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "related documents"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Events that are related to this event.",
                            "name": "related_events",
                            "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                            "verbose_name": "related events"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Witnesses that will be at the event.",
                            "name": "witnesses",
                            "related_model": { "__module__": "app.committee.models", "__name__": "CommitteeWitness" },
                            "verbose_name": "witnesses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this event has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/event/"
                },
                "ParticipantType": {
                    "__is_enum": true,
                    "none_type": { "key": "none_type", "label": "None Type", "value": 0 }
                }
            },
            "types": {
                "AvailabilityStatus": {
                    "__is_enum": true,
                    "closed": { "key": "closed", "label": "When a hearing is Closed, that means there will not be a video available of the hearing", "value": 3 },
                    "open": { "key": "open", "label": "by default hearing's availability will be open", "value": 1 },
                    "partially_closed": { "key": "partially_closed", "label": "when hearing mentions BOTH \u201copen\u201d AND \u201cclosed\u201d within parenthesis", "value": 2 }
                },
                "ElectionType": {
                    "__is_enum": true,
                    "convention": { "election_name": "convention", "fec_form_3x_abbrev": "C", "fec_import_lookup": "C", "key": "convention", "label": "Party Caucus or Convention", "pacc_election_key_code": "C", "pacc_election_type_enum": -1, "pacc_ga_election_type_enum": -1, "show_in_enumeration": true, "text": "Party Caucus or Convention", "tip": "The FEC provides that caucuses and conventions may be considered 'elections' for contribution limit purposes if the state gives those events authority to select candidates for federal office.", "value": 1001 },
                    "full_general": { "election_name": "full_general", "fec_form_3x_abbrev": "G", "fec_import_lookup": "G", "key": "full_general", "label": "US General Election", "pacc_election_key_code": "G", "pacc_election_type_enum": 2, "pacc_ga_election_type_enum": 2, "show_in_enumeration": true, "text": "US General Election", "tip": "The full Election Day in the US, on which nominated congressional (and, every four years, presidential) candidates are elected into office.", "value": 1010 },
                    "general_congressional_runoff": { "election_name": "general_congressional_runoff", "fec_form_3x_abbrev": "R", "fec_import_lookup": "R", "key": "general_congressional_runoff", "label": "General Congressional Runoff", "pacc_election_key_code": "R", "pacc_election_type_enum": 3, "pacc_ga_election_type_enum": 4, "show_in_enumeration": true, "text": "General Congressional Runoff", "value": 2002 },
                    "off_year_general": { "election_name": "off_year_general", "fec_form_3x_abbrev": "G", "key": "off_year_general", "label": "US Off-Year General Election", "pacc_election_key_code": "G", "pacc_election_type_enum": 2, "pacc_ga_election_type_enum": 2, "show_in_enumeration": true, "text": "US Off-Year General Election", "tip": "The full Election Day for US states that hold state level elections in odd-numbered years.", "value": 1011 },
                    "pacc_other": { "election_name": "pacc_other_election", "fec_form_3x_abbrev": "TBD", "key": "pacc_other", "label": "PACC Other Election", "pacc_election_key_code": "O", "pacc_election_type_enum": -1, "pacc_ga_election_type_enum": -1, "show_in_enumeration": false, "text": "PACC Other Election", "value": 3002 },
                    "pacc_recount": { "election_name": "pacc_recount_election", "fec_form_3x_abbrev": "TBD", "key": "pacc_recount", "label": "PACC Recount Election", "pacc_election_key_code": "E", "pacc_election_type_enum": -1, "pacc_ga_election_type_enum": 5, "show_in_enumeration": false, "text": "PACC Recount Election", "value": 3001 },
                    "primary_congressional": { "election_name": "primary_congressional", "fec_form_3x_abbrev": "P", "fec_import_lookup": "P", "key": "primary_congressional", "label": "Primary Congressional", "pacc_election_key_code": "P", "pacc_election_type_enum": 0, "pacc_ga_election_type_enum": 0, "show_in_enumeration": true, "text": "Primary Congressional", "value": 2003 },
                    "primary_congressional_runoff": { "election_name": "primary_congressional_runoff", "fec_form_3x_abbrev": "R", "key": "primary_congressional_runoff", "label": "Primary Congressional Runoff", "pacc_election_key_code": "PR", "pacc_election_type_enum": 2, "pacc_ga_election_type_enum": 3, "show_in_enumeration": true, "text": "Primary Congressional Runoff", "value": 2004 },
                    "primary_presidential": { "election_name": "primary_presidential", "fec_form_3x_abbrev": "P", "key": "primary_presidential", "label": "Primary Presidential", "pacc_election_key_code": "PT", "pacc_election_type_enum": 0, "pacc_ga_election_type_enum": 0, "show_in_enumeration": true, "text": "Primary Presidential", "value": 2005 },
                    "primary_presidential_runoff": { "election_name": "primary_presidential_runoff", "fec_form_3x_abbrev": "R", "key": "primary_presidential_runoff", "label": "Primary Presidential Runoff", "pacc_election_key_code": "PU", "pacc_election_type_enum": 2, "pacc_ga_election_type_enum": 2, "show_in_enumeration": true, "text": "Primary Presidential Runoff", "value": 2006 },
                    "special_general_congressional": { "election_name": "special_general_congressional", "fec_form_3x_abbrev": "S", "fec_import_lookup": "S", "key": "special_general_congressional", "label": "Special General Congressional", "pacc_election_key_code": "S", "pacc_election_type_enum": 8, "pacc_ga_election_type_enum": 8, "show_in_enumeration": true, "text": "Special General Congressional", "value": 2007 },
                    "special_general_congressional_runoff": { "election_name": "special_general_congressional_runoff", "fec_form_3x_abbrev": "S", "key": "special_general_congressional_runoff", "label": "Special General Congressional Runoff", "pacc_election_key_code": "SR", "pacc_election_type_enum": 9, "pacc_ga_election_type_enum": 9, "show_in_enumeration": true, "text": "Special General Congressional Runoff", "value": 2008 },
                    "special_primary_congressional": { "election_name": "special_primary_congressional", "fec_form_3x_abbrev": "S", "key": "special_primary_congressional", "label": "Special Primary Congressional", "pacc_election_key_code": "1", "pacc_election_type_enum": 6, "pacc_ga_election_type_enum": 6, "show_in_enumeration": true, "text": "Special Primary Congressional", "value": 2009 },
                    "special_primary_congressional_runoff": { "election_name": "special_primary_congressional_runoff", "fec_form_3x_abbrev": "S", "key": "special_primary_congressional_runoff", "label": "Special Primary Congressional Runoff", "pacc_election_key_code": "1R", "pacc_election_type_enum": 7, "pacc_ga_election_type_enum": 7, "show_in_enumeration": true, "text": "Special Primary Congressional Runoff", "value": 2010 }
                },
                "HearingStatus": {
                    "__is_enum": true,
                    "canceled": { "key": "canceled", "label": "hearing has been canceled", "value": 4 },
                    "postponed": { "key": "postponed", "label": "hearing would be postponed", "value": 2 },
                    "rescheduled": { "key": "rescheduled", "label": "hearing will be rescheduled", "value": 3 },
                    "scheduled": { "key": "scheduled", "label": "hearing will be scheduled", "value": 1 },
                    "unknown": { "key": "unknown", "label": "by default hearing will be unknown", "value": 0 }
                },
                "MeetingVideoPipelineStatus": {
                    "__is_enum": true,
                    "download_ended": { "key": "download_ended", "label": "Download finished", "value": 3 },
                    "download_error": { "key": "download_error", "label": "Download Error", "value": 4 },
                    "no_source_video_url": { "key": "no_source_video_url", "label": "There're no video posted in the soure page yet", "value": 1 },
                    "parsing_transcription_ended": { "key": "parsing_transcription_ended", "label": "Transcription parsed and transcript objects created. Full transcript and video are uploaded to s3", "value": 10 },
                    "parsing_transcription_error": { "key": "parsing_transcription_error", "label": "Transcription parsing error", "value": 11 },
                    "source_video_url_added": { "key": "source_video_url_added", "label": "Committee meeting video added in the source page.", "value": 2 },
                    "transcription_ended": { "key": "transcription_ended", "label": "Transcription ended", "value": 8 },
                    "transcription_error": { "key": "transcription_error", "label": "Transcription failed", "value": 9 },
                    "transcription_in_progress": { "key": "transcription_in_progress", "label": "Transcription in-progress", "value": 7 },
                    "transcription_sending_error": { "key": "transcription_sending_error", "label": "Error while sending video for transcription", "value": 6 },
                    "transcription_sending_started": { "key": "transcription_sending_started", "label": "Started sending video for transcription", "value": 5 }
                }
            }
        },
        "featureflags": {
            "models": {
                "FeatureFlag": {
                    "__is_model": true,
                    "__name__": "FeatureFlag",
                    "data_model": "app.featureflags.models.FeatureFlag",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/featureflag/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "", "name": "slug", "verbose_name": "Feature Flag Name" },
                        { "field_type": 3, "help_text": "A human friendly description of the feature flag", "name": "description", "verbose_name": "description" },
                        { "field_type": 1, "help_text": "This feature flag is enabled for all users", "name": "enabled_for_all", "verbose_name": "enabled for all" },
                        { "field_type": 21, "help_text": "Timestamp for when enabled_for_all was set", "name": "enabled_for_all_timestamp", "verbose_name": "enabled_for_all Timestamp" },
                        { "field_type": 1, "help_text": "This feature flag is disabled for everyone. This Boolean takes highest precendenceOver any other setting on this model.", "name": "disabled_for_all", "verbose_name": "disabled for all" },
                        { "field_type": 1, "help_text": "This feature flag is enabled for all Demo accounts. Must have enabledenabled_for_all_quorum_employees to take affect", "name": "enabled_for_all_quorum_demo_accounts", "verbose_name": "enabled for all quorum demo accounts" },
                        { "field_type": 1, "help_text": "This feature flag is enabled for all Quorum Employees, excluding demo accounts", "name": "enabled_for_all_quorum_employees", "verbose_name": "enabled for all quorum employees" },
                        { "field_type": 1, "help_text": "This feature flag is enabled for all superusers. A subset of Quorum employees.", "name": "enabled_for_all_superusers", "verbose_name": "enabled for all superusers" },
                        { "field_type": 1, "help_text": "If set to True, editing from the Feature Flag table will be disabled", "name": "should_disable_editing_from_gui", "verbose_name": "should disable editing from gui" },
                        { "field_type": null, "help_text": "Organization ids (int) that are excluded when enabled_for_all is True", "name": "excluded_organization_ids", "verbose_name": "excluded organization ids" },
                        {
                            "field_type": 8,
                            "help_text": "Additional Users to enable this feature flag for. If enabled_for_all is True, Users in this M2M relation have no affect. disabled_for_all Also makes this fieldtake no effect",
                            "name": "users",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "users"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Additional organizations to enable this feature flag for. If enabled_for_all is TrueUsers in this M2M relation have no effect",
                            "name": "organizations",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organizations"
                        }
                    ]
                }
            }
        },
        "fields": {
            "FieldType": {
                "BooleanField": { "category": "bool", "key": "BooleanField", "label": "BooleanField", "value": 9 },
                "CharField": { "category": "string", "key": "CharField", "label": "CharField", "value": 1 },
                "DateField": { "category": "date", "key": "DateField", "label": "DateField", "value": 8 },
                "DateTimeField": { "category": "date", "key": "DateTimeField", "label": "DateTimeField", "value": 7 },
                "DecimalField": { "category": "number", "key": "DecimalField", "label": "DecimalField", "value": 6 },
                "EnumField": { "category": "number", "key": "EnumField", "label": "EnumField", "value": 14 },
                "ForeignKey": { "category": "related", "key": "ForeignKey", "label": "ForeignKey", "value": 13 },
                "IntegerField": { "category": "number", "key": "IntegerField", "label": "IntegerField", "value": 3 },
                "ManyToManyField": { "category": "related", "key": "ManyToManyField", "label": "ManyToManyField", "value": 17 },
                "NullBooleanField": { "category": "bool", "key": "NullBooleanField", "label": "NullBooleanField", "value": 10 },
                "PositiveIntegerField": { "category": "number", "key": "PositiveIntegerField", "label": "PositiveIntegerField", "value": 4 },
                "PositiveSmallIntegerField": { "category": "number", "key": "PositiveSmallIntegerField", "label": "PositiveSmallIntegerField", "value": 5 },
                "QuorumDateField": { "category": "date", "key": "QuorumDateField", "label": "QuorumDateField", "value": 16 },
                "QuorumDateTimeField": { "category": "date", "key": "QuorumDateTimeField", "label": "QuorumDateTimeField", "value": 15 },
                "SafeCharField": { "category": "string", "key": "SafeCharField", "label": "SafeCharField", "value": 2 },
                "SafeTextField": { "category": "string", "key": "SafeTextField", "label": "SafeTextField", "value": 12 },
                "TextField": { "category": "string", "key": "TextField", "label": "TextField", "value": 11 },
                "__is_enum": true
            }
        },
        "generatepdf": {
            "models": {
                "CSVEmail": {
                    "__is_model": true,
                    "__name__": "CSVEmail",
                    "data_model": "app.generatepdf.models.CSVEmail",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/csvemail/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": null, "help_text": "The complete data received from Sparkpost", "name": "transmission_json", "verbose_name": "transmission json" },
                        { "field_type": 2, "help_text": "Unique transmission id generated by Sparkpost after the email is sent", "name": "transmission_id", "verbose_name": "transmission id" },
                        { "field_type": 2, "help_text": "The email address that the email was sent to", "name": "email_address", "verbose_name": "email address" },
                        { "field_type": null, "help_text": "The information about the csv being downloaded (filters, qdt)", "name": "csv_instructions", "verbose_name": "csv instructions" },
                        {
                            "field_type": 7,
                            "help_text": "The user requesting the csv download",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "sheet_column": true,
                            "verbose_name": "user"
                        },
                        { "field_type": 1, "help_text": "Whether the email has been sent yet", "name": "sent", "sheet_column": true, "verbose_name": "sent" },
                        { "field_type": 2, "help_text": "The title of the file being downloaded", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "The S3 path of the file being downloaded", "name": "path", "verbose_name": "path" },
                        { "field_type": 1, "help_text": "If the email has been tried to send but failed", "name": "failed_to_send", "verbose_name": "failed to send" },
                        { "field_type": 4, "help_text": "The number of times the crons have attempted to send this email", "name": "retry_count", "verbose_name": "retry count" },
                        {
                            "field_type": 7,
                            "help_text": "The user that was logged into the backend, if any, when this CSVEmail was created",
                            "name": "logged_in_as_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "logged in as user"
                        }
                    ]
                },
                "PDFEmail": {
                    "__is_model": true,
                    "__name__": "PDFEmail",
                    "data_model": "app.generatepdf.models.PDFEmail",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/pdfemail/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": null, "help_text": "The complete data received from Sparkpost", "name": "transmission_json", "verbose_name": "transmission json" },
                        { "field_type": 2, "help_text": "Unique transmission id generated by Sparkpost after the email is sent", "name": "transmission_id", "verbose_name": "transmission id" },
                        { "field_type": 2, "help_text": "The email address that the email was sent to", "name": "email_address", "verbose_name": "email address" },
                        { "field_type": null, "help_text": "", "name": "pdf_instructions", "verbose_name": "pdf instructions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "sheet_column": true,
                            "verbose_name": "user"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.generatepdf.models", "__name__": "PDFType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "pdf_type",
                            "verbose_name": "pdf type"
                        },
                        { "field_type": 1, "help_text": "", "name": "sent", "sheet_column": true, "verbose_name": "sent" },
                        { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "", "name": "path", "verbose_name": "path" },
                        { "field_type": 1, "help_text": "", "name": "failed_to_send", "verbose_name": "failed to send" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "safed_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "safed search"
                        },
                        { "field_type": 4, "help_text": "The number of times the crons have attempted to send this email", "name": "retry_count", "verbose_name": "retry count" },
                        {
                            "field_type": 7,
                            "help_text": "The user that was logged into the backend, if any, when this CSVEmail was created",
                            "name": "logged_in_as_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "logged in as user"
                        },
                        { "field_type": 2, "help_text": "A subdomain to test generating this email (ie staging, beta, pdf-testing)", "name": "debug_subdomain", "verbose_name": "debug subdomain" },
                        { "field_type": null, "help_text": "", "name": "ordering", "verbose_name": "ordering" },
                        { "field_type": null, "help_text": "", "name": "custom_pages", "verbose_name": "custom pages" },
                        { "field_type": null, "help_text": "", "name": "filter_dict", "verbose_name": "filter dict" },
                        { "field_type": null, "help_text": "", "name": "members_list", "verbose_name": "members list" },
                        { "field_type": null, "help_text": "", "name": "cosponsors_data", "verbose_name": "cosponsors data" },
                        { "field_type": 3, "help_text": "", "name": "html_option_in", "verbose_name": "html option in" },
                        { "field_type": 2, "help_text": "", "name": "url", "verbose_name": "url" }
                    ]
                },
                "PDFType": {
                    "__is_enum": true,
                    "analytics_download": { "action_text": "Download Analytics", "extension": "pdf", "key": "analytics_download", "label": "Analytics Download", "path": "graphDownload", "value": 4 },
                    "list_download": { "action_text": "Download PDF", "extension": "pdf", "key": "list_download", "label": "List Download", "path": "inlineDownload", "value": 3 },
                    "profile_zip": { "action_text": "", "extension": "zip", "key": "profile_zip", "label": "Profile Zip", "path": "/profiledownload/", "value": 2 },
                    "search_download": { "action_text": "", "extension": "pdf", "key": "search_download", "label": "Search Download", "value": 1 }
                }
            }
        },
        "geography": {
            "models": {
                "CookRating": {
                    "Lean_Democrat": { "key": "Lean_Democrat", "label": "Lean Democrat", "value": 3 },
                    "Lean_Republican": { "key": "Lean_Republican", "label": "Lean Republican", "value": 6 },
                    "Likely_Democrat": { "key": "Likely_Democrat", "label": "Likely Democrat", "value": 2 },
                    "Likely_Republican": { "key": "Likely_Republican", "label": "Likely Republican", "value": 7 },
                    "Solid_Democrat": { "key": "Solid_Democrat", "label": "Solid Democrat", "value": 1 },
                    "Solid_Republican": { "key": "Solid_Republican", "label": "Solid Republican", "value": 8 },
                    "Tossup": { "key": "Tossup", "label": "Tossup", "value": 9 },
                    "Tossup_Democrat": { "key": "Tossup_Democrat", "label": "Tossup Democrat", "value": 4 },
                    "Tossup_Republican": { "key": "Tossup_Republican", "label": "Tossup Republican", "value": 5 },
                    "__is_enum": true
                },
                "Country": {
                    "__is_model": true,
                    "__name__": "Country",
                    "data_model": "app.geography.models.Country",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/country/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 2,
                            "help_text": "",
                            "miscellaneous": [82, 1],
                            "name": "name",
                            "sheet_column": true,
                            "verbose_name": "Country"
                        },
                        { "field_type": 2, "help_text": "the default help text", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "offical name in english", "name": "name_official", "verbose_name": "name official" },
                        { "field_type": 2, "help_text": "common name in english", "name": "name_common", "verbose_name": "name common" },
                        { "field_type": null, "help_text": "list of all native names, keyed on three-letter ISO 639-3 language code", "name": "name_native", "verbose_name": "name native" },
                        { "field_type": 2, "help_text": "name given by Intrado in english", "name": "name_intrado", "verbose_name": "name intrado" },
                        { "field_type": null, "help_text": "country code top-level domain", "name": "tld", "verbose_name": "tld" },
                        { "field_type": 2, "help_text": "code ISO 3166-1 alpha-2", "name": "cca2", "verbose_name": "cca2" },
                        { "field_type": 2, "help_text": "code ISO 3166-1 numeric", "name": "ccn3", "verbose_name": "ccn3" },
                        { "field_type": 2, "help_text": "code ISO 3166-1 alpha-3", "name": "cca3", "verbose_name": "cca3" },
                        { "field_type": 2, "help_text": "code International Olympic Committee", "name": "cioc", "verbose_name": "cioc" },
                        { "field_type": null, "help_text": "ISO 4217 currency code(blank=True, null=True, s)", "name": "currency", "verbose_name": "currency" },
                        { "field_type": null, "help_text": "callingCode", "name": "callingCode", "verbose_name": "callingCode" },
                        { "field_type": 2, "help_text": "capital of nation", "name": "capital", "verbose_name": "capital" },
                        { "field_type": null, "help_text": "list of alt spellings i.e. ['AW']", "name": "altSpellings", "verbose_name": "altSpellings" },
                        { "field_type": 2, "help_text": "region of world: ie Americas", "name": "region", "verbose_name": "region" },
                        { "field_type": 2, "help_text": "sub region i.e. Americas --> 'Caribbean'", "name": "subregion", "verbose_name": "subregion" },
                        { "field_type": null, "help_text": "list of official languages, key: three-letter ISO 639-3 language code, value: name of the language", "name": "languages", "verbose_name": "languages" },
                        { "field_type": null, "help_text": "list of name translations, key: three-letter ISO 639-3 language code, value: name object", "name": "translations", "verbose_name": "translations" },
                        { "field_type": null, "help_text": "lat long ex: [12.5, -69.96666666]", "name": "latlng", "verbose_name": "latlng" },
                        { "field_type": 2, "help_text": "name of residents", "name": "demonym", "verbose_name": "demonym" },
                        { "field_type": 1, "help_text": "landlocked status", "name": "landlocked", "verbose_name": "landlocked" },
                        { "field_type": null, "help_text": "boarder with countries", "name": "borders", "verbose_name": "borders" },
                        { "field_type": 4, "help_text": "size of nation in km^2", "name": "area", "verbose_name": "area" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bordering_nations",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "bordering nations"
                        }
                    ]
                },
                "County": {
                    "__is_model": true,
                    "__name__": "County",
                    "data_model": "app.geography.models.County",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/county/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "The total population in this geography", "name": "population", "verbose_name": "population" },
                        { "field_type": 4, "help_text": "", "name": "number", "verbose_name": "number" },
                        { "field_type": 2, "help_text": "String of number", "name": "number_string", "verbose_name": "number string" },
                        { "field_type": 4, "help_text": "5 digit county id", "name": "fips_code", "verbose_name": "fips code" },
                        { "field_type": 2, "help_text": "String of full fips", "name": "full_fips_string", "verbose_name": "full fips string" },
                        { "field_type": 2, "help_text": "", "name": "name", "sheet_column": true, "verbose_name": "County" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        }
                    ]
                },
                "District": {
                    "__is_model": true,
                    "__name__": "District",
                    "data_model": "app.geography.models.District",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/district/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "know who's last update", "name": "kw_DistrictID", "verbose_name": "kw DistrictID" },
                        { "field_type": 2, "help_text": "know who's district code", "name": "kw_DistrictCode", "verbose_name": "kw DistrictCode" },
                        { "field_type": 2, "help_text": "know who's chamber code", "name": "kw_Chamber", "verbose_name": "kw Chamber" },
                        { "field_type": 2, "help_text": "know who's district name", "name": "kw_Description", "verbose_name": "kw Description" },
                        { "field_type": 16, "help_text": "when know who updated last", "name": "kw_LastUpdated", "verbose_name": "kw LastUpdated" },
                        { "field_type": null, "help_text": "\n            Districts as defined by LeadershipConnect. To them, districts are whatever a\n            State calls a district. For example: Idaho, with seats A and B within a district,\n            has two unique districts, 18A and 18B. However, Arizona, with no seat designation\n            but two legislators per district, has one unique district for two people. Thus,\n            Districts that have multiple representatives will share a district ID, while\n            Districts split into seats explicitly by the state will have a different district ID\n        ", "name": "_ph_lc_district_ids", "verbose_name": " ph lc district ids" },
                        { "field_type": 4, "help_text": "", "name": "number", "verbose_name": "number" },
                        { "field_type": 4, "help_text": "4 digit district id", "name": "fips_code", "verbose_name": "fips code" },
                        { "field_type": 2, "help_text": "String of full fips", "name": "full_fips_string", "verbose_name": "full fips string" },
                        {
                            "field_type": 2,
                            "help_text": "",
                            "miscellaneous": [1, 109],
                            "name": "name",
                            "sheet_column": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Congressional District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "miscellaneous": [1, 8, 109],
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "sheet_column": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "state"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party in control",
                            "name": "controlling_party",
                            "verbose_name": "controlling party"
                        }
                    ]
                },
                "DistrictStats": {
                    "__is_model": true,
                    "__name__": "DistrictStats",
                    "data_model": "app.geography.models.DistrictStats",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/districtstats/"
                },
                "GeoShape": {
                    "__is_model": true,
                    "__name__": "GeoShape",
                    "data_model": "app.geography.models.GeoShape",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/geoshape/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.geography.types", "__name__": "GeoShapeType" },
                            "field_type": 4,
                            "help_text": "The actual geography type this shape represents, such as a legislative district or a city / municipality",
                            "name": "geo_shape_type",
                            "verbose_name": "geo shape type"
                        },
                        { "field_type": null, "help_text": "", "name": "mpoly", "verbose_name": "mpoly" },
                        { "field_type": 1, "help_text": "Whether the geo shape is currently being used (not outdated, e.g. 2013 Pennsylvania congressional districts)", "name": "current", "verbose_name": "current" },
                        { "field_type": 3, "help_text": "The human readable name of this GeoShape, e.g. Missouri Congressional District 18", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "The regional human readable name of this GeoShape. For example, if this GeoShape represents aCanadian Federal Electoral District, the name here would be in French.", "name": "regional_name", "verbose_name": "regional name" },
                        { "field_type": 3, "help_text": "The most-common abbreviation of this GeoShape, e.g. Missouri Congressional District 18 == MS-18", "name": "abbrev", "verbose_name": "abbrev" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Region enum this GeoShape will be associated with",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "parent_geo_shape",
                            "related_model": { "__module__": "app.geography.models", "__name__": "GeoShape" },
                            "verbose_name": "parent geo shape"
                        },
                        { "field_type": null, "help_text": "\n            a dictionary of unique IDs of how the GeoShapeFile is commonly referred to in shape files (.shp).\n            In the US, that would be FIPS code. In Canada, the Standard Geographical Classification (SGC)\n            is the best way to classify them.\n        ", "name": "unique_id_dict", "verbose_name": "unique id dict" },
                        { "field_type": 3, "help_text": "The most universally unique identifier for this GeoShape across the whole world", "name": "universal_unique_id", "verbose_name": "universal unique id" },
                        { "field_type": 3, "help_text": "The unique identifier for this GeoShape in the region it's relevant in (e.g. FIPS code in the US)", "name": "regional_unique_id", "verbose_name": "regional unique id" },
                        { "field_type": 21, "help_text": "The date this GeoShape started/starts to take effect, e.g. 1/1/2019 for new district shapes", "name": "start_date", "verbose_name": "start date" },
                        { "field_type": 21, "help_text": "The date this GeoShape stopped/stops being used, e.g. 12/31/2020 for 116th Congressional district shapes", "name": "end_date", "verbose_name": "end date" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "country"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "upper_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "upper ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "lower_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "lower ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "municipality"
                        },
                        { "field_type": 3, "help_text": "\n            For ZIP geoshapes, this is the top-level postal code associated with this geographical entity.\n            For now, this must be a five-character string parseable to a nonnegative integer.\n        ", "name": "postal_code", "verbose_name": "postal code" },
                        { "field_type": 3, "help_text": "\n            For US ZIP geoshapes, this is the low side of a ZIP+4 range within the postal_code\n            that corresponds to the geographical entity. This must be defined if postal_code is defined.\n            (If we start using international postal code targeting, that may change.)\n\n            This must be a four-character string parseable to a nonnegative integer.\n        ", "name": "postal_code_us_zip4_low", "verbose_name": "postal code us zip4 low" },
                        { "field_type": 3, "help_text": "\n            For US ZIP geoshapes, this is the high side of a ZIP+4 range within the postal_code\n            that corresponds to the geographical entity. This must be defined if postal_code is defined.\n            (If we start using international postal code targeting, that may change.)\n\n            This must be a four-character string parseable to a nonnegative integer.\n        ", "name": "postal_code_us_zip4_high", "verbose_name": "postal code us zip4 high" }
                    ]
                },
                "LowerLD": {
                    "__is_model": true,
                    "__name__": "LowerLD",
                    "data_model": "app.geography.models.LowerLD",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/lowerld/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "know who's last update", "name": "kw_DistrictID", "verbose_name": "kw DistrictID" },
                        { "field_type": 2, "help_text": "know who's district code", "name": "kw_DistrictCode", "verbose_name": "kw DistrictCode" },
                        { "field_type": 2, "help_text": "know who's chamber code", "name": "kw_Chamber", "verbose_name": "kw Chamber" },
                        { "field_type": 2, "help_text": "know who's district name", "name": "kw_Description", "verbose_name": "kw Description" },
                        { "field_type": 16, "help_text": "when know who updated last", "name": "kw_LastUpdated", "verbose_name": "kw LastUpdated" },
                        { "field_type": null, "help_text": "\n            Districts as defined by LeadershipConnect. To them, districts are whatever a\n            State calls a district. For example: Idaho, with seats A and B within a district,\n            has two unique districts, 18A and 18B. However, Arizona, with no seat designation\n            but two legislators per district, has one unique district for two people. Thus,\n            Districts that have multiple representatives will share a district ID, while\n            Districts split into seats explicitly by the state will have a different district ID\n        ", "name": "_ph_lc_district_ids", "verbose_name": " ph lc district ids" },
                        { "field_type": 4, "help_text": "4 State lower district id", "name": "number", "verbose_name": "number" },
                        { "field_type": 2, "help_text": "String of number", "name": "number_string", "verbose_name": "number string" },
                        { "field_type": 4, "help_text": "5 digit lower district id", "name": "fips_code", "verbose_name": "fips code" },
                        { "field_type": 2, "help_text": "String of full fips", "name": "full_fips_string", "verbose_name": "full fips string" },
                        { "field_type": 2, "help_text": "", "name": "name", "sheet_column": true, "verbose_name": "Lower State District" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party in control",
                            "name": "controlling_party",
                            "verbose_name": "controlling party"
                        },
                        { "field_type": 4, "help_text": "The state_district_id for this state district in Legistorm", "name": "_ph_ls_state_district_id", "verbose_name": " ph ls state district id" }
                    ]
                },
                "LowerLDStats": {
                    "__is_model": true,
                    "__name__": "LowerLDStats",
                    "data_model": "app.geography.models.LowerLDStats",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/lowerldstats/"
                },
                "Municipality": {
                    "__is_model": true,
                    "__name__": "Municipality",
                    "data_model": "app.geography.models.Municipality",
                    "default_exclude_filters": { "name__iregex": " (cdp|ccd|precinct)" },
                    "default_filters": {},
                    "endpoint": "/api/municipality/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "The total population in this geography", "name": "population", "verbose_name": "population" },
                        { "field_type": 4, "help_text": "Municipality number", "name": "number", "verbose_name": "number" },
                        { "field_type": 2, "help_text": "String of municipality number", "name": "number_string", "verbose_name": "number string" },
                        { "field_type": 4, "help_text": "7 or 10 digit municipality ID", "name": "fips_code", "verbose_name": "fips code" },
                        { "field_type": 2, "help_text": "String of full fips code", "name": "full_fips_string", "verbose_name": "full fips string" },
                        { "field_type": 2, "help_text": "The name of the Municipality", "name": "name", "verbose_name": "Municipality" },
                        {
                            "field_type": 7,
                            "help_text": "The county where this municipality resides",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The state where this municipality resides",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        }
                    ]
                },
                "PopulationStratum": {
                    "__is_enum": true,
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Large",
                            "values": [6, 7, 8]
                        },
                        {
                            "display": "list",
                            "title": "Midsized",
                            "values": [4, 5]
                        },
                        {
                            "display": "list",
                            "title": "Small",
                            "values": [1, 2, 3]
                        }
                    ],
                    "range_10000000_plus": { "end": 1000000000, "key": "range_10000000_plus", "label": "Above 10,000,000", "start": 10000000, "value": 8 },
                    "range_1000000_5000000": { "end": 5000000, "key": "range_1000000_5000000", "label": "1,000,000 to 5,000,000", "start": 1000000, "value": 6 },
                    "range_100000_500000": { "end": 500000, "key": "range_100000_500000", "label": "100,000 to 500,000", "start": 100000, "value": 4 },
                    "range_10000_100000": { "end": 100000, "key": "range_10000_100000", "label": "10,000 to 100,000", "start": 10000, "value": 3 },
                    "range_1000_10000": { "end": 10000, "key": "range_1000_10000", "label": "1,000 to 10,000", "start": 1000, "value": 2 },
                    "range_5000000_10000000": { "end": 10000000, "key": "range_5000000_10000000", "label": "5,000,000 to 10,000,000", "start": 5000000, "value": 7 },
                    "range_500000_1000000": { "end": 1000000, "key": "range_500000_1000000", "label": "500,000 to 1,000,000", "start": 500000, "value": 5 },
                    "range_under_1000": { "end": 1000, "key": "range_under_1000", "label": "Under 1,000", "start": 0, "value": 1 }
                },
                "RedistrictingStatus": {
                    "__is_enum": true,
                    "error": { "key": "error", "label": "Error", "value": 3 },
                    "precomputed": { "key": "precomputed", "label": "Precomputed", "value": 1 },
                    "update_applied": { "key": "update_applied", "label": "Update Applied", "value": 2 }
                },
                "State": {
                    "__is_model": true,
                    "__name__": "State",
                    "data_model": "app.geography.models.State",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/state/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "know who's last update", "name": "kw_DistrictID", "verbose_name": "kw DistrictID" },
                        { "field_type": 2, "help_text": "know who's district code", "name": "kw_DistrictCode", "verbose_name": "kw DistrictCode" },
                        { "field_type": 2, "help_text": "know who's chamber code", "name": "kw_Chamber", "verbose_name": "kw Chamber" },
                        { "field_type": 2, "help_text": "know who's district name", "name": "kw_Description", "verbose_name": "kw Description" },
                        { "field_type": 16, "help_text": "when know who updated last", "name": "kw_LastUpdated", "verbose_name": "kw LastUpdated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "field_type": 2,
                            "help_text": "",
                            "miscellaneous": 109,
                            "name": "name",
                            "sheet_column": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "State"
                        },
                        { "field_type": 2, "help_text": "", "name": "abbrev", "sheet_column": true, "sheets_column_order": 16, "verbose_name": "State Abbreviation" },
                        { "field_type": 4, "help_text": "Two Digit State Id", "name": "state_id", "verbose_name": "state id" },
                        { "field_type": 2, "help_text": "String of full fips", "name": "full_fips_string", "verbose_name": "full fips string" },
                        {
                            "field_type": 2,
                            "help_text": "Name of State Capital",
                            "miscellaneous": [82, 1, 8],
                            "name": "capital",
                            "sheet_column": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Capital"
                        },
                        {
                            "field_type": 1,
                            "help_text": "Whether or not the state is an actual US state or a territory.",
                            "miscellaneous": 82,
                            "name": "is_us_state",
                            "sheet_column": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "US State"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party in control senate wise",
                            "name": "senate_control",
                            "verbose_name": "State Senate Controlling Party"
                        },
                        { "field_type": 6, "help_text": "Percent of house seats controlled 0 is republican, 100 is democrats", "name": "pct_house_seat_control", "verbose_name": "% of House Controlled by Dem." },
                        { "field_type": 6, "help_text": "Percent of seats in senate", "name": "pct_state_senate_seat_control", "verbose_name": "% of State Senate Controlled by Dem." },
                        { "field_type": 6, "help_text": "Percent of seats in house", "name": "pct_state_house_seat_control", "verbose_name": "% of State House Controlled by Dem." }
                    ]
                },
                "StateStats": {
                    "__is_model": true,
                    "__name__": "StateStats",
                    "data_model": "app.geography.models.StateStats",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/statestats/"
                },
                "UpperLD": {
                    "__is_model": true,
                    "__name__": "UpperLD",
                    "data_model": "app.geography.models.UpperLD",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/upperld/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 4, "help_text": "know who's last update", "name": "kw_DistrictID", "verbose_name": "kw DistrictID" },
                        { "field_type": 2, "help_text": "know who's district code", "name": "kw_DistrictCode", "verbose_name": "kw DistrictCode" },
                        { "field_type": 2, "help_text": "know who's chamber code", "name": "kw_Chamber", "verbose_name": "kw Chamber" },
                        { "field_type": 2, "help_text": "know who's district name", "name": "kw_Description", "verbose_name": "kw Description" },
                        { "field_type": 16, "help_text": "when know who updated last", "name": "kw_LastUpdated", "verbose_name": "kw LastUpdated" },
                        { "field_type": null, "help_text": "\n            Districts as defined by LeadershipConnect. To them, districts are whatever a\n            State calls a district. For example: Idaho, with seats A and B within a district,\n            has two unique districts, 18A and 18B. However, Arizona, with no seat designation\n            but two legislators per district, has one unique district for two people. Thus,\n            Districts that have multiple representatives will share a district ID, while\n            Districts split into seats explicitly by the state will have a different district ID\n        ", "name": "_ph_lc_district_ids", "verbose_name": " ph lc district ids" },
                        { "field_type": 4, "help_text": "4 State Upper district id", "name": "number", "verbose_name": "number" },
                        { "field_type": 2, "help_text": "String of number", "name": "number_string", "verbose_name": "number string" },
                        { "field_type": 4, "help_text": "5 digit upper district id", "name": "fips_code", "verbose_name": "fips code" },
                        { "field_type": 2, "help_text": "String of full fips", "name": "full_fips_string", "verbose_name": "full fips string" },
                        { "field_type": 2, "help_text": "", "name": "name", "sheet_column": true, "verbose_name": "Upper State District" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party in control",
                            "name": "controlling_party",
                            "verbose_name": "controlling party"
                        },
                        { "field_type": 4, "help_text": "The state_district_id for this state district in Legistorm", "name": "_ph_ls_state_district_id", "verbose_name": " ph ls state district id" }
                    ]
                },
                "UpperLDStats": {
                    "__is_model": true,
                    "__name__": "UpperLDStats",
                    "data_model": "app.geography.models.UpperLDStats",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/upperldstats/"
                }
            },
            "types": {
                "GeoShapeType": {
                    "__is_enum": true,
                    "canadian_federal_electoral_district": {
                        "key": "canadian_federal_electoral_district",
                        "label": "Canadian Federal Electoral District",
                        "local_path": "gis/federal_electoral_districts_boundaries_2015_shp_en/FED_CA_2_2_ENG.shp",
                        "mapping": { "mpoly": "MULTIPOLYGON", "name": "ENNAME", "regional_name": "FRNAME", "universal_unique_id": "NID" },
                        "order": 10,
                        "parent_label": "State",
                        "simplification_tolerance": 0.001,
                        "source_url": "https://open.canada.ca/data/en/dataset/737be5ea-27cf-48a3-91d6-e835f11834b0",
                        "supported_regions": [201],
                        "value": 20
                    },
                    "composite_shape": {
                        "key": "composite_shape",
                        "label": "Composite Shape",
                        "mapping": {},
                        "order": 11,
                        "parent_label": "Parent",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 40
                    },
                    "country": {
                        "key": "country",
                        "label": "Country",
                        "local_path": "gis/NATION/TM_WORLD_BORDERS-0.3/TM_WORLD_BORDERS-0.3.shp",
                        "mapping": {},
                        "model_name": "Country",
                        "order": 5,
                        "parent_label": "Parent",
                        "region_type_label": "nation",
                        "simplification_tolerance": 0.001,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 203, 205, 207, 211, 215, 216, 217, 218, 219, 226, 238, 106, 9999, 10003],
                        "value": 1
                    },
                    "county": {
                        "key": "county",
                        "label": "County",
                        "local_path": "gis/COUNTY/tl_2018_us_county/tl_2018_us_county.shp",
                        "mapping": {},
                        "model_name": "County",
                        "order": 7,
                        "parent_label": "State",
                        "region_type_label": "county",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 4
                    },
                    "district": {
                        "key": "district",
                        "label": "Congressional District",
                        "local_path": "gis/CD/tl_2018_us_cd116/tl_2018_us_cd116.shp",
                        "mapping": {},
                        "model_name": "District",
                        "order": 3,
                        "parent_label": "State",
                        "region_type_label": "cd",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [1, 10000],
                        "value": 3
                    },
                    "intergovernmental_organization": {
                        "key": "intergovernmental_organization",
                        "label": "Intergovernmental Organization",
                        "mapping": {},
                        "order": 4,
                        "parent_label": "Parent",
                        "simplification_tolerance": 0.001,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 203, 205, 207, 211, 215, 216, 217, 218, 219, 226, 238, 106, 9999, 10003],
                        "value": 30
                    },
                    "lower_ld": {
                        "key": "lower_ld",
                        "label": "Lower Legislative District",
                        "local_path": "gis/SLDL/tl_2018_01_sldl/tl_2018_01_sldl.shp",
                        "mapping": {},
                        "model_name": "LowerLD",
                        "order": 9,
                        "parent_label": "State",
                        "region_type_label": "sldl",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6
                    },
                    "municipality": {
                        "key": "municipality",
                        "label": "Municipality",
                        "local_path": "gis/PLACE/tl_2017_01_place/tl_2017_01_place.shp",
                        "mapping": {},
                        "order": 6,
                        "parent_label": "State",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 7
                    },
                    "state": {
                        "key": "state",
                        "label": "State (Political Boundary)",
                        "local_path": "gis/STATE/tl_2017_us_state/tl_2017_us_state.shp",
                        "mapping": {},
                        "model_name": "State",
                        "order": 2,
                        "parent_label": "Country",
                        "region_type_label": "state",
                        "simplification_tolerance": 0.001,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 2
                    },
                    "state_land": {
                        "key": "state_land",
                        "label": "State",
                        "local_path": "gis/States_Land/States.shp",
                        "mapping": { "abbrev": "STUSPS", "mpoly": "MULTIPOLYGON", "name": "NAME", "regional_unique_id": "STATEFP", "universal_unique_id": "GEOID" },
                        "order": 1,
                        "parent_label": "Country",
                        "simplification_tolerance": 0.001,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 8
                    },
                    "upper_ld": {
                        "key": "upper_ld",
                        "label": "Upper Legislative District",
                        "local_path": "gis/SLDU/tl_2018_01_sldu/tl_2018_01_sldu.shp",
                        "mapping": {},
                        "model_name": "UpperLD",
                        "order": 8,
                        "parent_label": "State",
                        "region_type_label": "sldu",
                        "simplification_tolerance": 0.0005,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "zip_county": {
                        "key": "zip_county",
                        "label": "County ZIP+4 Range",
                        "mapping": {},
                        "order": 1002,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 1002
                    },
                    "zip_municipal": {
                        "key": "zip_municipal",
                        "label": "Municipal ZIP+4 Range",
                        "mapping": {},
                        "order": 1001,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 1001
                    }
                }
            }
        },
        "grassroots": {
            "campaign": {
                "models": {
                    "Campaign": {
                        "__is_model": true,
                        "__name__": "Campaign",
                        "data_model": "app.grassroots.campaign.models.Campaign",
                        "default_exclude_filters": { "status": 0 },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/campaign/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "creator",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 3, "help_text": "This field maps to the og:description and twitter:description fields. It's typically recommended to keep this less than 200 characters.", "name": "social_description", "verbose_name": "social description" },
                            { "field_type": 3, "help_text": "The URL of an image to display on social media. Typically square and at least 50px by 50px.", "name": "social_image_url", "verbose_name": "social image url" },
                            { "field_type": 3, "help_text": "An alternative text to be displayed in place of the image as a fallback or for sight-restricted individuals.", "name": "social_image_alttext", "verbose_name": "social image alttext" },
                            { "field_type": 3, "help_text": "The title of your page that will show up first in Twitter or Facebook.", "name": "social_title", "verbose_name": "social title" },
                            { "field_type": 3, "help_text": "If it is possible to control what is shared on social media when someone clicks a button to share a given page, what message should be shared.", "name": "social_share_text", "verbose_name": "social share text" },
                            { "field_type": 3, "help_text": "The keyword attached to this item used to redirect to the item if texted by a supporter", "name": "text_keyword", "verbose_name": "text keyword" },
                            { "field_type": 3, "help_text": "Text to use in response to an inbound text with this action center's keyword.", "name": "inbound_texting_reply_message", "verbose_name": "inbound texting reply message" },
                            {
                                "field_type": 7,
                                "help_text": "phone number used for inbound texting for this object",
                                "name": "phone_number",
                                "related_model": { "__module__": "app.texting.models", "__name__": "PhoneNumber" },
                                "verbose_name": "phone number"
                            },
                            { "field_type": 2, "help_text": "The subject of the confirmation email set by the user", "name": "conf_email_subject", "verbose_name": "conf email subject" },
                            { "field_type": 2, "help_text": "The from email address the Confirmation Email should be sent from", "name": "conf_email_from_address", "verbose_name": "conf email from address" },
                            { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to DEFAULT_CONFIRMATION_SEND_FROM_EMAIL", "name": "conf_email_from_name", "verbose_name": "conf email from name" },
                            { "field_type": 2, "help_text": "The name that should appear when replying to a confirmation email", "name": "conf_email_reply_to_name", "verbose_name": "conf email reply to name" },
                            { "field_type": 2, "help_text": "The reply_to address of the email the Confirmation Email should be sent to", "name": "conf_email_reply_to_address", "verbose_name": "conf email reply to address" },
                            { "field_type": 2, "help_text": "The from email username the Confirmation Email should be sent from", "name": "conf_email_from_address_username", "verbose_name": "conf email from address username" },
                            { "field_type": 2, "help_text": "The username portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_username", "verbose_name": "conf email reply to address username" },
                            { "field_type": 2, "help_text": "The domain portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_domain", "verbose_name": "conf email reply to address domain" },
                            {
                                "field_type": 7,
                                "help_text": "If not null, grassroots users taking action on this campaign will have confirmation emailssent to their email addresses",
                                "name": "email_template",
                                "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                                "verbose_name": "email template"
                            },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 3, "help_text": "", "name": "short_description", "verbose_name": "short description" },
                            { "field_type": 3, "help_text": "", "name": "long_description", "verbose_name": "long description" },
                            { "field_type": 2, "help_text": "", "name": "internal_only_name", "verbose_name": "internal only name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.document.types", "__name__": "Language" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "language",
                                "sheet_column": true,
                                "verbose_name": "Campaign Language"
                            },
                            { "field_type": 2, "help_text": "", "name": "url", "verbose_name": "url" },
                            { "field_type": 2, "help_text": "The vanity slug provided for a grassroots page. Will appear as /campaign/[slug]", "name": "vanity_url_slug", "verbose_name": "vanity url slug" },
                            { "field_type": 2, "help_text": "", "name": "to_email", "verbose_name": "to email" },
                            { "field_type": 1, "help_text": "If the campaign is publicly accessible", "name": "public", "verbose_name": "public" },
                            { "field_type": 1, "help_text": "If Supporters are allowed to take multiple actions", "name": "multiple_actions_allowed", "verbose_name": "multiple actions allowed" },
                            { "field_type": 1, "help_text": "", "name": "targets_district_office", "verbose_name": "targets district office" },
                            { "field_type": 1, "help_text": "", "name": "require_confirmation", "verbose_name": "require confirmation" },
                            { "field_type": 1, "help_text": "", "name": "can_login_with_facebook", "verbose_name": "can login with facebook" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignSubType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_subtype",
                                "verbose_name": "campaign subtype"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignStatus" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "status",
                                "sheet_column": true,
                                "verbose_name": "Status"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_type",
                                "sheet_column": true,
                                "verbose_name": "Campaign Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "action_center",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                                "verbose_name": "action center"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization_design",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                                "verbose_name": "organization design"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The registration page desired for this campaign. Will combine CampaignEnum required fields and form fields.",
                                "name": "registration_page",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                                "verbose_name": "registration page"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "TargetMemberOptions" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "target_members",
                                "verbose_name": "target members"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The policy area for this campaign.",
                                "name": "policy_area",
                                "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                                "verbose_name": "policy area"
                            },
                            { "field_type": 3, "help_text": "", "name": "custom_target", "verbose_name": "custom target" },
                            { "field_type": 2, "help_text": "", "name": "target_email", "verbose_name": "target email" },
                            { "field_type": 1, "help_text": "", "name": "uses_default_member_list", "verbose_name": "uses default member list" },
                            { "field_type": 1, "help_text": "", "name": "targets_legislators", "verbose_name": "targets legislators" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "default_targets_saved_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "default targets saved search"
                            },
                            { "field_type": null, "help_text": "supporter selection json for pre populations chooser", "name": "supporter_selection_json", "verbose_name": "supporter selection json" },
                            { "field_type": 16, "help_text": "", "name": "activated", "sheet_column": true, "verbose_name": "Date Activated" },
                            { "field_type": 16, "help_text": "", "name": "completed", "sheet_column": true, "verbose_name": "Date Completed" },
                            { "field_type": 16, "help_text": "", "name": "regulation_comments_end_date", "verbose_name": "regulation comments end date" },
                            { "field_type": 3, "help_text": "", "name": "draft_message", "verbose_name": "draft message" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "DraftOptions" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "draft_requirements",
                                "verbose_name": "draft requirements"
                            },
                            { "field_type": 2, "help_text": "", "name": "draft_subject", "verbose_name": "draft subject" },
                            { "field_type": 1, "help_text": "Allow advocates to select which legislators they want to target", "name": "supporters_can_choose_targets", "verbose_name": "supporters can choose targets" },
                            { "field_type": 1, "help_text": "", "name": "single_body_for_all_messages", "verbose_name": "single body for all messages" },
                            { "field_type": 3, "help_text": "", "name": "talking_points", "verbose_name": "talking points" },
                            { "field_type": 2, "help_text": "", "name": "schedule_subject", "verbose_name": "schedule subject" },
                            { "field_type": 3, "help_text": "", "name": "schedule_email", "verbose_name": "schedule email" },
                            { "field_type": null, "help_text": "", "name": "social_media_platforms", "verbose_name": "social media platforms" },
                            { "field_type": 2, "help_text": "", "name": "share_url", "verbose_name": "share url" },
                            { "field_type": 2, "help_text": "", "name": "share_image", "verbose_name": "share image" },
                            { "field_type": 2, "help_text": "", "name": "success_redirection_url", "verbose_name": "success redirection url" },
                            { "field_type": 4, "help_text": "", "name": "success_redirection_id", "verbose_name": "success redirection id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "lower_bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "lower bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "upper_bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "upper bill"
                            },
                            { "field_type": 3, "help_text": "", "name": "pos_message", "verbose_name": "pos message" },
                            { "field_type": 3, "help_text": "", "name": "neg_message", "verbose_name": "neg message" },
                            { "field_type": 2, "help_text": "", "name": "pos_subject", "verbose_name": "pos subject" },
                            { "field_type": 2, "help_text": "", "name": "neg_subject", "verbose_name": "neg subject" },
                            { "field_type": null, "help_text": "A cache of the members currently targeted by this campaign.", "name": "targeted_members_cache", "verbose_name": "targeted members cache" },
                            { "field_type": null, "help_text": "A cache of the regions the targeted members are in.", "name": "targeted_regions_cache", "verbose_name": "targeted regions cache" },
                            { "field_type": null, "help_text": "A cache of targeted members whom we wish to send message one.", "name": "message_one_target_cache", "verbose_name": "message one target cache" },
                            { "field_type": null, "help_text": "A cache of targeted members whom we wish to send message two.", "name": "message_two_target_cache", "verbose_name": "message two target cache" },
                            { "field_type": null, "help_text": "An array of possible subject lines for those receiving message one.", "name": "message_one_subject_array", "verbose_name": "message one subject array" },
                            { "field_type": null, "help_text": "An array of possible subject lines for those receiving message two.", "name": "message_two_subject_array", "verbose_name": "message two subject array" },
                            { "field_type": null, "help_text": "An array of possible content for those receiving message one.", "name": "message_one_content_array", "verbose_name": "message one content array" },
                            { "field_type": null, "help_text": "An array of possible content for those receiving message two.", "name": "message_two_content_array", "verbose_name": "message two content array" },
                            { "field_type": 3, "help_text": "A text field that will show before the editable body. Cannot be changed.", "name": "fixed_pre_message", "verbose_name": "fixed pre message" },
                            { "field_type": 3, "help_text": "A text field that will show after the editable body. Cannot be changed.", "name": "fixed_post_message", "verbose_name": "fixed post message" },
                            { "field_type": 3, "help_text": "A text field that will show before the editable body in a multiple draft campaign. Cannot be changed.", "name": "fixed_pre_message_two", "verbose_name": "fixed pre message two" },
                            { "field_type": 3, "help_text": "A text field that will show after the editable body in a multiple draft campaign. Cannot be changed.", "name": "fixed_post_message_two", "verbose_name": "fixed post message two" },
                            { "field_type": 4, "help_text": "The id of the parent campaign if this is a multi action campaign child", "name": "multi_action_parent_id", "verbose_name": "multi action parent id" },
                            { "field_type": null, "help_text": "", "name": "multi_messages", "verbose_name": "multi messages" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "lower_vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "lower vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "upper_vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "upper vote"
                            },
                            { "field_type": 2, "help_text": "", "name": "background_image", "verbose_name": "background image" },
                            { "field_type": 3, "help_text": "Alt text for the background image for accessibility purposes", "name": "background_image_alt_text", "verbose_name": "background image alt text" },
                            { "field_type": 1, "help_text": "", "name": "show_header", "verbose_name": "show header" },
                            { "field_type": 1, "help_text": "", "name": "show_subheader", "verbose_name": "show subheader" },
                            { "field_type": 1, "help_text": "", "name": "show_num_supporters", "verbose_name": "show num supporters" },
                            { "field_type": 1, "help_text": "", "name": "show_num_actions", "verbose_name": "show num actions" },
                            { "field_type": 1, "help_text": "Whether a supporter should be allowed to target any legislator rather than just theirs", "name": "allow_all_supporters_to_target_all_targets", "verbose_name": "allow all supporters to target all targets" },
                            { "field_type": 1, "help_text": "Whether to show the share icons on the thank you page after completing a campaign.", "name": "allow_sharing", "verbose_name": "allow sharing" },
                            { "field_type": 3, "help_text": "The message that a supporter will see after completing this campaign", "name": "thank_you_message", "verbose_name": "thank you message" },
                            { "field_type": 2, "help_text": "", "name": "regulation_id", "verbose_name": "regulation id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CommentCampaignOrganizationTypes" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_organization_type",
                                "verbose_name": "comment organization type"
                            },
                            { "field_type": 2, "help_text": "", "name": "submitting_organization_name", "verbose_name": "submitting organization name" },
                            { "field_type": 4, "help_text": "", "name": "order", "verbose_name": "order" },
                            { "field_type": 1, "help_text": "", "name": "visible_on_action_center", "verbose_name": "visible on action center" },
                            { "field_type": 1, "help_text": "", "name": "block_action_center", "verbose_name": "block action center" },
                            { "field_type": 3, "help_text": "", "name": "slug", "verbose_name": "slug" },
                            { "field_type": 16, "help_text": "Date on and after which a campaign has finished, and will automatically have it status set as completed.", "name": "expiration_datetime", "verbose_name": "expiration datetime" },
                            { "field_type": null, "help_text": "If campaign is a Log Interaction campaign, these are the available interaction types", "name": "interaction_types", "verbose_name": "interaction types" },
                            { "field_type": null, "help_text": "If campaign is a Log Relationship campaign, these are the available relationship types", "name": "relationship_types", "verbose_name": "relationship types" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignPageLayout" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "page_layout_type",
                                "verbose_name": "page layout type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignLayoutType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_layout",
                                "verbose_name": "campaign layout"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignDescriptionAlignment" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "description_alignment_type",
                                "verbose_name": "description alignment type"
                            },
                            { "field_type": 3, "help_text": "The custom call to action text an organization replaces for default 'Act Now' text", "name": "custom_call_to_action_text", "verbose_name": "custom call to action text" },
                            { "field_type": 3, "help_text": "The custom call to action button text an organization replaces for default 'Submit' text", "name": "custom_call_to_action_button_text", "verbose_name": "custom call to action button text" },
                            { "field_type": 4, "help_text": "The number of actions on a campaign", "name": "number_actions_count", "verbose_name": "number actions count" },
                            { "field_type": 4, "help_text": "The number of actions on a campaign in the last month", "name": "number_actions_last_month_count", "verbose_name": "number actions last month count" },
                            { "field_type": 4, "help_text": "The number of unique participants on a campaign", "name": "number_participants_count", "verbose_name": "number participants count" },
                            { "field_type": 4, "help_text": "The number of unique participants on a campaign in the last month", "name": "number_participants_last_month_count", "verbose_name": "number participants last month count" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationPointsMode" },
                                "field_type": 4,
                                "help_text": "How gamification points should be calculated",
                                "name": "gamification_points_mode",
                                "verbose_name": "gamification points mode"
                            },
                            { "field_type": 4, "help_text": "Custom Gamification points", "name": "custom_gamification_points", "verbose_name": "custom gamification points" },
                            { "field_type": 1, "help_text": "Always show to advocates, including those not signed in, even if they can't participate, for instance, if the campaign only targets specific supporters or regions", "name": "always_show_to_advocates", "verbose_name": "always show to advocates" },
                            { "field_type": 3, "help_text": "If defined for Custom Call to Action campaigns, video in link must be watched before campaign can be submitted", "name": "required_video_link", "verbose_name": "required video link" },
                            { "field_type": 3, "help_text": "The id the leadgen form generated on Facebook", "name": "facebook_leadgen_form_id", "verbose_name": "facebook leadgen form id" },
                            { "field_type": null, "help_text": "A JSON array of the questions generated from the form", "name": "facebook_leadgen_form_questions", "verbose_name": "facebook leadgen form questions" },
                            { "field_type": 3, "help_text": "Javascript that's run when the campaign loads", "name": "custom_javascript", "verbose_name": "custom javascript" },
                            { "field_type": 3, "help_text": "CSS that's only loaded when the campaign is up", "name": "custom_css", "verbose_name": "custom css" },
                            { "field_type": 3, "help_text": "Javascript that's run immediately after taking action", "name": "custom_thank_you_javascript", "verbose_name": "custom thank you javascript" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignNavigationBarType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "navigation_bar_type",
                                "verbose_name": "navigation bar type"
                            },
                            { "field_type": 1, "help_text": "Whether the background of the navigation bar should be transparent", "name": "navigation_bar_is_transparent", "verbose_name": "navigation bar is transparent" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignFullBleedHeaderType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "full_bleed_header_type",
                                "verbose_name": "full bleed header type"
                            },
                            { "field_type": 1, "help_text": "If text is displayed on full bleed header, whether it should be left aligned", "name": "full_bleed_header_text_is_left_aligned", "verbose_name": "full bleed header text is left aligned" },
                            { "field_type": 3, "help_text": "URL for image in full bleed header", "name": "full_bleed_header_image_url", "verbose_name": "full bleed header image url" },
                            { "field_type": 1, "help_text": "Whether the the whole image should be displayed in a full bleed image header", "name": "full_bleed_header_image_contain", "verbose_name": "full bleed header image contain" },
                            { "field_type": 3, "help_text": "URL for video in full bleed header", "name": "full_bleed_header_video_url", "verbose_name": "full bleed header video url" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignNameDisplayOptionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "summary_display_option_type",
                                "verbose_name": "summary display option type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterBackgroundStyle" },
                                "field_type": 4,
                                "help_text": "Background style for Action Center page containing campaign",
                                "name": "background_style_type",
                                "verbose_name": "background style type"
                            },
                            { "field_type": 3, "help_text": "Background image for Action Center page containing campaign", "name": "background_image_override_url", "verbose_name": "background image override url" },
                            { "field_type": 2, "help_text": "Background color for Action Center page containing campaign", "name": "background_color_override", "verbose_name": "background color override" },
                            { "field_type": 3, "help_text": "Logo for a Standalone Campaign page", "name": "logo_override_url", "verbose_name": "logo override url" },
                            { "field_type": 1, "help_text": "Whether or not an action center should display a custom footer using footer_html", "name": "should_use_footer_html", "verbose_name": "should use footer html" },
                            { "field_type": 3, "help_text": "The custom html the organization sets to be displayed as the footer instead of the standard 'Powered by Quorum' footer", "name": "footer_html", "verbose_name": "footer html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignTargetingType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "targeting_type",
                                "verbose_name": "targeting type"
                            },
                            { "field_type": 3, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "If enabled, registering on campaign page will automatically submit campaign action", "name": "is_one_click_registration_enabled", "verbose_name": "is one click registration enabled" },
                            { "field_type": null, "help_text": "", "name": "multi_action_ordered_children_ids", "verbose_name": "multi action ordered children ids" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "ShareStoryType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "share_story_type",
                                "verbose_name": "share story type"
                            },
                            { "field_type": 4, "help_text": "Duration of the video in seconds", "name": "share_story_video_duration", "verbose_name": "share story video duration" },
                            { "field_type": null, "help_text": "List of user IDs who have been notified about the campaign video", "name": "video_notified_users", "verbose_name": "video notified users" },
                            { "field_type": null, "help_text": "A JSON object for personalized message campaigns", "name": "personalized_campaign_pages", "verbose_name": "personalized campaign pages" },
                            { "field_type": 1, "help_text": "Whether or not the personalized message campaign should be reworked with AI", "name": "should_rework_with_ai", "verbose_name": "should rework with ai" },
                            { "field_type": null, "help_text": "A JSON object for AI options", "name": "ai_options", "verbose_name": "ai options" },
                            { "field_type": 1, "help_text": "Whether custom targeting is enabled for the campaign or not.", "name": "is_custom_targeting_enabled", "verbose_name": "is custom targeting enabled" },
                            { "field_type": 4, "help_text": "Allowed requests per second for live campaign in order to protect ourselves from HTTP flood", "name": "rate_limit", "verbose_name": "rate limit" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "admins",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "admins"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "primary_targets",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "primary targets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "primary_targets_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "primary targets saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "participants",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "participants"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "participants_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "participants saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "secondary_targets",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "secondary targets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "If the user has chosen to have multiple drafts, this saved search shows who should get the first message.",
                                "name": "secondary_targets_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "secondary targets saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Campaigns that are grouped under a combined campaign",
                                "name": "combined_campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "combined campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "This field is used to 'tag' a bill to a campaign in the campaign creation process",
                                "name": "tagged_bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "tagged bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "This field is used to 'tag' a regulation to a campaign in the campaign creation process",
                                "name": "tagged_regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "tagged regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "The custom fields associated with this campaign (Currently only for Interaction/Relationship campaigns)",
                                "name": "custom_fields",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                                "verbose_name": "custom fields"
                            },
                            {
                                "field_type": 8,
                                "help_text": "All the Bulk Upload Files that created/modified this record",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            }
                        ]
                    },
                    "CampaignInteractionType": {
                        "__is_model": true,
                        "__name__": "CampaignInteractionType",
                        "data_model": "app.grassroots.campaign.models.CampaignInteractionType",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/campaigninteractiontype/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "The campaign",
                                "name": "campaign",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaign"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The custom_interaction_types that can be logged",
                                "name": "custom_interaction_type",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                                "verbose_name": "custom interaction type"
                            }
                        ]
                    },
                    "GrassrootsCampaign": {
                        "__is_model": true,
                        "__name__": "GrassrootsCampaign",
                        "data_model": "app.grassroots.campaign.models.GrassrootsCampaign",
                        "default_exclude_filters": { "status": 0 },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/grassrootscampaign/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "creator",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 3, "help_text": "This field maps to the og:description and twitter:description fields. It's typically recommended to keep this less than 200 characters.", "name": "social_description", "verbose_name": "social description" },
                            { "field_type": 3, "help_text": "The URL of an image to display on social media. Typically square and at least 50px by 50px.", "name": "social_image_url", "verbose_name": "social image url" },
                            { "field_type": 3, "help_text": "An alternative text to be displayed in place of the image as a fallback or for sight-restricted individuals.", "name": "social_image_alttext", "verbose_name": "social image alttext" },
                            { "field_type": 3, "help_text": "The title of your page that will show up first in Twitter or Facebook.", "name": "social_title", "verbose_name": "social title" },
                            { "field_type": 3, "help_text": "If it is possible to control what is shared on social media when someone clicks a button to share a given page, what message should be shared.", "name": "social_share_text", "verbose_name": "social share text" },
                            { "field_type": 3, "help_text": "The keyword attached to this item used to redirect to the item if texted by a supporter", "name": "text_keyword", "verbose_name": "text keyword" },
                            { "field_type": 3, "help_text": "Text to use in response to an inbound text with this action center's keyword.", "name": "inbound_texting_reply_message", "verbose_name": "inbound texting reply message" },
                            {
                                "field_type": 7,
                                "help_text": "phone number used for inbound texting for this object",
                                "name": "phone_number",
                                "related_model": { "__module__": "app.texting.models", "__name__": "PhoneNumber" },
                                "verbose_name": "phone number"
                            },
                            { "field_type": 2, "help_text": "The subject of the confirmation email set by the user", "name": "conf_email_subject", "verbose_name": "conf email subject" },
                            { "field_type": 2, "help_text": "The from email address the Confirmation Email should be sent from", "name": "conf_email_from_address", "verbose_name": "conf email from address" },
                            { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to DEFAULT_CONFIRMATION_SEND_FROM_EMAIL", "name": "conf_email_from_name", "verbose_name": "conf email from name" },
                            { "field_type": 2, "help_text": "The name that should appear when replying to a confirmation email", "name": "conf_email_reply_to_name", "verbose_name": "conf email reply to name" },
                            { "field_type": 2, "help_text": "The reply_to address of the email the Confirmation Email should be sent to", "name": "conf_email_reply_to_address", "verbose_name": "conf email reply to address" },
                            { "field_type": 2, "help_text": "The from email username the Confirmation Email should be sent from", "name": "conf_email_from_address_username", "verbose_name": "conf email from address username" },
                            { "field_type": 2, "help_text": "The username portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_username", "verbose_name": "conf email reply to address username" },
                            { "field_type": 2, "help_text": "The domain portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_domain", "verbose_name": "conf email reply to address domain" },
                            {
                                "field_type": 7,
                                "help_text": "If not null, grassroots users taking action on this campaign will have confirmation emailssent to their email addresses",
                                "name": "email_template",
                                "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                                "verbose_name": "email template"
                            },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 3, "help_text": "", "name": "short_description", "verbose_name": "short description" },
                            { "field_type": 3, "help_text": "", "name": "long_description", "verbose_name": "long description" },
                            { "field_type": 2, "help_text": "", "name": "internal_only_name", "verbose_name": "internal only name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.document.types", "__name__": "Language" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "language",
                                "sheet_column": true,
                                "verbose_name": "Campaign Language"
                            },
                            { "field_type": 2, "help_text": "", "name": "url", "verbose_name": "url" },
                            { "field_type": 2, "help_text": "The vanity slug provided for a grassroots page. Will appear as /campaign/[slug]", "name": "vanity_url_slug", "verbose_name": "vanity url slug" },
                            { "field_type": 2, "help_text": "", "name": "to_email", "verbose_name": "to email" },
                            { "field_type": 1, "help_text": "If the campaign is publicly accessible", "name": "public", "verbose_name": "public" },
                            { "field_type": 1, "help_text": "If Supporters are allowed to take multiple actions", "name": "multiple_actions_allowed", "verbose_name": "multiple actions allowed" },
                            { "field_type": 1, "help_text": "", "name": "targets_district_office", "verbose_name": "targets district office" },
                            { "field_type": 1, "help_text": "", "name": "require_confirmation", "verbose_name": "require confirmation" },
                            { "field_type": 1, "help_text": "", "name": "can_login_with_facebook", "verbose_name": "can login with facebook" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignSubType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_subtype",
                                "verbose_name": "campaign subtype"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignStatus" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "status",
                                "sheet_column": true,
                                "verbose_name": "Status"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_type",
                                "sheet_column": true,
                                "verbose_name": "Campaign Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "action_center",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                                "verbose_name": "action center"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization_design",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                                "verbose_name": "organization design"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The registration page desired for this campaign. Will combine CampaignEnum required fields and form fields.",
                                "name": "registration_page",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                                "verbose_name": "registration page"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "TargetMemberOptions" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "target_members",
                                "verbose_name": "target members"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The policy area for this campaign.",
                                "name": "policy_area",
                                "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                                "verbose_name": "policy area"
                            },
                            { "field_type": 3, "help_text": "", "name": "custom_target", "verbose_name": "custom target" },
                            { "field_type": 2, "help_text": "", "name": "target_email", "verbose_name": "target email" },
                            { "field_type": 1, "help_text": "", "name": "uses_default_member_list", "verbose_name": "uses default member list" },
                            { "field_type": 1, "help_text": "", "name": "targets_legislators", "verbose_name": "targets legislators" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "default_targets_saved_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "default targets saved search"
                            },
                            { "field_type": null, "help_text": "supporter selection json for pre populations chooser", "name": "supporter_selection_json", "verbose_name": "supporter selection json" },
                            { "field_type": 16, "help_text": "", "name": "activated", "sheet_column": true, "verbose_name": "Date Activated" },
                            { "field_type": 16, "help_text": "", "name": "completed", "sheet_column": true, "verbose_name": "Date Completed" },
                            { "field_type": 16, "help_text": "", "name": "regulation_comments_end_date", "verbose_name": "regulation comments end date" },
                            { "field_type": 3, "help_text": "", "name": "draft_message", "verbose_name": "draft message" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "DraftOptions" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "draft_requirements",
                                "verbose_name": "draft requirements"
                            },
                            { "field_type": 2, "help_text": "", "name": "draft_subject", "verbose_name": "draft subject" },
                            { "field_type": 1, "help_text": "Allow advocates to select which legislators they want to target", "name": "supporters_can_choose_targets", "verbose_name": "supporters can choose targets" },
                            { "field_type": 1, "help_text": "", "name": "single_body_for_all_messages", "verbose_name": "single body for all messages" },
                            { "field_type": 3, "help_text": "", "name": "talking_points", "verbose_name": "talking points" },
                            { "field_type": 2, "help_text": "", "name": "schedule_subject", "verbose_name": "schedule subject" },
                            { "field_type": 3, "help_text": "", "name": "schedule_email", "verbose_name": "schedule email" },
                            { "field_type": null, "help_text": "", "name": "social_media_platforms", "verbose_name": "social media platforms" },
                            { "field_type": 2, "help_text": "", "name": "share_url", "verbose_name": "share url" },
                            { "field_type": 2, "help_text": "", "name": "share_image", "verbose_name": "share image" },
                            { "field_type": 2, "help_text": "", "name": "success_redirection_url", "verbose_name": "success redirection url" },
                            { "field_type": 4, "help_text": "", "name": "success_redirection_id", "verbose_name": "success redirection id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "lower_bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "lower bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "upper_bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "upper bill"
                            },
                            { "field_type": 3, "help_text": "", "name": "pos_message", "verbose_name": "pos message" },
                            { "field_type": 3, "help_text": "", "name": "neg_message", "verbose_name": "neg message" },
                            { "field_type": 2, "help_text": "", "name": "pos_subject", "verbose_name": "pos subject" },
                            { "field_type": 2, "help_text": "", "name": "neg_subject", "verbose_name": "neg subject" },
                            { "field_type": null, "help_text": "A cache of the members currently targeted by this campaign.", "name": "targeted_members_cache", "verbose_name": "targeted members cache" },
                            { "field_type": null, "help_text": "A cache of the regions the targeted members are in.", "name": "targeted_regions_cache", "verbose_name": "targeted regions cache" },
                            { "field_type": null, "help_text": "A cache of targeted members whom we wish to send message one.", "name": "message_one_target_cache", "verbose_name": "message one target cache" },
                            { "field_type": null, "help_text": "A cache of targeted members whom we wish to send message two.", "name": "message_two_target_cache", "verbose_name": "message two target cache" },
                            { "field_type": null, "help_text": "An array of possible subject lines for those receiving message one.", "name": "message_one_subject_array", "verbose_name": "message one subject array" },
                            { "field_type": null, "help_text": "An array of possible subject lines for those receiving message two.", "name": "message_two_subject_array", "verbose_name": "message two subject array" },
                            { "field_type": null, "help_text": "An array of possible content for those receiving message one.", "name": "message_one_content_array", "verbose_name": "message one content array" },
                            { "field_type": null, "help_text": "An array of possible content for those receiving message two.", "name": "message_two_content_array", "verbose_name": "message two content array" },
                            { "field_type": 3, "help_text": "A text field that will show before the editable body. Cannot be changed.", "name": "fixed_pre_message", "verbose_name": "fixed pre message" },
                            { "field_type": 3, "help_text": "A text field that will show after the editable body. Cannot be changed.", "name": "fixed_post_message", "verbose_name": "fixed post message" },
                            { "field_type": 3, "help_text": "A text field that will show before the editable body in a multiple draft campaign. Cannot be changed.", "name": "fixed_pre_message_two", "verbose_name": "fixed pre message two" },
                            { "field_type": 3, "help_text": "A text field that will show after the editable body in a multiple draft campaign. Cannot be changed.", "name": "fixed_post_message_two", "verbose_name": "fixed post message two" },
                            { "field_type": 4, "help_text": "The id of the parent campaign if this is a multi action campaign child", "name": "multi_action_parent_id", "verbose_name": "multi action parent id" },
                            { "field_type": null, "help_text": "", "name": "multi_messages", "verbose_name": "multi messages" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "lower_vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "lower vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "upper_vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "upper vote"
                            },
                            { "field_type": 2, "help_text": "", "name": "background_image", "verbose_name": "background image" },
                            { "field_type": 3, "help_text": "Alt text for the background image for accessibility purposes", "name": "background_image_alt_text", "verbose_name": "background image alt text" },
                            { "field_type": 1, "help_text": "", "name": "show_header", "verbose_name": "show header" },
                            { "field_type": 1, "help_text": "", "name": "show_subheader", "verbose_name": "show subheader" },
                            { "field_type": 1, "help_text": "", "name": "show_num_supporters", "verbose_name": "show num supporters" },
                            { "field_type": 1, "help_text": "", "name": "show_num_actions", "verbose_name": "show num actions" },
                            { "field_type": 1, "help_text": "Whether a supporter should be allowed to target any legislator rather than just theirs", "name": "allow_all_supporters_to_target_all_targets", "verbose_name": "allow all supporters to target all targets" },
                            { "field_type": 1, "help_text": "Whether to show the share icons on the thank you page after completing a campaign.", "name": "allow_sharing", "verbose_name": "allow sharing" },
                            { "field_type": 3, "help_text": "The message that a supporter will see after completing this campaign", "name": "thank_you_message", "verbose_name": "thank you message" },
                            { "field_type": 2, "help_text": "", "name": "regulation_id", "verbose_name": "regulation id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CommentCampaignOrganizationTypes" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_organization_type",
                                "verbose_name": "comment organization type"
                            },
                            { "field_type": 2, "help_text": "", "name": "submitting_organization_name", "verbose_name": "submitting organization name" },
                            { "field_type": 4, "help_text": "", "name": "order", "verbose_name": "order" },
                            { "field_type": 1, "help_text": "", "name": "visible_on_action_center", "verbose_name": "visible on action center" },
                            { "field_type": 1, "help_text": "", "name": "block_action_center", "verbose_name": "block action center" },
                            { "field_type": 3, "help_text": "", "name": "slug", "verbose_name": "slug" },
                            { "field_type": 16, "help_text": "Date on and after which a campaign has finished, and will automatically have it status set as completed.", "name": "expiration_datetime", "verbose_name": "expiration datetime" },
                            { "field_type": null, "help_text": "If campaign is a Log Interaction campaign, these are the available interaction types", "name": "interaction_types", "verbose_name": "interaction types" },
                            { "field_type": null, "help_text": "If campaign is a Log Relationship campaign, these are the available relationship types", "name": "relationship_types", "verbose_name": "relationship types" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignPageLayout" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "page_layout_type",
                                "verbose_name": "page layout type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignLayoutType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "campaign_layout",
                                "verbose_name": "campaign layout"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignDescriptionAlignment" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "description_alignment_type",
                                "verbose_name": "description alignment type"
                            },
                            { "field_type": 3, "help_text": "The custom call to action text an organization replaces for default 'Act Now' text", "name": "custom_call_to_action_text", "verbose_name": "custom call to action text" },
                            { "field_type": 3, "help_text": "The custom call to action button text an organization replaces for default 'Submit' text", "name": "custom_call_to_action_button_text", "verbose_name": "custom call to action button text" },
                            { "field_type": 4, "help_text": "The number of actions on a campaign", "name": "number_actions_count", "verbose_name": "number actions count" },
                            { "field_type": 4, "help_text": "The number of actions on a campaign in the last month", "name": "number_actions_last_month_count", "verbose_name": "number actions last month count" },
                            { "field_type": 4, "help_text": "The number of unique participants on a campaign", "name": "number_participants_count", "verbose_name": "number participants count" },
                            { "field_type": 4, "help_text": "The number of unique participants on a campaign in the last month", "name": "number_participants_last_month_count", "verbose_name": "number participants last month count" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationPointsMode" },
                                "field_type": 4,
                                "help_text": "How gamification points should be calculated",
                                "name": "gamification_points_mode",
                                "verbose_name": "gamification points mode"
                            },
                            { "field_type": 4, "help_text": "Custom Gamification points", "name": "custom_gamification_points", "verbose_name": "custom gamification points" },
                            { "field_type": 1, "help_text": "Always show to advocates, including those not signed in, even if they can't participate, for instance, if the campaign only targets specific supporters or regions", "name": "always_show_to_advocates", "verbose_name": "always show to advocates" },
                            { "field_type": 3, "help_text": "If defined for Custom Call to Action campaigns, video in link must be watched before campaign can be submitted", "name": "required_video_link", "verbose_name": "required video link" },
                            { "field_type": 3, "help_text": "The id the leadgen form generated on Facebook", "name": "facebook_leadgen_form_id", "verbose_name": "facebook leadgen form id" },
                            { "field_type": null, "help_text": "A JSON array of the questions generated from the form", "name": "facebook_leadgen_form_questions", "verbose_name": "facebook leadgen form questions" },
                            { "field_type": 3, "help_text": "Javascript that's run when the campaign loads", "name": "custom_javascript", "verbose_name": "custom javascript" },
                            { "field_type": 3, "help_text": "CSS that's only loaded when the campaign is up", "name": "custom_css", "verbose_name": "custom css" },
                            { "field_type": 3, "help_text": "Javascript that's run immediately after taking action", "name": "custom_thank_you_javascript", "verbose_name": "custom thank you javascript" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignNavigationBarType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "navigation_bar_type",
                                "verbose_name": "navigation bar type"
                            },
                            { "field_type": 1, "help_text": "Whether the background of the navigation bar should be transparent", "name": "navigation_bar_is_transparent", "verbose_name": "navigation bar is transparent" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignFullBleedHeaderType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "full_bleed_header_type",
                                "verbose_name": "full bleed header type"
                            },
                            { "field_type": 1, "help_text": "If text is displayed on full bleed header, whether it should be left aligned", "name": "full_bleed_header_text_is_left_aligned", "verbose_name": "full bleed header text is left aligned" },
                            { "field_type": 3, "help_text": "URL for image in full bleed header", "name": "full_bleed_header_image_url", "verbose_name": "full bleed header image url" },
                            { "field_type": 1, "help_text": "Whether the the whole image should be displayed in a full bleed image header", "name": "full_bleed_header_image_contain", "verbose_name": "full bleed header image contain" },
                            { "field_type": 3, "help_text": "URL for video in full bleed header", "name": "full_bleed_header_video_url", "verbose_name": "full bleed header video url" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignNameDisplayOptionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "summary_display_option_type",
                                "verbose_name": "summary display option type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterBackgroundStyle" },
                                "field_type": 4,
                                "help_text": "Background style for Action Center page containing campaign",
                                "name": "background_style_type",
                                "verbose_name": "background style type"
                            },
                            { "field_type": 3, "help_text": "Background image for Action Center page containing campaign", "name": "background_image_override_url", "verbose_name": "background image override url" },
                            { "field_type": 2, "help_text": "Background color for Action Center page containing campaign", "name": "background_color_override", "verbose_name": "background color override" },
                            { "field_type": 3, "help_text": "Logo for a Standalone Campaign page", "name": "logo_override_url", "verbose_name": "logo override url" },
                            { "field_type": 1, "help_text": "Whether or not an action center should display a custom footer using footer_html", "name": "should_use_footer_html", "verbose_name": "should use footer html" },
                            { "field_type": 3, "help_text": "The custom html the organization sets to be displayed as the footer instead of the standard 'Powered by Quorum' footer", "name": "footer_html", "verbose_name": "footer html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignTargetingType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "targeting_type",
                                "verbose_name": "targeting type"
                            },
                            { "field_type": 3, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "If enabled, registering on campaign page will automatically submit campaign action", "name": "is_one_click_registration_enabled", "verbose_name": "is one click registration enabled" },
                            { "field_type": null, "help_text": "", "name": "multi_action_ordered_children_ids", "verbose_name": "multi action ordered children ids" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "ShareStoryType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "share_story_type",
                                "verbose_name": "share story type"
                            },
                            { "field_type": 4, "help_text": "Duration of the video in seconds", "name": "share_story_video_duration", "verbose_name": "share story video duration" },
                            { "field_type": null, "help_text": "List of user IDs who have been notified about the campaign video", "name": "video_notified_users", "verbose_name": "video notified users" },
                            { "field_type": null, "help_text": "A JSON object for personalized message campaigns", "name": "personalized_campaign_pages", "verbose_name": "personalized campaign pages" },
                            { "field_type": 1, "help_text": "Whether or not the personalized message campaign should be reworked with AI", "name": "should_rework_with_ai", "verbose_name": "should rework with ai" },
                            { "field_type": null, "help_text": "A JSON object for AI options", "name": "ai_options", "verbose_name": "ai options" },
                            { "field_type": 1, "help_text": "Whether custom targeting is enabled for the campaign or not.", "name": "is_custom_targeting_enabled", "verbose_name": "is custom targeting enabled" },
                            { "field_type": 4, "help_text": "Allowed requests per second for live campaign in order to protect ourselves from HTTP flood", "name": "rate_limit", "verbose_name": "rate limit" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "admins",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "admins"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "primary_targets",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "primary targets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "primary_targets_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "primary targets saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "participants",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "participants"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "participants_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "participants saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "secondary_targets",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "secondary targets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "If the user has chosen to have multiple drafts, this saved search shows who should get the first message.",
                                "name": "secondary_targets_saved_searches",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "secondary targets saved searches"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Campaigns that are grouped under a combined campaign",
                                "name": "combined_campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "combined campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "This field is used to 'tag' a bill to a campaign in the campaign creation process",
                                "name": "tagged_bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "tagged bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "This field is used to 'tag' a regulation to a campaign in the campaign creation process",
                                "name": "tagged_regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "tagged regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "The custom fields associated with this campaign (Currently only for Interaction/Relationship campaigns)",
                                "name": "custom_fields",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                                "verbose_name": "custom fields"
                            },
                            {
                                "field_type": 8,
                                "help_text": "All the Bulk Upload Files that created/modified this record",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            }
                        ],
                        "proxy_endpoint": "/api/campaign/"
                    }
                },
                "types": {
                    "CampaignDescriptionAlignment": {
                        "__is_enum": true,
                        "bottom_right": { "key": "bottom_right", "label": "Bottom", "tip": "Campaign description is displayed after the sign up widget. Best for campaigns with images, videos, or long descriptions.", "value": 2 },
                        "top_left": { "key": "top_left", "label": "Top", "tip": "Campaign description is displayed before the sign up widget. Best for campaigns with short descriptions.", "value": 1 }
                    },
                    "CampaignFullBleedHeaderType": {
                        "__is_enum": true,
                        "image": { "key": "image", "label": "Image", "order": 2, "tip": "Show a full bleed image above your campaign", "value": 2 },
                        "none": { "key": "none", "label": "None", "order": 1, "tip": "No full bleed header above your campaign", "value": 1 },
                        "video": { "key": "video", "label": "Video", "order": 3, "tip": "Show a full bleed video above your campaign", "value": 3 }
                    },
                    "CampaignLayoutType": {
                        "__is_enum": true,
                        "embedded": { "description": "This campaign can be embedded separately onto a unique website.", "icon": "code", "iconFamily": "far", "key": "embedded", "label": "3", "title": "Embedded Campaign", "value": 3 },
                        "standalone": { "description": "A one-page campaign that is available via link separate from Action Center.", "icon": "file-alt", "iconFamily": "far", "key": "standalone", "label": "2", "title": "Standalone Campaign", "value": 2 },
                        "standard": { "description": "This campaign resides in the list of the Action Center page and has its own page.", "icon": "bullhorn", "iconFamily": "far", "key": "standard", "label": "1", "title": "Standard Campaign", "value": 1 }
                    },
                    "CampaignNameDisplayOptionType": {
                        "__is_enum": true,
                        "include_in_main_text": { "key": "include_in_main_text", "label": "Include in main text", "order": 3, "tip": "Include your campaign name in the text of your campaign", "value": 3 },
                        "none": { "key": "none", "label": "None", "order": 1, "tip": "Do not display your campaign name on your campaign page", "value": 1 },
                        "overlay_header": { "key": "overlay_header", "label": "Overlay page header", "order": 2, "tip": "Overlay your campaign name on your full bleed header above your campaign", "value": 2 }
                    },
                    "CampaignNavigationBarType": {
                        "__is_enum": true,
                        "logo_only": { "key": "logo_only", "label": "Logo", "order": 1, "tip": "A header only containing your logo, centered horizontally", "value": 2 },
                        "none": { "key": "none", "label": "None", "order": 3, "tip": "No header for your campaign", "value": 3 },
                        "standard": { "key": "standard", "label": "Logo and global navigation", "order": 2, "tip": "The standard navigation bar from other pages of your Action Center", "value": 1 }
                    },
                    "CampaignPageLayout": {
                        "__is_enum": true,
                        "two_columns": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsCampaignLayouts/columnsActive.png", "column_width": 6, "icon": "fa-columns", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsCampaignLayouts/columnsInactive.png", "key": "two_columns", "label": "Two columns", "tip": "Content is split into two columns. Best for campaigns with images, videos, or long descriptions.", "value": 1 },
                        "two_rows": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsCampaignLayouts/rowsActive.png", "column_width": 12, "icon": "fa-columns fa-rotate-270", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsCampaignLayouts/rowsInactive.png", "key": "two_rows", "label": "Two rows", "tip": "Content is split into two rows. Best for campaigns with short descriptions.", "value": 2 }
                    },
                    "CampaignPostSubmissionActionType": {
                        "__is_enum": true,
                        "another_campaign": { "key": "another_campaign", "label": "Another Campaign", "value": 2 },
                        "donation_form": { "key": "donation_form", "label": "Donation Form", "value": 4 },
                        "external_link": { "key": "external_link", "label": "External Link", "value": 3 },
                        "thank_you": { "key": "thank_you", "label": "A Thank You Page", "value": 1 }
                    },
                    "CampaignStatus": {
                        "__is_enum": true,
                        "active": { "key": "active", "label": "Active", "value": 2 },
                        "complete": { "key": "complete", "label": "Complete", "value": 3 },
                        "discarded_draft": { "key": "discarded_draft", "label": "Discarded Draft", "value": 0 },
                        "draft": { "key": "draft", "label": "Draft", "value": 1 },
                        "p2aActive": { "key": "p2aActive", "label": "P2A Active", "value": 4 }
                    },
                    "CampaignTargetingType": {
                        "__is_enum": true,
                        "advocate_address": { "key": "advocate_address", "label": "Advocate's address", "order": 1, "tip": "Target based on advocate's address in Quorum", "value": 1 },
                        "advocate_address_and_organizations": { "key": "advocate_address_and_organizations", "label": "Both", "order": 3, "tip": "Target both the advocate's address and related organizations' addresses", "value": 3 },
                        "advocate_organizations_addresses": { "key": "advocate_organizations_addresses", "label": "Advocate's organizations' addresses", "order": 2, "tip": "Target based on the addresses of the advocate's related organizations", "value": 2 }
                    },
                    "CampaignType": {
                        "__is_enum": true,
                        "authorized_contribution": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "icon": "fa-pencil-square-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 108,
                            "is_enabled_for_campaign_form": false,
                            "key": "authorized_contribution",
                            "label": "Authorized Contribution",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [],
                            "targets_members": false,
                            "value": 103
                        },
                        "bills": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "bills",
                            "label": "Learn About Bills",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 14
                        },
                        "call": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": true,
                            "gamification_default_point_value": 10,
                            "i18n_verb_key": "campaign.call.verb",
                            "icon": "fa-phone",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": true,
                            "interaction_type": 50,
                            "is_enabled_for_campaign_form": true,
                            "key": "call",
                            "label": "Call a Number",
                            "minimal_label": "Call",
                            "minimal_tip": "Grassroots contacts call the capitol or district office of legislators or a custom number.",
                            "new_icon": "phone",
                            "order": 5,
                            "permission_enum": [],
                            "required_data_key": "most_recent_role__phone",
                            "required_registration_fields": [4, 3, 5],
                            "targets_members": true,
                            "value": 5
                        },
                        "combined_campaign": {
                            "allow_one_click_registration": true,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.combined_campaign.verb",
                            "icon": "fa-share-alt",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 48,
                            "is_enabled_for_campaign_form": true,
                            "key": "combined_campaign",
                            "label": "Combined Campaign",
                            "minimal_tip": "Grassroots contacts participate in multiple campaigns at once.",
                            "new_icon": "users",
                            "order": 4,
                            "permission_enum": [],
                            "required_registration_fields": [1, 2, 5, 4],
                            "targets_members": false,
                            "value": 19
                        },
                        "comment_on_regulation": {
                            "allow_one_click_registration": true,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.comment_on_regulation.verb",
                            "icon": "fa-comment-o",
                            "in_combined_campaign": true,
                            "in_multi_action_campaign": true,
                            "interaction_type": 44,
                            "is_enabled_for_campaign_form": true,
                            "key": "comment_on_regulation",
                            "label": "Comment on Regulation",
                            "minimal_label": "Comment",
                            "minimal_tip": "Grassroots contacts submit a comment on a pending regulation.",
                            "new_icon": "comment",
                            "order": 7,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 15
                        },
                        "contact_us": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "icon": "fa-envelope-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 109,
                            "is_enabled_for_campaign_form": false,
                            "key": "contact_us",
                            "label": "Contact Us",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [],
                            "targets_members": false,
                            "value": 26
                        },
                        "custom": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.custom.verb",
                            "icon": "fa-user",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "custom",
                            "label": "Custom",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": true,
                            "value": 1
                        },
                        "custom_points": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "icon": "fa-star",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 104,
                            "is_enabled_for_campaign_form": false,
                            "key": "custom_points",
                            "label": "Custom Points",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [],
                            "targets_members": false,
                            "value": 102
                        },
                        "donate": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.petition.verb",
                            "icon": "fa-usd",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": true,
                            "key": "donate",
                            "label": "Donate",
                            "minimal_tip": "Set a donation form to a campaign.",
                            "new_icon": "dollar-sign",
                            "order": 15,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 22
                        },
                        "election_info": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.election_info.verb",
                            "icon": "fa-sticky-note-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 107,
                            "is_enabled_for_campaign_form": false,
                            "key": "election_info",
                            "label": "Election Info",
                            "minimal_tip": "Present your grassroots advocates with an Election Info widget.",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 25
                        },
                        "gotv": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.gotv.verb",
                            "icon": "fa-sticky-note-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 105,
                            "is_enabled_for_campaign_form": true,
                            "key": "gotv",
                            "label": "Get Out the Vote",
                            "minimal_tip": "Present your grassroots advocates with a Get Out the Vote widget.",
                            "new_icon": "file",
                            "order": 12,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 23
                        },
                        "grassroots_story": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 3,
                            "i18n_verb_key": "campaign.grassroots_story.verb",
                            "icon": "fa-user",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 45,
                            "is_enabled_for_campaign_form": true,
                            "key": "grassroots_story",
                            "label": "Share a Story",
                            "minimal_tip": "Grassroots contacts share their stories via video and/or text.",
                            "new_icon": "comment",
                            "order": 8,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 17
                        },
                        "interaction": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "interaction",
                            "label": "Interact",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 3
                        },
                        "issues": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "issues",
                            "label": "Issues",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 6
                        },
                        "learn_about_member": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "learn_about_member",
                            "label": "About Your Member",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 13
                        },
                        "log_interaction": {
                            "action_center_settings_field_key": "external_interaction_types",
                            "allow_one_click_registration": false,
                            "campaign_field_key": "interaction_types",
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.log_interaction.verb",
                            "icon": "fa-handshake-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 52,
                            "is_enabled_for_campaign_form": true,
                            "key": "log_interaction",
                            "label": "Log Interaction",
                            "minimal_tip": "Log an interaction with a member of congress.",
                            "new_icon": "handshake",
                            "note_field_key": "interaction_type",
                            "order": 9,
                            "permission_enum": [7],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 20
                        },
                        "log_relationship": {
                            "action_center_settings_field_key": "external_relationship_types",
                            "allow_one_click_registration": false,
                            "campaign_field_key": "relationship_types",
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.log_interaction.verb",
                            "icon": "fa-handshake-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 52,
                            "is_enabled_for_campaign_form": true,
                            "key": "log_relationship",
                            "label": "Log Relationship",
                            "minimal_tip": "Log a relationship with a member of congress.",
                            "new_icon": "handshake",
                            "note_field_key": "relationship_type",
                            "order": 10,
                            "permission_enum": [5],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 21
                        },
                        "multi_action": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "campaign.multi_action.verb",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": true,
                            "key": "multi_action",
                            "label": "Multi-Action",
                            "minimal_tip": "Write, Call, Post at Someone, Regulation, Custom Call to Action, and Whitehouse actions at once",
                            "new_icon": "layer-group",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [5, 4, 3],
                            "targets_members": false,
                            "value": 27
                        },
                        "no_campaign": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "icon": "fa-pencil-square-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "no_campaign",
                            "label": "No Campaign",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [],
                            "targets_members": false,
                            "value": 7
                        },
                        "personalized_messages": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.personalized_messages.verb",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 53,
                            "is_enabled_for_campaign_form": true,
                            "key": "personalized_messages",
                            "label": "Interactive Campaign",
                            "minimal_tip": "Question and response campaigns to send to legislators or be used as surveys.",
                            "new_icon": "magic",
                            "order": 1,
                            "permission_enum": [],
                            "required_registration_fields": [1, 2, 5, 4],
                            "targets_members": true,
                            "value": 28
                        },
                        "petition": {
                            "allow_one_click_registration": true,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.petition.verb",
                            "icon": "fa-pencil",
                            "in_combined_campaign": true,
                            "in_multi_action_campaign": true,
                            "interaction_type": 28,
                            "is_enabled_for_campaign_form": true,
                            "key": "petition",
                            "label": "Custom Call-to-Action",
                            "minimal_label": "Action",
                            "minimal_tip": "Present your grassroots contacts with a custom call to action.",
                            "new_icon": "lightbulb",
                            "order": 3,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 8
                        },
                        "relationship": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "relationship",
                            "label": "Relationship",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 16
                        },
                        "schedule": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "i18n_verb_key": "",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 31,
                            "is_enabled_for_campaign_form": false,
                            "key": "schedule",
                            "label": "Scheduled",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 12
                        },
                        "share": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 1,
                            "i18n_verb_key": "campaign.share.verb",
                            "icon": "fa-bullhorn",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 30,
                            "is_enabled_for_campaign_form": true,
                            "key": "share",
                            "label": "Share a Link",
                            "minimal_tip": "Grassroots contacts share a given url on social media.",
                            "new_icon": "comment",
                            "order": 9,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 11
                        },
                        "test_campaign": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": false,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 0,
                            "icon": "fa-pencil-square-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "is_enabled_for_campaign_form": false,
                            "key": "test_campaign",
                            "label": "Test Campaign",
                            "order": 0,
                            "permission_enum": [],
                            "required_registration_fields": [],
                            "targets_members": true,
                            "value": 101
                        },
                        "tweet_at_member": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": true,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.tweet.verb",
                            "icon": "fa-twitter",
                            "icon_family": "q",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": true,
                            "interaction_type": 29,
                            "is_enabled_for_campaign_form": true,
                            "key": "tweet_at_member",
                            "label": "Post at Someone",
                            "minimal_label": "Post",
                            "minimal_tip": "Grassroots contacts send a post directly to legislators or a custom handle.",
                            "new_icon": "x-twitter",
                            "order": 6,
                            "permission_enum": [],
                            "required_registration_fields": [4, 5],
                            "targets_members": true,
                            "use_i18n_social_share_key": true,
                            "value": 10
                        },
                        "visit": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 5,
                            "i18n_verb_key": "campaign.visit.verb",
                            "icon": "fa-suitcase",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 26,
                            "is_enabled_for_campaign_form": true,
                            "key": "visit",
                            "label": "Request a Visit",
                            "minimal_tip": "Encourage contacts to request to visit the capitol or district office of a legislator.",
                            "new_icon": "paper-plane",
                            "order": 14,
                            "permission_enum": [],
                            "required_data_key": "most_recent_role__address",
                            "required_registration_fields": [4],
                            "targets_members": true,
                            "value": 4
                        },
                        "voter_registration": {
                            "allow_one_click_registration": false,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 2,
                            "i18n_verb_key": "campaign.voter_registration.verb",
                            "icon": "fa-sticky-note-o",
                            "in_combined_campaign": false,
                            "in_multi_action_campaign": false,
                            "interaction_type": 106,
                            "is_enabled_for_campaign_form": true,
                            "key": "voter_registration",
                            "label": "Voter Registration",
                            "minimal_tip": "Present your grassroots advocates with a Voter Registration widget.",
                            "new_icon": "edit",
                            "order": 13,
                            "permission_enum": [],
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 24
                        },
                        "write_member": {
                            "allow_one_click_registration": true,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": true,
                            "custom_target_optional_address_field": true,
                            "gamification_default_point_value": 3,
                            "i18n_verb_key": "campaign.write.verb",
                            "icon": "fa-envelope-o",
                            "in_combined_campaign": true,
                            "in_multi_action_campaign": true,
                            "interaction_type": 25,
                            "is_enabled_for_campaign_form": true,
                            "key": "write_member",
                            "label": "Write a Letter",
                            "minimal_label": "Write",
                            "minimal_tip": "Grassroots contacts send a message or custom email to legislators.",
                            "new_icon": "envelope-open",
                            "order": 2,
                            "permission_enum": [],
                            "required_data_key": "email",
                            "required_registration_fields": [1, 2, 5, 4],
                            "targets_members": true,
                            "use_i18n_social_share_key": true,
                            "value": 2
                        },
                        "write_white_house": {
                            "allow_one_click_registration": true,
                            "can_earn_gamification_points": true,
                            "canadian_grassroots_enabled": false,
                            "custom_target_optional_address_field": false,
                            "gamification_default_point_value": 3,
                            "i18n_verb_key": "campaign.write_white_house.verb",
                            "icon": "fa-envelope-o",
                            "in_combined_campaign": true,
                            "in_multi_action_campaign": true,
                            "interaction_type": 46,
                            "is_enabled_for_campaign_form": true,
                            "key": "write_white_house",
                            "label": "Write to the White House",
                            "minimal_label": "Write",
                            "minimal_tip": "Grassroots contacts send a message to the White House or a custom email.",
                            "new_icon": "pencil-alt",
                            "order": 11,
                            "permission_enum": [],
                            "required_data_key": "email",
                            "required_registration_fields": [4],
                            "targets_members": false,
                            "value": 18
                        }
                    },
                    "CommentCampaignOrganizationTypes": {
                        "__is_enum": true,
                        "default": { "key": "default", "label": "Default (Your organization)", "order": 1, "tip": "All participants will submit a comment on your organization's behalf.", "value": 1 },
                        "none": { "key": "none", "label": "None", "order": 4, "tip": "Do not fill out the organization field. This may cause some comments to not be delivered properly.", "value": 4 },
                        "org_chooses": { "key": "org_chooses", "label": "Same for all", "order": 3, "tip": "Choose a custom organization name that will apply to all participants.", "value": 2 },
                        "supporter_chooses": { "key": "supporter_chooses", "label": "Participant chooses", "order": 2, "tip": "Add a field to the comment submission form that asks each participant for the name of the organization they are part of.", "value": 3 }
                    },
                    "DraftOptions": {
                        "__is_enum": true,
                        "can_edit": { "key": "can_edit", "label": "Full editing", "long_label": "Supporter is Allowed to Edit", "order": 1, "value": 1 },
                        "cannot_edit": { "key": "cannot_edit", "label": "No editing", "long_label": "Supporter is not Allowed to Edit", "order": 3, "value": 3 },
                        "partial_edit": { "key": "partial_edit", "label": "Partial editing", "long_label": "Supporter is Allowed to edit the body", "order": 2, "value": 4 }
                    },
                    "MessageVariationGenerationAiType": {
                        "__is_enum": true,
                        "ai_generated": { "key": "ai_generated", "label": "AI Generated", "order": 1, "tip": "Message generated by AI", "value": 1 },
                        "ai_generated_and_edited": { "key": "ai_generated_and_edited", "label": "AI Generated and Edited", "order": 2, "tip": "Message generated by AI and then edited by a user", "value": 2 }
                    },
                    "MessageVariationsType": {
                        "__is_enum": true,
                        "auto_generated": { "key": "auto_generated", "label": "AI enhanced (content required)", "order": 3, "tip": "Messages generated using AI", "value": 3 },
                        "custom_written": { "key": "custom_written", "label": "Custom written", "order": 2, "tip": "Custom written message variations", "value": 2 },
                        "none": { "key": "none", "label": "None", "order": 1, "tip": "No message variations", "value": 1 }
                    },
                    "ShareStoryType": {
                        "__is_enum": true,
                        "text": { "key": "text", "label": "Text", "value": 1 },
                        "text_and_video": { "key": "text_and_video", "label": "Text and Video", "value": 3 },
                        "video": { "key": "video", "label": "Video", "value": 2 }
                    },
                    "TargetMemberOptions": {
                        "__is_enum": true,
                        "all_members": {
                            "display": "Members",
                            "key": "all_members",
                            "label": "All Members",
                            "placeholder": "Legislator",
                            "role_types": [1, 5, 7, 2, 6, 8, 9, 23, 24, 28, 38, 27],
                            "value": 1
                        },
                        "fed_members": {
                            "display": "Federal Members",
                            "key": "fed_members",
                            "label": "Federal Members",
                            "placeholder": "Member",
                            "role_types": [1, 2],
                            "value": 2
                        },
                        "representatives": {
                            "display": "Representative",
                            "key": "representatives",
                            "label": "Representatives",
                            "placeholder": "Representative",
                            "role_types": [2],
                            "value": 5
                        },
                        "senators": {
                            "display": "Senators",
                            "key": "senators",
                            "label": "Senators",
                            "placeholder": "Senator",
                            "role_types": [1],
                            "value": 4
                        },
                        "state_members": {
                            "display": "State Members",
                            "key": "state_members",
                            "label": "State Members",
                            "placeholder": "Legislator",
                            "role_types": [5, 6, 7, 8, 9],
                            "value": 3
                        },
                        "state_representatives": {
                            "display": "State Representative",
                            "key": "state_representatives",
                            "label": "State Representatives/Delegates/Assembly Members",
                            "placeholder": "Representative",
                            "role_types": [6, 8, 9],
                            "value": 7
                        },
                        "state_senators": {
                            "display": "State Senators",
                            "key": "state_senators",
                            "label": "State Senators",
                            "placeholder": "Senator",
                            "role_types": [5, 7],
                            "value": 6
                        }
                    }
                }
            },
            "enums": {
                "ActionCenterBackgroundStyle": {
                    "__is_enum": true,
                    "color": { "grassroots_admin_label": "Color", "key": "color", "label": "Color", "order": 2, "tip": "Override the default organization design settings background color with a solid color", "value": 2 },
                    "image": { "grassroots_admin_label": "Image", "key": "image", "label": "Image", "order": 3, "tip": "Set Action Center background to be an uploaded image", "value": 1 },
                    "org_design": { "grassroots_admin_label": "Default", "key": "org_design", "label": "Org Design", "order": 1, "tip": "Default to the background color that you have set in your organization design settings", "value": 3 }
                },
                "ActionCenterNavigationBarBackgroundStyle": {
                    "__is_enum": true,
                    "color": { "key": "color", "label": "Color", "tip": "Set Navigation Bar background to be a selected color", "value": 2 },
                    "image": { "key": "image", "label": "Image", "tip": "Set Navigation Bar background to be a selected image", "value": 1 },
                    "transparent": { "key": "transparent", "label": "Transparent", "tip": "Set navigation bar to transparent to allow navigation links to overlay Action Center background", "value": 3 }
                },
                "ActionItemType": {
                    "__is_enum": true,
                    "bills": {
                        "call": "Legislation",
                        "icon": "fa-file-text-o",
                        "key": "bills",
                        "label": "Legislation",
                        "permission_enum": [203],
                        "url": "legislation",
                        "value": 14
                    },
                    "interaction": {
                        "call": "Log Interaction",
                        "icon": "fa-handshake-o",
                        "key": "interaction",
                        "label": "Interaction",
                        "permission_enum": [7],
                        "url": "log",
                        "value": 3
                    },
                    "issues": { "call": "View Issues", "icon": "fa-file-text-o", "key": "issues", "label": "Issues", "url": "issues", "value": 6 },
                    "members": { "call": "My Legislators", "icon": "fa-users", "key": "members", "label": "Learn", "url": "register", "value": 13 },
                    "relationship": {
                        "call": "My Relationships",
                        "icon": "fa-exchange",
                        "key": "relationship",
                        "label": "My Relationships",
                        "permission_enum": [5],
                        "url": "relationship",
                        "value": 16
                    },
                    "write": { "call": "Write your Legislator", "icon": "fa-pencil", "key": "write", "label": "Write", "url": "write", "value": 2 }
                },
                "CallToActionMediaType": {
                    "__is_enum": true,
                    "image": { "key": "image", "label": "Image", "order": 2, "tip": "Display an image within this widget", "value": 2 },
                    "none": { "key": "none", "label": "None", "order": 1, "tip": "Do not display any media within this widget", "value": 1 },
                    "video": { "key": "video", "label": "Video", "order": 3, "tip": "Display a video within this widget", "value": 3 }
                },
                "CardLinkType": {
                    "__is_enum": true,
                    "clickable_button": { "key": "clickable_button", "label": "Clickable Button", "tip": "Card contains a customizable button that links to a chosen page", "value": 3 },
                    "clickable_card": { "key": "clickable_card", "label": "Clickable Card", "tip": "Card is a link to a chosen page", "value": 2 },
                    "static_card": { "key": "static_card", "label": "Static Card", "tip": "Card is not a link", "value": 1 }
                },
                "CardsSectionLayoutType": {
                    "__is_enum": true,
                    "four_cards": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/fourCardsActive.png", "card_width": 289, "icon_max_height": "60%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/fourCardsInactive.png", "key": "four_cards", "label": "4 Cards", "num_cards": 4, "order": 4, "value": 4 },
                    "one_card": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/oneCardActive.png", "card_width": 1210, "icon_max_height": "90%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/oneCardInactive.png", "key": "one_card", "label": "1 Card", "num_cards": 1, "order": 1, "value": 1 },
                    "three_cards": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/threeCardsActive.png", "card_width": 391, "icon_max_height": "80%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/threeCardsInactive.png", "key": "three_cards", "label": "3 Cards", "num_cards": 3, "order": 3, "value": 3 },
                    "two_cards": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/twoCardsActive.png", "card_width": 596, "icon_max_height": "90%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/cardsSection/twoCardsInactive.png", "key": "two_cards", "label": "2 Cards", "num_cards": 2, "order": 2, "value": 2 }
                },
                "CovveTypes": {
                    "__is_enum": true,
                    "failed_scan": { "key": "failed_scan", "label": "Scan failed (image unreadable). Please take another photo and scan again", "status": 401, "value": 3 },
                    "invalid": { "key": "invalid", "label": "Incoming model is invalid", "status": 400, "value": 4 },
                    "processed": { "key": "processed", "label": "Processed into Quorum", "status": 200, "value": 2 },
                    "successful_scan": { "key": "successful_scan", "label": "Scan successfully completed", "status": 200, "value": 1 }
                },
                "CustomDataWidgetDisplayType": {
                    "__is_enum": true,
                    "aggregate": {
                        "action_method": "aggregate_custom_data",
                        "action_method_kwargs": ["aggregate_field_and_method_dict", "region_filters"],
                        "key": "aggregate",
                        "label": "Aggregate View",
                        "value": 1,
                        "widget_fields": [1, 2, 3, 17, 4, 5]
                    },
                    "list": {
                        "action_method": "list_custom_data",
                        "action_method_kwargs": ["fields", "custom_data_id", "region_filters"],
                        "key": "list",
                        "label": "List View",
                        "value": 2,
                        "widget_fields": [1, 2, 3, 17, 13, 10, 18, 12, 11, 14]
                    },
                    "map": {
                        "action_method": "map_custom_data",
                        "action_method_kwargs": ["custom_data_id", "region_filters"],
                        "key": "map",
                        "label": "Map View",
                        "value": 3,
                        "widget_fields": [1, 2, 3, 17, 15, 13, 18, 16, 14, 19, 20, 21]
                    }
                },
                "CustomDataWidgetFields": {
                    "__is_enum": true,
                    "aggregate_field_and_method": { "description": "Dict with keys: custom_data_id, field_name, query_operation.field_name is field from numeric_fields on the selected CustomData.query_operation is the value of CustomDataQueryOperations enum item.", "field_name": "aggregate_field_and_method", "is_for_all_display_types": false, "is_required": true, "key": "aggregate_field_and_method", "label": "Aggregated Field and Method", "parent_enum": 5, "validation_type": "dict", "value": 6 },
                    "background_color": { "description": "Map background color.", "field_name": "background_color", "is_for_all_display_types": false, "is_required": false, "key": "background_color", "label": "Map background color", "validation_type": "str", "value": 15 },
                    "card_description": { "description": "Optional description field that displays within each card.", "field_name": "description", "is_for_all_display_types": false, "is_required": false, "key": "card_description", "label": "Card Description", "parent_enum": 5, "validation_type": "str", "value": 7 },
                    "card_layout": { "description": "The value of CardsSectionLayoutType enum item.", "field_name": "card_layout", "is_for_all_display_types": false, "is_required": true, "key": "card_layout", "label": "Card Layout", "validation_type": "int", "value": 4 },
                    "cards": { "description": "JSON shape mimics that of CardsSection, using a string of index as the key for this dict.", "field_name": "cards", "is_for_all_display_types": false, "is_required": true, "key": "cards", "label": "Cards", "validation_type": "dict", "value": 5 },
                    "custom_data_id": { "description": "ID of the selected CustomData for the widget.", "field_name": "custom_data_id", "is_for_all_display_types": false, "is_required": true, "key": "custom_data_id", "label": "Custom Data", "validation_type": "int", "value": 13 },
                    "display_type": { "description": "The value of CustomDataWidgetDisplayType enum item.", "field_name": "display_type", "is_for_all_display_types": true, "is_required": true, "key": "display_type", "label": "Display Type", "validation_type": "int", "value": 1 },
                    "fa4_icon": { "description": "Icon name should reference the icon selection on Issue edit page in Action Center", "field_name": "fa4_icon", "is_for_all_display_types": false, "is_required": false, "key": "fa4_icon", "label": "FA4 Icon", "parent_enum": 5, "validation_type": "str", "value": 8 },
                    "geo_shape_id": { "description": "When provided, only render the single GeoShape inside the provided geoJSON object generated via the geo_shape_type and region fields", "field_name": "geo_shape_id", "is_for_all_display_types": false, "is_required": false, "key": "geo_shape_id", "label": "GeoShapeID", "validation_type": "int", "value": 21 },
                    "geo_shape_type": { "description": "Divisions of the given Region to render(ex: district)", "field_name": "geo_shape_type", "is_for_all_display_types": false, "is_required": true, "key": "geo_shape_type", "label": "GeoShapeType", "validation_type": "int", "value": 20 },
                    "geodata_fields": { "description": "A list of dictionary that has `field_name` and `precedence`.`field_name` are fields on CustomGeoData. They are the same for any custom data: name, address, coordinates, latitude, longitude`precedence` is the order of the field in appearance among all fields.", "field_name": "geodata_fields", "is_for_all_display_types": false, "is_required": false, "key": "geodata_fields", "label": "List column - Geodata", "validation_type": "list", "value": 10 },
                    "height": { "description": "How tall the map or list widget will be in px. Some space will be reserved for padding/margin as well.", "field_name": "height", "is_for_all_display_types": false, "is_required": true, "key": "height", "label": "Height of Widget", "validation_type": "int", "value": 18 },
                    "id": { "description": "Is necessary if you have multiple custom data widgets on the same page.If widget id is not unique and the custom data widgets have the same aggregate field and method but for different regions,the returned data will overwrite each other.", "field_name": "id", "is_for_all_display_types": true, "is_required": false, "key": "id", "label": "Widget Id", "validation_type": "int", "value": 17 },
                    "image_url": { "description": "Image URL to display in place of Icon.When filled, the card will show the image regardless of what is filled in for fa4_icon field", "field_name": "image_url", "is_for_all_display_types": false, "is_required": false, "key": "image_url", "label": "Image URL", "parent_enum": 5, "validation_type": "str", "value": 9 },
                    "non_numeric_fields": { "description": "A list of dictionary that has `field_name` and `precedence`.`field_name` from `CustomData.non_numeric_fields` that should be handled as a string.`precedence` is the order of the field in appearance among all fields.", "field_name": "non_numeric_fields", "is_for_all_display_types": false, "is_required": false, "key": "non_numeric_fields", "label": "List column - Non-numeric Fields", "validation_type": "list", "value": 12 },
                    "numeric_fields": { "description": "A list of dictionary that has `field_name` and `precedence`.`field_name` from `CustomData.numeric_fields` that should be handled as a float.`precedence` is the order of the field in appearance among all fields.", "field_name": "numeric_fields", "is_for_all_display_types": false, "is_required": false, "key": "numeric_fields", "label": "List column - Numeric Fields", "validation_type": "list", "value": 11 },
                    "pin_color": { "description": "Map pin Color.", "field_name": "pin_color", "is_for_all_display_types": false, "is_required": false, "key": "pin_color", "label": "Map pin Color", "validation_type": "str", "value": 16 },
                    "region": { "description": "Region to render", "field_name": "region", "is_for_all_display_types": false, "is_required": true, "key": "region", "label": "region", "validation_type": "int", "value": 19 },
                    "region_filters": { "description": "Dict based on the smallest region type to display. Available region types are:country_id, state_id, district_id, county_id, upperld_id, lowerld_id.As of Nov 2022, we only support custom data for US region, so country_id should only be USA (id=234).", "field_name": "region_filters", "is_for_all_display_types": true, "is_required": true, "key": "region_filters", "label": "Region", "validation_type": "dict", "value": 3 },
                    "widget_description": { "description": "Widget description that is shown under the list or map.", "field_name": "description", "is_for_all_display_types": false, "is_required": false, "key": "widget_description", "label": "Widget Description", "validation_type": "str", "value": 14 },
                    "widget_title": { "description": "Optional title displayed at the top of the widget.", "field_name": "title", "is_for_all_display_types": true, "is_required": false, "key": "widget_title", "label": "Widget Title", "validation_type": "str", "value": 2 }
                },
                "CustomDocketLinkStatus": {
                    "__is_enum": true,
                    "created": { "key": "created", "label": "Created", "value": 3 },
                    "in_progress": { "key": "in_progress", "label": "In progress", "value": 2 },
                    "not_possible": { "key": "not_possible", "label": "Not possible", "value": 4 },
                    "requested": { "key": "requested", "label": "Requested", "value": 1 }
                },
                "FullContactTypes": {
                    "__is_enum": true,
                    "bad_callback": { "key": "bad_callback", "label": "Webhook Error", "status": "CALLBACK_MADE_NOT_PROCESSABLE", "value": 4 },
                    "callback_failed": { "key": "callback_failed", "label": "Callback Failed", "status": "CALLBACK_FAILED", "value": 5 },
                    "image_failed": { "key": "image_failed", "label": "Image not readable", "status": "CALLBACK_FAILED_NOT_PROCESSABLE", "value": 3 },
                    "image_not_processable": { "key": "image_not_processable", "label": "Image not processable", "status": 400, "value": 6 },
                    "processed": { "key": "processed", "label": "Processed", "status": "CALLBACK_MADE", "value": 2 },
                    "processing": { "key": "processing", "label": "Processing", "status": "PROCESSING", "value": 1 }
                },
                "ImageCollageLayoutType": {
                    "__is_enum": true,
                    "four_images": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/fourImagesActive.png", "icon_max_height": "100%", "image_height": 390, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/fourImagesInactive.png", "key": "four_images", "label": "4 Images", "num_images": 4, "num_rows": 2, "order": 4, "value": 4 },
                    "three_images_one_row": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/threeImagesOneRowActive.png", "icon_max_height": "100%", "image_height": 260, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/threeImagesOneRowInactive.png", "key": "three_images_one_row", "label": "3 Images", "num_images": 3, "num_rows": 1, "order": 3, "value": 3 },
                    "three_images_two_rows": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/threeImagesTwoRowsActive.png", "icon_max_height": "100%", "image_height": 390, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/threeImagesTwoRowsInactive.png", "key": "three_images_two_rows", "label": "3 Images", "num_images": 3, "num_rows": 2, "order": 2, "value": 2 },
                    "two_images": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/twoImagesActive.png", "icon_max_height": "100%", "image_height": 390, "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/imageCollage/twoImagesInactive.png", "key": "two_images", "label": "2 Images", "num_images": 2, "num_rows": 1, "order": 1, "value": 1 }
                },
                "ImageVideoCarouselWidgetType": {
                    "__is_enum": true,
                    "image": { "key": "image", "label": "Image", "value": 1 },
                    "video": { "key": "video", "label": "Video", "value": 2 }
                },
                "NumberStatsLayoutType": {
                    "__is_enum": true,
                    "four_stats": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/fourStatsActive.png", "card_width": "19.3vw", "icon_max_height": "40%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/fourStatsInactive.png", "key": "four_stats", "label": "4 Stats", "num_stats": 4, "order": 4, "stat_description_font_size": "1.9rem", "stat_font_size": "3.8rem", "stat_line_height": "4.5rem", "stat_title_font_size": "2.4rem", "value": 4 },
                    "one_stat": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/oneStatActive.png", "card_width": "26.48vw", "icon_max_height": "80%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/oneStatInactive.png", "key": "one_stat", "label": "1 Stat", "num_stats": 1, "order": 1, "stat_description_font_size": "2rem", "stat_font_size": "4.8rem", "stat_line_height": "6rem", "stat_title_font_size": "2.5rem", "value": 1 },
                    "three_stats": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/threeStatsActive.png", "card_width": "26.48vw", "icon_max_height": "60%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/threeStatsInactive.png", "key": "three_stats", "label": "3 Stats", "num_stats": 3, "order": 3, "stat_description_font_size": "2rem", "stat_font_size": "4.8rem", "stat_line_height": "6rem", "stat_title_font_size": "2.5rem", "value": 3 },
                    "two_stats": { "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/twoStatsActive.png", "card_width": "26.48vw", "icon_max_height": "80%", "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterWidgetLayouts/numberStats/twoStatsInactive.png", "key": "two_stats", "label": "2 Stats", "num_stats": 2, "order": 2, "stat_description_font_size": "2rem", "stat_font_size": "4.8rem", "stat_line_height": "6rem", "stat_title_font_size": "2.5rem", "value": 2 }
                },
                "Phone2ActionActionType": {
                    "__is_enum": true,
                    "connection": { "key": "connection", "label": "Legislator Connection", "value": 1 },
                    "membership": { "key": "membership", "label": "Joined Non-Legislative Campaign", "value": 2 },
                    "membership_email": { "key": "membership_email", "label": "Joined Email Campaign", "value": 3 },
                    "membership_ptc": { "key": "membership_ptc", "label": "Joined PTC Campaign", "value": 5 },
                    "membership_twitter": { "key": "membership_twitter", "label": "Joined Twitter Campaign", "value": 4 }
                },
                "Phone2ActionIntegrationType": {
                    "__is_enum": true,
                    "luminate": { "key": "luminate", "label": "Luminate Integration", "value": 3 },
                    "mailchimp": { "key": "mailchimp", "label": "Mailchimp Integration", "value": 4 },
                    "nationbuilder": { "key": "nationbuilder", "label": "NationBuilder Integration", "value": 2 },
                    "salesforce": { "key": "salesforce", "label": "Salesforce Integration", "value": 1 }
                },
                "SocialMediaType": {
                    "__is_enum": true,
                    "facebook": { "color": "#3B5998", "icon": "fa-facebook-square", "key": "facebook", "label": "Facebook", "supported": true, "value": 1 },
                    "google_plus": { "color": "#dd5044", "key": "google_plus", "label": "Google Plus", "supported": false, "value": 5 },
                    "linkedin": { "color": "#0177b5", "icon": "fa-linkedin-square", "key": "linkedin", "label": "LinkedIn", "supported": true, "value": 3 },
                    "pinterest": { "color": "#d8121d", "icon": "fa-pinterest", "key": "pinterest", "label": "Pinterest", "supported": true, "value": 4 },
                    "twitter": { "color": "#4099FF", "icon": "fa-twitter", "key": "twitter", "label": "Twitter", "supported": true, "value": 2 }
                },
                "SupporterActionType": {
                    "__is_enum": true,
                    "acted": { "key": "acted", "label": "Acted", "past_tense": "acted on a campaign", "value": 1 },
                    "authorized_contribution": { "key": "authorized_contribution", "label": "Authorized Contribution", "past_tense": "submitted an authorized contribution", "value": 103 },
                    "called": { "key": "called", "label": "Called", "past_tense": "called their legislator", "value": 5 },
                    "combined_campaign": { "key": "combined_campaign", "label": "Participated", "past_tense": "participated in a combined campaign", "value": 19 },
                    "commented_on_regulation": { "key": "commented_on_regulation", "label": "Commented", "past_tense": "commented on a regulation", "value": 15 },
                    "custom_points": { "key": "custom_points", "label": "Recieved Custom Points", "past_tense": "received custom points", "value": 102 },
                    "interacted": { "key": "interacted", "label": "Interacted", "past_tense": "logged an interaction", "value": 3 },
                    "personalized_message": { "key": "personalized_message", "label": "Personalized a message", "past_tense": "personalized a message", "value": 28 },
                    "registered": { "key": "registered", "label": "Registered", "past_tense": "registered", "value": 7 },
                    "registered_to_vote": { "key": "registered_to_vote", "label": "Registered to Vote", "past_tense": "registered to vote", "value": 24 },
                    "scheduled": { "key": "scheduled", "label": "Scheduled", "past_tense": "scheduled a visit", "value": 12 },
                    "shared": { "key": "shared", "label": "Shared", "past_tense": "shared on social media", "value": 11 },
                    "shared_story": { "key": "shared_story", "label": "Shared Story", "past_tense": "shared a story", "value": 17 },
                    "signed": { "key": "signed", "label": "Participated", "past_tense": "participated in campaign", "value": 8 },
                    "submit_contact_us_widget": { "key": "submit_contact_us_widget", "label": "Submitted Contact Us Widget", "past_tense": "submitted Contact Us widget", "value": 26 },
                    "submit_gotv_widget": { "key": "submit_gotv_widget", "label": "Submitted GOTV Widget", "past_tense": "submitted GOTV widget", "value": 23 },
                    "test_action": { "key": "test_action", "label": "Took test action", "past_tense": "took test action", "value": 101 },
                    "tweeted": { "key": "tweeted", "label": "Tweeted", "past_tense": "tweeted at their legislator", "value": 10 },
                    "visited": { "key": "visited", "label": "Visited", "past_tense": "visited their legislator", "value": 4 },
                    "wrote": { "key": "wrote", "label": "Wrote", "past_tense": "wrote their legislator", "value": 2 },
                    "wrote_white_house": { "key": "wrote_white_house", "label": "Wrote", "past_tense": "wrote White House", "value": 18 }
                },
                "SupporterTagOptionDisplayType": {
                    "__is_enum": true,
                    "dropdown_display": { "client_facing_label": "Display the options as a dropdown", "column_data_type": "integer", "key": "dropdown_display", "label": "Dropdown", "order": 1, "short_client_facing_label": "Dropdown", "slug": "dropdown", "value": 0 },
                    "list_display": { "client_facing_label": "Display the options as a list", "column_data_type": "integer", "key": "list_display", "label": "List", "order": 2, "short_client_facing_label": "List", "slug": "list", "value": 1 }
                }
            },
            "models": {
                "ActionCenterInteractionType": {
                    "__is_model": true,
                    "__name__": "ActionCenterInteractionType",
                    "data_model": "app.grassroots.models.ActionCenterInteractionType",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/actioncenterinteractiontype/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The ActionCenter",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The custom_interaction_types that are available",
                            "name": "custom_interaction_type",
                            "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                            "verbose_name": "custom interaction type"
                        }
                    ]
                },
                "ActionCenterSettings": {
                    "__is_model": true,
                    "__name__": "ActionCenterSettings",
                    "data_model": "app.grassroots.models.ActionCenterSettings",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/actioncentersettings/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "This field maps to the og:description and twitter:description fields. It's typically recommended to keep this less than 200 characters.", "name": "social_description", "verbose_name": "social description" },
                        { "field_type": 3, "help_text": "The URL of an image to display on social media. Typically square and at least 50px by 50px.", "name": "social_image_url", "verbose_name": "social image url" },
                        { "field_type": 3, "help_text": "An alternative text to be displayed in place of the image as a fallback or for sight-restricted individuals.", "name": "social_image_alttext", "verbose_name": "social image alttext" },
                        { "field_type": 3, "help_text": "The title of your page that will show up first in Twitter or Facebook.", "name": "social_title", "verbose_name": "social title" },
                        { "field_type": 3, "help_text": "If it is possible to control what is shared on social media when someone clicks a button to share a given page, what message should be shared.", "name": "social_share_text", "verbose_name": "social share text" },
                        { "field_type": 3, "help_text": "The keyword attached to this item used to redirect to the item if texted by a supporter", "name": "text_keyword", "verbose_name": "text keyword" },
                        { "field_type": 3, "help_text": "Text to use in response to an inbound text with this action center's keyword.", "name": "inbound_texting_reply_message", "verbose_name": "inbound texting reply message" },
                        {
                            "field_type": 7,
                            "help_text": "phone number used for inbound texting for this object",
                            "name": "phone_number",
                            "related_model": { "__module__": "app.texting.models", "__name__": "PhoneNumber" },
                            "verbose_name": "phone number"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The name that the organization wants to be known by in the Action Center", "name": "organization_user_specified_name", "verbose_name": "organization user specified name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "sheet_column": true,
                            "verbose_name": "Campaign Language"
                        },
                        { "field_type": 2, "help_text": "The twitter name to be used in tweet campaigns", "name": "twitter_handle", "verbose_name": "twitter handle" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization_design",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                            "verbose_name": "organization design"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "The full name to show in the Action Center -- replaces Organization Name + Action Center Name", "name": "full_name", "verbose_name": "full name" },
                        { "field_type": 3, "help_text": "", "name": "welcome_message", "verbose_name": "welcome message" },
                        { "field_type": 3, "help_text": "", "name": "login_message", "verbose_name": "login message" },
                        { "field_type": 3, "help_text": "", "name": "default_thank_you_message", "verbose_name": "default thank you message" },
                        { "field_type": 1, "help_text": "", "name": "show_welcome_message", "verbose_name": "show welcome message" },
                        { "field_type": 1, "help_text": "", "name": "show_login_message", "verbose_name": "show login message" },
                        { "field_type": 1, "help_text": "", "name": "show_footer_logo", "verbose_name": "show footer logo" },
                        { "field_type": 1, "help_text": "Whether the Powered by Quorum link should be shown in the footer.", "name": "show_quorum_link", "verbose_name": "show quorum link" },
                        { "field_type": 2, "help_text": "", "name": "footer_logo_url", "verbose_name": "footer logo url" },
                        { "field_type": 1, "help_text": "", "name": "show_org_name_in_top_bar", "verbose_name": "show org name in top bar" },
                        { "field_type": 1, "help_text": "Whether this action center allow users to updated their information", "name": "show_update_info", "verbose_name": "show update info" },
                        { "field_type": 1, "help_text": "Whether the texture behind the login and register pages should be shown.", "name": "hide_texture", "verbose_name": "hide texture" },
                        { "field_type": 1, "help_text": "Whether users can login with facebook to the action center", "name": "can_login_with_facebook", "verbose_name": "can login with facebook" },
                        { "field_type": 1, "help_text": "Whether the registration forms should show a password field (only on the register page -- campaigns never do)", "name": "show_password", "verbose_name": "show password" },
                        { "field_type": 1, "help_text": "", "name": "show_action_items", "verbose_name": "show action items" },
                        { "field_type": null, "help_text": "", "name": "action_items", "verbose_name": "action items" },
                        { "field_type": 1, "help_text": "", "name": "publicly_accessible", "verbose_name": "publicly accessible" },
                        { "field_type": 2, "help_text": "", "name": "default_password", "verbose_name": "default password" },
                        { "field_type": 2, "help_text": "", "name": "legislation_header", "verbose_name": "legislation header" },
                        { "field_type": 3, "help_text": "", "name": "legislation_description", "verbose_name": "legislation description" },
                        { "field_type": 2, "help_text": "", "name": "relationship_header", "verbose_name": "relationship header" },
                        { "field_type": 3, "help_text": "", "name": "relationship_description", "verbose_name": "relationship description" },
                        { "field_type": 3, "help_text": "", "name": "default_letter_message", "verbose_name": "default letter message" },
                        { "field_type": 3, "help_text": "", "name": "default_letter_subject", "verbose_name": "default letter subject" },
                        { "field_type": 3, "help_text": "", "name": "default_interaction_log_text", "verbose_name": "default interaction log text" },
                        { "field_type": 3, "help_text": "", "name": "default_interaction_log_title", "verbose_name": "default interaction log title" },
                        { "field_type": 4, "help_text": "", "name": "maximum_campaigns_first_page", "verbose_name": "maximum campaigns first page" },
                        { "field_type": null, "help_text": "Other default fields directly attached to the supporter that are required to register. This includes phone_number, title, prefix, suffix, secondary_phone", "name": "additional_default_registration_fields", "verbose_name": "additional default registration fields" },
                        { "field_type": 1, "help_text": "Specifies whether an external interaction logger or interaction campaign should require an official or staffer", "name": "should_require_interaction_official", "verbose_name": "should require interaction official" },
                        { "field_type": 1, "help_text": "Specifies whether the external interaction/relationship logger should include the contact's city and state when displaying the name", "name": "should_display_contact_city_state_in_external_logger", "verbose_name": "should display contact city state in external logger" },
                        { "field_type": null, "help_text": "Setting this field with an array of interaction types overrides the selector for the interaction types in the external logger.", "name": "external_interaction_types", "verbose_name": "external interaction types" },
                        { "field_type": null, "help_text": "Setting this field with an array of interaction types overrides the selector for the interaction types in the external relationship survey.", "name": "external_relationship_types", "verbose_name": "external relationship types" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Google Analytics, their custom UA code should be placed here.", "name": "external_ua_code", "verbose_name": "external ua code" },
                        { "field_type": 2, "help_text": "If a client would like to track individual actions via Google Tag Manager, their custom GTM ID should be placed here.", "name": "external_gtm_code", "verbose_name": "external gtm code" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Facebook, their custom FB pixel ID should be placed here.", "name": "external_fb_code", "verbose_name": "external fb code" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Adobe DTM, their custom tracking url should be placed here.", "name": "external_adobe_dtm_tag", "verbose_name": "external adobe dtm tag" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization_ng",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization ng"
                        },
                        { "field_type": null, "help_text": "List of integers generally corresponding to MinorRoleType enum values.", "name": "allowed_minor_role_types", "verbose_name": "allowed minor role types" },
                        { "field_type": null, "help_text": "List of integers generally corresponding to PersonGeneralRole enum values.", "name": "allowed_person_general_roles", "verbose_name": "allowed person general roles" },
                        { "field_type": 2, "help_text": "The domain attached to this action center, eg savethewhales in savethewhales.quorum.us", "name": "domain", "verbose_name": "domain" },
                        {
                            "field_type": 7,
                            "help_text": "The default grassroots page for our action center!",
                            "name": "index_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "QuorumGrassrootsPage" },
                            "verbose_name": "index page"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default registration page for our action center!",
                            "name": "default_registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "default registration page"
                        },
                        { "field_type": null, "help_text": "Represents the header of the action center.", "name": "header", "verbose_name": "header" },
                        { "field_type": null, "help_text": "Represents the footer of the action center.", "name": "footer", "verbose_name": "footer" },
                        { "field_type": null, "help_text": "Represents the navigation bar of the action center.", "name": "navigation_bar", "verbose_name": "navigation bar" },
                        { "field_type": 1, "help_text": "Determines if the organization's custom description (on DataDescription object) should be shown on member profile", "name": "should_show_official_custom_description", "verbose_name": "should show official custom description" },
                        { "field_type": 3, "help_text": "Custom styling the user can edit", "name": "custom_css", "verbose_name": "custom css" },
                        { "field_type": 1, "help_text": "Whether or not an action center should display a custom footer using footer_html", "name": "should_use_footer_html", "verbose_name": "should use footer html" },
                        { "field_type": 3, "help_text": "The custom html the organization sets to be displayed as the footer instead of the standard 'Powered by Quorum' footer", "name": "footer_html", "verbose_name": "footer html" },
                        { "field_type": 3, "help_text": "After login to a private action center, redirect to a link (can be relative or absolute link)", "name": "login_redirect_url", "verbose_name": "login redirect url" },
                        { "field_type": 3, "help_text": "The pre login text on the private action center's login page", "name": "login_page_pre_text", "verbose_name": "login page pre text" },
                        { "field_type": 3, "help_text": "The post login text on the private action center's login page", "name": "login_page_post_text", "verbose_name": "login page post text" },
                        { "field_type": 3, "help_text": "The label and placeholder for the username field on the private action center's login page", "name": "login_page_username_label", "verbose_name": "login page username label" },
                        { "field_type": 3, "help_text": "The label and placeholder for the username field on the private action center's login page", "name": "login_page_password_label", "verbose_name": "login page password label" },
                        { "field_type": 1, "help_text": "Whether we should allow custom action center domains to be indexable (ie, searchable on google)", "name": "allow_search_indexable_custom_domain", "verbose_name": "allow search indexable custom domain" },
                        { "field_type": 2, "help_text": "The text that will be displayed in the tooltip on the Action Center Update, Donation and Registration Page", "name": "tooltip_text", "verbose_name": "tooltip text" },
                        { "field_type": null, "help_text": "Fields that will have a read only state", "name": "read_only_form_fields", "verbose_name": "read only form fields" },
                        { "field_type": 1, "help_text": "If Gamification is enabled for this Action Center", "name": "gamification_enabled", "verbose_name": "gamification enabled" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationCampaignPointType" },
                            "field_type": 4,
                            "help_text": "Specifies how admins can assign point values to campaigns, by campaign type or all campaigns",
                            "name": "gamification_point_type",
                            "verbose_name": "gamification point type"
                        },
                        { "field_type": null, "help_text": "For 'Custom Point Type', dictionary mapping Campaign type and the potential points to earn. Key: CampaignType enum value. Value: points", "name": "gamification_campaign_type_points", "verbose_name": "gamification campaign type points" },
                        { "field_type": 4, "help_text": "Amount of points a Supporter has within an Action Center", "name": "gamification_all_campaign_points", "verbose_name": "gamification all campaign points" },
                        { "field_type": 1, "help_text": "If Gamification \"tiers\" will be shown to advocates", "name": "show_gamification_tiers", "verbose_name": "show gamification tiers" },
                        { "field_type": null, "help_text": "The different tiers an advocate could earn Key: Tier name. Value: dict of tier props (point value, image, message)", "name": "gamification_tiers", "verbose_name": "gamification tiers" },
                        { "field_type": 1, "help_text": "If Gamification \"ranks\" will be shown to advocates", "name": "show_gamification_ranks", "verbose_name": "show gamification ranks" },
                        { "field_type": null, "help_text": "Caches the amount of points needed to reach a rank. Key: GamificationRankType enum value. Value: Points needed", "name": "gamification_ranks", "verbose_name": "gamification ranks" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationAchievementIconType" },
                            "field_type": 4,
                            "help_text": "The icon that is shown on the gamification statistics widget or when an advocate earns points",
                            "name": "gamification_achievement_icon_type",
                            "verbose_name": "gamification achievement icon type"
                        },
                        { "field_type": 1, "help_text": "If the custom image for a gamification tier is specified, display that image in gamification stats widget and thanks page", "name": "should_use_custom_stats_icon", "verbose_name": "should use custom stats icon" },
                        { "field_type": 3, "help_text": "Custom Javascript, is run once when the top component is mounted", "name": "custom_javascript", "verbose_name": "custom javascript" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "FacebookConnectionStatus" },
                            "field_type": 4,
                            "help_text": "For lead ads integration, the current status of the connection to Facebook",
                            "name": "facebook_status",
                            "verbose_name": "facebook status"
                        },
                        { "field_type": null, "help_text": "An object provided by the user with information for connecting to facebook, should have properties for pageId and userAccessToken when initially saved", "name": "facebook_connection", "verbose_name": "facebook connection" },
                        { "field_type": 3, "help_text": "Page Id of page we want to use for lead ads. Facebook associates all advertisements with a page, which is supposed to represent a business. In this context pages are sometimes called accounts", "name": "facebook_page_id", "verbose_name": "facebook page id" },
                        { "field_type": 3, "help_text": "Access token used to access and Facebook to create, delete lead ads or view leads", "name": "facebook_access_token", "verbose_name": "facebook access token" },
                        { "field_type": 3, "help_text": "User access token to be used to get facebook_access_token. Since ads are created on pages, not individual accounts, this is only an intermediary to get the page token", "name": "facebook_user_token", "verbose_name": "facebook user token" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "ActionCenterTheme" },
                            "field_type": 4,
                            "help_text": "Theme that dictates style of Action Center.",
                            "name": "theme_type",
                            "verbose_name": "theme type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterNavigationBarBackgroundStyle" },
                            "field_type": 4,
                            "help_text": "Background style of the Action Center Navigation Bar.If null, use should_use_action_center_header_color to determine default.",
                            "name": "navigation_bar_style_type",
                            "verbose_name": "navigation bar style type"
                        },
                        { "field_type": 3, "help_text": "This image should be used for the Navigation Bar background if navigation_bar_style is Image.If null use background_image from OrganizationDesign.", "name": "navigation_bar_image_override_url", "verbose_name": "navigation bar image override url" },
                        { "field_type": 2, "help_text": "The background color that should be used for Navigation Bar background if navigation_bar_style is Color.If null and should_use_action_center_header_color from OrganizationDesign, use action_center_header_color from OrganizationDesign.", "name": "navigation_bar_color_override", "verbose_name": "navigation bar color override" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterBackgroundStyle" },
                            "field_type": 4,
                            "help_text": "Background style of the Action Center.If null, and background_image from OrganizationDesign is not null use background_image.If background_image is null, use background_color from OrganizationDesign.",
                            "name": "background_style_type",
                            "verbose_name": "background style type"
                        },
                        { "field_type": 3, "help_text": "This image should be used for the Action Center background if background_style is Image.If null, use background_image from OrganizationDesign.", "name": "background_image_override_url", "verbose_name": "background image override url" },
                        { "field_type": 2, "help_text": "The background color that should be used for Action background if background_style is Color.If null and background_image is null, use background_color on OrganizationDesign.", "name": "background_color_override", "verbose_name": "background color override" },
                        { "field_type": 3, "help_text": "url of custom favicon to display in tab of action center", "name": "custom_favicon_url", "verbose_name": "custom favicon url" },
                        { "field_type": 3, "help_text": "Text to use in outbound texting subscription confirmation message sent to new supporters.This should be the entire message, including any disclaimer text.", "name": "outbound_texting_confirmation_message", "verbose_name": "outbound texting confirmation message" },
                        {
                            "field_type": 7,
                            "help_text": "LedgerSettings associated with this action center",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        { "field_type": 3, "help_text": "Message to display when a supporter attempts to view a page, but are disallowed because they are not a PAC eligible. If this field is blank, we replace it with a default value. Only relevant for PAC-connected action centers.", "name": "pac_restricted_to_eligibles_message", "verbose_name": "pac restricted to eligibles message" },
                        { "field_type": 3, "help_text": "Like pac_restricted_to_eligibles_message, except if disallowed because they *are* eligible", "name": "pac_restricted_to_ineligibles_message", "verbose_name": "pac restricted to ineligibles message" },
                        { "field_type": 3, "help_text": "Like pac_restricted_to_eligibles_message but specifically for users that are not logged in.", "name": "pac_restricted_user_not_logged_in_message", "verbose_name": "pac restricted user not logged in message" },
                        { "field_type": 1, "help_text": "If conditional giving levels are enabled for this Action Center", "name": "conditional_giving_enabled", "verbose_name": "conditional giving enabled" },
                        { "field_type": 1, "help_text": "If this action center is a Collaborator Action Center", "name": "is_collaborator_action_center", "verbose_name": "is collaborator action center" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Additional custom tags that this organization wants to require as part of the registration process.",
                            "name": "additional_custom_registration_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "additional custom registration fields"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The issues related to this action center.",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this Action Center's external Interaction logger",
                            "name": "interaction_custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "interaction custom fields"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this Action Center's external Relationship logger",
                            "name": "relationship_custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "relationship custom fields"
                        }
                    ]
                },
                "BusinessCard": {
                    "__is_model": true,
                    "__name__": "BusinessCard",
                    "data_model": "app.grassroots.models.BusinessCard",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/businesscard/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 16, "help_text": "When the business card was created", "name": "created", "sheet_column": true, "verbose_name": "Date Created" },
                        { "field_type": 16, "help_text": "When the business card was updated", "name": "updated", "sheet_column": true, "verbose_name": "Date Updated" },
                        { "field_type": 3, "help_text": "The base64 encoded string of the front of the business card", "name": "front_img_url", "verbose_name": "front img url" },
                        { "field_type": 3, "help_text": "The base64 encoded string of the back of the business card", "name": "back_img_url", "verbose_name": "back img url" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "FullContactTypes" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "fullcontact_status",
                            "verbose_name": "fullcontact status"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "CovveTypes" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        { "field_type": 2, "help_text": "Full Contact ID", "name": "fullcontact_id", "verbose_name": "fullcontact id" },
                        { "field_type": 2, "help_text": "Covve ID", "name": "covve_id", "verbose_name": "covve id" },
                        { "field_type": null, "help_text": "Covve API returned JSON", "name": "json", "verbose_name": "json" }
                    ]
                },
                "CustomTag": {
                    "__is_model": true,
                    "__name__": "CustomTag",
                    "data_model": "app.grassroots.models.CustomTag",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/customtag/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "TagType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "tag_type",
                            "sheet_column": true,
                            "sheets_display_key": "short_client_facing_label",
                            "verbose_name": "tag type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterTagOptionDisplayType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "option_display_type",
                            "sheet_column": true,
                            "verbose_name": "option display type"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 3, "help_text": "Text describing the Custom Field", "name": "description", "verbose_name": "description" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "group",
                            "related_model": { "__module__": "app.custom_field.models", "__name__": "CustomFieldGroup" },
                            "verbose_name": "group"
                        },
                        { "field_type": null, "help_text": "", "name": "options", "verbose_name": "options" },
                        { "field_type": null, "help_text": "The new implementation of options for Custom Fields. Instead of an ArrayField of values, options are a JSONField mapping slugs to value, order, and archived status", "name": "options_new", "verbose_name": "options new" },
                        { "field_type": 3, "help_text": "Regardless of tag type, the default value is stored as a string in this singular field. This is for the ResourceTable component to reference and create a Default Value row.", "name": "default_value", "verbose_name": "default value" },
                        { "field_type": 1, "help_text": "If the tag type is a boolean, this field holds the default value. Otherwise, this field is Null", "name": "default_boolean_value", "verbose_name": "default boolean value" },
                        { "field_type": 2, "help_text": "If the tag type is a string, date, number, or single options, this field holds the default value. Otherwise, this field is Null", "name": "default_string_value", "verbose_name": "default string value" },
                        { "field_type": null, "help_text": "If the tag type is a multiple options, this field holds the default value. Otherwise, this field is Null", "name": "default_multi_value", "verbose_name": "default multi value" },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Represent the owner model for this CustomTag, e.g. Supporter, PublicOrganization",
                            "name": "tag_owner",
                            "verbose_name": "CustomTag's owner model"
                        },
                        { "field_type": 1, "help_text": "If this field should be visible and editable by the Supporter/Person on the unsubscribe page", "name": "used_to_generate_outbox_email_lists", "verbose_name": "used to generate outbox email lists" },
                        { "field_type": 2, "help_text": "The name displayed externally to a Supporter or Person", "name": "external_name", "verbose_name": "external name" },
                        { "field_type": 3, "help_text": "The description displayed externally to a Supporter or Person as a tooltip", "name": "external_description", "verbose_name": "external description" },
                        { "field_type": 1, "help_text": "Whether a URL input is displayed to hyperlink a text Custom Field value.", "name": "is_hyperlinkable", "verbose_name": "is hyperlinkable" },
                        { "field_type": 1, "help_text": "If this field should be required when editing the tag owner", "name": "is_required", "verbose_name": "is required" },
                        { "field_type": 1, "help_text": "Whether this field is editable from the application (via the UI). Useful to set to False if managed via a backend process.", "name": "is_editable", "verbose_name": "is editable" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the object's profile page", "name": "display_on_profile", "verbose_name": "display on profile" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the search page", "name": "display_on_filters", "verbose_name": "display on filters" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the create page", "name": "display_on_create_page", "verbose_name": "display on create page" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the object's profile page even if the value is null", "name": "display_null_value", "verbose_name": "display null value" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "conditional_parent_custom_field",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "conditional parent custom field"
                        },
                        { "field_type": 1, "help_text": "If conditional_parent_custom_field is a boolean type, this field specifies what value the parent must have to render this custom field", "name": "conditional_boolean_value", "verbose_name": "conditional boolean value" },
                        { "field_type": 3, "help_text": "If conditional_parent_custom_field is a string, select one, or number type, this field specifies what value the parent must have to render this custom field", "name": "conditional_string_value", "verbose_name": "conditional string value" },
                        { "field_type": null, "help_text": "", "name": "conditional_list_value", "verbose_name": "conditional list value" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "If tag_type is power_search, this is the data set that is being power searched on",
                            "name": "power_search_data_set",
                            "verbose_name": "power search data set"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "GrassrootsActionCenterSettings": {
                    "__is_model": true,
                    "__name__": "GrassrootsActionCenterSettings",
                    "data_model": "app.grassroots.models.GrassrootsActionCenterSettings",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/grassrootsactioncentersettings/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "This field maps to the og:description and twitter:description fields. It's typically recommended to keep this less than 200 characters.", "name": "social_description", "verbose_name": "social description" },
                        { "field_type": 3, "help_text": "The URL of an image to display on social media. Typically square and at least 50px by 50px.", "name": "social_image_url", "verbose_name": "social image url" },
                        { "field_type": 3, "help_text": "An alternative text to be displayed in place of the image as a fallback or for sight-restricted individuals.", "name": "social_image_alttext", "verbose_name": "social image alttext" },
                        { "field_type": 3, "help_text": "The title of your page that will show up first in Twitter or Facebook.", "name": "social_title", "verbose_name": "social title" },
                        { "field_type": 3, "help_text": "If it is possible to control what is shared on social media when someone clicks a button to share a given page, what message should be shared.", "name": "social_share_text", "verbose_name": "social share text" },
                        { "field_type": 3, "help_text": "The keyword attached to this item used to redirect to the item if texted by a supporter", "name": "text_keyword", "verbose_name": "text keyword" },
                        { "field_type": 3, "help_text": "Text to use in response to an inbound text with this action center's keyword.", "name": "inbound_texting_reply_message", "verbose_name": "inbound texting reply message" },
                        {
                            "field_type": 7,
                            "help_text": "phone number used for inbound texting for this object",
                            "name": "phone_number",
                            "related_model": { "__module__": "app.texting.models", "__name__": "PhoneNumber" },
                            "verbose_name": "phone number"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The name that the organization wants to be known by in the Action Center", "name": "organization_user_specified_name", "verbose_name": "organization user specified name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "language",
                            "sheet_column": true,
                            "verbose_name": "Campaign Language"
                        },
                        { "field_type": 2, "help_text": "The twitter name to be used in tweet campaigns", "name": "twitter_handle", "verbose_name": "twitter handle" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization_design",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                            "verbose_name": "organization design"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "The full name to show in the Action Center -- replaces Organization Name + Action Center Name", "name": "full_name", "verbose_name": "full name" },
                        { "field_type": 3, "help_text": "", "name": "welcome_message", "verbose_name": "welcome message" },
                        { "field_type": 3, "help_text": "", "name": "login_message", "verbose_name": "login message" },
                        { "field_type": 3, "help_text": "", "name": "default_thank_you_message", "verbose_name": "default thank you message" },
                        { "field_type": 1, "help_text": "", "name": "show_welcome_message", "verbose_name": "show welcome message" },
                        { "field_type": 1, "help_text": "", "name": "show_login_message", "verbose_name": "show login message" },
                        { "field_type": 1, "help_text": "", "name": "show_footer_logo", "verbose_name": "show footer logo" },
                        { "field_type": 1, "help_text": "Whether the Powered by Quorum link should be shown in the footer.", "name": "show_quorum_link", "verbose_name": "show quorum link" },
                        { "field_type": 2, "help_text": "", "name": "footer_logo_url", "verbose_name": "footer logo url" },
                        { "field_type": 1, "help_text": "", "name": "show_org_name_in_top_bar", "verbose_name": "show org name in top bar" },
                        { "field_type": 1, "help_text": "Whether this action center allow users to updated their information", "name": "show_update_info", "verbose_name": "show update info" },
                        { "field_type": 1, "help_text": "Whether the texture behind the login and register pages should be shown.", "name": "hide_texture", "verbose_name": "hide texture" },
                        { "field_type": 1, "help_text": "Whether users can login with facebook to the action center", "name": "can_login_with_facebook", "verbose_name": "can login with facebook" },
                        { "field_type": 1, "help_text": "Whether the registration forms should show a password field (only on the register page -- campaigns never do)", "name": "show_password", "verbose_name": "show password" },
                        { "field_type": 1, "help_text": "", "name": "show_action_items", "verbose_name": "show action items" },
                        { "field_type": null, "help_text": "", "name": "action_items", "verbose_name": "action items" },
                        { "field_type": 1, "help_text": "", "name": "publicly_accessible", "verbose_name": "publicly accessible" },
                        { "field_type": 2, "help_text": "", "name": "default_password", "verbose_name": "default password" },
                        { "field_type": 2, "help_text": "", "name": "legislation_header", "verbose_name": "legislation header" },
                        { "field_type": 3, "help_text": "", "name": "legislation_description", "verbose_name": "legislation description" },
                        { "field_type": 2, "help_text": "", "name": "relationship_header", "verbose_name": "relationship header" },
                        { "field_type": 3, "help_text": "", "name": "relationship_description", "verbose_name": "relationship description" },
                        { "field_type": 3, "help_text": "", "name": "default_letter_message", "verbose_name": "default letter message" },
                        { "field_type": 3, "help_text": "", "name": "default_letter_subject", "verbose_name": "default letter subject" },
                        { "field_type": 3, "help_text": "", "name": "default_interaction_log_text", "verbose_name": "default interaction log text" },
                        { "field_type": 3, "help_text": "", "name": "default_interaction_log_title", "verbose_name": "default interaction log title" },
                        { "field_type": 4, "help_text": "", "name": "maximum_campaigns_first_page", "verbose_name": "maximum campaigns first page" },
                        { "field_type": null, "help_text": "Other default fields directly attached to the supporter that are required to register. This includes phone_number, title, prefix, suffix, secondary_phone", "name": "additional_default_registration_fields", "verbose_name": "additional default registration fields" },
                        { "field_type": 1, "help_text": "Specifies whether an external interaction logger or interaction campaign should require an official or staffer", "name": "should_require_interaction_official", "verbose_name": "should require interaction official" },
                        { "field_type": 1, "help_text": "Specifies whether the external interaction/relationship logger should include the contact's city and state when displaying the name", "name": "should_display_contact_city_state_in_external_logger", "verbose_name": "should display contact city state in external logger" },
                        { "field_type": null, "help_text": "Setting this field with an array of interaction types overrides the selector for the interaction types in the external logger.", "name": "external_interaction_types", "verbose_name": "external interaction types" },
                        { "field_type": null, "help_text": "Setting this field with an array of interaction types overrides the selector for the interaction types in the external relationship survey.", "name": "external_relationship_types", "verbose_name": "external relationship types" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Google Analytics, their custom UA code should be placed here.", "name": "external_ua_code", "verbose_name": "external ua code" },
                        { "field_type": 2, "help_text": "If a client would like to track individual actions via Google Tag Manager, their custom GTM ID should be placed here.", "name": "external_gtm_code", "verbose_name": "external gtm code" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Facebook, their custom FB pixel ID should be placed here.", "name": "external_fb_code", "verbose_name": "external fb code" },
                        { "field_type": 2, "help_text": "If a client would like to track activity via Adobe DTM, their custom tracking url should be placed here.", "name": "external_adobe_dtm_tag", "verbose_name": "external adobe dtm tag" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization_ng",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization ng"
                        },
                        { "field_type": null, "help_text": "List of integers generally corresponding to MinorRoleType enum values.", "name": "allowed_minor_role_types", "verbose_name": "allowed minor role types" },
                        { "field_type": null, "help_text": "List of integers generally corresponding to PersonGeneralRole enum values.", "name": "allowed_person_general_roles", "verbose_name": "allowed person general roles" },
                        { "field_type": 2, "help_text": "The domain attached to this action center, eg savethewhales in savethewhales.quorum.us", "name": "domain", "verbose_name": "domain" },
                        {
                            "field_type": 7,
                            "help_text": "The default grassroots page for our action center!",
                            "name": "index_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "QuorumGrassrootsPage" },
                            "verbose_name": "index page"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default registration page for our action center!",
                            "name": "default_registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "default registration page"
                        },
                        { "field_type": null, "help_text": "Represents the header of the action center.", "name": "header", "verbose_name": "header" },
                        { "field_type": null, "help_text": "Represents the footer of the action center.", "name": "footer", "verbose_name": "footer" },
                        { "field_type": null, "help_text": "Represents the navigation bar of the action center.", "name": "navigation_bar", "verbose_name": "navigation bar" },
                        { "field_type": 1, "help_text": "Determines if the organization's custom description (on DataDescription object) should be shown on member profile", "name": "should_show_official_custom_description", "verbose_name": "should show official custom description" },
                        { "field_type": 3, "help_text": "Custom styling the user can edit", "name": "custom_css", "verbose_name": "custom css" },
                        { "field_type": 1, "help_text": "Whether or not an action center should display a custom footer using footer_html", "name": "should_use_footer_html", "verbose_name": "should use footer html" },
                        { "field_type": 3, "help_text": "The custom html the organization sets to be displayed as the footer instead of the standard 'Powered by Quorum' footer", "name": "footer_html", "verbose_name": "footer html" },
                        { "field_type": 3, "help_text": "After login to a private action center, redirect to a link (can be relative or absolute link)", "name": "login_redirect_url", "verbose_name": "login redirect url" },
                        { "field_type": 3, "help_text": "The pre login text on the private action center's login page", "name": "login_page_pre_text", "verbose_name": "login page pre text" },
                        { "field_type": 3, "help_text": "The post login text on the private action center's login page", "name": "login_page_post_text", "verbose_name": "login page post text" },
                        { "field_type": 3, "help_text": "The label and placeholder for the username field on the private action center's login page", "name": "login_page_username_label", "verbose_name": "login page username label" },
                        { "field_type": 3, "help_text": "The label and placeholder for the username field on the private action center's login page", "name": "login_page_password_label", "verbose_name": "login page password label" },
                        { "field_type": 1, "help_text": "Whether we should allow custom action center domains to be indexable (ie, searchable on google)", "name": "allow_search_indexable_custom_domain", "verbose_name": "allow search indexable custom domain" },
                        { "field_type": 2, "help_text": "The text that will be displayed in the tooltip on the Action Center Update, Donation and Registration Page", "name": "tooltip_text", "verbose_name": "tooltip text" },
                        { "field_type": null, "help_text": "Fields that will have a read only state", "name": "read_only_form_fields", "verbose_name": "read only form fields" },
                        { "field_type": 1, "help_text": "If Gamification is enabled for this Action Center", "name": "gamification_enabled", "verbose_name": "gamification enabled" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationCampaignPointType" },
                            "field_type": 4,
                            "help_text": "Specifies how admins can assign point values to campaigns, by campaign type or all campaigns",
                            "name": "gamification_point_type",
                            "verbose_name": "gamification point type"
                        },
                        { "field_type": null, "help_text": "For 'Custom Point Type', dictionary mapping Campaign type and the potential points to earn. Key: CampaignType enum value. Value: points", "name": "gamification_campaign_type_points", "verbose_name": "gamification campaign type points" },
                        { "field_type": 4, "help_text": "Amount of points a Supporter has within an Action Center", "name": "gamification_all_campaign_points", "verbose_name": "gamification all campaign points" },
                        { "field_type": 1, "help_text": "If Gamification \"tiers\" will be shown to advocates", "name": "show_gamification_tiers", "verbose_name": "show gamification tiers" },
                        { "field_type": null, "help_text": "The different tiers an advocate could earn Key: Tier name. Value: dict of tier props (point value, image, message)", "name": "gamification_tiers", "verbose_name": "gamification tiers" },
                        { "field_type": 1, "help_text": "If Gamification \"ranks\" will be shown to advocates", "name": "show_gamification_ranks", "verbose_name": "show gamification ranks" },
                        { "field_type": null, "help_text": "Caches the amount of points needed to reach a rank. Key: GamificationRankType enum value. Value: Points needed", "name": "gamification_ranks", "verbose_name": "gamification ranks" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GamificationAchievementIconType" },
                            "field_type": 4,
                            "help_text": "The icon that is shown on the gamification statistics widget or when an advocate earns points",
                            "name": "gamification_achievement_icon_type",
                            "verbose_name": "gamification achievement icon type"
                        },
                        { "field_type": 1, "help_text": "If the custom image for a gamification tier is specified, display that image in gamification stats widget and thanks page", "name": "should_use_custom_stats_icon", "verbose_name": "should use custom stats icon" },
                        { "field_type": 3, "help_text": "Custom Javascript, is run once when the top component is mounted", "name": "custom_javascript", "verbose_name": "custom javascript" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "FacebookConnectionStatus" },
                            "field_type": 4,
                            "help_text": "For lead ads integration, the current status of the connection to Facebook",
                            "name": "facebook_status",
                            "verbose_name": "facebook status"
                        },
                        { "field_type": null, "help_text": "An object provided by the user with information for connecting to facebook, should have properties for pageId and userAccessToken when initially saved", "name": "facebook_connection", "verbose_name": "facebook connection" },
                        { "field_type": 3, "help_text": "Page Id of page we want to use for lead ads. Facebook associates all advertisements with a page, which is supposed to represent a business. In this context pages are sometimes called accounts", "name": "facebook_page_id", "verbose_name": "facebook page id" },
                        { "field_type": 3, "help_text": "Access token used to access and Facebook to create, delete lead ads or view leads", "name": "facebook_access_token", "verbose_name": "facebook access token" },
                        { "field_type": 3, "help_text": "User access token to be used to get facebook_access_token. Since ads are created on pages, not individual accounts, this is only an intermediary to get the page token", "name": "facebook_user_token", "verbose_name": "facebook user token" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "ActionCenterTheme" },
                            "field_type": 4,
                            "help_text": "Theme that dictates style of Action Center.",
                            "name": "theme_type",
                            "verbose_name": "theme type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterNavigationBarBackgroundStyle" },
                            "field_type": 4,
                            "help_text": "Background style of the Action Center Navigation Bar.If null, use should_use_action_center_header_color to determine default.",
                            "name": "navigation_bar_style_type",
                            "verbose_name": "navigation bar style type"
                        },
                        { "field_type": 3, "help_text": "This image should be used for the Navigation Bar background if navigation_bar_style is Image.If null use background_image from OrganizationDesign.", "name": "navigation_bar_image_override_url", "verbose_name": "navigation bar image override url" },
                        { "field_type": 2, "help_text": "The background color that should be used for Navigation Bar background if navigation_bar_style is Color.If null and should_use_action_center_header_color from OrganizationDesign, use action_center_header_color from OrganizationDesign.", "name": "navigation_bar_color_override", "verbose_name": "navigation bar color override" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "ActionCenterBackgroundStyle" },
                            "field_type": 4,
                            "help_text": "Background style of the Action Center.If null, and background_image from OrganizationDesign is not null use background_image.If background_image is null, use background_color from OrganizationDesign.",
                            "name": "background_style_type",
                            "verbose_name": "background style type"
                        },
                        { "field_type": 3, "help_text": "This image should be used for the Action Center background if background_style is Image.If null, use background_image from OrganizationDesign.", "name": "background_image_override_url", "verbose_name": "background image override url" },
                        { "field_type": 2, "help_text": "The background color that should be used for Action background if background_style is Color.If null and background_image is null, use background_color on OrganizationDesign.", "name": "background_color_override", "verbose_name": "background color override" },
                        { "field_type": 3, "help_text": "url of custom favicon to display in tab of action center", "name": "custom_favicon_url", "verbose_name": "custom favicon url" },
                        { "field_type": 3, "help_text": "Text to use in outbound texting subscription confirmation message sent to new supporters.This should be the entire message, including any disclaimer text.", "name": "outbound_texting_confirmation_message", "verbose_name": "outbound texting confirmation message" },
                        {
                            "field_type": 7,
                            "help_text": "LedgerSettings associated with this action center",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        { "field_type": 3, "help_text": "Message to display when a supporter attempts to view a page, but are disallowed because they are not a PAC eligible. If this field is blank, we replace it with a default value. Only relevant for PAC-connected action centers.", "name": "pac_restricted_to_eligibles_message", "verbose_name": "pac restricted to eligibles message" },
                        { "field_type": 3, "help_text": "Like pac_restricted_to_eligibles_message, except if disallowed because they *are* eligible", "name": "pac_restricted_to_ineligibles_message", "verbose_name": "pac restricted to ineligibles message" },
                        { "field_type": 3, "help_text": "Like pac_restricted_to_eligibles_message but specifically for users that are not logged in.", "name": "pac_restricted_user_not_logged_in_message", "verbose_name": "pac restricted user not logged in message" },
                        { "field_type": 1, "help_text": "If conditional giving levels are enabled for this Action Center", "name": "conditional_giving_enabled", "verbose_name": "conditional giving enabled" },
                        { "field_type": 1, "help_text": "If this action center is a Collaborator Action Center", "name": "is_collaborator_action_center", "verbose_name": "is collaborator action center" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Additional custom tags that this organization wants to require as part of the registration process.",
                            "name": "additional_custom_registration_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "additional custom registration fields"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The issues related to this action center.",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this Action Center's external Interaction logger",
                            "name": "interaction_custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "interaction custom fields"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The custom fields associated with this Action Center's external Relationship logger",
                            "name": "relationship_custom_fields",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "relationship custom fields"
                        }
                    ],
                    "proxy_endpoint": "/api/actioncentersettings/"
                },
                "GrassrootsCustomTag": {
                    "__is_model": true,
                    "__name__": "GrassrootsCustomTag",
                    "data_model": "app.grassroots.models.GrassrootsCustomTag",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/grassrootscustomtag/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "TagType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "tag_type",
                            "sheet_column": true,
                            "sheets_display_key": "short_client_facing_label",
                            "verbose_name": "tag type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterTagOptionDisplayType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "option_display_type",
                            "sheet_column": true,
                            "verbose_name": "option display type"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 3, "help_text": "Text describing the Custom Field", "name": "description", "verbose_name": "description" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "group",
                            "related_model": { "__module__": "app.custom_field.models", "__name__": "CustomFieldGroup" },
                            "verbose_name": "group"
                        },
                        { "field_type": null, "help_text": "", "name": "options", "verbose_name": "options" },
                        { "field_type": null, "help_text": "The new implementation of options for Custom Fields. Instead of an ArrayField of values, options are a JSONField mapping slugs to value, order, and archived status", "name": "options_new", "verbose_name": "options new" },
                        { "field_type": 3, "help_text": "Regardless of tag type, the default value is stored as a string in this singular field. This is for the ResourceTable component to reference and create a Default Value row.", "name": "default_value", "verbose_name": "default value" },
                        { "field_type": 1, "help_text": "If the tag type is a boolean, this field holds the default value. Otherwise, this field is Null", "name": "default_boolean_value", "verbose_name": "default boolean value" },
                        { "field_type": 2, "help_text": "If the tag type is a string, date, number, or single options, this field holds the default value. Otherwise, this field is Null", "name": "default_string_value", "verbose_name": "default string value" },
                        { "field_type": null, "help_text": "If the tag type is a multiple options, this field holds the default value. Otherwise, this field is Null", "name": "default_multi_value", "verbose_name": "default multi value" },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Represent the owner model for this CustomTag, e.g. Supporter, PublicOrganization",
                            "name": "tag_owner",
                            "verbose_name": "CustomTag's owner model"
                        },
                        { "field_type": 1, "help_text": "If this field should be visible and editable by the Supporter/Person on the unsubscribe page", "name": "used_to_generate_outbox_email_lists", "verbose_name": "used to generate outbox email lists" },
                        { "field_type": 2, "help_text": "The name displayed externally to a Supporter or Person", "name": "external_name", "verbose_name": "external name" },
                        { "field_type": 3, "help_text": "The description displayed externally to a Supporter or Person as a tooltip", "name": "external_description", "verbose_name": "external description" },
                        { "field_type": 1, "help_text": "Whether a URL input is displayed to hyperlink a text Custom Field value.", "name": "is_hyperlinkable", "verbose_name": "is hyperlinkable" },
                        { "field_type": 1, "help_text": "If this field should be required when editing the tag owner", "name": "is_required", "verbose_name": "is required" },
                        { "field_type": 1, "help_text": "Whether this field is editable from the application (via the UI). Useful to set to False if managed via a backend process.", "name": "is_editable", "verbose_name": "is editable" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the object's profile page", "name": "display_on_profile", "verbose_name": "display on profile" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the search page", "name": "display_on_filters", "verbose_name": "display on filters" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the create page", "name": "display_on_create_page", "verbose_name": "display on create page" },
                        { "field_type": 1, "help_text": "If this field should be displayed on the object's profile page even if the value is null", "name": "display_null_value", "verbose_name": "display null value" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "conditional_parent_custom_field",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                            "verbose_name": "conditional parent custom field"
                        },
                        { "field_type": 1, "help_text": "If conditional_parent_custom_field is a boolean type, this field specifies what value the parent must have to render this custom field", "name": "conditional_boolean_value", "verbose_name": "conditional boolean value" },
                        { "field_type": 3, "help_text": "If conditional_parent_custom_field is a string, select one, or number type, this field specifies what value the parent must have to render this custom field", "name": "conditional_string_value", "verbose_name": "conditional string value" },
                        { "field_type": null, "help_text": "", "name": "conditional_list_value", "verbose_name": "conditional list value" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "If tag_type is power_search, this is the data set that is being power searched on",
                            "name": "power_search_data_set",
                            "verbose_name": "power search data set"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ],
                    "proxy_endpoint": "/api/customtag/"
                },
                "GrassrootsPageVisit": {
                    "__is_model": true,
                    "__name__": "GrassrootsPageVisit",
                    "data_model": "app.grassroots.models.GrassrootsPageVisit",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/grassrootspagevisit/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "GrassrootsPageType" },
                            "field_type": 4,
                            "help_text": "What kind of page did the supporter visit.",
                            "name": "page_type",
                            "verbose_name": "page type"
                        },
                        { "field_type": 2, "help_text": "", "name": "url", "verbose_name": "url" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        { "field_type": 2, "help_text": "", "name": "session_key", "verbose_name": "session key" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "campaign",
                            "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                            "verbose_name": "campaign"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "issue",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issue"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 5, "help_text": "Used for various things.", "name": "day", "verbose_name": "day" },
                        { "field_type": 21, "help_text": "", "name": "created", "verbose_name": "Created" }
                    ]
                },
                "GrassrootsRegistrationPage": {
                    "__is_model": true,
                    "__name__": "GrassrootsRegistrationPage",
                    "data_model": "app.grassroots.models.GrassrootsRegistrationPage",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/grassrootsregistrationpage/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "The subject of the confirmation email set by the user", "name": "conf_email_subject", "verbose_name": "conf email subject" },
                        { "field_type": 2, "help_text": "The from email address the Confirmation Email should be sent from", "name": "conf_email_from_address", "verbose_name": "conf email from address" },
                        { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to DEFAULT_CONFIRMATION_SEND_FROM_EMAIL", "name": "conf_email_from_name", "verbose_name": "conf email from name" },
                        { "field_type": 2, "help_text": "The name that should appear when replying to a confirmation email", "name": "conf_email_reply_to_name", "verbose_name": "conf email reply to name" },
                        { "field_type": 2, "help_text": "The reply_to address of the email the Confirmation Email should be sent to", "name": "conf_email_reply_to_address", "verbose_name": "conf email reply to address" },
                        { "field_type": 2, "help_text": "The from email username the Confirmation Email should be sent from", "name": "conf_email_from_address_username", "verbose_name": "conf email from address username" },
                        { "field_type": 2, "help_text": "The username portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_username", "verbose_name": "conf email reply to address username" },
                        { "field_type": 2, "help_text": "The domain portion of the email the Confirmation Email should be sent from", "name": "conf_email_reply_to_address_domain", "verbose_name": "conf email reply to address domain" },
                        { "field_type": 2, "help_text": "Name of the registration page", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If not null, grassroots users registering at this ActionCenter will receive a confirmation emailsent to their email addresses",
                            "name": "email_template",
                            "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                            "verbose_name": "email template"
                        },
                        { "field_type": 3, "help_text": "The message shown before the user submits the form, above the form fields", "name": "pre_text", "verbose_name": "pre text" },
                        { "field_type": 3, "help_text": "The message shown before the user submits the form, below the form fields", "name": "post_text", "verbose_name": "post text" },
                        { "field_type": 3, "help_text": "Text on the submit button. If left empty, defaults to 'Submit'", "name": "submit_button_text", "verbose_name": "submit button text" },
                        { "field_type": 3, "help_text": "For Donation forms, the disclaimer text to be displayed at the bottom of forms", "name": "disclaimer_text", "verbose_name": "disclaimer text" },
                        { "field_type": null, "help_text": "The necessary fields a user must fill in order to register.", "name": "form_fields", "verbose_name": "form fields" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "RegistrationPostSubmissionAction" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "post_submission_action_type",
                            "verbose_name": "post submission action type"
                        },
                        { "field_type": 3, "help_text": "The message seen after the user registers (if 'Thank you' message is specificed)", "name": "thank_you_text", "verbose_name": "thank you text" },
                        { "field_type": 3, "help_text": "The url the user is redirected to after registering (if specified)", "name": "redirect_url", "verbose_name": "redirect url" },
                        { "field_type": 1, "help_text": "Only true for registration pages created when an action center is created. False for user created pages", "name": "default", "verbose_name": "default" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GrassrootsFormType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "grassroots_form_type",
                            "verbose_name": "grassroots form type"
                        },
                        { "field_type": 3, "help_text": "", "name": "facebook_leadgen_form_id", "verbose_name": "facebook leadgen form id" },
                        { "field_type": null, "help_text": "", "name": "facebook_leadgen_form_questions", "verbose_name": "facebook leadgen form questions" },
                        { "field_type": 3, "help_text": "Javascript that is executable when the regisration form is mounted", "name": "custom_javascript", "verbose_name": "custom javascript" },
                        { "field_type": 3, "help_text": "Javascript that is executed when the registration form is successfully submitted", "name": "custom_after_registration_javascript", "verbose_name": "custom after registration javascript" },
                        { "field_type": 3, "help_text": "CSS that's loaded with the regisration form", "name": "custom_css", "verbose_name": "custom css" },
                        {
                            "field_type": 7,
                            "help_text": "The PAC associated with this registration page",
                            "name": "pac_classic_pac",
                            "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                            "verbose_name": "pac classic pac"
                        },
                        { "field_type": null, "help_text": "Donation methods the advocate is allowed to use in the donation form", "name": "allowed_donation_methods", "verbose_name": "allowed donation methods" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "pac_classic_site",
                            "related_model": { "__module__": "app.pac_classic.models.site", "__name__": "PacClassicSite" },
                            "verbose_name": "pac classic site"
                        },
                        { "field_type": null, "help_text": "List of user IDs who have been notified about the donation", "name": "donation_notified_users", "verbose_name": "donation notified users" },
                        { "field_type": null, "help_text": "List of emails who have been notified about the donation", "name": "donation_notified_emails", "verbose_name": "donation notified emails" },
                        { "field_type": 3, "help_text": "The address to which the check should be sent to (DEPRECATED: put the address in check_mailing_instruction instead)", "name": "check_mailing_address", "verbose_name": "check mailing address" },
                        { "field_type": 3, "help_text": "Instructions for mailing the check", "name": "check_mailing_instruction", "verbose_name": "check mailing instruction" },
                        { "field_type": null, "help_text": "Tier settings for the Check Contributions amounts", "name": "donation_amounts_check", "verbose_name": "donation amounts check" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "DonationFormType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "donation_form_type",
                            "verbose_name": "donation form type"
                        },
                        { "field_type": 3, "help_text": "Text above donation methods asking user to select one, if empty a reasonable default will be used", "name": "donation_method_prompt_text", "verbose_name": "donation method prompt text" },
                        { "field_type": 3, "help_text": "Text above donation amounts if credit card method is selected, if empty a reasonable default will be used", "name": "donation_amount_credit_prompt_text", "verbose_name": "donation amount credit prompt text" },
                        { "field_type": 3, "help_text": "Text above donation amounts if payroll method is selected, if empty a reasonable default will be used", "name": "donation_amount_payroll_prompt_text", "verbose_name": "donation amount payroll prompt text" },
                        { "field_type": null, "help_text": "The necessary fields a user must fill in order to register.", "name": "donation_amounts", "verbose_name": "donation amounts" },
                        { "field_type": null, "help_text": "The prefilled options for donation amounts for credit cards. To be used in donation forms.", "name": "donation_amounts_credit", "verbose_name": "donation amounts credit" },
                        { "field_type": null, "help_text": "The prefilled donation option amounts for payroll donations. To be used in donation forms.", "name": "donation_amounts_payroll", "verbose_name": "donation amounts payroll" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "PayrollFrequencyType" },
                            "field_type": 4,
                            "help_text": "For donation forms that have payroll donations",
                            "name": "payroll_frequency_type",
                            "verbose_name": "Payroll Frequency Type"
                        },
                        { "field_type": 1, "help_text": "Allow advocates to register for an action center with a partial address (e.g. only a zip code)", "name": "should_allow_partial_address", "verbose_name": "should allow partial address" },
                        { "field_type": 4, "help_text": "The number of times this form has been submitted", "name": "number_submissions", "verbose_name": "number submissions" },
                        { "field_type": 1, "help_text": "Whether this page has PAC match enabled", "name": "enabled_pac_match", "verbose_name": "enabled pac match" },
                        { "field_type": 3, "help_text": "Custom label for charity select", "name": "pac_match_select_label", "verbose_name": "pac match select label" },
                        { "field_type": 3, "help_text": "Descriptive text for the charity match select", "name": "pac_match_description", "verbose_name": "pac match description" },
                        { "field_type": 4, "help_text": "Minimum required donation for PAC Match", "name": "pac_match_threshold", "verbose_name": "pac match threshold" },
                        { "field_type": null, "help_text": "Represents the Payroll donation type the advocate is allowed to use in the donation form", "name": "allowed_payroll_donation_types", "verbose_name": "allowed payroll donation types" },
                        { "field_type": null, "help_text": "Represents the tier settings for the Percentage Payroll type", "name": "donation_percentages_payroll", "verbose_name": "donation percentages payroll" },
                        { "field_type": 3, "help_text": "Represents the amount of the Payroll Donation Type at the Donation Form", "name": "payroll_amount_label", "verbose_name": "payroll amount label" },
                        { "field_type": 3, "help_text": "Represents the percentage of the Payroll Donation Type at the Donation Form", "name": "payroll_percentage_label", "verbose_name": "payroll percentage label" },
                        { "field_type": 1, "help_text": "Switch button to enable checkbox of Terms and Conditions on the Donation Form", "name": "terms_and_conditions_switch", "verbose_name": "terms and conditions switch" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "GrassrootsSupporterAction": {
                    "__is_model": true,
                    "__name__": "GrassrootsSupporterAction",
                    "data_model": "app.grassroots.models.GrassrootsSupporterAction",
                    "default_exclude_filters": { "interaction_type": 34 },
                    "default_filters": { "archived": false },
                    "endpoint": "/api/supporteraction/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                            "field_type": 4,
                            "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                            "miscellaneous": 12,
                            "name": "source_type",
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "sheets_tooltip_text": "The Source of this Contact",
                            "verbose_name": "Source Type"
                        },
                        { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                        { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                        { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                        { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                        { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                        { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                        { "field_type": 3, "help_text": "The text body of the message", "name": "text", "verbose_name": "text" },
                        { "field_type": 3, "help_text": "The raw content of the message (should be full text searchable)", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 16, "help_text": "The date that the supporter action took place", "name": "date", "verbose_name": "date" },
                        { "field_type": 2, "help_text": "Date searchable and in a human-readable format", "name": "searchable_date", "verbose_name": "searchable date" },
                        { "field_type": 2, "help_text": "The subject of the message to legislator", "name": "subject", "verbose_name": "subject" },
                        { "field_type": 2, "help_text": "If this is a comment regulation campaign, this the name of the organization", "name": "submitting_org_name", "verbose_name": "submitting org name" },
                        { "field_type": 1, "help_text": "Whether or not the action has been confirmed in a campaign requiring approval", "name": "confirmed", "verbose_name": "confirmed" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionType" },
                            "field_type": 4,
                            "help_text": "The type of the supporter action",
                            "name": "supporter_action_type",
                            "verbose_name": "supporter action type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "GrassrootsInteractionType" },
                            "field_type": 4,
                            "help_text": "Interaction type for the action. Required for all actions to help build inlines",
                            "name": "interaction_type",
                            "verbose_name": "interaction type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "NoteType" },
                            "field_type": 4,
                            "help_text": "Note type for the action. Should all be interactions",
                            "name": "note_type",
                            "verbose_name": "note type"
                        },
                        { "field_type": 2, "help_text": "The delivery id from submitting it via CWC API", "name": "delivery_id", "verbose_name": "delivery id" },
                        { "field_type": null, "help_text": "Tricky cache needed for inline formatting", "name": "cache_json", "verbose_name": "cache json" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SocialMediaType" },
                            "field_type": 4,
                            "help_text": "The type of social media being shared on Shared campaigns",
                            "name": "social_media_type",
                            "verbose_name": "social media type"
                        },
                        { "field_type": null, "help_text": "The regions represented by all of the different actions", "name": "regions", "verbose_name": "regions" },
                        { "field_type": 3, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                        { "field_type": 3, "help_text": "The humanized display text on the object. Previously a property.", "name": "humanized_text", "verbose_name": "humanized text" },
                        { "field_type": 4, "help_text": "Length of grassroots phone call in seconds", "name": "call_duration", "verbose_name": "call duration" },
                        { "field_type": 4, "help_text": "Amount of points a supporter earned from this action", "name": "points_earned", "verbose_name": "points earned" },
                        { "field_type": 4, "help_text": "Number of answers provided for this action", "name": "answers_amount", "verbose_name": "answers amount" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 3, "help_text": "The cameratag video id for the share story action", "name": "share_story_video_uuid", "verbose_name": "share story video uuid" },
                        {
                            "field_type": 7,
                            "help_text": "The short link for Gather Voice recorded video",
                            "name": "share_story_video_short_link",
                            "related_model": { "__module__": "app.short_link.models", "__name__": "ShortLink" },
                            "verbose_name": "share story video short link"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The id of the related note. A one-to-one mapping from the old SA to new GSA model",
                            "name": "note",
                            "related_model": { "__module__": "app.userdata.notes.models", "__name__": "Note" },
                            "verbose_name": "note"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The supporter who owns this supporter action",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The person who the message is targeted for",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The public organization for the supporter action",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The campaign this supporter action is associated with",
                            "name": "campaign",
                            "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                            "verbose_name": "campaign"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The registration page the supporter used to register to the action center",
                            "name": "registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that the supporter action is taking an action for",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The user associated with the action",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bulk_email",
                            "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                            "verbose_name": "bulk email"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The BulkSMS from which this action originated",
                            "name": "bulk_sms",
                            "related_model": { "__module__": "app.texting.models", "__name__": "BulkSMS" },
                            "verbose_name": "bulk sms"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        { "field_type": 2, "help_text": "Target email for different types of people, not just standard legislators", "name": "custom_email_target", "verbose_name": "custom email target" },
                        { "field_type": 1, "help_text": "Whether the message was delivered successfully or not", "name": "delivered", "verbose_name": "delivered" },
                        { "field_type": 1, "help_text": "Marks if the supporter action was attempted to be delivered and failed", "name": "failed_delivery", "verbose_name": "failed delivery" },
                        { "field_type": null, "help_text": "The results from the delivery of the supporter action", "name": "audit_trail", "verbose_name": "audit trail" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionStatus" },
                            "field_type": 4,
                            "help_text": "The current status of this supporter action",
                            "name": "message_status",
                            "verbose_name": "message status"
                        },
                        { "field_type": null, "help_text": "Various timestamps collected every time an action has been attempted to be delivered", "name": "timestamp", "verbose_name": "timestamp" },
                        { "field_type": 4, "help_text": "The number of delivery attempts on a suporter action", "name": "num_attempts", "verbose_name": "num attempts" },
                        { "field_type": 1, "help_text": "Indicator if the action is inlvolved in grassroots. Holdover from Note model", "name": "from_grassroots", "verbose_name": "from grassroots" },
                        { "field_type": 21, "help_text": "Time when the delivery was made", "name": "delivered_timestamp", "verbose_name": "delivered timestamp" },
                        { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "sheet_column": true, "verbose_name": "opens" },
                        { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "sheet_column": true, "verbose_name": "clicks" },
                        { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                        { "field_type": 16, "help_text": "timestamp for when the first open occurred", "name": "first_open", "verbose_name": "first open" },
                        { "field_type": 4, "help_text": "A nonnegative transaction account, in the smallest denomination, assummed to be USD cents", "name": "amount", "verbose_name": "amount" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "TransactionMethodType" },
                            "field_type": 4,
                            "help_text": "The Type of method - credit card, ach transfer, etc",
                            "name": "transaction_method_type",
                            "verbose_name": "transaction method type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "PayrollFrequencyType" },
                            "field_type": 4,
                            "help_text": "Payroll frequency for payroll contributions",
                            "name": "payroll_frequency_type",
                            "verbose_name": "payroll frequency type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "PayrollDonationType" },
                            "field_type": 4,
                            "help_text": "Whether the donation is an amount or percentage",
                            "name": "payroll_donation_type",
                            "verbose_name": "payroll donation type"
                        },
                        { "field_type": 3, "help_text": "The decimal value to be donated. Stored as string to prevent floating point precision issues.", "name": "payroll_decimal_value", "verbose_name": "payroll decimal value" },
                        { "field_type": 3, "help_text": "Label for percentage option in donation form, stored for export", "name": "percentage_label", "verbose_name": "percentage label" },
                        {
                            "field_type": 7,
                            "help_text": "The quorum user that created the authorized contribution at the admin panel",
                            "name": "created_by",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "created by"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "export_batch",
                            "related_model": { "__module__": "app.pac.models.pac_donation_export", "__name__": "PACDonationExport" },
                            "verbose_name": "export batch"
                        },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        {
                            "field_type": 7,
                            "help_text": "The PAC associated with the action",
                            "name": "pacc_pac",
                            "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                            "verbose_name": "pacc pac"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The projects this supporter action is associated with. It can be associated with multiple projects",
                            "name": "projects",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "projects"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        }
                    ]
                },
                "NewSupporter": {
                    "__is_model": true,
                    "__name__": "NewSupporter",
                    "data_model": "app.grassroots.models.NewSupporter",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/newsupporter/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        { "field_type": null, "help_text": "A cache of the teams in the limited_to_teams m2m that is used so we can avoid doing a join on every lookup", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                            "field_type": 4,
                            "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                            "miscellaneous": 12,
                            "name": "source_type",
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "sheets_tooltip_text": "The Source of this Contact",
                            "verbose_name": "Source Type"
                        },
                        { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                        { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                        { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                        { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                        { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                        { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                        { "field_type": 16, "help_text": "When the contact was created.", "name": "created", "overriden_column_data_type": 7, "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Created" },
                        { "field_type": 16, "help_text": "When the contact was most recently updated.", "name": "updated", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Updated" },
                        { "feature_flag_slug": "ff_pac", "field_type": 3, "help_text": "The employer of the contact, if applicable.", "name": "employer", "sheet_column": true, "verbose_name": "Employer" },
                        {
                            "field_type": 7,
                            "help_text": "The QuorumUser record for the Contact, permitting access to the Grassroots Action Center.",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "User Account Object"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The last Quorum Platform User that created/edited this Supporter in any way.",
                            "name": "last_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "Last-modified QuorumUser"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Quorum Client Organization that owns this supporter record.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "Organization Obj"
                        },
                        { "field_type": 4, "help_text": "The ID of the individual in the PAC Classic system.", "name": "pacc_individual_id", "verbose_name": "pacc individual id" },
                        { "field_type": 4, "help_text": "The ID of the organization in the PAC Classic system.", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "feature_flag_slug": "ff_pac_charitable_match_search", "field_type": 16, "help_text": "Last time the supporter's charity selection was updated", "name": "pac_charity_selection_date", "patch": true, "sheet_column": true, "sheets_subcategory": 25, "verbose_name": "Charity Selection Date" },
                        { "field_type": 3, "help_text": "The fax number of the contact, if applicable.", "name": "fax", "verbose_name": "Fax" },
                        {
                            "feature_flag_slug": "ff_pac",
                            "field_type": 3,
                            "help_text": "A contact's occupation",
                            "name": "occupation",
                            "sheet_column": true,
                            "sheets_column_order": 13,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Occupation"
                        },
                        { "field_type": 3, "help_text": "The work phone number of the contact, if applicable.", "name": "work_phone", "verbose_name": "Work Phone" },
                        { "field_type": 3, "help_text": "The work fax number of the contact, if applicable.", "name": "work_fax", "verbose_name": "Work Fax" },
                        { "field_type": 4, "help_text": "The PAC conditional giving level of the contact, if applicable.", "name": "pac_conditional_giving_level_deprecated", "verbose_name": "Conditional Giving Level" },
                        { "feature_flag_slug": "ff_pac_permissions_one", "field_type": 3, "help_text": "The PAC conditional giving level of the contact, if applicable.", "name": "pac_conditional_giving_level", "patch": true, "sheet_column": true, "sheets_subcategory": 25, "verbose_name": "Conditional Giving Level" },
                        { "field_type": 1, "help_text": "Whether the contact is eligible for PAC Hybrid donations.", "name": "pac_hybrid_eligible", "verbose_name": "PAC Hybrid Eligible" },
                        {
                            "field_type": 7,
                            "help_text": "Legacy public_organization foreign key, no longer in use.",
                            "included_related_model_fields": ["name"],
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "verbose_name": "Organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Whether there is a record in the Officials or Staffers datasets visible to you that has the same email address.",
                            "name": "email_related_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "Person related by Email"
                        },
                        { "field_type": 1, "help_text": "Whether the email address is known to be invalid - FALSE indicates that the email address is known to be invalid,TRUE indicates only that the email address is not already known to be invalid, but does not indicate that it hasbeen excplicitly validated in any way.", "name": "valid_email", "verbose_name": "valid email" },
                        { "field_type": 2, "help_text": "Random id for the Contact used to track requests to Unsubscribe from Outbox.", "name": "bulk_email_unsubscribe_key", "verbose_name": "bulk email unsubscribe key" },
                        { "field_type": 1, "help_text": "Whether the contact is unsubscribed from your bulk emails.", "name": "unsubscribed_from_bulk_emails", "patch": true, "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Unsubscribed" },
                        { "field_type": 16, "help_text": "Date that this contact unsubscribed from all Outbox emails.", "name": "date_unsubscribed_from_bulk_emails", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Unsubscribed from Emails" },
                        { "field_type": 1, "help_text": "Whether the contact is explicitly unsubscribed from your text messages.", "name": "unsubscribed_from_texting", "verbose_name": "Unsubscribed from texting" },
                        { "field_type": 16, "help_text": "Date that this contact unsubscribed from receiving text messages", "name": "date_unsubscribed_from_texting", "verbose_name": "Date Unsubscribed from Texting" },
                        { "field_type": 1, "help_text": "Whether the contact has opened or clicked on any emails from this organization in the last 120 days or was added to the account within the last 30 days.", "name": "is_recently_active_email_recipient", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Recently Engaged with Outbox Emails" },
                        { "field_type": 2, "help_text": "A hash value of data fields on the Contact to quickly identify when data has changed. NOTE:Does not cover data stored in Array or Dictionary fields, including Custom Fields.", "name": "data_hash", "verbose_name": "data hash" },
                        { "field_type": 1, "help_text": "Whether or not the account has been activated by a Contact through them logging in to the Grassroots Action Center.", "name": "activated", "verbose_name": "Account Actived" },
                        { "field_type": 1, "help_text": "User Account Validated", "name": "active", "verbose_name": "User Account Validated" },
                        { "field_type": 1, "help_text": "Whether an org created this supporter and is waiting to be used by the user.", "name": "waiting_to_be_created_by_user", "verbose_name": "Waiting for user initializtion" },
                        { "field_type": 2, "help_text": "Hashed value of the password set for the Contact through a protected Grassroots Action Center.", "name": "password", "verbose_name": "Password" },
                        { "field_type": 2, "help_text": "Contact Full Name.", "name": "name", "patch": true, "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 3, "verbose_name": "Name" },
                        { "field_type": 2, "help_text": "Contact First Name.", "name": "firstname", "patch": true, "sheet_column": true, "sheets_column_order": 2, "sheets_subcategory": 3, "verbose_name": "First Name" },
                        { "field_type": 2, "help_text": "Contact Last Name.", "name": "lastname", "patch": true, "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 3, "verbose_name": "Last Name" },
                        { "field_type": 2, "help_text": "Contact Middle Name.", "name": "middlename", "patch": true, "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Middle Name" },
                        { "field_type": 2, "help_text": "Contact Preferred Name.", "name": "preferred_name", "patch": true, "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Preferred Name" },
                        { "field_type": 2, "help_text": "Prefix of a person's name, like Mr., Mrs., The Honorable, etc.", "name": "prefix", "patch": true, "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 3, "verbose_name": "Prefix" },
                        { "field_type": 3, "help_text": "A unique Stripe identifier for this Supporter. This id is created when the Supporter interacts with Stripe for the first time.", "name": "stripe_customer_id", "verbose_name": "stripe customer id" },
                        { "field_type": 2, "help_text": "Suffix of a person's name, like III, Jr., etc.", "name": "suffix", "patch": true, "sheet_column": true, "sheets_column_order": 7, "sheets_subcategory": 3, "verbose_name": "Suffix" },
                        { "field_type": 5, "help_text": "The birthdate of this Contact.", "name": "birthdate", "sheet_column": true, "sheets_subcategory": 3, "verbose_name": "Birthdate" },
                        { "field_type": 2, "help_text": "Primary Email Address for this Contact; this is the address available in Outbox to email this Contact.", "name": "email", "patch": true, "sheet_column": true, "sheets_column_order": 8, "sheets_subcategory": 3, "verbose_name": "Email Address" },
                        { "field_type": 2, "help_text": "Secondary Email (personal etc.) assuming the first one is work/primary email", "name": "secondary_email", "patch": true, "sheet_column": true, "sheets_column_order": 12, "sheets_subcategory": 3, "verbose_name": "Secondary Email (personal etc.) assuming the first one is work/primary email" },
                        { "field_type": 2, "help_text": "Supporter's webpage, like www.greatagain.gov", "name": "website", "verbose_name": "Website" },
                        { "field_type": 2, "help_text": "", "name": "phone_number", "patch": true, "sheet_column": true, "sheets_column_order": 9, "sheets_subcategory": 3, "verbose_name": "Home/Work Number" },
                        { "field_type": 2, "help_text": "", "name": "secondary_phone", "patch": true, "sheet_column": true, "sheets_column_order": 10, "sheets_subcategory": 3, "verbose_name": "Cell Number" },
                        { "field_type": 2, "help_text": "", "name": "extension", "patch": true, "sheet_column": true, "sheets_column_order": 10, "sheets_subcategory": 3, "verbose_name": "Telephone Extension" },
                        { "field_type": 2, "help_text": "", "name": "secondary_extension", "verbose_name": "Telephone Extension" },
                        { "field_type": 3, "name": "address", "patch": true, "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Verified Address" },
                        { "field_type": 3, "help_text": "", "name": "input_address", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Input Address" },
                        { "field_type": 2, "help_text": "The person's most recent title", "name": "title", "patch": true, "sheet_column": true, "sheets_column_order": 12, "sheets_subcategory": 3, "verbose_name": "Title" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 2, "help_text": "The organization-specific unique identifier for this Contact.", "name": "unique_identifier", "sheet_column": true, "sheets_column_order": 13, "sheets_subcategory": 3, "verbose_name": "Unique Identifier" },
                        { "field_type": 6, "help_text": "The latitude of the Geocoded address for this Contact.", "name": "latitude", "verbose_name": "latitude" },
                        { "field_type": 6, "help_text": "The longitude of the Geocoded address for this Contact.", "name": "longitude", "verbose_name": "longitude" },
                        { "field_type": null, "help_text": "The Point (lat, lon) where this supporter/contact is based at, if any", "name": "coordinates", "verbose_name": "coordinates" },
                        { "field_type": 3, "help_text": "The first line of the Geocoded address for this Contact.", "name": "street_address", "verbose_name": "Street Address" },
                        { "field_type": 3, "help_text": "The second line of the Geocoded address for this Contact.", "name": "street_address_2", "verbose_name": "Street Address, Second Line" },
                        { "field_type": 3, "help_text": "The city of the Geocoded address for this Contact.", "name": "city", "verbose_name": "City" },
                        { "field_type": 2, "help_text": "The country of the Geocoded address for this Contact.", "name": "county_name", "verbose_name": "County" },
                        { "field_type": 2, "help_text": "The state of the Geocoded address for this Contact.", "name": "state_name", "verbose_name": "State" },
                        { "field_type": 2, "help_text": "The postal code of the Geocoded address for this Contact.", "name": "postal_code", "verbose_name": "Postal Code" },
                        { "field_type": 2, "help_text": "The postal code extension of the Geocoded address for this Contact.", "name": "postal_code_ext", "verbose_name": "Postal Code Extension" },
                        { "field_type": 2, "help_text": "", "name": "country_name", "verbose_name": "Country Name" },
                        { "field_type": 2, "help_text": "An alternate address entered for the Contact; note that this field is not Geocoded.", "name": "alternate_address", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Alternate Address" },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is someone who would advocate on your behalf.",
                            "name": "is_grassroots_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Grassroots Contact"
                        },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is an influencer for your organization's public policy objectives.",
                            "name": "is_stakeholder_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Stakeholder Contact"
                        },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is granted limited access to view specific bill profiles selected by your organization and provide comments on them.",
                            "name": "is_collaborator_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Collaborator Contact"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterType" },
                            "field_type": 4,
                            "help_text": "Field to represents whether the user for this organization has been activated as a supporter",
                            "name": "supporter_type",
                            "verbose_name": "Supporter Type"
                        },
                        { "field_type": 4, "help_text": "The integer ID for this Contact's facebook account.", "name": "fb_id", "verbose_name": "Facebook ID" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        {
                            "field_type": 7,
                            "help_text": "The State object in the Geography model for this Contact's Geocoded primary address.",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Quorum Region the contact's geocoded primary address is located within.",
                            "name": "region",
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the U.S. House of Representatives district within which thisContact's geocoded primary address is located.",
                            "name": "congressional_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "Congressional District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "County"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the state Upper house (e.g. Senate or equivalent) district within which thisContact's geocoded primary address is located.",
                            "name": "upper_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "Upper State Legislative District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the state lower house (e.g. House of Representatives) district within which thisContact's geocoded primary address is located.",
                            "name": "lower_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "Lower State Legislative District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the Municipal district within which thisContact's geocoded primary address is located.",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "City"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The country object for within which this Contact's geocoded primary address is located.",
                            "name": "country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "Country"
                        },
                        { "field_type": 1, "help_text": "Whether the string address has been geocoded into lat/lon pair", "name": "address_geocoded", "verbose_name": "Was the string address geocoded?" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "If this contact should be available in the organization's action center's external interaction/relationship logger", "name": "should_display_in_external_logger", "verbose_name": "should display in external logger" },
                        { "field_type": 3, "help_text": "The keyword that this supporter texted and used to register to an action center", "name": "registered_with_text_keyword", "verbose_name": "registered with text keyword" },
                        {
                            "field_type": 7,
                            "help_text": "The source registration page the supporter used to register with",
                            "name": "registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page"
                        },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has participated in any campaigns", "name": "has_participated_in_any_campaign_dn", "verbose_name": "has participated in any campaign dn" },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has shared in any campaigns on the socials", "name": "has_shared_campaign_on_social_dn", "verbose_name": "has shared campaign on social dn" },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has ever recieved an email through outbox", "name": "has_ever_received_email_dn", "verbose_name": "has ever received email dn" },
                        { "field_type": 5, "help_text": "The last time this supporter took an action", "name": "last_action_date", "verbose_name": "last action date" },
                        { "field_type": 4, "help_text": "The number of actions this supporter has taken", "name": "num_actions", "verbose_name": "num actions" },
                        { "field_type": 4, "help_text": "The number of campaigns this supporter has interacted with", "name": "num_campaigns_interacted", "verbose_name": "num campaigns interacted" },
                        { "field_type": 5, "help_text": "The last time this supporter either visited a page or opened an email through outbox", "name": "last_activated_at", "verbose_name": "last activated at" },
                        { "field_type": 4, "help_text": "The last kind of action this supporter took", "name": "last_kind_action", "verbose_name": "last kind action" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The PACs that this supporter is eligible to donate to.",
                            "name": "pac_eligibilities",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "pac eligibilities"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All public organizations related to a supporter, both Quorum Supplied and client Custom Organizations.",
                            "name": "public_organizations",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organizations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which Quorum Issues this contact is tagged with.",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "members",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "members"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All registration page the supporter used to register/login with",
                            "name": "registration_page_interactions",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page interactions"
                        }
                    ],
                    "proxy_endpoint": "/api/supporter/"
                },
                "QuorumGrassrootsPage": {
                    "__is_model": true,
                    "__name__": "QuorumGrassrootsPage",
                    "data_model": "app.grassroots.models.QuorumGrassrootsPage",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/quorumgrassrootspage/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "Name of the Grassroots Page", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "action_center",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action center"
                        },
                        { "field_type": 2, "help_text": "The url path attached to this page.", "name": "path", "verbose_name": "path" },
                        { "field_type": 2, "help_text": "The title for the page in the browser toolbar", "name": "title", "verbose_name": "title" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "PageRestrictionType" },
                            "field_type": 4,
                            "help_text": "Determines who has access to the page, in particular with regard to pac eligibility",
                            "name": "page_restriction_type",
                            "verbose_name": "page restriction type"
                        },
                        { "field_type": null, "help_text": "Array of widgets for this page to display.", "name": "widgets", "verbose_name": "widgets" },
                        { "field_type": 1, "help_text": "Whether or not the user needs to be logged in in order to see this page.", "name": "requires_login", "verbose_name": "requires login" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "GrassrootsPageWidgetLayoutType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "widget_layout_type",
                            "verbose_name": "widget layout type"
                        },
                        { "field_type": 3, "help_text": "Javascript that will be run when the component mounts", "name": "custom_javascript", "verbose_name": "custom javascript" },
                        { "field_type": 3, "help_text": "Javascript that gets loaded only when the page is loaded", "name": "custom_css", "verbose_name": "custom css" },
                        { "field_type": 3, "help_text": "For PAC action centers, a disclaimer that appear at the top of the footer", "name": "disclaimer_text", "verbose_name": "disclaimer text" },
                        { "field_type": 1, "help_text": "Whether this widgets on this page should use the passed in region to filter and display data", "name": "use_page_region", "verbose_name": "use page region" }
                    ]
                },
                "Supporter": {
                    "__is_model": true,
                    "__name__": "Supporter",
                    "data_model": "app.grassroots.models.Supporter",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/supporter/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        { "field_type": null, "help_text": "A cache of the teams in the limited_to_teams m2m that is used so we can avoid doing a join on every lookup", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                            "field_type": 4,
                            "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                            "miscellaneous": 12,
                            "name": "source_type",
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "sheets_tooltip_text": "The Source of this Contact",
                            "verbose_name": "Source Type"
                        },
                        { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                        { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                        { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                        { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                        { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                        { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                        { "field_type": 16, "help_text": "When the contact was created.", "name": "created", "overriden_column_data_type": 7, "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Created" },
                        { "field_type": 16, "help_text": "When the contact was most recently updated.", "name": "updated", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Updated" },
                        { "feature_flag_slug": "ff_pac", "field_type": 3, "help_text": "The employer of the contact, if applicable.", "name": "employer", "sheet_column": true, "verbose_name": "Employer" },
                        {
                            "field_type": 7,
                            "help_text": "The QuorumUser record for the Contact, permitting access to the Grassroots Action Center.",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "User Account Object"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The last Quorum Platform User that created/edited this Supporter in any way.",
                            "name": "last_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "Last-modified QuorumUser"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Quorum Client Organization that owns this supporter record.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "Organization Obj"
                        },
                        { "field_type": 4, "help_text": "The ID of the individual in the PAC Classic system.", "name": "pacc_individual_id", "verbose_name": "pacc individual id" },
                        { "field_type": 4, "help_text": "The ID of the organization in the PAC Classic system.", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "feature_flag_slug": "ff_pac_charitable_match_search", "field_type": 16, "help_text": "Last time the supporter's charity selection was updated", "name": "pac_charity_selection_date", "patch": true, "sheet_column": true, "sheets_subcategory": 25, "verbose_name": "Charity Selection Date" },
                        { "field_type": 3, "help_text": "The fax number of the contact, if applicable.", "name": "fax", "verbose_name": "Fax" },
                        {
                            "feature_flag_slug": "ff_pac",
                            "field_type": 3,
                            "help_text": "A contact's occupation",
                            "name": "occupation",
                            "sheet_column": true,
                            "sheets_column_order": 13,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Occupation"
                        },
                        { "field_type": 3, "help_text": "The work phone number of the contact, if applicable.", "name": "work_phone", "verbose_name": "Work Phone" },
                        { "field_type": 3, "help_text": "The work fax number of the contact, if applicable.", "name": "work_fax", "verbose_name": "Work Fax" },
                        { "field_type": 4, "help_text": "The PAC conditional giving level of the contact, if applicable.", "name": "pac_conditional_giving_level_deprecated", "verbose_name": "Conditional Giving Level" },
                        { "feature_flag_slug": "ff_pac_permissions_one", "field_type": 3, "help_text": "The PAC conditional giving level of the contact, if applicable.", "name": "pac_conditional_giving_level", "patch": true, "sheet_column": true, "sheets_subcategory": 25, "verbose_name": "Conditional Giving Level" },
                        { "field_type": 1, "help_text": "Whether the contact is eligible for PAC Hybrid donations.", "name": "pac_hybrid_eligible", "verbose_name": "PAC Hybrid Eligible" },
                        {
                            "field_type": 7,
                            "help_text": "Legacy public_organization foreign key, no longer in use.",
                            "included_related_model_fields": ["name"],
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "verbose_name": "Organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Whether there is a record in the Officials or Staffers datasets visible to you that has the same email address.",
                            "name": "email_related_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "Person related by Email"
                        },
                        { "field_type": 1, "help_text": "Whether the email address is known to be invalid - FALSE indicates that the email address is known to be invalid,TRUE indicates only that the email address is not already known to be invalid, but does not indicate that it hasbeen excplicitly validated in any way.", "name": "valid_email", "verbose_name": "valid email" },
                        { "field_type": 2, "help_text": "Random id for the Contact used to track requests to Unsubscribe from Outbox.", "name": "bulk_email_unsubscribe_key", "verbose_name": "bulk email unsubscribe key" },
                        { "field_type": 1, "help_text": "Whether the contact is unsubscribed from your bulk emails.", "name": "unsubscribed_from_bulk_emails", "patch": true, "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Unsubscribed" },
                        { "field_type": 16, "help_text": "Date that this contact unsubscribed from all Outbox emails.", "name": "date_unsubscribed_from_bulk_emails", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Date Unsubscribed from Emails" },
                        { "field_type": 1, "help_text": "Whether the contact is explicitly unsubscribed from your text messages.", "name": "unsubscribed_from_texting", "verbose_name": "Unsubscribed from texting" },
                        { "field_type": 16, "help_text": "Date that this contact unsubscribed from receiving text messages", "name": "date_unsubscribed_from_texting", "verbose_name": "Date Unsubscribed from Texting" },
                        { "field_type": 1, "help_text": "Whether the contact has opened or clicked on any emails from this organization in the last 120 days or was added to the account within the last 30 days.", "name": "is_recently_active_email_recipient", "sheet_column": true, "sheets_subcategory": 12, "verbose_name": "Recently Engaged with Outbox Emails" },
                        { "field_type": 2, "help_text": "A hash value of data fields on the Contact to quickly identify when data has changed. NOTE:Does not cover data stored in Array or Dictionary fields, including Custom Fields.", "name": "data_hash", "verbose_name": "data hash" },
                        { "field_type": 1, "help_text": "Whether or not the account has been activated by a Contact through them logging in to the Grassroots Action Center.", "name": "activated", "verbose_name": "Account Actived" },
                        { "field_type": 1, "help_text": "User Account Validated", "name": "active", "verbose_name": "User Account Validated" },
                        { "field_type": 1, "help_text": "Whether an org created this supporter and is waiting to be used by the user.", "name": "waiting_to_be_created_by_user", "verbose_name": "Waiting for user initializtion" },
                        { "field_type": 2, "help_text": "Hashed value of the password set for the Contact through a protected Grassroots Action Center.", "name": "password", "verbose_name": "Password" },
                        { "field_type": 2, "help_text": "Contact Full Name.", "name": "name", "patch": true, "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 3, "verbose_name": "Name" },
                        { "field_type": 2, "help_text": "Contact First Name.", "name": "firstname", "patch": true, "sheet_column": true, "sheets_column_order": 2, "sheets_subcategory": 3, "verbose_name": "First Name" },
                        { "field_type": 2, "help_text": "Contact Last Name.", "name": "lastname", "patch": true, "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 3, "verbose_name": "Last Name" },
                        { "field_type": 2, "help_text": "Contact Middle Name.", "name": "middlename", "patch": true, "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Middle Name" },
                        { "field_type": 2, "help_text": "Contact Preferred Name.", "name": "preferred_name", "patch": true, "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Preferred Name" },
                        { "field_type": 2, "help_text": "Prefix of a person's name, like Mr., Mrs., The Honorable, etc.", "name": "prefix", "patch": true, "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 3, "verbose_name": "Prefix" },
                        { "field_type": 3, "help_text": "A unique Stripe identifier for this Supporter. This id is created when the Supporter interacts with Stripe for the first time.", "name": "stripe_customer_id", "verbose_name": "stripe customer id" },
                        { "field_type": 2, "help_text": "Suffix of a person's name, like III, Jr., etc.", "name": "suffix", "patch": true, "sheet_column": true, "sheets_column_order": 7, "sheets_subcategory": 3, "verbose_name": "Suffix" },
                        { "field_type": 5, "help_text": "The birthdate of this Contact.", "name": "birthdate", "sheet_column": true, "sheets_subcategory": 3, "verbose_name": "Birthdate" },
                        { "field_type": 2, "help_text": "Primary Email Address for this Contact; this is the address available in Outbox to email this Contact.", "name": "email", "patch": true, "sheet_column": true, "sheets_column_order": 8, "sheets_subcategory": 3, "verbose_name": "Email Address" },
                        { "field_type": 2, "help_text": "Secondary Email (personal etc.) assuming the first one is work/primary email", "name": "secondary_email", "patch": true, "sheet_column": true, "sheets_column_order": 12, "sheets_subcategory": 3, "verbose_name": "Secondary Email (personal etc.) assuming the first one is work/primary email" },
                        { "field_type": 2, "help_text": "Supporter's webpage, like www.greatagain.gov", "name": "website", "verbose_name": "Website" },
                        { "field_type": 2, "help_text": "", "name": "phone_number", "patch": true, "sheet_column": true, "sheets_column_order": 9, "sheets_subcategory": 3, "verbose_name": "Home/Work Number" },
                        { "field_type": 2, "help_text": "", "name": "secondary_phone", "patch": true, "sheet_column": true, "sheets_column_order": 10, "sheets_subcategory": 3, "verbose_name": "Cell Number" },
                        { "field_type": 2, "help_text": "", "name": "extension", "patch": true, "sheet_column": true, "sheets_column_order": 10, "sheets_subcategory": 3, "verbose_name": "Telephone Extension" },
                        { "field_type": 2, "help_text": "", "name": "secondary_extension", "verbose_name": "Telephone Extension" },
                        { "field_type": 3, "name": "address", "patch": true, "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Verified Address" },
                        { "field_type": 3, "help_text": "", "name": "input_address", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Input Address" },
                        { "field_type": 2, "help_text": "The person's most recent title", "name": "title", "patch": true, "sheet_column": true, "sheets_column_order": 12, "sheets_subcategory": 3, "verbose_name": "Title" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 2, "help_text": "The organization-specific unique identifier for this Contact.", "name": "unique_identifier", "sheet_column": true, "sheets_column_order": 13, "sheets_subcategory": 3, "verbose_name": "Unique Identifier" },
                        { "field_type": 6, "help_text": "The latitude of the Geocoded address for this Contact.", "name": "latitude", "verbose_name": "latitude" },
                        { "field_type": 6, "help_text": "The longitude of the Geocoded address for this Contact.", "name": "longitude", "verbose_name": "longitude" },
                        { "field_type": null, "help_text": "The Point (lat, lon) where this supporter/contact is based at, if any", "name": "coordinates", "verbose_name": "coordinates" },
                        { "field_type": 3, "help_text": "The first line of the Geocoded address for this Contact.", "name": "street_address", "verbose_name": "Street Address" },
                        { "field_type": 3, "help_text": "The second line of the Geocoded address for this Contact.", "name": "street_address_2", "verbose_name": "Street Address, Second Line" },
                        { "field_type": 3, "help_text": "The city of the Geocoded address for this Contact.", "name": "city", "verbose_name": "City" },
                        { "field_type": 2, "help_text": "The country of the Geocoded address for this Contact.", "name": "county_name", "verbose_name": "County" },
                        { "field_type": 2, "help_text": "The state of the Geocoded address for this Contact.", "name": "state_name", "verbose_name": "State" },
                        { "field_type": 2, "help_text": "The postal code of the Geocoded address for this Contact.", "name": "postal_code", "verbose_name": "Postal Code" },
                        { "field_type": 2, "help_text": "The postal code extension of the Geocoded address for this Contact.", "name": "postal_code_ext", "verbose_name": "Postal Code Extension" },
                        { "field_type": 2, "help_text": "", "name": "country_name", "verbose_name": "Country Name" },
                        { "field_type": 2, "help_text": "An alternate address entered for the Contact; note that this field is not Geocoded.", "name": "alternate_address", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Alternate Address" },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is someone who would advocate on your behalf.",
                            "name": "is_grassroots_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Grassroots Contact"
                        },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is an influencer for your organization's public policy objectives.",
                            "name": "is_stakeholder_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Stakeholder Contact"
                        },
                        {
                            "field_type": 1,
                            "help_text": "Whether this contact is granted limited access to view specific bill profiles selected by your organization and provide comments on them.",
                            "name": "is_collaborator_supporter",
                            "patch": true,
                            "sheet_column": true,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Collaborator Contact"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterType" },
                            "field_type": 4,
                            "help_text": "Field to represents whether the user for this organization has been activated as a supporter",
                            "name": "supporter_type",
                            "verbose_name": "Supporter Type"
                        },
                        { "field_type": 4, "help_text": "The integer ID for this Contact's facebook account.", "name": "fb_id", "verbose_name": "Facebook ID" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        {
                            "field_type": 7,
                            "help_text": "The State object in the Geography model for this Contact's Geocoded primary address.",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Quorum Region the contact's geocoded primary address is located within.",
                            "name": "region",
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the U.S. House of Representatives district within which thisContact's geocoded primary address is located.",
                            "name": "congressional_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "Congressional District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "County"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the state Upper house (e.g. Senate or equivalent) district within which thisContact's geocoded primary address is located.",
                            "name": "upper_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "Upper State Legislative District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the state lower house (e.g. House of Representatives) district within which thisContact's geocoded primary address is located.",
                            "name": "lower_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "Lower State Legislative District"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The district object for the Municipal district within which thisContact's geocoded primary address is located.",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "City"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The country object for within which this Contact's geocoded primary address is located.",
                            "name": "country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "Country"
                        },
                        { "field_type": 1, "help_text": "Whether the string address has been geocoded into lat/lon pair", "name": "address_geocoded", "verbose_name": "Was the string address geocoded?" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 1, "help_text": "If this contact should be available in the organization's action center's external interaction/relationship logger", "name": "should_display_in_external_logger", "verbose_name": "should display in external logger" },
                        { "field_type": 3, "help_text": "The keyword that this supporter texted and used to register to an action center", "name": "registered_with_text_keyword", "verbose_name": "registered with text keyword" },
                        {
                            "field_type": 7,
                            "help_text": "The source registration page the supporter used to register with",
                            "name": "registration_page",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page"
                        },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has participated in any campaigns", "name": "has_participated_in_any_campaign_dn", "verbose_name": "has participated in any campaign dn" },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has shared in any campaigns on the socials", "name": "has_shared_campaign_on_social_dn", "verbose_name": "has shared campaign on social dn" },
                        { "field_type": 1, "help_text": "Denormalized field indicating if this Supporter has ever recieved an email through outbox", "name": "has_ever_received_email_dn", "verbose_name": "has ever received email dn" },
                        { "field_type": 5, "help_text": "The last time this supporter took an action", "name": "last_action_date", "verbose_name": "last action date" },
                        { "field_type": 4, "help_text": "The number of actions this supporter has taken", "name": "num_actions", "verbose_name": "num actions" },
                        { "field_type": 4, "help_text": "The number of campaigns this supporter has interacted with", "name": "num_campaigns_interacted", "verbose_name": "num campaigns interacted" },
                        { "field_type": 5, "help_text": "The last time this supporter either visited a page or opened an email through outbox", "name": "last_activated_at", "verbose_name": "last activated at" },
                        { "field_type": 4, "help_text": "The last kind of action this supporter took", "name": "last_kind_action", "verbose_name": "last kind action" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The PACs that this supporter is eligible to donate to.",
                            "name": "pac_eligibilities",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "pac eligibilities"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All public organizations related to a supporter, both Quorum Supplied and client Custom Organizations.",
                            "name": "public_organizations",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organizations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which Quorum Issues this contact is tagged with.",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "members",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "members"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All registration page the supporter used to register/login with",
                            "name": "registration_page_interactions",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "registration page interactions"
                        }
                    ]
                }
            },
            "types": {
                "ActionCenterTheme": {
                    "__is_enum": true,
                    "default": { "image_url": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterThemes/boxy.png", "key": "default", "label": "Classic", "name": "Classic", "top_label": "Self contained, grid oriented with additional padding", "value": 1 },
                    "impact": { "image_url": "https://static.quorum.us/global/frontend/images/grassrootsActionCenterThemes/impact.png", "key": "impact", "label": "Editorial", "name": "Editorial", "top_label": "Full width, high impact storytelling", "value": 2 }
                },
                "DonationFormType": {
                    "__is_enum": true,
                    "nonprofit_fundraising": { "key": "nonprofit_fundraising", "label": "Nonprofit Fundraising", "value": 2 },
                    "pac": { "key": "pac", "label": "PAC", "value": 1 }
                },
                "FormInputType": {
                    "__is_enum": true,
                    "address": { "key": "address", "label": "Address", "value": 5 },
                    "email": { "key": "email", "label": "Email", "value": 8 },
                    "multi_select": { "key": "multi_select", "label": "Multi Select", "value": 4 },
                    "numeric": { "key": "numeric", "label": "Numeric", "value": 6 },
                    "phone_number": { "key": "phone_number", "label": "Phone Number", "value": 7 },
                    "single_select": { "key": "single_select", "label": "Single Select", "value": 3 },
                    "text": { "key": "text", "label": "Text", "value": 1 },
                    "toggle": { "key": "toggle", "label": "Toggle", "value": 2 }
                },
                "GamificationAchievementIconType": {
                    "__is_enum": true,
                    "star": { "fa4_icon": "fa-star", "key": "star", "label": "Star", "value": 2 },
                    "trophy": { "fa4_icon": "fa-trophy", "key": "trophy", "label": "Trophy", "value": 1 }
                },
                "GamificationCampaignPointType": {
                    "__is_enum": true,
                    "custom": { "key": "custom", "label": "Assign Points for Each Campaign Action", "tip": "Specify the amount of points each campaign type is worth", "value": 1 },
                    "same": { "key": "same", "label": "Assign Same Point Value to All Campaign Actions", "tip": "Specify one point value that all campaigns are worth", "value": 2 }
                },
                "GamificationPointsMode": {
                    "__is_enum": true,
                    "custom_points": { "key": "custom_points", "label": "Custom Points", "order": 2, "tip": "Use a custom Gamification points for this campaign", "value": 2 },
                    "default": { "key": "default", "label": "Default", "order": 1, "tip": "Use the default Gamification points for the given campaign type", "value": 1 },
                    "disable": { "key": "disable", "label": "Disable", "order": 3, "tip": "Disable Gamification for this campaign", "value": 3 }
                },
                "GamificationRankType": {
                    "__is_enum": true,
                    "fifteen": { "key": "fifteen", "label": "Top 15%", "percentile": 15, "value": 4 },
                    "fifty": { "key": "fifty", "label": "Top 50%", "percentile": 50, "value": 1 },
                    "five": { "key": "five", "label": "Top 5%", "percentile": 5, "value": 6 },
                    "one": { "key": "one", "label": "Top 1%", "percentile": 1, "value": 7 },
                    "ten": { "key": "ten", "label": "Top 10%", "percentile": 10, "value": 5 },
                    "twenty": { "key": "twenty", "label": "Top 20%", "percentile": 20, "value": 3 },
                    "twenty_five": { "key": "twenty_five", "label": "Top 25%", "percentile": 25, "value": 2 }
                },
                "GrassrootsContextField": {
                    "__is_enum": true,
                    "campaign_list": {
                        "additional_fields_required": false,
                        "detail": false,
                        "key": "campaign_list",
                        "label": "campaign_list",
                        "model": "app.grassroots.campaign.models.GrassrootsCampaign",
                        "order_by": ["-order", "id"],
                        "pagination_amount": 20,
                        "resource": "app.grassroots.campaign.newapi.GrassrootsCampaignResource",
                        "should_paginate": true,
                        "store_key": "campaignList",
                        "update_on_login": false,
                        "value": 1
                    },
                    "custom_fields": { "additional_fields_required": false, "detail": false, "key": "custom_fields", "label": "custom_fields", "model": "app.grassroots.models.GrassrootsCustomTag", "pagination_amount": 20, "resource": "app.grassroots.newapi.GrassrootsCustomTagResource", "should_paginate": false, "store_key": "customFields", "update_on_login": false, "value": 2 },
                    "donation_forms": {
                        "additional_fields_required": false,
                        "detail": false,
                        "feature_flags": ["ff_pac"],
                        "filters": { "grassroots_form_type": 2 },
                        "key": "donation_forms",
                        "label": "donation_forms",
                        "model": "app.grassroots.models.GrassrootsRegistrationPage",
                        "only_fields": ["allowed_donation_methods", "allowed_payroll_donation_types", "disclaimer_text", "donation_amount_credit_prompt_text", "donation_amount_payroll_prompt_text", "donation_amounts", "donation_amounts_check", "donation_amounts_credit", "donation_amounts_payroll", "donation_amounts_check", "donation_form_type", "donation_method_prompt_text", "check_mailing_instruction", "check_mailing_address", "donation_percentages_payroll", "enabled_pac_match", "form_fields", "id", "pac_classic_site", "pac_match_description", "pac_match_select_label", "pac_match_threshold", "payroll_amount_label", "payroll_percentage_label", "payroll_frequency_type", "post_submission_action_type", "post_text", "pre_text", "redirect_url", "submit_button_text", "thank_you_text", "terms_and_conditions_switch", "custom_javascript", "custom_css", "custom_after_registration_javascript"],
                        "pagination_amount": 20,
                        "should_paginate": false,
                        "store_key": "donationForms",
                        "update_on_login": false,
                        "value": 6
                    },
                    "event_list": { "additional_fields_required": false, "detail": false, "key": "event_list", "label": "event_list", "model": "app.custom_event.models.GrassrootsCustomEvent", "pagination_amount": 20, "resource": "app.grassroots.newapi.GrassrootsCustomEventResource", "should_paginate": false, "store_key": "eventList", "update_on_login": false, "value": 5 },
                    "issue_list": {
                        "additional_fields_required": false,
                        "detail": false,
                        "filters": { "archived": false },
                        "key": "issue_list",
                        "label": "issue_list",
                        "model": "app.userdata.models.GrassrootsIssue",
                        "pagination_amount": 20,
                        "resource": "app.grassroots.newapi.GrassrootsIssueResource",
                        "should_paginate": false,
                        "store_key": "issueList",
                        "update_on_login": false,
                        "value": 4
                    },
                    "registration_pages": {
                        "additional_fields_required": false,
                        "detail": false,
                        "filters": { "grassroots_form_type": 1 },
                        "key": "registration_pages",
                        "label": "registration_pages",
                        "model": "app.grassroots.models.GrassrootsRegistrationPage",
                        "only_fields": ["id", "form_fields", "pre_text", "post_text", "post_submission_action_type", "submit_button_text", "thank_you_text", "redirect_url", "custom_javascript", "custom_after_registration_javascript", "custom_css", "should_allow_partial_address"],
                        "pagination_amount": 20,
                        "should_paginate": false,
                        "store_key": "registrationPages",
                        "update_on_login": false,
                        "value": 3
                    }
                },
                "GrassrootsFormType": {
                    "__is_enum": true,
                    "donation": { "key": "donation", "label": "Donation Form", "value": 2 },
                    "registration": { "key": "registration", "label": "Registration Form", "value": 1 }
                },
                "GrassrootsFoundationalRoute": {
                    "__is_enum": true,
                    "forgot_password": { "anonymous_only": true, "key": "forgot_password", "label": "2", "logged_in_only": false, "page_title": "Recover", "path": "/recover/", "private_acs_only": true, "value": 2 },
                    "logout": { "anonymous_only": false, "key": "logout", "label": "1", "logged_in_only": true, "page_title": "Logout", "path": "/logout/", "private_acs_only": false, "value": 1 },
                    "reset_password": { "anonymous_only": false, "key": "reset_password", "label": "3", "logged_in_only": true, "page_title": "Reset Password", "path": "/reset_password/", "private_acs_only": true, "value": 3 }
                },
                "GrassrootsNavigationBarButtonType": {
                    "__is_enum": true,
                    "dropdown_menu": { "exclude_i360_client_with_stakeholder": false, "key": "dropdown_menu", "label": "Dropdown Menu", "value": 1 },
                    "external": { "exclude_i360_client_with_stakeholder": false, "key": "external", "label": "External Link", "value": 7 },
                    "interaction_logger": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "interaction_logger",
                        "label": "Link to Interaction Logger",
                        "page_url": "/log/",
                        "permission_enum": [7],
                        "value": 8
                    },
                    "list_campaigns": {
                        "exclude_i360_client_with_stakeholder": true,
                        "key": "list_campaigns",
                        "label": "Link to List of Campaigns",
                        "page_url": "/campaigns/",
                        "permission_enum": [201],
                        "value": 4
                    },
                    "list_custom_events": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "list_custom_events",
                        "label": "Link to List of Events",
                        "page_url": "/events/",
                        "permission_enum": [206],
                        "value": 11
                    },
                    "list_issues": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "list_issues",
                        "label": "Link to List of Issues",
                        "page_url": "/issues/",
                        "permission_enum": [201, 7, 5],
                        "value": 3
                    },
                    "list_legislators": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "list_legislators",
                        "label": "Link to List of Legislators",
                        "page_url": "/officials/",
                        "permission_enum": [201],
                        "value": 6
                    },
                    "relationship_logger": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "relationship_logger",
                        "label": "Link to Relationship Logger",
                        "page_url": "/relationship/",
                        "permission_enum": [5],
                        "value": 9
                    },
                    "single_campaign": {
                        "exclude_i360_client_with_stakeholder": true,
                        "key": "single_campaign",
                        "label": "Link to Single Campaign",
                        "permission_enum": [201],
                        "value": 5
                    },
                    "single_custom_event": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "single_custom_event",
                        "label": "Link to Single Event",
                        "permission_enum": [206],
                        "value": 10
                    },
                    "single_donation_form": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "single_donation_form",
                        "label": "Link to a Donation Form",
                        "permission_enum": [8],
                        "value": 13
                    },
                    "single_issue": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "single_issue",
                        "label": "Link to Single Issue",
                        "permission_enum": [201],
                        "value": 12
                    },
                    "single_page": {
                        "exclude_i360_client_with_stakeholder": false,
                        "key": "single_page",
                        "label": "Link to Single Page",
                        "permission_enum": [201],
                        "value": 2
                    }
                },
                "GrassrootsPageWidgetLayoutType": {
                    "__is_enum": true,
                    "eight_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout18(8)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout18(8)-Neutral.png",
                        "key": "eight_rows",
                        "label": "Eight Rows",
                        "num_widgets": 8,
                        "order": 18,
                        "should_use_icon_path": true,
                        "value": 18,
                        "widget_is_full_width": [true, true, true, true, true, true, true, true]
                    },
                    "five_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout15(5)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout15(5)-Neutral.png",
                        "key": "five_rows",
                        "label": "Five Rows",
                        "num_widgets": 5,
                        "order": 15,
                        "should_use_icon_path": true,
                        "value": 15,
                        "widget_is_full_width": [true, true, true, true, true]
                    },
                    "four_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout14(4)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout14(4)-Neutral.png",
                        "key": "four_rows",
                        "label": "Four Rows",
                        "num_widgets": 4,
                        "order": 14,
                        "should_use_icon_path": true,
                        "value": 9,
                        "widget_is_full_width": [true, true, true, true]
                    },
                    "four_square": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout7(4)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout7(4)-Neutral.png",
                        "key": "four_square",
                        "label": "Four Square",
                        "num_widgets": 4,
                        "order": 7,
                        "should_use_icon_path": true,
                        "value": 10,
                        "widget_is_full_width": [false, false, false, false]
                    },
                    "left_full_column": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout4(3)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout4(3)-Neutral.png",
                        "key": "left_full_column",
                        "label": "Left Full Column",
                        "num_widgets": 3,
                        "order": 4,
                        "should_use_icon_path": true,
                        "value": 4,
                        "widget_is_full_width": [false, false, false]
                    },
                    "nine_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout19(9)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout19(9)-Neutral.png",
                        "key": "nine_rows",
                        "label": "Nine Rows",
                        "num_widgets": 9,
                        "order": 19,
                        "should_use_icon_path": true,
                        "value": 19,
                        "widget_is_full_width": [true, true, true, true, true, true, true, true, true]
                    },
                    "one_top_four_bottom": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout8(5)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout8(5)-Neutral.png",
                        "key": "one_top_four_bottom",
                        "label": "One Top Four Bottom",
                        "num_widgets": 5,
                        "order": 8,
                        "should_use_icon_path": true,
                        "value": 11,
                        "widget_is_full_width": [true, false, false, false, false]
                    },
                    "right_full_column": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout3(3)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout3(3)-Neutral.png",
                        "key": "right_full_column",
                        "label": "Right Full Column",
                        "num_widgets": 3,
                        "order": 3,
                        "should_use_icon_path": true,
                        "value": 3,
                        "widget_is_full_width": [false, false, false]
                    },
                    "seven_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout17(7)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout17(7)-Neutral.png",
                        "key": "seven_rows",
                        "label": "Seven Rows",
                        "num_widgets": 7,
                        "order": 17,
                        "should_use_icon_path": true,
                        "value": 17,
                        "widget_is_full_width": [true, true, true, true, true, true, true]
                    },
                    "single_column": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout1(1)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout1(1)-Neutral.png",
                        "key": "single_column",
                        "label": "Single Column",
                        "num_widgets": 1,
                        "order": 1,
                        "should_use_icon_path": true,
                        "value": 1,
                        "widget_is_full_width": [true]
                    },
                    "six_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout16(6)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout16(6)-Neutral.png",
                        "key": "six_rows",
                        "label": "Six Rows",
                        "num_widgets": 6,
                        "order": 16,
                        "should_use_icon_path": true,
                        "value": 16,
                        "widget_is_full_width": [true, true, true, true, true, true]
                    },
                    "six_square": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout11(6)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout11(6)-Neutral.png",
                        "key": "six_square",
                        "label": "Six Square",
                        "num_widgets": 6,
                        "order": 11,
                        "should_use_icon_path": true,
                        "value": 14,
                        "widget_is_full_width": [false, false, false, false, false, false]
                    },
                    "ten_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout20(10)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout20(10)-Neutral.png",
                        "key": "ten_rows",
                        "label": "Ten Rows",
                        "num_widgets": 10,
                        "order": 20,
                        "should_use_icon_path": true,
                        "value": 20,
                        "widget_is_full_width": [true, true, true, true, true, true, true, true, true, true]
                    },
                    "three_left_two_right": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout9(5)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout9(5)-Neutral.png",
                        "key": "three_left_two_right",
                        "label": "Three Left Two Right",
                        "num_widgets": 5,
                        "order": 9,
                        "should_use_icon_path": true,
                        "value": 12,
                        "widget_is_full_width": [false, false, false, false, false]
                    },
                    "three_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout13(3)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout13(3)-Neutral.png",
                        "key": "three_rows",
                        "label": "Three Rows",
                        "num_widgets": 3,
                        "order": 13,
                        "should_use_icon_path": true,
                        "value": 8,
                        "widget_is_full_width": [true, true, true]
                    },
                    "two_columns": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout2(2)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout2(2)-Neutral.png",
                        "key": "two_columns",
                        "label": "Two Columns",
                        "num_widgets": 2,
                        "order": 2,
                        "should_use_icon_path": true,
                        "value": 2,
                        "widget_is_full_width": [false, false]
                    },
                    "two_left_three_right": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout10(5)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout10(5)-Neutral.png",
                        "key": "two_left_three_right",
                        "label": "Two Left Three Right",
                        "num_widgets": 5,
                        "order": 10,
                        "should_use_icon_path": true,
                        "value": 13,
                        "widget_is_full_width": [false, false, false, false, false]
                    },
                    "two_rows": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout12(2)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout12(2)-Neutral.png",
                        "key": "two_rows",
                        "label": "Two Rows",
                        "num_widgets": 2,
                        "order": 12,
                        "should_use_icon_path": true,
                        "value": 5,
                        "widget_is_full_width": [true, true]
                    },
                    "two_rows_half_bottom": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout5(3)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout5(3)-Neutral.png",
                        "key": "two_rows_half_bottom",
                        "label": "Two Rows Half Bottom",
                        "num_widgets": 3,
                        "order": 5,
                        "should_use_icon_path": true,
                        "value": 6,
                        "widget_is_full_width": [true, false, false]
                    },
                    "two_rows_half_top": {
                        "active_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout6(3)-Selected.png",
                        "inactive_icon_path": "https://static.quorum.us/global/frontend/images/grassrootsPageIcons/2021/Layout6(3)-Neutral.png",
                        "key": "two_rows_half_top",
                        "label": "Two Rows Half Top",
                        "num_widgets": 3,
                        "order": 6,
                        "should_use_icon_path": true,
                        "value": 7,
                        "widget_is_full_width": [false, false, true]
                    }
                },
                "GrassrootsRegistrationField": {
                    "__is_enum": true,
                    "address": {
                        "defaults": { "width": 1 },
                        "disabled": false,
                        "fb_lead_question_type": "STREET_ADDRESS",
                        "i18n_label_key": "registration.address.label",
                        "i18n_placeholder_key": "registration.address.placeholder",
                        "input_type": 5,
                        "key": "address",
                        "label": "Address",
                        "required_props": [],
                        "supporter_field": "input_address",
                        "value": 5
                    },
                    "custom_field": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.phone.label",
                        "i18n_placeholder_key": "registration.phone.placeholder",
                        "key": "custom_field",
                        "label": "Custom Field",
                        "required_props": ["id"],
                        "supporter_field": "tag_dict",
                        "value": 100
                    },
                    "email": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "EMAIL",
                        "i18n_label_key": "registration.email.label",
                        "i18n_placeholder_key": "registration.email.placeholder",
                        "input_type": 8,
                        "key": "email",
                        "label": "Email",
                        "required_props": [],
                        "supporter_field": "email",
                        "value": 4
                    },
                    "employer": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.employer.label",
                        "i18n_placeholder_key": "registration.employer.placeholder",
                        "input_type": 1,
                        "key": "employer",
                        "label": "Employer",
                        "required_props": [],
                        "supporter_field": "employer",
                        "value": 12
                    },
                    "firstname": {
                        "defaults": { "input_type": 1, "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "FIRST_NAME",
                        "i18n_label_key": "registration.firstname.label",
                        "i18n_placeholder_key": "registration.firstname.placeholder",
                        "input_type": 1,
                        "key": "firstname",
                        "label": "First Name",
                        "required_props": [],
                        "supporter_field": "firstname",
                        "value": 1
                    },
                    "fullname": {
                        "defaults": { "input_type": 1, "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "FULL_NAME",
                        "i18n_label_key": "registration.fullname.label",
                        "i18n_placeholder_key": "registration.fullname.placeholder",
                        "input_type": 1,
                        "key": "fullname",
                        "label": "Full Name",
                        "required_props": [],
                        "supporter_field": "name",
                        "value": 13
                    },
                    "lastname": {
                        "defaults": { "input_type": 1, "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "LAST_NAME",
                        "i18n_label_key": "registration.lastname.label",
                        "i18n_placeholder_key": "registration.lastname.placeholder",
                        "input_type": 1,
                        "key": "lastname",
                        "label": "Last Name",
                        "required_props": [],
                        "supporter_field": "lastname",
                        "value": 2
                    },
                    "occupation": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.occupation.label",
                        "i18n_placeholder_key": "registration.occupation.placeholder",
                        "input_type": 1,
                        "key": "occupation",
                        "label": "Occupation",
                        "required_props": [],
                        "supporter_field": "occupation",
                        "value": 11
                    },
                    "organization": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "COMPANY_NAME",
                        "i18n_label_key": "registration.organization.label",
                        "i18n_placeholder_key": "registration.organization.placeholder",
                        "input_type": 1,
                        "key": "organization",
                        "label": "Organization",
                        "required_props": [],
                        "supporter_field": "public_organization_name",
                        "value": 9
                    },
                    "phone_number": {
                        "defaults": { "input_type": 7, "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "PHONE",
                        "i18n_label_key": "registration.phone_number.label",
                        "i18n_placeholder_key": "registration.phone_number.placeholder",
                        "input_type": 7,
                        "key": "phone_number",
                        "label": "Phone Number",
                        "required_props": [],
                        "supporter_field": "secondary_phone",
                        "value": 3
                    },
                    "prefix": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.prefix.label",
                        "i18n_placeholder_key": "registration.prefix.placeholder",
                        "input_type": 1,
                        "key": "prefix",
                        "label": "Prefix",
                        "required_props": [],
                        "supporter_field": "prefix",
                        "value": 7
                    },
                    "suffix": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.suffix.label",
                        "i18n_placeholder_key": "registration.suffix.placeholder",
                        "input_type": 1,
                        "key": "suffix",
                        "label": "Suffix",
                        "required_props": [],
                        "supporter_field": "suffix",
                        "value": 8
                    },
                    "text_opt_in": {
                        "defaults": {
                            "input_type": 2,
                            "toggleChoices": [
                                { "i18n_label_key": "registration.text_opt_in.agree_to_sms", "value": true },
                                { "i18n_label_key": "registration.text_opt_in.decline_sms", "value": false }
                            ],
                            "width": 0.5
                        },
                        "disabled": false,
                        "fb_lead_question_options": [
                            { "key": "true", "value": "I agree to receive SMS messages" },
                            { "key": "false", "value": "I do not wish to receive SMS" }
                        ],
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.text_opt_in.sms_opt_in_message",
                        "input_type": 2,
                        "key": "text_opt_in",
                        "label": "Texting Opt-In",
                        "required_props": [],
                        "supporter_field": "outbound_texting_opted_in",
                        "value": 10
                    },
                    "title": {
                        "defaults": { "width": 0.5 },
                        "disabled": false,
                        "fb_lead_question_type": "CUSTOM",
                        "i18n_label_key": "registration.title.label",
                        "i18n_placeholder_key": "registration.title.placeholder",
                        "input_type": 1,
                        "key": "title",
                        "label": "Title",
                        "required_props": [],
                        "supporter_field": "title",
                        "value": 6
                    }
                },
                "GrassrootsWidgetType": {
                    "__is_enum": true,
                    "call_to_action": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": true, "exclude_i360_client_with_stakeholder": false, "full_width": true, "key": "call_to_action", "label": "Call to Action", "logged_in_only": false, "order": 16, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display an image or video alongside text and a call to action button.", "value": 23 },
                    "campaign": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3, 1],
                        "exclude_i360_client_with_stakeholder": true,
                        "full_width": false,
                        "key": "campaign",
                        "label": "Campaign",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201],
                        "required_props": ["id"],
                        "requires_login": false,
                        "value": 1,
                        "widget_url": "/campaign/",
                        "widget_url_params": ":slug"
                    },
                    "campaign_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "context_fields": [1],
                        "exclude_i360_client_with_stakeholder": true,
                        "full_width": false,
                        "key": "campaign_list",
                        "label": "List of Campaigns",
                        "logged_in_only": false,
                        "order": 7,
                        "page_form_title_placeholder": "",
                        "page_title": "Campaigns",
                        "permissions": [201],
                        "requires_login": false,
                        "tip": "This will create a page of all of your active campaigns.",
                        "value": 101,
                        "widget_url": "/campaigns/"
                    },
                    "cards_section": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": true, "exclude_i360_client_with_stakeholder": false, "full_width": true, "key": "cards_section", "label": "Cards Section", "layout_enum": "CardsSectionLayoutType", "logged_in_only": false, "order": 14, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display a collection of cards the full width of the page", "value": 21 },
                    "contact_us": { "anonymous_only": false, "can_be_independent_page": true, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "contact_us", "label": "Contact Us", "logged_in_only": false, "order": 18, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Contact the organization", "value": 25, "widget_url": "/contact_us/" },
                    "custom_data_widget": {
                        "anonymous_only": false,
                        "can_be_independent_page": false,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "feature_flags": ["ff_custom_data_grs_widget"],
                        "full_width": true,
                        "key": "custom_data_widget",
                        "label": "Custom Data",
                        "logged_in_only": false,
                        "order": 14,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201, 4],
                        "requires_login": false,
                        "tip": "Display a collection of cards the full width of the page",
                        "value": 105
                    },
                    "district_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": false,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "feature_flags": ["ff_gr_region_enhancements"],
                        "full_width": true,
                        "key": "district_list",
                        "label": "List of Districts",
                        "logged_in_only": false,
                        "order": 21,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201],
                        "requires_login": false,
                        "tip": "Display a list of districts based on the state exisiting in the query params",
                        "value": 108
                    },
                    "donation_form": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 6],
                        "exclude_i360_client_with_stakeholder": false,
                        "feature_flags": ["ff_pac"],
                        "full_width": false,
                        "key": "donation_form",
                        "label": "Donation Form",
                        "logged_in_only": false,
                        "order": 6,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "requires_login": false,
                        "tip": "Add a Donation Form using the drop down menu below (for PAC or nonprofit fundraising)",
                        "value": 17,
                        "widget_url": "/donate/",
                        "widget_url_params": ":donation_form_id"
                    },
                    "donor_history": {
                        "anonymous_only": false,
                        "can_be_independent_page": false,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "donor_history",
                        "label": "Donor History",
                        "logged_in_only": false,
                        "order": 22,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201, 8, 215],
                        "requires_login": false,
                        "tip": "Display the latest donation received and the totals for the last two years",
                        "value": 109
                    },
                    "draft_campaign": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3, 1],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "draft_campaign",
                        "label": "Draft Campaign",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201],
                        "requires_login": false,
                        "value": 13,
                        "widget_url": "/campaign_draft/",
                        "widget_url_params": ":slug"
                    },
                    "embed": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "embed", "label": "Embed Code", "logged_in_only": false, "order": 11, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Use an embed code", "value": 18 },
                    "event": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "event",
                        "label": "Event",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [206],
                        "required_props": ["id"],
                        "requires_login": false,
                        "value": 15,
                        "widget_url": "/event/",
                        "widget_url_params": ":id"
                    },
                    "event_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "context_fields": [5],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "event_list",
                        "label": "List of Events",
                        "logged_in_only": false,
                        "order": 10,
                        "page_form_title_placeholder": "",
                        "page_title": "Events",
                        "permissions": [206],
                        "requires_login": false,
                        "tip": "Creates a list of all of your public events",
                        "value": 104,
                        "widget_url": "/events/"
                    },
                    "flag_and_region_name": {
                        "anonymous_only": false,
                        "can_be_independent_page": false,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "feature_flags": ["ff_gr_region_enhancements"],
                        "full_width": true,
                        "key": "flag_and_region_name",
                        "label": "Flag and Region Name",
                        "logged_in_only": false,
                        "order": 20,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201],
                        "requires_login": false,
                        "tip": "Display a flag of a an American state its name based on url parameter",
                        "value": 107
                    },
                    "full_bleed_image": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": true, "key": "full_bleed_image", "label": "Full Bleed Image", "logged_in_only": false, "order": 12, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display an image the full width of the page", "value": 19 },
                    "gamification_stats": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "gamification_stats", "label": "Gamification Stats", "logged_in_only": false, "order": 5, "page_form_title_placeholder": "Your Adovcacy Activity", "page_title": "", "requires_login": false, "tip": "Display the advocate's Gamification Stats", "value": 12 },
                    "image": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "image", "label": "Image", "logged_in_only": false, "order": 2, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Insert an Image Link to insert an image onto your Page.", "value": 5 },
                    "image_collage": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": true, "exclude_i360_client_with_stakeholder": false, "full_width": true, "key": "image_collage", "label": "Image Collage", "layout_enum": "ImageCollageLayoutType", "logged_in_only": false, "order": 13, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display a collage of images the full width of the page", "value": 20 },
                    "image_video_carousel": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": true, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "image_video_carousel", "label": "Image/Video Carousel", "logged_in_only": false, "order": 17, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display a carousel of images and/or videos", "value": 24 },
                    "issue": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "issue",
                        "label": "Issue",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201, 7, 5],
                        "required_props": ["id"],
                        "requires_login": false,
                        "value": 2,
                        "widget_url": "/issue/",
                        "widget_url_params": ":slug"
                    },
                    "issue_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "context_fields": [4],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "issue_list",
                        "label": "List of Issues",
                        "logged_in_only": false,
                        "order": 8,
                        "page_form_title_placeholder": "",
                        "page_title": "Issues",
                        "permissions": [201, 7, 5],
                        "requires_login": false,
                        "tip": "Creates a list of all of your Issues where advocates can click into each Issue to learn more.",
                        "value": 102,
                        "widget_url": "/issues/"
                    },
                    "log_interaction": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "log_interaction",
                        "label": "Log Interaction",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "Log Interaction",
                        "permissions": [7],
                        "requires_login": false,
                        "value": 10,
                        "widget_url": "/log/"
                    },
                    "log_relationship": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "log_relationship",
                        "label": "Log Relationship",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "Log Relationship",
                        "permissions": [5],
                        "requires_login": false,
                        "value": 6,
                        "widget_url": "/relationship/"
                    },
                    "number_stats": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": true, "exclude_i360_client_with_stakeholder": false, "full_width": true, "key": "number_stats", "label": "Stats Widget", "layout_enum": "NumberStatsLayoutType", "logged_in_only": false, "order": 15, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Display a statistics in bubbles the full width of the page", "value": 22 },
                    "official": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "official",
                        "label": "Official",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "",
                        "permissions": [201],
                        "required_props": ["id"],
                        "requires_login": false,
                        "value": 3,
                        "widget_url": "/official/",
                        "widget_url_params": ":id"
                    },
                    "official_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "official_list",
                        "label": "List of Officials",
                        "logged_in_only": false,
                        "order": 9,
                        "page_form_title_placeholder": "",
                        "page_title": "Officials",
                        "permissions": [201],
                        "requires_login": false,
                        "tip": "Creates a list of Elected Officials relevant to the advocate based off of the address they register with.",
                        "value": 103,
                        "widget_url": "/officials/"
                    },
                    "public_sheet": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "public_sheet", "label": "Public Sheet", "logged_in_only": false, "order": 6, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "value": 14 },
                    "region_list": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "exclude_i360_client_with_stakeholder": false,
                        "feature_flags": ["ff_gr_region_enhancements"],
                        "full_width": false,
                        "key": "region_list",
                        "label": "List of Regions",
                        "logged_in_only": false,
                        "order": 19,
                        "page_form_title_placeholder": "",
                        "page_title": "Regions",
                        "permissions": [201],
                        "requires_login": false,
                        "tip": "Creates a list of Regions chosen by the advocate.",
                        "value": 106,
                        "widget_url": "/regions/"
                    },
                    "sign_in": {
                        "anonymous_only": true,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "sign_in",
                        "label": "Sign In",
                        "logged_in_only": false,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "Sign In",
                        "requires_login": false,
                        "value": 7,
                        "widget_url": "/sign_in/"
                    },
                    "sign_up": {
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": true,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "sign_up",
                        "label": "Registration Form",
                        "logged_in_only": false,
                        "order": 11,
                        "page_form_title_placeholder": "",
                        "page_title": "Sign Up",
                        "permissions": [201, 7, 5, 102, 3],
                        "requires_login": false,
                        "tip": "Add a Registration Form using the drop down menu below to help acquire advocates.",
                        "value": 9,
                        "widget_url": "/sign_up/",
                        "widget_url_params": ":reg_page_id"
                    },
                    "text": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "text", "label": "Text", "logged_in_only": false, "order": 1, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Use a Text box to insert text into your widget.", "value": 4 },
                    "twitter_timeline": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "twitter_timeline", "label": "Twitter Timeline", "logged_in_only": false, "order": 4, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Timeline of Twitter account tweets", "value": 16 },
                    "update_info": {
                        "action_center_route_permissions": ["show_update_info"],
                        "anonymous_only": false,
                        "can_be_independent_page": true,
                        "can_be_used_in_page_form": false,
                        "can_use_custom_background_color": false,
                        "context_fields": [2, 3],
                        "exclude_i360_client_with_stakeholder": false,
                        "full_width": false,
                        "key": "update_info",
                        "label": "Update Information",
                        "logged_in_only": true,
                        "order": 1,
                        "page_form_title_placeholder": "",
                        "page_title": "Update Information",
                        "requires_login": true,
                        "value": 8,
                        "widget_url": "/update_info/"
                    },
                    "video": { "anonymous_only": false, "can_be_independent_page": false, "can_be_used_in_page_form": true, "can_use_custom_background_color": false, "exclude_i360_client_with_stakeholder": false, "full_width": false, "key": "video", "label": "Video", "logged_in_only": false, "order": 3, "page_form_title_placeholder": "", "page_title": "", "requires_login": false, "tip": "Paste a Youtube URL to insert a video onto your Page. Advocates will be able to watch the video on this Page without leaving your Action Center.", "value": 11 }
                },
                "PageRestrictionType": {
                    "__is_enum": true,
                    "hidden": { "key": "hidden", "label": "Hidden Page", "tip": "Nobody can access this page", "value": 4 },
                    "no_restriction": { "key": "no_restriction", "label": "Open Page", "tip": "Anyone can view this page", "value": 1 },
                    "pac_eligible_only": { "key": "pac_eligible_only", "label": "PAC Restricted", "tip": "This page is restricted to PAC-eligible supporters", "value": 2 },
                    "pac_ineligible_only": { "key": "pac_ineligible_only", "label": "non-PAC Restricted", "tip": "This page is restricted to non-PAC-eligible supporters", "value": 3 }
                },
                "PayrollDonationType": {
                    "__is_enum": true,
                    "amount": { "key": "amount", "label": "Amount", "search_label": "Amount", "value": 1 },
                    "percentage": { "key": "percentage", "label": "Percentage", "search_label": "Payroll Percentage", "value": 2 }
                },
                "RegistrationPostSubmissionAction": {
                    "__is_enum": true,
                    "redirect_to_url": { "key": "redirect_to_url", "label": "Redirect to URL", "value": 2 },
                    "thank_you_message": { "key": "thank_you_message", "label": "Thank You Message", "value": 1 }
                },
                "UTMSourceType": {
                    "__is_enum": true,
                    "bing": {
                        "help_text": "This Contact came to your Action Center via a Bing search and registered or took action there.",
                        "http_referer_pattern": "^https?:\\/\\/www\\.bing\\.com",
                        "key": "bing",
                        "label": "Searched on Bing",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 13
                    },
                    "bulk_upload": {
                        "help_text": "This Contact was added via Bulk Upload.",
                        "key": "bulk_upload",
                        "label": "Bulk Upload",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 5
                    },
                    "business_card_scanner": {
                        "help_text": "This Contact was added through the Business Card scanner.",
                        "key": "business_card_scanner",
                        "label": "Business Card Scanner",
                        "permission_enum": [3],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 3
                    },
                    "custom_event": {
                        "help_text": "This Contact was created when an Official or Staffer uses a custom event invite email to login to grassroots",
                        "key": "custom_event",
                        "label": "Custom Event",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": false,
                        "value": 20
                    },
                    "direct_link": {
                        "help_text": "This Contact came directly to your Action Center and registered or took action there.",
                        "key": "direct_link",
                        "label": "Direct Link to Action Center",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 6
                    },
                    "facebook": {
                        "help_text": "This Contact came to your Action Center after clicking a link on Facebook.",
                        "http_referer_pattern": "^https?:\\/\\/(www\\.)?(facebook\\.com|fb\\.me)",
                        "key": "facebook",
                        "label": "Facebook",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 8
                    },
                    "facebook_lead": {
                        "help_text": "This contact was created from a lead retrieved from Facebook",
                        "key": "facebook_lead",
                        "label": "Facebook Lead Ad",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 21
                    },
                    "forwarded_email": {
                        "help_text": "This Contact was added after an email chain mentioning them was sent to forwards@quorum.us.",
                        "key": "forwarded_email",
                        "label": "forwards@quorum.us",
                        "permission_enum": [3],
                        "region_specific_dict": {
                            "belgium": { "label": "forwards@quorumeu.com" },
                            "czechia": { "label": "forwards@quorumeu.com" },
                            "denmark": { "label": "forwards@quorumeu.com" },
                            "eu": { "label": "forwards@quorumeu.com" },
                            "france": { "label": "forwards@quorumeu.com" },
                            "germany": { "label": "forwards@quorumeu.com" },
                            "ireland": { "label": "forwards@quorumeu.com" },
                            "italy": { "label": "forwards@quorumeu.com" },
                            "netherlands": { "label": "forwards@quorumeu.com" },
                            "poland": { "label": "forwards@quorumeu.com" },
                            "spain": { "label": "forwards@quorumeu.com" },
                            "sweden": { "label": "forwards@quorumeu.com" }
                        },
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 4
                    },
                    "google": {
                        "help_text": "This Contact came to your Action Center via a Google search and registered or took action there.",
                        "http_referer_pattern": "^https?:\\/\\/www\\.google\\.com",
                        "key": "google",
                        "label": "Searched on Google",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 12
                    },
                    "inbound_text": {
                        "help_text": "This Contact was created from an incoming text",
                        "key": "inbound_text",
                        "label": "Inbound Text",
                        "permission_enum": [201],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 16
                    },
                    "individual_entry": {
                        "help_text": "This Contact was added directly through the Add Contact page.",
                        "key": "individual_entry",
                        "label": "Individual Entry",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 2
                    },
                    "iterable": {
                        "help_text": "This contact was created from the Iterable Integration",
                        "key": "iterable",
                        "label": "Iterable",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 23
                    },
                    "linkedin": {
                        "help_text": "This Contact came to your Action Center after clicking a link on LinkedIn.",
                        "http_referer_pattern": "^https?:\\/\\/www\\.linkedin\\.com",
                        "key": "linkedin",
                        "label": "LinkedIn",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 10
                    },
                    "nationbuilder": {
                        "help_text": "This Contact was added via the NationBuilder Integration",
                        "key": "nationbuilder",
                        "label": "NationBuilder",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 19
                    },
                    "outbox_email": {
                        "help_text": "This Contact clicked on a link in an Outbox Email and then took action.",
                        "key": "outbox_email",
                        "label": "Outbox Email",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": false,
                        "show_in_enumeration": true,
                        "value": 7
                    },
                    "pinterest": {
                        "help_text": "This Contact came to your Action Center after clicking a link on Pinterest.",
                        "http_referer_pattern": "^https?:\\/\\/www\\.pinterest\\.com",
                        "key": "pinterest",
                        "label": "Pinterest",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 11
                    },
                    "salesforce": {
                        "help_text": "This Contact was added via the Salesforce Integration",
                        "key": "salesforce",
                        "label": "Salesforce",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 15
                    },
                    "sftp_upload": {
                        "help_text": "This contact was created from an automated data feed to an SFTP site",
                        "key": "sftp_upload",
                        "label": "Automated Upload Posted to SFTP",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 22
                    },
                    "texting": {
                        "help_text": "This Contact clicked on a link in a SMS and then took action.",
                        "key": "texting",
                        "label": "Texting",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": false,
                        "show_in_enumeration": true,
                        "value": 24
                    },
                    "twitter": {
                        "help_text": "This Contact came to your Action Center after clicking a link on Twitter.",
                        "http_referer_pattern": "^https?:\\/\\/(www\\.)?(twitter\\.com|t\\.co)",
                        "key": "twitter",
                        "label": "Twitter",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 9
                    },
                    "unknown": {
                        "help_text": "Quorum does not know how this data was added to the system.",
                        "key": "unknown",
                        "label": "Unknown",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": false,
                        "value": 1
                    },
                    "yahoo": {
                        "help_text": "This Contact came to your Action Center via a Yahoo search and registered or took action there.",
                        "http_referer_pattern": "^https?:\\/\\/search\\.yahoo\\.com",
                        "key": "yahoo",
                        "label": "Searched on Yahoo",
                        "permission_enum": [201, 5, 7],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": true,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 14
                    },
                    "zapier_facebook": {
                        "help_text": "This Contact was created from a Zapier Facebook Zap",
                        "key": "zapier_facebook",
                        "label": "Facebook Lead Ad (Zapier)",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 17
                    },
                    "zapier_linkedin": {
                        "help_text": "This Contact was created from a Zapier LinkedIn Zap",
                        "key": "zapier_linkedin",
                        "label": "LinkedIn Lead Ad",
                        "permission_enum": [204],
                        "region_specific_dict": {},
                        "relevant_to_campaigns": false,
                        "relevant_to_contacts": true,
                        "show_in_enumeration": true,
                        "value": 18
                    }
                }
            }
        },
        "hubble": {
            "queryset": {
                "TrendingPeriodEnum": {
                    "__is_enum": true,
                    "day": { "bg_period": "now-7d/d", "fg_period": "now/d", "key": "day", "label": "Today", "value": 1 },
                    "week": { "bg_period": "now-30d/d", "fg_period": "now-7d/d", "key": "week", "label": "This Week", "value": 2 }
                }
            }
        },
        "impact_reports": {
            "models": {
                "default_template": {
                    "DefaultTemplate": {
                        "__is_model": true,
                        "__name__": "DefaultTemplate",
                        "data_model": "app.impact_reports.models.default_template.DefaultTemplate",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/impact-reports/default-templates/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 2, "help_text": "", "name": "description", "verbose_name": "description" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "Quorum data type rendered in report",
                                "name": "type",
                                "verbose_name": "type"
                            },
                            { "field_type": null, "help_text": "Structured data for BeeFree engine", "name": "json_content", "verbose_name": "json content" },
                            { "field_type": 3, "help_text": "Storage for html data", "name": "html_content", "verbose_name": "html content" },
                            { "field_type": 2, "help_text": "Public accessible link to s3", "name": "preview_url", "verbose_name": "preview url" },
                            {
                                "field_type": 7,
                                "help_text": "Default data for default template",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            }
                        ]
                    }
                },
                "default_widget": {
                    "DefaultWidget": {
                        "__is_model": true,
                        "__name__": "DefaultWidget",
                        "data_model": "app.impact_reports.models.default_widget.DefaultWidget",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/impact-reports/default-widgets/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 3, "help_text": "", "name": "beefree_handle", "verbose_name": "beefree handle" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "template",
                                "related_model": { "__module__": "app.impact_reports.models.default_template", "__name__": "DefaultTemplate" },
                                "verbose_name": "template"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.impact_reports.types.other", "__name__": "WidgetType" },
                                "field_type": 4,
                                "help_text": "Visualization type",
                                "name": "type",
                                "verbose_name": "type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "Widget's Quorum data type.",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "Structured data for BeeFree engine.", "name": "json_content", "verbose_name": "json content" },
                            { "field_type": null, "help_text": "All the widget's filters.", "name": "filters", "verbose_name": "filters" }
                        ]
                    }
                },
                "download": {
                    "Download": {
                        "__is_model": true,
                        "__name__": "Download",
                        "data_model": "app.impact_reports.models.download.Download",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/impact-reports/bulk-download/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "creator",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 2, "help_text": "File title", "name": "title", "verbose_name": "title" },
                            {
                                "field_type": 7,
                                "help_text": "The template used to generate this report",
                                "name": "user_template",
                                "related_model": { "__module__": "app.impact_reports.models.user_template", "__name__": "UserTemplate" },
                                "verbose_name": "user template"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The user that was logged into the backend, if any, when the Report was created",
                                "name": "logged_in_as_user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "logged in as user"
                            },
                            { "field_type": 2, "help_text": "URL to the S3 location we email to the user for download", "name": "url", "verbose_name": "url" },
                            { "field_type": 4, "help_text": "The number of times the cron jobs have attempted to send this email", "name": "retry_count", "verbose_name": "retry count" },
                            { "field_type": 4, "help_text": "Number of PDFs associated with this bulk download", "name": "pdf_count", "verbose_name": "pdf count" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.impact_reports.types.other", "__name__": "ImpactReportDownloadStatus" },
                                "field_type": 4,
                                "help_text": "Status of generated report",
                                "name": "status",
                                "verbose_name": "status"
                            },
                            {
                                "field_type": 7,
                                "help_text": "Data from user's or default's template",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            },
                            { "field_type": 3, "help_text": "Snapshot of template HTML template at time of download creation.", "name": "template_snapshot", "verbose_name": "template snapshot" },
                            { "field_type": 3, "help_text": "Snapshot of header HTML template at time of download creation.", "name": "header_snapshot", "verbose_name": "header snapshot" },
                            { "field_type": 3, "help_text": "Snapshot of footer HTML template at time of download creation.", "name": "footer_snapshot", "verbose_name": "footer snapshot" },
                            { "field_type": null, "help_text": "Snapshot of dataset IDs from saved search at time of download creation.", "name": "snapshot_dataset_ids", "verbose_name": "snapshot dataset ids" }
                        ]
                    }
                },
                "search_list": {
                    "SearchList": {
                        "__is_model": true,
                        "__name__": "SearchList",
                        "data_model": "app.impact_reports.models.search_list.SearchList",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/impact-reports/search-lists/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "Data type corresponding template types",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "SafedSearch to link query set with search list object",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            },
                            { "field_type": 1, "help_text": "If enabled, prevent users other than the creator from editing or saving the template.", "name": "is_default", "verbose_name": "is default" },
                            {
                                "field_type": 7,
                                "help_text": "User who created search list",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            }
                        ]
                    }
                },
                "user_template": {
                    "UserTemplate": {
                        "__is_model": true,
                        "__name__": "UserTemplate",
                        "data_model": "app.impact_reports.models.user_template.UserTemplate",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/impact-reports/user-templates/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "creator",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                            { "field_type": 2, "help_text": "The name of the template", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "Quorum data type rendered in report",
                                "name": "type",
                                "verbose_name": "type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.impact_reports.types.template", "__name__": "BriefBuilderTemplateType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "impact_report_type",
                                "verbose_name": "impact report type"
                            },
                            { "field_type": null, "help_text": "Structured data for BeeFree engine", "name": "json_content", "verbose_name": "json content" },
                            { "field_type": 3, "help_text": "Storage for html data", "name": "html_content", "verbose_name": "html content" },
                            {
                                "field_type": 7,
                                "help_text": "Base template for user's template",
                                "name": "default_template",
                                "related_model": { "__module__": "app.impact_reports.models.default_template", "__name__": "DefaultTemplate" },
                                "verbose_name": "default template"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "Selected data by user.",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            },
                            { "field_type": 2, "help_text": "", "name": "creator_name", "verbose_name": "creator name" },
                            {
                                "field_type": 7,
                                "help_text": "UserTemplate instance used as header",
                                "name": "header_template",
                                "related_model": { "__module__": "app.impact_reports.models.user_template", "__name__": "UserTemplate" },
                                "verbose_name": "header template"
                            },
                            {
                                "field_type": 7,
                                "help_text": "UserTemplate instance used as footer",
                                "name": "footer_template",
                                "related_model": { "__module__": "app.impact_reports.models.user_template", "__name__": "UserTemplate" },
                                "verbose_name": "footer template"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            }
                        ]
                    }
                }
            },
            "types": {
                "other": {
                    "ImpactReportDownloadStatus": {
                        "__is_enum": true,
                        "error": { "key": "error", "label": "Error", "value": 5 },
                        "processing": { "key": "processing", "label": "Processing", "value": 3 },
                        "queued": { "key": "queued", "label": "Queued for Processing", "value": 2 },
                        "sent": { "key": "sent", "label": "Sent", "value": 4 },
                        "unprocessed": { "key": "unprocessed", "label": "Waiting to be Processed", "value": 1 }
                    }
                },
                "template": {
                    "BriefBuilderTemplateType": {
                        "__is_enum": true,
                        "blank": {
                            "description": "Create from scratch",
                            "files_path": "",
                            "for_section": 2,
                            "icon": "file",
                            "key": "blank",
                            "label": "Blank Template",
                            "order": 5,
                            "permission_enum": [],
                            "quorum_data_type": 102,
                            "selectable_for_new_templates": true,
                            "value": 6
                        },
                        "district_fact_sheet": {
                            "description": "Create an overview of each district, including its lawmakers and demographics.",
                            "files_path": "",
                            "for_section": 2,
                            "icon": "map",
                            "key": "district_fact_sheet",
                            "label": "District fact sheet",
                            "order": 9999,
                            "permission_enum": [],
                            "quorum_data_type": 97,
                            "selectable_for_new_templates": false,
                            "value": 2
                        },
                        "engagement": {
                            "description": "Review recent interactions with officials and their staff from the past 3 months.",
                            "files_path": "engagement_with_office_template",
                            "for_section": 2,
                            "icon": "users",
                            "key": "engagement",
                            "label": "Engagement with Office",
                            "order": 3,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/impact_report_engagement_with_office.png",
                            "quorum_data_type": 1,
                            "selectable_for_new_templates": true,
                            "value": 5
                        },
                        "footer": {
                            "description": "Footer template",
                            "files_path": "footer",
                            "for_section": 3,
                            "icon": "file",
                            "key": "footer",
                            "label": "Footer template",
                            "order": 1,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/brief_builder_footer.png",
                            "quorum_data_type": 102,
                            "selectable_for_new_templates": false,
                            "value": 12
                        },
                        "header_blank": {
                            "description": "Header template for Blank",
                            "files_path": "header_blank",
                            "for_section": 1,
                            "icon": "file",
                            "key": "header_blank",
                            "label": "Header template for Blank",
                            "order": 1,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/brief_builder_header_blank.png",
                            "quorum_data_type": 102,
                            "selectable_for_new_templates": false,
                            "value": 11
                        },
                        "header_officials": {
                            "description": "Header template for Officials",
                            "files_path": "header_officials",
                            "for_section": 1,
                            "icon": "file",
                            "key": "header_officials",
                            "label": "Header template for Officials",
                            "order": 1,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/brief_builder_header_officials.png",
                            "quorum_data_type": 1,
                            "selectable_for_new_templates": false,
                            "value": 9
                        },
                        "header_regions": {
                            "description": "Header template for Regions",
                            "files_path": "header_regions",
                            "for_section": 1,
                            "icon": "file",
                            "key": "header_regions",
                            "label": "Header template for Regions",
                            "order": 1,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/brief_builder_header_regions.png",
                            "quorum_data_type": 97,
                            "selectable_for_new_templates": false,
                            "value": 10
                        },
                        "impact_report": {
                            "description": "Show your organization's economic impact and essential details, including lawmakers.",
                            "files_path": "impact_report_template",
                            "for_section": 2,
                            "icon": "map",
                            "key": "impact_report",
                            "label": "Impact Report",
                            "order": 4,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/impact_report_org_footprint.png",
                            "quorum_data_type": 97,
                            "selectable_for_new_templates": true,
                            "value": 1
                        },
                        "legislator_briefing_sheet": {
                            "description": "Prepare for meetings with a brief on recent interactions, staff names, tweets and biographical details.",
                            "files_path": "legislator_briefing_sheet",
                            "for_section": 2,
                            "icon": "users",
                            "key": "legislator_briefing_sheet",
                            "label": "Official Brief: one-pager",
                            "order": 1,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/impact_report_official_brief_one_pager.png",
                            "quorum_data_type": 1,
                            "selectable_for_new_templates": true,
                            "value": 3
                        },
                        "legislator_briefing_sheet_detailed_bio": {
                            "description": "Prepare for meetings with a brief that provides an extended biography.",
                            "files_path": "legislator_briefing_sheet_detailed_bio",
                            "for_section": 2,
                            "icon": "users",
                            "key": "legislator_briefing_sheet_detailed_bio",
                            "label": "Official Brief: detailed bio",
                            "order": 2,
                            "permission_enum": [],
                            "preview_url": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/impact_report_official_brief_detailed_bio.png",
                            "quorum_data_type": 1,
                            "selectable_for_new_templates": true,
                            "value": 8
                        }
                    },
                    "TemplateSectionType": {
                        "__is_enum": true,
                        "body": { "key": "body", "label": "Body", "value": 2 },
                        "footer": { "key": "footer", "label": "Footer", "value": 3 },
                        "header": { "key": "header", "label": "Header", "value": 1 }
                    }
                },
                "widget": {
                    "ImpactReportWidget": {
                        "__is_enum": true,
                        "ai_bill_summary_key_takeaway": {
                            "data_template": "{ai_key_takeaway}",
                            "display_name": "AI Bill Summary Key Takeaway",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"AIBillSummaryKeyTakeaway\" style=\"line-height: 120%;\"><p>AI Bill Summary Key Takeaway</p></div>" }
                            },
                            "key": "ai_bill_summary_key_takeaway",
                            "label": "AI Bill Summary Key Takeaway",
                            "permissions": [],
                            "placeholder": "AI Bill Summary Key Takeaway",
                            "supported_report_data_types": [2],
                            "type": 4,
                            "value": "AIBillSummaryKeyTakeaway",
                            "widget_processor": "AiBillSummaryKeyTakeawayProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "bill_name": {
                            "data_template": "{bill_name_with_region}",
                            "display_name": "Bill Name",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"BillName\" style=\"line-height: 120%;\"><p>Bill Name</p></div>" }
                            },
                            "key": "bill_name",
                            "label": "Bill Name",
                            "permissions": [],
                            "placeholder": "Bill Name",
                            "supported_report_data_types": [2],
                            "type": 4,
                            "value": "BillName",
                            "widget_processor": "BillNameProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "bill_official_summary": {
                            "data_template": "{official_summary}",
                            "display_name": "Official Bill Summary",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialBillSummary\" style=\"line-height: 120%;\"><p>Official Bill Summary</p></div>" }
                            },
                            "key": "bill_official_summary",
                            "label": "Official Bill Summary",
                            "permissions": [],
                            "placeholder": "Official Bill Summary",
                            "supported_report_data_types": [2],
                            "type": 4,
                            "value": "OfficialBillSummary",
                            "widget_processor": "BillOfficialSummaryProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "bills": {
                            "display_name": "Bills",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Bills\" data-widget-type=\"card\" id=\"bill_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\"><div id=\"cards\" style=\"display: flex; flex-direction: column; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\"><div style=\"width: 100%; display: flex; flex-direction: row; gap: 1px;\"><p style=\"width: 100%; text-align: inherit;\" ><span id=\"bills-number\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 700;\">State abbreviation</span><span id=\"bills-title\" style=\"font-weight: 500; font-size: 0.875em;\"> Bill title </span></p></div><p id=\"bills-status\" style=\"font-weight: 900; text-align: inherit; font-size: 0.875em; padding: 1px;\">Bill Status</p></div></div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Bills\" data-widget-type=\"list\" style=\"line-height: 120%;\"><div style=\"margin: 0px;\"><div id=\"cards\"><div style=\"width: 100%; display: flex; flex-direction: row; gap: 1px;\"><span id=\"bills-number\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 700;\">State abbreviation</span><p id=\"bills-title\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 500;\"> Bill title</p></div></div></div></div>" }
                                    }
                                ]
                            },
                            "key": "bills",
                            "label": "Bills",
                            "permissions": [],
                            "supported_report_data_types": [102, 97, 1],
                            "type": 3,
                            "value": "Bills",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "caucuses": {
                            "display_name": "Caucuses",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Caucuses\" data-widget-type=\"card\" id=\"caucuses_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\" style=\"display: flex; flex-direction: column; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\">\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 1px; text-align: inherit;\">\n<p id=\"caucuses-name\" style=\"text-align: inherit; font-size: 1em; font-weight: 700; margin-bottom: 4px!important;\">Caucuses</p><p id=\"caucuses-official\" style=\"font-weight: 400; font-size: 0.875em; opacity: 0.6; margin-bottom: 0px!important;\">Official #1</p><p id=\"caucuses-official\" style=\"font-weight: 400; font-size: 0.875em; opacity: 0.6;\">Official #2</p></div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Caucuses\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Caucuses name </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "caucuses",
                            "label": "Caucuses",
                            "permissions": [],
                            "supported_report_data_types": [1],
                            "type": 3,
                            "value": "Caucuses",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "committees": {
                            "display_name": "Committees",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Committees\" data-widget-type=\"card\" id=\"committee_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\"><div id=\"cards\" style=\"display: flex; flex-direction: column; margin-top: 0px; margin-bottom: 0px; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\"><div style=\"width: 100%; display: flex; flex-direction: column; gap: 1px; text-align: inherit; margin-top: 0px; margin-bottom: 0px;\"><p id=\"committees-name\" style=\"margin-bottom: 0px; margin-top:0px; text-align: inherit; font-size: 1em; font-weight: 700;\">Committee name</p><p id=\"committees-official\" style=\"font-weight: 400; font-size: 0.875em; margin-top: 0px; margin-bottom: 0px; opacity: 0.6;\">Official #1</p><p id=\"committees-official\" style=\"font-weight: 400; font-size: 0.875em; opacity: 0.6; margin-top: 0px; margin-bottom: 0px;\">Official #2</p></div></div></div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Committees\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Committee name </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "committees",
                            "label": "Committees",
                            "permissions": [],
                            "supported_report_data_types": [2, 102, 1],
                            "type": 3,
                            "value": "Committees",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "district_name": {
                            "data_template": "{district_name}",
                            "display_name": "District name",
                            "for_header_or_footer": true,
                            "group": 4,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"DistrictName\" style=\"line-height: 120%;\"><p>District Name</p></div>" }
                            },
                            "key": "district_name",
                            "label": "District Name",
                            "permissions": [],
                            "placeholder": "District Name",
                            "supported_report_data_types": [97, 1],
                            "type": 4,
                            "value": "DistrictName",
                            "widget_processor": "DistrictNameProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "documents": {
                            "display_name": "Documents",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Documents\" data-widget-type=\"card\" id=\"documents_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\" style=\"display: flex; flex-direction: column; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\">\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 8px; text-align: inherit;\">\n<div>\n<p id=\"documents-date\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 400; opacity: 0.5;\">Date</p>\n<p id=\"documents-senator-tweet\" style=\"font-weight: 500; font-size: 1em; margin-bottom: 0px;\">Tweet from Senator</p>\n</div>\n<p id=\"documents-text\" style=\"font-weight: 400; font-size: 0.875em; opacity: 0.6;\">Lorem ipsum odor amet, consectetuer adipiscing elit. Maximus dictum urna curae fames sollicitudin ultricies.</p>\n</div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Documents\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> <span id=\"documents-date\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 1em; font-weight: 700;\"> Date, </span><span id=\"documents-title\" style=\"font-weight: 500; font-size: 1em;\">Document type, Source</span> </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "documents",
                            "label": "Documents",
                            "permissions": [],
                            "supported_report_data_types": [2, 102, 97, 1],
                            "type": 3,
                            "value": "Documents",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "footprint_data_map": {
                            "display_name": "Footprint data map",
                            "for_header_or_footer": false,
                            "group": 4,
                            "json_content": {
                                "content": [
                                    { "html": "\n<div\n  data-id=\"FootprintDataMap\"\n  data-widget-type=\"map\"\n  id=\"custom-data-map\"\n  style=\"\n    display: flex;\n    gap: 4px;\n    flex-direction: column;\n    width: 100%;\n    break-inside: avoid;\n    line-height: 120%;\n  \"\n>\n  <p style=\"display: none\">\n    <img id=\"map-img\" style=\"width: 100%;\" />\n  </p>\n  <div\n    id=\"map-container\"\n    style=\"\n      align-items: center;\n      border-radius: 4px;\n      border: 1px solid #e7ecef;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      justify-content: center;\n      padding: 30px;\n    \"\n  >\n    <div id=\"map\">\n      <svg\n        width=\"50\"\n        height=\"59\"\n        viewBox=\"0 0 50 59\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n      >\n        <path\n          d=\"M16.8969 16.5723L0.689453 22.5762L0.69013 57.5951L16.8969 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M1.09989 54.9789L1.09961 57.1127L16.4935 51.242V49.1609L1.09989 54.9789Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M33.3479 55.0884L33.3477 57.2222L49.0398 51.3109V49.2297L33.3479 55.0884Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M49.313 16.5723L33.1055 22.5762L33.1061 57.5951L49.313 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n          stroke-linejoin=\"round\"\n        />\n        <path\n          d=\"M16.898 16.5723L33.1055 22.5762L33.1048 57.5951L16.898 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n          stroke-linejoin=\"round\"\n        />\n        <path\n          d=\"M33.5237 54.8513L33.5234 56.9852L48.9178 51.3271V49.2459L33.5237 54.8513Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M32.7146 54.8408L32.7148 56.9747L17.2993 51.2846V49.2034L32.7146 54.8408Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M24.9327 42.3154C22.2518 39.8263 9.74609 21.8284 9.74609 16.9924L40.2173 17.2919C40.2173 21.9167 27.6844 39.8375 24.9327 42.3154Z\"\n          fill=\"white\"\n          style=\"fill: white; fill-opacity: 1\"\n        />\n        <path\n          d=\"M38.6865 14.7292C38.6865 16.5872 37.8443 19.0853 36.5193 21.8396C35.2029 24.5763 33.4428 27.5002 31.6757 30.1883C29.9097 32.8746 28.1427 35.3161 26.8168 37.0865C26.1541 37.9715 25.6019 38.6882 25.2158 39.1833C25.1369 39.2844 25.065 39.3762 25.0005 39.4584C24.9359 39.3762 24.864 39.2844 24.7852 39.1833C24.399 38.6882 23.8469 37.9715 23.1841 37.0865C21.8582 35.3161 20.0913 32.8746 18.3253 30.1883C16.5581 27.5002 14.7981 24.5763 13.4816 21.8396C12.1567 19.0853 11.3145 16.5872 11.3145 14.7292C11.3145 11.0612 12.7575 7.54447 15.3247 4.95231C17.8917 2.36031 21.3723 0.905029 25.0005 0.905029C28.6286 0.905029 32.1092 2.36031 34.6762 4.95231C37.2434 7.54447 38.6865 11.0612 38.6865 14.7292Z\" # noqa: E501\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M30.9877 14.1061V14.1063C30.9877 15.3036 30.636 16.4736 29.9778 17.4683C29.3195 18.463 28.3845 19.2376 27.2914 19.6947C26.1984 20.1519 24.9959 20.2714 23.8359 20.0384C22.6759 19.8054 21.6096 19.2302 20.7723 18.3847C19.9349 17.5392 19.3641 16.4613 19.1328 15.2871C18.9015 14.113 19.0202 12.8959 19.4738 11.7902C19.9274 10.6845 20.6952 9.74017 21.6794 9.07616C22.6635 8.41219 23.82 8.05811 25.0026 8.05811L25.0029 8.05811C25.7882 8.05774 26.5661 8.21366 27.292 8.51707C28.0179 8.82049 28.6778 9.26553 29.2338 9.82698C29.7899 10.3884 30.2312 11.0553 30.5322 11.7896C30.8332 12.5239 30.988 13.3111 30.9877 14.1061Z\" # noqa: E501\n          stroke=\"#7259EF\"\n          style=\"\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M37.7809 14.1064C36.9965 21.6076 25.0023 36.6215 25.0023 36.6215C25.0023 36.6215 13.0082 21.6076 12.2238 14.1064C12.1971 14.4488 12.1836 14.7933 12.1836 15.1392C12.1836 22.3421 25.0023 38.3882 25.0023 38.3882C25.0023 38.3882 37.8211 22.3421 37.8211 15.1392C37.8211 14.7933 37.8076 14.4488 37.7809 14.1064Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          fill-rule=\"evenodd\"\n          clip-rule=\"evenodd\"\n          d=\"M31.4578 13.3088C31.475 13.1145 31.4838 12.9191 31.4838 12.723C31.4841 11.863 31.3167 11.0113 30.9909 10.2166C30.6651 9.422 30.1875 8.69997 29.5852 8.09184C28.9829 7.48371 28.2679 7.00139 27.4809 6.67245C26.6939 6.34351 25.8505 6.17441 24.9987 6.17481C23.7161 6.17481 22.4623 6.55885 21.3958 7.27838C20.3294 7.9979 19.4982 9.02058 19.0073 10.2171C18.6049 11.198 18.4461 12.2596 18.5398 13.3102C18.5983 12.654 18.7549 12.0068 19.0073 11.3915C19.4982 10.1949 20.3294 9.17226 21.3958 8.45274C22.4623 7.73321 23.7161 7.34917 24.9987 7.34917C25.8505 7.34877 26.6939 7.51788 27.4809 7.84681C28.2679 8.17575 28.9829 8.65807 29.5852 9.2662C30.1875 9.87434 30.6651 10.5964 30.9909 11.391C31.2421 12.0038 31.3992 12.6505 31.4578 13.3088Z\" # noqa: E501\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n      </svg>\n    </div>\n    <div id=\"map-caption\" style=\"font-size: 12px; font-weight: 400\">\n      Footprint Data Map\n    </div>\n  </div>\n  <div id=\"legend-container\" style=\"display: flex; flex-direction: column\">\n    <div\n      id=\"legend-title\"\n      style=\"font-size: 14px; font-weight: 500; padding: 4px\"\n    >\n      Legend\n    </div>\n    <div\n      id=\"legend-items\"\n      style=\"display: flex; gap: 16px; align-items: center; flex-wrap: wrap;\"\n    >\n      <div id=\"legend-item\" style=\"display: flex; align-items: center;\">\n        <div\n          id=\"legend-icon\"\n          style=\"\n            background-color: rgba(12, 161, 170, 1);\n            align-items: center;\n            border-radius: 46.667px;\n            color: white;\n            display: flex;\n            font-size: 9px;\n            font-style: normal;\n            font-weight: 500;\n            height: 14px;\n            justify-content: center;\n            align-items: center;\n            width: 14px;\n            text-align: center;\n          \"\n        >\n          1\n        </div>\n        <div\n          id=\"legend-label\"\n          style=\"\n            font-size: 12px;\n            font-weight: 400;\n            padding: 4px;\n          \"\n        >\n          Footprint data #1:\n        </div>\n        <div\n          id=\"legend-value\"\n          style=\"font-size: 12px; font-weight: 600;\"\n        >\n          0\n        </div>\n      </div>\n      <span id=\"legend-divider\" style=\"color: #d9d9d9; font-size: 14px;\">|</span>\n    </div>\n  </div>\n</div>\n", "type": "paragraph" }
                                ]
                            },
                            "key": "footprint_data_map",
                            "label": "Footprint Data - Map",
                            "permissions": [4],
                            "supported_report_data_types": [1, 97],
                            "type": 7,
                            "value": "FootprintDataMap",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "footprint_data_stats": {
                            "display_name": "Footprint data cards",
                            "for_header_or_footer": false,
                            "group": 4,
                            "json_content": {
                                "content": [
                                    { "html": "\n<div\n    data-id=\"FootprintDataStats\"\n    data-widget-type=\"card\"\n    id=\"footprint_data_stats\"\n    style=\"display: flex; gap: 4px; line-height: 120%;\"\n>\n    <div\n        id=\"cards\"\n        style=\"\n            display: flex;\n            flex-direction: row;\n            width: 100%;\n            align-items: center;\n            padding: 8px 12px;\n            gap: 16px;\n            border: 1px solid #d9d9d9;\n            border-radius: 8px;\n            break-inside: avoid;\n            justify-content: space-between;\n        \"\n    >\n        <div\n            id=\"custom-data-label\"\n            style=\"font-size: 12px; font-weight: 400\"\n        >\n            Footprint data#1\n        </div>\n        <div\n            id=\"custom-data-stat\"\n            style=\"\n                font-size: 20px;\n                font-weight: 600;\n                text-align: right;\n                white-space: nowrap;\n            \"\n        >\n            0000\n        </div>\n    </div>\n</div>\n", "type": "paragraph" }
                                ]
                            },
                            "key": "footprint_data_stats",
                            "label": "Footprint Data - Cards",
                            "permissions": [4],
                            "supported_report_data_types": [97, 1],
                            "type": 3,
                            "value": "FootprintDataStats",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "footprint_data_table": {
                            "display_name": "Footprint data table",
                            "for_header_or_footer": false,
                            "group": 4,
                            "json_content": {
                                "content": [
                                    { "html": "\n<table\n    data-id=\"FootprintDataTable\"\n    data-widget-type=\"table\"\n    id=\"footprint_data_table\"\n    style=\"width: 100%; border-collapse: collapse; line-height: 120%;\"\n>\n    <thead style=\"display: table-header-group;\">\n        <tr\n            style=\"\n                page-break-inside: avoid;\n                border-bottom: 1px solid #dce2e6;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n            \"\n        >\n            <th id=\"header-cell\" style=\"text-align: left; width: 100%\">\n                Column name #1\n            </th>\n        </tr>\n    </thead>\n    <tbody\n        style=\"\n            display: table-row-group;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n        \"\n    >\n        <tr style=\"page-break-inside: avoid;\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 100%\">\n                Row #1\n            </td>\n        </tr>\n        <tr style=\"page-break-inside: avoid; background-color: #fafbfc\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 100%\">\n                Row #2\n            </td>\n        </tr>\n    </tbody>\n</table>\n", "type": "paragraph" },
                                    { "html": "\n<table\n    data-id=\"FootprintDataTable\"\n    data-widget-type=\"table\"\n    id=\"footprint_data_table\"\n    style=\"width: 100%; border-collapse: collapse; line-height: 120%;\"\n>\n    <thead style=\"display: table-header-group;\">\n        <tr\n            style=\"\n                page-break-inside: avoid;\n                border-bottom: 1px solid #dce2e6;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n            \"\n        >\n            <th id=\"header-cell\" style=\"text-align: left; width: 60%\">\n                Column name #1\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 40%\">\n                Column name #2\n            </th>\n        </tr>\n    </thead>\n    <tbody\n        style=\"\n            display: table-row-group;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n        \"\n    >\n        <tr style=\"page-break-inside: avoid;\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 60%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 40%\">\n                Row #1\n            </td>\n        </tr>\n        <tr style=\"page-break-inside: avoid; background-color: #fafbfc\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 60%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 40%\">\n                Row #2\n            </td>\n        </tr>\n    </tbody>\n</table>\n", "type": "paragraph" },
                                    { "html": "\n<table\n    data-id=\"FootprintDataTable\"\n    data-widget-type=\"table\"\n    id=\"footprint_data_table\"\n    style=\"width: 100%; border-collapse: collapse; line-height: 120%;\"\n>\n    <thead style=\"display: table-header-group;\">\n        <tr\n            style=\"\n                page-break-inside: avoid;\n                border-bottom: 1px solid #dce2e6;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n            \"\n        >\n            <th id=\"header-cell\" style=\"text-align: left; width: 50%\">\n                Column name #1\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 25%\">\n                Column name #2\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 25%\">\n                Column name #3\n            </th>\n        </tr>\n    </thead>\n    <tbody\n        style=\"\n            display: table-row-group;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n        \"\n    >\n        <tr style=\"page-break-inside: avoid;\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 50%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 25%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 25%\">\n                Row #1\n            </td>\n        </tr>\n        <tr style=\"page-break-inside: avoid; background-color: #fafbfc\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 50%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 25%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 25%\">\n                Row #2\n            </td>\n        </tr>\n    </tbody>\n</table>\n", "type": "paragraph" },
                                    { "html": "\n<table\n    data-id=\"FootprintDataTable\"\n    data-widget-type=\"table\"\n    id=\"footprint_data_table\"\n    style=\"width: 100%; border-collapse: collapse; line-height: 120%;\"\n>\n    <thead style=\"display: table-header-group;\">\n        <tr\n            style=\"\n                page-break-inside: avoid;\n                border-bottom: 1px solid #dce2e6;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n            \"\n        >\n            <th id=\"header-cell\" style=\"text-align: left; width: 40%\">\n                Column name #1\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 20%\">\n                Column name #2\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 20%\">\n                Column name #3\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 20%\">\n                Column name #4\n            </th>\n        </tr>\n    </thead>\n    <tbody\n        style=\"\n            display: table-row-group;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n        \"\n    >\n        <tr style=\"page-break-inside: avoid;\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 40%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #1\n            </td>\n        </tr>\n        <tr style=\"page-break-inside: avoid; background-color: #fafbfc\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 40%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 20%\">\n                Row #2\n            </td>\n        </tr>\n    </tbody>\n</table>\n", "type": "paragraph" },
                                    { "html": "\n<table\n    data-id=\"FootprintDataTable\"\n    data-widget-type=\"table\"\n    id=\"footprint_data_table\"\n    style=\"width: 100%; border-collapse: collapse; line-height: 120%;\"\n>\n    <thead style=\"display: table-header-group;\">\n        <tr\n            style=\"\n                page-break-inside: avoid;\n                border-bottom: 1px solid #dce2e6;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n            \"\n        >\n            <th id=\"header-cell\" style=\"text-align: left; width: 32%\">\n                Column name #1\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 17%\">\n                Column name #2\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 17%\">\n                Column name #3\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 17%\">\n                Column name #4\n            </th>\n            <th id=\"header-cell\" style=\"text-align: right; width: 17%\">\n                Column name #5\n            </th>\n        </tr>\n    </thead>\n    <tbody\n        style=\"\n            display: table-row-group;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n        \"\n    >\n        <tr style=\"page-break-inside: avoid;\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 32%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #1\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #1\n            </td>\n        </tr>\n        <tr style=\"page-break-inside: avoid; background-color: #fafbfc\">\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: left; width: 50%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #2\n            </td>\n            <td id=\"row-cell\" style=\"padding: 4px 0; text-align: right; width: 17%\">\n                Row #2\n            </td>\n        </tr>\n    </tbody>\n</table>\nFOOTPRINT_DATA_MAP = ", "type": "paragraph" }
                                ]
                            },
                            "key": "footprint_data_table",
                            "label": "Footprint Data - Table",
                            "permissions": [4],
                            "supported_report_data_types": [97, 1],
                            "type": 2,
                            "value": "FootprintDataTable",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "map": {
                            "data_template": "{mapbox_url}",
                            "display_name": "Map",
                            "for_header_or_footer": false,
                            "group": 4,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "\n<div data-type=\"1\" data-id=\"Map\" style=\"width: 100%\">\n  <p style=\"display: none\">\n    <img\n      style=\"width: 100%\"\n      src=\"https://dev-quorum-media.s3.amazonaws.com/media/css/impact-reports/map.png\"\n    />\n  </p>\n  <div\n    style=\"\n      align-items: center;\n      border-radius: 4px;\n      border: 1px solid #e7ecef;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      break-inside: avoid;\n    \"\n  >\n    <div\n      id=\"map-dummy-container\"\n      style=\"\n        display: flex;\n        gap: 4px;\n        padding: 30px 0;\n        flex-direction: column;\n        align-items: center;\n      \"\n    >\n      <svg\n        width=\"50\"\n        height=\"59\"\n        viewBox=\"0 0 50 59\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n      >\n        <path\n          d=\"M16.8969 16.5723L0.689453 22.5762L0.69013 57.5951L16.8969 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M1.09989 54.9789L1.09961 57.1127L16.4935 51.242V49.1609L1.09989 54.9789Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M33.3479 55.0884L33.3477 57.2222L49.0398 51.3109V49.2297L33.3479 55.0884Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M49.313 16.5723L33.1055 22.5762L33.1061 57.5951L49.313 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n          stroke-linejoin=\"round\"\n        />\n        <path\n          d=\"M16.898 16.5723L33.1055 22.5762L33.1048 57.5951L16.898 51.4379V16.5723Z\"\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n          stroke-linejoin=\"round\"\n        />\n        <path\n          d=\"M33.5237 54.8513L33.5234 56.9852L48.9178 51.3271V49.2459L33.5237 54.8513Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M32.7146 54.8408L32.7148 56.9747L17.2993 51.2846V49.2034L32.7146 54.8408Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M24.9327 42.3154C22.2518 39.8263 9.74609 21.8284 9.74609 16.9924L40.2173 17.2919C40.2173 21.9167 27.6844 39.8375 24.9327 42.3154Z\"\n          fill=\"white\"\n          style=\"fill: white; fill-opacity: 1\"\n        />\n        <path\n          d=\"M38.6865 14.7292C38.6865 16.5872 37.8443 19.0853 36.5193 21.8396C35.2029 24.5763 33.4428 27.5002 31.6757 30.1883C29.9097 32.8746 28.1427 35.3161 26.8168 37.0865C26.1541 37.9715 25.6019 38.6882 25.2158 39.1833C25.1369 39.2844 25.065 39.3762 25.0005 39.4584C24.9359 39.3762 24.864 39.2844 24.7852 39.1833C24.399 38.6882 23.8469 37.9715 23.1841 37.0865C21.8582 35.3161 20.0913 32.8746 18.3253 30.1883C16.5581 27.5002 14.7981 24.5763 13.4816 21.8396C12.1567 19.0853 11.3145 16.5872 11.3145 14.7292C11.3145 11.0612 12.7575 7.54447 15.3247 4.95231C17.8917 2.36031 21.3723 0.905029 25.0005 0.905029C28.6286 0.905029 32.1092 2.36031 34.6762 4.95231C37.2434 7.54447 38.6865 11.0612 38.6865 14.7292Z\" # noqa: E501\n          fill=\"white\"\n          stroke=\"#7259EF\"\n          style=\"\n            fill: white;\n            fill-opacity: 1;\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M30.9877 14.1061V14.1063C30.9877 15.3036 30.636 16.4736 29.9778 17.4683C29.3195 18.463 28.3845 19.2376 27.2914 19.6947C26.1984 20.1519 24.9959 20.2714 23.8359 20.0384C22.6759 19.8054 21.6096 19.2302 20.7723 18.3847C19.9349 17.5392 19.3641 16.4613 19.1328 15.2871C18.9015 14.113 19.0202 12.8959 19.4738 11.7902C19.9274 10.6845 20.6952 9.74017 21.6794 9.07616C22.6635 8.41219 23.82 8.05811 25.0026 8.05811L25.0029 8.05811C25.7882 8.05774 26.5661 8.21366 27.292 8.51707C28.0179 8.82049 28.6778 9.26553 29.2338 9.82698C29.7899 10.3884 30.2312 11.0553 30.5322 11.7896C30.8332 12.5239 30.988 13.3111 30.9877 14.1061Z\" # noqa: E501\n          stroke=\"#7259EF\"\n          style=\"\n            stroke: #7259ef;\n            stroke: color(display-p3 0.4471 0.349 0.9373);\n            stroke-opacity: 1;\n          \"\n        />\n        <path\n          d=\"M37.7809 14.1064C36.9965 21.6076 25.0023 36.6215 25.0023 36.6215C25.0023 36.6215 13.0082 21.6076 12.2238 14.1064C12.1971 14.4488 12.1836 14.7933 12.1836 15.1392C12.1836 22.3421 25.0023 38.3882 25.0023 38.3882C25.0023 38.3882 37.8211 22.3421 37.8211 15.1392C37.8211 14.7933 37.8076 14.4488 37.7809 14.1064Z\"\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n        <path\n          fill-rule=\"evenodd\"\n          clip-rule=\"evenodd\"\n          d=\"M31.4578 13.3088C31.475 13.1145 31.4838 12.9191 31.4838 12.723C31.4841 11.863 31.3167 11.0113 30.9909 10.2166C30.6651 9.422 30.1875 8.69997 29.5852 8.09184C28.9829 7.48371 28.2679 7.00139 27.4809 6.67245C26.6939 6.34351 25.8505 6.17441 24.9987 6.17481C23.7161 6.17481 22.4623 6.55885 21.3958 7.27838C20.3294 7.9979 19.4982 9.02058 19.0073 10.2171C18.6049 11.198 18.4461 12.2596 18.5398 13.3102C18.5983 12.654 18.7549 12.0068 19.0073 11.3915C19.4982 10.1949 20.3294 9.17226 21.3958 8.45274C22.4623 7.73321 23.7161 7.34917 24.9987 7.34917C25.8505 7.34877 26.6939 7.51788 27.4809 7.84681C28.2679 8.17575 28.9829 8.65807 29.5852 9.2662C30.1875 9.87434 30.6651 10.5964 30.9909 11.391C31.2421 12.0038 31.3992 12.6505 31.4578 13.3088Z\" # noqa: E501\n          fill=\"#EBEAFD\"\n          style=\"\n            fill: #ebeafd;\n            fill: color(display-p3 0.9216 0.9176 0.9922);\n            fill-opacity: 1;\n          \"\n        />\n      </svg>\n      <div id=\"map-caption\" style=\"font-size: 12px; font-weight: 400\">Map</div>\n    </div>\n  </div>\n</div>\n" }
                            },
                            "key": "map",
                            "label": "Map",
                            "permissions": [],
                            "placeholder": "https://dev-quorum-media.s3.amazonaws.com/media/css/impact-reports/map.png",
                            "supported_report_data_types": [97, 1],
                            "type": 3,
                            "value": "Map",
                            "widget_processor": "MapWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "notes": {
                            "display_name": "Notes",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Notes\" data-widget-type=\"card\" id=\"notes_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\" style=\"display: flex; flex-direction: column; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\">\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 8px; text-align: inherit;\">\n<div>\n<p id=\"notes-date\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em;font-weight: 400; opacity: 0.5;\">Date</p>\n<p id=\"notes-senator-interaction\" style=\"font-weight: 500; font-size: 1em; margin-bottom: 0px;\">John Smith met with Senator</p>\n</div>\n<p id=\"notes-text\" style=\"font-weight: 400; font-size: 0.875em; opacity: 0.6;\">Lorem ipsum odor amet, consectetuer adipiscing elit. Primis libero dolor duis sem feugiat.</p>\n</div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Notes\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Date - Interaction type </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "notes",
                            "label": "Notes",
                            "permissions": [],
                            "supported_report_data_types": [2, 102, 97, 1],
                            "type": 3,
                            "value": "Notes",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_age": {
                            "data_template": "{age}",
                            "display_name": "Age",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsAge\" style=\"line-height: 120%;\"><p>Official's Age</p></div>" }
                            },
                            "key": "official_age",
                            "label": "Officials - Age",
                            "permissions": [],
                            "placeholder": "Official's Age",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsAge",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_birthday": {
                            "data_template": "{biography___ph_birthdate}",
                            "display_name": "Birthday",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsBirthday\" style=\"line-height: 120%;\"><p>Birthday</p></div>" }
                            },
                            "key": "official_birthday",
                            "label": "Officials - Birthday",
                            "permissions": [],
                            "placeholder": "Birthday",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsBirthday",
                            "widget_processor": "DateTimeWidgetProcessor",
                            "widget_processor_xtra_kwargs": { "date_format": "%B %-d, %Y" }
                        },
                        "official_birthplace": {
                            "data_template": "{biography__birthplace}",
                            "display_name": "Birthplace",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsBirthplace\" style=\"line-height: 120%;\"><p>Birthplace</p></div>" }
                            },
                            "key": "official_birthplace",
                            "label": "Officials - Birthplace",
                            "permissions": [],
                            "placeholder": "Birthplace",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsBirthplace",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_capitol_address": {
                            "data_template": "{address}",
                            "display_name": "Capitol address",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsCapitolAddress\" style=\"line-height: 120%;\"><p>Capitol Address</p></div>" }
                            },
                            "key": "official_capitol_address",
                            "label": "Officials - Capitol Address",
                            "permissions": [],
                            "placeholder": "Capitol Address",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsCapitolAddress",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_custom_biography": {
                            "data_template": "{custom_biography}",
                            "display_name": "Custom Bio",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsCustomBiography\" style=\"line-height: 120%;\"><p>Custom Biography</p></div>" }
                            },
                            "key": "official_custom_biography",
                            "label": "Officials - Custom Biography",
                            "permissions": [],
                            "placeholder": "Custom Biography",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsCustomBiography",
                            "widget_processor": "OfficialsCustomBiographyProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_district_address": {
                            "data_template": "{district_office_address}",
                            "display_name": "District address",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsDistrictAddress\" style=\"line-height: 120%;\"><p>District Address</p></div>" }
                            },
                            "key": "official_district_address",
                            "label": "Officials - District Address",
                            "permissions": [],
                            "placeholder": "District Address",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsDistrictAddress",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_ethnicity": {
                            "data_template": "{biography__ethnicity__label}",
                            "display_name": "Ethnicity",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsEthnicity\" style=\"line-height: 120%;\"><p>Ethnicity</p></div>" }
                            },
                            "key": "official_ethnicity",
                            "label": "Officials - Ethnicity",
                            "permissions": [],
                            "placeholder": "Ethnicity",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsEthnicity",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_expanded_biography": {
                            "data_template": "{biography__almanac_biography}",
                            "display_name": "Expanded Bio",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsExpandedBiography\" style=\"line-height: 120%;\"><p>Expanded Biography</p></div>" }
                            },
                            "key": "official_expanded_biography",
                            "label": "Officials - Expanded Biography",
                            "permissions": [],
                            "placeholder": "Expanded Biography",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsExpandedBiography",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_facebook": {
                            "data_template": "{person_socials}",
                            "display_name": "Facebook",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsFacebook\" style=\"line-height: 120%;\"><p>Facebook</p></div>" }
                            },
                            "key": "official_facebook",
                            "label": "Officials - Facebook",
                            "permissions": [],
                            "placeholder": "Facebook",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsFacebook",
                            "widget_processor": "SocialMediaWidgetProcessor",
                            "widget_processor_xtra_kwargs": { "dict_key": "facebook" }
                        },
                        "official_full_name": {
                            "data_template": "{name}",
                            "display_name": "Full name",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsFullName\" style=\"line-height: 120%;\"><p>Official Full Name and District Abbreviation</p></div>" }
                            },
                            "key": "official_full_name",
                            "label": "Officials - Full Name",
                            "permissions": [],
                            "placeholder": "Official Full Name and District Abbreviation",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsFullName",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_image": {
                            "data_template": "{image_url}",
                            "display_name": "Official image",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "image",
                                "value": { "alt": "", "dynamicSrc": "OfficialsImage", "href": "", "src": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/square_image_placeholder.png" }
                            },
                            "key": "official_image",
                            "label": "Officials - Image",
                            "permissions": [],
                            "placeholder": "https://quorum-media.s3.us-east-1.amazonaws.com/impact-reports/square_image_placeholder.png",
                            "supported_report_data_types": [1],
                            "type": 5,
                            "value": "OfficialsImage",
                            "widget_processor": "ImageProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_marital_status": {
                            "data_template": "{biography__marital}",
                            "display_name": "Marital status",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsMaritalStatus\" style=\"line-height: 120%;\"><p>Marital Status</p></div>" }
                            },
                            "key": "official_marital_status",
                            "label": "Officials - Marital Status",
                            "permissions": [],
                            "placeholder": "Marital Status",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsMaritalStatus",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_next_election": {
                            "data_template": "{most_recent_role__reelectionyear}",
                            "display_name": "Next election",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsNextElection\" style=\"line-height: 120%;\"><p>Next Election Date</p></div>" }
                            },
                            "key": "official_next_election",
                            "label": "Officials - Next Election",
                            "permissions": [],
                            "placeholder": "Next Election Date",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsNextElection",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_official_biography": {
                            "data_template": "{biography__kw_biography}",
                            "display_name": "Official Bio",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsOfficialBiography\" style=\"line-height: 120%;\"><p>Official Biography</p></div>" }
                            },
                            "key": "official_official_biography",
                            "label": "Officials - Official Biography",
                            "permissions": [],
                            "placeholder": "Official Biography",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsOfficialBiography",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_phone": {
                            "data_template": "{phone}",
                            "display_name": "Phone",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsPhone\" style=\"line-height: 120%;\"><p>Phone</p></div>" }
                            },
                            "key": "official_phone",
                            "label": "Officials - Phone",
                            "permissions": [],
                            "placeholder": "Phone",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsPhone",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_pronunciation": {
                            "data_template": "{pronunciation}",
                            "display_name": "Pronunciation",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsPronunciation\" style=\"line-height: 120%;\"><p>Pronunciation</p></div>" }
                            },
                            "key": "official_pronunciation",
                            "label": "Officials - Pronunciation",
                            "permissions": [],
                            "placeholder": "Pronunciation",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsPronunciation",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_quorum_biography": {
                            "data_template": "{biography__quorum_biography}",
                            "display_name": "Quorum Bio",
                            "for_header_or_footer": false,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsQuorumBiography\" style=\"line-height: 120%;\"><p>Quorum Biography</p></div>" }
                            },
                            "key": "official_quorum_biography",
                            "label": "Officials - Quorum Biography",
                            "permissions": [],
                            "placeholder": "Quorum Biography",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsQuorumBiography",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_religion": {
                            "data_template": "{biography__religion__label}",
                            "display_name": "Religion",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsReligion\" style=\"line-height: 120%;\"><p>Religion</p></div>" }
                            },
                            "key": "official_religion",
                            "label": "Officials - Religion",
                            "permissions": [],
                            "placeholder": "Religion",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsReligion",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_residence": {
                            "data_template": "{biography__residence}",
                            "display_name": "Residence",
                            "for_header_or_footer": true,
                            "group": 2,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsResidence\" style=\"line-height: 120%;\"><p>Residence</p></div>" }
                            },
                            "key": "official_residence",
                            "label": "Officials - Residence",
                            "permissions": [],
                            "placeholder": "Residence",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsResidence",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_state_name": {
                            "data_template": "{state_fullname}",
                            "display_name": "State name",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsStateName\" style=\"line-height: 120%;\"><p>State name</p></div>" }
                            },
                            "key": "official_state_name",
                            "label": "Officials - State Name",
                            "permissions": [],
                            "placeholder": "State name",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsStateName",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "official_term": {
                            "data_template": "{num_terms}",
                            "display_name": "Term",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsTerm\" style=\"line-height: 120%;\"><p>Term</p></div>" }
                            },
                            "key": "official_term",
                            "label": "Officials - Term",
                            "permissions": [],
                            "placeholder": "Term",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsTerm",
                            "widget_processor": "PositionalWidgetProcessor",
                            "widget_processor_xtra_kwargs": { "postfix": "term" }
                        },
                        "official_twitter": {
                            "data_template": "{person_socials}",
                            "display_name": "X (formerly Twitter)",
                            "for_header_or_footer": true,
                            "group": 1,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsTwitter\" style=\"line-height: 120%;\"><p>X (formerly Twitter) Handle</p></div>" }
                            },
                            "key": "official_twitter",
                            "label": "Officials - Twitter",
                            "permissions": [],
                            "placeholder": "X (formerly Twitter) Handle",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsTwitter",
                            "widget_processor": "SocialMediaWidgetProcessor",
                            "widget_processor_xtra_kwargs": { "dict_key": "twitter", "prepend_at": true }
                        },
                        "official_website": {
                            "data_template": "{most_recent_role__website}",
                            "display_name": "Website",
                            "for_header_or_footer": true,
                            "group": 3,
                            "json_content": {
                                "type": "paragraph",
                                "value": { "html": "<div data-id=\"OfficialsWebsite\" style=\"line-height: 120%;\"><p>Website</p></div>" }
                            },
                            "key": "official_website",
                            "label": "Officials - Website",
                            "permissions": [],
                            "placeholder": "Website",
                            "supported_report_data_types": [1],
                            "type": 4,
                            "value": "OfficialsWebsite",
                            "widget_processor": "BasicWidgetProcessor",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "officials": {
                            "display_name": "Officials",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Officials\" data-widget-type=\"card\" id=\"official_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\"  style=\"display: flex; width: 100%; align-items: center; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px; page-break-inside: avoid;\">\n<img style=\"border-radius: 50%; width: 40px; height: 40px; object-fit:cover\" src=\"https://dev-quorum-media.s3.amazonaws.com/media/css/impact-reports/Image+placeholder.png\"/>\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 2px;\">\n<p id=\"officials-title\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 1em; font-weight: 600; padding: 1px;\">Senator Alexandra Gray (D-NY)</p>\n<p id=\"officials-committees\" style=\"text-align: inherit; font-size: 0.875em; padding: 1px;\">Judiciary, Finance</p>\n</div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Officials\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> <p style=\"display: flex; margin-bottom: 0px; height: fit-content; flex-direction: row; gap: 2px; font-size: 1em; font-weight: 600; padding: 1px;\">Senator Alexandra Gray (D-NY)</p><p style=\"margin-bottom: 0px;\">,</p><p id=\"officials-committees\" style=\"font-size: 1em; height: fit-content; font-weight: 600; padding: 1px;\">Judiciary, Finance</p> </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "officials",
                            "label": "Officials",
                            "permissions": [],
                            "supported_report_data_types": [102, 97],
                            "type": 3,
                            "value": "Officials",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "organizations": {
                            "display_name": "Organizations",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Organizations\" data-widget-type=\"card\" id=\"organizations_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\" style=\"display: flex; flex-direction: column; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\">\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 1px; text-align: inherit;\">\n<p id=\"organizations-name\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 1em; font-weight: 700;\">Organization name</p><p id=\"organizations-parent\" style=\"font-weight: 400; font-size: 0.875em; margin-bottom: 0px; opacity: 0.6;\">Parent organization</p></div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Organizations\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Organization name </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "organizations",
                            "label": "Organizations",
                            "permissions": [],
                            "supported_report_data_types": [102, 97, 1],
                            "type": 3,
                            "value": "Organizations",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "rich_text": {
                            "display_name": "Rich Text",
                            "for_header_or_footer": true,
                            "json_content": {
                                "content": [
                                    {
                                        "type": "paragraph",
                                        "value": { "html": "<div data-id=\"RichText\"></div>" }
                                    }
                                ]
                            },
                            "key": "rich_text",
                            "label": "Rich Text",
                            "permissions": [],
                            "supported_report_data_types": [2, 102, 97, 1],
                            "type": 4,
                            "value": "RichText",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "staffers": {
                            "display_name": "Staffers",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Staffers\" data-widget-type=\"card\" id=\"staffers_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\">\n<div id=\"cards\"  style=\"display: flex; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\">\n<img style=\"border-radius: 50%; width: 40px; height: 40px\" src=\"https://dev-quorum-media.s3.amazonaws.com/media/css/impact-reports/Image+placeholder.png\"/>\n<div style=\"width: 100%; display: flex; flex-direction: column; gap: 2px;\">\n<p id=\"staffer-title\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 1em; font-weight: 600; padding: 1px;\">Staffer name, Title</p>\n<p id=\"staffer-office\" style=\"text-align: inherit; font-size: 0.875em; padding: 1px; margin-bottom: 0px; opacity: 0.6;\">Office</p>\n<p id=\"staffer-email\" style=\"text-align: inherit; font-size: 0.875em; padding: 1px; margin-bottom: 0px; opacity: 0.6;\">Email</p>\n</div>\n</div>\n</div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Staffers\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Staffer name, Title </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "staffers",
                            "label": "Staffers",
                            "permissions": [],
                            "supported_report_data_types": [102, 1],
                            "type": 3,
                            "value": "Staffers",
                            "widget_processor_xtra_kwargs": {}
                        },
                        "votes": {
                            "display_name": "Votes",
                            "for_header_or_footer": false,
                            "group": 3,
                            "json_content": {
                                "content": [
                                    { "html": "<div data-id=\"Votes\" data-widget-type=\"card\" id=\"vote_cards\" style=\"display: flex; gap: 10px; break-inside: avoid; line-height: 120%;\"><div id=\"cards\" style=\"display: flex; flex-direction: column; margin-top: 0px; margin-bottom: 0px; width: 100%; padding: 8px 12px; gap: 4px; border: 1px solid #D9D9D9; border-radius: 10px;\"><div style=\"width: 100%; display: flex; flex-direction: column; gap: 1px; text-align: inherit; margin-top: 0px; margin-bottom: 0px;\"><p id=\"vote-name\" style=\"font-weight: 400; font-size: 0.875em; margin-top: 0px; margin-bottom: 0px;\">Vote Name</p><p style=\"width: 100%; text-align: inherit;\"><span id=\"vote-result\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 900;\">Vote Result</span><span id=\"vote-date\" style=\"margin-bottom: 0px; text-align: inherit; font-size: 0.875em; font-weight: 500;\"> Vote Date</span></p></div></div></div>", "type": "paragraph" },
                                    {
                                        "type": "list",
                                        "value": { "html": "<div data-id=\"Votes\" data-widget-type=\"list\" style=\"line-height: 120%;\"> <div style=\"margin: 0px;\"> <div id=\"cards\" style=\"display: flex; margin: 0px; height: fit-content; flex-direction: row;\"> <div style=\"width: 5px; flex-basis: 5px; flex-grow: 0; flex-shrink: 0; height: 5px; border-radius: 50%; background-color: black; align-self: center; margin-right: 8px;\"> </div> <div style=\"display: flex; flex-direction: row; gap: 1px;\"> <p data-apply-style style=\"margin: 0px; text-align: inherit; font-size: 1em; font-weight: 500;\"> Vote Results </p> </div> </div> </div></div>" }
                                    }
                                ]
                            },
                            "key": "votes",
                            "label": "Votes",
                            "permissions": [],
                            "supported_report_data_types": [2, 102, 1],
                            "type": 3,
                            "value": "Votes",
                            "widget_processor_xtra_kwargs": {}
                        }
                    },
                    "ImpactReportWidgetGroup": {
                        "__is_enum": true,
                        "basic": {
                            "collapsed_on_load": false,
                            "key": "basic",
                            "label": "Basic Information",
                            "supported_report_data_types": { "1": "Basic Information", "2": "Basic Information" },
                            "value": 1
                        },
                        "district": {
                            "collapsed_on_load": true,
                            "key": "district",
                            "label": "District Overview",
                            "supported_report_data_types": { "1": "District Overview", "97": "District Overview" },
                            "value": 4
                        },
                        "office_and_legislative": {
                            "collapsed_on_load": true,
                            "key": "office_and_legislative",
                            "label": "Office and Legislative Information",
                            "supported_report_data_types": { "1": "Office and Legislative Information", "102": "Legislative Information", "97": "Legislative Information" },
                            "value": 3
                        },
                        "personal": {
                            "collapsed_on_load": true,
                            "key": "personal",
                            "label": "Personal Details",
                            "supported_report_data_types": { "1": "Personal Details" },
                            "value": 2
                        }
                    }
                }
            }
        },
        "ledger": {
            "models": {
                "Account": {
                    "__is_model": true,
                    "__name__": "Account",
                    "data_model": "app.ledger.models.Account",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/ledgeraccount/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "The account number associated with this account, if applicable. Relevant for real world accounts", "name": "account_number", "verbose_name": "account number" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "LedgerAccountType" },
                            "field_type": 4,
                            "help_text": "The type of this account",
                            "name": "account_type",
                            "verbose_name": "account type"
                        },
                        { "field_type": 3, "help_text": "The city of the bank account", "name": "bank_city", "verbose_name": "bank city" },
                        { "field_type": 3, "help_text": "The country of the bank account", "name": "bank_country", "verbose_name": "bank country" },
                        { "field_type": 3, "help_text": "The name of the bank, if the type of bank is of type LedgerAccountType.checking_account orLedgerAccountType.savings_account", "name": "bank_name", "verbose_name": "bank name" },
                        { "field_type": 3, "help_text": "The state of the bank account", "name": "bank_state", "verbose_name": "bank state" },
                        { "field_type": 3, "help_text": "The street address of the bank account", "name": "bank_street_address", "verbose_name": "bank street address" },
                        { "field_type": 3, "help_text": "The street address 2 of the bank account", "name": "bank_street_address_2", "verbose_name": "bank street address 2" },
                        { "field_type": 3, "help_text": "The zip code of the bank account", "name": "bank_zip_code", "verbose_name": "bank zip code" },
                        { "field_type": 1, "help_text": "Whether this is the default bank account. A PAC can only have 1 default bank account and must beeither a LedgerAccountType.checking_account or LedgerAccountType.savings_account", "name": "is_default_bank_account", "verbose_name": "is default bank account" },
                        { "field_type": 4, "help_text": "The initial balance of the bank account on the initial balance date", "name": "initial_bank_balance", "verbose_name": "initial bank balance" },
                        { "field_type": 5, "help_text": "The initial balance date of the bank account.", "name": "initial_bank_balance_date", "verbose_name": "initial bank balance date" },
                        { "field_type": 4, "help_text": "The initial check number for this bank account. Only relevant for Asset accounts", "name": "initial_check_number", "verbose_name": "initial check number" },
                        { "field_type": 4, "help_text": "The balance of this account, in the smallest denomination of the current_balance_currency", "name": "current_balance", "verbose_name": "current balance" },
                        {
                            "field_type": 7,
                            "help_text": "The event that last modified the balance of this Account. This field will be used to help determine the validity of the balance cached on the account",
                            "name": "last_event",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "TransactionEvent" },
                            "verbose_name": "last event"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this account belongs to",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        { "field_type": 3, "help_text": "A nickname for this Account that can be set by the user.", "name": "nickname", "verbose_name": "nickname" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this account belongs to, denormalized from ledger_settings. Note: An organization can have more than one Ledger.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The custom public organization associated with this Account, if it is an asset account.",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        { "field_type": 4, "help_text": "The PAC Classic PACBankAccountID of this record.", "name": "pacc_id", "verbose_name": "pacc id" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" }
                    ]
                },
                "AccountReconciliation": {
                    "__is_model": true,
                    "__name__": "AccountReconciliation",
                    "data_model": "app.ledger.models.AccountReconciliation",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/reconciliation/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The account that this reconciliation is for.",
                            "name": "account",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                            "verbose_name": "account"
                        },
                        { "field_type": 5, "help_text": "The date this reconciliation was completed", "name": "date_completed", "verbose_name": "date completed" },
                        { "field_type": 5, "help_text": "The end date of this reconciliation. ", "name": "end_date", "verbose_name": "end date" },
                        { "field_type": 4, "help_text": "The ending balance of the bank account this reconciliation is for", "name": "ending_balance", "verbose_name": "ending balance" },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this AccountReconciliation belongs to",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this reconciliation belongs to belongs to.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 5, "help_text": "The start date of this reconciliation", "name": "start_date", "verbose_name": "start date" },
                        { "field_type": 4, "help_text": "The starting balance of the bank account this reconciliation is for", "name": "starting_balance", "verbose_name": "starting balance" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "AccountReconciliationStatusType" },
                            "field_type": 4,
                            "help_text": "The status of this reconciliation",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The user that completed this reconciliation.",
                            "name": "performed_by_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "performed by user"
                        }
                    ]
                },
                "AccountStateError": {
                    "__is_model": true,
                    "__name__": "AccountStateError",
                    "data_model": "app.ledger.models.AccountStateError",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/accountstateerror/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The account associated with this error, if applicable",
                            "name": "account",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                            "verbose_name": "account"
                        },
                        { "field_type": 4, "help_text": "The amount by which the account is over the limit, if applicable. Assumed to be in US cents.", "name": "over_balance_amount", "verbose_name": "over balance amount" },
                        {
                            "field_type": 7,
                            "help_text": "The implicit subaccount representing a contribution or receipt from a committee or supporter",
                            "name": "contribution_sum_cache",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "ContributionSumCache" },
                            "verbose_name": "contribution sum cache"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "ErrorTierType" },
                            "field_type": 4,
                            "help_text": "The tier of this error",
                            "name": "error_tier",
                            "verbose_name": "error tier"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "AccountStateErrorType" },
                            "field_type": 4,
                            "help_text": "The type of error - limit, report, transaction, etc",
                            "name": "error_type",
                            "verbose_name": "error type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "AccountStateErrorSubType" },
                            "field_type": 4,
                            "help_text": "Subtype of error. Explanatory text will live on the ErrorSubType enum.",
                            "name": "error_subtype",
                            "verbose_name": "error subtype"
                        },
                        {
                            "field_type": 7,
                            "help_text": "For affiliated entities, the group cache representing contributions to all of the affiliated entities. For example, for committees, this represents the cache of contributions to a group of Affiliated Committees",
                            "name": "group_contribution_sum_cache",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "GroupContributionSumCache" },
                            "verbose_name": "group contribution sum cache"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this AccountStateError belongs to. This field is denormalized from account and contribution_sum_cache",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        { "field_type": null, "help_text": "Metadata associated with this error", "name": "metadata", "verbose_name": "metadata" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this AccountStateError belongs to. This field is denormalized.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The implicit subaccount representing the refunds made to to a committee or supporter",
                            "name": "refund_contribution_sum_cache",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "ContributionSumCache" },
                            "verbose_name": "refund contribution sum cache"
                        },
                        {
                            "field_type": 7,
                            "help_text": "For affiliated entities, the group cache representing the refunds made to all of the affiliated committees",
                            "name": "group_refund_contribution_sum_cache",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "GroupContributionSumCache" },
                            "verbose_name": "group refund contribution sum cache"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If this error is associated with a PublicOrganization, the PublicOrganization for which this error is relevant",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The supporter for which an error exists",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "For errors with a specific transaction, the transaction this error corresponds to",
                            "name": "transaction",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Transaction" },
                            "verbose_name": "transaction"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The pac file that this AccountStateError belongs to.",
                            "name": "pac_file",
                            "related_model": { "__module__": "app.pac.models.pac_file", "__name__": "PacFile" },
                            "verbose_name": "pac file"
                        }
                    ]
                },
                "LedgerAffiliatedEntity": {
                    "__is_model": true,
                    "__name__": "LedgerAffiliatedEntity",
                    "data_model": "app.ledger.models.LedgerAffiliatedEntity",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/ledgeraffiliatedentity/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The political committee that this affiliated entity was recorded for.",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that created this affiliated entity. Denormalized from ledger_settings.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "FecForm1AffiliatedEntityType" },
                            "field_type": 4,
                            "help_text": "The type of affiliated entity.",
                            "name": "entity_type",
                            "verbose_name": "entity type"
                        },
                        { "field_type": 2, "help_text": "The FEC's unique 9-character identifier for the entity, if an affiliated committee.", "name": "fec_committee_id", "verbose_name": "fec committee id" },
                        { "field_type": 2, "help_text": "The name of the entity, if an affiliated committee or organization.", "name": "org_name", "verbose_name": "org name" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        { "field_type": 2, "help_text": "The FEC's unique 9-character identifier for the entity, if an affiliated candidate.", "name": "fec_candidacy_id", "verbose_name": "fec candidacy id" },
                        { "field_type": 2, "help_text": "The last name of an affiliated candidate or leadership PAC sponsor.", "name": "last_name", "verbose_name": "last name" },
                        { "field_type": 2, "help_text": "The first name of an affiliated candidate or leadership PAC sponsor.", "name": "first_name", "verbose_name": "first name" },
                        { "field_type": 2, "help_text": "The middle name of an affiliated candidate or leadership PAC sponsor.", "name": "middle_name", "verbose_name": "middle name" },
                        { "field_type": 2, "help_text": "The prefix of an affiliated candidate's or leadership PAC sponsor's name.", "name": "prefix_name", "verbose_name": "prefix name" },
                        { "field_type": 2, "help_text": "The suffix of an affiliated candidate's or leadership PAC sponsor's name.", "name": "suffix_name", "verbose_name": "suffix name" },
                        { "field_type": 2, "help_text": "The first line of the street address of the affiliated entity.", "name": "street_address_1", "verbose_name": "street address 1" },
                        { "field_type": 2, "help_text": "The second line of the street address of the affiliated entity.", "name": "street_address_2", "verbose_name": "street address 2" },
                        { "field_type": 2, "help_text": "The city of the address of the affiliated entity.", "name": "city", "verbose_name": "city" },
                        { "field_type": 2, "help_text": "The state abbreviation for the address of the affiliated entity.", "name": "state", "verbose_name": "state" },
                        { "field_type": 2, "help_text": "The 5- or 9-digit ZIP code for the address of the affiliated entity.", "name": "zip", "verbose_name": "zip" }
                    ]
                },
                "LedgerReportingJurisdiction": {
                    "__is_model": true,
                    "__name__": "LedgerReportingJurisdiction",
                    "data_model": "app.ledger.models.LedgerReportingJurisdiction",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/ledgerreportingjurisdiction/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 4, "help_text": "The PacJurisdictionID of PACJurisdiction in PACC", "name": "pacc_id", "verbose_name": "pacc id" },
                        { "field_type": 4, "help_text": "Used by PACCSyncModelMixin", "name": "pacc_version", "verbose_name": "pacc version" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "ReportingJurisdictionType" },
                            "field_type": 4,
                            "help_text": "The jurisdiction this object represents",
                            "name": "jurisdiction_type",
                            "verbose_name": "jurisdiction type"
                        },
                        { "field_type": 1, "help_text": "", "name": "is_primary", "verbose_name": "is primary" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "ReportingTransactionSortKey" },
                            "field_type": 4,
                            "help_text": "The jurisdiction this object represents",
                            "name": "reporting_transaction_sort_key",
                            "verbose_name": "reporting transaction sort key"
                        },
                        { "field_type": 3, "help_text": "", "name": "filer_id", "verbose_name": "filer id" },
                        { "field_type": 3, "help_text": "", "name": "e_filer_id", "verbose_name": "e filer id" },
                        { "field_type": 3, "help_text": "", "name": "filer_password", "verbose_name": "filer password" },
                        { "field_type": 3, "help_text": "Used by New York and Washington", "name": "filer_password_2", "verbose_name": "filer password 2" },
                        { "field_type": 5, "help_text": "", "name": "appointed_date", "verbose_name": "appointed date" },
                        { "field_type": 5, "help_text": "", "name": "registration_date", "verbose_name": "registration date" },
                        { "field_type": 5, "help_text": "", "name": "registration_amended_date", "verbose_name": "registration amended date" },
                        { "field_type": 5, "help_text": "", "name": "dissolution_date", "verbose_name": "dissolution date" },
                        { "field_type": 1, "help_text": "Required by Michigan and Nebraska", "name": "is_independent_committee", "verbose_name": "is independent committee" },
                        { "field_type": 1, "help_text": "Required by Arizona", "name": "is_super_pac", "verbose_name": "is super pac" },
                        { "field_type": 3, "help_text": "", "name": "nature_of_business", "verbose_name": "nature of business" },
                        { "field_type": 3, "help_text": "", "name": "ak_report_key", "verbose_name": "ak report key" },
                        { "field_type": 1, "help_text": "", "name": "ca_is_major_donor_pac", "verbose_name": "ca is major donor pac" },
                        { "field_type": 1, "help_text": "", "name": "ca_is_small_contributor_committee", "verbose_name": "ca is small contributor committee" },
                        { "field_type": 1, "help_text": "", "name": "ca_is_sponsoring_committee", "verbose_name": "ca is sponsoring committee" },
                        { "field_type": 1, "help_text": "", "name": "fed_is_multicandidate", "verbose_name": "fed is multicandidate" },
                        { "field_type": 3, "help_text": "", "name": "fed_share", "verbose_name": "fed share" },
                        { "field_type": 3, "help_text": "", "name": "me_committee_purpose", "verbose_name": "me committee purpose" },
                        { "field_type": 3, "help_text": "", "name": "mn_registration_id", "verbose_name": "mn registration id" },
                        { "field_type": 3, "help_text": "", "name": "ny_pin", "verbose_name": "ny pin" },
                        { "field_type": 1, "help_text": "", "name": "ny_treat_llc_like_corporation", "verbose_name": "ny treat llc like corporation" },
                        { "field_type": 3, "help_text": "", "name": "oh_electronic_signature", "verbose_name": "oh electronic signature" },
                        { "field_type": 3, "help_text": "", "name": "oh_entity_key_number", "verbose_name": "oh entity key number" },
                        { "field_type": 1, "help_text": "", "name": "pa_summarize_payroll", "verbose_name": "pa summarize payroll" },
                        { "field_type": 1, "help_text": "", "name": "wi_conduit_pac", "verbose_name": "wi conduit pac" }
                    ]
                },
                "LedgerSettings": {
                    "__is_model": true,
                    "__name__": "LedgerSettings",
                    "data_model": "app.ledger.models.LedgerSettings",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/ledgersettings/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this Ledger belongs to belongs to. Note: An organization can have more than one Ledger.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "PoliticalCommitteeType" },
                            "field_type": 4,
                            "help_text": "A PAC can either be a multicandidate or non-multicandidate committee. ",
                            "name": "committee_type",
                            "verbose_name": "committee type"
                        },
                        { "field_type": 4, "help_text": "The PACId (PK) for the corresponding PAC in PACC, if data for this organization was imported", "name": "pacc_pacid", "verbose_name": "pacc pacid" },
                        { "field_type": 1, "help_text": "Whether to sync this LedgerSettings to PACC or not", "name": "sync_to_pacc", "verbose_name": "sync to pacc" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "field_type": null, "help_text": "PAC-level parameters controlling the behavior of the PAC Classic systemSee also pacc_client_parameters on the Organization model", "name": "pacc_pac_parameters", "verbose_name": "pacc pac parameters" },
                        { "field_type": 2, "help_text": "The last name of the committee's custodian of records.", "name": "custodian_of_records_last_name", "verbose_name": "custodian of records last name" },
                        { "field_type": 2, "help_text": "The first name of the committee's custodian of records.", "name": "custodian_of_records_first_name", "verbose_name": "custodian of records first name" },
                        { "field_type": 2, "help_text": "The middle name of the committee's custodian of records.", "name": "custodian_of_records_middle_name", "verbose_name": "custodian of records middle name" },
                        { "field_type": 2, "help_text": "The prefix of the name of the committee's custodian of records.", "name": "custodian_of_records_prefix_name", "verbose_name": "custodian of records prefix name" },
                        { "field_type": 2, "help_text": "The suffix of the name of the committee's custodian of records.", "name": "custodian_of_records_suffix_name", "verbose_name": "custodian of records suffix name" },
                        { "field_type": 2, "help_text": "The first line of the street address of the committee's custodian of records.", "name": "custodian_of_records_street_address", "verbose_name": "custodian of records street address" },
                        { "field_type": 2, "help_text": "The second line of the street address of the committee's custodian of records.", "name": "custodian_of_records_street_address_2", "verbose_name": "custodian of records street address 2" },
                        { "field_type": 2, "help_text": "The city of the address of the committee's custodian of records.", "name": "custodian_of_records_city", "verbose_name": "custodian of records city" },
                        { "field_type": 2, "help_text": "The state abbreviation for the address of the committee's custodian of records.", "name": "custodian_of_records_state", "verbose_name": "custodian of records state" },
                        { "field_type": 2, "help_text": "The 5- or 9-digit ZIP code for the address of the committee's custodian of records.", "name": "custodian_of_records_zip", "verbose_name": "custodian of records zip" },
                        { "field_type": 3, "help_text": "The country of the custodian of records", "name": "custodian_of_records_country", "verbose_name": "custodian of records country" },
                        { "field_type": 2, "help_text": "The title of the committee's custodian of records", "name": "custodian_of_records_title", "verbose_name": "custodian of records title" },
                        { "field_type": 3, "help_text": "The email of the custodian of records (not sent to FEC)", "name": "custodian_of_records_email", "verbose_name": "custodian of records email" },
                        { "field_type": 3, "help_text": "The employer of the custodian of records (not sent to FEC)", "name": "custodian_of_records_employer", "verbose_name": "custodian of records employer" },
                        { "field_type": 2, "help_text": "The phone number of the committee's custodian of records", "name": "custodian_of_records_phone", "verbose_name": "custodian of records phone" },
                        { "field_type": 5, "help_text": "The date the ledger was formed.", "name": "date_formed", "verbose_name": "date formed" },
                        { "field_type": 5, "help_text": "The date The Ledger achieved multicandidate status", "name": "date_became_multicandidate", "verbose_name": "date became multicandidate" },
                        { "field_type": 2, "help_text": "The last name of the committee's designated agent.", "name": "designated_agent_last_name", "verbose_name": "designated agent last name" },
                        { "field_type": 2, "help_text": "The first name of the committee's designated agent.", "name": "designated_agent_first_name", "verbose_name": "designated agent first name" },
                        { "field_type": 2, "help_text": "The middle name of the committee's designated agent.", "name": "designated_agent_middle_name", "verbose_name": "designated agent middle name" },
                        { "field_type": 2, "help_text": "The prefix of the name of the committee's designated agent.", "name": "designated_agent_prefix_name", "verbose_name": "designated agent prefix name" },
                        { "field_type": 2, "help_text": "The suffix of the name of the committee's designated agent.", "name": "designated_agent_suffix_name", "verbose_name": "designated agent suffix name" },
                        { "field_type": 2, "help_text": "The first line of the street address of the committee's designated agent.", "name": "designated_agent_street_address", "verbose_name": "designated agent street address" },
                        { "field_type": 2, "help_text": "The second line of the street address of the committee's designated agent.", "name": "designated_agent_street_address_2", "verbose_name": "designated agent street address 2" },
                        { "field_type": 2, "help_text": "The city of the address of the committee's designated agent.", "name": "designated_agent_city", "verbose_name": "designated agent city" },
                        { "field_type": 2, "help_text": "The state abbreviation for the address of the committee's designated agent.", "name": "designated_agent_state", "verbose_name": "designated agent state" },
                        { "field_type": 2, "help_text": "The 5- or 9-digit ZIP code for the address of the committee's designated agent.", "name": "designated_agent_zip", "verbose_name": "designated agent zip" },
                        { "field_type": 3, "help_text": "The country of the designated agent", "name": "designated_agent_country", "verbose_name": "designated agent country" },
                        { "field_type": 2, "help_text": "The title of the committee's designated agent.", "name": "designated_agent_title", "verbose_name": "designated agent title" },
                        { "field_type": 3, "help_text": "The email of the designated agent (not sent to FEC)", "name": "designated_agent_email", "verbose_name": "designated agent email" },
                        { "field_type": 3, "help_text": "The employer of the designated agent (not sent to FEC)", "name": "designated_agent_employer", "verbose_name": "designated agent employer" },
                        { "field_type": 2, "help_text": "The phone number of the committee's designated agent.", "name": "designated_agent_phone", "verbose_name": "designated agent phone" },
                        { "field_type": 2, "help_text": "The street address of the committee.", "name": "street_address", "verbose_name": "street address" },
                        { "field_type": 2, "help_text": "The second line of the street address of the committee", "name": "street_address_2", "verbose_name": "street address 2" },
                        { "field_type": 2, "help_text": "The city of the committee", "name": "city", "verbose_name": "city" },
                        { "field_type": 2, "help_text": "The state of the committee", "name": "state", "verbose_name": "state" },
                        { "field_type": 2, "help_text": "The zip code of the committee", "name": "zip_code", "verbose_name": "zip code" },
                        { "field_type": 3, "help_text": "The country of the PAC", "name": "country", "verbose_name": "country" },
                        { "field_type": 3, "help_text": "An optional email address for the PAC", "name": "email", "verbose_name": "email" },
                        { "field_type": 3, "help_text": "A unique 9-character alphanumeric code assigned to the committee by the FEC.", "name": "fec_committee_id", "verbose_name": "fec committee id" },
                        { "field_type": 3, "help_text": "Name of the 1st filer", "name": "filer_name_1", "verbose_name": "filer name 1" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "PacFilingFrequencyType" },
                            "field_type": 4,
                            "help_text": "The frequency a PAC files",
                            "name": "filing_frequency",
                            "verbose_name": "filing frequency"
                        },
                        { "field_type": 1, "help_text": "True if a Stripe account has been created and a user has completed the onboarding process", "name": "has_completed_stripe_onboarding", "verbose_name": "has completed stripe onboarding" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "LedgerType" },
                            "field_type": 4,
                            "help_text": "Whether this Ledger is for a PAC, nonprofit, etc.",
                            "name": "ledger_type",
                            "verbose_name": "ledger type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Jurisdiction of the PAC",
                            "name": "pac_jurisdiction",
                            "verbose_name": "pac jurisdiction"
                        },
                        { "field_type": 3, "help_text": "The name of the pac", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "A shortened name for the PAC", "name": "pacronym", "verbose_name": "pacronym" },
                        { "field_type": 3, "help_text": "The phone number of the PAC", "name": "phone", "verbose_name": "phone" },
                        {
                            "field_type": 7,
                            "help_text": "The custom public organization representing Quorum Analytics associated with this LedgerSettings.",
                            "name": "quorum_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "quorum organization"
                        },
                        { "field_type": 3, "help_text": "ID, provided by Stripe, of the Stripe Connect Express account of the PAC.", "name": "stripe_account_id", "verbose_name": "stripe account id" },
                        { "field_type": 2, "help_text": "The last name of the committee's treasurer.", "name": "treasurer_last_name", "verbose_name": "treasurer last name" },
                        { "field_type": 2, "help_text": "The first name of the committee's treasurer.", "name": "treasurer_first_name", "verbose_name": "treasurer first name" },
                        { "field_type": 2, "help_text": "The middle name of the committee's treasurer.", "name": "treasurer_middle_name", "verbose_name": "treasurer middle name" },
                        { "field_type": 2, "help_text": "The prefix of the name of the committee's treasurer.", "name": "treasurer_prefix_name", "verbose_name": "treasurer prefix name" },
                        { "field_type": 2, "help_text": "The suffix of the name of the committee's treasurer.", "name": "treasurer_suffix_name", "verbose_name": "treasurer suffix name" },
                        { "field_type": 2, "help_text": "The first line of the street address of the committee's treasurer.", "name": "treasurer_street_address", "verbose_name": "treasurer street address" },
                        { "field_type": 2, "help_text": "The second line of the street address of the committee's treasurer.", "name": "treasurer_street_address_2", "verbose_name": "treasurer street address 2" },
                        { "field_type": 2, "help_text": "The city of the address of the committee's treasurer.", "name": "treasurer_city", "verbose_name": "treasurer city" },
                        { "field_type": 2, "help_text": "The state abbreviation for the address of the committee's treasurer.", "name": "treasurer_state", "verbose_name": "treasurer state" },
                        { "field_type": 2, "help_text": "The 5- or 9-digit ZIP code for the address of the committee's treasurer.", "name": "treasurer_zip", "verbose_name": "treasurer zip" },
                        { "field_type": 3, "help_text": "The country of the treasurer", "name": "treasurer_country", "verbose_name": "treasurer country" },
                        { "field_type": 2, "help_text": "The title of the committee's treasurer", "name": "treasurer_title", "verbose_name": "treasurer title" },
                        { "field_type": 3, "help_text": "The email of the treasurer (not sent to FEC)", "name": "treasurer_email", "verbose_name": "treasurer email" },
                        { "field_type": 3, "help_text": "The employer of the treasurer (not sent to FEC)", "name": "treasurer_employer", "verbose_name": "treasurer employer" },
                        { "field_type": 2, "help_text": "The phone number of the committee's treasurer", "name": "treasurer_phone", "verbose_name": "treasurer phone" },
                        { "field_type": 3, "help_text": "The web address of the PAC", "name": "web_address", "verbose_name": "web address" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "FecForm1Line5CommitteeType" },
                            "field_type": 4,
                            "help_text": "The committee's type as provided on Line 5 of the FEC Form 1.",
                            "name": "form_1_line_5_committee_type",
                            "verbose_name": "form 1 line 5 committee type"
                        },
                        { "field_type": 2, "help_text": "The ID assigned by the FEC to any Form 1 or amendment filed by the committee.", "name": "prior_form_1_fec_id", "verbose_name": "prior form 1 fec id" },
                        { "field_type": 5, "help_text": "The date filed of the Form 1 or amendment corresponding to prior_form_1_fec_id", "name": "prior_form_1_amendment_date", "verbose_name": "prior form 1 amendment date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "PacType" },
                            "field_type": 4,
                            "help_text": "The type of PAC - one of trade assocation, corporation, etc",
                            "name": "pac_type",
                            "verbose_name": "pac type"
                        },
                        { "field_type": 1, "help_text": "True if and only if this PAC is a Lobbyist/Registrant PAC", "name": "is_lobbyist_or_registrant_pac", "verbose_name": "is lobbyist or registrant pac" },
                        { "field_type": 1, "help_text": "True if and only if this PAC is a Leadership PAC", "name": "is_leadership_pac", "verbose_name": "is leadership pac" },
                        { "field_type": 1, "help_text": "Whether filings submitted for this PAC should use the FEC's sandbox server", "name": "use_fec_sandbox_server", "verbose_name": "use fec sandbox server" }
                    ]
                },
                "StripePayment": {
                    "__is_model": true,
                    "__name__": "StripePayment",
                    "data_model": "app.ledger.models.StripePayment",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/stripepayment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 4, "help_text": "A nonnegative transaction account, in the smallest denomination of the amount_currency (TBD). Assummed to be USD centsuntil additional currency is needed. ", "name": "amount", "verbose_name": "amount" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "CurrencyType" },
                            "field_type": 4,
                            "help_text": "The currency this payment took place in.",
                            "name": "amount_currency",
                            "verbose_name": "amount currency"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The donation form used to process this Stripe Payment",
                            "name": "donation_form",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsRegistrationPage" },
                            "verbose_name": "donation form"
                        },
                        { "field_type": 14, "help_text": "A key generated by Quorum to help prevent duplicate transactions", "name": "idempotency_key", "verbose_name": "idempotency key" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this StripePayment belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this StripePayment belongs to",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        { "field_type": 3, "help_text": "An id assigned by Stripe to represent a PaymentIntent instance.", "name": "payment_intent_id", "verbose_name": "payment intent id" },
                        {
                            "field_type": 7,
                            "help_text": "The payment method associated with this Stripe Payment. Optional because a payment intent may be in an progress state and not yet have a payment method attached to it.",
                            "name": "payment_method",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "StripePaymentMethod" },
                            "verbose_name": "payment method"
                        },
                        { "field_type": 3, "help_text": "ID assigned by Stripe for the Charge which completed thePaymentIntent. There will be at most one successful charge on aPaymentIntent, whose ID will be stored on this field. Field isempty until the payment_intent.succeeded event is processed", "name": "stripe_charge_id", "verbose_name": "stripe charge id" },
                        {
                            "field_type": 7,
                            "help_text": "The supporter participating in this payment",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The transaction event responsible for creation of this StripePayment",
                            "name": "transaction_event",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "TransactionEvent" },
                            "verbose_name": "transaction event"
                        }
                    ]
                },
                "Transaction": {
                    "__is_model": true,
                    "__name__": "Transaction",
                    "data_model": "app.ledger.models.Transaction",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/transaction/",
                    "fields": [
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 14, "help_text": "", "name": "id", "verbose_name": "id" },
                        { "field_type": 4, "help_text": "The PACTransactionID (PK) from PACC, if this transaction was imported", "name": "pacc_pactransactionid", "verbose_name": "pacc pactransactionid" },
                        { "field_type": 4, "help_text": "The PACElectionID from PACC for the election associated with this transaction, if this transaction was imported", "name": "pacc_pacelectionid", "verbose_name": "pacc pacelectionid" },
                        { "field_type": 4, "help_text": "The PACAccountId from PACC for the PACAccount associated with this transaction, if this transaction was imported", "name": "pacc_pacaccountid", "verbose_name": "pacc pacaccountid" },
                        { "field_type": 4, "help_text": "The PACReportCodeID from PACC for the Report Code associated with this transaction, if this transaction was imported", "name": "pacc_pacreportcodeid", "verbose_name": "pacc pacreportcodeid" },
                        { "field_type": 4, "help_text": "The PacParentTransactionID from PACC for the parent transaction associated with this transaction, if this transaction was imported", "name": "pacc_pacparenttransactionid", "verbose_name": "pacc pacparenttransactionid" },
                        { "field_type": 4, "help_text": "The PACExpenseTypeID from PACC associated with this transaction, if this transaction was imported", "name": "pacc_pacexpensetypeid", "verbose_name": "pacc pacexpensetypeid" },
                        { "field_type": null, "help_text": "Additional transaction metadata relevant for State Reporting through PAC Classic.", "name": "pacc_state_metadata", "verbose_name": "pacc state metadata" },
                        { "field_type": 3, "help_text": "Additional notes the client may want to provide about the Transaction. NOT a reference to the Note model.NOTE: Appears on the Front End as 'Internal Comment' currently.", "name": "additional_notes", "verbose_name": "Additional Notes" },
                        { "field_type": 4, "help_text": "A nonnegative transaction account, in the smallest denomination of the amount_currency (TBD). Assummed to be USD centsuntil additional currency is needed", "name": "amount", "verbose_name": "amount" },
                        { "field_type": 1, "help_text": "Whether this transaction should be permanently excluded from the calculation of PAC disbursement / receipt limits", "name": "exclude_from_limits_calc", "sheet_column": true, "sheets_column_order": 17, "sheets_subcategory": 19, "verbose_name": "exclude from limits calc" },
                        { "field_type": 1, "help_text": "Whether this transaction, if to a Joint Fundraising Committee, should enable the allocation data", "name": "enable_allocation_data", "verbose_name": "enable allocation data" },
                        {
                            "field_type": 7,
                            "help_text": "This field allows a client to name a set of Transaction under 1 batch.",
                            "name": "batch",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "TransactionBatch" },
                            "verbose_name": "batch"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If this transaction is associated with a Grassroots Campaign, this FK will be defined",
                            "name": "campaign",
                            "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                            "verbose_name": "campaign"
                        },
                        { "field_type": 5, "help_text": "", "name": "occurred_date", "verbose_name": "occurred date" },
                        { "field_type": 16, "help_text": "The time this transaction occurred", "name": "occurred_time", "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 19, "verbose_name": "Date" },
                        {
                            "field_type": 7,
                            "help_text": "The account being 'credited' in the Accounting sense - money coming in the door as revenue on the income statement, or a decrease in the net value of the balance sheet.",
                            "name": "credit_account",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                            "verbose_name": "credit account"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The account being 'debited' in the Accounting sense - money going out the door as an expense on the income statement, or an increase in the net value of the balance sheet.",
                            "name": "debit_account",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                            "verbose_name": "debit account"
                        },
                        { "field_type": 3, "help_text": "This field stores the Report description (also known as the Purpose of Transaction)", "name": "description", "sheet_column": true, "sheets_column_order": 8, "sheets_subcategory": 19, "verbose_name": "Description" },
                        {
                            "field_type": 7,
                            "help_text": "If this transaction that is associated with a committee",
                            "name": "committee",
                            "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                            "verbose_name": "committee"
                        },
                        { "field_type": 1, "help_text": "Whether this Transaction should be itemized, if applicable.", "name": "force_itemize", "verbose_name": "force itemize" },
                        {
                            "field_type": 7,
                            "help_text": "The election associated with this Transaction. For example, a Transaction may be a disbursement to the 2020 Joe Biden Democratic Primary, in which case the Election will be the Democratic Primary",
                            "name": "election",
                            "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                            "verbose_name": "election"
                        },
                        { "field_type": 1, "help_text": "Whether the transaction has been reconciled by the client in a finished reconciliation. Reconciliation is the process by which each transaction in the system is confirmed to becleared in one of the clients' bank accountsNOTE - Transactions can be imported ALREADY reconciled, in which case there is no in-Quorum reconciliation, which is why final reconciliation status is a separate boolean value.", "name": "is_reconciled", "sheet_column": true, "sheets_column_order": 14, "sheets_subcategory": 19, "verbose_name": "Reconciliation Status" },
                        {
                            "field_type": 7,
                            "help_text": "The reconciliation that this Transaction is included in; can be either tentative or finalized.",
                            "name": "reconciliation",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "AccountReconciliation" },
                            "verbose_name": "reconciliation"
                        },
                        { "field_type": 1, "help_text": "A boolean to determine if this transaction should be reported as a Memo Entry/ Memo Item.The FEC requires reporting certain transactions as memo entries, such as In Kind TransactionsSee the reporting documentation to learn more about Memo Entries / Items.", "name": "is_memo_entry", "sheet_column": true, "sheets_column_order": 11, "sheets_subcategory": 19, "verbose_name": "Memo Entry Status" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this transaction belongs to. Note: An organization can have more than one Ledger. Denormalized from LedgerSettings.organization",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this transaction belongs to",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "PlaidTransactionType" },
                            "field_type": 4,
                            "help_text": "The type of transaction, as classified by Plaid",
                            "name": "plaid_transaction_type",
                            "verbose_name": "plaid transaction type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If this transaction is associated with a PublicOrganization, the PublicOrganization participating",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The transaction can be associated with a custom public organization in the Advanced Options section.",
                            "name": "non_pac_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "non pac public organization"
                        },
                        { "field_type": 3, "help_text": "An identifier supplied by a PAC user, such as a check number", "name": "reference_number", "sheet_column": true, "sheets_column_order": 15, "sheets_subcategory": 19, "verbose_name": "Reference Number" },
                        {
                            "field_type": 7,
                            "help_text": "A related Transaction. For example, for a reversal, this will point to the transaction being reversed.",
                            "name": "reference_transaction",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Transaction" },
                            "verbose_name": "reference transaction"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If This Transaction is associated with a transaction made using Stripe, a reference to the StripePayment",
                            "name": "stripe_payment",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "StripePayment" },
                            "verbose_name": "stripe payment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If this transaction is associated with an individual, the individual participating in the transaction",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "TransactionMethodType" },
                            "field_type": 4,
                            "help_text": "This transaction's method, such as check, in-kind, cash, etc.",
                            "name": "transaction_method",
                            "sheet_column": true,
                            "sheets_column_order": 200,
                            "sheets_subcategory": 19,
                            "verbose_name": "Transaction Method"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "PayrollFrequencyType" },
                            "field_type": 4,
                            "help_text": "If this transaction represents a Payroll transaction, this field indicates the frequency",
                            "name": "payroll_frequency_type",
                            "sheet_column": true,
                            "sheets_column_order": 13,
                            "sheets_subcategory": 19,
                            "verbose_name": "Payroll Frequency"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "TransactionType" },
                            "field_type": 4,
                            "help_text": "The type of transaction: Whether this transaction represents money coming or going out.",
                            "name": "transaction_type",
                            "sheet_column": true,
                            "sheets_column_order": 202,
                            "sheets_display_key": "pac_label",
                            "sheets_subcategory": 19,
                            "verbose_name": "Type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "TransactionSpecialType" },
                            "field_type": 4,
                            "help_text": "Subtype of the Transaction, where applicable. For example, a Reattribution Transaction.",
                            "name": "transaction_special_type",
                            "sheet_column": true,
                            "sheets_column_order": 16,
                            "sheets_subcategory": 19,
                            "verbose_name": "SubType"
                        },
                        { "field_type": 16, "help_text": "The Date this transaction was voided, if relevant (denormalized on original transaction from reversing transaction)", "name": "void_date", "verbose_name": "void date" },
                        { "field_type": 3, "help_text": "The memo text used to provide additional information regarding reports and transactions. It should be at the end of the FEC report", "name": "fec_misc_text", "verbose_name": "fec misc text" },
                        { "field_type": 3, "help_text": "ID, provided by Stripe, of the Stripe Payout object, if applicable", "name": "stripe_payout_id", "verbose_name": "stripe payout id" },
                        { "field_type": 3, "help_text": "A unique value used to identify this specific transaction in imports.", "name": "import_id", "sheet_column": true, "sheets_column_order": 15, "sheets_subcategory": 19, "verbose_name": "Import ID" },
                        {
                            "_is_enum_field": true,
                            "blank": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "ExpenseType" },
                            "field_type": 4,
                            "help_text": "The transaction's Expense Type, which corresponds to the FEC Expense Code",
                            "name": "expense_type",
                            "null": true,
                            "sheet_column": true,
                            "sheets_column_order": 10,
                            "sheets_subcategory": 19,
                            "verbose_name": "Expense Type"
                        },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "field_type": null, "help_text": "The JSON-format transaction metadata to save any instance specific information.", "name": "metadata", "verbose_name": "metadata" },
                        {
                            "field_type": 8,
                            "help_text": "Any Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The Form 3X submissions a transaction item is attached to.",
                            "name": "form_3x_submissions",
                            "related_model": { "__module__": "app.pac.models.fec_form_3x_submission", "__name__": "FecForm3XSubmission" },
                            "verbose_name": "form 3x submissions"
                        }
                    ]
                },
                "TransactionBatch": {
                    "__is_model": true,
                    "__name__": "TransactionBatch",
                    "data_model": "app.ledger.models.TransactionBatch",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/transactionbatch/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 5, "help_text": "The date this batch covers.", "name": "batch_date", "verbose_name": "batch date" },
                        { "field_type": 3, "help_text": "The name of this transaction batch", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this transaction batch belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The PAC this batch is a part of.",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The account this batch is part of.",
                            "name": "account",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                            "verbose_name": "account"
                        },
                        { "field_type": 1, "help_text": "Whether the transaction batch has been reconciled by the client in a finished reconciliation. Reconciliation is the process by which each transaction batch in the system is confirmed to be cleared in one of the clients' bank accounts.NOTE - Transactions can be imported ALREADY reconciled, in which case there is no in-Quorum reconciliation, which is why final reconciliation status is a separate boolean value.", "name": "is_reconciled", "sheet_column": true, "verbose_name": "Reconciliation Status" },
                        {
                            "field_type": 7,
                            "help_text": "The reconciliation that this Transaction Batch is included in; can be either tentative or finalized.",
                            "name": "reconciliation",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "AccountReconciliation" },
                            "verbose_name": "reconciliation"
                        },
                        { "field_type": 4, "help_text": "Count of receipts in the batch.", "name": "receipt_count", "verbose_name": "receipt count" },
                        { "field_type": 4, "help_text": "Count of disbursements in the batch.", "name": "disbursement_count", "verbose_name": "disbursement count" },
                        { "field_type": 4, "help_text": "The sum of all receipts in the batch.", "name": "receipt_amount_total", "verbose_name": "receipt amount total" },
                        { "field_type": 4, "help_text": "The sum of all disbursements in the batch.", "name": "disbursement_amount_total", "verbose_name": "disbursement amount total" }
                    ]
                },
                "TransactionEvent": {
                    "__is_model": true,
                    "__name__": "TransactionEvent",
                    "data_model": "app.ledger.models.TransactionEvent",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/transactionevent/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": null, "help_text": "The data associated with this event # TODO TO BEEF THIS UP", "name": "data", "verbose_name": "data" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.ledger.types", "__name__": "TransactionEventType" },
                            "field_type": 4,
                            "help_text": "The type of event - such as create transaction and modify transaction",
                            "name": "event_type",
                            "verbose_name": "event type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this transaction belongs to. Note: An organization can have more than one Ledger.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Ledger that this transaction belongs to",
                            "name": "ledger_settings",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                            "verbose_name": "ledger settings"
                        },
                        {
                            "field_type": 7,
                            "help_text": "A transaction event that was responsible for creating this TransactionEvent. Useful to represent the relationship between the TransactionEvent that created a parent JFC Transaction and the TransactionEvents that create the Memo Transactions for the JFC. Not all TransactionEvents have a parent.",
                            "name": "parent_transaction_event",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "TransactionEvent" },
                            "verbose_name": "parent transaction event"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "transaction",
                            "related_model": { "__module__": "app.ledger.models", "__name__": "Transaction" },
                            "verbose_name": "transaction"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The user responsible for creating this TransactionEvent",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        }
                    ]
                }
            },
            "types": {
                "AccountReconciliationStatusType": {
                    "__is_enum": true,
                    "completed": { "key": "completed", "label": "Completed", "value": 3 },
                    "in_progress": { "key": "in_progress", "label": "In Progress", "value": 2 },
                    "not_started": { "key": "not_started", "label": "In Progress", "value": 1 }
                },
                "AccountStateErrorSubType": {
                    "__is_enum": true,
                    "beginning_cash_on_hand_discrepancy": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "", "explanatory_text": "The Beginning Cash on Hand for column A does not match the previously filed report's ending balance", "icon": "warning", "key": "beginning_cash_on_hand_discrepancy", "label": "Beginning Cash on Hand Discrepancy", "location": 110, "parent": 6, "suggested_solutions": "", "value": 11 },
                    "close_cash_on_hand_discrepancy_between_two_columns": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "", "explanatory_text": "The Close Cash on Hand for column A does not match the Close Cash on Hand for column B", "icon": "warning", "key": "close_cash_on_hand_discrepancy_between_two_columns", "label": "Close Cash on Hand Discrepancy between column A and column B", "location": 110, "parent": 6, "suggested_solutions": "", "value": 12 },
                    "disbursement_after_election_date": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/#:~:text=Candidates%20who%20lose%20in%20the,separate%20limit%20for%20the%20general.", "explanatory_text": "A contribution designated for-but made after-*an election is acceptable only to the extent the campaignhas net debts outstanding for the *election on the date of receipt.", "icon": "warning", "key": "disbursement_after_election_date", "label": "Disbursement after Election date", "location": 107, "parent": 1, "suggested_solutions": "Confirm candidate has debt associated for that election", "value": 3 },
                    "exceeds_anonymous_contribution_limit": { "default_account_type": 2002, "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "An anonymous contribution of cash is limited to $50. If the SSF receives a larger anonymous contribution, the excess amount may be used for any lawful purpose unrelated to any federal election, campaign or candidate. 110.4(c)(3).", "icon": "warning", "key": "exceeds_anonymous_contribution_limit", "label": "$50 limit on anonymous contributions", "location": 107, "parent": 2, "suggested_solutions": "", "value": 6 },
                    "exceeds_cash_contribution_limit": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "An SSF may not accept more than $100 in cash from any contributor. 110.4(c)(1). Amounts exceeding $100 must be promptly returned. 110.4(c)(2)", "icon": "warning", "key": "exceeds_cash_contribution_limit", "label": "$100 limit on cash contributions", "location": 107, "parent": 1, "suggested_solutions": "", "value": 5 },
                    "exceeds_contribution_from_individuals_limit": { "default_account_type": 2001, "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "Under the Act, political committees, individuals and other entities that are not prohibited from making contributions(e.g., partnerships, sole proprietorships and certain LLCs) may contribute a maximum of {amount_string} per calendar year to an SSF. 110.1(d).", "icon": "warning", "key": "exceeds_contribution_from_individuals_limit", "label": "Receipt exceeds calendar year limit from a Contact or Supporter", "location": 12, "parent": 1, "suggested_solutions": "", "value": 7 },
                    "exceeds_contribution_from_public_org_limit": { "default_account_type": 2010, "default_error_tier": 3, "error_message_subline": "", "explanatory_text": "Under the Act, political committees, individuals and other entities that are not prohibited from making contributions(e.g., partnerships, sole proprietorships and certain LLCs) may contribute a maximum of {amount_string} per calendar year to an SSF. 110.1(d).", "icon": "warning", "key": "exceeds_contribution_from_public_org_limit", "label": "Receipt exceeds calendar year limit from a Public Organization", "location": 42, "parent": 1, "suggested_solutions": "", "value": 13 },
                    "exceeds_jfc_contribution_limit": { "default_account_type": 3036, "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/updates/contributions-to-joint-fundraisers/", "explanatory_text": "The maximum amount a contributor may give to a joint fundraiser is the total amount that individual or entity may contribute to all participants without exceeding any limits.", "icon": "failure", "key": "exceeds_jfc_contribution_limit", "label": "One or more JFC allocations exceeds the contribution limit.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 107 },
                    "exceeds_multicandidate_election_contribution_limit": { "default_account_type": 3011, "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/making-disbursements-ssf-or-connected-organization/qualifying-multicandidate-committee-ssf/", "explanatory_text": "An SSF that has qualified as a multicandidate committee may contribute up to {amount_string} per candidate, per election. 110.2(b)(1).", "icon": "warning", "key": "exceeds_multicandidate_election_contribution_limit", "label": "Multicandidate PAC exceeds election contribution limit to a candidate.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 4 },
                    "exceeds_multicandidate_national_party_calendar_year_limits": { "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "An SSF that qualifies as a multicandidate committee may give up to {amount_string} per year to a national party committee.", "icon": "warning", "key": "exceeds_multicandidate_national_party_calendar_year_limits", "label": "Multicandidate PAC exceeds National Party Committee calendar year limits", "location": 107, "parent": 1, "suggested_solutions": "", "value": 105 },
                    "exceeds_multicandidate_party_committee_calendar_year_limits": { "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/taking-receipts-political-party/affiliation-between-party-committees/", "explanatory_text": "The state committee and local party committees together may receive a maximum of {amount_string} per calendar year from any multicandidate committee.", "icon": "warning", "key": "exceeds_multicandidate_party_committee_calendar_year_limits", "label": "Multicandidate PAC exceeds State/District/Local Party Committee calendar year limits", "location": 107, "parent": 1, "suggested_solutions": "", "value": 104 },
                    "exceeds_non_multicandidate_election_contribution_limit": { "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "", "explanatory_text_template": "During the {year_1}-{year_2} election cycle, an SSF may contribute up to {amount_string} per candidate, per election, unless it qualifies as a multicandidate committee. 110.1(b)(1).", "icon": "warning", "key": "exceeds_non_multicandidate_election_contribution_limit", "label": "Non-Multicandidate PAC exceeds election contribution limit to a candidate.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 102 },
                    "exceeds_non_multicandidate_national_party_calendar_year_limits": { "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "A non-multicandidate committee may give up to {amount_string} per year to a national party committee during the {year_1}-{year_2} election cycle.", "icon": "warning", "key": "exceeds_non_multicandidate_national_party_calendar_year_limits", "label": "Multicandidate PAC exceeds State/District/Local Party Committee calendar year limits.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 106 },
                    "exceeds_non_multicandidate_party_committee_calendar_year_limits": { "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "The state committee and local party committees together may receive a maximum of {amount_string} per calendar year from any one individual or non-multicandidate committee contributor.", "icon": "warning", "key": "exceeds_non_multicandidate_party_committee_calendar_year_limits", "label": "Non-Multicandidate PAC exceeds State/District/Local Party Committee calendar year limits", "location": 107, "parent": 1, "suggested_solutions": "", "value": 103 },
                    "exceeds_pac_calendar_year_limits": { "default_account_type": 3030, "default_error_tier": 3, "error_message_subline": "Review the amounts and the selected political commitee and make changes if necessary.", "explanatory_text": "A multicandidate PAC may make contributions of up to {amount_string} per year to any political committee other than a national party committee, 110.2(d).", "icon": "warning", "key": "exceeds_pac_calendar_year_limits", "label": "PAC exceeds calendar year limits to a PAC.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 101 },
                    "exceeds_partnership_contribution_limit": { "default_error_tier": 3, "error_message_subline": "Review the amounts, the date and the contribution source and make necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/partnership-llc-contributions/", "explanatory_text": "Whatever the attribution, the portion attributed to each partner must not, when aggregated with other contributions from that person, exceed his or her contribution limit to the political committee.", "icon": "warning", "key": "exceeds_partnership_contribution_limit", "label": "One or more partnership allocations exceeds contribution limit.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 110 },
                    "exceeds_political_committee_calendar_year_limit": { "default_error_tier": 3, "error_message_subline": "Review the amounts, the date and the contribution source and make necessary.", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/contribution-limits/", "explanatory_text": "Under the Act, political committees, individuals and other entities that are not prohibited from making contributions (e.g., partnerships, sole proprietorships and certain LLCs) may contribute a maximumof $5,000 per calendar year to an SSF. 110.1(d).", "icon": "warning", "key": "exceeds_political_committee_calendar_year_limit", "label": "Receipt exceeds calendar year limit from Political Committees.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 109 },
                    "generic_exceeds_contribution": { "default_error_tier": 3, "error_message_subline": "", "explanatory_text": "The amount exceeds the applicable contribution limit. Please review the amount and the selected counterparty's limits.", "icon": "warning", "key": "generic_exceeds_contribution", "label": "Amount exceeds contribution limits.", "location": 107, "parent": 1, "suggested_solutions": "", "value": 9999 },
                    "incomplete_public_organization_information": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/filing-reports/individual-contributions/", "explanatory_text": "For each contribution that exceeds $200, either by itself or when added to the organization\u2019s previous contributions made during the same calendar year, records must identify each organization by address and name.", "icon": "warning", "key": "incomplete_public_organization_information", "label": "Incomplete Name or Address. Aggregate YTD exceeds $200. Additional information is required.", "location": 42, "parent": 5, "suggested_solutions": "", "value": 9 },
                    "incomplete_supporter_information": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/filing-reports/individual-contributions/", "explanatory_text": "This contributor is missing required information in their contact record.  The FEC requires full name, address, occupation and employer for contributors who gives more that $200 in a calendar year.", "icon": "warning", "key": "incomplete_supporter_information", "label": "Address, employer, or occupation incomplete", "location": 12, "parent": 4, "suggested_solutions": "", "value": 8 },
                    "public_org_prohibited_source": { "default_error_tier": 3, "error_message_subline": "", "explanatory_link": "https://www.fec.gov/help-candidates-and-committees/candidate-taking-receipts/who-can-and-cant-contribute/#:~:text=Federal%20law%20prohibits%20contributions%2C%20donations,%E2%80%94%20federal%2C%20state%20or%20local.", "explanatory_text": "If a committee treasurer deposits a contribution that appears to come from a prohibited source, he or shehas 30 days to: \u2022 Confirm the legality of the contribution; or \u2022 Refund the contribution. 103.3(b)(1).", "icon": "warning", "key": "public_org_prohibited_source", "label": "Potential receipt from a prohibited source - Corporation, Labor Org, or Federal Gov Contractor", "location": 42, "parent": 5, "suggested_solutions": "", "value": 10 },
                    "public_organization_duplicate": { "default_error_tier": 3, "error_message_subline": "", "explanatory_text": "", "icon": "warning", "key": "public_organization_duplicate", "label": "Organization Duplicate", "location": 42, "parent": 3, "suggested_solutions": "", "value": 2 },
                    "supporter_duplicate": { "default_error_tier": 3, "error_message_subline": "", "explanatory_text": "", "icon": "warning", "key": "supporter_duplicate", "label": "Contact Duplicate", "location": 12, "parent": 3, "suggested_solutions": "", "value": 1 }
                },
                "AccountStateErrorType": {
                    "__is_enum": true,
                    "duplicate": { "description": "", "fa5_icon": "object-ungroup", "key": "duplicate", "label": "Duplicate", "value": 3 },
                    "exceeds_limit": { "description": "A transaction has surpassed a limit given current totals for an account.", "fa5_icon": "draw-square", "key": "exceeds_limit", "label": "Limit", "value": 1 },
                    "exceeds_limit_for_filing": { "description": "The amount aggregated within a specific filing time interval has surpassed a CampaignFinanceLimit.", "fa5_icon": "dollar-sign", "key": "exceeds_limit_for_filing", "label": "Time Bucketed Filing Limit", "value": 9 },
                    "form_1": { "description": "", "fa5_icon": "dollar-sign", "key": "form_1", "label": "Form 1 Filing", "value": 7 },
                    "form_3x": { "description": "", "fa5_icon": "dollar-sign", "key": "form_3x", "label": "Form 3X Filing", "value": 6 },
                    "public_organization": { "description": "", "fa5_icon": "dollar-sign", "key": "public_organization", "label": "Organization", "value": 5 },
                    "supporter": { "description": "", "fa5_icon": "dollar-sign", "key": "supporter", "label": "Contact", "value": 4 },
                    "transaction": { "description": "", "fa5_icon": "dollar-sign", "key": "transaction", "label": "Transaction", "value": 2 }
                },
                "CurrencyType": {
                    "__is_enum": true,
                    "usd": { "divide_amount": 100, "key": "usd", "label": "USD", "symbol": "$", "value": 1 }
                },
                "ErrorTierType": {
                    "__is_enum": true,
                    "error": { "key": "error", "label": "Error", "value": 3 },
                    "exception": { "key": "exception", "label": "Exception", "value": 4 },
                    "info": { "key": "info", "label": "Info", "value": 1 },
                    "warning": { "key": "warning", "label": "Warning", "value": 2 }
                },
                "LedgerAccountType": {
                    "__is_enum": true,
                    "accidental_deposit": {
                        "active": false,
                        "donor_type": 1002,
                        "fec_form3x_line": 107,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "accidental_deposit",
                        "label": "Accidental Deposit",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2016
                    },
                    "allocated_activity": {
                        "active": true,
                        "fec_form3x_line": 109,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "allocated_activity",
                        "label": "Allocated Activity",
                        "meta_account_type": 3,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3001
                    },
                    "anonymous_contributions": {
                        "active": true,
                        "donor_type": 1003,
                        "fec_form3x_line": 101,
                        "form_donor_types": [1003],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "anonymous_contributions",
                        "label": "Anonymous Contributions",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 109,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2002
                    },
                    "ballot_measure_committee": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "ballot_measure_committee",
                        "label": "Ballot Measure Committee",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 210,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3051
                    },
                    "bank_and_card_fees": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [1013],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "bank_and_card_fees",
                        "label": "Bank & Credit Card Fees",
                        "meta_account_type": 3,
                        "order": 3,
                        "recipient_type": 1013,
                        "report_code_into_pacc": 291,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3005
                    },
                    "bank_interest_and_income": {
                        "active": true,
                        "donor_type": 1013,
                        "fec_form3x_line": 107,
                        "form_donor_types": [1013],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "bank_interest_and_income",
                        "label": "Bank Interest and Income",
                        "meta_account_type": 2,
                        "order": 0,
                        "recipient_type": 6,
                        "report_code_into_pacc": 160,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2011
                    },
                    "campaign_communication_consulting": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "campaign_communication_consulting",
                        "label": "Campaign Strategy & Communications Consulting",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3009
                    },
                    "charitable_contributions": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "charitable_contributions",
                        "label": "Charitable Contributions",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3025
                    },
                    "checking_account": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "checking_account",
                        "label": "Checking",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1001
                    },
                    "common_stock": {
                        "active": false,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "common_stock",
                        "label": "Common Stock",
                        "meta_account_type": 4,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 4001
                    },
                    "contributions_from_individuals": {
                        "active": true,
                        "donor_type": 1001,
                        "fec_form3x_line": 101,
                        "form_donor_types": [1001],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "contributions_from_individuals",
                        "label": "Contributions from Individuals",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3013,
                        "report_code_into_pacc": 101,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2001
                    },
                    "contributions_to_local_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [1011],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "contributions_to_local_pacs",
                        "label": "Contributions to Local PACs",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1011,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3022
                    },
                    "contributions_to_party_committees": {
                        "active": false,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [1008, 1009],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "contributions_to_party_committees",
                        "label": "Contributions to Party Committees (State/District/Local Party Committee - Federal)",
                        "meta_account_type": 3,
                        "order": 7,
                        "refund_account_type": 2021,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3031
                    },
                    "contributions_to_state_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [6],
                        "form_recipient_types": [30],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "contributions_to_state_party_committees",
                        "label": "Contribution to a State Political Party",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 30,
                        "refund_account_type": 2021,
                        "report_code_into_pacc": 207,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3020
                    },
                    "corporate_reimbursement": {
                        "active": true,
                        "donor_type": 1015,
                        "fec_form3x_line": 105,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "corporate_reimbursement",
                        "label": "Corporate Reimbursement of Administrative & Fundraising Expenses",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 120,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2006
                    },
                    "deposit": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "deposit",
                        "label": "Deposit",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 270,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3054
                    },
                    "disbursements_to_federal_candidates": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [1],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "disbursements_to_federal_candidates",
                        "label": "Contributions to Federal Candidates",
                        "meta_account_type": 3,
                        "order": 8,
                        "recipient_type": 1,
                        "refund_account_type": 2008,
                        "report_code_into_pacc": 201,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3011
                    },
                    "disbursements_to_federal_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 2, 3],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "disbursements_to_federal_pacs",
                        "label": "Contributions to Federal PACs",
                        "meta_account_type": 3,
                        "order": 1,
                        "recipient_type": 6,
                        "refund_account_type": 2003,
                        "report_code_into_pacc": 204,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3030
                    },
                    "disbursements_to_jfcs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [101],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_jfcs",
                        "label": "Contributions to Joint Fundraising Committees",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 101,
                        "refund_account_type": 2024,
                        "report_code_into_pacc": 161,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3036
                    },
                    "disbursements_to_local_candidates": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [41],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_local_candidates",
                        "label": "Contributions to Local Candidates",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 41,
                        "refund_account_type": 2020,
                        "report_code_into_pacc": 203,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3021
                    },
                    "disbursements_to_local_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [6],
                        "form_recipient_types": [40],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_local_party_committees",
                        "label": "Contribution to a Local Political Party",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 40,
                        "refund_account_type": 2051,
                        "report_code_into_pacc": 208,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3023
                    },
                    "disbursements_to_national_party_committee_special_accounts_for_election_recounts_and_contests": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [8],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_national_party_committee_special_accounts_for_election_recounts_and_contests",
                        "label": "Contributions to National Party Committee Special Accounts for Election Recounts, Contests, and Other Legal Proceedings",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 8,
                        "refund_account_type": 2026,
                        "report_code_into_pacc": 206,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3038
                    },
                    "disbursements_to_national_party_committee_special_accounts_for_headquarters_buildings": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [9],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_national_party_committee_special_accounts_for_headquarters_buildings",
                        "label": "Contributions to National Party Committee Special Accounts for National Party Headquarters Buildings",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 9,
                        "refund_account_type": 2027,
                        "report_code_into_pacc": 206,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3039
                    },
                    "disbursements_to_national_party_committee_special_accounts_for_presidential_nominating_convention": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [7],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_national_party_committee_special_accounts_for_presidential_nominating_convention",
                        "label": "Contributions to National Party Committee Special Accounts for Presidential Nominating Convention",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 7,
                        "refund_account_type": 2025,
                        "report_code_into_pacc": 206,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3037
                    },
                    "disbursements_to_national_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [5],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "disbursements_to_national_party_committees",
                        "label": "Contributions to National Party Committees",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 5,
                        "refund_account_type": 2022,
                        "report_code_into_pacc": 206,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3032
                    },
                    "disbursements_to_other_527_orgs": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_other_527_orgs",
                        "label": "Contributions to Other 527 Organizations",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "refund_account_type": 2900,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3024
                    },
                    "disbursements_to_state_candidates": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [31],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_state_candidates",
                        "label": "Contributions to State Candidates",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 31,
                        "refund_account_type": 2009,
                        "report_code_into_pacc": 202,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3018
                    },
                    "disbursements_to_state_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [32],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "disbursements_to_state_pacs",
                        "label": "Contributions to State PACs",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 32,
                        "refund_account_type": 2019,
                        "report_code_into_pacc": 205,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3019
                    },
                    "disbursements_to_state_party_committees_fed_accounts": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 112,
                        "form_donor_types": [],
                        "form_recipient_types": [33],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "disbursements_to_state_party_committees_fed_accounts",
                        "label": "Contributions to State Party Committee Federal Accounts",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 33,
                        "refund_account_type": 3064,
                        "report_code_into_pacc": 206,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3065
                    },
                    "event_expenses": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "event_expenses",
                        "label": "Administrative Event Expenses & Food",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3004
                    },
                    "in_kind_attributions_asset": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": true,
                        "is_primary": false,
                        "key": "in_kind_attributions_asset",
                        "label": "In-Kind Attributions Asset",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1007
                    },
                    "in_kind_contributions_disbursement": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "in_kind_contributions_disbursement",
                        "label": "Inkind Contributions (Non-Monetary)",
                        "meta_account_type": 3,
                        "order": 1000,
                        "refund_account_type": 2043,
                        "report_code_into_pacc": 209,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3049
                    },
                    "in_kind_contributions_receipt": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "in_kind_contributions_receipt",
                        "label": "Inkind Contributions (Non-Monetary)",
                        "meta_account_type": 3,
                        "order": 1000,
                        "refund_account_type": 2043,
                        "report_code_into_pacc": 108,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3050
                    },
                    "in_kind_expenses": {
                        "active": true,
                        "expense_type": 10,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "in_kind_expenses",
                        "label": "In-Kind Expenses",
                        "meta_account_type": 3,
                        "order": 31,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3035
                    },
                    "income_tax_expenses": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "income_tax_expenses",
                        "label": "Income Tax Expenses",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3006
                    },
                    "independent_expenditures": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 36,
                        "fec_form3x_line": 113,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "independent_expenditures",
                        "label": "Independent Expenditures",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "report_code_into_pacc": 240,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3012
                    },
                    "irs_527_disbursement": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "irs_527_disbursement",
                        "label": "IRS 527 Disbursement",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 298,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3058
                    },
                    "irs_527_receipt": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "irs_527_receipt",
                        "label": "IRS 527 Receipt",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 198,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2052
                    },
                    "jfc_attributions_asset": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": true,
                        "is_primary": false,
                        "key": "jfc_attributions_asset",
                        "label": "JFC Attributions Asset",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1006
                    },
                    "joint_federal_non_federal_expenditures": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "joint_federal_non_federal_expenditures",
                        "label": "Joint Federal / Non-Federal Expenditures",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 280,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3055
                    },
                    "joint_non_federal_share": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "joint_non_federal_share",
                        "label": "Joint Non-Federal Share",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 281,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3056
                    },
                    "loan_repayments_made": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "loan_repayments_made",
                        "label": "Loan Repayments Made",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "report_code_into_pacc": 251,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3048
                    },
                    "loan_repayments_received": {
                        "active": true,
                        "donor_type": 1013,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "loan_repayments_received",
                        "label": "Loan Repayments Received",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 151,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2038
                    },
                    "loans": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "loans",
                        "label": "Loans",
                        "meta_account_type": 5,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 5001
                    },
                    "loans_made": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "loans_made",
                        "label": "Loans Made",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "report_code_into_pacc": 250,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3047
                    },
                    "loans_received": {
                        "active": true,
                        "donor_type": 1013,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "loans_received",
                        "label": "Loans Received",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 150,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2037
                    },
                    "misc_expenses": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "misc_expenses",
                        "label": "Misc. Expenses",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3028
                    },
                    "non_aggregated_receipt": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "non_aggregated_receipt",
                        "label": "Non Aggregated Receipt",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 197,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2050
                    },
                    "non_reporting_disbursement_to_organizations": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [1020, 1023, 1022, 1018, 1016, 1021, 1014, 1019, 100000, 1012],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "non_reporting_disbursement_to_organizations",
                        "label": "Non Reporting Disbursement to Organization",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "refund_account_type": 2075,
                        "report_code_into_pacc": 299,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 2073
                    },
                    "non_reporting_disbursement_to_political_committees": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [102, 1, 6, 103, 101, 41, 40, 2, 5, 8, 9, 7, 3, 31, 32, 30, 33, 100, 100000],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "non_reporting_disbursement_to_political_committees",
                        "label": "Non Reporting Disbursement to Political Committee",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1004,
                        "refund_account_type": 2076,
                        "report_code_into_pacc": 299,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 2074
                    },
                    "non_reporting_receipt_to_organizations": {
                        "active": true,
                        "donor_type": 1002,
                        "form_donor_types": [1020, 1023, 1022, 1018, 1016, 1021, 1014, 1019, 100000, 1012],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "non_reporting_receipt_to_organizations",
                        "label": "Non Reporting Receipt from Organization",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 2078,
                        "report_code_into_pacc": 199,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2039
                    },
                    "non_reporting_receipt_to_political_committees": {
                        "active": true,
                        "donor_type": 1004,
                        "form_donor_types": [102, 1, 6, 103, 101, 41, 40, 2, 5, 8, 9, 7, 3, 31, 32, 30, 33, 100, 100000],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "non_reporting_receipt_to_political_committees",
                        "label": "Non Reporting Receipt from Political Committee",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 2077,
                        "report_code_into_pacc": 199,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2044
                    },
                    "offsets_to_operating_expenditures": {
                        "active": true,
                        "donor_type": 1002,
                        "fec_form3x_line": 105,
                        "form_donor_types": [1002, 1015, 1016, 1012, 1017],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "offsets_to_operating_expenditures",
                        "label": "Offsets to Operating Expenditures",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 190,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2023
                    },
                    "other_assets": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "other_assets",
                        "label": "Other Asset",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1005
                    },
                    "other_disbursements": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [1002, 1015, 1016, 1012, 1017, 1020, 1023, 1018, 1021],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "other_disbursements",
                        "label": "Other Disbursements",
                        "meta_account_type": 3,
                        "order": 20,
                        "recipient_type": 1002,
                        "refund_account_type": 2900,
                        "report_code_into_pacc": 290,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3014
                    },
                    "other_disbursements_for_individuals": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [1001],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "other_disbursements_for_individuals",
                        "label": "Other Disbursements to Individuals",
                        "meta_account_type": 3,
                        "order": 21,
                        "recipient_type": 1001,
                        "report_code_into_pacc": 290,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3015
                    },
                    "other_federal_operating_expenditures": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [1002, 1015, 1016, 1012, 1017],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "other_federal_operating_expenditures",
                        "label": "Other Federal Operating Expenditures",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "report_code_into_pacc": 291,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3002
                    },
                    "other_liabilities": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "other_liabilities",
                        "label": "Other Liabilities",
                        "meta_account_type": 5,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 5002
                    },
                    "other_receipts": {
                        "active": true,
                        "donor_type": 1002,
                        "fec_form3x_line": 107,
                        "form_donor_types": [1002, 1015, 1016, 1012, 1017, 1020, 1023, 1018, 1021, 1013],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": true,
                        "key": "other_receipts",
                        "label": "Other Receipts",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 190,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2010
                    },
                    "other_refunds": {
                        "active": true,
                        "donor_type": 1002,
                        "fec_form3x_line": 105,
                        "form_donor_types": [1002, 1015, 1016, 1012, 1017],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "other_refunds",
                        "label": "Other Refunds",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 120,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2900
                    },
                    "other_surplus_funds_paid_out": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "other_surplus_funds_paid_out",
                        "label": "Other Surplus Funds Paid Out",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 292,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 3057
                    },
                    "outstanding_receipts": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "outstanding_receipts",
                        "label": "Outstanding Receipts",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1004
                    },
                    "printing_publication_postage": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "printing_publication_postage",
                        "label": "Printing, Publications, & Postage",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3008
                    },
                    "receipts_from_corporations": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_corporations",
                        "label": "Contributions from Corporations",
                        "meta_account_type": 2,
                        "order": 1000,
                        "refund_account_type": 3052,
                        "report_code_into_pacc": 104,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2029
                    },
                    "receipts_from_federal_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 103,
                        "form_donor_types": [6, 2, 3],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_federal_pacs",
                        "label": "Contributions from Federal PACs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3029,
                        "report_code_into_pacc": 102,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2004
                    },
                    "receipts_from_fundraisers": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_fundraisers",
                        "label": "Receipts from Fundraisers",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 191,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2046
                    },
                    "receipts_from_labor_unions": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_labor_unions",
                        "label": "Contributions from Labor Unions",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 110,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2041
                    },
                    "receipts_from_limited_liability_corporations": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_limited_liability_corporations",
                        "label": "Contributions from Limited Liability Corporations",
                        "meta_account_type": 2,
                        "order": 1000,
                        "refund_account_type": 3063,
                        "report_code_into_pacc": 112,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2042
                    },
                    "receipts_from_limited_liability_partnerships": {
                        "active": true,
                        "donor_type": 1018,
                        "fec_form3x_line": 101,
                        "form_donor_types": [1018],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_limited_liability_partnerships",
                        "label": "Contribution from Limited Liability Partnerships",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3045,
                        "report_code_into_pacc": 113,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2034
                    },
                    "receipts_from_local_party_committees": {
                        "active": true,
                        "donor_type": 40,
                        "form_donor_types": [40],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_local_party_committees",
                        "label": "Contribution from Local Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3033,
                        "report_code_into_pacc": 107,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2031
                    },
                    "receipts_from_national_party_committees": {
                        "active": true,
                        "donor_type": 5,
                        "form_donor_types": [5],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_national_party_committees",
                        "label": "Contributions from National Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3042,
                        "report_code_into_pacc": 105,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2032
                    },
                    "receipts_from_other_pacs": {
                        "active": true,
                        "donor_type": 100000,
                        "fec_form3x_line": 103,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_other_pacs",
                        "label": "Contributions from Other Political Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3044,
                        "report_code_into_pacc": 115,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2040
                    },
                    "receipts_from_partnerships": {
                        "active": true,
                        "donor_type": 1014,
                        "fec_form3x_line": 101,
                        "form_donor_types": [1014],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_partnerships",
                        "label": "Contributions from Partnerships",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3043,
                        "report_code_into_pacc": 111,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2033
                    },
                    "receipts_from_political_clubs": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_political_clubs",
                        "label": "Contributions from Political Clubs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 192,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2048
                    },
                    "receipts_from_sole_proprietorships": {
                        "active": true,
                        "donor_type": 1019,
                        "fec_form3x_line": 101,
                        "form_donor_types": [1019],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_sole_proprietorships",
                        "label": "Contributions from Sole Proprietorships",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3046,
                        "report_code_into_pacc": 114,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2035
                    },
                    "receipts_from_state_pacs": {
                        "active": true,
                        "donor_type": 32,
                        "fec_form3x_line": 103,
                        "form_donor_types": [32],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_state_pacs",
                        "label": "Contributions from state PACs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3040,
                        "report_code_into_pacc": 103,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2028
                    },
                    "receipts_from_state_party_committees": {
                        "active": true,
                        "donor_type": 30,
                        "form_donor_types": [30],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_state_party_committees",
                        "label": "Contributions from State Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3053,
                        "report_code_into_pacc": 106,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2030
                    },
                    "receipts_from_state_party_committees_fed_accounts": {
                        "active": true,
                        "donor_type": 33,
                        "form_donor_types": [33],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "receipts_from_state_party_committees_fed_accounts",
                        "label": "Contributions from State Party Committee Federal Accounts",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "refund_account_type": 3066,
                        "report_code_into_pacc": 105,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 3067
                    },
                    "refund_of_deposit": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refund_of_deposit",
                        "label": "Refund of Deposit",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 180,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2045
                    },
                    "refunds_of_contributions_from_individuals": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 114,
                        "form_donor_types": [],
                        "form_recipient_types": [1001],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_contributions_from_individuals",
                        "label": "Refunds of Contributions from Individuals",
                        "meta_account_type": 3,
                        "order": 10,
                        "recipient_type": 1001,
                        "report_code_into_pacc": 211,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give back to Individuals",
                        "transaction_type": 3,
                        "value": 3013
                    },
                    "refunds_of_contributions_from_party_committees": {
                        "active": false,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 115,
                        "form_donor_types": [],
                        "form_recipient_types": [1008, 1009],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_contributions_from_party_committees",
                        "label": "Refunds of Contributions from Party Committees (State/District/Local Party Committee - Federal)",
                        "meta_account_type": 3,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give to Party Committees (State/District/Local Party Committee - Federal)",
                        "transaction_type": 3,
                        "value": 3034
                    },
                    "refunds_of_disbursements_to_federal_candidates": {
                        "active": true,
                        "donor_type": 1,
                        "fec_form3x_line": 106,
                        "form_donor_types": [1],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_federal_candidates",
                        "label": "Refunds of Contributions Made to Federal Candidates",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 121,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2008
                    },
                    "refunds_of_disbursements_to_federal_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 106,
                        "form_donor_types": [6, 2, 3],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_federal_pacs",
                        "label": "Refunds of Contributions Made to Federal PACs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 124,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2003
                    },
                    "refunds_of_disbursements_to_jfcs": {
                        "active": true,
                        "donor_type": 101,
                        "fec_form3x_line": 106,
                        "form_donor_types": [101],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_jfcs",
                        "label": "Refunds of Contributions Made to Joint Fundraising Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 261,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2024
                    },
                    "refunds_of_disbursements_to_local_candidates": {
                        "active": true,
                        "donor_type": 41,
                        "fec_form3x_line": 106,
                        "form_donor_types": [41],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_local_candidates",
                        "label": "Refunds of Contributions Made to Local Candidates",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 123,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2020
                    },
                    "refunds_of_disbursements_to_local_party_committees": {
                        "active": true,
                        "donor_type": 1009,
                        "fec_form3x_line": 106,
                        "form_donor_types": [1009],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_local_party_committees",
                        "label": "Refunds of Contributions Made to Local Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 128,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds the the PAC receives for money given to Local Party Committees",
                        "transaction_type": 4,
                        "value": 2051
                    },
                    "refunds_of_disbursements_to_national_party_committee_special_accounts_for_election_recounts_and_contests": {
                        "active": true,
                        "donor_type": 8,
                        "fec_form3x_line": 106,
                        "form_donor_types": [8],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_national_party_committee_special_accounts_for_election_recounts_and_contests",
                        "label": "Refunds of Contributions Made to National Party Committee Special Accounts for Election Recounts, Contests, and Other Legal Proceedings",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2026
                    },
                    "refunds_of_disbursements_to_national_party_committee_special_accounts_for_headquarters_buildings": {
                        "active": true,
                        "donor_type": 9,
                        "fec_form3x_line": 106,
                        "form_donor_types": [9],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_national_party_committee_special_accounts_for_headquarters_buildings",
                        "label": "Refunds of Contributions Made to National Party Committee Special Accounts for National Party Headquarters Buildings",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2027
                    },
                    "refunds_of_disbursements_to_national_party_committee_special_accounts_for_presidential_nominating_convention": {
                        "active": true,
                        "donor_type": 7,
                        "fec_form3x_line": 106,
                        "form_donor_types": [7],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_national_party_committee_special_accounts_for_presidential_nominating_convention",
                        "label": "Refunds of Contributions Made to National Party Committee Special Accounts for Presidential Nominating Convention",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2025
                    },
                    "refunds_of_disbursements_to_national_party_committees": {
                        "active": true,
                        "donor_type": 5,
                        "fec_form3x_line": 106,
                        "form_donor_types": [5],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_national_party_committees",
                        "label": "Refunds of Contributions Made to National Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 126,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2022
                    },
                    "refunds_of_disbursements_to_state_candidates": {
                        "active": true,
                        "donor_type": 31,
                        "fec_form3x_line": 106,
                        "form_donor_types": [31],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_state_candidates",
                        "label": "Refunds of Contributions Made to State Candidates",
                        "meta_account_type": 2,
                        "order": 100,
                        "recipient_type": 6,
                        "report_code_into_pacc": 122,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2009
                    },
                    "refunds_of_disbursements_to_state_pacs": {
                        "active": true,
                        "donor_type": 32,
                        "fec_form3x_line": 106,
                        "form_donor_types": [32],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_state_pacs",
                        "label": "Refunds of Contributions Made to State PACs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 125,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2019
                    },
                    "refunds_of_disbursements_to_state_party_committees": {
                        "active": true,
                        "donor_type": 30,
                        "fec_form3x_line": 106,
                        "form_donor_types": [30],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_state_party_committees",
                        "label": "Refunds of Contributions Made to State Party Committees",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 127,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds the the PAC receives for money given to State Party Committees",
                        "transaction_type": 4,
                        "value": 2021
                    },
                    "refunds_of_disbursements_to_state_party_committees_fed_accounts": {
                        "active": true,
                        "donor_type": 33,
                        "fec_form3x_line": 106,
                        "form_donor_types": [33],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_disbursements_to_state_party_committees_fed_accounts",
                        "label": "Refunds of Contributions Made to State Party Committee Federal Accounts",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 126,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 3064
                    },
                    "refunds_of_in_kind_contributions": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_in_kind_contributions",
                        "label": "Refunds of Inkind Contributions (Non-Monetary)",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 129,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2043
                    },
                    "refunds_of_inkind_receipts": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_inkind_receipts",
                        "label": "Refunds of Inkind Receipts (Non-Monetary)",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 218,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3061
                    },
                    "refunds_of_non_reporting_disbursement_to_organizations": {
                        "active": true,
                        "donor_type": 1002,
                        "form_donor_types": [1020, 1023, 1022, 1018, 1016, 1021, 1014, 1019, 100000, 1012],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_non_reporting_disbursement_to_organizations",
                        "label": "Refunds of Non Reporting Disbursement to Organization",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 199,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2075
                    },
                    "refunds_of_non_reporting_disbursement_to_political_committees": {
                        "active": true,
                        "donor_type": 1004,
                        "form_donor_types": [102, 1, 6, 103, 101, 41, 40, 2, 5, 8, 9, 7, 3, 31, 32, 30, 33, 100, 100000],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_non_reporting_disbursement_to_political_committees",
                        "label": "Refunds of Non Reporting Disbursement to Political Committee",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 199,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2076
                    },
                    "refunds_of_non_reporting_receipt_to_organizations": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [1020, 1023, 1022, 1018, 1016, 1021, 1014, 1019, 100000, 1012],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_non_reporting_receipt_to_organizations",
                        "label": "Refunds of Non Reporting Receipt to Organization",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "report_code_into_pacc": 299,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 2078
                    },
                    "refunds_of_non_reporting_receipt_to_political_committees": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [102, 1, 6, 103, 101, 41, 40, 2, 5, 8, 9, 7, 3, 31, 32, 30, 33, 100, 100000],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_non_reporting_receipt_to_political_committees",
                        "label": "Refunds of Non Reporting Receipt to Political Committee",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1004,
                        "report_code_into_pacc": 299,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 2077
                    },
                    "refunds_of_receipts_from_corporations": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_corporations",
                        "label": "Refunds of Contributions from Corporations",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 214,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3052
                    },
                    "refunds_of_receipts_from_federal_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 116,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 2, 3],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_federal_pacs",
                        "label": "Refunds of Contributions from Federal PACs",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 212,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give to Federal PACs",
                        "transaction_type": 3,
                        "value": 3029
                    },
                    "refunds_of_receipts_from_labor_unions": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_labor_unions",
                        "label": "Refunds of Contributions from Labor Organizations",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 220,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3062
                    },
                    "refunds_of_receipts_from_limited_liability_corporations": {
                        "active": true,
                        "donor_type": 6,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_limited_liability_corporations",
                        "label": "Refunds of Contributions from Limited Liability Corporations",
                        "meta_account_type": 3,
                        "order": 1000,
                        "report_code_into_pacc": 222,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3063
                    },
                    "refunds_of_receipts_from_limited_liability_partnerships": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 114,
                        "form_donor_types": [],
                        "form_recipient_types": [1018],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_limited_liability_partnerships",
                        "label": "Refunds of Contributions from Limited Liability Partnerships",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1018,
                        "report_code_into_pacc": 223,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3045
                    },
                    "refunds_of_receipts_from_local_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 115,
                        "form_donor_types": [],
                        "form_recipient_types": [40],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_local_party_committees",
                        "label": "Refund of a Contribution to a Local Political Party",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 40,
                        "report_code_into_pacc": 217,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give to Local Political Parties",
                        "transaction_type": 3,
                        "value": 3033
                    },
                    "refunds_of_receipts_from_national_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 115,
                        "form_donor_types": [],
                        "form_recipient_types": [5],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_national_party_committees",
                        "label": "Refunds of Contributions from National Party Committees",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 5,
                        "report_code_into_pacc": 215,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3042
                    },
                    "refunds_of_receipts_from_other_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 116,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 2, 3],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_other_pacs",
                        "label": "Refunds of Contributions from Other PACs",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 225,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3044
                    },
                    "refunds_of_receipts_from_partnerships": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 114,
                        "form_donor_types": [],
                        "form_recipient_types": [1014],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_partnerships",
                        "label": "Refunds of Contributions from Partnerships",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1014,
                        "report_code_into_pacc": 221,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3043
                    },
                    "refunds_of_receipts_from_sole_proprietorships": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 114,
                        "form_donor_types": [],
                        "form_recipient_types": [1019],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_sole_proprietorships",
                        "label": "Refunds of Contributions from Sole Proprietorships",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1019,
                        "report_code_into_pacc": 224,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3046
                    },
                    "refunds_of_receipts_from_state_pacs": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 116,
                        "form_donor_types": [],
                        "form_recipient_types": [32],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_state_pacs",
                        "label": "Refunds of Contributions from State PACs",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 32,
                        "report_code_into_pacc": 213,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give to State PACs",
                        "transaction_type": 3,
                        "value": 3040
                    },
                    "refunds_of_receipts_from_state_party_committees": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 115,
                        "form_donor_types": [],
                        "form_recipient_types": [30],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_state_party_committees",
                        "label": "Refunds of Contributions from State Party Committees",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 30,
                        "report_code_into_pacc": 216,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "This account represents refunds that the PAC will give to State Party Committees",
                        "transaction_type": 3,
                        "value": 3053
                    },
                    "refunds_of_receipts_from_state_party_committees_fed_accounts": {
                        "active": true,
                        "donor_type": 6,
                        "expense_type": 35,
                        "fec_form3x_line": 115,
                        "form_donor_types": [],
                        "form_recipient_types": [33],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_of_receipts_from_state_party_committees_fed_accounts",
                        "label": "Refund of Contributions from State Party Committee Federal Accounts",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 33,
                        "report_code_into_pacc": 215,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 3,
                        "value": 3066
                    },
                    "refunds_received_for_establishment_costs": {
                        "active": true,
                        "donor_type": 1002,
                        "fec_form3x_line": 105,
                        "form_donor_types": [1016],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "refunds_received_for_establishment_costs",
                        "label": "Refunds Received for Establishment Costs",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 181,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2901
                    },
                    "rent_and_utilities": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "rent_and_utilities",
                        "label": "Rent & Utilities",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3027
                    },
                    "retained_earnings": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "retained_earnings",
                        "label": "Retained Earnings",
                        "meta_account_type": 4,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 4002
                    },
                    "salaries_compensations_benefits": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "salaries_compensations_benefits",
                        "label": "Salaries, Other Compensation, & Benefits",
                        "meta_account_type": 3,
                        "order": 30,
                        "recipient_type": 1001,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3026
                    },
                    "savings_account": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "savings_account",
                        "label": "Savings",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1002
                    },
                    "services": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "services",
                        "label": "Accountants, Compliance, & Legal Services",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3003
                    },
                    "software_expenses": {
                        "active": false,
                        "donor_type": 6,
                        "fec_form3x_line": 110,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "software_expenses",
                        "label": "Software Expenses",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1002,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3007
                    },
                    "stripe_virtual_account": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "stripe_virtual_account",
                        "label": "Stripe Virtual Account",
                        "meta_account_type": 1,
                        "order": 1000,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1003
                    },
                    "ticket_sales": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "ticket_sales",
                        "label": "Ticket Sales",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 194,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2049
                    },
                    "transfers_from_affiliated_committees": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 104,
                        "form_donor_types": [6, 2, 3],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": true,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_from_affiliated_committees",
                        "label": "Transfers from Affiliated Committees",
                        "meta_account_type": 2,
                        "order": 110,
                        "recipient_type": 6,
                        "report_code_into_pacc": 132,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2005
                    },
                    "transfers_from_internal_accounts": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 1013],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_from_internal_accounts",
                        "label": "Transfers from Internal Accounts",
                        "meta_account_type": 1,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 131,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "value": 1008
                    },
                    "transfers_from_nonfederal_account_for_joint_activity": {
                        "active": true,
                        "fec_form3x_line": 108,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_from_nonfederal_account_for_joint_activity",
                        "label": "Transfers from Non-Federal Account for Joint Activity",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 130,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2012
                    },
                    "transfers_from_parent_organizations": {
                        "active": true,
                        "donor_type": 1015,
                        "fec_form3x_line": 107,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 1021],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_from_parent_organizations",
                        "label": "Transfers from Parent Organizations",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 134,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": true,
                        "tooltip": "",
                        "transaction_type": 1,
                        "value": 2036
                    },
                    "transfers_out": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 117,
                        "form_donor_types": [6, 1021],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_out",
                        "label": "Transfers Out",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 238,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 2067
                    },
                    "transfers_to_a_succeeding_election": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_to_a_succeeding_election",
                        "label": "Transfers to a Succeeding Election",
                        "meta_account_type": 2,
                        "order": 1000,
                        "report_code_into_pacc": 232,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 2066
                    },
                    "transfers_to_affiliated_committees": {
                        "active": true,
                        "donor_type": 6,
                        "fec_form3x_line": 111,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 2, 3],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": true,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_to_affiliated_committees",
                        "label": "Transfers to Affiliated Committees",
                        "meta_account_type": 3,
                        "order": 1000,
                        "recipient_type": 1005,
                        "report_code_into_pacc": 230,
                        "show_in_enumeration": true,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 2,
                        "value": 3010
                    },
                    "transfers_to_internal_accounts": {
                        "active": true,
                        "form_donor_types": [],
                        "form_recipient_types": [6, 1013],
                        "has_csc_without_limits": false,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "transfers_to_internal_accounts",
                        "label": "Transfers to Internal Accounts",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 231,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 5,
                        "value": 2065
                    },
                    "vendor_refunds": {
                        "active": false,
                        "donor_type": 1012,
                        "fec_form3x_line": 105,
                        "form_donor_types": [1012],
                        "form_recipient_types": [],
                        "has_csc_without_limits": true,
                        "is_affiliated_committee_account_type": false,
                        "is_attribution_asset_account_type": false,
                        "is_primary": false,
                        "key": "vendor_refunds",
                        "label": "Refunds of Payments Made to Vendors",
                        "meta_account_type": 2,
                        "order": 1000,
                        "recipient_type": 6,
                        "report_code_into_pacc": 120,
                        "show_in_enumeration": false,
                        "subject_to_qpac_contribution_limits": false,
                        "tooltip": "",
                        "transaction_type": 4,
                        "value": 2007
                    }
                },
                "LedgerSettingsAgentType": {
                    "__is_enum": true,
                    "assistant_treasurer": { "key": "assistant_treasurer", "label": "Assistant Treasurer", "value": 11 },
                    "bookkeeper": { "key": "bookkeeper", "label": "Bookkeeper", "value": 40 },
                    "chairman": { "key": "chairman", "label": "Chairman", "value": 50 },
                    "custodian_of_records": { "key": "custodian_of_records", "label": "Custodian of Records", "value": 30 },
                    "designated_agent": { "key": "designated_agent", "label": "Designated Agent", "value": 20 },
                    "treasurer": { "key": "treasurer", "label": "Treasurer", "value": 10 }
                },
                "LedgerType": {
                    "__is_enum": true,
                    "nonprofit": { "key": "nonprofit", "label": "Nonprofit", "value": 2 },
                    "pac": { "key": "pac", "label": "PAC", "value": 1 }
                },
                "MetaAccountType": {
                    "__is_enum": true,
                    "asset": { "credit_sum_factor": -1, "debit_sum_factor": 1, "key": "asset", "label": "Asset", "value": 1 },
                    "equity": { "credit_sum_factor": 1, "debit_sum_factor": -1, "key": "equity", "label": "Equity", "value": 4 },
                    "expense": { "credit_sum_factor": -1, "debit_sum_factor": 1, "key": "expense", "label": "Expense", "value": 3 },
                    "liability": { "credit_sum_factor": 1, "debit_sum_factor": -1, "key": "liability", "label": "Liability", "value": 5 },
                    "revenue": { "credit_sum_factor": 1, "debit_sum_factor": -1, "key": "revenue", "label": "Revenue", "value": 2 }
                },
                "PACCTransactionWarningKeys": {
                    "__is_enum": true,
                    "already_filed": { "key": "already_filed", "label": "One Or More Election Compliance Reports Have Already Been Filed For This Period. Be aware that you MAY be required to re-submit subsequent filings.", "value": 1 },
                    "chk_num_in_use": { "key": "chk_num_in_use", "label": "Check Number <xxxxxx> Is Already In Use", "value": 5 },
                    "event_already_linked": { "key": "event_already_linked", "label": "The Selected Event Is Already Linked To A Disbursement. This Disbursement Will Now Become Linked Instead.", "value": 3 },
                    "exceeds_budget": { "key": "exceeds_budget", "label": "Transaction Exceeds Budget of xxx. Based on past disbursements the amount cannot be greater than <$xxx.xx>.", "value": 6 },
                    "exceeds_pledge": { "key": "exceeds_pledge", "label": "Transaction Exceeds Pledge of <$xxx.xx>. Based on past receipts the amount cannot be greater than <$xxx.xx>", "value": 7 },
                    "insufficient_balance": { "key": "insufficient_balance", "label": "The Individual Selected Does Not Have A Sufficient Available Balance To Cover This Disbursement.", "value": 4 },
                    "nc_anon": { "key": "nc_anon", "label": "Anonymous Contributions are not permitted in North Carolina...", "value": 2 },
                    "ok_pac_to_pac": { "key": "ok_pac_to_pac", "label": "In an Oklahoma PAC, for transactions dated between July 1, 2008 and December 31, 2014, a PAC is prohibited from making a contribution...", "value": 8 }
                },
                "PayrollFrequencyType": {
                    "__is_enum": true,
                    "bi_weekly": { "code": "B", "cycles_per_year": 26, "help_text": "A pay cycle occurs the first Friday and every other following Friday of the year", "key": "bi_weekly", "label": "Bi-Weekly", "value": 1 },
                    "monthly": { "code": "M", "cycles_per_year": 12, "help_text": "A pay cycle occurs on the 1st of each month or the following Monday if the 1st is a weekend", "key": "monthly", "label": "Monthly", "value": 4 },
                    "semi_monthly": { "code": "S", "cycles_per_year": 24, "help_text": "A pay cycle occurs on the 1st and 15th of each month or closest weekday within the month if either are weekends", "key": "semi_monthly", "label": "Semi-Monthly", "value": 5 },
                    "weekly": { "code": "W", "cycles_per_year": 52, "help_text": "A pay cycle occurs every Friday in the year", "key": "weekly", "label": "Weekly", "value": 3 }
                },
                "PlaidTransactionType": {
                    "__is_enum": true,
                    "digital": { "key": "digital", "label": "Digital", "value": 1 },
                    "place": { "key": "place", "label": "Place", "value": 2 }
                },
                "ReportingJurisdictionType": {
                    "__is_enum": true,
                    "alabama": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": true,
                        "is_amendable": true,
                        "key": "alabama",
                        "label": "Alabama",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "AL",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "form2": true, "form3": true, "form4": true, "form5": true, "summaryPage": true },
                        "region": 2,
                        "value": 2
                    },
                    "alaska": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "alaska",
                        "label": "Alaska",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "AK",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 3,
                        "value": 3
                    },
                    "arizona": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": true,
                        "is_amendable": true,
                        "key": "arizona",
                        "label": "Arizona",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "AZ",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "cover_sheet": true, "schedule_a": true, "schedule_a1": true, "schedule_b": true, "schedule_c1": true, "schedule_c2": true, "schedule_c2_end_page": 0, "schedule_c2_start_page": 0, "schedule_c3a": true, "schedule_c3b": true, "schedule_c3c": true, "schedule_c4a": true, "schedule_c4b": true, "schedule_c4c": true, "schedule_c5": true, "schedule_c5a": true, "schedule_c8": true, "schedule_d": true, "schedule_d1": true, "schedule_d2": true, "schedule_d3": true, "schedule_d5": true, "schedule_d6": true, "schedule_d7": true, "schedule_e": true, "schedule_e1": true, "schedule_e2a": true, "schedule_e2b": true, "schedule_e2c": true, "schedule_e3a": true, "schedule_e3b": true, "schedule_e3c": true, "schedule_e3d": true, "schedule_e3e": true, "schedule_e3f": true, "schedule_e4": true, "schedule_f1": true, "schedule_f2": true, "schedule_l1": true, "schedule_l2": true, "schedule_r1": true, "schedule_t1": true, "summary_page": true },
                        "region": 4,
                        "value": 4
                    },
                    "arkansas": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "arkansas",
                        "label": "Arkansas",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "AR",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 5,
                        "value": 5
                    },
                    "california": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "california",
                        "label": "California",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "CA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 6,
                        "value": 6
                    },
                    "colorado": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "colorado",
                        "label": "Colorado",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "CO",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 7,
                        "value": 7
                    },
                    "connecticut": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "connecticut",
                        "label": "Connecticut",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "CT",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 8,
                        "value": 8
                    },
                    "delaware": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "delaware",
                        "label": "Delaware",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "DE",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 9,
                        "value": 9
                    },
                    "district_of_columbia": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "district_of_columbia",
                        "label": "District of Columbia",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "DC",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 10,
                        "value": 10
                    },
                    "federal": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": true,
                        "key": "federal",
                        "label": "Federal",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "US",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 1,
                        "value": 1
                    },
                    "florida": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "florida",
                        "label": "Florida",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "FL",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 11,
                        "value": 11
                    },
                    "georgia": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "georgia",
                        "label": "Georgia",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "GA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "contributions_received": true, "expenditures": true, "investments": true, "loans": true },
                        "region": 12,
                        "value": 12
                    },
                    "hawaii": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "hawaii",
                        "label": "Hawaii",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "HI",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 13,
                        "value": 13
                    },
                    "idaho": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "idaho",
                        "label": "Idaho",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "ID",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 14,
                        "value": 14
                    },
                    "illinois": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "illinois",
                        "label": "Illinois",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "IL",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 15,
                        "value": 15
                    },
                    "indiana": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "indiana",
                        "label": "Indiana",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "IN",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 16,
                        "value": 16
                    },
                    "iowa": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "iowa",
                        "label": "Iowa",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "IA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 17,
                        "value": 17
                    },
                    "irs": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "irs",
                        "label": "Internal Revenue Service",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "IR",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "value": 5000
                    },
                    "kansas": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "kansas",
                        "label": "Kansas",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "KS",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 18,
                        "value": 18
                    },
                    "kentucky": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "kentucky",
                        "label": "Kentucky",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "KY",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 19,
                        "value": 19
                    },
                    "louisiana": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "louisiana",
                        "label": "Louisiana",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "LA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 20,
                        "value": 20
                    },
                    "maine": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "maine",
                        "label": "Maine",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "ME",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 21,
                        "value": 21
                    },
                    "maryland": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "maryland",
                        "label": "Maryland",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MD",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 22,
                        "value": 22
                    },
                    "massachusetts": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "massachusetts",
                        "label": "Massachusetts",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 23,
                        "value": 23
                    },
                    "michigan": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": true,
                        "key": "michigan",
                        "label": "Michigan",
                        "pacc_automatic_submit_filing": true,
                        "pacc_code": "MI",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "cover_page": true, "schedule_2a": true, "schedule_2a1": true, "schedule_2a2": true, "schedule_2b": true, "schedule_2b1": true, "schedule_2b2": true, "schedule_2e": true, "schedule_2f": true, "schedule_2ik": true, "schedule_bg": true, "summary_page": true },
                        "region": 24,
                        "value": 24
                    },
                    "minnesota": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "minnesota",
                        "label": "Minnesota",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MN",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 25,
                        "value": 25
                    },
                    "mississippi": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "mississippi",
                        "label": "Mississippi",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MS",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 26,
                        "value": 26
                    },
                    "missouri": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "missouri",
                        "label": "Missouri",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MO",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 27,
                        "value": 27
                    },
                    "montana": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "montana",
                        "label": "Montana",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "MT",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 28,
                        "value": 28
                    },
                    "nebraska": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "nebraska",
                        "label": "Nebraska",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NE",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 29,
                        "value": 29
                    },
                    "nevada": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": true,
                        "is_amendable": true,
                        "key": "nevada",
                        "label": "Nevada",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NV",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "campaign_contributions": true, "campaign_expenses": true, "inkind_campaign_contributions": true, "inkind_campaign_expenses": true, "inkind_written_commitments": true, "summary_page": true, "written_commitments": true },
                        "region": 30,
                        "value": 30
                    },
                    "new_hampshire": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "new_hampshire",
                        "label": "New Hampshire",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NH",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 31,
                        "value": 31
                    },
                    "new_jersey": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "new_jersey",
                        "label": "New Jersey",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NJ",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 32,
                        "value": 32
                    },
                    "new_mexico": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "new_mexico",
                        "label": "New Mexico",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NM",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 33,
                        "value": 33
                    },
                    "new_york": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "new_york",
                        "label": "New York",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NY",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 34,
                        "value": 34
                    },
                    "north_carolina": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": true,
                        "key": "north_carolina",
                        "label": "North Carolina",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "NC",
                        "pdf_copy_of_as_filed_has_conditional_params": true,
                        "pdf_copy_of_as_filed_parameters": { "admin_support": true, "aggregated_contributions_from_individuals_form_cro_1205": true, "contributions_from_individuals_form_cro_1210": true, "cover_page": true, "end_page_form_cro_1205": 0, "end_page_form_cro_1210": 0, "itemized_disbursements": true, "loan_proceeds": true, "loan_repayments": true, "other_contributions_and_receipts": true, "start_page_form_cro_1205": 0, "start_page_form_cro_1210": 0, "summary_page": true },
                        "region": 35,
                        "value": 35
                    },
                    "north_dakota": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "north_dakota",
                        "label": "North Dakota",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "ND",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 36,
                        "value": 36
                    },
                    "ohio": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "ohio",
                        "label": "Ohio",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "OH",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 37,
                        "value": 37
                    },
                    "oklahoma": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "oklahoma",
                        "label": "Oklahoma",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "OK",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 38,
                        "value": 38
                    },
                    "oregon": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "oregon",
                        "label": "Oregon",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "OR",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 39,
                        "value": 39
                    },
                    "pennsylvania": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": true,
                        "is_amendable": true,
                        "key": "pennsylvania",
                        "label": "Pennsylvania",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "PA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": { "schedule_1": true, "schedule_1_end_page": 0, "schedule_1_start_page": 0, "schedule_2": true, "schedule_3": true, "schedule_4": true, "schedule_cover_sheet": true },
                        "region": 40,
                        "value": 40
                    },
                    "rhode_island": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "rhode_island",
                        "label": "Rhode Island",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "RI",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 42,
                        "value": 42
                    },
                    "south_carolina": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "south_carolina",
                        "label": "South Carolina",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "SC",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 43,
                        "value": 43
                    },
                    "south_dakota": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "south_dakota",
                        "label": "South Dakota",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "SD",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 44,
                        "value": 44
                    },
                    "tennessee": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "tennessee",
                        "label": "Tennessee",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "TN",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 45,
                        "value": 45
                    },
                    "texas": {
                        "disabled": false,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "texas",
                        "label": "Texas",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "TX",
                        "pdf_copy_of_as_filed_has_conditional_params": true,
                        "pdf_copy_of_as_filed_parameters": { "dissolution_page": true, "schedule_A2": true, "schedule_B2": true, "schedule_C": true, "schedule_E": true, "schedule_F": true, "schedule_I": true, "schedule_J": true, "schedule_K": true, "schedule_PACT": false, "schedule_T": true, "schedule_cover_sheet_page_1": true, "schedule_cover_sheet_page_2": true },
                        "region": 46,
                        "value": 46
                    },
                    "utah": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "utah",
                        "label": "Utah",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "UT",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 47,
                        "value": 47
                    },
                    "vermont": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "vermont",
                        "label": "Vermont",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "VT",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 48,
                        "value": 48
                    },
                    "virginia": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "virginia",
                        "label": "Virginia",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "VA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 49,
                        "value": 49
                    },
                    "washington": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "washington",
                        "label": "Washington",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "WA",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 50,
                        "value": 50
                    },
                    "west_virginia": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "west_virginia",
                        "label": "West Virginia",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "WV",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 51,
                        "value": 51
                    },
                    "wisconsin": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "wisconsin",
                        "label": "Wisconsin",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "WI",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 52,
                        "value": 52
                    },
                    "wyoming": {
                        "disabled": true,
                        "does_not_allow_entering_amendment_number": false,
                        "is_amendable": false,
                        "key": "wyoming",
                        "label": "Wyoming",
                        "pacc_automatic_submit_filing": false,
                        "pacc_code": "WY",
                        "pdf_copy_of_as_filed_has_conditional_params": false,
                        "pdf_copy_of_as_filed_parameters": {},
                        "region": 53,
                        "value": 53
                    }
                },
                "ReportingTransactionSortKey": {
                    "__is_enum": true,
                    "date": { "key": "date", "label": "Date", "value": 10 },
                    "name": { "key": "name", "label": "Name", "value": 20 },
                    "state": { "key": "state", "label": "State", "value": 30 }
                },
                "StripeEventType": {
                    "__is_enum": true,
                    "account_updated": { "handler_name": "process_event_account_updated", "key": "account_updated", "label": "account.updated", "should_ignore_events": false, "value": 4 },
                    "application_fee_created": { "handler_name": "process_event_application_fee_created", "key": "application_fee_created", "label": "application_fee.created", "should_ignore_events": false, "value": 2 },
                    "payment_intent_succeeded": { "handler_name": "process_event_payment_intent_succeeded", "key": "payment_intent_succeeded", "label": "payment_intent.succeeded", "should_ignore_events": false, "value": 1 },
                    "payout_paid": { "handler_name": "process_event_payout_paid", "key": "payout_paid", "label": "payout.paid", "should_ignore_events": false, "value": 3 }
                },
                "StripeLinkType": {
                    "__is_enum": true,
                    "dashboard": { "key": "dashboard", "label": "dashboard", "value": 2 },
                    "onboarding": { "key": "onboarding", "label": "onboarding", "value": 1 }
                },
                "StripeWebhookEventStatus": {
                    "__is_enum": true,
                    "errored": { "key": "errored", "label": "Errored", "value": 6 },
                    "flagged_as_duplicate": { "key": "flagged_as_duplicate", "label": "Flagged as duplicate", "value": 4 },
                    "ignored": { "key": "ignored", "label": "Ignored", "value": 5 },
                    "processed": { "key": "processed", "label": "Processed", "value": 3 },
                    "processing": { "key": "processing", "label": "Processing", "value": 2 },
                    "unprocessed": { "key": "unprocessed", "label": "Unprocessed", "value": 1 }
                },
                "StripeWebhookObjectType": {
                    "__is_enum": true,
                    "account": { "key": "account", "label": "account", "value": 7 },
                    "application_fee": { "key": "application_fee", "label": "application_fee", "value": 4 },
                    "charge": { "key": "charge", "label": "charge", "value": 5 },
                    "event": { "key": "event", "label": "event", "value": 1 },
                    "payment_intent": { "key": "payment_intent", "label": "payment_intent", "value": 2 },
                    "payout": { "key": "payout", "label": "payout", "value": 6 },
                    "transfer": { "key": "transfer", "label": "transfer", "value": 3 }
                },
                "TransactionEventType": {
                    "__is_enum": true,
                    "create_in_kind_transaction": { "key": "create_in_kind_transaction", "label": "Create In-Kind Transaction", "value": 10 },
                    "create_independent_expenditure_transaction": { "key": "create_independent_expenditure_transaction", "label": "Create Independent Expenditure Transaction", "value": 12 },
                    "create_jfc_transaction": { "key": "create_jfc_transaction", "label": "Create JFC Transaction", "value": 8 },
                    "create_transaction": { "key": "create_transaction", "label": "Create Transaction", "value": 1 },
                    "delete_transaction": { "key": "delete_transaction", "label": "Delete Transaction", "value": 3 },
                    "modify_in_kind_transaction": { "key": "modify_in_kind_transaction", "label": "Modify In-Kind Transaction", "value": 11 },
                    "modify_independent_expenditure_transaction": { "key": "modify_independent_expenditure_transaction", "label": "Modify Independent Expenditure Transaction", "value": 13 },
                    "modify_jfc_transaction": { "key": "modify_jfc_transaction", "label": "Modify JFC Transaction", "value": 9 },
                    "modify_transaction": { "key": "modify_transaction", "label": "Modify Transaction", "value": 2 },
                    "reverse_transaction": { "key": "reverse_transaction", "label": "Reverse Transaction", "value": 7 },
                    "undelete_transaction": { "key": "undelete_transaction", "label": "Undelete Transaction", "value": 4 },
                    "unvoid_transaction": { "key": "unvoid_transaction", "label": "Unvoid Transaction", "value": 6 },
                    "void_transaction": { "key": "void_transaction", "label": "Void Transaction", "value": 5 }
                },
                "TransactionMethodType": {
                    "__is_enum": true,
                    "ach_transfer": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "random",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "ach_transfer",
                        "label": "ACH Transfer",
                        "order": 22,
                        "requires_stripe_onboarding": false,
                        "search_label": "ACH Transfer",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 4
                    },
                    "cash": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "money-bill-alt",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "cash",
                        "label": "Cash",
                        "order": 40,
                        "pacc_code": "$",
                        "requires_stripe_onboarding": false,
                        "search_label": "Cash",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": true,
                        "valid_receipt_donor_types": [1001, 1003],
                        "value": 2
                    },
                    "check": {
                        "code": "C",
                        "donation_form_display": "Check",
                        "donation_form_feature_flags": [],
                        "fa5_icon": "money-check-edit-alt",
                        "fa5_icon_family": "fal",
                        "is_primary": true,
                        "key": "check",
                        "label": "Manual Check",
                        "order": 0,
                        "pacc_code": "C",
                        "requires_stripe_onboarding": false,
                        "search_label": "Check",
                        "used_in_donation_form": true,
                        "valid_disbursement_donor_types": [1001, 1, 2, 3, 5, 6, 100, 101, 1016, 1013, 1012, 1014, 1015],
                        "valid_for_disbursements": true,
                        "valid_for_receipts": true,
                        "valid_receipt_donor_types": [6, 1013, 1, 1015, 1001, 101, 2, 5, 3, 1016, 100000, 1014, 100, 1012],
                        "value": 7
                    },
                    "credit_card": {
                        "code": "CC",
                        "donation_form_feature_flags": ["ff_pac_action_center_enable_credit_card"],
                        "fa5_icon": "credit-card",
                        "fa5_icon_family": "fal",
                        "is_primary": true,
                        "key": "credit_card",
                        "label": "Credit Card",
                        "order": 30,
                        "pacc_code": "V",
                        "requires_stripe_onboarding": false,
                        "search_label": "Credit Card",
                        "used_in_donation_form": true,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": true,
                        "valid_receipt_donor_types": [1001, 100000],
                        "value": 1
                    },
                    "in_kind": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "money-bill-wave",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "in_kind",
                        "label": "In Kind",
                        "order": 50,
                        "pacc_code": "I",
                        "requires_stripe_onboarding": false,
                        "search_label": "In Kind",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 6
                    },
                    "memo": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "sticky-note",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "memo",
                        "label": "Memo",
                        "order": 1000,
                        "pacc_code": "O",
                        "requires_stripe_onboarding": false,
                        "search_label": "Memo",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 9
                    },
                    "other": {
                        "code": "O",
                        "donation_form_feature_flags": [],
                        "fa5_icon": "random",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "other",
                        "label": "Other",
                        "order": 1000,
                        "pacc_code": "O",
                        "requires_stripe_onboarding": false,
                        "search_label": "Other",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [1001, 1, 2, 3, 6, 5, 100, 101, 1016, 1013, 1012, 1014, 1015],
                        "valid_for_disbursements": true,
                        "valid_for_receipts": true,
                        "valid_receipt_donor_types": [1001, 1, 2, 3, 6, 5, 100, 101, 1016, 1013, 1012, 1014, 1015, 1004, 100000],
                        "value": 12
                    },
                    "payroll": {
                        "code": "P",
                        "donation_form_feature_flags": [],
                        "fa5_icon": "receipt",
                        "fa5_icon_family": "fal",
                        "is_primary": true,
                        "key": "payroll",
                        "label": "Payroll",
                        "order": 10,
                        "pacc_code": "P",
                        "requires_stripe_onboarding": false,
                        "search_label": "Payroll",
                        "used_in_donation_form": true,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": true,
                        "valid_receipt_donor_types": [1001, 100000],
                        "value": 5
                    },
                    "printing_check": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "money-check-edit-alt",
                        "fa5_icon_family": "fal",
                        "is_primary": true,
                        "key": "printing_check",
                        "label": "Auto Printed Check",
                        "order": 11,
                        "pacc_code": "C",
                        "requires_stripe_onboarding": false,
                        "search_label": "Auto Printed Check",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [1001, 1, 2, 3, 5, 6, 100, 101, 1016, 1012, 1014, 1015, 1013],
                        "valid_for_disbursements": true,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 8
                    },
                    "stripe_fee": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "credit-card",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "stripe_fee",
                        "label": "Stripe Fee",
                        "order": 1000,
                        "requires_stripe_onboarding": false,
                        "search_label": "Stripe Fee",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 10
                    },
                    "stripe_payment": {
                        "donation_form_display": "Credit Card",
                        "donation_form_feature_flags": [],
                        "fa5_icon": "stripe",
                        "fa5_icon_family": "fab",
                        "is_primary": false,
                        "key": "stripe_payment",
                        "label": "Stripe",
                        "order": 1000,
                        "requires_stripe_onboarding": true,
                        "search_label": "Stripe",
                        "used_in_donation_form": true,
                        "valid_disbursement_donor_types": [],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 11
                    },
                    "wire_transfer": {
                        "donation_form_feature_flags": [],
                        "fa5_icon": "file-invoice-dollar",
                        "fa5_icon_family": "fal",
                        "is_primary": false,
                        "key": "wire_transfer",
                        "label": "Wire Transfer",
                        "order": 1000,
                        "requires_stripe_onboarding": false,
                        "search_label": "Wire Transfer",
                        "used_in_donation_form": false,
                        "valid_disbursement_donor_types": [1013],
                        "valid_for_disbursements": false,
                        "valid_for_receipts": false,
                        "valid_receipt_donor_types": [],
                        "value": 3
                    }
                },
                "TransactionSpecialType": {
                    "__is_enum": true,
                    "in_kind_attribution": { "is_attribution": true, "key": "in_kind_attribution", "label": "In-Kind Attribution", "value": 6 },
                    "independent_expenditure_attribution": { "is_attribution": true, "key": "independent_expenditure_attribution", "label": "Independent Expenditure Attribution", "value": 7 },
                    "jfc_attribution": { "is_attribution": true, "key": "jfc_attribution", "label": "JFC Attribution", "value": 5 },
                    "partnership_attribution": { "is_attribution": false, "key": "partnership_attribution", "label": "Partnership Attribution", "pac_label": "Partnership Attribution", "value": 3 },
                    "reattribution": { "is_attribution": false, "key": "reattribution", "label": "Reattribution", "pac_label": "Reattribution", "value": 1 },
                    "redesignation": { "is_attribution": false, "key": "redesignation", "label": "Redesignation", "pac_label": "Redesignation", "value": 2 },
                    "reversal": { "is_attribution": false, "key": "reversal", "label": "Reversal", "pac_label": "Void", "value": 4 }
                },
                "TransactionTableFilterType": {
                    "__is_enum": true,
                    "disbursements_only": { "key": "disbursements_only", "label": "Disbursements Only", "value": 3 },
                    "no_filter": { "key": "no_filter", "label": "All", "value": 1 },
                    "receipts_only": { "key": "receipts_only", "label": "Receipts Only", "value": 2 }
                },
                "TransactionType": {
                    "__is_enum": true,
                    "bank_transfer": { "fa5_icon": "bank", "key": "bank_transfer", "label": "Bank Transfer", "pac_label": "Internal Bank Transfer", "value": 5 },
                    "money_given": { "fa5_icon": "minus", "key": "money_given", "label": "Money Given", "pac_label": "Disbursement", "reverse_type": 1, "value": 2 },
                    "money_received": { "fa5_icon": "plus", "key": "money_received", "label": "Money Received", "pac_label": "Receipt", "reverse_type": 2, "value": 1 },
                    "refund_given": { "fa5_icon": "minus", "key": "refund_given", "label": "Refund Given", "pac_label": "Receipt Refund", "reverse_type": 4, "value": 3 },
                    "refund_received": { "fa5_icon": "plus", "key": "refund_received", "label": "Refund Received", "pac_label": "Disbursement Refund", "reverse_type": 3, "value": 4 }
                }
            }
        },
        "media_monitoring": {
            "models": {
                "Article": {
                    "__is_model": true,
                    "__name__": "Article",
                    "data_model": "app.media_monitoring.models.Article",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/article/",
                    "fields": [
                        { "field_type": 1, "name": "is_duplicate", "verbose_name": "Is Duplicate" },
                        { "field_type": 1, "name": "archived", "verbose_name": "Archived" },
                        { "field_type": 16, "name": "created", "verbose_name": "Created" },
                        { "field_type": 16, "name": "updated", "verbose_name": "Updated" },
                        { "field_type": 12, "name": "ingest_delay", "verbose_name": "Ingest Delay" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "name": "region",
                            "verbose_name": "Region"
                        },
                        { "field_type": 4, "name": "id_with_docvalues", "verbose_name": "Id With Docvalues" },
                        { "field_type": 2, "name": "ingestion_method", "verbose_name": "Ingestion Method" },
                        { "field_type": 7, "name": "alert_cache", "verbose_name": "Alert Cache" },
                        { "field_type": 3, "name": "title", "verbose_name": "Title" },
                        { "field_type": 3, "name": "content", "verbose_name": "Content" },
                        { "field_type": 3, "name": "extract", "verbose_name": "Extract" },
                        { "field_type": 3, "name": "content_with_markup", "verbose_name": "Content With Markup" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "name": "language",
                            "verbose_name": "Language"
                        },
                        { "field_type": 2, "name": "language_original", "verbose_name": "Language Original" },
                        { "field_type": 7, "name": "author", "verbose_name": "Author" },
                        { "field_type": 7, "name": "source", "verbose_name": "Source" },
                        { "field_type": 4, "name": "sequence_id", "verbose_name": "Sequence Id" },
                        { "field_type": 4, "name": "duplicate_group_id", "verbose_name": "Duplicate Group Id" },
                        { "field_type": 4, "name": "word_count", "verbose_name": "Word Count" },
                        { "field_type": 2, "name": "tags", "verbose_name": "Tags" },
                        { "field_type": 7, "name": "topics", "verbose_name": "Topics" },
                        { "field_type": 4, "name": "takedown_sequence_id", "verbose_name": "Takedown Sequence Id" },
                        { "field_type": 7, "name": "industry_index_terms", "verbose_name": "Industry Index Terms" },
                        { "field_type": 7, "name": "subject_index_terms", "verbose_name": "Subject Index Terms" },
                        { "field_type": 7, "name": "companies", "verbose_name": "Companies" },
                        { "field_type": 7, "name": "primary_companies", "verbose_name": "Primary Companies" },
                        { "field_type": 16, "name": "published_date", "verbose_name": "Published Date" },
                        { "field_type": 16, "name": "harvest_date", "verbose_name": "Harvest Date" },
                        { "field_type": 16, "name": "estimated_published_date", "verbose_name": "Estimated Published Date" },
                        { "field_type": 16, "name": "embargo_date", "verbose_name": "Embargo Date" },
                        { "field_type": 16, "name": "license_end_date", "verbose_name": "License End Date" },
                        { "field_type": 3, "name": "lexis_url", "verbose_name": "Lexis Url" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "MediaLoginStatus" },
                            "field_type": 4,
                            "name": "login_status",
                            "verbose_name": "Login Status"
                        },
                        { "field_type": 3, "name": "copyright", "verbose_name": "Copyright" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "MediaLicense" },
                            "field_type": 4,
                            "name": "license",
                            "verbose_name": "License"
                        },
                        { "field_type": 4, "name": "issues", "verbose_name": "Issues" },
                        { "field_type": 2, "name": "person_entities", "verbose_name": "Person Entities" },
                        { "field_type": 2, "name": "organization_entities", "verbose_name": "Organization Entities" },
                        { "field_type": 2, "name": "location_entities", "verbose_name": "Location Entities" },
                        { "field_type": 2, "name": "product_entities", "verbose_name": "Product Entities" },
                        { "field_type": 3, "name": "outbound_urls", "verbose_name": "Outbound Urls" }
                    ]
                },
                "ArticleTopic": {
                    "__is_model": true,
                    "__name__": "ArticleTopic",
                    "data_model": "app.media_monitoring.models.ArticleTopic",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/articletopic/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 3, "help_text": "The name of this topic", "name": "topic", "verbose_name": "Lexis Nexis Editorial Topic Group" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "ArticleTopicType" },
                            "field_type": 4,
                            "help_text": "What type of topic is this?",
                            "name": "topic_type",
                            "verbose_name": "Lexis Nexis Editorial Topic Group"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If this topic is a subtopic of a group, this foreign key will link to the parent topic group.",
                            "name": "parent_topic",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "ArticleTopic" },
                            "verbose_name": "parent topic"
                        }
                    ]
                },
                "Beat": {
                    "__is_model": true,
                    "__name__": "Beat",
                    "data_model": "app.media_monitoring.models.Beat",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/beat/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 3,
                            "help_text": "Name of the beat from Intrado.",
                            "miscellaneous": [120, 42],
                            "name": "name",
                            "sheet_column": true,
                            "sheets_tooltip_text": "Names of the topics covered.",
                            "verbose_name": "Beats"
                        },
                        { "field_type": 3, "help_text": "Description of the Intrado beat.", "name": "description", "verbose_name": "description" },
                        {
                            "field_type": 7,
                            "help_text": "Parent beat. Some beats are subcategories of another beat. Ex: Bioinformatics is a child of Information Technology",
                            "name": "parent_beat",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "Beat" },
                            "verbose_name": "parent beat"
                        }
                    ]
                },
                "DesignatedMarketArea": {
                    "__is_model": true,
                    "__name__": "DesignatedMarketArea",
                    "data_model": "app.media_monitoring.models.DesignatedMarketArea",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/designatedmarketarea/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 3,
                            "help_text": "Name of the DesignatedMarketArea from Intrado.",
                            "miscellaneous": [120, 42],
                            "name": "name",
                            "sheet_column": true,
                            "sheets_tooltip_text": "Names of the Designated Market Areas serviced.",
                            "verbose_name": "DMA"
                        }
                    ]
                }
            },
            "types": {
                "ArticleTopicType": {
                    "__is_enum": true,
                    "group": { "key": "group", "label": "Topic", "source_field": "topics__group", "value": 1 },
                    "subtopic": { "key": "subtopic", "label": "Subtopic", "source_field": "topics__name", "value": 2 }
                },
                "IntradoAudienceFocus": {
                    "__is_enum": true,
                    "consumer": { "key": "consumer", "label": "Consumer", "value": 2 },
                    "trade": { "key": "trade", "label": "Trade", "value": 1 }
                },
                "IntradoCirculation": {
                    "__is_enum": true,
                    "range_10000000_plus": { "end": 1000000000, "key": "range_10000000_plus", "label": "Above 10,000,000", "start": 10000000, "value": 1 },
                    "range_1000000_5000000": { "end": 5000000, "key": "range_1000000_5000000", "label": "1,000,000 to 5,000,000", "start": 1000000, "value": 3 },
                    "range_100000_500000": { "end": 500000, "key": "range_100000_500000", "label": "100,000 to 500,000", "start": 100000, "value": 5 },
                    "range_10000_100000": { "end": 100000, "key": "range_10000_100000", "label": "10,000 to 100,000", "start": 10000, "value": 6 },
                    "range_1000_10000": { "end": 10000, "key": "range_1000_10000", "label": "1,000 to 10,000", "start": 1000, "value": 7 },
                    "range_5000000_10000000": { "end": 10000000, "key": "range_5000000_10000000", "label": "5,000,000 to 10,000,000", "start": 5000000, "value": 2 },
                    "range_500000_1000000": { "end": 1000000, "key": "range_500000_1000000", "label": "500,000 to 1,000,000", "start": 500000, "value": 4 },
                    "range_under_1000": { "end": 1000, "key": "range_under_1000", "label": "Under 1,000", "start": 1, "value": 8 }
                },
                "IntradoCoverage": {
                    "__is_enum": true,
                    "international": { "key": "international", "label": "International", "value": 4 },
                    "local": { "key": "local", "label": "Local", "value": 1 },
                    "national": { "key": "national", "label": "National", "value": 3 },
                    "other": { "key": "other", "label": "Unknown", "value": 5 },
                    "regional": { "key": "regional", "label": "Regional", "value": 2 }
                },
                "IntradoFrequency": {
                    "__is_enum": true,
                    "annual": { "key": "annual", "label": "Annual", "value": 11 },
                    "daily": { "key": "daily", "label": "Daily", "value": 1 },
                    "every_other_month": { "key": "every_other_month", "label": "Every Other Month", "value": 7 },
                    "monthly": { "key": "monthly", "label": "Monthly", "value": 6 },
                    "other": { "key": "other", "label": "Other", "value": 12 },
                    "quarterly": { "key": "quarterly", "label": "Quarterly", "value": 8 },
                    "three_times_a_year": { "key": "three_times_a_year", "label": "Three Times A Year", "value": 9 },
                    "twice_a_month": { "key": "twice_a_month", "label": "Twice A Month", "value": 5 },
                    "twice_a_week": { "key": "twice_a_week", "label": "Twice A Week", "value": 3 },
                    "twice_a_year": { "key": "twice_a_year", "label": "Twice A Year", "value": 10 },
                    "weekdays": { "key": "weekdays", "label": "Mon-Fri", "value": 2 },
                    "weekly": { "key": "weekly", "label": "Weekly", "value": 4 }
                },
                "IntradoMediaType": {
                    "__is_enum": true,
                    "blog": { "key": "blog", "label": "Blog", "value": 1 },
                    "forum": { "key": "forum", "label": "Forum", "value": 3 },
                    "freelance": { "key": "freelance", "label": "Freelance Journalist", "value": 20 },
                    "internet": { "key": "internet", "label": "Internet Publications", "value": 11 },
                    "journal": { "key": "journal", "label": "Journal", "value": 29 },
                    "magazine": { "key": "magazine", "label": "Magazine", "value": 2 },
                    "news_wire": { "key": "news_wire", "label": "News Service/Wires", "value": 9 },
                    "newsletter": { "key": "newsletter", "label": "Newsletter", "value": 24 },
                    "newspaper": { "key": "newspaper", "label": "Newspaper", "value": 12 },
                    "podcast": { "key": "podcast", "label": "Podcast", "value": 32 },
                    "radio_am": { "key": "radio_am", "label": "AM Stations", "value": 8 },
                    "radio_fm": { "key": "radio_fm", "label": "FM Stations", "value": 6 },
                    "radio_local": { "key": "radio_local", "label": "Radio - Local Station Shows/Programs", "value": 5 },
                    "radio_network_company": { "key": "radio_network_company", "label": "Radio Network Companies", "value": 25 },
                    "radio_network_program": { "key": "radio_network_program", "label": "Radio - Network Shows/Programs", "value": 23 },
                    "radio_production": { "key": "radio_production", "label": "Radio - Production Companies", "value": 31 },
                    "radio_satellite_company": { "key": "radio_satellite_company", "label": "Satellite Radio Companies", "value": 28 },
                    "radio_satellite_program": { "key": "radio_satellite_program", "label": "Satellite Radio Shows/Programs", "value": 27 },
                    "radio_syndicated": { "key": "radio_syndicated", "label": "Radio - Syndicated Shows/Programs", "value": 19 },
                    "research": { "key": "research", "label": "Research Firm", "value": 30 },
                    "tv_cable": { "key": "tv_cable", "label": "TV - Cable Shows/Programs", "value": 10 },
                    "tv_cable_company": { "key": "tv_cable_company", "label": "Cable TV Companies", "value": 18 },
                    "tv_local": { "key": "tv_local", "label": "TV - Local Station Shows/Programs", "value": 15 },
                    "tv_network_company": { "key": "tv_network_company", "label": "TV Network Companies", "value": 16 },
                    "tv_network_program": { "key": "tv_network_program", "label": "TV - Network Shows/Programs", "value": 13 },
                    "tv_other": { "key": "tv_other", "label": "TV - Various Stations", "value": 14 },
                    "tv_production": { "key": "tv_production", "label": "TV - Production Companies", "value": 7 },
                    "tv_satellite_company": { "key": "tv_satellite_company", "label": "Satellite TV Companies", "value": 17 },
                    "tv_satellite_program": { "key": "tv_satellite_program", "label": "Satellite TV Shows/Programs", "value": 21 },
                    "tv_syndicated": { "key": "tv_syndicated", "label": "TV - Syndicated Shows/Programs", "value": 26 }
                },
                "IntradoOutletTier": {
                    "__is_enum": true,
                    "top_100_internet_publications_ca": { "key": "top_100_internet_publications_ca", "label": "Top 100 Internet Publications_Canada", "value": 21 },
                    "top_100_internet_publications_uk": { "key": "top_100_internet_publications_uk", "label": "Top 100 Internet Publications_UK", "value": 20 },
                    "top_100_internet_publications_usa": { "key": "top_100_internet_publications_usa", "label": "Top 100 Internet Publications_USA", "value": 19 },
                    "top_100_magazines_ca": { "key": "top_100_magazines_ca", "label": "Top 100 Magazines_Canada", "value": 6 },
                    "top_100_magazines_uk": { "key": "top_100_magazines_uk", "label": "Top 100 Magazines_UK", "value": 5 },
                    "top_100_magazines_usa": { "key": "top_100_magazines_usa", "label": "Top 100 Magazines_USA", "value": 4 },
                    "top_100_newspapers_ca": { "key": "top_100_newspapers_ca", "label": "Top 100 Newspapers_Canada", "value": 3 },
                    "top_100_newspapers_uk": { "key": "top_100_newspapers_uk", "label": "Top 100 Newspapers_UK", "value": 2 },
                    "top_100_newspapers_usa": { "key": "top_100_newspapers_usa", "label": "Top 100 Newspapers_USA", "value": 1 },
                    "top_100_radio_stations_ca": { "key": "top_100_radio_stations_ca", "label": "Top 100 Radio Stations_Canada", "value": 12 },
                    "top_100_radio_stations_uk": { "key": "top_100_radio_stations_uk", "label": "Top 100 Radio Stations_UK", "value": 11 },
                    "top_100_radio_stations_usa": { "key": "top_100_radio_stations_usa", "label": "Top 100 Radio Stations_USA", "value": 10 },
                    "top_100_research_firms_usa": { "key": "top_100_research_firms_usa", "label": "Top 100 Research Firms_USA", "value": 16 },
                    "top_100_television_stations_ca": { "key": "top_100_television_stations_ca", "label": "Top 100 Television Stations_Canada", "value": 15 },
                    "top_100_television_stations_usa": { "key": "top_100_television_stations_usa", "label": "Top 100 Television Stations_USA", "value": 13 },
                    "top_10_research_firms_ca": { "key": "top_10_research_firms_ca", "label": "Top 10 Research Firms_Canada", "value": 18 },
                    "top_10_research_firms_uk": { "key": "top_10_research_firms_uk", "label": "Top 10 Research Firms_UK", "value": 17 },
                    "top_50_television_stations_uk": { "key": "top_50_television_stations_uk", "label": "Top 50 Television Stations_UK", "value": 14 },
                    "top_5_news_agencies_ca": { "key": "top_5_news_agencies_ca", "label": "Top 5 News Agencies_Canada", "value": 9 },
                    "top_5_news_agencies_uk": { "key": "top_5_news_agencies_uk", "label": "Top 5 News Agencies_UK", "value": 8 },
                    "top_5_news_agencies_usa": { "key": "top_5_news_agencies_usa", "label": "Top 5 News Agencies_USA", "value": 7 }
                },
                "IntradoPreferredDistributionMode": {
                    "__is_enum": true,
                    "email": { "key": "email", "label": "Email", "value": 1 },
                    "phone": { "key": "phone", "label": "Phone", "value": 2 }
                },
                "MediaLicense": {
                    "__is_enum": true,
                    "cfc": { "key": "cfc", "label": "CFC", "licensed_content": false, "value": 2 },
                    "cla": { "key": "cla", "label": "CLA", "licensed_content": false, "value": 3 },
                    "lexis_nexis": { "key": "lexis_nexis", "label": "LexisNexis Licensed", "licensed_content": true, "value": 4 },
                    "nla": { "key": "nla", "label": "NLA", "licensed_content": false, "value": 5 },
                    "postmedia": { "key": "postmedia", "label": "Postmedia Network", "licensed_content": false, "value": 6 },
                    "public": { "key": "public", "label": "Publicly Available", "licensed_content": false, "value": 1 }
                },
                "MediaSourceCategory": {
                    "__is_enum": true,
                    "academic": { "desc": "News items from educational institutions, e.g. schools and universities.", "key": "academic", "label": "Academic", "precedence": 7, "tip": "News items from educational institutions.", "value": 1 },
                    "consumer": { "desc": "News items from consumer and magazine type publications, e.g. Salon, GQ.", "key": "consumer", "label": "Consumer", "precedence": 4, "tip": "News items from consumer and magazine type publications.", "value": 2 },
                    "corporate": { "desc": "Corporate website press release pages, e.g. McDonalds, Shell.", "key": "corporate", "label": "Corporate", "precedence": 10, "tip": "Corporate website press release pages.", "value": 3 },
                    "general": { "desc": "News items from sources that are yet to be assigned a source category.", "key": "general", "label": "General", "precedence": 12, "tip": "News items from sources that have not yet been assigned a coverage area or fall outside the coverage area.", "value": 4 },
                    "government": { "desc": "News and information from governments and government departments.", "key": "government", "label": "Government", "precedence": 8, "tip": "News and information from governments & government departments.", "value": 5 },
                    "journal": { "desc": "Periodical publications, typically focused on science, technology or professions.", "key": "journal", "label": "Journal", "precedence": 6, "tip": "Periodical publications, typically focused on science, technology or professions.", "value": 6 },
                    "local": { "desc": "News from local and regional news sources, e.g. The Alaska Star, Bath Chronicle.", "key": "local", "label": "Local", "precedence": 2, "tip": "News from regional & local news sources.", "value": 7 },
                    "misc": { "desc": "News from sources that do not fit into any of the other source categories.", "key": "misc", "label": "Other", "precedence": 11, "tip": "News items from sources that have not yet been assigned a coverage area or fall outside the coverage area.", "value": 8 },
                    "national": { "desc": "News from national and international sources, e.g. BBC, The New York Times.", "key": "national", "label": "National", "precedence": 1, "tip": "News from international & national news sources.", "value": 9 },
                    "organization": { "desc": "News from organizations such as charities, political parties, NGOs.", "key": "organization", "label": "Organization", "precedence": 9, "tip": "News from organizations such as charities, political parties, NGOs.", "value": 10 },
                    "press_wire": { "desc": "Designated press release and press wire sources, e.g. Business Wire.", "key": "press_wire", "label": "Press Wire", "precedence": 3, "tip": "Designated press release and press wire sources.", "value": 11 },
                    "trade": { "desc": "News items from designated industry, profession or technology focused sources, e.g. Financial Review, McKinsey Quarterly, Oil and Gas Journal.", "key": "trade", "label": "Trade", "precedence": 5, "tip": "News items from designated industry, profession or technology focused sources.", "value": 12 }
                },
                "MediaSourceRank": {
                    "__is_enum": true,
                    "five": { "desc": "Covers non-news sources and data.", "key": "five", "label": "Tier 5: Non-News Sources", "show_in_enumeration": true, "value": 5 },
                    "four": { "desc": "Covers a broad range of news sources, newswire sources and sources with a local focus.", "key": "four", "label": "Tier 4: Local News", "show_in_enumeration": true, "value": 4 },
                    "one": { "desc": "Top international, national, and business news sources", "key": "one", "label": "Tier 1: Top International and National News", "show_in_enumeration": true, "value": 1 },
                    "three": { "desc": " A broad range of news sources of good editorial quality", "key": "three", "label": "Tier 3: Industry, Sports, Country Specific News", "show_in_enumeration": true, "value": 3 },
                    "two": { "desc": "Top regional sources", "key": "two", "label": "Tier 2: Regional News", "show_in_enumeration": true, "value": 2 }
                },
                "MediaSourceType": {
                    "__is_enum": true,
                    "blog": { "icon": "rss-square", "icon_fa5": "blog", "ie": "WordPress, Blogger, TypePad, LiveJournal", "key": "blog", "label": "Blog", "original_label": "Blog", "parent": 80, "show_in_enumeration": true, "value": 2 },
                    "broadcast": { "icon": "pencil-square", "icon_fa5": "broadcast-tower", "ie": "CNN Transcripts, NBC News, Canadian Television Network", "key": "broadcast", "label": "Broadcast Transcript", "original_label": "Broadcast", "parent": 127, "show_in_enumeration": true, "value": 4 },
                    "classified": { "icon": "file-text-o", "icon_fa5": "file-search", "ie": "LivingSocial, Craigslist, Groupon, Gumtree, Kijiji", "key": "classified", "label": "Classified", "original_label": "Classified", "parent": 118, "show_in_enumeration": false, "value": 15 },
                    "comment": { "icon": "comment-o", "icon_fa5": "comment-dots", "ie": "Mashable.com, Gizmodo.com, Wired.com, NYT blogs", "key": "comment", "label": "Comment", "original_label": "Comment", "parent": 118, "show_in_enumeration": false, "value": 12 },
                    "forum": { "icon": "window-maximize", "icon_fa5": "w", "ie": "Formspring.com, MacRumours, ZetaBoards, ProBoards, FreeForums.org", "key": "forum", "label": "Forum", "original_label": "Forum", "parent": 118, "show_in_enumeration": false, "value": 14 },
                    "microblog": { "icon": "rss-square", "icon_fa5": "blog", "ie": "FriendFeed, Indenti.ca, Audioboo, Formspring", "key": "microblog", "label": "Microblog", "original_label": "Microblog", "parent": 118, "show_in_enumeration": false, "value": 5 },
                    "online_news": { "icon": "desktop", "icon_fa5": "chalkboard-teacher", "ie": "national and local news sources, business publications, press releases", "key": "online_news", "label": "Online News", "original_label": "News", "parent": 126, "show_in_enumeration": true, "value": 1 },
                    "podcast": { "icon": "podcast", "icon_fa5": "podcast", "ie": "BBC, NPR, The Onion, Channel4 Podcasts, Engadget Podcasts", "key": "podcast", "label": "Podcast", "original_label": "Podcast", "parent": 117, "show_in_enumeration": true, "value": 9 },
                    "print_news": { "icon": "newspaper-o", "icon_fa5": "newspaper", "ie": "China Daily - US Edition, La Nazione (Italy), Belfast Telegraph", "key": "print_news", "label": "Print", "original_label": "Print", "parent": 56, "show_in_enumeration": true, "value": 3 },
                    "q_a": { "icon": "list-alt", "icon_fa5": "list-alt", "ie": "LinkedIn Answers, Yahoo! Answers, Wiki Answers, Quora, ChaCha", "key": "q_a", "label": "Q&A", "original_label": "Q&A", "parent": 118, "show_in_enumeration": false, "value": 13 },
                    "review": { "icon": "file-text", "icon_fa5": "file-invoice", "ie": "Amazon.com, Yelp, ePinions, Glassdoor, TripAdvisor", "key": "review", "label": "Review", "original_label": "Review", "parent": 118, "show_in_enumeration": false, "value": 10 },
                    "social_network": { "icon": "comment-o", "icon_fa5": "comment-o", "ie": "Public Facebook Pages, Mene\u0301ame, Pinterest, LinkedIn, Ning", "key": "social_network", "label": "Social Network", "original_label": "Social Network", "parent": 118, "show_in_enumeration": false, "value": 8 },
                    "social_photo": { "icon": "file-image-o", "icon_fa5": "file-image-o", "ie": "Flickr, SmugMug, Webstagram, Twitpic, Picasa, Photobucket", "key": "social_photo", "label": "Social Photo", "original_label": "Social Photo", "parent": 118, "show_in_enumeration": false, "value": 7 },
                    "social_video": { "icon": "video-camera", "icon_fa5": "video-camera", "ie": "YouTube, Vimeo, blip.tv, MSN Video, Dailymotion, Hyves.nl", "key": "social_video", "label": "Social Video", "original_label": "Social Video", "parent": 118, "show_in_enumeration": false, "value": 6 },
                    "wiki": { "icon": "list-alt", "icon_fa5": "list-alt", "ie": "MediaWiki, Wikipedia, WikiLeaks, WikiBooks", "key": "wiki", "label": "Wiki", "original_label": "Wiki", "parent": 118, "show_in_enumeration": false, "value": 11 }
                },
                "XFrameOptionsType": {
                    "__is_enum": true,
                    "allow": { "key": "allow", "label": "Allow", "show_iframe": true, "value": 1 },
                    "allow_from": { "key": "allow_from", "label": "Allow From (deprecated)", "show_iframe": true, "value": 4 },
                    "deny": { "key": "deny", "label": "Deny", "show_iframe": false, "value": 2 },
                    "error": { "key": "error", "label": "Error while Scraping X-Frame-Options", "show_iframe": false, "value": 10 },
                    "frame_ancestors": { "key": "frame_ancestors", "label": "Content Security Policy frame-ancestors", "show_iframe": true, "value": 5 },
                    "invalid": { "key": "invalid", "label": "Invalid XFrameOptions String", "show_iframe": true, "value": 11 },
                    "same_origin": { "key": "same_origin", "label": "Same Origin", "show_iframe": false, "value": 3 },
                    "unset": { "key": "unset", "label": "Undetermined", "show_iframe": false, "value": 9 }
                }
            }
        },
        "models": {
            "CongressChamber": {
                "__is_enum": true,
                "both": { "abbrev": "both", "key": "both", "label": "Joint", "level": "both", "short_name": "b", "show_in_enumeration": true, "value": 3 },
                "executive": { "abbrev": "exec", "key": "executive", "label": "Executive", "level": "exec", "short_name": "e", "show_in_enumeration": false, "value": 4 },
                "house": { "abbrev": "rep", "key": "house", "label": "House", "level": "lower", "short_name": "h", "show_in_enumeration": true, "value": 2 },
                "senate": { "abbrev": "sen", "key": "senate", "label": "Senate", "level": "upper", "short_name": "s", "show_in_enumeration": true, "value": 1 }
            },
            "Feature": {
                "__is_enum": true,
                "action_center": {
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10734627338139-Action-Center",
                    "icon": "bullhorn",
                    "iconFamily": "fad",
                    "key": "action_center",
                    "label": "Action Center",
                    "paths": ["/action_centers/:id?/:child?"],
                    "splash_cards": [
                        { "icon": "key-skeleton", "iconFamily": "fad", "text": "Share content to educate your advocates on key issues" },
                        { "icon": "bullhorn", "iconFamily": "fad", "text": "Launch campaigns quickly to drive immediate action" },
                        { "icon": "file-chart-line", "iconFamily": "fad", "text": "Report on your efforts to inform future advocacy strategy" },
                        { "icon": "trophy-alt", "iconFamily": "fad", "text": "Encourage engagement with game-style points and levels" }
                    ],
                    "splash_paragraph": "Customize a new website through Quorum or embed campaigns on your own website to educate and activate your advocates on campaigns.",
                    "splash_title": "Mobilize Advocates to Take Action",
                    "value": 1
                },
                "bulk_uploads": { "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10735956817307-Bulk-Uploads", "icon": "bug", "iconFamily": "fad", "key": "bulk_uploads", "label": "Bulk Uploads", "value": 2 },
                "campaigns": {
                    "empty_state_paragraph": "Grassroots users can use Quorum's Action Center to launch Campaigns, activating advocates and informing them on the issues that matter most.",
                    "empty_state_title": { "Active Campaign": "Create A Campaign", "Complete Campaign": "There Aren't Any Completed Campaigns", "Draft Campaign": "There Aren't Any Drafted Campaigns", "P2A Active Campaign": "There Aren't Any P2A Active Campaigns" },
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/articles/12591919874971-Launch-a-Campaign",
                    "icon": "bullhorn",
                    "iconFamily": "fad",
                    "key": "campaigns",
                    "label": "Campaigns",
                    "value": 15
                },
                "custom_field_group": { "empty_state_paragraph": "Custom field groups allow you to categorize your custom fields so you can keep your custom data organized.", "empty_state_title": "Add a Custom Field Group", "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736144555163-Custom-Fields", "icon": "layer-group", "iconFamily": "far", "key": "custom_field_group", "label": "Custom Field Groups", "value": 24 },
                "custom_fields": {
                    "empty_state_paragraph": "Custom fields enable you to add and keep track of custom information associated with any of Quorum's data types, for example: \"Tier 1\" or \"Needs review\".",
                    "empty_state_title": { "bill": "Add A Custom Field For Bills", "committee": "Add A Custom Field For Committees", "contact": "Add A Custom Field For Contacts", "issue": "Add A Custom Field For Issues", "note": "Add A Custom Field For Notes", "official": "Add A Custom Field For Officials", "organization": "Add A Custom Field For Organizations", "regulation": "Add A Custom Field For Regulations", "staffer": "Add A Custom Field For Staffers" },
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736144555163-Custom-Fields",
                    "icon": "sliders-h",
                    "iconFamily": "fad",
                    "key": "custom_fields",
                    "label": "Custom Fields",
                    "value": 3
                },
                "custom_regions": { "empty_state_paragraph": "Custom Regions allow you to keep track of key information focused on specific locations that are relevant to you.", "empty_state_title": "Add A Custom Region", "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/articles/11048120063771-Change-Your-Region-or-Create-Custom-Regions", "icon": "map-marked-alt", "iconFamily": "fad", "key": "custom_regions", "label": "Custom Regions", "value": 12 },
                "dashboard": {
                    "empty_state_paragraph": "Dashboards are customizable, auto-updating reports that give you a visual summary of where your priorities, team, or strategy currently stand.",
                    "empty_state_title": "Create Your First Dashboard",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736239139355-Dashboards",
                    "icon": "dashboard",
                    "iconFamily": "q",
                    "key": "dashboard",
                    "label": "Dashboards",
                    "paths": ["/dashboard/"],
                    "splash_cards": [
                        { "icon": "chart-line", "iconFamily": "fad", "text": "Identify and monitor trends" },
                        { "icon": "bell-exclamation", "iconFamily": "fad", "text": "View recent updates to your issues" },
                        { "icon": "analytics", "iconFamily": "fad", "text": "Quantify the impact of your efforts" },
                        { "icon": "handshake", "iconFamily": "fad", "text": "Track Recent Interactions" }
                    ],
                    "splash_paragraph": "Get a high-level, visual summary of everything you care about with an auto-updating Dashboard for your homepage or issues.",
                    "splash_title": "Key Insights and Information at a Glance",
                    "value": 16
                },
                "download_center": {
                    "empty_state_paragraph": "Create customized PDF one-pagers with your organization's branding and custom data to share information quickly with your team.",
                    "empty_state_title": "Create A New Download",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736304028571-Download-Center",
                    "icon": "cloud-download-alt",
                    "iconFamily": "fad",
                    "key": "download_center",
                    "label": "Download Center",
                    "paths": ["/profiledownload/", "/download_center/", "/downloadcenter/:a?/:b?/:c?/"],
                    "splash_cards": [
                        { "icon": "copy", "iconFamily": "fad", "text": "Create and customize templates" },
                        { "icon": "palette", "iconFamily": "fad", "text": "Personalize with your organization's colors, fonts, and logos" },
                        { "icon": "map", "iconFamily": "fad", "text": "Map custom data to demonstrate your impact" },
                        { "icon": "arrow-to-bottom", "iconFamily": "fad", "text": "Move faster by downloading PDFs for all of your stakeholders at once" }
                    ],
                    "splash_paragraph": "Create and download one-pagers to prepare your team for advocacy days, meetings with stakeholders, or briefings to leadership.",
                    "splash_title": "Empower Your Team to Work Smarter with One-Pagers",
                    "value": 4
                },
                "downloads": {
                    "empty_state_paragraph": { "CSV": "When you download a CSV it will appear in a list here.", "PDF": "When you download a PDF it will appear in a list here." },
                    "empty_state_title": { "CSV": "You Haven't Downloaded A CSV Yet", "PDF": "You Haven't Downloaded A PDF Yet" },
                    "icon": "download",
                    "iconFamily": "fad",
                    "key": "downloads",
                    "label": "Downloads",
                    "value": 13
                },
                "duplicate_management": { "empty_state_paragraph": "There are currently no potential duplicates for you to manage.", "empty_state_title": "Potential Duplicates", "icon": "object-ungroup", "iconFamily": "fad", "key": "duplicate_management", "label": "Duplicate Management", "value": 22 },
                "email_alerts": { "empty_state_paragraph": "Get email alerts with real time data changes and view your alerts feed by turning on default alerts or creating your own custom alerts!", "empty_state_title": "Set Up Alerts", "icon": "rss", "iconFamily": "fad", "key": "email_alerts", "label": "Email Alerts", "value": 5 },
                "event_management": {
                    "empty_state_paragraph": "Use events to create events, send invitations through Outbox, and generate reports on who was invited, RSVPed, or attended any of your events.",
                    "empty_state_title": "Create An Event",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736310119067-Event-Management",
                    "icon": "calendar-check",
                    "iconFamily": "fad",
                    "key": "event_management",
                    "label": "Event Management",
                    "paths": ["/custom_event/:id?/:tab?"],
                    "splash_cards": [
                        { "icon": "list", "iconFamily": "fad", "text": "Create a reusable guest list with your own data and Quorum data" },
                        { "icon": "envelope-open-text", "iconFamily": "fad", "text": "Design and send invitations using Quorum's Outbox tool" },
                        { "icon": "browser", "iconFamily": "fad", "text": "Use a landing page to collect RSVPs without forms" },
                        { "icon": "tasks", "iconFamily": "fad", "text": "Track RSVPs and event attendance and send tailored follow-up messages" }
                    ],
                    "splash_paragraph": "Your team can work smarter when you make events part of your wider stakeholder engagement strategy and track results.",
                    "splash_title": "Personalize Events for the People Who Matter",
                    "value": 6
                },
                "filing": { "empty_state_paragraph": "To get started, create a new report.", "empty_state_title": "Campaign Finance Reports", "icon": "file-invoice-dollar", "iconFamily": "fad", "key": "filing", "label": "Filings", "value": 18 },
                "impact_reports": {
                    "empty_state_paragraph": "Create customized PDF one-pagers with your organization's branding and custom data to share information quickly with your team.",
                    "empty_state_title": "Create A New Brief",
                    "icon": "cloud-download-alt",
                    "iconFamily": "fad",
                    "key": "impact_reports",
                    "label": "Impact Reports",
                    "paths": ["/brief_builder/", "/brief_builder/edit"],
                    "splash_cards": [
                        { "icon": "copy", "iconFamily": "fad", "text": "Create and customize templates" },
                        { "icon": "palette", "iconFamily": "fad", "text": "Personalize with your organization's colors, fonts, and logos" },
                        { "icon": "map", "iconFamily": "fad", "text": "Map custom data to demonstrate your impact" },
                        { "icon": "arrow-to-bottom", "iconFamily": "fad", "text": "Move faster by downloading PDFs for all of your stakeholders at once" }
                    ],
                    "splash_paragraph": "Create and download one-pagers to prepare your team for advocacy days, meetings with stakeholders, or briefings to leadership.",
                    "splash_title": "Empower Your Team to Work Smarter with One-Pagers",
                    "value": 25
                },
                "issue_management": {
                    "empty_state_paragraph": "Issue management allows you to collect and view data around key issues, documents, staffers and more, all in one place to stay up to date.",
                    "empty_state_title": "Create An Issue",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736420072347-Issue-Management",
                    "icon": "thumbtack",
                    "iconFamily": "fad",
                    "key": "issue_management",
                    "label": "Issue Management",
                    "paths": ["/issue_management/:id?/:tab?"],
                    "splash_cards": [
                        { "icon": "eye", "iconFamily": "fad", "text": "Create an issue for each of your organization's focus areas" },
                        { "icon": "tags", "iconFamily": "fad", "text": "Tag documents, staffers, contacts and more to your issues" },
                        { "icon": "users", "iconFamily": "fad", "text": "Easily collaborate with your team by tagging information to your issues" },
                        { "icon": "alarm-clock", "iconFamily": "fad", "text": "Keep up to date with the latest data" }
                    ],
                    "splash_paragraph": "With your policy landscape mapped out in one place, your team can work smarter by seeing the full picture with the latest developments.",
                    "splash_title": "Manage Your Issues in One Place",
                    "value": 7
                },
                "outbound_texting": {
                    "empty_state_paragraph": "Use Texting to notify contacts and supporters about your campaigns and legislative priorities.",
                    "empty_state_title": { "Draft": "There Aren't Any Drafted Texts", "Sent": "Send Your First Text" },
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/articles/12591173910043-Mobilize-Advocates-Using-Texting",
                    "icon": "mobile-alt",
                    "iconFamily": "fas",
                    "key": "outbound_texting",
                    "label": "Texting",
                    "paths": ["/texting/:child?/:id?/:tab?"],
                    "splash_cards": [
                        { "icon": "bullseye-arrow", "iconFamily": "fad", "text": "Target contacts based on information in Quorum" },
                        { "icon": "comment-edit", "iconFamily": "fad", "text": "Customize placeholders to personalize communications" },
                        { "icon": "analytics", "iconFamily": "fad", "text": "Analyze your reach with click rate and reply rate metrics and reports" },
                        { "icon": "mobile-alt", "iconFamily": "fad", "text": "Drive greater campaign activity with 99% text open rates" }
                    ],
                    "splash_paragraph": "Send personalized text messages in bulk and manage your communications with the same system you're using to track the rest of your engagement.",
                    "splash_title": "Communicate with Stakeholders by Text Message",
                    "value": 17
                },
                "outbox": {
                    "empty_state_icon": { "Draft": "envelope", "Email Templates": "file-alt", "Scheduled": "envelope", "Sent": "envelope" },
                    "empty_state_paragraph": { "Draft": "Use Outbox, Quorum's mail feature to email and notify champions and potential champions of events, advocacy opportunities, and legislative priorities.", "Email Templates": "Creating an Outbox Template allows you to compose a draft of your email that you can use again in the future.", "Scheduled": "Use Outbox, Quorum's mail feature to email and notify champions and potential champions of events, advocacy opportunities, and legislative priorities.", "Sent": "Use Outbox, Quorum's mail feature to email and notify champions and potential champions of events, advocacy opportunities, and legislative priorities." },
                    "empty_state_title": { "Draft": "There Aren't Any Drafted Emails", "Email Templates": "There Aren't Any Saved Outbox Templates", "Scheduled": "There Aren't Any Scheduled Emails", "Sent": "Send Your First Email" },
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736828955675-Outbox",
                    "icon": "envelope",
                    "iconFamily": "fad",
                    "key": "outbox",
                    "label": "Outbox",
                    "paths": ["/outbox/:child?/:id?/:tab?"],
                    "splash_cards": [
                        { "icon": "bullseye-arrow", "iconFamily": "fad", "text": "Target contacts based on information in Quorum" },
                        { "icon": "palette", "iconFamily": "fad", "text": "Create and save templates" },
                        { "icon": "comment-edit", "iconFamily": "fad", "text": "Customize placeholders to personalize communications" },
                        { "icon": "analytics", "iconFamily": "fad", "text": "Analyze your reach with open and click rate metrics and reports" }
                    ],
                    "splash_paragraph": "Send personalized emails in bulk and manage your communications with the same system you're using to track the rest of your engagement.",
                    "splash_title": "Communicate with Stakeholders by Email",
                    "value": 8
                },
                "pac": {
                    "icon": "file-invoice-dollar",
                    "iconFamily": "fad",
                    "key": "pac",
                    "label": "PAC",
                    "paths": ["/pacinternal/:id?"],
                    "splash_cards": [
                        { "icon": "hand-holding-usd", "iconFamily": "fad", "text": "Manage financial transactions" },
                        { "icon": "piggy-bank", "iconFamily": "fad", "text": "Reconcile accounts" },
                        { "icon": "file-invoice-dollar", "iconFamily": "fad", "text": "Automatically check for compliance errors" },
                        { "icon": "file-invoice-dollar", "iconFamily": "fad", "text": "File campaign finance reports" }
                    ],
                    "splash_paragraph": "This is where you'll be able to easily manage and report on all your campaign financials.",
                    "splash_title": "Welcome to your PAC Command Center!",
                    "value": 19
                },
                "pac_hybrid": { "icon": "fa-usd", "iconFamily": "fad", "key": "pac_hybrid", "label": "PAC 2.0", "splash_paragraph": "This is where you'll be able to easily manage and report on all your campaign financials.", "splash_title": "Welcome to your PAC Command Center!", "value": 26 },
                "pac_reconciliation": { "empty_state_paragraph": "Create a new reconciliation form to get started.", "empty_state_title": "View Past or In Progress Reconciliation Reports", "icon": "piggy-bank", "iconFamily": "fad", "key": "pac_reconciliation", "label": "Reconciliation", "value": 20 },
                "pac_transaction": { "empty_state_paragraph": "Get started by either uploading or manually entering new receipts and disbursements", "empty_state_title": "View All Account Transactions", "icon": "piggy-bank", "iconFamily": "fad", "key": "pac_transaction", "label": "Transaction", "value": 21 },
                "search": {
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736941408795-Search",
                    "icon": "search",
                    "iconFamily": "fad",
                    "key": "search",
                    "label": "Search",
                    "paths": ["/search/:type?/"],
                    "splash_cards": [
                        { "icon": "sliders-h", "iconFamily": "fad", "text": "Use filters to quickly expand or narrow your search" },
                        { "icon": "chart-bar", "iconFamily": "fad", "text": "Visualize search results to identify new insights and trends" },
                        { "icon": "star", "iconFamily": "fad", "text": "Favorite your frequent searches to find new information faster" },
                        { "icon": "rss", "iconFamily": "fad", "text": "Create alerts for instant updates of bills, regulations, or documents" }
                    ],
                    "splash_paragraph": "Find and filter both Quorum's data and your team's user-generated data to pinpoint information & relevant insight.",
                    "splash_title": "Search, Identify, and Analyze Relevant Information",
                    "value": 9
                },
                "sheets": {
                    "empty_state_paragraph": "Sheets is a smart spreadsheets tool which allows you to track officials, bills, votes, and team members, and share with your team or externally with clients and advocates.",
                    "empty_state_title": "Create A Sheet",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736948390299-Sheets",
                    "icon": "sort-amount-down",
                    "iconFamily": "fad",
                    "key": "sheets",
                    "label": "Sheets",
                    "splash_cards": [
                        { "icon": "table", "iconFamily": "fad", "text": "Build sheets of data, dialogue, interactions, or any other data in Quorum" },
                        { "icon": "chart-line", "iconFamily": "fad", "text": "Visualize spreadsheet data to identify trends" },
                        { "icon": "share-all", "iconFamily": "fad", "text": "Share spreadsheets externally to report on your work" },
                        { "icon": "paint-roller", "iconFamily": "fad", "text": "Add color to sheets data for easy information management" }
                    ],
                    "splash_paragraph": "Create auto-updating and auto-populating spreadsheets to manage information and report on key metrics.",
                    "splash_title": "Work Smarter with Auto-Updating Spreadsheets",
                    "value": 10
                },
                "team_management": { "empty_state_paragraph": "Segment your workflows by creating teams in Quorum to choose which groups of users have access to information within the site.", "empty_state_title": "Manage teams", "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/articles/11043783906075-Account-Admin-Create-and-Manage-Teams", "icon": "users", "iconFamily": "fad", "key": "team_management", "label": "Team Management", "value": 23 },
                "tracking_dashboards": {
                    "empty_state_paragraph": "Tracking boards allow your team to efficiently keep track of relevant legislation and organize it by stance and priority to optimize workflow.",
                    "empty_state_title": "Create A Tracking Board",
                    "helpcenter_url_zendesk": "https://quorumsupport.zendesk.com/hc/en-us/sections/10736971745947-Tracking-Boards",
                    "icon": "tachometer-alt-fast",
                    "iconFamily": "fad",
                    "key": "tracking_dashboards",
                    "label": "Tracking Boards",
                    "paths": ["/tracking_boards/", "/tracking_board/:id/:tab?"],
                    "splash_cards": [
                        { "icon": "tachometer-alt", "iconFamily": "fad", "text": "Dashboards help ensure you never miss new information" },
                        { "icon": "users-class", "iconFamily": "fad", "text": "Move faster with a team-wide system for work, sharing and reporting" },
                        { "icon": "list-ul", "iconFamily": "fad", "text": "Manage your work with a feed that adjusts as you review legislation" },
                        { "icon": "file-chart-pie", "iconFamily": "fad", "text": "Pull end of session reports and metrics" }
                    ],
                    "splash_paragraph": "Build personalized dashboards with your org's stance, priority and issues to make it easy to follow updates to legislation and regulations.",
                    "splash_title": "Legislative and Regulatory Tracking is Fast with Real-Time Tracking Boards",
                    "value": 11
                },
                "uploads": { "empty_state_paragraph": "Bulk uploads allow you to manage custom data by importing information that your organization collects and tracks.", "empty_state_title": "Upload Your Information In Bulk", "icon": "upload", "iconFamily": "fad", "key": "uploads", "label": "Uploads", "value": 14 }
            },
            "LegSession": {
                "__is_model": true,
                "__name__": "LegSession",
                "data_model": "app.models.LegSession",
                "default_exclude_filters": {},
                "default_filters": { "searchable": true },
                "endpoint": "/api/legsession/",
                "fields": [
                    { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                    { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                    { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                    {
                        "_is_enum_field": true,
                        "choices": { "__module__": "app.models", "__name__": "Region" },
                        "field_type": 4,
                        "help_text": "The Region which the session is for.",
                        "name": "region",
                        "verbose_name": "region"
                    },
                    { "field_type": 2, "help_text": "The official title of the session.", "name": "title", "verbose_name": "title" },
                    { "field_type": 21, "help_text": "The beginning date of the session.", "name": "start_date", "verbose_name": "start date" },
                    { "field_type": 21, "help_text": "The ending date of the session.", "name": "end_date", "verbose_name": "end date" },
                    { "field_type": 4, "help_text": "The number of the session.", "name": "number", "verbose_name": "number" },
                    { "field_type": 1, "help_text": "Whether or not the session is regular.", "name": "regular_session", "verbose_name": "regular session" },
                    {
                        "field_type": 7,
                        "help_text": "The Term the Session was part of.",
                        "name": "term",
                        "related_model": { "__module__": "app.models", "__name__": "Term" },
                        "verbose_name": "term"
                    },
                    { "field_type": 2, "help_text": "The display name of session -- for matching with Term for states.", "name": "session_name", "verbose_name": "session name" },
                    { "field_type": null, "help_text": "A dictionary of information that is used during state scraping. willbe different for each state.", "name": "state_info", "verbose_name": "state info" },
                    { "field_type": 2, "help_text": "The abbreviation of the sessions region.", "name": "region_abbrev", "verbose_name": "region abbrev" },
                    { "field_type": 2, "help_text": "The official title of the sessions region.", "name": "region_title", "verbose_name": "region title" },
                    { "field_type": 1, "help_text": "Whether or not the session is the current session.", "name": "current", "verbose_name": "current" },
                    { "field_type": 4, "help_text": "The first real year of this session. A session running 12/1/19 - 12/1/21 would be 2020", "name": "start_year", "verbose_name": "start year" },
                    { "field_type": null, "help_text": "The primary years of this session. A session running 12/1/19-12/1/20 would be [2020].", "name": "primary_years", "verbose_name": "primary years" },
                    { "field_type": null, "help_text": "The date(s) that a bill carries over from one year to the next.", "name": "carryover_dates", "verbose_name": "carryover dates" },
                    { "field_type": 5, "help_text": "The first day of prefiling for this session.", "name": "prefile_start_date", "verbose_name": "prefile start date" },
                    { "field_type": 5, "help_text": "The last day of prefiling for this session.", "name": "prefile_deadline", "verbose_name": "prefile deadline" },
                    { "field_type": 5, "help_text": "The last day for a bill to pass from house/assembly to senate for consideration.", "name": "lower_crossover_deadline", "verbose_name": "lower crossover deadline" },
                    { "field_type": 5, "help_text": "The last day for a bill to pass from senate to house/assembly for consideration.", "name": "upper_crossover_deadline", "verbose_name": "upper crossover deadline" },
                    { "field_type": 5, "help_text": "The last day the executive is allowed to sign a bill from this session into law.", "name": "signing_deadline", "verbose_name": "signing deadline" },
                    { "field_type": 3, "help_text": "Additional information about prefiling for this session", "name": "prefile_notes", "verbose_name": "prefile notes" },
                    { "field_type": 3, "help_text": "Additional information about the start_date for this session", "name": "start_date_notes", "verbose_name": "start date notes" },
                    { "field_type": 3, "help_text": "Additional information about the end_date for this session", "name": "end_date_notes", "verbose_name": "end date notes" },
                    { "field_type": 3, "help_text": "Additional information about the crossover_deadline for this session", "name": "crossover_deadline_notes", "verbose_name": "crossover deadline notes" },
                    { "field_type": 3, "help_text": "Additional information about the signing_deadline for this session", "name": "signing_deadline_notes", "verbose_name": "signing deadline notes" }
                ]
            },
            "LegislativeBody": {
                "__is_enum": true,
                "brazil_chamber_of_deputies": { "abbrev": "BRD", "key": "brazil_chamber_of_deputies", "label": "Brazil Chamber of Deputies", "letter": "D", "value": 140 },
                "brazil_congress": { "abbrev": "BRC", "key": "brazil_congress", "label": "Brazil Congress", "letter": "C", "value": 142 },
                "brazil_president": { "abbrev": "BRP", "key": "brazil_president", "label": "Brazil President", "letter": "P", "value": 143 },
                "brazil_senate": { "abbrev": "BRS", "key": "brazil_senate", "label": "Brazil Senate", "letter": "S", "value": 141 },
                "canada_both": { "abbrev": "CAB", "key": "canada_both", "label": "Canada House and Senate", "value": 112 },
                "canada_house": { "abbrev": "CAH", "key": "canada_house", "label": "Canada House", "letter": "H", "value": 110 },
                "canada_senate": { "abbrev": "CAS", "key": "canada_senate", "label": "Canada Senate", "letter": "S", "value": 111 },
                "eu_commission": { "abbrev": "COM", "key": "eu_commission", "label": "European Commission", "letter": "C", "value": 1 },
                "eu_council": { "abbrev": "CONSIL", "key": "eu_council", "label": "European Council", "letter": "CL", "value": 3 },
                "eu_council_and_parliament": { "abbrev": "C&P", "key": "eu_council_and_parliament", "label": "European Council and Parliament", "letter": "CP", "value": 4 },
                "eu_other": { "abbrev": "Other", "key": "eu_other", "label": "Other", "value": 100 },
                "eu_parliament": { "abbrev": "EP", "key": "eu_parliament", "label": "European Parliament", "letter": "P", "value": 2 },
                "eu_unknown": { "abbrev": "Unknown", "key": "eu_unknown", "label": "Unknown", "value": 101 },
                "france_assemblee_nationale": { "abbrev": "FRAN", "key": "france_assemblee_nationale", "label": "France Assembl\u00e9e Nationale", "letter": "A", "value": 150 },
                "france_commission_mixte_paritaire": { "abbrev": "FRCP", "key": "france_commission_mixte_paritaire", "label": "France Commission Mixte Paritaire", "letter": "CM", "value": 152 },
                "france_conseil_constitutionnel": { "abbrev": "FRCC", "key": "france_conseil_constitutionnel", "label": "France Conseil Constitutionnel", "letter": "C", "value": 153 },
                "france_president": { "abbrev": "FRP", "key": "france_president", "label": "France President", "letter": "P", "value": 154 },
                "france_senat": { "abbrev": "FRSE", "key": "france_senat", "label": "France S\u00e9nat", "letter": "S", "value": 151 },
                "germany_bundesregierung": { "abbrev": "DEBR", "key": "germany_bundesregierung", "label": "Germany Bundesregierung", "letter": "BR", "value": 131 },
                "germany_bundestag": { "abbrev": "DEBT", "key": "germany_bundestag", "label": "Germany Bundestag", "letter": "BT", "value": 130 },
                "spain_congress": { "abbrev": "SPC", "key": "spain_congress", "label": "Spain Congress", "letter": "C", "value": 161 },
                "spain_senate": { "abbrev": "SPS", "key": "spain_senate", "label": "Spain Senate", "letter": "S", "value": 160 },
                "uk_both": { "abbrev": "UKB", "key": "uk_both", "label": "United Kingdom House of Commons and House of Lords", "value": 122 },
                "uk_house_of_commons": { "abbrev": "UKC", "key": "uk_house_of_commons", "label": "United Kingdom House of Commons", "letter": "C", "value": 120 },
                "uk_house_of_lords": { "abbrev": "UKL", "key": "uk_house_of_lords", "label": "United Kingdom House of Lords", "letter": "L", "value": 121 }
            },
            "PermissionType": {
                "__is_enum": true,
                "action_center": { "key": "action_center", "label": "qp_action_center", "value": 201, "visible_in_grassroots": true },
                "action_center_campaigns": { "key": "action_center_campaigns", "label": "qp_action_center_campaigns", "value": 219, "visible_in_grassroots": true },
                "ai_grassroots_messages": { "key": "ai_grassroots_messages", "label": "qp_ai_grassroots_messages", "value": 1033, "visible_in_grassroots": false },
                "ai_outbox_suggestions": { "key": "ai_outbox_suggestions", "label": "qp_ai_outbox_suggestions", "value": 1032, "visible_in_grassroots": false },
                "ai_summaries": { "key": "ai_summaries", "label": "qp_ai_summaries", "value": 1031, "visible_in_grassroots": false },
                "ai_tracking_boards": { "key": "ai_tracking_boards", "label": "qp_ai_tracking_boards", "value": 1034, "visible_in_grassroots": false },
                "campaign_finance": { "key": "campaign_finance", "label": "qp_campaign_finance", "value": 9, "visible_in_grassroots": true },
                "can_access_axios_articles": { "key": "can_access_axios_articles", "label": "can_access_axios_articles", "value": 1013, "visible_in_grassroots": false },
                "can_access_bulk_uploads": { "key": "can_access_bulk_uploads", "label": "can_access_bulk_uploads", "value": 1012, "visible_in_grassroots": false },
                "can_access_campaign_finance": { "key": "can_access_campaign_finance", "label": "can_access_campaign_finance", "value": 1007, "visible_in_grassroots": true },
                "can_access_custom_fields_management": { "key": "can_access_custom_fields_management", "label": "can_access_custom_fields_management", "value": 1004, "visible_in_grassroots": false },
                "can_access_grassroots": { "key": "can_access_grassroots", "label": "can_access_grassroots", "value": 1005, "visible_in_grassroots": false },
                "can_access_issue_management": { "key": "can_access_issue_management", "label": "can_access_issue_management", "value": 1006, "visible_in_grassroots": false },
                "can_access_pac": { "key": "can_access_pac", "label": "can_access_pac", "value": 1011, "visible_in_grassroots": false },
                "can_access_pac_hybrid_dashboard_template": { "key": "can_access_pac_hybrid_dashboard_template", "label": "can_access_pac_hybrid_dashboard_template", "value": 217, "visible_in_grassroots": false },
                "can_access_pac_management": { "key": "can_access_pac_management", "label": "can_access_pac_management", "value": 1014, "visible_in_grassroots": false },
                "can_alter_pac_transactions": { "key": "can_alter_pac_transactions", "label": "can_alter_pac_transactions", "value": 1010, "visible_in_grassroots": false },
                "can_change_action_center_settings": { "key": "can_change_action_center_settings", "label": "can_change_action_center_settings", "value": 1002, "visible_in_grassroots": false },
                "can_see_all_campaigns": { "key": "can_see_all_campaigns", "label": "can_see_all_campaigns", "value": 1003, "visible_in_grassroots": false },
                "can_see_any_previous_outbox_email": { "key": "can_see_any_previous_outbox_email", "label": "can_see_any_previous_outbox_email", "value": 1001, "visible_in_grassroots": false },
                "can_send_from_any_outbox": { "key": "can_send_from_any_outbox", "label": "can_send_from_any_outbox", "value": 1000, "visible_in_grassroots": false },
                "can_view_pac_disbursements": { "key": "can_view_pac_disbursements", "label": "can_view_pac_disbursements", "value": 1009, "visible_in_grassroots": false },
                "can_view_pac_receipts": { "key": "can_view_pac_receipts", "label": "can_view_pac_receipts", "value": 1008, "visible_in_grassroots": false },
                "collaborators": { "key": "collaborators", "label": "qp_collaborators", "value": 221, "visible_in_grassroots": true },
                "consultants": { "key": "consultants", "label": "qp_consultants", "value": 210, "visible_in_grassroots": false },
                "contacts_documents": { "key": "contacts_documents", "label": "qp_contacts_documents", "value": 207, "visible_in_grassroots": false },
                "copilot_analyze": { "key": "copilot_analyze", "label": "qp_copilot_analyze", "value": 1030, "visible_in_grassroots": false },
                "copilot_grassroots": { "key": "copilot_grassroots", "label": "qp_copilot_grassroots", "value": 1035, "visible_in_grassroots": false },
                "copilot_pac": { "key": "copilot_pac", "label": "qp_copilot_pac", "value": 1036, "visible_in_grassroots": false },
                "custom_contacts": { "key": "custom_contacts", "label": "qp_custom_contacts", "value": 204, "visible_in_grassroots": false },
                "custom_data": { "key": "custom_data", "label": "qp_custom_data", "value": 4, "visible_in_grassroots": false },
                "custom_docket": { "key": "custom_docket", "label": "qp_custom_docket", "value": 311, "visible_in_grassroots": true },
                "custom_events": { "key": "custom_events", "label": "qp_custom_events", "value": 206, "visible_in_grassroots": true },
                "custom_outbox": { "key": "custom_outbox", "label": "qp_custom_outbox", "value": 205, "visible_in_grassroots": false },
                "eu": { "key": "eu", "label": "qp_eu", "value": 2, "visible_in_grassroots": false },
                "executives": { "key": "executives", "label": "qp_executives", "value": 301, "visible_in_grassroots": false },
                "external_interactions": { "key": "external_interactions", "label": "qp_external_interactions", "value": 7, "visible_in_grassroots": true },
                "external_relationship": { "key": "external_relationship", "label": "qp_external_relationship", "value": 5, "visible_in_grassroots": true },
                "federal": { "key": "federal", "label": "qp_federal", "value": 1, "visible_in_grassroots": false },
                "grassroots": { "key": "grassroots", "label": "qp_grassroots", "value": 102, "visible_in_grassroots": true },
                "hide_alignment": { "key": "hide_alignment", "label": "qp_hide_alignment", "value": 110, "visible_in_grassroots": false },
                "hide_assignment": { "key": "hide_assignment", "label": "qp_hide_assignment", "value": 112, "visible_in_grassroots": false },
                "hide_priority": { "key": "hide_priority", "label": "qp_hide_priority", "value": 109, "visible_in_grassroots": false },
                "hide_review_status": { "key": "hide_review_status", "label": "qp_hide_review_status", "value": 111, "visible_in_grassroots": false },
                "hide_stance": { "key": "hide_stance", "label": "qp_hide_stance", "value": 108, "visible_in_grassroots": false },
                "internal_relationship": { "key": "internal_relationship", "label": "qp_internal_relationship", "value": 6, "visible_in_grassroots": false },
                "international": { "key": "international", "label": "qp_international", "value": 103, "visible_in_grassroots": false },
                "legislation_page": { "key": "legislation_page", "label": "qp_legislation_page", "value": 203, "visible_in_grassroots": false },
                "legislative_data": { "key": "legislative_data", "label": "qp_legislative_data", "value": 303, "visible_in_grassroots": false },
                "legislative_profiles": { "key": "legislative_profiles", "label": "qp_legislative_profiles", "value": 304, "visible_in_grassroots": false },
                "legislators": { "key": "legislators", "label": "qp_legislators", "value": 300, "visible_in_grassroots": false },
                "live_chat": { "key": "live_chat", "label": "qp_live_chat", "value": 211, "visible_in_grassroots": false },
                "local": { "key": "local", "label": "qp_local", "value": 101, "visible_in_grassroots": false },
                "local_agendas": { "key": "local_agendas", "label": "qp_local_agendas", "value": 212, "visible_in_grassroots": false },
                "media_monitoring": { "key": "media_monitoring", "label": "qp_media_monitoring", "value": 104, "visible_in_grassroots": false },
                "media_relations": { "key": "media_relations", "label": "qp_media_relations", "value": 105, "visible_in_grassroots": false },
                "no_permission_needed": { "key": "no_permission_needed", "label": "qp_no_permission_needed", "value": 0, "visible_in_grassroots": false },
                "not_allowed": { "key": "not_allowed", "label": "not_allowed", "value": 9999, "visible_in_grassroots": false },
                "official_documents": { "key": "official_documents", "label": "qp_official_documents", "value": 305, "visible_in_grassroots": false },
                "officials_outbox": { "key": "officials_outbox", "label": "qp_officials_outbox", "value": 202, "visible_in_grassroots": false },
                "outbound_texting": { "key": "outbound_texting", "label": "qp_outbound_texting", "value": 216, "visible_in_grassroots": false },
                "pac_hybrid": { "key": "pac_hybrid", "label": "qp_pac_hybrid", "value": 215, "visible_in_grassroots": true },
                "pac_hybrid_or_qpac_v1": { "key": "pac_hybrid_or_qpac_v1", "label": "qp_pac_hybrid_or_qpac_v1", "value": 218, "visible_in_grassroots": false },
                "pac_match": { "key": "pac_match", "label": "qp_pac_match", "value": 214, "visible_in_grassroots": true },
                "pac_state_and_local_committees": { "key": "pac_state_and_local_committees", "label": "qp_pac_state_and_local_committees", "value": 213, "visible_in_grassroots": false },
                "pac_sync_supporter_from_pacc": { "key": "pac_sync_supporter_from_pacc", "label": "qp_pac_sync_supporter_from_pacc", "value": 220, "visible_in_grassroots": true },
                "project_management": { "key": "project_management", "label": "qp_project_management", "value": 208, "visible_in_grassroots": false },
                "qpac_v1": { "key": "qpac_v1", "label": "qp_qpac_v1", "value": 8, "visible_in_grassroots": true },
                "regulations": { "key": "regulations", "label": "qp_regulations", "value": 310, "visible_in_grassroots": false },
                "school_boards": { "key": "school_boards", "label": "qp_school_boards", "value": 107, "visible_in_grassroots": false },
                "staffers": { "key": "staffers", "label": "qp_staffers", "value": 302, "visible_in_grassroots": false },
                "stakeholder": { "key": "stakeholder", "label": "qp_stakeholder", "value": 3, "visible_in_grassroots": true },
                "states": { "key": "states", "label": "qp_states", "value": 100, "visible_in_grassroots": false },
                "unique_ids_in_downloads": { "key": "unique_ids_in_downloads", "label": "qp_unique_ids_in_downloads", "value": 209, "visible_in_grassroots": false }
            },
            "PersonaSidebarItem": {
                "__is_enum": true,
                "action_center": {
                    "disable_for_limited": true,
                    "href": "/action_centers/",
                    "icon": "globe",
                    "icon_family": "far",
                    "key": "action_center",
                    "label": "Action Center",
                    "permission_enum": [201, 5, 7, 3],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 7
                },
                "action_center_events": {
                    "disable_for_limited": true,
                    "icon": "thumbtack",
                    "icon_family": "far",
                    "key": "action_center_events",
                    "label": "Events",
                    "permission_enum": [201],
                    "permission_user": ["can_access_grassroots"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 21
                },
                "action_center_issues": {
                    "disable_for_limited": true,
                    "icon": "thumbtack",
                    "icon_family": "far",
                    "key": "action_center_issues",
                    "label": "Issues",
                    "permission_enum": [201, 7, 5],
                    "permission_user": ["can_access_grassroots", "can_access_issue_management"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 20
                },
                "action_center_settings": {
                    "disable_for_limited": true,
                    "icon": "cog",
                    "icon_family": "far",
                    "key": "action_center_settings",
                    "label": "Settings",
                    "permission_enum": [201],
                    "permission_user": ["can_access_grassroots", "can_change_action_center_settings"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 19
                },
                "advanced_search": {
                    "disable_for_limited": true,
                    "href": "/search/",
                    "icon": "search",
                    "icon_family": "far",
                    "key": "advanced_search",
                    "label": "Search",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 1
                },
                "ai_bill_tracker": {
                    "badge": "BETA",
                    "disable_for_limited": true,
                    "href": "/ai_bill_tracker/",
                    "icon": "sparkles",
                    "icon_family": "far",
                    "key": "ai_bill_tracker",
                    "label": "AI Bill Tracker",
                    "permission_enum": [304],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 27
                },
                "campaigns": {
                    "disable_for_limited": true,
                    "icon": "bullhorn",
                    "icon_family": "far",
                    "key": "campaigns",
                    "label": "Campaigns",
                    "permission_enum": [201],
                    "permission_user": ["can_access_grassroots"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 16
                },
                "dashboards": {
                    "disable_for_limited": true,
                    "href": "/dashboard/",
                    "icon": "chart-bar",
                    "icon_family": "far",
                    "key": "dashboards",
                    "label": "Dashboards",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 13
                },
                "districts": {
                    "disable_for_limited": true,
                    "href": "/geographies/",
                    "icon": "globe",
                    "icon_family": "far",
                    "key": "districts",
                    "label": "Districts",
                    "permission_enum": [304],
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "value": 5
                },
                "downloads": {
                    "disable_for_limited": true,
                    "href": "/download_center/",
                    "icon": "cloud-download-alt",
                    "icon_family": "far",
                    "key": "downloads",
                    "label": "Download Center",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 12
                },
                "email_alerts": {
                    "disable_for_limited": true,
                    "href": "/alerts/",
                    "icon": "rss",
                    "icon_family": "far",
                    "key": "email_alerts",
                    "label": "Alert Management",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 2
                },
                "event_management": {
                    "disable_for_limited": true,
                    "href": "/custom_event/",
                    "icon": "calendar-check-o",
                    "icon_family": "far",
                    "key": "event_management",
                    "label": "Event Management",
                    "permission_enum": [206],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 10
                },
                "impact_reports": {
                    "badge": "NEW",
                    "disable_for_limited": true,
                    "href": "/brief_builder/",
                    "icon": "memo-pad",
                    "icon_family": "far",
                    "key": "impact_reports",
                    "label": "Brief Builder",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 26
                },
                "issue_management": {
                    "disable_for_limited": true,
                    "href": "/issue_management/",
                    "icon": "thumbtack",
                    "icon_family": "far",
                    "key": "issue_management",
                    "label": "Issue Management",
                    "permission_enum": [1006],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 9
                },
                "legislative_issues": {
                    "disable_for_limited": true,
                    "href": "/issue/",
                    "icon": "tasks",
                    "icon_family": "far",
                    "key": "legislative_issues",
                    "label": "Legislative Issues",
                    "permission_enum": [304],
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "value": 4
                },
                "outbound_texting": {
                    "disable_for_limited": true,
                    "excluded_by_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 203, 205, 207, 211, 215, 216, 217, 218, 219, 226, 238, 106, 9999, 10003],
                    "href": "/texting/sent/",
                    "icon": "comment",
                    "icon_family": "far",
                    "key": "outbound_texting",
                    "label": "Texting",
                    "permission_enum": [216],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 15
                },
                "outbox": {
                    "disable_for_limited": true,
                    "href": "/outbox/sent",
                    "icon": "envelope-open",
                    "icon_family": "far",
                    "key": "outbox",
                    "label": "Outbox",
                    "permission_enum": [202, 205, 105],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 6
                },
                "pac": {
                    "disable_for_limited": true,
                    "href": "/pacinternal/",
                    "icon": "usd",
                    "icon_family": "far",
                    "key": "pac",
                    "label": "PAC",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 14
                },
                "pac_filing": {
                    "disable_for_limited": true,
                    "key": "pac_filing",
                    "label": "Filings",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 24
                },
                "pac_financial": {
                    "disable_for_limited": true,
                    "key": "pac_financial",
                    "label": "Financial",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 23
                },
                "pac_settings": {
                    "disable_for_limited": true,
                    "key": "pac_settings",
                    "label": "Settings",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 25
                },
                "pac_transaction": {
                    "disable_for_limited": true,
                    "key": "pac_transaction",
                    "label": "PAC Transactions",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 22
                },
                "pages": {
                    "disable_for_limited": true,
                    "icon": "file",
                    "icon_family": "far",
                    "key": "pages",
                    "label": "Pages",
                    "permission_enum": [201],
                    "permission_user": ["can_access_grassroots"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 18
                },
                "registration_forms": {
                    "disable_for_limited": true,
                    "icon": "edit",
                    "icon_family": "far",
                    "key": "registration_forms",
                    "label": "Forms",
                    "permission_enum": [201],
                    "permission_user": ["can_access_grassroots"],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 17
                },
                "sheets": {
                    "disable_for_limited": true,
                    "href": "/sheets/",
                    "icon": "sort-amount-down",
                    "icon_family": "far",
                    "key": "sheets",
                    "label": "Sheets",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 8
                },
                "tracking_dashboards": {
                    "disable_for_limited": true,
                    "href": "/tracking_boards/",
                    "icon": "tachometer-alt-fast",
                    "icon_family": "far",
                    "key": "tracking_dashboards",
                    "label": "Tracking Boards",
                    "permission_enum": [304, 310, 305],
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 11
                }
            },
            "QuorumDataType": {
                "__is_enum": true,
                "account": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.Account",
                    "description": "",
                    "display_key": "id",
                    "download_center": false,
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "account",
                    "label": "Account",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Accounts",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Account",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 131
                },
                "account_reconciliation": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.AccountReconciliation",
                    "description": "",
                    "display_key": "reconciliation_display_key",
                    "download_center": false,
                    "feature": 20,
                    "fts": false,
                    "icon": "fa-money",
                    "issues_management": false,
                    "key": "account_reconciliation",
                    "label": "Reconciliation",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Reconciliations",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Reconciliation",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 112
                },
                "action_center_settings": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.grassroots.models.ActionCenterSettings",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "bullhorn",
                    "fts": false,
                    "icon": "fa-bullhorn",
                    "iconColor": "#503ABD",
                    "issues_management": false,
                    "key": "action_center_settings",
                    "label": "Action Center",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [201],
                    "plural": "Action Centers",
                    "precision_max_threshold": 50000,
                    "profile": "/action_centers/",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Action Center",
                    "sort_key": "",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 99
                },
                "alert": {
                    "advanced_search": true,
                    "advanced_search_order": 16,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.alerts.models.Alert",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "rss",
                    "fa5_icon_family": "fas",
                    "feature": 5,
                    "fts": false,
                    "icon": "fa-rss",
                    "issues_management": false,
                    "key": "alert",
                    "label": "Alert",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [0],
                    "plural": "Alerts",
                    "precision_max_threshold": 50000,
                    "profile": "/alert/alert/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "alert",
                    "related_pk_field": "alert_id",
                    "search_description": { "1": "All email alerts you've received from Quorum.", "10000": "All email alerts you've received from Quorum.", "10001": "All email alerts you've received from Quorum.", "10002": "All email alerts you've received from Quorum.", "10003": "All email alerts you've received from Quorum.", "10004": "All email alerts you've received from Quorum.", "106": "All email alerts you've received from Quorum.", "9999": "All email alerts you've received from Quorum." },
                    "search_url": "alerts/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Alert",
                    "sort_key": "title",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 74
                },
                "alignment_type": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.stakeholder.models.AlignmentType",
                    "description": "",
                    "display_key": "label",
                    "download_center": false,
                    "fa5_icon": "thumbs-up",
                    "fts": false,
                    "icon": "fa-thumbs-o-up",
                    "issues_management": false,
                    "key": "alignment_type",
                    "label": "Alignment Type",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Alignment Types",
                    "precision_max_threshold": 50000,
                    "profile": "/alignmenttypes/edit/",
                    "quicksearch": false,
                    "quicksearch_key": "label",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Alignment Type",
                    "sort_key": "order",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 116
                },
                "amendment": {
                    "advanced_search": true,
                    "advanced_search_order": 10,
                    "archivable": false,
                    "assignment": true,
                    "comments": "referencing_amendments",
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.bill.models.Amendment",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "paperclip",
                    "fa5_icon_family": "fal",
                    "fts": true,
                    "icon": "fa-paperclip",
                    "issues_management": true,
                    "key": "amendment",
                    "label": "Amendment",
                    "legislative_priority": false,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "amendments",
                    "permission_enum": [304],
                    "plural": "Amendments",
                    "precision_max_threshold": 50000,
                    "profile": "/amendment/",
                    "proxy_resource_data_model": "app.bill.models.NewAmendment",
                    "quicksearch": true,
                    "quicksearch_key": "title",
                    "quicksearch_order": 6,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "amendment",
                    "related_pk_field": "amendment_id",
                    "search_description": { "1": "Amendments proposed by Members of Congress.", "10000": "Amendments proposed by Members of Congress.", "10001": "", "10002": "", "10003": "", "10004": "", "106": "", "9999": "Amendments proposed by Members of the US Congress." },
                    "search_url": "amendments/",
                    "sheet_order": 7,
                    "sheet_row_values": ["id", "title"],
                    "sheets": true,
                    "singular": "Amendment",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": true,
                    "undelete": false,
                    "value": 4
                },
                "article_topic": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.media_monitoring.models.ArticleTopic",
                    "description": "",
                    "display_key": "topic",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-newspaper-o",
                    "issues_management": false,
                    "key": "article_topic",
                    "label": "Media Topic",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [104],
                    "plural": "News Articles Topics",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "News Article Topic",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 108
                },
                "assignment": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.Assignment",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fa5_icon": "user-circle",
                    "fts": false,
                    "icon": "fa-user-circle",
                    "issues_management": false,
                    "key": "assignment",
                    "label": "Assignment",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [0],
                    "plural": "Assignments",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_order": 100,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "assignment",
                    "search_url": "assignments/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Assignment",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 75
                },
                "attachment": {
                    "advanced_search": true,
                    "advanced_search_order": 13,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.userdata.models.NonOutboxAttachment",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "folder-open",
                    "fa5_icon_family": "far",
                    "fts": true,
                    "icon": "fa-folder-open-o",
                    "issues_management": false,
                    "key": "attachment",
                    "label": "Attachment",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [3],
                    "plural": "Files",
                    "precision_max_threshold": 50000,
                    "profile": "/file/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "attachment",
                    "related_pk_field": "attachment_id",
                    "search_description": { "1": "Files that your team has uploaded to Quorum.", "10000": "Files that your team has uploaded to Quorum.", "10001": "Files that your team has uploaded to Quorum.", "10002": "Files that your team has uploaded to Quorum.", "10003": "Files that your team has uploaded to Quorum.", "10004": "Files that your team has uploaded to Quorum.", "106": "Files that your team has uploaded to Quorum.", "9999": "Files that your team has uploaded to Quorum." },
                    "search_url": "files/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "File",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 62
                },
                "bill": {
                    "advanced_search": true,
                    "advanced_search_order": 0,
                    "archivable": false,
                    "assignment": true,
                    "comments": "involving_bills",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "bill",
                    "custom_lists": true,
                    "data_model": "app.bill.models.Bill",
                    "description": "",
                    "display_key": "title",
                    "download_center": true,
                    "fa5_icon": "file-alt",
                    "fa5_icon_family": "fal",
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "issues_management": true,
                    "key": "bill",
                    "label": "Bill",
                    "legislative_priority": true,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "bills",
                    "party_frequency_request_key": "for_parties",
                    "permission_enum": [304],
                    "person_frequency_request_key": "sponsored_or_cosponsored_by_or",
                    "plural": "Bills",
                    "precision_max_threshold": 55000,
                    "profile": "/bill/",
                    "proxy_resource_data_model": "app.bill.models.NewBill",
                    "quicksearch": true,
                    "quicksearch_key": "title",
                    "quicksearch_order": 1,
                    "quicksearch_subtitle": ["current_general_status", "current_status_date"],
                    "region_specific_dict": {
                        "Romania": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "argentina": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "australia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "belgium": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "brazil": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "canada": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "chile": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "china": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "colombia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "costa_rica": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "czechia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "denmark": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "dominican_republic": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "eu": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "france": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "germany": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "greece": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "hong_kong": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "india": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "indonesia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "international": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "ireland": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "israel": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "italy": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "japan": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "malaysia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "mexico": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "netherlands": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "new_zealand": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "panama": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "philippines": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "poland": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "saudi_arabia": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "singapore": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "south_africa": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "south_korea": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "spain": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "sweden": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "taiwan": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "thailand": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "turkey": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "united_arab_emirates": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "united_kingdom": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "user_global": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" },
                        "vietnam": { "label": "Legislation", "plural": "Legislation", "singular": "Legislation" }
                    },
                    "related_field": "bill",
                    "related_pk_field": "bill_id",
                    "search_description": { "1": "Bills and resolutions introduced in the US Congress.", "10000": "Bills and resolutions introduced in the US Congress, the US states, DC, and Puerto Rico.", "10001": "Bills and resolutions introduced in the US states, DC, and Puerto Rico.", "10002": "Legislation from your available regions.", "10003": "Legislation introduced at the national level.", "10004": "Bills and resolutions introduced in the US states, DC, and Puerto Rico.", "106": "Directives, regulations, and decisions from the European Union.", "9999": "Legislation from your available regions." },
                    "search_url": "bills/",
                    "sheet_order": 5,
                    "sheet_row_values": ["id", "title"],
                    "sheets": true,
                    "singular": "Bill",
                    "sort_key": "number",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106, 201, 203, 204, 208, 205, 211, 1000],
                    "supports_alert": true,
                    "supports_alert_changes": true,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": true,
                    "undelete": false,
                    "value": 2
                },
                "bill_tracking_project": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.BillTrackingProject",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-map-signs",
                    "issues_management": false,
                    "key": "bill_tracking_project",
                    "label": "Bill Tracking Project",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "projects",
                    "permission_enum": [304],
                    "plural": "Bill Tracking Projects",
                    "precision_max_threshold": 50000,
                    "profile": "/bill_tracking_project/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "project",
                    "related_pk_field": "project_id",
                    "sheet_row_values": ["id", "name"],
                    "sheets": false,
                    "singular": "Bill Tracking Project",
                    "sort_key": "name",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 72
                },
                "blank_download": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.pdfdownload.models.NewDownloadTemplate",
                    "description": "",
                    "download_center": true,
                    "fa5_icon": "file",
                    "fts": false,
                    "icon": "fa-columns",
                    "issues_management": false,
                    "key": "blank_download",
                    "label": "Blank",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304, 4],
                    "plural": "Blank",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Blank",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 102
                },
                "bulk_action": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.search.bulkactions.models.BulkAction",
                    "description": "",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-tasks",
                    "issues_management": false,
                    "key": "bulk_action",
                    "label": "Bulk Action",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Bulk Actions",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Bulk Action",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 90
                },
                "bulk_email": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.outbox.models.bulk_email.BulkEmail",
                    "description": "",
                    "display_key": "subject",
                    "download_center": false,
                    "fa5_icon": "envelope",
                    "fa5_icon_family": "fas",
                    "feature": 8,
                    "fts": false,
                    "icon": "fa-envelope",
                    "issues_management": true,
                    "key": "bulk_email",
                    "label": "Bulk Email",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "bulk_emails",
                    "permission_enum": [202, 205],
                    "plural": "Outbox",
                    "precision_max_threshold": 50000,
                    "profile": "/outbox/details/",
                    "quicksearch": false,
                    "quicksearch_key": "subject",
                    "quicksearch_subtitle": ["bulk_email"],
                    "region_specific_dict": {},
                    "related_field": "bulk_email",
                    "related_pk_field": "bulk_email_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Outbox",
                    "sort_key": "subject",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 44
                },
                "bulk_sms": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.texting.models.BulkSMS",
                    "description": "",
                    "display_key": "description",
                    "download_center": false,
                    "fa5_icon": "mobile-alt",
                    "fa5_icon_family": "fas",
                    "feature": 17,
                    "fts": false,
                    "icon": "fa-mobile",
                    "issues_management": true,
                    "key": "bulk_sms",
                    "label": "Bulk SMS",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "bulksms_messages",
                    "permission_enum": [216],
                    "plural": "Texts",
                    "precision_max_threshold": 50000,
                    "profile": "/texting/details/",
                    "quicksearch": false,
                    "quicksearch_key": "description",
                    "quicksearch_subtitle": ["bulk_sms"],
                    "region_specific_dict": {},
                    "related_field": "bulk_sms",
                    "related_pk_field": "bulk_sms_id",
                    "search_url": "texting/",
                    "sheet_order": 16,
                    "sheet_row_values": ["id", "description"],
                    "sheets": true,
                    "singular": "Text",
                    "sort_key": "description",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 113
                },
                "bulk_upload": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.custom_data.models.BulkUploadFile",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "upload",
                    "feature": 14,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "bulk_upload",
                    "label": "Bulk Upload",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Bulk Uploads",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "bulk_upload_file",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Bulk Upload",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 70
                },
                "campaign": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.grassroots.campaign.models.Campaign",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "bullhorn",
                    "fa5_icon_family": "fas",
                    "feature": 15,
                    "fts": false,
                    "icon": "fa-bullhorn",
                    "issues_management": false,
                    "key": "campaign",
                    "label": "Campaign",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "campaigns",
                    "permission_enum": [219],
                    "plural": "Campaigns",
                    "precision_max_threshold": 50000,
                    "profile": "/grassroots_campaign/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": ["name"],
                    "region_specific_dict": {},
                    "related_field": "campaign",
                    "related_pk_field": "campaign_id",
                    "sheet_order": 9,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "Campaign",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 47
                },
                "caucus": {
                    "advanced_search": true,
                    "advanced_search_order": 12,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.committee.models.Caucus",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "edit",
                    "fa5_icon_family": "far",
                    "fts": false,
                    "icon": "fa-pencil-square-o",
                    "issues_management": true,
                    "key": "caucus",
                    "label": "Caucus",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [300],
                    "plural": "Caucuses",
                    "precision_max_threshold": 50000,
                    "profile": "/caucus/",
                    "quicksearch": true,
                    "quicksearch_key": "name",
                    "quicksearch_order": 4,
                    "quicksearch_subtitle": ["chairs_string"],
                    "region_specific_dict": {},
                    "related_field": "committee",
                    "related_pk_field": "committee_id",
                    "search_description": { "1": "Congressional caucuses.", "10000": "Congressional caucuses.", "10001": "", "10002": "", "10003": "", "10004": "", "106": "", "9999": "US Congrsessional caucuses." },
                    "search_url": "caucuses/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Caucus",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 16
                },
                "cbo_report": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.CBOReport",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "issues_management": false,
                    "key": "cbo_report",
                    "label": "CBO Report",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [305],
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 23
                },
                "cf_committee": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.moneyball.models.CommitteesSuggester",
                    "description": "",
                    "display_key": "cf_committee_id",
                    "download_center": false,
                    "fa5_icon": "gavel",
                    "fts": false,
                    "icon": "fa-gavel",
                    "issues_management": false,
                    "key": "cf_committee",
                    "label": "CF_Committee",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [9, 1007],
                    "plural": "Committees",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Committee",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 133
                },
                "committee": {
                    "advanced_search": true,
                    "advanced_search_order": 11,
                    "archivable": false,
                    "assignment": true,
                    "comments": false,
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "committee",
                    "custom_lists": true,
                    "data_model": "app.committee.models.Committee",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "gavel",
                    "fts": false,
                    "icon": "fa-gavel",
                    "issues_management": true,
                    "key": "committee",
                    "label": "Committee",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "committees",
                    "permission_enum": [300],
                    "plural": "Committees",
                    "precision_max_threshold": 50000,
                    "profile": "/committee/",
                    "quicksearch": true,
                    "quicksearch_key": "fullname",
                    "quicksearch_order": 3,
                    "quicksearch_subtitle": ["chairs_string"],
                    "region_specific_dict": {},
                    "related_field": "committee",
                    "related_pk_field": "committee_id",
                    "search_description": { "1": "Congressional committees and subcomittees.", "10000": "Congressional and state legislative committees and subcomittees.", "10001": "State legislative committees and subcomittees.", "10002": "", "10003": "", "10004": "State legislative committees and subcomittees.", "106": "European Parliament Committees.", "9999": "US congressional and state legislative committees and subcomittees." },
                    "search_url": "committees/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Committee",
                    "sort_key": "name",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 15
                },
                "committee_document": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Document",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-file-text-o",
                    "is_subset_of": 25,
                    "issues_management": false,
                    "key": "committee_document",
                    "label": "Committee Hearing Document",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [305],
                    "plural": "Hearings",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 12,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 17
                },
                "committee_meeting": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Document",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": false,
                    "is_subset_of": 25,
                    "issues_management": false,
                    "key": "committee_meeting",
                    "label": "Committee Meeting",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 13,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 18
                },
                "committee_opinion": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.CommitteeOpinion",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "committee_opinion",
                    "label": "Committee Opinion",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "plural": "Committee Opinions",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Committee Opinion",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 55
                },
                "committee_report": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Document",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "is_subset_of": 25,
                    "issues_management": false,
                    "key": "committee_report",
                    "label": "Committee Report",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304],
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000, 106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 34
                },
                "constituent_email": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.ConstituentEmail",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-inbox",
                    "issues_management": false,
                    "key": "constituent_email",
                    "label": "Newsletter to Constituents",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [305],
                    "plural": "Newsletters to Constituents",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Newsletter to Constituents",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 24
                },
                "crs_report": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.CRSReport",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "issues_management": false,
                    "key": "crs_report",
                    "label": "CRS Report",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [305],
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 22
                },
                "custom_data": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.custom_data.manage_data.models.CustomData",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "cubes",
                    "fts": false,
                    "icon": "fa-cubes",
                    "issues_management": false,
                    "key": "custom_data",
                    "label": "Footprint Data",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [4],
                    "plural": "Footprint Data",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "related_field": "custom_data",
                    "sheet_order": 10,
                    "sheet_row_values": ["id", "name", "additional_info"],
                    "sheets": true,
                    "singular": "Footprint Data",
                    "sort_key": "",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 79
                },
                "custom_event": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": true,
                    "comments": false,
                    "custom_fields": true,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "custom_event",
                    "custom_lists": false,
                    "data_model": "app.custom_event.models.CustomEvent",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "calendar-check",
                    "fa5_icon_family": "far",
                    "feature": 6,
                    "fts": false,
                    "icon": "fa-calendar-check-o",
                    "issues_management": true,
                    "key": "custom_event",
                    "label": "Custom Event",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "custom_event",
                    "permission_enum": [206],
                    "plural": "Events",
                    "precision_max_threshold": 50000,
                    "profile": "/custom_event/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "custom_event",
                    "related_pk_field": "custom_event_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Event",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 85
                },
                "custom_event_participant": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.custom_event.models.CustomEventParticipant",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-calendar-check-o",
                    "issues_management": false,
                    "key": "custom_event_participant",
                    "label": "Custom Event Participant",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Event Participants",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "search_url": "custom_event/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Event Participant",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 86
                },
                "custom_field": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.grassroots.models.CustomTag",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "address-card",
                    "fa5_icon_family": "far",
                    "feature": 3,
                    "fts": false,
                    "icon": "fa-address-card-o",
                    "issues_management": false,
                    "key": "custom_field",
                    "label": "Custom Field",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Custom Fields",
                    "precision_max_threshold": 50000,
                    "profile": "/customfields/edit/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "custom_field",
                    "related_pk_field": "custom_field_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Custom Field",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 73
                },
                "custom_field_group": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.custom_field.models.CustomFieldGroup",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "layer-group",
                    "fa5_icon_family": "far",
                    "feature": 24,
                    "fts": false,
                    "icon": "fa-layer-group",
                    "issues_management": false,
                    "key": "custom_field_group",
                    "label": "Custom Field Group",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Custom Field Groups",
                    "precision_max_threshold": 50000,
                    "profile": "/custom_field_groups/edit/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Custom Field Group",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 124
                },
                "custom_interaction_type": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.notes.models.CustomInteractionType",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "handshake",
                    "fts": false,
                    "icon": "fa-handshake-o",
                    "issues_management": false,
                    "key": "custom_interaction_type",
                    "label": "Custom Interaction Type",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Interaction Types",
                    "precision_max_threshold": 50000,
                    "profile": "/interactiontypes/edit/",
                    "quicksearch": false,
                    "quicksearch_key": "title",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Interaction Type",
                    "sort_key": "order",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 106
                },
                "custom_region": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.userdata.models.CustomRegionSelection",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "map-marked-alt",
                    "fa5_icon_family": "fas",
                    "feature": 12,
                    "fts": false,
                    "icon": "fa-star",
                    "issues_management": false,
                    "key": "custom_region",
                    "label": "Custom Region",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Custom Regions",
                    "precision_max_threshold": 50000,
                    "profile": "/custom_regions/",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "related_field": "custom_region_selection",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Custom Region",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 87
                },
                "dashboard": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.widgets.models.Dashboard",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "dashboard-small",
                    "fa5_icon_family": "q",
                    "feature": 16,
                    "fts": false,
                    "icon": "fa-dashboard",
                    "issues_management": false,
                    "key": "dashboard",
                    "label": "Dashboard",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Dashboards",
                    "precision_max_threshold": 50000,
                    "profile": "/dashboard/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Dashboard",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 104
                },
                "dc_letter": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.DCLetter",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-paper-plane-o",
                    "issues_management": false,
                    "key": "dc_letter",
                    "label": "Dear Colleague Letter",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Dear Colleague Letters",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 11,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Dear Colleague Letter",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 10
                },
                "disbursement": {
                    "advanced_search": true,
                    "advanced_search_order": 23,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.moneyball.models.Disbursement",
                    "description": "",
                    "display_key": "spender_name",
                    "download_center": false,
                    "fa5_icon": "dollar-sign",
                    "fts": false,
                    "icon": "fa-money",
                    "issues_management": false,
                    "key": "disbursement",
                    "label": "Disbursement",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [9, 1007],
                    "plural": "Disbursements",
                    "precision_max_threshold": 50000,
                    "profile": "/disbursement/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "search_description": { "1": "Campaign finance disbursements.", "10000": "Campaign finance disbursements.", "10001": "Campaign finance disbursements.", "10002": "Campaign finance disbursements.", "10003": "Campaign finance disbursements.", "10004": "Campaign finance disbursements.", "106": "Campaign finance disbursements.", "9999": "" },
                    "search_url": "disbursements/",
                    "sheet_row_values": ["id", "spender_name"],
                    "sheets": false,
                    "singular": "Disburser",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 125
                },
                "district": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.geography.models.District",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "building",
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "district",
                    "label": "District",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Districts",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_order": 14,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "District",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 109
                },
                "docket": {
                    "advanced_search": true,
                    "advanced_search_order": 20,
                    "archivable": false,
                    "assignment": true,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "docket",
                    "custom_lists": false,
                    "data_model": "app.reg.models.Docket",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "folders",
                    "fts": true,
                    "icon": "fa-folder-open",
                    "issues_management": false,
                    "key": "docket",
                    "label": "Docket",
                    "legislative_priority": true,
                    "legislative_stance": true,
                    "lists": false,
                    "note_through_field": "dockets",
                    "permission_enum": [310],
                    "plural": "Dockets",
                    "precision_max_threshold": 50000,
                    "profile": "/docket/",
                    "quicksearch": false,
                    "quicksearch_key": "title",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "docket",
                    "related_pk_field": "docket_id",
                    "search_description": { "1": "Nonrulemaking and rulemaking dockets", "10000": "Federal nonrulemaking and rulemaking dockets.", "10001": "", "10002": "", "10003": "", "10004": "", "106": "", "9999": "US Federal nonrulemaking and rulemaking dockets." },
                    "search_url": "dockets/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Docket",
                    "sort_key": "updated",
                    "supported_regions": [1],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 88
                },
                "document": {
                    "advanced_search": true,
                    "advanced_search_order": 1,
                    "archivable": false,
                    "assignment": false,
                    "comments": true,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.document.models.Document",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fa5_icon": "file-audio",
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": true,
                    "key": "document",
                    "label": "Document",
                    "legislative_priority": false,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "documents",
                    "party_frequency_request_key": "party",
                    "permission_enum": [305, 207, 105],
                    "person_frequency_request_key": "source_members",
                    "plural": "Documents",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "proxy_resource_data_model": "app.document.models.NewDocument",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_frequency_request_key": "for_regions",
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "search_description": { "1": "Statements, social media, reports, executive orders, and other document types.", "10000": "Statements, social media, reports, executive orders, and other document types.", "10001": "Statements, social media, executive orders, newsletters to constiuents, and other document types.", "10002": "Statements, social media, newsletters to constiuents, and other document types.", "10003": "Social media, including twitter, facebook, and youtube posts.", "10004": "Statements, social media, executive orders, newsletters to constiuents, and other document types.", "106": "Statements, Social Media, Reports, and dozens of other document types.", "9999": "Statements, social media, reports, and more from stakeholders." },
                    "search_url": "documents/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Document",
                    "sort_key": "title",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": true,
                    "undelete": false,
                    "value": 25
                },
                "document_section": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.DocumentSection",
                    "description": "",
                    "display_key": "text",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "document_section",
                    "label": "Document Section",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 36
                },
                "election": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac.models.election.Election",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "podium",
                    "fa5_icon_family": "fad",
                    "fts": false,
                    "icon": "fad-podium",
                    "issues_management": false,
                    "key": "election",
                    "label": "Election",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8, 9],
                    "plural": "Elections",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "election",
                    "related_pk_field": "election_id",
                    "search_description": { "1": "US elections.", "10000": "US elections.", "10001": "US elections.", "10002": "", "10003": "", "10004": "US elections.", "106": "", "9999": "" },
                    "search_url": "elections/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Election",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 123
                },
                "email_template": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.userdata.outbox.models.email_template.EmailTemplate",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "copy",
                    "fa5_icon_family": "fal",
                    "feature": 8,
                    "fts": false,
                    "icon": "fa-copy",
                    "issues_management": false,
                    "key": "email_template",
                    "label": "Email Template",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [202, 205],
                    "plural": "Email Templates",
                    "precision_max_threshold": 50000,
                    "profile": "/outbox/create_template/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Email Template",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 118
                },
                "event": {
                    "advanced_search": true,
                    "advanced_search_order": 7,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.events.models.Event",
                    "description": "",
                    "display_key": "subject",
                    "download_center": false,
                    "fa5_icon": "calendar-alt",
                    "fts": false,
                    "icon": "fa-calendar",
                    "issues_management": true,
                    "key": "event",
                    "label": "Official Event",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "events",
                    "permission_enum": [304],
                    "plural": "Official Events",
                    "precision_max_threshold": 1e+06,
                    "profile": "/event/",
                    "proxy_resource_data_model": "app.events.models.NewEvent",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "event",
                    "related_pk_field": "event_id",
                    "search_description": { "1": "Congressional floor schedule, committee meetings, session dates, election dates, and other events.", "10000": "Congressional and state legislative committee meetings, session dates and deadlines, election dates, city and county government meetings, and other events.", "10001": "State legislative committee meetings, session dates and deadlines, election dates, and other events.", "10002": "City council meetings, county board meetings, and other local government events.", "10003": "", "10004": "State legislative committee meetings, session and elections dates, cities, counties, and city councils.", "106": "European Council and Council of the EU Official Events.", "9999": "" },
                    "search_url": "events/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Official Event",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 28
                },
                "event_participant": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.custom_event.models.CustomEventParticipant",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-user",
                    "issues_management": false,
                    "key": "event_participant",
                    "label": "Event Participant",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Participants",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Participant",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 58
                },
                "executive": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.person.models.Executive",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-user",
                    "issues_management": false,
                    "key": "executive",
                    "label": "Executive",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [301],
                    "plural": "Executives",
                    "precision_max_threshold": 50000,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Executive",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 30
                },
                "executive_order": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.ExecutiveOrder",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "executive_order",
                    "label": "Executive Order",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Executive Orders",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Executive Order",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 64
                },
                "facebook_post": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.FacebookPost",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-facebook",
                    "issues_management": false,
                    "key": "facebook_post",
                    "label": "Facebook Post",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Facebook Posts",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 14,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Facebook Post",
                    "sort_key": "content",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 9
                },
                "fact_sheet": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.FactSheet",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "fact_sheet",
                    "label": "Fact Sheet",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Fact Sheets",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Fact Sheet",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 145
                },
                "feature": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.blog.models.FeatureType",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-tasks",
                    "issues_management": false,
                    "key": "feature",
                    "label": "Feature",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Features",
                    "precision_max_threshold": 50000,
                    "profile": "/help/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Features",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 93
                },
                "feature_flag": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.featureflags.models.FeatureFlag",
                    "description": "",
                    "display_key": "slug",
                    "download_center": false,
                    "fa5_icon": "flag-alt",
                    "fa5_icon_family": "fas",
                    "fts": false,
                    "icon": "fa-flag",
                    "issues_management": false,
                    "key": "feature_flag",
                    "label": "Feature Flag",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Feature Flags",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "slug",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Feature Flag",
                    "sort_key": "slug",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 84
                },
                "floor_schedule": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.events.models.FloorSchedule",
                    "description": "",
                    "display_key": "subject",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-calendar-check-o",
                    "issues_management": false,
                    "key": "floor_schedule",
                    "label": "Floor Schedule",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Floor Schedules",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Floor Schedule",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 26
                },
                "floor_statement": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.FloorStatement",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "floor_statement",
                    "label": "Floor Statement",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Floor Statements",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 9,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Floor Statement",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 7
                },
                "gao_report": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.GAOReport",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "issues_management": false,
                    "key": "gao_report",
                    "label": "GAO Report",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [305],
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 21
                },
                "geoshape": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.geography.models.GeoShape",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "fa5_icon": "compass",
                    "fts": false,
                    "icon": "fa-compass",
                    "issues_management": false,
                    "key": "geoshape",
                    "label": "GeoShape",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Geographies",
                    "precision_max_threshold": 50000,
                    "profile": "/geoshape/",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Geography",
                    "sort_key": "",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 97
                },
                "grassroots_action": {
                    "advanced_search": true,
                    "advanced_search_order": 6,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": true,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "action",
                    "custom_lists": true,
                    "data_model": "app.grassroots.models.GrassrootsSupporterAction",
                    "description": "",
                    "display_key": "raw_content",
                    "download_center": false,
                    "fa5_icon": "comments",
                    "fts": false,
                    "icon": "fa-comments-o",
                    "issues_management": false,
                    "key": "grassroots_action",
                    "label": "Action",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [201],
                    "person_frequency_request_key": "involving_member",
                    "plural": "Actions",
                    "precision_max_threshold": 50000,
                    "profile": "/grassrootsaction/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_frequency_request_key": "for_regions",
                    "region_specific_dict": {},
                    "search_description": { "1": "Grassroots Actions Taken by Your Organization's Advocates.", "10000": "Grassroots Actions Taken by Your Organization's Advocates.", "10001": "Grassroots Actions Taken by Your Organization's Advocates.", "10002": "Grassroots Actions Taken by Your Organization's Advocates.", "10003": "Grassroots Actions Taken by Your Organization's Advocates.", "10004": "Grassroots Actions Taken by Your Organization's Advocates.", "106": "Grassroots Actions Taken by Your Organization's Advocates.", "9999": "Grassroots Actions Taken by Your Organization's Advocates." },
                    "search_url": "grassroots/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Action",
                    "sort_key": "text",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "type_frequency_request_key": "interaction_type__in",
                    "undelete": false,
                    "value": 69
                },
                "grassroots_page": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.grassroots.models.QuorumGrassrootsPage",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "file",
                    "fts": false,
                    "icon": "fa-files-o",
                    "issues_management": false,
                    "key": "grassroots_page",
                    "label": "Grassroots Page",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "pages",
                    "permission_enum": [201],
                    "plural": "Pages",
                    "precision_max_threshold": 50000,
                    "profile": "/pages/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pages",
                    "related_pk_field": "page_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Page",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 98
                },
                "grassroots_registration_page": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.grassroots.models.GrassrootsRegistrationPage",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "edit",
                    "fa5_icon_family": "fas",
                    "fts": false,
                    "icon": "fa-pencil-square-o",
                    "issues_management": false,
                    "key": "grassroots_registration_page",
                    "label": "Grassroots Registration Page",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "registration_pages",
                    "permission_enum": [201],
                    "plural": "Forms",
                    "precision_max_threshold": 50000,
                    "profile": "/registration_forms/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "registration_pages",
                    "related_pk_field": "registration_page_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Form",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 96
                },
                "help_center_post": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.blog.models.HelpCenterPost",
                    "description": "",
                    "display_key": "post",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-newspaper-o",
                    "issues_management": false,
                    "key": "help_center_post",
                    "label": "Help Center Post",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Posts",
                    "precision_max_threshold": 50000,
                    "profile": "/help/how-to/",
                    "quicksearch": true,
                    "quicksearch_key": "title",
                    "quicksearch_order": 0,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Post",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 77
                },
                "impact_report_download": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.impact_reports.models.download.Download",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 25,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "impact_report_download",
                    "label": "Brief Builder Download",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Brief Builder Downloads",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "download",
                    "related_pk_field": "download_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Brief Builder Download",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 141
                },
                "instagram_post": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.InstagramPost",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-instagram",
                    "issues_management": false,
                    "key": "instagram_post",
                    "label": "Instagram Post",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Instagram Posts",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Instagram Post",
                    "sort_key": "content",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 39
                },
                "internal_cspan_event": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.events.models.InternalCspanEvent",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-calendar",
                    "issues_management": false,
                    "key": "internal_cspan_event",
                    "label": "InternalCspanEvent",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "precision_max_threshold": 50000,
                    "profile": "/event_cspan/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 37
                },
                "issue": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.bill.models.BillTerm",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-tasks",
                    "issues_management": false,
                    "key": "issue",
                    "label": "Legislative Issues",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304],
                    "plural": "Issues",
                    "precision_max_threshold": 50000,
                    "profile": "/issue/",
                    "quicksearch": true,
                    "quicksearch_key": "name",
                    "quicksearch_order": 2,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Issue",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 14
                },
                "issue_management": {
                    "advanced_search": false,
                    "advanced_search_order": 17,
                    "archivable": true,
                    "assignment": false,
                    "comments": "for_project_and_subprojects",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "issue",
                    "custom_lists": false,
                    "data_model": "app.userdata.models.IssueManagement",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "fa5_icon": "thumbtack",
                    "fa5_icon_family": "fas",
                    "feature": 7,
                    "fts": false,
                    "icon": "fa-thumb-tack",
                    "issues_management": false,
                    "key": "issue_management",
                    "label": "Issue Management",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "projects",
                    "plural": "Issues",
                    "precision_max_threshold": 50000,
                    "profile": "/issue_management/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "project",
                    "related_pk_field": "project_id",
                    "sheet_order": 12,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "Issue",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": true,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 83
                },
                "learning_module": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.blog.models.LearningModule",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-graduation-cap",
                    "issues_management": false,
                    "key": "learning_module",
                    "label": "Learning Module",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Learning Modules",
                    "precision_max_threshold": 50000,
                    "profile": "/help/module/",
                    "quicksearch": true,
                    "quicksearch_key": "name",
                    "quicksearch_order": 1,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Learning Module",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 92
                },
                "ledger_settings": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.LedgerSettings",
                    "description": "",
                    "display_key": "ledger_settings",
                    "download_center": false,
                    "fa5_icon": "file",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "ledger_settings",
                    "label": "Ledger Settings",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Ledger Settings'",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "ledger_settings",
                    "related_pk_field": "ledger_settings_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Ledger Settings",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 128
                },
                "leg_session": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.models.LegSession",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 9,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "leg_session",
                    "label": "Legislative Session",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Legislative Sessions",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "session",
                    "related_pk_field": "session_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Legislative Session",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 142
                },
                "legislator": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": true,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.person.models.Person",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "event_participant_key": "person_participant",
                    "fts": false,
                    "icon": "fa-address-book",
                    "is_subset_of": 1,
                    "issues_management": true,
                    "key": "legislator",
                    "label": "Legislator",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "members",
                    "permission_enum": [300],
                    "plural": "Officials",
                    "precision_max_threshold": 50000,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "quicksearch_key": "quicksearch_name",
                    "quicksearch_order": 16,
                    "quicksearch_subtitle": ["most_recent_person_type", "committee_string", "title", "primary_organization_name"],
                    "region_specific_dict": {},
                    "related_field": "person",
                    "related_pk_field": "person_id",
                    "sheet_row_values": ["id", "name", "image_url", "most_recent_party"],
                    "sheets": false,
                    "singular": "Official",
                    "sort_key": "lastname",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 66
                },
                "letter": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.document.models.Letter",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-envelope",
                    "issues_management": false,
                    "key": "letter",
                    "label": "Letter",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [305],
                    "plural": "Letters",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Letter",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 40
                },
                "live_transcript_document": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.events.models.Event",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-video-o",
                    "issues_management": false,
                    "key": "live_transcript_document",
                    "label": "Live Transcript Document",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [1],
                    "plural": "Live Transcript Documents",
                    "precision_max_threshold": 50000,
                    "profile": "/event_cspan/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Live Transcript Document",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 35
                },
                "local_member": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.person.models.LocalMember",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-user",
                    "issues_management": false,
                    "key": "local_member",
                    "label": "Local Member",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [300],
                    "precision_max_threshold": 50000,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 33
                },
                "media": {
                    "advanced_search": true,
                    "advanced_search_order": 21,
                    "archivable": false,
                    "assignment": false,
                    "comments": true,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.media_monitoring.models.Article",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "newspaper",
                    "fts": false,
                    "icon": "fa-newspaper-o",
                    "issues_management": true,
                    "key": "media",
                    "label": "News",
                    "legislative_priority": true,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "articles",
                    "permission_enum": [104],
                    "plural": "News Articles",
                    "precision_max_threshold": 50000,
                    "profile": "/article/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "article",
                    "related_pk_field": "article_id",
                    "search_description": { "1": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "10000": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "10001": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "10002": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "10003": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "10004": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "106": "News Articles, Blogs, Print, Broadcast Transcripts, Podcast stored by Quorum.", "9999": "News articles, including print and online, broadcast transcripts, blogs, and more, from your available regions." },
                    "search_url": "articles/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "News Article",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": true,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": true,
                    "undelete": false,
                    "value": 105
                },
                "medium_post": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.MediumPost",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-medium",
                    "issues_management": false,
                    "key": "medium_post",
                    "label": "Medium Post",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Medium Posts",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Medium Post",
                    "sort_key": "content",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 38
                },
                "member": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": true,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.person.models.Person",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-street-view",
                    "is_subset_of": 1,
                    "issues_management": true,
                    "key": "member",
                    "label": "Member",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "members",
                    "permission_enum": [300],
                    "precision_max_threshold": 50000,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "related_field": "person",
                    "related_pk_field": "person_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 29
                },
                "memorandum": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Memorandum",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "memorandum",
                    "label": "Presidential Memorandum",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [305],
                    "plural": "Presidential Memoranda",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Presidential Memorandum",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 68
                },
                "message_event": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.outbox.models.message_event.MessageEvent",
                    "description": "",
                    "display_key": "event_name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-envelope-o",
                    "issues_management": false,
                    "key": "message_event",
                    "label": "Message Event",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "message_events",
                    "plural": "Message Events",
                    "precision_max_threshold": 50000,
                    "profile": "/message_event/",
                    "quicksearch": false,
                    "quicksearch_key": "event_name",
                    "quicksearch_subtitle": ["message_event"],
                    "region_specific_dict": {},
                    "related_field": "message_event",
                    "related_pk_field": "message_event_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Message Events",
                    "sort_key": "event_name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 46
                },
                "motion_for_resolution": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.MotionForResolution",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "motion_for_resolution",
                    "label": "Motion for Resolution",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Motions for Resolution",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Motion for Resolution",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 54
                },
                "new_download_template": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.pdfdownload.models.NewDownloadTemplate",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "cloud-download-alt",
                    "fa5_icon_family": "fas",
                    "feature": 4,
                    "fts": false,
                    "icon": "fa-columns",
                    "issues_management": false,
                    "key": "new_download_template",
                    "label": "Download",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304, 4],
                    "plural": "Downloads",
                    "precision_max_threshold": 50000,
                    "profile": "/downloadcenter/",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Download",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 100
                },
                "new_list": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.NewList",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-list",
                    "issues_management": false,
                    "key": "new_list",
                    "label": "New List",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Lists",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "List",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 91
                },
                "new_pdf_email": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pdfdownload.models.NewPDFEmail",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "download",
                    "feature": 4,
                    "fts": false,
                    "icon": "fa-envelope-o",
                    "issues_management": false,
                    "key": "new_pdf_email",
                    "label": "New Pdf Email",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "PDF Downloads",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PDF Download",
                    "sort_key": "title",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 103
                },
                "nomination": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Nomination",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "nomination",
                    "label": "Presidential Nomination",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [304],
                    "plural": "Presidential Nominations",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Presidential Nomination",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 71
                },
                "note": {
                    "advanced_search": true,
                    "advanced_search_order": 5,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": true,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "note",
                    "custom_lists": true,
                    "data_model": "app.userdata.notes.models.Note",
                    "description": "",
                    "display_key": "raw_content",
                    "download_center": false,
                    "fa5_icon": "pencil-alt",
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": true,
                    "key": "note",
                    "label": "Note",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "notes",
                    "permission_enum": [6, 5, 7],
                    "person_frequency_request_key": "involving_member",
                    "plural": "Notes",
                    "precision_max_threshold": 50000,
                    "profile": "/note/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_frequency_request_key": "for_regions",
                    "region_specific_dict": {},
                    "related_field": "note",
                    "related_pk_field": "note_id",
                    "search_description": { "1": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "10000": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "10001": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "10002": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "10003": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "10004": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "106": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team.", "9999": "Interactions, Meetings, Relationships, Comments and Custom Notes Logged by Your Team." },
                    "search_url": "notes/",
                    "sheet_order": 15,
                    "sheet_row_values": ["id", "raw_content", "cache_json", "note_type"],
                    "sheets": true,
                    "singular": "Note",
                    "sort_key": "text",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "type_frequency_request_key": "interaction_type__in",
                    "undelete": true,
                    "value": 20
                },
                "organization": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.Organization",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "building",
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "organization",
                    "label": "Organization",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Organizations",
                    "precision_max_threshold": 50000,
                    "profile": "/edit_org/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Organization",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 63
                },
                "outlet": {
                    "advanced_search": false,
                    "advanced_search_order": 25,
                    "archivable": false,
                    "assignment": false,
                    "comments": "involving_public_organization_and_associated_individuals",
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "outlet",
                    "custom_lists": false,
                    "data_model": "app.person.models.PublicOrganization",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "event_participant_key": "public_organization_participant",
                    "fa5_icon": "building",
                    "fa5_icon_family": "far",
                    "fts": false,
                    "icon": "fa-building-o",
                    "issues_management": false,
                    "key": "outlet",
                    "label": "Outlet",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "public_organizations",
                    "permission_enum": [105, 104],
                    "plural": "Outlets",
                    "precision_max_threshold": 50000,
                    "profile": "/outlet/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_order": 23,
                    "quicksearch_subtitle": ["public_organization"],
                    "region_specific_dict": {},
                    "related_field": "public_organization",
                    "related_pk_field": "public_organization_id",
                    "search_url": "outlets/",
                    "sheet_row_values": ["id"],
                    "sheets": false,
                    "singular": "Outlet",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 121
                },
                "pac_filings": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac.models.pac_file.PacFile",
                    "description": "",
                    "display_key": "filing_display_key",
                    "download_center": false,
                    "fa5_icon": "file-alt",
                    "feature": 18,
                    "fts": false,
                    "icon": "fa-file",
                    "issues_management": false,
                    "key": "pac_filings",
                    "label": "PAC Filing",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Filings",
                    "precision_max_threshold": 50000,
                    "profile": "/filing/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pac_file",
                    "related_pk_field": "pac_file_id",
                    "search_url": "filings/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Filing",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 110
                },
                "pac_jurisdiction": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.LedgerReportingJurisdiction",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fa5_icon": "file",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "pac_jurisdiction",
                    "label": "Reporting Jurisdiction",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Reporting Jurisdictions",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "reporting_jurisdictions",
                    "related_pk_field": "reporting_jurisdictions_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Reporting Jurisdiction",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 132
                },
                "pacc_bank_account": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac_classic.models.bank_account.PacClassicBankAccount",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "pencil",
                    "fa5_icon_family": "far",
                    "feature": 26,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "pacc_bank_account",
                    "label": "Bank Account (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "Bank Accounts (PAC)",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "bank_account",
                    "related_pk_field": "bank_account_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Bank Account",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 136
                },
                "pacc_election": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac_classic.models.election.PacClassicElection",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "podium",
                    "fa5_icon_family": "fad",
                    "feature": 26,
                    "fts": false,
                    "icon": "fad-podium",
                    "issues_management": false,
                    "key": "pacc_election",
                    "label": "Election (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "Elections (PAC)",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "election",
                    "related_pk_field": "election_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Election",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 137
                },
                "pacc_organization": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac_classic.models.organization.PacClassicOrganization",
                    "description": "",
                    "display_key": "full_name",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 26,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "pacc_organization",
                    "label": "Organization (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "Organizations (PAC)",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pac_classic_organization",
                    "related_pk_field": "pac_classic_organization_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Organization",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 139
                },
                "pacc_pac_account": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac.models.pacc_pac_account.PACCPACAccount",
                    "description": "",
                    "display_key": "id",
                    "download_center": false,
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "pacc_pac_account",
                    "label": "PACC PAC Account",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "PACC PAC Accounts",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PACC PAC Account",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 130
                },
                "pacc_pac_office": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac_classic.models.office.PacClassicPacOffice",
                    "description": "",
                    "display_key": "name_with_juris",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 26,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "pacc_pac_office",
                    "label": "Elected Office (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "Elected Offices (PAC)",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pac_classic_pac_office",
                    "related_pk_field": "pac_classic_pac_office_id",
                    "search_url": "elected-offices/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Elected Office",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 140
                },
                "pacc_pac_organization": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac_classic.models.pac_organization.PacClassicPacOrganization",
                    "description": "",
                    "display_key": "organization_name",
                    "download_center": false,
                    "fa5_icon": "dollar-sign",
                    "fa5_icon_family": "far",
                    "feature": 26,
                    "fts": false,
                    "icon": "fa-usd",
                    "issues_management": false,
                    "key": "pacc_pac_organization",
                    "label": "PAC Organization (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "PAC Organizations",
                    "precision_max_threshold": 50000,
                    "profile": "/pac-organization/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pac_classic_pac_organization",
                    "related_pk_field": "pac_classic_pac_organization_id",
                    "search_url": "pac-organization",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PAC Organization",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 138
                },
                "pacc_pac_transaction": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.pac_classic.models.transaction.PacClassicPacTransaction",
                    "description": "",
                    "display_key": "entity_name",
                    "download_center": false,
                    "fa5_icon": "money-bill",
                    "fa5_icon_family": "far",
                    "feature": 26,
                    "fts": false,
                    "icon": "fa-money",
                    "issues_management": false,
                    "key": "pacc_pac_transaction",
                    "label": "Transaction (PAC)",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [215],
                    "plural": "PAC Transactions",
                    "precision_max_threshold": 50000,
                    "profile": "/pac-transaction/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "search_description": { "1": "PAC 2.0 Receipts, Disbursements, and Refunds.", "10000": "PAC 2.0 Receipts, Disbursements, and Refunds.", "10001": "PAC 2.0 Receipts, Disbursements, and Refunds.", "10002": "PAC 2.0 Receipts, Disbursements, and Refunds.", "10004": "PAC 2.0 Receipts, Disbursements, and Refunds.", "9999": "PAC 2.0 Receipts, Disbursements, and Refunds." },
                    "search_url": "pac-transactions/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 135
                },
                "pacc_report_request": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac.state_pac.models.pacc_report_request.PACCReportRequest",
                    "description": "",
                    "display_key": "id",
                    "download_center": false,
                    "fa5_icon": "upload",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "pacc_report_request",
                    "label": "PACC Report Request",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "PACC Report Requests",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pacc_report_request",
                    "related_pk_field": "pacc_report_request_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PACC Report Requests",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 129
                },
                "pacc_sync_log": {
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.pac.pacc_sync.models.PACCSyncLog",
                    "description": "",
                    "display_key": "id",
                    "download_center": false,
                    "fa5_icon": "upload",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-pencil",
                    "issues_management": false,
                    "key": "pacc_sync_log",
                    "label": "PACC Sync Log",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "PACC Sync Logs",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "pacc_sync_log",
                    "related_pk_field": "pacc_sync_log_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PACC Sync Log",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 127
                },
                "parliamentary_question": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.ParliamentaryQuestion",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "parliamentary_question",
                    "label": "Parliamentary Question",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Parliamentary Questions",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Parliamentary Question",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 50
                },
                "pdf_email": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.generatepdf.models.PDFEmail",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "download",
                    "feature": 13,
                    "fts": false,
                    "icon": "fa-envelope-o",
                    "issues_management": false,
                    "key": "pdf_email",
                    "label": "Pdf Email",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "send_emails",
                    "plural": "PDF Downloads",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "title",
                    "quicksearch_subtitle": ["send_email"],
                    "region_specific_dict": {},
                    "related_field": "send_email",
                    "related_pk_field": "send_email_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "PDF Download",
                    "sort_key": "title",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 48
                },
                "person": {
                    "advanced_search": true,
                    "advanced_search_order": 2,
                    "archivable": false,
                    "assignment": true,
                    "comments": "involving_member",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "official",
                    "custom_lists": true,
                    "data_model": "app.person.models.Person",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "event_participant_key": "person_participant",
                    "fa5_icon": "users",
                    "fts": false,
                    "icon": "fa-users",
                    "issues_management": true,
                    "key": "person",
                    "label": "Person",
                    "legislative_priority": true,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "members",
                    "outbox_selection_styling": "blue-tag-2",
                    "permission_enum": [300],
                    "plural": "Officials",
                    "precision_max_threshold": 1e+06,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": true,
                    "quicksearch_key": "quicksearch_name",
                    "quicksearch_order": 0,
                    "quicksearch_subtitle": ["most_recent_person_type", "committee_string", "title", "primary_organization_name"],
                    "region_specific_dict": {},
                    "related_field": "person",
                    "related_pk_field": "person_id",
                    "search_description": { "1": "Members of Congress and officials who work in the executive branch.", "10000": "Members of Congress, state legislators, executive branch officials, city and county officials, and other officials.", "10001": "State legislators, statewide elected officials, and other state officials.", "10002": "City and county officials.", "10003": "Elected and appointed officials.", "10004": "State legislators, statewide elected officials, and other state officials.", "106": "Officials and Staff from the European Union institutions, including MEPs, Commissioners, Council Ministers and Permanent Representation Attach\u00e9s as well as relevant staff members.", "9999": "Elected and appointed officials from your available regions." },
                    "search_url": "officials/",
                    "sheet_order": 0,
                    "sheet_row_values": ["id", "name", "image_url", "most_recent_party", "organization"],
                    "sheets": true,
                    "singular": "Official",
                    "sort_key": "lastname",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": true,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 1
                },
                "person_biography": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.person.models.PersonBiography",
                    "description": "",
                    "display_key": "person",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 9,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "person_biography",
                    "label": "Person Role",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Person Biography",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "biography",
                    "related_pk_field": "biography_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Person Biography",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 144
                },
                "person_role": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.person.models.PersonRole",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "building",
                    "feature": 9,
                    "fts": false,
                    "icon": "fa-building",
                    "issues_management": false,
                    "key": "person_role",
                    "label": "Person Role",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Person Role",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "most_recent_role",
                    "related_pk_field": "most_recent_role_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Person Role",
                    "sort_key": "id",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 143
                },
                "political_committee": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.pac.models.political_committee.PoliticalCommittee",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "dollar-sign",
                    "fa5_icon_family": "far",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-usd",
                    "issues_management": false,
                    "key": "political_committee",
                    "label": "Political Committee",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [8, 9],
                    "plural": "Political Committees",
                    "precision_max_threshold": 50000,
                    "profile": "/political_committee/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "political_committee",
                    "related_pk_field": "political_committee_id",
                    "search_description": { "1": "PACs, Candidate Committees, Party Committees, JFC's and more.", "10000": "PACs, Candidate Committees, Party Committees, JFC's and more.", "10001": "PACs, Candidate Committees, Party Committees, JFC's and more.", "10002": "PACs, Candidate Committees, Party Committees, JFC's and more.", "10003": "PACs, Candidate Committees, Party Committees, JFC's and more.", "10004": "PACs, Candidate Committees, Party Committees, JFC's and more.", "106": "PACs, Candidate Committees, Party Committees, JFC's and more.", "9999": "US PACs, Candidate Committees, Party Committees, JFC's, and more." },
                    "search_url": "political_committees/",
                    "sheet_order": 42,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "Political Committee",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 114
                },
                "potential_duplicates": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.deduplication.models.PotentialDuplicate",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fa5_icon": "object-ungroup",
                    "fa5_icon_family": "fal",
                    "feature": 22,
                    "fts": false,
                    "icon": "fa-object-ungroup",
                    "issues_management": false,
                    "key": "potential_duplicates",
                    "label": "Potential Duplicate",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Potential Duplicates",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Potential Duplicate",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 117
                },
                "press_briefing": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.PressBriefing",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "press_briefing",
                    "label": "Press Briefing",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Press Briefings",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Press Briefing",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 65
                },
                "press_contact": {
                    "advanced_search": true,
                    "advanced_search_order": 24,
                    "archivable": false,
                    "assignment": true,
                    "comments": "involving_member",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "press",
                    "custom_lists": true,
                    "data_model": "app.person.models.Person",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "fa5_icon": "microphone",
                    "fa5_icon_family": "fas",
                    "fts": false,
                    "icon": "fa-microphone",
                    "issues_management": true,
                    "key": "press_contact",
                    "label": "Press Contact",
                    "legislative_priority": true,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "members",
                    "outbox_selection_styling": "blue-tag-2",
                    "permission_enum": [105],
                    "plural": "Press Contacts",
                    "precision_max_threshold": 50000,
                    "profile": "/press/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "quicksearch_key": "quicksearch_name",
                    "quicksearch_order": 0,
                    "quicksearch_subtitle": ["most_recent_person_type"],
                    "region_specific_dict": {},
                    "related_field": "person",
                    "related_pk_field": "person_id",
                    "search_description": { "1": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "10000": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "10001": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "10002": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "10003": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "10004": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "106": "Reporters, Editors, Producers, News Anchors, and other members of the media.", "9999": "Reporters, Editors, Producers, News Anchors, and other members of the media." },
                    "search_url": "press/",
                    "sheet_order": 2,
                    "sheet_row_values": ["id", "image_url", "name"],
                    "sheets": true,
                    "singular": "Press",
                    "sort_key": "lastname",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": true,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 120
                },
                "press_release": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.PressRelease",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "press_release",
                    "label": "Press Release",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Press Releases",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Press Release",
                    "sort_key": "title",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 5
                },
                "proclamation": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Proclamation",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "proclamation",
                    "label": "White House Proclamation",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [305],
                    "plural": "White House Proclamations",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "White House Proclamation",
                    "sort_key": "title",
                    "supported_regions": [1, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 67
                },
                "project": {
                    "advanced_search": false,
                    "advanced_search_order": 17,
                    "archivable": true,
                    "assignment": true,
                    "comments": "for_project_and_subprojects",
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.Project",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-map-signs",
                    "issues_management": false,
                    "key": "project",
                    "label": "Issue",
                    "legislative_priority": true,
                    "legislative_stance": true,
                    "lists": false,
                    "note_through_field": "projects",
                    "plural": "Issues",
                    "precision_max_threshold": 50000,
                    "profile": "/issue_management/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "project",
                    "related_pk_field": "project_id",
                    "sheet_row_values": ["id", "name"],
                    "sheets": false,
                    "singular": "Issue",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 49
                },
                "public_organization": {
                    "advanced_search": true,
                    "advanced_search_order": 14,
                    "archivable": true,
                    "assignment": true,
                    "comments": "involving_public_organization_and_associated_individuals",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "organization",
                    "custom_lists": true,
                    "data_model": "app.person.models.PublicOrganization",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "event_participant_key": "public_organization_participant",
                    "fa5_icon": "building",
                    "fa5_icon_family": "far",
                    "fts": false,
                    "icon": "fa-building-o",
                    "issues_management": true,
                    "key": "public_organization",
                    "label": "Organization",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "public_organizations",
                    "permission_enum": [301, 204, 105, 104],
                    "plural": "Organizations",
                    "precision_max_threshold": 1e+06,
                    "profile": "/organization/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_order": 8,
                    "quicksearch_subtitle": ["public_organization"],
                    "region_specific_dict": {},
                    "related_field": "public_organization",
                    "related_pk_field": "public_organization_id",
                    "search_description": { "1": "Federal departments, independent agencies, other legislative or government bodies, and custom orgs.", "10000": "Legislatures, departments, agencies, cities, counties, city councils, county boards, other legislative or government bodies, and custom orgs.", "10001": "State legislatures, departments, agencies, other legislative or government bodies, and custom orgs.", "10002": "Cities, counties, city councils, county boards, other local government bodies, and custom orgs.", "10003": "National governments, legislative bodies, political parties, and other official and custom orgs.", "10004": "State legislatures, departments, agencies, other legislative or government bodies, and custom orgs.", "106": "Official European Union Organizations and Custom Organizations.", "9999": "" },
                    "search_url": "orgs/",
                    "sheet_order": 3,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "Organization",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 42
                },
                "receipt": {
                    "advanced_search": true,
                    "advanced_search_order": 22,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.moneyball.models.Receipt",
                    "description": "",
                    "display_key": "donor_name",
                    "download_center": false,
                    "fa5_icon": "dollar-sign",
                    "fts": false,
                    "icon": "fa-dollar",
                    "issues_management": false,
                    "key": "receipt",
                    "label": "Receipt",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [9, 1007],
                    "plural": "Receipts",
                    "precision_max_threshold": 50000,
                    "profile": "/receipt/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "search_description": { "1": "Campaign finance receipts.", "10000": "Campaign finance receipts.", "10001": "Campaign finance receipts.", "10002": "Campaign finance receipts.", "10003": "Campaign finance receipts.", "10004": "Campaign finance receipts.", "106": "Campaign finance receipts.", "9999": "" },
                    "search_url": "receipts/",
                    "sheet_row_values": ["id", "donor_name"],
                    "sheets": false,
                    "singular": "Contributor",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 126
                },
                "reg_comment": {
                    "advanced_search": false,
                    "advanced_search_order": 19,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "reg_comment",
                    "custom_lists": false,
                    "data_model": "app.reg.models.RegComment",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fa5_icon": "comment-edit",
                    "fts": true,
                    "icon": "fa-bullhorn",
                    "issues_management": false,
                    "key": "reg_comment",
                    "label": "Comment on Regulation",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [310],
                    "plural": "Comments on Regulations",
                    "precision_max_threshold": 50000,
                    "profile": "/reg_comment/",
                    "quicksearch": false,
                    "quicksearch_key": "title",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "reg_comment",
                    "related_pk_field": "reg_comment_id",
                    "search_url": "reg_comments/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Comment on Regulation",
                    "sort_key": "posted_by_agency_datetime",
                    "supported_regions": [1],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 95
                },
                "register": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.reg.models.Register",
                    "description": "",
                    "display_key": "title",
                    "download_center": false,
                    "fts": false,
                    "issues_management": false,
                    "key": "register",
                    "label": "Register",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Registers",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Register",
                    "sort_key": "date",
                    "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 1],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 81
                },
                "regulation": {
                    "advanced_search": true,
                    "advanced_search_order": 10,
                    "archivable": false,
                    "assignment": true,
                    "comments": true,
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "regulation",
                    "custom_lists": true,
                    "data_model": "app.reg.models.Regulation",
                    "description": "",
                    "display_key": "title",
                    "download_center": true,
                    "fa5_icon": "book",
                    "fts": true,
                    "icon": "fa-book",
                    "issues_management": true,
                    "key": "regulation",
                    "label": "Regulation",
                    "legislative_priority": true,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "regulations",
                    "permission_enum": [310],
                    "plural": "Regulations",
                    "precision_max_threshold": 50000,
                    "profile": "/regulation/",
                    "quicksearch": false,
                    "quicksearch_key": "title",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "regulation",
                    "related_pk_field": "regulation_id",
                    "search_description": { "1": "Federal rules, proposed rules, notices, and other regulatory documents.", "10000": "Federal and state rules, proposed rules, and other regulatory documents.", "10001": "State rules, proposed rules, and other regulatory documents.", "10002": "", "10003": "Proposed or adopted rules and regulations at the national level.", "10004": "State rules, proposed rules, and other regulatory documents.", "106": "", "201": "Canada statutory instruments.", "9999": "US federal and state rules, proposed rules, and other regulatory documents." },
                    "search_url": "regs/",
                    "sheet_order": 13,
                    "sheet_row_values": ["id", "title"],
                    "sheets": true,
                    "singular": "Regulation",
                    "sort_key": "proposal_date",
                    "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 1, 204, 201, 203, 208, 205, 211],
                    "supports_alert": true,
                    "supports_alert_changes": true,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": true,
                    "undelete": false,
                    "value": 80
                },
                "reply_email": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.outbox.models.reply_email.ReplyEmail",
                    "description": "",
                    "display_key": "subject",
                    "download_center": false,
                    "fa5_icon": "envelope-square",
                    "fts": false,
                    "icon": "fa-envelope-square",
                    "issues_management": false,
                    "key": "reply_email",
                    "label": "Reply Email",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "replies",
                    "permission_enum": [202, 205],
                    "plural": "Replies",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "subject",
                    "quicksearch_subtitle": ["reply_email"],
                    "region_specific_dict": {},
                    "related_field": "reply_email",
                    "related_pk_field": "reply_email_id",
                    "search_url": "replies/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Reply",
                    "sort_key": "subject",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 101
                },
                "saved_search": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.SafedSearch",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-search",
                    "issues_management": false,
                    "key": "saved_search",
                    "label": "Saved Search",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Searches",
                    "precision_max_threshold": 50000,
                    "profile": "/search/",
                    "quicksearch": false,
                    "quicksearch_order": 0,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Search",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 76
                },
                "send_email": {
                    "advanced_search": true,
                    "advanced_search_order": 18,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.userdata.outbox.models.send_email.SendEmail",
                    "description": "Filter individuals based on the emails you\u2019ve sent them via Outbox over the last 12 months - whether they\u2019ve opened, clicked or replied to your emails.",
                    "display_key": "recipient_name",
                    "download_center": false,
                    "fa5_icon": "envelope",
                    "fts": false,
                    "icon": "fa-envelope-o",
                    "issues_management": false,
                    "key": "send_email",
                    "label": "Send Email",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "send_emails",
                    "permission_enum": [202, 205, 105],
                    "plural": "Outbox (Recipients)",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "recipient_name",
                    "quicksearch_subtitle": ["send_email"],
                    "region_specific_dict": {},
                    "related_field": "send_email",
                    "related_pk_field": "send_email_id",
                    "search_description": { "1": "Outbox emails that your organization has sent.", "10000": "Outbox emails that your organization has sent.", "10001": "Outbox emails that your organization has sent.", "10002": "Outbox emails that your organization has sent.", "10003": "Outbox emails that your organization has sent.", "10004": "Outbox emails that your organization has sent.", "106": "Outbox emails that your organization has sent.", "9999": "Outbox emails that your organization has sent." },
                    "search_url": "outbox/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Outbox (Recipient)",
                    "sort_key": "recipient_name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 45
                },
                "send_email_archived": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.userdata.outbox.models.send_email.SendEmailArchived",
                    "description": "Filter individuals based on the emails you\u2019ve sent them via Outbox beyond the last 12 months - whether they\u2019ve opened, clicked or replied to your emails.",
                    "display_key": "recipient_name",
                    "download_center": false,
                    "fa5_icon": "envelope",
                    "fts": false,
                    "icon": "fa-envelope-o",
                    "issues_management": false,
                    "key": "send_email_archived",
                    "label": "Send Email Archived",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "archived_send_emails",
                    "permission_enum": [202, 205, 105],
                    "plural": "Outbox (Recipients) Archived",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_key": "recipient_name",
                    "quicksearch_subtitle": ["archived_send_email"],
                    "region_specific_dict": {},
                    "related_field": "archived_send_email",
                    "related_pk_field": "archived_send_email_id",
                    "search_description": { "1": "Outbox emails that your organization has sent beyond the last 12 months.", "10000": "Outbox emails that your organization has sent beyond the last 12 months.", "10001": "Outbox emails that your organization has sent beyond the last 12 months.", "10002": "Outbox emails that your organization has sent beyond the last 12 months.", "10003": "Outbox emails that your organization has sent beyond the last 12 months.", "10004": "Outbox emails that your organization has sent beyond the last 12 months.", "106": "Outbox emails that your organization has sent beyond the last 12 months.", "9999": "Outbox emails that your organization has sent beyond the last 12 months." },
                    "search_url": "outbox/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Outbox (Recipient) Archived",
                    "sort_key": "recipient_name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 134
                },
                "send_sms": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.texting.models.SendSMS",
                    "description": "",
                    "display_key": "supporter_name",
                    "download_center": false,
                    "fa5_icon": "mobile-alt",
                    "fa5_icon_family": "fas",
                    "feature": 17,
                    "fts": false,
                    "icon": "fa-mobile",
                    "issues_management": false,
                    "key": "send_sms",
                    "label": "Send SMS",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "sendsms_messages",
                    "permission_enum": [216],
                    "plural": "Outbound Texting (Recipients)",
                    "precision_max_threshold": 50000,
                    "profile": "/send_sms/",
                    "quicksearch": false,
                    "quicksearch_key": "recipient_name",
                    "quicksearch_subtitle": ["bulk_sms"],
                    "region_specific_dict": {},
                    "related_field": "sendsms_message",
                    "related_pk_field": "sendsms_message_id",
                    "search_url": "send_sms/",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Outbound Texting (Recipients)",
                    "sort_key": "recipient_name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 119
                },
                "sheet": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.spreadsheet.models.Sheet",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "sort-amount-down",
                    "fa5_icon_family": "far",
                    "feature": 10,
                    "fts": false,
                    "icon": "fa-sort-amount-desc",
                    "issues_management": false,
                    "key": "sheet",
                    "label": "Sheet",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Sheets",
                    "precision_max_threshold": 50000,
                    "profile": "/sheet/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "sheet",
                    "sheet_row_values": ["id", "name"],
                    "sheets": false,
                    "singular": "Sheet",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 78
                },
                "sms_message": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.texting.models.SMSMessage",
                    "description": "",
                    "display_key": "associated_number",
                    "download_center": false,
                    "fa5_icon": "mobile-alt",
                    "fa5_icon_family": "fas",
                    "feature": 17,
                    "fts": false,
                    "icon": "fa-mobile",
                    "issues_management": false,
                    "key": "sms_message",
                    "label": "SMS Message",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "sms_messages",
                    "permission_enum": [201],
                    "plural": "Outbound Texting (Recipients and Replies)",
                    "precision_max_threshold": 50000,
                    "profile": "/sms_message/",
                    "quicksearch": false,
                    "quicksearch_key": "recipient_name",
                    "quicksearch_subtitle": ["bulk_sms"],
                    "region_specific_dict": {},
                    "related_field": "sms_message",
                    "related_pk_field": "sms_message_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Outbound Texting (Recipients and Replies)",
                    "sort_key": "recipient_name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 115
                },
                "speech": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Speech",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-audio-o",
                    "issues_management": false,
                    "key": "speech",
                    "label": "Speech",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Speeches",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Speech",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 43
                },
                "speech_in_plenary": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.SpeechInPlenary",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "speech_in_plenary",
                    "label": "Speech in Plenary",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Speeches in Plenary",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Speech in Plenary",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 56
                },
                "staffer": {
                    "advanced_search": true,
                    "advanced_search_order": 3,
                    "archivable": false,
                    "assignment": true,
                    "comments": "involving_member",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": true,
                    "custom_fields_url_pattern": "staffer",
                    "custom_lists": true,
                    "data_model": "app.person.models.Person",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "fa5_icon": "address-card",
                    "fa5_icon_family": "far",
                    "fts": false,
                    "icon": "fa-address-card-o",
                    "is_subset_of": 1,
                    "issues_management": true,
                    "key": "staffer",
                    "label": "Staffer",
                    "legislative_priority": true,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "members",
                    "outbox_selection_styling": "blue-tag-2",
                    "permission_enum": [302],
                    "plural": "Staffers",
                    "precision_max_threshold": 50000,
                    "profile": "/official/",
                    "proxy_resource_data_model": "app.person.models.NewPerson",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_order": 3,
                    "quicksearch_subtitle": ["title", "member", "committee"],
                    "region_specific_dict": {
                        "Romania": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "argentina": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "australia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "belgium": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "brazil": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "canada": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "chile": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "china": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "colombia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "costa_rica": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "czechia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "denmark": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "dominican_republic": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "eu": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "france": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "germany": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "greece": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "hong_kong": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "india": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "indonesia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "international": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "ireland": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "israel": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "italy": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "japan": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "malaysia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "mexico": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "netherlands": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "new_zealand": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "panama": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "philippines": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "poland": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "saudi_arabia": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "singapore": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "south_africa": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "south_korea": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "spain": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "sweden": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "taiwan": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "thailand": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "turkey": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "united_arab_emirates": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "united_kingdom": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "user_global": { "label": "Staff", "plural": "Staff", "singular": "Staff" },
                        "vietnam": { "label": "Staff", "plural": "Staff", "singular": "Staff" }
                    },
                    "related_field": "person",
                    "related_pk_field": "person_id",
                    "search_description": { "1": "Legislative, committee, executive, and leadership staffers.", "10000": "Legislative, committee, executive, and leadership staffers.", "10001": "Legislative, committee, and executive staffers.", "10002": "", "10003": "", "10004": "Legislative, committee, and executive staffers.", "106": "", "9999": "High-level United States legislative, committee, executive, and leadership staffers." },
                    "search_url": "staffers/",
                    "sheet_order": 1,
                    "sheet_row_values": ["id", "name", "image_url", "most_recent_party"],
                    "sheets": true,
                    "singular": "Staffer",
                    "sort_key": "lastname",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": true,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 8
                },
                "state": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "data_model": "app.geography.models.State",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "compass",
                    "fts": false,
                    "icon": "fa-compass",
                    "issues_management": false,
                    "key": "state",
                    "label": "State",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "States",
                    "precision_max_threshold": 50000,
                    "profile": "",
                    "quicksearch": false,
                    "region_specific_dict": {},
                    "sheet_order": 11,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "State",
                    "sort_key": "",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 82
                },
                "state_bill_supporting_document": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Document",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-file-text-o",
                    "is_subset_of": 25,
                    "issues_management": false,
                    "key": "state_bill_supporting_document",
                    "label": "State Bill Supporting Document",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304],
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 27
                },
                "statistic": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.stats.models.StatName",
                    "description": "",
                    "display_key": "full_name",
                    "download_center": false,
                    "fts": false,
                    "icon": "fa-bar-chart",
                    "issues_management": false,
                    "key": "statistic",
                    "label": "StatName",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Statistics",
                    "precision_max_threshold": 50000,
                    "profile": "/statistics/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Statistic",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 57
                },
                "supporter": {
                    "advanced_search": true,
                    "advanced_search_order": 4,
                    "archivable": true,
                    "assignment": true,
                    "comments": "involving_supporter",
                    "custom_fields": true,
                    "custom_fields_on_datadesc": false,
                    "custom_fields_url_pattern": "contact",
                    "custom_lists": true,
                    "data_model": "app.grassroots.models.Supporter",
                    "description": "",
                    "display_key": "name",
                    "download_center": true,
                    "event_participant_key": "supporter_participant",
                    "fa5_icon": "child",
                    "fa5_icon_family": "far",
                    "fts": false,
                    "icon": "fa-child",
                    "issues_management": true,
                    "key": "supporter",
                    "label": "Supporter",
                    "legislative_priority": true,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "supporters",
                    "outbox_selection_styling": "purple-tag-2",
                    "permission_enum": [204],
                    "plural": "Contacts",
                    "precision_max_threshold": 1e+06,
                    "profile": "/contact/",
                    "proxy_resource_data_model": "app.grassroots.models.NewSupporter",
                    "quicksearch": true,
                    "quicksearch_key": "name",
                    "quicksearch_order": 7,
                    "quicksearch_subtitle": ["supp"],
                    "region_specific_dict": {},
                    "related_field": "supporter",
                    "related_pk_field": "supporter_id",
                    "search_description": { "1": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "10000": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "10001": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "10002": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "10003": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "10004": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "106": "Contact information for your stakeholders, advocates, and more that you provide to Quorum.", "9999": "Contact database for your organization's stakeholders, advocates, and more that you add to Quorum." },
                    "search_url": "contacts/",
                    "sheet_order": 4,
                    "sheet_row_values": ["id", "name"],
                    "sheets": true,
                    "singular": "Contact",
                    "sort_key": "lastname",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": true,
                    "team_permissioning": true,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 12
                },
                "team": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.Team",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "event_participant_key": "team_participant",
                    "fa5_icon": "users",
                    "feature": 23,
                    "fts": false,
                    "icon": "fa-users",
                    "issues_management": false,
                    "key": "team",
                    "label": "Team",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "teams",
                    "plural": "Teams",
                    "precision_max_threshold": 50000,
                    "profile": "/edit_team/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Team",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 60
                },
                "tracking_dashboard": {
                    "advanced_search": false,
                    "archivable": true,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.tracking_dashboards.models.TrackingDashboard",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "tachometer-alt",
                    "fa5_icon_family": "fas",
                    "feature": 11,
                    "fts": false,
                    "icon": "fa-dashboard",
                    "issues_management": false,
                    "key": "tracking_dashboard",
                    "label": "Tracking Board",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "plural": "Tracking Boards",
                    "precision_max_threshold": 50000,
                    "profile": "/tracking_board/",
                    "quicksearch": false,
                    "quicksearch_key": "name",
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Tracking Board",
                    "sort_key": "name",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": true,
                    "value": 89
                },
                "transaction": {
                    "advanced_search": true,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": true,
                    "data_model": "app.ledger.models.Transaction",
                    "description": "",
                    "display_key": "entity_associated_with_transaction",
                    "download_center": false,
                    "fa5_icon": "money-bill",
                    "fa5_icon_family": "far",
                    "feature": 21,
                    "fts": false,
                    "icon": "fa-money",
                    "issues_management": false,
                    "key": "transaction",
                    "label": "Transaction",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "permission_enum": [8],
                    "plural": "PAC Transactions",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "search_description": { "1": "Receipts, Disbursements, and Refunds.", "10000": "Receipts, Disbursements, and Refunds.", "10001": "Receipts, Disbursements, and Refunds.", "10002": "Receipts, Disbursements, and Refunds.", "10003": "Receipts, Disbursements, and Refunds.", "10004": "Receipts, Disbursements, and Refunds.", "106": "Receipts, Disbursements, and Refunds.", "9999": "" },
                    "search_url": "transactions/",
                    "sheet_order": 43,
                    "sheet_row_values": ["entity_associated_with_transaction", "id", "transaction_type"],
                    "sheets": true,
                    "singular": "Transaction",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 107
                },
                "transaction_batch": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.TransactionBatch",
                    "description": "",
                    "display_key": "name",
                    "download_center": false,
                    "fa5_icon": "dollar-sign",
                    "feature": 19,
                    "fts": false,
                    "icon": "fa-money",
                    "issues_management": false,
                    "key": "transaction_batch",
                    "label": "Transaction Batch",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Transaction Batches",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Transaction Batch",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 122
                },
                "transaction_errors": {
                    "advanced_search": false,
                    "advanced_search_order": 15,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.ledger.models.AccountStateError",
                    "description": "",
                    "display_key": "error_display_key",
                    "download_center": false,
                    "feature": 21,
                    "fts": false,
                    "icon": "fa-exclamation-triangle",
                    "issues_management": false,
                    "key": "transaction_errors",
                    "label": "Transaction Errors",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [8],
                    "plural": "Errors",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Error",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 111
                },
                "tweet": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.Tweet",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-twitter",
                    "is_subset_of": 25,
                    "issues_management": false,
                    "key": "tweet",
                    "label": "Tweet",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305, 105],
                    "plural": "Tweets",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 10,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Tweet",
                    "sort_key": "content",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 6
                },
                "user": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.userdata.models.QuorumUser",
                    "description": "",
                    "display_key": "user_info__full_name",
                    "download_center": false,
                    "event_participant_key": "user_participant",
                    "fa5_icon": "users",
                    "fts": false,
                    "icon": "fa-user",
                    "issues_management": false,
                    "key": "user",
                    "label": "User",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "note_through_field": "team_members",
                    "plural": "Team Members",
                    "precision_max_threshold": 50000,
                    "profile": "/edit_user/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "user",
                    "related_pk_field": "user_id",
                    "sheet_order": 8,
                    "sheet_row_values": ["id", "first_name", "last_name", "user_info__full_name"],
                    "sheets": true,
                    "singular": "Team Member",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 59
                },
                "vote": {
                    "advanced_search": true,
                    "advanced_search_order": 9,
                    "archivable": false,
                    "assignment": true,
                    "comments": "referencing_votes",
                    "custom_fields": false,
                    "custom_lists": true,
                    "data_model": "app.vote.models.Vote",
                    "description": "",
                    "display_key": "display_name",
                    "download_center": false,
                    "fa5_icon": "check",
                    "fts": false,
                    "icon": "fa-check",
                    "issues_management": true,
                    "key": "vote",
                    "label": "Vote",
                    "legislative_priority": false,
                    "legislative_stance": true,
                    "lists": true,
                    "note_through_field": "votes",
                    "permission_enum": [304],
                    "plural": "Votes",
                    "precision_max_threshold": 50000,
                    "profile": "/vote/",
                    "quicksearch": false,
                    "quicksearch_key": "question",
                    "quicksearch_order": 5,
                    "quicksearch_subtitle": ["result", "created"],
                    "region_specific_dict": {},
                    "related_field": "vote",
                    "related_pk_field": "vote_id",
                    "search_description": { "1": "Congressional votes on legislation, amendments, confirmations, and other procedures.", "10000": "Congressional and state legislative votes on legislation, amendments, and other procedures.", "10001": "State legislative floor and committee votes.", "10002": "", "10003": "", "10004": "State legislative floor and committee votes.", "106": "", "9999": "Congressional and state legislative votes on legislation, amendments, and other procedures." },
                    "search_url": "votes/",
                    "sheet_order": 6,
                    "sheet_row_values": ["id", "question", "majority_result"],
                    "sheets": true,
                    "singular": "Vote",
                    "sort_key": "question",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": true,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": true,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 3
                },
                "vote_explanation": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.VoteExplanation",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "vote_explanation",
                    "label": "Vote Explanation",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Vote Explanations",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Vote Explanation",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 52
                },
                "vote_result": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.vote.models.VoteResult",
                    "description": "",
                    "download_center": false,
                    "fa5_icon": "check",
                    "fts": false,
                    "icon": "fa-check",
                    "issues_management": false,
                    "key": "vote_result",
                    "label": "Vote Result",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": false,
                    "permission_enum": [304],
                    "plural": "Votes",
                    "precision_max_threshold": 50000,
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Vote",
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 94
                },
                "written_declaration": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.WrittenDeclaration",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-microphone",
                    "issues_management": false,
                    "key": "written_declaration",
                    "label": "Written Declaration",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "plural": "Written Declarations",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_order": 15,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Written Declaration",
                    "sort_key": "title",
                    "supported_regions": [106],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 53
                },
                "youtube_video": {
                    "advanced_search": false,
                    "archivable": false,
                    "assignment": false,
                    "comments": false,
                    "custom_fields": false,
                    "custom_fields_on_datadesc": false,
                    "custom_lists": false,
                    "data_model": "app.document.models.YouTubeVideo",
                    "description": "",
                    "display_key": "display_text",
                    "download_center": false,
                    "fts": true,
                    "icon": "fa-youtube-play",
                    "issues_management": false,
                    "key": "youtube_video",
                    "label": "YouTube Video",
                    "legislative_priority": false,
                    "legislative_stance": false,
                    "lists": true,
                    "note_through_field": "documents",
                    "permission_enum": [305],
                    "plural": "Youtube Videos",
                    "precision_max_threshold": 50000,
                    "profile": "/document/",
                    "quicksearch": false,
                    "quicksearch_subtitle": [],
                    "region_specific_dict": {},
                    "related_field": "document",
                    "related_pk_field": "document_id",
                    "sheet_row_values": [],
                    "sheets": false,
                    "singular": "Youtube Video",
                    "sort_key": "content",
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "supports_alert": false,
                    "supports_alert_changes": false,
                    "supports_alert_edit_saved_search": false,
                    "supports_stakeholder_alignment": false,
                    "team_permissioning": false,
                    "tracking_dashboards": false,
                    "undelete": false,
                    "value": 41
                }
            },
            "Region": {
                "Romania": {
                    "abbrev": "rou",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 189,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "RO",
                    "key": "Romania",
                    "label": "Romanian Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 237,
                    "region_name": "Romania",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+2",
                    "value": 237
                },
                "__is_enum": true,
                "alabama": {
                    "abbrev": "al",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 1,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 1,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-al'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AL",
                    "key": "alabama",
                    "label": "Alabama Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 2,
                    "region_name": "Alabama",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 2
                },
                "alabama_local": {
                    "abbrev": "al_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 1,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-al'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AL",
                    "key": "alabama_local",
                    "label": "Alabama Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 54,
                    "region_name": "Alabama Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 54
                },
                "alaska": {
                    "abbrev": "ak",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 2,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 2,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ak'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AK",
                    "key": "alaska",
                    "label": "Alaska State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 3,
                    "region_name": "Alaska",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AKT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 3
                },
                "alaska_local": {
                    "abbrev": "ak_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 2,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ak'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AK",
                    "key": "alaska_local",
                    "label": "Alaska Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 55,
                    "region_name": "Alaska Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AKT",
                    "value": 55
                },
                "american_samoa": {
                    "abbrev": "as",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 56,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 60,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "AS",
                    "key": "american_samoa",
                    "label": "American Samoa Fono",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 108,
                    "region_name": "American Samoa",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "SST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 108
                },
                "argentina": {
                    "abbrev": "arg",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 9,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AR",
                    "key": "argentina",
                    "label": "The National Congress of Argentina",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 224,
                    "region_name": "Argentina",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-3",
                    "value": 224
                },
                "arizona": {
                    "abbrev": "az",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 3,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 4,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-az'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AZ",
                    "key": "arizona",
                    "label": "Arizona State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 4,
                    "region_name": "Arizona",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 4
                },
                "arizona_local": {
                    "abbrev": "az_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 4,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-az'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AZ",
                    "key": "arizona_local",
                    "label": "Arizona Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 56,
                    "region_name": "Arizona Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 56
                },
                "arkansas": {
                    "abbrev": "ar",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 4,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 5,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ar'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AR",
                    "key": "arkansas",
                    "label": "Arkansas General Assembly",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 5,
                    "region_name": "Arkansas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 5
                },
                "arkansas_local": {
                    "abbrev": "ar_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 5,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ar'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AR",
                    "key": "arkansas_local",
                    "label": "Arkansas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 57,
                    "region_name": "Arkansas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 57
                },
                "australia": {
                    "abbrev": "aus",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 15,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AU",
                    "key": "australia",
                    "label": "Parliament of Australia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 200,
                    "region_name": "Australia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "AEST",
                    "value": 200
                },
                "belgium": {
                    "abbrev": "bel",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 19,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "BE",
                    "key": "belgium",
                    "label": "Belgian Federal Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 226,
                    "region_name": "Belgium",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 226
                },
                "brazil": {
                    "abbrev": "bra",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 32,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "BR",
                    "key": "brazil",
                    "label": "Federal Government of Brazil",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 208,
                    "region_name": "Brazil",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "BRST",
                    "value": 208
                },
                "california": {
                    "abbrev": "ca",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 5,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 6,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ca'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CA",
                    "key": "california",
                    "label": "California State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 6,
                    "region_name": "California",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 6
                },
                "california_local": {
                    "abbrev": "ca_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 6,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ca'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CA",
                    "key": "california_local",
                    "label": "California Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 58,
                    "region_name": "California Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 58
                },
                "canada": {
                    "abbrev": "can",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 39,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CA",
                    "key": "canada",
                    "label": "Parliament of Canada",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 201,
                    "region_name": "Canada",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "value": 201
                },
                "chile": {
                    "abbrev": "chl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 42,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CL",
                    "key": "chile",
                    "label": "National Congress of Chile",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 233,
                    "region_name": "Chile",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-4",
                    "value": 233
                },
                "china": {
                    "abbrev": "chn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 43,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CN",
                    "key": "china",
                    "label": "National People's Congress of the People's Republic of China",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 209,
                    "region_name": "China",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CST",
                    "value": 209
                },
                "colombia": {
                    "abbrev": "col",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 49,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CO",
                    "key": "colombia",
                    "label": "Congress of the Republic of Colombia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 213,
                    "region_name": "Colombia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "COT",
                    "value": 213
                },
                "colorado": {
                    "abbrev": "co",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 6,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 8,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-co'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CO",
                    "key": "colorado",
                    "label": "Colorado General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 7,
                    "region_name": "Colorado",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 7
                },
                "colorado_local": {
                    "abbrev": "co_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 8,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-co'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CO",
                    "key": "colorado_local",
                    "label": "Colorado Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 59,
                    "region_name": "Colorado Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 59
                },
                "connecticut": {
                    "abbrev": "ct",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 7,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 9,
                    "has_bills": true,
                    "has_committee_cosponsors": true,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ct'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CT",
                    "key": "connecticut",
                    "label": "Connecticut General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 8,
                    "region_name": "Connecticut",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 8
                },
                "connecticut_local": {
                    "abbrev": "ct_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 9,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ct'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CT",
                    "key": "connecticut_local",
                    "label": "Connecticut Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 60,
                    "region_name": "Connecticut Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 60
                },
                "costa_rica": {
                    "abbrev": "cri",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 52,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CR",
                    "key": "costa_rica",
                    "label": "Republic of Costa Rica",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 232,
                    "region_name": "Costa Rica",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-6",
                    "value": 232
                },
                "czechia": {
                    "abbrev": "cze",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 58,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CZ",
                    "key": "czechia",
                    "label": "Parliament of Czechia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 238,
                    "region_name": "Czechia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+1",
                    "value": 238
                },
                "dc_local": {
                    "abbrev": "dc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 11,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-dc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-DC",
                    "key": "dc_local",
                    "label": "District of Columbia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 62,
                    "region_name": "District of Columbia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 62
                },
                "delaware": {
                    "abbrev": "de",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 8,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 10,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-de'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-DE",
                    "key": "delaware",
                    "label": "Delaware General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 9,
                    "region_name": "Delaware",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 9
                },
                "delaware_local": {
                    "abbrev": "de_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 10,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-de'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-DE",
                    "key": "delaware_local",
                    "label": "Delaware Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 61,
                    "region_name": "Delaware Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 61
                },
                "denmark": {
                    "abbrev": "dnk",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 62,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DK",
                    "key": "denmark",
                    "label": "Folketing",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 217,
                    "region_name": "Denmark",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 217
                },
                "district_of_columbia": {
                    "abbrev": "dc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 9,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 11,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-dc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "US-DC",
                    "key": "district_of_columbia",
                    "label": "Council of the District of Columbia",
                    "leg_type": 2,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 10,
                    "region_name": "District of Columbia",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Council",
                    "upper_member_title": "Council Member",
                    "value": 10
                },
                "dominican_republic": {
                    "abbrev": "dom",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 63,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DO",
                    "key": "dominican_republic",
                    "label": "Congress of the Dominican Republic",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 235,
                    "region_name": "Dominican Republic",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-4",
                    "value": 235
                },
                "eu": {
                    "abbrev": "eu",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "key": "eu",
                    "label": "European Union",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 0,
                    "region_name": "European Union",
                    "show_in_selector": false,
                    "show_reg_uids": true,
                    "timezone": "CET",
                    "value": 106
                },
                "federal": {
                    "abbrev": "us",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-us'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US",
                    "key": "federal",
                    "label": "US Congress",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": [],
                    "odd_to_even_carryover": false,
                    "order": 1,
                    "region_name": "US Federal",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 1
                },
                "florida": {
                    "abbrev": "fl",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 10,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 12,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-fl'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-FL",
                    "key": "florida",
                    "label": "Florida Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 11,
                    "region_name": "Florida",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 11
                },
                "florida_local": {
                    "abbrev": "fl_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 12,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-fl'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-FL",
                    "key": "florida_local",
                    "label": "Florida Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 63,
                    "region_name": "Florida Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 63
                },
                "france": {
                    "abbrev": "fra",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 75,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "FR",
                    "key": "france",
                    "label": "French Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 205,
                    "region_name": "France",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 205
                },
                "georgia": {
                    "abbrev": "ga",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 11,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 13,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ga'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-GA",
                    "key": "georgia",
                    "label": "Georgia General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 12,
                    "region_name": "Georgia",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 12
                },
                "georgia_local": {
                    "abbrev": "ga_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 13,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ga'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-GA",
                    "key": "georgia_local",
                    "label": "Georgia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 64,
                    "region_name": "Georgia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 64
                },
                "germany": {
                    "abbrev": "deu",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 59,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DE",
                    "key": "germany",
                    "label": "The German Bundestag",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 203,
                    "region_name": "Germany",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CEST",
                    "value": 203
                },
                "global_region": {
                    "abbrev": "glb",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-us'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "key": "global_region",
                    "label": "Global",
                    "leg_type": 1,
                    "maintainers": [],
                    "odd_to_even_carryover": false,
                    "order": 1,
                    "region_name": "Global Region",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC",
                    "value": 1000
                },
                "greece": {
                    "abbrev": "grc",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 89,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "GR",
                    "key": "greece",
                    "label": "Hellenic Republic",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 234,
                    "region_name": "Greece",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+3",
                    "value": 234
                },
                "guam": {
                    "abbrev": "gu",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 57,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 66,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "GU",
                    "key": "guam",
                    "label": "Legislature of Guam",
                    "leg_type": 2,
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 109,
                    "region_name": "Guam",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ChST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 109
                },
                "hawaii": {
                    "abbrev": "hi",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 12,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 15,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-hi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-HI",
                    "key": "hawaii",
                    "label": "Hawaii State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 13,
                    "region_name": "Hawaii",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "HST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 13
                },
                "hawaii_local": {
                    "abbrev": "hi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 15,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-hi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-HI",
                    "key": "hawaii_local",
                    "label": "Hawaii Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 65,
                    "region_name": "Hawaii Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "HST",
                    "value": 65
                },
                "hong_kong": {
                    "abbrev": "hkg",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 96,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "HK",
                    "key": "hong_kong",
                    "label": "Legislative Council of Hong Kong",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 227,
                    "region_name": "Hong Kong",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+8",
                    "value": 227
                },
                "idaho": {
                    "abbrev": "id",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 13,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 16,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-id'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ID",
                    "key": "idaho",
                    "label": "Idaho State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 14,
                    "region_name": "Idaho",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 14
                },
                "idaho_local": {
                    "abbrev": "id_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 16,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-id'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ID",
                    "key": "idaho_local",
                    "label": "Idaho Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 66,
                    "region_name": "Idaho Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 66
                },
                "illinois": {
                    "abbrev": "il",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 14,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 17,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-il'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IL",
                    "key": "illinois",
                    "label": "Illinois General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 15,
                    "region_name": "Illinois",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 15
                },
                "illinois_local": {
                    "abbrev": "il_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 17,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-il'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IL",
                    "key": "illinois_local",
                    "label": "Illinois Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 67,
                    "region_name": "Illinois Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 67
                },
                "india": {
                    "abbrev": "ind",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 104,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IN",
                    "key": "india",
                    "label": "Parliament of India",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 206,
                    "region_name": "India",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "IST",
                    "value": 206
                },
                "indiana": {
                    "abbrev": "in",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 15,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 18,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-in'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IN",
                    "key": "indiana",
                    "label": "Indiana General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 16,
                    "region_name": "Indiana",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 16
                },
                "indiana_local": {
                    "abbrev": "in_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 18,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-in'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IN",
                    "key": "indiana_local",
                    "label": "Indiana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 68,
                    "region_name": "Indiana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 68
                },
                "indonesia": {
                    "abbrev": "idn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 102,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ID",
                    "key": "indonesia",
                    "label": "People's Consultative Assembly of the Republic of Indonesia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 222,
                    "region_name": "Indonesia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "WIB",
                    "value": 222
                },
                "iowa": {
                    "abbrev": "ia",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 16,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 19,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ia'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IA",
                    "key": "iowa",
                    "label": "Iowa General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 17,
                    "region_name": "Iowa",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 17
                },
                "iowa_local": {
                    "abbrev": "ia_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 19,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ia'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IA",
                    "key": "iowa_local",
                    "label": "Iowa Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 69,
                    "region_name": "Iowa Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 69
                },
                "ireland": {
                    "abbrev": "irl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 106,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IE",
                    "key": "ireland",
                    "label": "The Oireachtas",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 215,
                    "region_name": "Ireland",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT",
                    "value": 215
                },
                "israel": {
                    "abbrev": "isr",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 110,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IL",
                    "key": "israel",
                    "label": "State of Israel",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 240,
                    "region_name": "Israel",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+2",
                    "value": 240
                },
                "italy": {
                    "abbrev": "ita",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 111,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IT",
                    "key": "italy",
                    "label": "Italian Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 207,
                    "region_name": "Italy",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 207
                },
                "japan": {
                    "abbrev": "jpn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 115,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "JP",
                    "key": "japan",
                    "label": "National Diet of Japan",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 210,
                    "region_name": "Japan",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "JST",
                    "value": 210
                },
                "kansas": {
                    "abbrev": "ks",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 17,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 20,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ks'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-KS",
                    "key": "kansas",
                    "label": "Kansas State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 18,
                    "region_name": "Kansas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 18
                },
                "kansas_local": {
                    "abbrev": "ks_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 20,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ks'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-KS",
                    "key": "kansas_local",
                    "label": "Kansas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 70,
                    "region_name": "Kansas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 70
                },
                "kentucky": {
                    "abbrev": "ky",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 18,
                    "error_type": 6,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 21,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ky'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-KY",
                    "key": "kentucky",
                    "label": "Kentucky General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 19,
                    "region_name": "Kentucky",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 19
                },
                "kentucky_local": {
                    "abbrev": "ky_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 21,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ky'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-KY",
                    "key": "kentucky_local",
                    "label": "Kentucky Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 71,
                    "region_name": "Kentucky Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 71
                },
                "louisiana": {
                    "abbrev": "la",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 19,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 22,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-la'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-LA",
                    "key": "louisiana",
                    "label": "Louisiana Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 20,
                    "region_name": "Louisiana",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 20
                },
                "louisiana_local": {
                    "abbrev": "la_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 22,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-la'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-LA",
                    "key": "louisiana_local",
                    "label": "Louisiana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 72,
                    "region_name": "Louisiana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 72
                },
                "maine": {
                    "abbrev": "me",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 20,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 23,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-me'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ME",
                    "key": "maine",
                    "label": "Maine Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 21,
                    "region_name": "Maine",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 21
                },
                "maine_local": {
                    "abbrev": "me_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 23,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-me'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ME",
                    "key": "maine_local",
                    "label": "Maine Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 73,
                    "region_name": "Maine Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 73
                },
                "malaysia": {
                    "abbrev": "mys",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 158,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "MY",
                    "key": "malaysia",
                    "label": "Parliament of Malaysia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 228,
                    "region_name": "Malaysia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+8",
                    "value": 228
                },
                "maryland": {
                    "abbrev": "md",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 21,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 24,
                    "has_bills": true,
                    "has_committee_cosponsors": true,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-md'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MD",
                    "key": "maryland",
                    "label": "Maryland General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 22,
                    "region_name": "Maryland",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 22
                },
                "maryland_local": {
                    "abbrev": "md_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 24,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-md'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MD",
                    "key": "maryland_local",
                    "label": "Maryland Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 74,
                    "region_name": "Maryland Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 74
                },
                "massachusetts": {
                    "abbrev": "ma",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 22,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 25,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ma'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MA",
                    "key": "massachusetts",
                    "label": "Massachusetts General Court",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 23,
                    "region_name": "Massachusetts",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 23
                },
                "massachusetts_local": {
                    "abbrev": "ma_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 25,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ma'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MA",
                    "key": "massachusetts_local",
                    "label": "Massachusetts Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 75,
                    "region_name": "Massachusetts Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 75
                },
                "mexico": {
                    "abbrev": "mex",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 143,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "MX",
                    "key": "mexico",
                    "label": "General Congress of the United Mexican States",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 202,
                    "region_name": "Mexico",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "value": 202
                },
                "michigan": {
                    "abbrev": "mi",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 23,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 26,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MI",
                    "key": "michigan",
                    "label": "Michigan Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 24,
                    "region_name": "Michigan",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 24
                },
                "michigan_local": {
                    "abbrev": "mi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 26,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MI",
                    "key": "michigan_local",
                    "label": "Michigan Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 76,
                    "region_name": "Michigan Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 76
                },
                "minnesota": {
                    "abbrev": "mn",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 24,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 27,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MN",
                    "key": "minnesota",
                    "label": "Minnesota State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 25,
                    "region_name": "Minnesota",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 25
                },
                "minnesota_local": {
                    "abbrev": "mn_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 27,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MN",
                    "key": "minnesota_local",
                    "label": "Minnesota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 77,
                    "region_name": "Minnesota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 77
                },
                "mississippi": {
                    "abbrev": "ms",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 25,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 28,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ms'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MS",
                    "key": "mississippi",
                    "label": "Mississippi Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 26,
                    "region_name": "Mississippi",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 26
                },
                "mississippi_local": {
                    "abbrev": "ms_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 28,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ms'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MS",
                    "key": "mississippi_local",
                    "label": "Mississippi Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 78,
                    "region_name": "Mississippi Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 78
                },
                "missouri": {
                    "abbrev": "mo",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 26,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 29,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mo'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MO",
                    "key": "missouri",
                    "label": "Missouri General Assembly",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 27,
                    "region_name": "Missouri",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 27
                },
                "missouri_local": {
                    "abbrev": "mo_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 29,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mo'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MO",
                    "key": "missouri_local",
                    "label": "Missouri Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 79,
                    "region_name": "Missouri Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 79
                },
                "montana": {
                    "abbrev": "mt",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 27,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 30,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MT",
                    "key": "montana",
                    "label": "Montana Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 28,
                    "region_name": "Montana",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 28
                },
                "montana_local": {
                    "abbrev": "mt_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 30,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MT",
                    "key": "montana_local",
                    "label": "Montana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 80,
                    "region_name": "Montana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 80
                },
                "nebraska": {
                    "abbrev": "ne",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 28,
                    "error_type": 8,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 31,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ne'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NE",
                    "key": "nebraska",
                    "label": "Nebraska Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 29,
                    "region_name": "Nebraska",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 29
                },
                "nebraska_local": {
                    "abbrev": "ne_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 31,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ne'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NE",
                    "key": "nebraska_local",
                    "label": "Nebraska Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 81,
                    "region_name": "Nebraska Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 81
                },
                "netherlands": {
                    "abbrev": "nld",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 167,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "NL",
                    "key": "netherlands",
                    "label": "States General of the Netherlands",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 219,
                    "region_name": "Netherlands",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 219
                },
                "nevada": {
                    "abbrev": "nv",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 29,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 32,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NV",
                    "key": "nevada",
                    "label": "Nevada Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 30,
                    "region_name": "Nevada",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 30
                },
                "nevada_local": {
                    "abbrev": "nv_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 32,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NV",
                    "key": "nevada_local",
                    "label": "Nevada Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 82,
                    "region_name": "Nevada Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 82
                },
                "new_hampshire": {
                    "abbrev": "nh",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 30,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 33,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NH",
                    "key": "new_hampshire",
                    "label": "New Hampshire General Court",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 31,
                    "region_name": "New Hampshire",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 31
                },
                "new_hampshire_local": {
                    "abbrev": "nh_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 33,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NH",
                    "key": "new_hampshire_local",
                    "label": "New Hampshire Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 83,
                    "region_name": "New Hampshire Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 83
                },
                "new_jersey": {
                    "abbrev": "nj",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 31,
                    "error_type": 1,
                    "even_to_odd_carryover": true,
                    "even_year_sessions": true,
                    "fips_code": 34,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nj'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NJ",
                    "key": "new_jersey",
                    "label": "New Jersey Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 32,
                    "region_name": "New Jersey",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 32
                },
                "new_jersey_local": {
                    "abbrev": "nj_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 34,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nj'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NJ",
                    "key": "new_jersey_local",
                    "label": "New Jersey Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 84,
                    "region_name": "New Jersey Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 84
                },
                "new_mexico": {
                    "abbrev": "nm",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 32,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 35,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nm'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NM",
                    "key": "new_mexico",
                    "label": "New Mexico Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 33,
                    "region_name": "New Mexico",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 33
                },
                "new_mexico_local": {
                    "abbrev": "nm_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 35,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nm'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NM",
                    "key": "new_mexico_local",
                    "label": "New Mexico Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 85,
                    "region_name": "New Mexico Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 85
                },
                "new_york": {
                    "abbrev": "ny",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 33,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 36,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ny'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NY",
                    "key": "new_york",
                    "label": "New York Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 34,
                    "region_name": "New York",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 34
                },
                "new_york_local": {
                    "abbrev": "ny_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 36,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ny'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NY",
                    "key": "new_york_local",
                    "label": "New York Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 86,
                    "region_name": "New York Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 86
                },
                "new_zealand": {
                    "abbrev": "nzl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 171,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "NZ",
                    "key": "new_zealand",
                    "label": "New Zealand Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 231,
                    "region_name": "New Zealand",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+13",
                    "value": 231
                },
                "north_carolina": {
                    "abbrev": "nc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 34,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 37,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NC",
                    "key": "north_carolina",
                    "label": "North Carolina General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 35,
                    "region_name": "North Carolina",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 35
                },
                "north_carolina_local": {
                    "abbrev": "nc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 37,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NC",
                    "key": "north_carolina_local",
                    "label": "North Carolina Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 87,
                    "region_name": "North Carolina Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 87
                },
                "north_dakota": {
                    "abbrev": "nd",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 35,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 38,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ND",
                    "key": "north_dakota",
                    "label": "North Dakota Legislative Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 36,
                    "region_name": "North Dakota",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 36
                },
                "north_dakota_local": {
                    "abbrev": "nd_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 38,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ND",
                    "key": "north_dakota_local",
                    "label": "North Dakota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 88,
                    "region_name": "North Dakota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 88
                },
                "northern_mariana_islands": {
                    "abbrev": "mp",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 55,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 69,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "MP",
                    "key": "northern_mariana_islands",
                    "label": "Northern Mariana Islands Commonwealth Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 110,
                    "region_name": "Northern Mariana Islands",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ChST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 110
                },
                "ohio": {
                    "abbrev": "oh",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 36,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 39,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-oh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OH",
                    "key": "ohio",
                    "label": "Ohio General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 37,
                    "region_name": "Ohio",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 37
                },
                "ohio_local": {
                    "abbrev": "oh_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 39,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-oh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OH",
                    "key": "ohio_local",
                    "label": "Ohio Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 89,
                    "region_name": "Ohio Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 89
                },
                "oklahoma": {
                    "abbrev": "ok",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 37,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 40,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ok'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OK",
                    "key": "oklahoma",
                    "label": "Oklahoma Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 38,
                    "region_name": "Oklahoma",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 38
                },
                "oklahoma_local": {
                    "abbrev": "ok_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 40,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ok'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OK",
                    "key": "oklahoma_local",
                    "label": "Oklahoma Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 90,
                    "region_name": "Oklahoma Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 90
                },
                "oregon": {
                    "abbrev": "or",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 38,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 41,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-or'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OR",
                    "key": "oregon",
                    "label": "Oregon Legislative Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 39,
                    "region_name": "Oregon",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 39
                },
                "oregon_local": {
                    "abbrev": "or_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 41,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-or'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OR",
                    "key": "oregon_local",
                    "label": "Oregon Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 91,
                    "region_name": "Oregon Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 91
                },
                "panama": {
                    "abbrev": "pan",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 174,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PA",
                    "key": "panama",
                    "label": "Legislative Branch of Panama",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 236,
                    "region_name": "Panama",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC-5",
                    "value": 236
                },
                "pennsylvania": {
                    "abbrev": "pa",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 39,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 42,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-pa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-PA",
                    "key": "pennsylvania",
                    "label": "Pennsylvania General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 40,
                    "region_name": "Pennsylvania",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 40
                },
                "pennsylvania_local": {
                    "abbrev": "pa_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 42,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-pa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-PA",
                    "key": "pennsylvania_local",
                    "label": "Pennsylvania Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 92,
                    "region_name": "Pennsylvania Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 92
                },
                "philippines": {
                    "abbrev": "phl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 177,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PH",
                    "key": "philippines",
                    "label": "Congress of the Philippines",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 229,
                    "region_name": "Philippines",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+8",
                    "value": 229
                },
                "poland": {
                    "abbrev": "pol",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 180,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PL",
                    "key": "poland",
                    "label": "Parliament of Poland",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 216,
                    "region_name": "Poland",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 216
                },
                "puerto_rico": {
                    "abbrev": "pr",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 54,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 72,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-pr'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "US-PR",
                    "key": "puerto_rico",
                    "label": "Legislative Assembly of Puerto Rico",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 41,
                    "region_name": "Puerto Rico",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 41
                },
                "puerto_rico_local": {
                    "abbrev": "pr_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 72,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-pr'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-PR",
                    "key": "puerto_rico_local",
                    "label": "Puerto Rico Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 93,
                    "region_name": "Puerto Rico Local",
                    "show_in_selector": false,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "value": 93
                },
                "rhode_island": {
                    "abbrev": "ri",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 40,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 44,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ri'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-RI",
                    "key": "rhode_island",
                    "label": "Rhode Island General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 42,
                    "region_name": "Rhode Island",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 42
                },
                "rhode_island_local": {
                    "abbrev": "ri_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 44,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ri'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-RI",
                    "key": "rhode_island_local",
                    "label": "Rhode Island Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 94,
                    "region_name": "Rhode Island Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 94
                },
                "saudi_arabia": {
                    "abbrev": "sau",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 192,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SA",
                    "key": "saudi_arabia",
                    "label": "Consultative Assembly of Saudi Arabia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 212,
                    "region_name": "Saudi Arabia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SAST",
                    "value": 212
                },
                "singapore": {
                    "abbrev": "sgp",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 195,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SG",
                    "key": "singapore",
                    "label": "Parliament of Singapore",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 223,
                    "region_name": "Singapore",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SGT",
                    "value": 223
                },
                "south_africa": {
                    "abbrev": "zaf",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 246,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ZA",
                    "key": "south_africa",
                    "label": "Parliament of South Africa",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 214,
                    "region_name": "South Africa",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SAST",
                    "value": 214
                },
                "south_carolina": {
                    "abbrev": "sc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 41,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 45,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-sc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-SC",
                    "key": "south_carolina",
                    "label": "South Carolina Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 43,
                    "region_name": "South Carolina",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 43
                },
                "south_carolina_local": {
                    "abbrev": "sc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 45,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-sc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-SC",
                    "key": "south_carolina_local",
                    "label": "South Carolina Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 95,
                    "region_name": "South Carolina Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 95
                },
                "south_dakota": {
                    "abbrev": "sd",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 42,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 46,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-sd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-SD",
                    "key": "south_dakota",
                    "label": "South Dakota State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 44,
                    "region_name": "South Dakota",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 44
                },
                "south_dakota_local": {
                    "abbrev": "sd_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 46,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-sd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-SD",
                    "key": "south_dakota_local",
                    "label": "South Dakota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 96,
                    "region_name": "South Dakota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 96
                },
                "south_korea": {
                    "abbrev": "kor",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 122,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "KR",
                    "key": "south_korea",
                    "label": "National Assembly of the Republic of Korea",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 221,
                    "region_name": "South Korea",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "KST",
                    "value": 221
                },
                "spain": {
                    "abbrev": "esp",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 69,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ES",
                    "key": "spain",
                    "label": "Las Cortes Generales",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 211,
                    "region_name": "Spain",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CEST",
                    "value": 211
                },
                "sweden": {
                    "abbrev": "swe",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 210,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SE",
                    "key": "sweden",
                    "label": "Riksdag",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 218,
                    "region_name": "Sweden",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 218
                },
                "taiwan": {
                    "abbrev": "twn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 228,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TW",
                    "key": "taiwan",
                    "label": "Legislative Yuan",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 225,
                    "region_name": "Taiwan",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CST",
                    "value": 225
                },
                "tennessee": {
                    "abbrev": "tn",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 43,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 47,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-tn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-TN",
                    "key": "tennessee",
                    "label": "Tennessee General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 45,
                    "region_name": "Tennessee",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 45
                },
                "tennessee_local": {
                    "abbrev": "tn_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 47,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-tn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-TN",
                    "key": "tennessee_local",
                    "label": "Tennessee Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 97,
                    "region_name": "Tennessee Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 97
                },
                "texas": {
                    "abbrev": "tx",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 44,
                    "error_type": 5,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 48,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-tx'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-TX",
                    "key": "texas",
                    "label": "Texas Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 46,
                    "region_name": "Texas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 46
                },
                "texas_local": {
                    "abbrev": "tx_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 48,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-tx'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-TX",
                    "key": "texas_local",
                    "label": "Texas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 98,
                    "region_name": "Texas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 98
                },
                "thailand": {
                    "abbrev": "tha",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 218,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TH",
                    "key": "thailand",
                    "label": "National Assembly of Thailand",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 220,
                    "region_name": "Thailand",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "ICT",
                    "value": 220
                },
                "turkey": {
                    "abbrev": "tur",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 226,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TR",
                    "key": "turkey",
                    "label": "Parliament of Turkey",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 239,
                    "region_name": "Turkey",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+3",
                    "value": 239
                },
                "united_arab_emirates": {
                    "abbrev": "uae",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 8,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AE",
                    "key": "united_arab_emirates",
                    "label": "The United Arab Emirates",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 241,
                    "region_name": "United Arab Emirates",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+4",
                    "value": 241
                },
                "united_kingdom": {
                    "abbrev": "gbr",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 79,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "GB",
                    "key": "united_kingdom",
                    "label": "Parliament of the United Kingdom of Great Britain and Northern Ireland",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 204,
                    "region_name": "United Kingdom",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT",
                    "value": 204
                },
                "utah": {
                    "abbrev": "ut",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 45,
                    "error_type": 10,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 49,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ut'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-UT",
                    "key": "utah",
                    "label": "Utah State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 47,
                    "region_name": "Utah",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 47
                },
                "utah_local": {
                    "abbrev": "ut_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 49,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ut'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-UT",
                    "key": "utah_local",
                    "label": "Utah Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 99,
                    "region_name": "Utah Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 99
                },
                "vermont": {
                    "abbrev": "vt",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 46,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 50,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-vt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-VT",
                    "key": "vermont",
                    "label": "Vermont General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 48,
                    "region_name": "Vermont",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 48
                },
                "vermont_local": {
                    "abbrev": "vt_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 50,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-vt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-VT",
                    "key": "vermont_local",
                    "label": "Vermont Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 100,
                    "region_name": "Vermont Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 100
                },
                "vietnam": {
                    "abbrev": "vnm",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 241,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "VN",
                    "key": "vietnam",
                    "label": "National Assembly of the Socialist Republic of Vietnam",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 230,
                    "region_name": "Vietnam",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+7",
                    "value": 230
                },
                "virgin_islands": {
                    "abbrev": "vi",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 53,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 78,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "VI",
                    "key": "virgin_islands",
                    "label": "Legislature of the Virgin Islands",
                    "leg_type": 2,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 107,
                    "region_name": "Virgin Islands",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 107
                },
                "virginia": {
                    "abbrev": "va",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 47,
                    "error_type": 1,
                    "even_to_odd_carryover": true,
                    "even_year_sessions": true,
                    "fips_code": 51,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-va'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-VA",
                    "key": "virginia",
                    "label": "Virginia General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 49,
                    "region_name": "Virginia",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 49
                },
                "virginia_local": {
                    "abbrev": "va_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 51,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-va'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-VA",
                    "key": "virginia_local",
                    "label": "Virginia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 101,
                    "region_name": "Virginia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 101
                },
                "washington": {
                    "abbrev": "wa",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 48,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 53,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WA",
                    "key": "washington",
                    "label": "Washington State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 50,
                    "region_name": "Washington",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 50
                },
                "washington_local": {
                    "abbrev": "wa_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 53,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WA",
                    "key": "washington_local",
                    "label": "Washington Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 102,
                    "region_name": "Washington Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 102
                },
                "west_virginia": {
                    "abbrev": "wv",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 49,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 54,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WV",
                    "key": "west_virginia",
                    "label": "West Virginia Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 51,
                    "region_name": "West Virginia",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 51
                },
                "west_virginia_local": {
                    "abbrev": "wv_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 54,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WV",
                    "key": "west_virginia_local",
                    "label": "West Virginia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 103,
                    "region_name": "West Virginia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 103
                },
                "wisconsin": {
                    "abbrev": "wi",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 50,
                    "error_type": 11,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 55,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WI",
                    "key": "wisconsin",
                    "label": "Wisconsin State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 52,
                    "region_name": "Wisconsin",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 52
                },
                "wisconsin_local": {
                    "abbrev": "wi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 55,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WI",
                    "key": "wisconsin_local",
                    "label": "Wisconsin Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 104,
                    "region_name": "Wisconsin Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 104
                },
                "wyoming": {
                    "abbrev": "wy",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 51,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 56,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wy'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WY",
                    "key": "wyoming",
                    "label": "Wyoming State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 53,
                    "region_name": "Wyoming",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 53
                },
                "wyoming_local": {
                    "abbrev": "wy_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 56,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wy'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WY",
                    "key": "wyoming_local",
                    "label": "Wyoming Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 105,
                    "region_name": "Wyoming Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 105
                }
            },
            "SidebarItem": {
                "__is_enum": true,
                "advanced_search": {
                    "category": "tracking",
                    "description": "Search any dataset in Quorum by keyword or by using filters. Visualize, download, or save your results.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/search/",
                    "icon": "fa-search",
                    "key": "advanced_search",
                    "label": "Search",
                    "permission_enum": [0],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 1
                },
                "campaigns": {
                    "category": "grassroots",
                    "description": "Manage your Grassroots activity by creating campaigns, editing your Action Center settings, or pulling analytics about the performance of your advocates.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/action_centers/",
                    "icon": "fa-bullhorn",
                    "key": "campaigns",
                    "label": "Action Center",
                    "permission_enum": [201, 5, 7, 3],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 11
                },
                "custom_event": {
                    "category": "custom events",
                    "description": "Manage events you plan to host",
                    "disable_for_limited": true,
                    "fa5_icon_family": "far",
                    "href": "/custom_event/",
                    "icon": "fa-calendar-check-o",
                    "key": "custom_event",
                    "label": "Event Management",
                    "permission_enum": [206],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 18
                },
                "dashboards": {
                    "category": "project management",
                    "description": "Dashboards are customizable, auto-updating reports that give you a visual summary of where your priorities, team, or strategy currently stand.",
                    "disable_for_limited": true,
                    "fa5_icon": "dashboard-small",
                    "fa5_icon_family": "q",
                    "href": "/dashboard/",
                    "key": "dashboards",
                    "label": "Dashboards",
                    "permission_enum": [0],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 21
                },
                "districts": {
                    "category": "targeting",
                    "description": "Explore demographic statistics of legislators' districts on an interactive map.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/geographies/",
                    "icon": "fa-globe",
                    "key": "districts",
                    "label": "Districts",
                    "permission_enum": [304],
                    "shift_up": true,
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "value": 6
                },
                "email_alerts": {
                    "category": "tracking",
                    "description": "Edit or delete the email alerts that you set up in Search.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/alerts/",
                    "icon": "fa-rss",
                    "key": "email_alerts",
                    "label": "Alert Management",
                    "permission_enum": [0],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 2
                },
                "files": {
                    "category": "project management",
                    "description": "Upload strategy briefings, handouts, notes, and more to Quorum and share them with you entire team. Files can be organized by project and many filetypes are fully full-text searchable.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "far",
                    "href": "/sn/files/",
                    "icon": "fa-folder-open-o",
                    "key": "files",
                    "label": "Files",
                    "permission_enum": [3],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 16
                },
                "issue_management": {
                    "category": "project management",
                    "description": "Save & organize the information you're keeping track of throughout the site",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/issue_management/",
                    "icon": "fa-thumb-tack",
                    "key": "issue_management",
                    "label": "Issue Management",
                    "permission_enum": [1006],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 17
                },
                "issues": {
                    "category": "targeting",
                    "description": "View analytics on which legislators are most active, effective, or impactful across hundreds of issue areas.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/issue/",
                    "icon": "fa-tasks",
                    "key": "issues",
                    "label": "Legislative Issues",
                    "permission_enum": [304],
                    "shift_up": false,
                    "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                    "value": 4
                },
                "lists": {
                    "category": "project management",
                    "description": "Save & organize the information you're keeping track of throughout the site. Each project contains a series of boards that contain the lists that you've saved for emails, legislator targeting, and more.",
                    "disable_for_limited": false,
                    "fa5_icon_family": "fas",
                    "href": "/projects/",
                    "icon": "fa-map-signs",
                    "key": "lists",
                    "label": "Projects",
                    "permission_enum": [9999],
                    "shift_up": false,
                    "supported_regions": [],
                    "value": 9
                },
                "new_downloads": {
                    "category": "outreach",
                    "description": "Create customized PDF profiles of legislators, bills, organizations, and other profile types and download them in bulk.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/download_center/",
                    "icon": "fa-cloud-download",
                    "key": "new_downloads",
                    "label": "Download Center",
                    "permission_enum": [0],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 20
                },
                "outbound_texting": {
                    "category": "outreach",
                    "description": "Send customized text messages to contacts in bulk.",
                    "disable_for_limited": true,
                    "excluded_by_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 203, 205, 207, 211, 215, 216, 217, 218, 219, 226, 238, 106, 9999, 10003],
                    "fa5_icon": "mobile-alt",
                    "fa5_icon_family": "fas",
                    "feature_flags": [],
                    "href": "/texting/sent/",
                    "icon": "fa-mobile",
                    "key": "outbound_texting",
                    "label": "Texting",
                    "permission_enum": [201],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 23
                },
                "outbox": {
                    "category": "outreach",
                    "description": "Send customized emails to officials, staff, or custom contacts in bulk. Track the efficacy of your emails and quickly see who is opening, responding, or engaging with your messages.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "far",
                    "href": "/outbox/sent",
                    "icon": "fa-envelope-o",
                    "key": "outbox",
                    "label": "Outbox",
                    "permission_enum": [202, 205, 105],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 10
                },
                "pac": {
                    "category": "project management",
                    "description": "Easily manage and report on all of your PAC financials.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/pacinternal/",
                    "icon": "fa-usd",
                    "key": "pac",
                    "label": "PAC",
                    "permission_enum": [8],
                    "permission_user": ["can_access_pac"],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 22
                },
                "pac_hybrid": {
                    "category": "project management",
                    "description": "Easily manage and report on all of your PAC 2.0 financials.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "",
                    "icon": "fa-usd",
                    "key": "pac_hybrid",
                    "label": "PAC 2.0",
                    "permission_enum": [215],
                    "permission_user": ["can_access_pac"],
                    "shift_up": true,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                    "value": 24
                },
                "sheets": {
                    "category": "project management",
                    "description": "Build auto-updating spreadsheets of officials, bills, contacts, and more and share them with your team or optionally make them available to your supporters. Pull together legislative & demographic information, notes & interactions, custom data, contact information, and more into one place.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/sheets/",
                    "icon": "fa-sort-amount-desc",
                    "key": "sheets",
                    "label": "Sheets",
                    "permission_enum": [0],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 12
                },
                "tracking_dashboards": {
                    "category": "project management",
                    "description": "Track Legislation, Regulations and More.",
                    "disable_for_limited": true,
                    "fa5_icon_family": "fas",
                    "href": "/tracking_boards/",
                    "icon": "fa-dashboard",
                    "key": "tracking_dashboards",
                    "label": "Tracking Boards",
                    "permission_enum": [304, 310, 305],
                    "shift_up": false,
                    "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                    "value": 19
                }
            },
            "SupportedRegion": {
                "Romania": {
                    "abbrev": "rou",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 189,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "RO",
                    "key": "Romania",
                    "label": "Romanian Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 237,
                    "region_name": "Romania",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+2",
                    "value": 237
                },
                "__is_enum": true,
                "alabama": {
                    "abbrev": "al",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 1,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 1,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-al'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AL",
                    "key": "alabama",
                    "label": "Alabama Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 2,
                    "region_name": "Alabama",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 2
                },
                "alabama_local": {
                    "abbrev": "al_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 1,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-al'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AL",
                    "key": "alabama_local",
                    "label": "Alabama Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 54,
                    "region_name": "Alabama Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 54
                },
                "alaska": {
                    "abbrev": "ak",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 2,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 2,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ak'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AK",
                    "key": "alaska",
                    "label": "Alaska State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 3,
                    "region_name": "Alaska",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AKT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 3
                },
                "alaska_local": {
                    "abbrev": "ak_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 2,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ak'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AK",
                    "key": "alaska_local",
                    "label": "Alaska Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 55,
                    "region_name": "Alaska Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AKT",
                    "value": 55
                },
                "all_regions": {
                    "abbrev": "all",
                    "child_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110],
                    "group_label": "All Regions",
                    "international_region_ready": false,
                    "key": "all_regions",
                    "label": "All Regions",
                    "order": -1000,
                    "region_name": "Entire US",
                    "show_reg_uids": true,
                    "value": 10000
                },
                "american_samoa": {
                    "abbrev": "as",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 56,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 60,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "AS",
                    "key": "american_samoa",
                    "label": "American Samoa Fono",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 108,
                    "region_name": "American Samoa",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "SST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 108
                },
                "argentina": {
                    "abbrev": "arg",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 9,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AR",
                    "key": "argentina",
                    "label": "The National Congress of Argentina",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 224,
                    "region_name": "Argentina",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-3",
                    "value": 224
                },
                "arizona": {
                    "abbrev": "az",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 3,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 4,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-az'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AZ",
                    "key": "arizona",
                    "label": "Arizona State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 4,
                    "region_name": "Arizona",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 4
                },
                "arizona_local": {
                    "abbrev": "az_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 4,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-az'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AZ",
                    "key": "arizona_local",
                    "label": "Arizona Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 56,
                    "region_name": "Arizona Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 56
                },
                "arkansas": {
                    "abbrev": "ar",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 4,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 5,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ar'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-AR",
                    "key": "arkansas",
                    "label": "Arkansas General Assembly",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 5,
                    "region_name": "Arkansas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 5
                },
                "arkansas_local": {
                    "abbrev": "ar_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 5,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ar'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-AR",
                    "key": "arkansas_local",
                    "label": "Arkansas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 57,
                    "region_name": "Arkansas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 57
                },
                "australia": {
                    "abbrev": "aus",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 15,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AU",
                    "key": "australia",
                    "label": "Parliament of Australia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 200,
                    "region_name": "Australia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "AEST",
                    "value": 200
                },
                "belgium": {
                    "abbrev": "bel",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 19,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "BE",
                    "key": "belgium",
                    "label": "Belgian Federal Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 226,
                    "region_name": "Belgium",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 226
                },
                "brazil": {
                    "abbrev": "bra",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 32,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "BR",
                    "key": "brazil",
                    "label": "Federal Government of Brazil",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 208,
                    "region_name": "Brazil",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "BRST",
                    "value": 208
                },
                "california": {
                    "abbrev": "ca",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 5,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 6,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ca'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CA",
                    "key": "california",
                    "label": "California State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 6,
                    "region_name": "California",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 6
                },
                "california_local": {
                    "abbrev": "ca_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 6,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ca'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CA",
                    "key": "california_local",
                    "label": "California Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 58,
                    "region_name": "California Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 58
                },
                "canada": {
                    "abbrev": "can",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 39,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CA",
                    "key": "canada",
                    "label": "Parliament of Canada",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 201,
                    "region_name": "Canada",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "value": 201
                },
                "chile": {
                    "abbrev": "chl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 42,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CL",
                    "key": "chile",
                    "label": "National Congress of Chile",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 233,
                    "region_name": "Chile",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-4",
                    "value": 233
                },
                "china": {
                    "abbrev": "chn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 43,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CN",
                    "key": "china",
                    "label": "National People's Congress of the People's Republic of China",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 209,
                    "region_name": "China",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CST",
                    "value": 209
                },
                "colombia": {
                    "abbrev": "col",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 49,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CO",
                    "key": "colombia",
                    "label": "Congress of the Republic of Colombia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 213,
                    "region_name": "Colombia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "COT",
                    "value": 213
                },
                "colorado": {
                    "abbrev": "co",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 6,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 8,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-co'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CO",
                    "key": "colorado",
                    "label": "Colorado General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 7,
                    "region_name": "Colorado",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 7
                },
                "colorado_local": {
                    "abbrev": "co_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 8,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-co'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CO",
                    "key": "colorado_local",
                    "label": "Colorado Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 59,
                    "region_name": "Colorado Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 59
                },
                "connecticut": {
                    "abbrev": "ct",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 7,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 9,
                    "has_bills": true,
                    "has_committee_cosponsors": true,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ct'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-CT",
                    "key": "connecticut",
                    "label": "Connecticut General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 8,
                    "region_name": "Connecticut",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 8
                },
                "connecticut_local": {
                    "abbrev": "ct_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 9,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ct'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-CT",
                    "key": "connecticut_local",
                    "label": "Connecticut Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 60,
                    "region_name": "Connecticut Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 60
                },
                "costa_rica": {
                    "abbrev": "cri",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 52,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CR",
                    "key": "costa_rica",
                    "label": "Republic of Costa Rica",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 232,
                    "region_name": "Costa Rica",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-6",
                    "value": 232
                },
                "czechia": {
                    "abbrev": "cze",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 58,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "CZ",
                    "key": "czechia",
                    "label": "Parliament of Czechia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 238,
                    "region_name": "Czechia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+1",
                    "value": 238
                },
                "dc_local": {
                    "abbrev": "dc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 11,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-dc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-DC",
                    "key": "dc_local",
                    "label": "District of Columbia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 62,
                    "region_name": "District of Columbia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 62
                },
                "delaware": {
                    "abbrev": "de",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 8,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 10,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-de'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-DE",
                    "key": "delaware",
                    "label": "Delaware General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 9,
                    "region_name": "Delaware",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 9
                },
                "delaware_local": {
                    "abbrev": "de_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 10,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-de'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-DE",
                    "key": "delaware_local",
                    "label": "Delaware Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 61,
                    "region_name": "Delaware Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 61
                },
                "denmark": {
                    "abbrev": "dnk",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 62,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DK",
                    "key": "denmark",
                    "label": "Folketing",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 217,
                    "region_name": "Denmark",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 217
                },
                "district_of_columbia": {
                    "abbrev": "dc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 9,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 11,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-dc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "US-DC",
                    "key": "district_of_columbia",
                    "label": "Council of the District of Columbia",
                    "leg_type": 2,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 10,
                    "region_name": "District of Columbia",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Council",
                    "upper_member_title": "Council Member",
                    "value": 10
                },
                "dominican_republic": {
                    "abbrev": "dom",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 63,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DO",
                    "key": "dominican_republic",
                    "label": "Congress of the Dominican Republic",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 235,
                    "region_name": "Dominican Republic",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT-4",
                    "value": 235
                },
                "eu": {
                    "abbrev": "eu",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "key": "eu",
                    "label": "European Union",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 0,
                    "region_name": "European Union",
                    "show_in_selector": false,
                    "show_reg_uids": true,
                    "timezone": "CET",
                    "value": 106
                },
                "eu_member_states": {
                    "abbrev": "eu-members",
                    "child_regions": [203, 205, 207, 211, 215, 216, 217, 218, 219, 226, 238],
                    "group_label": "EU Member States",
                    "international_region_ready": false,
                    "key": "eu_member_states",
                    "label": "EU Member States",
                    "order": -995,
                    "region_name": "EU Member States",
                    "show_reg_uids": true,
                    "value": 10005
                },
                "federal": {
                    "abbrev": "us",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-us'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US",
                    "key": "federal",
                    "label": "US Congress",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": [],
                    "odd_to_even_carryover": false,
                    "order": 1,
                    "region_name": "US Federal",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 1
                },
                "florida": {
                    "abbrev": "fl",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 10,
                    "error_type": 2,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 12,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-fl'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-FL",
                    "key": "florida",
                    "label": "Florida Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 11,
                    "region_name": "Florida",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 11
                },
                "florida_local": {
                    "abbrev": "fl_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 12,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-fl'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-FL",
                    "key": "florida_local",
                    "label": "Florida Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 63,
                    "region_name": "Florida Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 63
                },
                "france": {
                    "abbrev": "fra",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 75,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "FR",
                    "key": "france",
                    "label": "French Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 205,
                    "region_name": "France",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 205
                },
                "georgia": {
                    "abbrev": "ga",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 11,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 13,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ga'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-GA",
                    "key": "georgia",
                    "label": "Georgia General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 12,
                    "region_name": "Georgia",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 12
                },
                "georgia_local": {
                    "abbrev": "ga_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 13,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ga'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-GA",
                    "key": "georgia_local",
                    "label": "Georgia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 64,
                    "region_name": "Georgia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 64
                },
                "germany": {
                    "abbrev": "deu",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 59,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "DE",
                    "key": "germany",
                    "label": "The German Bundestag",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 203,
                    "region_name": "Germany",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CEST",
                    "value": 203
                },
                "global_region": {
                    "abbrev": "glb",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-us'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "key": "global_region",
                    "label": "Global",
                    "leg_type": 1,
                    "maintainers": [],
                    "odd_to_even_carryover": false,
                    "order": 1,
                    "region_name": "Global Region",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC",
                    "value": 1000
                },
                "greece": {
                    "abbrev": "grc",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 89,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "GR",
                    "key": "greece",
                    "label": "Hellenic Republic",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 234,
                    "region_name": "Greece",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+3",
                    "value": 234
                },
                "guam": {
                    "abbrev": "gu",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 57,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 66,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "GU",
                    "key": "guam",
                    "label": "Legislature of Guam",
                    "leg_type": 2,
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 109,
                    "region_name": "Guam",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ChST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 109
                },
                "hawaii": {
                    "abbrev": "hi",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 12,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 15,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-hi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-HI",
                    "key": "hawaii",
                    "label": "Hawaii State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 13,
                    "region_name": "Hawaii",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "HST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 13
                },
                "hawaii_local": {
                    "abbrev": "hi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 15,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-hi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-HI",
                    "key": "hawaii_local",
                    "label": "Hawaii Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 65,
                    "region_name": "Hawaii Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "HST",
                    "value": 65
                },
                "hong_kong": {
                    "abbrev": "hkg",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 96,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "HK",
                    "key": "hong_kong",
                    "label": "Legislative Council of Hong Kong",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 227,
                    "region_name": "Hong Kong",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+8",
                    "value": 227
                },
                "idaho": {
                    "abbrev": "id",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 13,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 16,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-id'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ID",
                    "key": "idaho",
                    "label": "Idaho State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 14,
                    "region_name": "Idaho",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 14
                },
                "idaho_local": {
                    "abbrev": "id_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 16,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-id'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ID",
                    "key": "idaho_local",
                    "label": "Idaho Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 66,
                    "region_name": "Idaho Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 66
                },
                "illinois": {
                    "abbrev": "il",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 14,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 17,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-il'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IL",
                    "key": "illinois",
                    "label": "Illinois General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 15,
                    "region_name": "Illinois",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 15
                },
                "illinois_local": {
                    "abbrev": "il_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 17,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-il'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IL",
                    "key": "illinois_local",
                    "label": "Illinois Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 67,
                    "region_name": "Illinois Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 67
                },
                "india": {
                    "abbrev": "ind",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 104,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IN",
                    "key": "india",
                    "label": "Parliament of India",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 206,
                    "region_name": "India",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "IST",
                    "value": 206
                },
                "indiana": {
                    "abbrev": "in",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 15,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 18,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-in'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IN",
                    "key": "indiana",
                    "label": "Indiana General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 16,
                    "region_name": "Indiana",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 16
                },
                "indiana_local": {
                    "abbrev": "in_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 18,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-in'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IN",
                    "key": "indiana_local",
                    "label": "Indiana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 68,
                    "region_name": "Indiana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 68
                },
                "indonesia": {
                    "abbrev": "idn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 102,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ID",
                    "key": "indonesia",
                    "label": "People's Consultative Assembly of the Republic of Indonesia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 222,
                    "region_name": "Indonesia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "WIB",
                    "value": 222
                },
                "international": {
                    "abbrev": "international",
                    "child_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                    "group_label": "International",
                    "international_region_ready": false,
                    "key": "international",
                    "label": "International",
                    "order": -997,
                    "region_name": "International",
                    "show_reg_uids": true,
                    "value": 10003
                },
                "iowa": {
                    "abbrev": "ia",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 16,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 19,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ia'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-IA",
                    "key": "iowa",
                    "label": "Iowa General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 17,
                    "region_name": "Iowa",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 17
                },
                "iowa_local": {
                    "abbrev": "ia_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 19,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ia'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-IA",
                    "key": "iowa_local",
                    "label": "Iowa Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 69,
                    "region_name": "Iowa Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 69
                },
                "ireland": {
                    "abbrev": "irl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 106,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IE",
                    "key": "ireland",
                    "label": "The Oireachtas",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 215,
                    "region_name": "Ireland",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT",
                    "value": 215
                },
                "israel": {
                    "abbrev": "isr",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 110,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IL",
                    "key": "israel",
                    "label": "State of Israel",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 240,
                    "region_name": "Israel",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+2",
                    "value": 240
                },
                "italy": {
                    "abbrev": "ita",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 111,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "IT",
                    "key": "italy",
                    "label": "Italian Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 207,
                    "region_name": "Italy",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 207
                },
                "japan": {
                    "abbrev": "jpn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 115,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "JP",
                    "key": "japan",
                    "label": "National Diet of Japan",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 210,
                    "region_name": "Japan",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "JST",
                    "value": 210
                },
                "kansas": {
                    "abbrev": "ks",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 17,
                    "error_type": 3,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 20,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ks'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-KS",
                    "key": "kansas",
                    "label": "Kansas State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 18,
                    "region_name": "Kansas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 18
                },
                "kansas_local": {
                    "abbrev": "ks_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 20,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ks'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-KS",
                    "key": "kansas_local",
                    "label": "Kansas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 70,
                    "region_name": "Kansas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 70
                },
                "kentucky": {
                    "abbrev": "ky",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 18,
                    "error_type": 6,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 21,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ky'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-KY",
                    "key": "kentucky",
                    "label": "Kentucky General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 19,
                    "region_name": "Kentucky",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 19
                },
                "kentucky_local": {
                    "abbrev": "ky_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 21,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ky'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-KY",
                    "key": "kentucky_local",
                    "label": "Kentucky Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 71,
                    "region_name": "Kentucky Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 71
                },
                "local": {
                    "abbrev": "local",
                    "child_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "group_label": "US Local",
                    "international_region_ready": false,
                    "key": "local",
                    "label": "Local",
                    "order": -998,
                    "region_name": "US Local",
                    "show_reg_uids": true,
                    "value": 10002
                },
                "louisiana": {
                    "abbrev": "la",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 19,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 22,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-la'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-LA",
                    "key": "louisiana",
                    "label": "Louisiana Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 20,
                    "region_name": "Louisiana",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 20
                },
                "louisiana_local": {
                    "abbrev": "la_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 22,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-la'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-LA",
                    "key": "louisiana_local",
                    "label": "Louisiana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 72,
                    "region_name": "Louisiana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 72
                },
                "maine": {
                    "abbrev": "me",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 20,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 23,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-me'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ME",
                    "key": "maine",
                    "label": "Maine Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 21,
                    "region_name": "Maine",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 21
                },
                "maine_local": {
                    "abbrev": "me_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 23,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-me'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ME",
                    "key": "maine_local",
                    "label": "Maine Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 73,
                    "region_name": "Maine Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 73
                },
                "malaysia": {
                    "abbrev": "mys",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 158,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "MY",
                    "key": "malaysia",
                    "label": "Parliament of Malaysia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 228,
                    "region_name": "Malaysia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+8",
                    "value": 228
                },
                "maryland": {
                    "abbrev": "md",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 21,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 24,
                    "has_bills": true,
                    "has_committee_cosponsors": true,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-md'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MD",
                    "key": "maryland",
                    "label": "Maryland General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 22,
                    "region_name": "Maryland",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 22
                },
                "maryland_local": {
                    "abbrev": "md_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 24,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-md'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MD",
                    "key": "maryland_local",
                    "label": "Maryland Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 74,
                    "region_name": "Maryland Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 74
                },
                "massachusetts": {
                    "abbrev": "ma",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 22,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 25,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ma'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MA",
                    "key": "massachusetts",
                    "label": "Massachusetts General Court",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 23,
                    "region_name": "Massachusetts",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 23
                },
                "massachusetts_local": {
                    "abbrev": "ma_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 25,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ma'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MA",
                    "key": "massachusetts_local",
                    "label": "Massachusetts Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 75,
                    "region_name": "Massachusetts Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 75
                },
                "mexico": {
                    "abbrev": "mex",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 143,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "MX",
                    "key": "mexico",
                    "label": "General Congress of the United Mexican States",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 202,
                    "region_name": "Mexico",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "value": 202
                },
                "michigan": {
                    "abbrev": "mi",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 23,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 26,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MI",
                    "key": "michigan",
                    "label": "Michigan Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 24,
                    "region_name": "Michigan",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 24
                },
                "michigan_local": {
                    "abbrev": "mi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 26,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MI",
                    "key": "michigan_local",
                    "label": "Michigan Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 76,
                    "region_name": "Michigan Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 76
                },
                "minnesota": {
                    "abbrev": "mn",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 24,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 27,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MN",
                    "key": "minnesota",
                    "label": "Minnesota State Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 25,
                    "region_name": "Minnesota",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 25
                },
                "minnesota_local": {
                    "abbrev": "mn_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 27,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MN",
                    "key": "minnesota_local",
                    "label": "Minnesota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 77,
                    "region_name": "Minnesota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 77
                },
                "mississippi": {
                    "abbrev": "ms",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 25,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 28,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ms'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MS",
                    "key": "mississippi",
                    "label": "Mississippi Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 26,
                    "region_name": "Mississippi",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 26
                },
                "mississippi_local": {
                    "abbrev": "ms_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 28,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ms'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MS",
                    "key": "mississippi_local",
                    "label": "Mississippi Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 78,
                    "region_name": "Mississippi Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 78
                },
                "missouri": {
                    "abbrev": "mo",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 26,
                    "error_type": 4,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 29,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mo'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MO",
                    "key": "missouri",
                    "label": "Missouri General Assembly",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 27,
                    "region_name": "Missouri",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 27
                },
                "missouri_local": {
                    "abbrev": "mo_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 29,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mo'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MO",
                    "key": "missouri_local",
                    "label": "Missouri Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 79,
                    "region_name": "Missouri Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 79
                },
                "montana": {
                    "abbrev": "mt",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 27,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 30,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-mt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-MT",
                    "key": "montana",
                    "label": "Montana Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 28,
                    "region_name": "Montana",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 28
                },
                "montana_local": {
                    "abbrev": "mt_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 30,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-mt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-MT",
                    "key": "montana_local",
                    "label": "Montana Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 80,
                    "region_name": "Montana Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 80
                },
                "nebraska": {
                    "abbrev": "ne",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 28,
                    "error_type": 8,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 31,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ne'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NE",
                    "key": "nebraska",
                    "label": "Nebraska Legislature",
                    "leg_type": 3,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 29,
                    "region_name": "Nebraska",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 29
                },
                "nebraska_local": {
                    "abbrev": "ne_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 31,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ne'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NE",
                    "key": "nebraska_local",
                    "label": "Nebraska Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 81,
                    "region_name": "Nebraska Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 81
                },
                "netherlands": {
                    "abbrev": "nld",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 167,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "NL",
                    "key": "netherlands",
                    "label": "States General of the Netherlands",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 219,
                    "region_name": "Netherlands",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 219
                },
                "nevada": {
                    "abbrev": "nv",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 29,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 32,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NV",
                    "key": "nevada",
                    "label": "Nevada Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 30,
                    "region_name": "Nevada",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 30
                },
                "nevada_local": {
                    "abbrev": "nv_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 32,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NV",
                    "key": "nevada_local",
                    "label": "Nevada Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 82,
                    "region_name": "Nevada Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 82
                },
                "new_hampshire": {
                    "abbrev": "nh",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 30,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 33,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NH",
                    "key": "new_hampshire",
                    "label": "New Hampshire General Court",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 31,
                    "region_name": "New Hampshire",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 31
                },
                "new_hampshire_local": {
                    "abbrev": "nh_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 33,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NH",
                    "key": "new_hampshire_local",
                    "label": "New Hampshire Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 83,
                    "region_name": "New Hampshire Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 83
                },
                "new_jersey": {
                    "abbrev": "nj",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 31,
                    "error_type": 1,
                    "even_to_odd_carryover": true,
                    "even_year_sessions": true,
                    "fips_code": 34,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nj'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NJ",
                    "key": "new_jersey",
                    "label": "New Jersey Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 32,
                    "region_name": "New Jersey",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 32
                },
                "new_jersey_local": {
                    "abbrev": "nj_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 34,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nj'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NJ",
                    "key": "new_jersey_local",
                    "label": "New Jersey Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 84,
                    "region_name": "New Jersey Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 84
                },
                "new_mexico": {
                    "abbrev": "nm",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 32,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 35,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nm'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NM",
                    "key": "new_mexico",
                    "label": "New Mexico Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 33,
                    "region_name": "New Mexico",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 33
                },
                "new_mexico_local": {
                    "abbrev": "nm_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 35,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nm'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NM",
                    "key": "new_mexico_local",
                    "label": "New Mexico Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 85,
                    "region_name": "New Mexico Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 85
                },
                "new_york": {
                    "abbrev": "ny",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 33,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 36,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ny'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NY",
                    "key": "new_york",
                    "label": "New York Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Assembly Member",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 34,
                    "region_name": "New York",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 34
                },
                "new_york_local": {
                    "abbrev": "ny_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 36,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ny'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NY",
                    "key": "new_york_local",
                    "label": "New York Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 86,
                    "region_name": "New York Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 86
                },
                "new_zealand": {
                    "abbrev": "nzl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 171,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "NZ",
                    "key": "new_zealand",
                    "label": "New Zealand Parliament",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 231,
                    "region_name": "New Zealand",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+13",
                    "value": 231
                },
                "north_carolina": {
                    "abbrev": "nc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 34,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 37,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-NC",
                    "key": "north_carolina",
                    "label": "North Carolina General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 35,
                    "region_name": "North Carolina",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 35
                },
                "north_carolina_local": {
                    "abbrev": "nc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 37,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-NC",
                    "key": "north_carolina_local",
                    "label": "North Carolina Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 87,
                    "region_name": "North Carolina Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 87
                },
                "north_dakota": {
                    "abbrev": "nd",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 35,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 38,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-nd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-ND",
                    "key": "north_dakota",
                    "label": "North Dakota Legislative Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 36,
                    "region_name": "North Dakota",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 36
                },
                "north_dakota_local": {
                    "abbrev": "nd_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 38,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-nd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-ND",
                    "key": "north_dakota_local",
                    "label": "North Dakota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 88,
                    "region_name": "North Dakota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 88
                },
                "northern_mariana_islands": {
                    "abbrev": "mp",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 55,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 69,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "MP",
                    "key": "northern_mariana_islands",
                    "label": "Northern Mariana Islands Commonwealth Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 110,
                    "region_name": "Northern Mariana Islands",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ChST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 110
                },
                "ohio": {
                    "abbrev": "oh",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 36,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 39,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-oh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OH",
                    "key": "ohio",
                    "label": "Ohio General Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 37,
                    "region_name": "Ohio",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 37
                },
                "ohio_local": {
                    "abbrev": "oh_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 39,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-oh'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OH",
                    "key": "ohio_local",
                    "label": "Ohio Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 89,
                    "region_name": "Ohio Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 89
                },
                "oklahoma": {
                    "abbrev": "ok",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 37,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 40,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ok'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OK",
                    "key": "oklahoma",
                    "label": "Oklahoma Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 38,
                    "region_name": "Oklahoma",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 38
                },
                "oklahoma_local": {
                    "abbrev": "ok_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 40,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ok'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OK",
                    "key": "oklahoma_local",
                    "label": "Oklahoma Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 90,
                    "region_name": "Oklahoma Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 90
                },
                "oregon": {
                    "abbrev": "or",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 38,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 41,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-or'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-OR",
                    "key": "oregon",
                    "label": "Oregon Legislative Assembly",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 39,
                    "region_name": "Oregon",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 39
                },
                "oregon_local": {
                    "abbrev": "or_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 41,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-or'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-OR",
                    "key": "oregon_local",
                    "label": "Oregon Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 91,
                    "region_name": "Oregon Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 91
                },
                "panama": {
                    "abbrev": "pan",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 174,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PA",
                    "key": "panama",
                    "label": "Legislative Branch of Panama",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 236,
                    "region_name": "Panama",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC-5",
                    "value": 236
                },
                "pennsylvania": {
                    "abbrev": "pa",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 39,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 42,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-pa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-PA",
                    "key": "pennsylvania",
                    "label": "Pennsylvania General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 40,
                    "region_name": "Pennsylvania",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 40
                },
                "pennsylvania_local": {
                    "abbrev": "pa_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 42,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-pa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-PA",
                    "key": "pennsylvania_local",
                    "label": "Pennsylvania Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 92,
                    "region_name": "Pennsylvania Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 92
                },
                "philippines": {
                    "abbrev": "phl",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 177,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PH",
                    "key": "philippines",
                    "label": "Congress of the Philippines",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 229,
                    "region_name": "Philippines",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+8",
                    "value": 229
                },
                "poland": {
                    "abbrev": "pol",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 180,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "PL",
                    "key": "poland",
                    "label": "Parliament of Poland",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 216,
                    "region_name": "Poland",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 216
                },
                "puerto_rico": {
                    "abbrev": "pr",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 54,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 72,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-pr'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "US-PR",
                    "key": "puerto_rico",
                    "label": "Legislative Assembly of Puerto Rico",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 41,
                    "region_name": "Puerto Rico",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 41
                },
                "puerto_rico_local": {
                    "abbrev": "pr_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 72,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-pr'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-PR",
                    "key": "puerto_rico_local",
                    "label": "Puerto Rico Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 93,
                    "region_name": "Puerto Rico Local",
                    "show_in_selector": false,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "value": 93
                },
                "rhode_island": {
                    "abbrev": "ri",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 40,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 44,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ri'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-RI",
                    "key": "rhode_island",
                    "label": "Rhode Island General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 42,
                    "region_name": "Rhode Island",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 42
                },
                "rhode_island_local": {
                    "abbrev": "ri_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 44,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ri'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-RI",
                    "key": "rhode_island_local",
                    "label": "Rhode Island Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 94,
                    "region_name": "Rhode Island Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 94
                },
                "saudi_arabia": {
                    "abbrev": "sau",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 192,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SA",
                    "key": "saudi_arabia",
                    "label": "Consultative Assembly of Saudi Arabia",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 212,
                    "region_name": "Saudi Arabia",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SAST",
                    "value": 212
                },
                "singapore": {
                    "abbrev": "sgp",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 195,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SG",
                    "key": "singapore",
                    "label": "Parliament of Singapore",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 223,
                    "region_name": "Singapore",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SGT",
                    "value": 223
                },
                "south_africa": {
                    "abbrev": "zaf",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 246,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ZA",
                    "key": "south_africa",
                    "label": "Parliament of South Africa",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 214,
                    "region_name": "South Africa",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "SAST",
                    "value": 214
                },
                "south_carolina": {
                    "abbrev": "sc",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 41,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 45,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-sc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-SC",
                    "key": "south_carolina",
                    "label": "South Carolina Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 43,
                    "region_name": "South Carolina",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 43
                },
                "south_carolina_local": {
                    "abbrev": "sc_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 45,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-sc'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-SC",
                    "key": "south_carolina_local",
                    "label": "South Carolina Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 95,
                    "region_name": "South Carolina Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 95
                },
                "south_dakota": {
                    "abbrev": "sd",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 42,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 46,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-sd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-SD",
                    "key": "south_dakota",
                    "label": "South Dakota State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 44,
                    "region_name": "South Dakota",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 44
                },
                "south_dakota_local": {
                    "abbrev": "sd_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 46,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-sd'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-SD",
                    "key": "south_dakota_local",
                    "label": "South Dakota Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 96,
                    "region_name": "South Dakota Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 96
                },
                "south_korea": {
                    "abbrev": "kor",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 122,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "KR",
                    "key": "south_korea",
                    "label": "National Assembly of the Republic of Korea",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 221,
                    "region_name": "South Korea",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "KST",
                    "value": 221
                },
                "spain": {
                    "abbrev": "esp",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 69,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "ES",
                    "key": "spain",
                    "label": "Las Cortes Generales",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 211,
                    "region_name": "Spain",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CEST",
                    "value": 211
                },
                "states": {
                    "abbrev": "states",
                    "child_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110],
                    "group_label": "US States and Territories",
                    "international_region_ready": false,
                    "key": "states",
                    "label": "States",
                    "order": -999,
                    "region_name": "US States",
                    "show_reg_uids": true,
                    "value": 10001
                },
                "states_and_local": {
                    "abbrev": "states-and-local",
                    "child_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                    "group_label": "US States & Local",
                    "international_region_ready": false,
                    "key": "states_and_local",
                    "label": "US States & Local",
                    "order": -996,
                    "region_name": "US States & Local",
                    "show_reg_uids": true,
                    "value": 10004
                },
                "sweden": {
                    "abbrev": "swe",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 210,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": true,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "SE",
                    "key": "sweden",
                    "label": "Riksdag",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 218,
                    "region_name": "Sweden",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CET",
                    "value": 218
                },
                "taiwan": {
                    "abbrev": "twn",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 228,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TW",
                    "key": "taiwan",
                    "label": "Legislative Yuan",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 225,
                    "region_name": "Taiwan",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "CST",
                    "value": 225
                },
                "tennessee": {
                    "abbrev": "tn",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 43,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 47,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-tn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-TN",
                    "key": "tennessee",
                    "label": "Tennessee General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 45,
                    "region_name": "Tennessee",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 45
                },
                "tennessee_local": {
                    "abbrev": "tn_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 47,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-tn'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-TN",
                    "key": "tennessee_local",
                    "label": "Tennessee Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 97,
                    "region_name": "Tennessee Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 97
                },
                "texas": {
                    "abbrev": "tx",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 44,
                    "error_type": 5,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 48,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-tx'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-TX",
                    "key": "texas",
                    "label": "Texas Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 46,
                    "region_name": "Texas",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 46
                },
                "texas_local": {
                    "abbrev": "tx_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 48,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-tx'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-TX",
                    "key": "texas_local",
                    "label": "Texas Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 98,
                    "region_name": "Texas Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 98
                },
                "thailand": {
                    "abbrev": "tha",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 218,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TH",
                    "key": "thailand",
                    "label": "National Assembly of Thailand",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 220,
                    "region_name": "Thailand",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "ICT",
                    "value": 220
                },
                "turkey": {
                    "abbrev": "tur",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 226,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "TR",
                    "key": "turkey",
                    "label": "Parliament of Turkey",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 239,
                    "region_name": "Turkey",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+3",
                    "value": 239
                },
                "united_arab_emirates": {
                    "abbrev": "uae",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 8,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "AE",
                    "key": "united_arab_emirates",
                    "label": "The United Arab Emirates",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 241,
                    "region_name": "United Arab Emirates",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "UTC+4",
                    "value": 241
                },
                "united_kingdom": {
                    "abbrev": "gbr",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 79,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "GB",
                    "key": "united_kingdom",
                    "label": "Parliament of the United Kingdom of Great Britain and Northern Ireland",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 204,
                    "region_name": "United Kingdom",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT",
                    "value": 204
                },
                "user_global": {
                    "abbrev": "global",
                    "child_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000],
                    "group_label": "Global",
                    "international_region_ready": false,
                    "key": "user_global",
                    "label": "Global",
                    "order": -1001,
                    "region_name": "Global",
                    "show_reg_uids": true,
                    "value": 9999
                },
                "utah": {
                    "abbrev": "ut",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 45,
                    "error_type": 10,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 49,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-ut'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-UT",
                    "key": "utah",
                    "label": "Utah State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 47,
                    "region_name": "Utah",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 47
                },
                "utah_local": {
                    "abbrev": "ut_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 49,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-ut'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-UT",
                    "key": "utah_local",
                    "label": "Utah Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 99,
                    "region_name": "Utah Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 99
                },
                "vermont": {
                    "abbrev": "vt",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 46,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 50,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-vt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-VT",
                    "key": "vermont",
                    "label": "Vermont General Assembly",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 48,
                    "region_name": "Vermont",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 48
                },
                "vermont_local": {
                    "abbrev": "vt_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 50,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-vt'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-VT",
                    "key": "vermont_local",
                    "label": "Vermont Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 100,
                    "region_name": "Vermont Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 100
                },
                "vietnam": {
                    "abbrev": "vnm",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "database_id": 241,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "",
                    "international_region_ready": true,
                    "is_eu_member_state": false,
                    "is_international_region": true,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "VN",
                    "key": "vietnam",
                    "label": "National Assembly of the Socialist Republic of Vietnam",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 230,
                    "region_name": "Vietnam",
                    "show_in_selector": false,
                    "show_reg_uids": false,
                    "timezone": "GMT+7",
                    "value": 230
                },
                "virgin_islands": {
                    "abbrev": "vi",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 53,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 78,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": false,
                    "is_state_region": true,
                    "iso_code": "VI",
                    "key": "virgin_islands",
                    "label": "Legislature of the Virgin Islands",
                    "leg_type": 2,
                    "lower_chamber_title": "",
                    "lower_member_title": "",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 107,
                    "region_name": "Virgin Islands",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "AST",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 107
                },
                "virginia": {
                    "abbrev": "va",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 47,
                    "error_type": 1,
                    "even_to_odd_carryover": true,
                    "even_year_sessions": true,
                    "fips_code": 51,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-va'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-VA",
                    "key": "virginia",
                    "label": "Virginia General Assembly",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 49,
                    "region_name": "Virginia",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 49
                },
                "virginia_local": {
                    "abbrev": "va_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 51,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-va'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-VA",
                    "key": "virginia_local",
                    "label": "Virginia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 101,
                    "region_name": "Virginia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 101
                },
                "washington": {
                    "abbrev": "wa",
                    "annual_sessions": false,
                    "bills_carryover": true,
                    "database_id": 48,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 53,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WA",
                    "key": "washington",
                    "label": "Washington State Legislature",
                    "leg_type": 2,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 50,
                    "region_name": "Washington",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 50
                },
                "washington_local": {
                    "abbrev": "wa_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 53,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wa'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WA",
                    "key": "washington_local",
                    "label": "Washington Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 102,
                    "region_name": "Washington Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "PT",
                    "value": 102
                },
                "west_virginia": {
                    "abbrev": "wv",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 49,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 54,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": true,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WV",
                    "key": "west_virginia",
                    "label": "West Virginia Legislature",
                    "leg_type": 1,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Delegate",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 51,
                    "region_name": "West Virginia",
                    "show_in_selector": true,
                    "show_reg_uids": false,
                    "timezone": "ET",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 51
                },
                "west_virginia_local": {
                    "abbrev": "wv_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 54,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wv'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WV",
                    "key": "west_virginia_local",
                    "label": "West Virginia Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 103,
                    "region_name": "West Virginia Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "ET",
                    "value": 103
                },
                "wisconsin": {
                    "abbrev": "wi",
                    "annual_sessions": true,
                    "bills_carryover": true,
                    "database_id": 50,
                    "error_type": 11,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 55,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WI",
                    "key": "wisconsin",
                    "label": "Wisconsin State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "Assembly",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": true,
                    "order": 52,
                    "region_name": "Wisconsin",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 52
                },
                "wisconsin_local": {
                    "abbrev": "wi_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 55,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wi'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WI",
                    "key": "wisconsin_local",
                    "label": "Wisconsin Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 104,
                    "region_name": "Wisconsin Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "CT",
                    "value": 104
                },
                "wyoming": {
                    "abbrev": "wy",
                    "annual_sessions": true,
                    "bills_carryover": false,
                    "database_id": 51,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": true,
                    "fips_code": 56,
                    "has_bills": true,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": true,
                    "has_cosponsors": false,
                    "has_resolutions": true,
                    "has_sponsors": true,
                    "icon_element": "<span class='stateface stateface-wy'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": false,
                    "is_single_us_state": true,
                    "is_state_region": true,
                    "iso_code": "US-WY",
                    "key": "wyoming",
                    "label": "Wyoming State Legislature",
                    "leg_type": 4,
                    "lower_chamber_title": "House",
                    "lower_member_title": "Representative",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 53,
                    "region_name": "Wyoming",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "upper_chamber_title": "Senate",
                    "upper_member_title": "Senator",
                    "value": 53
                },
                "wyoming_local": {
                    "abbrev": "wy_local",
                    "annual_sessions": false,
                    "bills_carryover": false,
                    "error_type": 1,
                    "even_to_odd_carryover": false,
                    "even_year_sessions": false,
                    "fips_code": 56,
                    "has_bills": false,
                    "has_committee_cosponsors": false,
                    "has_committee_sponsors": false,
                    "has_cosponsors": false,
                    "has_resolutions": false,
                    "has_sponsors": false,
                    "icon_element": "<span class='stateface stateface-wy'></span>",
                    "international_region_ready": false,
                    "is_eu_member_state": false,
                    "is_international_region": false,
                    "is_local_region": true,
                    "is_single_us_state": false,
                    "is_state_region": false,
                    "iso_code": "US-WY",
                    "key": "wyoming_local",
                    "label": "Wyoming Local",
                    "maintainers": ["dev-data@quorum.us"],
                    "odd_to_even_carryover": false,
                    "order": 105,
                    "region_name": "Wyoming Local",
                    "show_in_selector": true,
                    "show_reg_uids": true,
                    "timezone": "MT",
                    "value": 105
                }
            },
            "TermType": {
                "__is_enum": true,
                "crs_term": { "key": "crs_term", "label": "crs_term", "value": 3 },
                "new": { "key": "new", "label": "New", "value": 2 },
                "old": { "key": "old", "label": "Old", "value": 1 },
                "other": { "key": "other", "label": "other", "value": 4 }
            },
            "UrlAction": {
                "__is_enum": true,
                "set_priority": {
                    "key": "set_priority",
                    "label": "set_priority",
                    "required_arguments": ["quorum_data_type", "object_id", "priority"],
                    "value": 2
                },
                "set_stance": {
                    "key": "set_stance",
                    "label": "set_stance",
                    "required_arguments": ["quorum_data_type", "object_id", "stance"],
                    "value": 1
                },
                "toggle_feature": {
                    "key": "toggle_feature",
                    "label": "toggle_feature",
                    "required_arguments": ["feature_slug"],
                    "value": 0
                }
            }
        },
        "onboarding": {
            "models": {
                "Application": {
                    "__is_model": true,
                    "__name__": "Application",
                    "data_model": "app.onboarding.models.Application",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/application/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 3, "help_text": "Name of the application.", "name": "name", "verbose_name": "name" },
                        { "field_type": 16, "help_text": "The date that the application was created.", "name": "created", "verbose_name": "created" },
                        {
                            "field_type": 7,
                            "help_text": "The application's creator",
                            "name": "creator",
                            "related_model": { "__module__": "app.onboarding.models", "__name__": "Developer" },
                            "verbose_name": "creator"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The User to which the Application belongs.",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        }
                    ]
                },
                "Developer": {
                    "__is_model": true,
                    "__name__": "Developer",
                    "data_model": "app.onboarding.models.Developer",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/developer/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 3, "help_text": "Developer's Firstname", "name": "firstname", "verbose_name": "firstname" },
                        { "field_type": 3, "help_text": "Developer Lastname", "name": "lastname", "verbose_name": "lastname" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.onboarding.models", "__name__": "OperatingSystemType" },
                            "field_type": 4,
                            "help_text": "Developer Operating System Preference",
                            "name": "operating_system_preference",
                            "verbose_name": "operating system preference"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Organization to which the Developer belongs.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        }
                    ]
                },
                "OperatingSystemType": {
                    "__is_enum": true,
                    "linux": { "company": "N/A", "key": "linux", "label": "Linux", "value": 3 },
                    "osx": { "company": "Apple", "key": "osx", "label": "OSX", "value": 1 },
                    "windows": { "company": "Microsoft", "key": "windows", "label": "Windows", "value": 2 }
                }
            }
        },
        "pac": {
            "e_advocacy": {
                "models": {
                    "PACCEAdvocacyLoginRequest": {
                        "__is_model": true,
                        "__name__": "PACCEAdvocacyLoginRequest",
                        "data_model": "app.pac.e_advocacy.models.PACCEAdvocacyLoginRequest",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/eadvocacy-login/",
                        "fields": [
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 14, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "field_type": 7,
                                "help_text": "The organization associated with this login request",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The QuorumUser that requested access to a hybrid PAC Classic page",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The supporter that the request is for, if the request is for a particular Supporter (Individual in PAC Classic)",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            { "field_type": 4, "help_text": "The amount of time in seconds that this request will wait for a response from PAC Classic before expiring", "name": "time_to_live", "verbose_name": "time to live" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.e_advocacy.types", "__name__": "PACCEAdvocacyLoginStatus" },
                                "field_type": 4,
                                "help_text": "The current status of the trusted login request",
                                "name": "status",
                                "verbose_name": "status"
                            },
                            { "field_type": 3, "help_text": "The encrypted token generated when the request was created", "name": "token", "verbose_name": "token" }
                        ]
                    }
                },
                "types": {
                    "PACCEAdvocacyLoginStatus": {
                        "__is_enum": true,
                        "created": { "description": "The PACCEAdvocacyLoginRequest is created, but not yet sent to PAC Classic", "is_completed_status": false, "key": "created", "label": "Created", "value": 0 },
                        "expired": { "description": "The PACCEAdvocacyLoginRequest did not return from PAC Classic within the TTL, and has expired", "is_completed_status": true, "key": "expired", "label": "Expired", "value": 4 },
                        "returned": { "description": "The PACCEAdvocacyLoginRequest has returned from PAC Classic, but not yet processed as valid, invalid, or expired", "is_completed_status": false, "key": "returned", "label": "Returned", "value": 2 },
                        "sent": { "description": "The PACCEAdvocacyLoginRequest has been sent to PAC Classic, and is awaiting a response", "is_completed_status": false, "key": "sent", "label": "Sent", "value": 1 },
                        "validated": { "description": "The PACCEAdvocacyLoginRequest has returned from PAC Classic, and has been validated", "is_completed_status": true, "key": "validated", "label": "Validated", "value": 3 }
                    }
                }
            },
            "models": {
                "coverage_period": {
                    "CoveragePeriod": {
                        "__is_model": true,
                        "__name__": "CoveragePeriod",
                        "data_model": "app.pac.models.coverage_period.CoveragePeriod",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/coverage-period/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "The PAC that this coverage period pertains to.",
                                "name": "ledger_settings",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                                "verbose_name": "ledger settings"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The organization that this FecFile belongs to",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            { "field_type": 5, "help_text": "The lower date boundary (in the FEC's timezone) for this coverage period.", "name": "coverage_start_date", "verbose_name": "coverage start date" },
                            { "field_type": 5, "help_text": "The upper date boundary (in the FEC's timezone) for this coverage period.", "name": "coverage_end_date", "verbose_name": "coverage end date" }
                        ]
                    }
                },
                "elected_office": {
                    "ElectedOffice": {
                        "__is_model": true,
                        "__name__": "ElectedOffice",
                        "data_model": "app.pac.models.elected_office.ElectedOffice",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/electedoffice/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 4, "help_text": "The PACC PACOfficeID of this record - required for PACC sync", "name": "pacc_id", "verbose_name": "pacc id" },
                            { "field_type": 3, "help_text": "Human-readable name of the office", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.ledger.types", "__name__": "ReportingJurisdictionType" },
                                "field_type": 4,
                                "help_text": "The jurisdiction for this office",
                                "name": "jurisdiction",
                                "verbose_name": "jurisdiction"
                            }
                        ]
                    }
                },
                "election": {
                    "Election": {
                        "__is_model": true,
                        "__name__": "Election",
                        "data_model": "app.pac.models.election.Election",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/election/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "The election cycle with which this election is associated.",
                                "name": "cycle",
                                "related_model": { "__module__": "app.pac.models.election_cycle", "__name__": "ElectionCycle" },
                                "verbose_name": "cycle"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.events.types", "__name__": "ElectionType" },
                                "field_type": 4,
                                "help_text": "The type of this election.",
                                "name": "election_type",
                                "verbose_name": "election type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "\n            The broadest GeoShape including all jurisdictions for which this election is capable of\n            appointing congressional officials or selecting candidates for congressional office.\n\n            Examples:\n            - A primary election held across all of New York would be mapped to\n                the New York state GeoShape, rather than any individual GeoShape within New York.\n            - A congressional convention held in Virginia-09 would be mapped to the VA-09 GeoShape,\n                because VA holds conventions on a district-by-district basis.\n            - A congressional convention held in SC would be mapped to the SC state geoshape, because\n                SC holds a single statewide convention.\n            - The HI presidential and congressional primary would be mapped to the HI state geoshape,\n                because we ignore the presidential component and HI's convention is statewide.\n            - The US-wide Election Day would be mapped to the US national GeoShape, because although\n                we ignore the presidential component, the composite of all US districts is (essentially)\n                the entire US.\n        ",
                                "name": "geo_shape",
                                "related_model": { "__module__": "app.geography.models", "__name__": "GeoShape" },
                                "verbose_name": "geo shape"
                            },
                            { "field_type": 3, "help_text": "\n            A short name for this Election. Should be suitable for putting on the FEC Form\n            3/3X as the purpose of a donation.\n        ", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "Region" },
                                "field_type": 4,
                                "help_text": "\n            For Quorum product permissioning purposes, the product Region of the office that this election\n            selects a candidate for.\n\n            For example, an election for US representative or senator for Vermont would have q_region = Region.federal.\n            A primary election for DC council would have q_region = Region.district_of_columbia.\n        ",
                                "name": "q_region",
                                "verbose_name": "q region"
                            },
                            { "field_type": 3, "help_text": "A 'key' for the Election built by concatenating the 4 digit year, the Jurisdiction abbreviation, and the single-character election type code. Example: 2022 Ohio General would be 2022OHG.", "name": "pacc_election_key", "verbose_name": "Constructed Election Key" },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "election_dates",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "election dates"
                            }
                        ]
                    }
                },
                "election_cycle": {
                    "ElectionCycle": {
                        "__is_model": true,
                        "__name__": "ElectionCycle",
                        "data_model": "app.pac.models.election_cycle.ElectionCycle",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/electioncycle/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 4, "help_text": "\n            The year used to identify this election cycle.\n            The year(s) of election dates associated with this election may can be greater than or less than\n            this value; e.g. 2019 elections and January 2021 runoff elections would typically be associated with the\n            2020 FEC election cycle.\n        ", "name": "cycle_year", "verbose_name": "cycle year" },
                            { "field_type": 3, "help_text": "The name of this election cycle.", "name": "name", "verbose_name": "name" }
                        ]
                    }
                },
                "fec_form_3x_submission": {
                    "FecForm3XSubmission": {
                        "__is_model": true,
                        "__name__": "FecForm3XSubmission",
                        "data_model": "app.pac.models.fec_form_3x_submission.FecForm3XSubmission",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/fecform3xsubmission/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "The PacFile this individual form submission belongs to.",
                                "name": "pac_file",
                                "related_model": { "__module__": "app.pac.models.pac_file", "__name__": "PacFile" },
                                "verbose_name": "pac file"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The organization that this form belongs to. Should always match .pac_file.organization.",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "Form3XReportType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "report_code",
                                "verbose_name": "report code"
                            },
                            { "field_type": 3, "help_text": "The type of election to which this Form 3x corresponds.", "name": "election_type", "verbose_name": "election type" },
                            { "field_type": 5, "help_text": "The date of the election event or ElectionDate to which this Form 3X corresponds.", "name": "election_date", "verbose_name": "election date" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "Region" },
                                "field_type": 4,
                                "help_text": "If a Form 3X for an election in a particular state, the election in which that state occurred.",
                                "name": "election_region",
                                "verbose_name": "election region"
                            },
                            { "field_type": 1, "help_text": "Whether there is a change of the committee address.", "name": "is_change_of_committee_address", "verbose_name": "is change of committee address" },
                            { "field_type": 4, "help_text": "Line 6(b), Column A: the committee's cash on hand at the beginning of the reporting period.", "name": "col_a_cash_on_hand_beginning", "verbose_name": "col a cash on hand beginning" },
                            { "field_type": 4, "help_text": "Line 6(c), Column A: the committee's aggregate receipts over the reporting period.", "name": "col_a_total_receipts", "verbose_name": "col a total receipts" },
                            { "field_type": 4, "help_text": "Line 7, Column A: the committee's aggregate disbursements over the reporting period.", "name": "col_a_total_disbursements", "verbose_name": "col a total disbursements" },
                            { "field_type": 4, "help_text": "Line 8, column A: the committee's cash on hand at the close of the reporting period.", "name": "col_a_cash_on_hand_close", "verbose_name": "col a cash on hand close" },
                            { "field_type": 4, "help_text": "Line 9, column A: all debts and obligations owed to this committee at the close of the reporting period.", "name": "col_a_debts_owed_to_committee", "verbose_name": "col a debts owed to committee" },
                            { "field_type": 4, "help_text": "Line 10, column A: all debts and obligations owed by this committee at the close of the reporting period.", "name": "col_a_debts_owed_by_committee", "verbose_name": "col a debts owed by committee" },
                            { "field_type": 4, "help_text": "Line 11(a)i, column A: the total of all itemized contributions from individuals other than political committees over the reporting period.", "name": "col_a_total_itemized_contributions_from_non_committees", "verbose_name": "col a total itemized contributions from non committees" },
                            { "field_type": 4, "help_text": "Line 11(a)ii, column A: the total of all unitemized contributions from individuals other than political committees over the reporting period.", "name": "col_a_total_unitemized_contributions_from_non_committees", "verbose_name": "col a total unitemized contributions from non committees" },
                            { "field_type": 4, "help_text": "Line 11(b), column A: The total of all contributions from political party committees during the reporting period.", "name": "col_a_total_contributions_from_political_party_committees", "verbose_name": "col a total contributions from political party committees" },
                            { "field_type": 4, "help_text": "Line 11(c), column A: The total of all contributions from political committees other than party committees during the reporting period.", "name": "col_a_total_contributions_from_other_political_committees", "verbose_name": "col a total contributions from other political committees" },
                            { "field_type": 4, "help_text": "Line 12, column A: The total of all transfers from affiliated political committees during the reporting period.", "name": "col_a_transfers_from_affiliated_other_party_committees", "verbose_name": "col a transfers from affiliated other party committees" },
                            { "field_type": 4, "help_text": "Line 13, column A: The total of all loans received by the committee during the reporting period.", "name": "col_a_loans_received", "verbose_name": "col a loans received" },
                            { "field_type": 4, "help_text": "Line 14, column A: The total of all loan repayments received by the committee during the reporting period.", "name": "col_a_loan_repayments_received", "verbose_name": "col a loan repayments received" },
                            { "field_type": 4, "help_text": "Line 15, column A: The total of offsets to operating expenditures (refunds, etc.) during the reporting period.", "name": "col_a_offsets_to_operating_expenditures", "verbose_name": "col a offsets to operating expenditures" },
                            { "field_type": 4, "help_text": "Line 16, column A: The total, during the reporting period, of refunds received from federal political committees to which the committee had initially made contributions.", "name": "col_a_refunds_of_federal_contributions", "verbose_name": "col a refunds of federal contributions" },
                            { "field_type": 4, "help_text": "Line 17, column A: The total of other miscellaneous receipts during the reporting period.", "name": "col_a_other_federal_receipts", "verbose_name": "col a other federal receipts" },
                            { "field_type": 4, "help_text": "Line 18(a), column A: The total of transfers made from nonfederal accounts to this PAC's federal account to pay for allocated federal/nonfederal activity.", "name": "col_a_transfers_from_nonfederal_accounts", "verbose_name": "col a transfers from nonfederal accounts" },
                            { "field_type": 4, "help_text": "Line 18(b), column A: The total of transfers made to this PAC's federal account from Levin funds.", "name": "col_a_transfers_from_levin_funds", "verbose_name": "col a transfers from levin funds" },
                            { "field_type": 4, "help_text": "Line 21(a)i, column A: For committees engaging in allocated federal and nonfederal activity, the total federal share of all such operating expenditures.", "name": "col_a_allocated_federal_share", "verbose_name": "col a allocated federal share" },
                            { "field_type": 4, "help_text": "Line 21(a)ii, column A: For committees engaging in allocated federal and nonfederal activity, the total nonfederal share of all such operating expenditures.", "name": "col_a_allocated_nonfederal_share", "verbose_name": "col a allocated nonfederal share" },
                            { "field_type": 4, "help_text": "Line 21(b), column A: Federal operating expenditures not covered in Line 21(a). Includes all federal operating expenditures for purely federal committees.", "name": "col_a_other_federal_operating_expenditures", "verbose_name": "col a other federal operating expenditures" },
                            { "field_type": 4, "help_text": "Line 22, column A: The total of all transfers to affiliated political committees during the reporting period.", "name": "col_a_transfers_to_affiliated_other_party_committees", "verbose_name": "col a transfers to affiliated other party committees" },
                            { "field_type": 4, "help_text": "Line 23, column A: The total of all contributions this committee made to federal political committees or candidates during the reporting period.", "name": "col_a_contributions_to_federal_committees", "verbose_name": "col a contributions to federal committees" },
                            { "field_type": 4, "help_text": "Line 24, column A: The total of all independent expenditures this committee made during the reporting period.", "name": "col_a_independent_expenditures", "verbose_name": "col a independent expenditures" },
                            { "field_type": 4, "help_text": "Line 25, column A: The total of all coordinated party expenditures this committee made during the reporting period. (This is only applicable to party committees.)", "name": "col_a_coordinated_party_expenditures", "verbose_name": "col a coordinated party expenditures" },
                            { "field_type": 4, "help_text": "Line 26, column A: The total of all loan repayments this committee made during the reporting period.", "name": "col_a_loan_repayments_made", "verbose_name": "col a loan repayments made" },
                            { "field_type": 4, "help_text": "Line 27, column A: The total of all loans this committee made during the reporting period.", "name": "col_a_loans_made", "verbose_name": "col a loans made" },
                            { "field_type": 4, "help_text": "Line 28(a), column A: The total of all refunds made by the committee during the reporting period against contributions initially received from individuals other than political committees.", "name": "col_a_refunds_made_to_individuals", "verbose_name": "col a refunds made to individuals" },
                            { "field_type": 4, "help_text": "Line 28(b), column A: The total of all refunds made by the committee during the reporting period against contributions initially received from political party committees.", "name": "col_a_refunds_made_to_party_committees", "verbose_name": "col a refunds made to party committees" },
                            { "field_type": 4, "help_text": "Line 28(c), column A: The total of all refunds made by the committee during the reporting period against contributions initially received from political committees other than party committees.", "name": "col_a_refunds_made_to_other_political_committees", "verbose_name": "col a refunds made to other political committees" },
                            { "field_type": 4, "help_text": "Line 29, column A: The total of all disbursements made by the committee during the reporting period and not categorized under any of the other lines.", "name": "col_a_other_disbursements", "verbose_name": "col a other disbursements" },
                            { "field_type": 4, "help_text": "Line 30(a)i, column A: The total federal portion of all disbursements made for allocable federal election activity during the reporting period.", "name": "col_a_allocated_federal_election_activity_federal_share", "verbose_name": "col a allocated federal election activity federal share" },
                            { "field_type": 4, "help_text": "Line 30(a)ii, column A: The total Levin or non-federal share of all disbursements made for allocable federal election activity during the reporting period.", "name": "col_a_allocated_federal_election_activity_levin_share", "verbose_name": "col a allocated federal election activity levin share" },
                            { "field_type": 4, "help_text": "Line 30(b), column A: The total amount of disbursements made for activity classified under 11 CFR 100.24(b)(3) and (4) during the reporting period.", "name": "col_a_federal_election_activity_federal_funds", "verbose_name": "col a federal election activity federal funds" },
                            { "field_type": 4, "help_text": "Line 6(b), Column B: the committee's cash on hand at the beginning of the calendar year.", "name": "col_b_cash_on_hand_beginning", "verbose_name": "col b cash on hand beginning" },
                            { "field_type": 4, "help_text": "Line 6(c), Column B: the committee's aggregate receipts year-to-date.", "name": "col_b_total_receipts", "verbose_name": "col b total receipts" },
                            { "field_type": 4, "help_text": "Line 7, Column B: the committee's aggregate disbursements year-to-date.", "name": "col_b_total_disbursements", "verbose_name": "col b total disbursements" },
                            { "field_type": 4, "help_text": "Line 8, column B: the committee's cash on hand at the close of the reporting period.", "name": "col_b_cash_on_hand_close", "verbose_name": "col b cash on hand close" },
                            { "field_type": 4, "help_text": "Line 11(a)i, column B: the total of all itemized contributions from individuals other than political committees year-to-date.", "name": "col_b_total_itemized_contributions_from_non_committees", "verbose_name": "col b total itemized contributions from non committees" },
                            { "field_type": 4, "help_text": "Line 11(a)ii, column B: the total of all unitemized contributions from individuals other than political committees year-to-date.", "name": "col_b_total_unitemized_contributions_from_non_committees", "verbose_name": "col b total unitemized contributions from non committees" },
                            { "field_type": 4, "help_text": "Line 11(b), column B: The total of all contributions from political party committees year-to-date.", "name": "col_b_total_contributions_from_political_party_committees", "verbose_name": "col b total contributions from political party committees" },
                            { "field_type": 4, "help_text": "Line 11(c), column B: The total of all contributions from political committees other than party committees year-to-date.", "name": "col_b_total_contributions_from_other_political_committees", "verbose_name": "col b total contributions from other political committees" },
                            { "field_type": 4, "help_text": "Line 12, column B: The total of all transfers from affiliated political committees year-to-date.", "name": "col_b_transfers_from_affiliated_other_party_committees", "verbose_name": "col b transfers from affiliated other party committees" },
                            { "field_type": 4, "help_text": "Line 13, column B: The total of all loans received by the committee year-to-date.", "name": "col_b_loans_received", "verbose_name": "col b loans received" },
                            { "field_type": 4, "help_text": "Line 14, column B: The total of all loan repayments received by the committee year-to-date.", "name": "col_b_loan_repayments_received", "verbose_name": "col b loan repayments received" },
                            { "field_type": 4, "help_text": "Line 15, column B: The total of offsets to operating expenditures (refunds, etc.) year-to-date.", "name": "col_b_offsets_to_operating_expenditures", "verbose_name": "col b offsets to operating expenditures" },
                            { "field_type": 4, "help_text": "Line 16, column B: The total, year-to-date, of refunds received from federal political committees to which the committee had initially made contributions.", "name": "col_b_refunds_of_federal_contributions", "verbose_name": "col b refunds of federal contributions" },
                            { "field_type": 4, "help_text": "Line 17, column B: The total of other miscellaneous receipts year-to-date.", "name": "col_b_other_federal_receipts", "verbose_name": "col b other federal receipts" },
                            { "field_type": 4, "help_text": "Line 18(a), column B: The total of transfers made from nonfederal accounts to this PAC's federal account to pay for allocated federal/nonfederal activity.", "name": "col_b_transfers_from_nonfederal_accounts", "verbose_name": "col b transfers from nonfederal accounts" },
                            { "field_type": 4, "help_text": "Line 18(b), column B: The total of transfers made to this PAC's federal account from Levin funds.", "name": "col_b_transfers_from_levin_funds", "verbose_name": "col b transfers from levin funds" },
                            { "field_type": 4, "help_text": "Line 21(a)i, column B: For committees engaging in allocated federal and nonfederal activity, the total federal share of all such operating expenditures.", "name": "col_b_allocated_federal_share", "verbose_name": "col b allocated federal share" },
                            { "field_type": 4, "help_text": "Line 21(a)ii, column B: For committees engaging in allocated federal and nonfederal activity, the total nonfederal share of all such operating expenditures.", "name": "col_b_allocated_nonfederal_share", "verbose_name": "col b allocated nonfederal share" },
                            { "field_type": 4, "help_text": "Line 21(b), column B: Federal operating expenditures not covered in Line 21(a). Includes all federal operating expenditures for purely federal committees.", "name": "col_b_other_federal_operating_expenditures", "verbose_name": "col b other federal operating expenditures" },
                            { "field_type": 4, "help_text": "Line 22, column B: The total of all transfers to affiliated political committees year-to-date.", "name": "col_b_transfers_to_affiliated_other_party_committees", "verbose_name": "col b transfers to affiliated other party committees" },
                            { "field_type": 4, "help_text": "Line 23, column B: The total of all contributions this committee made to federal political committees or candidates year-to-date.", "name": "col_b_contributions_to_federal_committees", "verbose_name": "col b contributions to federal committees" },
                            { "field_type": 4, "help_text": "Line 24, column B: The total of all independent expenditures this committee made year-to-date.", "name": "col_b_independent_expenditures", "verbose_name": "col b independent expenditures" },
                            { "field_type": 4, "help_text": "Line 25, column B: The total of all coordinated party expenditures this committee made year-to-date. (This is only applicable to party committees.)", "name": "col_b_coordinated_party_expenditures", "verbose_name": "col b coordinated party expenditures" },
                            { "field_type": 4, "help_text": "Line 26, column B: The total of all loan repayments this committee made year-to-date.", "name": "col_b_loan_repayments_made", "verbose_name": "col b loan repayments made" },
                            { "field_type": 4, "help_text": "Line 27, column B: The total of all loans this committee made year-to-date.", "name": "col_b_loans_made", "verbose_name": "col b loans made" },
                            { "field_type": 4, "help_text": "Line 28(a), column B: The total of all refunds made by the committee year-to-date against contributions initially received from individuals other than political committees.", "name": "col_b_refunds_made_to_individuals", "verbose_name": "col b refunds made to individuals" },
                            { "field_type": 4, "help_text": "Line 28(b), column B: The total of all refunds made by the committee year-to-date against contributions initially received from political party committees.", "name": "col_b_refunds_made_to_party_committees", "verbose_name": "col b refunds made to party committees" },
                            { "field_type": 4, "help_text": "Line 28(c), column B: The total of all refunds made by the committee year-to-date against contributions initially received from political committees other than party committees.", "name": "col_b_refunds_made_to_other_political_committees", "verbose_name": "col b refunds made to other political committees" },
                            { "field_type": 4, "help_text": "Line 29, column B: The total of all disbursements made by the committee year-to-date and not categorized under any of the other lines.", "name": "col_b_other_disbursements", "verbose_name": "col b other disbursements" },
                            { "field_type": 4, "help_text": "Line 30(a)i, column B: The total federal portion of all disbursements made for allocable federal election activity year-to-date.", "name": "col_b_allocated_federal_election_activity_federal_share", "verbose_name": "col b allocated federal election activity federal share" },
                            { "field_type": 4, "help_text": "Line 30(a)ii, column B: The total Levin or non-federal share of all disbursements made for allocable federal election activity year-to-date.", "name": "col_b_allocated_federal_election_activity_levin_share", "verbose_name": "col b allocated federal election activity levin share" },
                            { "field_type": 4, "help_text": "Line 30(b), column B: The total amount of disbursements made for activity classified under 11 CFR 100.24(b)(3) and (4) year-to-date.", "name": "col_b_federal_election_activity_federal_funds", "verbose_name": "col b federal election activity federal funds" },
                            { "field_type": null, "help_text": "", "name": "fec_misc_texts", "verbose_name": "fec misc texts" },
                            {
                                "field_type": 8,
                                "help_text": "The ledger Transactions a Form 3X submission item is meant to represent.",
                                "name": "transactions",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "Transaction" },
                                "verbose_name": "transactions"
                            }
                        ]
                    }
                },
                "pac_file": {
                    "PacFile": {
                        "__is_model": true,
                        "__name__": "PacFile",
                        "data_model": "app.pac.models.pac_file.PacFile",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/pacfile/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "The period that this filing covers, if applicable. Not applicable for the Form 1.",
                                "name": "coverage_period",
                                "related_model": { "__module__": "app.pac.models.coverage_period", "__name__": "CoveragePeriod" },
                                "verbose_name": "coverage period"
                            },
                            { "field_type": 5, "help_text": "The start date boundary for this report. Not currently applicable to Federal reports.", "name": "start_date", "verbose_name": "start date" },
                            { "field_type": 5, "help_text": "The upper date boundary for this report. Not currently applicable to Federal reports.", "name": "end_date", "verbose_name": "end date" },
                            { "field_type": 16, "help_text": "The date and time at which this form was successfully submitted to a government agencies.", "name": "submitted_timestamp", "verbose_name": "submitted timestamp" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "PacFileFormPeriodType" },
                                "field_type": 4,
                                "help_text": "The period of this form. Choices are monthly, quarterly, yearly, etc.",
                                "name": "form_period_type",
                                "verbose_name": "form period type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "PacFileFormType" },
                                "field_type": 4,
                                "help_text": "the type of form for this record",
                                "name": "form_type",
                                "verbose_name": "form type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The report type associated with this filing, if applicable. Will eventually replace `form_type`.",
                                "name": "pac_report_type",
                                "related_model": { "__module__": "app.pac.models.pac_report_type", "__name__": "PACReportType" },
                                "verbose_name": "pac report type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The Ledger that file belongs to.",
                                "name": "ledger_settings",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerSettings" },
                                "verbose_name": "ledger settings"
                            },
                            { "field_type": 4, "help_text": "The PACReportMasterID in PACC for this record, if any", "name": "pacc_id", "verbose_name": "pacc id" },
                            { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                            { "field_type": 1, "help_text": "Whether the filing is filed on PACC Classic.", "name": "pacc_is_filed", "verbose_name": "pacc is filed" },
                            {
                                "field_type": 7,
                                "help_text": "The form this form is amending. This field will remain unpopulated for Form 1 amendments in this case where the client is amending a Form 1 for the first time in Quorum, or if the previous amendment was for some reason filed outside of Quorum. In these cases, the client must provide the Amended FEC Filing ID which is required by the FEC to file properly",
                                "name": "amendment_form",
                                "related_model": { "__module__": "app.pac.models.pac_file", "__name__": "PacFile" },
                                "verbose_name": "amendment form"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The organization that this FecFile belongs to",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "Region" },
                                "field_type": 4,
                                "help_text": "The jurisdiction for this PAC report. For example, FEC Form 3X is Region.federal",
                                "name": "region",
                                "verbose_name": "region"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.ledger.types", "__name__": "ReportingJurisdictionType" },
                                "field_type": 4,
                                "help_text": "The jurisdiction for this PAC report. For example, FEC Form 3X is Region.federal",
                                "name": "jurisdiction",
                                "verbose_name": "jurisdiction"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The election associated with this Filing, if applicable.",
                                "name": "election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "election"
                            },
                            { "field_type": 5, "help_text": "The date manually provided for the election by the User.", "name": "election_date_override", "verbose_name": "election date override" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "PacFileFormStatusType" },
                                "field_type": 4,
                                "help_text": "The status of the form through the filing process",
                                "name": "status",
                                "verbose_name": "status"
                            },
                            { "field_type": 2, "help_text": "\n            The version of Quorum PAC that generated this submission.\n            Should always equal the current GitHub release number of the server code\n            that submitted this filing.", "name": "quorum_pac_version", "verbose_name": "quorum pac version" },
                            { "field_type": 1, "help_text": "True if this filing is a reconstruction of a filing that was previously filed with a different vendor.", "name": "is_imported_filing", "verbose_name": "is imported filing" },
                            { "field_type": null, "help_text": "Additional jurisdiction-specific metadata for this PACFile.", "name": "additional_metadata", "verbose_name": "additional metadata" },
                            {
                                "field_type": 7,
                                "help_text": "The version number of the FEC eFiling Format under which we made this submission.",
                                "name": "fec_efiling_version",
                                "related_model": { "__module__": "app.pac.federal.fec_models", "__name__": "FecElectronicFilingFormat" },
                                "verbose_name": "fec efiling version"
                            },
                            { "field_type": 2, "help_text": "\n            A unique ID that identifies this filing. For federal filings, this is provided by the FEC upon successful\n            submission. When producing a HDR record for a submission of an amendment, we fill the Report ID field with\n            \"FEC-\" plus this value.", "name": "fec_id", "verbose_name": "fec id" },
                            { "field_type": 2, "help_text": "\n            A unique ID that identifies a filing this form amends.\n            If this PacFile has an amendment_form, this field is a denormalization of that form's fec_id.\n        ", "name": "amends_filing_id", "verbose_name": "amends filing id" },
                            { "field_type": 4, "help_text": "\n            The number of amendment submissions that have been made to the form with this fec_id, including this\n            submission. If filing the original version, this number is 0; if filing the Nth amendment to a form,\n            this number is N.", "name": "amendment_number", "verbose_name": "amendment number" },
                            { "field_type": 3, "help_text": "Description of this filing or amendment, included in submission to the FEC.", "name": "description", "verbose_name": "description" },
                            { "field_type": 3, "help_text": "S3 path for the .fec file we generate for this filing, within its S3 bucket.", "name": "fec_s3_path", "verbose_name": "fec s3 path" },
                            { "field_type": 3, "help_text": "S3 path for the .pdf file we generate for this filing, within its S3 bucket.", "name": "pdf_s3_path", "verbose_name": "pdf s3 path" },
                            { "field_type": 3, "help_text": "S3 path for the human-readable .msg file output by FECCheck when validating .fec filings", "name": "msg_s3_path", "verbose_name": "msg s3 path" },
                            { "field_type": 3, "help_text": "S3 path for the machine-readable .ms2 file output by FECCheck when validating .fec filings", "name": "ms2_s3_path", "verbose_name": "ms2 s3 path" },
                            { "field_type": 16, "help_text": "\n        The time a client last modified this form. The date should be sent via the API, and should never\n        be modified by any backend maintenance processes.", "name": "signature_timestamp", "verbose_name": "signature timestamp" },
                            { "field_type": 1, "help_text": "True if errors are found in a specific PAC file.", "name": "is_errors_found", "verbose_name": "is errors found" }
                        ]
                    }
                },
                "pac_report_type": {
                    "PACReportType": {
                        "__is_model": true,
                        "__name__": "PACReportType",
                        "data_model": "app.pac.models.pac_report_type.PACReportType",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac-report-type/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 4, "help_text": "The PACC PACReportMasterTypeID of this record - required since all data here comes from PACC", "name": "pacc_id", "verbose_name": "pacc id" },
                            { "field_type": 2, "help_text": "Human-readable description of the report type", "name": "description", "verbose_name": "description" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "Region" },
                                "field_type": 4,
                                "help_text": "The jurisdiction for this report type",
                                "name": "region",
                                "verbose_name": "region"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.ledger.types", "__name__": "ReportingJurisdictionType" },
                                "field_type": 4,
                                "help_text": "The jurisdiction for this report type",
                                "name": "jurisdiction",
                                "verbose_name": "jurisdiction"
                            },
                            { "field_type": 5, "help_text": "This report type is available for reports ending on or after this date", "name": "effective_date", "verbose_name": "effective date" },
                            { "field_type": 5, "help_text": "This report type is available for reports beginning on or before this date", "name": "end_date", "verbose_name": "end date" },
                            { "field_type": 1, "help_text": "Is this report type a notification report?", "name": "is_notification_report", "verbose_name": "is notification report" },
                            { "field_type": 1, "help_text": "Does this report type support additional schedules?", "name": "supports_additional_schedules", "verbose_name": "supports additional schedules" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "ReportFrequencyType" },
                                "field_type": 4,
                                "help_text": "The frequency of filing this report type",
                                "name": "frequency",
                                "verbose_name": "frequency"
                            }
                        ]
                    }
                },
                "political_committee": {
                    "PoliticalCommittee": {
                        "__is_model": true,
                        "__name__": "PoliticalCommittee",
                        "data_model": "app.pac.models.political_committee.PoliticalCommittee",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/politicalcommittee/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "FecCandidateStatus" },
                                "field_type": 4,
                                "help_text": "If the candidate is an incumbent or challenger. For federal committees this is de-normalized from fec_candidacy, and null for all non-candidate committees.",
                                "name": "candidate_status",
                                "verbose_name": "candidate status"
                            },
                            {
                                "field_type": 7,
                                "help_text": "If a single-candidate (not joint) committee, this is the person this committee is set up to receive contribution on behalf of.",
                                "name": "candidate",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "candidate"
                            },
                            { "db_index": true, "field_type": 3, "help_text": "The name of the committee as recorded by the FEC.", "name": "name", "sheet_column": true, "sheets_subcategory": 17, "verbose_name": "Name" },
                            { "field_type": 1, "help_text": "True if and only if this committee is actively operating.", "name": "is_active", "sheet_column": true, "sheets_subcategory": 17, "verbose_name": "Active Status" },
                            {
                                "field_type": 7,
                                "help_text": "ID of the organization the Political Committee belongs to.",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The parent political committee, if one exists.",
                                "name": "parent",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "parent"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "PoliticalCommitteeType" },
                                "field_type": 4,
                                "help_text": "\n                The type of committee for contribution limit purposes, such as\n                Candidate Committee or National Party Committee.\n            ",
                                "name": "committee_type",
                                "sheet_column": true,
                                "sheet_column_order": 2,
                                "sheets_subcategory": 17,
                                "verbose_name": "Political Committee Type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "FecCommitteeCode" },
                                "field_type": 4,
                                "help_text": "For federal committees, the committee's CMTE_TP designation from the FEC. If null, treat as a state committee.",
                                "name": "fec_committee_code",
                                "sheet_column": true,
                                "sheets_subcategory": 17,
                                "verbose_name": "Office Sought"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "FecCommitteeDesignation" },
                                "field_type": 4,
                                "help_text": "The committee's CMTE_DSGN designation from the FEC. Null for state committees.",
                                "name": "fec_committee_designation",
                                "verbose_name": "fec committee designation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The candidacy organization linked to this committee, if any.",
                                "name": "fec_candidacy",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "fec candidacy"
                            },
                            { "field_type": 3, "help_text": "For federal PACs, the unique 9-character alphanumeric code assigned to the committee by the FEC.", "name": "fec_committee_id", "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 17, "verbose_name": "Committee ID" },
                            { "field_type": 3, "help_text": "A unique value used to identify this specific Political Committee in imports.", "name": "import_id", "sheet_column": true, "sheets_column_order": 15, "sheets_subcategory": 19, "verbose_name": "Import ID" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "FecParty" },
                                "field_type": 4,
                                "help_text": "For federal committees, the political party this committee is registered as.",
                                "name": "party",
                                "sheet_column": true,
                                "sheet_column_order": 3,
                                "sheets_subcategory": 17,
                                "verbose_name": "Party"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "MichiganPartyType" },
                                "field_type": 4,
                                "help_text": "Michigan Party Type for state committee form.",
                                "name": "michigan_party_type",
                                "sheet_column": true,
                                "verbose_name": "Michigan Party Type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "Region" },
                                "field_type": 4,
                                "help_text": "The state associated with this committee. If this committee is a national committee (presidential) this will be the region that contains their HQ",
                                "name": "state_region",
                                "verbose_name": "state region"
                            },
                            { "field_type": 1, "help_text": "\n        True if and only if the FEC designates this committee a national party committee,\n        which affects its contribution limits.\n        ", "name": "is_national_party_committee", "verbose_name": "is national party committee" },
                            {
                                "field_type": 7,
                                "help_text": "The National Party Committee (Parent) linked to this National Party Committee Special Account",
                                "name": "national_party_committee",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "national party committee"
                            },
                            { "field_type": 3, "help_text": "Address - Street 1", "name": "addr_street1", "sheet_column": true, "sheet_column_order": 4, "sheets_subcategory": 17, "verbose_name": "Address" },
                            { "field_type": 3, "help_text": "Address - Street 2", "name": "addr_street2", "sheet_column": true, "sheet_column_order": 5, "sheets_subcategory": 17, "verbose_name": "Address 2" },
                            { "field_type": 3, "help_text": "Address - City", "name": "addr_city", "sheet_column": true, "sheet_column_order": 6, "sheets_subcategory": 17, "verbose_name": "City" },
                            { "field_type": 3, "help_text": "Address - State", "name": "addr_state", "sheet_column": true, "sheet_column_order": 7, "sheets_subcategory": 17, "verbose_name": "State" },
                            { "field_type": 3, "help_text": "Address - ZIP Code", "name": "addr_zip", "sheet_column": true, "sheet_column_order": 8, "sheets_subcategory": 17, "verbose_name": "Zip" },
                            { "field_type": 2, "help_text": "The committee's phone number.", "name": "phone_number", "verbose_name": "phone number" },
                            { "field_type": 2, "help_text": "The committee's fax number.", "name": "fax_number", "verbose_name": "fax number" },
                            { "field_type": 2, "help_text": "The committee's email.", "name": "email", "verbose_name": "email" },
                            { "field_type": 2, "help_text": "The committee's website", "name": "website", "verbose_name": "website" },
                            { "field_type": 2, "help_text": "The prefix of the name of the committee's contact.", "name": "contact_prefix", "verbose_name": "contact prefix" },
                            { "field_type": 2, "help_text": "The first name of the committee's contact.", "name": "contact_first_name", "verbose_name": "contact first name" },
                            { "field_type": 2, "help_text": "The middle name of the committee's contact (optional).", "name": "contact_middle_name", "verbose_name": "contact middle name" },
                            { "field_type": 2, "help_text": "The last name of the committee's contact.", "name": "contact_last_name", "verbose_name": "contact last name" },
                            { "field_type": 2, "help_text": "The suffix of the name of the committee's contact, usually one of Jr., Sr., I, II, etc.", "name": "contact_suffix", "verbose_name": "contact suffix" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.types", "__name__": "FecParty" },
                                "field_type": 4,
                                "help_text": "The political party of the committee's candidate.",
                                "name": "candidate_party",
                                "verbose_name": "candidate party"
                            },
                            { "field_type": 2, "help_text": "The prefix of the name of the committee's treasurer.", "name": "candidate_prefix", "verbose_name": "candidate prefix" },
                            { "field_type": 2, "help_text": "The first name of the committee's treasurer.", "name": "candidate_first_name", "verbose_name": "candidate first name" },
                            { "field_type": 2, "help_text": "The middle name of the committee's treasurer.", "name": "candidate_middle_name", "verbose_name": "candidate middle name" },
                            { "field_type": 2, "help_text": "The last name of the committee's treasurer.", "name": "candidate_last_name", "verbose_name": "candidate last name" },
                            { "field_type": 2, "help_text": "The suffix of the name of the committee's treasurer.", "name": "candidate_suffix", "verbose_name": "candidate suffix" },
                            { "field_type": 2, "help_text": "The district of the candidate.", "name": "candidate_district", "verbose_name": "candidate district" },
                            {
                                "field_type": 7,
                                "help_text": "The county of the candidate.",
                                "name": "candidate_county",
                                "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                                "verbose_name": "candidate county"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The state of the candidate.",
                                "name": "candidate_state",
                                "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                                "verbose_name": "candidate state"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The office this candidate is running for.",
                                "name": "candidate_office",
                                "related_model": { "__module__": "app.pac.models.elected_office", "__name__": "ElectedOffice" },
                                "verbose_name": "candidate office"
                            },
                            { "field_type": 4, "help_text": "The year the candidate is up for re-election.", "name": "re_election_year", "verbose_name": "re election year" },
                            { "field_type": 2, "help_text": "The prefix of the name of the committee's treasurer.", "name": "treasurer_prefix", "verbose_name": "treasurer prefix" },
                            { "field_type": 2, "help_text": "The first name of the committee's treasurer.", "name": "treasurer_first_name", "verbose_name": "treasurer first name" },
                            { "field_type": 2, "help_text": "The middle name of the committee's treasurer.", "name": "treasurer_middle_name", "verbose_name": "treasurer middle name" },
                            { "field_type": 2, "help_text": "The last name of the committee's treasurer.", "name": "treasurer_last_name", "verbose_name": "treasurer last name" },
                            { "field_type": 2, "help_text": "The suffix of the name of the committee's treasurer.", "name": "treasurer_suffix", "verbose_name": "treasurer suffix" },
                            { "field_type": 2, "help_text": "The first line of the street address of the committee's treasurer.", "name": "treasurer_street_address", "verbose_name": "treasurer street address" },
                            { "field_type": 2, "help_text": "The second line of the street address of the committee's treasurer.", "name": "treasurer_street_address_2", "verbose_name": "treasurer street address 2" },
                            { "field_type": 2, "help_text": "The city of the address of the committee's treasurer.", "name": "treasurer_city", "verbose_name": "treasurer city" },
                            { "field_type": 2, "help_text": "The state of the address of the committee's treasurer.", "name": "treasurer_state", "verbose_name": "treasurer state" },
                            { "field_type": 2, "help_text": "The 5- or 9-digit ZIP code for the address of the committee's treasurer.", "name": "treasurer_zip", "verbose_name": "treasurer zip" }
                        ]
                    }
                }
            },
            "reports": {
                "models": {
                    "BankReconciliationReport": {
                        "__is_model": true,
                        "__name__": "BankReconciliationReport",
                        "data_model": "app.pac.reports.models.BankReconciliationReport",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/bankreconciliationreport/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "The reconciliation account to which this report is assigned to.",
                                "name": "account_reconciliation",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "AccountReconciliation" },
                                "verbose_name": "account reconciliation"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.reports.types", "__name__": "BankReconciliationReportType" },
                                "field_type": 4,
                                "help_text": "The file type which the reconciliation report was stored as.",
                                "name": "report_type",
                                "verbose_name": "report type"
                            },
                            { "field_type": 1, "help_text": "If True, the report will be ignored", "name": "archived", "verbose_name": "archived" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.reports.types", "__name__": "BankReconciliationReportStatus" },
                                "field_type": 4,
                                "help_text": "Status of the process of the reconciliation report",
                                "name": "status",
                                "verbose_name": "status"
                            },
                            { "field_type": 2, "help_text": "The bucket the file is stored in", "name": "s3_bucket", "verbose_name": "s3 bucket" },
                            { "field_type": 2, "help_text": "The path to where in the s3 bucket the file is stored", "name": "s3_path", "verbose_name": "s3 path" }
                        ]
                    }
                },
                "types": {
                    "BankReconciliationReportStatus": {
                        "__is_enum": true,
                        "completed": { "key": "completed", "label": "Completed", "value": 3 },
                        "failed": { "key": "failed", "label": "Failed", "value": 4 },
                        "in_progress": { "key": "in_progress", "label": "In progress", "value": 2 },
                        "queued": { "key": "queued", "label": "Queued", "value": 1 }
                    },
                    "BankReconciliationReportType": {
                        "__is_enum": true,
                        "excel": { "extension": "xlsx", "key": "excel", "label": "Excel", "mime_type": "application/vnd.ms-excel", "value": 2 },
                        "pdf": { "extension": "pdf", "key": "pdf", "label": "PDF", "mime_type": "application/pdf", "value": 1 }
                    }
                }
            },
            "state_pac": {
                "models": {
                    "pac_form_schedule": {
                        "PACFormSchedule": {
                            "__is_model": true,
                            "__name__": "PACFormSchedule",
                            "data_model": "app.pac.state_pac.models.pac_form_schedule.PACFormSchedule",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/pacformschedule/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 4, "help_text": "The PACScheduleID for this record in PACC", "name": "pacc_pacscheduleid", "verbose_name": "pacc pacscheduleid" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.models", "__name__": "Region" },
                                    "field_type": 4,
                                    "help_text": "",
                                    "name": "region",
                                    "verbose_name": "region"
                                },
                                { "field_type": 3, "help_text": "The name of the schedule.", "name": "name", "verbose_name": "name" },
                                { "field_type": 5, "help_text": "The date this schedule begins to be applicable.", "name": "effective_date", "verbose_name": "effective date" },
                                { "field_type": 5, "help_text": "The date this schedule ceases to be applicable", "name": "end_date", "verbose_name": "end date" },
                                { "field_type": 1, "help_text": "TBD", "name": "is_notification", "verbose_name": "is notification" },
                                { "field_type": 1, "help_text": "TBD", "name": "is_multi_page", "verbose_name": "is multi page" }
                            ]
                        }
                    },
                    "pac_form_schedule_item": {
                        "PACFormScheduleItem": {
                            "__is_model": true,
                            "__name__": "PACFormScheduleItem",
                            "data_model": "app.pac.state_pac.models.pac_form_schedule_item.PACFormScheduleItem",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/pacformscheduleitem/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "schedule",
                                    "related_model": { "__module__": "app.pac.state_pac.models.pac_form_schedule", "__name__": "PACFormSchedule" },
                                    "verbose_name": "schedule"
                                },
                                { "field_type": 3, "help_text": "The PACScheduleItemID for this record in PACC", "name": "pacc_pacscheduleitemid", "verbose_name": "pacc pacscheduleitemid" },
                                { "field_type": 3, "help_text": "The UI Prompt for this field.", "name": "ui_prompt", "verbose_name": "ui prompt" },
                                { "field_type": 3, "help_text": "The XML tag for storing the value of this item.", "name": "xml_tag", "verbose_name": "xml tag" },
                                { "field_type": 4, "help_text": "The order in which to display this item in the UI", "name": "sort_order", "verbose_name": "sort order" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACScheduleItemDataType" },
                                    "field_type": 4,
                                    "help_text": "The field type",
                                    "name": "control_type",
                                    "verbose_name": "control type"
                                },
                                { "field_type": 4, "help_text": "For text fields, the allowed text size in characters", "name": "width", "verbose_name": "width" }
                            ]
                        }
                    },
                    "pacc_report_request": {
                        "PACCReportRequest": {
                            "__is_model": true,
                            "__name__": "PACCReportRequest",
                            "data_model": "app.pac.state_pac.models.pacc_report_request.PACCReportRequest",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/pacc-report-request/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                {
                                    "field_type": 7,
                                    "help_text": "The organization associated with this record, if any",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "The QuorumUser that requested this report generation.",
                                    "name": "user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "user"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "the QuorumUser who actually generated the request, if logged in as another",
                                    "name": "logged_in_as_user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "logged in as user"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "The PACFile for which the report is being requested.",
                                    "name": "pac_file",
                                    "related_model": { "__module__": "app.pac.models.pac_file", "__name__": "PacFile" },
                                    "verbose_name": "pac file"
                                },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACCReportActionType" },
                                    "field_type": 4,
                                    "help_text": "What action should be taken with the generated report",
                                    "name": "action",
                                    "verbose_name": "action"
                                },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACCReportFormat" },
                                    "field_type": 4,
                                    "help_text": "The format of the deliverable being requested",
                                    "name": "format",
                                    "verbose_name": "format"
                                },
                                { "field_type": null, "help_text": "The JSON-format parameters to pass to the report generation, can be state specific.", "name": "parameters", "verbose_name": "parameters" },
                                { "field_type": 4, "help_text": "The PACC JobActionID for this job", "name": "pacc_id", "verbose_name": "pacc id" },
                                { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACCReportStatus" },
                                    "field_type": 4,
                                    "help_text": "The status of this particular report request.",
                                    "name": "report_status",
                                    "verbose_name": "report status"
                                },
                                { "field_type": null, "help_text": "The history of the statuses.", "name": "status_history", "verbose_name": "status history" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACCReportErrors" },
                                    "field_type": 4,
                                    "help_text": "The error experienced the last time the record was synced.",
                                    "name": "report_error",
                                    "verbose_name": "report error"
                                },
                                { "field_type": null, "help_text": "The details of the error experienced.", "name": "error_details", "verbose_name": "error details" },
                                { "field_type": 16, "help_text": "The last time an update was retrieved from PACC.", "name": "last_update_from_pacc", "verbose_name": "last update from pacc" },
                                { "field_type": 3, "help_text": "S3 path for the file received related to this request.", "name": "file_s3_path", "verbose_name": "file s3 path" }
                            ]
                        }
                    },
                    "pacc_transaction_pick_list_item": {
                        "PACCTransactionPickListItem": {
                            "__is_model": true,
                            "__name__": "PACCTransactionPickListItem",
                            "data_model": "app.pac.state_pac.models.pacc_transaction_pick_list_item.PACCTransactionPickListItem",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/pacctransactionpicklistitem/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.pac.state_pac.types", "__name__": "PACCPickListType" },
                                    "field_type": 4,
                                    "help_text": "The specific Picklist type in PAC Classic",
                                    "name": "pacc_picklist_type",
                                    "verbose_name": "pacc picklist type"
                                },
                                { "field_type": 4, "help_text": "The PAC Classic ID on the corresponding table for the Picklist Type", "name": "pacc_id", "verbose_name": "pacc id" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.ledger.types", "__name__": "ReportingJurisdictionType" },
                                    "field_type": 4,
                                    "help_text": "The Reporting Jurisdiction to which this item applies.",
                                    "name": "jurisdiction",
                                    "verbose_name": "jurisdiction"
                                },
                                { "field_type": 3, "help_text": "The name of this item in PAC Classic", "name": "name", "verbose_name": "name" },
                                { "field_type": 3, "help_text": "The FEC Code matching this Expense Type; only applies to Expense Types", "name": "fec_code", "verbose_name": "fec code" },
                                { "field_type": 3, "help_text": "The Jurisdiction Code for this item; corresponds to State Code/Code in PAC Classic.", "name": "jurisdiction_code", "verbose_name": "jurisdiction code" },
                                { "field_type": 5, "help_text": "The date on or after which this item is an option", "name": "effective_date", "verbose_name": "effective date" },
                                { "field_type": 5, "help_text": "The date on or before which this item is an option", "name": "end_date", "verbose_name": "end date" }
                            ]
                        }
                    }
                },
                "types": {
                    "PACCReportActionType": {
                        "__is_enum": true,
                        "actually_file": { "description": "Do everything to actually file the report (what varies by state).", "key": "actually_file", "label": "Actually File", "pacc_action_type": "Generate", "pacc_use_saved": 0, "value": 2 },
                        "as_filed_review_copy": { "description": "Generate a review copy of the actual filing", "key": "as_filed_review_copy", "label": "Filed Review Copy", "pacc_action_type": "AuditReport", "pacc_use_saved": 1, "value": 3 },
                        "for_review": { "description": "Generate a Review Copy.", "key": "for_review", "label": "For Review", "pacc_action_type": "AuditReport", "pacc_use_saved": 0, "value": 1 },
                        "generate_federal": { "description": "Generate the FEC Federal filing set (efile, PDF, error log if necessary)", "key": "generate_federal", "label": "Generate Federal Filing", "value": 4 }
                    },
                    "PACCReportStatus": {
                        "__is_enum": true,
                        "error": { "description": "The PACC Report generation experienced an error.", "in_process": false, "key": "error", "label": "Error", "success": false, "value": 4 },
                        "generating": { "description": "PACC has acknowledged the request and is generating the file", "in_process": true, "key": "generating", "label": "Generating", "success": false, "value": 1 },
                        "notification_of_failure_sent": { "description": "The PACC report generation has errored and a notification has been sent to the customer", "in_process": false, "key": "notification_of_failure_sent", "label": "Error Email Sent", "success": false, "value": 5 },
                        "notification_sent": { "description": "The email notification has been sent to the customer with the file link", "in_process": false, "key": "notification_sent", "label": "Success Email Sent", "success": true, "value": 3 },
                        "received": { "description": "PACC has completed the report and provided the S3 link to the file", "in_process": false, "key": "received", "label": "Received", "success": true, "value": 2 },
                        "requested": { "description": "Report requested from PACC", "in_process": true, "key": "requested", "label": "Requested", "success": false, "value": 0 }
                    },
                    "PACReportFileExtension": {
                        "__is_enum": true,
                        "pdf": { "content_type": "application/pdf", "key": "pdf", "label": "pdf", "value": 1 },
                        "zip": { "content_type": "application/x-zip", "key": "zip", "label": "zip", "value": 2 }
                    },
                    "PACScheduleItemDataType": {
                        "__is_enum": true,
                        "amount": { "description": "A field for entering currency amounts.", "input_type": 1, "key": "amount", "label": "Text Box - Currency Datatype", "value": 34 },
                        "check_box": { "description": "A checkbox", "input_type": 4, "key": "check_box", "label": "Check Box", "pacc_value": "checkbox", "value": 10 },
                        "date": { "description": "A field for entering dates.", "input_type": 1, "key": "date", "label": "Text Box - Date Datatype", "value": 35 },
                        "descriptive_text": { "description": "Descriptive text to display.", "key": "descriptive_text", "label": "Descriptive Text", "pacc_value": "text", "value": 0 },
                        "header_1": { "description": "A large heading.", "key": "header_1", "label": "Header 1", "pacc_value": "header1", "value": 1 },
                        "header_2": { "description": "A small heading.", "key": "header_2", "label": "Header 2", "pacc_value": "header2", "value": 2 },
                        "header_3": { "description": "A smaller heading.", "key": "header_3", "label": "Header 3", "pacc_value": "header3", "value": 3 },
                        "header_4": { "description": "A smallest heading.", "key": "header_4", "label": "Header 4", "pacc_value": "header4", "value": 4 },
                        "link": { "description": "Hyperlink to display.", "key": "link", "label": "Link", "pacc_value": "text", "value": 5 },
                        "number": { "description": "A field for entering Numbers", "input_type": 1, "key": "number", "label": "Text Box - Number Datatype", "value": 33 },
                        "pac_org_picklist": { "description": "A picklist of PAC Organizations for the account.", "input_type": 5, "key": "pac_org_picklist", "label": "PAC Organization Picklist", "pacc_value": "pacorgpicklist", "related_model": "public_organization", "value": 21 },
                        "pledge_picklist": { "description": "A picklist of Pledges for the account.", "input_type": 5, "key": "pledge_picklist", "label": "Pledge Picklist", "pacc_value": "pledgepicklist", "related_model": "TBD", "value": 22 },
                        "supporter_picklist": { "description": "A picklist of supporters for the account.", "input_type": 5, "key": "supporter_picklist", "label": "Contact Picklist", "pacc_value": "individualpicklist", "related_model": "supporter", "value": 20 },
                        "text_area": { "description": "A text entry field", "input_type": 0, "key": "text_area", "label": "Text Area", "pacc_value": "textarea", "value": 32 },
                        "text_box": { "description": "A text entry field", "input_type": 0, "key": "text_box", "label": "Text Box", "pacc_value": "textbox", "value": 31 },
                        "transaction_picklist": { "description": "A picklist of Transactions for the account.", "input_type": 5, "key": "transaction_picklist", "label": "Transaction Picklist", "pacc_value": "uniqueid", "related_model": "TBD", "value": 23 },
                        "yes_no": { "description": "A Yes/No Choice", "input_type": 4, "key": "yes_no", "label": "Yes/No", "pacc_value": "yesno", "value": 11 }
                    },
                    "PACScheduleItemInputType": {
                        "__is_enum": true,
                        "boolean": { "key": "boolean", "label": "Boolean", "value": 4 },
                        "currency_amount": { "key": "currency_amount", "label": "Currency Amount (in Cents)", "value": 2 },
                        "date": { "key": "date", "label": "Date", "value": 3 },
                        "number": { "key": "number", "label": "Number", "value": 1 },
                        "picklist": { "key": "picklist", "label": "Picklist", "value": 5 },
                        "text": { "key": "text", "label": "Text", "value": 0 }
                    }
                }
            },
            "trusted_login": {
                "models": {
                    "PACCTrustedLoginRequest": {
                        "__is_model": true,
                        "__name__": "PACCTrustedLoginRequest",
                        "data_model": "app.pac.trusted_login.models.PACCTrustedLoginRequest",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/trusted-login/",
                        "fields": [
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 14, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "field_type": 7,
                                "help_text": "The organization associated with this login request",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The QuorumUser that requested access to a hybrid PAC Classic page",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.trusted_login.types", "__name__": "PACCTrustedLoginDestination" },
                                "field_type": 4,
                                "help_text": "The PAC Classic page that was requested",
                                "name": "destination_page",
                                "verbose_name": "destination page"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The supporter that the request is for, if the request is for a particular Supporter (Individual in PAC Classic)",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            { "field_type": 4, "help_text": "The amount of time in seconds that this request will wait for a response from PAC Classic before expiring", "name": "time_to_live", "verbose_name": "time to live" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac.trusted_login.types", "__name__": "PACCTrustedLoginStatus" },
                                "field_type": 4,
                                "help_text": "The current status of the trusted login request",
                                "name": "status",
                                "verbose_name": "status"
                            },
                            { "field_type": 3, "help_text": "The encrypted token generated when the request was created", "name": "token", "verbose_name": "token" },
                            {
                                "field_type": 7,
                                "help_text": "The PAC Classic ID of the entity the request is for",
                                "name": "pacc_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pacc pac"
                            }
                        ]
                    }
                },
                "types": {
                    "PACCTrustedLoginDestination": {
                        "__is_enum": true,
                        "compliance_page": { "key": "compliance_page", "label": "ComplianceManagement", "value": 2 },
                        "logout": { "key": "logout", "label": "Logout", "value": 0 },
                        "pac_action_center_page": { "key": "pac_action_center_page", "label": "PACActionCenter", "value": 4 },
                        "settings_page": { "key": "settings_page", "label": "Settings", "value": 3 },
                        "single_contact_page": { "key": "single_contact_page", "label": "Individuals", "value": 5 },
                        "transactions_page": { "key": "transactions_page", "label": "Transactions", "value": 1 }
                    },
                    "PACCTrustedLoginStatus": {
                        "__is_enum": true,
                        "created": { "description": "The PACCTrustedLoginRequest is created, but not yet sent to PAC Classic", "is_completed_status": false, "key": "created", "label": "Created", "value": 0 },
                        "expired": { "description": "The PACCTrustedLoginRequest did not return from PAC Classic within the TTL, and has expired", "is_completed_status": true, "key": "expired", "label": "Expired", "value": 4 },
                        "returned": { "description": "The PACCTrustedLoginRequest has returned from PAC Classic, but not yet processed as valid, invalid, or expired", "is_completed_status": false, "key": "returned", "label": "Returned", "value": 2 },
                        "sent": { "description": "The PACCTrustedLoginRequest has been sent to PAC Classic, and is awaiting a response", "is_completed_status": false, "key": "sent", "label": "Sent", "value": 1 },
                        "validated": { "description": "The PACCTrustedLoginRequest has returned from PAC Classic, and has been validated", "is_completed_status": true, "key": "validated", "label": "Validated", "value": 3 }
                    }
                }
            },
            "types": {
                "AffiliationType": {
                    "__is_enum": true,
                    "authorized_by_shared_candidate": { "key": "authorized_by_shared_candidate", "label": "Authorized Candidate Committees", "tip": "Any committee authorized by a candidate is considered affiliated with the candidate's principal campaign committee.", "value": 2 },
                    "formed_by_advisory_opinion": { "key": "formed_by_advisory_opinion", "label": "Affiliation Determined by FEC Advisory Opinion", "tip": "Special groups split off or merged together from other affiliation groups as the result of an advisory opinion by the Federal Election Commission stating that certain committees are affiliated or disaffiliated.", "value": 4 },
                    "party_committees_within_state": { "key": "party_committees_within_state", "label": "Party Committees Within a State", "tip": "A state party committee and all local party committees in the state are considered affiliated, provided they share the same party. National party committees, however, have separate contribution limits from those of state and local party committees.", "value": 1 },
                    "same_sponsoring_organization": { "key": "same_sponsoring_organization", "label": "Tied to a Shared Organization", "tip": "All SSFs established, financed, maintained, or controlled by the same corporation or labor organization are considered to be affiliated by the Federal Election Commission.", "value": 3 }
                },
                "ContributionType": {
                    "__is_enum": true,
                    "contribution": {
                        "key": "contribution",
                        "label": "Contribution",
                        "valid_transaction_donor_types": [1005],
                        "value": 1
                    },
                    "dividends_interest": {
                        "key": "dividends_interest",
                        "label": "Dividends/Interest",
                        "valid_transaction_donor_types": [1013],
                        "value": 4
                    },
                    "internal_account_transfer": {
                        "key": "internal_account_transfer",
                        "label": "Transfers from Internal Accounts",
                        "valid_transaction_donor_types": [1013],
                        "value": 5
                    },
                    "refund": {
                        "key": "refund",
                        "label": "Refund",
                        "valid_transaction_donor_types": [1005],
                        "value": 3
                    },
                    "transfer": {
                        "key": "transfer",
                        "label": "Transfer",
                        "valid_transaction_donor_types": [1005],
                        "value": 2
                    }
                },
                "DisbursementType": {
                    "__is_enum": true,
                    "bank": {
                        "key": "bank",
                        "label": "Bank & Credit Card Fees",
                        "valid_transaction_donor_types": [1013],
                        "value": 6
                    },
                    "charitable_contributions": {
                        "key": "charitable_contributions",
                        "label": "Charitable Contributions",
                        "valid_transaction_donor_types": [100000],
                        "value": 9
                    },
                    "contributions": {
                        "key": "contributions",
                        "label": "Contributions",
                        "valid_transaction_donor_types": [1005],
                        "value": 1
                    },
                    "independent_expenditures": {
                        "key": "independent_expenditures",
                        "label": "Independent Expenditures",
                        "valid_transaction_donor_types": [1005],
                        "value": 2
                    },
                    "internal_account_transfers": {
                        "key": "internal_account_transfers",
                        "label": "Tranfers from Internal Accounts",
                        "valid_transaction_donor_types": [1013],
                        "value": 7
                    },
                    "misc_expenses": {
                        "key": "misc_expenses",
                        "label": "Misc Expenses",
                        "valid_transaction_donor_types": [100000],
                        "value": 10
                    },
                    "other": {
                        "key": "other",
                        "label": "Other",
                        "valid_transaction_donor_types": [1001],
                        "value": 11
                    },
                    "other_organization_contribution": {
                        "key": "other_organization_contribution",
                        "label": "Contribution to other XX Organizations",
                        "valid_transaction_donor_types": [100000],
                        "value": 8
                    },
                    "refund": {
                        "key": "refund",
                        "label": "Refund",
                        "valid_transaction_donor_types": [1001, 1005],
                        "value": 3
                    },
                    "salary": {
                        "key": "salary",
                        "label": "Salary/Other Compensation/Employee Benefits",
                        "valid_transaction_donor_types": [1001],
                        "value": 5
                    },
                    "transfers": {
                        "key": "transfers",
                        "label": "Transfers",
                        "valid_transaction_donor_types": [1005],
                        "value": 4
                    }
                },
                "EntityType": {
                    "__is_enum": true,
                    "affiliated_committees": { "associated_qdt": 114, "form_label": "", "help_text": "Affiliated committees are designed by the FEC to be related and share contribution limits", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "affiliated_committees", "label": "Affiliated Committees", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1005 },
                    "anonymous": { "form_label": "Anonymous", "help_text": "An anonymous entity.", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "anonymous", "label": "Anonymous", "order": 500, "pacc_code": "", "pacc_limit_type": "ANO", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": true, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1003 },
                    "ballot_measures_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that supports or opposes ballot measures.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "ballot_measures_committee", "label": "Ballot Measures Committee", "order": 0, "pacc_code": "BAL", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 102 },
                    "bank": { "associated_qdt": 42, "form_label": "Bank", "help_text": "Bank", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "bank", "label": "Bank", "order": 1000000, "pacc_code": "", "pacc_limit_type": "BNK", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1013 },
                    "candidate_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that is set up to receive contributions on behalf of a candidate", "is_candidate_committee": true, "is_political_committee": true, "is_state_or_local": false, "key": "candidate_committee", "label": "Federal Candidate Committee", "order": 0, "pacc_code": "FCC", "pacc_limit_type": "", "requires_election_for_transaction": true, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1 },
                    "committees": { "associated_qdt": 114, "form_label": "", "help_text": "Committees", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "committees", "label": "Committees", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1004 },
                    "connected_organization": { "associated_qdt": 42, "form_label": "Connected Organization", "help_text": "Connected Organization", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "connected_organization", "label": "Connected Organization", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1015 },
                    "corporation": { "associated_qdt": 42, "form_label": "Corporation", "help_text": "Corporation", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "corporation", "label": "Corporation", "order": 1000000, "pacc_code": "", "pacc_limit_type": "INC", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1020 },
                    "federal_pac_ssf_and_nonconnected": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "\n            A Federal level PAC that is either of multicandidate or nonmulticandidate status.\n            Useful in instances where the status is irrelevant.\n\n            Corresponds to the \"PAC (SSF and nonconnected)\" category for 2019-2020 federal election\n            contribution limits.\n        ",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": false,
                        "key": "federal_pac_ssf_and_nonconnected",
                        "label": "Federal PAC (SSF and Nonconnected)",
                        "order": 0,
                        "pacc_code": "FSF",
                        "pacc_limit_type": "",
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 6
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "CAN_RECEIVE_DISBURSEMENTS",
                            "values": [1013, 1015, 1020, 1023, 1022, 1018, 1002, 1016, 1021, 1017, 1012]
                        }
                    ],
                    "incidental_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": false,
                        "key": "incidental_committee",
                        "label": "Incidental Committee",
                        "order": 0,
                        "pacc_code": "ICM",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": false,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 103
                    },
                    "individual": { "associated_qdt": 12, "form_label": "Contact (Individual)", "help_text": "An individual can be considered an Donor by the FEC", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "individual", "label": "Individual", "order": 100, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": true, "show_in_enumeration": true, "show_in_receipt_form": true, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1001 },
                    "joint_fundraising_committee": { "associated_qdt": 114, "form_label": "", "help_text": "\n        A joint fundraiser (FecCommitteeDesignation.joint_fundraiser) with a type of\n        FecCommitteeCode.house, FecCommitteeCode.presidential, or FecCommitteeCode.senate.\n        Exists as a joint fundraising effort with the express purpose of allocating funds\n        to support one or more candidates for political office.\n        ", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "joint_fundraising_committee", "label": "Joint Fundraising Committee", "order": 0, "pacc_code": "JFC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 101 },
                    "labor_union": { "associated_qdt": 42, "form_label": "Labor Union", "help_text": "Labor Union", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "labor_union", "label": "Labor Union", "order": 1000000, "pacc_code": "", "pacc_limit_type": "LAB", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1023 },
                    "limited_liability_company": { "associated_qdt": 42, "form_label": "Limited Liability Company", "help_text": "Limited Liability Company", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "limited_liability_company", "label": "Limited Liability Company", "order": 1000000, "pacc_code": "", "pacc_limit_type": "LLC", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1022 },
                    "limited_liability_partnership": { "associated_qdt": 42, "form_label": "", "help_text": "Limited Liability Partnership", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "limited_liability_partnership", "label": "Limited Liability Partnership", "order": 1000000, "pacc_code": "", "pacc_limit_type": "LLP", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1018 },
                    "local_candidate_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": true,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "local_candidate_committee",
                        "label": "Local Candidate Committee",
                        "order": 0,
                        "pacc_code": "LCC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": true,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 41
                    },
                    "local_candidates": { "associated_qdt": 114, "form_label": "", "help_text": "Local Candidates", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "local_candidates", "label": "Local Candidates", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1010 },
                    "local_pacs": { "associated_qdt": 114, "form_label": "", "help_text": "Local PACs", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "local_pacs", "label": "Local PACs", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 6, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1011 },
                    "local_party_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "local_party_committee",
                        "label": "Local Party Committee",
                        "order": 0,
                        "pacc_code": "LPC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 40
                    },
                    "local_party_committees": { "associated_qdt": 114, "form_label": "", "help_text": "A local political party committee", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "local_party_committees", "label": "Local Political Party Committees", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 40, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1009 },
                    "multicandidate_pac": { "associated_qdt": 114, "form_label": "", "help_text": "A PAC can be either an SSF or a nonconnected organization that makes contributions to other federal politicalcommittees. This type is for PAC's that are able to give to multiple candidates.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "multicandidate_pac", "label": "Multicandidate PAC", "order": 0, "pacc_code": "FSF", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 2 },
                    "national_party_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that represents a political party and is part of the official party structure at the national level", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee", "label": "National Party Committee", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 5 },
                    "national_party_committee_special_account_for_election_recounts_and_contests": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for election recounts and contests and other legal proceedings that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_election_recounts_and_contests", "label": "National Party Committee: Special Account for Election Recounts and Contests and Other Legal Proceedings", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 8 },
                    "national_party_committee_special_account_for_headquarters_buildings": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for national party headquarters buildings that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_headquarters_buildings", "label": "National Party Committee: Special Account for National Party Headquarters Buildings", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 9 },
                    "national_party_committee_special_account_for_presidential_nominating_convention": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for presidential nominating convention that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_presidential_nominating_convention", "label": "National Party Committee: Special Account for Presidential Nominating Convention", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 7 },
                    "nonmulticandidate_pac": { "associated_qdt": 114, "form_label": "", "help_text": "A PAC can be either an SSF or a nonconnected organization that makes contributions to other federal politicalcommittees. This type is for PAC's that cannot give to multiple candidates", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "nonmulticandidate_pac", "label": "Nonmulticandidate PAC", "order": 0, "pacc_code": "FSF", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 3 },
                    "organization": { "associated_qdt": 42, "form_label": "", "help_text": "An organization can either by a Donor or Receipient of money", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "organization", "label": "Organization", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1002 },
                    "other": { "associated_qdt": 114, "form_label": "Other", "help_text": "Catch-all for PoliticalCommittees that do not fall cleanly into the explicitly defined categories.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "other", "label": "Uncategorized", "order": 0, "pacc_code": "OTH", "pacc_limit_type": "OTH", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 100000 },
                    "other_org": { "associated_qdt": 42, "form_label": "Other", "help_text": "Other", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "other_org", "label": "Other", "order": 1000000, "pacc_code": "", "pacc_limit_type": "OTH", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1016 },
                    "parent_entity": { "associated_qdt": 42, "form_label": "Parent Entity", "help_text": "Parent Entity", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "parent_entity", "label": "Parent Entity", "order": 1000000, "pacc_code": "", "pacc_limit_type": "PAR", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1021 },
                    "partnership": { "associated_qdt": 42, "form_label": "", "help_text": "Partnership", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "partnership", "label": "Partnership", "order": 1000000, "pacc_code": "", "pacc_limit_type": "SHP", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1014 },
                    "public_organization": { "form_label": "", "help_text": "", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "public_organization", "label": "Organization", "order": 0, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 3000 },
                    "sole_proprietorship": { "associated_qdt": 42, "form_label": "", "help_text": "Sole Proprietorships", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "sole_proprietorship", "label": "Sole Proprietorship", "order": 1000000, "pacc_code": "", "pacc_limit_type": "SOL", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1019 },
                    "state_candidate_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": true,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_candidate_committee",
                        "label": "State Candidate Committee",
                        "order": 0,
                        "pacc_code": "SCC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": true,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 31
                    },
                    "state_candidate_committees": { "associated_qdt": 114, "form_label": "", "help_text": "State Candidate Committees", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "state_candidate_committees", "label": "State Candidate Committees", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 1, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1006 },
                    "state_pac_ssf": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_pac_ssf",
                        "label": "State PAC / SSF",
                        "order": 0,
                        "pacc_code": "SSF",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 32
                    },
                    "state_pacs": { "associated_qdt": 114, "form_label": "", "help_text": "State PACs", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "state_pacs", "label": "State PACs", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 6, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1007 },
                    "state_party_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_party_committee",
                        "label": "State Party Committee",
                        "order": 0,
                        "pacc_code": "SPC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 30
                    },
                    "state_party_committee_fed_acct": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_party_committee_fed_acct",
                        "label": "State Party Committee Federal Account",
                        "order": 0,
                        "pacc_code": "SPF",
                        "pacc_limit_type": "",
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 33
                    },
                    "state_party_committees": { "associated_qdt": 114, "form_label": "", "help_text": "A state political party committee", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "state_party_committees", "label": "State Political Party Committees", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 30, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1008 },
                    "stripe_virtual_account": { "associated_qdt": 42, "form_label": "Stripe Virtual Account", "help_text": "Stripe Virtual Account", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "stripe_virtual_account", "label": "Stripe Virtual Account", "order": 1000000, "pacc_code": "", "pacc_limit_type": "", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1017 },
                    "super_pac": { "associated_qdt": 114, "form_label": "", "help_text": "\n        An independent expenditure-only committee, or super PAC. May receive/spend unlimited sums of money\n        as long as this is done independently of candidate campaigns.\n        ", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "super_pac", "label": "Super PAC", "order": 0, "pacc_code": "OTH", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 100 },
                    "vendor": { "associated_qdt": 42, "form_label": "Vendor", "help_text": "Vendor", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "vendor", "label": "Vendor", "order": 1000000, "pacc_code": "", "pacc_limit_type": "VEN", "parent": 3000, "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 1012 }
                },
                "ExpenseType": {
                    "__is_enum": true,
                    "accounting_fees": {
                        "fec_code": "001",
                        "key": "accounting_fees",
                        "label": "Accounting Fees",
                        "pacc_expensecodeid": [360],
                        "value": 1
                    },
                    "bank_fees": {
                        "fec_code": "001",
                        "key": "bank_fees",
                        "label": "Bank Fees",
                        "pacc_expensecodeid": [503],
                        "value": 34
                    },
                    "campaign_consultant": {
                        "fec_code": "003",
                        "key": "campaign_consultant",
                        "label": "Campaign Consultant",
                        "pacc_expensecodeid": [361],
                        "value": 2
                    },
                    "campaign_literature": {
                        "fec_code": "006",
                        "key": "campaign_literature",
                        "label": "Campaign Literature",
                        "pacc_expensecodeid": [362],
                        "value": 3
                    },
                    "campaign_mailings": {
                        "fec_code": "003",
                        "key": "campaign_mailings",
                        "label": "Campaign Mailings",
                        "pacc_expensecodeid": [363],
                        "value": 4
                    },
                    "campaign_salaries": {
                        "fec_code": "001",
                        "key": "campaign_salaries",
                        "label": "Campaign Salaries",
                        "pacc_expensecodeid": [364],
                        "value": 5
                    },
                    "charitable_contributions": {
                        "fec_code": "012",
                        "key": "charitable_contributions",
                        "label": "Charitable Contributions",
                        "pacc_expensecodeid": [365],
                        "value": 6
                    },
                    "constituent_services": {
                        "fec_code": "001",
                        "key": "constituent_services",
                        "label": "Constituent Services",
                        "pacc_expensecodeid": [366],
                        "value": 7
                    },
                    "expenditure_for_or_against_ballot_issues": {
                        "fec_code": "003",
                        "key": "expenditure_for_or_against_ballot_issues",
                        "label": "Expenditure For Or Against Ballot Issues",
                        "pacc_expensecodeid": [392],
                        "value": 29
                    },
                    "federal_taxes": {
                        "fec_code": "001",
                        "key": "federal_taxes",
                        "label": "Federal Taxes",
                        "pacc_expensecodeid": [391],
                        "value": 28
                    },
                    "fundraising": {
                        "fec_code": "003",
                        "key": "fundraising",
                        "label": "Fundraising",
                        "pacc_expensecodeid": [371],
                        "value": 8
                    },
                    "furniture_or_fixtures": {
                        "fec_code": "001",
                        "key": "furniture_or_fixtures",
                        "label": "Furniture/Fixtures",
                        "pacc_expensecodeid": [372],
                        "value": 9
                    },
                    "in_kind": {
                        "fec_code": "011",
                        "key": "in_kind",
                        "label": "In Kind",
                        "pacc_expensecodeid": [373],
                        "value": 10
                    },
                    "investment_expenses": {
                        "fec_code": "001",
                        "key": "investment_expenses",
                        "label": "Investment Expenses",
                        "pacc_expensecodeid": [374],
                        "value": 11
                    },
                    "legal_fees": {
                        "fec_code": "001",
                        "key": "legal_fees",
                        "label": "Legal Fees",
                        "pacc_expensecodeid": [375],
                        "value": 12
                    },
                    "office_equipment": {
                        "fec_code": "001",
                        "key": "office_equipment",
                        "label": "Office Equipment",
                        "pacc_expensecodeid": [376],
                        "value": 13
                    },
                    "office_supplies_or_stationery": {
                        "fec_code": "001",
                        "key": "office_supplies_or_stationery",
                        "label": "Office Supplies/Stationery",
                        "pacc_expensecodeid": [377],
                        "value": 14
                    },
                    "other_advertising": {
                        "fec_code": "004",
                        "key": "other_advertising",
                        "label": "Other Advertising",
                        "pacc_expensecodeid": [378],
                        "value": 15
                    },
                    "other_consultants": {
                        "fec_code": "003",
                        "key": "other_consultants",
                        "label": "Other Consultants",
                        "pacc_expensecodeid": [379],
                        "value": 16
                    },
                    "petition_expenses": {
                        "fec_code": "001",
                        "key": "petition_expenses",
                        "label": "Petition Expenses",
                        "pacc_expensecodeid": [380],
                        "value": 17
                    },
                    "political_contributions": {
                        "fec_code": "011",
                        "key": "political_contributions",
                        "label": "Political contributions",
                        "pacc_expensecodeid": [367, 368, 369, 370, 468],
                        "value": 36
                    },
                    "political_party_dues": {
                        "fec_code": "001",
                        "key": "political_party_dues",
                        "label": "Political Party Dues",
                        "pacc_expensecodeid": [394],
                        "value": 31
                    },
                    "polling_costs": {
                        "fec_code": "005",
                        "key": "polling_costs",
                        "label": "Polling Costs",
                        "pacc_expensecodeid": [381],
                        "value": 18
                    },
                    "postage": {
                        "fec_code": "001",
                        "key": "postage",
                        "label": "Postage",
                        "pacc_expensecodeid": [382],
                        "value": 19
                    },
                    "print_advertising": {
                        "fec_code": "004",
                        "key": "print_advertising",
                        "label": "Print Advertising",
                        "pacc_expensecodeid": [383],
                        "value": 20
                    },
                    "print_aids": {
                        "fec_code": "006",
                        "key": "print_aids",
                        "label": "Print Aids",
                        "pacc_expensecodeid": [384],
                        "value": 21
                    },
                    "radio_advertising": {
                        "fec_code": "004",
                        "key": "radio_advertising",
                        "label": "Radio Advertising",
                        "pacc_expensecodeid": [385],
                        "value": 22
                    },
                    "refunds_of_contributions": {
                        "fec_code": "010",
                        "key": "refunds_of_contributions",
                        "label": "Refunds of contributions",
                        "pacc_expensecodeid": [1440],
                        "value": 35
                    },
                    "rent": {
                        "fec_code": "001",
                        "key": "rent",
                        "label": "Rent",
                        "pacc_expensecodeid": [386],
                        "value": 23
                    },
                    "sign_advertising": {
                        "fec_code": "004",
                        "key": "sign_advertising",
                        "label": "Sign Advertising",
                        "pacc_expensecodeid": [393],
                        "value": 30
                    },
                    "ticket_purchases": {
                        "fec_code": "011",
                        "key": "ticket_purchases",
                        "label": "Ticket Purchases",
                        "pacc_expensecodeid": [395],
                        "value": 32
                    },
                    "transfers": {
                        "fec_code": "008",
                        "key": "transfers",
                        "label": "Transfers",
                        "pacc_expensecodeid": [490],
                        "value": 33
                    },
                    "travel_expenses": {
                        "fec_code": "002",
                        "key": "travel_expenses",
                        "label": "Travel Expenses",
                        "pacc_expensecodeid": [388],
                        "value": 25
                    },
                    "tv_advertising": {
                        "fec_code": "004",
                        "key": "tv_advertising",
                        "label": "TV Advertising",
                        "pacc_expensecodeid": [387],
                        "value": 24
                    },
                    "utilities": {
                        "fec_code": "001",
                        "key": "utilities",
                        "label": "Utilities",
                        "pacc_expensecodeid": [389],
                        "value": 26
                    },
                    "voter_registration_expenses": {
                        "fec_code": "001",
                        "key": "voter_registration_expenses",
                        "label": "Voter Registration Expenses",
                        "pacc_expensecodeid": [390],
                        "value": 27
                    }
                },
                "FECForm3XLineType": {
                    "__is_enum": true,
                    "line_11a": { "help_text": "Itemized (11ai) and Unitemized (11aii) Contributions from Individuals", "key": "line_11a", "label": "11a", "value": 101 },
                    "line_11b": { "help_text": "Receipts from Political Party Committees", "key": "line_11b", "label": "11b", "value": 102 },
                    "line_11c": { "help_text": "Contributions from Other Political Committees", "key": "line_11c", "label": "11c", "value": 103 },
                    "line_12": { "help_text": "Transfers from Affiliated Committees", "key": "line_12", "label": "12", "value": 104 },
                    "line_13": { "help_text": "Loans Received", "key": "line_13", "label": "13", "value": 205 },
                    "line_14": { "help_text": "Loan Repayments Received", "key": "line_14", "label": "14", "value": 206 },
                    "line_15": { "help_text": "Offsets to Operating Expenditures", "key": "line_15", "label": "15", "value": 105 },
                    "line_16": { "help_text": "Refunds of Contributions Made to Federal Candidates and Other Political Committees", "key": "line_16", "label": "16", "value": 106 },
                    "line_17": { "help_text": "Other Receipts", "key": "line_17", "label": "17", "value": 107 },
                    "line_18a": { "help_text": "Transfers from Nonfederal Funds", "key": "line_18a", "label": "18a", "value": 108 },
                    "line_18b": { "help_text": "Transfers from Levin Funds", "key": "line_18b", "label": "18b", "value": 207 },
                    "line_21a": { "help_text": "Allocated federal/nonfederal activity", "key": "line_21a", "label": "21a", "value": 109 },
                    "line_21b": { "help_text": "Other Federal Operating Expenditures", "key": "line_21b", "label": "21b", "value": 110 },
                    "line_22": { "help_text": "Transfers to Affiliated Committees", "key": "line_22", "label": "22", "value": 111 },
                    "line_23": { "help_text": "Contributions to Federal Candidates/Committees and Other Political committees", "key": "line_23", "label": "23", "value": 112 },
                    "line_24": { "help_text": "Independent Expenditures", "key": "line_24", "label": "24", "value": 113 },
                    "line_25": { "help_text": "Coordinated Party Expenditures", "key": "line_25", "label": "25", "value": 208 },
                    "line_26": { "help_text": "Loan Repayments Made", "key": "line_26", "label": "26", "value": 209 },
                    "line_27": { "help_text": "Loans Made", "key": "line_27", "label": "27", "value": 210 },
                    "line_28a": { "help_text": "Refunds of Contributions to Individuals", "key": "line_28a", "label": "28a", "value": 114 },
                    "line_28b": { "help_text": "Refunds of Contributions to Political Party Committees", "key": "line_28b", "label": "28b", "value": 115 },
                    "line_28c": { "help_text": "Refunds of Contributions to Other Political Committees", "key": "line_28c", "label": "28c", "value": 116 },
                    "line_29": { "help_text": "Misc Expenses", "key": "line_29", "label": "29", "value": 117 },
                    "line_30a": { "help_text": "Allocated Federal Election Activity", "key": "line_30a", "label": "30a", "value": 211 },
                    "line_30b": { "help_text": "Federal Election Activity Paid Entirely With Federal Party Funds", "key": "line_30b", "label": "30b", "value": 212 }
                },
                "FecCandidateStatus": {
                    "__is_enum": true,
                    "challenger": { "fec_code": "C", "key": "challenger", "label": "Challenger", "value": 1 },
                    "incumbent": { "fec_code": "I", "key": "incumbent", "label": "Incumbent", "value": 2 },
                    "open_seat": { "fec_code": "O", "key": "open_seat", "label": "Open Seat", "value": 3 }
                },
                "FecCommitteeCode": {
                    "__is_enum": true,
                    "communication_cost": { "description": "\n        Organizations like corporations or unions may prepare communications for their\n        employees or members that advocate the election of specific candidates and they\n        must disclose them under certain circumstances. These are usually paid with direct\n        corporate or union funds rather than from PACs.\n        ", "fec_code": "C", "key": "communication_cost", "label": "Communication Cost", "value": 1 },
                    "delegate_committee": { "description": "\n        Delegate committees are organized for the purpose of influencing the selection\n        of delegates to Presidential nominating conventions. The term includes a group of\n        delegates, a group of individuals seeking to become delegates, and a group of\n        individuals supporting delegates.\n        ", "fec_code": "D", "key": "delegate_committee", "label": "Delegate Committee", "value": 2 },
                    "electioneering_communication": { "description": "\n        Groups (other than PACs) making electioneering communications.\n        ", "fec_code": "E", "key": "electioneering_communication", "label": "Electioneering Communication", "value": 3 },
                    "house": { "description": "\n        Campaign committees for candidates for the U.S. House of Representatives.\n        ", "fec_code": "H", "key": "house", "label": "House", "value": 4 },
                    "independent_expenditor_person_or_group": { "description": "\n        Individuals or groups (other than PACs) making independent expenditures over $250\n        in a year must disclose those expenditures.\n        ", "fec_code": "I", "key": "independent_expenditor_person_or_group", "label": "Independent Expenditor (Person or Group)", "value": 5 },
                    "independent_expenditure_only_super_pacs": { "description": "\n        Political Committee that has filed a statement consistent with AO 2010-09 or AO 2010-11.\n        ", "fec_code": "O", "key": "independent_expenditure_only_super_pacs", "label": "Independent Expenditure-Only (Super PACs)", "value": 7 },
                    "national_party_nonfederal_account": { "description": "\n        National party nonfederal accounts. Not permitted after enactment of Bipartisan\n        Campaign Reform Act of 2002.\n        ", "fec_code": "Z", "key": "national_party_nonfederal_account", "label": "National Party Nonfederal Account", "value": 16 },
                    "national_party_special_account_for_election_recounts_and_contests": { "description": "\n        National party committee special accounts for election recounts and contests and other legal proceedings. This\n        type of special committee is created by our system instead of scrapping from FEC's dataset.\n        ", "fec_code": "", "key": "national_party_special_account_for_election_recounts_and_contests", "label": "National Party Committee Special Account for Election Recounts and Contests and Other Legal Proceedings", "value": 18 },
                    "national_party_special_account_for_headquarters_buildings": { "description": "\n        National party committee special accounts for national party headquarters buildings. This type of special committee\n        is created by our system instead of scrapping from FEC's dataset.\n        ", "fec_code": "", "key": "national_party_special_account_for_headquarters_buildings", "label": "National Party Committee Special Account for National Party Headquarters Buildings", "value": 19 },
                    "national_party_special_account_for_presidential_nominating_convention": { "description": "\n        National party committee special accounts for presidential nominating convention. This type of special committee\n        is created by our system instead of scrapping from FEC's dataset.\n        ", "fec_code": "", "key": "national_party_special_account_for_presidential_nominating_convention", "label": "National Party Committee Special Account for Presidential Nominating Convention", "value": 17 },
                    "pac_nonqualified": { "description": "\n        PACs that have not yet been in existence for six months and received contributions\n        from 50 people and made contributions to five federal candidates. These committees\n        have lower limits for their contributions to candidates.\n        ", "fec_code": "N", "key": "pac_nonqualified", "label": "PAC - Nonqualified", "value": 6 },
                    "pac_qualified": { "description": "\n        PACs that have been in existence for six months and received contributions from\n        50 people and made contributions to five federal candidates.\n        ", "fec_code": "Q", "key": "pac_qualified", "label": "PAC - Qualified", "value": 9 },
                    "pac_with_non_contribution_account_nonqualified": { "description": "\n        Political committees with non-contribution accounts.\n        ", "fec_code": "V", "key": "pac_with_non_contribution_account_nonqualified", "label": "PAC With Non-Contribution Account - Nonqualified", "value": 12 },
                    "pac_with_non_contribution_account_qualified": { "description": "\n        Political committees with non-contribution accounts\n        ", "fec_code": "W", "key": "pac_with_non_contribution_account_qualified", "label": "PAC With Non-Contribution Account - Qualified", "value": 13 },
                    "party_nonqualified": { "description": "\n        Party committees that have not yet been in existence for six months and received\n        contributions from 50 people, unless they are affiliated with another party committee\n        that has met these requirements.\n        ", "fec_code": "X", "key": "party_nonqualified", "label": "Party - Nonqualified", "value": 14 },
                    "party_qualified": { "description": "\n        Party committees that have existed for at least six months and received contributions\n        from 50 people or are affiliated with another party committee that meets these\n        requirements.\n        ", "fec_code": "Y", "key": "party_qualified", "label": "Party - Qualified", "value": 15 },
                    "presidential": { "description": "\n        Campaign committee for candidate for U.S. President.\n        ", "fec_code": "P", "key": "presidential", "label": "Presidential", "value": 8 },
                    "senate": { "description": "\n        Campaign committee for candidate for Senate.\n        ", "fec_code": "S", "key": "senate", "label": "Senate", "value": 10 },
                    "single_candidate_independent_expenditure": { "description": "", "fec_code": "U", "key": "single_candidate_independent_expenditure", "label": "Single-Candidate Independent Expenditure", "value": 11 }
                },
                "FecCommitteeDesignation": {
                    "__is_enum": true,
                    "authorized_by_candidate": { "fec_code": "A", "key": "authorized_by_candidate", "label": "Authorized by a Candidate", "value": 1 },
                    "joint_fundraiser": { "fec_code": "J", "key": "joint_fundraiser", "label": "Joint Fundraiser", "value": 4 },
                    "leadership_pac": { "fec_code": "D", "key": "leadership_pac", "label": "Leadership PAC", "value": 3 },
                    "lobbyist_registrant_pac": { "fec_code": "B", "key": "lobbyist_registrant_pac", "label": "Lobbyist/Registrant PAC", "value": 2 },
                    "principal_campaign_committee": { "fec_code": "P", "key": "principal_campaign_committee", "label": "Principal Campaign Committee of a Candidate", "value": 5 },
                    "unauthorized": { "fec_code": "U", "key": "unauthorized", "label": "Unauthorized", "value": 6 }
                },
                "FecForm1AffiliatedEntityType": {
                    "__is_enum": true,
                    "affiliated_committee": { "fec_code": "AFF", "key": "affiliated_committee", "label": "Affiliated Committee", "value": 2 },
                    "connected_organization": { "fec_code": "ORG", "key": "connected_organization", "label": "Connected Organization", "value": 1 },
                    "joint_fundraising_representative": { "fec_code": "JFR", "key": "joint_fundraising_representative", "label": "Joint Fundraising Representative", "value": 3 },
                    "leadership_pac_sponsor": { "fec_code": "LPS", "key": "leadership_pac_sponsor", "label": "Leadership PAC Sponsor", "value": 4 }
                },
                "FecForm1Line5CommitteeType": {
                    "__is_enum": true,
                    "authorized_committee": { "fec_code": "B", "key": "authorized_committee", "label": "Authorized committee", "value": 2 },
                    "hybrid_pac": { "fec_code": "H", "key": "hybrid_pac", "label": "Hybrid PAC; both contribution and non-contribution accounts", "value": 10 },
                    "jfr_at_least_one_authorized": { "fec_code": "I", "key": "jfr_at_least_one_authorized", "label": "Joint fundraising representative; at least one participant is an authorized committee", "value": 7 },
                    "jfr_none_authorized": { "fec_code": "J", "key": "jfr_none_authorized", "label": "Joint fundraising representative; no participants are authorized by a candidate", "value": 8 },
                    "national_state_or_subordinate_party_committee": { "fec_code": "D", "key": "national_state_or_subordinate_party_committee", "label": "National, state, or subordinate committee of a party", "value": 4 },
                    "principal_campaign_committee": { "fec_code": "A", "key": "principal_campaign_committee", "label": "Principal campaign committee", "value": 1 },
                    "separate_segregated_fund": { "fec_code": "E", "key": "separate_segregated_fund", "label": "Separate segregated fund", "value": 5 },
                    "super_pac": { "fec_code": "G", "key": "super_pac", "label": "Super PAC; independent expenditure only", "value": 9 },
                    "support_oppose_multiple_not_ssf": { "fec_code": "F", "key": "support_oppose_multiple_not_ssf", "label": "Support/oppose multiple federal candidates, and not an ssf or party committee", "value": 6 },
                    "support_oppose_one_candidate_not_authorized": { "fec_code": "C", "key": "support_oppose_one_candidate_not_authorized", "label": "Support/oppose one candidate, and not an authorized committee", "value": 3 }
                },
                "FecForm1SupplementaryItemType": {
                    "__is_enum": true,
                    "affiliated_entity": { "key": "affiliated_entity", "label": "Affiliated Entity", "value": 1 },
                    "bank_account": { "key": "bank_account", "label": "Bank Account", "value": 3 },
                    "designated_agent": { "key": "designated_agent", "label": "Designated Agent", "value": 2 }
                },
                "FecParty": {
                    "__is_enum": true,
                    "ace_party": { "fec_code": "ACE", "key": "ace_party", "label": "Ace Party", "major_party_order": 999, "value": 1 },
                    "alaskan_independence_party": { "fec_code": "AKI", "key": "alaskan_independence_party", "label": "Alaskan Independence Party", "major_party_order": 999, "value": 2 },
                    "american_independent_conservative": { "fec_code": "AIC", "key": "american_independent_conservative", "label": "American Independent Conservative", "major_party_order": 999, "value": 3 },
                    "american_independent_party": { "fec_code": "AIP", "key": "american_independent_party", "label": "American Independent Party", "major_party_order": 999, "pacc_party_code": "A", "value": 4 },
                    "american_party": { "fec_code": "AMP", "key": "american_party", "label": "American Party", "major_party_order": 999, "value": 5 },
                    "american_peoples_freedom_party": { "fec_code": "APF", "key": "american_peoples_freedom_party", "label": "American People's Freedom Party", "major_party_order": 999, "value": 6 },
                    "americans_elect": { "fec_code": "AE", "key": "americans_elect", "label": "Americans Elect", "major_party_order": 999, "value": 7 },
                    "citizens_party": { "fec_code": "CIT", "key": "citizens_party", "label": "Citizens' Party", "major_party_order": 999, "pacc_party_code": "B", "value": 8 },
                    "commandments_party": { "fec_code": "CMD", "key": "commandments_party", "label": "Commandments Party", "major_party_order": 999, "value": 9 },
                    "commonwealth_party_of_the_us": { "fec_code": "CMP", "key": "commonwealth_party_of_the_us", "label": "Commonwealth Party of the U.S.", "major_party_order": 999, "value": 10 },
                    "communist_party": { "fec_code": "COM", "key": "communist_party", "label": "Communist Party", "major_party_order": 999, "pacc_party_code": "C", "value": 11 },
                    "concerned_citizens_party_of_connecticut": { "fec_code": "CNC", "key": "concerned_citizens_party_of_connecticut", "label": "Concerned Citizens Party Of Connecticut", "major_party_order": 999, "value": 12 },
                    "conservative_party": { "fec_code": "CRV", "key": "conservative_party", "label": "Conservative Party", "major_party_order": 999, "pacc_party_code": "F", "value": 13 },
                    "constitution_party": { "fec_code": "CON", "key": "constitution_party", "label": "Constitution Party", "major_party_order": 999, "value": 14 },
                    "constitutional": { "fec_code": "CST", "key": "constitutional", "label": "Constitutional", "major_party_order": 999, "pacc_party_code": "J", "value": 15 },
                    "country": { "fec_code": "COU", "key": "country", "label": "Country", "major_party_order": 999, "value": 16 },
                    "dc_statehood_green_party": { "fec_code": "DCG", "key": "dc_statehood_green_party", "label": "D.C. Statehood Green Party", "major_party_order": 999, "value": 17 },
                    "democratic_conservative": { "fec_code": "D/C", "key": "democratic_conservative", "label": "Democratic/Conservative", "major_party_order": 999, "value": 20 },
                    "democratic_nonpartisan_league": { "fec_code": "DNL", "key": "democratic_nonpartisan_league", "label": "Democratic-Nonpartisan League", "major_party_order": 999, "value": 18 },
                    "democratic_party": { "fec_code": "DEM", "key": "democratic_party", "label": "Democratic Party", "major_party_order": 2, "pacc_party_code": "D", "party": 1, "value": 19 },
                    "democraticfarmerlabor": { "fec_code": "DFL", "key": "democraticfarmerlabor", "label": "Democratic-Farmer-Labor", "major_party_order": 999, "pacc_party_code": "E", "party": 1, "value": 21 },
                    "desert_green_party": { "fec_code": "DGR", "key": "desert_green_party", "label": "Desert Green Party", "major_party_order": 999, "value": 22 },
                    "federalist": { "fec_code": "FED", "key": "federalist", "label": "Federalist", "major_party_order": 999, "value": 23 },
                    "freedom_labor_party": { "fec_code": "FLP", "key": "freedom_labor_party", "label": "Freedom Labor Party", "major_party_order": 999, "value": 24 },
                    "freedom_party": { "fec_code": "FRE", "key": "freedom_party", "label": "Freedom Party", "major_party_order": 999, "value": 25 },
                    "george_wallace_party": { "fec_code": "GWP", "key": "george_wallace_party", "label": "George Wallace Party", "major_party_order": 999, "value": 26 },
                    "grassroots": { "fec_code": "GRT", "key": "grassroots", "label": "Grassroots", "major_party_order": 999, "value": 27 },
                    "green_party": { "fec_code": "GRE", "key": "green_party", "label": "Green Party", "major_party_order": 5, "pacc_party_code": "G", "value": 28 },
                    "greenrainbow": { "fec_code": "GR", "key": "greenrainbow", "label": "Green-Rainbow", "major_party_order": 999, "value": 29 },
                    "human_rights_party": { "fec_code": "HRP", "key": "human_rights_party", "label": "Human Rights Party", "major_party_order": 999, "value": 30 },
                    "independence_party": { "fec_code": "IDP", "key": "independence_party", "label": "Independence Party", "major_party_order": 999, "pacc_party_code": "7", "value": 31 },
                    "independent": { "fec_code": "IND", "key": "independent", "label": "Independent", "major_party_order": 3, "pacc_party_code": "I", "party": 3, "value": 32 },
                    "independent_american_party": { "fec_code": "IAP", "key": "independent_american_party", "label": "Independent American Party", "major_party_order": 999, "pacc_party_code": "H", "value": 33 },
                    "independent_conservative_democratic": { "fec_code": "ICD", "key": "independent_conservative_democratic", "label": "Independent Conservative Democratic", "major_party_order": 999, "value": 34 },
                    "independent_green": { "fec_code": "IGR", "key": "independent_green", "label": "Independent Green", "major_party_order": 999, "value": 35 },
                    "independent_party": { "fec_code": "IP", "key": "independent_party", "label": "Independent Party", "major_party_order": 999, "value": 36 },
                    "independent_party_of_delaware": { "fec_code": "IDE", "key": "independent_party_of_delaware", "label": "Independent Party of Delaware", "major_party_order": 999, "value": 37 },
                    "industrial_government_party": { "fec_code": "IGD", "key": "industrial_government_party", "label": "Industrial Government Party", "major_party_order": 999, "value": 38 },
                    "jewish_christian_national": { "fec_code": "JCN", "key": "jewish_christian_national", "label": "Jewish/Christian National", "major_party_order": 999, "value": 39 },
                    "justice_party": { "fec_code": "JUS", "key": "justice_party", "label": "Justice Party", "major_party_order": 999, "value": 40 },
                    "la_raza_unida": { "fec_code": "LRU", "key": "la_raza_unida", "label": "La Raza Unida", "major_party_order": 999, "value": 41 },
                    "labor_party": { "fec_code": "LBR", "key": "labor_party", "label": "Labor Party", "major_party_order": 999, "value": 42 },
                    "less_federal_taxes": { "fec_code": "LFT", "key": "less_federal_taxes", "label": "Less Federal Taxes", "major_party_order": 999, "value": 43 },
                    "liberal_party": { "fec_code": "LBL", "key": "liberal_party", "label": "Liberal Party", "major_party_order": 999, "pacc_party_code": "K", "value": 44 },
                    "libertarian_party": { "fec_code": "LIB", "key": "libertarian_party", "label": "Libertarian Party", "major_party_order": 4, "pacc_party_code": "L", "party": 21, "value": 45 },
                    "liberty_union_party": { "fec_code": "LBU", "key": "liberty_union_party", "label": "Liberty Union Party", "major_party_order": 999, "value": 46 },
                    "mountain_party": { "fec_code": "MTP", "key": "mountain_party", "label": "Mountain Party", "major_party_order": 999, "value": 47 },
                    "national_democratic_party": { "fec_code": "NDP", "key": "national_democratic_party", "label": "National Democratic Party", "major_party_order": 999, "value": 48 },
                    "natural_law_party": { "fec_code": "NLP", "key": "natural_law_party", "label": "Natural Law Party", "major_party_order": 999, "pacc_party_code": "M", "value": 49 },
                    "new_alliance": { "fec_code": "NA", "key": "new_alliance", "label": "New Alliance", "major_party_order": 999, "value": 50 },
                    "new_jersey_conservative_party": { "fec_code": "NJC", "key": "new_jersey_conservative_party", "label": "New Jersey Conservative Party", "major_party_order": 999, "value": 51 },
                    "new_progressive_party": { "fec_code": "NPP", "key": "new_progressive_party", "label": "New Progressive Party", "major_party_order": 999, "value": 52 },
                    "no_party_affiliation": { "fec_code": "NPA", "key": "no_party_affiliation", "label": "No Party Affiliation", "major_party_order": 999, "value": 53 },
                    "no_party_preference": { "fec_code": "NOP", "key": "no_party_preference", "label": "No Party Preference", "major_party_order": 999, "value": 54 },
                    "none": { "fec_code": "NNE", "key": "none", "label": "None", "major_party_order": 999, "pacc_party_code": "N", "value": 55 },
                    "nonpartisan": { "fec_code": "N", "key": "nonpartisan", "label": "Nonpartisan", "major_party_order": 999, "value": 56 },
                    "nonparty": { "fec_code": "NON", "key": "nonparty", "label": "Non-Party", "major_party_order": 999, "value": 57 },
                    "one_earth_party": { "fec_code": "OE", "key": "one_earth_party", "label": "One Earth Party", "major_party_order": 999, "value": 58 },
                    "other": { "fec_code": "OTH", "key": "other", "label": "Other", "major_party_order": 6, "pacc_party_code": "O", "party": 4, "value": 59 },
                    "pacific_green": { "fec_code": "PG", "key": "pacific_green", "label": "Pacific Green", "major_party_order": 999, "value": 60 },
                    "party_for_socialism_and_liberation": { "fec_code": "PSL", "key": "party_for_socialism_and_liberation", "label": "Party for Socialism and Liberation", "major_party_order": 999, "value": 61 },
                    "peace_and_freedom": { "fec_code": "PAF", "key": "peace_and_freedom", "label": "Peace And Freedom", "major_party_order": 999, "value": 62 },
                    "peace_and_freedom_party": { "fec_code": "PFP", "key": "peace_and_freedom_party", "label": "Peace And Freedom Party", "major_party_order": 999, "value": 63 },
                    "peace_freedom_party": { "fec_code": "PFD", "key": "peace_freedom_party", "label": "Peace Freedom Party", "major_party_order": 999, "value": 64 },
                    "people_over_politics": { "fec_code": "POP", "key": "people_over_politics", "label": "People Over Politics", "major_party_order": 999, "value": 65 },
                    "peoples_party": { "fec_code": "PPY", "key": "peoples_party", "label": "People's Party", "major_party_order": 999, "value": 66 },
                    "personal_choice_party": { "fec_code": "PCH", "key": "personal_choice_party", "label": "Personal Choice Party", "major_party_order": 999, "value": 67 },
                    "popular_democratic_party": { "fec_code": "PPD", "key": "popular_democratic_party", "label": "Popular Democratic Party", "major_party_order": 999, "value": 68 },
                    "progressive_party": { "fec_code": "PRO", "key": "progressive_party", "label": "Progressive Party", "major_party_order": 999, "value": 69 },
                    "prohibition_party": { "fec_code": "NAP", "key": "prohibition_party", "label": "Prohibition Party", "major_party_order": 999, "value": 70 },
                    "puerto_rican_independence_party": { "fec_code": "PRI", "key": "puerto_rican_independence_party", "label": "Puerto Rican Independence Party", "major_party_order": 999, "value": 71 },
                    "raza_unida_party": { "fec_code": "RUP", "key": "raza_unida_party", "label": "Raza Unida Party", "major_party_order": 999, "value": 72 },
                    "reform_party": { "fec_code": "REF", "key": "reform_party", "label": "Reform Party", "major_party_order": 999, "pacc_party_code": "P", "value": 73 },
                    "republican_party": { "fec_code": "REP", "key": "republican_party", "label": "Republican Party", "major_party_order": 1, "pacc_party_code": "R", "party": 2, "value": 74 },
                    "resource_party": { "fec_code": "RES", "key": "resource_party", "label": "Resource Party", "major_party_order": 999, "value": 75 },
                    "right_to_life": { "fec_code": "RTL", "key": "right_to_life", "label": "Right To Life", "major_party_order": 999, "pacc_party_code": "Q", "value": 76 },
                    "socialist_equality_party": { "fec_code": "SEP", "key": "socialist_equality_party", "label": "Socialist Equality Party", "major_party_order": 999, "pacc_party_code": "3", "value": 77 },
                    "socialist_labor_party": { "fec_code": "SLP", "key": "socialist_labor_party", "label": "Socialist Labor Party", "major_party_order": 999, "pacc_party_code": "4", "value": 78 },
                    "socialist_party": { "fec_code": "SUS", "key": "socialist_party", "label": "Socialist Party", "major_party_order": 999, "pacc_party_code": "S", "value": 79 },
                    "socialist_party_usa": { "fec_code": "SOC", "key": "socialist_party_usa", "label": "Socialist Party U.S.A.", "major_party_order": 999, "pacc_party_code": "V", "value": 80 },
                    "socialist_workers_party": { "fec_code": "SWP", "key": "socialist_workers_party", "label": "Socialist Workers Party", "major_party_order": 999, "pacc_party_code": "W", "value": 81 },
                    "taxpayers": { "fec_code": "TX", "key": "taxpayers", "label": "Taxpayers", "major_party_order": 999, "pacc_party_code": "T", "value": 82 },
                    "taxpayers_without_representation": { "fec_code": "TWR", "key": "taxpayers_without_representation", "label": "Taxpayers Without Representation", "major_party_order": 999, "value": 83 },
                    "tea_party": { "fec_code": "TEA", "key": "tea_party", "label": "Tea Party", "major_party_order": 999, "value": 84 },
                    "theodemocratic": { "fec_code": "THD", "key": "theodemocratic", "label": "Theo-Democratic", "major_party_order": 999, "value": 85 },
                    "unaffiliated": { "fec_code": "UN", "key": "unaffiliated", "label": "Unaffiliated", "major_party_order": 999, "value": 89 },
                    "united_citizen": { "fec_code": "UC", "key": "united_citizen", "label": "United Citizen", "major_party_order": 999, "value": 90 },
                    "united_party": { "fec_code": "UNI", "key": "united_party", "label": "United Party", "major_party_order": 999, "value": 91 },
                    "unknown": { "fec_code": "UNK", "key": "unknown", "label": "Unknown", "major_party_order": 999, "pacc_party_code": "U", "value": 92 },
                    "us_labor_party": { "fec_code": "LAB", "key": "us_labor_party", "label": "U.S. Labor Party", "major_party_order": 999, "value": 86 },
                    "us_peoples_party": { "fec_code": "USP", "key": "us_peoples_party", "label": "U.S. People's Party", "major_party_order": 999, "value": 87 },
                    "us_taxpayers_party": { "fec_code": "UST", "key": "us_taxpayers_party", "label": "U.S. Taxpayers Party", "major_party_order": 999, "value": 88 },
                    "veterans_party": { "fec_code": "VET", "key": "veterans_party", "label": "Veterans Party", "major_party_order": 999, "value": 93 },
                    "we_the_people": { "fec_code": "WTP", "key": "we_the_people", "label": "We the People", "major_party_order": 999, "value": 94 },
                    "writein": { "fec_code": "W", "key": "writein", "label": "Write-In", "major_party_order": 999, "value": 95 }
                },
                "Form3XReportType": {
                    "__is_enum": true,
                    "m_10": { "code": "M10", "coverage_end_month_day": "09/30", "dataCy": "monthly-report-M10", "due_date": "10/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_10", "label": "Monthly Report (M10)", "sort_order": 10, "title": "October 20", "value": 13 },
                    "m_11": { "code": "M11", "coverage_end_month_day": "10/31", "dataCy": "monthly-report-M11", "due_date": "11/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_11", "label": "Monthly Report (M11)", "sort_order": 11, "title": "November 20", "value": 14 },
                    "m_12": { "code": "M12", "coverage_end_month_day": "11/30", "dataCy": "monthly-report-M12", "due_date": "12/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_12", "label": "Monthly Report (M12)", "sort_order": 12, "title": "December 20", "value": 21 },
                    "m_2": { "code": "M2", "coverage_end_month_day": "01/31", "dataCy": "monthly-report-M2", "due_date": "02/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_2", "label": "Monthly Report (M2)", "sort_order": 2, "title": "February 20", "value": 5 },
                    "m_3": { "code": "M3", "coverage_end_month_day": "02/28", "dataCy": "monthly-report-M3", "due_date": "03/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_3", "label": "Monthly Report (M3)", "sort_order": 3, "title": "March 20", "value": 6 },
                    "m_4": { "code": "M4", "coverage_end_month_day": "03/31", "dataCy": "monthly-report-M4", "due_date": "04/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_4", "label": "Monthly Report (M4)", "sort_order": 4, "title": "April 20", "value": 7 },
                    "m_5": { "code": "M5", "coverage_end_month_day": "04/30", "dataCy": "monthly-report-M5", "due_date": "05/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_5", "label": "Monthly Report (M5)", "sort_order": 5, "title": "May 20", "value": 8 },
                    "m_6": { "code": "M6", "coverage_end_month_day": "05/31", "dataCy": "monthly-report-M6", "due_date": "06/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_6", "label": "Monthly Report (M6)", "sort_order": 6, "title": "June 20", "value": 9 },
                    "m_7": { "code": "M7", "coverage_end_month_day": "06/30", "dataCy": "monthly-report-M7", "due_date": "07/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_7", "label": "Monthly Report (M7)", "sort_order": 7, "title": "July 20", "value": 10 },
                    "m_8": { "code": "M8", "coverage_end_month_day": "07/31", "dataCy": "monthly-report-M8", "due_date": "08/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_8", "label": "Monthly Report (M8)", "sort_order": 8, "title": "August 20", "value": 11 },
                    "m_9": { "code": "M9", "coverage_end_month_day": "08/31", "dataCy": "monthly-report-M9", "due_date": "09/20", "form_period_type": 1, "icon": "file-invoice-dollar", "key": "m_9", "label": "Monthly Report (M9)", "sort_order": 9, "title": "September 20", "value": 12 },
                    "post_election": { "code": "30", "dataCy": "post-election", "icon": "file-invoice-dollar", "key": "post_election", "label": "30-Day Post Election Report", "sort_order": 49, "title": "Post-Election", "value": 20 },
                    "pre_election": { "code": "12", "dataCy": "pre-election", "icon": "file-invoice-dollar", "key": "pre_election", "label": "12-Day Pre Election Report", "sort_order": 48, "title": "Pre-Election", "value": 19 },
                    "q_1": { "code": "Q1", "coverage_end_month_day": "03/31", "dataCy": "quarterly-report-Q1", "due_date": "04/15", "form_period_type": 2, "icon": "file-invoice-dollar", "key": "q_1", "label": "Quarterly Report (Q1)", "sort_order": 1, "title": "April 15", "value": 1 },
                    "q_2": { "code": "Q2", "coverage_end_month_day": "06/30", "dataCy": "quarterly-report-Q2", "due_date": "07/15", "form_period_type": 2, "icon": "file-invoice-dollar", "key": "q_2", "label": "Quarterly Report (Q2)", "sort_order": 2, "title": "July 15", "value": 2 },
                    "q_3": { "code": "Q3", "coverage_end_month_day": "09/30", "dataCy": "quarterly-report-Q3", "due_date": "10/15", "form_period_type": 2, "icon": "file-invoice-dollar", "key": "q_3", "label": "Quarterly Report (Q3)", "sort_order": 3, "title": "October 15", "value": 3 },
                    "q_mid_year": { "code": "MY", "coverage_end_month_day": "06/30", "dataCy": "quarterly-mid-year-report", "due_date": "07/31", "form_period_type": 2, "icon": "file-invoice-dollar", "key": "q_mid_year", "label": "Mid-Year Report (MY)", "sort_order": 46, "title": "July 31", "value": 17 },
                    "termination_report": { "code": "TER", "dataCy": "termination-report", "icon": "file-invoice-dollar", "key": "termination_report", "label": "Termination Report", "sort_order": 50, "title": "Termination Report (TER)", "value": 18 },
                    "year_end": { "code": "YE", "coverage_end_month_day": "12/31", "dataCy": "year-end-report", "due_date": "01/31", "icon": "file-invoice-dollar", "key": "year_end", "label": "Year-End Report (YE)", "sort_order": 47, "title": "January 31", "value": 15 }
                },
                "MichiganPartyType": {
                    "__is_enum": true,
                    "congressional_district_political_party_committee": { "key": "congressional_district_political_party_committee", "label": "Congressional District Political Party Committee", "pacc_michigan_party_code": "DPP", "value": 2 },
                    "state_political_party_committee": { "key": "state_political_party_committee", "label": "State Political Party Committee", "pacc_michigan_party_code": "SPP", "value": 1 }
                },
                "PACCLimitType": {
                    "__is_enum": true,
                    "anonymous": { "key": "anonymous", "label": "Anonymous", "pacc_code": "ANO", "value": 0 },
                    "ballot_measure_committee": { "key": "ballot_measure_committee", "label": "Ballot Measure Committee", "pacc_code": "BAL", "value": 50 },
                    "bank": { "key": "bank", "label": "Bank", "pacc_code": "BNK", "value": 10 },
                    "corporation": { "key": "corporation", "label": "Corporate Entity", "pacc_code": "INC", "value": 11 },
                    "federal_candidate_committee": { "key": "federal_candidate_committee", "label": "Federal Candidate Committee", "pacc_code": "FCC", "value": 22 },
                    "federal_pac_ssf": { "key": "federal_pac_ssf", "label": "Federal PAC / SSF", "pacc_code": "FSF", "value": 23 },
                    "incidental_committee": { "key": "incidental_committee", "label": "Incidental Committee", "pacc_code": "ICM", "value": 51 },
                    "individual": { "key": "individual", "label": "Individual", "pacc_code": "IND", "value": 1 },
                    "jfc": { "key": "jfc", "label": "Joint Fundraising Committee", "pacc_code": "JFC", "value": 24 },
                    "labor_union": { "key": "labor_union", "label": "Labor Union", "pacc_code": "LAB", "value": 12 },
                    "llc": { "key": "llc", "label": "Limited Liability Corporation", "pacc_code": "LLC", "value": 13 },
                    "llp": { "key": "llp", "label": "Limited Liability Partnership", "pacc_code": "LLP", "value": 14 },
                    "local_candidate_committee": { "key": "local_candidate_committee", "label": "Local Candidate Committee", "pacc_code": "LCC", "value": 41 },
                    "local_party_committee": { "key": "local_party_committee", "label": "Local Party Committee", "pacc_code": "LPC", "value": 40 },
                    "national_party_committee": { "key": "national_party_committee", "label": "National Party Committee", "pacc_code": "NPC", "value": 21 },
                    "other": { "key": "other", "label": "Other", "pacc_code": "OTH", "value": 15 },
                    "parent_entity": { "key": "parent_entity", "label": "Parent Entity", "pacc_code": "PAR", "value": 16 },
                    "partnership": { "key": "partnership", "label": "Partnership", "pacc_code": "SHP", "value": 17 },
                    "sole_proprietorship": { "key": "sole_proprietorship", "label": "Sole Proprietorship", "pacc_code": "SOL", "value": 2 },
                    "state_candidate_committee": { "key": "state_candidate_committee", "label": "State Candidate Committee", "pacc_code": "SCC", "value": 31 },
                    "state_pac_ssf": { "key": "state_pac_ssf", "label": "State PAC / SSF", "pacc_code": "SSF", "value": 32 },
                    "state_party_committee": { "key": "state_party_committee", "label": "State Party Committee", "pacc_code": "SPC", "value": 30 },
                    "state_party_committee_fed_acct": { "key": "state_party_committee_fed_acct", "label": "State Party Committee Federal Account", "pacc_code": "SPF", "value": 33 },
                    "vendor": { "key": "vendor", "label": "Vendor", "pacc_code": "VEN", "value": 18 }
                },
                "PacFileFormPeriodType": {
                    "__is_enum": true,
                    "monthly": { "key": "monthly", "label": "Monthly", "show_in_pac_settings_form": true, "value": 1 },
                    "quarterly": { "key": "quarterly", "label": "Quarterly", "show_in_pac_settings_form": true, "value": 2 },
                    "yearly": { "key": "yearly", "label": "Yearly", "show_in_pac_settings_form": false, "value": 3 }
                },
                "PacFileFormStatusType": {
                    "GENERATING": [19, 5, 10, 18, 19],
                    "__is_enum": true,
                    "fec_generate_requested": { "in_progress": true, "key": "fec_generate_requested", "label": "FEC Generate Requested", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 5 },
                    "filed": { "in_progress": false, "key": "filed", "label": "Filed", "should_have_quorum_pac_version": true, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": true, "value": 20 },
                    "filed_overridden": { "in_progress": false, "key": "filed_overridden", "label": "Filed (Edited Filing ID)", "should_have_quorum_pac_version": true, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 25 },
                    "filing_failed": { "in_progress": true, "key": "filing_failed", "label": "Failed", "should_have_quorum_pac_version": true, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": true, "value": 16 },
                    "filing_generated": { "in_progress": true, "key": "filing_generated", "label": "Filing Generated", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": true, "value": 21 },
                    "filing_in_progress": { "in_progress": true, "key": "filing_in_progress", "label": "Filing in Progress", "should_have_quorum_pac_version": true, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 18 },
                    "generating": { "in_progress": true, "key": "generating", "label": "Generating Filing", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": true, "value": 19 },
                    "imported_filing": { "in_progress": false, "key": "imported_filing", "label": "Previous Vendor Filing", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 100 },
                    "in_progress": { "in_progress": true, "key": "in_progress", "label": "In Progress", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 10 },
                    "not_filed": { "in_progress": true, "key": "not_filed", "label": "Not Filed", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": false, "valid_for_state": true, "value": 11 },
                    "not_started": { "in_progress": true, "key": "not_started", "label": "Not Started", "should_have_quorum_pac_version": false, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 1 },
                    "queued_for_filing": { "in_progress": true, "key": "queued_for_filing", "label": "Queued for Filing", "should_have_quorum_pac_version": true, "show_in_enumeration": true, "valid_for_fec": true, "valid_for_state": false, "value": 15 }
                },
                "PacFileFormType": {
                    "__is_enum": true,
                    "form_f1": { "disabled": false, "key": "form_f1", "label": "Statement of Declaration", "order": 3, "region": 1, "report_super_type": 10, "subtitle": "Statement of Organization", "title": "Form 1", "value": 1 },
                    "form_f1m": { "disabled": true, "key": "form_f1m", "label": "Notification of Multicandidate Status", "order": 4, "region": 1, "report_super_type": 10, "subtitle": "Notification of Multicandidate Status", "title": "Form 1M", "value": 2 },
                    "form_f3x": { "disabled": false, "key": "form_f3x", "label": "Report of receipts and disbursements for an authorized committee", "order": 1, "region": 1, "report_super_type": 20, "subtitle": "Report of Receipts and Disbursements", "title": "Form 3X", "value": 3 },
                    "form_f99": { "disabled": true, "key": "form_f99", "label": "Miscellaneous Report to the FEC", "order": 5, "region": 1, "report_super_type": 10, "subtitle": "Miscellaneous Report to the FEC", "title": "Form 99", "value": 4 },
                    "ld_203": { "disabled": true, "key": "ld_203", "label": "House and Senate Lobbying Disclosure", "order": 2, "region": 1, "report_super_type": 10, "subtitle": "House and Senate Lobbying Disclosure", "title": "LD-203", "value": 5 },
                    "state_form": { "disabled": true, "key": "state_form", "label": "No Form Type", "order": 9999, "subtitle": "No Form Type", "title": "No Form Type", "value": 6 }
                },
                "PacFilingFrequencyType": {
                    "__is_enum": true,
                    "monthly": { "key": "monthly", "label": "Monthly", "value": 1 },
                    "quarterly": { "key": "quarterly", "label": "Quarterly", "value": 2 }
                },
                "PacReportSuperType": {
                    "__is_enum": true,
                    "compliance_report": { "key": "compliance_report", "label": "Compliance Report", "value": 20 },
                    "notification_report": { "key": "notification_report", "label": "Notification Report", "value": 10 }
                },
                "PacType": {
                    "__is_enum": true,
                    "cooperative": { "fec_code": "V", "key": "cooperative", "label": "Cooperative", "value": 5 },
                    "corporation": { "fec_code": "C", "key": "corporation", "label": "Corporation", "value": 1 },
                    "corporation_without_capital_stock": { "fec_code": "W", "key": "corporation_without_capital_stock", "label": "Corporation Without Capital Stock", "value": 6 },
                    "labor_organization": { "fec_code": "L", "key": "labor_organization", "label": "Labor Organization", "value": 3 },
                    "membership_organization": { "fec_code": "M", "key": "membership_organization", "label": "Membership Organization", "value": 4 },
                    "trade_association": { "fec_code": "T", "key": "trade_association", "label": "Trade Association", "value": 2 }
                },
                "PeriodType": {
                    "__is_enum": true,
                    "election": { "help_text": "A period of 1 election", "key": "election", "label": "Election", "value": 2 },
                    "none": { "help_text": "No time period - useful for unlimited limits", "key": "none", "label": "None", "value": 3 },
                    "year": { "help_text": "A period of 1 year", "key": "year", "label": "Year", "value": 1 }
                },
                "PoliticalCommitteeType": {
                    "__is_enum": true,
                    "ballot_measures_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that supports or opposes ballot measures.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "ballot_measures_committee", "label": "Ballot Measures Committee", "order": 0, "pacc_code": "BAL", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 102 },
                    "candidate_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that is set up to receive contributions on behalf of a candidate", "is_candidate_committee": true, "is_political_committee": true, "is_state_or_local": false, "key": "candidate_committee", "label": "Federal Candidate Committee", "order": 0, "pacc_code": "FCC", "pacc_limit_type": "", "requires_election_for_transaction": true, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 1 },
                    "federal_pac_ssf_and_nonconnected": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "\n            A Federal level PAC that is either of multicandidate or nonmulticandidate status.\n            Useful in instances where the status is irrelevant.\n\n            Corresponds to the \"PAC (SSF and nonconnected)\" category for 2019-2020 federal election\n            contribution limits.\n        ",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": false,
                        "key": "federal_pac_ssf_and_nonconnected",
                        "label": "Federal PAC (SSF and Nonconnected)",
                        "order": 0,
                        "pacc_code": "FSF",
                        "pacc_limit_type": "",
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 6
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "CAN_CONTRIBUTE_RECEIPTS",
                            "values": [1, 101, 5, 7, 8, 9, 6, 2, 3, 31, 30, 33, 32, 41, 40]
                        }
                    ],
                    "incidental_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": false,
                        "key": "incidental_committee",
                        "label": "Incidental Committee",
                        "order": 0,
                        "pacc_code": "ICM",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": false,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 103
                    },
                    "joint_fundraising_committee": { "associated_qdt": 114, "form_label": "", "help_text": "\n        A joint fundraiser (FecCommitteeDesignation.joint_fundraiser) with a type of\n        FecCommitteeCode.house, FecCommitteeCode.presidential, or FecCommitteeCode.senate.\n        Exists as a joint fundraising effort with the express purpose of allocating funds\n        to support one or more candidates for political office.\n        ", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "joint_fundraising_committee", "label": "Joint Fundraising Committee", "order": 0, "pacc_code": "JFC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 101 },
                    "local_candidate_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": true,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "local_candidate_committee",
                        "label": "Local Candidate Committee",
                        "order": 0,
                        "pacc_code": "LCC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": true,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 41
                    },
                    "local_party_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "local_party_committee",
                        "label": "Local Party Committee",
                        "order": 0,
                        "pacc_code": "LPC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 40
                    },
                    "multicandidate_pac": { "associated_qdt": 114, "form_label": "", "help_text": "A PAC can be either an SSF or a nonconnected organization that makes contributions to other federal politicalcommittees. This type is for PAC's that are able to give to multiple candidates.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "multicandidate_pac", "label": "Multicandidate PAC", "order": 0, "pacc_code": "FSF", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 2 },
                    "national_party_committee": { "associated_qdt": 114, "form_label": "", "help_text": "A committee that represents a political party and is part of the official party structure at the national level", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee", "label": "National Party Committee", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 5 },
                    "national_party_committee_special_account_for_election_recounts_and_contests": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for election recounts and contests and other legal proceedings that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_election_recounts_and_contests", "label": "National Party Committee: Special Account for Election Recounts and Contests and Other Legal Proceedings", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 8 },
                    "national_party_committee_special_account_for_headquarters_buildings": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for national party headquarters buildings that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_headquarters_buildings", "label": "National Party Committee: Special Account for National Party Headquarters Buildings", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 9 },
                    "national_party_committee_special_account_for_presidential_nominating_convention": { "associated_qdt": 114, "form_label": "", "help_text": "A special account of national party committee for presidential nominating convention that has different contribution limit from the national party committee it belongs to", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "national_party_committee_special_account_for_presidential_nominating_convention", "label": "National Party Committee: Special Account for Presidential Nominating Convention", "order": 0, "pacc_code": "NPC", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 7 },
                    "nonmulticandidate_pac": { "associated_qdt": 114, "form_label": "", "help_text": "A PAC can be either an SSF or a nonconnected organization that makes contributions to other federal politicalcommittees. This type is for PAC's that cannot give to multiple candidates", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "nonmulticandidate_pac", "label": "Nonmulticandidate PAC", "order": 0, "pacc_code": "FSF", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 3 },
                    "other": { "associated_qdt": 114, "form_label": "Other", "help_text": "Catch-all for PoliticalCommittees that do not fall cleanly into the explicitly defined categories.", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "other", "label": "Uncategorized", "order": 0, "pacc_code": "OTH", "pacc_limit_type": "OTH", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": true, "value": 100000 },
                    "state_candidate_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": true,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_candidate_committee",
                        "label": "State Candidate Committee",
                        "order": 0,
                        "pacc_code": "SCC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": true,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 31
                    },
                    "state_pac_ssf": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_pac_ssf",
                        "label": "State PAC / SSF",
                        "order": 0,
                        "pacc_code": "SSF",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 32
                    },
                    "state_party_committee": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_party_committee",
                        "label": "State Party Committee",
                        "order": 0,
                        "pacc_code": "SPC",
                        "pacc_limit_type": "",
                        "permission_enum": [213],
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 30
                    },
                    "state_party_committee_fed_acct": {
                        "associated_qdt": 114,
                        "form_label": "",
                        "help_text": "",
                        "is_candidate_committee": false,
                        "is_political_committee": true,
                        "is_state_or_local": true,
                        "key": "state_party_committee_fed_acct",
                        "label": "State Party Committee Federal Account",
                        "order": 0,
                        "pacc_code": "SPF",
                        "pacc_limit_type": "",
                        "requires_election_for_transaction": false,
                        "show_in_disbursement_form": false,
                        "show_in_enumeration": true,
                        "show_in_receipt_form": false,
                        "show_in_state_committee_form": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "user_selectable_pac_org_type": false,
                        "value": 33
                    },
                    "super_pac": { "associated_qdt": 114, "form_label": "", "help_text": "\n        An independent expenditure-only committee, or super PAC. May receive/spend unlimited sums of money\n        as long as this is done independently of candidate campaigns.\n        ", "is_candidate_committee": false, "is_political_committee": true, "is_state_or_local": false, "key": "super_pac", "label": "Super PAC", "order": 0, "pacc_code": "OTH", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": true, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 100 }
                },
                "ReportFrequencyType": {
                    "__is_enum": true,
                    "annually": { "key": "annually", "label": "Annually", "value": 4 },
                    "daily": { "key": "daily", "label": "Daily", "value": 0 },
                    "monthly": { "key": "monthly", "label": "Monthly", "value": 2 },
                    "quarterly": { "key": "quarterly", "label": "Quarterly", "value": 3 },
                    "weekly": { "key": "weekly", "label": "Weekly", "value": 1 }
                },
                "ReportType": {
                    "__is_enum": true,
                    "balance_sheet": { "key": "balance_sheet", "label": "Balance Sheet", "value": 1 },
                    "general_ledger": { "key": "general_ledger", "label": "General Ledger", "value": 2 },
                    "income_statement": { "key": "income_statement", "label": "Income Statement", "value": 3 }
                },
                "_ParentEntityType": {
                    "__is_enum": true,
                    "public_organization": { "form_label": "", "help_text": "", "is_candidate_committee": false, "is_political_committee": false, "is_state_or_local": false, "key": "public_organization", "label": "Organization", "order": 0, "pacc_code": "", "pacc_limit_type": "", "requires_election_for_transaction": false, "show_in_disbursement_form": false, "show_in_enumeration": false, "show_in_receipt_form": false, "show_in_state_committee_form": false, "user_selectable_pac_org_type": false, "value": 3000 }
                }
            }
        },
        "pac_classic": {
            "models": {
                "bank_account": {
                    "PacClassicBankAccount": {
                        "__is_model": true,
                        "__name__": "PacClassicBankAccount",
                        "data_model": "app.pac_classic.models.bank_account.PacClassicBankAccount",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/bank-account/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_bank_account_id", "verbose_name": "pac bank account id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_bank_account",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "Account" },
                                "verbose_name": "qpac v1 bank account"
                            },
                            { "field_type": 2, "help_text": "", "name": "account_type", "verbose_name": "account type" },
                            { "field_type": 2, "help_text": "", "name": "account_number", "verbose_name": "account number" },
                            { "field_type": 2, "help_text": "", "name": "bank_account_external_id", "verbose_name": "bank account external id" },
                            { "field_type": 4, "help_text": "", "name": "next_check_no", "verbose_name": "next check no" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicDefaultCheckType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "default_check_type",
                                "verbose_name": "default check type"
                            },
                            { "field_type": 1, "help_text": "", "name": "is_default", "verbose_name": "is default" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 2, "help_text": "", "name": "address_1", "verbose_name": "address 1" },
                            { "field_type": 2, "help_text": "", "name": "address_2", "verbose_name": "address 2" },
                            { "field_type": 2, "help_text": "", "name": "city", "verbose_name": "city" },
                            { "field_type": 2, "help_text": "", "name": "state", "verbose_name": "state" },
                            { "field_type": 2, "help_text": "", "name": "zip", "verbose_name": "zip" },
                            { "field_type": 2, "help_text": "", "name": "phone", "verbose_name": "phone" }
                        ]
                    }
                },
                "committee": {
                    "PacClassicLegislativeCommittee": {
                        "__is_model": true,
                        "__name__": "PacClassicLegislativeCommittee",
                        "data_model": "app.pac_classic.models.committee.PacClassicLegislativeCommittee",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/committee/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "committee_id", "verbose_name": "committee id" },
                            { "field_type": 2, "help_text": "", "name": "commno", "verbose_name": "commno" },
                            { "field_type": 2, "help_text": "", "name": "committee_name", "verbose_name": "committee name" },
                            { "field_type": 2, "help_text": "", "name": "address_line_1", "verbose_name": "address line 1" },
                            { "field_type": 2, "help_text": "", "name": "address_line_2", "verbose_name": "address line 2" },
                            { "field_type": 2, "help_text": "", "name": "address_line_3", "verbose_name": "address line 3" },
                            { "field_type": 2, "help_text": "", "name": "chamber", "verbose_name": "chamber" },
                            { "field_type": 2, "help_text": "", "name": "juris", "verbose_name": "juris" },
                            { "field_type": 1, "help_text": "", "name": "is_subcommittee", "verbose_name": "is subcommittee" },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 21, "help_text": "", "name": "last_indexed_date", "verbose_name": "last indexed date" },
                            { "field_type": 1, "help_text": "", "name": "re_index", "verbose_name": "re index" },
                            { "field_type": 2, "help_text": "", "name": "pacc_id", "verbose_name": "pacc id" }
                        ]
                    }
                },
                "election": {
                    "PacClassicElection": {
                        "__is_model": true,
                        "__name__": "PacClassicElection",
                        "data_model": "app.pac_classic.models.election.PacClassicElection",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/election/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_election_id", "verbose_name": "pac election id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "qpac v1 election"
                            },
                            { "field_type": 21, "help_text": "", "name": "election_date", "verbose_name": "election date" },
                            { "field_type": 2, "help_text": "", "name": "election_external_id", "verbose_name": "election external id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicElectionType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "election_type",
                                "verbose_name": "election type"
                            },
                            { "field_type": 1, "help_text": "", "name": "is_displayed", "verbose_name": "is displayed" },
                            { "field_type": 2, "help_text": "", "name": "jurisdiction", "verbose_name": "jurisdiction" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPartyType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "party",
                                "verbose_name": "party"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source",
                                "verbose_name": "source"
                            },
                            { "field_type": 4, "help_text": "", "name": "year", "verbose_name": "year" }
                        ]
                    }
                },
                "individual": {
                    "PacClassicIndividual": {
                        "__is_model": true,
                        "__name__": "PacClassicIndividual",
                        "data_model": "app.pac_classic.models.individual.PacClassicIndividual",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/individual/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "individual_id", "verbose_name": "individual id" },
                            { "field_type": 4, "help_text": "", "name": "supporter_quorum_id", "verbose_name": "supporter quorum id" },
                            { "field_type": 2, "help_text": "", "name": "external_id", "verbose_name": "external id" },
                            { "field_type": 4, "help_text": "", "name": "individual_type_id", "verbose_name": "individual type id" },
                            { "field_type": 2, "help_text": "", "name": "delaware_id", "verbose_name": "delaware id" },
                            { "field_type": 2, "help_text": "", "name": "oklahoma_id", "verbose_name": "oklahoma id" },
                            { "field_type": 2, "help_text": "", "name": "vermont_id", "verbose_name": "vermont id" },
                            { "field_type": 1, "help_text": "", "name": "advocacy_account_locked", "verbose_name": "advocacy account locked" },
                            { "field_type": 4, "help_text": "", "name": "advocacy_failed_login_attempts", "verbose_name": "advocacy failed login attempts" },
                            { "field_type": 2, "help_text": "", "name": "advocacy_user_id", "verbose_name": "advocacy user id" },
                            { "field_type": 2, "help_text": "", "name": "advocacy_password", "verbose_name": "advocacy password" },
                            { "field_type": 2, "help_text": "", "name": "password_salt", "verbose_name": "password salt" },
                            { "field_type": 21, "help_text": "", "name": "advocacy_password_last_changed", "verbose_name": "advocacy password last changed" },
                            { "field_type": 2, "help_text": "", "name": "prefix", "verbose_name": "prefix" },
                            { "field_type": 2, "help_text": "", "name": "first_name", "verbose_name": "first name" },
                            { "field_type": 2, "help_text": "", "name": "nickname", "verbose_name": "nickname" },
                            { "field_type": 2, "help_text": "", "name": "middle_name", "verbose_name": "middle name" },
                            { "field_type": 2, "help_text": "", "name": "last_name", "verbose_name": "last name" },
                            { "field_type": 2, "help_text": "", "name": "suffix", "verbose_name": "suffix" },
                            { "field_type": 2, "help_text": "", "name": "full_name", "verbose_name": "full name" },
                            { "field_type": 2, "help_text": "", "name": "sort_name", "verbose_name": "sort name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredAddressType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_address",
                                "verbose_name": "preferred address"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredDeliveryType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_delivery_type",
                                "verbose_name": "preferred delivery type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredEmailType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_email",
                                "verbose_name": "preferred email"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredFaxType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_fax",
                                "verbose_name": "preferred fax"
                            },
                            { "field_type": 2, "help_text": "", "name": "home_address_line_1", "verbose_name": "home address line 1" },
                            { "field_type": 2, "help_text": "", "name": "home_address_line_2", "verbose_name": "home address line 2" },
                            { "field_type": 2, "help_text": "", "name": "home_city", "verbose_name": "home city" },
                            { "field_type": 2, "help_text": "", "name": "home_state", "verbose_name": "home state" },
                            { "field_type": 2, "help_text": "", "name": "home_zip", "verbose_name": "home zip" },
                            { "field_type": 4, "help_text": "", "name": "country_id", "verbose_name": "country id" },
                            { "field_type": 2, "help_text": "", "name": "home_fed_house_district", "verbose_name": "home fed house district" },
                            { "field_type": 2, "help_text": "", "name": "home_state_senate_district", "verbose_name": "home state senate district" },
                            { "field_type": 2, "help_text": "", "name": "home_state_house_district", "verbose_name": "home state house district" },
                            { "field_type": 1, "help_text": "", "name": "has_email", "verbose_name": "has email" },
                            { "field_type": 2, "help_text": "", "name": "email", "verbose_name": "email" },
                            { "field_type": 2, "help_text": "", "name": "home_phone", "verbose_name": "home phone" },
                            { "field_type": 1, "help_text": "", "name": "has_fax", "verbose_name": "has fax" },
                            { "field_type": 2, "help_text": "", "name": "home_fax", "verbose_name": "home fax" },
                            { "field_type": 2, "help_text": "", "name": "mobile_phone", "verbose_name": "mobile phone" },
                            { "field_type": 4, "help_text": "", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_organization",
                                "related_model": { "__module__": "app.pac_classic.models.organization", "__name__": "PacClassicOrganization" },
                                "verbose_name": "pac classic organization"
                            },
                            { "field_type": 2, "help_text": "", "name": "pacc_organization_sort_name", "verbose_name": "pacc organization sort name" },
                            { "field_type": 1, "help_text": "", "name": "org_is_employer", "verbose_name": "org is employer" },
                            { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                            { "field_type": 2, "help_text": "", "name": "occupation", "verbose_name": "occupation" },
                            { "field_type": 2, "help_text": "", "name": "occupation_code", "verbose_name": "occupation code" },
                            { "field_type": 2, "help_text": "", "name": "occupation_code_co", "verbose_name": "occupation code co" },
                            { "field_type": 2, "help_text": "", "name": "occupation_code_md", "verbose_name": "occupation code md" },
                            { "field_type": 2, "help_text": "", "name": "nj_ind_occ", "verbose_name": "nj ind occ" },
                            { "field_type": 2, "help_text": "", "name": "wa_ind_occ", "verbose_name": "wa ind occ" },
                            { "field_type": 2, "help_text": "", "name": "employer_name", "verbose_name": "employer name" },
                            { "field_type": 2, "help_text": "", "name": "work_address_line_1", "verbose_name": "work address line 1" },
                            { "field_type": 2, "help_text": "", "name": "work_address_line_2", "verbose_name": "work address line 2" },
                            { "field_type": 2, "help_text": "", "name": "work_city", "verbose_name": "work city" },
                            { "field_type": 2, "help_text": "", "name": "work_state", "verbose_name": "work state" },
                            { "field_type": 2, "help_text": "", "name": "work_zip", "verbose_name": "work zip" },
                            { "field_type": 2, "help_text": "", "name": "work_email", "verbose_name": "work email" },
                            { "field_type": 2, "help_text": "", "name": "work_phone", "verbose_name": "work phone" },
                            { "field_type": 2, "help_text": "", "name": "work_fax", "verbose_name": "work fax" },
                            { "field_type": 2, "help_text": "", "name": "work_fed_house_district", "verbose_name": "work fed house district" },
                            { "field_type": 2, "help_text": "", "name": "work_state_senate_district", "verbose_name": "work state senate district" },
                            { "field_type": 2, "help_text": "", "name": "work_state_house_district", "verbose_name": "work state house district" },
                            { "field_type": 1, "help_text": "", "name": "facebook_can_post", "verbose_name": "facebook can post" },
                            { "field_type": 4, "help_text": "", "name": "facebook_object_id", "verbose_name": "facebook object id" },
                            { "field_type": 1, "help_text": "", "name": "has_facebook_url", "verbose_name": "has facebook url" },
                            { "field_type": 2, "help_text": "", "name": "facebook_url", "verbose_name": "facebook url" },
                            { "field_type": 1, "help_text": "", "name": "has_linkedin_url", "verbose_name": "has linkedin url" },
                            { "field_type": 2, "help_text": "", "name": "linkedin_url", "verbose_name": "linkedin url" },
                            { "field_type": 1, "help_text": "", "name": "has_twitter_username", "verbose_name": "has twitter username" },
                            { "field_type": 2, "help_text": "", "name": "twitter_user_name", "verbose_name": "twitter user name" },
                            { "field_type": 1, "help_text": "", "name": "has_website_url", "verbose_name": "has website url" },
                            { "field_type": 2, "help_text": "", "name": "website_url", "verbose_name": "website url" },
                            { "field_type": 1, "help_text": "", "name": "has_alert", "verbose_name": "has alert" },
                            { "field_type": 2, "help_text": "", "name": "alert_message", "verbose_name": "alert message" },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 1, "help_text": "", "name": "include_in_correspondence", "verbose_name": "include in correspondence" },
                            { "field_type": 1, "help_text": "", "name": "is_active", "verbose_name": "is active" },
                            { "field_type": 1, "help_text": "", "name": "is_profnet_individual", "verbose_name": "is profnet individual" },
                            { "field_type": 21, "help_text": "", "name": "last_imported", "verbose_name": "last imported" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 1, "help_text": "", "name": "is_peer2peer_manager", "verbose_name": "is peer2peer manager" },
                            { "field_type": 4, "help_text": "", "name": "peer2peer_campaign_id", "verbose_name": "peer2peer campaign id" },
                            { "field_type": 4, "help_text": "", "name": "peer2peer_manager_id", "verbose_name": "peer2peer manager id" },
                            { "field_type": 2, "help_text": "", "name": "peer2peer_manager_sort_name", "verbose_name": "peer2peer manager sort name" },
                            { "field_type": 3, "help_text": "", "name": "peer2peer_note", "verbose_name": "peer2peer note" },
                            { "field_type": 21, "help_text": "", "name": "signup_date", "verbose_name": "signup date" },
                            {
                                "field_type": 8,
                                "help_text": "The related supporter.",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            }
                        ]
                    }
                },
                "jurisdiction": {
                    "PacClassicPacJurisdiction": {
                        "__is_model": true,
                        "__name__": "PacClassicPacJurisdiction",
                        "data_model": "app.pac_classic.models.jurisdiction.PacClassicPacJurisdiction",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-jurisdiction/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_jurisdiction_id", "verbose_name": "pac jurisdiction id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_quorum_id",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "LedgerReportingJurisdiction" },
                                "verbose_name": "qpac v1 quorum id"
                            },
                            { "field_type": 2, "help_text": "", "name": "chairman_cars_id", "verbose_name": "chairman cars id" },
                            { "field_type": 2, "help_text": "", "name": "chairman_prefix", "verbose_name": "chairman prefix" },
                            { "field_type": 2, "help_text": "", "name": "chairman_first_name", "verbose_name": "chairman first name" },
                            { "field_type": 2, "help_text": "", "name": "chairman_last_name", "verbose_name": "chairman last name" },
                            { "field_type": 2, "help_text": "", "name": "chairman_suffix", "verbose_name": "chairman suffix" },
                            { "field_type": 2, "help_text": "", "name": "chairman_address_line_1", "verbose_name": "chairman address line 1" },
                            { "field_type": 2, "help_text": "", "name": "chairman_address_line_2", "verbose_name": "chairman address line 2" },
                            { "field_type": 2, "help_text": "", "name": "chairman_city", "verbose_name": "chairman city" },
                            { "field_type": 2, "help_text": "", "name": "chairman_state", "verbose_name": "chairman state" },
                            { "field_type": 2, "help_text": "", "name": "chairman_zip", "verbose_name": "chairman zip" },
                            { "field_type": 2, "help_text": "", "name": "chairman_employer", "verbose_name": "chairman employer" },
                            { "field_type": 2, "help_text": "", "name": "chairman_occupation", "verbose_name": "chairman occupation" },
                            { "field_type": 2, "help_text": "", "name": "chairman_phone", "verbose_name": "chairman phone" },
                            { "field_type": 2, "help_text": "", "name": "chairman_fax", "verbose_name": "chairman fax" },
                            { "field_type": 2, "help_text": "", "name": "chairman_email", "verbose_name": "chairman email" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_cars_id", "verbose_name": "treasurer cars id" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_prefix", "verbose_name": "treasurer prefix" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_first_name", "verbose_name": "treasurer first name" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_last_name", "verbose_name": "treasurer last name" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_suffix", "verbose_name": "treasurer suffix" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_address_line_1", "verbose_name": "treasurer address line 1" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_address_line_2", "verbose_name": "treasurer address line 2" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_city", "verbose_name": "treasurer city" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_state", "verbose_name": "treasurer state" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_zip", "verbose_name": "treasurer zip" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_employer", "verbose_name": "treasurer employer" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_occupation", "verbose_name": "treasurer occupation" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_phone", "verbose_name": "treasurer phone" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_fax", "verbose_name": "treasurer fax" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_email", "verbose_name": "treasurer email" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_address_line_1", "verbose_name": "treasurer secondary address line 1" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_address_line_2", "verbose_name": "treasurer secondary address line 2" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_city", "verbose_name": "treasurer secondary city" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_state", "verbose_name": "treasurer secondary state" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_zip", "verbose_name": "treasurer secondary zip" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_secondary_phone", "verbose_name": "treasurer secondary phone" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_cars_id", "verbose_name": "assistant treasurer cars id" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_prefix", "verbose_name": "assistant treasurer prefix" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_first_name", "verbose_name": "assistant treasurer first name" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_last_name", "verbose_name": "assistant treasurer last name" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_suffix", "verbose_name": "assistant treasurer suffix" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_address_line_1", "verbose_name": "assistant treasurer address line 1" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_address_line_2", "verbose_name": "assistant treasurer address line 2" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_city", "verbose_name": "assistant treasurer city" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_state", "verbose_name": "assistant treasurer state" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_zip", "verbose_name": "assistant treasurer zip" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_employer", "verbose_name": "assistant treasurer employer" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_occupation", "verbose_name": "assistant treasurer occupation" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_phone", "verbose_name": "assistant treasurer phone" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_fax", "verbose_name": "assistant treasurer fax" },
                            { "field_type": 2, "help_text": "", "name": "assistant_treasurer_email", "verbose_name": "assistant treasurer email" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_cars_id", "verbose_name": "bookkeeper cars id" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_prefix", "verbose_name": "bookkeeper prefix" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_first_name", "verbose_name": "bookkeeper first name" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_last_name", "verbose_name": "bookkeeper last name" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_suffix", "verbose_name": "bookkeeper suffix" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_address_line_1", "verbose_name": "bookkeeper address line 1" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_address_line_2", "verbose_name": "bookkeeper address line 2" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_city", "verbose_name": "bookkeeper city" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_state", "verbose_name": "bookkeeper state" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_zip", "verbose_name": "bookkeeper zip" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_employer", "verbose_name": "bookkeeper employer" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_occupation", "verbose_name": "bookkeeper occupation" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_phone", "verbose_name": "bookkeeper phone" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_fax", "verbose_name": "bookkeeper fax" },
                            { "field_type": 2, "help_text": "", "name": "bookkeeper_email", "verbose_name": "bookkeeper email" },
                            { "field_type": 2, "help_text": "", "name": "committee_purpose", "verbose_name": "committee purpose" },
                            { "field_type": 21, "help_text": "", "name": "date_appointed", "verbose_name": "date appointed" },
                            { "field_type": 21, "help_text": "", "name": "dissolution_date", "verbose_name": "dissolution date" },
                            { "field_type": 2, "help_text": "", "name": "efile_id", "verbose_name": "efile id" },
                            { "field_type": 2, "help_text": "", "name": "efile_password", "verbose_name": "efile password" },
                            { "field_type": 2, "help_text": "", "name": "electronic_signature", "verbose_name": "electronic signature" },
                            { "field_type": 2, "help_text": "", "name": "entity_key", "verbose_name": "entity key" },
                            { "field_type": 13, "help_text": "", "name": "fed_share", "verbose_name": "fed share" },
                            { "field_type": 2, "help_text": "", "name": "filer_id", "verbose_name": "filer id" },
                            { "field_type": 1, "help_text": "", "name": "is_broad_base", "verbose_name": "is broad base" },
                            { "field_type": 1, "help_text": "", "name": "is_cce", "verbose_name": "is cce" },
                            { "field_type": 1, "help_text": "", "name": "is_independent_committee", "verbose_name": "is independent committee" },
                            { "field_type": 1, "help_text": "", "name": "is_major_donor_pac", "verbose_name": "is major donor pac" },
                            { "field_type": 1, "help_text": "", "name": "is_multicandidate_committee", "verbose_name": "is multicandidate committee" },
                            { "field_type": 1, "help_text": "", "name": "is_ny_corp", "verbose_name": "is ny corp" },
                            { "field_type": 1, "help_text": "", "name": "is_parent", "verbose_name": "is parent" },
                            { "field_type": 1, "help_text": "", "name": "is_sponsoring_committee", "verbose_name": "is sponsoring committee" },
                            { "field_type": 1, "help_text": "", "name": "is_summarize_pr", "verbose_name": "is summarize pr" },
                            { "field_type": 1, "help_text": "", "name": "is_superpac", "verbose_name": "is superpac" },
                            { "field_type": 1, "help_text": "", "name": "is_wi_conduit", "verbose_name": "is wi conduit" },
                            { "field_type": 2, "help_text": "", "name": "juris", "verbose_name": "juris" },
                            { "field_type": 2, "help_text": "", "name": "nature_of_business", "verbose_name": "nature of business" },
                            { "field_type": 21, "help_text": "", "name": "registration_date", "verbose_name": "registration date" },
                            { "field_type": 21, "help_text": "", "name": "registration_amended_date", "verbose_name": "registration amended date" },
                            { "field_type": 2, "help_text": "", "name": "second_address_line1", "verbose_name": "second address line1" },
                            { "field_type": 2, "help_text": "", "name": "second_address_line2", "verbose_name": "second address line2" },
                            { "field_type": 2, "help_text": "", "name": "second_city", "verbose_name": "second city" },
                            { "field_type": 2, "help_text": "", "name": "second_state", "verbose_name": "second state" },
                            { "field_type": 2, "help_text": "", "name": "second_zip", "verbose_name": "second zip" },
                            { "field_type": 2, "help_text": "", "name": "second_county", "verbose_name": "second county" },
                            { "field_type": 2, "help_text": "", "name": "second_phone", "verbose_name": "second phone" },
                            { "field_type": 2, "help_text": "", "name": "second_fax", "verbose_name": "second fax" },
                            { "field_type": 2, "help_text": "", "name": "second_email", "verbose_name": "second email" },
                            { "field_type": 2, "help_text": "", "name": "sponsoring_organization_name", "verbose_name": "sponsoring organization name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicTransactionSortKey" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "transaction_sort_key",
                                "verbose_name": "transaction sort key"
                            }
                        ]
                    }
                },
                "legislator_committee": {
                    "PacClassicLegislatorCommitteeRelationship": {
                        "__is_model": true,
                        "__name__": "PacClassicLegislatorCommitteeRelationship",
                        "data_model": "app.pac_classic.models.legislator_committee.PacClassicLegislatorCommitteeRelationship",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/legislator-committee/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "legislator_committee_id", "verbose_name": "legislator committee id" },
                            { "field_type": 4, "help_text": "", "name": "legislator_id", "verbose_name": "legislator id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_legislator",
                                "related_model": { "__module__": "app.pac_classic.models.pac_classic_legislator", "__name__": "PacClassicLegislator" },
                                "verbose_name": "pac classic legislator"
                            },
                            { "field_type": 4, "help_text": "", "name": "committee_id", "verbose_name": "committee id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_committee",
                                "related_model": { "__module__": "app.pac_classic.models.committee", "__name__": "PacClassicLegislativeCommittee" },
                                "verbose_name": "pac classic committee"
                            },
                            { "field_type": 2, "help_text": "", "name": "position", "verbose_name": "position" },
                            { "field_type": 2, "help_text": "", "name": "major_minor", "verbose_name": "major minor" },
                            { "field_type": 2, "help_text": "", "name": "seat", "verbose_name": "seat" },
                            { "field_type": 2, "help_text": "", "name": "juris", "verbose_name": "juris" }
                        ]
                    }
                },
                "office": {
                    "PacClassicPacOffice": {
                        "__is_model": true,
                        "__name__": "PacClassicPacOffice",
                        "data_model": "app.pac_classic.models.office.PacClassicPacOffice",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-office/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_office_id", "verbose_name": "pac office id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            { "field_type": 2, "help_text": "", "name": "juris", "verbose_name": "juris" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" }
                        ]
                    }
                },
                "organization": {
                    "PacClassicOrganization": {
                        "__is_model": true,
                        "__name__": "PacClassicOrganization",
                        "data_model": "app.pac_classic.models.organization.PacClassicOrganization",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/organization/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "qpac v1 public organization"
                            },
                            { "field_type": 4, "help_text": "", "name": "organization_type_id", "verbose_name": "organization type id" },
                            { "field_type": 2, "help_text": "", "name": "external_id", "verbose_name": "external id" },
                            { "field_type": 2, "help_text": "", "name": "full_name", "verbose_name": "full name" },
                            { "field_type": 2, "help_text": "", "name": "sort_name", "verbose_name": "sort name" },
                            { "field_type": 2, "help_text": "", "name": "address_line_1", "verbose_name": "address line 1" },
                            { "field_type": 2, "help_text": "", "name": "address_line_2", "verbose_name": "address line 2" },
                            { "field_type": 2, "help_text": "", "name": "city", "verbose_name": "city" },
                            { "field_type": 2, "help_text": "", "name": "state", "verbose_name": "state" },
                            { "field_type": 2, "help_text": "", "name": "zip", "verbose_name": "zip" },
                            { "field_type": 4, "help_text": "", "name": "country_id", "verbose_name": "country id" },
                            { "field_type": 2, "help_text": "", "name": "address_1_fed_house_district", "verbose_name": "address 1 fed house district" },
                            { "field_type": 2, "help_text": "", "name": "address_1_state_senate_district", "verbose_name": "address 1 state senate district" },
                            { "field_type": 2, "help_text": "", "name": "address_1_state_house_district", "verbose_name": "address 1 state house district" },
                            { "field_type": 2, "help_text": "", "name": "phone", "verbose_name": "phone" },
                            { "field_type": 1, "help_text": "", "name": "has_fax", "verbose_name": "has fax" },
                            { "field_type": 2, "help_text": "", "name": "fax", "verbose_name": "fax" },
                            { "field_type": 1, "help_text": "", "name": "has_email", "verbose_name": "has email" },
                            { "field_type": 2, "help_text": "", "name": "email", "verbose_name": "email" },
                            { "field_type": 1, "help_text": "", "name": "is_parent", "verbose_name": "is parent" },
                            { "field_type": 1, "help_text": "", "name": "has_parent", "verbose_name": "has parent" },
                            { "field_type": 4, "help_text": "", "name": "organization_parent_id", "verbose_name": "organization parent id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "parent_organization",
                                "related_model": { "__module__": "app.pac_classic.models.organization", "__name__": "PacClassicOrganization" },
                                "verbose_name": "parent organization"
                            },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 1, "help_text": "", "name": "has_facebook_url", "verbose_name": "has facebook url" },
                            { "field_type": 2, "help_text": "", "name": "facebook_url", "verbose_name": "facebook url" },
                            { "field_type": 1, "help_text": "", "name": "has_twitter_username", "verbose_name": "has twitter username" },
                            { "field_type": 2, "help_text": "", "name": "twitter_username", "verbose_name": "twitter username" },
                            { "field_type": 1, "help_text": "", "name": "has_website_url", "verbose_name": "has website url" },
                            { "field_type": 2, "help_text": "", "name": "website", "verbose_name": "website" },
                            { "field_type": 1, "help_text": "", "name": "is_active", "verbose_name": "is active" },
                            { "field_type": 1, "help_text": "", "name": "is_employer", "verbose_name": "is employer" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredDeliveryType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_delivery_type",
                                "verbose_name": "preferred delivery type"
                            },
                            { "field_type": 13, "help_text": "", "name": "split_percentage", "verbose_name": "split percentage" }
                        ]
                    }
                },
                "pac": {
                    "PacClassicPac": {
                        "__is_model": true,
                        "__name__": "PacClassicPac",
                        "data_model": "app.pac_classic.models.pac.PacClassicPac",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 2, "help_text": "", "name": "acronym", "verbose_name": "acronym" },
                            { "field_type": 2, "help_text": "", "name": "pac_external_id", "verbose_name": "pac external id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_type",
                                "verbose_name": "pac type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSplitType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "split_type",
                                "verbose_name": "split type"
                            },
                            { "field_type": 2, "help_text": "", "name": "juris", "verbose_name": "juris" },
                            { "field_type": 2, "help_text": "", "name": "address_line_1", "verbose_name": "address line 1" },
                            { "field_type": 2, "help_text": "", "name": "address_line_2", "verbose_name": "address line 2" },
                            { "field_type": 2, "help_text": "", "name": "city", "verbose_name": "city" },
                            { "field_type": 2, "help_text": "", "name": "state", "verbose_name": "state" },
                            { "field_type": 2, "help_text": "", "name": "zip", "verbose_name": "zip" },
                            { "field_type": 2, "help_text": "", "name": "county", "verbose_name": "county" },
                            { "field_type": 2, "help_text": "", "name": "email", "verbose_name": "email" },
                            { "field_type": 2, "help_text": "", "name": "phone", "verbose_name": "phone" },
                            { "field_type": 2, "help_text": "", "name": "fax", "verbose_name": "fax" },
                            { "field_type": 2, "help_text": "", "name": "alternate_address_line_1", "verbose_name": "alternate address line 1" },
                            { "field_type": 2, "help_text": "", "name": "alternate_address_line_2", "verbose_name": "alternate address line 2" },
                            { "field_type": 2, "help_text": "", "name": "alternate_city", "verbose_name": "alternate city" },
                            { "field_type": 2, "help_text": "", "name": "alternate_state", "verbose_name": "alternate state" },
                            { "field_type": 2, "help_text": "", "name": "alternate_zip", "verbose_name": "alternate zip" },
                            { "field_type": 2, "help_text": "", "name": "default_pledge_payment_method", "verbose_name": "default pledge payment method" },
                            { "field_type": 2, "help_text": "", "name": "draw_percentage_from", "verbose_name": "draw percentage from" },
                            { "field_type": 2, "help_text": "", "name": "email_confirm_bcc", "verbose_name": "email confirm bcc" },
                            { "field_type": 3, "help_text": "", "name": "email_confirm_body", "verbose_name": "email confirm body" },
                            { "field_type": 2, "help_text": "", "name": "email_confirm_subject", "verbose_name": "email confirm subject" },
                            { "field_type": 3, "help_text": "", "name": "email_failed_body", "verbose_name": "email failed body" },
                            { "field_type": 1, "help_text": "", "name": "is_affiliated", "verbose_name": "is affiliated" },
                            { "field_type": 1, "help_text": "", "name": "is_all_individuals_are_members", "verbose_name": "is all individuals are members" },
                            { "field_type": 1, "help_text": "", "name": "is_all_pac_total", "verbose_name": "is all pac total" },
                            { "field_type": 1, "help_text": "", "name": "is_apply_pledge_payments_by_import", "verbose_name": "is apply pledge payments by import" },
                            { "field_type": 1, "help_text": "", "name": "is_force_budgets", "verbose_name": "is force budgets" },
                            { "field_type": 1, "help_text": "", "name": "is_has_dues", "verbose_name": "is has dues" },
                            { "field_type": 1, "help_text": "", "name": "is_has_gl_accounts", "verbose_name": "is has gl accounts" },
                            { "field_type": 1, "help_text": "", "name": "is_has_pledges", "verbose_name": "is has pledges" },
                            { "field_type": 1, "help_text": "", "name": "is_has_source", "verbose_name": "is has source" },
                            { "field_type": 1, "help_text": "", "name": "is_holding_pac", "verbose_name": "is holding pac" },
                            { "field_type": 1, "help_text": "", "name": "is_negative_balance_allowed", "verbose_name": "is negative balance allowed" },
                            { "field_type": 1, "help_text": "", "name": "is_nj_corp", "verbose_name": "is nj corp" },
                            { "field_type": 1, "help_text": "", "name": "is_no_over_budget_payments", "verbose_name": "is no over budget payments" },
                            { "field_type": 1, "help_text": "", "name": "is_pledge_warn", "verbose_name": "is pledge warn" },
                            { "field_type": 2, "help_text": "", "name": "label_pac_controlled_side", "verbose_name": "label pac controlled side" },
                            { "field_type": 2, "help_text": "", "name": "label_reserved_side", "verbose_name": "label reserved side" },
                            { "field_type": 13, "help_text": "", "name": "system_percentage", "verbose_name": "system percentage" }
                        ]
                    }
                },
                "pac_account": {
                    "PacClassicPacAccount": {
                        "__is_model": true,
                        "__name__": "PacClassicPacAccount",
                        "data_model": "app.pac_classic.models.pac_account.PacClassicPacAccount",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-account/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_account_id", "verbose_name": "pac account id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_qpac_pac_account",
                                "related_model": { "__module__": "app.pac.models.pacc_pac_account", "__name__": "PACCPACAccount" },
                                "verbose_name": "qpac v1 qpac pac account"
                            },
                            { "field_type": 4, "help_text": "", "name": "entity_id", "verbose_name": "entity id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicEntityType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "entity_type",
                                "verbose_name": "entity type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_individual",
                                "related_model": { "__module__": "app.pac_classic.models.individual", "__name__": "PacClassicIndividual" },
                                "verbose_name": "pac classic individual"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac_organization",
                                "related_model": { "__module__": "app.pac_classic.models.pac_organization", "__name__": "PacClassicPacOrganization" },
                                "verbose_name": "pac classic pac organization"
                            },
                            { "field_type": 6, "help_text": "", "name": "pac_account_balance", "verbose_name": "pac account balance" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacLimitType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_limit_type",
                                "verbose_name": "pac limit type"
                            },
                            { "field_type": 6, "help_text": "", "name": "pac_percentage", "verbose_name": "pac percentage" },
                            { "field_type": 6, "help_text": "", "name": "pac_pledge_last_amount", "verbose_name": "pac pledge last amount" },
                            { "field_type": 6, "help_text": "", "name": "pac_pledge_last_bill_amount", "verbose_name": "pac pledge last bill amount" },
                            { "field_type": 21, "help_text": "", "name": "pac_pledge_last_bill_date", "verbose_name": "pac pledge last bill date" },
                            { "field_type": 21, "help_text": "", "name": "pac_pledge_last_date", "verbose_name": "pac pledge last date" },
                            { "field_type": 6, "help_text": "", "name": "pac_pledge_last_payment_amount", "verbose_name": "pac pledge last payment amount" },
                            { "field_type": 21, "help_text": "", "name": "pac_pledge_last_payment_date", "verbose_name": "pac pledge last payment date" },
                            { "field_type": 6, "help_text": "", "name": "pac_pledge_remaining_amount", "verbose_name": "pac pledge remaining amount" },
                            { "field_type": 6, "help_text": "", "name": "pac_receipt_last_amount", "verbose_name": "pac receipt last amount" },
                            { "field_type": 21, "help_text": "", "name": "pac_receipt_last_date", "verbose_name": "pac receipt last date" },
                            { "field_type": 6, "help_text": "", "name": "pac_received_amount_lytd", "verbose_name": "pac received amount lytd" },
                            { "field_type": 6, "help_text": "", "name": "pac_received_amount_ytd", "verbose_name": "pac received amount ytd" },
                            { "field_type": 4, "help_text": "", "name": "pac_received_count_lytd", "verbose_name": "pac received count lytd" },
                            { "field_type": 4, "help_text": "", "name": "pac_received_count_ytd", "verbose_name": "pac received count ytd" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPayrollCycleType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "payroll_cycle",
                                "verbose_name": "payroll cycle"
                            },
                            { "field_type": 6, "help_text": "", "name": "payroll_deduction_amount", "verbose_name": "payroll deduction amount" }
                        ]
                    }
                },
                "pac_batch": {
                    "PacClassicPacBatch": {
                        "__is_model": true,
                        "__name__": "PacClassicPacBatch",
                        "data_model": "app.pac_classic.models.pac_batch.PacClassicPacBatch",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-batch/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_batch_id", "verbose_name": "pac batch id" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 2, "help_text": "", "name": "batch_type", "verbose_name": "batch type" },
                            { "field_type": 1, "help_text": "", "name": "is_batch_deposit", "verbose_name": "is batch deposit" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" }
                        ]
                    }
                },
                "pac_classic_legislator": {
                    "PacClassicLegislator": {
                        "__is_model": true,
                        "__name__": "PacClassicLegislator",
                        "data_model": "app.pac_classic.models.pac_classic_legislator.PacClassicLegislator",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-legislator/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "legislator_id", "verbose_name": "legislator id" },
                            { "field_type": 3, "help_text": "", "name": "jurisdiction_csd", "verbose_name": "jurisdiction csd" },
                            { "field_type": 3, "help_text": "", "name": "fedstate", "verbose_name": "fedstate" },
                            { "field_type": 3, "help_text": "", "name": "was_id", "verbose_name": "was id" },
                            { "field_type": 3, "help_text": "", "name": "chamber", "verbose_name": "chamber" },
                            { "field_type": 3, "help_text": "", "name": "state", "verbose_name": "state" },
                            { "field_type": 3, "help_text": "", "name": "district", "verbose_name": "district" },
                            { "field_type": 3, "help_text": "", "name": "district_name", "verbose_name": "district name" },
                            { "field_type": 3, "help_text": "", "name": "party", "verbose_name": "party" },
                            { "field_type": 3, "help_text": "", "name": "full_name", "verbose_name": "full name" },
                            { "field_type": 3, "help_text": "", "name": "sort_name", "verbose_name": "sort name" },
                            { "field_type": 3, "help_text": "", "name": "prefix", "verbose_name": "prefix" },
                            { "field_type": 3, "help_text": "", "name": "first_name", "verbose_name": "first name" },
                            { "field_type": 3, "help_text": "", "name": "middle_name", "verbose_name": "middle name" },
                            { "field_type": 3, "help_text": "", "name": "last_name", "verbose_name": "last name" },
                            { "field_type": 3, "help_text": "", "name": "suffix", "verbose_name": "suffix" },
                            { "field_type": 3, "help_text": "", "name": "nickname", "verbose_name": "nickname" },
                            { "field_type": 3, "help_text": "", "name": "title", "verbose_name": "title" },
                            { "field_type": 3, "help_text": "", "name": "leadership", "verbose_name": "leadership" },
                            { "field_type": 3, "help_text": "", "name": "building_name", "verbose_name": "building name" },
                            { "field_type": 3, "help_text": "", "name": "floor", "verbose_name": "floor" },
                            { "field_type": 3, "help_text": "", "name": "room", "verbose_name": "room" },
                            { "field_type": 3, "help_text": "", "name": "party_state_district", "verbose_name": "party state district" },
                            { "field_type": 3, "help_text": "", "name": "cap_phone", "verbose_name": "cap phone" },
                            { "field_type": 3, "help_text": "", "name": "cap_fax", "verbose_name": "cap fax" },
                            { "field_type": 3, "help_text": "", "name": "cap_email", "verbose_name": "cap email" },
                            { "field_type": 3, "help_text": "", "name": "cap_add1", "verbose_name": "cap add1" },
                            { "field_type": 3, "help_text": "", "name": "cap_city", "verbose_name": "cap city" },
                            { "field_type": 3, "help_text": "", "name": "cap_state", "verbose_name": "cap state" },
                            { "field_type": 3, "help_text": "", "name": "cap_zip", "verbose_name": "cap zip" },
                            { "field_type": 3, "help_text": "", "name": "dist1_add1", "verbose_name": "dist1 add1" },
                            { "field_type": 3, "help_text": "", "name": "dist1_add2", "verbose_name": "dist1 add2" },
                            { "field_type": 3, "help_text": "", "name": "dist1_add3", "verbose_name": "dist1 add3" },
                            { "field_type": 3, "help_text": "", "name": "dist1_phone", "verbose_name": "dist1 phone" },
                            { "field_type": 3, "help_text": "", "name": "dist2_add1", "verbose_name": "dist2 add1" },
                            { "field_type": 3, "help_text": "", "name": "dist2_add2", "verbose_name": "dist2 add2" },
                            { "field_type": 3, "help_text": "", "name": "dist2_add3", "verbose_name": "dist2 add3" },
                            { "field_type": 3, "help_text": "", "name": "dist2_phone", "verbose_name": "dist2 phone" },
                            { "field_type": 3, "help_text": "", "name": "dist3_add1", "verbose_name": "dist3 add1" },
                            { "field_type": 3, "help_text": "", "name": "dist3_add2", "verbose_name": "dist3 add2" },
                            { "field_type": 3, "help_text": "", "name": "dist3_add3", "verbose_name": "dist3 add3" },
                            { "field_type": 3, "help_text": "", "name": "dist3_phone", "verbose_name": "dist3 phone" },
                            { "field_type": 21, "help_text": "", "name": "birth_date", "verbose_name": "birth date" },
                            { "field_type": 3, "help_text": "", "name": "year_elect", "verbose_name": "year elect" },
                            { "field_type": 3, "help_text": "", "name": "reelect_year", "verbose_name": "reelect year" },
                            { "field_type": 3, "help_text": "", "name": "home_city", "verbose_name": "home city" },
                            { "field_type": 3, "help_text": "", "name": "ug_degree", "verbose_name": "ug degree" },
                            { "field_type": 3, "help_text": "", "name": "ug_institution", "verbose_name": "ug institution" },
                            { "field_type": 3, "help_text": "", "name": "grad_degree", "verbose_name": "grad degree" },
                            { "field_type": 3, "help_text": "", "name": "grad_institution", "verbose_name": "grad institution" },
                            { "field_type": 3, "help_text": "", "name": "profession", "verbose_name": "profession" },
                            { "field_type": 3, "help_text": "", "name": "religion", "verbose_name": "religion" },
                            { "field_type": 3, "help_text": "", "name": "gender", "verbose_name": "gender" },
                            { "field_type": 3, "help_text": "", "name": "marital_status", "verbose_name": "marital status" },
                            { "field_type": 3, "help_text": "", "name": "spouse_name", "verbose_name": "spouse name" },
                            { "field_type": 3, "help_text": "", "name": "birth_city", "verbose_name": "birth city" },
                            { "field_type": 3, "help_text": "", "name": "birth_state", "verbose_name": "birth state" },
                            { "field_type": 13, "help_text": "", "name": "lec_ind_receipts", "verbose_name": "lec ind receipts" },
                            { "field_type": 13, "help_text": "", "name": "lec_expenses", "verbose_name": "lec expenses" },
                            { "field_type": 13, "help_text": "", "name": "lec_pac_receipts", "verbose_name": "lec pac receipts" },
                            { "field_type": 3, "help_text": "", "name": "military_service", "verbose_name": "military service" },
                            { "field_type": 4, "help_text": "", "name": "children", "verbose_name": "children" },
                            { "field_type": 13, "help_text": "", "name": "vote_percentage", "verbose_name": "vote percentage" },
                            { "field_type": 3, "help_text": "", "name": "jurisdiction", "verbose_name": "jurisdiction" },
                            { "field_type": 3, "help_text": "", "name": "website", "verbose_name": "website" },
                            { "field_type": 3, "help_text": "", "name": "status", "verbose_name": "status" },
                            { "field_type": 3, "help_text": "", "name": "abbtitle", "verbose_name": "abbtitle" },
                            { "field_type": 1, "help_text": "", "name": "has_fax", "verbose_name": "has fax" },
                            { "field_type": 1, "help_text": "", "name": "has_email", "verbose_name": "has email" },
                            { "field_type": 1, "help_text": "", "name": "is_leader", "verbose_name": "is leader" },
                            { "field_type": 4, "help_text": "", "name": "birth_month", "verbose_name": "birth month" },
                            { "field_type": 1, "help_text": "", "name": "has_military_service", "verbose_name": "has military service" },
                            { "field_type": 3, "help_text": "", "name": "webmail_url", "verbose_name": "webmail url" },
                            { "field_type": 1, "help_text": "", "name": "is_challenger", "verbose_name": "is challenger" },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 21, "help_text": "", "name": "last_indexed_date", "verbose_name": "last indexed date" },
                            { "field_type": 1, "help_text": "", "name": "reindex", "verbose_name": "reindex" },
                            { "field_type": 1, "help_text": "", "name": "is_ldi", "verbose_name": "is ldi" },
                            { "field_type": 3, "help_text": "", "name": "ldi_org_name", "verbose_name": "ldi org name" },
                            { "field_type": 1, "help_text": "", "name": "show_in_ead", "verbose_name": "show in ead" },
                            { "field_type": 3, "help_text": "", "name": "municipal_code", "verbose_name": "municipal code" },
                            { "field_type": 3, "help_text": "", "name": "twitter_username", "verbose_name": "twitter username" },
                            { "field_type": 3, "help_text": "", "name": "facebook_url", "verbose_name": "facebook url" },
                            { "field_type": 1, "help_text": "", "name": "has_twitter_username", "verbose_name": "has twitter username" },
                            { "field_type": 1, "help_text": "", "name": "has_facebook_url", "verbose_name": "has facebook url" },
                            { "field_type": 3, "help_text": "", "name": "pacc_id", "verbose_name": "pacc id" }
                        ]
                    }
                },
                "pac_organization": {
                    "PacClassicPacOrganization": {
                        "__is_model": true,
                        "__name__": "PacClassicPacOrganization",
                        "data_model": "app.pac_classic.models.pac_organization.PacClassicPacOrganization",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-organization/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_organization_id", "verbose_name": "pac organization id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "qpac v1 public organization"
                            },
                            { "field_type": 2, "help_text": "", "name": "organization_name", "verbose_name": "organization name" },
                            { "field_type": 2, "help_text": "", "name": "sort_name", "verbose_name": "sort name" },
                            { "field_type": 2, "help_text": "", "name": "combined_sort_name", "verbose_name": "combined sort name" },
                            { "field_type": 2, "help_text": "", "name": "filer_id", "verbose_name": "filer id" },
                            { "field_type": 1, "help_text": "", "name": "is_active", "verbose_name": "is active" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacOrganizationType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_type",
                                "verbose_name": "pac type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacLimitType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_limit_type",
                                "verbose_name": "pac limit type"
                            },
                            { "field_type": 2, "help_text": "", "name": "nature_of_business", "verbose_name": "nature of business" },
                            { "field_type": 2, "help_text": "", "name": "az_commission_id", "verbose_name": "az commission id" },
                            { "field_type": 2, "help_text": "", "name": "delaware_id", "verbose_name": "delaware id" },
                            { "field_type": 2, "help_text": "", "name": "external_id", "verbose_name": "external id" },
                            { "field_type": 2, "help_text": "", "name": "iowa_id", "verbose_name": "iowa id" },
                            { "field_type": 1, "help_text": "", "name": "is_maryland_caucus_comm", "verbose_name": "is maryland caucus comm" },
                            { "field_type": 4, "help_text": "", "name": "minnesota_committee_id", "verbose_name": "minnesota committee id" },
                            { "field_type": 2, "help_text": "", "name": "oklahoma_id", "verbose_name": "oklahoma id" },
                            { "field_type": 2, "help_text": "", "name": "vermont_id", "verbose_name": "vermont id" },
                            { "field_type": 2, "help_text": "", "name": "wisconsin_gabid", "verbose_name": "wisconsin gabid" },
                            { "field_type": 2, "help_text": "", "name": "wyoming_source", "verbose_name": "wyoming source" },
                            { "field_type": 2, "help_text": "", "name": "address_line_1", "verbose_name": "address line 1" },
                            { "field_type": 2, "help_text": "", "name": "address_line_2", "verbose_name": "address line 2" },
                            { "field_type": 2, "help_text": "", "name": "city", "verbose_name": "city" },
                            { "field_type": 2, "help_text": "", "name": "state", "verbose_name": "state" },
                            { "field_type": 2, "help_text": "", "name": "zip", "verbose_name": "zip" },
                            { "field_type": 2, "help_text": "", "name": "country", "verbose_name": "country" },
                            { "field_type": 2, "help_text": "", "name": "county", "verbose_name": "county" },
                            { "field_type": 2, "help_text": "", "name": "phone", "verbose_name": "phone" },
                            { "field_type": 1, "help_text": "", "name": "has_fax", "verbose_name": "has fax" },
                            { "field_type": 2, "help_text": "", "name": "fax", "verbose_name": "fax" },
                            { "field_type": 1, "help_text": "", "name": "has_email", "verbose_name": "has email" },
                            { "field_type": 2, "help_text": "", "name": "email", "verbose_name": "email" },
                            { "field_type": 2, "help_text": "", "name": "website", "verbose_name": "website" },
                            { "field_type": 2, "help_text": "", "name": "candidate_id", "verbose_name": "candidate id" },
                            { "field_type": 2, "help_text": "", "name": "candidate_prefix", "verbose_name": "candidate prefix" },
                            { "field_type": 2, "help_text": "", "name": "candidate_first_name", "verbose_name": "candidate first name" },
                            { "field_type": 2, "help_text": "", "name": "candidate_middle_name", "verbose_name": "candidate middle name" },
                            { "field_type": 2, "help_text": "", "name": "candidate_last_name", "verbose_name": "candidate last name" },
                            { "field_type": 2, "help_text": "", "name": "candidate_suffix", "verbose_name": "candidate suffix" },
                            { "field_type": 2, "help_text": "", "name": "candidate_sort_name", "verbose_name": "candidate sort name" },
                            { "field_type": 4, "help_text": "", "name": "is_incumbent", "verbose_name": "is incumbent" },
                            { "field_type": 4, "help_text": "", "name": "legislator_id", "verbose_name": "legislator id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_legislator",
                                "related_model": { "__module__": "app.pac_classic.models.pac_classic_legislator", "__name__": "PacClassicLegislator" },
                                "verbose_name": "pac classic legislator"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicOfficeChamberType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "office_chamber",
                                "verbose_name": "office chamber"
                            },
                            { "field_type": 2, "help_text": "", "name": "office_district", "verbose_name": "office district" },
                            { "field_type": 2, "help_text": "", "name": "office_state", "verbose_name": "office state" },
                            { "field_type": 4, "help_text": "", "name": "pac_office_id", "verbose_name": "pac office id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "office",
                                "related_model": { "__module__": "app.pac_classic.models.office", "__name__": "PacClassicPacOffice" },
                                "verbose_name": "office"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPartyType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "party",
                                "verbose_name": "party"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPartyTypeType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "party_type",
                                "verbose_name": "party type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicContactType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "contact_type",
                                "verbose_name": "contact type"
                            },
                            { "field_type": 2, "help_text": "", "name": "dear", "verbose_name": "dear" },
                            { "field_type": 2, "help_text": "", "name": "prefix", "verbose_name": "prefix" },
                            { "field_type": 2, "help_text": "", "name": "first_name", "verbose_name": "first name" },
                            { "field_type": 2, "help_text": "", "name": "middle_name", "verbose_name": "middle name" },
                            { "field_type": 2, "help_text": "", "name": "last_name", "verbose_name": "last name" },
                            { "field_type": 2, "help_text": "", "name": "suffix", "verbose_name": "suffix" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicGenderType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "gender",
                                "verbose_name": "gender"
                            },
                            { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                            { "field_type": 1, "help_text": "", "name": "include_in_correspondence", "verbose_name": "include in correspondence" },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 21, "help_text": "", "name": "last_indexed_date", "verbose_name": "last indexed date" },
                            { "field_type": 1, "help_text": "", "name": "re_index", "verbose_name": "re index" },
                            { "field_type": 6, "help_text": "", "name": "limit_amount", "verbose_name": "limit amount" },
                            { "field_type": 4, "help_text": "", "name": "pac_jurisdiction_code_id", "verbose_name": "pac jurisdiction code id" },
                            { "field_type": 2, "help_text": "", "name": "pac_jurisdiction_description", "verbose_name": "pac jurisdiction description" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPreferredDeliveryType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "preferred_delivery_type",
                                "verbose_name": "preferred delivery type"
                            },
                            { "field_type": 2, "help_text": "", "name": "reelection_year", "verbose_name": "reelection year" },
                            { "field_type": 4, "help_text": "", "name": "related_pac_organization_pacc_id", "verbose_name": "related pac organization pacc id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "related_pac_organization",
                                "related_model": { "__module__": "app.pac_classic.models.pac_organization", "__name__": "PacClassicPacOrganization" },
                                "verbose_name": "related pac organization"
                            },
                            { "field_type": 2, "help_text": "", "name": "treasurer_prefix", "verbose_name": "treasurer prefix" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_first_name", "verbose_name": "treasurer first name" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_middle_name", "verbose_name": "treasurer middle name" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_last_name", "verbose_name": "treasurer last name" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_suffix", "verbose_name": "treasurer suffix" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_address_1", "verbose_name": "treasurer address 1" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_address_2", "verbose_name": "treasurer address 2" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_city", "verbose_name": "treasurer city" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_state", "verbose_name": "treasurer state" },
                            { "field_type": 2, "help_text": "", "name": "treasurer_zip", "verbose_name": "treasurer zip" }
                        ]
                    }
                },
                "pac_organization_note": {
                    "PacClassicPacOrganizationNote": {
                        "__is_model": true,
                        "__name__": "PacClassicPacOrganizationNote",
                        "data_model": "app.pac_classic.models.pac_organization_note.PacClassicPacOrganizationNote",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-organization-note/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_organization_id", "verbose_name": "pac organization id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac_organization",
                                "related_model": { "__module__": "app.pac_classic.models.pac_organization", "__name__": "PacClassicPacOrganization" },
                                "verbose_name": "pac classic pac organization"
                            },
                            { "field_type": 3, "help_text": "", "name": "note", "verbose_name": "note" }
                        ]
                    }
                },
                "site": {
                    "PacClassicSite": {
                        "__is_model": true,
                        "__name__": "PacClassicSite",
                        "data_model": "app.pac_classic.models.site.PacClassicSite",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/site/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            { "field_type": 4, "help_text": "", "name": "site_id", "verbose_name": "site id" },
                            { "field_type": 2, "help_text": "", "name": "url", "verbose_name": "url" },
                            { "field_type": 2, "help_text": "", "name": "site_tab_url", "verbose_name": "site tab url" },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" }
                        ]
                    }
                },
                "transaction": {
                    "PacClassicPacTransaction": {
                        "__is_model": true,
                        "__name__": "PacClassicPacTransaction",
                        "data_model": "app.pac_classic.models.transaction.PacClassicPacTransaction",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/pac/pac-transaction/",
                        "fields": [
                            { "field_type": 4, "help_text": "", "name": "id", "verbose_name": "id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "source_schema",
                                "verbose_name": "source schema"
                            },
                            { "field_type": 21, "help_text": "The date and time this record was created in the QUORUM database (via replication).", "name": "q_db_created", "verbose_name": "q db created" },
                            { "field_type": 21, "help_text": "The date and time this record was most recently UPDATED in the QUORUM database (via replication).", "name": "q_db_updated", "verbose_name": "q db updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "company",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "company"
                            },
                            { "field_type": 4, "help_text": "", "name": "version", "verbose_name": "version" },
                            { "field_type": 4, "help_text": "", "name": "pac_transaction_id", "verbose_name": "pac transaction id" },
                            { "field_type": 4, "help_text": "", "name": "pac_id", "verbose_name": "pac id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac",
                                "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                                "verbose_name": "pac classic pac"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "qpac_v1_qpac_transaction",
                                "related_model": { "__module__": "app.ledger.models", "__name__": "Transaction" },
                                "verbose_name": "qpac v1 qpac transaction"
                            },
                            { "field_type": 1, "help_text": "", "name": "is_parent", "verbose_name": "is parent" },
                            { "field_type": 4, "help_text": "", "name": "parent_pac_transaction_id", "verbose_name": "parent pac transaction id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "parent_transaction",
                                "related_model": { "__module__": "app.pac_classic.models.transaction", "__name__": "PacClassicPacTransaction" },
                                "verbose_name": "parent transaction"
                            },
                            { "field_type": 21, "help_text": "", "name": "creation_date", "verbose_name": "creation date" },
                            { "field_type": 21, "help_text": "", "name": "last_modified_date", "verbose_name": "last modified date" },
                            { "field_type": 4, "help_text": "", "name": "user_account_id", "verbose_name": "user account id" },
                            { "field_type": 21, "help_text": "", "name": "agent_date", "verbose_name": "agent date" },
                            { "field_type": 6, "help_text": "", "name": "amount", "verbose_name": "amount" },
                            { "field_type": 6, "help_text": "", "name": "search_amount", "verbose_name": "search amount" },
                            { "field_type": 6, "help_text": "", "name": "loan_interest_amount", "verbose_name": "loan interest amount" },
                            { "field_type": 6, "help_text": "", "name": "loan_principal_amount", "verbose_name": "loan principal amount" },
                            { "field_type": 6, "help_text": "", "name": "pac_side_amount", "verbose_name": "pac side amount" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacReportCode" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_report_code",
                                "verbose_name": "pac report code"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicPacReportCodeTransactionType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "pac_report_code_transaction_type",
                                "verbose_name": "pac report code transaction type"
                            },
                            { "field_type": 21, "help_text": "", "name": "raw_transaction_date", "verbose_name": "raw transaction date" },
                            { "field_type": 5, "help_text": "", "name": "transaction_date", "verbose_name": "transaction date" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicTransactionMethodType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "transaction_method",
                                "verbose_name": "transaction method"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicTransactionType" },
                                "field_type": 2,
                                "help_text": "",
                                "name": "transaction_type",
                                "verbose_name": "transaction type"
                            },
                            { "field_type": 4, "help_text": "", "name": "individual_pac_account_id", "verbose_name": "individual pac account id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_individual_pac_account",
                                "related_model": { "__module__": "app.pac_classic.models.pac_account", "__name__": "PacClassicPacAccount" },
                                "verbose_name": "pac classic individual pac account"
                            },
                            { "field_type": 6, "help_text": "", "name": "individual_pac_account_side_amount", "verbose_name": "individual pac account side amount" },
                            { "field_type": 1, "help_text": "", "name": "is_individual_on_check", "verbose_name": "is individual on check" },
                            { "field_type": 4, "help_text": "", "name": "pac_account_id", "verbose_name": "pac account id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac_account",
                                "related_model": { "__module__": "app.pac_classic.models.pac_account", "__name__": "PacClassicPacAccount" },
                                "verbose_name": "pac classic pac account"
                            },
                            { "field_type": 4, "help_text": "", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_organization",
                                "related_model": { "__module__": "app.pac_classic.models.organization", "__name__": "PacClassicOrganization" },
                                "verbose_name": "pac classic organization"
                            },
                            { "field_type": 1, "help_text": "", "name": "is_organization_on_check", "verbose_name": "is organization on check" },
                            { "field_type": 4, "help_text": "", "name": "election_id", "verbose_name": "election id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_election",
                                "related_model": { "__module__": "app.pac_classic.models.election", "__name__": "PacClassicElection" },
                                "verbose_name": "pac classic election"
                            },
                            { "field_type": 2, "help_text": "", "name": "memo_entry_description", "verbose_name": "memo entry description" },
                            { "field_type": 2, "help_text": "", "name": "internal_comment", "verbose_name": "internal comment" },
                            { "field_type": 2, "help_text": "", "name": "reference_number", "verbose_name": "reference number" },
                            { "field_type": 2, "help_text": "", "name": "report_description", "verbose_name": "report description" },
                            { "field_type": 4, "help_text": "", "name": "bank_account_id", "verbose_name": "bank account id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_bank_account",
                                "related_model": { "__module__": "app.pac_classic.models.bank_account", "__name__": "PacClassicBankAccount" },
                                "verbose_name": "pac classic bank account"
                            },
                            { "field_type": 1, "help_text": "", "name": "is_cleared", "verbose_name": "is cleared" },
                            { "field_type": 4, "help_text": "", "name": "bank_rec_id", "verbose_name": "bank rec id" },
                            { "field_type": 4, "help_text": "", "name": "pac_batch_id", "verbose_name": "pac batch id" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "pac_classic_pac_batch",
                                "related_model": { "__module__": "app.pac_classic.models.pac_batch", "__name__": "PacClassicPacBatch" },
                                "verbose_name": "pac classic pac batch"
                            },
                            { "field_type": 2, "help_text": "", "name": "credit_card_expire", "verbose_name": "credit card expire" },
                            { "field_type": 2, "help_text": "", "name": "credit_card_number", "verbose_name": "credit card number" },
                            { "field_type": 2, "help_text": "", "name": "credit_card_type", "verbose_name": "credit card type" },
                            { "field_type": 21, "help_text": "", "name": "dissemination_date", "verbose_name": "dissemination date" },
                            { "field_type": 1, "help_text": "", "name": "is_earmarked_receipt", "verbose_name": "is earmarked receipt" },
                            { "field_type": 1, "help_text": "", "name": "is_earmark_generated", "verbose_name": "is earmark generated" },
                            { "field_type": 4, "help_text": "", "name": "earmark_gl_account_id", "verbose_name": "earmark gl account id" },
                            { "field_type": 4, "help_text": "", "name": "earmark_pac_account_id", "verbose_name": "earmark pac account id" },
                            { "field_type": 4, "help_text": "", "name": "earmark_pac_budget_id", "verbose_name": "earmark pac budget id" },
                            { "field_type": 4, "help_text": "", "name": "earmark_pac_category_id", "verbose_name": "earmark pac category id" },
                            { "field_type": 4, "help_text": "", "name": "earmark_pac_election_id", "verbose_name": "earmark pac election id" },
                            { "field_type": 4, "help_text": "", "name": "earmark_pac_transaction_id", "verbose_name": "earmark pac transaction id" },
                            { "field_type": 2, "help_text": "", "name": "earmark_report_code_id", "verbose_name": "earmark report code id" },
                            { "field_type": 2, "help_text": "", "name": "earmark_report_description", "verbose_name": "earmark report description" },
                            { "field_type": 4, "help_text": "", "name": "pac_event_id", "verbose_name": "pac event id" },
                            { "field_type": 2, "help_text": "", "name": "event_name", "verbose_name": "event name" },
                            { "field_type": 6, "help_text": "", "name": "event_ytd_amount", "verbose_name": "event ytd amount" },
                            { "field_type": 13, "help_text": "", "name": "fed_share", "verbose_name": "fed share" },
                            { "field_type": 1, "help_text": "", "name": "is_computer_check", "verbose_name": "is computer check" },
                            { "field_type": 1, "help_text": "", "name": "is_dues", "verbose_name": "is dues" },
                            { "field_type": 1, "help_text": "", "name": "is_itemized", "verbose_name": "is itemized" },
                            { "field_type": 1, "help_text": "", "name": "is_memo_entry", "verbose_name": "is memo entry" },
                            { "field_type": 1, "help_text": "", "name": "is_no_limits", "verbose_name": "is no limits" },
                            { "field_type": 1, "help_text": "", "name": "is_redesignation", "verbose_name": "is redesignation" },
                            { "field_type": 1, "help_text": "", "name": "is_split_posted", "verbose_name": "is split posted" },
                            { "field_type": 1, "help_text": "", "name": "is_void", "verbose_name": "is void" },
                            { "field_type": 2, "help_text": "", "name": "limit_id", "verbose_name": "limit id" },
                            { "field_type": 4, "help_text": "", "name": "pac_category_id", "verbose_name": "pac category id" },
                            { "field_type": 4, "help_text": "", "name": "pac_expense_code_id", "verbose_name": "pac expense code id" },
                            { "field_type": 4, "help_text": "", "name": "pac_report_purpose_code_id_de", "verbose_name": "pac report purpose code id de" },
                            { "field_type": 4, "help_text": "", "name": "pac_expense_type_id_md", "verbose_name": "pac expense type id md" },
                            { "field_type": 4, "help_text": "", "name": "pac_report_purpose_code_id_md", "verbose_name": "pac report purpose code id md" },
                            { "field_type": 2, "help_text": "", "name": "nj_disb_purpose", "verbose_name": "nj disb purpose" },
                            { "field_type": 4, "help_text": "", "name": "pac_expense_type_id_nv", "verbose_name": "pac expense type id nv" },
                            { "field_type": 4, "help_text": "", "name": "pac_expense_type_id_vt", "verbose_name": "pac expense type id vt" },
                            { "field_type": 4, "help_text": "", "name": "pac_expense_type_id_wi", "verbose_name": "pac expense type id wi" },
                            { "field_type": 4, "help_text": "", "name": "pac_gl_account_id", "verbose_name": "pac gl account id" },
                            { "field_type": 4, "help_text": "", "name": "pac_master_budget_id", "verbose_name": "pac master budget id" },
                            { "field_type": 4, "help_text": "", "name": "pac_budget_id", "verbose_name": "pac budget id" },
                            { "field_type": 13, "help_text": "", "name": "pac_percentage", "verbose_name": "pac percentage" },
                            { "field_type": 4, "help_text": "", "name": "pac_pledge_id", "verbose_name": "pac pledge id" },
                            { "field_type": 4, "help_text": "", "name": "pac_schedule_h_event_id", "verbose_name": "pac schedule h event id" },
                            { "field_type": 4, "help_text": "", "name": "pac_source_id", "verbose_name": "pac source id" },
                            { "field_type": 4, "help_text": "", "name": "pac_split_id", "verbose_name": "pac split id" },
                            { "field_type": 4, "help_text": "", "name": "peer2peer_campaign_id", "verbose_name": "peer2peer campaign id" },
                            { "field_type": 4, "help_text": "", "name": "peer2peer_manager_id", "verbose_name": "peer2peer manager id" },
                            { "field_type": 2, "help_text": "", "name": "peer2peer_manager_sort_name", "verbose_name": "peer2peer manager sort name" },
                            { "field_type": 2, "help_text": "", "name": "pnref", "verbose_name": "pnref" },
                            { "field_type": 2, "help_text": "", "name": "support_oppose", "verbose_name": "support oppose" },
                            {
                                "field_type": 8,
                                "help_text": "The related grassroots supporter action.",
                                "name": "grassroots_supporter_action",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsSupporterAction" },
                                "verbose_name": "grassroots supporter action"
                            }
                        ]
                    }
                }
            },
            "types": {
                "DrawPercentageFromType": {
                    "__is_enum": true,
                    "individual": { "key": "individual", "label": "Individual", "value": "I" },
                    "organization": { "key": "organization", "label": "Organization", "value": "O" },
                    "system": { "key": "system", "label": "System", "value": "S" }
                },
                "PacClassicContactType": {
                    "__is_enum": true,
                    "cau": { "key": "cau", "label": "Caucus Committee", "value": "CAU" },
                    "cp": { "key": "cp", "label": "County Party", "value": "CP" },
                    "ldp": { "key": "ldp", "label": "Legislative District Party", "value": "LDP" },
                    "mp": { "key": "mp", "label": "Minor Party", "value": "MP" },
                    "sp": { "key": "sp", "label": "State Party", "value": "SP" }
                },
                "PacClassicDefaultCheckType": {
                    "__is_enum": true,
                    "computer": { "key": "computer", "label": "Computer", "value": "C" },
                    "manual": { "key": "manual", "label": "Manual", "value": "M" }
                },
                "PacClassicElectionType": {
                    "__is_enum": true,
                    "convention": { "key": "convention", "label": "Convention", "value": "C" },
                    "general": { "key": "general", "label": "General", "value": "G" },
                    "other": { "key": "other", "label": "Other", "value": "O" },
                    "primary": { "key": "primary", "label": "Primary", "value": "P" },
                    "primary_presidential": { "key": "primary_presidential", "label": "Primary Presidential", "value": "PT" },
                    "primary_runoff": { "key": "primary_runoff", "label": "Primary Runoff", "value": "PR" },
                    "recount": { "key": "recount", "label": "Recount", "value": "E" },
                    "runoff": { "key": "runoff", "label": "Runoff", "value": "R" },
                    "special_general": { "key": "special_general", "label": "Special General", "value": "S" },
                    "special_primary": { "key": "special_primary", "label": "Special Primary", "value": "1" },
                    "special_primary_runoff": { "key": "special_primary_runoff", "label": "Special Primary Runoff", "value": "1R" },
                    "special_runoff": { "key": "special_runoff", "label": "Special Runoff", "value": "SR" }
                },
                "PacClassicEntityType": {
                    "__is_enum": true,
                    "individual": { "key": "individual", "label": "Individual", "value": "I" },
                    "pac_organization": { "key": "pac_organization", "label": "PacOrganization", "value": "P" }
                },
                "PacClassicGenderType": {
                    "__is_enum": true,
                    "d": { "key": "d", "label": "TBD", "show_in_enumeration": false, "value": "D" },
                    "female": { "key": "female", "label": "Female", "show_in_enumeration": true, "value": "F" },
                    "female_lower": { "key": "female_lower", "label": "Female Lowercase", "show_in_enumeration": false, "value": "f" },
                    "male": { "key": "male", "label": "Male", "show_in_enumeration": true, "value": "M" },
                    "male_lower": { "key": "male_lower", "label": "Male Lowercase", "show_in_enumeration": false, "value": "m" },
                    "n": { "key": "n", "label": "TBD", "show_in_enumeration": false, "value": "N" },
                    "one": { "key": "one", "label": "TBD", "show_in_enumeration": false, "value": "1" },
                    "r": { "key": "r", "label": "TBD", "show_in_enumeration": false, "value": "R" },
                    "s": { "key": "s", "label": "TBD", "show_in_enumeration": false, "value": "S" },
                    "u": { "key": "u", "label": "TBD", "show_in_enumeration": false, "value": "U" }
                },
                "PacClassicLimitCycleType": {
                    "__is_enum": true,
                    "election": { "key": "election", "label": "Election Cycle", "value": "E" },
                    "year": { "key": "year", "label": "Year", "value": "Y" }
                },
                "PacClassicMetaTransactionType": {
                    "__is_enum": true,
                    "allocation": { "is_refund": false, "key": "allocation", "label": "Allocation", "normally_negative": true, "value": "A" },
                    "disbursement": { "is_refund": false, "key": "disbursement", "label": "Disbursement", "normally_negative": true, "value": "D" },
                    "disbursement_refund": { "is_refund": true, "key": "disbursement_refund", "label": "Disbursement Refund", "normally_negative": false, "value": "DR" },
                    "receipt": { "is_refund": false, "key": "receipt", "label": "Receipt", "normally_negative": false, "value": "R" },
                    "receipt_refund": { "is_refund": true, "key": "receipt_refund", "label": "Receipt Refund", "normally_negative": true, "value": "RR" },
                    "unknown": { "is_refund": false, "key": "unknown", "label": "Unknown", "normally_negative": false, "value": "U" }
                },
                "PacClassicOfficeChamberType": {
                    "__is_enum": true,
                    "capital_b": { "key": "capital_b", "label": "TBD", "show_in_enumeration": false, "value": "B" },
                    "capital_c": { "key": "capital_c", "label": "TBD", "show_in_enumeration": false, "value": "C" },
                    "capital_r": { "key": "capital_r", "label": "TBD", "show_in_enumeration": false, "value": "R" },
                    "county": { "key": "county", "label": "County", "show_in_enumeration": true, "value": "Y" },
                    "federal": { "key": "federal", "label": "Federal", "show_in_enumeration": true, "value": "F" },
                    "four": { "key": "four", "label": "TBD", "show_in_enumeration": false, "value": "4" },
                    "governor": { "key": "governor", "label": "Governor", "show_in_enumeration": true, "value": "G" },
                    "house": { "key": "house", "label": "House", "show_in_enumeration": true, "value": "H" },
                    "house_lowercase": { "key": "house_lowercase", "label": "House Lowercase", "show_in_enumeration": false, "value": "h" },
                    "lt_governor": { "key": "lt_governor", "label": "Lt. Governor", "show_in_enumeration": true, "value": "L" },
                    "municipal_city": { "key": "municipal_city", "label": "Municipal/City", "show_in_enumeration": true, "value": "M" },
                    "one": { "key": "one", "label": "TBD", "show_in_enumeration": false, "value": "1" },
                    "other": { "key": "other", "label": "Other", "show_in_enumeration": true, "value": "O" },
                    "president": { "key": "president", "label": "President", "show_in_enumeration": true, "value": "P" },
                    "private": { "key": "private", "label": "Private", "show_in_enumeration": false, "value": "X" },
                    "senate": { "key": "senate", "label": "Senate", "show_in_enumeration": true, "value": "S" },
                    "senate_lowercase": { "key": "senate_lowercase", "label": "Senate Lowercase", "show_in_enumeration": false, "value": "s" },
                    "state_attorney_general": { "key": "state_attorney_general", "label": "State Attorney General", "show_in_enumeration": true, "value": "A" },
                    "three": { "key": "three", "label": "TBD", "show_in_enumeration": false, "value": "3" },
                    "us_attorney_general": { "key": "us_attorney_general", "label": "US Attorney General", "show_in_enumeration": true, "value": "T" },
                    "vice_president": { "key": "vice_president", "label": "Vice President", "show_in_enumeration": true, "value": "V" },
                    "zero": { "key": "zero", "label": "TBD", "show_in_enumeration": false, "value": "0" }
                },
                "PacClassicPacLimitType": {
                    "Inc": { "is_individual": false, "is_pac": false, "key": "Inc", "label": "Inc", "show_in_enumeration": false, "takes_candidate": false, "value": "Inc" },
                    "Oth": { "is_individual": false, "is_pac": false, "key": "Oth", "label": "Oth", "show_in_enumeration": false, "takes_candidate": false, "value": "Oth" },
                    "__is_enum": true,
                    "anonymous": { "is_individual": false, "is_pac": false, "key": "anonymous", "label": "Anonymous", "show_in_enumeration": true, "takes_candidate": false, "value": "ANO" },
                    "ballot_measure_committee": { "is_individual": false, "is_pac": true, "key": "ballot_measure_committee", "label": "Ballot Measure Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "BAL" },
                    "bank": { "is_individual": false, "is_pac": false, "key": "bank", "label": "Bank", "show_in_enumeration": true, "takes_candidate": false, "value": "BNK" },
                    "can": { "is_individual": false, "is_pac": false, "key": "can", "label": "Can", "show_in_enumeration": false, "takes_candidate": false, "value": "Can" },
                    "che": { "is_individual": false, "is_pac": false, "key": "che", "label": "Che", "show_in_enumeration": false, "takes_candidate": false, "value": "Che" },
                    "cit": { "is_individual": false, "is_pac": false, "key": "cit", "label": "Cit", "show_in_enumeration": false, "takes_candidate": false, "value": "Cit" },
                    "cor": { "is_individual": false, "is_pac": false, "key": "cor", "label": "COR", "show_in_enumeration": false, "takes_candidate": false, "value": "COR" },
                    "corporation": { "is_individual": false, "is_pac": false, "key": "corporation", "label": "Corporate Entity", "show_in_enumeration": true, "takes_candidate": false, "value": "INC" },
                    "eandm": { "is_individual": false, "is_pac": false, "key": "eandm", "label": "E&M", "show_in_enumeration": false, "takes_candidate": false, "value": "E&M" },
                    "fdf": { "is_individual": false, "is_pac": false, "key": "fdf", "label": "FDF", "show_in_enumeration": false, "takes_candidate": false, "value": "FDF" },
                    "federal_candidate_committee": { "is_individual": false, "is_pac": true, "key": "federal_candidate_committee", "label": "Federal Candidate Committee", "show_in_enumeration": true, "takes_candidate": true, "value": "FCC" },
                    "federal_pac_ssf": { "is_individual": false, "is_pac": true, "key": "federal_pac_ssf", "label": "Federal PAC / SSF", "show_in_enumeration": true, "takes_candidate": false, "value": "FSF" },
                    "fsf": { "is_individual": false, "is_pac": false, "key": "fsf", "label": "Fsf", "show_in_enumeration": false, "takes_candidate": false, "value": "Fsf" },
                    "hel": { "is_individual": false, "is_pac": false, "key": "hel", "label": "Hel", "show_in_enumeration": false, "takes_candidate": false, "value": "Hel" },
                    "i": { "is_individual": false, "is_pac": false, "key": "i", "label": "I", "show_in_enumeration": false, "takes_candidate": false, "value": "I" },
                    "inc": { "is_individual": false, "is_pac": false, "key": "inc", "label": "inc", "show_in_enumeration": false, "takes_candidate": false, "value": "inc" },
                    "incidental_committee": { "is_individual": false, "is_pac": true, "key": "incidental_committee", "label": "Incidental Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "ICM" },
                    "individual": { "is_individual": true, "is_pac": false, "key": "individual", "label": "Individual", "show_in_enumeration": true, "takes_candidate": false, "value": "IND" },
                    "jfc": { "is_individual": false, "is_pac": true, "key": "jfc", "label": "Joint Fundraising Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "JFC" },
                    "labor_union": { "is_individual": false, "is_pac": false, "key": "labor_union", "label": "Labor Union", "show_in_enumeration": true, "takes_candidate": false, "value": "LAB" },
                    "lim": { "is_individual": false, "is_pac": false, "key": "lim", "label": "Lim", "show_in_enumeration": false, "takes_candidate": false, "value": "Lim" },
                    "llc": { "is_individual": false, "is_pac": false, "key": "llc", "label": "Limited Liability Corporation", "show_in_enumeration": true, "takes_candidate": false, "value": "LLC" },
                    "llp": { "is_individual": false, "is_pac": false, "key": "llp", "label": "Limited Liability Partnership", "show_in_enumeration": true, "takes_candidate": false, "value": "LLP" },
                    "local_candidate_committee": { "is_individual": false, "is_pac": true, "key": "local_candidate_committee", "label": "Local Candidate Committee", "show_in_enumeration": true, "takes_candidate": true, "value": "LCC" },
                    "local_party_committee": { "is_individual": false, "is_pac": true, "key": "local_party_committee", "label": "Local Party Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "LPC" },
                    "lpn": { "is_individual": false, "is_pac": false, "key": "lpn", "label": "LPN", "show_in_enumeration": false, "takes_candidate": false, "value": "LPN" },
                    "national_party_committee": { "is_individual": false, "is_pac": true, "key": "national_party_committee", "label": "National Party Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "NPC" },
                    "nul": { "is_individual": false, "is_pac": false, "key": "nul", "label": "NUL", "show_in_enumeration": false, "takes_candidate": false, "value": "NUL" },
                    "one_forty_one": { "is_individual": false, "is_pac": false, "key": "one_forty_one", "label": "141", "show_in_enumeration": false, "takes_candidate": false, "value": "141" },
                    "oth": { "is_individual": false, "is_pac": false, "key": "oth", "label": "oth", "show_in_enumeration": false, "takes_candidate": false, "value": "oth" },
                    "othOth": { "is_individual": false, "is_pac": false, "key": "othOth", "label": "othOth", "show_in_enumeration": false, "takes_candidate": false, "value": "othOth" },
                    "other": { "is_individual": false, "is_pac": false, "key": "other", "label": "Other", "show_in_enumeration": true, "takes_candidate": false, "value": "OTH" },
                    "parent_entity": { "is_individual": false, "is_pac": false, "key": "parent_entity", "label": "Parent Entity", "show_in_enumeration": true, "takes_candidate": false, "value": "PAR" },
                    "partnership": { "is_individual": false, "is_pac": false, "key": "partnership", "label": "Partnership", "show_in_enumeration": true, "takes_candidate": false, "value": "SHP" },
                    "pie": { "is_individual": false, "is_pac": false, "key": "pie", "label": "Pie", "show_in_enumeration": false, "takes_candidate": false, "value": "Pie" },
                    "rep": { "is_individual": false, "is_pac": false, "key": "rep", "label": "Rep", "show_in_enumeration": false, "takes_candidate": false, "value": "Rep" },
                    "rov": { "is_individual": false, "is_pac": false, "key": "rov", "label": "Rov", "show_in_enumeration": false, "takes_candidate": false, "value": "Rov" },
                    "rup": { "is_individual": false, "is_pac": false, "key": "rup", "label": "Rup", "show_in_enumeration": false, "takes_candidate": false, "value": "Rup" },
                    "sc": { "is_individual": false, "is_pac": false, "key": "sc", "label": "SC", "show_in_enumeration": false, "takes_candidate": false, "value": "SC" },
                    "scs": { "is_individual": false, "is_pac": false, "key": "scs", "label": "SCS", "show_in_enumeration": false, "takes_candidate": false, "value": "SCS" },
                    "sen": { "is_individual": false, "is_pac": false, "key": "sen", "label": "Sen", "show_in_enumeration": false, "takes_candidate": false, "value": "Sen" },
                    "sfs": { "is_individual": false, "is_pac": false, "key": "sfs", "label": "SFS", "show_in_enumeration": false, "takes_candidate": false, "value": "SFS" },
                    "sole_proprietorship": { "is_individual": false, "is_pac": false, "key": "sole_proprietorship", "label": "Sole Proprietorship", "show_in_enumeration": true, "takes_candidate": false, "value": "SOL" },
                    "state_candidate_committee": { "is_individual": false, "is_pac": true, "key": "state_candidate_committee", "label": "State Candidate Committee", "show_in_enumeration": true, "takes_candidate": true, "value": "SCC" },
                    "state_pac_ssf": { "is_individual": false, "is_pac": true, "key": "state_pac_ssf", "label": "State PAC / SSF", "show_in_enumeration": true, "takes_candidate": false, "value": "SSF" },
                    "state_party_committee": { "is_individual": false, "is_pac": true, "key": "state_party_committee", "label": "State Party Committee", "show_in_enumeration": true, "takes_candidate": false, "value": "SPC" },
                    "state_party_committee_fed_acct": { "is_individual": false, "is_pac": true, "key": "state_party_committee_fed_acct", "label": "State Party Committee Federal Account", "show_in_enumeration": true, "takes_candidate": false, "value": "SPF" },
                    "thi": { "is_individual": false, "is_pac": false, "key": "thi", "label": "Thi", "show_in_enumeration": false, "takes_candidate": false, "value": "Thi" },
                    "thirty_31": { "is_individual": false, "is_pac": false, "key": "thirty_31", "label": "31", "show_in_enumeration": false, "takes_candidate": false, "value": "31" },
                    "twenty_six_dash": { "is_individual": false, "is_pac": false, "key": "twenty_six_dash", "label": "26-", "show_in_enumeration": false, "takes_candidate": false, "value": "26-" },
                    "typ": { "is_individual": false, "is_pac": false, "key": "typ", "label": "Typ", "show_in_enumeration": false, "takes_candidate": false, "value": "Typ" },
                    "vendor": { "is_individual": false, "is_pac": false, "key": "vendor", "label": "Vendor", "show_in_enumeration": true, "takes_candidate": false, "value": "VEN" },
                    "vnd": { "is_individual": false, "is_pac": false, "key": "vnd", "label": "VND", "show_in_enumeration": false, "takes_candidate": false, "value": "VND" },
                    "y": { "is_individual": false, "is_pac": false, "key": "y", "label": "Y", "show_in_enumeration": false, "takes_candidate": false, "value": "Y" },
                    "zero": { "is_individual": false, "is_pac": false, "key": "zero", "label": "0", "show_in_enumeration": false, "takes_candidate": false, "value": "0" },
                    "zeroth": { "is_individual": false, "is_pac": false, "key": "zeroth", "label": "0TH", "show_in_enumeration": false, "takes_candidate": false, "value": "0TH" }
                },
                "PacClassicPacOrganizationType": {
                    "__is_enum": true,
                    "cpc": { "key": "cpc", "label": "Caucus Committee", "value": "CPC" },
                    "ipc": { "key": "ipc", "label": "Independent Committee", "value": "IPC" },
                    "pac": { "key": "pac", "label": "Political Committee", "value": "PAC" }
                },
                "PacClassicPacReportCode": {
                    "__is_enum": true,
                    "anonymous_contributions": {
                        "generally_valid_limit_types": ["ANO"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "anonymous_contributions",
                        "label": "Anonymous Contributions",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "109"
                    },
                    "b": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "b",
                        "label": "B",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "B"
                    },
                    "bank_interest_received": {
                        "generally_valid_limit_types": ["BNK"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "bank_interest_received",
                        "label": "Bank Interest Received",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "160"
                    },
                    "deposit": {
                        "generally_valid_limit_types": ["BNK"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "deposit",
                        "label": "Deposit",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "270"
                    },
                    "disbursements_to_ballot_measure_committees": {
                        "generally_valid_limit_types": ["BAL"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_ballot_measure_committees",
                        "key": "disbursements_to_ballot_measure_committees",
                        "label": "Contributions to Ballot Measure Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "210"
                    },
                    "disbursements_to_federal_candidates": {
                        "generally_valid_limit_types": ["FCC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_federal_candidates",
                        "key": "disbursements_to_federal_candidates",
                        "label": "Contributions to Federal Candidates",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "201"
                    },
                    "disbursements_to_federal_pacs": {
                        "generally_valid_limit_types": ["FSF"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_federal_pacs",
                        "key": "disbursements_to_federal_pacs",
                        "label": "Contributions to Federal PACs",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "204"
                    },
                    "disbursements_to_joint_fundraising_committees": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_joint_fundraising_committees",
                        "key": "disbursements_to_joint_fundraising_committees",
                        "label": "Contributions to Joint Fundraising Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "261"
                    },
                    "disbursements_to_local_candidates": {
                        "generally_valid_limit_types": ["LCC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_local_candidates",
                        "key": "disbursements_to_local_candidates",
                        "label": "Contributions to Local Candidates",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "203"
                    },
                    "disbursements_to_local_party_committees": {
                        "generally_valid_limit_types": ["LPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_local_party_committees",
                        "key": "disbursements_to_local_party_committees",
                        "label": "Contributions to Local Party Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "208"
                    },
                    "disbursements_to_national_party_committees": {
                        "generally_valid_limit_types": ["NPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_national_party_committees",
                        "key": "disbursements_to_national_party_committees",
                        "label": "Contributions to National Party Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "206"
                    },
                    "disbursements_to_state_candidates": {
                        "generally_valid_limit_types": ["SCC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_state_candidates",
                        "key": "disbursements_to_state_candidates",
                        "label": "Contributions to State Candidates",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "202"
                    },
                    "disbursements_to_state_pacs": {
                        "generally_valid_limit_types": ["SSF"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_state_pacs",
                        "key": "disbursements_to_state_pacs",
                        "label": "Contributions to State PACs",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "205"
                    },
                    "disbursements_to_state_party_committees": {
                        "generally_valid_limit_types": ["SPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_disbursements_to_state_party_committees",
                        "key": "disbursements_to_state_party_committees",
                        "label": "Contributions to State Party Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "207"
                    },
                    "fifty_four": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "fifty_four",
                        "label": "54",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "54"
                    },
                    "fifty_three": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "fifty_three",
                        "label": "53",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "53"
                    },
                    "independent_expenditures": {
                        "generally_valid_limit_types": ["VEN"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "independent_expenditures",
                        "label": "Independent Expenditures",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "240"
                    },
                    "inkind_contributions_non_monetary": {
                        "generally_valid_limit_types": ["INC"],
                        "generally_valid_refund_report_code_key": "refunds_of_inkind_contributions_non_monetary",
                        "key": "inkind_contributions_non_monetary",
                        "label": "Inkind Contributions (Non-Monetary)",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "209"
                    },
                    "inkind_receipts_non_monetary": {
                        "generally_valid_limit_types": ["VEN", "BNK", "INC"],
                        "generally_valid_refund_report_code_key": "refunds_of_inkind_receipts_non_monetary",
                        "key": "inkind_receipts_non_monetary",
                        "label": "Inkind Receipts (Non-Monetary)",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "108"
                    },
                    "irs_527_disbursement": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "irs_527_disbursement",
                        "label": "IRS 527 Disbursement",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "298"
                    },
                    "irs_527_receipt": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "irs_527_receipt",
                        "label": "IRS 527 Receipt",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "198"
                    },
                    "joint_federal_non_federal_expenditures": {
                        "generally_valid_limit_types": ["SPF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "joint_federal_non_federal_expenditures",
                        "label": "Joint Federal / Non-Federal Expenditures",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "280"
                    },
                    "joint_non_federal_share": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "joint_non_federal_share",
                        "label": "Joint - Non Federal Share",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "281"
                    },
                    "lab": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "lab",
                        "label": "LAB",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "LAB"
                    },
                    "loan_repayments_made": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "loan_repayments_made",
                        "label": "Loan Repayments Made",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "251"
                    },
                    "loan_repayments_received": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "loan_repayments_received",
                        "label": "Loan Repayments Received",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "151"
                    },
                    "loans_made": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "loans_made",
                        "label": "Loans Made",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "250"
                    },
                    "loans_received": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "loans_received",
                        "label": "Loans Received",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "150"
                    },
                    "mon": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "mon",
                        "label": "Mon",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "Mon"
                    },
                    "non_aggregated_receipt": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "non_aggregated_receipt",
                        "label": "Non Aggregated Receipt",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "197"
                    },
                    "non_reporting_disbursement": {
                        "generally_valid_limit_types": ["any"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "non_reporting_disbursement",
                        "label": "Non Reporting Disbursement",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "299"
                    },
                    "non_reporting_receipt": {
                        "generally_valid_limit_types": ["any"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "non_reporting_receipt",
                        "label": "Non Reporting Receipt",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "199"
                    },
                    "ob": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "ob",
                        "label": "OB",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "OB"
                    },
                    "off": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "off",
                        "label": "Off",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "Off"
                    },
                    "oth": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "oth",
                        "label": "Oth",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "Oth"
                    },
                    "other_disbursements": {
                        "generally_valid_limit_types": ["any"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "other_disbursements",
                        "label": "Other Disbursements",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "290"
                    },
                    "other_federal_operating_expenditures": {
                        "generally_valid_limit_types": ["VEN"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "other_federal_operating_expenditures",
                        "label": "Other Federal Operating Expenditures",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "291"
                    },
                    "other_receipt": {
                        "generally_valid_limit_types": ["any"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "other_receipt",
                        "label": "Other Receipt",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "190"
                    },
                    "other_refunds": {
                        "generally_valid_limit_types": ["OTH", "VEN"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "other_refunds",
                        "label": "Other Refunds",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "120"
                    },
                    "other_surplus_funds_paid_out": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "other_surplus_funds_paid_out",
                        "label": "Other Surplus Funds Paid Out",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "292"
                    },
                    "purchase_of_stock_or_cd": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "purchase_of_stock_or_cd",
                        "label": "Purchase of Stock or CD",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "255"
                    },
                    "receipts_from_corporations": {
                        "generally_valid_limit_types": ["INC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_corporations",
                        "key": "receipts_from_corporations",
                        "label": "Contributions from Corporations",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "104"
                    },
                    "receipts_from_federal_pacs": {
                        "generally_valid_limit_types": ["FSF"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_federal_pacs",
                        "key": "receipts_from_federal_pacs",
                        "label": "Contributions from Federal PACs",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "102"
                    },
                    "receipts_from_fundraisers": {
                        "generally_valid_limit_types": ["JFC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "receipts_from_fundraisers",
                        "label": "Receipts from Fundraisers",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "191"
                    },
                    "receipts_from_individuals": {
                        "generally_valid_limit_types": ["IND"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_individuals",
                        "key": "receipts_from_individuals",
                        "label": "Contributions from Individuals",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "101"
                    },
                    "receipts_from_labor_unions": {
                        "generally_valid_limit_types": ["LAB"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_labor_organizations",
                        "key": "receipts_from_labor_unions",
                        "label": "Contributions from Labor Unions",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "110"
                    },
                    "receipts_from_llcs": {
                        "generally_valid_limit_types": ["LLC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_llcs",
                        "key": "receipts_from_llcs",
                        "label": "Contributions from Limited Liability Corporations",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "112"
                    },
                    "receipts_from_llps": {
                        "generally_valid_limit_types": ["LLP"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_llps",
                        "key": "receipts_from_llps",
                        "label": "Contributions from Limited Liability Partnerships",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "113"
                    },
                    "receipts_from_local_party_committees": {
                        "generally_valid_limit_types": ["LPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_local_party_committees",
                        "key": "receipts_from_local_party_committees",
                        "label": "Contributions from Local Party Committees",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "107"
                    },
                    "receipts_from_national_party_committees": {
                        "generally_valid_limit_types": ["NPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_national_party_committees",
                        "key": "receipts_from_national_party_committees",
                        "label": "Contributions from National Party Committees",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "105"
                    },
                    "receipts_from_other_political_committees": {
                        "generally_valid_limit_types": ["FSF", "SSF"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_other_political_committees",
                        "key": "receipts_from_other_political_committees",
                        "label": "Contributions from Other Political Committees",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "115"
                    },
                    "receipts_from_partnerships": {
                        "generally_valid_limit_types": ["SHP"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_partnerships",
                        "key": "receipts_from_partnerships",
                        "label": "Contributions from Partnerships",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "111"
                    },
                    "receipts_from_political_clubs": {
                        "generally_valid_limit_types": ["OTH"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "receipts_from_political_clubs",
                        "label": "Contributions from Political Clubs",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "192"
                    },
                    "receipts_from_sole_proprietorships": {
                        "generally_valid_limit_types": ["SOL"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_sole_proprietorships",
                        "key": "receipts_from_sole_proprietorships",
                        "label": "Contributions from Sole Proprietorships",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "114"
                    },
                    "receipts_from_state_pacs": {
                        "generally_valid_limit_types": ["SCC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_state_pacs",
                        "key": "receipts_from_state_pacs",
                        "label": "Contributions from State PACs",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "103"
                    },
                    "receipts_from_state_party_committees": {
                        "generally_valid_limit_types": ["SPC"],
                        "generally_valid_refund_report_code_key": "refunds_of_receipts_from_state_party_committees",
                        "key": "receipts_from_state_party_committees",
                        "label": "Contributions from State Party Committees",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "106"
                    },
                    "refund_of_deposit": {
                        "generally_valid_limit_types": ["BNK"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refund_of_deposit",
                        "label": "Refund of Deposit",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "180"
                    },
                    "refunds_of_disbursements_to_ballot_measure_committees": {
                        "generally_valid_limit_types": ["BAL"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_ballot_measure_committees",
                        "label": "Refunds of Contributions to Ballot Measure Committees",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "182"
                    },
                    "refunds_of_disbursements_to_federal_candidates": {
                        "generally_valid_limit_types": ["FCC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_federal_candidates",
                        "label": "Refunds of Contributions to Federal Candidates",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "121"
                    },
                    "refunds_of_disbursements_to_federal_pacs": {
                        "generally_valid_limit_types": ["FSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_federal_pacs",
                        "label": "Refunds of Contributions to Federal PACs",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "124"
                    },
                    "refunds_of_disbursements_to_joint_fundraising_committees": {
                        "generally_valid_limit_types": ["JFC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_joint_fundraising_committees",
                        "label": "Refunds of Contributions to Joint Fundraising Committees",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "161"
                    },
                    "refunds_of_disbursements_to_local_candidates": {
                        "generally_valid_limit_types": ["LCC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_local_candidates",
                        "label": "Refunds of Contributions to Local Candidates",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "123"
                    },
                    "refunds_of_disbursements_to_local_party_committees": {
                        "generally_valid_limit_types": ["LPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_local_party_committees",
                        "label": "Refunds of Contributions to Local Party Committees",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "128"
                    },
                    "refunds_of_disbursements_to_national_party_committees": {
                        "generally_valid_limit_types": ["NPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_national_party_committees",
                        "label": "Refunds of Contributions to National Party Committees",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "126"
                    },
                    "refunds_of_disbursements_to_state_candidates": {
                        "generally_valid_limit_types": ["SCC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_state_candidates",
                        "label": "Refunds of Contributions to State Candidates",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "122"
                    },
                    "refunds_of_disbursements_to_state_pacs": {
                        "generally_valid_limit_types": ["SSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_state_pacs",
                        "label": "Refunds of Contributions to State PACs",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "125"
                    },
                    "refunds_of_disbursements_to_state_party_committees": {
                        "generally_valid_limit_types": ["SPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_disbursements_to_state_party_committees",
                        "label": "Refunds of Contributions to State Party Committees",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "127"
                    },
                    "refunds_of_inkind_contributions_non_monetary": {
                        "generally_valid_limit_types": ["VEN", "BNK", "INC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_inkind_contributions_non_monetary",
                        "label": "Refunds of Inkind Contributions (Non-Monetary)",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "129"
                    },
                    "refunds_of_inkind_receipts_non_monetary": {
                        "generally_valid_limit_types": ["INC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_inkind_receipts_non_monetary",
                        "label": "Refunds of Inkind Receipts (Non-Monetary)",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "218"
                    },
                    "refunds_of_receipts_from_corporations": {
                        "generally_valid_limit_types": ["INC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_corporations",
                        "label": "Refunds of Contributions from Corporations",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "214"
                    },
                    "refunds_of_receipts_from_federal_pacs": {
                        "generally_valid_limit_types": ["FSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_federal_pacs",
                        "label": "Refunds of Contributions from Federal PACs",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "212"
                    },
                    "refunds_of_receipts_from_individuals": {
                        "generally_valid_limit_types": ["IND"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_individuals",
                        "label": "Refunds of Contributions from Individuals",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "211"
                    },
                    "refunds_of_receipts_from_labor_organizations": {
                        "generally_valid_limit_types": ["LAB"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_labor_organizations",
                        "label": "Refunds of Contributions from Labor Organizations",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "220"
                    },
                    "refunds_of_receipts_from_llcs": {
                        "generally_valid_limit_types": ["LLC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_llcs",
                        "label": "Refunds of Contributions from Limited Liability Corporations",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "222"
                    },
                    "refunds_of_receipts_from_llps": {
                        "generally_valid_limit_types": ["LLP"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_llps",
                        "label": "Refunds of Contributions from Limited Liability Partnerships",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "223"
                    },
                    "refunds_of_receipts_from_local_party_committees": {
                        "generally_valid_limit_types": ["LPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_local_party_committees",
                        "label": "Refunds of Contributions from Local Party Committees",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "217"
                    },
                    "refunds_of_receipts_from_national_party_committees": {
                        "generally_valid_limit_types": ["NPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_national_party_committees",
                        "label": "Refunds of Contributions from National  Party Committees",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "215"
                    },
                    "refunds_of_receipts_from_other_political_committees": {
                        "generally_valid_limit_types": ["FSF", "SSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_other_political_committees",
                        "label": "Refunds of Contributions from Other Political Committees",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "225"
                    },
                    "refunds_of_receipts_from_partnerships": {
                        "generally_valid_limit_types": ["SHP"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_partnerships",
                        "label": "Refunds of Contributions from Partnerships",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "221"
                    },
                    "refunds_of_receipts_from_sole_proprietorships": {
                        "generally_valid_limit_types": ["SOL"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_sole_proprietorships",
                        "label": "Refunds of Contributions from Sole Proprietorships",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "224"
                    },
                    "refunds_of_receipts_from_state_pacs": {
                        "generally_valid_limit_types": ["SSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_state_pacs",
                        "label": "Refunds of Contributions from State PACs",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "213"
                    },
                    "refunds_of_receipts_from_state_party_committees": {
                        "generally_valid_limit_types": ["SPC"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_of_receipts_from_state_party_committees",
                        "label": "Refunds of Contributions from State Party Committees",
                        "meta_transaction_type": "RR",
                        "show_in_enumeration": true,
                        "value": "216"
                    },
                    "refunds_received_for_establishment_costs": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "refunds_received_for_establishment_costs",
                        "label": "Refunds Received for Establishment Costs",
                        "meta_transaction_type": "DR",
                        "show_in_enumeration": true,
                        "value": "181"
                    },
                    "sixteen": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "sixteen",
                        "label": "16",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "16"
                    },
                    "sixteen_c": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "sixteen_c",
                        "label": "16C",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "16C"
                    },
                    "sixty_one": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "sixty_one",
                        "label": "61",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "61"
                    },
                    "ticket_sales": {
                        "generally_valid_limit_types": ["OTH"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "ticket_sales",
                        "label": "Ticket Sales",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "194"
                    },
                    "transfers_from_affiliated_committees": {
                        "generally_valid_limit_types": ["FSF", "SSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_from_affiliated_committees",
                        "label": "Transfers from Affiliated Committees",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "132"
                    },
                    "transfers_from_internal_accounts": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_from_internal_accounts",
                        "label": "Transfers from Internal Accounts",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "131"
                    },
                    "transfers_from_non_federal_account_for_joint_activity": {
                        "generally_valid_limit_types": ["SPF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_from_non_federal_account_for_joint_activity",
                        "label": "Transfers from Non-Federal Account for Joint Activity",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "130"
                    },
                    "transfers_in_from_parent_organizations": {
                        "generally_valid_limit_types": ["PAR"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_in_from_parent_organizations",
                        "label": "Transfers In From Parent Organizations",
                        "meta_transaction_type": "R",
                        "show_in_enumeration": true,
                        "value": "134"
                    },
                    "transfers_out": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_out",
                        "label": "Transfers Out",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "238"
                    },
                    "transfers_to_a_succeeding_election": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_to_a_succeeding_election",
                        "label": "Transfers to a Succeeding Election",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "232"
                    },
                    "transfers_to_affiliated_committees": {
                        "generally_valid_limit_types": ["FSF", "SSF"],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_to_affiliated_committees",
                        "label": "Transfers to Affiliated Committees",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "230"
                    },
                    "transfers_to_internal_accounts": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "transfers_to_internal_accounts",
                        "label": "Transfers to Internal Accounts",
                        "meta_transaction_type": "D",
                        "show_in_enumeration": true,
                        "value": "231"
                    },
                    "twenty_eight_paren": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "twenty_eight_paren",
                        "label": "28(",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "28("
                    },
                    "twenty_nine": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "twenty_nine",
                        "label": "29",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "29"
                    },
                    "twenty_three": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "twenty_three",
                        "label": "23",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "23"
                    },
                    "zero_zero_one": {
                        "generally_valid_limit_types": [],
                        "generally_valid_refund_report_code_key": "",
                        "key": "zero_zero_one",
                        "label": "001",
                        "meta_transaction_type": "U",
                        "show_in_enumeration": false,
                        "value": "001"
                    }
                },
                "PacClassicPacReportCodeTransactionType": {
                    "__is_enum": true,
                    "disbursement": { "key": "disbursement", "label": "Disbursement", "value": "D" },
                    "receipt": { "key": "receipt", "label": "Receipt", "value": "R" }
                },
                "PacClassicPacType": {
                    "__is_enum": true,
                    "business_entity": { "key": "business_entity", "label": "Business Entity", "value": "B" },
                    "cooperative": { "key": "cooperative", "label": "Cooperative", "value": "O" },
                    "corporation": { "key": "corporation", "label": "Corporation", "value": "C" },
                    "corporation_without_capital_stock": { "key": "corporation_without_capital_stock", "label": "Corporation without Capital Stock", "value": "S" },
                    "labor_organization": { "key": "labor_organization", "label": "Labor Organization", "value": "L" },
                    "membership_organization": { "key": "membership_organization", "label": "Membership Organization", "value": "M" },
                    "one": { "key": "one", "label": "Unknown", "value": "1" },
                    "trade_association": { "key": "trade_association", "label": "Trade Association", "value": "T" }
                },
                "PacClassicPartyType": {
                    "__is_enum": true,
                    "american_independent_party": { "key": "american_independent_party", "label": "American Independent Party", "show_in_enumeration": true, "value": "A" },
                    "citizens": { "key": "citizens", "label": "Citizens", "show_in_enumeration": true, "value": "B" },
                    "communist_party": { "key": "communist_party", "label": "Communist Party", "show_in_enumeration": true, "value": "C" },
                    "conservative_party": { "key": "conservative_party", "label": "Conservative Party", "show_in_enumeration": true, "value": "F" },
                    "constitutional": { "key": "constitutional", "label": "Constitutional", "show_in_enumeration": true, "value": "J" },
                    "creators_rights_party": { "key": "creators_rights_party", "label": "Creators Rights Party", "show_in_enumeration": true, "value": "X" },
                    "democrat_party": { "key": "democrat_party", "label": "Democrat Party", "show_in_enumeration": true, "value": "D" },
                    "democrat_party_lowercase": { "key": "democrat_party_lowercase", "label": "Democrat Party Lowercase", "show_in_enumeration": false, "value": "d" },
                    "democratic_farmer_labor": { "key": "democratic_farmer_labor", "label": "Democratic Farmer Labor", "show_in_enumeration": true, "value": "E" },
                    "empty": { "key": "empty", "label": "N/A", "show_in_enumeration": false, "value": "" },
                    "green": { "key": "green", "label": "Green Party", "show_in_enumeration": true, "value": "G" },
                    "independence": { "key": "independence", "label": "Independence", "show_in_enumeration": true, "value": "7" },
                    "independent": { "key": "independent", "label": "Independent", "show_in_enumeration": true, "value": "I" },
                    "independent_american_party": { "key": "independent_american_party", "label": "Independent American Party", "show_in_enumeration": true, "value": "H" },
                    "liberal": { "key": "liberal", "label": "Liberal", "show_in_enumeration": true, "value": "K" },
                    "libertarian": { "key": "libertarian", "label": "Libertarian", "show_in_enumeration": true, "value": "L" },
                    "natural_law_party": { "key": "natural_law_party", "label": "Natural Law Party", "show_in_enumeration": true, "value": "M" },
                    "none": { "key": "none", "label": "None", "show_in_enumeration": true, "value": "N" },
                    "other": { "key": "other", "label": "Other", "show_in_enumeration": true, "value": "O" },
                    "other_lowercase": { "key": "other_lowercase", "label": "Other Lowercase", "show_in_enumeration": false, "value": "o" },
                    "pansexual_peace_party": { "key": "pansexual_peace_party", "label": "Pansexual Peace Party", "show_in_enumeration": true, "value": "Z" },
                    "progressive_labor_party": { "key": "progressive_labor_party", "label": "Progressive Labor Party", "show_in_enumeration": true, "value": "1" },
                    "questionmark": { "key": "questionmark", "label": "Question Mark", "show_in_enumeration": false, "value": "?" },
                    "reform_party": { "key": "reform_party", "label": "Reform Party", "show_in_enumeration": true, "value": "P" },
                    "republican_party": { "key": "republican_party", "label": "Republican Party", "show_in_enumeration": true, "value": "R" },
                    "republican_party_lowercase": { "key": "republican_party_lowercase", "label": "Republican Party Lowercase", "show_in_enumeration": false, "value": "r" },
                    "right_to_life": { "key": "right_to_life", "label": "Right to Life", "show_in_enumeration": true, "value": "Q" },
                    "social_democrats": { "key": "social_democrats", "label": "Social Democrats", "show_in_enumeration": true, "value": "2" },
                    "socialist": { "key": "socialist", "label": "Socialist", "show_in_enumeration": true, "value": "S" },
                    "socialist_equality": { "key": "socialist_equality", "label": "Socialist Equality", "show_in_enumeration": true, "value": "3" },
                    "socialist_labor": { "key": "socialist_labor", "label": "Socialist Labor (Gopher)", "show_in_enumeration": true, "value": "4" },
                    "socialist_party_usa": { "key": "socialist_party_usa", "label": "Socialist Party USA", "show_in_enumeration": true, "value": "V" },
                    "socialist_workers_party": { "key": "socialist_workers_party", "label": "Socialist Workers Party", "show_in_enumeration": true, "value": "W" },
                    "solidarity": { "key": "solidarity", "label": "Solidarity", "show_in_enumeration": true, "value": "5" },
                    "taxpayers": { "key": "taxpayers", "label": "Taxpayers", "show_in_enumeration": true, "value": "T" },
                    "the_new_party": { "key": "the_new_party", "label": "The New Party", "show_in_enumeration": true, "value": "Y" },
                    "unknown": { "key": "unknown", "label": "Unknown", "show_in_enumeration": true, "value": "U" },
                    "workers_world_party": { "key": "workers_world_party", "label": "Workers World Party", "show_in_enumeration": true, "value": "6" },
                    "zero": { "key": "zero", "label": "Zero", "show_in_enumeration": false, "value": "0" }
                },
                "PacClassicPartyTypeType": {
                    "__is_enum": true,
                    "dpp": { "key": "dpp", "label": "Congressional District Political Party Committee", "value": "DPP" },
                    "spp": { "key": "spp", "label": "State Political Party", "value": "SPP" }
                },
                "PacClassicPayrollCycleType": {
                    "__is_enum": true,
                    "annual": { "key": "annual", "label": "Annual", "show_in_enumeration": false, "value": "A" },
                    "bi_weekly": { "key": "bi_weekly", "label": "Bi-weekly", "show_in_enumeration": true, "value": "B" },
                    "h": { "key": "h", "label": "H", "show_in_enumeration": false, "value": "H" },
                    "monthly": { "key": "monthly", "label": "Monthly", "show_in_enumeration": true, "value": "M" },
                    "n": { "key": "n", "label": "None", "show_in_enumeration": false, "value": "N" },
                    "none": { "key": "none", "label": "None", "show_in_enumeration": true, "value": "NONE" },
                    "o": { "key": "o", "label": "O", "show_in_enumeration": false, "value": "O" },
                    "semi_monthly": { "key": "semi_monthly", "label": "Semi-Monthly", "show_in_enumeration": true, "value": "S" },
                    "signed_up": { "key": "signed_up", "label": "Signed Up", "show_in_enumeration": true, "value": "U" },
                    "two": { "key": "two", "label": "2", "show_in_enumeration": false, "value": "2" },
                    "weekly": { "key": "weekly", "label": "Weekly", "show_in_enumeration": true, "value": "W" }
                },
                "PacClassicPreferredAddressType": {
                    "__is_enum": true,
                    "home": { "key": "home", "label": "Home", "show_in_enumeration": true, "value": "H" },
                    "preferred": { "key": "preferred", "label": "Preferred", "show_in_enumeration": false, "value": "P" },
                    "work": { "key": "work", "label": "Work", "show_in_enumeration": true, "value": "W" }
                },
                "PacClassicPreferredDeliveryType": {
                    "__is_enum": true,
                    "email": { "key": "email", "label": "Email", "value": "E" },
                    "fax": { "key": "fax", "label": "Fax", "value": "F" },
                    "letter": { "key": "letter", "label": "Letter", "value": "L" }
                },
                "PacClassicPreferredEmailType": {
                    "__is_enum": true,
                    "home": { "key": "home", "label": "Home", "value": "H" },
                    "work": { "key": "work", "label": "Work", "value": "W" }
                },
                "PacClassicPreferredFaxType": {
                    "__is_enum": true,
                    "home": { "key": "home", "label": "Home", "value": "H" },
                    "work": { "key": "work", "label": "Work", "value": "W" }
                },
                "PacClassicSourceSchema": {
                    "__is_enum": true,
                    "cust_vocus_gr": { "environment": "DEV", "id_suffix": 2, "key": "cust_vocus_gr", "label": "CUSTVocusGR", "server": "quorum-dev-gr-003.cq5fjxpegpcs.us-east-1.rds.amazonaws.com", "value": "CUSTVocusGR" },
                    "gr1": { "environment": "PROD", "id_suffix": 1, "key": "gr1", "label": "GR1", "server": "quorum-prod-rds-sql-gr-001.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR1" },
                    "gr2": { "environment": "PROD", "id_suffix": 2, "key": "gr2", "label": "GR2", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR2" },
                    "gr3": { "environment": "PROD", "id_suffix": 3, "key": "gr3", "label": "GR3", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR3" },
                    "gr4": { "environment": "PROD", "id_suffix": 4, "key": "gr4", "label": "GR4", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR4" },
                    "gr5": { "environment": "PROD", "id_suffix": 5, "key": "gr5", "label": "GR5", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR5" },
                    "gr6": { "environment": "PROD", "id_suffix": 6, "key": "gr6", "label": "GR6", "server": "quorum-prod-rds-sql-gr-001.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GR6" },
                    "gr_convert_1": { "environment": "PROD", "id_suffix": 7, "key": "gr_convert_1", "label": "GRConvert1", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GRConvert1" },
                    "gr_space_2": { "environment": "PROD", "id_suffix": 8, "key": "gr_space_2", "label": "GRSPACE2", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "GRSPACE2" },
                    "nada": { "environment": "PROD", "id_suffix": 9, "key": "nada", "label": "Nada", "server": "quorum-prod-rds-sql-gr-003.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "Nada" },
                    "pac_classic_1": { "environment": "LOCAL", "id_suffix": 1, "key": "pac_classic_1", "label": "PacClassic1", "server": "LOCAL", "value": "PacClassic1" },
                    "pac_classic_2": { "environment": "LOCAL", "id_suffix": 2, "key": "pac_classic_2", "label": "PacClassic2", "server": "LOCAL", "value": "PacClassic2" },
                    "qagrkb": { "environment": "DEV", "id_suffix": 1, "key": "qagrkb", "label": "QAGRKB", "server": "quorum-dev-gr-003.cq5fjxpegpcs.us-east-1.rds.amazonaws.com", "value": "QAGRKB" },
                    "secure_gr": { "environment": "PROD", "id_suffix": 10, "key": "secure_gr", "label": "SecureGR", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "SecureGR" },
                    "vocus_gr": { "environment": "PROD", "id_suffix": 11, "key": "vocus_gr", "label": "VocusGR", "server": "quorum-prod-rds-sql-gr-002.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "VocusGR" },
                    "vocus_gribtu": { "environment": "PROD", "id_suffix": 12, "key": "vocus_gribtu", "label": "VocusGRIBTU", "server": "quorum-prod-rds-sql-gr-003.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "VocusGRIBTU" },
                    "vocus_grsbc": { "environment": "PROD", "id_suffix": 13, "key": "vocus_grsbc", "label": "VocusGRSBC", "server": "quorum-prod-rds-sql-gr-003.c2dmqgtbmtrt.us-east-1.rds.amazonaws.com", "value": "VocusGRSBC" }
                },
                "PacClassicSourceType": {
                    "__is_enum": true,
                    "c": { "key": "c", "label": "TBD", "show_in_enumeration": false, "value": "C" },
                    "dash": { "key": "dash", "label": "TBD", "show_in_enumeration": false, "value": "-" },
                    "o": { "key": "o", "label": "TBD", "show_in_enumeration": true, "value": "O" },
                    "s": { "key": "s", "label": "TBD", "show_in_enumeration": false, "value": "S" },
                    "u": { "key": "u", "label": "TBD", "show_in_enumeration": true, "value": "U" },
                    "zero": { "key": "zero", "label": "TBD", "show_in_enumeration": false, "value": "0" }
                },
                "PacClassicSplitType": {
                    "__is_enum": true,
                    "external": { "key": "external", "label": "External", "value": "E" },
                    "internal": { "key": "internal", "label": "Internal", "value": "I" },
                    "none": { "key": "none", "label": "None", "value": "N" }
                },
                "PacClassicTransactionMethodType": {
                    "__is_enum": true,
                    "cash": { "key": "cash", "label": "Cash", "order": 4, "value": "$" },
                    "check": { "key": "check", "label": "Check", "order": 2, "value": "C" },
                    "credit_card": { "key": "credit_card", "label": "Credit Card", "order": 3, "value": "V" },
                    "in_kind": { "key": "in_kind", "label": "In-Kind", "order": 6, "value": "I" },
                    "other": { "key": "other", "label": "Other", "order": 5, "value": "O" },
                    "payroll": { "key": "payroll", "label": "Payroll", "order": 1, "value": "P" },
                    "web": { "key": "web", "label": "Web", "order": 7, "value": "W" }
                },
                "PacClassicTransactionSortKey": {
                    "__is_enum": true,
                    "sort_by_name": { "key": "sort_by_name", "label": "Sort by SortName", "value": "N" },
                    "sort_by_state": { "key": "sort_by_state", "label": "Sort by SortState", "value": "S" },
                    "sort_by_transaction_date": { "key": "sort_by_transaction_date", "label": "Sort by TransactionDate", "value": "D" }
                },
                "PacClassicTransactionType": {
                    "__is_enum": true,
                    "allocation": { "key": "allocation", "label": "Allocation", "value": "A" },
                    "disbursement": { "key": "disbursement", "label": "Disbursement", "value": "D" },
                    "receipt": { "key": "receipt", "label": "Receipt", "value": "R" }
                },
                "PacClassicUserMatcherStatus": {
                    "__is_enum": true,
                    "already_linked": { "key": "already_linked", "label": "Already Linked", "value": "2" },
                    "created": { "key": "created", "label": "Created", "value": "5" },
                    "error": { "key": "error", "label": "Error", "value": "4" },
                    "matched": { "key": "matched", "label": "Matched", "value": "1" },
                    "not_found": { "key": "not_found", "label": "Not Found", "value": "3" }
                }
            }
        },
        "pdfdownload": {
            "models": {
                "NewDownloadTemplate": {
                    "__is_model": true,
                    "__name__": "NewDownloadTemplate",
                    "data_model": "app.pdfdownload.models.NewDownloadTemplate",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/newdownloadtemplate/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Data type corresponding to DLC mode",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The last user that edited this template",
                            "name": "last_editor",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "last editor"
                        },
                        { "field_type": null, "help_text": "The download center slice of the store used to repopulate the store", "name": "store", "verbose_name": "store" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pdfdownload.types", "__name__": "NewDownloadTemplateType" },
                            "field_type": 4,
                            "help_text": "The type of template this is (i.e. user-made, Quorum-made, or auto-generated)",
                            "name": "template_type",
                            "verbose_name": "template type"
                        },
                        { "field_type": 1, "help_text": "If enabled, prevent users other than the creator from editing or saving the template.", "name": "is_locked", "verbose_name": "is locked" },
                        { "field_type": 2, "help_text": "The name of the template", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "SafedSearch to retrieve of the most recently viewed profile for this template",
                            "name": "profile_safed_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "profile safed search"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "NewPDFEmail": {
                    "__is_model": true,
                    "__name__": "NewPDFEmail",
                    "data_model": "app.pdfdownload.models.NewPDFEmail",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newpdfemail/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pdfdownload.types", "__name__": "NewPDFEmailType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "pdf_email_type",
                            "verbose_name": "pdf email type"
                        },
                        { "field_type": 4, "help_text": "The number of times the crons have attempted to send this email", "name": "retry_count", "verbose_name": "retry count" },
                        { "field_type": 4, "help_text": "Number of pdfs associated with this bulk download", "name": "pdf_count", "verbose_name": "pdf count" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pdfdownload.types", "__name__": "NewPDFEmailStatus" },
                            "field_type": 4,
                            "help_text": "The status of this pdf email - whether is is processing, has been sent, errored, etc.",
                            "name": "status",
                            "verbose_name": "status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "SafedSearch for all the profiles that will be/were downloaded",
                            "name": "safed_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "safed search"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Download template capturing app state when the user requested a bulk download",
                            "name": "template",
                            "related_model": { "__module__": "app.pdfdownload.models", "__name__": "NewDownloadTemplate" },
                            "verbose_name": "template"
                        },
                        { "field_type": 2, "help_text": "A subdomain to tell Selenium to point to when test generating this email (ie staging, beta, pdf-testing)", "name": "debug_subdomain", "verbose_name": "debug subdomain" },
                        {
                            "field_type": 7,
                            "help_text": "The user that was logged in when this NewPDFEmail was created - and who the success email would be sent to",
                            "name": "logged_in_as_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "logged in as user"
                        },
                        { "field_type": 2, "help_text": "Path of uploaded file within S3", "name": "s3_path", "verbose_name": "s3 path" },
                        { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 2, "help_text": "URL to download's S3 location that we email to the user", "name": "url", "verbose_name": "url" }
                    ]
                }
            },
            "types": {
                "NewDownloadTemplateType": {
                    "__is_enum": true,
                    "auto_generated": { "help_text": "Template was auto-generated when user made a bulk download without saving as a custom template", "key": "auto_generated", "label": "Auto Generated", "value": 3 },
                    "custom": { "help_text": "Template was created and saved by the user", "key": "custom", "label": "Custom", "value": 1 },
                    "default": { "help_text": "Template was created by Quorum and available to all users", "key": "default", "label": "Default", "value": 2 }
                },
                "NewPDFEmailStatus": {
                    "__is_enum": true,
                    "failed": { "key": "failed", "label": "Error Occurred During Processing", "value": 9 },
                    "failed_to_create_pdf": { "key": "failed_to_create_pdf", "label": "Error Occurred During Processing", "value": 4 },
                    "failed_to_create_zip": { "key": "failed_to_create_zip", "label": "Error Occurred During Processing", "value": 5 },
                    "failed_to_login": { "key": "failed_to_login", "label": "Error Occured During Processing", "value": 10 },
                    "failed_to_navigate_or_click": { "key": "failed_to_navigate_or_click", "label": "Error Occurred During Processing", "value": 11 },
                    "failed_to_send_email": { "key": "failed_to_send_email", "label": "Error Occurred During Processing", "value": 7 },
                    "failed_to_upload_to_s3": { "key": "failed_to_upload_to_s3", "label": "Error Occurred During Processing", "value": 6 },
                    "processing": { "key": "processing", "label": "Processing", "value": 3 },
                    "queued": { "key": "queued", "label": "Queued for Processing", "value": 2 },
                    "sent": { "key": "sent", "label": "Sent", "value": 8 },
                    "unprocessed": { "key": "unprocessed", "label": "Waiting to be Processed", "value": 1 }
                },
                "NewPDFEmailType": {
                    "__is_enum": true,
                    "analytics_download": { "action_text": "Download Analytics", "extension": "pdf", "key": "analytics_download", "label": "Analytics Download", "path": "graphDownload", "value": 3 },
                    "profile_zip": { "action_text": "", "extension": "zip", "key": "profile_zip", "label": "Profile Zip", "path": "/downloadcenter/", "value": 1 },
                    "search_download_zip": { "action_text": "Download PDF", "extension": "zip", "key": "search_download_zip", "label": "Search Download Zip", "path": "/downloadcenter/", "value": 2 }
                }
            }
        },
        "person": {
            "models": {
                "GrassrootsPerson": {
                    "__is_model": true,
                    "__name__": "GrassrootsPerson",
                    "data_model": "app.person.models.GrassrootsPerson",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "show_in_quicksearch": true },
                    "endpoint": "/api/grassrootsperson/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The QuorumUser that created this record.",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Quorum Client Organization that owns this record.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The person's UID/MEMID on Know Who", "name": "kw_uid", "verbose_name": "kw uid" },
                        { "field_type": 2, "help_text": "ID on bioguide.congress.gov. May be null if the person served only as a president.", "name": "bioguideid", "verbose_name": "bioguideid" },
                        { "field_type": 2, "help_text": "The person's ID on thomas.congress.gov.", "name": "thomasid", "verbose_name": "thomasid" },
                        { "field_type": 2, "help_text": "The OpenStates id for person, if known, comma separated", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 2, "help_text": "The name of the person's LIS id, if known.", "name": "lisid", "verbose_name": "lisid" },
                        {
                            "field_type": 4,
                            "help_text": "Number of terms this person spans in their current role",
                            "miscellaneous": 1,
                            "name": "num_terms",
                            "sheet_column": true,
                            "sheets_column_order": 10,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 10002, 10004, 10005, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 1000],
                            "verbose_name": "Number of Terms"
                        },
                        { "field_type": 3, "help_text": "A list of all the committees that this official sits on.", "miscellaneous": 1, "name": "committee_string", "sheet_column": true, "sheets_column_order": 25, "sheets_subcategory": 6, "verbose_name": "Committee List" },
                        { "field_type": 3, "help_text": "A list of all the parties this person is affiliated with", "name": "party_string", "verbose_name": "Parties" },
                        { "field_type": null, "help_text": "", "name": "committee_id_name_arr", "verbose_name": "committee id name arr" },
                        { "field_type": 3, "help_text": "Email address the member uses to reach out to constituents", "name": "constituent_email", "verbose_name": "constituent email" },
                        { "field_type": 1, "help_text": "Whether or not a person has been a legislator, now or at anytime in the past.", "name": "has_been_legislator", "verbose_name": "has been legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member is brand new in their region.", "name": "new_legislator", "verbose_name": "new legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member recently switched chambers in their region.", "name": "new_chamber", "verbose_name": "new chamber" },
                        { "field_type": 1, "help_text": "If this person is a freshman legislator", "name": "freshman_legislator", "verbose_name": "freshman legislator" },
                        { "field_type": 2, "help_text": "Know Who staffer ID", "name": "kw_sid", "verbose_name": "kw sid" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "personrole",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "personrole"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ComStafferType" },
                            "field_type": 4,
                            "help_text": "Whether Staffer is affiliated with a majority or minority committee only",
                            "name": "comstaffertype",
                            "verbose_name": "comstaffertype"
                        },
                        { "field_type": null, "help_text": "All staffer types corresponding to this person", "name": "staffer_types", "verbose_name": "staffer types" },
                        { "field_type": 4, "help_text": "Highest rank of the staffer's various titlecodes", "name": "titlecode_order", "verbose_name": "titlecode order" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "location",
                            "related_model": { "__module__": "app.person.models", "__name__": "MemberOffice" },
                            "verbose_name": "location"
                        },
                        { "field_type": 2, "help_text": "Responsibilities", "miscellaneous": 8, "name": "responsibilities_string", "sheet_column": true, "sheets_column_order": 10, "verbose_name": "Responsibilities" },
                        { "field_type": 2, "help_text": "The person's EXECID on Know Who", "name": "kw_execid", "verbose_name": "kw execid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SpecificExecutiveRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_executive_role",
                            "verbose_name": "most recent executive role"
                        },
                        { "field_type": 2, "help_text": "The person's UID on Know Who, call it kw_locid to differentiate btw members.", "name": "kw_locid", "verbose_name": "kw locid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveBranch" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_branch",
                            "verbose_name": "most recent local branch"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveDepartment" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_department",
                            "verbose_name": "most recent local department"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The most recent legislature the person has been a part of",
                            "miscellaneous": 1,
                            "name": "most_recent_region",
                            "sheet_column": true,
                            "sheets_column_order": 15,
                            "sheets_display_key": "region_name",
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Region"
                        },
                        { "field_type": null, "help_text": "\n            All regions the person was a part of in their most recent role(s).\n            For example, an EU person can be in [Region.eu, Region.france]\n        ", "name": "most_recent_regions", "verbose_name": "most recent regions" },
                        {
                            "field_type": 7,
                            "help_text": "The country that an official represents. For EU officials, this will be their international country they represent for the EU. International and US officials will use their respective countries.",
                            "name": "representing_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "representing country"
                        },
                        { "field_type": null, "help_text": "All regions corresponding to former roles of this Official.", "name": "_ph_dn_former_regions", "verbose_name": " ph dn former regions" },
                        { "field_type": null, "help_text": "All regions corresponding to the current and former roles of this Official.", "name": "_ph_dn_all_regions", "verbose_name": " ph dn all regions" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.geography.models", "__name__": "DistrictType" },
                            "field_type": 4,
                            "help_text": "The type of district",
                            "name": "most_recent_district_type",
                            "verbose_name": "most recent district type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The current US state of this person",
                            "miscellaneous": 1,
                            "name": "most_recent_state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "sheet_column": true,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "US State"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "most recent district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_upper_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "most recent upper district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_lower_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "most recent lower district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "most recent county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "most recent municipality"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "miscellaneous": 1,
                            "name": "most_recent_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                            "verbose_name": "Country"
                        },
                        { "field_type": 1, "help_text": "Whether this individual currently holds a role, or if this is archival information.", "name": "current", "verbose_name": "current" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonStatus" },
                            "field_type": 4,
                            "help_text": "The status of this person (active, incoming, leaving or former).",
                            "miscellaneous": 1,
                            "name": "status",
                            "sheet_column": true,
                            "sheets_column_order": 22,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Election Status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the most recent role of the person.",
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "most recent role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "RoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_role_type",
                            "verbose_name": "most recent role type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of people:\n                ExecutiveRoleType\n                LocalExecutiveRoleType\n                etc...\n            ", "name": "most_recent_role_sub_type", "verbose_name": "most recent role sub type" },
                        { "field_type": 3, "help_text": "the address of this person's most recent role", "name": "most_recent_role_address", "verbose_name": "most recent role address" },
                        { "field_type": 3, "help_text": "the room of this person's most recent role", "name": "most_recent_role_room", "verbose_name": "most recent role room" },
                        { "field_type": 3, "help_text": "the name of the office building of this person's most recent role", "name": "most_recent_role_building", "verbose_name": "most recent role building" },
                        { "field_type": 3, "help_text": "first line of the street address of this person's most recent role", "name": "most_recent_role_street1", "verbose_name": "most recent role street1" },
                        { "field_type": 3, "help_text": "second line of the street address of this person's most recent role", "name": "most_recent_role_street2", "verbose_name": "most recent role street2" },
                        { "field_type": 3, "help_text": "the ZipCode of this person's most recent role", "name": "most_recent_role_zipcode", "verbose_name": "most recent role zipcode" },
                        { "field_type": 3, "help_text": "the phone number of this person's most recent role", "name": "most_recent_role_phone", "verbose_name": "most recent role phone" },
                        { "field_type": 3, "help_text": "the city of this person's most recent role", "name": "most_recent_role_city", "verbose_name": "most recent role city" },
                        { "field_type": 3, "help_text": "the state of this person's most recent role", "name": "most_recent_role_state", "verbose_name": "most recent role state" },
                        { "field_type": 2, "help_text": "The last known leadership role held during this role, if any.", "name": "most_recent_leadership_title", "verbose_name": "most recent leadership title" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The most recent political party of the person.",
                            "name": "most_recent_party",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Party"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "used to determine the perceived party of independents",
                            "name": "perceived_party",
                            "verbose_name": "perceived party"
                        },
                        { "field_type": null, "help_text": "The different major global types held by this legislator(e.g. Head of State, Top-Level Cabinet Member, etc.)", "name": "major_person_types", "verbose_name": "major person types" },
                        { "field_type": null, "help_text": "The different minor types held by this legislator, oftentimes specific to a region/country(e.g. Senator, Department Secretary, etc.)", "name": "minor_person_types", "verbose_name": "minor person types" },
                        { "field_type": null, "help_text": "The different specific types held by this legislator(e.g. Speaker, House Majority Leader, etc.)", "name": "specific_person_types", "verbose_name": "specific person types" },
                        { "field_type": 3, "help_text": "The (international) region that this person represents as text, until we have shapefiles that we can map to", "name": "region_represented", "verbose_name": "region represented" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_sector_type",
                            "verbose_name": "most recent ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_meta_role_type",
                            "verbose_name": "most recent ph meta role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_major_role_type",
                            "verbose_name": "most recent ph major role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_minor_role_type",
                            "verbose_name": "most recent ph minor role type"
                        },
                        { "field_type": null, "help_text": "", "name": "most_recent_ph_specific_role_types", "verbose_name": "most recent ph specific role types" },
                        { "field_type": 16, "help_text": "The last time KW updated this person's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 16, "help_text": "The last time Intrado updated the object in their database corresponding to this Person.", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 16, "help_text": "The last time we attempted to flush this person", "name": "last_attempted_flush", "verbose_name": "last attempted flush" },
                        { "field_type": 16, "help_text": "The last time we successfully flushed this person", "name": "last_successful_flush", "verbose_name": "last successful flush" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": 2, "help_text": "Facebook ID", "name": "facebookid", "verbose_name": "facebookid" },
                        { "field_type": 2, "help_text": "The url of the facebook page", "name": "facebook_url", "verbose_name": "facebook url" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": 2, "help_text": "The name of the person's official Twitter handle, if known.", "name": "twitterid", "verbose_name": "twitterid" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": 2, "help_text": "The ID of the person's official YouTube channel, if known.", "name": "youtubeid", "verbose_name": "youtubeid" },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the current role of the person, if present.",
                            "name": "current_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "current role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "DemographicType" },
                            "field_type": 4,
                            "help_text": "Represent a state or district",
                            "name": "demographic_type",
                            "verbose_name": "demographic type"
                        },
                        { "field_type": 2, "help_text": "The House History id of the person, if known.", "name": "househistoryid", "verbose_name": "househistoryid" },
                        { "field_type": 4, "help_text": "The ICPSR id of the person (Poole and Rosenthal), if known.", "name": "icpsrid", "verbose_name": "icpsrid" },
                        { "field_type": 16, "help_text": "The last time the Person object was updated", "name": "last_updated", "verbose_name": "last updated" },
                        {
                            "field_type": 7,
                            "help_text": "The Corresponding Old Staffer Object",
                            "name": "legacy_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "legacy staffer"
                        },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (donation to legislator/candidate with id)", "name": "legislator_candidate_id", "verbose_name": "legislator candidate id" },
                        { "field_type": 4, "help_text": "The Maplight id of the person, if known.", "name": "maplightid", "verbose_name": "maplightid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ExecutivePosition" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_position",
                            "verbose_name": "most recent position"
                        },
                        { "field_type": 4, "help_text": "The official ID given by a state website for a legislator.", "name": "official_stateid", "verbose_name": "official stateid" },
                        { "field_type": 4, "help_text": "DEPRECATED", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 2, "help_text": "The person's ID on opensecrets.org (The Center for Responsive Politics), if known.", "name": "osid", "verbose_name": "osid" },
                        { "field_type": 2, "help_text": "The person's ID on vote-smart.org (Project Vote Smart), if known.", "name": "pvsid", "verbose_name": "pvsid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionDeliveryType" },
                            "field_type": 4,
                            "help_text": "If member requires special treatment for delivering supporter messages (i.e. recaptcha on form).",
                            "name": "supporter_action_delivery_type",
                            "verbose_name": "supporter action delivery type"
                        },
                        { "field_type": 2, "help_text": "The name of the person's id in the Washington Post, if known.", "name": "wpid", "verbose_name": "wpid" },
                        { "field_type": 4, "help_text": "KnowWho's PersonID for the tblPeople entry corresponding to this Person.", "name": "_ph_kw_person_id", "verbose_name": " ph kw person id" },
                        { "field_type": 3, "help_text": "\n            A person's IE (Information Evolution) ID. If they have this ID,\n            they were at some point collected or enriched by the consultants\n        ", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        { "field_type": 1, "help_text": "If True, this Person is ready for frontend consumption. Set True during flushing.", "name": "_ph_is_clean", "verbose_name": " ph is clean" },
                        { "field_type": 1, "help_text": "Marks that we should flush this person in the next Bidet run", "name": "_ph_should_flush_next_run", "verbose_name": " ph should flush next run" },
                        { "field_type": 4, "help_text": "A UniqueID for a Person originating from the Intrado data source.", "name": "_ph_intrado_person_id", "verbose_name": " ph intrado person id" },
                        { "field_type": 4, "help_text": "Leadership Connect's PersonID for a Person.", "name": "_ph_lc_person_id", "verbose_name": " ph lc person id" },
                        { "field_type": 4, "help_text": "The core_person_id for the Legistorm core_person this Person represents.", "name": "_ph_ls_core_person_id", "verbose_name": " ph ls core person id" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from currently held PersonRoles.", "name": "_ph_dn_current_sector_types", "verbose_name": " ph dn current sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_meta_role_types", "verbose_name": " ph dn current meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_major_role_types", "verbose_name": " ph dn current major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_minor_role_types", "verbose_name": " ph dn current minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from currently held PersonRoles.", "name": "_ph_dn_current_specific_role_types", "verbose_name": " ph dn current specific role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from formerly held PersonRoles.", "name": "_ph_dn_former_sector_types", "verbose_name": " ph dn former sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_meta_role_types", "verbose_name": " ph dn former meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_major_role_types", "verbose_name": " ph dn former major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_minor_role_types", "verbose_name": " ph dn former minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from formerly held PersonRoles.", "name": "_ph_dn_former_specific_role_types", "verbose_name": " ph dn former specific role types" },
                        { "field_type": null, "help_text": "All of the intrado Tag names from a person's PersonRoles.", "name": "_ph_dn_intrado_tags", "verbose_name": " ph dn intrado tags" },
                        { "field_type": null, "help_text": "Denormalization of intrado languages from PersonRoles.", "name": "_ph_dn_intrado_languages", "verbose_name": " ph dn intrado languages" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoPreferredDistributionMode" },
                            "field_type": 4,
                            "help_text": "Denormalization of intrado PreferredDistributionMode from PersonRoles.",
                            "name": "_ph_dn_intrado_preferred_distribution_mode",
                            "verbose_name": " ph dn intrado preferred distribution mode"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_person_type",
                            "verbose_name": "most recent person type"
                        },
                        { "field_type": 3, "help_text": "The person's most recent title.", "name": "title", "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 3, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The person's full name with title, district, and party information for current Members of Congress.Also allows the sheet to be more easily ordered alphabetically.", "name": "name", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Name" },
                        { "field_type": 2, "help_text": "The person's first name or first initial.", "name": "firstname", "sheet_column": true, "sheets_column_order": 2, "sheets_subcategory": 3, "verbose_name": "First Name" },
                        { "field_type": 2, "help_text": "The person's last name.", "name": "lastname", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 3, "verbose_name": "Last Name" },
                        { "field_type": 2, "help_text": "The person's middle name (optional).", "name": "middlename", "verbose_name": "middlename" },
                        { "field_type": 3, "help_text": "The prefix on the person's name, usually one of Dr., Ms., etc. This is usually different than their titles", "name": "prefix", "verbose_name": "prefix" },
                        { "field_type": 2, "help_text": "The suffix on the person's name usually one of Jr., Sr., I, II, etc.", "name": "namemod", "verbose_name": "namemod" },
                        { "field_type": 2, "help_text": "If set, the nickname should usually be displayed in quotes where a middle name would go.", "name": "nickname", "verbose_name": "nickname" },
                        { "field_type": 2, "help_text": "Pronunciation", "name": "pronunciation", "verbose_name": "pronunciation" },
                        { "field_type": 1, "help_text": "Whether the name has been manually overwritten and wont be updated from KW", "name": "has_custom_name", "verbose_name": "has custom name" },
                        { "field_type": 2, "help_text": "Public Organization Descriptor", "name": "public_organization_descriptor", "verbose_name": "public organization descriptor" },
                        { "field_type": 1, "help_text": "", "name": "show_in_quicksearch", "verbose_name": "show in quicksearch" },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" },
                        { "field_type": 4, "help_text": "", "name": "precedence_local", "verbose_name": "precedence local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state", "verbose_name": "precedence state" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state_and_local", "verbose_name": "precedence state and local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_eu", "verbose_name": "precedence eu" },
                        { "field_type": 2, "help_text": "The person's ascii first name or first initial.", "name": "firstname_search", "verbose_name": "firstname search" },
                        { "field_type": 2, "help_text": "The person's ascii last name.", "name": "lastname_search", "verbose_name": "lastname search" },
                        { "field_type": 2, "help_text": "The person's ascii middle name (optional).", "name": "middlename_search", "verbose_name": "middlename search" },
                        { "field_type": 3, "help_text": "The person's unicode full name with firstname, lastname, and nickname information for Person.\n                    In cases with accented names, represent the accented and unaccented (unidecoded) name in the same\n                    string for searching capabilities.\n                ", "name": "name_search", "verbose_name": "name search" },
                        { "field_type": 5, "help_text": "The person's birthday.", "name": "birthday", "verbose_name": "Birthday" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Gender" },
                            "field_type": 4,
                            "help_text": "The person's gender, if known. For historical data, the gender is sometimes not known.",
                            "miscellaneous": 1,
                            "name": "gender",
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "verbose_name": "Gender"
                        },
                        { "field_type": 2, "help_text": "The person's email.", "is_contact_info": true, "name": "email", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Email" },
                        {
                            "field_type": 3,
                            "help_text": "Alternate Email for this Press Contact",
                            "miscellaneous": 120,
                            "name": "intrado_other_email",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "verbose_name": "Alternate Email"
                        },
                        { "field_type": 1, "help_text": "whether the email is valid and/or verified", "name": "valid_email", "verbose_name": "valid email" },
                        { "field_type": 2, "help_text": "The person's PID on Know Who", "name": "kw_pid", "verbose_name": "kw pid" },
                        { "field_type": 2, "help_text": "The person's OFCID's on Know Who, comma separated", "name": "kw_ofcid", "verbose_name": "kw ofcid" },
                        { "field_type": 4, "help_text": "The ID of the person on CSPAN websites, if known.", "name": "cspanid", "verbose_name": "cspanid" },
                        { "field_type": 2, "help_text": "The official ID given by a state website for a legislator, but in unicode.", "name": "external_state_id", "verbose_name": "external state id" },
                        { "field_type": 3, "help_text": "The local path of the image for a person on update/state update, which is often under settings.DATA_PATH", "name": "local_image_path", "verbose_name": "local image path" },
                        { "field_type": 3, "help_text": "The URL of this person's image/avatar that is actually rendered on the frontend (most likely an S3 URL with correct CORS)", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 3, "help_text": "Original image url location that we get from the outside world, as one would find via Google Images Search", "name": "source_image_url", "verbose_name": "source image url" },
                        { "field_type": 3, "help_text": "The high quality path of this members image", "name": "high_quality_local_image_path", "verbose_name": "high quality local image path" },
                        { "field_type": 3, "help_text": "Cached path of high quality image url", "name": "high_quality_image_url", "verbose_name": "high quality image url" },
                        { "field_type": 3, "help_text": "The Wikipedia URL for this person, if any", "name": "wikipedia_url", "verbose_name": "wikipedia url" },
                        { "field_type": null, "help_text": "The different urls where we can find this person on the web (via our consultants)", "name": "source_urls", "verbose_name": "source urls" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "primary_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "primary organization"
                        },
                        { "field_type": null, "help_text": "The different types of leadership roles held by this legislator.", "name": "leadership_types", "verbose_name": "leadership types" },
                        { "field_type": 1, "help_text": "Whether the leadership types have been manually overwritten or can be set automatically.", "name": "custom_leadership_types", "verbose_name": "custom leadership types" },
                        { "field_type": null, "help_text": "Stores all external unique IDs for faster matching Person objects from vendors like DDC & Cision", "name": "external_unique_id_dict", "verbose_name": "external unique id dict" },
                        { "field_type": null, "help_text": "A person's WhoisWho ID", "name": "wiw_ids", "verbose_name": "wiw ids" },
                        { "field_type": 4, "help_text": "A persons's EU MEP ID", "name": "mepid", "verbose_name": "mepid" },
                        { "field_type": 2, "help_text": "Consultant added person's LegislatorID from international persons sheet", "name": "legislator_id", "verbose_name": "legislator id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ProfileInfoSource" },
                            "field_type": 4,
                            "help_text": "The most recent site from which we have scraped information to fill out the person's profile",
                            "name": "most_recent_profile_info_source",
                            "verbose_name": "most recent profile info source"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "send_messages_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "send messages to"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 3, "help_text": "The office code for a US Congressperson. Used in Grassroots delivery by the\n                     CWC for message routing. House format: H{state_abbrev}{district_number}.\n                     Senate format: S{state_abbrev}{senate_class_number}.", "name": "office_code", "verbose_name": "office code" },
                        { "field_type": 1, "help_text": "Whether or not this person should be delivered via fill forms", "name": "should_deliver_via_fill_form", "verbose_name": "should deliver via fill form" },
                        { "field_type": 1, "help_text": "If the Member has a valid office code in CWC", "name": "is_cwc", "verbose_name": "is cwc" },
                        { "field_type": 3, "help_text": "LinkedIn Username", "name": "linkedin_username", "verbose_name": "linkedin username" },
                        { "field_type": null, "help_text": "All the AppointedByTypes for a given person", "name": "dn_appointed_by_types", "verbose_name": "dn appointed by types" },
                        { "field_type": null, "help_text": "All the PayScales for a given person", "name": "dn_pay_scale_types", "verbose_name": "dn pay scale types" },
                        {
                            "field_type": 8,
                            "help_text": "All the congresses this person spans",
                            "name": "congresses",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congresses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the sessions this person spans.",
                            "name": "sessions",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "sessions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "titlecode",
                            "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                            "verbose_name": "titlecode"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "responsibilities",
                            "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                            "verbose_name": "responsibilities"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "beats",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "Beat" },
                            "sheet_column": true,
                            "verbose_name": "beats"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dma",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "DesignatedMarketArea" },
                            "sheet_column": true,
                            "verbose_name": "dma"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this person is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "biography",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonBiography" },
                            "sheet_column": true
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "sheet_column": true
                        }
                    ],
                    "proxy_endpoint": "/api/person/"
                },
                "MemberOffice": {
                    "__is_model": true,
                    "__name__": "MemberOffice",
                    "data_model": "app.person.models.MemberOffice",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/memberoffice/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 16, "help_text": "The datetime this record 'expired' or became no longer applicable.", "name": "expired", "sheet_column": true, "verbose_name": "expired" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "OfficeType" },
                            "field_type": 4,
                            "help_text": "type of office",
                            "name": "office_type",
                            "verbose_name": "office type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "StafferLocation" },
                            "field_type": 4,
                            "help_text": "Staffer Location (see enum)",
                            "name": "location",
                            "verbose_name": "location"
                        },
                        { "field_type": 3, "help_text": "formatted address", "name": "address", "verbose_name": "address" },
                        { "field_type": 3, "help_text": "room that this office is in", "name": "room", "verbose_name": "room" },
                        { "field_type": 3, "help_text": "the name of the building the office is in", "name": "building", "verbose_name": "building" },
                        { "field_type": 3, "help_text": "first line of street address", "name": "street1", "verbose_name": "street1" },
                        { "field_type": 3, "help_text": "second line of street address", "name": "street2", "verbose_name": "street2" },
                        { "field_type": 3, "help_text": "ZipCode of address", "name": "zipcode", "verbose_name": "zipcode" },
                        { "field_type": 3, "help_text": "phone number", "name": "phone", "verbose_name": "phone" },
                        { "field_type": 3, "help_text": "city", "name": "city", "verbose_name": "city" },
                        { "field_type": 3, "help_text": "state", "name": "state", "verbose_name": "state" },
                        { "field_type": 13, "help_text": "", "name": "latitude", "verbose_name": "latitude" },
                        { "field_type": 13, "help_text": "", "name": "longitude", "verbose_name": "longitude" },
                        { "field_type": 16, "help_text": "The last time KW updated this member office's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 2, "help_text": "KnowWho Office ID", "name": "kw_officeid", "verbose_name": "kw officeid" },
                        { "field_type": 4, "help_text": "KnowWho Office ID for County Muni", "name": "kw_cm_officeid", "verbose_name": "kw cm officeid" },
                        { "field_type": 4, "help_text": "The Address id for a given position/organization's address in Leadership Connect", "name": "_ph_lc_address_id", "verbose_name": " ph lc address id" },
                        { "field_type": 4, "help_text": "The state_legislator_address_id for a given state_legislator_address in Legistorm", "name": "_ph_ls_state_legislator_address_id", "verbose_name": " ph ls state legislator address id" }
                    ]
                },
                "NewPerson": {
                    "__is_model": true,
                    "__name__": "NewPerson",
                    "data_model": "app.person.models.NewPerson",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "show_in_quicksearch": true },
                    "endpoint": "/api/newperson/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The QuorumUser that created this record.",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Quorum Client Organization that owns this record.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The person's UID/MEMID on Know Who", "name": "kw_uid", "verbose_name": "kw uid" },
                        { "field_type": 2, "help_text": "ID on bioguide.congress.gov. May be null if the person served only as a president.", "name": "bioguideid", "verbose_name": "bioguideid" },
                        { "field_type": 2, "help_text": "The person's ID on thomas.congress.gov.", "name": "thomasid", "verbose_name": "thomasid" },
                        { "field_type": 2, "help_text": "The OpenStates id for person, if known, comma separated", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 2, "help_text": "The name of the person's LIS id, if known.", "name": "lisid", "verbose_name": "lisid" },
                        {
                            "field_type": 4,
                            "help_text": "Number of terms this person spans in their current role",
                            "miscellaneous": 1,
                            "name": "num_terms",
                            "sheet_column": true,
                            "sheets_column_order": 10,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 10002, 10004, 10005, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 1000],
                            "verbose_name": "Number of Terms"
                        },
                        { "field_type": 3, "help_text": "A list of all the committees that this official sits on.", "miscellaneous": 1, "name": "committee_string", "sheet_column": true, "sheets_column_order": 25, "sheets_subcategory": 6, "verbose_name": "Committee List" },
                        { "field_type": 3, "help_text": "A list of all the parties this person is affiliated with", "name": "party_string", "verbose_name": "Parties" },
                        { "field_type": null, "help_text": "", "name": "committee_id_name_arr", "verbose_name": "committee id name arr" },
                        { "field_type": 3, "help_text": "Email address the member uses to reach out to constituents", "name": "constituent_email", "verbose_name": "constituent email" },
                        { "field_type": 1, "help_text": "Whether or not a person has been a legislator, now or at anytime in the past.", "name": "has_been_legislator", "verbose_name": "has been legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member is brand new in their region.", "name": "new_legislator", "verbose_name": "new legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member recently switched chambers in their region.", "name": "new_chamber", "verbose_name": "new chamber" },
                        { "field_type": 1, "help_text": "If this person is a freshman legislator", "name": "freshman_legislator", "verbose_name": "freshman legislator" },
                        { "field_type": 2, "help_text": "Know Who staffer ID", "name": "kw_sid", "verbose_name": "kw sid" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "personrole",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "personrole"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ComStafferType" },
                            "field_type": 4,
                            "help_text": "Whether Staffer is affiliated with a majority or minority committee only",
                            "name": "comstaffertype",
                            "verbose_name": "comstaffertype"
                        },
                        { "field_type": null, "help_text": "All staffer types corresponding to this person", "name": "staffer_types", "verbose_name": "staffer types" },
                        { "field_type": 4, "help_text": "Highest rank of the staffer's various titlecodes", "name": "titlecode_order", "verbose_name": "titlecode order" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "location",
                            "related_model": { "__module__": "app.person.models", "__name__": "MemberOffice" },
                            "verbose_name": "location"
                        },
                        { "field_type": 2, "help_text": "Responsibilities", "miscellaneous": 8, "name": "responsibilities_string", "sheet_column": true, "sheets_column_order": 10, "verbose_name": "Responsibilities" },
                        { "field_type": 2, "help_text": "The person's EXECID on Know Who", "name": "kw_execid", "verbose_name": "kw execid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SpecificExecutiveRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_executive_role",
                            "verbose_name": "most recent executive role"
                        },
                        { "field_type": 2, "help_text": "The person's UID on Know Who, call it kw_locid to differentiate btw members.", "name": "kw_locid", "verbose_name": "kw locid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveBranch" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_branch",
                            "verbose_name": "most recent local branch"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveDepartment" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_department",
                            "verbose_name": "most recent local department"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The most recent legislature the person has been a part of",
                            "miscellaneous": 1,
                            "name": "most_recent_region",
                            "sheet_column": true,
                            "sheets_column_order": 15,
                            "sheets_display_key": "region_name",
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Region"
                        },
                        { "field_type": null, "help_text": "\n            All regions the person was a part of in their most recent role(s).\n            For example, an EU person can be in [Region.eu, Region.france]\n        ", "name": "most_recent_regions", "verbose_name": "most recent regions" },
                        {
                            "field_type": 7,
                            "help_text": "The country that an official represents. For EU officials, this will be their international country they represent for the EU. International and US officials will use their respective countries.",
                            "name": "representing_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "representing country"
                        },
                        { "field_type": null, "help_text": "All regions corresponding to former roles of this Official.", "name": "_ph_dn_former_regions", "verbose_name": " ph dn former regions" },
                        { "field_type": null, "help_text": "All regions corresponding to the current and former roles of this Official.", "name": "_ph_dn_all_regions", "verbose_name": " ph dn all regions" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.geography.models", "__name__": "DistrictType" },
                            "field_type": 4,
                            "help_text": "The type of district",
                            "name": "most_recent_district_type",
                            "verbose_name": "most recent district type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The current US state of this person",
                            "miscellaneous": 1,
                            "name": "most_recent_state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "sheet_column": true,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "US State"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "most recent district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_upper_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "most recent upper district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_lower_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "most recent lower district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "most recent county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "most recent municipality"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "miscellaneous": 1,
                            "name": "most_recent_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                            "verbose_name": "Country"
                        },
                        { "field_type": 1, "help_text": "Whether this individual currently holds a role, or if this is archival information.", "name": "current", "verbose_name": "current" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonStatus" },
                            "field_type": 4,
                            "help_text": "The status of this person (active, incoming, leaving or former).",
                            "miscellaneous": 1,
                            "name": "status",
                            "sheet_column": true,
                            "sheets_column_order": 22,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Election Status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the most recent role of the person.",
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "most recent role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "RoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_role_type",
                            "verbose_name": "most recent role type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of people:\n                ExecutiveRoleType\n                LocalExecutiveRoleType\n                etc...\n            ", "name": "most_recent_role_sub_type", "verbose_name": "most recent role sub type" },
                        { "field_type": 3, "help_text": "the address of this person's most recent role", "name": "most_recent_role_address", "verbose_name": "most recent role address" },
                        { "field_type": 3, "help_text": "the room of this person's most recent role", "name": "most_recent_role_room", "verbose_name": "most recent role room" },
                        { "field_type": 3, "help_text": "the name of the office building of this person's most recent role", "name": "most_recent_role_building", "verbose_name": "most recent role building" },
                        { "field_type": 3, "help_text": "first line of the street address of this person's most recent role", "name": "most_recent_role_street1", "verbose_name": "most recent role street1" },
                        { "field_type": 3, "help_text": "second line of the street address of this person's most recent role", "name": "most_recent_role_street2", "verbose_name": "most recent role street2" },
                        { "field_type": 3, "help_text": "the ZipCode of this person's most recent role", "name": "most_recent_role_zipcode", "verbose_name": "most recent role zipcode" },
                        { "field_type": 3, "help_text": "the phone number of this person's most recent role", "name": "most_recent_role_phone", "verbose_name": "most recent role phone" },
                        { "field_type": 3, "help_text": "the city of this person's most recent role", "name": "most_recent_role_city", "verbose_name": "most recent role city" },
                        { "field_type": 3, "help_text": "the state of this person's most recent role", "name": "most_recent_role_state", "verbose_name": "most recent role state" },
                        { "field_type": 2, "help_text": "The last known leadership role held during this role, if any.", "name": "most_recent_leadership_title", "verbose_name": "most recent leadership title" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The most recent political party of the person.",
                            "name": "most_recent_party",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Party"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "used to determine the perceived party of independents",
                            "name": "perceived_party",
                            "verbose_name": "perceived party"
                        },
                        { "field_type": null, "help_text": "The different major global types held by this legislator(e.g. Head of State, Top-Level Cabinet Member, etc.)", "name": "major_person_types", "verbose_name": "major person types" },
                        { "field_type": null, "help_text": "The different minor types held by this legislator, oftentimes specific to a region/country(e.g. Senator, Department Secretary, etc.)", "name": "minor_person_types", "verbose_name": "minor person types" },
                        { "field_type": null, "help_text": "The different specific types held by this legislator(e.g. Speaker, House Majority Leader, etc.)", "name": "specific_person_types", "verbose_name": "specific person types" },
                        { "field_type": 3, "help_text": "The (international) region that this person represents as text, until we have shapefiles that we can map to", "name": "region_represented", "verbose_name": "region represented" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_sector_type",
                            "verbose_name": "most recent ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_meta_role_type",
                            "verbose_name": "most recent ph meta role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_major_role_type",
                            "verbose_name": "most recent ph major role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_minor_role_type",
                            "verbose_name": "most recent ph minor role type"
                        },
                        { "field_type": null, "help_text": "", "name": "most_recent_ph_specific_role_types", "verbose_name": "most recent ph specific role types" },
                        { "field_type": 16, "help_text": "The last time KW updated this person's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 16, "help_text": "The last time Intrado updated the object in their database corresponding to this Person.", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 16, "help_text": "The last time we attempted to flush this person", "name": "last_attempted_flush", "verbose_name": "last attempted flush" },
                        { "field_type": 16, "help_text": "The last time we successfully flushed this person", "name": "last_successful_flush", "verbose_name": "last successful flush" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": 2, "help_text": "Facebook ID", "name": "facebookid", "verbose_name": "facebookid" },
                        { "field_type": 2, "help_text": "The url of the facebook page", "name": "facebook_url", "verbose_name": "facebook url" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": 2, "help_text": "The name of the person's official Twitter handle, if known.", "name": "twitterid", "verbose_name": "twitterid" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": 2, "help_text": "The ID of the person's official YouTube channel, if known.", "name": "youtubeid", "verbose_name": "youtubeid" },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the current role of the person, if present.",
                            "name": "current_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "current role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "DemographicType" },
                            "field_type": 4,
                            "help_text": "Represent a state or district",
                            "name": "demographic_type",
                            "verbose_name": "demographic type"
                        },
                        { "field_type": 2, "help_text": "The House History id of the person, if known.", "name": "househistoryid", "verbose_name": "househistoryid" },
                        { "field_type": 4, "help_text": "The ICPSR id of the person (Poole and Rosenthal), if known.", "name": "icpsrid", "verbose_name": "icpsrid" },
                        { "field_type": 16, "help_text": "The last time the Person object was updated", "name": "last_updated", "verbose_name": "last updated" },
                        {
                            "field_type": 7,
                            "help_text": "The Corresponding Old Staffer Object",
                            "name": "legacy_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "legacy staffer"
                        },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (donation to legislator/candidate with id)", "name": "legislator_candidate_id", "verbose_name": "legislator candidate id" },
                        { "field_type": 4, "help_text": "The Maplight id of the person, if known.", "name": "maplightid", "verbose_name": "maplightid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ExecutivePosition" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_position",
                            "verbose_name": "most recent position"
                        },
                        { "field_type": 4, "help_text": "The official ID given by a state website for a legislator.", "name": "official_stateid", "verbose_name": "official stateid" },
                        { "field_type": 4, "help_text": "DEPRECATED", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 2, "help_text": "The person's ID on opensecrets.org (The Center for Responsive Politics), if known.", "name": "osid", "verbose_name": "osid" },
                        { "field_type": 2, "help_text": "The person's ID on vote-smart.org (Project Vote Smart), if known.", "name": "pvsid", "verbose_name": "pvsid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionDeliveryType" },
                            "field_type": 4,
                            "help_text": "If member requires special treatment for delivering supporter messages (i.e. recaptcha on form).",
                            "name": "supporter_action_delivery_type",
                            "verbose_name": "supporter action delivery type"
                        },
                        { "field_type": 2, "help_text": "The name of the person's id in the Washington Post, if known.", "name": "wpid", "verbose_name": "wpid" },
                        { "field_type": 4, "help_text": "KnowWho's PersonID for the tblPeople entry corresponding to this Person.", "name": "_ph_kw_person_id", "verbose_name": " ph kw person id" },
                        { "field_type": 3, "help_text": "\n            A person's IE (Information Evolution) ID. If they have this ID,\n            they were at some point collected or enriched by the consultants\n        ", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        { "field_type": 1, "help_text": "If True, this Person is ready for frontend consumption. Set True during flushing.", "name": "_ph_is_clean", "verbose_name": " ph is clean" },
                        { "field_type": 1, "help_text": "Marks that we should flush this person in the next Bidet run", "name": "_ph_should_flush_next_run", "verbose_name": " ph should flush next run" },
                        { "field_type": 4, "help_text": "A UniqueID for a Person originating from the Intrado data source.", "name": "_ph_intrado_person_id", "verbose_name": " ph intrado person id" },
                        { "field_type": 4, "help_text": "Leadership Connect's PersonID for a Person.", "name": "_ph_lc_person_id", "verbose_name": " ph lc person id" },
                        { "field_type": 4, "help_text": "The core_person_id for the Legistorm core_person this Person represents.", "name": "_ph_ls_core_person_id", "verbose_name": " ph ls core person id" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from currently held PersonRoles.", "name": "_ph_dn_current_sector_types", "verbose_name": " ph dn current sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_meta_role_types", "verbose_name": " ph dn current meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_major_role_types", "verbose_name": " ph dn current major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_minor_role_types", "verbose_name": " ph dn current minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from currently held PersonRoles.", "name": "_ph_dn_current_specific_role_types", "verbose_name": " ph dn current specific role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from formerly held PersonRoles.", "name": "_ph_dn_former_sector_types", "verbose_name": " ph dn former sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_meta_role_types", "verbose_name": " ph dn former meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_major_role_types", "verbose_name": " ph dn former major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_minor_role_types", "verbose_name": " ph dn former minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from formerly held PersonRoles.", "name": "_ph_dn_former_specific_role_types", "verbose_name": " ph dn former specific role types" },
                        { "field_type": null, "help_text": "All of the intrado Tag names from a person's PersonRoles.", "name": "_ph_dn_intrado_tags", "verbose_name": " ph dn intrado tags" },
                        { "field_type": null, "help_text": "Denormalization of intrado languages from PersonRoles.", "name": "_ph_dn_intrado_languages", "verbose_name": " ph dn intrado languages" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoPreferredDistributionMode" },
                            "field_type": 4,
                            "help_text": "Denormalization of intrado PreferredDistributionMode from PersonRoles.",
                            "name": "_ph_dn_intrado_preferred_distribution_mode",
                            "verbose_name": " ph dn intrado preferred distribution mode"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_person_type",
                            "verbose_name": "most recent person type"
                        },
                        { "field_type": 3, "help_text": "The person's most recent title.", "name": "title", "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 3, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The person's full name with title, district, and party information for current Members of Congress.Also allows the sheet to be more easily ordered alphabetically.", "name": "name", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Name" },
                        { "field_type": 2, "help_text": "The person's first name or first initial.", "name": "firstname", "sheet_column": true, "sheets_column_order": 2, "sheets_subcategory": 3, "verbose_name": "First Name" },
                        { "field_type": 2, "help_text": "The person's last name.", "name": "lastname", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 3, "verbose_name": "Last Name" },
                        { "field_type": 2, "help_text": "The person's middle name (optional).", "name": "middlename", "verbose_name": "middlename" },
                        { "field_type": 3, "help_text": "The prefix on the person's name, usually one of Dr., Ms., etc. This is usually different than their titles", "name": "prefix", "verbose_name": "prefix" },
                        { "field_type": 2, "help_text": "The suffix on the person's name usually one of Jr., Sr., I, II, etc.", "name": "namemod", "verbose_name": "namemod" },
                        { "field_type": 2, "help_text": "If set, the nickname should usually be displayed in quotes where a middle name would go.", "name": "nickname", "verbose_name": "nickname" },
                        { "field_type": 2, "help_text": "Pronunciation", "name": "pronunciation", "verbose_name": "pronunciation" },
                        { "field_type": 1, "help_text": "Whether the name has been manually overwritten and wont be updated from KW", "name": "has_custom_name", "verbose_name": "has custom name" },
                        { "field_type": 2, "help_text": "Public Organization Descriptor", "name": "public_organization_descriptor", "verbose_name": "public organization descriptor" },
                        { "field_type": 1, "help_text": "", "name": "show_in_quicksearch", "verbose_name": "show in quicksearch" },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" },
                        { "field_type": 4, "help_text": "", "name": "precedence_local", "verbose_name": "precedence local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state", "verbose_name": "precedence state" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state_and_local", "verbose_name": "precedence state and local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_eu", "verbose_name": "precedence eu" },
                        { "field_type": 2, "help_text": "The person's ascii first name or first initial.", "name": "firstname_search", "verbose_name": "firstname search" },
                        { "field_type": 2, "help_text": "The person's ascii last name.", "name": "lastname_search", "verbose_name": "lastname search" },
                        { "field_type": 2, "help_text": "The person's ascii middle name (optional).", "name": "middlename_search", "verbose_name": "middlename search" },
                        { "field_type": 3, "help_text": "The person's unicode full name with firstname, lastname, and nickname information for Person.\n                    In cases with accented names, represent the accented and unaccented (unidecoded) name in the same\n                    string for searching capabilities.\n                ", "name": "name_search", "verbose_name": "name search" },
                        { "field_type": 5, "help_text": "The person's birthday.", "name": "birthday", "verbose_name": "Birthday" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Gender" },
                            "field_type": 4,
                            "help_text": "The person's gender, if known. For historical data, the gender is sometimes not known.",
                            "miscellaneous": 1,
                            "name": "gender",
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "verbose_name": "Gender"
                        },
                        { "field_type": 2, "help_text": "The person's email.", "is_contact_info": true, "name": "email", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Email" },
                        {
                            "field_type": 3,
                            "help_text": "Alternate Email for this Press Contact",
                            "miscellaneous": 120,
                            "name": "intrado_other_email",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "verbose_name": "Alternate Email"
                        },
                        { "field_type": 1, "help_text": "whether the email is valid and/or verified", "name": "valid_email", "verbose_name": "valid email" },
                        { "field_type": 2, "help_text": "The person's PID on Know Who", "name": "kw_pid", "verbose_name": "kw pid" },
                        { "field_type": 2, "help_text": "The person's OFCID's on Know Who, comma separated", "name": "kw_ofcid", "verbose_name": "kw ofcid" },
                        { "field_type": 4, "help_text": "The ID of the person on CSPAN websites, if known.", "name": "cspanid", "verbose_name": "cspanid" },
                        { "field_type": 2, "help_text": "The official ID given by a state website for a legislator, but in unicode.", "name": "external_state_id", "verbose_name": "external state id" },
                        { "field_type": 3, "help_text": "The local path of the image for a person on update/state update, which is often under settings.DATA_PATH", "name": "local_image_path", "verbose_name": "local image path" },
                        { "field_type": 3, "help_text": "The URL of this person's image/avatar that is actually rendered on the frontend (most likely an S3 URL with correct CORS)", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 3, "help_text": "Original image url location that we get from the outside world, as one would find via Google Images Search", "name": "source_image_url", "verbose_name": "source image url" },
                        { "field_type": 3, "help_text": "The high quality path of this members image", "name": "high_quality_local_image_path", "verbose_name": "high quality local image path" },
                        { "field_type": 3, "help_text": "Cached path of high quality image url", "name": "high_quality_image_url", "verbose_name": "high quality image url" },
                        { "field_type": 3, "help_text": "The Wikipedia URL for this person, if any", "name": "wikipedia_url", "verbose_name": "wikipedia url" },
                        { "field_type": null, "help_text": "The different urls where we can find this person on the web (via our consultants)", "name": "source_urls", "verbose_name": "source urls" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "primary_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "primary organization"
                        },
                        { "field_type": null, "help_text": "The different types of leadership roles held by this legislator.", "name": "leadership_types", "verbose_name": "leadership types" },
                        { "field_type": 1, "help_text": "Whether the leadership types have been manually overwritten or can be set automatically.", "name": "custom_leadership_types", "verbose_name": "custom leadership types" },
                        { "field_type": null, "help_text": "Stores all external unique IDs for faster matching Person objects from vendors like DDC & Cision", "name": "external_unique_id_dict", "verbose_name": "external unique id dict" },
                        { "field_type": null, "help_text": "A person's WhoisWho ID", "name": "wiw_ids", "verbose_name": "wiw ids" },
                        { "field_type": 4, "help_text": "A persons's EU MEP ID", "name": "mepid", "verbose_name": "mepid" },
                        { "field_type": 2, "help_text": "Consultant added person's LegislatorID from international persons sheet", "name": "legislator_id", "verbose_name": "legislator id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ProfileInfoSource" },
                            "field_type": 4,
                            "help_text": "The most recent site from which we have scraped information to fill out the person's profile",
                            "name": "most_recent_profile_info_source",
                            "verbose_name": "most recent profile info source"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "send_messages_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "send messages to"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 3, "help_text": "The office code for a US Congressperson. Used in Grassroots delivery by the\n                     CWC for message routing. House format: H{state_abbrev}{district_number}.\n                     Senate format: S{state_abbrev}{senate_class_number}.", "name": "office_code", "verbose_name": "office code" },
                        { "field_type": 1, "help_text": "Whether or not this person should be delivered via fill forms", "name": "should_deliver_via_fill_form", "verbose_name": "should deliver via fill form" },
                        { "field_type": 1, "help_text": "If the Member has a valid office code in CWC", "name": "is_cwc", "verbose_name": "is cwc" },
                        { "field_type": 3, "help_text": "LinkedIn Username", "name": "linkedin_username", "verbose_name": "linkedin username" },
                        { "field_type": null, "help_text": "All the AppointedByTypes for a given person", "name": "dn_appointed_by_types", "verbose_name": "dn appointed by types" },
                        { "field_type": null, "help_text": "All the PayScales for a given person", "name": "dn_pay_scale_types", "verbose_name": "dn pay scale types" },
                        {
                            "field_type": 8,
                            "help_text": "All the congresses this person spans",
                            "name": "congresses",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congresses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the sessions this person spans.",
                            "name": "sessions",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "sessions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "titlecode",
                            "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                            "verbose_name": "titlecode"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "responsibilities",
                            "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                            "verbose_name": "responsibilities"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "beats",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "Beat" },
                            "sheet_column": true,
                            "verbose_name": "beats"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dma",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "DesignatedMarketArea" },
                            "sheet_column": true,
                            "verbose_name": "dma"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this person is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "biography",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonBiography" },
                            "sheet_column": true
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "sheet_column": true
                        }
                    ],
                    "proxy_endpoint": "/api/person/"
                },
                "NewPersonBiography": {
                    "__is_model": true,
                    "__name__": "NewPersonBiography",
                    "data_model": "app.person.models.NewPersonBiography",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newpersonbiography/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 5, "help_text": "The person's date of birth.", "miscellaneous": 1, "name": "_ph_birthdate", "sheet_column": true, "sheets_subcategory": 6, "verbose_name": "Date of Birth" },
                        { "field_type": 5, "help_text": "The person's date of death.", "name": "_ph_deathdate", "verbose_name": "Date of Death" },
                        { "field_type": null, "help_text": "\n        A list of dictionaries containing information about current and former roles,\n        memberships, educational experiences, or similar for the Person to whom this PersonBiography belongs.\n\n        In the US, this data is sourced from current and former PersonRoles as well as less-structured \"role-like\"\n        KnowWho tables like tblpeoplemilitary (military experience), tblpeopledirector (directorships), etc.\n\n        Every entry in this list should follow ROLE_DATA_SCHEMA.\n        ", "name": "_ph_role_data", "verbose_name": " ph role data" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        { "field_type": 3, "help_text": "Biography from KnowWho", "name": "kw_biography", "verbose_name": "kw biography" },
                        { "field_type": 3, "help_text": "Biography from EU Website", "name": "eu_biography", "verbose_name": "eu biography" },
                        { "field_type": 3, "help_text": "Biography from Quorum", "name": "quorum_biography", "verbose_name": "quorum biography" },
                        { "field_type": 3, "help_text": "Biography from the Almanac of American Politics", "name": "almanac_biography", "verbose_name": "almanac biography" },
                        { "field_type": 3, "help_text": "Biography from our international data provider Information Evolution,not to be confused with the best web browser ever created", "name": "ie_biography", "verbose_name": "ie biography" },
                        { "field_type": 3, "help_text": "Biography from Intrado if they ever send us our data", "name": "intrado_biography", "verbose_name": "intrado biography" },
                        { "field_type": 3, "help_text": "The responsibilities of a person, from commission website", "name": "eu_responsibilities", "verbose_name": "eu responsibilities" },
                        { "field_type": 2, "help_text": "A PDF of a biography or CV", "name": "bio_pdf_url", "verbose_name": "bio pdf url" },
                        { "field_type": 2, "help_text": "A PDF of a declaration of interests, used in EU", "name": "declaration_of_interests_pdf_url", "verbose_name": "declaration of interests pdf url" },
                        { "field_type": 3, "help_text": "The full text of any PDFs to be searched", "name": "bio_pdf_fts_text", "verbose_name": "bio pdf fts text" },
                        {
                            "field_type": 5,
                            "help_text": "Date Assumed Office for Current Role",
                            "miscellaneous": 1,
                            "name": "dateelected",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Date Assumed Office"
                        },
                        {
                            "field_type": 5,
                            "help_text": "The date the official was first elected into their current primary role.",
                            "miscellaneous": 1,
                            "name": "first_election_date",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "First Elected Date"
                        },
                        {
                            "field_type": 5,
                            "help_text": "The date the official was first appointed into their current primary role.",
                            "miscellaneous": 1,
                            "name": "assumed_office_date",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Assumed Office Date"
                        },
                        { "field_type": 2, "help_text": "The person's birthplace", "name": "birthplace", "verbose_name": "birthplace" },
                        { "field_type": 2, "help_text": "The person's birth state", "name": "birthstate", "verbose_name": "birthstate" },
                        { "field_type": 2, "help_text": "The person's marital status", "name": "marital", "verbose_name": "marital" },
                        {
                            "field_type": 2,
                            "help_text": "The person's spouse",
                            "miscellaneous": 1,
                            "name": "spouse",
                            "sheet_column": true,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Spouse"
                        },
                        { "field_type": 2, "help_text": "The person's residence", "name": "residence", "verbose_name": "residence" },
                        { "field_type": 2, "help_text": "The person's family", "name": "family", "verbose_name": "family" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Religion" },
                            "field_type": 4,
                            "help_text": "The person's religious background.",
                            "miscellaneous": 1,
                            "name": "religion",
                            "sheet_column": true,
                            "sheets_column_order": 20,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Religion"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Ethnicity" },
                            "field_type": 4,
                            "help_text": "The person's ethnicity.",
                            "name": "ethnicity",
                            "verbose_name": "Ethnicity"
                        },
                        { "field_type": 3, "help_text": "The person's first previous role", "name": "previousrole1type", "verbose_name": "previousrole1type" },
                        { "field_type": 2, "help_text": "the person's first previous role end date", "name": "previousrole1dates", "verbose_name": "previousrole1dates" },
                        { "field_type": 3, "help_text": "The person's second previous role", "name": "previousrole2type", "verbose_name": "previousrole2type" },
                        { "field_type": 2, "help_text": "the person's second previous role start date", "name": "previousrole2dates", "verbose_name": "previousrole2dates" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Occupations" },
                            "field_type": 4,
                            "help_text": "Occupation prior to political career",
                            "name": "previousindustry1",
                            "verbose_name": "previousindustry1"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Occupations" },
                            "field_type": 4,
                            "help_text": "Occupation prior to political career",
                            "name": "previousindustry2",
                            "verbose_name": "previousindustry2"
                        },
                        { "field_type": 2, "help_text": "Education", "name": "education1", "verbose_name": "education1" },
                        { "field_type": 2, "help_text": "Degree type", "name": "degree1", "verbose_name": "degree1" },
                        { "field_type": 4, "help_text": "Degree date", "name": "degreedate1", "verbose_name": "degreedate1" },
                        { "field_type": 2, "help_text": "Education 2", "name": "education2", "verbose_name": "education2" },
                        { "field_type": 2, "help_text": "Degree type 2", "name": "degree2", "verbose_name": "degree2" },
                        { "field_type": 4, "help_text": "Degree date 2", "name": "degreedate2", "verbose_name": "degreedate2" },
                        { "field_type": 2, "help_text": "Education 3", "name": "education3", "verbose_name": "education3" },
                        { "field_type": 2, "help_text": "Degree type 3", "name": "degree3", "verbose_name": "degree3" },
                        { "field_type": 4, "help_text": "Degree date 3", "name": "degreedate3", "verbose_name": "degreedate3" },
                        { "field_type": 2, "help_text": "Institution of undergrad", "name": "undergrad_institution", "verbose_name": "undergrad institution" },
                        { "field_type": 2, "help_text": "Institution of graduate", "name": "graduate_institution", "verbose_name": "graduate institution" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "TerminalDegree" },
                            "field_type": 4,
                            "help_text": "The last degree the person received.",
                            "miscellaneous": 1,
                            "name": "terminal_degree",
                            "sheet_column": true,
                            "sheets_column_order": 19,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Terminal Degree"
                        },
                        { "field_type": 2, "help_text": "Military background branch", "name": "militarybranch1", "verbose_name": "militarybranch1" },
                        { "field_type": 2, "help_text": "military role", "name": "militaryrole1", "verbose_name": "militaryrole1" },
                        { "field_type": 2, "help_text": "Military startdate", "name": "military1dates", "verbose_name": "military1dates" },
                        { "field_type": 2, "help_text": "Military 2 background branch", "name": "militarybranch2", "verbose_name": "militarybranch2" },
                        { "field_type": 2, "help_text": "military 2 role", "name": "militaryrole2", "verbose_name": "militaryrole2" },
                        { "field_type": 2, "help_text": "Military 2 startdate", "name": "military2dates", "verbose_name": "military2dates" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 16, "help_text": "The last time KW updated this biography's information", "name": "kw_last_updated", "verbose_name": "kw last updated" }
                    ],
                    "proxy_endpoint": "/api/personbiography/"
                },
                "NewPersonRole": {
                    "__is_model": true,
                    "__name__": "NewPersonRole",
                    "data_model": "app.person.models.NewPersonRole",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/newpersonrole/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SenatorClass" },
                            "field_type": 4,
                            "help_text": "For senators, their election class, which determines which years they are up for election.",
                            "name": "senator_class",
                            "verbose_name": "senator class"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SenatorRank" },
                            "field_type": 4,
                            "help_text": "For senators, their state rank, i.e. junior/senior. For historical data, this is their last known rank.",
                            "name": "senator_rank",
                            "verbose_name": "senator rank"
                        },
                        { "field_type": 4, "help_text": "The Person's rank in chamber, from Know Who", "name": "chamberrank", "verbose_name": "chamberrank" },
                        { "field_type": 4, "help_text": "The Person's rank in party, from Know Who", "name": "partyrank", "verbose_name": "partyrank" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ElectCode" },
                            "field_type": 4,
                            "help_text": "How the person was elected to congress",
                            "name": "electcode",
                            "verbose_name": "electcode"
                        },
                        { "field_type": 4, "help_text": "ADA Score for member of congress", "name": "adascore", "verbose_name": "adascore" },
                        { "field_type": 4, "help_text": "ACU Score for member of congress", "name": "acuscore", "verbose_name": "acuscore" },
                        { "field_type": 4, "help_text": "AFL-CIO Score for member of congress", "name": "aflscore", "verbose_name": "aflscore" },
                        { "field_type": 4, "help_text": "CCUS Score for member of congress", "name": "ccusscore", "verbose_name": "ccusscore" },
                        { "field_type": 4, "help_text": "Club For Growth Lifetime Economic Growth Score for member of congress", "name": "cfgscore", "verbose_name": "cfgscore" },
                        { "field_type": 4, "help_text": "NARAL public score for legislators", "name": "naralscore", "verbose_name": "naralscore" },
                        { "field_type": 6, "help_text": "Latitude from Zip-State combo for travel visualization", "name": "travelviz_latitude", "verbose_name": "travelviz latitude" },
                        { "field_type": 6, "help_text": "Longitude from Zip-State combo for travel visualization", "name": "travelviz_longitude", "verbose_name": "travelviz longitude" },
                        {
                            "field_type": 7,
                            "help_text": "The term for which the Person Role exists.",
                            "name": "term",
                            "related_model": { "__module__": "app.models", "__name__": "Term" },
                            "verbose_name": "term"
                        },
                        { "field_type": 2, "help_text": "\n            A 9-character alphanumeric code assigned to a candidacy by the FEC.\n            Remains the same across election cycles as long as the candidate runs for the\n            same office.\n\n            Corresponds to government.tbllegmem.FECLinkNum in KnowWho level-3 data\n        ", "name": "fec_id", "verbose_name": "fec id" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "for_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "for person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ComStafferType" },
                            "field_type": 4,
                            "help_text": "Whether Staffer is affiliated with a majority or minority committee only",
                            "name": "comstaffertype",
                            "verbose_name": "comstaffertype"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "_ph_location",
                            "related_model": { "__module__": "app.person.models", "__name__": "MemberOffice" },
                            "verbose_name": " ph location"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveBranch" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "local_branch",
                            "verbose_name": "local branch"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "municipality"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SpecificExecutiveRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "executive_role",
                            "verbose_name": "executive role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_sector_type",
                            "verbose_name": " ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_meta_role_type",
                            "verbose_name": " ph meta role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_major_role_type",
                            "verbose_name": " ph major role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_minor_role_type",
                            "verbose_name": " ph minor role type"
                        },
                        { "field_type": null, "help_text": "SpecificRoleTypes corresponding to this role", "name": "_ph_specific_role_types", "verbose_name": " ph specific role types" },
                        { "field_type": 3, "help_text": "ID on bioguide.congress.gov. May be null if the person served only as a president.", "name": "_ph_bioguideid", "verbose_name": " ph bioguideid" },
                        { "field_type": 3, "help_text": "Unicode representation of the official ID given by a state website for a legislator.", "name": "_ph_external_state_id", "verbose_name": " ph external state id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecPosID for the tblExecPos entry corresponding to this PersonRole. Corresponds to EXECID in Level-2 data.", "name": "_ph_kw_exec_pos_id", "verbose_name": " ph kw exec pos id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecCandidateID for the tblExecCandidate entry corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_exec_candidate_id", "verbose_name": " ph kw exec candidate id" },
                        { "field_type": null, "help_text": "KnowWho's ExecElectIDs for the set of tblExecElect entries corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_exec_elect_ids", "verbose_name": " ph kw exec elect ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegMemID for the tblLegMem entry corresponding to this PersonRole. Corresponds to UID in Level-2 data.", "name": "_ph_kw_leg_mem_id", "verbose_name": " ph kw leg mem id" },
                        { "field_type": 4, "help_text": "KnowWho's LegCandidateID for the tblLegCandidate entry corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_leg_candidate_id", "verbose_name": " ph kw leg candidate id" },
                        { "field_type": null, "help_text": "KnowWho's LegElectIDs for the tblLegElect entries corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_leg_elect_ids", "verbose_name": " ph kw leg elect ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegOfcID for the tblLegOfc entry corresponding to this PersonRole.", "name": "_ph_kw_leg_ofc_id", "verbose_name": " ph kw leg ofc id" },
                        { "field_type": 4, "help_text": "KnowWho's LegComMemberID for the tblLegComMember entry corresponding to this PersonRole. Corresponds to COMMEMID in Level-2 data.", "name": "_ph_kw_leg_com_member_id", "verbose_name": " ph kw leg com member id" },
                        { "field_type": 4, "help_text": "KnowWho's PositionID for the tblExecLegJudPositions entry corresponding to this PersonRole. Corresponds to UID in countymuni_2/Officials.csv in Level-2 data.", "name": "_ph_kw_cm_position_id", "verbose_name": " ph kw cm position id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecPosStaffID for the tblExecPosStaff entry corresponding to this PersonRole.", "name": "_ph_kw_exec_pos_staff_id", "verbose_name": " ph kw exec pos staff id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecCandidateStaffID for the tblExecCandidateStaff entry corresponding to this PersonRole.", "name": "_ph_kw_exec_candidate_staff_id", "verbose_name": " ph kw exec candidate staff id" },
                        { "field_type": null, "help_text": "KnowWho's ExecElectStaffIDs for the tblExecElectStaff entries corresponding to this PersonRole.", "name": "_ph_kw_exec_elect_staff_ids", "verbose_name": " ph kw exec elect staff ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegMemStaffID for the tblLgMemStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_mem_staff_id", "verbose_name": " ph kw leg mem staff id" },
                        { "field_type": 4, "help_text": "KnowWho's KegCandidateStaffID for the tblLegCandidateStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_candidate_staff_id", "verbose_name": " ph kw leg candidate staff id" },
                        { "field_type": null, "help_text": "KnowWho's LegElectStaffIDs for the tblLegElectStaff entries corresponding to this PersonRole.", "name": "_ph_kw_leg_elect_staff_ids", "verbose_name": " ph kw leg elect staff ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegOfcStafffID for the tblLegOfcStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_ofc_staff_id", "verbose_name": " ph kw leg ofc staff id" },
                        { "field_type": 4, "help_text": "KnowWho's LegComStaffID for the tblLegCOmStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_com_staff_id", "verbose_name": " ph kw leg com staff id" },
                        { "field_type": 3, "help_text": "A persons's EU MEP ID", "name": "_ph_mepid", "verbose_name": " ph mepid" },
                        { "field_type": 3, "help_text": "A person's WhoisWho ID", "name": "_ph_wiwid", "verbose_name": " ph wiwid" },
                        { "field_type": 3, "help_text": "\n            A person's IE (Information Evolution) ID. If they have this ID,\n            they were at some point collected or enriched by the consultants\n        ", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        { "field_type": 4, "help_text": "KnowWho's PositionID for the tblIntlPosition entry corresponding to this PersonRole.", "name": "_ph_kw_position_id", "verbose_name": " ph kw position id" },
                        { "field_type": 4, "help_text": "Leadership Connect PositionID corresponding to a PersonRole.", "name": "_ph_lc_position_id", "verbose_name": " ph lc position id" },
                        { "field_type": 4, "help_text": "Legistorm state_legislator_staff_history primary key that corresponds to this PersonRole.", "name": "_ph_ls_state_legislator_staff_history_id", "verbose_name": " ph ls state legislator staff history id" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "_ph_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": " ph public organization"
                        },
                        { "field_type": 3, "help_text": "\n            If a foreign key to a Quorum PublicOrganization is not available, this field contains\n            the name of the organization that the PersonRole corresponds to. For PH roles,\n            this should be defined if and only if _ph_public_organization is not.\n        ", "name": "_ph_public_organization_desc", "verbose_name": " ph public organization desc" },
                        { "field_type": null, "help_text": "All emails applicable to the person in the position represented by this PersonRole.", "name": "_ph_emails", "verbose_name": " ph emails" },
                        { "field_type": 16, "help_text": "The last time KW updated the object in their database corresponding to this PersonRole.", "name": "_ph_kw_last_updated", "verbose_name": " ph kw last updated" },
                        { "field_type": 16, "help_text": "\n            The last time the consultants (Information Evolution -- IE) updated\n            the object in their database corresponding to this PersonRole.\n        ", "name": "_ph_ie_last_updated", "verbose_name": " ph ie last updated" },
                        { "field_type": 16, "help_text": "\n            The last time the WIW scraper updated the object in the database corresponding\n            to this PersonRole.\n        ", "name": "_ph_wiw_last_updated", "verbose_name": " ph wiw last updated" },
                        { "field_type": 16, "help_text": "The last time Intrado updated the object in their database corresponding to this PersonRole.", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 3, "help_text": "The (international) region that this person represents as text, until we have shapefiles that we can map to", "name": "_ph_region_represented", "verbose_name": " ph region represented" },
                        { "field_type": 4, "help_text": "A measure of the importance of this PersonRole. Lower precedence = more important = appears higher in search.", "name": "_ph_search_precedence", "verbose_name": " ph search precedence" },
                        { "field_type": null, "help_text": "Each URL on the web where information about this PersonRole can be found (e.g. via our consultants).", "name": "_ph_source_urls", "verbose_name": " ph source urls" },
                        { "field_type": 3, "help_text": "A list of all the parties this particular PersonRole is affiliated with", "name": "_ph_party_string", "verbose_name": "Parties" },
                        { "field_type": 4, "help_text": "The number of terms this PersonRole has been served in its jurisdiction.", "name": "_ph_term_number", "verbose_name": " ph term number" },
                        { "field_type": 5, "help_text": "The date on which this person was nominated for this position. if applicable.", "name": "_ph_nominated_date", "verbose_name": " ph nominated date" },
                        { "field_type": 5, "help_text": "The date on which this person's nomination to their current position was confirmed, if applicable.", "name": "_ph_nomination_confirmed_date", "verbose_name": " ph nomination confirmed date" },
                        { "field_type": 3, "help_text": "Denormalization of titles of responsibilities", "name": "_ph_dn_responsibilities_string", "verbose_name": " ph dn responsibilities string" },
                        { "field_type": 1, "help_text": "\n            True if and only if this PersonRole represents ownership of the organization\n            it is tied to. For example, Lamar Alexander's senator role has dr_is_owner = True\n            for the Office of Lamar Alexander.\n\n            Derivation of information on role type(s).\n            ", "name": "_ph_dr_is_owner", "verbose_name": " ph dr is owner" },
                        { "field_type": null, "help_text": "The different Intrado Tags associated with this PersonRole", "name": "intrado_tags", "verbose_name": "intrado tags" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoPreferredDistributionMode" },
                            "field_type": 4,
                            "help_text": "The Intrado PersonRole preferred distribution mode.",
                            "name": "intrado_preferred_distribution_mode",
                            "verbose_name": "intrado preferred distribution mode"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "person_type",
                            "verbose_name": "person type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "RoleType" },
                            "field_type": 4,
                            "help_text": "The type of role this person has, like representative or municipal_executive",
                            "name": "role_type",
                            "verbose_name": "role type"
                        },
                        { "field_type": 4, "help_text": "The convergence of all types of types of roles: ExecutiveRoleType, etc...", "name": "role_sub_type", "verbose_name": "role sub type" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorPersonType" },
                            "field_type": 4,
                            "help_text": "The major global type held by this person for this particular PersonRole instance(e.g. Head of State, Top-Level Cabinet Member, etc.)",
                            "name": "major_person_type",
                            "verbose_name": "major person type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorPersonType" },
                            "field_type": 4,
                            "help_text": "The minor type held by this person, oftentimes specific to a region/country(e.g. Senator, Department Secretary, etc.)",
                            "name": "minor_person_type",
                            "verbose_name": "minor person type"
                        },
                        { "field_type": 4, "help_text": "The specific type held by a person for this particular PersonRole instance(e.g. Speaker, House Majority Leader, etc.)", "name": "specific_person_type", "verbose_name": "specific person type" },
                        { "field_type": 3, "help_text": "The person role title.", "name": "title", "verbose_name": "title" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "primary_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "primary organization"
                        },
                        { "field_type": 1, "help_text": "Whether this PersonRole is currently applicable/currently held. Should be completely redundant given startdate and enddate.", "name": "current", "verbose_name": "current" },
                        { "field_type": 1, "help_text": "Whether the role is an incoming role or not.", "name": "incoming", "verbose_name": "incoming" },
                        { "field_type": 1, "help_text": "Whether the person is retiring from this role.", "name": "leaving", "verbose_name": "leaving" },
                        { "field_type": 5, "help_text": "The date the role began (when the person took office).", "name": "startdate", "verbose_name": "startdate" },
                        { "field_type": 5, "help_text": "The date the official was first elected into this role.", "name": "first_election_date", "verbose_name": "first election date" },
                        { "field_type": 5, "help_text": "The date the official was first appointed into this role.", "name": "assumed_office_date", "verbose_name": "assumed office date" },
                        { "field_type": 5, "help_text": "The date the role ended (when the person resigned, died, etc.)", "name": "enddate", "verbose_name": "enddate" },
                        { "field_type": 4, "help_text": "For representatives, the number of their congressional district. 0 for at-large districts.", "name": "district", "verbose_name": "district" },
                        { "field_type": 2, "help_text": "Some State Legislators have character Districts", "name": "district_char", "verbose_name": "district char" },
                        { "field_type": 2, "help_text": "For senators and representatives, the two-letter USPS abbrevation for the state or\n                     territory they are serving. Values are the abbreviations for the 50 states\n                     (each of which have at least one representative and two senators, assuming no vacancies)\n                     plus DC, PR, and the island territories AS, GU, MP, and VI (all of which have a non-voting delegate),\n                     and for really old historical data you will also find PI (Philippines, 1907-1946),\n                     DK (Dakota Territory, 1861-1889), and OR (Orleans Territory, 1806-1811) for non-voting delegates.", "name": "state", "verbose_name": "state" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "upper_district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "upper district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "lower_district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "lower district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "country_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "country obj"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party of the person.",
                            "name": "party",
                            "verbose_name": "party"
                        },
                        { "field_type": 2, "help_text": "The name of the political party", "name": "party_name", "verbose_name": "party name" },
                        { "field_type": 3, "help_text": "The URL to the official website of the person during this role, if known.", "name": "website", "verbose_name": "website" },
                        { "field_type": 2, "help_text": "The URL to the official position website of the person during this role, if known. Otherwise null.", "name": "contact_website", "verbose_name": "contact website" },
                        { "field_type": 2, "help_text": "The last known phone number of the official during this role, if known.", "is_contact_info": true, "name": "phone", "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 3, "verbose_name": "Phone" },
                        { "field_type": 2, "help_text": "The last known mobile phone number of the official during this role, if known.", "name": "mobile_phone", "verbose_name": "mobile phone" },
                        { "field_type": 2, "help_text": "The last known leadership role held during this role, if any.", "name": "leadership_title", "verbose_name": "leadership title" },
                        { "field_type": 2, "help_text": "Most recent office address", "name": "address", "verbose_name": "address" },
                        { "field_type": 2, "help_text": "Most recent office address (shorter form)", "name": "office", "verbose_name": "office" },
                        { "field_type": 3, "help_text": "most recent office room", "name": "office_room", "verbose_name": "office room" },
                        { "field_type": 3, "help_text": "most recent office building", "name": "office_building", "verbose_name": "office building" },
                        { "field_type": 3, "help_text": "most recent office address first line", "name": "office_street1", "verbose_name": "office street1" },
                        { "field_type": 3, "help_text": "most recent office address second line", "name": "office_street2", "verbose_name": "office street2" },
                        { "field_type": 3, "help_text": "most recent office zipcode", "name": "office_zipcode", "verbose_name": "office zipcode" },
                        { "field_type": 3, "help_text": "most recent office city", "name": "office_city", "verbose_name": "office city" },
                        { "field_type": 3, "help_text": "most recent office state", "name": "office_state", "verbose_name": "office state" },
                        { "field_type": 3, "help_text": "most recent office country", "name": "office_country", "verbose_name": "office country" },
                        { "field_type": 2, "help_text": "Seat status from Know Who", "name": "kw_seat_status", "verbose_name": "kw seat status" },
                        { "field_type": 1, "help_text": "Seat status code from Know Who", "name": "kw_seat_status_code", "verbose_name": "kw seat status code" },
                        { "field_type": 6, "help_text": "Percentage of vote in last election", "name": "lastelection", "verbose_name": "Percentage Votes in Last Election" },
                        {
                            "field_type": 4,
                            "help_text": "When is the person up for reelection",
                            "miscellaneous": 1,
                            "name": "reelectionyear",
                            "overriden_column_data_type": 2,
                            "sheet_column": true,
                            "sheets_column_order": 11,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Next Election Year"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Region which the person role is for.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ProfileInfoSource" },
                            "field_type": 4,
                            "help_text": "The most recent site from which we have scraped information to fill out the person's profile",
                            "name": "profile_info_source",
                            "verbose_name": "profile info source"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "AppointedByType" },
                            "field_type": 4,
                            "help_text": "The AppointedByType for a given role",
                            "name": "appointed_by_type",
                            "verbose_name": "appointed by type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PayScaleType" },
                            "field_type": 4,
                            "help_text": "The PayScaleType for a given role",
                            "name": "pay_scale_type",
                            "verbose_name": "pay scale type"
                        },
                        { "field_type": 1, "help_text": "Marks whether a role is considered Primary by the source that its from", "name": "is_primary_from_source", "verbose_name": "is primary from source" },
                        { "field_type": 4, "help_text": "Marks the order for which this role is set in the International & EU editorial tools (if applicable)", "name": "editorial_precedence", "verbose_name": "editorial precedence" },
                        {
                            "field_type": 8,
                            "help_text": "The congresses this role spans",
                            "name": "congresses",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congresses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The congresses this role spans",
                            "name": "sessions",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "sessions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The KW staffer title(s) associated with this role.",
                            "name": "_ph_kw_staffer_titles",
                            "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                            "verbose_name": " ph kw staffer titles"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The KW responsibilit(ies) associated with this role.",
                            "name": "_ph_kw_responsibilities",
                            "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                            "verbose_name": " ph kw responsibilities"
                        }
                    ],
                    "proxy_endpoint": "/api/personrole/"
                },
                "Person": {
                    "__is_model": true,
                    "__name__": "Person",
                    "data_model": "app.person.models.Person",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "show_in_quicksearch": true },
                    "endpoint": "/api/person/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The QuorumUser that created this record.",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Quorum Client Organization that owns this record.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The person's UID/MEMID on Know Who", "name": "kw_uid", "verbose_name": "kw uid" },
                        { "field_type": 2, "help_text": "ID on bioguide.congress.gov. May be null if the person served only as a president.", "name": "bioguideid", "verbose_name": "bioguideid" },
                        { "field_type": 2, "help_text": "The person's ID on thomas.congress.gov.", "name": "thomasid", "verbose_name": "thomasid" },
                        { "field_type": 2, "help_text": "The OpenStates id for person, if known, comma separated", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 2, "help_text": "The name of the person's LIS id, if known.", "name": "lisid", "verbose_name": "lisid" },
                        {
                            "field_type": 4,
                            "help_text": "Number of terms this person spans in their current role",
                            "miscellaneous": 1,
                            "name": "num_terms",
                            "sheet_column": true,
                            "sheets_column_order": 10,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 10002, 10004, 10005, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 1000],
                            "verbose_name": "Number of Terms"
                        },
                        { "field_type": 3, "help_text": "A list of all the committees that this official sits on.", "miscellaneous": 1, "name": "committee_string", "sheet_column": true, "sheets_column_order": 25, "sheets_subcategory": 6, "verbose_name": "Committee List" },
                        { "field_type": 3, "help_text": "A list of all the parties this person is affiliated with", "name": "party_string", "verbose_name": "Parties" },
                        { "field_type": null, "help_text": "", "name": "committee_id_name_arr", "verbose_name": "committee id name arr" },
                        { "field_type": 3, "help_text": "Email address the member uses to reach out to constituents", "name": "constituent_email", "verbose_name": "constituent email" },
                        { "field_type": 1, "help_text": "Whether or not a person has been a legislator, now or at anytime in the past.", "name": "has_been_legislator", "verbose_name": "has been legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member is brand new in their region.", "name": "new_legislator", "verbose_name": "new legislator" },
                        { "field_type": 1, "help_text": "Whether or not a member recently switched chambers in their region.", "name": "new_chamber", "verbose_name": "new chamber" },
                        { "field_type": 1, "help_text": "If this person is a freshman legislator", "name": "freshman_legislator", "verbose_name": "freshman legislator" },
                        { "field_type": 2, "help_text": "Know Who staffer ID", "name": "kw_sid", "verbose_name": "kw sid" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "personrole",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "personrole"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ComStafferType" },
                            "field_type": 4,
                            "help_text": "Whether Staffer is affiliated with a majority or minority committee only",
                            "name": "comstaffertype",
                            "verbose_name": "comstaffertype"
                        },
                        { "field_type": null, "help_text": "All staffer types corresponding to this person", "name": "staffer_types", "verbose_name": "staffer types" },
                        { "field_type": 4, "help_text": "Highest rank of the staffer's various titlecodes", "name": "titlecode_order", "verbose_name": "titlecode order" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "location",
                            "related_model": { "__module__": "app.person.models", "__name__": "MemberOffice" },
                            "verbose_name": "location"
                        },
                        { "field_type": 2, "help_text": "Responsibilities", "miscellaneous": 8, "name": "responsibilities_string", "sheet_column": true, "sheets_column_order": 10, "verbose_name": "Responsibilities" },
                        { "field_type": 2, "help_text": "The person's EXECID on Know Who", "name": "kw_execid", "verbose_name": "kw execid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SpecificExecutiveRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_executive_role",
                            "verbose_name": "most recent executive role"
                        },
                        { "field_type": 2, "help_text": "The person's UID on Know Who, call it kw_locid to differentiate btw members.", "name": "kw_locid", "verbose_name": "kw locid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveBranch" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_branch",
                            "verbose_name": "most recent local branch"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveDepartment" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_local_department",
                            "verbose_name": "most recent local department"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The most recent legislature the person has been a part of",
                            "miscellaneous": 1,
                            "name": "most_recent_region",
                            "sheet_column": true,
                            "sheets_column_order": 15,
                            "sheets_display_key": "region_name",
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Region"
                        },
                        { "field_type": null, "help_text": "\n            All regions the person was a part of in their most recent role(s).\n            For example, an EU person can be in [Region.eu, Region.france]\n        ", "name": "most_recent_regions", "verbose_name": "most recent regions" },
                        {
                            "field_type": 7,
                            "help_text": "The country that an official represents. For EU officials, this will be their international country they represent for the EU. International and US officials will use their respective countries.",
                            "name": "representing_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "representing country"
                        },
                        { "field_type": null, "help_text": "All regions corresponding to former roles of this Official.", "name": "_ph_dn_former_regions", "verbose_name": " ph dn former regions" },
                        { "field_type": null, "help_text": "All regions corresponding to the current and former roles of this Official.", "name": "_ph_dn_all_regions", "verbose_name": " ph dn all regions" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.geography.models", "__name__": "DistrictType" },
                            "field_type": 4,
                            "help_text": "The type of district",
                            "name": "most_recent_district_type",
                            "verbose_name": "most recent district type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The current US state of this person",
                            "miscellaneous": 1,
                            "name": "most_recent_state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "sheet_column": true,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "US State"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "most recent district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_upper_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "most recent upper district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_lower_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "most recent lower district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "most recent county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "most_recent_municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "most recent municipality"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "miscellaneous": 1,
                            "name": "most_recent_country",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                            "verbose_name": "Country"
                        },
                        { "field_type": 1, "help_text": "Whether this individual currently holds a role, or if this is archival information.", "name": "current", "verbose_name": "current" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonStatus" },
                            "field_type": 4,
                            "help_text": "The status of this person (active, incoming, leaving or former).",
                            "miscellaneous": 1,
                            "name": "status",
                            "sheet_column": true,
                            "sheets_column_order": 22,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Election Status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the most recent role of the person.",
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "most recent role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "RoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_role_type",
                            "verbose_name": "most recent role type"
                        },
                        { "field_type": 4, "help_text": "\n            The convergence of all types of types of people:\n                ExecutiveRoleType\n                LocalExecutiveRoleType\n                etc...\n            ", "name": "most_recent_role_sub_type", "verbose_name": "most recent role sub type" },
                        { "field_type": 3, "help_text": "the address of this person's most recent role", "name": "most_recent_role_address", "verbose_name": "most recent role address" },
                        { "field_type": 3, "help_text": "the room of this person's most recent role", "name": "most_recent_role_room", "verbose_name": "most recent role room" },
                        { "field_type": 3, "help_text": "the name of the office building of this person's most recent role", "name": "most_recent_role_building", "verbose_name": "most recent role building" },
                        { "field_type": 3, "help_text": "first line of the street address of this person's most recent role", "name": "most_recent_role_street1", "verbose_name": "most recent role street1" },
                        { "field_type": 3, "help_text": "second line of the street address of this person's most recent role", "name": "most_recent_role_street2", "verbose_name": "most recent role street2" },
                        { "field_type": 3, "help_text": "the ZipCode of this person's most recent role", "name": "most_recent_role_zipcode", "verbose_name": "most recent role zipcode" },
                        { "field_type": 3, "help_text": "the phone number of this person's most recent role", "name": "most_recent_role_phone", "verbose_name": "most recent role phone" },
                        { "field_type": 3, "help_text": "the city of this person's most recent role", "name": "most_recent_role_city", "verbose_name": "most recent role city" },
                        { "field_type": 3, "help_text": "the state of this person's most recent role", "name": "most_recent_role_state", "verbose_name": "most recent role state" },
                        { "field_type": 2, "help_text": "The last known leadership role held during this role, if any.", "name": "most_recent_leadership_title", "verbose_name": "most recent leadership title" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The most recent political party of the person.",
                            "name": "most_recent_party",
                            "sheet_column": true,
                            "sheets_column_order": 7,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "verbose_name": "Party"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "used to determine the perceived party of independents",
                            "name": "perceived_party",
                            "verbose_name": "perceived party"
                        },
                        { "field_type": null, "help_text": "The different major global types held by this legislator(e.g. Head of State, Top-Level Cabinet Member, etc.)", "name": "major_person_types", "verbose_name": "major person types" },
                        { "field_type": null, "help_text": "The different minor types held by this legislator, oftentimes specific to a region/country(e.g. Senator, Department Secretary, etc.)", "name": "minor_person_types", "verbose_name": "minor person types" },
                        { "field_type": null, "help_text": "The different specific types held by this legislator(e.g. Speaker, House Majority Leader, etc.)", "name": "specific_person_types", "verbose_name": "specific person types" },
                        { "field_type": 3, "help_text": "The (international) region that this person represents as text, until we have shapefiles that we can map to", "name": "region_represented", "verbose_name": "region represented" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_sector_type",
                            "verbose_name": "most recent ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_meta_role_type",
                            "verbose_name": "most recent ph meta role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_major_role_type",
                            "verbose_name": "most recent ph major role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_ph_minor_role_type",
                            "verbose_name": "most recent ph minor role type"
                        },
                        { "field_type": null, "help_text": "", "name": "most_recent_ph_specific_role_types", "verbose_name": "most recent ph specific role types" },
                        { "field_type": 16, "help_text": "The last time KW updated this person's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": 16, "help_text": "The last time Intrado updated the object in their database corresponding to this Person.", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 16, "help_text": "The last time we attempted to flush this person", "name": "last_attempted_flush", "verbose_name": "last attempted flush" },
                        { "field_type": 16, "help_text": "The last time we successfully flushed this person", "name": "last_successful_flush", "verbose_name": "last successful flush" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": 2, "help_text": "Facebook ID", "name": "facebookid", "verbose_name": "facebookid" },
                        { "field_type": 2, "help_text": "The url of the facebook page", "name": "facebook_url", "verbose_name": "facebook url" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": 2, "help_text": "The name of the person's official Twitter handle, if known.", "name": "twitterid", "verbose_name": "twitterid" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": 2, "help_text": "The ID of the person's official YouTube channel, if known.", "name": "youtubeid", "verbose_name": "youtubeid" },
                        {
                            "field_type": 7,
                            "help_text": "A shortcut to the current role of the person, if present.",
                            "name": "current_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "current role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "DemographicType" },
                            "field_type": 4,
                            "help_text": "Represent a state or district",
                            "name": "demographic_type",
                            "verbose_name": "demographic type"
                        },
                        { "field_type": 2, "help_text": "The House History id of the person, if known.", "name": "househistoryid", "verbose_name": "househistoryid" },
                        { "field_type": 4, "help_text": "The ICPSR id of the person (Poole and Rosenthal), if known.", "name": "icpsrid", "verbose_name": "icpsrid" },
                        { "field_type": 16, "help_text": "The last time the Person object was updated", "name": "last_updated", "verbose_name": "last updated" },
                        {
                            "field_type": 7,
                            "help_text": "The Corresponding Old Staffer Object",
                            "name": "legacy_staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "legacy staffer"
                        },
                        { "field_type": 2, "help_text": "The primary key of the object from its original source (donation to legislator/candidate with id)", "name": "legislator_candidate_id", "verbose_name": "legislator candidate id" },
                        { "field_type": 4, "help_text": "The Maplight id of the person, if known.", "name": "maplightid", "verbose_name": "maplightid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ExecutivePosition" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_position",
                            "verbose_name": "most recent position"
                        },
                        { "field_type": 4, "help_text": "The official ID given by a state website for a legislator.", "name": "official_stateid", "verbose_name": "official stateid" },
                        { "field_type": 4, "help_text": "DEPRECATED", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 2, "help_text": "The person's ID on opensecrets.org (The Center for Responsive Politics), if known.", "name": "osid", "verbose_name": "osid" },
                        { "field_type": 2, "help_text": "The person's ID on vote-smart.org (Project Vote Smart), if known.", "name": "pvsid", "verbose_name": "pvsid" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionDeliveryType" },
                            "field_type": 4,
                            "help_text": "If member requires special treatment for delivering supporter messages (i.e. recaptcha on form).",
                            "name": "supporter_action_delivery_type",
                            "verbose_name": "supporter action delivery type"
                        },
                        { "field_type": 2, "help_text": "The name of the person's id in the Washington Post, if known.", "name": "wpid", "verbose_name": "wpid" },
                        { "field_type": 4, "help_text": "KnowWho's PersonID for the tblPeople entry corresponding to this Person.", "name": "_ph_kw_person_id", "verbose_name": " ph kw person id" },
                        { "field_type": 3, "help_text": "\n            A person's IE (Information Evolution) ID. If they have this ID,\n            they were at some point collected or enriched by the consultants\n        ", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        { "field_type": 1, "help_text": "If True, this Person is ready for frontend consumption. Set True during flushing.", "name": "_ph_is_clean", "verbose_name": " ph is clean" },
                        { "field_type": 1, "help_text": "Marks that we should flush this person in the next Bidet run", "name": "_ph_should_flush_next_run", "verbose_name": " ph should flush next run" },
                        { "field_type": 4, "help_text": "A UniqueID for a Person originating from the Intrado data source.", "name": "_ph_intrado_person_id", "verbose_name": " ph intrado person id" },
                        { "field_type": 4, "help_text": "Leadership Connect's PersonID for a Person.", "name": "_ph_lc_person_id", "verbose_name": " ph lc person id" },
                        { "field_type": 4, "help_text": "The core_person_id for the Legistorm core_person this Person represents.", "name": "_ph_ls_core_person_id", "verbose_name": " ph ls core person id" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from currently held PersonRoles.", "name": "_ph_dn_current_sector_types", "verbose_name": " ph dn current sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_meta_role_types", "verbose_name": " ph dn current meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_major_role_types", "verbose_name": " ph dn current major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from currently held PersonRoles.", "name": "_ph_dn_current_minor_role_types", "verbose_name": " ph dn current minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from currently held PersonRoles.", "name": "_ph_dn_current_specific_role_types", "verbose_name": " ph dn current specific role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_sector_type values from formerly held PersonRoles.", "name": "_ph_dn_former_sector_types", "verbose_name": " ph dn former sector types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_meta_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_meta_role_types", "verbose_name": " ph dn former meta role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_major_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_major_role_types", "verbose_name": " ph dn former major role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_minor_role_type values from formerly held PersonRoles.", "name": "_ph_dn_former_minor_role_types", "verbose_name": " ph dn former minor role types" },
                        { "field_type": null, "help_text": "Denormalization of _ph_specific_role_types values from formerly held PersonRoles.", "name": "_ph_dn_former_specific_role_types", "verbose_name": " ph dn former specific role types" },
                        { "field_type": null, "help_text": "All of the intrado Tag names from a person's PersonRoles.", "name": "_ph_dn_intrado_tags", "verbose_name": " ph dn intrado tags" },
                        { "field_type": null, "help_text": "Denormalization of intrado languages from PersonRoles.", "name": "_ph_dn_intrado_languages", "verbose_name": " ph dn intrado languages" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoPreferredDistributionMode" },
                            "field_type": 4,
                            "help_text": "Denormalization of intrado PreferredDistributionMode from PersonRoles.",
                            "name": "_ph_dn_intrado_preferred_distribution_mode",
                            "verbose_name": " ph dn intrado preferred distribution mode"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "most_recent_person_type",
                            "verbose_name": "most recent person type"
                        },
                        { "field_type": 3, "help_text": "The person's most recent title.", "name": "title", "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 3, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The person's full name with title, district, and party information for current Members of Congress.Also allows the sheet to be more easily ordered alphabetically.", "name": "name", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 3, "verbose_name": "Name" },
                        { "field_type": 2, "help_text": "The person's first name or first initial.", "name": "firstname", "sheet_column": true, "sheets_column_order": 2, "sheets_subcategory": 3, "verbose_name": "First Name" },
                        { "field_type": 2, "help_text": "The person's last name.", "name": "lastname", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 3, "verbose_name": "Last Name" },
                        { "field_type": 2, "help_text": "The person's middle name (optional).", "name": "middlename", "verbose_name": "middlename" },
                        { "field_type": 3, "help_text": "The prefix on the person's name, usually one of Dr., Ms., etc. This is usually different than their titles", "name": "prefix", "verbose_name": "prefix" },
                        { "field_type": 2, "help_text": "The suffix on the person's name usually one of Jr., Sr., I, II, etc.", "name": "namemod", "verbose_name": "namemod" },
                        { "field_type": 2, "help_text": "If set, the nickname should usually be displayed in quotes where a middle name would go.", "name": "nickname", "verbose_name": "nickname" },
                        { "field_type": 2, "help_text": "Pronunciation", "name": "pronunciation", "verbose_name": "pronunciation" },
                        { "field_type": 1, "help_text": "Whether the name has been manually overwritten and wont be updated from KW", "name": "has_custom_name", "verbose_name": "has custom name" },
                        { "field_type": 2, "help_text": "Public Organization Descriptor", "name": "public_organization_descriptor", "verbose_name": "public organization descriptor" },
                        { "field_type": 1, "help_text": "", "name": "show_in_quicksearch", "verbose_name": "show in quicksearch" },
                        { "field_type": 4, "help_text": "", "name": "precedence", "verbose_name": "precedence" },
                        { "field_type": 4, "help_text": "", "name": "precedence_local", "verbose_name": "precedence local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state", "verbose_name": "precedence state" },
                        { "field_type": 4, "help_text": "", "name": "precedence_state_and_local", "verbose_name": "precedence state and local" },
                        { "field_type": 4, "help_text": "", "name": "precedence_eu", "verbose_name": "precedence eu" },
                        { "field_type": 2, "help_text": "The person's ascii first name or first initial.", "name": "firstname_search", "verbose_name": "firstname search" },
                        { "field_type": 2, "help_text": "The person's ascii last name.", "name": "lastname_search", "verbose_name": "lastname search" },
                        { "field_type": 2, "help_text": "The person's ascii middle name (optional).", "name": "middlename_search", "verbose_name": "middlename search" },
                        { "field_type": 3, "help_text": "The person's unicode full name with firstname, lastname, and nickname information for Person.\n                    In cases with accented names, represent the accented and unaccented (unidecoded) name in the same\n                    string for searching capabilities.\n                ", "name": "name_search", "verbose_name": "name search" },
                        { "field_type": 5, "help_text": "The person's birthday.", "name": "birthday", "verbose_name": "Birthday" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Gender" },
                            "field_type": 4,
                            "help_text": "The person's gender, if known. For historical data, the gender is sometimes not known.",
                            "miscellaneous": 1,
                            "name": "gender",
                            "sheet_column": true,
                            "sheets_subcategory": 3,
                            "verbose_name": "Gender"
                        },
                        { "field_type": 2, "help_text": "The person's email.", "is_contact_info": true, "name": "email", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 3, "verbose_name": "Email" },
                        {
                            "field_type": 3,
                            "help_text": "Alternate Email for this Press Contact",
                            "miscellaneous": 120,
                            "name": "intrado_other_email",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "verbose_name": "Alternate Email"
                        },
                        { "field_type": 1, "help_text": "whether the email is valid and/or verified", "name": "valid_email", "verbose_name": "valid email" },
                        { "field_type": 2, "help_text": "The person's PID on Know Who", "name": "kw_pid", "verbose_name": "kw pid" },
                        { "field_type": 2, "help_text": "The person's OFCID's on Know Who, comma separated", "name": "kw_ofcid", "verbose_name": "kw ofcid" },
                        { "field_type": 4, "help_text": "The ID of the person on CSPAN websites, if known.", "name": "cspanid", "verbose_name": "cspanid" },
                        { "field_type": 2, "help_text": "The official ID given by a state website for a legislator, but in unicode.", "name": "external_state_id", "verbose_name": "external state id" },
                        { "field_type": 3, "help_text": "The local path of the image for a person on update/state update, which is often under settings.DATA_PATH", "name": "local_image_path", "verbose_name": "local image path" },
                        { "field_type": 3, "help_text": "The URL of this person's image/avatar that is actually rendered on the frontend (most likely an S3 URL with correct CORS)", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 3, "help_text": "Original image url location that we get from the outside world, as one would find via Google Images Search", "name": "source_image_url", "verbose_name": "source image url" },
                        { "field_type": 3, "help_text": "The high quality path of this members image", "name": "high_quality_local_image_path", "verbose_name": "high quality local image path" },
                        { "field_type": 3, "help_text": "Cached path of high quality image url", "name": "high_quality_image_url", "verbose_name": "high quality image url" },
                        { "field_type": 3, "help_text": "The Wikipedia URL for this person, if any", "name": "wikipedia_url", "verbose_name": "wikipedia url" },
                        { "field_type": null, "help_text": "The different urls where we can find this person on the web (via our consultants)", "name": "source_urls", "verbose_name": "source urls" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "primary_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "primary organization"
                        },
                        { "field_type": null, "help_text": "The different types of leadership roles held by this legislator.", "name": "leadership_types", "verbose_name": "leadership types" },
                        { "field_type": 1, "help_text": "Whether the leadership types have been manually overwritten or can be set automatically.", "name": "custom_leadership_types", "verbose_name": "custom leadership types" },
                        { "field_type": null, "help_text": "Stores all external unique IDs for faster matching Person objects from vendors like DDC & Cision", "name": "external_unique_id_dict", "verbose_name": "external unique id dict" },
                        { "field_type": null, "help_text": "A person's WhoisWho ID", "name": "wiw_ids", "verbose_name": "wiw ids" },
                        { "field_type": 4, "help_text": "A persons's EU MEP ID", "name": "mepid", "verbose_name": "mepid" },
                        { "field_type": 2, "help_text": "Consultant added person's LegislatorID from international persons sheet", "name": "legislator_id", "verbose_name": "legislator id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ProfileInfoSource" },
                            "field_type": 4,
                            "help_text": "The most recent site from which we have scraped information to fill out the person's profile",
                            "name": "most_recent_profile_info_source",
                            "verbose_name": "most recent profile info source"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "send_messages_to",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "send messages to"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 3, "help_text": "The office code for a US Congressperson. Used in Grassroots delivery by the\n                     CWC for message routing. House format: H{state_abbrev}{district_number}.\n                     Senate format: S{state_abbrev}{senate_class_number}.", "name": "office_code", "verbose_name": "office code" },
                        { "field_type": 1, "help_text": "Whether or not this person should be delivered via fill forms", "name": "should_deliver_via_fill_form", "verbose_name": "should deliver via fill form" },
                        { "field_type": 1, "help_text": "If the Member has a valid office code in CWC", "name": "is_cwc", "verbose_name": "is cwc" },
                        { "field_type": 3, "help_text": "LinkedIn Username", "name": "linkedin_username", "verbose_name": "linkedin username" },
                        { "field_type": null, "help_text": "All the AppointedByTypes for a given person", "name": "dn_appointed_by_types", "verbose_name": "dn appointed by types" },
                        { "field_type": null, "help_text": "All the PayScales for a given person", "name": "dn_pay_scale_types", "verbose_name": "dn pay scale types" },
                        {
                            "field_type": 8,
                            "help_text": "All the congresses this person spans",
                            "name": "congresses",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congresses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the sessions this person spans.",
                            "name": "sessions",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "sessions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "titlecode",
                            "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                            "verbose_name": "titlecode"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "responsibilities",
                            "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                            "verbose_name": "responsibilities"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "beats",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "Beat" },
                            "sheet_column": true,
                            "verbose_name": "beats"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dma",
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "DesignatedMarketArea" },
                            "sheet_column": true,
                            "verbose_name": "dma"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this person is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "biography",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonBiography" },
                            "sheet_column": true
                        },
                        {
                            "__class__": { "__name__": "ForeignKey" },
                            "field_type": 7,
                            "name": "most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "sheet_column": true
                        }
                    ]
                },
                "PersonBiography": {
                    "__is_model": true,
                    "__name__": "PersonBiography",
                    "data_model": "app.person.models.PersonBiography",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/personbiography/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 5, "help_text": "The person's date of birth.", "miscellaneous": 1, "name": "_ph_birthdate", "sheet_column": true, "sheets_subcategory": 6, "verbose_name": "Date of Birth" },
                        { "field_type": 5, "help_text": "The person's date of death.", "name": "_ph_deathdate", "verbose_name": "Date of Death" },
                        { "field_type": null, "help_text": "\n        A list of dictionaries containing information about current and former roles,\n        memberships, educational experiences, or similar for the Person to whom this PersonBiography belongs.\n\n        In the US, this data is sourced from current and former PersonRoles as well as less-structured \"role-like\"\n        KnowWho tables like tblpeoplemilitary (military experience), tblpeopledirector (directorships), etc.\n\n        Every entry in this list should follow ROLE_DATA_SCHEMA.\n        ", "name": "_ph_role_data", "verbose_name": " ph role data" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        { "field_type": 3, "help_text": "Biography from KnowWho", "name": "kw_biography", "verbose_name": "kw biography" },
                        { "field_type": 3, "help_text": "Biography from EU Website", "name": "eu_biography", "verbose_name": "eu biography" },
                        { "field_type": 3, "help_text": "Biography from Quorum", "name": "quorum_biography", "verbose_name": "quorum biography" },
                        { "field_type": 3, "help_text": "Biography from the Almanac of American Politics", "name": "almanac_biography", "verbose_name": "almanac biography" },
                        { "field_type": 3, "help_text": "Biography from our international data provider Information Evolution,not to be confused with the best web browser ever created", "name": "ie_biography", "verbose_name": "ie biography" },
                        { "field_type": 3, "help_text": "Biography from Intrado if they ever send us our data", "name": "intrado_biography", "verbose_name": "intrado biography" },
                        { "field_type": 3, "help_text": "The responsibilities of a person, from commission website", "name": "eu_responsibilities", "verbose_name": "eu responsibilities" },
                        { "field_type": 2, "help_text": "A PDF of a biography or CV", "name": "bio_pdf_url", "verbose_name": "bio pdf url" },
                        { "field_type": 2, "help_text": "A PDF of a declaration of interests, used in EU", "name": "declaration_of_interests_pdf_url", "verbose_name": "declaration of interests pdf url" },
                        { "field_type": 3, "help_text": "The full text of any PDFs to be searched", "name": "bio_pdf_fts_text", "verbose_name": "bio pdf fts text" },
                        {
                            "field_type": 5,
                            "help_text": "Date Assumed Office for Current Role",
                            "miscellaneous": 1,
                            "name": "dateelected",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Date Assumed Office"
                        },
                        {
                            "field_type": 5,
                            "help_text": "The date the official was first elected into their current primary role.",
                            "miscellaneous": 1,
                            "name": "first_election_date",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "First Elected Date"
                        },
                        {
                            "field_type": 5,
                            "help_text": "The date the official was first appointed into their current primary role.",
                            "miscellaneous": 1,
                            "name": "assumed_office_date",
                            "overriden_column_data_type": 12,
                            "sheet_column": true,
                            "sheets_column_order": 9,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Assumed Office Date"
                        },
                        { "field_type": 2, "help_text": "The person's birthplace", "name": "birthplace", "verbose_name": "birthplace" },
                        { "field_type": 2, "help_text": "The person's birth state", "name": "birthstate", "verbose_name": "birthstate" },
                        { "field_type": 2, "help_text": "The person's marital status", "name": "marital", "verbose_name": "marital" },
                        {
                            "field_type": 2,
                            "help_text": "The person's spouse",
                            "miscellaneous": 1,
                            "name": "spouse",
                            "sheet_column": true,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Spouse"
                        },
                        { "field_type": 2, "help_text": "The person's residence", "name": "residence", "verbose_name": "residence" },
                        { "field_type": 2, "help_text": "The person's family", "name": "family", "verbose_name": "family" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Religion" },
                            "field_type": 4,
                            "help_text": "The person's religious background.",
                            "miscellaneous": 1,
                            "name": "religion",
                            "sheet_column": true,
                            "sheets_column_order": 20,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Religion"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Ethnicity" },
                            "field_type": 4,
                            "help_text": "The person's ethnicity.",
                            "name": "ethnicity",
                            "verbose_name": "Ethnicity"
                        },
                        { "field_type": 3, "help_text": "The person's first previous role", "name": "previousrole1type", "verbose_name": "previousrole1type" },
                        { "field_type": 2, "help_text": "the person's first previous role end date", "name": "previousrole1dates", "verbose_name": "previousrole1dates" },
                        { "field_type": 3, "help_text": "The person's second previous role", "name": "previousrole2type", "verbose_name": "previousrole2type" },
                        { "field_type": 2, "help_text": "the person's second previous role start date", "name": "previousrole2dates", "verbose_name": "previousrole2dates" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Occupations" },
                            "field_type": 4,
                            "help_text": "Occupation prior to political career",
                            "name": "previousindustry1",
                            "verbose_name": "previousindustry1"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Occupations" },
                            "field_type": 4,
                            "help_text": "Occupation prior to political career",
                            "name": "previousindustry2",
                            "verbose_name": "previousindustry2"
                        },
                        { "field_type": 2, "help_text": "Education", "name": "education1", "verbose_name": "education1" },
                        { "field_type": 2, "help_text": "Degree type", "name": "degree1", "verbose_name": "degree1" },
                        { "field_type": 4, "help_text": "Degree date", "name": "degreedate1", "verbose_name": "degreedate1" },
                        { "field_type": 2, "help_text": "Education 2", "name": "education2", "verbose_name": "education2" },
                        { "field_type": 2, "help_text": "Degree type 2", "name": "degree2", "verbose_name": "degree2" },
                        { "field_type": 4, "help_text": "Degree date 2", "name": "degreedate2", "verbose_name": "degreedate2" },
                        { "field_type": 2, "help_text": "Education 3", "name": "education3", "verbose_name": "education3" },
                        { "field_type": 2, "help_text": "Degree type 3", "name": "degree3", "verbose_name": "degree3" },
                        { "field_type": 4, "help_text": "Degree date 3", "name": "degreedate3", "verbose_name": "degreedate3" },
                        { "field_type": 2, "help_text": "Institution of undergrad", "name": "undergrad_institution", "verbose_name": "undergrad institution" },
                        { "field_type": 2, "help_text": "Institution of graduate", "name": "graduate_institution", "verbose_name": "graduate institution" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "TerminalDegree" },
                            "field_type": 4,
                            "help_text": "The last degree the person received.",
                            "miscellaneous": 1,
                            "name": "terminal_degree",
                            "sheet_column": true,
                            "sheets_column_order": 19,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "verbose_name": "Terminal Degree"
                        },
                        { "field_type": 2, "help_text": "Military background branch", "name": "militarybranch1", "verbose_name": "militarybranch1" },
                        { "field_type": 2, "help_text": "military role", "name": "militaryrole1", "verbose_name": "militaryrole1" },
                        { "field_type": 2, "help_text": "Military startdate", "name": "military1dates", "verbose_name": "military1dates" },
                        { "field_type": 2, "help_text": "Military 2 background branch", "name": "militarybranch2", "verbose_name": "militarybranch2" },
                        { "field_type": 2, "help_text": "military 2 role", "name": "militaryrole2", "verbose_name": "militaryrole2" },
                        { "field_type": 2, "help_text": "Military 2 startdate", "name": "military2dates", "verbose_name": "military2dates" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": 16, "help_text": "The last time KW updated this biography's information", "name": "kw_last_updated", "verbose_name": "kw last updated" }
                    ]
                },
                "PersonRole": {
                    "__is_model": true,
                    "__name__": "PersonRole",
                    "data_model": "app.person.models.PersonRole",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/personrole/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SenatorClass" },
                            "field_type": 4,
                            "help_text": "For senators, their election class, which determines which years they are up for election.",
                            "name": "senator_class",
                            "verbose_name": "senator class"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SenatorRank" },
                            "field_type": 4,
                            "help_text": "For senators, their state rank, i.e. junior/senior. For historical data, this is their last known rank.",
                            "name": "senator_rank",
                            "verbose_name": "senator rank"
                        },
                        { "field_type": 4, "help_text": "The Person's rank in chamber, from Know Who", "name": "chamberrank", "verbose_name": "chamberrank" },
                        { "field_type": 4, "help_text": "The Person's rank in party, from Know Who", "name": "partyrank", "verbose_name": "partyrank" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ElectCode" },
                            "field_type": 4,
                            "help_text": "How the person was elected to congress",
                            "name": "electcode",
                            "verbose_name": "electcode"
                        },
                        { "field_type": 4, "help_text": "ADA Score for member of congress", "name": "adascore", "verbose_name": "adascore" },
                        { "field_type": 4, "help_text": "ACU Score for member of congress", "name": "acuscore", "verbose_name": "acuscore" },
                        { "field_type": 4, "help_text": "AFL-CIO Score for member of congress", "name": "aflscore", "verbose_name": "aflscore" },
                        { "field_type": 4, "help_text": "CCUS Score for member of congress", "name": "ccusscore", "verbose_name": "ccusscore" },
                        { "field_type": 4, "help_text": "Club For Growth Lifetime Economic Growth Score for member of congress", "name": "cfgscore", "verbose_name": "cfgscore" },
                        { "field_type": 4, "help_text": "NARAL public score for legislators", "name": "naralscore", "verbose_name": "naralscore" },
                        { "field_type": 6, "help_text": "Latitude from Zip-State combo for travel visualization", "name": "travelviz_latitude", "verbose_name": "travelviz latitude" },
                        { "field_type": 6, "help_text": "Longitude from Zip-State combo for travel visualization", "name": "travelviz_longitude", "verbose_name": "travelviz longitude" },
                        {
                            "field_type": 7,
                            "help_text": "The term for which the Person Role exists.",
                            "name": "term",
                            "related_model": { "__module__": "app.models", "__name__": "Term" },
                            "verbose_name": "term"
                        },
                        { "field_type": 2, "help_text": "\n            A 9-character alphanumeric code assigned to a candidacy by the FEC.\n            Remains the same across election cycles as long as the candidate runs for the\n            same office.\n\n            Corresponds to government.tbllegmem.FECLinkNum in KnowWho level-3 data\n        ", "name": "fec_id", "verbose_name": "fec id" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "for_person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "for person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ComStafferType" },
                            "field_type": 4,
                            "help_text": "Whether Staffer is affiliated with a majority or minority committee only",
                            "name": "comstaffertype",
                            "verbose_name": "comstaffertype"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "_ph_location",
                            "related_model": { "__module__": "app.person.models", "__name__": "MemberOffice" },
                            "verbose_name": " ph location"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "LocalExecutiveBranch" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "local_branch",
                            "verbose_name": "local branch"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "municipality"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "SpecificExecutiveRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "executive_role",
                            "verbose_name": "executive role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_sector_type",
                            "verbose_name": " ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_meta_role_type",
                            "verbose_name": " ph meta role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_major_role_type",
                            "verbose_name": " ph major role type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorRoleType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_minor_role_type",
                            "verbose_name": " ph minor role type"
                        },
                        { "field_type": null, "help_text": "SpecificRoleTypes corresponding to this role", "name": "_ph_specific_role_types", "verbose_name": " ph specific role types" },
                        { "field_type": 3, "help_text": "ID on bioguide.congress.gov. May be null if the person served only as a president.", "name": "_ph_bioguideid", "verbose_name": " ph bioguideid" },
                        { "field_type": 3, "help_text": "Unicode representation of the official ID given by a state website for a legislator.", "name": "_ph_external_state_id", "verbose_name": " ph external state id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecPosID for the tblExecPos entry corresponding to this PersonRole. Corresponds to EXECID in Level-2 data.", "name": "_ph_kw_exec_pos_id", "verbose_name": " ph kw exec pos id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecCandidateID for the tblExecCandidate entry corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_exec_candidate_id", "verbose_name": " ph kw exec candidate id" },
                        { "field_type": null, "help_text": "KnowWho's ExecElectIDs for the set of tblExecElect entries corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_exec_elect_ids", "verbose_name": " ph kw exec elect ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegMemID for the tblLegMem entry corresponding to this PersonRole. Corresponds to UID in Level-2 data.", "name": "_ph_kw_leg_mem_id", "verbose_name": " ph kw leg mem id" },
                        { "field_type": 4, "help_text": "KnowWho's LegCandidateID for the tblLegCandidate entry corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_leg_candidate_id", "verbose_name": " ph kw leg candidate id" },
                        { "field_type": null, "help_text": "KnowWho's LegElectIDs for the tblLegElect entries corresponding to this PersonRole. Not present in Level-2 data.", "name": "_ph_kw_leg_elect_ids", "verbose_name": " ph kw leg elect ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegOfcID for the tblLegOfc entry corresponding to this PersonRole.", "name": "_ph_kw_leg_ofc_id", "verbose_name": " ph kw leg ofc id" },
                        { "field_type": 4, "help_text": "KnowWho's LegComMemberID for the tblLegComMember entry corresponding to this PersonRole. Corresponds to COMMEMID in Level-2 data.", "name": "_ph_kw_leg_com_member_id", "verbose_name": " ph kw leg com member id" },
                        { "field_type": 4, "help_text": "KnowWho's PositionID for the tblExecLegJudPositions entry corresponding to this PersonRole. Corresponds to UID in countymuni_2/Officials.csv in Level-2 data.", "name": "_ph_kw_cm_position_id", "verbose_name": " ph kw cm position id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecPosStaffID for the tblExecPosStaff entry corresponding to this PersonRole.", "name": "_ph_kw_exec_pos_staff_id", "verbose_name": " ph kw exec pos staff id" },
                        { "field_type": 4, "help_text": "KnowWho's ExecCandidateStaffID for the tblExecCandidateStaff entry corresponding to this PersonRole.", "name": "_ph_kw_exec_candidate_staff_id", "verbose_name": " ph kw exec candidate staff id" },
                        { "field_type": null, "help_text": "KnowWho's ExecElectStaffIDs for the tblExecElectStaff entries corresponding to this PersonRole.", "name": "_ph_kw_exec_elect_staff_ids", "verbose_name": " ph kw exec elect staff ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegMemStaffID for the tblLgMemStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_mem_staff_id", "verbose_name": " ph kw leg mem staff id" },
                        { "field_type": 4, "help_text": "KnowWho's KegCandidateStaffID for the tblLegCandidateStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_candidate_staff_id", "verbose_name": " ph kw leg candidate staff id" },
                        { "field_type": null, "help_text": "KnowWho's LegElectStaffIDs for the tblLegElectStaff entries corresponding to this PersonRole.", "name": "_ph_kw_leg_elect_staff_ids", "verbose_name": " ph kw leg elect staff ids" },
                        { "field_type": 4, "help_text": "KnowWho's LegOfcStafffID for the tblLegOfcStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_ofc_staff_id", "verbose_name": " ph kw leg ofc staff id" },
                        { "field_type": 4, "help_text": "KnowWho's LegComStaffID for the tblLegCOmStaff entry corresponding to this PersonRole.", "name": "_ph_kw_leg_com_staff_id", "verbose_name": " ph kw leg com staff id" },
                        { "field_type": 3, "help_text": "A persons's EU MEP ID", "name": "_ph_mepid", "verbose_name": " ph mepid" },
                        { "field_type": 3, "help_text": "A person's WhoisWho ID", "name": "_ph_wiwid", "verbose_name": " ph wiwid" },
                        { "field_type": 3, "help_text": "\n            A person's IE (Information Evolution) ID. If they have this ID,\n            they were at some point collected or enriched by the consultants\n        ", "name": "_ph_ie_id", "verbose_name": " ph ie id" },
                        { "field_type": 4, "help_text": "KnowWho's PositionID for the tblIntlPosition entry corresponding to this PersonRole.", "name": "_ph_kw_position_id", "verbose_name": " ph kw position id" },
                        { "field_type": 4, "help_text": "Leadership Connect PositionID corresponding to a PersonRole.", "name": "_ph_lc_position_id", "verbose_name": " ph lc position id" },
                        { "field_type": 4, "help_text": "Legistorm state_legislator_staff_history primary key that corresponds to this PersonRole.", "name": "_ph_ls_state_legislator_staff_history_id", "verbose_name": " ph ls state legislator staff history id" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "_ph_public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": " ph public organization"
                        },
                        { "field_type": 3, "help_text": "\n            If a foreign key to a Quorum PublicOrganization is not available, this field contains\n            the name of the organization that the PersonRole corresponds to. For PH roles,\n            this should be defined if and only if _ph_public_organization is not.\n        ", "name": "_ph_public_organization_desc", "verbose_name": " ph public organization desc" },
                        { "field_type": null, "help_text": "All emails applicable to the person in the position represented by this PersonRole.", "name": "_ph_emails", "verbose_name": " ph emails" },
                        { "field_type": 16, "help_text": "The last time KW updated the object in their database corresponding to this PersonRole.", "name": "_ph_kw_last_updated", "verbose_name": " ph kw last updated" },
                        { "field_type": 16, "help_text": "\n            The last time the consultants (Information Evolution -- IE) updated\n            the object in their database corresponding to this PersonRole.\n        ", "name": "_ph_ie_last_updated", "verbose_name": " ph ie last updated" },
                        { "field_type": 16, "help_text": "\n            The last time the WIW scraper updated the object in the database corresponding\n            to this PersonRole.\n        ", "name": "_ph_wiw_last_updated", "verbose_name": " ph wiw last updated" },
                        { "field_type": 16, "help_text": "The last time Intrado updated the object in their database corresponding to this PersonRole.", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 3, "help_text": "The (international) region that this person represents as text, until we have shapefiles that we can map to", "name": "_ph_region_represented", "verbose_name": " ph region represented" },
                        { "field_type": 4, "help_text": "A measure of the importance of this PersonRole. Lower precedence = more important = appears higher in search.", "name": "_ph_search_precedence", "verbose_name": " ph search precedence" },
                        { "field_type": null, "help_text": "Each URL on the web where information about this PersonRole can be found (e.g. via our consultants).", "name": "_ph_source_urls", "verbose_name": " ph source urls" },
                        { "field_type": 3, "help_text": "A list of all the parties this particular PersonRole is affiliated with", "name": "_ph_party_string", "verbose_name": "Parties" },
                        { "field_type": 4, "help_text": "The number of terms this PersonRole has been served in its jurisdiction.", "name": "_ph_term_number", "verbose_name": " ph term number" },
                        { "field_type": 5, "help_text": "The date on which this person was nominated for this position. if applicable.", "name": "_ph_nominated_date", "verbose_name": " ph nominated date" },
                        { "field_type": 5, "help_text": "The date on which this person's nomination to their current position was confirmed, if applicable.", "name": "_ph_nomination_confirmed_date", "verbose_name": " ph nomination confirmed date" },
                        { "field_type": 3, "help_text": "Denormalization of titles of responsibilities", "name": "_ph_dn_responsibilities_string", "verbose_name": " ph dn responsibilities string" },
                        { "field_type": 1, "help_text": "\n            True if and only if this PersonRole represents ownership of the organization\n            it is tied to. For example, Lamar Alexander's senator role has dr_is_owner = True\n            for the Office of Lamar Alexander.\n\n            Derivation of information on role type(s).\n            ", "name": "_ph_dr_is_owner", "verbose_name": " ph dr is owner" },
                        { "field_type": null, "help_text": "The different Intrado Tags associated with this PersonRole", "name": "intrado_tags", "verbose_name": "intrado tags" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoPreferredDistributionMode" },
                            "field_type": 4,
                            "help_text": "The Intrado PersonRole preferred distribution mode.",
                            "name": "intrado_preferred_distribution_mode",
                            "verbose_name": "intrado preferred distribution mode"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PersonType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "person_type",
                            "verbose_name": "person type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "RoleType" },
                            "field_type": 4,
                            "help_text": "The type of role this person has, like representative or municipal_executive",
                            "name": "role_type",
                            "verbose_name": "role type"
                        },
                        { "field_type": 4, "help_text": "The convergence of all types of types of roles: ExecutiveRoleType, etc...", "name": "role_sub_type", "verbose_name": "role sub type" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MajorPersonType" },
                            "field_type": 4,
                            "help_text": "The major global type held by this person for this particular PersonRole instance(e.g. Head of State, Top-Level Cabinet Member, etc.)",
                            "name": "major_person_type",
                            "verbose_name": "major person type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MinorPersonType" },
                            "field_type": 4,
                            "help_text": "The minor type held by this person, oftentimes specific to a region/country(e.g. Senator, Department Secretary, etc.)",
                            "name": "minor_person_type",
                            "verbose_name": "minor person type"
                        },
                        { "field_type": 4, "help_text": "The specific type held by a person for this particular PersonRole instance(e.g. Speaker, House Majority Leader, etc.)", "name": "specific_person_type", "verbose_name": "specific person type" },
                        { "field_type": 3, "help_text": "The person role title.", "name": "title", "verbose_name": "title" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "primary_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "primary organization"
                        },
                        { "field_type": 1, "help_text": "Whether this PersonRole is currently applicable/currently held. Should be completely redundant given startdate and enddate.", "name": "current", "verbose_name": "current" },
                        { "field_type": 1, "help_text": "Whether the role is an incoming role or not.", "name": "incoming", "verbose_name": "incoming" },
                        { "field_type": 1, "help_text": "Whether the person is retiring from this role.", "name": "leaving", "verbose_name": "leaving" },
                        { "field_type": 5, "help_text": "The date the role began (when the person took office).", "name": "startdate", "verbose_name": "startdate" },
                        { "field_type": 5, "help_text": "The date the official was first elected into this role.", "name": "first_election_date", "verbose_name": "first election date" },
                        { "field_type": 5, "help_text": "The date the official was first appointed into this role.", "name": "assumed_office_date", "verbose_name": "assumed office date" },
                        { "field_type": 5, "help_text": "The date the role ended (when the person resigned, died, etc.)", "name": "enddate", "verbose_name": "enddate" },
                        { "field_type": 4, "help_text": "For representatives, the number of their congressional district. 0 for at-large districts.", "name": "district", "verbose_name": "district" },
                        { "field_type": 2, "help_text": "Some State Legislators have character Districts", "name": "district_char", "verbose_name": "district char" },
                        { "field_type": 2, "help_text": "For senators and representatives, the two-letter USPS abbrevation for the state or\n                     territory they are serving. Values are the abbreviations for the 50 states\n                     (each of which have at least one representative and two senators, assuming no vacancies)\n                     plus DC, PR, and the island territories AS, GU, MP, and VI (all of which have a non-voting delegate),\n                     and for really old historical data you will also find PI (Philippines, 1907-1946),\n                     DK (Dakota Territory, 1861-1889), and OR (Orleans Territory, 1806-1811) for non-voting delegates.", "name": "state", "verbose_name": "state" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "upper_district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "upper district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "lower_district_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "lower district obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "state_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state obj"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "country_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "verbose_name": "country obj"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The political party of the person.",
                            "name": "party",
                            "verbose_name": "party"
                        },
                        { "field_type": 2, "help_text": "The name of the political party", "name": "party_name", "verbose_name": "party name" },
                        { "field_type": 3, "help_text": "The URL to the official website of the person during this role, if known.", "name": "website", "verbose_name": "website" },
                        { "field_type": 2, "help_text": "The URL to the official position website of the person during this role, if known. Otherwise null.", "name": "contact_website", "verbose_name": "contact website" },
                        { "field_type": 2, "help_text": "The last known phone number of the official during this role, if known.", "is_contact_info": true, "name": "phone", "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 3, "verbose_name": "Phone" },
                        { "field_type": 2, "help_text": "The last known mobile phone number of the official during this role, if known.", "name": "mobile_phone", "verbose_name": "mobile phone" },
                        { "field_type": 2, "help_text": "The last known leadership role held during this role, if any.", "name": "leadership_title", "verbose_name": "leadership title" },
                        { "field_type": 2, "help_text": "Most recent office address", "name": "address", "verbose_name": "address" },
                        { "field_type": 2, "help_text": "Most recent office address (shorter form)", "name": "office", "verbose_name": "office" },
                        { "field_type": 3, "help_text": "most recent office room", "name": "office_room", "verbose_name": "office room" },
                        { "field_type": 3, "help_text": "most recent office building", "name": "office_building", "verbose_name": "office building" },
                        { "field_type": 3, "help_text": "most recent office address first line", "name": "office_street1", "verbose_name": "office street1" },
                        { "field_type": 3, "help_text": "most recent office address second line", "name": "office_street2", "verbose_name": "office street2" },
                        { "field_type": 3, "help_text": "most recent office zipcode", "name": "office_zipcode", "verbose_name": "office zipcode" },
                        { "field_type": 3, "help_text": "most recent office city", "name": "office_city", "verbose_name": "office city" },
                        { "field_type": 3, "help_text": "most recent office state", "name": "office_state", "verbose_name": "office state" },
                        { "field_type": 3, "help_text": "most recent office country", "name": "office_country", "verbose_name": "office country" },
                        { "field_type": 2, "help_text": "Seat status from Know Who", "name": "kw_seat_status", "verbose_name": "kw seat status" },
                        { "field_type": 1, "help_text": "Seat status code from Know Who", "name": "kw_seat_status_code", "verbose_name": "kw seat status code" },
                        { "field_type": 6, "help_text": "Percentage of vote in last election", "name": "lastelection", "verbose_name": "Percentage Votes in Last Election" },
                        {
                            "field_type": 4,
                            "help_text": "When is the person up for reelection",
                            "miscellaneous": 1,
                            "name": "reelectionyear",
                            "overriden_column_data_type": 2,
                            "sheet_column": true,
                            "sheets_column_order": 11,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 10004, 10005, 1000],
                            "verbose_name": "Next Election Year"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The Region which the person role is for.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "ProfileInfoSource" },
                            "field_type": 4,
                            "help_text": "The most recent site from which we have scraped information to fill out the person's profile",
                            "name": "profile_info_source",
                            "verbose_name": "profile info source"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "AppointedByType" },
                            "field_type": 4,
                            "help_text": "The AppointedByType for a given role",
                            "name": "appointed_by_type",
                            "verbose_name": "appointed by type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PayScaleType" },
                            "field_type": 4,
                            "help_text": "The PayScaleType for a given role",
                            "name": "pay_scale_type",
                            "verbose_name": "pay scale type"
                        },
                        { "field_type": 1, "help_text": "Marks whether a role is considered Primary by the source that its from", "name": "is_primary_from_source", "verbose_name": "is primary from source" },
                        { "field_type": 4, "help_text": "Marks the order for which this role is set in the International & EU editorial tools (if applicable)", "name": "editorial_precedence", "verbose_name": "editorial precedence" },
                        {
                            "field_type": 8,
                            "help_text": "The congresses this role spans",
                            "name": "congresses",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congresses"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The congresses this role spans",
                            "name": "sessions",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "sessions"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The KW staffer title(s) associated with this role.",
                            "name": "_ph_kw_staffer_titles",
                            "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                            "verbose_name": " ph kw staffer titles"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The KW responsibilit(ies) associated with this role.",
                            "name": "_ph_kw_responsibilities",
                            "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                            "verbose_name": " ph kw responsibilities"
                        }
                    ]
                },
                "PublicOrganization": {
                    "__is_model": true,
                    "__name__": "PublicOrganization",
                    "data_model": "app.person.models.PublicOrganization",
                    "default_exclude_filters": {},
                    "default_filters": { "active": true, "archived": false },
                    "endpoint": "/api/publicorganization/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        { "field_type": 2, "help_text": "The name of this organization.", "name": "name", "sheet_column": true, "sheets_column_order": 4, "verbose_name": "Organization Name" },
                        { "field_type": 2, "help_text": "An abbreviation for the public organization.", "name": "abbrev", "sheet_column": true, "verbose_name": "Abbreviation" },
                        { "field_type": 2, "help_text": "The organization-specific unique identifier", "name": "unique_identifier", "sheet_column": true, "verbose_name": "Unique Identifier" },
                        { "field_type": 4, "help_text": "KnowWho's ExecOrgID for the tblExecOrg entry corresponding to this PublicOrganization.", "name": "_ph_kw_exec_org_id", "verbose_name": " ph kw exec org id" },
                        { "field_type": 4, "help_text": "KnowWho's OfficeID for the countymuni.tblExecLegJudOffices entry corresponding to this PublicOrganiation.", "name": "_ph_kw_cm_office_id", "verbose_name": " ph kw cm office id" },
                        { "field_type": 4, "help_text": "For 'office-of' legislative orgs and candidacies, the PersonID of KnowWho's tblPeople entry for the person to whom this office belongs.", "name": "_ph_kw_person_id", "verbose_name": " ph kw person id" },
                        { "field_type": null, "help_text": "For legislative leadership positions, the LegOfcIDs of KnowWho's tblLegOfc entries for the role to which this organization corresponds.", "name": "_ph_kw_leg_ofc_ids", "verbose_name": " ph kw leg ofc ids" },
                        { "field_type": 4, "help_text": "For legislative candidacies, the LegCandidateID of KnowWho's tblLegCandidate entry for the candidacy.", "name": "_ph_kw_leg_candidate_id", "verbose_name": " ph kw leg candidate id" },
                        { "field_type": null, "help_text": "For legislative candidacies, the LegCandidateIDs of KnowWho's tblLegCandidate entries for the candidacies to which this organization corresponds.", "name": "_ph_kw_leg_candidate_ids", "verbose_name": " ph kw leg candidate ids" },
                        { "field_type": 4, "help_text": "For executive candidacies, the ExecCandidateID of KnowWho's tblExecCandidate entry for the candidacy.", "name": "_ph_kw_exec_candidate_id", "verbose_name": " ph kw exec candidate id" },
                        { "field_type": null, "help_text": "For executive candidacies, the ExecCandidateIDs of KnowWho's tblExecCandidate entries for the candidacies to which this organization corresponds.", "name": "_ph_kw_exec_candidate_ids", "verbose_name": " ph kw exec candidate ids" },
                        { "field_type": null, "help_text": "KnowWho's LegElectIDs for the tblLegElect entries corresponding to this Office-Of PublicOrganization. Not present in Level-2 data.", "name": "_ph_kw_leg_elect_ids", "verbose_name": " ph kw leg elect ids" },
                        { "field_type": null, "help_text": "KnowWho's ExecElectIDs for the set of tblExecElect entries corresponding to this Office-Of PublicOrganization. Not present in Level-2 data.", "name": "_ph_kw_exec_elect_ids", "verbose_name": " ph kw exec elect ids" },
                        { "field_type": 4, "help_text": "For PublicOrganizations copied from KnowWho committees, the LegComID of KnowWho's tblLegCom entry for this committee.", "name": "_ph_kw_leg_com_id", "verbose_name": " ph kw leg com id" },
                        { "field_type": 2, "help_text": "", "name": "kw_name", "verbose_name": "kw name" },
                        { "field_type": 4, "help_text": "DEPRECATED", "name": "wiwid", "verbose_name": "wiwid" },
                        { "field_type": 3, "help_text": "A PublicOrganization's WhoisWho ID", "name": "wiw_id", "verbose_name": "wiw id" },
                        { "field_type": 2, "help_text": "Name from who is who", "name": "wiw_name", "verbose_name": "wiw name" },
                        { "field_type": 3, "help_text": "A PublicOrganization's full path in WhoisWho. Denoted as a\n                     long string like `European Union/European Commission/...`", "name": "wiw_path", "verbose_name": "wiw path" },
                        { "field_type": 16, "help_text": "The last time the Public Org object was updated from WIW", "name": "last_updated", "verbose_name": "last updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "parent_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "parent organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "top_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "top organization"
                        },
                        { "field_type": 4, "help_text": "How deep this organization is. Depth of 0 corresponds to US Congress and the European Union, depth of 1 is Commission, House, etc.", "name": "depth", "verbose_name": "depth" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "PublicOrganizationType" },
                            "field_type": 4,
                            "help_text": "The type of this public organization, such as legislative body or executive office.",
                            "name": "organization_type",
                            "sheet_column": true,
                            "verbose_name": "Organization Type"
                        },
                        { "field_type": null, "help_text": "The global non-custom organization type, e.g. an executive branch or an upper state legislative branch", "name": "major_organization_types", "verbose_name": "major organization types" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "SectorType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_sector_type",
                            "verbose_name": " ph sector type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "MetaOrganizationType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_meta_organization_type",
                            "verbose_name": " ph meta organization type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.newtypes", "__name__": "NewMajorOrganizationType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "_ph_major_organization_type",
                            "verbose_name": " ph major organization type"
                        },
                        { "field_type": 2, "help_text": "Public Org Website", "name": "website", "sheet_column": true, "verbose_name": "Website" },
                        { "field_type": 2, "help_text": "The URL where we scraped data for this public organization. Primarily used for who-is-who pages for EU pub orgs.", "name": "source_url", "verbose_name": "source url" },
                        { "field_type": null, "help_text": "The different urls where we can find this org on the web (via our consultants)", "name": "source_urls", "verbose_name": "source urls" },
                        { "field_type": 3, "help_text": "The image url of this public org, like one you would find on Google image", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 3, "help_text": "The local path of the image for a person on Update server, which is often under settings.DATA_PATH", "name": "local_image_path", "verbose_name": "local image path" },
                        { "field_type": 3, "help_text": "The URL of this person's image/avatar that is actually rendered on the frontend (most likely an S3 URL with correct CORS)", "name": "s3_image_url", "verbose_name": "s3 image url" },
                        { "field_type": 3, "help_text": "Used by update_static to check whether the image we process for a puborg is identical to the image file used in a previous run.", "name": "image_b64_hash", "verbose_name": "image b64 hash" },
                        { "field_type": 3, "help_text": "The Wikipedia URL for this public org, if any", "name": "wikipedia_url", "verbose_name": "wikipedia url" },
                        { "field_type": 2, "help_text": "The telephone number for this organization.", "name": "phone_number", "sheet_column": true, "verbose_name": "Telephone Number" },
                        { "field_type": 2, "help_text": "The pub org's email.", "name": "email", "sheet_column": true, "verbose_name": "Email" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "EntityType" },
                            "field_type": 4,
                            "help_text": "The political action committee (PAC) type of this organization, if applicable.",
                            "name": "pac_org_type",
                            "permission_enum": [8],
                            "sheet_column": true,
                            "verbose_name": "PAC Type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        { "field_type": null, "help_text": "The Point (lat, lon) where this public org is based at, if any", "name": "shipping_coordinates", "verbose_name": "shipping coordinates" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region where this organization operates.",
                            "name": "region",
                            "sheet_column": true,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The county where this Public Organization resides",
                            "name": "county",
                            "related_model": { "__module__": "app.geography.models", "__name__": "County" },
                            "verbose_name": "county"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The municipality/place where this Public Organization resides",
                            "name": "municipality",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Municipality" },
                            "verbose_name": "municipality"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The state where this Public Organization resides",
                            "name": "state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "state"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The congressional district where this Public Organization resides",
                            "name": "congressional_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "congressional district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The upper state legislative district where this Public Organization resides",
                            "name": "upper_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "upper ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The lower state legislative disrtict this Public Organization resides",
                            "name": "lower_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "lower ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The country this Public Organization is associated with",
                            "name": "country_obj",
                            "related_model": { "__module__": "app.geography.models", "__name__": "Country" },
                            "sheet_column": true,
                            "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                            "verbose_name": "country obj"
                        },
                        { "field_type": 3, "help_text": "", "name": "billing_address", "verbose_name": "Billing Address" },
                        { "field_type": 2, "help_text": "", "name": "billing_street", "verbose_name": "Billing Street Address" },
                        { "field_type": 3, "help_text": "", "name": "billing_street_2", "verbose_name": "Billing Street Address, Second Line" },
                        { "field_type": 2, "help_text": "", "name": "billing_city", "verbose_name": "Billing City" },
                        { "field_type": 2, "help_text": "", "name": "billing_state", "verbose_name": "Billing State/Province" },
                        { "field_type": 2, "help_text": "", "name": "billing_postal_code", "verbose_name": "Billing Postal Code" },
                        { "field_type": 3, "help_text": "", "name": "billing_country", "verbose_name": "Billing Country" },
                        { "field_type": 3, "help_text": "A shipping (default) address for the organization.", "name": "shipping_address", "sheet_column": true, "verbose_name": "Address" },
                        { "field_type": 2, "help_text": "", "name": "shipping_street", "verbose_name": "Shipping Street Address" },
                        { "field_type": 3, "help_text": "", "name": "shipping_street_2", "verbose_name": "Shipping Street Address, Second Line" },
                        { "field_type": 2, "help_text": "", "name": "shipping_city", "verbose_name": "Shipping City" },
                        { "field_type": 2, "help_text": "", "name": "shipping_state", "verbose_name": "Shipping State/Province" },
                        { "field_type": 2, "help_text": "", "name": "shipping_postal_code", "verbose_name": "Shipping Postal Code" },
                        { "field_type": 3, "help_text": "", "name": "shipping_country", "verbose_name": "Shipping Country" },
                        { "field_type": 2, "help_text": "The address we get from wiw", "name": "wiw_address", "verbose_name": "wiw address" },
                        { "field_type": 1, "help_text": "", "name": "active", "verbose_name": "active" },
                        { "field_type": 1, "help_text": "", "name": "secondary", "verbose_name": "secondary" },
                        { "field_type": null, "help_text": "", "name": "twitter_array", "verbose_name": "twitter array" },
                        { "field_type": null, "help_text": "", "name": "facebook_array", "verbose_name": "facebook array" },
                        { "field_type": null, "help_text": "", "name": "facebook_url_array", "verbose_name": "facebook url array" },
                        { "field_type": null, "help_text": "", "name": "instagram_array", "verbose_name": "instagram array" },
                        { "field_type": null, "help_text": "", "name": "medium_array", "verbose_name": "medium array" },
                        { "field_type": null, "help_text": "", "name": "youtube_array", "verbose_name": "youtube array" },
                        { "field_type": 4, "help_text": "The Outlet's original source id in LexisNexis.", "name": "ln_source_id", "verbose_name": "ln source id" },
                        { "field_type": null, "help_text": "The ids of the sources in LexisNexis that this Outlet corresponds to.  Must always contain ln_source_id.", "name": "ln_source_ids", "verbose_name": "ln source ids" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "MediaSourceRank" },
                            "field_type": 4,
                            "help_text": "The source's rank (importance) as defined by LexisNexis.  Only relevant for news outlets.",
                            "name": "ln_rank",
                            "verbose_name": "ln rank"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "MediaSourceCategory" },
                            "field_type": 4,
                            "help_text": "The type of news this source writes about as defined by LexisNexis.  Only relevant for news outlets.",
                            "name": "ln_category",
                            "verbose_name": "ln category"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "MediaSourceType" },
                            "field_type": 4,
                            "help_text": "The medium this source's news is delivered on as defined by LexisNexis.  Only relevant for news outlets.",
                            "name": "ln_media_type",
                            "verbose_name": "ln media type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "XFrameOptionsType" },
                            "field_type": 4,
                            "help_text": "For Media Outlets, this enum denotes whether we can show iframes of articles from this source",
                            "name": "x_frame_options",
                            "verbose_name": "x frame options"
                        },
                        { "field_type": 16, "help_text": "The last time the Public Org object was checked by ArchiveNotSupportedOutletArticlesCronJob", "name": "ln_archive_checked_date", "verbose_name": "ln archive checked date" },
                        { "field_type": 2, "help_text": "\n            A 9-character alphanumeric code assigned to a candidacy by the FEC.\n            Remains the same across election cycles as long as the candidate runs for the\n            same office.\n\n            Corresponds to government.tbllegcandidate.FECLinkNum or government.tblexeccandidate.FECLinkNum\n            in KnowWho level-3 data, and to candidate.CAND_ID or committee.CAND_ID in FEC bulk campaign finance data.\n        ", "name": "fec_candidacy_id", "verbose_name": "fec candidacy id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac.types", "__name__": "FecCandidateStatus" },
                            "field_type": 4,
                            "help_text": "\n            Status assigned by the FEC: Is this candidate an incumbent, challenger, or running for an open seat?\n            If blank, this org probably isn't a US Federal candidacy.\n        ",
                            "name": "fec_incumbent_challenger_status",
                            "verbose_name": "fec incumbent challenger status"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If a candidacy for US House, the District this candidacy is targeting.",
                            "name": "leg_candidate_sought_district",
                            "related_model": { "__module__": "app.geography.models", "__name__": "District" },
                            "verbose_name": "leg candidate sought district"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If a candidacy for state Senate, the UpperLD this candidacy is targeting.",
                            "name": "leg_candidate_sought_upper_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "UpperLD" },
                            "verbose_name": "leg candidate sought upper ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "If a candidacy for state House, the LowerLD this candidacy is targeting.",
                            "name": "leg_candidate_sought_lower_ld",
                            "related_model": { "__module__": "app.geography.models", "__name__": "LowerLD" },
                            "verbose_name": "leg candidate sought lower ld"
                        },
                        {
                            "field_type": 7,
                            "help_text": "\n        If a federal or state legislative candidacy, the State containing the office this candidacy is targeting.\n        For example, candidates for US Representative from Vermont, US Senator from Vermont, Vermont House, and\n        Vermont Senate would all use the Vermont State.\n\n        This column is left null for executive candidacies, since all candidacies for executives representing a state\n        (gvnr, lt. gvnr, attorney general, etc.) have a region value corresponding to the region of that state.\n        ",
                            "name": "leg_candidate_sought_state",
                            "related_model": { "__module__": "app.geography.models", "__name__": "State" },
                            "verbose_name": "leg candidate sought state"
                        },
                        { "field_type": 1, "help_text": "", "name": "pacc_is_parent", "verbose_name": "pacc is parent" },
                        { "field_type": 1, "help_text": "", "name": "pacc_has_parent", "verbose_name": "pacc has parent" },
                        { "field_type": 4, "help_text": "The OrganizationID from PACC, if this record was imported", "name": "pacc_organization_id", "verbose_name": "pacc organization id" },
                        { "field_type": 4, "help_text": "The PACOrganizationID from PACC, if this record was imported", "name": "pacc_pacorganizationid", "verbose_name": "pacc pacorganizationid" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "field_type": 3, "help_text": "The PACLimitType code from PACC, if this record was imported", "name": "pacc_paclimittype", "verbose_name": "pacc paclimittype" },
                        { "field_type": 3, "help_text": "The fax number of the Public Organization, if any.", "name": "fax", "verbose_name": "fax" },
                        { "field_type": 3, "help_text": "The domain of the outlet website", "name": "_ph_website_domain", "verbose_name": " ph website domain" },
                        { "field_type": null, "help_text": "\n            All regions for the outlet, including its own region and child regions.\n            For example, a global Outlet can be include child outlets in [Region.ireland, Region.france]\n        ", "name": "_ph_outlet_regions", "verbose_name": " ph outlet regions" },
                        { "field_type": 16, "help_text": "The last time the Public Org object was updated from Intrado", "name": "_ph_intrado_last_updated", "verbose_name": " ph intrado last updated" },
                        { "field_type": 4, "help_text": "A UniqueID for an Outlet originating from the Intrado data source.", "name": "_ph_intrado_outlet_id", "verbose_name": " ph intrado outlet id" },
                        { "field_type": null, "help_text": "The different Intrado Tags associated with this Outlet", "name": "intrado_tags", "verbose_name": "intrado tags" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoCoverage" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's Coverage values",
                            "name": "intrado_coverage",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip_text": "Coverage area of outlet.",
                            "verbose_name": "Coverage"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.document.types", "__name__": "Language" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's language values",
                            "name": "intrado_language",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip_text": "Primary publication language of outlet.",
                            "verbose_name": "Language"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoFrequency" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's frequency values",
                            "name": "intrado_frequency",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip_text": "Publication frequency of outlet.",
                            "verbose_name": "Frequency"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoMediaType" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's Media Type values",
                            "name": "intrado_media_type",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip": "Type of media published by outlet.",
                            "verbose_name": "Media Type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoOutletTier" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's Outlet Tier values",
                            "name": "intrado_outlet_tier",
                            "verbose_name": "intrado outlet tier"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.media_monitoring.types", "__name__": "IntradoAudienceFocus" },
                            "field_type": 4,
                            "help_text": "The Enum associated with Intrado's Audience Focus values",
                            "name": "intrado_audience_focus",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip_text": "Audience focus of outlet.",
                            "verbose_name": "Audience Focus"
                        },
                        {
                            "field_type": 4,
                            "help_text": "\n            Claimed audience size of an outlet. Circulation is driven by UVPD (unique visitors per day)\n             for Websites or subscriber circulation numbers for print publications\n            ",
                            "name": "intrado_circulation",
                            "permission_enum": [105],
                            "sheet_column": true,
                            "sheets_tooltip_text": "Size of audience of outlet.",
                            "verbose_name": "Circulation"
                        },
                        { "field_type": 4, "help_text": "KnowWho's SchoolDistrictOfficeID for the countymuni.tblSchoolDistrictOffices entry corresponding to this PublicOrganiation.", "name": "_ph_kw_sd_office_id", "verbose_name": " ph kw sd office id" },
                        { "field_type": 2, "help_text": "The Primary NAICS code for this organization, see https://www.census.gov/naics/ for the complete list of valid values", "name": "naics_code", "verbose_name": "Primary NAICS Code" },
                        { "field_type": 2, "help_text": "The level of education provided by the district - Elementary, Middle, High, etc.", "name": "district_level", "verbose_name": "District Level" },
                        { "field_type": 2, "help_text": "The kind of Local Education Agency (LEA) this district represents.", "name": "lea_classification", "verbose_name": "LEA Classification" },
                        { "field_type": 2, "help_text": "The NCES ID of this organization, see https://nces.ed.gov/ccd/schoolsearch/ to search for districts by id.", "name": "nces", "verbose_name": "NCES" },
                        { "field_type": 4, "help_text": "The number of people enrolled at this school district.", "name": "enrollment", "verbose_name": "Enrollment" },
                        { "field_type": 4, "help_text": "Leadership Connect's ID corresponding to a PublicOrganization.", "name": "_ph_lc_org_id", "verbose_name": " ph lc org id" },
                        { "field_type": 4, "help_text": "For 'office-of' legislative orgs, the core_person_id of Legistorm's core_person entry for the person to whom this office belongs.", "name": "_ph_ls_core_person_id", "verbose_name": " ph ls core person id" },
                        { "field_type": 1, "help_text": "If true, hide this organization by default. This is meant for a handful of scraped orgs with inappropriate names.", "name": "is_censored", "verbose_name": "is censored" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this organization is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "people",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "people"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "election_cycles",
                            "related_model": { "__module__": "app.pac.models.election_cycle", "__name__": "ElectionCycle" },
                            "verbose_name": "election cycles"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "beats",
                            "permission_enum": [105],
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "Beat" },
                            "sheet_column": true,
                            "verbose_name": "beats"
                        },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "dma",
                            "permission_enum": [105],
                            "related_model": { "__module__": "app.media_monitoring.models", "__name__": "DesignatedMarketArea" },
                            "sheet_column": true,
                            "verbose_name": "dma"
                        }
                    ]
                },
                "StaffTitle": {
                    "__is_model": true,
                    "__name__": "StaffTitle",
                    "data_model": "app.person.models.StaffTitle",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/stafftitle/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "StafferType" },
                            "field_type": 4,
                            "help_text": "Type of staffer title -- committees and members use different ones",
                            "name": "title_type",
                            "verbose_name": "title type"
                        },
                        { "field_type": 4, "help_text": "", "name": "order", "verbose_name": "order" },
                        { "field_type": 16, "help_text": "The last time KW updated this staffer title's information", "name": "kw_last_updated", "verbose_name": "kw last updated" },
                        { "field_type": null, "help_text": "The list of government.lutlegroles IDs that carry this title.", "name": "_ph_kw_leg_role_ids", "verbose_name": " ph kw leg role ids" },
                        { "field_type": null, "help_text": "The list of government.lutexecroles IDs that carry this title.", "name": "_ph_kw_exec_role_ids", "verbose_name": " ph kw exec role ids" }
                    ]
                },
                "StafferTerm": {
                    "__is_model": true,
                    "__name__": "StafferTerm",
                    "data_model": "app.person.models.StafferTerm",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/stafferterm/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 4, "help_text": "", "name": "kw_responsibility_id", "verbose_name": "kw responsibility id" },
                        { "field_type": 2, "help_text": "", "name": "kw_responsibility", "verbose_name": "kw responsibility" },
                        { "field_type": 2, "help_text": "", "name": "kw_responsibility_short", "verbose_name": "kw responsibility short" },
                        { "field_type": 4, "help_text": "Leadership Connect's JobFocus id", "name": "lc_job_focus_id", "verbose_name": "lc job focus id" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "term",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "term"
                        }
                    ]
                }
            },
            "newtypes": {
                "MajorOrganizationType": {
                    "__is_enum": true,
                    "executive_agency_1": {
                        "description": "\n            A ministry or agency that is contained within the Executive Branch of a given country\n            (for example, the French Ministry of the Economy, Industry, and Employment).\n        ",
                        "key": "executive_agency_1",
                        "label": "Top Level Ministry/Agency",
                        "min_per_country": 1,
                        "order": 7,
                        "required_parent_type": [5],
                        "unique_identifier": "EB1",
                        "value": 7
                    },
                    "executive_agency_2": {
                        "description": "\n            A sub-organization within an Executive ministry / agency (for example,\n            the French Directorate-General of Customs and Indirect Taxes within the Ministry\n            of the Economy, Industry, and Employment).\n        ",
                        "key": "executive_agency_2",
                        "label": "Second-Level Ministry/Agency",
                        "order": 8,
                        "required_parent_type": [7],
                        "unique_identifier": "EB2",
                        "value": 8
                    },
                    "executive_agency_3": {
                        "description": "\n            A sub-sub-organization within an Executive ministry / agency (for example,\n            the Office of Information and Communication within the French Directorate-General\n            of Customs and Indirect Taxes).\n        ",
                        "key": "executive_agency_3",
                        "label": "Third-Level Ministry/Agency",
                        "order": 9,
                        "required_parent_type": [8],
                        "unique_identifier": "EB3",
                        "value": 9
                    },
                    "executive_branch": {
                        "description": "The executive branch of a specific country, including both the head of government & staff and all ministries.",
                        "key": "executive_branch",
                        "label": "Executive Branch",
                        "max_per_country": 1,
                        "min_per_country": 1,
                        "order": 6,
                        "required_parent_type": [1],
                        "unique_identifier": "EB",
                        "value": 5
                    },
                    "judicial_branch": {
                        "description": "The Judicial Branch of a Country.",
                        "key": "judicial_branch",
                        "label": "Judicial Branch",
                        "max_per_country": 1,
                        "min_per_country": 1,
                        "order": 5,
                        "required_parent_type": [1],
                        "unique_identifier": "JB",
                        "value": 6
                    },
                    "judicial_court_1": {
                        "description": "\n            The highest levels of the judiciary in a specific country. In the United States,\n            this would be the Supreme Court.\n        ",
                        "key": "judicial_court_1",
                        "label": "Top-Level Judiciary",
                        "order": 18,
                        "required_parent_type": [6],
                        "unique_identifier": "JB1",
                        "value": 18
                    },
                    "judicial_court_2": {
                        "description": "\n            The second level of the judiciary in a specific country. In the United States,\n            this would be the apellate courts.\n        ",
                        "key": "judicial_court_2",
                        "label": "Second-Level Judiciary",
                        "order": 18,
                        "required_parent_type": [6],
                        "unique_identifier": "JB2",
                        "value": 19
                    },
                    "legislative_branch": {
                        "description": "The national legislative branch of a country.",
                        "key": "legislative_branch",
                        "label": "Legislative Branch",
                        "max_per_country": 1,
                        "min_per_country": 1,
                        "order": 2,
                        "required_parent_type": [1],
                        "unique_identifier": "LB",
                        "value": 2
                    },
                    "legislative_committee": {
                        "description": "A committee / group of legislators within a given country's legislature.",
                        "key": "legislative_committee",
                        "label": "Legislative Committee",
                        "min_per_country": 1,
                        "order": 10,
                        "required_parent_type": [3, 4, 16, 17],
                        "unique_identifier": "COM",
                        "value": 10
                    },
                    "lower_legislative_branch": {
                        "description": "The lower legislative body of a specific country (i.e. the French Assembly).",
                        "key": "lower_legislative_branch",
                        "label": "Lower Legislative Branch",
                        "max_per_country": 1,
                        "order": 4,
                        "required_parent_type": [2],
                        "unique_identifier": "LLB",
                        "value": 4
                    },
                    "nation_state": { "description": "This organization represents the entire government for a specific country (i.e. Government of France).", "key": "nation_state", "label": "Nation State", "max_per_country": 1, "min_per_country": 1, "order": 1, "unique_identifier": "NS", "value": 1 },
                    "political_party": {
                        "description": "A political party.",
                        "key": "political_party",
                        "label": "Political Party",
                        "min_per_country": 1,
                        "order": 11,
                        "required_parent_type": [1, 12],
                        "unique_identifier": "PP",
                        "value": 11
                    },
                    "state": {
                        "description": "A sub-national state or province.",
                        "key": "state",
                        "label": "State / Province",
                        "order": 12,
                        "required_parent_type": [1],
                        "unique_identifier": "STA",
                        "value": 12
                    },
                    "state_executive_agency_1": {
                        "description": "A ministry or agency that is contained within the Executive Branch of a given state / province.",
                        "key": "state_executive_agency_1",
                        "label": "State Top-Level Ministry/Agency",
                        "order": 14,
                        "required_parent_type": [13],
                        "unique_identifier": "SEB1",
                        "value": 14
                    },
                    "state_executive_branch": {
                        "description": "The executive branch of a sub-national state / province.",
                        "key": "state_executive_branch",
                        "label": "State Executive Branch",
                        "order": 13,
                        "required_parent_type": [12],
                        "unique_identifier": "SEB",
                        "value": 13
                    },
                    "state_legislative_branch": {
                        "description": "The legislative branch of a state / province.",
                        "key": "state_legislative_branch",
                        "label": "State Legislative Branch",
                        "order": 15,
                        "required_parent_type": [12],
                        "unique_identifier": "SLB",
                        "value": 15
                    },
                    "state_lower_legislative_branch": {
                        "description": "The lower legislative body of a state / province.",
                        "key": "state_lower_legislative_branch",
                        "label": "State Lower Legislative Branch",
                        "order": 17,
                        "required_parent_type": [15],
                        "unique_identifier": "LULB",
                        "value": 17
                    },
                    "state_upper_legislative_branch": {
                        "description": "The upper legislative body of a state / province.",
                        "key": "state_upper_legislative_branch",
                        "label": "State Upper Legislative Branch",
                        "order": 16,
                        "required_parent_type": [15],
                        "unique_identifier": "SULB",
                        "value": 16
                    },
                    "upper_legislative_branch": {
                        "description": "The upper legislative body of a specific country (i.e. the French Senate).",
                        "key": "upper_legislative_branch",
                        "label": "Upper Legislative Branch",
                        "max_per_country": 1,
                        "order": 3,
                        "required_parent_type": [2],
                        "unique_identifier": "ULB",
                        "value": 3
                    }
                },
                "MajorPersonType": {
                    "__is_enum": true,
                    "committee_leader": {
                        "allowed_organization_types": [10],
                        "description": "A person that leads a committee (a committee chair or ranking member).",
                        "key": "committee_leader",
                        "label": "Committee Leader",
                        "name": "Committee Leader",
                        "precedence": 5,
                        "region_specific_dict": {
                            "belgium": { "count": 32, "title": "Committee Leader" },
                            "canada": { "title": "Committee Chair" },
                            "costa_rica": { "count": 46, "title": "Committee Leader" },
                            "denmark": { "title": "Committee Chairperson" },
                            "malaysia": { "count": 9, "title": "Chairman" },
                            "philippines": { "count": 266, "title": "Commitee Leader" },
                            "poland": { "title": "Committee Chairperson" },
                            "south_africa": { "title": "Committee Chairperson" },
                            "south_korea": { "title": "Chairman" },
                            "vietnam": { "count": 15, "title": "Committee Chairman" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "CL",
                        "value": 6
                    },
                    "deputy_head_of_government": {
                        "allowed_organization_types": [5],
                        "description": "\n            The second or third-highest official in the executive branch of a country\n            -- for example, a Vice President or Deputy Prime Minister.\n        ",
                        "key": "deputy_head_of_government",
                        "label": "Deputy Head of Government",
                        "name": "Deputy Head of Government",
                        "precedence": 3,
                        "region_specific_dict": {
                            "argentina": { "count": 1, "title": "Vice President" },
                            "australia": { "count": 1, "title": "Deputy Prime Minister" },
                            "belgium": { "count": 7, "title": "Deputy Prime Minister" },
                            "brazil": {
                                "count": [0, 1],
                                "title": "Vice President"
                            },
                            "canada": { "count": 1, "title": "Deputy Prime Minister" },
                            "chile": { "count": 1, "title": "Vice-President" },
                            "china": { "count": 1, "title": "Vice President" },
                            "colombia": { "count": 1, "title": "Vice President" },
                            "costa_rica": { "count": 2, "title": "Vice President" },
                            "france": { "count": 0, "title": "Deputy Prime Minister" },
                            "germany": { "count": 1, "title": "Vice Chancellor" },
                            "india": { "count": 0, "title": "Deputy Prime Minister" },
                            "indonesia": { "count": 1, "title": "Vice President" },
                            "ireland": { "count": 1, "title": "Tanaiste" },
                            "italy": { "count": 2, "title": "Deputy Prime Minister" },
                            "japan": {
                                "count": [0, 1],
                                "title": "Deputy Prime Minister"
                            },
                            "mexico": { "count": 0, "title": "Vice President" },
                            "netherlands": { "count": 1, "title": "Deputy Prime Minister" },
                            "new_zealand": { "count": 1, "title": "Deputy Prime Minister" },
                            "philippines": { "count": 1, "title": "Vice President" },
                            "poland": { "count": 1, "title": "Deputy Prime Minister" },
                            "saudi_arabia": { "count": 1, "title": "Crown Prince" },
                            "singapore": { "count": 1, "title": "Deputy Prime Minister" },
                            "south_africa": {
                                "count": [0, 1],
                                "title": "Deputy President"
                            },
                            "south_korea": {
                                "count": [0, 1],
                                "title": "Deputy Prime Minister"
                            },
                            "spain": { "count": 1, "title": "Vice President of the Government" },
                            "sweden": { "count": 1, "title": "Deputy Prime Minister" },
                            "taiwan": { "count": 1, "title": "Vice-President" },
                            "thailand": { "count": 1, "title": "Deputy Prime Minister" },
                            "united_kingdom": { "count": 0, "title": "Deputy Prime Minister" },
                            "vietnam": { "count": 4, "title": "Deputy Prime Minister" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 203, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 218, 219, 220, 221, 222, 223, 224, 225, 226, 229, 230, 231, 232, 233],
                        "unique_identifier": "DHOG",
                        "value": 3
                    },
                    "deputy_sub_national_head_of_state": {
                        "allowed_organization_types": [12],
                        "description": "\n            The deputy chief public representative of a state or province, such as\n            a Lt. Governor in Australia.\n        ",
                        "key": "deputy_sub_national_head_of_state",
                        "label": "Deputy Sub-national Head of State",
                        "name": "Deputy Sub-national Head of State",
                        "precedence": 22,
                        "region_specific_dict": {
                            "argentina": {
                                "count": [24],
                                "title": "Governor"
                            },
                            "australia": {
                                "count": [0, 9],
                                "title": "Lt. Governor"
                            },
                            "brazil": {
                                "count": [0, 27],
                                "title": "Deputy Governor"
                            },
                            "india": {
                                "count": [6, 7],
                                "title": "Lt. Governor/Administrator"
                            },
                            "mexico": {
                                "count": [27],
                                "title": "General Secretary"
                            },
                            "spain": { "title": "Autonomous Community Vice-President" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 202, 206, 208, 211, 224],
                        "unique_identifier": "DSHOS",
                        "value": 14
                    },
                    "executive_1": {
                        "allowed_organization_types": [7],
                        "description": "\n            An individual that runs a particular department or ministry within a country.\n            In the United States this would be a Secretary or Cabinet-level position,\n            and in the UK this might be the Home Secretary.\n        ",
                        "key": "executive_1",
                        "label": "Top-Level Minister or Cabinet Member",
                        "name": "Top-Level Minister or Cabinet Member",
                        "precedence": 4,
                        "region_specific_dict": {
                            "argentina": { "count": 25, "title": "Minister" },
                            "australia": { "count": 22, "title": "Cabinet Member" },
                            "belgium": { "count": 14, "title": "Minister" },
                            "brazil": { "count": 22, "title": "Minister" },
                            "canada": { "count": 34, "title": "Minister" },
                            "chile": { "count": 24, "title": "Minister" },
                            "china": { "count": 24, "title": "Minister" },
                            "colombia": { "count": 16, "title": "Minister" },
                            "costa_rica": { "title": "Minister" },
                            "denmark": { "count": 25, "title": "Minister" },
                            "france": { "count": 16, "title": "Minister" },
                            "germany": { "count": 14, "title": "Federal Minister" },
                            "hong_kong": { "count": 38, "title": "Executive Council Member" },
                            "india": { "count": 26, "title": "Cabinet Minister" },
                            "indonesia": { "count": 34, "title": "Minister" },
                            "ireland": {
                                "count": [7, 15],
                                "title": "Minister"
                            },
                            "italy": { "count": 18, "title": "Minister" },
                            "japan": {
                                "count": [19, 20],
                                "title": "Cabinet Member"
                            },
                            "malaysia": { "count": 25, "title": "Minister" },
                            "mexico": {
                                "count": [19, 25],
                                "title": "Secretary"
                            },
                            "netherlands": { "count": 22, "title": "Minister" },
                            "new_zealand": { "count": 27, "title": "Executive Council Member" },
                            "philippines": { "count": 22, "title": "Secretary" },
                            "poland": { "count": 24, "title": "Minister" },
                            "saudi_arabia": { "count": 28, "title": "Minister" },
                            "singapore": { "title": "Ministers and Council Members" },
                            "south_africa": { "count": 28, "title": "Minister" },
                            "south_korea": {
                                "count": [15, 18],
                                "title": "Minister"
                            },
                            "spain": { "count": 17, "title": "Minister" },
                            "sweden": { "count": 21, "title": "Minister" },
                            "taiwan": { "count": 214, "title": "Yuan Principal Officer" },
                            "thailand": { "count": 20, "title": "Minister" },
                            "united_kingdom": { "count": 24, "title": "Cabinet Member" },
                            "vietnam": { "count": 25, "title": "Cabinet Member" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "EB1",
                        "value": 4
                    },
                    "executive_2": {
                        "allowed_organization_types": [7, 8],
                        "description": "\n            An individual that reports to the top-level minister or cabinet member. In\n            the United States this would be a Deputy Secretary.\n        ",
                        "key": "executive_2",
                        "label": "Second-Level Minister or Cabinet Member",
                        "name": "Second-Level Minister or Cabinet Member",
                        "precedence": 6,
                        "region_specific_dict": {
                            "argentina": { "title": "Secretary" },
                            "australia": {
                                "count": [7, 10],
                                "title": "Assistant Minister"
                            },
                            "belgium": { "count": 5, "title": "Secretary of State" },
                            "brazil": {
                                "count": [0, 100],
                                "title": "Executive Secretary"
                            },
                            "canada": { "title": "Deputy Minister" },
                            "chile": { "count": 39, "title": "Undersecretary" },
                            "colombia": { "title": "Vice-Minister" },
                            "costa_rica": { "title": "Vice Minister" },
                            "france": { "title": "Secretary of State" },
                            "germany": { "title": "State Secretary" },
                            "hong_kong": { "title": "Permanent Secretary" },
                            "india": {
                                "count": [45, 49],
                                "title": "Minister of State"
                            },
                            "indonesia": {
                                "count": [12, 15],
                                "title": "Deputy Minister"
                            },
                            "ireland": { "title": "Minister of State" },
                            "italy": {
                                "count": [6, 7],
                                "title": "Deputy Minister"
                            },
                            "japan": { "count": 26, "title": "State Minister" },
                            "malaysia": { "title": "Deputy Minister" },
                            "mexico": { "title": "Undersecretary" },
                            "netherlands": { "count": 6, "title": "State Secretary" },
                            "new_zealand": { "count": 1, "title": "Parliamentary Under-Secretary" },
                            "philippines": { "title": "Undersecretary" },
                            "poland": { "title": "Secretary of State" },
                            "saudi_arabia": { "count": 62, "title": "Deputy Minister" },
                            "singapore": { "title": "Permanent Secretary" },
                            "south_africa": {
                                "count": [28, 34],
                                "title": "Deputy Minister"
                            },
                            "south_korea": { "count": 24, "title": "Vice Minister" },
                            "spain": { "title": "Secretary of State" },
                            "sweden": { "title": "Deputy Minister" },
                            "taiwan": { "count": 71, "title": "Executive Yuan Deputy Minister" },
                            "thailand": { "title": "Deputy Minister" },
                            "united_kingdom": { "count": 28, "title": "Secretary of State" },
                            "vietnam": { "count": 84, "title": "Deputy Minister" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "EB2",
                        "value": 10
                    },
                    "executive_3": {
                        "allowed_organization_types": [7, 8, 9],
                        "description": "\n            An individual that reports to the second-level minister or cabinet member. In\n            the United States this would be an Assistant Secretary.\n        ",
                        "key": "executive_3",
                        "label": "Third-Level Minister",
                        "name": "Third-Level Minister",
                        "precedence": 7,
                        "region_specific_dict": {
                            "australia": { "count": 12, "title": "Parliament Secretary" },
                            "canada": { "title": "Parliament Secretary" },
                            "germany": { "title": "Parliamentary State Secretary" },
                            "hong_kong": { "title": "Deputy Secretary" },
                            "india": { "title": "Secretary" },
                            "ireland": { "title": "Secretary General" },
                            "italy": { "count": 39, "title": "Under Secretary" },
                            "malaysia": { "title": "Secretary General" },
                            "new_zealand": { "count": 41, "title": "Public Service Leader" },
                            "singapore": { "title": "Senior Advisor" },
                            "spain": { "title": "Undersecretary" },
                            "thailand": { "title": "Permanent Secretary" },
                            "united_kingdom": {
                                "count": [37, 39],
                                "title": "Junior Minister"
                            },
                            "vietnam": { "title": "Third-Level Ministry / Agency" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 203, 204, 206, 207, 210, 211, 215, 220, 223, 227, 228, 230, 231],
                        "unique_identifier": "EB3",
                        "value": 11
                    },
                    "executive_branch_member": {
                        "allowed_organization_types": [7, 8, 9],
                        "description": "An individual that works within the Executive Branch.",
                        "key": "executive_branch_member",
                        "label": "Executive Branch Member",
                        "name": "Executive Branch Member",
                        "precedence": 8,
                        "region_specific_dict": {
                            "argentina": { "title": "Executive Branch Member" },
                            "belgium": { "title": "Executive Branch Member" },
                            "costa_rica": { "title": "Executive Branch Member" },
                            "malaysia": { "title": "Executive Branch Member" },
                            "philippines": { "title": "Executive Branch Member" },
                            "south_korea": { "title": "Executive Branch Member" },
                            "taiwan": { "title": "Executive Branch Member" },
                            "vietnam": { "title": "Executive Branch Member" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "EBM",
                        "value": 12
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislators",
                            "values": [8, 9, 5, 7, 6, 23, 17, 18, 25]
                        },
                        {
                            "display": "list",
                            "title": "Executives",
                            "values": [1, 2, 3, 4, 10, 11, 12, 13, 15, 14, 16, 24]
                        },
                        {
                            "display": "list",
                            "title": "Judiciaries",
                            "values": [19, 20]
                        },
                        {
                            "display": "list",
                            "title": "Staffers",
                            "values": [21, 22]
                        }
                    ],
                    "head_of_government": {
                        "allowed_organization_types": [5],
                        "description": "\n            The highest or second-highest official in the executive branch of a country,\n            such as a Prime Minister. In the United States, this would be\n            the President, and in the UK this would be the Prime Minister.\n        ",
                        "key": "head_of_government",
                        "label": "Head of Government",
                        "name": "Head of Government",
                        "precedence": 2,
                        "region_specific_dict": {
                            "argentina": { "count": 1, "title": "President" },
                            "australia": { "count": 1, "title": "Prime Minister" },
                            "belgium": { "count": 1, "title": "Prime Minister" },
                            "brazil": { "count": 1, "title": "President" },
                            "canada": { "count": 1, "title": "Prime Minister" },
                            "china": { "count": 1, "title": "Premier" },
                            "colombia": { "count": 1, "title": "President" },
                            "denmark": { "count": 1, "title": "Prime Minister" },
                            "france": { "count": 1, "title": "Prime Minister" },
                            "germany": { "count": 1, "title": "Chancellor" },
                            "hong_kong": { "count": 1, "title": "Chief Executive" },
                            "india": { "count": 1, "title": "Prime Minister" },
                            "indonesia": { "count": 1, "title": "President" },
                            "ireland": { "count": 1, "title": "Taoiseach" },
                            "italy": { "count": 1, "title": "Prime Minister" },
                            "japan": { "count": 1, "title": "Prime Minister" },
                            "malaysia": { "count": 1, "title": "Prime Minister" },
                            "mexico": { "count": 1, "title": "President" },
                            "netherlands": { "count": 1, "title": "Prime Minister" },
                            "new_zealand": { "count": 1, "title": "Prime Minister" },
                            "poland": { "count": 1, "title": "Prime Minister" },
                            "saudi_arabia": { "count": 1, "title": "King" },
                            "singapore": { "count": 1, "title": "Prime Minister" },
                            "south_africa": { "count": 1, "title": "President" },
                            "south_korea": { "count": 1, "title": "Prime Minister" },
                            "spain": { "count": 1, "title": "President of the Government" },
                            "sweden": { "count": 1, "title": "Prime Minister" },
                            "taiwan": { "count": 2, "title": "Premier" },
                            "thailand": { "count": 1, "title": "Prime Minister" },
                            "united_kingdom": { "count": 1, "title": "Prime Minister" },
                            "vietnam": { "count": 1, "title": "Prime Minister" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231],
                        "unique_identifier": "HOG",
                        "value": 2
                    },
                    "head_of_state": {
                        "allowed_organization_types": [1],
                        "description": "\n            The chief public representative of a country, such as a president or\n            monarch, who may concurrently be the Head of Government. In the United\n            States this would be the President, and in the UK this would\n            be the Queen.\n        ",
                        "key": "head_of_state",
                        "label": "Head of State",
                        "name": "Head of State",
                        "precedence": 1,
                        "region_specific_dict": {
                            "australia": { "count": 1, "title": "Governor General" },
                            "belgium": { "count": 1, "title": "The King" },
                            "brazil": { "count": 1, "title": "President" },
                            "canada": { "count": 1, "title": "Governor General" },
                            "chile": { "count": 1, "title": "President" },
                            "china": { "count": 1, "title": "President" },
                            "colombia": { "count": 1, "title": "President" },
                            "costa_rica": { "count": 1, "title": "President" },
                            "denmark": { "count": 1, "title": "Queen" },
                            "france": { "count": 1, "title": "President" },
                            "germany": { "count": 1, "title": "President" },
                            "india": { "count": 1, "title": "President" },
                            "indonesia": { "count": 1, "title": "President" },
                            "ireland": { "count": 1, "title": "President" },
                            "italy": { "count": 1, "title": "President" },
                            "japan": { "count": 1, "title": "Emperor" },
                            "malaysia": { "count": 1, "title": "The King" },
                            "mexico": { "count": 1, "title": "President" },
                            "netherlands": { "count": 1, "title": "King" },
                            "new_zealand": { "count": 1, "title": "Governor General" },
                            "philippines": { "count": 1, "title": "President" },
                            "poland": { "count": 1, "title": "President" },
                            "saudi_arabia": { "count": 1, "title": "King" },
                            "singapore": { "count": 1, "title": "President" },
                            "south_africa": { "count": 1, "title": "President" },
                            "south_korea": { "count": 1, "title": "President" },
                            "spain": { "count": 1, "title": "King" },
                            "sweden": { "count": 1, "title": "King" },
                            "taiwan": { "count": 1, "title": "President" },
                            "thailand": { "count": 1, "title": "King" },
                            "united_kingdom": { "count": 1, "title": "The King" },
                            "vietnam": { "count": 1, "title": "President" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 225, 226, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "HOS",
                        "value": 1
                    },
                    "legislative_chamber_leader": {
                        "allowed_organization_types": [7, 13],
                        "description": "\n            An individual that leads a lower body chamber (or shadow cabinet). For\n            example, in Australia, all shadow ministers would have LCLs as their non-primary\n            person types\n        ",
                        "key": "legislative_chamber_leader",
                        "label": "Legislative Chamber Leader",
                        "name": "Legislative Chamber Leader",
                        "precedence": 5,
                        "region_specific_dict": {
                            "australia": { "title": "Shadow Minister" },
                            "belgium": { "count": 2, "title": "Legislative Chamber Leader" },
                            "canada": { "title": "Shadow Minister" },
                            "costa_rica": { "count": 2, "title": "Legislative Chamber Leader" },
                            "hong_kong": { "count": 1, "title": "Legislative Council President" },
                            "malaysia": { "count": 5, "title": "Legislative Chamber Leader" },
                            "philippines": { "count": 17, "title": "Legislative Chamber Leader" },
                            "singapore": { "title": "Leader" },
                            "united_kingdom": { "title": "Shadow Minister" },
                            "vietnam": { "count": 1, "title": "Chairman of the National Assembly of Vietnam" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 204, 223, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "LCL",
                        "value": 5
                    },
                    "local_executive": {
                        "allowed_organization_types": [],
                        "description": "\n            An executive at the local level. For example, in the US, a\n            city's mayor would fit this description\n        ",
                        "key": "local_executive",
                        "label": "Local Executive",
                        "name": "Local Executive",
                        "precedence": 35,
                        "region_specific_dict": {},
                        "show_in_enumeration": false,
                        "supported_regions": [],
                        "unique_identifier": "LOEB",
                        "value": 24
                    },
                    "local_legislator": {
                        "allowed_organization_types": [],
                        "description": "\n            A legislator at the local level who works on a municipal /\n            local legislature\n        ",
                        "key": "local_legislator",
                        "label": "Local Legislator",
                        "name": "Local Legislator",
                        "precedence": 36,
                        "region_specific_dict": {},
                        "show_in_enumeration": false,
                        "supported_regions": [],
                        "unique_identifier": "LOLEG",
                        "value": 25
                    },
                    "lower_body_legislator": {
                        "allowed_organization_types": [4],
                        "description": "A legislator in the lower body (typically House or Assembly)",
                        "key": "lower_body_legislator",
                        "label": "Lower Body Legislator",
                        "name": "Lower Body Legislator",
                        "precedence": 15,
                        "region_specific_dict": {
                            "argentina": { "count": 257, "title": "Deputy" },
                            "australia": {
                                "count": [149, 150],
                                "title": "House Member"
                            },
                            "belgium": { "count": 150, "title": "Deputy" },
                            "brazil": { "count": 513, "title": "Deputy" },
                            "canada": {
                                "count": [334, 338],
                                "title": "Member of Parliament"
                            },
                            "chile": { "count": 155, "title": "Deputy" },
                            "colombia": {
                                "count": [166, 172],
                                "title": "Representative"
                            },
                            "france": { "count": 577, "title": "Deputy" },
                            "germany": {
                                "count": [598, 709],
                                "title": "Member of the Bundestag"
                            },
                            "india": {
                                "count": [524, 552],
                                "title": "Member of Parliament, Lok Sabha"
                            },
                            "indonesia": {
                                "count": [570, 575],
                                "title": "Member of the House of Representatives"
                            },
                            "ireland": {
                                "count": [156, 158],
                                "title": "TD"
                            },
                            "italy": { "count": 630, "title": "Deputy" },
                            "japan": { "count": 465, "title": "Member of the House of Representatives" },
                            "malaysia": { "count": 222, "title": "Member of the House of Representatives" },
                            "mexico": { "count": 500, "title": "Representative" },
                            "netherlands": { "count": 150, "title": "Representative" },
                            "philippines": { "count": 312, "title": "House Member" },
                            "poland": { "count": 460, "title": "Deputy" },
                            "singapore": { "count": 103, "title": "Member of Parliament" },
                            "south_africa": {
                                "count": [399, 400],
                                "title": "Member of the National Assembly"
                            },
                            "spain": { "count": 350, "title": "Deputy" },
                            "thailand": { "count": 500, "title": "Representative" },
                            "united_kingdom": { "count": 650, "title": "Member of Parliament" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 210, 211, 213, 214, 215, 216, 219, 220, 222, 223, 224, 226, 228, 229, 233],
                        "unique_identifier": "LLEG",
                        "value": 9
                    },
                    "member": {
                        "allowed_organization_types": [],
                        "description": "A member of an organization (typically a party or committee).",
                        "key": "member",
                        "label": "Member",
                        "name": "Member",
                        "precedence": 40,
                        "region_specific_dict": {},
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "M",
                        "value": 23
                    },
                    "organization_staffer": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual that works directly for an organization in the government primarily\n            in a facilitiating capacity.\n        ",
                        "key": "organization_staffer",
                        "label": "Organization Staffer",
                        "name": "Organization Staffer",
                        "precedence": 100,
                        "region_specific_dict": {},
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 205, 206, 211, 213, 214, 215, 231],
                        "unique_identifier": "SO",
                        "value": 22
                    },
                    "party_leader": {
                        "allowed_organization_types": [11],
                        "description": "A person that is in the leadership of a political party.",
                        "key": "party_leader",
                        "label": "Party Leader",
                        "name": "Party Leader",
                        "precedence": 5,
                        "region_specific_dict": {
                            "belgium": { "count": 20 },
                            "costa_rica": { "count": 76, "title": "Party Leader" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 230, 231, 232, 233],
                        "unique_identifier": "PL",
                        "value": 7
                    },
                    "second_level_judge": {
                        "allowed_organization_types": [19],
                        "description": "\n            An individual that sits on the second-highest-level court in the Judiciary system.\n            In the United States this would be a Justice on an apellate\n            court.\n        ",
                        "key": "second_level_judge",
                        "label": "Second-Level Judge",
                        "name": "Second-Level Judge",
                        "precedence": 31,
                        "region_specific_dict": {
                            "belgium": { "count": 57, "title": "Judge" },
                            "brazil": { "title": "Judicial Minister" },
                            "chile": { "count": 272, "title": "Member of the Court of Appeals" },
                            "china": { "title": "Court Judge" },
                            "denmark": { "title": "Judge" },
                            "france": { "title": "Second-Level Judge" },
                            "hong_kong": { "count": 54, "title": "Judge of the High Court" },
                            "india": { "count": 25, "title": "High Court Chief Justice" },
                            "malaysia": { "count": 98, "title": "Second-Level Judge" },
                            "mexico": { "title": "Magistrate" },
                            "new_zealand": { "count": 10, "title": "Judge of the Court of Appeal" },
                            "philippines": { "title": "Judge" },
                            "poland": { "title": "Judicial Branch Member" },
                            "spain": { "title": "Judge" },
                            "taiwan": { "count": 12, "title": "Chief Judge" },
                            "vietnam": { "count": 25, "title": "Judge of the High Court" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 208, 209, 211, 212, 213, 214, 215, 216, 217, 218, 219, 221, 225, 226, 227, 228, 229, 230, 231, 233],
                        "unique_identifier": "J2",
                        "value": 20
                    },
                    "staffer": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual that works for someone in the governmental hierarchy predominantly in\n            a faciliating capacity.\n        ",
                        "key": "staffer",
                        "label": "Staffer",
                        "name": "Staffer",
                        "precedence": 100,
                        "region_specific_dict": {},
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 204, 205, 206, 207, 208, 212, 213, 214, 215, 222, 223, 226, 227, 228, 229, 232, 233],
                        "unique_identifier": "S",
                        "value": 21
                    },
                    "state_executive_1": {
                        "allowed_organization_types": [14],
                        "description": "A high-level executive (Minister, Secretary, etc.) of a state/province.",
                        "key": "state_executive_1",
                        "label": "Sub-national Top-Level Executive",
                        "name": "Sub-national Top-Level Executive",
                        "precedence": 23,
                        "region_specific_dict": {
                            "australia": { "count": 200, "title": "State Minister" },
                            "brazil": { "title": "Secretary of State" },
                            "canada": { "count": 2000, "title": "Provincial Minister" },
                            "india": { "count": 400, "title": "State Minister" },
                            "mexico": { "count": 2000, "title": "State Secretary" },
                            "spain": { "title": "Autonomous Community Minister" },
                            "united_kingdom": { "title": "State Minister" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 204, 206, 208, 211],
                        "unique_identifier": "SEB1",
                        "value": 16
                    },
                    "state_lower_legislator": {
                        "allowed_organization_types": [17],
                        "description": "\n            A legislator in the lower body (typically Senate) of a sub-national state/province's\n            legislature.\n        ",
                        "key": "state_lower_legislator",
                        "label": "Sub-national Lower Body Legislator",
                        "name": "Sub-national Lower Body Legislator",
                        "precedence": 27,
                        "region_specific_dict": {
                            "australia": {
                                "count": [0, 400],
                                "title": "State Legislative Assembly Member"
                            },
                            "brazil": {
                                "count": [0, 400],
                                "title": "State Deputy"
                            },
                            "mexico": { "count": 1114, "title": "State Deputy" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 208, 202],
                        "unique_identifier": "SLLEG",
                        "value": 18
                    },
                    "state_upper_legislator": {
                        "allowed_organization_types": [16],
                        "description": "\n            A legislator in the upper body (typically Senate) of a sub-national state/province's\n            legislature.\n        ",
                        "key": "state_upper_legislator",
                        "label": "Sub-national Upper Body Legislator",
                        "name": "Sub-national Upper Body Legislator",
                        "precedence": 27,
                        "region_specific_dict": {
                            "australia": {
                                "count": [0, 400],
                                "title": "State Legislative Council Member"
                            },
                            "canada": {
                                "count": [0, 1625],
                                "title": "Legislative Assembly Member"
                            }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201],
                        "unique_identifier": "SULEG",
                        "value": 17
                    },
                    "sub_national_head_of_government": {
                        "allowed_organization_types": [13],
                        "description": "\n            The highest executive of a state / province, such as a Premier\n            of State in Australia or Canada.\n        ",
                        "key": "sub_national_head_of_government",
                        "label": "Sub-national Head of Government",
                        "name": "Sub-national Head of Government",
                        "precedence": 21,
                        "region_specific_dict": {
                            "argentina": { "count": 22, "title": "Vice Governor" },
                            "australia": {
                                "count": [6, 8],
                                "title": "Premier"
                            },
                            "canada": {
                                "count": [10, 13],
                                "title": "Premier"
                            },
                            "india": {
                                "count": [30, 31],
                                "title": "Chief Minister"
                            },
                            "mexico": { "count": 32, "title": "Governor" },
                            "spain": { "title": "Autonomous Community President" },
                            "united_kingdom": { "count": 3, "title": "First Minister" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 204, 206, 211, 224],
                        "unique_identifier": "SHOG",
                        "value": 15
                    },
                    "sub_national_head_of_state": {
                        "allowed_organization_types": [12],
                        "description": "\n            The chief public representative of a state or province, such as a\n            Governor in Australia or Lt. Governor in Canada.\n        ",
                        "key": "sub_national_head_of_state",
                        "label": "Sub-national Head of State",
                        "name": "Sub-national Head of State",
                        "precedence": 20,
                        "region_specific_dict": {
                            "australia": {
                                "count": [6, 9],
                                "title": "Governor"
                            },
                            "brazil": {
                                "count": [0, 100],
                                "title": "Governor"
                            },
                            "canada": { "count": 10, "title": "Lt. Governor" },
                            "india": {
                                "count": [27, 29],
                                "title": "Governor"
                            },
                            "mexico": { "count": 32, "title": "Governor" },
                            "spain": { "title": "Autonomous Community President" },
                            "taiwan": { "count": 21, "title": "State Executive" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 206, 208, 211, 214, 225],
                        "unique_identifier": "SHOS",
                        "value": 13
                    },
                    "top_level_judge": {
                        "allowed_organization_types": [18],
                        "description": "\n            An individual that sits on the highest-level court in the Judiciary system.\n            In the United States this would be a Supreme Court Justice.\n        ",
                        "key": "top_level_judge",
                        "label": "Top-Level Judge",
                        "name": "Top-Level Judge",
                        "precedence": 30,
                        "region_specific_dict": {
                            "argentina": { "count": 4, "title": "Supreme Court Justice" },
                            "australia": { "count": 7, "title": "High Court Justice" },
                            "belgium": { "count": 43, "title": "Magistrate" },
                            "brazil": { "count": 11, "title": "Justice" },
                            "canada": { "count": 9, "title": "Justice" },
                            "chile": { "count": 21, "title": "Member of the Supreme Court of Justice" },
                            "china": { "title": "Justice of the Supreme People's Court" },
                            "colombia": { "count": 23, "title": "Justice" },
                            "costa_rica": { "count": 49, "title": "Magistrate" },
                            "denmark": { "title": "Supreme Court Justice" },
                            "germany": { "title": "Supreme Court Judge" },
                            "hong_kong": { "count": 18, "title": "Judge of the Court of Final Appeal" },
                            "india": {
                                "count": [26, 31],
                                "title": "Supreme Court Justice"
                            },
                            "indonesia": { "title": "Justice" },
                            "ireland": {
                                "count": [9, 10],
                                "title": "Judge"
                            },
                            "italy": { "title": "Constitutional Court Judge" },
                            "japan": { "count": 15, "title": "Justice" },
                            "malaysia": { "count": 9, "title": "Federal Court Judge" },
                            "mexico": { "count": 11, "title": "Minister" },
                            "new_zealand": { "count": 6, "title": "Judge of the Supreme Court" },
                            "philippines": { "count": 15, "title": "Supreme Court Justice" },
                            "poland": { "title": "Supreme Court Judge" },
                            "saudi_arabia": { "count": 12, "title": "Qadi" },
                            "south_africa": { "count": 9, "title": "Judge" },
                            "south_korea": { "count": 25 },
                            "spain": { "count": 20, "title": "Magistrate" },
                            "sweden": { "count": 1, "title": "Supreme Court Judge" },
                            "taiwan": { "count": 19, "title": "Judicial Yuan Principal Officer and Justice" },
                            "united_kingdom": { "title": "Supreme Court Justice" },
                            "vietnam": { "count": 16, "title": "Judge of the Supreme People's Court" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "J1",
                        "value": 19
                    },
                    "upper_body_legislator": {
                        "allowed_organization_types": [3],
                        "description": "A legislator in the upper body (typically Senate) of a country's legislature.",
                        "key": "upper_body_legislator",
                        "label": "Upper Body Legislator",
                        "name": "Upper Body Legislator",
                        "precedence": 15,
                        "region_specific_dict": {
                            "argentina": { "count": 72, "title": "Senator" },
                            "australia": { "count": 76, "title": "Senator" },
                            "belgium": { "count": 60, "title": "Senator" },
                            "brazil": { "count": 81, "title": "Senator" },
                            "canada": { "count": 105, "title": "Senator" },
                            "chile": { "count": 50, "title": "Senator" },
                            "china": { "count": 2980, "title": "Deputy" },
                            "colombia": { "count": 108, "title": "Senator" },
                            "costa_rica": { "count": 57, "title": "Deputy" },
                            "denmark": { "count": 179, "title": "Member of the Danish Parliament" },
                            "france": { "count": 348, "title": "Senator" },
                            "germany": { "count": 69, "title": "Member of the Bundesrat" },
                            "hong_kong": { "count": 90, "title": "Legislative Council Member" },
                            "india": {
                                "count": [244, 250],
                                "title": "Member of Parliament, Rajya Sabha"
                            },
                            "indonesia": {
                                "count": [136, 138],
                                "title": "Member of the Regional Representative Council"
                            },
                            "ireland": { "count": 60, "title": "Senator" },
                            "italy": {
                                "count": [315, 321],
                                "title": "Senator"
                            },
                            "japan": {
                                "count": [243, 245],
                                "title": "Member of the House of Councilors "
                            },
                            "malaysia": { "count": 51, "title": "Senator" },
                            "mexico": { "count": 128, "title": "Senator" },
                            "netherlands": { "count": 75, "title": "Senator" },
                            "new_zealand": { "count": 120, "title": "Member of Parliament" },
                            "philippines": { "count": 24, "title": "Senator" },
                            "poland": { "count": 100, "title": "Senator" },
                            "saudi_arabia": { "count": 150, "title": "Council Member" },
                            "south_africa": {
                                "count": [54, 90],
                                "title": "Provincial Delegate"
                            },
                            "south_korea": {
                                "count": [294, 300],
                                "title": "Senator"
                            },
                            "spain": { "count": 265, "title": "Senator" },
                            "sweden": { "count": 349, "title": "Member of Parliament" },
                            "taiwan": { "count": 113, "title": "Legislator" },
                            "thailand": { "count": 250, "title": "Senator" },
                            "united_kingdom": {
                                "count": [792, 793],
                                "title": "Lord"
                            },
                            "vietnam": { "count": 500, "title": "Delegate" }
                        },
                        "show_in_enumeration": true,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233],
                        "unique_identifier": "ULEG",
                        "value": 8
                    }
                },
                "MajorRoleType": {
                    "__is_enum": true,
                    "ambassador": {
                        "allowed_organization_types": [],
                        "description": "An individual working as a representative for a foreign country.",
                        "key": "ambassador",
                        "label": "Ambassador",
                        "parent": 2,
                        "precedence": 10,
                        "region_specific_dict": {},
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "AMB",
                        "value": 57
                    },
                    "committee_leader": {
                        "allowed_organization_types": [20],
                        "description": "A person that leads a committee (a committee chair or ranking member).",
                        "key": "committee_leader",
                        "label": "Committee Leader",
                        "order": 2,
                        "parent": 1,
                        "precedence": 25,
                        "region_specific_dict": {
                            "belgium": { "count": 32, "title": "Committee Leader" },
                            "canada": { "title": "Committee Chair" },
                            "costa_rica": { "count": 46, "title": "Committee Leader" },
                            "denmark": { "title": "Committee Chairperson" },
                            "dominican_republic": { "title": "Committee Leader" },
                            "greece": { "title": "Committee Leader" },
                            "israel": { "count": 27, "title": "Chairperson" },
                            "malaysia": { "count": 9, "title": "Chairman" },
                            "panama": { "title": "Committee Leader" },
                            "philippines": { "count": 266, "title": "Commitee Leader" },
                            "poland": { "title": "Committee Chairperson" },
                            "romania": { "count": 67, "title": "Committee Leader" },
                            "south_africa": { "title": "Committee Chairperson" },
                            "south_korea": { "title": "Chairman" },
                            "vietnam": { "count": 15, "title": "Committee Chairman" }
                        },
                        "regions": [200, 201, 238, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 213, 214, 215, 216, 217, 218, 220, 221, 222, 223, 224, 225, 239, 226, 227, 228, 240, 230, 231, 1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [200, 201, 238, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 213, 214, 215, 216, 217, 218, 220, 221, 222, 223, 224, 225, 239, 226, 227, 228, 240, 230, 231, 1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "CL",
                        "value": 55
                    },
                    "deputy_head_of_government": {
                        "allowed_organization_types": [7],
                        "description": "\n            The second or third-highest official in the executive branch of a country\n            - for example, a Vice President or Deputy Prime Minister.\n        ",
                        "key": "deputy_head_of_government",
                        "label": "Deputy Head of Government",
                        "order": 12,
                        "parent": 2,
                        "precedence": 3,
                        "region_specific_dict": {
                            "argentina": { "count": 1, "title": "Vice President" },
                            "australia": { "count": 1, "title": "Deputy Prime Minister" },
                            "belgium": { "count": 7, "title": "Deputy Prime Minister" },
                            "brazil": {
                                "count": [0, 1],
                                "title": "Vice President"
                            },
                            "canada": { "count": 1, "title": "Deputy Prime Minister" },
                            "chile": { "count": 1, "title": "Vice-President" },
                            "china": { "count": 1, "title": "Vice President" },
                            "colombia": { "count": 1, "title": "Vice President" },
                            "costa_rica": { "count": 2, "title": "Vice President" },
                            "dominican_republic": { "count": 1, "title": "Vice President" },
                            "france": { "count": 0, "title": "Deputy Prime Minister" },
                            "germany": { "count": 1, "title": "Vice Chancellor" },
                            "greece": { "count": 1, "title": "Vice President" },
                            "india": { "count": 0, "title": "Deputy Prime Minister" },
                            "indonesia": { "count": 1, "title": "Vice President" },
                            "ireland": { "count": 1, "title": "Tanaiste" },
                            "israel": { "count": 1, "title": "Deputy Prime Minister" },
                            "italy": { "count": 2, "title": "Deputy Prime Minister" },
                            "japan": {
                                "count": [0, 1],
                                "title": "Deputy Prime Minister"
                            },
                            "mexico": { "count": 0, "title": "Vice President" },
                            "netherlands": { "count": 1, "title": "Deputy Prime Minister" },
                            "new_zealand": { "count": 1, "title": "Deputy Prime Minister" },
                            "panama": { "count": 1, "title": "Vice President" },
                            "philippines": { "count": 1, "title": "Vice President" },
                            "poland": { "count": 1, "title": "Deputy Prime Minister" },
                            "romania": { "count": 1, "title": "Deputy Prime Minister" },
                            "saudi_arabia": { "count": 1, "title": "Crown Prince" },
                            "singapore": { "count": 1, "title": "Deputy Prime Minister" },
                            "south_africa": {
                                "count": [0, 1],
                                "title": "Deputy President"
                            },
                            "south_korea": {
                                "count": [0, 1],
                                "title": "Deputy Prime Minister"
                            },
                            "spain": { "count": 1, "title": "Vice President of the Government" },
                            "sweden": { "count": 1, "title": "Deputy Prime Minister" },
                            "taiwan": { "count": 1, "title": "Vice-President" },
                            "thailand": { "count": 1, "title": "Deputy Prime Minister" },
                            "united_arab_emirates": { "count": 1, "title": "Deputy Prime Minister" },
                            "united_kingdom": { "count": 0, "title": "Deputy Prime Minister" },
                            "vietnam": { "count": 4, "title": "Deputy Prime Minister" }
                        },
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "DHOG",
                        "value": 3
                    },
                    "deputy_head_of_state": {
                        "allowed_organization_types": [],
                        "description": "\n            The second or third-highest chief public representative of a country,\n            such as a president or monarch, who may concurrently be the Head of Government.\n        ",
                        "key": "deputy_head_of_state",
                        "label": "Deputy Head of State",
                        "order": 12,
                        "parent": 2,
                        "precedence": 3,
                        "region_specific_dict": {
                            "united_arab_emirates": { "count": 1, "title": "Vice President" }
                        },
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "DHOS",
                        "value": 59
                    },
                    "deputy_sub_national_head_of_state": {
                        "allowed_organization_types": [5],
                        "description": "\n            The deputy chief public representative of a state or province, such as\n            a Lt. Governor in Australia.\n        ",
                        "key": "deputy_sub_national_head_of_state",
                        "label": "Deputy Sub-National Head of State",
                        "order": 18,
                        "parent": 2,
                        "precedence": 12,
                        "region_specific_dict": {
                            "argentina": {
                                "count": [24],
                                "title": "Governor"
                            },
                            "australia": {
                                "count": [0, 9],
                                "title": "Lt. Governor"
                            },
                            "brazil": {
                                "count": [0, 27],
                                "title": "Deputy Governor"
                            },
                            "india": {
                                "count": [6, 7],
                                "title": "Lt. Governor/Administrator"
                            },
                            "mexico": {
                                "count": [27],
                                "title": "General Secretary"
                            },
                            "spain": { "title": "Autonomous Community Vice-President" },
                            "united_arab_emirates": { "title": "Deputy Ruler" }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "DSHOS",
                        "value": 15
                    },
                    "exec_1": {
                        "allowed_organization_types": [8],
                        "description": "\n            An individual who runs a particular department or ministry within a country.\n            In the United States this would be a Secretary or Cabinet-level position,\n            and in the UK this might be the Home Secretary.\n        ",
                        "key": "exec_1",
                        "label": "Top-Level Minister or Cabinet Member",
                        "order": 13,
                        "parent": 2,
                        "precedence": 4,
                        "region_specific_dict": {
                            "argentina": { "count": 25, "title": "Minister" },
                            "australia": { "count": 22, "title": "Cabinet Member" },
                            "belgium": { "count": 14, "title": "Minister" },
                            "brazil": { "count": 22, "title": "Minister" },
                            "canada": { "count": 34, "title": "Minister" },
                            "chile": { "count": 24, "title": "Minister" },
                            "china": { "count": 24, "title": "Minister" },
                            "colombia": { "count": 16, "title": "Minister" },
                            "costa_rica": { "title": "Minister" },
                            "denmark": { "count": 25, "title": "Minister" },
                            "dominican_republic": { "count": 23, "title": "Minister" },
                            "france": { "count": 16, "title": "Minister" },
                            "germany": { "count": 14, "title": "Federal Minister" },
                            "greece": { "count": 19, "title": "Minister" },
                            "hong_kong": { "count": 38, "title": "Executive Council Member" },
                            "india": { "count": 26, "title": "Cabinet Minister" },
                            "indonesia": { "count": 34, "title": "Minister" },
                            "ireland": {
                                "count": [7, 15],
                                "title": "Minister"
                            },
                            "israel": { "count": 26, "title": "Minister" },
                            "italy": { "count": 18, "title": "Minister" },
                            "japan": {
                                "count": [19, 20],
                                "title": "Cabinet Member"
                            },
                            "malaysia": { "count": 25, "title": "Minister" },
                            "mexico": {
                                "count": [19, 25],
                                "title": "Secretary"
                            },
                            "netherlands": { "count": 22, "title": "Minister" },
                            "new_zealand": { "count": 27, "title": "Executive Council Member" },
                            "panama": { "count": 16, "title": "Minister" },
                            "philippines": { "count": 22, "title": "Secretary" },
                            "poland": { "count": 24, "title": "Minister" },
                            "romania": { "count": 20, "title": "Minister" },
                            "saudi_arabia": { "count": 28, "title": "Minister" },
                            "singapore": { "title": "Ministers and Council Members" },
                            "south_africa": { "count": 28, "title": "Minister" },
                            "south_korea": {
                                "count": [15, 18],
                                "title": "Minister"
                            },
                            "spain": { "count": 17, "title": "Minister" },
                            "sweden": { "count": 21, "title": "Minister" },
                            "taiwan": { "count": 214, "title": "Yuan Principal Officer" },
                            "thailand": { "count": 20, "title": "Minister" },
                            "united_arab_emirates": { "title": "Minister" },
                            "united_kingdom": { "count": 24, "title": "Cabinet Member" },
                            "vietnam": { "count": 25, "title": "Cabinet Member" }
                        },
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB1",
                        "value": 4
                    },
                    "exec_2": {
                        "allowed_organization_types": [8, 9],
                        "description": "\n            An individual who reports to the Top-Level minister or cabinet member. In\n            the United States this would be a Deputy Secretary.\n        ",
                        "key": "exec_2",
                        "label": "Second-Level Minister or Cabinet Member",
                        "order": 14,
                        "parent": 2,
                        "precedence": 5,
                        "region_specific_dict": {
                            "argentina": { "title": "Secretary" },
                            "australia": {
                                "count": [7, 10],
                                "title": "Assistant Minister"
                            },
                            "belgium": { "count": 5, "title": "Secretary of State" },
                            "brazil": {
                                "count": [0, 100],
                                "title": "Executive Secretary"
                            },
                            "canada": { "title": "Deputy Minister" },
                            "chile": { "count": 39, "title": "Undersecretary" },
                            "colombia": { "title": "Vice-Minister" },
                            "costa_rica": { "title": "Vice Minister" },
                            "dominican_republic": { "count": 261, "title": "Director" },
                            "france": { "title": "Secretary of State" },
                            "germany": { "title": "State Secretary" },
                            "greece": { "count": 39, "title": "Deputy Minister" },
                            "hong_kong": { "title": "Permanent Secretary" },
                            "india": {
                                "count": [45, 49],
                                "title": "Minister of State"
                            },
                            "indonesia": {
                                "count": [12, 15],
                                "title": "Deputy Minister"
                            },
                            "ireland": { "title": "Minister of State" },
                            "italy": {
                                "count": [6, 7],
                                "title": "Deputy Minister"
                            },
                            "japan": { "count": 26, "title": "State Minister" },
                            "malaysia": { "title": "Deputy Minister" },
                            "mexico": { "title": "Undersecretary" },
                            "netherlands": { "count": 6, "title": "State Secretary" },
                            "new_zealand": { "count": 1, "title": "Parliamentary Under-Secretary" },
                            "panama": { "count": 76, "title": "Deputy Minister" },
                            "philippines": { "title": "Undersecretary" },
                            "poland": { "title": "Secretary of State" },
                            "romania": { "title": "Secretary of State" },
                            "saudi_arabia": { "count": 62, "title": "Deputy Minister" },
                            "singapore": { "title": "Permanent Secretary" },
                            "south_africa": {
                                "count": [28, 34],
                                "title": "Deputy Minister"
                            },
                            "south_korea": { "count": 24, "title": "Vice Minister" },
                            "spain": { "title": "Secretary of State" },
                            "sweden": { "title": "Deputy Minister" },
                            "taiwan": { "count": 71, "title": "Executive Yuan Deputy Minister" },
                            "thailand": { "title": "Deputy Minister" },
                            "united_arab_emirates": { "title": "Minister of State" },
                            "united_kingdom": { "count": 28, "title": "Secretary of State" },
                            "vietnam": { "count": 84, "title": "Deputy Minister" }
                        },
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB2",
                        "value": 5
                    },
                    "exec_3": {
                        "allowed_organization_types": [8, 9, 10],
                        "description": "\n            An individual who reports to the second-level minister or cabinet member. In\n            the United States this would be an Assistant Secretary.\n        ",
                        "key": "exec_3",
                        "label": "Third-Level Minister",
                        "order": 15,
                        "parent": 2,
                        "precedence": 5,
                        "region_specific_dict": {
                            "australia": { "count": 12, "title": "Parliament Secretary" },
                            "canada": { "title": "Parliament Secretary" },
                            "germany": { "title": "Parliamentary State Secretary" },
                            "hong_kong": { "title": "Deputy Secretary" },
                            "india": { "title": "Secretary" },
                            "ireland": { "title": "Secretary General" },
                            "italy": { "count": 39, "title": "Under Secretary" },
                            "malaysia": { "title": "Secretary General" },
                            "new_zealand": { "count": 41, "title": "Public Service Leader" },
                            "singapore": { "title": "Senior Advisor" },
                            "spain": { "title": "Undersecretary" },
                            "thailand": { "title": "Permanent Secretary" },
                            "united_kingdom": {
                                "count": [37, 39],
                                "title": "Junior Minister"
                            },
                            "vietnam": { "title": "Third-Level Ministry / Agency" }
                        },
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "EB3",
                        "value": 6
                    },
                    "exec_4": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who reports to the third-level minister or cabinet member. In\n            the United States this would be a Deputy Assistant Secretary.\n        ",
                        "key": "exec_4",
                        "label": "Fourth-Level Executive",
                        "parent": 2,
                        "precedence": 8,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB4",
                        "value": 7
                    },
                    "exec_5": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who reports to the fourth-level minister or cabinet member. In\n            the United States this would be an Under Secretary.\n        ",
                        "key": "exec_5",
                        "label": "Fifth-Level Executive",
                        "parent": 2,
                        "precedence": 9,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB5",
                        "value": 8
                    },
                    "exec_6": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who reports to the fifth-level minister or cabinet member. In\n            the United States this would be a Deputy Under Secretary.\n        ",
                        "key": "exec_6",
                        "label": "Sixth-Level Executive",
                        "parent": 2,
                        "precedence": 10,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB6",
                        "value": 9
                    },
                    "exec_branch_member": {
                        "allowed_organization_types": [8, 9, 10],
                        "description": "An individual who works within the executive branch at the national level.",
                        "key": "exec_branch_member",
                        "label": "Executive Branch Member",
                        "order": 16,
                        "parent": 2,
                        "precedence": 15,
                        "region_specific_dict": {
                            "argentina": { "title": "Executive Branch Member" },
                            "belgium": { "title": "Executive Branch Member" },
                            "costa_rica": { "title": "Executive Branch Member" },
                            "dominican_republic": { "title": "Executive Branch Member" },
                            "greece": { "title": "Executive Branch Member" },
                            "malaysia": { "title": "Executive Branch Member" },
                            "panama": { "title": "Executive Branch Member" },
                            "philippines": { "title": "Executive Branch Member" },
                            "romania": { "title": "Executive Branch Member" },
                            "south_korea": { "title": "Executive Branch Member" },
                            "taiwan": { "title": "Executive Branch Member" },
                            "vietnam": { "title": "Executive Branch Member" }
                        },
                        "regions": [106, 1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [106, 1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "EBM",
                        "value": 10
                    },
                    "exec_branch_member_other": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works within the executive branch at the national level\n            in a low precedence role. Useful to give priority to other state\n            or local roles\n        ",
                        "key": "exec_branch_member_other",
                        "label": "Executive Branch Member Other",
                        "parent": 2,
                        "precedence": 50,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EBMO",
                        "value": 50
                    },
                    "exec_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the executive branch of a\n            national or supranational governing body.\n        ",
                        "key": "exec_can",
                        "label": "Executive Candidate",
                        "parent": 5,
                        "precedence": 33,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANEB",
                        "value": 27
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislative",
                            "values": [11, 12, 54, 56, 55, 29, 63, 64, 66, 65, 60, 61, 18, 19, 26]
                        },
                        {
                            "display": "list",
                            "title": "Executive",
                            "values": [1, 2, 3, 59, 4, 5, 6, 10, 57, 14, 16, 15, 17, 30, 25]
                        },
                        {
                            "display": "list",
                            "title": "Staffers",
                            "values": [23, 24]
                        }
                    ],
                    "head_of_government": {
                        "allowed_organization_types": [7],
                        "description": "\n            The highest or second-highest official in the executive branch of a country,\n            such as a Prime Minister. In the United States, this would be\n            the President, and in the UK this would be the Prime Minister.\n        ",
                        "key": "head_of_government",
                        "label": "Head of Government",
                        "order": 11,
                        "parent": 2,
                        "precedence": 2,
                        "region_specific_dict": {
                            "argentina": { "count": 1, "title": "President" },
                            "australia": { "count": 1, "title": "Prime Minister" },
                            "belgium": { "count": 1, "title": "Prime Minister" },
                            "brazil": { "count": 1, "title": "President" },
                            "canada": { "count": 1, "title": "Prime Minister" },
                            "china": { "count": 1, "title": "Premier" },
                            "colombia": { "count": 1, "title": "President" },
                            "denmark": { "count": 1, "title": "Prime Minister" },
                            "dominican_republic": { "count": 1, "title": "President" },
                            "france": { "count": 1, "title": "Prime Minister" },
                            "germany": { "count": 1, "title": "Chancellor" },
                            "greece": { "count": 1, "title": "Prime Minister" },
                            "hong_kong": { "count": 1, "title": "Chief Executive" },
                            "india": { "count": 1, "title": "Prime Minister" },
                            "indonesia": { "count": 1, "title": "President" },
                            "ireland": { "count": 1, "title": "Taoiseach" },
                            "israel": { "count": 1, "title": "Prime Minister" },
                            "italy": { "count": 1, "title": "Prime Minister" },
                            "japan": { "count": 1, "title": "Prime Minister" },
                            "malaysia": { "count": 1, "title": "Prime Minister" },
                            "mexico": { "count": 1, "title": "President" },
                            "netherlands": { "count": 1, "title": "Prime Minister" },
                            "new_zealand": { "count": 1, "title": "Prime Minister" },
                            "panama": { "count": 1, "title": "President" },
                            "poland": { "count": 1, "title": "Prime Minister" },
                            "romania": { "count": 1, "title": "Prime Minister" },
                            "saudi_arabia": { "count": 1, "title": "King" },
                            "singapore": { "count": 1, "title": "Prime Minister" },
                            "south_africa": { "count": 1, "title": "President" },
                            "south_korea": { "count": 1, "title": "Prime Minister" },
                            "spain": { "count": 1, "title": "President of the Government" },
                            "sweden": { "count": 1, "title": "Prime Minister" },
                            "taiwan": { "count": 2, "title": "Premier" },
                            "thailand": { "count": 1, "title": "Prime Minister" },
                            "united_arab_emirates": { "count": 1, "title": "Prime Minister" },
                            "united_kingdom": { "count": 1, "title": "Prime Minister" },
                            "vietnam": { "count": 1, "title": "Prime Minister" }
                        },
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "HOG",
                        "value": 2
                    },
                    "head_of_state": {
                        "allowed_organization_types": [4],
                        "description": "\n            The chief public representative of a country, such as a president or\n            monarch, who may concurrently be the Head of Government. In the United\n            States this would be the President, and in the UK this would\n            be the Queen.\n        ",
                        "key": "head_of_state",
                        "label": "Head of State",
                        "order": 10,
                        "parent": 2,
                        "precedence": 1,
                        "region_specific_dict": {
                            "australia": { "count": 1, "title": "Governor General" },
                            "belgium": { "count": 1, "title": "The King" },
                            "brazil": { "count": 1, "title": "President" },
                            "canada": { "count": 1, "title": "Governor General" },
                            "chile": { "count": 1, "title": "President" },
                            "china": { "count": 1, "title": "President" },
                            "colombia": { "count": 1, "title": "President" },
                            "costa_rica": { "count": 1, "title": "President" },
                            "denmark": { "count": 1, "title": "King" },
                            "dominican_republic": { "count": 1, "title": "President" },
                            "france": { "count": 1, "title": "President" },
                            "germany": { "count": 1, "title": "President" },
                            "greece": { "count": 1, "title": "President" },
                            "india": { "count": 1, "title": "President" },
                            "indonesia": { "count": 1, "title": "President" },
                            "ireland": { "count": 1, "title": "President" },
                            "israel": { "count": 1, "title": "President" },
                            "italy": { "count": 1, "title": "President" },
                            "japan": { "count": 1, "title": "Emperor" },
                            "malaysia": { "count": 1, "title": "The King" },
                            "mexico": { "count": 1, "title": "President" },
                            "netherlands": { "count": 1, "title": "King" },
                            "new_zealand": { "count": 1, "title": "Governor General" },
                            "panama": { "count": 1, "title": "President" },
                            "philippines": { "count": 1, "title": "President" },
                            "poland": { "count": 1, "title": "President" },
                            "romania": { "count": 1, "title": "President" },
                            "saudi_arabia": { "count": 1, "title": "King" },
                            "singapore": { "count": 1, "title": "President" },
                            "south_africa": { "count": 1, "title": "President" },
                            "south_korea": { "count": 1, "title": "President" },
                            "spain": { "count": 1, "title": "King" },
                            "sweden": { "count": 1, "title": "King" },
                            "taiwan": { "count": 1, "title": "President" },
                            "thailand": { "count": 1, "title": "King" },
                            "united_arab_emirates": { "count": 1, "title": "President" },
                            "united_kingdom": { "count": 1, "title": "The King" },
                            "vietnam": { "count": 1, "title": "President" }
                        },
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "HOS",
                        "value": 1
                    },
                    "leg_agency_member": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual working at a National Legislative Agency, such as the GAO,\n            CBO, or Library of Congress\n        ",
                        "key": "leg_agency_member",
                        "label": "Legislative Agency Member",
                        "parent": 1,
                        "precedence": 15,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "LEGA",
                        "value": 48
                    },
                    "legislative_chamber_leader": {
                        "allowed_organization_types": [8, 22],
                        "description": "\n            An individual that leads a lower body chamber (or shadow cabinet). For\n            example, in Australia, all shadow ministers would have LCLs as their non-primary\n            person types\n        ",
                        "key": "legislative_chamber_leader",
                        "label": "Legislative Chamber Leader",
                        "order": 1,
                        "parent": 1,
                        "precedence": 25,
                        "region_specific_dict": {
                            "belgium": { "count": 2, "title": "Legislative Chamber Leader" },
                            "costa_rica": { "count": 2, "title": "Legislative Chamber Leader" },
                            "greece": { "count": 8, "title": "Legislative Chamber Leader" },
                            "hong_kong": { "count": 1, "title": "Legislative Council President" },
                            "malaysia": { "count": 5, "title": "Legislative Chamber Leader" },
                            "philippines": { "count": 17, "title": "Legislative Chamber Leader" },
                            "romania": { "count": 10, "title": "Legislative Chamber Leader" },
                            "singapore": { "title": "Leader" },
                            "vietnam": { "count": 1, "title": "Chairman of the National Assembly of Vietnam" }
                        },
                        "regions": [200, 201, 238, 204, 223, 226, 227, 228, 229, 239, 230, 231, 1, 10000],
                        "supported_regions": [200, 201, 238, 204, 223, 226, 227, 228, 229, 239, 230, 231, 1, 10000],
                        "unique_identifier": "LCL",
                        "value": 54
                    },
                    "legislative_other": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works within the legislative branch at the national level,\n            but is not a legislator or a staffer. EX: clerk or chaplain\n            of the senate\n        ",
                        "key": "legislative_other",
                        "label": "Legislative Other",
                        "parent": 1,
                        "precedence": 23,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "LEGOTHER",
                        "value": 52
                    },
                    "local_exec": {
                        "allowed_organization_types": [],
                        "description": "\n            An executive at the local level. For example, in the US, a\n            city's mayor would fit this description\n        ",
                        "key": "local_exec",
                        "label": "Local Head of Government",
                        "order": 21,
                        "parent": 2,
                        "precedence": 30,
                        "region_specific_dict": {},
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "LOEB",
                        "value": 25
                    },
                    "local_judicial": {
                        "allowed_organization_types": [],
                        "description": "An individual at the local level who works in a judicial position.",
                        "key": "local_judicial",
                        "label": "Local Judicial Officer",
                        "parent": 3,
                        "precedence": 30,
                        "region_specific_dict": {},
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "LOJUD",
                        "value": 35
                    },
                    "local_legislator": {
                        "allowed_organization_types": [],
                        "description": "\n            A legislator at the local level who works on a municipal /\n            local legislature\n        ",
                        "key": "local_legislator",
                        "label": "Local Legislator",
                        "order": 8,
                        "parent": 1,
                        "precedence": 30,
                        "region_specific_dict": {},
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "LOLEG",
                        "value": 26
                    },
                    "lower_body_leg_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the lower body of the\n            legislative branch of a national or supranational governing entity.\n        ",
                        "key": "lower_body_leg_can",
                        "label": "Lower Body Legislative Candidate",
                        "parent": 5,
                        "precedence": 35,
                        "region_specific_dict": {},
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANLLEG",
                        "value": 28
                    },
                    "lower_body_legislator": {
                        "allowed_organization_types": [4],
                        "description": "A legislator in the lower body (typically House or Assembly)",
                        "key": "lower_body_legislator",
                        "label": "Lower Body Legislator",
                        "order": 5,
                        "parent": 1,
                        "precedence": 5,
                        "region_specific_dict": {
                            "argentina": { "count": 257, "title": "Deputy" },
                            "australia": {
                                "count": [149, 150],
                                "title": "House Member"
                            },
                            "belgium": { "count": 150, "title": "Deputy" },
                            "brazil": { "count": 513, "title": "Deputy" },
                            "canada": {
                                "count": [334, 338],
                                "title": "Member of Parliament"
                            },
                            "chile": { "count": 155, "title": "Deputy" },
                            "colombia": {
                                "count": [166, 172],
                                "title": "Representative"
                            },
                            "dominican_republic": { "count": 190, "title": "Deputy" },
                            "france": { "count": 577, "title": "Deputy" },
                            "germany": {
                                "count": [598, 709],
                                "title": "Member of the Bundestag"
                            },
                            "india": {
                                "count": [524, 552],
                                "title": "Member of Parliament, Lok Sabha"
                            },
                            "indonesia": {
                                "count": [570, 575],
                                "title": "Member of the House of Representatives"
                            },
                            "ireland": {
                                "count": [156, 158],
                                "title": "TD"
                            },
                            "italy": { "count": 630, "title": "Deputy" },
                            "japan": { "count": 465, "title": "Member of the House of Representatives" },
                            "malaysia": { "count": 222, "title": "Member of the House of Representatives" },
                            "mexico": { "count": 500, "title": "Representative" },
                            "netherlands": { "count": 150, "title": "Representative" },
                            "philippines": { "count": 312, "title": "House Member" },
                            "poland": { "count": 460, "title": "Deputy" },
                            "romania": { "count": 330, "title": "Deputy" },
                            "singapore": { "count": 103, "title": "Member of Parliament" },
                            "south_africa": {
                                "count": [399, 400],
                                "title": "Member of the National Assembly"
                            },
                            "spain": { "count": 350, "title": "Deputy" },
                            "thailand": { "count": 500, "title": "Representative" },
                            "united_kingdom": { "count": 650, "title": "Member of Parliament" }
                        },
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "LLEG",
                        "value": 12
                    },
                    "media_assistant": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who operates as an assistant or staff role within a\n            media organization.\n        ",
                        "key": "media_assistant",
                        "label": "Assistant",
                        "parent": 7,
                        "precedence": 110,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "ASSISTANT",
                        "value": 45
                    },
                    "media_director": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who is in charge of a media activity, department, or\n            organization.\n        ",
                        "key": "media_director",
                        "label": "Director",
                        "parent": 7,
                        "precedence": 70,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "DIRECTOR",
                        "value": 41
                    },
                    "media_editor": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who is helps determine the final content of a media\n            product.\n        ",
                        "key": "media_editor",
                        "label": "Editor",
                        "parent": 7,
                        "precedence": 60,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "EDITOR",
                        "value": 40
                    },
                    "media_other": {
                        "allowed_organization_types": [],
                        "description": "An individual working at a media organization.",
                        "key": "media_other",
                        "label": "Other",
                        "parent": 7,
                        "precedence": 130,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "MEDOTH",
                        "value": 47
                    },
                    "media_producer": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who is responsible for the financial and managerial aspects of\n            a media product.\n        ",
                        "key": "media_producer",
                        "label": "Producer",
                        "parent": 7,
                        "precedence": 80,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "PRODUCER",
                        "value": 42
                    },
                    "media_publisher": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual or company that prepares and issues books, journals, music, or\n            other works for sale.\n        ",
                        "key": "media_publisher",
                        "label": "Publisher",
                        "parent": 7,
                        "precedence": 100,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "PUBLISHER",
                        "value": 44
                    },
                    "media_reporter": {
                        "allowed_organization_types": [],
                        "description": "An individual who reports news or conduct interviews for media organizations.",
                        "key": "media_reporter",
                        "label": "Reporter",
                        "parent": 7,
                        "precedence": 120,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "REPORTER",
                        "value": 46
                    },
                    "media_writer": {
                        "allowed_organization_types": [],
                        "description": "An indivudal who writes media products as a job or regular occupation.",
                        "key": "media_writer",
                        "label": "Writer",
                        "parent": 7,
                        "precedence": 90,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "WRITER",
                        "value": 43
                    },
                    "opposition_leader": {
                        "allowed_organization_types": [],
                        "description": "An individual that leads the opposition of a legislative chamber (or shadow cabinet).",
                        "key": "opposition_leader",
                        "label": "Opposition Leader",
                        "order": 2,
                        "parent": 1,
                        "precedence": 15,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "OLCL",
                        "value": 63
                    },
                    "organization_staff": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works directly for an organization in the government primarily\n            in a facilitiating capacity.\n        ",
                        "key": "organization_staff",
                        "label": "Organization Staffer",
                        "order": 25,
                        "parent": 4,
                        "precedence": 25,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "unique_identifier": "SO",
                        "value": 24
                    },
                    "other_major_role_type": {
                        "allowed_organization_types": [],
                        "description": "",
                        "key": "other_major_role_type",
                        "label": "Other",
                        "parent": 100,
                        "precedence": 1000,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "OTH",
                        "value": 1000
                    },
                    "party_leader": {
                        "allowed_organization_types": [21],
                        "description": "A person that is in the leadership of a political party.",
                        "key": "party_leader",
                        "label": "Party Leader",
                        "order": 3,
                        "parent": 1,
                        "precedence": 25,
                        "region_specific_dict": {
                            "belgium": { "count": 20 },
                            "costa_rica": { "count": 76, "title": "Party Leader" },
                            "dominican_republic": { "title": "Party Leader" },
                            "greece": { "title": "Party Leader" },
                            "israel": { "count": 26 },
                            "panama": { "title": "Party Leader" },
                            "romania": { "count": 23, "title": "Party Leader" }
                        },
                        "regions": [200, 201, 238, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 220, 221, 222, 223, 224, 225, 226, 239, 227, 228, 240, 229, 230, 231, 1, 10000],
                        "supported_regions": [200, 201, 238, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 220, 221, 222, 223, 224, 225, 226, 239, 227, 228, 240, 229, 230, 231, 1, 10000],
                        "unique_identifier": "PL",
                        "value": 56
                    },
                    "personal_staff": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works for someone in the governmental hierarchy predominantly in\n            a faciliating capacity.\n        ",
                        "key": "personal_staff",
                        "label": "Personal Staffer",
                        "order": 24,
                        "parent": 4,
                        "precedence": 25,
                        "region_specific_dict": {},
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "unique_identifier": "S",
                        "value": 23
                    },
                    "pol_mem": {
                        "allowed_organization_types": [],
                        "description": "A member of a political organization",
                        "key": "pol_mem",
                        "label": "Political Party Member",
                        "order": 9,
                        "parent": 6,
                        "precedence": 50,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "M",
                        "value": 29
                    },
                    "school_board_official": {
                        "allowed_organization_types": [133],
                        "description": "An individual working for a School Board",
                        "key": "school_board_official",
                        "label": "School Board Official",
                        "parent": 2,
                        "precedence": 35,
                        "region_specific_dict": {},
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "SBO",
                        "value": 58
                    },
                    "second_level_judge": {
                        "allowed_organization_types": [19],
                        "description": "\n            An individual who sits on the second-highest-level court in the Judiciary system.\n            In the United States this would be a Justice on an apellate\n            court.\n        ",
                        "key": "second_level_judge",
                        "label": "Second-Level Judge",
                        "order": 23,
                        "parent": 3,
                        "precedence": 21,
                        "region_specific_dict": {
                            "belgium": { "count": 57, "title": "Judge" },
                            "brazil": { "title": "Judicial Minister" },
                            "chile": { "count": 272, "title": "Member of the Court of Appeals" },
                            "china": { "title": "Court Judge" },
                            "denmark": { "title": "Judge" },
                            "france": { "title": "Second-Level Judge" },
                            "hong_kong": { "count": 54, "title": "Judge of the High Court" },
                            "india": { "count": 25, "title": "High Court Chief Justice" },
                            "malaysia": { "count": 98, "title": "Second-Level Judge" },
                            "mexico": { "title": "Magistrate" },
                            "new_zealand": { "count": 10, "title": "Judge of the Court of Appeal" },
                            "philippines": { "title": "Judge" },
                            "poland": { "title": "Judicial Branch Member" },
                            "spain": { "title": "Judge" },
                            "taiwan": { "count": 12, "title": "Chief Judge" },
                            "vietnam": { "count": 25, "title": "Judge of the High Court" }
                        },
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "J2",
                        "value": 22
                    },
                    "shadow_minister_spokesperson": {
                        "allowed_organization_types": [],
                        "description": "An individual that oversees a particular department or ministry within a country.",
                        "key": "shadow_minister_spokesperson",
                        "label": "Shadow Minister/Spokesperson",
                        "order": 2,
                        "parent": 1,
                        "precedence": 11,
                        "region_specific_dict": {
                            "australia": { "title": "Shadow Minister" },
                            "canada": { "title": "Shadow Minister" },
                            "new_zealand": { "title": "Shadow Minister" },
                            "united_kingdom": { "title": "Shadow Minister" }
                        },
                        "regions": [200, 201, 204, 231],
                        "supported_regions": [200, 201, 204, 231],
                        "unique_identifier": "OEB1",
                        "value": 60
                    },
                    "shadow_second_level_minister": {
                        "allowed_organization_types": [],
                        "description": "An individual that shadows a Second-Level Minister",
                        "key": "shadow_second_level_minister",
                        "label": "Shadow Second-Level Minister",
                        "parent": 1,
                        "precedence": 12,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "OEB2",
                        "value": 61
                    },
                    "shadow_third_level_minister": {
                        "allowed_organization_types": [],
                        "description": "An individual that shadows a Third-Level Minister",
                        "key": "shadow_third_level_minister",
                        "label": "Shadow Third-Level Minister",
                        "parent": 1,
                        "precedence": 13,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "OEB3",
                        "value": 62
                    },
                    "sub_national_deputy_opposition_legislative_person": {
                        "allowed_organization_types": [],
                        "description": "An individual that is the 2nd in the opposition of a sub-national legislative chamber (Deputy shadow Minister)",
                        "key": "sub_national_deputy_opposition_legislative_person",
                        "label": "Sub-national Deputy Opposition Legislative Person",
                        "order": 6,
                        "parent": 1,
                        "precedence": 24,
                        "region_specific_dict": {
                            "australia": { "title": "Provincial Shadow Minister" },
                            "canada": { "title": "Provincial Shadow Minister" },
                            "new_zealand": { "title": "Provincial Shadow Minister" },
                            "united_kingdom": { "title": "Provincial Shadow Minister" }
                        },
                        "regions": [200, 201, 204, 231],
                        "supported_regions": [200, 201, 204, 231],
                        "unique_identifier": "SODLCL",
                        "value": 65
                    },
                    "sub_national_exec_1": {
                        "allowed_organization_types": [23],
                        "description": "A high-level executive (Minister, Secretary, etc.) of a state/province.",
                        "key": "sub_national_exec_1",
                        "label": "Sub-National Top-Level Executive",
                        "order": 20,
                        "parent": 2,
                        "precedence": 13,
                        "region_specific_dict": {
                            "australia": { "count": 200, "title": "State Minister" },
                            "brazil": { "title": "Secretary of State" },
                            "canada": { "count": 2000, "title": "Provincial Minister" },
                            "india": { "count": 400, "title": "State Minister" },
                            "mexico": { "count": 2000, "title": "State Secretary" },
                            "spain": { "title": "Autonomous Community Minister" },
                            "united_arab_emirates": { "title": "Chairman / CEO" },
                            "united_kingdom": { "title": "State Minister" }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB1",
                        "value": 17
                    },
                    "sub_national_exec_2": {
                        "allowed_organization_types": [],
                        "description": "A second-level executive of a state or province.",
                        "key": "sub_national_exec_2",
                        "label": "Sub-National Second-Level Executive",
                        "order": 21,
                        "parent": 2,
                        "precedence": 15,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SEB2",
                        "value": 30
                    },
                    "sub_national_exec_3": {
                        "allowed_organization_types": [],
                        "description": "A third-level executive of a state or province.",
                        "key": "sub_national_exec_3",
                        "label": "Sub-National Third-Level Executive",
                        "parent": 2,
                        "precedence": 16,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB3",
                        "value": 31
                    },
                    "sub_national_exec_4": {
                        "allowed_organization_types": [],
                        "description": "A fourth-level executive of a state or province.",
                        "key": "sub_national_exec_4",
                        "label": "Sub-National Fourth-Level Executive",
                        "parent": 2,
                        "precedence": 17,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB4",
                        "value": 32
                    },
                    "sub_national_exec_5": {
                        "allowed_organization_types": [],
                        "description": "A fifth-level executive of a state or province.",
                        "key": "sub_national_exec_5",
                        "label": "Sub-National Fifth-Level Executive",
                        "parent": 2,
                        "precedence": 18,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB5",
                        "value": 33
                    },
                    "sub_national_exec_branch_member": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works within the executive branch of a state or\n            province,\n        ",
                        "key": "sub_national_exec_branch_member",
                        "label": "Sub-National Executive Branch Member",
                        "parent": 2,
                        "precedence": 24,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEBM",
                        "value": 34
                    },
                    "sub_national_exec_branch_member_other": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works within the executive branch of a state or\n            province in a low precedence role. Useful to give priority to other\n            local roles\n        ",
                        "key": "sub_national_exec_branch_member_other",
                        "label": "Sub-National Executive Branch Member Other",
                        "parent": 2,
                        "precedence": 50,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEBMO",
                        "value": 51
                    },
                    "sub_national_exec_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the executive branch of a\n            state or province.\n        ",
                        "key": "sub_national_exec_can",
                        "label": "Sub-National Executive Candidate",
                        "parent": 5,
                        "precedence": 40,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANSEB",
                        "value": 36
                    },
                    "sub_national_head_of_government": {
                        "allowed_organization_types": [22],
                        "description": "\n            The highest executive of a state / province, such as a Premier\n            of State in Australia or Canada.\n        ",
                        "key": "sub_national_head_of_government",
                        "label": "Sub-National Head of Government",
                        "order": 19,
                        "parent": 2,
                        "precedence": 11,
                        "region_specific_dict": {
                            "argentina": { "count": 22, "title": "Vice Governor" },
                            "australia": {
                                "count": [6, 8],
                                "title": "Premier"
                            },
                            "brazil": { "count": 27, "title": "Governor" },
                            "canada": {
                                "count": [10, 13],
                                "title": "Premier"
                            },
                            "india": {
                                "count": [30, 31],
                                "title": "Chief Minister"
                            },
                            "mexico": { "count": 32, "title": "Governor" },
                            "spain": { "title": "Autonomous Community Head of Government" },
                            "united_arab_emirates": { "title": "Ruler" },
                            "united_kingdom": { "count": 3, "title": "First Minister" }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SHOG",
                        "value": 16
                    },
                    "sub_national_head_of_state": {
                        "allowed_organization_types": [5],
                        "description": "\n            The chief public representative of a state or province, such as a\n            Governor in Australia or Lt. Governor in Canada.\n        ",
                        "key": "sub_national_head_of_state",
                        "label": "Sub-National Head of State",
                        "order": 17,
                        "parent": 2,
                        "precedence": 11,
                        "region_specific_dict": {
                            "australia": {
                                "count": [6, 9],
                                "title": "Governor"
                            },
                            "canada": { "count": 10, "title": "Lt. Governor" },
                            "india": {
                                "count": [27, 29],
                                "title": "Governor"
                            },
                            "mexico": { "count": 32, "title": "Governor" },
                            "spain": { "title": "Autonomous Community President" },
                            "taiwan": { "count": 21, "title": "State Executive" }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SHOS",
                        "value": 14
                    },
                    "sub_national_leg_agency_member": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual working at a Sub-National Legislative Agency, such as WA JAARC\n            or VA Division of Legislative Services\n        ",
                        "key": "sub_national_leg_agency_member",
                        "label": "Sub-National Legislative Agency Member",
                        "parent": 1,
                        "precedence": 24,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SLEGA",
                        "value": 49
                    },
                    "sub_national_legislative_chamber_leader": {
                        "allowed_organization_types": [],
                        "description": "An individual that leads the opposition of a sub-national legislative chamber (or shadow cabinet).",
                        "key": "sub_national_legislative_chamber_leader",
                        "label": "Sub-national Legislative Chamber Leader",
                        "order": 6,
                        "parent": 1,
                        "precedence": 23,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SLCL",
                        "value": 64
                    },
                    "sub_national_legislative_other": {
                        "allowed_organization_types": [],
                        "description": "\n            An individual who works within the legislative branch at the sub national\n            level, but is not a legislator or a staffer. EX: clerk or\n            chaplain of the senate\n        ",
                        "key": "sub_national_legislative_other",
                        "label": "Sub National Legislative Other",
                        "parent": 1,
                        "precedence": 24,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SLEGOTHER",
                        "value": 53
                    },
                    "sub_national_lower_body_leg_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the lower body of the\n            legislative branch of a subnational government.\n        ",
                        "key": "sub_national_lower_body_leg_can",
                        "label": "Sub-National Lower Body Legislative Candidate",
                        "parent": 5,
                        "precedence": 40,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANSLLEG",
                        "value": 39
                    },
                    "sub_national_lower_legislator": {
                        "allowed_organization_types": [26],
                        "description": "\n            A legislator in the lower body (typically House) of a sub-national state/province's\n            legislature.\n        ",
                        "key": "sub_national_lower_legislator",
                        "label": "Sub-National Lower Body Legislator",
                        "order": 7,
                        "parent": 1,
                        "precedence": 14,
                        "region_specific_dict": {
                            "australia": {
                                "count": [0, 400],
                                "title": "State Legislative Assembly Member"
                            },
                            "brazil": {
                                "count": [0, 400],
                                "title": "State Deputy"
                            },
                            "mexico": { "count": 1114, "title": "State Deputy" }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SLLEG",
                        "value": 19
                    },
                    "sub_national_opposition_legislative_person": {
                        "allowed_organization_types": [],
                        "description": "An individual in the oposition of a sub-national legislative chamber (or shadow cabinet).",
                        "key": "sub_national_opposition_legislative_person",
                        "label": "Sub-national Opposition Legislative Person",
                        "order": 6,
                        "parent": 1,
                        "precedence": 24,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SOLCL",
                        "value": 66
                    },
                    "sub_national_unicameral_legislator": {
                        "allowed_organization_types": [],
                        "description": "A legislator of a sub-national state/province's unicameral legislature.",
                        "key": "sub_national_unicameral_legislator",
                        "label": "Sub-National Unicameral Body Legislator",
                        "parent": 1,
                        "precedence": 14,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SUULEG",
                        "value": 20
                    },
                    "sub_national_upper_body_leg_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the upper body of the\n            legislative branch of a subnational government.\n        ",
                        "key": "sub_national_upper_body_leg_can",
                        "label": "Sub-National Upper Body Legislative Candidate",
                        "parent": 5,
                        "precedence": 40,
                        "region_specific_dict": {},
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANSULEG",
                        "value": 38
                    },
                    "sub_national_upper_legislator": {
                        "allowed_organization_types": [25],
                        "description": "\n            A legislator in the upper body (typically Senate) of a sub-national state/province's\n            legislature.\n        ",
                        "key": "sub_national_upper_legislator",
                        "label": "Sub-National Upper Body Legislator",
                        "order": 6,
                        "parent": 1,
                        "precedence": 14,
                        "region_specific_dict": {
                            "australia": {
                                "count": [0, 400],
                                "title": "State Legislative Council Member"
                            },
                            "canada": {
                                "count": [0, 1625],
                                "title": "Legislative Assembly Member"
                            }
                        },
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "SULEG",
                        "value": 18
                    },
                    "top_level_judge": {
                        "allowed_organization_types": [18],
                        "description": "\n            An individual who sits on the highest-level court in the Judiciary system.\n            In the United States this would be a Supreme Court Justice.\n        ",
                        "key": "top_level_judge",
                        "label": "Top-Level Judge",
                        "order": 22,
                        "parent": 3,
                        "precedence": 20,
                        "region_specific_dict": {
                            "argentina": { "count": 4, "title": "Supreme Court Justice" },
                            "australia": { "count": 7, "title": "High Court Justice" },
                            "belgium": { "count": 43, "title": "Magistrate" },
                            "brazil": { "count": 11, "title": "Justice" },
                            "canada": { "count": 9, "title": "Justice" },
                            "chile": { "count": 21, "title": "Member of the Supreme Court of Justice" },
                            "china": { "title": "Justice of the Supreme People's Court" },
                            "colombia": { "count": 23, "title": "Justice" },
                            "costa_rica": { "count": 49, "title": "Magistrate" },
                            "denmark": { "title": "Supreme Court Justice" },
                            "germany": { "title": "Supreme Court Judge" },
                            "hong_kong": { "count": 18, "title": "Judge of the Court of Final Appeal" },
                            "india": {
                                "count": [26, 31],
                                "title": "Supreme Court Justice"
                            },
                            "indonesia": { "title": "Justice" },
                            "ireland": {
                                "count": [9, 10],
                                "title": "Judge"
                            },
                            "italy": { "title": "Constitutional Court Judge" },
                            "japan": { "count": 15, "title": "Justice" },
                            "malaysia": { "count": 9, "title": "Federal Court Judge" },
                            "mexico": { "count": 11, "title": "Minister" },
                            "new_zealand": { "count": 6, "title": "Judge of the Supreme Court" },
                            "philippines": { "count": 15, "title": "Supreme Court Justice" },
                            "poland": { "title": "Supreme Court Judge" },
                            "saudi_arabia": { "count": 12, "title": "Qadi" },
                            "south_africa": { "count": 9, "title": "Judge" },
                            "south_korea": { "count": 25 },
                            "spain": { "count": 20, "title": "Magistrate" },
                            "sweden": { "count": 1, "title": "Supreme Court Judge" },
                            "taiwan": { "count": 19, "title": "Judicial Yuan Principal Officer and Justice" },
                            "united_kingdom": { "title": "Supreme Court Justice" },
                            "vietnam": { "count": 16, "title": "Judge of the Supreme People's Court" }
                        },
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "unique_identifier": "J1",
                        "value": 21
                    },
                    "unicameral_body_legislator": {
                        "allowed_organization_types": [],
                        "description": "A legislator in a unicameral legislature",
                        "key": "unicameral_body_legislator",
                        "label": "Unicameral Body Legislator",
                        "parent": 1,
                        "precedence": 4,
                        "region_specific_dict": {},
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "UULEG",
                        "value": 13
                    },
                    "upper_body_leg_can": {
                        "allowed_organization_types": [],
                        "description": "\n            A candidate running for a role in the upper body of the\n            legislative branch of a national or supranational governing entity.\n        ",
                        "key": "upper_body_leg_can",
                        "label": "Upper Body Legislative Candidate",
                        "parent": 5,
                        "precedence": 34,
                        "region_specific_dict": {},
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "CANULEG",
                        "value": 37
                    },
                    "upper_body_legislator": {
                        "allowed_organization_types": [3],
                        "description": "A legislator in the upper body (typically Senate) of a country's legislature.",
                        "key": "upper_body_legislator",
                        "label": "Upper Body Legislator",
                        "order": 4,
                        "parent": 1,
                        "precedence": 4,
                        "region_specific_dict": {
                            "argentina": { "count": 72, "title": "Senator" },
                            "australia": { "count": 76, "title": "Senator" },
                            "belgium": { "count": 60, "title": "Senator" },
                            "brazil": { "count": 81, "title": "Senator" },
                            "canada": { "count": 105, "title": "Senator" },
                            "chile": { "count": 50, "title": "Senator" },
                            "china": { "count": 2980, "title": "Deputy" },
                            "colombia": { "count": 108, "title": "Senator" },
                            "costa_rica": { "count": 57, "title": "Deputy" },
                            "denmark": { "count": 179, "title": "Member of the Danish Parliament" },
                            "dominican_republic": { "count": 32, "title": "Senator" },
                            "france": { "count": 348, "title": "Senator" },
                            "germany": { "count": 69, "title": "Member of the Bundesrat" },
                            "greece": { "count": 300, "title": "Member of the Hellenic Parliament" },
                            "hong_kong": { "count": 90, "title": "Legislative Council Member" },
                            "india": {
                                "count": [244, 250],
                                "title": "Member of Parliament, Rajya Sabha"
                            },
                            "indonesia": {
                                "count": [136, 138],
                                "title": "Member of the Regional Representative Council"
                            },
                            "ireland": { "count": 60, "title": "Senator" },
                            "israel": { "count": 120, "title": "Knesset Member" },
                            "italy": {
                                "count": [315, 321],
                                "title": "Senator"
                            },
                            "japan": {
                                "count": [243, 245],
                                "title": "Member of the House of Councilors "
                            },
                            "malaysia": { "count": 51, "title": "Senator" },
                            "mexico": { "count": 128, "title": "Senator" },
                            "netherlands": { "count": 75, "title": "Senator" },
                            "new_zealand": { "count": 120, "title": "Member of Parliament" },
                            "panama": { "count": 71, "title": "Member of the National Assembly" },
                            "philippines": { "count": 24, "title": "Senator" },
                            "poland": { "count": 100, "title": "Senator" },
                            "romania": { "count": 136, "title": "Senator" },
                            "saudi_arabia": { "count": 150, "title": "Council Member" },
                            "south_africa": {
                                "count": [54, 90],
                                "title": "Provincial Delegate"
                            },
                            "south_korea": {
                                "count": [294, 300],
                                "title": "Senator"
                            },
                            "spain": { "count": 265, "title": "Senator" },
                            "sweden": { "count": 349, "title": "Member of Parliament" },
                            "taiwan": { "count": 113, "title": "Legislator" },
                            "thailand": { "count": 250, "title": "Senator" },
                            "united_arab_emirates": { "count": 40, "title": "Council Member" },
                            "united_kingdom": {
                                "count": [792, 793],
                                "title": "Lord"
                            },
                            "vietnam": { "count": 500, "title": "Delegate" }
                        },
                        "regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [106, 1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "ULEG",
                        "value": 11
                    }
                },
                "MetaOrganizationType": {
                    "__is_enum": true,
                    "broadcast": {
                        "description": "A broadcast media organization",
                        "key": "broadcast",
                        "label": "Broadcast",
                        "parent": 2,
                        "precedence": 6,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "BRD",
                        "value": 12
                    },
                    "charity": {
                        "description": "A non-profit organization",
                        "key": "charity",
                        "label": "Charity",
                        "parent": 3,
                        "precedence": 999,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "NPFTO",
                        "value": 18
                    },
                    "county": {
                        "description": "A local geographical region of a country used for administrative reason",
                        "key": "county",
                        "label": "County",
                        "parent": 1,
                        "precedence": 15,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "COU",
                        "value": 7
                    },
                    "custom": {
                        "description": "A custom organization created by an end user",
                        "key": "custom",
                        "label": "Custom",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "CUS",
                        "value": 10
                    },
                    "executive_org": {
                        "description": "An executive body",
                        "key": "executive_org",
                        "label": "Executive",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "EXC",
                        "value": 2
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Media Outlets",
                            "values": [11, 12, 13, 14, 15, 17]
                        }
                    ],
                    "freelance": {
                        "description": "An organization representing freelance work",
                        "key": "freelance",
                        "label": "Freelance",
                        "parent": 2,
                        "precedence": 9,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "FRE",
                        "value": 15
                    },
                    "institute": {
                        "description": "A research, advocacy, or advisory organization",
                        "key": "institute",
                        "label": "Institute",
                        "parent": 2,
                        "precedence": 8,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "INS",
                        "value": 14
                    },
                    "intergovernmental": {
                        "description": "\n            An organization composed primarily of sovereign states, or of other intergovernmental organizations\n            (e.g. the EU)\n        ",
                        "key": "intergovernmental",
                        "label": "Intergovernmental",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "IGO",
                        "value": 9
                    },
                    "internet": {
                        "description": "An internet media organization",
                        "key": "internet",
                        "label": "Internet",
                        "parent": 2,
                        "precedence": 7,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "INT",
                        "value": 13
                    },
                    "judiciary_org": {
                        "description": "A judicial body",
                        "key": "judiciary_org",
                        "label": "Judiciary",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "JUD",
                        "value": 3
                    },
                    "legislative_org": {
                        "description": "A legislative body",
                        "key": "legislative_org",
                        "label": "Legislative",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "LEG",
                        "value": 1
                    },
                    "municipality": {
                        "description": "\n            A single administrative division having corporate status and powers of self-government or\n            jurisdiction as granted by national and regional laws to which it is\n            subordinate\n        ",
                        "key": "municipality",
                        "label": "Municipality",
                        "parent": 1,
                        "precedence": 15,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "MUN",
                        "value": 8
                    },
                    "nation_state": {
                        "description": "\n            An organization of this type represents the entire government for a specific\n            country (i.e. Government of France)\n        ",
                        "key": "nation_state",
                        "label": "Nation State",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "NS",
                        "value": 4
                    },
                    "other_media": {
                        "description": "All other media organizations",
                        "key": "other_media",
                        "label": "Other Media",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "MEDIA",
                        "value": 17
                    },
                    "political_org": {
                        "description": "A political organization that is independent of the government",
                        "key": "political_org",
                        "label": "Political",
                        "parent": 1,
                        "precedence": 2,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "POL",
                        "value": 6
                    },
                    "print_media": {
                        "description": "A print media organization",
                        "key": "print_media",
                        "label": "Print",
                        "parent": 2,
                        "precedence": 1,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "PRT",
                        "value": 11
                    },
                    "pub_service_corp": {
                        "description": "\n            A corporation providing a public service for a fee, enabling corporation to\n            turn a profit, that requires government oversight\n        ",
                        "key": "pub_service_corp",
                        "label": "Public Service Corporation",
                        "parent": 1,
                        "precedence": 20,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "PSCORP",
                        "value": 16
                    },
                    "state_province": {
                        "description": "A sub-national state or province",
                        "key": "state_province",
                        "label": "State / Province",
                        "parent": 1,
                        "precedence": 5,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "STA",
                        "value": 5
                    }
                },
                "MetaRoleType": {
                    "__is_enum": true,
                    "candidate": {
                        "description": "A candidate for an upcoming election",
                        "key": "candidate",
                        "label": "Candidate",
                        "parent": 1,
                        "precedence": 2,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "CAN",
                        "value": 5
                    },
                    "executive": {
                        "description": "A member of a government's executive branch",
                        "key": "executive",
                        "label": "Executive",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "EXC",
                        "value": 2
                    },
                    "judiciary": {
                        "description": "A member of a government's judicial branch",
                        "key": "judiciary",
                        "label": "Judiciary",
                        "parent": 1,
                        "precedence": 4,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "JUD",
                        "value": 3
                    },
                    "legislative": {
                        "description": "A member of a government's legislative branch",
                        "key": "legislative",
                        "label": "Legislative",
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "LEG",
                        "value": 1
                    },
                    "media_meta": {
                        "description": "A person in the media",
                        "key": "media_meta",
                        "label": "Media",
                        "parent": 2,
                        "precedence": 5,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "MED",
                        "value": 7
                    },
                    "other_meta_role_type": {
                        "description": "For custom persons, ability to add a custom role",
                        "key": "other_meta_role_type",
                        "label": "Other",
                        "parent": 4,
                        "precedence": 100,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "OTH",
                        "value": 100
                    },
                    "political": {
                        "description": "A political role that is independent of the government (i.e. Party)",
                        "key": "political",
                        "label": "Political",
                        "parent": 1,
                        "precedence": 3,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "POL",
                        "value": 6
                    },
                    "staff": {
                        "description": "A government staffer who works for a person or an organization",
                        "key": "staff",
                        "label": "Staff",
                        "parent": 1,
                        "precedence": 2,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "STF",
                        "value": 4
                    }
                },
                "MinorRoleType": {
                    "__is_enum": true,
                    "administrative_director": {
                        "key": "administrative_director",
                        "label": "Administrative Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 228
                    },
                    "analyst": {
                        "key": "analyst",
                        "label": "Analyst",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 229
                    },
                    "anchor": {
                        "key": "anchor",
                        "label": "Anchor/Host",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 230
                    },
                    "arg_deputy": {
                        "key": "arg_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 347
                    },
                    "arg_executive_branch_member": {
                        "key": "arg_executive_branch_member",
                        "label": "Executive",
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 344
                    },
                    "arg_minister": {
                        "key": "arg_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 342
                    },
                    "arg_president": {
                        "key": "arg_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 340
                    },
                    "arg_provincial_governor": {
                        "key": "arg_provincial_governor",
                        "label": "Provincial Governor",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 345
                    },
                    "arg_secretary": {
                        "key": "arg_secretary",
                        "label": "Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 343
                    },
                    "arg_senator": {
                        "key": "arg_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 346
                    },
                    "arg_top_level_judge": {
                        "key": "arg_top_level_judge",
                        "label": "Supreme Court Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 348
                    },
                    "arg_vice_president": {
                        "key": "arg_vice_president",
                        "label": "Vice-President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [224],
                        "show_in_quicksearch": false,
                        "supported_regions": [224],
                        "value": 341
                    },
                    "assignment_editor": {
                        "key": "assignment_editor",
                        "label": "Assignment Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 231
                    },
                    "assignment_manager": {
                        "key": "assignment_manager",
                        "label": "Assignment Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 232
                    },
                    "assistant_director": {
                        "key": "assistant_director",
                        "label": "Assistant Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 233
                    },
                    "assistant_editor": {
                        "key": "assistant_editor",
                        "label": "Assistant Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 234
                    },
                    "assistant_managing_editor": {
                        "key": "assistant_managing_editor",
                        "label": "Assistant Managing Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 235
                    },
                    "assistant_producer": {
                        "key": "assistant_producer",
                        "label": "Assistant Producer",
                        "parent": 42,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 236
                    },
                    "assistant_program_director": {
                        "key": "assistant_program_director",
                        "label": "Assistant Program Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 237
                    },
                    "assistant_publisher": {
                        "key": "assistant_publisher",
                        "label": "Assistant Publisher",
                        "parent": 44,
                        "precedence": 1000,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 238
                    },
                    "assistant_to_the_editor": {
                        "key": "assistant_to_the_editor",
                        "label": "Assistant to Editor",
                        "parent": 45,
                        "precedence": 1100,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 239
                    },
                    "associate_director": {
                        "key": "associate_director",
                        "label": "Associate Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 240
                    },
                    "associate_editor": {
                        "key": "associate_editor",
                        "label": "Associate Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 241
                    },
                    "associate_producer": {
                        "key": "associate_producer",
                        "label": "Associate Producer",
                        "parent": 42,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 242
                    },
                    "associate_publisher": {
                        "key": "associate_publisher",
                        "label": "Associate Publisher",
                        "parent": 44,
                        "precedence": 1000,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 243
                    },
                    "aus_deputy_minister": {
                        "key": "aus_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 102
                    },
                    "aus_deputy_prime_minister": {
                        "key": "aus_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 98
                    },
                    "aus_governor": {
                        "key": "aus_governor",
                        "label": "Governor",
                        "parent": 14,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 104
                    },
                    "aus_governor_general": {
                        "key": "aus_governor_general",
                        "label": "Governor General",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 96
                    },
                    "aus_lt_governor": {
                        "key": "aus_lt_governor",
                        "label": "Lt. Governor",
                        "parent": 15,
                        "precedence": 305,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 105
                    },
                    "aus_minister": {
                        "key": "aus_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 99
                    },
                    "aus_mp": {
                        "key": "aus_mp",
                        "label": "Member of Parliament",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 101
                    },
                    "aus_parliament_secretary": {
                        "key": "aus_parliament_secretary",
                        "label": "Parliament Secretary",
                        "parent": 6,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 103
                    },
                    "aus_premier": {
                        "key": "aus_premier",
                        "label": "Premier",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 106
                    },
                    "aus_prime_minister": {
                        "key": "aus_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 97
                    },
                    "aus_senator": {
                        "key": "aus_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 100
                    },
                    "aus_sta_lower_body_legislator": {
                        "key": "aus_sta_lower_body_legislator",
                        "label": "Legislative Assembly",
                        "parent": 19,
                        "precedence": 785,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 222
                    },
                    "aus_sta_upper_body_legislator": {
                        "key": "aus_sta_upper_body_legislator",
                        "label": "Legislative Council",
                        "parent": 18,
                        "precedence": 780,
                        "rank": 1000,
                        "regions": [200],
                        "show_in_quicksearch": false,
                        "supported_regions": [200],
                        "value": 221
                    },
                    "bel_deputy": {
                        "key": "bel_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 385
                    },
                    "bel_deputy_prime_minister": {
                        "key": "bel_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 380
                    },
                    "bel_executive_branch_member": {
                        "key": "bel_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 383
                    },
                    "bel_judge": {
                        "key": "bel_judge",
                        "label": "Judge",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 388
                    },
                    "bel_king": {
                        "key": "bel_king",
                        "label": "King",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 378
                    },
                    "bel_legislative_chamber_leader": {
                        "key": "bel_legislative_chamber_leader",
                        "label": "Legislative Chamber Leader",
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 386
                    },
                    "bel_magistrate": {
                        "key": "bel_magistrate",
                        "label": "Magistrate",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 387
                    },
                    "bel_minister": {
                        "key": "bel_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 381
                    },
                    "bel_prime_minister": {
                        "key": "bel_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 379
                    },
                    "bel_secretary_of_state": {
                        "key": "bel_secretary_of_state",
                        "label": "Secretary of State",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 382
                    },
                    "bel_senator": {
                        "key": "bel_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [226],
                        "show_in_quicksearch": false,
                        "supported_regions": [226],
                        "value": 384
                    },
                    "blogger": {
                        "key": "blogger",
                        "label": "Blogger",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 244
                    },
                    "booker": {
                        "key": "booker",
                        "label": "Booker",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 245
                    },
                    "bra_deputy": {
                        "key": "bra_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 121
                    },
                    "bra_executive_secretariat": {
                        "key": "bra_executive_secretariat",
                        "label": "Executive Secretariat",
                        "parent": 6,
                        "precedence": 810,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 224
                    },
                    "bra_governor": {
                        "key": "bra_governor",
                        "label": "Governor",
                        "parent": 16,
                        "precedence": 790,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 225
                    },
                    "bra_justice": {
                        "key": "bra_justice",
                        "label": "Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 122
                    },
                    "bra_minister": {
                        "key": "bra_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 119
                    },
                    "bra_president": {
                        "key": "bra_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 117
                    },
                    "bra_secretariat": {
                        "key": "bra_secretariat",
                        "label": "Secretariat",
                        "parent": 5,
                        "precedence": 815,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 223
                    },
                    "bra_senator": {
                        "key": "bra_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 120
                    },
                    "bra_sta_lower_body_legislator": {
                        "key": "bra_sta_lower_body_legislator",
                        "label": "State Assembly",
                        "parent": 19,
                        "precedence": 805,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 227
                    },
                    "bra_sta_upper_body_legislator": {
                        "key": "bra_sta_upper_body_legislator",
                        "label": "State Deputy",
                        "parent": 18,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 226
                    },
                    "bra_vice_president": {
                        "key": "bra_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [208],
                        "show_in_quicksearch": false,
                        "supported_regions": [208],
                        "value": 118
                    },
                    "bureau_chief": {
                        "key": "bureau_chief",
                        "label": "Bureau Chief",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 246
                    },
                    "cadet": {
                        "key": "cadet",
                        "label": "Cadet",
                        "parent": 46,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 377
                    },
                    "calendar_editor": {
                        "key": "calendar_editor",
                        "label": "Calendar Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 247
                    },
                    "can_deputy_minister": {
                        "key": "can_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 113
                    },
                    "can_deputy_prime_minister": {
                        "key": "can_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 109
                    },
                    "can_governor_general": {
                        "key": "can_governor_general",
                        "label": "Governor General",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 107
                    },
                    "can_lt_governor": {
                        "key": "can_lt_governor",
                        "label": "Lt. Governor",
                        "parent": 14,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 115
                    },
                    "can_minister": {
                        "key": "can_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 110
                    },
                    "can_mp": {
                        "key": "can_mp",
                        "label": "Member of Parliament",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 112
                    },
                    "can_parliament_secretary": {
                        "key": "can_parliament_secretary",
                        "label": "Parliament Secretary",
                        "parent": 6,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 114
                    },
                    "can_premier": {
                        "key": "can_premier",
                        "label": "Premier",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 116
                    },
                    "can_prime_minister": {
                        "key": "can_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 108
                    },
                    "can_senator": {
                        "key": "can_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 111
                    },
                    "can_sta_upper_body_legislator": {
                        "key": "can_sta_upper_body_legislator",
                        "label": "Legislative Assembly Member",
                        "parent": 18,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [201],
                        "show_in_quicksearch": false,
                        "supported_regions": [201],
                        "value": 371
                    },
                    "chl_deputy": {
                        "key": "chl_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 447
                    },
                    "chl_executive_branch_member": {
                        "key": "chl_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 450
                    },
                    "chl_member_of_court_of_appeals": {
                        "key": "chl_member_of_court_of_appeals",
                        "label": "Member of the Court of Appeals",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 452
                    },
                    "chl_member_of_supreme_court_justice": {
                        "key": "chl_member_of_supreme_court_justice",
                        "label": "Member of the Supreme Court of Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 451
                    },
                    "chl_minister": {
                        "key": "chl_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 448
                    },
                    "chl_president": {
                        "key": "chl_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 444
                    },
                    "chl_senator": {
                        "key": "chl_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 446
                    },
                    "chl_undersecretary": {
                        "key": "chl_undersecretary",
                        "label": "Undersecretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 449
                    },
                    "chl_vice_president": {
                        "key": "chl_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [233],
                        "show_in_quicksearch": false,
                        "supported_regions": [233],
                        "value": 445
                    },
                    "chn_deputy": {
                        "key": "chn_deputy",
                        "label": "Deputy",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [209],
                        "show_in_quicksearch": false,
                        "supported_regions": [209],
                        "value": 542
                    },
                    "col_magistrate": {
                        "key": "col_magistrate",
                        "label": "Magistrate",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 141
                    },
                    "col_minister": {
                        "key": "col_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 138
                    },
                    "col_president": {
                        "key": "col_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 136
                    },
                    "col_representative": {
                        "key": "col_representative",
                        "label": "Representative",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 140
                    },
                    "col_senator": {
                        "key": "col_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 139
                    },
                    "col_vice_president": {
                        "key": "col_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [213],
                        "show_in_quicksearch": false,
                        "supported_regions": [213],
                        "value": 137
                    },
                    "columnist": {
                        "key": "columnist",
                        "label": "Columnist",
                        "parent": 43,
                        "precedence": 900,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 248
                    },
                    "community_affairs_director": {
                        "key": "community_affairs_director",
                        "label": "Community Affairs Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 249
                    },
                    "consultant": {
                        "key": "consultant",
                        "label": "Consultant",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 250
                    },
                    "content_director": {
                        "key": "content_director",
                        "label": "Content Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 251
                    },
                    "content_editor": {
                        "key": "content_editor",
                        "label": "Content Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 252
                    },
                    "content_manager": {
                        "key": "content_manager",
                        "label": "Content Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 253
                    },
                    "content_producer": {
                        "key": "content_producer",
                        "label": "Content Producer",
                        "parent": 42,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 254
                    },
                    "contributing_editor": {
                        "key": "contributing_editor",
                        "label": "Contributing Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 255
                    },
                    "contributor": {
                        "key": "contributor",
                        "label": "Contributor",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 256
                    },
                    "coordinator": {
                        "key": "coordinator",
                        "label": "Coordinator",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 257
                    },
                    "copy_editor": {
                        "key": "copy_editor",
                        "label": "Copy Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 258
                    },
                    "correspondent": {
                        "key": "correspondent",
                        "label": "Correspondent",
                        "parent": 46,
                        "precedence": 1200,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 259
                    },
                    "cri_deputy": {
                        "key": "cri_deputy",
                        "label": "Deputy",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 439
                    },
                    "cri_executive_branch_member": {
                        "key": "cri_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 442
                    },
                    "cri_magistrate": {
                        "key": "cri_magistrate",
                        "label": "Magistrate",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 443
                    },
                    "cri_president": {
                        "key": "cri_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 437
                    },
                    "cri_second_level_minister": {
                        "key": "cri_second_level_minister",
                        "label": "Vice Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 441
                    },
                    "cri_top_level_minister": {
                        "key": "cri_top_level_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 440
                    },
                    "cri_vice_president": {
                        "key": "cri_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [232],
                        "show_in_quicksearch": false,
                        "supported_regions": [232],
                        "value": 438
                    },
                    "critic": {
                        "key": "critic",
                        "label": "Critic",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 260
                    },
                    "cze_chief_director": {
                        "key": "cze_chief_director",
                        "label": "Chief Director",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 495
                    },
                    "cze_committee_leader": {
                        "key": "cze_committee_leader",
                        "label": "Committee Leader",
                        "parent": 55,
                        "precedence": 385,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 501
                    },
                    "cze_deputy": {
                        "key": "cze_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 499
                    },
                    "cze_deputy_chief_director": {
                        "key": "cze_deputy_chief_director",
                        "label": "Deputy Chief Director",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 496
                    },
                    "cze_deputy_minister": {
                        "key": "cze_deputy_minister",
                        "label": "Minister, Deputy Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 493
                    },
                    "cze_deputy_prime_minister": {
                        "key": "cze_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 492
                    },
                    "cze_executive_branch_member": {
                        "key": "cze_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 497
                    },
                    "cze_leg_chamber_leader": {
                        "key": "cze_leg_chamber_leader",
                        "label": "Legislative Chamber Leader",
                        "parent": 54,
                        "precedence": 385,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 500
                    },
                    "cze_party_leader": {
                        "key": "cze_party_leader",
                        "label": "Party Leader",
                        "parent": 56,
                        "precedence": 395,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 502
                    },
                    "cze_president": {
                        "key": "cze_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 490
                    },
                    "cze_prime_minister": {
                        "key": "cze_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 491
                    },
                    "cze_senator": {
                        "key": "cze_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 498
                    },
                    "cze_staff": {
                        "key": "cze_staff",
                        "label": "Staffer",
                        "parent": 23,
                        "precedence": 395,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 503
                    },
                    "cze_state_secretary": {
                        "key": "cze_state_secretary",
                        "label": "State Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [238],
                        "show_in_quicksearch": false,
                        "supported_regions": [238],
                        "value": 494
                    },
                    "den_parl_member": {
                        "key": "den_parl_member",
                        "label": "Member of the Danish Parliament",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [217],
                        "show_in_quicksearch": false,
                        "supported_regions": [217],
                        "value": 543
                    },
                    "deputy_editor": {
                        "key": "deputy_editor",
                        "label": "Deputy Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 261
                    },
                    "deputy_managing_editor": {
                        "key": "deputy_managing_editor",
                        "label": "Deputy Managing Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 262
                    },
                    "desk": {
                        "key": "desk",
                        "label": "Desk",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 373
                    },
                    "desk_contact": {
                        "key": "desk_contact",
                        "label": "Desk Contact",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 263
                    },
                    "desk_editor": {
                        "key": "desk_editor",
                        "label": "Desk Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 264
                    },
                    "deu_cabinet_minister": {
                        "key": "deu_cabinet_minister",
                        "label": "Cabinet Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 65
                    },
                    "deu_federal_chancellor": {
                        "key": "deu_federal_chancellor",
                        "label": "Federal Chancellor",
                        "parent": 1,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 64
                    },
                    "deu_federal_president": {
                        "key": "deu_federal_president",
                        "label": "Federal President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 63
                    },
                    "deu_judge": {
                        "key": "deu_judge",
                        "label": "Judge",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 68
                    },
                    "deu_lay_judge": {
                        "key": "deu_lay_judge",
                        "label": "Lay Judge",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 69
                    },
                    "deu_member_bundesrag": {
                        "key": "deu_member_bundesrag",
                        "label": "Member of Bundesrag",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 66
                    },
                    "deu_member_bundestag": {
                        "key": "deu_member_bundestag",
                        "label": "Member of Bundestag",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 67
                    },
                    "deu_minister_president": {
                        "key": "deu_minister_president",
                        "label": "Minister-President",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 70
                    },
                    "deu_parliamentary_state_secretary": {
                        "key": "deu_parliamentary_state_secretary",
                        "label": "Parliamentary State Secretary",
                        "parent": 6,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 207
                    },
                    "deu_state_secretary": {
                        "key": "deu_state_secretary",
                        "label": "State Secretary",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 206
                    },
                    "director": {
                        "key": "director",
                        "label": "Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 312
                    },
                    "disc_jockey": {
                        "key": "disc_jockey",
                        "label": "Disc Jockey",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 265
                    },
                    "dom_deputy": {
                        "key": "dom_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 470
                    },
                    "dom_director": {
                        "key": "dom_director",
                        "label": "Director",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 472
                    },
                    "dom_executive_branch_member": {
                        "key": "dom_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 473
                    },
                    "dom_minister": {
                        "key": "dom_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 471
                    },
                    "dom_president": {
                        "key": "dom_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 467
                    },
                    "dom_senator": {
                        "key": "dom_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 469
                    },
                    "dom_vice_president": {
                        "key": "dom_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [235],
                        "show_in_quicksearch": false,
                        "supported_regions": [235],
                        "value": 468
                    },
                    "due_member_landtag": {
                        "key": "due_member_landtag",
                        "label": "Member of Landtag",
                        "parent": 20,
                        "precedence": 265,
                        "rank": 1000,
                        "regions": [203],
                        "show_in_quicksearch": false,
                        "supported_regions": [203],
                        "value": 71
                    },
                    "editor": {
                        "key": "editor",
                        "label": "Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 266
                    },
                    "editor_at_large": {
                        "key": "editor_at_large",
                        "label": "Editor-at-large",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 268
                    },
                    "editor_emeritus": {
                        "key": "editor_emeritus",
                        "label": "Editor Emeritus",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 267
                    },
                    "editor_in_chief": {
                        "key": "editor_in_chief",
                        "label": "Editor-in-chief",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 269
                    },
                    "editorial_assistant": {
                        "key": "editorial_assistant",
                        "label": "Editorial Assistant",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 270
                    },
                    "editorial_director": {
                        "key": "editorial_director",
                        "label": "Editorial Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 271
                    },
                    "editorial_head": {
                        "key": "editorial_head",
                        "label": "Editorial Head",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 272
                    },
                    "esp_deputy": {
                        "key": "esp_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 154
                    },
                    "esp_deputy_prime_minister": {
                        "key": "esp_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 210
                    },
                    "esp_minister": {
                        "key": "esp_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 151
                    },
                    "esp_monarch": {
                        "key": "esp_monarch",
                        "label": "Monarch",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 149
                    },
                    "esp_prime_minister": {
                        "key": "esp_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 150
                    },
                    "esp_secretary_of_state": {
                        "key": "esp_secretary_of_state",
                        "label": "Secretary of State",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 152
                    },
                    "esp_senator": {
                        "key": "esp_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 153
                    },
                    "esp_top_level_judge": {
                        "key": "esp_top_level_judge",
                        "label": "Judge",
                        "parent": 21,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [211],
                        "show_in_quicksearch": false,
                        "supported_regions": [211],
                        "value": 155
                    },
                    "eu_agency_committee_members": {
                        "key": "eu_agency_committee_members",
                        "label": "Committee Member",
                        "order": 35,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 366
                    },
                    "eu_agency_executive": {
                        "key": "eu_agency_executive",
                        "label": "Executive",
                        "order": 9,
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 362
                    },
                    "eu_agency_management": {
                        "key": "eu_agency_management",
                        "label": "Management",
                        "order": 10,
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 363
                    },
                    "eu_agency_press_contacts": {
                        "key": "eu_agency_press_contacts",
                        "label": "Press Contact",
                        "order": 37,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 368
                    },
                    "eu_agency_staff": {
                        "key": "eu_agency_staff",
                        "label": "Staff",
                        "order": 38,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 369
                    },
                    "eu_agency_stakeholder_group_member": {
                        "key": "eu_agency_stakeholder_group_member",
                        "label": "Stakeholder Group Member",
                        "order": 36,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 367
                    },
                    "eu_com_advisory_board_chair": {
                        "description": "\n            This position-type includes only the Chair of the 2 advisory bodies within\n            the European Commission: Regulatory Scrutiny Board and European Fiscal Board (EFB)\n        ",
                        "key": "eu_com_advisory_board_chair",
                        "label": "Advisory Board Chair",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 529
                    },
                    "eu_com_advisory_board_member": {
                        "description": "\n            This position-type includes only the Members of the 2 advisory bodies within\n            the European Commission: Regulatory Scrutiny Board and European Fiscal Board (EFB)\n        ",
                        "key": "eu_com_advisory_board_member",
                        "label": "Advisory Board Member",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 530
                    },
                    "eu_com_cabinet_staff": {
                        "description": "wiw",
                        "key": "eu_com_cabinet_staff",
                        "label": "Commissioner Cabinet",
                        "order": 11,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 106,
                        "supported_regions": [106],
                        "value": 45
                    },
                    "eu_com_desk_officer": {
                        "key": "eu_com_desk_officer",
                        "label": "Desk Officer",
                        "order": 16,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 364
                    },
                    "eu_com_dg_director": {
                        "description": "\n            Directors report to the Directors-General, and are accountable for the management of\n            financial and human resources within their Directorates.\n        ",
                        "key": "eu_com_dg_director",
                        "label": "Director",
                        "order": 14,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 325
                    },
                    "eu_com_dg_headofunit": {
                        "description": "\n            Heads of Unit are the equivalent of the line managers of the\n            Commission - they are crucial in the effective delivery of the Commission's\n            political priorities.\n        ",
                        "key": "eu_com_dg_headofunit",
                        "label": "Head of Unit",
                        "order": 15,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 326
                    },
                    "eu_com_dg_press_and_communication_officers": {
                        "description": "\n            Press Contacts inside the Commission include the Spokespersons' Service (spokesperson's + press\n            officers of the EU Commission) and the Press Officers in the National\n            EC Representations\n        ",
                        "key": "eu_com_dg_press_and_communication_officers",
                        "label": "Press and Communication Contact",
                        "order": 17,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 327
                    },
                    "eu_com_director_general": {
                        "description": "\n            The Commission is divided into policy departments - these are known as\n            Directorates-Generals (DGs), which are responsible for different policy areas, and are led\n            by 1 Director General\n        ",
                        "key": "eu_com_director_general",
                        "label": "Director General",
                        "order": 13,
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 324
                    },
                    "eu_com_secretariat": {
                        "description": "\n            The Secretariat-General supports the whole Commission, and is responsible for the overall\n            coherence of the Commission's work - in shaping new policies and in\n            steering them though the other EU institutions\n        ",
                        "key": "eu_com_secretariat",
                        "label": "Commission Secretariat General",
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 323
                    },
                    "eu_com_secretariat_staff": {
                        "key": "eu_com_secretariat_staff",
                        "label": "Commission Secretariat",
                        "order": 12,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 370
                    },
                    "eu_com_sg_director": {
                        "description": "\n            This person-type includes the Directors and Deputy Directors which are heads of\n            the Directorates (Sub-org) in the Secretariat General Organization\n        ",
                        "key": "eu_com_sg_director",
                        "label": "Secretariat-General Director",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 527
                    },
                    "eu_com_sg_headofunit": {
                        "description": "\n            This person-type includes the Heads of Units which fall under the Directorate\n            of the Secretariat-General of the EU Commission\n        ",
                        "key": "eu_com_sg_headofunit",
                        "label": "Secretariat-General Head of Unit",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 528
                    },
                    "eu_com_sg_leadership": {
                        "description": "This position includes the following titles: Secretary-General and Deputy Secretary-General",
                        "key": "eu_com_sg_leadership",
                        "label": "Secretariat-General Leadership",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 526
                    },
                    "eu_com_staff": {
                        "description": "wiw",
                        "key": "eu_com_staff",
                        "label": "Commission Staff",
                        "order": 18,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 107,
                        "supported_regions": [106],
                        "value": 46
                    },
                    "eu_commissioner": {
                        "description": "wiw",
                        "key": "eu_commissioner",
                        "label": "Commissioner",
                        "order": 1,
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 25,
                        "supported_regions": [106],
                        "unique_identifier": "EU_COMM",
                        "value": 34
                    },
                    "eu_committee_secretariat": {
                        "description": "wiw",
                        "key": "eu_committee_secretariat",
                        "label": "Committee Secretariat",
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 103,
                        "supported_regions": [106],
                        "value": 42
                    },
                    "eu_consil_cabinet_staff": {
                        "description": "wiw",
                        "key": "eu_consil_cabinet_staff",
                        "label": "Council President Cabinet Staff",
                        "order": 30,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 108,
                        "supported_regions": [106],
                        "value": 47
                    },
                    "eu_council_director": {
                        "description": "\n            This person-type includes the heads of Directorates known as \"Directors\" under the\n            Directorates-General\n        ",
                        "key": "eu_council_director",
                        "label": "Director",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 540
                    },
                    "eu_council_director_general": {
                        "description": "\n            This person-type includes the Directors-General in the General Secretariat of the Council\n            of the EU\n        ",
                        "key": "eu_council_director_general",
                        "label": "Director-General",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 539
                    },
                    "eu_council_head_of_unit": {
                        "description": "This person-type includes the heads of Units under the Directorates",
                        "key": "eu_council_head_of_unit",
                        "label": "Head of Unit",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 541
                    },
                    "eu_council_minister": {
                        "description": "wiw",
                        "key": "eu_council_minister",
                        "label": "Minister of the Council of the EU",
                        "order": 5,
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 27,
                        "supported_regions": [106],
                        "unique_identifier": "EU_CCMIN",
                        "value": 36
                    },
                    "eu_council_president": {
                        "description": "This person-type is for the President of the European Council",
                        "key": "eu_council_president",
                        "label": "EU Council President",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 525
                    },
                    "eu_council_press": {
                        "description": "\n            Contacts of the press services of the European Parliament, the President and\n            the Political Groups\n        ",
                        "key": "eu_council_press",
                        "label": "Press Contacts",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 537
                    },
                    "eu_council_press_contacts": {
                        "description": "\n            These Press Contacts work throughout the EU Council and the Council of\n            the EU.\n        ",
                        "key": "eu_council_press_contacts",
                        "label": "Press Contact",
                        "order": 33,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 330
                    },
                    "eu_council_secretariat": {
                        "description": "wiw",
                        "key": "eu_council_secretariat",
                        "label": "General Secretariat of the Council",
                        "order": 31,
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 109,
                        "supported_regions": [106],
                        "value": 48
                    },
                    "eu_council_secretary_general": {
                        "description": "This person-type is for the Secretary-General of the Council of the EU",
                        "key": "eu_council_secretary_general",
                        "label": "Secretary-General",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 538
                    },
                    "eu_councilmember": {
                        "description": "wiw",
                        "key": "eu_councilmember",
                        "label": "EU Council Member",
                        "order": 3,
                        "parent": 1,
                        "precedence": 190,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 26,
                        "supported_regions": [106],
                        "unique_identifier": "EU_CCMEM",
                        "value": 35
                    },
                    "eu_ep_cabinet_staff": {
                        "description": "\n            The President of the EU Parliament has its Cabinet that supports them\n            in their daily work.\n        ",
                        "key": "eu_ep_cabinet_staff",
                        "label": "President's Cabinet",
                        "order": 19,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 331
                    },
                    "eu_ep_press_contacts": {
                        "description": "\n            Contacts of the press services of the European Parliament, the President and\n            the Political Groups.\n        ",
                        "key": "eu_ep_press_contacts",
                        "label": "Press Contact",
                        "order": 28,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 332
                    },
                    "eu_ep_secretariat": {
                        "description": "wiw",
                        "key": "eu_ep_secretariat",
                        "label": "Parliament Secretariat",
                        "order": 20,
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 104,
                        "supported_regions": [106],
                        "value": 43
                    },
                    "eu_ep_staff": {
                        "key": "eu_ep_staff",
                        "label": "Parliament Staff",
                        "order": 29,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 333
                    },
                    "eu_mep": {
                        "description": "eu_parl",
                        "key": "eu_mep",
                        "label": "MEP",
                        "order": 2,
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 28,
                        "supported_regions": [106],
                        "unique_identifier": "EU_MEP",
                        "value": 37
                    },
                    "eu_mep_can": {
                        "description": "mep_candidates",
                        "key": "eu_mep_can",
                        "label": "MEP Candidate",
                        "parent": 28,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 38,
                        "supported_regions": [106],
                        "unique_identifier": "EU_MEP_CAN",
                        "value": 39
                    },
                    "eu_other_mep_staff": {
                        "description": "eu_parliament",
                        "key": "eu_other_mep_staff",
                        "label": "Other MEP Staff",
                        "parent": 23,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 105,
                        "supported_regions": [106],
                        "value": 44
                    },
                    "eu_other_orgs_exec": {
                        "key": "eu_other_orgs_exec",
                        "label": "Executive",
                        "order": 7,
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 360
                    },
                    "eu_other_orgs_main_officials": {
                        "description": "\n            The ECB is the central bank of the 19 European Union countries\n            which use the euro\n        ",
                        "key": "eu_other_orgs_main_officials",
                        "label": "Main EU Officials",
                        "parent": 10,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 334
                    },
                    "eu_other_orgs_management": {
                        "key": "eu_other_orgs_management",
                        "label": "Management",
                        "order": 8,
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 361
                    },
                    "eu_other_orgs_staff": {
                        "key": "eu_other_orgs_staff",
                        "label": "Staff",
                        "order": 34,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 365
                    },
                    "eu_parl_committee_leadership": {
                        "key": "eu_parl_committee_leadership",
                        "label": "Committee Leadership",
                        "order": 22,
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 335
                    },
                    "eu_parl_committee_staff": {
                        "key": "eu_parl_committee_staff",
                        "label": "Committee Staff",
                        "order": 23,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 338
                    },
                    "eu_parl_delegation_leadership": {
                        "key": "eu_parl_delegation_leadership",
                        "label": "Delegation Leadership",
                        "order": 24,
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 336
                    },
                    "eu_parl_delegation_staff": {
                        "key": "eu_parl_delegation_staff",
                        "label": "Delegation Staff",
                        "order": 25,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 339
                    },
                    "eu_parl_director": {
                        "description": "\n            This position includes only the title \"Director\" of the different units below\n            a DG\n        ",
                        "key": "eu_parl_director",
                        "label": "Director",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 533
                    },
                    "eu_parl_director_general": {
                        "description": "This position includes all the Director-General of the European Parliament DGs",
                        "key": "eu_parl_director_general",
                        "label": "Director-General",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 532
                    },
                    "eu_parl_governing_body_member": {
                        "key": "eu_parl_governing_body_member",
                        "label": "EU Parliament Governing Body Member",
                        "parent": 12,
                        "precedence": 400,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 523
                    },
                    "eu_parl_jurisconsult": {
                        "description": "This is the head of the Secretariat's Legal Service",
                        "key": "eu_parl_jurisconsult",
                        "label": "Jurisconsult of the European Parliament",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 534
                    },
                    "eu_parl_leadership": {
                        "key": "eu_parl_leadership",
                        "label": "EU Parliament Leadership",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 522
                    },
                    "eu_parl_political_group_leadership": {
                        "key": "eu_parl_political_group_leadership",
                        "label": "Political Group Leadership",
                        "order": 26,
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 337
                    },
                    "eu_parl_pres_cabinet_staff": {
                        "key": "eu_parl_pres_cabinet_staff",
                        "label": "President's Cabinet",
                        "parent": 24,
                        "precedence": 400,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 524
                    },
                    "eu_parl_sg_leadership": {
                        "description": "This position includes Secretary-General and Deputies Secretary-General",
                        "key": "eu_parl_sg_leadership",
                        "label": "Secretariat-General Leadership",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 531
                    },
                    "eu_parl_subcom_leadership": {
                        "description": "This position includes the Chair and Vice CHair of Subcommittees",
                        "key": "eu_parl_subcom_leadership",
                        "label": "Subcommittee Leadership",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 535
                    },
                    "eu_parl_subcom_staff": {
                        "description": "This position includes the Members and Substitute Members in Subcommittees",
                        "key": "eu_parl_subcom_staff",
                        "label": "Subcommittee Member",
                        "parent": 24,
                        "precedence": 400,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 536
                    },
                    "eu_parliamentary_assistant": {
                        "description": "eu_parliament",
                        "key": "eu_parliamentary_assistant",
                        "label": "Accredited Parliamentary Assistant",
                        "order": 21,
                        "parent": 23,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 101,
                        "supported_regions": [106],
                        "value": 40
                    },
                    "eu_perm_rep_staff": {
                        "description": "wiw",
                        "key": "eu_perm_rep_staff",
                        "label": "Permanent Representation Staff",
                        "parent": 24,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 110,
                        "supported_regions": [106],
                        "value": 49
                    },
                    "eu_permanent_representative": {
                        "description": "wiw",
                        "key": "eu_permanent_representative",
                        "label": "Permanent Representation",
                        "order": 6,
                        "parent": 24,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 30,
                        "supported_regions": [106],
                        "unique_identifier": "EU_PREP",
                        "value": 38
                    },
                    "eu_political_group_staff": {
                        "description": "wiw",
                        "key": "eu_political_group_staff",
                        "label": "Political Group Staff",
                        "order": 27,
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 102,
                        "supported_regions": [106],
                        "value": 41
                    },
                    "eu_rotating_presidency": {
                        "key": "eu_rotating_presidency",
                        "label": "Council Rotating Presidency",
                        "order": 4,
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 328
                    },
                    "eu_staff_council_minister": {
                        "key": "eu_staff_council_minister",
                        "label": "Staff of Minister of Council of the EU",
                        "order": 32,
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [106],
                        "show_in_quicksearch": false,
                        "supported_regions": [106],
                        "value": 329
                    },
                    "events_manager": {
                        "key": "events_manager",
                        "label": "Events Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 273
                    },
                    "exec_branch_member_minor": {
                        "key": "exec_branch_member_minor",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "show_in_quicksearch": false,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "value": 158
                    },
                    "executives": {
                        "key": "executives",
                        "label": "Executives",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 274
                    },
                    "features_editor": {
                        "key": "features_editor",
                        "label": "Features Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 275
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "sub_group": [
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Institutions",
                                    "values": [34, 522, 523, 37, 35, 328, 36, 38]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Other EU Governing Bodies",
                                    "values": [360, 361]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Agencies",
                                    "values": [362, 363]
                                }
                            ],
                            "title": "Officials",
                            "values": [34, 522, 523, 37, 35, 328, 36, 38, 360, 361, 362, 363]
                        },
                        {
                            "display": "list",
                            "sub_group": [
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Commission",
                                    "values": [45, 370, 324, 325, 326, 364, 327, 46]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Parliament",
                                    "values": [524, 43, 40, 335, 336, 337, 332, 333]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Council",
                                    "values": [47]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Council of the EU",
                                    "values": [48, 329, 330]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Other EU Governing Bodies",
                                    "values": [365]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Agencies",
                                    "values": [366, 367, 368, 369]
                                }
                            ],
                            "title": "Staff",
                            "values": [45, 370, 324, 325, 326, 364, 327, 46, 524, 43, 40, 335, 336, 337, 332, 333, 47, 48, 329, 330, 365, 366, 367, 368, 369]
                        },
                        {
                            "display": "list",
                            "title": "Legislative",
                            "values": [5, 6, 7, 8, 9, 199]
                        },
                        {
                            "display": "list",
                            "title": "Executive",
                            "values": [11, 12, 13, 14, 15, 16, 17, 21, 22, 186, 187, 571, 189, 572, 191, 193, 194, 196, 453, 198, 489, 504]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Legislative Staff",
                            "values": [30, 160]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Committee Staff",
                            "values": [32, 162]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Executive Staff",
                            "values": [163, 20]
                        },
                        {
                            "collapseGroup": true,
                            "display": "list",
                            "title": "Leadership Staff",
                            "values": [31, 161, 170, 171, 172, 173]
                        }
                    ],
                    "fra_chief_justice": {
                        "key": "fra_chief_justice",
                        "label": "Chief Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 78
                    },
                    "fra_deputy": {
                        "key": "fra_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 77
                    },
                    "fra_junior_minister": {
                        "key": "fra_junior_minister",
                        "label": "Junior Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 75
                    },
                    "fra_president": {
                        "key": "fra_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 72
                    },
                    "fra_prime_minister": {
                        "key": "fra_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 73
                    },
                    "fra_senator": {
                        "key": "fra_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 76
                    },
                    "fra_senior_minister": {
                        "key": "fra_senior_minister",
                        "label": "Senior Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [205],
                        "show_in_quicksearch": false,
                        "supported_regions": [205],
                        "value": 74
                    },
                    "freelance_journalist": {
                        "key": "freelance_journalist",
                        "label": "Freelance Journalist",
                        "parent": 43,
                        "precedence": 900,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 276
                    },
                    "gbr_civil_servant": {
                        "key": "gbr_civil_servant",
                        "label": "Civil Servant",
                        "parent": 6,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 92
                    },
                    "gbr_lord": {
                        "key": "gbr_lord",
                        "label": "Lord",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 93
                    },
                    "gbr_minister": {
                        "key": "gbr_minister",
                        "label": "Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 91
                    },
                    "gbr_monarch": {
                        "key": "gbr_monarch",
                        "label": "Monarch",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 88
                    },
                    "gbr_mp": {
                        "key": "gbr_mp",
                        "label": "Member of Parliament",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 94
                    },
                    "gbr_prime_minister": {
                        "key": "gbr_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 89
                    },
                    "gbr_secretary_of_state": {
                        "key": "gbr_secretary_of_state",
                        "label": "Secretary of State",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 90
                    },
                    "gbr_supreme_court_justice": {
                        "key": "gbr_supreme_court_justice",
                        "label": "Supreme Court Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [204],
                        "show_in_quicksearch": false,
                        "supported_regions": [204],
                        "value": 95
                    },
                    "general_manager": {
                        "key": "general_manager",
                        "label": "General Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 277
                    },
                    "grc_deputy_minister": {
                        "key": "grc_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 465
                    },
                    "grc_executive_branch_member": {
                        "key": "grc_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 466
                    },
                    "grc_member_of_hellenic_parliament": {
                        "key": "grc_member_of_hellenic_parliament",
                        "label": "Member of the Hellenic Parliament",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 463
                    },
                    "grc_minister": {
                        "key": "grc_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 464
                    },
                    "grc_president": {
                        "key": "grc_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 460
                    },
                    "grc_prime_minister": {
                        "key": "grc_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 461
                    },
                    "grc_vice_president": {
                        "key": "grc_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [234],
                        "show_in_quicksearch": false,
                        "supported_regions": [234],
                        "value": 462
                    },
                    "hkg_chief_executive": {
                        "key": "hkg_chief_executive",
                        "label": "Chief Executive ",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 389
                    },
                    "hkg_deputy_secretary": {
                        "key": "hkg_deputy_secretary",
                        "label": "Deputy Secretary",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 392
                    },
                    "hkg_executive_branch_member": {
                        "key": "hkg_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 393
                    },
                    "hkg_executive_council_member": {
                        "key": "hkg_executive_council_member",
                        "label": "Executive Council Member",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 390
                    },
                    "hkg_judge_of_the_court": {
                        "key": "hkg_judge_of_the_court",
                        "label": "Judge of the Court of Final Appeal",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 395
                    },
                    "hkg_judge_of_the_high_court": {
                        "key": "hkg_judge_of_the_high_court",
                        "label": "Judge of the High Court",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 396
                    },
                    "hkg_legislative_council_member": {
                        "key": "hkg_legislative_council_member",
                        "label": "Legislative Council Member",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 394
                    },
                    "hkg_permanent_secretary": {
                        "key": "hkg_permanent_secretary",
                        "label": "Permanent Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [227],
                        "show_in_quicksearch": false,
                        "supported_regions": [227],
                        "value": 391
                    },
                    "idn_rep": {
                        "key": "idn_rep",
                        "label": "Member of the House of Representatives",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [222],
                        "show_in_quicksearch": false,
                        "supported_regions": [222],
                        "value": 545
                    },
                    "idn_rep_council_member": {
                        "key": "idn_rep_council_member",
                        "label": "Member of the Regional Representative Council",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [222],
                        "show_in_quicksearch": false,
                        "supported_regions": [222],
                        "value": 544
                    },
                    "ind_cabinet_minister": {
                        "key": "ind_cabinet_minister",
                        "label": "Cabinet Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 126
                    },
                    "ind_chief_minister": {
                        "key": "ind_chief_minister",
                        "label": "Chief Minister",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 133
                    },
                    "ind_deputy_prime_minister": {
                        "key": "ind_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 125
                    },
                    "ind_governor": {
                        "key": "ind_governor",
                        "label": "Governor",
                        "parent": 14,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 131
                    },
                    "ind_high_court_justice": {
                        "key": "ind_high_court_justice",
                        "label": "High Court Chief Justice",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 135
                    },
                    "ind_lok_sabha": {
                        "key": "ind_lok_sabha",
                        "label": "Member of Parliament, Lok Sabha",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 128
                    },
                    "ind_lt_governor_administrator": {
                        "key": "ind_lt_governor_administrator",
                        "label": "Lt. Governor/Administrator",
                        "parent": 15,
                        "precedence": 305,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 132
                    },
                    "ind_minister_of_state": {
                        "key": "ind_minister_of_state",
                        "label": "Minister of State",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 129
                    },
                    "ind_president": {
                        "key": "ind_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 123
                    },
                    "ind_prime_minister": {
                        "key": "ind_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 124
                    },
                    "ind_rajya_sabha": {
                        "key": "ind_rajya_sabha",
                        "label": "Member of Parliament, Rajya Sabha",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 127
                    },
                    "ind_secretary": {
                        "key": "ind_secretary",
                        "label": "Secretary",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 130
                    },
                    "ind_supreme_court_justice": {
                        "key": "ind_supreme_court_justice",
                        "label": "Supreme Court Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [206],
                        "show_in_quicksearch": false,
                        "supported_regions": [206],
                        "value": 134
                    },
                    "irl_judge": {
                        "key": "irl_judge",
                        "label": "Judge",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 218
                    },
                    "irl_minister": {
                        "key": "irl_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 214
                    },
                    "irl_minister_of_state": {
                        "key": "irl_minister_of_state",
                        "label": "Minister of State",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 217
                    },
                    "irl_president": {
                        "key": "irl_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 211
                    },
                    "irl_senator": {
                        "key": "irl_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 215
                    },
                    "irl_tanaiste": {
                        "key": "irl_tanaiste",
                        "label": "Tanaiste",
                        "parent": 3,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 213
                    },
                    "irl_taoiseach": {
                        "key": "irl_taoiseach",
                        "label": "Taoiseach",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 212
                    },
                    "irl_td": {
                        "key": "irl_td",
                        "label": "TD",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [215],
                        "show_in_quicksearch": false,
                        "supported_regions": [215],
                        "value": 216
                    },
                    "isr_dep_prime_minister": {
                        "key": "isr_dep_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [240],
                        "show_in_quicksearch": false,
                        "supported_regions": [240],
                        "value": 558
                    },
                    "isr_knesset_member": {
                        "key": "isr_knesset_member",
                        "label": "Knesset Member",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [240],
                        "show_in_quicksearch": false,
                        "supported_regions": [240],
                        "value": 560
                    },
                    "isr_minister": {
                        "key": "isr_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [240],
                        "show_in_quicksearch": false,
                        "supported_regions": [240],
                        "value": 559
                    },
                    "isr_president": {
                        "key": "isr_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [240],
                        "show_in_quicksearch": false,
                        "supported_regions": [240],
                        "value": 556
                    },
                    "isr_prime_minister": {
                        "key": "isr_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [240],
                        "show_in_quicksearch": false,
                        "supported_regions": [240],
                        "value": 557
                    },
                    "ita_cabinet_minister": {
                        "key": "ita_cabinet_minister",
                        "label": "Cabinet Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 81
                    },
                    "ita_chief_justice": {
                        "key": "ita_chief_justice",
                        "label": "Chief Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 84
                    },
                    "ita_deputy": {
                        "key": "ita_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 83
                    },
                    "ita_president": {
                        "key": "ita_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 79
                    },
                    "ita_prime_minister": {
                        "key": "ita_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 80
                    },
                    "ita_regional_committee_president": {
                        "key": "ita_regional_committee_president",
                        "label": "President of Regional Committee",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 86
                    },
                    "ita_regional_councilmember": {
                        "key": "ita_regional_councilmember",
                        "label": "Regional Councilmember",
                        "parent": 20,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 87
                    },
                    "ita_regional_president": {
                        "key": "ita_regional_president",
                        "label": "Regional President",
                        "parent": 14,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 85
                    },
                    "ita_senator": {
                        "key": "ita_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 82
                    },
                    "ita_state_secretary": {
                        "key": "ita_state_secretary",
                        "label": "State Secretary",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 208
                    },
                    "ita_undersecretary": {
                        "key": "ita_undersecretary",
                        "label": "Undersecretary",
                        "parent": 6,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [207],
                        "show_in_quicksearch": false,
                        "supported_regions": [207],
                        "value": 209
                    },
                    "journalist": {
                        "key": "journalist",
                        "label": "Journalist",
                        "parent": 46,
                        "precedence": 1200,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 279
                    },
                    "jpn_council_member": {
                        "key": "jpn_council_member",
                        "label": "Member of the House of Councilors",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [210],
                        "show_in_quicksearch": false,
                        "supported_regions": [210],
                        "value": 546
                    },
                    "jpn_rep": {
                        "key": "jpn_rep",
                        "label": "Member of the House of Representatives",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [210],
                        "show_in_quicksearch": false,
                        "supported_regions": [210],
                        "value": 547
                    },
                    "kor_senator": {
                        "key": "kor_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [221],
                        "show_in_quicksearch": false,
                        "supported_regions": [221],
                        "value": 552
                    },
                    "manager": {
                        "key": "manager",
                        "label": "Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 280
                    },
                    "managing_director": {
                        "key": "managing_director",
                        "label": "Managing Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 281
                    },
                    "managing_editor": {
                        "key": "managing_editor",
                        "label": "Managing Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 282
                    },
                    "media_intern": {
                        "key": "media_intern",
                        "label": "Intern",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 278
                    },
                    "meteorologist": {
                        "key": "meteorologist",
                        "label": "Meteorologist",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 283
                    },
                    "mex_deputy": {
                        "key": "mex_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 55
                    },
                    "mex_deputy_secretary": {
                        "key": "mex_deputy_secretary",
                        "label": "Deputy Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 53
                    },
                    "mex_governor": {
                        "key": "mex_governor",
                        "label": "Governor",
                        "parent": 16,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 56
                    },
                    "mex_minister": {
                        "key": "mex_minister",
                        "label": "Minister",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 57
                    },
                    "mex_president": {
                        "key": "mex_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 50
                    },
                    "mex_secretary": {
                        "key": "mex_secretary",
                        "label": "Secretary",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 52
                    },
                    "mex_senator": {
                        "key": "mex_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 54
                    },
                    "mex_vice_president": {
                        "key": "mex_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [202],
                        "show_in_quicksearch": false,
                        "supported_regions": [202],
                        "value": 51
                    },
                    "mys_executive_branch_member": {
                        "key": "mys_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 402
                    },
                    "mys_head_of_government": {
                        "key": "mys_head_of_government",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 398
                    },
                    "mys_head_of_state": {
                        "key": "mys_head_of_state",
                        "label": "The King",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 397
                    },
                    "mys_lower_body_legislator": {
                        "key": "mys_lower_body_legislator",
                        "label": "Member of the House of Representatives",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 404
                    },
                    "mys_second_level_judge": {
                        "key": "mys_second_level_judge",
                        "label": "Second-Level Judge",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 406
                    },
                    "mys_second_level_minister": {
                        "key": "mys_second_level_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 400
                    },
                    "mys_third_level_minister": {
                        "key": "mys_third_level_minister",
                        "label": "Secretary General",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 401
                    },
                    "mys_top_level_judge": {
                        "key": "mys_top_level_judge",
                        "label": "Federal Court Judge",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 405
                    },
                    "mys_top_level_minister": {
                        "key": "mys_top_level_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 399
                    },
                    "mys_upper_body_legislator": {
                        "key": "mys_upper_body_legislator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [228],
                        "show_in_quicksearch": false,
                        "supported_regions": [228],
                        "value": 403
                    },
                    "news_assistant": {
                        "key": "news_assistant",
                        "label": "News Assistant",
                        "parent": 45,
                        "precedence": 1100,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 284
                    },
                    "nld_member": {
                        "key": "nld_member",
                        "label": "Member",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [219],
                        "show_in_quicksearch": false,
                        "supported_regions": [219],
                        "value": 549
                    },
                    "nld_senator": {
                        "key": "nld_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [219],
                        "show_in_quicksearch": false,
                        "supported_regions": [219],
                        "value": 548
                    },
                    "nzl_deputy_prime_minister": {
                        "key": "nzl_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 428
                    },
                    "nzl_executive_branch_member": {
                        "key": "nzl_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 432
                    },
                    "nzl_executive_council_member": {
                        "key": "nzl_executive_council_member",
                        "label": "Executive Council Member",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 429
                    },
                    "nzl_governor_general": {
                        "key": "nzl_governor_general",
                        "label": "Governor General ",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 426
                    },
                    "nzl_judge_of_court_of_appeal": {
                        "key": "nzl_judge_of_court_of_appeal",
                        "label": "Judge of the Court of Appeal ",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 436
                    },
                    "nzl_judge_of_supreme_court": {
                        "key": "nzl_judge_of_supreme_court",
                        "label": "Judge of the Supreme Court",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 435
                    },
                    "nzl_member_of_parliament": {
                        "key": "nzl_member_of_parliament",
                        "label": "Member of Parliament",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 434
                    },
                    "nzl_organization_staffer": {
                        "key": "nzl_organization_staffer",
                        "label": "Organization Staffer",
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 433
                    },
                    "nzl_parliamentary_under_secretary": {
                        "key": "nzl_parliamentary_under_secretary",
                        "label": "Parliamentary Under-Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 430
                    },
                    "nzl_prime_minister": {
                        "key": "nzl_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 427
                    },
                    "nzl_public_service_leader": {
                        "key": "nzl_public_service_leader",
                        "label": "Public Service Leader",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [231],
                        "show_in_quicksearch": false,
                        "supported_regions": [231],
                        "value": 431
                    },
                    "on_air_personality": {
                        "key": "on_air_personality",
                        "label": "On Air Personality",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 285
                    },
                    "opinion_editor": {
                        "key": "opinion_editor",
                        "label": "Opinion Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 286
                    },
                    "organization_staff_minor": {
                        "key": "organization_staff_minor",
                        "label": "Organization Staffer",
                        "parent": 24,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "value": 157
                    },
                    "other_minor_role_type": {
                        "key": "other_minor_role_type",
                        "label": "Other",
                        "parent": 1000,
                        "precedence": 10000,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 10000
                    },
                    "pan_deputy_minister": {
                        "key": "pan_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 478
                    },
                    "pan_executive_branch_member": {
                        "key": "pan_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 479
                    },
                    "pan_member_of_national_assembly": {
                        "key": "pan_member_of_national_assembly",
                        "label": "Member of the National Assembly",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 476
                    },
                    "pan_minister": {
                        "key": "pan_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 477
                    },
                    "pan_president": {
                        "key": "pan_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 474
                    },
                    "pan_vice_president": {
                        "key": "pan_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [236],
                        "show_in_quicksearch": false,
                        "supported_regions": [236],
                        "value": 475
                    },
                    "personal_staff_minor": {
                        "key": "personal_staff_minor",
                        "label": "Personal Staffer",
                        "parent": 23,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                        "value": 156
                    },
                    "phl_executive_branch_member": {
                        "key": "phl_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 412
                    },
                    "phl_house_member": {
                        "key": "phl_house_member",
                        "label": "House Member",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 414
                    },
                    "phl_judge": {
                        "key": "phl_judge",
                        "label": "Judge",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 416
                    },
                    "phl_president": {
                        "key": "phl_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 408
                    },
                    "phl_secretary": {
                        "key": "phl_secretary",
                        "label": "Secretary",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 410
                    },
                    "phl_senator": {
                        "key": "phl_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 413
                    },
                    "phl_supreme_court_justice": {
                        "key": "phl_supreme_court_justice",
                        "label": "Supreme Court Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 415
                    },
                    "phl_undersecretary": {
                        "key": "phl_undersecretary",
                        "label": "Undersecretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 411
                    },
                    "phl_vice_president": {
                        "key": "phl_vice_president",
                        "label": "Vice President ",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [229],
                        "show_in_quicksearch": false,
                        "supported_regions": [229],
                        "value": 409
                    },
                    "photo_editor": {
                        "key": "photo_editor",
                        "label": "Photo Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 287
                    },
                    "podcaster": {
                        "key": "podcaster",
                        "label": "Podcaster",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 372
                    },
                    "pol_deputy": {
                        "key": "pol_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [216],
                        "show_in_quicksearch": false,
                        "supported_regions": [216],
                        "value": 551
                    },
                    "pol_party_member": {
                        "description": "Member of a Political Party",
                        "key": "pol_party_member",
                        "label": "Political Party Member",
                        "parent": 29,
                        "precedence": 990,
                        "rank": 1000,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "show_in_quicksearch": false,
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240],
                        "value": 159
                    },
                    "pol_senator": {
                        "key": "pol_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [216],
                        "show_in_quicksearch": false,
                        "supported_regions": [216],
                        "value": 550
                    },
                    "producer": {
                        "key": "producer",
                        "label": "Producer",
                        "parent": 42,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 288
                    },
                    "production_assistant": {
                        "key": "production_assistant",
                        "label": "Production Assistant",
                        "parent": 45,
                        "precedence": 1100,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 289
                    },
                    "production_coordinator": {
                        "key": "production_coordinator",
                        "label": "Production Coordinator",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 290
                    },
                    "production_director": {
                        "key": "production_director",
                        "label": "Production Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 291
                    },
                    "program_director": {
                        "key": "program_director",
                        "label": "Program Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 292
                    },
                    "program_manager": {
                        "key": "program_manager",
                        "label": "Program Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 293
                    },
                    "public_affairs_director": {
                        "key": "public_affairs_director",
                        "label": "Public Affairs Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 294
                    },
                    "public_service_announcement_director": {
                        "key": "public_service_announcement_director",
                        "label": "Public Service Announcement Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 295
                    },
                    "publisher": {
                        "key": "publisher",
                        "label": "Publisher",
                        "parent": 44,
                        "precedence": 1000,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 296
                    },
                    "reporter": {
                        "key": "reporter",
                        "label": "Reporter",
                        "parent": 46,
                        "precedence": 1200,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 297
                    },
                    "research_assistant": {
                        "key": "research_assistant",
                        "label": "Research Assistant",
                        "parent": 45,
                        "precedence": 1100,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 298
                    },
                    "research_associate": {
                        "key": "research_associate",
                        "label": "Research Associate",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 299
                    },
                    "research_director": {
                        "key": "research_director",
                        "label": "Research Director",
                        "parent": 41,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 300
                    },
                    "research_manager": {
                        "key": "research_manager",
                        "label": "Research Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 301
                    },
                    "reviewer": {
                        "key": "reviewer",
                        "label": "Reviewer",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 302
                    },
                    "role_groups": {
                        "exec_staff": [163, 20],
                        "execs_all": [11, 12, 13, 14, 15, 16, 17, 21, 22, 186, 187, 571, 189, 572, 191, 193, 194, 196, 453, 198, 489, 504],
                        "execs_federal": [11, 12, 13, 14, 15, 16, 17, 489],
                        "execs_local": [198, 191, 186, 193, 187, 194, 189, 196, 504, 571, 572],
                        "execs_states": [21, 22, 453, 17],
                        "leg_staff": [30, 160],
                        "legislators_all": [5, 6, 7, 8, 9, 199],
                        "legislators_federal": [5, 6],
                        "legislators_local": [9, 199],
                        "legislators_states": [7, 8]
                    },
                    "rou_deputy": {
                        "key": "rou_deputy",
                        "label": "Deputy",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 488
                    },
                    "rou_deputy_prime_minister": {
                        "key": "rou_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 482
                    },
                    "rou_executive_branch_member": {
                        "key": "rou_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 486
                    },
                    "rou_minister": {
                        "key": "rou_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 483
                    },
                    "rou_president": {
                        "key": "rou_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 480
                    },
                    "rou_prime_minister": {
                        "key": "rou_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 481
                    },
                    "rou_secretary_of_state": {
                        "key": "rou_secretary_of_state",
                        "label": "Secretary of State",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 484
                    },
                    "rou_senator": {
                        "key": "rou_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 487
                    },
                    "rou_third_level_minister": {
                        "key": "rou_third_level_minister",
                        "label": "Third-Level Minister",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [237],
                        "show_in_quicksearch": false,
                        "supported_regions": [237],
                        "value": 485
                    },
                    "sau_council_member": {
                        "key": "sau_council_member",
                        "label": "Council Member",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [212],
                        "show_in_quicksearch": false,
                        "supported_regions": [212],
                        "value": 61
                    },
                    "sau_crown_prince": {
                        "key": "sau_crown_prince",
                        "label": "Crown Prince",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [212],
                        "show_in_quicksearch": false,
                        "supported_regions": [212],
                        "value": 59
                    },
                    "sau_king": {
                        "key": "sau_king",
                        "label": "King",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [212],
                        "show_in_quicksearch": false,
                        "supported_regions": [212],
                        "value": 58
                    },
                    "sau_minister": {
                        "key": "sau_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [212],
                        "show_in_quicksearch": false,
                        "supported_regions": [212],
                        "value": 60
                    },
                    "sau_qadi": {
                        "key": "sau_qadi",
                        "label": "Qadi",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [212],
                        "show_in_quicksearch": false,
                        "supported_regions": [212],
                        "value": 62
                    },
                    "school_board_assistant_superintendent": {
                        "key": "school_board_assistant_superintendent",
                        "label": "School Board Assistant Superintendent",
                        "order": 41,
                        "parent": 58,
                        "precedence": 910,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 572
                    },
                    "school_board_member": {
                        "key": "school_board_member",
                        "label": "School Board Member / Officer",
                        "order": 39,
                        "parent": 58,
                        "precedence": 920,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 504
                    },
                    "school_board_superintendent": {
                        "key": "school_board_superintendent",
                        "label": "School Board Superintendent",
                        "order": 40,
                        "parent": 58,
                        "precedence": 900,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 571
                    },
                    "scientist": {
                        "key": "scientist",
                        "label": "Scientist",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 303
                    },
                    "segment_producer": {
                        "key": "segment_producer",
                        "label": "Segment Producer",
                        "parent": 42,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 304
                    },
                    "sgp_deputy_prime_minister": {
                        "key": "sgp_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 317
                    },
                    "sgp_members_of_parliament": {
                        "key": "sgp_members_of_parliament",
                        "label": "Members of Parliament",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 321
                    },
                    "sgp_minister_and_council_member": {
                        "key": "sgp_minister_and_council_member",
                        "label": "Ministers and Council Members",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 318
                    },
                    "sgp_permanent_secretary": {
                        "key": "sgp_permanent_secretary",
                        "label": "Permanent Secretary",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 319
                    },
                    "sgp_president": {
                        "key": "sgp_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 315
                    },
                    "sgp_prime_minister": {
                        "key": "sgp_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 316
                    },
                    "sgp_senator": {
                        "key": "sgp_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 322
                    },
                    "sgp_senior_advisor": {
                        "key": "sgp_senior_advisor",
                        "label": "Senior Advisor",
                        "parent": 6,
                        "precedence": 170,
                        "rank": 1000,
                        "regions": [223],
                        "show_in_quicksearch": false,
                        "supported_regions": [223],
                        "value": 320
                    },
                    "sr_eu_correspondent": {
                        "key": "sr_eu_correspondent",
                        "label": "Senior European Correspondent",
                        "parent": 46,
                        "precedence": 1200,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 407
                    },
                    "staff_writer": {
                        "key": "staff_writer",
                        "label": "Staff Writer",
                        "parent": 43,
                        "precedence": 900,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 305
                    },
                    "station_manager": {
                        "key": "station_manager",
                        "label": "Station Manager",
                        "parent": 47,
                        "precedence": 1300,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 306
                    },
                    "sub_editor": {
                        "key": "sub_editor",
                        "label": "Sub Editor",
                        "parent": 40,
                        "precedence": 600,
                        "rank": 1000,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 307
                    },
                    "swe_parl_member": {
                        "key": "swe_parl_member",
                        "label": "Member of Parliament",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [218],
                        "show_in_quicksearch": false,
                        "supported_regions": [218],
                        "value": 553
                    },
                    "tha_rep": {
                        "key": "tha_rep",
                        "label": "Representative",
                        "parent": 12,
                        "precedence": 250,
                        "regions": [220],
                        "show_in_quicksearch": false,
                        "supported_regions": [220],
                        "value": 555
                    },
                    "tha_senator": {
                        "key": "tha_senator",
                        "label": "Senator",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [220],
                        "show_in_quicksearch": false,
                        "supported_regions": [220],
                        "value": 554
                    },
                    "tur_branch_member": {
                        "key": "tur_branch_member",
                        "label": "Branch Manager",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 518
                    },
                    "tur_chief_exec": {
                        "key": "tur_chief_exec",
                        "label": "Chief Executive ",
                        "parent": 5,
                        "precedence": 160,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 512
                    },
                    "tur_dep_chief_exec": {
                        "key": "tur_dep_chief_exec",
                        "label": "Deputy Chief Executive",
                        "parent": 5,
                        "precedence": 160,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 513
                    },
                    "tur_dep_dir_gen": {
                        "key": "tur_dep_dir_gen",
                        "label": "Deputy Director General",
                        "parent": 5,
                        "precedence": 160,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 511
                    },
                    "tur_dep_head_of_unit": {
                        "key": "tur_dep_head_of_unit",
                        "label": "Deputy Head of Unit",
                        "parent": 6,
                        "precedence": 170,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 516
                    },
                    "tur_dep_minister": {
                        "key": "tur_dep_minister",
                        "label": "Deputy Minister",
                        "parent": 4,
                        "precedence": 150,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 509
                    },
                    "tur_dir_gen": {
                        "key": "tur_dir_gen",
                        "label": "Director General",
                        "parent": 5,
                        "precedence": 160,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 510
                    },
                    "tur_director": {
                        "key": "tur_director",
                        "label": "Director",
                        "parent": 6,
                        "precedence": 170,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 517
                    },
                    "tur_head_of_department": {
                        "key": "tur_head_of_department",
                        "label": "Head of Department",
                        "parent": 6,
                        "precedence": 170,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 514
                    },
                    "tur_head_of_government": {
                        "key": "tur_head_of_government",
                        "label": "President",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 506
                    },
                    "tur_head_of_state": {
                        "key": "tur_head_of_state",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 505
                    },
                    "tur_head_of_unit": {
                        "key": "tur_head_of_unit",
                        "label": "Head of Unit",
                        "parent": 6,
                        "precedence": 170,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 515
                    },
                    "tur_leg_chamber_leader": {
                        "key": "tur_leg_chamber_leader",
                        "label": "Speaker / Vice-Speaker",
                        "parent": 54,
                        "precedence": 385,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 521
                    },
                    "tur_member_of_parl": {
                        "key": "tur_member_of_parl",
                        "label": "Member of Parliament",
                        "parent": 11,
                        "precedence": 200,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 520
                    },
                    "tur_minister": {
                        "key": "tur_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 508
                    },
                    "tur_supervisor": {
                        "key": "tur_supervisor",
                        "label": "Supervisor",
                        "parent": 10,
                        "precedence": 275,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 519
                    },
                    "tur_vice_president": {
                        "key": "tur_vice_president",
                        "label": "Vice President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [239],
                        "show_in_quicksearch": false,
                        "supported_regions": [239],
                        "value": 507
                    },
                    "twn_chief_judge": {
                        "key": "twn_chief_judge",
                        "label": "Chief Judge",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 358
                    },
                    "twn_executive_branch_member": {
                        "key": "twn_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 355
                    },
                    "twn_executive_yuan_deputy_minister": {
                        "key": "twn_executive_yuan_deputy_minister",
                        "label": "Executive Yuan Deputy Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 354
                    },
                    "twn_judicial_yuan_principal_officer_and_justice": {
                        "key": "twn_judicial_yuan_principal_officer_and_justice",
                        "label": "Judicial Yuan Principal Officer and Justice",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 357
                    },
                    "twn_legislator": {
                        "key": "twn_legislator",
                        "label": "Legislator",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 352
                    },
                    "twn_premier": {
                        "key": "twn_premier",
                        "label": "Premier",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 350
                    },
                    "twn_president": {
                        "key": "twn_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 349
                    },
                    "twn_state_executive": {
                        "key": "twn_state_executive",
                        "label": "State Executive",
                        "parent": 14,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 356
                    },
                    "twn_vice_president": {
                        "key": "twn_vice_president",
                        "label": "Vice-President",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 351
                    },
                    "twn_yuan_principal_officer": {
                        "key": "twn_yuan_principal_officer",
                        "label": "Yuan Principal Officer",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [225],
                        "show_in_quicksearch": false,
                        "supported_regions": [225],
                        "value": 353
                    },
                    "uae_chairman": {
                        "key": "uae_chairman",
                        "label": "Chairman / CEO",
                        "parent": 17,
                        "precedence": 300,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 570
                    },
                    "uae_council_member": {
                        "key": "uae_council_member",
                        "label": "Council Member",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 567
                    },
                    "uae_deputy_prime_minister": {
                        "key": "uae_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 564
                    },
                    "uae_deputy_ruler": {
                        "key": "uae_deputy_ruler",
                        "label": "Deputy Ruler",
                        "parent": 15,
                        "precedence": 255,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 569
                    },
                    "uae_minister": {
                        "key": "uae_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 565
                    },
                    "uae_minister_of_state": {
                        "key": "uae_minister_of_state",
                        "label": "Minister of State",
                        "parent": 5,
                        "precedence": 155,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 566
                    },
                    "uae_president": {
                        "key": "uae_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 561
                    },
                    "uae_prime_minister": {
                        "key": "uae_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 563
                    },
                    "uae_ruler": {
                        "key": "uae_ruler",
                        "label": "Ruler",
                        "parent": 16,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 568
                    },
                    "uae_vice_president": {
                        "key": "uae_vice_president",
                        "label": "Vice President",
                        "parent": 59,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [241],
                        "show_in_quicksearch": false,
                        "supported_regions": [241],
                        "value": 562
                    },
                    "us_ambassador": {
                        "key": "us_ambassador",
                        "label": "Ambassador",
                        "parent": 57,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 489
                    },
                    "us_assistant_secretary": {
                        "key": "us_assistant_secretary",
                        "kw_code": "ASSTSEC",
                        "label": "Assistant Secretary",
                        "order": 12,
                        "parent": 6,
                        "precedence": 305,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "ASSTSEC",
                        "value": 13
                    },
                    "us_county_legislator": {
                        "key": "us_county_legislator",
                        "kw_code": "MEM",
                        "label": "County Legislator",
                        "order": 5,
                        "parent": 26,
                        "precedence": 930,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 23,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "CL",
                        "value": 9
                    },
                    "us_dept_secretary": {
                        "key": "us_dept_secretary",
                        "kw_code": "SEC",
                        "label": "Department Secretary",
                        "order": 10,
                        "parent": 4,
                        "precedence": 150,
                        "rank": 18,
                        "regions": [1, 10000],
                        "show_in_quicksearch": true,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "SEC",
                        "value": 11
                    },
                    "us_deputy_assistant_secretary": {
                        "key": "us_deputy_assistant_secretary",
                        "kw_code": "DEPASSTSEC",
                        "label": "Deputy Assistant Secretary",
                        "order": 13,
                        "parent": 7,
                        "precedence": 310,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "DEPASSTSEC",
                        "value": 14
                    },
                    "us_deputy_secretary": {
                        "key": "us_deputy_secretary",
                        "kw_code": "DEPSEC",
                        "label": "Deputy Secretary",
                        "order": 11,
                        "parent": 5,
                        "precedence": 300,
                        "rank": 30,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "DEPSEC",
                        "value": 12
                    },
                    "us_deputy_under_secretary": {
                        "key": "us_deputy_under_secretary",
                        "kw_code": "DEPUNDSEC",
                        "label": "Deputy Under Secretary",
                        "order": 15,
                        "parent": 9,
                        "precedence": 320,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "DEPUNDSEC",
                        "value": 16
                    },
                    "us_ebm": {
                        "description": "\n            Individuals that work within the federal executive branch, could not be classified\n            into any other category and should have a high precedence.\n        ",
                        "key": "us_ebm",
                        "label": "Executive Member",
                        "parent": 10,
                        "precedence": 340,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 18
                    },
                    "us_fed_caucus_staff": {
                        "key": "us_fed_caucus_staff",
                        "label": "Federal Caucus Staff",
                        "parent": 24,
                        "precedence": 540,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 178
                    },
                    "us_fed_committee_staff": {
                        "key": "us_fed_committee_staff",
                        "label": "Federal Committee Staff",
                        "parent": 24,
                        "precedence": 520,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 3,
                        "supported_regions": [1, 10000],
                        "value": 32
                    },
                    "us_fed_exec_can_staff": {
                        "key": "us_fed_exec_can_staff",
                        "label": "Federal Executive Candidate Staff",
                        "parent": 24,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 166
                    },
                    "us_fed_exec_other": {
                        "description": "\n            Individuals that work within the federal executive branch, could not be classified\n            into any other category and should have a low precedence\n        ",
                        "key": "us_fed_exec_other",
                        "label": "Federal Executive Other",
                        "parent": 50,
                        "precedence": 990,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 313
                    },
                    "us_fed_exec_staff": {
                        "key": "us_fed_exec_staff",
                        "label": "Federal Executive Staff",
                        "parent": 24,
                        "precedence": 500,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 4,
                        "supported_regions": [1, 10000],
                        "value": 33
                    },
                    "us_fed_house_can": {
                        "key": "us_fed_house_can",
                        "label": "Candidate for US House of Representatives",
                        "parent": 28,
                        "precedence": 715,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 201
                    },
                    "us_fed_house_officer": {
                        "key": "us_fed_house_officer",
                        "label": "House Officer",
                        "parent": 12,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 176
                    },
                    "us_fed_jud_office_staff": {
                        "key": "us_fed_jud_office_staff",
                        "label": "Federal Judicial Office Staff",
                        "parent": 24,
                        "precedence": 520,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 170
                    },
                    "us_fed_leg_agency_member": {
                        "key": "us_fed_leg_agency_member",
                        "label": "Federal Legislative Agency Member",
                        "parent": 48,
                        "precedence": 345,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 310
                    },
                    "us_fed_leg_can_staff": {
                        "key": "us_fed_leg_can_staff",
                        "label": "Federal Legislative Candidate Staff",
                        "parent": 24,
                        "precedence": 810,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 168
                    },
                    "us_fed_leg_office_staff": {
                        "key": "us_fed_leg_office_staff",
                        "label": "Federal Legislative Office Staff",
                        "parent": 24,
                        "precedence": 520,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 172
                    },
                    "us_fed_member_staff": {
                        "key": "us_fed_member_staff",
                        "label": "Federal Member Staff",
                        "parent": 23,
                        "precedence": 505,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 1,
                        "supported_regions": [1, 10000],
                        "value": 30
                    },
                    "us_fed_officer_staff": {
                        "key": "us_fed_officer_staff",
                        "label": "Federal Legislative Officer Staff",
                        "parent": 23,
                        "precedence": 510,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "StafferType",
                        "source_enum_value": 2,
                        "supported_regions": [1, 10000],
                        "value": 31
                    },
                    "us_fed_panel_staff": {
                        "key": "us_fed_panel_staff",
                        "label": "Federal Panel Staff",
                        "parent": 24,
                        "precedence": 530,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 180
                    },
                    "us_fed_senate_can": {
                        "key": "us_fed_senate_can",
                        "label": "Candidate for US Senate",
                        "parent": 37,
                        "precedence": 710,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 164
                    },
                    "us_fed_senate_officer": {
                        "key": "us_fed_senate_officer",
                        "label": "Senate Officer",
                        "parent": 11,
                        "precedence": 270,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 174
                    },
                    "us_first_lady": {
                        "key": "us_first_lady",
                        "kw_code": "PRES02",
                        "label": "First Lady",
                        "parent": 10,
                        "precedence": 105,
                        "rank": 3,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 2
                    },
                    "us_governor": {
                        "key": "us_governor",
                        "kw_code": "GOVNR",
                        "label": "Governor",
                        "order": 7,
                        "parent": 16,
                        "precedence": 260,
                        "rank": 10,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": true,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "GOVNR",
                        "value": 21
                    },
                    "us_house_committee_leader": {
                        "key": "us_house_committee_leader",
                        "label": "House Committee Leader",
                        "parent": 55,
                        "precedence": 390,
                        "rank": 1000,
                        "regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 457
                    },
                    "us_house_leg_chamber_leader": {
                        "key": "us_house_leg_chamber_leader",
                        "label": "House Leader",
                        "parent": 54,
                        "precedence": 385,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 455
                    },
                    "us_house_party_leader": {
                        "key": "us_house_party_leader",
                        "label": "House Party Leader",
                        "parent": 56,
                        "precedence": 395,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 459
                    },
                    "us_local_county_admin": {
                        "key": "us_local_county_admin",
                        "kw_code": "ADMIN",
                        "label": "County Administrator",
                        "order": 19,
                        "parent": 25,
                        "precedence": 908,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 186
                    },
                    "us_local_county_chief_of_staff": {
                        "key": "us_local_county_chief_of_staff",
                        "kw_code": "COS",
                        "label": "County Chief of Staff",
                        "parent": 26,
                        "precedence": 940,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 190
                    },
                    "us_local_county_clerk": {
                        "key": "us_local_county_clerk",
                        "kw_code": "CLK",
                        "label": "County Clerk",
                        "order": 21,
                        "parent": 25,
                        "precedence": 915,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 187
                    },
                    "us_local_county_da": {
                        "key": "us_local_county_da",
                        "kw_code": "DA",
                        "label": "County District Attorney",
                        "parent": 35,
                        "precedence": 910,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 188
                    },
                    "us_local_county_executive": {
                        "key": "us_local_county_executive",
                        "kw_code": "CE",
                        "label": "County Executive",
                        "order": 17,
                        "parent": 25,
                        "precedence": 905,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 191
                    },
                    "us_local_county_leg_officer": {
                        "key": "us_local_county_leg_officer",
                        "label": "County Legislative Officer",
                        "parent": 26,
                        "precedence": 925,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 192
                    },
                    "us_local_county_sheriff": {
                        "key": "us_local_county_sheriff",
                        "kw_code": "SHER",
                        "label": "County Sheriff",
                        "order": 23,
                        "parent": 35,
                        "precedence": 920,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 189
                    },
                    "us_local_muni_admin": {
                        "key": "us_local_muni_admin",
                        "kw_code": "ADMIN",
                        "label": "City Administrator",
                        "order": 20,
                        "parent": 25,
                        "precedence": 958,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 193
                    },
                    "us_local_muni_chief_of_staff": {
                        "key": "us_local_muni_chief_of_staff",
                        "kw_code": "COS",
                        "label": "Municipal Chief of Staff",
                        "parent": 26,
                        "precedence": 990,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 197
                    },
                    "us_local_muni_clerk": {
                        "key": "us_local_muni_clerk",
                        "kw_code": "CLK",
                        "label": "City Clerk",
                        "order": 22,
                        "parent": 25,
                        "precedence": 965,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 194
                    },
                    "us_local_muni_da": {
                        "key": "us_local_muni_da",
                        "kw_code": "DA",
                        "label": "Municipal District Attorney",
                        "parent": 35,
                        "precedence": 960,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 195
                    },
                    "us_local_muni_leg_officer": {
                        "key": "us_local_muni_leg_officer",
                        "label": "Municipal Legislative Officer",
                        "parent": 26,
                        "precedence": 975,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 200
                    },
                    "us_local_muni_legislator": {
                        "key": "us_local_muni_legislator",
                        "kw_code": "MEM",
                        "label": "City Legislator",
                        "order": 6,
                        "parent": 26,
                        "precedence": 980,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 199
                    },
                    "us_local_muni_mayor": {
                        "key": "us_local_muni_mayor",
                        "kw_code": "CE",
                        "label": "City Mayor",
                        "order": 18,
                        "parent": 25,
                        "precedence": 955,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 198
                    },
                    "us_local_muni_sheriff": {
                        "key": "us_local_muni_sheriff",
                        "kw_code": "SHER",
                        "label": "City Police Chief",
                        "order": 24,
                        "parent": 35,
                        "precedence": 970,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 196
                    },
                    "us_local_municipal_executive": {
                        "key": "us_local_municipal_executive",
                        "label": "Municipal Executive",
                        "parent": 25,
                        "precedence": 910,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 308
                    },
                    "us_local_other": {
                        "description": "A catch all for local people",
                        "key": "us_local_other",
                        "label": "Local Other",
                        "parent": 25,
                        "precedence": 1200,
                        "rank": 1000,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 309
                    },
                    "us_lt_governor": {
                        "key": "us_lt_governor",
                        "kw_code": "LTGOV",
                        "label": "Lt. Governor",
                        "order": 8,
                        "parent": 17,
                        "precedence": 265,
                        "rank": 11,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "LTGOV",
                        "value": 22
                    },
                    "us_potus": {
                        "key": "us_potus",
                        "kw_code": "PRES01",
                        "label": "President of the United States",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1,
                        "regions": [1, 10000],
                        "show_in_quicksearch": true,
                        "supported_regions": [1, 10000],
                        "value": 1
                    },
                    "us_pres_can": {
                        "key": "us_pres_can",
                        "label": "Candidate for President",
                        "parent": 27,
                        "precedence": 700,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 19
                    },
                    "us_representative": {
                        "key": "us_representative",
                        "kw_code": "FH",
                        "label": "Representative",
                        "order": 2,
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 2,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FH",
                        "value": 6
                    },
                    "us_senate_committee_leader": {
                        "key": "us_senate_committee_leader",
                        "label": "Senate Committee Leader",
                        "parent": 55,
                        "precedence": 390,
                        "rank": 1000,
                        "regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 456
                    },
                    "us_senate_leg_chamber_leader": {
                        "key": "us_senate_leg_chamber_leader",
                        "label": "Senate Leader",
                        "parent": 54,
                        "precedence": 385,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 454
                    },
                    "us_senate_party_leader": {
                        "key": "us_senate_party_leader",
                        "label": "Senate Party Leader",
                        "parent": 56,
                        "precedence": 395,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 458
                    },
                    "us_senator": {
                        "key": "us_senator",
                        "kw_code": "FS",
                        "label": "Senator",
                        "order": 1,
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 1,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FS",
                        "value": 5
                    },
                    "us_sta_att_gen_can": {
                        "key": "us_sta_att_gen_can",
                        "label": "Candidate for State Attorney General",
                        "parent": 36,
                        "precedence": 770,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 219
                    },
                    "us_sta_attorney_general": {
                        "key": "us_sta_attorney_general",
                        "kw_code": "ATTYGEN",
                        "label": "Attorney General",
                        "order": 9,
                        "parent": 17,
                        "precedence": 380,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 453
                    },
                    "us_sta_caucus_staff": {
                        "key": "us_sta_caucus_staff",
                        "label": "State Caucus Staff",
                        "parent": 24,
                        "precedence": 590,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 179
                    },
                    "us_sta_committee_staff": {
                        "key": "us_sta_committee_staff",
                        "label": "State Committee Staff",
                        "parent": 24,
                        "precedence": 570,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 162
                    },
                    "us_sta_exec_can_staff": {
                        "key": "us_sta_exec_can_staff",
                        "label": "State Executive Candidate Staff",
                        "parent": 24,
                        "precedence": 850,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 167
                    },
                    "us_sta_exec_staff": {
                        "key": "us_sta_exec_staff",
                        "label": "State Executive Staff",
                        "parent": 24,
                        "precedence": 595,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 163
                    },
                    "us_sta_house_can": {
                        "key": "us_sta_house_can",
                        "label": "Candidate for State House",
                        "parent": 39,
                        "precedence": 765,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 202
                    },
                    "us_sta_jud_office_staff": {
                        "key": "us_sta_jud_office_staff",
                        "label": "State Judicial Office Staff",
                        "parent": 24,
                        "precedence": 570,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 171
                    },
                    "us_sta_leg_agency_member": {
                        "key": "us_sta_leg_agency_member",
                        "label": "State Legislative Agency Member",
                        "parent": 49,
                        "precedence": 445,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 311
                    },
                    "us_sta_leg_can_staff": {
                        "key": "us_sta_leg_can_staff",
                        "label": "State Legislative Candidate Staff",
                        "parent": 24,
                        "precedence": 860,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 169
                    },
                    "us_sta_leg_office_staff": {
                        "key": "us_sta_leg_office_staff",
                        "label": "State Legislative Office Staff",
                        "parent": 24,
                        "precedence": 570,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 173
                    },
                    "us_sta_lower_officer": {
                        "key": "us_sta_lower_officer",
                        "label": "State Lower Body Officer",
                        "parent": 19,
                        "precedence": 390,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 177
                    },
                    "us_sta_lt_gov_can": {
                        "key": "us_sta_lt_gov_can",
                        "label": "Candidate for Lt. Governor",
                        "parent": 36,
                        "precedence": 755,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 203
                    },
                    "us_sta_member_staff": {
                        "key": "us_sta_member_staff",
                        "label": "State Member Staff",
                        "parent": 23,
                        "precedence": 550,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 160
                    },
                    "us_sta_officer_staff": {
                        "key": "us_sta_officer_staff",
                        "label": "State Legislative Officer Staff",
                        "parent": 23,
                        "precedence": 560,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 161
                    },
                    "us_sta_other_exec_can": {
                        "key": "us_sta_other_exec_can",
                        "label": "Other State Executive Candidate",
                        "parent": 36,
                        "precedence": 780,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 204
                    },
                    "us_sta_panel_staff": {
                        "key": "us_sta_panel_staff",
                        "label": "State Panel Staff",
                        "parent": 24,
                        "precedence": 580,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 181
                    },
                    "us_sta_sec_state_can": {
                        "key": "us_sta_sec_state_can",
                        "label": "Candidate for State Secretary of State",
                        "parent": 36,
                        "precedence": 775,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 220
                    },
                    "us_sta_senate_can": {
                        "key": "us_sta_senate_can",
                        "label": "Candidate for State Senate",
                        "parent": 38,
                        "precedence": 760,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 165
                    },
                    "us_sta_upper_officer": {
                        "key": "us_sta_upper_officer",
                        "label": "State Upper Body Officer",
                        "parent": 18,
                        "precedence": 385,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 175
                    },
                    "us_state_assistant_secretary": {
                        "key": "us_state_assistant_secretary",
                        "kw_code": "ASSTSEC",
                        "label": "State Executive Assistant Secretary",
                        "parent": 31,
                        "precedence": 405,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 183
                    },
                    "us_state_department_secretary": {
                        "key": "us_state_department_secretary",
                        "label": "State Executive Department Secretary",
                        "parent": 17,
                        "precedence": 345,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 24
                    },
                    "us_state_deputy_assistant_secretary": {
                        "key": "us_state_deputy_assistant_secretary",
                        "kw_code": "DEPASSTSEC",
                        "label": "State Executive Deputy Assistant Secretary",
                        "parent": 32,
                        "precedence": 410,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 184
                    },
                    "us_state_deputy_secretary": {
                        "key": "us_state_deputy_secretary",
                        "kw_code": "DEPSEC",
                        "label": "State Executive Deputy Secretary",
                        "parent": 30,
                        "precedence": 400,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 182
                    },
                    "us_state_ebm": {
                        "description": "\n            Individuals that work within the state executive branch, could not be classified\n            into any other category and should have a high precedence.\n        ",
                        "key": "us_state_ebm",
                        "label": "State Executive Member",
                        "parent": 10,
                        "precedence": 440,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 20
                    },
                    "us_state_exec_other": {
                        "description": "\n            Individuals that work within the state executive branch, could not be classified\n            into any other category and should have a low precedence\n        ",
                        "key": "us_state_exec_other",
                        "label": "State Executive Other",
                        "parent": 51,
                        "precedence": 990,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 314
                    },
                    "us_state_gov_can": {
                        "key": "us_state_gov_can",
                        "label": "Candidate for Governor",
                        "parent": 36,
                        "precedence": 750,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 23
                    },
                    "us_state_parl": {
                        "key": "us_state_parl",
                        "label": "State Parliamentarian",
                        "parent": 53,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 374
                    },
                    "us_state_prot_officer": {
                        "key": "us_state_prot_officer",
                        "label": "State Protocol Officer",
                        "parent": 53,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 375
                    },
                    "us_state_rec": {
                        "key": "us_state_rec",
                        "label": "State Recorder",
                        "parent": 53,
                        "precedence": 800,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 376
                    },
                    "us_state_representative": {
                        "key": "us_state_representative",
                        "kw_code": "SH",
                        "label": "State Representative",
                        "order": 4,
                        "parent": 19,
                        "precedence": 375,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 6,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SH",
                        "value": 8
                    },
                    "us_state_senator": {
                        "key": "us_state_senator",
                        "kw_code": "SS",
                        "label": "State Senator",
                        "order": 3,
                        "parent": 18,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": "RoleType",
                        "source_enum_value": 5,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SS",
                        "value": 7
                    },
                    "us_state_under_secretary": {
                        "key": "us_state_under_secretary",
                        "kw_code": "UNDERSEC",
                        "label": "State Executive Under Secretary",
                        "parent": 33,
                        "precedence": 415,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 185
                    },
                    "us_treasurer": {
                        "key": "us_treasurer",
                        "kw_code": "TREAS",
                        "label": "Treasurer",
                        "order": 16,
                        "parent": 10,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "TREAS",
                        "value": 17
                    },
                    "us_under_secretary": {
                        "key": "us_under_secretary",
                        "kw_code": "UNDERSEC",
                        "label": "Under Secretary",
                        "order": 14,
                        "parent": 8,
                        "precedence": 315,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "UNDERSEC",
                        "value": 15
                    },
                    "us_vice_pres_can": {
                        "key": "us_vice_pres_can",
                        "label": "Candidate for Vice President",
                        "parent": 27,
                        "precedence": 705,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 205
                    },
                    "us_vpotus": {
                        "key": "us_vpotus",
                        "kw_code": "PRES03",
                        "label": "Vice President of the United States",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 2,
                        "regions": [1, 10000],
                        "show_in_quicksearch": true,
                        "supported_regions": [1, 10000],
                        "value": 3
                    },
                    "us_vpotus_spouse": {
                        "key": "us_vpotus_spouse",
                        "kw_code": "PRES04",
                        "label": "Spouse of the Vice President",
                        "parent": 10,
                        "precedence": 330,
                        "rank": 4,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "supported_regions": [1, 10000],
                        "value": 4
                    },
                    "vnm_cabinet_member": {
                        "key": "vnm_cabinet_member",
                        "label": "Cabinet Member",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 420
                    },
                    "vnm_delegate": {
                        "key": "vnm_delegate",
                        "label": "Delegate",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 423
                    },
                    "vnm_deputy_minister": {
                        "key": "vnm_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 160,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 421
                    },
                    "vnm_deputy_prime_minister": {
                        "key": "vnm_deputy_prime_minister",
                        "label": "Deputy Prime Minister",
                        "parent": 3,
                        "precedence": 115,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 419
                    },
                    "vnm_executive_branch_member": {
                        "key": "vnm_executive_branch_member",
                        "label": "Executive Branch Member",
                        "parent": 10,
                        "precedence": 275,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 422
                    },
                    "vnm_judge_of_high_court": {
                        "key": "vnm_judge_of_high_court",
                        "label": "Judge of the High Court",
                        "parent": 22,
                        "precedence": 360,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 425
                    },
                    "vnm_judge_of_supreme_peoples_court": {
                        "key": "vnm_judge_of_supreme_peoples_court",
                        "label": "Judge of the Supreme People's Court",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 424
                    },
                    "vnm_president": {
                        "key": "vnm_president",
                        "label": "President",
                        "parent": 1,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 417
                    },
                    "vnm_prime_minister": {
                        "key": "vnm_prime_minister",
                        "label": "Prime Minister",
                        "parent": 2,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [230],
                        "show_in_quicksearch": false,
                        "supported_regions": [230],
                        "value": 418
                    },
                    "zaf_delegate": {
                        "key": "zaf_delegate",
                        "label": "Delegate",
                        "parent": 11,
                        "precedence": 200,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 145
                    },
                    "zaf_deputy_minister": {
                        "key": "zaf_deputy_minister",
                        "label": "Deputy Minister",
                        "parent": 5,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 147
                    },
                    "zaf_deputy_president": {
                        "key": "zaf_deputy_president",
                        "label": "Deputy President",
                        "parent": 3,
                        "precedence": 110,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 143
                    },
                    "zaf_judge": {
                        "key": "zaf_judge",
                        "label": "Judge",
                        "parent": 21,
                        "precedence": 350,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 148
                    },
                    "zaf_member_national_assembly": {
                        "key": "zaf_member_national_assembly",
                        "label": "Member of the National Assembly",
                        "parent": 12,
                        "precedence": 250,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 146
                    },
                    "zaf_minister": {
                        "key": "zaf_minister",
                        "label": "Minister",
                        "parent": 4,
                        "precedence": 150,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 144
                    },
                    "zaf_president": {
                        "key": "zaf_president",
                        "label": "President",
                        "parent": 2,
                        "precedence": 100,
                        "rank": 1000,
                        "regions": [214],
                        "show_in_quicksearch": false,
                        "supported_regions": [214],
                        "value": 142
                    }
                },
                "NewMajorOrganizationType": {
                    "__is_enum": true,
                    "blog": {
                        "description": "A regularly updated website written informally",
                        "key": "blog",
                        "label": "Blog",
                        "parent": 13,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "BLOG",
                        "value": 80
                    },
                    "county_exec": {
                        "key": "county_exec",
                        "label": "County Executive",
                        "parent": 2,
                        "precedence": 30,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 18,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "CE",
                        "value": 31
                    },
                    "county_jud": {
                        "key": "county_jud",
                        "label": "County Judicial",
                        "parent": 3,
                        "precedence": 30,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 20,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "CJ",
                        "value": 33
                    },
                    "county_leg": {
                        "key": "county_leg",
                        "label": "County Legislative",
                        "parent": 1,
                        "precedence": 30,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 19,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "CL",
                        "value": 32
                    },
                    "county_location": {
                        "description": "A PublicOrganization representing a County",
                        "key": "county_location",
                        "label": "County",
                        "parent": 7,
                        "precedence": 29,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "COUNTYLOC",
                        "value": 96
                    },
                    "county_office": {
                        "description": "\n            An office operating under the jurisdiction of a county. Derived from KnowWho's\n            tblexeclegjudoffices.\n        ",
                        "key": "county_office",
                        "label": "County Office",
                        "parent": 7,
                        "precedence": 30,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "COFF",
                        "value": 39
                    },
                    "custom_org": {
                        "description": "A custom organization.",
                        "key": "custom_org",
                        "label": "Custom",
                        "parent": 10,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 129
                    },
                    "diplomatic_mission": {
                        "description": "\n            The set of diplomatic representatives operating in another country or multinational organization;\n            an umbrella organization for embassies and other ambassadorial offices.\n        ",
                        "key": "diplomatic_mission",
                        "label": "Diplomatic Mission",
                        "parent": 2,
                        "precedence": 15,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "DIPMISS",
                        "value": 93
                    },
                    "embassy": {
                        "description": "The primary office of one nation's diplomatic representatives residing in another country.",
                        "key": "embassy",
                        "label": "Embassy",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "EMBY",
                        "value": 92
                    },
                    "eu_agency_committees": {
                        "key": "eu_agency_committees",
                        "label": "Committees",
                        "parent": 9,
                        "precedence": 125,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 123
                    },
                    "eu_agency_directorate": {
                        "key": "eu_agency_directorate",
                        "label": "Directorates",
                        "parent": 9,
                        "precedence": 124,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 122
                    },
                    "eu_agency_governance": {
                        "key": "eu_agency_governance",
                        "label": "Governance",
                        "parent": 9,
                        "precedence": 123,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 121
                    },
                    "eu_agency_stakeholder_group": {
                        "key": "eu_agency_stakeholder_group",
                        "label": "Stakeholder Groups",
                        "parent": 9,
                        "precedence": 126,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 124
                    },
                    "eu_com_adv_body": {
                        "description": "Advisory Bodies within the European Commission",
                        "key": "eu_com_adv_body",
                        "label": "Advisory Body",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 144
                    },
                    "eu_com_adv_body_secr_efb": {
                        "description": "The Secretariat of the European Fiscal Board within the European Commission",
                        "key": "eu_com_adv_body_secr_efb",
                        "label": "Secretariat of the European Fiscal Board",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 145
                    },
                    "eu_com_cabinets": {
                        "key": "eu_com_cabinets",
                        "label": "Cabinets of Commissioners",
                        "parent": 2,
                        "precedence": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 99
                    },
                    "eu_com_dg_directorate": {
                        "description": "Directorates under the Directorates General in the EU Commission",
                        "key": "eu_com_dg_directorate",
                        "label": "Directorate",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 141
                    },
                    "eu_com_dg_service": {
                        "description": "Services of the EU Commission",
                        "key": "eu_com_dg_service",
                        "label": "Service",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 143
                    },
                    "eu_com_dg_unit": {
                        "description": "Unit under the Directorate of the EU Commission's Directorates General",
                        "key": "eu_com_dg_unit",
                        "label": "Unit",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 142
                    },
                    "eu_com_divisions": {
                        "key": "eu_com_divisions",
                        "label": "Other Division",
                        "parent": 2,
                        "precedence": 4,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 100
                    },
                    "eu_com_sec_general": {
                        "key": "eu_com_sec_general",
                        "label": "Secretariat General",
                        "parent": 2,
                        "precedence": 1,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 116
                    },
                    "eu_com_sg_directorate": {
                        "description": "Directorate under the EU Commission's Secretariat General",
                        "key": "eu_com_sg_directorate",
                        "label": "Secretariat General Directorate",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 139
                    },
                    "eu_com_sg_unit": {
                        "description": "Unit under the Directorate of the EU Commission's Secretariat General",
                        "key": "eu_com_sg_unit",
                        "label": "Secretariat General Unit",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 140
                    },
                    "eu_council_config": {
                        "key": "eu_council_config",
                        "label": "Council Configuration",
                        "parent": 1,
                        "precedence": 5,
                        "regions": [106],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 27,
                        "supported_regions": [106],
                        "unique_identifier": "CC",
                        "value": 29
                    },
                    "eu_council_dg": {
                        "description": "Directorates General in the Council of the EU",
                        "key": "eu_council_dg",
                        "label": "Directorate-General",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 147
                    },
                    "eu_council_dg_directorate": {
                        "description": "\n            Directorates are the sub-orgs under the Directorates General in the Council of\n            the EU\n        ",
                        "key": "eu_council_dg_directorate",
                        "label": "Directorate",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 148
                    },
                    "eu_council_dg_unit": {
                        "description": "\n            Units are the child organizations under the Directorates in the Directorates General\n            of the Council of the EU\n        ",
                        "key": "eu_council_dg_unit",
                        "label": "Unit",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 149
                    },
                    "eu_council_member_state": {
                        "description": "\n            There are 27 Member States in the EU. Each should be included\n            as an organization below the Council of the EU\n        ",
                        "key": "eu_council_member_state",
                        "label": "EU Member State",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 150
                    },
                    "eu_council_ministers": {
                        "key": "eu_council_ministers",
                        "label": "EU Member State Office",
                        "parent": 2,
                        "precedence": 19,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 114
                    },
                    "eu_council_prep": {
                        "key": "eu_council_prep",
                        "label": "Council Preparatory Body",
                        "parent": 1,
                        "precedence": 5,
                        "regions": [106],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 28,
                        "supported_regions": [106],
                        "unique_identifier": "CPB",
                        "value": 30
                    },
                    "eu_council_pres_cabinet": {
                        "key": "eu_council_pres_cabinet",
                        "label": "Cabinet of the President",
                        "parent": 2,
                        "precedence": 115,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 108
                    },
                    "eu_council_pres_cabinet_division": {
                        "description": "\n            This organization-type includes the different divisions in the Cabinet of the European\n            Council President\n        ",
                        "key": "eu_council_pres_cabinet_division",
                        "label": "Cabinet Division",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 146
                    },
                    "eu_council_sec_general": {
                        "key": "eu_council_sec_general",
                        "label": "Secretariat General",
                        "parent": 2,
                        "precedence": 17,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 115
                    },
                    "eu_dir_general": {
                        "key": "eu_dir_general",
                        "label": "Directorate General",
                        "parent": 2,
                        "precedence": 3,
                        "regions": [106],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 15,
                        "supported_regions": [106],
                        "unique_identifier": "DG",
                        "value": 28
                    },
                    "eu_ecb_directorates_and_divisions": {
                        "key": "eu_ecb_directorates_and_divisions",
                        "label": "Directorates and Divisions",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 112
                    },
                    "eu_ecb_executive": {
                        "key": "eu_ecb_executive",
                        "label": "Executive",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 111
                    },
                    "eu_exec_office": {
                        "description": "An office of a member of the EU executive branch",
                        "key": "eu_exec_office",
                        "label": "EU Executive Office",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [106],
                        "supported_regions": [106],
                        "unique_identifier": "EUEO",
                        "value": 50
                    },
                    "eu_general_institution": {
                        "description": "An EU institution not otherwise defined",
                        "key": "eu_general_institution",
                        "label": "EU General Institution",
                        "parent": 9,
                        "precedence": 10,
                        "regions": [106],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 13,
                        "supported_regions": [106],
                        "unique_identifier": "EUGI",
                        "value": 52
                    },
                    "eu_gov_representation": {
                        "description": "\n            27 Representatives of the Governments for each of the 27 Member States\n            of the European Union\n        ",
                        "key": "eu_gov_representation",
                        "label": "EU Government Representation",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 154
                    },
                    "eu_institution": {
                        "key": "eu_institution",
                        "label": "EU Institution",
                        "parent": 9,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 98
                    },
                    "eu_leg_office": {
                        "description": "An office of a member of the EU legislative branch",
                        "key": "eu_leg_office",
                        "label": "EU Legislative Office",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [106],
                        "supported_regions": [106],
                        "unique_identifier": "EULO",
                        "value": 51
                    },
                    "eu_mep_office": {
                        "key": "eu_mep_office",
                        "label": "MEP Office",
                        "parent": 1,
                        "precedence": 7,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 101
                    },
                    "eu_other_governing_bodies_departments": {
                        "key": "eu_other_governing_bodies_departments",
                        "label": "Departments",
                        "parent": 9,
                        "precedence": 21,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 120
                    },
                    "eu_other_governing_bodies_exec": {
                        "key": "eu_other_governing_bodies_exec",
                        "label": "Executive",
                        "parent": 9,
                        "precedence": 20,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 119
                    },
                    "eu_other_governing_bodies_subgroup": {
                        "key": "eu_other_governing_bodies_subgroup",
                        "label": "Sub-group",
                        "parent": 9,
                        "precedence": 22,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 125
                    },
                    "eu_parl_committees": {
                        "key": "eu_parl_committees",
                        "label": "Parliamentary Committee",
                        "parent": 1,
                        "precedence": 9,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 102
                    },
                    "eu_parl_delegations": {
                        "key": "eu_parl_delegations",
                        "label": "EU Joint Parliamentary Committees Delegation",
                        "parent": 1,
                        "precedence": 13,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 106
                    },
                    "eu_parl_dg": {
                        "description": "Directorates-General (DG) which are under the Secretariat of the European Parliament",
                        "key": "eu_parl_dg",
                        "label": "Directorate-General",
                        "parent": 1,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 136
                    },
                    "eu_parl_dg_directorate": {
                        "description": "Directorates which are under the Directorate General organizations",
                        "key": "eu_parl_dg_directorate",
                        "label": "Directorate",
                        "parent": 1,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 137
                    },
                    "eu_parl_governing_bodies": {
                        "key": "eu_parl_governing_bodies",
                        "label": "Governing Bodies",
                        "parent": 1,
                        "precedence": 6,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 113
                    },
                    "eu_parl_inquiry_committees": {
                        "key": "eu_parl_inquiry_committees",
                        "label": "Parliamentary Committees of Inquiry",
                        "parent": 1,
                        "precedence": 12,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 105
                    },
                    "eu_parl_interparl_delegations": {
                        "key": "eu_parl_interparl_delegations",
                        "label": "Interparliamentary Delegation",
                        "parent": 1,
                        "precedence": 14,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 107
                    },
                    "eu_parl_pres_cabinet": {
                        "key": "eu_parl_pres_cabinet",
                        "label": "President's Cabinet",
                        "parent": 1,
                        "precedence": 15,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 109
                    },
                    "eu_parl_service": {
                        "description": "Legal Service of the EU Parliament",
                        "key": "eu_parl_service",
                        "label": "Legal Service",
                        "parent": 1,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 138
                    },
                    "eu_parl_special_committees": {
                        "key": "eu_parl_special_committees",
                        "label": "Parliamentary Special Committee",
                        "parent": 1,
                        "precedence": 11,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 104
                    },
                    "eu_parl_subcommittees": {
                        "key": "eu_parl_subcommittees",
                        "label": "Parliamentary Subcommittee",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 103
                    },
                    "eu_perm_rep_department": {
                        "description": "Sub-orgs under th Permanent Representation organizations, which are separated by areas",
                        "key": "eu_perm_rep_department",
                        "label": "Permanent Representation Department",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 151
                    },
                    "eu_perm_rep_press": {
                        "description": "The Press departments in each of the 27 Permanent Representations",
                        "key": "eu_perm_rep_press",
                        "label": "Press Department",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 153
                    },
                    "eu_perm_rep_unit": {
                        "description": "Units under the Perm Rep Departments",
                        "key": "eu_perm_rep_unit",
                        "label": "Permanent Representation Unit",
                        "parent": 2,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 152
                    },
                    "eu_perm_reps": {
                        "key": "eu_perm_reps",
                        "label": "Permanent Representation",
                        "parent": 2,
                        "precedence": 18,
                        "regions": [106],
                        "supported_regions": [106],
                        "value": 110
                    },
                    "eu_sec_general": {
                        "key": "eu_sec_general",
                        "label": "Secretariat General",
                        "parent": 1,
                        "precedence": 5,
                        "regions": [106],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 14,
                        "supported_regions": [106],
                        "unique_identifier": "SG",
                        "value": 27
                    },
                    "exec_agency_1": {
                        "description": "\n            A ministry or agency that is contained within the Executive Branch of\n            a given country (for example, the French Ministry of the Economy, Industry,\n            and Employment)\n        ",
                        "key": "exec_agency_1",
                        "label": "Top Level Ministry/Agency",
                        "order": 7,
                        "parent": 2,
                        "precedence": 2,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [7],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB1",
                        "value": 8
                    },
                    "exec_agency_2": {
                        "description": "\n            A sub-organization within an Executive ministry / agency (for example, the French\n            Directorate-General of Customs and Indirect Taxes within the Ministry of the Economy,\n            Industry, and Employment).\n        ",
                        "key": "exec_agency_2",
                        "label": "Second-Level Ministry/Agency",
                        "order": 8,
                        "parent": 2,
                        "precedence": 3,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [8],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB2",
                        "value": 9
                    },
                    "exec_agency_3": {
                        "description": "\n            A sub-sub-organization within an Executive ministry / agency (for example, the Office\n            of Information and Communication within the French Directorate-General of Customs and Indirect\n            Taxes).\n        ",
                        "key": "exec_agency_3",
                        "label": "Third-Level Ministry/Agency",
                        "order": 9,
                        "parent": 2,
                        "precedence": 4,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [9],
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "EB3",
                        "value": 10
                    },
                    "exec_branch": {
                        "description": "\n            The Executive Branch of a specific country, including both the head of\n            government & staff and all ministries\n        ",
                        "key": "exec_branch",
                        "label": "Executive Branch",
                        "order": 5,
                        "parent": 2,
                        "precedence": 1,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "required_parent_type": [130],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 24,
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "EB",
                        "value": 7
                    },
                    "fed_campaign_office": {
                        "description": "A Sub Organization for a federal candidacy office",
                        "key": "fed_campaign_office",
                        "label": "Federal Campaign Office",
                        "parent": 6,
                        "precedence": 120,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FCAMPOF",
                        "value": 88
                    },
                    "fed_exec_agc": {
                        "key": "fed_exec_agc",
                        "kw_code": "FEA",
                        "label": "Federal Executive Agency",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [1, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 9,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FEA",
                        "value": 13
                    },
                    "fed_exec_candidacy": {
                        "description": "A candidacy for a federal-level elected office, e.g. 'Warren for President'.",
                        "key": "fed_exec_candidacy",
                        "label": "Federal Executive Candidacy",
                        "parent": 6,
                        "precedence": 100,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FECAND",
                        "value": 47
                    },
                    "fed_exec_dept": {
                        "key": "fed_exec_dept",
                        "kw_code": "FED",
                        "label": "Federal Executive Department",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [1, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 8,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FED",
                        "value": 12
                    },
                    "fed_exec_office": {
                        "key": "fed_exec_office",
                        "kw_code": "FEO",
                        "label": "Federal Executive Office",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [1, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 7,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FEO",
                        "value": 11
                    },
                    "fed_exec_personal_office": {
                        "description": "\n            An organization representing the conglomeration of all staffers working for a person\n            in their capacity as a federal executive. People grouped under these organizations\n            may work across multiple physical locations, e.g. capitol versus district office locations.\n        ",
                        "key": "fed_exec_personal_office",
                        "label": "Federal Executive's Personal Office",
                        "parent": 2,
                        "precedence": 100,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FEPOFF",
                        "value": 54
                    },
                    "fed_jud_office": {
                        "key": "fed_jud_office",
                        "kw_code": "FJO",
                        "label": "Federal Judicial Office",
                        "parent": 3,
                        "precedence": 23,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FJO",
                        "value": 37
                    },
                    "fed_leg_candidacy": {
                        "description": "\n            A candidacy for a seat in a federal legislative body, e.g. 'Lamar\n            Alexander for US Senate for Tennessee'.\n        ",
                        "key": "fed_leg_candidacy",
                        "label": "Federal Legislative Candidacy",
                        "parent": 6,
                        "precedence": 105,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FLCAND",
                        "value": 45
                    },
                    "fed_leg_leadership_office": {
                        "description": "\n            An office for a federal legislative officer, e.g. Speaker of the House\n            or House Majority Whip.\n        ",
                        "key": "fed_leg_leadership_office",
                        "label": "Federal Legislative Leadership Office",
                        "parent": 1,
                        "precedence": 7,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FLLEAD",
                        "value": 43
                    },
                    "fed_leg_office": {
                        "key": "fed_leg_office",
                        "kw_code": "FLO",
                        "label": "Federal Legislative Office",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [1, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 5,
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FLO",
                        "value": 5
                    },
                    "fed_leg_personal_office": {
                        "description": "\n            An organization representing the conglomeration of all staffers working for a person\n            in their capacity as a federal legislator. People grouped under these organizations\n            may work across multiple physical locations, e.g. capitol versus district office locations.\n        ",
                        "key": "fed_leg_personal_office",
                        "label": "Federal Legislator's Personal Office",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FLPOFF",
                        "value": 41
                    },
                    "fed_other_leg_org": {
                        "description": "\n            A federal legislative organization that does not fall under the other federal\n            legislative categories\n        ",
                        "key": "fed_other_leg_org",
                        "label": "Other Federal Legislative Organization",
                        "parent": 1,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "FOLO",
                        "value": 94
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "sub_group": [
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Commission",
                                    "values": [116, 99, 28, 100]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Parliament",
                                    "values": [109, 27, 113, 101, 21, 102, 103, 104, 105, 107]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "EU Council",
                                    "values": [108]
                                },
                                {
                                    "display": "list",
                                    "regions": "European Union",
                                    "title": "Council of the EU",
                                    "values": [115, 110, 114]
                                }
                            ],
                            "title": "Institutions",
                            "values": [116, 99, 28, 100, 109, 27, 113, 101, 21, 102, 103, 104, 105, 107, 108, 115, 110, 114]
                        },
                        {
                            "display": "list",
                            "title": "Other EU Governing Bodies",
                            "values": [119, 120, 125]
                        },
                        {
                            "display": "list",
                            "title": "EU Agencies",
                            "values": [121, 122, 123, 124]
                        },
                        {
                            "display": "list",
                            "title": "Organization Types",
                            "values": [130, 1, 3, 4, 7, 8, 9, 10, 20, 21, 131, 22, 23, 24, 25, 26, 134, 135]
                        }
                    ],
                    "forum": {
                        "description": "A news and education organization for trade industry",
                        "key": "forum",
                        "label": "Forum",
                        "parent": 14,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "FORUM",
                        "value": 83
                    },
                    "freelance_journalist_org": {
                        "description": "An organization representing freelance work",
                        "key": "freelance_journalist_org",
                        "label": "Freelance Journalist",
                        "parent": 15,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "FREE",
                        "value": 84
                    },
                    "government_org": {
                        "description": "An organization representing a government as a whole.",
                        "key": "government_org",
                        "label": "Government (all branches)",
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 1, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 1, 10000],
                        "value": 128
                    },
                    "i_member_office": {
                        "description": "An office of an International member",
                        "key": "i_member_office",
                        "label": "International Member Office",
                        "parent": 2,
                        "precedence": 10,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "IMO",
                        "value": 53
                    },
                    "internet_publication": {
                        "description": "A news publication published on the internet",
                        "key": "internet_publication",
                        "label": "Internet Publications",
                        "parent": 13,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "INTP",
                        "value": 81
                    },
                    "journal": {
                        "description": "\n            A newspaper or magazine that deals with a particular subject or professional\n            activity\n        ",
                        "key": "journal",
                        "label": "Journal",
                        "parent": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "JOURL",
                        "value": 59
                    },
                    "jud_1": {
                        "description": "\n            The highest levels of the judiciary in a specific country. In the\n            United States, this would be the Supreme Court.\n        ",
                        "key": "jud_1",
                        "label": "Top-Level Judiciary",
                        "order": 18,
                        "parent": 3,
                        "precedence": 21,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "required_parent_type": [17],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "JB1",
                        "value": 18
                    },
                    "jud_2": {
                        "description": "\n            The second level of the judiciary in a specific country. In the\n            United States, this would be the apellate courts.\n        ",
                        "key": "jud_2",
                        "label": "Second-Level Judiciary",
                        "order": 19,
                        "parent": 3,
                        "precedence": 22,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "required_parent_type": [17],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "JB2",
                        "value": 19
                    },
                    "jud_branch": {
                        "description": "The Judicial Branch of a country/government",
                        "key": "jud_branch",
                        "label": "Judicial Branch",
                        "order": 6,
                        "parent": 3,
                        "precedence": 20,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "required_parent_type": [130],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "JB",
                        "value": 17
                    },
                    "leg_branch": {
                        "description": "The national Legislative Branch of a country",
                        "key": "leg_branch",
                        "label": "Legislative Branch",
                        "order": 2,
                        "parent": 1,
                        "precedence": 1,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [130],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 2,
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "LB",
                        "value": 1
                    },
                    "leg_caucus": {
                        "description": "\n            A Congressional Member Organization in the U.S. legislative branch, distinct from a\n            committee.\n        ",
                        "key": "leg_caucus",
                        "label": "Legislative Caucus",
                        "parent": 1,
                        "precedence": 11,
                        "regions": [1, 10000],
                        "supported_regions": [1, 10000],
                        "unique_identifier": "CAU",
                        "value": 49
                    },
                    "leg_committee": {
                        "description": "A committee / group of legislators within a given country's legislature",
                        "key": "leg_committee",
                        "label": "Legislative Committee",
                        "order": 10,
                        "parent": 1,
                        "precedence": 10,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "required_parent_type": [3, 4, 25, 26],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "COM",
                        "value": 20
                    },
                    "local_library_system": {
                        "description": "A library or library system operating under a county or municipal jurisdiction.",
                        "key": "local_library_system",
                        "label": "Local Library System",
                        "parent": 2,
                        "precedence": 140,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "LOCLIB",
                        "value": 91
                    },
                    "lower_leg_body": {
                        "description": "The lower legislative body of a specific country (i.e. the French Assembly)",
                        "key": "lower_leg_body",
                        "label": "Lower Legislative Branch",
                        "order": 4,
                        "parent": 1,
                        "precedence": 5,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "required_parent_type": [1],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 4,
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "LLB",
                        "value": 4
                    },
                    "magazine": {
                        "description": "A periodical publication containing articles and illustrations",
                        "key": "magazine",
                        "label": "Magazine",
                        "parent": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "ZINE",
                        "value": 57
                    },
                    "major_charity_org": {
                        "description": "A non-profit organization",
                        "key": "major_charity_org",
                        "label": "Charity",
                        "parent": 18,
                        "precedence": 999,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "MJO",
                        "value": 132
                    },
                    "media_org_other": {
                        "description": "All other media organizations",
                        "key": "media_org_other",
                        "label": "Other Media",
                        "parent": 17,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "value": 118
                    },
                    "muni_exec": {
                        "key": "muni_exec",
                        "label": "Municipality Executive",
                        "parent": 2,
                        "precedence": 35,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 21,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "ME",
                        "value": 34
                    },
                    "muni_jud": {
                        "key": "muni_jud",
                        "label": "Municipality Judicial",
                        "parent": 3,
                        "precedence": 35,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 23,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "MJ",
                        "value": 36
                    },
                    "muni_leg": {
                        "key": "muni_leg",
                        "label": "Municipality Legislative",
                        "parent": 1,
                        "precedence": 35,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 22,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "ML",
                        "value": 35
                    },
                    "muni_office": {
                        "description": "\n            An office operating under the jurisdiction of a municipality. Derived from KnowWho's\n            tblexeclegjudoffices.\n        ",
                        "key": "muni_office",
                        "label": "Municipal Office",
                        "parent": 8,
                        "precedence": 35,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "MOFF",
                        "value": 40
                    },
                    "municipality_location": {
                        "description": "A PublicOrganization representing a Municipality",
                        "key": "municipality_location",
                        "label": "Municipality",
                        "parent": 8,
                        "precedence": 34,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "MUNICIPALITYLOC",
                        "value": 97
                    },
                    "nation_state_org": {
                        "description": "\n            This organization represents the entire government for a specific country (i.e. Government\n            of France).\n        ",
                        "key": "nation_state_org",
                        "label": "Nation State",
                        "order": 1,
                        "parent": 4,
                        "precedence": 0,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "NS",
                        "value": 130
                    },
                    "newsletter": {
                        "description": "\n            A bulletin issued periodically to the members of a society, business, or\n            organization\n        ",
                        "key": "newsletter",
                        "label": "Newsletter",
                        "parent": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "NEWSL",
                        "value": 58
                    },
                    "newspaper": {
                        "description": "A daily or weekly printed/online publication featuring articles, advertisements, and correspondance",
                        "key": "newspaper",
                        "label": "Newspaper",
                        "parent": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "NEWSP",
                        "value": 56
                    },
                    "newswire": {
                        "description": "\n            An electronically transmitted service providing up-to-the-minute news stories, financial market updates, and\n            other information\n        ",
                        "key": "newswire",
                        "label": "News Service/Wires",
                        "parent": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "NEWSW",
                        "value": 60
                    },
                    "online_news": {
                        "description": "An organization representing an online news source",
                        "key": "online_news",
                        "label": "Online News",
                        "parent": 13,
                        "precedence": 1000,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "ONNEWS",
                        "value": 126
                    },
                    "opposition_cabinet": {
                        "description": "The opposition of the PM/President Cabinet.",
                        "key": "opposition_cabinet",
                        "label": "Opposition Cabinet",
                        "order": 20,
                        "parent": 2,
                        "precedence": 116,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "OC",
                        "value": 134
                    },
                    "party": {
                        "description": "\n            An organized group of people who have the same ideology formed to\n            get themselves elected in the government\n        ",
                        "key": "party",
                        "label": "Political Party",
                        "order": 11,
                        "parent": 6,
                        "precedence": 8,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "required_parent_type": [130, 131],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "PP",
                        "value": 21
                    },
                    "podcast": {
                        "description": "Podcast",
                        "key": "podcast",
                        "label": "Podcast",
                        "parent": 12,
                        "precedence": 20,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "value": 117
                    },
                    "port_authority": {
                        "description": "\n            An organization administering and overseeing a ship or air port in a\n            region\n        ",
                        "key": "port_authority",
                        "label": "Port Authority",
                        "parent": 2,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "PORTAUTH",
                        "value": 87
                    },
                    "radio_am": {
                        "description": "A radio station on the AM frequency bandwidth",
                        "key": "radio_am",
                        "label": "AM Stations",
                        "parent": 12,
                        "precedence": 11,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADAM",
                        "value": 61
                    },
                    "radio_fm": {
                        "description": "A radio station on the FM frequency bandwidth",
                        "key": "radio_fm",
                        "label": "FM Stations",
                        "parent": 12,
                        "precedence": 12,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADFM",
                        "value": 62
                    },
                    "radio_local": {
                        "description": "A radio network/program covering/broadcast a local area",
                        "key": "radio_local",
                        "label": "Radio - Local Station Shows/Programs",
                        "parent": 12,
                        "precedence": 13,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADL",
                        "value": 63
                    },
                    "radio_network_company": {
                        "description": "A network radio company",
                        "key": "radio_network_company",
                        "label": "Radio Network Companies",
                        "parent": 12,
                        "precedence": 16,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADNC",
                        "value": 66
                    },
                    "radio_network_program": {
                        "description": "A network radio show/program",
                        "key": "radio_network_program",
                        "label": "Radio - Network Shows/Programs",
                        "parent": 12,
                        "precedence": 15,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADNP",
                        "value": 65
                    },
                    "radio_production_company": {
                        "description": "A radio production company",
                        "key": "radio_production_company",
                        "label": "Radio - Production Companies",
                        "parent": 12,
                        "precedence": 19,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADPC",
                        "value": 69
                    },
                    "radio_satellite_company": {
                        "description": "A satellite radio company",
                        "key": "radio_satellite_company",
                        "label": "Satellite Radio Companies",
                        "parent": 12,
                        "precedence": 18,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADSC",
                        "value": 68
                    },
                    "radio_satellite_program": {
                        "description": "A satellite radio show/program",
                        "key": "radio_satellite_program",
                        "label": "Satellite Radio Shows/Programs",
                        "parent": 12,
                        "precedence": 17,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADSP",
                        "value": 67
                    },
                    "radio_syndicated": {
                        "description": "A radio show/program licensed for many other stations",
                        "key": "radio_syndicated",
                        "label": "Radio - Syndicated Shows/Programs",
                        "parent": 12,
                        "precedence": 14,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RADSY",
                        "value": 64
                    },
                    "research_firm": {
                        "description": "A research or advisory organization",
                        "key": "research_firm",
                        "label": "Research Firm",
                        "parent": 14,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "RESRC",
                        "value": 82
                    },
                    "school_district_office": {
                        "description": "A U.S. Local School District's main office.",
                        "key": "school_district_office",
                        "label": "School District Office",
                        "parent": 2,
                        "precedence": 40,
                        "regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 37,
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "unique_identifier": "SDO",
                        "value": 133
                    },
                    "sta_campaign": {
                        "description": "A State Level Abstract Candidate Office",
                        "key": "sta_campaign",
                        "label": "State Level Campaign",
                        "parent": 6,
                        "precedence": 110,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SCAMP",
                        "value": 90
                    },
                    "sta_campaign_office": {
                        "description": "A Sub Organization for a state candidacy office",
                        "key": "sta_campaign_office",
                        "label": "State Campaign Office",
                        "parent": 6,
                        "precedence": 130,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SCAMPOF",
                        "value": 89
                    },
                    "sta_exec_agc": {
                        "key": "sta_exec_agc",
                        "kw_code": "SEA",
                        "label": "State Executive Agency",
                        "parent": 2,
                        "precedence": 15,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 12,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SEA",
                        "value": 16
                    },
                    "sta_exec_agency_1": {
                        "description": "\n            A ministry or agency that is contained within the Executive Branch of\n            a given state / province\n        ",
                        "key": "sta_exec_agency_1",
                        "label": "State Top-Level Ministry/Agency",
                        "order": 14,
                        "parent": 2,
                        "precedence": 26,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [22],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB1",
                        "value": 23
                    },
                    "sta_exec_branch": {
                        "description": "The executive branch of a sub-national state / province",
                        "key": "sta_exec_branch",
                        "label": "State Executive Branch",
                        "order": 13,
                        "parent": 2,
                        "precedence": 25,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [131],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 25,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SEB",
                        "value": 22
                    },
                    "sta_exec_candidacy": {
                        "description": "\n            A candidacy for a state-level elected office, e.g. 'Bill Toole for North\n            Carolina Lt. Governor'.\n        ",
                        "key": "sta_exec_candidacy",
                        "label": "State Executive Candidacy",
                        "parent": 6,
                        "precedence": 110,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SECAND",
                        "value": 48
                    },
                    "sta_exec_dept": {
                        "key": "sta_exec_dept",
                        "kw_code": "SED",
                        "label": "State Executive Department",
                        "parent": 2,
                        "precedence": 15,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 11,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SED",
                        "value": 15
                    },
                    "sta_exec_office": {
                        "key": "sta_exec_office",
                        "kw_code": "SEO",
                        "label": "State Executive Office",
                        "parent": 2,
                        "precedence": 15,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 10,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SEO",
                        "value": 14
                    },
                    "sta_exec_personal_office": {
                        "description": "\n            An organization representing the conglomeration of all staffers working for a person\n            in their capacity as a state executive. People grouped under these organizations\n            may work across multiple physical locations, e.g. capitol versus district office locations.\n        ",
                        "key": "sta_exec_personal_office",
                        "label": "State Executive's Personal Office",
                        "parent": 2,
                        "precedence": 100,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SEPOFF",
                        "value": 55
                    },
                    "sta_jud_office": {
                        "key": "sta_jud_office",
                        "kw_code": "SJO",
                        "label": "State Judicial Office",
                        "parent": 3,
                        "precedence": 29,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SJO",
                        "value": 38
                    },
                    "sta_leg_branch": {
                        "description": "The legislative branch of a state / province",
                        "key": "sta_leg_branch",
                        "label": "State Legislative Branch",
                        "order": 15,
                        "parent": 1,
                        "precedence": 25,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [131],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SLB",
                        "value": 24
                    },
                    "sta_leg_candidacy": {
                        "description": "\n            A candidacy for a seat in a state legislative body, e.g. 'Jim\n            Abeler for MN State Senate'.\n        ",
                        "key": "sta_leg_candidacy",
                        "label": "State Legislative Candidacy",
                        "parent": 6,
                        "precedence": 115,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SLCAND",
                        "value": 46
                    },
                    "sta_leg_leadership_office": {
                        "description": "\n            An office for a state legislative office, like the NC House Sergeant-At-Arms\n            or the NC House Republican Freshman Leader.\n        ",
                        "key": "sta_leg_leadership_office",
                        "label": "State Legislative Leadership Office",
                        "parent": 1,
                        "precedence": 7,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SLLEAD",
                        "value": 44
                    },
                    "sta_leg_office": {
                        "key": "sta_leg_office",
                        "kw_code": "SLO",
                        "label": "State Legislative Office",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 6,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SLO",
                        "value": 6
                    },
                    "sta_leg_personal_office": {
                        "description": "\n            An organization representing the conglomeration of all staffers working for a person\n            in their capacity as a state legislator. People grouped under these organizations\n            may work across multiple physical locations, e.g. capitol versus district office locations.\n        ",
                        "key": "sta_leg_personal_office",
                        "label": "State Legislator's Personal Office",
                        "parent": 1,
                        "precedence": 10,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SLPOFF",
                        "value": 42
                    },
                    "sta_lleg_branch": {
                        "description": "The lower legislative body of a state / province",
                        "key": "sta_lleg_branch",
                        "label": "State Lower Legislative Branch",
                        "order": 17,
                        "parent": 1,
                        "precedence": 27,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [24],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "LULB",
                        "value": 26
                    },
                    "sta_other_leg_org": {
                        "description": "\n            A state legislative organization that does not fall under the other state\n            legislative categores\n        ",
                        "key": "sta_other_leg_org",
                        "label": "Other State Legislative Organization",
                        "parent": 1,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": "SOLO",
                        "value": 95
                    },
                    "sta_uleg_branch": {
                        "description": "The upper legislative body of a state / province",
                        "key": "sta_uleg_branch",
                        "label": "State Upper Legislative Branch",
                        "order": 16,
                        "parent": 1,
                        "precedence": 27,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [24],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SULB",
                        "value": 25
                    },
                    "state_province_org": {
                        "description": "A sub-national state or province.",
                        "key": "state_province_org",
                        "label": "State / Province",
                        "order": 12,
                        "parent": 5,
                        "precedence": 1,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "required_parent_type": [130],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "STA",
                        "value": 131
                    },
                    "sub_national_opposition_cabinet": {
                        "description": "The opposition of the sub-national governors' Cabinet",
                        "key": "sub_national_opposition_cabinet",
                        "label": "Sub-national Opposition Cabinet",
                        "order": 21,
                        "parent": 2,
                        "precedence": 116,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "SOC",
                        "value": 135
                    },
                    "transcript_service": {
                        "description": "An organization representing a transcript service",
                        "key": "transcript_service",
                        "label": "Transcript Service",
                        "parent": 12,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TRANSSERV",
                        "value": 127
                    },
                    "transit_agency": {
                        "description": "An organization administering public transit within a region",
                        "key": "transit_agency",
                        "label": "Transit Agency",
                        "parent": 2,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "TRANSIT",
                        "value": 86
                    },
                    "tv_cable_company": {
                        "description": "A cable television company",
                        "key": "tv_cable_company",
                        "label": "Cable TV Companies",
                        "parent": 12,
                        "precedence": 6,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVCC",
                        "value": 75
                    },
                    "tv_cable_program": {
                        "description": "A cable television show/program",
                        "key": "tv_cable_program",
                        "label": "TV - Cable Shows/Programs",
                        "parent": 12,
                        "precedence": 5,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVCP",
                        "value": 74
                    },
                    "tv_local": {
                        "description": "A local television station show/program",
                        "key": "tv_local",
                        "label": "TV - Local Station Shows/Programs",
                        "parent": 12,
                        "precedence": 1,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVLP",
                        "value": 70
                    },
                    "tv_network_company": {
                        "description": "A network television company",
                        "key": "tv_network_company",
                        "label": "TV Network Companies",
                        "parent": 12,
                        "precedence": 4,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVNC",
                        "value": 73
                    },
                    "tv_network_program": {
                        "description": "A network television show/program",
                        "key": "tv_network_program",
                        "label": "TV - Network Shows/Programs",
                        "parent": 12,
                        "precedence": 3,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVNP",
                        "value": 72
                    },
                    "tv_production_company": {
                        "description": "A television production company",
                        "key": "tv_production_company",
                        "label": "TV - Production Companies",
                        "parent": 12,
                        "precedence": 9,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVPC",
                        "value": 78
                    },
                    "tv_satellite_company": {
                        "description": "A satellite television company",
                        "key": "tv_satellite_company",
                        "label": "Satellite TV Companies",
                        "parent": 12,
                        "precedence": 8,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVSC",
                        "value": 77
                    },
                    "tv_satellite_program": {
                        "description": "A satellite television show/program",
                        "key": "tv_satellite_program",
                        "label": "Satellite TV Shows/Programs",
                        "parent": 12,
                        "precedence": 7,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVSP",
                        "value": 76
                    },
                    "tv_station_other": {
                        "description": "A television station",
                        "key": "tv_station_other",
                        "label": "TV - Various Stations",
                        "parent": 12,
                        "precedence": 10,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVVS",
                        "value": 79
                    },
                    "tv_syndicated": {
                        "description": "A television show/program licensed for many other stations",
                        "key": "tv_syndicated",
                        "label": "TV - Syndicated Shows/Programs",
                        "parent": 12,
                        "precedence": 2,
                        "regions": [9999],
                        "supported_regions": [9999],
                        "unique_identifier": "TVSY",
                        "value": 71
                    },
                    "uni_leg_body": {
                        "description": "\n            The unicameral legislative body of a specific country (i.e. the Folketing, also\n            known as the Danish Parliament)\n        ",
                        "key": "uni_leg_body",
                        "label": "Unicameral Legislative Body",
                        "parent": 1,
                        "precedence": 5,
                        "regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "unique_identifier": "UNLB",
                        "value": 2
                    },
                    "upper_leg_body": {
                        "description": "The upper legislative body of a specific country (i.e. the French Senate)",
                        "key": "upper_leg_body",
                        "label": "Upper Legislative Branch",
                        "order": 3,
                        "parent": 1,
                        "precedence": 5,
                        "regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "required_parent_type": [1],
                        "source_enum_pot": "PublicOrganizationType",
                        "source_enum_value_pot": 3,
                        "supported_regions": [1, 10000, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                        "unique_identifier": "ULB",
                        "value": 3
                    },
                    "utility": {
                        "description": "An organization operating a public utility",
                        "key": "utility",
                        "label": "Public Utility",
                        "parent": 16,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "unique_identifier": "PUTIL",
                        "value": 85
                    }
                },
                "PersonBiographyRoleDataSource": {
                    "__is_enum": true,
                    "custom_from_client": { "description": "Data source directly from client", "key": "custom_from_client", "label": "Custom from Client", "profile_info_source": 17, "value": 24 },
                    "intrado_education": { "description": "The education details recieved from the IntradoParser", "key": "intrado_education", "label": "Intrado Parser Education Roles", "profile_info_source": 9, "value": 14 },
                    "intrado_experience": { "description": "The previous experience details recieved from the IntradoParser", "key": "intrado_experience", "label": "Intrado Parser Previous Experience Roles", "profile_info_source": 9, "value": 15 },
                    "kw_cm_tblpeopledirector": { "description": "An entry in the directorship table of KnowWho's local database.", "key": "kw_cm_tblpeopledirector", "label": "KnowWho countymuni.tblpeopledirector", "profile_info_source": 5, "value": 9 },
                    "kw_cm_tblpeopleeducation": { "description": "An entry in the educational history table of KnowWho's local database.", "key": "kw_cm_tblpeopleeducation", "label": "KnowWho countymuni.tblpeopleeducation", "profile_info_source": 5, "value": 8 },
                    "kw_cm_tblpeopleexperience": { "description": "An entry in the 'past history' table of KnowWho's local database.", "key": "kw_cm_tblpeopleexperience", "label": "KnowWho countymuni.tblpeopleexperience", "profile_info_source": 5, "value": 10 },
                    "kw_cm_tblpeoplemembership": { "description": "An entry in the NGO/board membership table of KnowWho's local database.", "key": "kw_cm_tblpeoplemembership", "label": "KnowWho countymuni.tblpeoplemembership", "profile_info_source": 5, "value": 11 },
                    "kw_cm_tblpeoplemilitary": { "description": "An entry in the military history table of KnowWho's local database.", "key": "kw_cm_tblpeoplemilitary", "label": "KnowWho countymuni.tblpeoplemilitary", "profile_info_source": 5, "value": 12 },
                    "kw_cm_tblpeopleoccupation": { "description": "An entry in the occupational history table of KnowWho's local database.", "key": "kw_cm_tblpeopleoccupation", "label": "KnowWho countymuni.tblpeopleoccupation", "profile_info_source": 5, "value": 13 },
                    "kw_gov_tblpeopledirector": { "description": "An entry in the directorship table of KnowWho's federal/state database.", "key": "kw_gov_tblpeopledirector", "label": "KnowWho government.tblpeopledirector", "profile_info_source": 5, "value": 3 },
                    "kw_gov_tblpeopleeducation": { "description": "An entry in the educational history table of KnowWho's federal/state database.", "key": "kw_gov_tblpeopleeducation", "label": "KnowWho government.tblpeopleeducation", "profile_info_source": 5, "value": 2 },
                    "kw_gov_tblpeopleexperience": { "description": "An entry in the 'past history' table of KnowWho's federal/state database.", "key": "kw_gov_tblpeopleexperience", "label": "KnowWho government.tblpeopleexperience", "profile_info_source": 5, "value": 4 },
                    "kw_gov_tblpeoplemembership": { "description": "An entry in the NGO/board membership table of KnowWho's federal/state database.", "key": "kw_gov_tblpeoplemembership", "label": "KnowWho government.tblpeoplemembership", "profile_info_source": 5, "value": 5 },
                    "kw_gov_tblpeoplemilitary": { "description": "An entry in the military history table of KnowWho's federal/state database.", "key": "kw_gov_tblpeoplemilitary", "label": "KnowWho government.tblpeoplemilitary", "profile_info_source": 5, "value": 6 },
                    "kw_gov_tblpeopleoccupation": { "description": "An entry in the occupational history table of KnowWho's federal/state database.", "key": "kw_gov_tblpeopleoccupation", "label": "KnowWho government.tblpeopleoccupation", "profile_info_source": 5, "value": 7 },
                    "lc_careers": { "description": "Careers information, an expansion of person with other work experience not present in positions.", "key": "lc_careers", "label": "Leadership Connect /person/careers", "profile_info_source": 12, "value": 16 },
                    "lc_education": { "description": "Education information, an expansion of person with details about their education.", "key": "lc_education", "label": "Leadership Connect /person/education", "profile_info_source": 12, "value": 22 },
                    "lc_memberships": { "description": "Memberships information, an expansion of person with other organizations the person is member of.", "key": "lc_memberships", "label": "Leadership Connect /person/memberships", "profile_info_source": 12, "value": 17 },
                    "lc_position": { "description": "Position information, an expansion of a person with details about their position.", "key": "lc_position", "label": "Leadership Connect /person/positions", "profile_info_source": 12, "value": 23 },
                    "legistorm_congressional_history": { "description": "Details about a person's former federal staff roles from the congressional_history table", "key": "legistorm_congressional_history", "label": "LegiStorm congressional_history", "profile_info_source": 13, "value": 21 },
                    "legistorm_person_education": { "description": "Details about a person's education history from the person_education table", "key": "legistorm_person_education", "label": "LegiStorm person_education", "profile_info_source": 13, "value": 20 },
                    "legistorm_person_military_history": { "description": "Details about a person's military history from the person_military_history table", "key": "legistorm_person_military_history", "label": "LegiStorm person_military_history", "profile_info_source": 13, "value": 19 },
                    "legistorm_person_organization": { "description": "Details about a person's past careers and memberships from the person_organization table", "key": "legistorm_person_organization", "label": "LegiStorm person_organization", "profile_info_source": 13, "value": 18 },
                    "personrole": { "description": "An entry sourced from a Quorum PersonRole.", "key": "personrole", "label": "PersonRole", "value": 1 }
                },
                "SectorType": {
                    "__is_enum": true,
                    "government": {
                        "description": "A person who works for the government",
                        "key": "government",
                        "label": "Government",
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "GOV",
                        "value": 1
                    },
                    "media": {
                        "description": "A person who works for the media, e.g. a journalist",
                        "key": "media",
                        "label": "Media",
                        "precedence": 1,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "MED",
                        "value": 2
                    },
                    "non_profit": {
                        "description": "A non-profitable organization of a sort",
                        "key": "non_profit",
                        "label": "Non-profitable",
                        "precedence": 999,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "NPFT",
                        "value": 3
                    },
                    "other_sector_type": {
                        "description": "A person who works for an organization that does not fall into any of the other categories",
                        "key": "other_sector_type",
                        "label": "Other",
                        "precedence": 999,
                        "regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "unique_identifier": "OTH",
                        "value": 4
                    }
                },
                "SpecificRoleType": {
                    "__is_enum": true,
                    "us_fed_house_cauc_conf_leader": {
                        "description": null,
                        "key": "us_fed_house_cauc_conf_leader",
                        "kw_code": null,
                        "label": "House Caucus or Conference Leader",
                        "parent": 459,
                        "precedence": 275210,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 829
                    },
                    "us_fed_house_maj_leader": {
                        "description": null,
                        "key": "us_fed_house_maj_leader",
                        "kw_code": null,
                        "label": "House Majority Leader",
                        "parent": 455,
                        "precedence": 275060,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 825
                    },
                    "us_fed_house_maj_whip": {
                        "description": null,
                        "key": "us_fed_house_maj_whip",
                        "kw_code": null,
                        "label": "House Majority Whip",
                        "parent": 455,
                        "precedence": 275120,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 826
                    },
                    "us_fed_house_min_leader": {
                        "description": null,
                        "key": "us_fed_house_min_leader",
                        "kw_code": null,
                        "label": "House Minority Leader",
                        "parent": 455,
                        "precedence": 275090,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 827
                    },
                    "us_fed_house_min_whip": {
                        "description": null,
                        "key": "us_fed_house_min_whip",
                        "kw_code": null,
                        "label": "House Minority Whip",
                        "parent": 455,
                        "precedence": 275150,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 828
                    },
                    "us_fed_house_other_officer": {
                        "description": null,
                        "key": "us_fed_house_other_officer",
                        "kw_code": null,
                        "label": "US House - Other Officer Role",
                        "parent": 176,
                        "precedence": 275180,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 830
                    },
                    "us_fed_house_speaker": {
                        "description": null,
                        "key": "us_fed_house_speaker",
                        "kw_code": null,
                        "label": "Speaker of the House",
                        "parent": 455,
                        "precedence": 275030,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 824
                    },
                    "us_fed_other_committee_staff": {
                        "description": null,
                        "key": "us_fed_other_committee_staff",
                        "kw_code": null,
                        "label": "Other Committee Staff",
                        "parent": 32,
                        "precedence": 520060,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 10
                    },
                    "us_fed_sen_cauc_conf_leader": {
                        "description": null,
                        "key": "us_fed_sen_cauc_conf_leader",
                        "kw_code": null,
                        "label": "Senate Caucus or Conference Leader",
                        "parent": 458,
                        "precedence": 270270,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 839
                    },
                    "us_fed_sen_maj_asst": {
                        "description": null,
                        "key": "us_fed_sen_maj_asst",
                        "kw_code": null,
                        "label": "Senate Assistant Majority Leader",
                        "parent": 454,
                        "precedence": 270210,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 834
                    },
                    "us_fed_sen_maj_leader": {
                        "description": null,
                        "key": "us_fed_sen_maj_leader",
                        "kw_code": null,
                        "label": "Senate Majority Leader",
                        "parent": 454,
                        "precedence": 270090,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 833
                    },
                    "us_fed_sen_maj_whip": {
                        "description": null,
                        "key": "us_fed_sen_maj_whip",
                        "kw_code": null,
                        "label": "Senate Majority Whip",
                        "parent": 454,
                        "precedence": 270150,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 835
                    },
                    "us_fed_sen_min_asst": {
                        "description": null,
                        "key": "us_fed_sen_min_asst",
                        "kw_code": null,
                        "label": "Senate Assistant Minority Leader",
                        "parent": 454,
                        "precedence": 270240,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 837
                    },
                    "us_fed_sen_min_leader": {
                        "description": null,
                        "key": "us_fed_sen_min_leader",
                        "kw_code": null,
                        "label": "Senate Minority Leader",
                        "parent": 454,
                        "precedence": 270120,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 836
                    },
                    "us_fed_sen_min_whip": {
                        "description": null,
                        "key": "us_fed_sen_min_whip",
                        "kw_code": null,
                        "label": "Senate Minority Whip",
                        "parent": 454,
                        "precedence": 270180,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 838
                    },
                    "us_fed_sen_pres_pro_tempore": {
                        "description": null,
                        "key": "us_fed_sen_pres_pro_tempore",
                        "kw_code": null,
                        "label": "President Pro Tempore of the Senate",
                        "parent": 454,
                        "precedence": 270060,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 832
                    },
                    "us_fed_sen_president": {
                        "description": null,
                        "key": "us_fed_sen_president",
                        "kw_code": null,
                        "label": "President of the Senate",
                        "parent": 454,
                        "precedence": 270030,
                        "rank": 1000,
                        "regions": [1, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 831
                    },
                    "us_state_rep": {
                        "description": null,
                        "key": "us_state_rep",
                        "kw_code": "SH",
                        "label": "State Representative",
                        "parent": 8,
                        "precedence": 375030,
                        "rank": 1000,
                        "regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "show_in_quicksearch": false,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "unique_identifier": null,
                        "value": 1
                    },
                    "us_vpotus_assistant": {
                        "description": null,
                        "key": "us_vpotus_assistant",
                        "kw_code": "PRES10",
                        "label": "Assistant to the Vice President",
                        "parent": 18,
                        "precedence": 340500,
                        "rank": 10,
                        "regions": [1, 10000],
                        "show_in_quicksearch": true,
                        "source_enum": null,
                        "source_enum_value": null,
                        "supported_regions": [1, 10000],
                        "unique_identifier": null,
                        "value": 33
                    }
                }
            },
            "searchfiltertypes": {
                "CommitteeLeadershipType": {
                    "__is_enum": true,
                    "chair": {
                        "key": "chair",
                        "label": "Chair",
                        "specific_role_types": [460, 461, 462, 463, 468, 469, 518, 519, 520, 521, 526, 527],
                        "value": 1
                    },
                    "vice_chair_or_ranking_member": {
                        "key": "vice_chair_or_ranking_member",
                        "label": "Vice Chair / Ranking Member",
                        "specific_role_types": [470, 471, 478, 479, 508, 509, 464, 465, 528, 529, 536, 537, 566, 567, 522, 523],
                        "value": 2
                    }
                }
            },
            "types": {
                "AppointedByType": {
                    "__is_enum": true,
                    "appointed_by_commission": {
                        "key": "appointed_by_commission",
                        "label": "Appointed by Commission",
                        "lc_appointed_by_id": 8,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 8
                    },
                    "appointed_by_council": {
                        "key": "appointed_by_council",
                        "label": "Appointed by Council",
                        "lc_appointed_by_id": 9,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 9
                    },
                    "appointed_by_county_executive": {
                        "key": "appointed_by_county_executive",
                        "label": "Appointed by County Executive",
                        "lc_appointed_by_id": 10,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 10
                    },
                    "appointed_by_governor": {
                        "key": "appointed_by_governor",
                        "label": "Appointed by Governor",
                        "lc_appointed_by_id": 11,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 11
                    },
                    "appointed_by_judge": {
                        "key": "appointed_by_judge",
                        "label": "Appointed by Judge",
                        "lc_appointed_by_id": 12,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 12
                    },
                    "appointed_by_mayor": {
                        "key": "appointed_by_mayor",
                        "label": "Appointed by Mayor",
                        "lc_appointed_by_id": 13,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 13
                    },
                    "appointed_by_state_supreme_court": {
                        "key": "appointed_by_state_supreme_court",
                        "label": "Appointed by State Supreme Court",
                        "lc_appointed_by_id": 14,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                        "value": 14
                    },
                    "career_senior_executive_service_cases": {
                        "key": "career_senior_executive_service_cases",
                        "label": "Career Senior Executive Service (CA/SES)",
                        "lc_appointed_by_id": 1,
                        "supported_regions": [1, 10000],
                        "value": 1
                    },
                    "non_career_senior_executive_service_nases": {
                        "key": "non_career_senior_executive_service_nases",
                        "label": "Non-Career Senior Executive Service (NA/SES)",
                        "lc_appointed_by_id": 3,
                        "supported_regions": [1, 10000],
                        "value": 3
                    },
                    "presidential_appointments_of_federal_boards_or_commissions": {
                        "key": "presidential_appointments_of_federal_boards_or_commissions",
                        "label": "Presidential Appointments of Federal Boards or Commissions",
                        "lc_appointed_by_id": 6,
                        "supported_regions": [1, 10000],
                        "value": 6
                    },
                    "presidential_appointments_with_senate_confirmation_pas": {
                        "key": "presidential_appointments_with_senate_confirmation_pas",
                        "label": "Presidential Appointments with Senate Confirmation (PAS)",
                        "lc_appointed_by_id": 5,
                        "supported_regions": [1, 10000],
                        "value": 5
                    },
                    "presidential_appointments_without_senate_confirmation_pa": {
                        "key": "presidential_appointments_without_senate_confirmation_pa",
                        "label": "Presidential Appointments without Senate Confirmation (PA)",
                        "lc_appointed_by_id": 4,
                        "supported_regions": [1, 10000],
                        "value": 4
                    },
                    "schedule_c_sc": {
                        "key": "schedule_c_sc",
                        "label": "Schedule C (SC)",
                        "lc_appointed_by_id": 7,
                        "supported_regions": [1, 10000],
                        "value": 7
                    },
                    "senior_foreign_service_sfs": {
                        "key": "senior_foreign_service_sfs",
                        "label": "Senior Foreign Service (SFS)",
                        "lc_appointed_by_id": 2,
                        "supported_regions": [1, 10000],
                        "value": 2
                    }
                },
                "ComStafferType": {
                    "Majority": { "abbrev": "MAJ", "icon": "fa-bell-o", "key": "Majority", "label": "Majority", "value": 1 },
                    "Minority": { "abbrev": "MIN", "icon": "fa-dot-circle-o", "key": "Minority", "label": "Minority", "value": 2 },
                    "NoneValue": { "icon": "fa-flag-o", "key": "NoneValue", "label": "None" },
                    "Other": { "abbrev": "OTH", "icon": "fa-flag-o", "key": "Other", "label": "Other", "value": 3 },
                    "__is_enum": true
                },
                "Country": {
                    "Afghanistan": { "abbrev": "", "database_id": 2, "is_eu": false, "key": "Afghanistan", "label": "Afghanistan", "value": 2 },
                    "Albania": { "abbrev": "", "database_id": 6, "is_eu": false, "key": "Albania", "label": "Albania", "value": 6 },
                    "Algeria": { "abbrev": "", "database_id": 64, "is_eu": false, "key": "Algeria", "label": "Algeria", "value": 65 },
                    "AmericanSamoa": { "abbrev": "", "database_id": 11, "is_eu": false, "key": "AmericanSamoa", "label": "American Samoa", "value": 11 },
                    "Andorra": { "abbrev": "", "database_id": 7, "is_eu": false, "key": "Andorra", "label": "Andorra", "value": 7 },
                    "Angola": { "abbrev": "", "database_id": 3, "is_eu": false, "key": "Angola", "label": "Angola", "value": 3 },
                    "Anguilla": { "abbrev": "", "database_id": 4, "is_eu": false, "key": "Anguilla", "label": "Anguilla", "value": 4 },
                    "Antarctica": { "abbrev": "", "database_id": 12, "is_eu": false, "key": "Antarctica", "label": "Antarctica", "value": 12 },
                    "AntiguaandBarbuda": { "abbrev": "", "database_id": 14, "is_eu": false, "key": "AntiguaandBarbuda", "label": "Antigua and Barbuda", "value": 14 },
                    "Argentina": { "abbrev": "", "database_id": 9, "is_eu": false, "key": "Argentina", "label": "Argentina", "value": 9 },
                    "Armenia": { "abbrev": "", "database_id": 10, "is_eu": false, "key": "Armenia", "label": "Armenia", "value": 10 },
                    "Aruba": { "abbrev": "", "database_id": 1, "is_eu": false, "key": "Aruba", "label": "Aruba", "value": 1 },
                    "Australia": { "abbrev": "", "database_id": 15, "is_eu": false, "key": "Australia", "label": "Australia", "value": 15 },
                    "Austria": { "abbrev": "AT", "database_id": 16, "is_eu": true, "key": "Austria", "label": "Austria", "value": 16 },
                    "Azerbaijan": { "abbrev": "", "database_id": 17, "is_eu": false, "key": "Azerbaijan", "label": "Azerbaijan", "value": 17 },
                    "Bahamas": { "abbrev": "", "database_id": 25, "is_eu": false, "key": "Bahamas", "label": "Bahamas", "value": 26 },
                    "Bahrain": { "abbrev": "", "database_id": 24, "is_eu": false, "key": "Bahrain", "label": "Bahrain", "value": 25 },
                    "Bangladesh": { "abbrev": "", "database_id": 22, "is_eu": false, "key": "Bangladesh", "label": "Bangladesh", "value": 23 },
                    "Barbados": { "abbrev": "", "database_id": 33, "is_eu": false, "key": "Barbados", "label": "Barbados", "value": 34 },
                    "Belarus": { "abbrev": "", "database_id": 28, "is_eu": false, "key": "Belarus", "label": "Belarus", "value": 29 },
                    "Belgium": { "abbrev": "BE", "database_id": 19, "is_eu": true, "key": "Belgium", "label": "Belgium", "value": 19 },
                    "Belize": { "abbrev": "", "database_id": 29, "is_eu": false, "key": "Belize", "label": "Belize", "value": 30 },
                    "Benin": { "abbrev": "", "database_id": 20, "is_eu": false, "key": "Benin", "label": "Benin", "value": 20 },
                    "Bermuda": { "abbrev": "", "database_id": 30, "is_eu": false, "key": "Bermuda", "label": "Bermuda", "value": 31 },
                    "Bhutan": { "abbrev": "", "database_id": 35, "is_eu": false, "key": "Bhutan", "label": "Bhutan", "value": 36 },
                    "Bolivia": { "abbrev": "", "database_id": 31, "is_eu": false, "key": "Bolivia", "label": "Bolivia", "value": 32 },
                    "Bonaire": { "abbrev": "", "is_eu": false, "key": "Bonaire", "label": "Bonaire", "value": 21 },
                    "BosniaandHerzegovina": { "abbrev": "", "database_id": 26, "is_eu": false, "key": "BosniaandHerzegovina", "label": "Bosnia and Herzegovina", "value": 27 },
                    "Botswana": { "abbrev": "", "database_id": 37, "is_eu": false, "key": "Botswana", "label": "Botswana", "value": 38 },
                    "BouvetIsland": { "abbrev": "", "is_eu": false, "key": "BouvetIsland", "label": "Bouvet Island", "value": 37 },
                    "Brazil": { "abbrev": "", "database_id": 32, "is_eu": false, "key": "Brazil", "label": "Brazil", "value": 33 },
                    "BritishIndianOceanTerritory": { "abbrev": "", "database_id": 105, "is_eu": false, "key": "BritishIndianOceanTerritory", "label": "British Indian Ocean Territory", "value": 106 },
                    "BritishVirginIslands": { "abbrev": "", "database_id": 239, "is_eu": false, "key": "BritishVirginIslands", "label": "British Virgin Islands", "value": 241 },
                    "Brunei": { "abbrev": "", "database_id": 34, "is_eu": false, "key": "Brunei", "label": "Brunei", "value": 35 },
                    "Bulgaria": { "abbrev": "BG", "database_id": 23, "is_eu": true, "key": "Bulgaria", "label": "Bulgaria", "value": 24 },
                    "BurkinaFaso": { "abbrev": "", "database_id": 21, "is_eu": false, "key": "BurkinaFaso", "label": "Burkina Faso", "value": 22 },
                    "Burundi": { "abbrev": "", "database_id": 18, "is_eu": false, "key": "Burundi", "label": "Burundi", "value": 18 },
                    "Cambodia": { "abbrev": "", "database_id": 119, "is_eu": false, "key": "Cambodia", "label": "Cambodia", "value": 120 },
                    "Cameroon": { "abbrev": "", "database_id": 45, "is_eu": false, "key": "Cameroon", "label": "Cameroon", "value": 46 },
                    "Canada": { "abbrev": "", "database_id": 39, "is_eu": false, "key": "Canada", "label": "Canada", "value": 40 },
                    "CapeVerde": { "abbrev": "", "database_id": 51, "is_eu": false, "key": "CapeVerde", "label": "Cape Verde", "value": 52 },
                    "CaymanIslands": { "abbrev": "", "database_id": 56, "is_eu": false, "key": "CaymanIslands", "label": "Cayman Islands", "value": 57 },
                    "CentralAfricanRepublic": { "abbrev": "", "database_id": 38, "is_eu": false, "key": "CentralAfricanRepublic", "label": "Central African Republic", "value": 39 },
                    "Chad": { "abbrev": "", "database_id": 216, "is_eu": false, "key": "Chad", "label": "Chad", "value": 218 },
                    "Chile": { "abbrev": "", "database_id": 42, "is_eu": false, "key": "Chile", "label": "Chile", "value": 43 },
                    "China": { "abbrev": "", "database_id": 43, "is_eu": false, "key": "China", "label": "China", "value": 44 },
                    "ChristmasIsland": { "abbrev": "", "is_eu": false, "key": "ChristmasIsland", "label": "Christmas Island", "value": 56 },
                    "CocosKeelingIslands": { "abbrev": "", "is_eu": false, "key": "CocosKeelingIslands", "label": "Cocos (Keeling) Islands", "value": 41 },
                    "Colombia": { "abbrev": "", "database_id": 49, "is_eu": false, "key": "Colombia", "label": "Colombia", "value": 50 },
                    "Comoros": { "abbrev": "", "database_id": 50, "is_eu": false, "key": "Comoros", "label": "Comoros", "value": 51 },
                    "CookIslands": { "abbrev": "", "database_id": 48, "is_eu": false, "key": "CookIslands", "label": "Cook Islands", "value": 49 },
                    "CostaRica": { "abbrev": "", "database_id": 52, "is_eu": false, "key": "CostaRica", "label": "Costa Rica", "value": 53 },
                    "Croatia": { "abbrev": "HR", "database_id": 99, "is_eu": true, "key": "Croatia", "label": "Croatia", "value": 100 },
                    "Cuba": { "abbrev": "", "database_id": 53, "is_eu": false, "key": "Cuba", "label": "Cuba", "value": 54 },
                    "Curaao": { "abbrev": "", "database_id": 54, "is_eu": false, "key": "Curaao", "label": "Curacao", "value": 55 },
                    "Cyprus": { "abbrev": "CY", "database_id": 57, "is_eu": true, "key": "Cyprus", "label": "Cyprus", "value": 58 },
                    "CzechRepublic": { "abbrev": "CZ", "database_id": 58, "is_eu": true, "key": "CzechRepublic", "label": "Czechia", "value": 59 },
                    "DRCongo": { "abbrev": "", "database_id": 46, "is_eu": false, "key": "DRCongo", "label": "Democratic Republic of the Congo", "value": 47 },
                    "Denmark": { "abbrev": "DK", "database_id": 62, "is_eu": true, "key": "Denmark", "label": "Denmark", "value": 63 },
                    "Djibouti": { "abbrev": "", "database_id": 60, "is_eu": false, "key": "Djibouti", "label": "Djibouti", "value": 61 },
                    "Dominica": { "abbrev": "", "database_id": 61, "is_eu": false, "key": "Dominica", "label": "Dominica", "value": 62 },
                    "DominicanRepublic": { "abbrev": "", "database_id": 63, "is_eu": false, "key": "DominicanRepublic", "label": "Dominican Republic", "value": 64 },
                    "Ecuador": { "abbrev": "", "database_id": 65, "is_eu": false, "key": "Ecuador", "label": "Ecuador", "value": 66 },
                    "Egypt": { "abbrev": "", "database_id": 66, "is_eu": false, "key": "Egypt", "label": "Egypt", "value": 67 },
                    "ElSalvador": { "abbrev": "", "database_id": 200, "is_eu": false, "key": "ElSalvador", "label": "El Salvador", "value": 202 },
                    "EquatorialGuinea": { "abbrev": "", "database_id": 88, "is_eu": false, "key": "EquatorialGuinea", "label": "Equatorial Guinea", "value": 89 },
                    "Eritrea": { "abbrev": "", "database_id": 67, "is_eu": false, "key": "Eritrea", "label": "Eritrea", "value": 68 },
                    "Estonia": { "abbrev": "EE", "database_id": 70, "is_eu": true, "key": "Estonia", "label": "Estonia", "value": 71 },
                    "Ethiopia": { "abbrev": "", "database_id": 71, "is_eu": false, "key": "Ethiopia", "label": "Ethiopia", "value": 72 },
                    "FalklandIslands": { "abbrev": "", "database_id": 74, "is_eu": false, "key": "FalklandIslands", "label": "Falkland Islands", "value": 75 },
                    "FaroeIslands": { "abbrev": "", "database_id": 76, "is_eu": false, "key": "FaroeIslands", "label": "Faroe Islands", "value": 77 },
                    "Fiji": { "abbrev": "", "database_id": 73, "is_eu": false, "key": "Fiji", "label": "Fiji", "value": 74 },
                    "Finland": { "abbrev": "FI", "database_id": 72, "is_eu": true, "key": "Finland", "label": "Finland", "value": 73 },
                    "France": { "abbrev": "FR", "database_id": 75, "is_eu": true, "key": "France", "label": "France", "value": 76 },
                    "FrenchGuiana": { "abbrev": "", "is_eu": false, "key": "FrenchGuiana", "label": "French Guiana", "value": 94 },
                    "FrenchPolynesia": { "abbrev": "", "database_id": 186, "is_eu": false, "key": "FrenchPolynesia", "label": "French Polynesia", "value": 187 },
                    "FrenchSouthernandAntarcticLands": { "abbrev": "", "is_eu": false, "key": "FrenchSouthernandAntarcticLands", "label": "French Southern and Antarctic Lands", "value": 13 },
                    "Gabon": { "abbrev": "", "database_id": 78, "is_eu": false, "key": "Gabon", "label": "Gabon", "value": 79 },
                    "Gambia": { "abbrev": "", "database_id": 86, "is_eu": false, "key": "Gambia", "label": "Gambia", "value": 87 },
                    "Georgia": { "abbrev": "", "database_id": 80, "is_eu": false, "key": "Georgia", "label": "Georgia", "value": 81 },
                    "Germany": { "abbrev": "DE", "database_id": 59, "is_eu": true, "key": "Germany", "label": "Germany", "value": 60 },
                    "Ghana": { "abbrev": "", "database_id": 82, "is_eu": false, "key": "Ghana", "label": "Ghana", "value": 83 },
                    "Gibraltar": { "abbrev": "", "database_id": 83, "is_eu": false, "key": "Gibraltar", "label": "Gibraltar", "value": 84 },
                    "Greece": { "abbrev": "GR", "database_id": 89, "is_eu": true, "key": "Greece", "label": "Greece", "value": 90 },
                    "Greenland": { "abbrev": "", "database_id": 91, "is_eu": false, "key": "Greenland", "label": "Greenland", "value": 92 },
                    "Grenada": { "abbrev": "", "database_id": 90, "is_eu": false, "key": "Grenada", "label": "Grenada", "value": 91 },
                    "Guadeloupe": { "abbrev": "", "database_id": 85, "is_eu": false, "key": "Guadeloupe", "label": "Guadeloupe", "value": 86 },
                    "Guam": { "abbrev": "", "database_id": 94, "is_eu": false, "key": "Guam", "label": "Guam", "value": 95 },
                    "Guatemala": { "abbrev": "", "database_id": 92, "is_eu": false, "key": "Guatemala", "label": "Guatemala", "value": 93 },
                    "Guernsey": { "abbrev": "", "database_id": 81, "is_eu": false, "key": "Guernsey", "label": "Guernsey", "value": 82 },
                    "Guinea": { "abbrev": "", "database_id": 84, "is_eu": false, "key": "Guinea", "label": "Guinea", "value": 85 },
                    "GuineaBissau": { "abbrev": "", "database_id": 87, "is_eu": false, "key": "GuineaBissau", "label": "Guinea-Bissau", "value": 88 },
                    "Guyana": { "abbrev": "", "database_id": 95, "is_eu": false, "key": "Guyana", "label": "Guyana", "value": 96 },
                    "Haiti": { "abbrev": "", "database_id": 100, "is_eu": false, "key": "Haiti", "label": "Haiti", "value": 101 },
                    "HeardIslandandMcDonaldIslands": { "abbrev": "", "is_eu": false, "key": "HeardIslandandMcDonaldIslands", "label": "Heard Island and McDonald Islands", "value": 98 },
                    "Honduras": { "abbrev": "", "database_id": 98, "is_eu": false, "key": "Honduras", "label": "Honduras", "value": 99 },
                    "HongKong": { "abbrev": "", "database_id": 96, "is_eu": false, "key": "HongKong", "label": "Hong Kong", "value": 97 },
                    "Hungary": { "abbrev": "HU", "database_id": 101, "is_eu": true, "key": "Hungary", "label": "Hungary", "value": 102 },
                    "Iceland": { "abbrev": "", "database_id": 109, "is_eu": false, "key": "Iceland", "label": "Iceland", "value": 110 },
                    "India": { "abbrev": "", "database_id": 104, "is_eu": false, "key": "India", "label": "India", "value": 105 },
                    "Indonesia": { "abbrev": "", "database_id": 102, "is_eu": false, "key": "Indonesia", "label": "Indonesia", "value": 103 },
                    "Iran": { "abbrev": "", "database_id": 107, "is_eu": false, "key": "Iran", "label": "Iran", "value": 108 },
                    "Iraq": { "abbrev": "", "database_id": 108, "is_eu": false, "key": "Iraq", "label": "Iraq", "value": 109 },
                    "Ireland": { "abbrev": "IE", "database_id": 106, "is_eu": true, "key": "Ireland", "label": "Ireland", "value": 107 },
                    "IsleofMan": { "abbrev": "", "database_id": 103, "is_eu": false, "key": "IsleofMan", "label": "Isle of Man", "value": 104 },
                    "Israel": { "abbrev": "", "database_id": 110, "is_eu": false, "key": "Israel", "label": "Israel", "value": 111 },
                    "Italy": { "abbrev": "IT", "database_id": 111, "is_eu": true, "key": "Italy", "label": "Italy", "value": 112 },
                    "IvoryCoast": { "abbrev": "", "database_id": 44, "is_eu": false, "key": "IvoryCoast", "label": "Ivory Coast", "value": 45 },
                    "Jamaica": { "abbrev": "", "database_id": 112, "is_eu": false, "key": "Jamaica", "label": "Jamaica", "value": 113 },
                    "Japan": { "abbrev": "", "database_id": 115, "is_eu": false, "key": "Japan", "label": "Japan", "value": 116 },
                    "Jersey": { "abbrev": "", "database_id": 113, "is_eu": false, "key": "Jersey", "label": "Jersey", "value": 114 },
                    "Jordan": { "abbrev": "", "database_id": 114, "is_eu": false, "key": "Jordan", "label": "Jordan", "value": 115 },
                    "Kazakhstan": { "abbrev": "", "database_id": 116, "is_eu": false, "key": "Kazakhstan", "label": "Kazakhstan", "value": 117 },
                    "Kenya": { "abbrev": "", "database_id": 117, "is_eu": false, "key": "Kenya", "label": "Kenya", "value": 118 },
                    "Kiribati": { "abbrev": "", "database_id": 120, "is_eu": false, "key": "Kiribati", "label": "Kiribati", "value": 121 },
                    "Kosovo": { "abbrev": "", "database_id": 123, "is_eu": false, "key": "Kosovo", "label": "Kosovo", "value": 124 },
                    "Kuwait": { "abbrev": "", "database_id": 124, "is_eu": false, "key": "Kuwait", "label": "Kuwait", "value": 125 },
                    "Kyrgyzstan": { "abbrev": "", "database_id": 118, "is_eu": false, "key": "Kyrgyzstan", "label": "Kyrgyzstan", "value": 119 },
                    "Laos": { "abbrev": "", "database_id": 125, "is_eu": false, "key": "Laos", "label": "Laos", "value": 126 },
                    "Latvia": { "abbrev": "LV", "database_id": 135, "is_eu": true, "key": "Latvia", "label": "Latvia", "value": 136 },
                    "Lebanon": { "abbrev": "", "database_id": 126, "is_eu": false, "key": "Lebanon", "label": "Lebanon", "value": 127 },
                    "Lesotho": { "abbrev": "", "database_id": 132, "is_eu": false, "key": "Lesotho", "label": "Lesotho", "value": 133 },
                    "Liberia": { "abbrev": "", "database_id": 127, "is_eu": false, "key": "Liberia", "label": "Liberia", "value": 128 },
                    "Libya": { "abbrev": "", "database_id": 128, "is_eu": false, "key": "Libya", "label": "Libya", "value": 129 },
                    "Liechtenstein": { "abbrev": "", "database_id": 130, "is_eu": false, "key": "Liechtenstein", "label": "Liechtenstein", "value": 131 },
                    "Lithuania": { "abbrev": "LT", "database_id": 133, "is_eu": true, "key": "Lithuania", "label": "Lithuania", "value": 134 },
                    "Luxembourg": { "abbrev": "LU", "database_id": 134, "is_eu": true, "key": "Luxembourg", "label": "Luxembourg", "value": 135 },
                    "Macau": { "abbrev": "", "database_id": 136, "is_eu": false, "key": "Macau", "label": "Macau", "value": 137 },
                    "Macedonia": { "abbrev": "", "database_id": 145, "is_eu": false, "key": "Macedonia", "label": "Macedonia", "value": 146 },
                    "Madagascar": { "abbrev": "", "database_id": 141, "is_eu": false, "key": "Madagascar", "label": "Madagascar", "value": 142 },
                    "Malawi": { "abbrev": "", "database_id": 157, "is_eu": false, "key": "Malawi", "label": "Malawi", "value": 158 },
                    "Malaysia": { "abbrev": "", "database_id": 158, "is_eu": false, "key": "Malaysia", "label": "Malaysia", "value": 159 },
                    "Maldives": { "abbrev": "", "database_id": 142, "is_eu": false, "key": "Maldives", "label": "Maldives", "value": 143 },
                    "Mali": { "abbrev": "", "database_id": 146, "is_eu": false, "key": "Mali", "label": "Mali", "value": 147 },
                    "Malta": { "abbrev": "MT", "database_id": 147, "is_eu": true, "key": "Malta", "label": "Malta", "value": 148 },
                    "MarshallIslands": { "abbrev": "", "database_id": 144, "is_eu": false, "key": "MarshallIslands", "label": "Marshall Islands", "value": 145 },
                    "Martinique": { "abbrev": "", "database_id": 155, "is_eu": false, "key": "Martinique", "label": "Martinique", "value": 156 },
                    "Mauritania": { "abbrev": "", "database_id": 153, "is_eu": false, "key": "Mauritania", "label": "Mauritania", "value": 154 },
                    "Mauritius": { "abbrev": "", "database_id": 156, "is_eu": false, "key": "Mauritius", "label": "Mauritius", "value": 157 },
                    "Mayotte": { "abbrev": "", "is_eu": false, "key": "Mayotte", "label": "Mayotte", "value": 160 },
                    "Mexico": { "abbrev": "", "database_id": 143, "is_eu": false, "key": "Mexico", "label": "Mexico", "value": 144 },
                    "Micronesia": { "abbrev": "", "database_id": 77, "is_eu": false, "key": "Micronesia", "label": "Micronesia", "value": 78 },
                    "Moldova": { "abbrev": "", "database_id": 140, "is_eu": false, "key": "Moldova", "label": "Moldova", "value": 141 },
                    "Monaco": { "abbrev": "", "database_id": 139, "is_eu": false, "key": "Monaco", "label": "Monaco", "value": 140 },
                    "Mongolia": { "abbrev": "", "database_id": 150, "is_eu": false, "key": "Mongolia", "label": "Mongolia", "value": 151 },
                    "Montenegro": { "abbrev": "", "database_id": 149, "is_eu": false, "key": "Montenegro", "label": "Montenegro", "value": 150 },
                    "Montserrat": { "abbrev": "", "database_id": 154, "is_eu": false, "key": "Montserrat", "label": "Montserrat", "value": 155 },
                    "Morocco": { "abbrev": "", "database_id": 138, "is_eu": false, "key": "Morocco", "label": "Morocco", "value": 139 },
                    "Mozambique": { "abbrev": "", "database_id": 152, "is_eu": false, "key": "Mozambique", "label": "Mozambique", "value": 153 },
                    "Myanmar": { "abbrev": "", "database_id": 148, "is_eu": false, "key": "Myanmar", "label": "Myanmar", "value": 149 },
                    "Namibia": { "abbrev": "", "database_id": 160, "is_eu": false, "key": "Namibia", "label": "Namibia", "value": 161 },
                    "Nauru": { "abbrev": "", "database_id": 170, "is_eu": false, "key": "Nauru", "label": "Nauru", "value": 171 },
                    "Nepal": { "abbrev": "", "database_id": 169, "is_eu": false, "key": "Nepal", "label": "Nepal", "value": 170 },
                    "Netherlands": { "abbrev": "NL", "database_id": 167, "is_eu": true, "key": "Netherlands", "label": "Netherlands", "value": 168 },
                    "NewCaledonia": { "abbrev": "", "database_id": 161, "is_eu": false, "key": "NewCaledonia", "label": "New Caledonia", "value": 162 },
                    "NewZealand": { "abbrev": "", "database_id": 171, "is_eu": false, "key": "NewZealand", "label": "New Zealand", "value": 172 },
                    "Nicaragua": { "abbrev": "", "database_id": 165, "is_eu": false, "key": "Nicaragua", "label": "Nicaragua", "value": 166 },
                    "Niger": { "abbrev": "", "database_id": 162, "is_eu": false, "key": "Niger", "label": "Niger", "value": 163 },
                    "Nigeria": { "abbrev": "", "database_id": 164, "is_eu": false, "key": "Nigeria", "label": "Nigeria", "value": 165 },
                    "Niue": { "abbrev": "", "database_id": 166, "is_eu": false, "key": "Niue", "label": "Niue", "value": 167 },
                    "NorfolkIsland": { "abbrev": "", "is_eu": false, "key": "NorfolkIsland", "label": "Norfolk Island", "value": 164 },
                    "NorthKorea": { "abbrev": "", "database_id": 182, "is_eu": false, "key": "NorthKorea", "label": "North Korea", "value": 183 },
                    "NorthernMarianaIslands": { "abbrev": "", "database_id": 151, "is_eu": false, "key": "NorthernMarianaIslands", "label": "Northern Mariana Islands", "value": 152 },
                    "Norway": { "abbrev": "", "database_id": 168, "is_eu": false, "key": "Norway", "label": "Norway", "value": 169 },
                    "Oman": { "abbrev": "", "database_id": 172, "is_eu": false, "key": "Oman", "label": "Oman", "value": 173 },
                    "Pakistan": { "abbrev": "", "database_id": 173, "is_eu": false, "key": "Pakistan", "label": "Pakistan", "value": 174 },
                    "Palau": { "abbrev": "", "database_id": 178, "is_eu": false, "key": "Palau", "label": "Palau", "value": 179 },
                    "Palestine": { "abbrev": "", "database_id": 185, "is_eu": false, "key": "Palestine", "label": "Palestine", "value": 186 },
                    "Panama": { "abbrev": "", "database_id": 174, "is_eu": false, "key": "Panama", "label": "Panama", "value": 175 },
                    "PapuaNewGuinea": { "abbrev": "", "database_id": 179, "is_eu": false, "key": "PapuaNewGuinea", "label": "Papua New Guinea", "value": 180 },
                    "Paraguay": { "abbrev": "", "database_id": 184, "is_eu": false, "key": "Paraguay", "label": "Paraguay", "value": 185 },
                    "Peru": { "abbrev": "", "database_id": 176, "is_eu": false, "key": "Peru", "label": "Peru", "value": 177 },
                    "Philippines": { "abbrev": "", "database_id": 177, "is_eu": false, "key": "Philippines", "label": "Philippines", "value": 178 },
                    "PitcairnIslands": { "abbrev": "", "is_eu": false, "key": "PitcairnIslands", "label": "Pitcairn Islands", "value": 176 },
                    "Poland": { "abbrev": "PL", "database_id": 180, "is_eu": true, "key": "Poland", "label": "Poland", "value": 181 },
                    "Portugal": { "abbrev": "PT", "database_id": 183, "is_eu": true, "key": "Portugal", "label": "Portugal", "value": 184 },
                    "PuertoRico": { "abbrev": "", "database_id": 181, "is_eu": false, "key": "PuertoRico", "label": "Puerto Rico", "value": 182 },
                    "Qatar": { "abbrev": "", "database_id": 187, "is_eu": false, "key": "Qatar", "label": "Qatar", "value": 188 },
                    "RepublicoftheCongo": { "abbrev": "", "database_id": 47, "is_eu": false, "key": "RepublicoftheCongo", "label": "Republic of the Congo", "value": 48 },
                    "Romania": { "abbrev": "RO", "database_id": 189, "is_eu": true, "key": "Romania", "label": "Romania", "value": 190 },
                    "Runion": { "abbrev": "", "database_id": 188, "is_eu": false, "key": "Runion", "label": "Reunion", "value": 189 },
                    "Russia": { "abbrev": "", "database_id": 190, "is_eu": false, "key": "Russia", "label": "Russia", "value": 191 },
                    "Rwanda": { "abbrev": "", "database_id": 191, "is_eu": false, "key": "Rwanda", "label": "Rwanda", "value": 192 },
                    "SaintBarthlemy": { "abbrev": "", "is_eu": false, "key": "SaintBarthlemy", "label": "Saint Barthelemy", "value": 28 },
                    "SaintHelenaAscensionandTristandaCunha": { "abbrev": "", "is_eu": false, "key": "SaintHelenaAscensionandTristandaCunha", "label": "Saint Helena, Ascension and Tristan da Cunha", "value": 198 },
                    "SaintKittsandNevis": { "abbrev": "", "database_id": 121, "is_eu": false, "key": "SaintKittsandNevis", "label": "Saint Kitts and Nevis", "value": 122 },
                    "SaintLucia": { "abbrev": "", "database_id": 129, "is_eu": false, "key": "SaintLucia", "label": "Saint Lucia", "value": 130 },
                    "SaintMartin": { "abbrev": "", "is_eu": false, "key": "SaintMartin", "label": "Saint Martin", "value": 138 },
                    "SaintPierreandMiquelon": { "abbrev": "", "is_eu": false, "key": "SaintPierreandMiquelon", "label": "Saint Pierre and Miquelon", "value": 205 },
                    "SaintVincentandtheGrenadines": { "abbrev": "", "database_id": 237, "is_eu": false, "key": "SaintVincentandtheGrenadines", "label": "Saint Vincent and the Grenadines", "value": 239 },
                    "Samoa": { "abbrev": "", "database_id": 244, "is_eu": false, "key": "Samoa", "label": "Samoa", "value": 246 },
                    "SanMarino": { "abbrev": "", "database_id": 201, "is_eu": false, "key": "SanMarino", "label": "San Marino", "value": 203 },
                    "SaudiArabia": { "abbrev": "", "database_id": 192, "is_eu": false, "key": "SaudiArabia", "label": "Saudi Arabia", "value": 193 },
                    "Senegal": { "abbrev": "", "database_id": 194, "is_eu": false, "key": "Senegal", "label": "Senegal", "value": 195 },
                    "Serbia": { "abbrev": "", "database_id": 204, "is_eu": false, "key": "Serbia", "label": "Serbia", "value": 206 },
                    "Seychelles": { "abbrev": "", "database_id": 213, "is_eu": false, "key": "Seychelles", "label": "Seychelles", "value": 215 },
                    "SierraLeone": { "abbrev": "", "database_id": 199, "is_eu": false, "key": "SierraLeone", "label": "Sierra Leone", "value": 201 },
                    "Singapore": { "abbrev": "", "database_id": 195, "is_eu": false, "key": "Singapore", "label": "Singapore", "value": 196 },
                    "SintMaarten": { "abbrev": "", "database_id": 212, "is_eu": false, "key": "SintMaarten", "label": "Sint Maarten", "value": 214 },
                    "Slovakia": { "abbrev": "SK", "database_id": 208, "is_eu": true, "key": "Slovakia", "label": "Slovakia", "value": 210 },
                    "Slovenia": { "abbrev": "SI", "database_id": 209, "is_eu": true, "key": "Slovenia", "label": "Slovenia", "value": 211 },
                    "SoTomandPrncipe": { "abbrev": "", "database_id": 206, "is_eu": false, "key": "SoTomandPrncipe", "label": "Sao Tome and Principe", "value": 208 },
                    "SolomonIslands": { "abbrev": "", "database_id": 198, "is_eu": false, "key": "SolomonIslands", "label": "Solomon Islands", "value": 200 },
                    "Somalia": { "abbrev": "", "database_id": 202, "is_eu": false, "key": "Somalia", "label": "Somalia", "value": 204 },
                    "SouthAfrica": { "abbrev": "", "database_id": 246, "is_eu": false, "key": "SouthAfrica", "label": "South Africa", "value": 248 },
                    "SouthGeorgia": { "abbrev": "", "is_eu": false, "key": "SouthGeorgia", "label": "South Georgia", "value": 197 },
                    "SouthKorea": { "abbrev": "", "database_id": 122, "is_eu": false, "key": "SouthKorea", "label": "South Korea", "value": 123 },
                    "SouthSudan": { "abbrev": "", "database_id": 205, "is_eu": false, "key": "SouthSudan", "label": "South Sudan", "value": 207 },
                    "Spain": { "abbrev": "ES", "database_id": 69, "is_eu": true, "key": "Spain", "label": "Spain", "value": 70 },
                    "SriLanka": { "abbrev": "", "database_id": 131, "is_eu": false, "key": "SriLanka", "label": "Sri Lanka", "value": 132 },
                    "Sudan": { "abbrev": "", "database_id": 193, "is_eu": false, "key": "Sudan", "label": "Sudan", "value": 194 },
                    "Suriname": { "abbrev": "", "database_id": 207, "is_eu": false, "key": "Suriname", "label": "Suriname", "value": 209 },
                    "SvalbardandJanMayen": { "abbrev": "", "is_eu": false, "key": "SvalbardandJanMayen", "label": "Svalbard and Jan Mayen", "value": 199 },
                    "Swaziland": { "abbrev": "", "database_id": 211, "is_eu": false, "key": "Swaziland", "label": "Swaziland", "value": 213 },
                    "Sweden": { "abbrev": "SE", "database_id": 210, "is_eu": true, "key": "Sweden", "label": "Sweden", "value": 212 },
                    "Switzerland": { "abbrev": "", "database_id": 41, "is_eu": false, "key": "Switzerland", "label": "Switzerland", "value": 42 },
                    "Syria": { "abbrev": "", "database_id": 214, "is_eu": false, "key": "Syria", "label": "Syria", "value": 216 },
                    "Taiwan": { "abbrev": "", "database_id": 228, "is_eu": false, "key": "Taiwan", "label": "Taiwan", "value": 230 },
                    "Tajikistan": { "abbrev": "", "database_id": 219, "is_eu": false, "key": "Tajikistan", "label": "Tajikistan", "value": 221 },
                    "Tanzania": { "abbrev": "", "database_id": 229, "is_eu": false, "key": "Tanzania", "label": "Tanzania", "value": 231 },
                    "Thailand": { "abbrev": "", "database_id": 218, "is_eu": false, "key": "Thailand", "label": "Thailand", "value": 220 },
                    "TimorLeste": { "abbrev": "", "database_id": 222, "is_eu": false, "key": "TimorLeste", "label": "Timor-Leste", "value": 224 },
                    "Togo": { "abbrev": "", "database_id": 217, "is_eu": false, "key": "Togo", "label": "Togo", "value": 219 },
                    "Tokelau": { "abbrev": "", "database_id": 220, "is_eu": false, "key": "Tokelau", "label": "Tokelau", "value": 222 },
                    "Tonga": { "abbrev": "", "database_id": 223, "is_eu": false, "key": "Tonga", "label": "Tonga", "value": 225 },
                    "TrinidadandTobago": { "abbrev": "", "database_id": 224, "is_eu": false, "key": "TrinidadandTobago", "label": "Trinidad and Tobago", "value": 226 },
                    "Tunisia": { "abbrev": "", "database_id": 225, "is_eu": false, "key": "Tunisia", "label": "Tunisia", "value": 227 },
                    "Turkey": { "abbrev": "", "database_id": 226, "is_eu": false, "key": "Turkey", "label": "Turkey", "value": 228 },
                    "Turkmenistan": { "abbrev": "", "database_id": 221, "is_eu": false, "key": "Turkmenistan", "label": "Turkmenistan", "value": 223 },
                    "TurksandCaicosIslands": { "abbrev": "", "database_id": 215, "is_eu": false, "key": "TurksandCaicosIslands", "label": "Turks and Caicos Islands", "value": 217 },
                    "Tuvalu": { "abbrev": "", "database_id": 227, "is_eu": false, "key": "Tuvalu", "label": "Tuvalu", "value": 229 },
                    "Uganda": { "abbrev": "", "database_id": 230, "is_eu": false, "key": "Uganda", "label": "Uganda", "value": 232 },
                    "Ukraine": { "abbrev": "", "database_id": 231, "is_eu": false, "key": "Ukraine", "label": "Ukraine", "value": 233 },
                    "UnitedArabEmirates": { "abbrev": "", "database_id": 8, "is_eu": false, "key": "UnitedArabEmirates", "label": "United Arab Emirates", "value": 8 },
                    "UnitedKingdom": { "abbrev": "UK", "database_id": 79, "is_eu": false, "key": "UnitedKingdom", "label": "United Kingdom", "value": 80 },
                    "UnitedStates": { "abbrev": "", "database_id": 234, "is_eu": false, "key": "UnitedStates", "label": "United States", "value": 236 },
                    "UnitedStatesMinorOutlyingIslands": { "abbrev": "", "is_eu": false, "key": "UnitedStatesMinorOutlyingIslands", "label": "United States Minor Outlying Islands", "value": 234 },
                    "UnitedStatesVirginIslands": { "abbrev": "", "database_id": 240, "is_eu": false, "key": "UnitedStatesVirginIslands", "label": "United States Virgin Islands", "value": 242 },
                    "Uruguay": { "abbrev": "", "database_id": 233, "is_eu": false, "key": "Uruguay", "label": "Uruguay", "value": 235 },
                    "Uzbekistan": { "abbrev": "", "database_id": 235, "is_eu": false, "key": "Uzbekistan", "label": "Uzbekistan", "value": 237 },
                    "Vanuatu": { "abbrev": "", "database_id": 242, "is_eu": false, "key": "Vanuatu", "label": "Vanuatu", "value": 244 },
                    "VaticanCity": { "abbrev": "", "database_id": 236, "is_eu": false, "key": "VaticanCity", "label": "Vatican City", "value": 238 },
                    "Venezuela": { "abbrev": "", "database_id": 238, "is_eu": false, "key": "Venezuela", "label": "Venezuela", "value": 240 },
                    "Vietnam": { "abbrev": "", "database_id": 241, "is_eu": false, "key": "Vietnam", "label": "Vietnam", "value": 243 },
                    "WallisandFutuna": { "abbrev": "", "is_eu": false, "key": "WallisandFutuna", "label": "Wallis and Futuna", "value": 245 },
                    "WesternSahara": { "abbrev": "", "database_id": 68, "is_eu": false, "key": "WesternSahara", "label": "Western Sahara", "value": 69 },
                    "Yemen": { "abbrev": "", "database_id": 245, "is_eu": false, "key": "Yemen", "label": "Yemen", "value": 247 },
                    "Zambia": { "abbrev": "", "database_id": 247, "is_eu": false, "key": "Zambia", "label": "Zambia", "value": 249 },
                    "Zimbabwe": { "abbrev": "", "database_id": 248, "is_eu": false, "key": "Zimbabwe", "label": "Zimbabwe", "value": 250 },
                    "__is_enum": true,
                    "landIslands": { "abbrev": "", "is_eu": false, "key": "landIslands", "label": "Aland Islands", "value": 5 }
                },
                "EmployeeType": {
                    "__is_enum": true,
                    "assistant": { "key": "assistant", "label": "Assistant", "value": 1 }
                },
                "Ethnicity": {
                    "AfricanAmerican": { "key": "AfricanAmerican", "kw_ethnicid": 1, "label": "Black/African American", "ls_race_id": 2, "value": 5 },
                    "ArabPersian": { "key": "ArabPersian", "label": "Arab/Persian", "ls_race_id": 43, "value": 9 },
                    "Asian": { "key": "Asian", "kw_ethnicid": 4, "label": "Asian/Pacific American", "ls_race_id": 5, "value": 6 },
                    "HawaiiPacific": { "key": "HawaiiPacific", "kw_ethnicid": 7, "label": "Hawaiian/Pacific Islander", "value": 1 },
                    "Hispanic": { "key": "Hispanic", "kw_ethnicid": 2, "label": "Hispanic/Latino", "ls_race_id": 4, "value": 7 },
                    "NativeAmerican": { "key": "NativeAmerican", "kw_ethnicid": 3, "label": "Indian/Native American", "ls_race_id": 9, "value": 4 },
                    "NoneSpecified": { "key": "NoneSpecified", "label": "No information" },
                    "Other": { "key": "Other", "kw_ethnicid": 8, "label": "Other", "ls_race_id": 44, "value": 2 },
                    "TwoEthnicities": { "key": "TwoEthnicities", "kw_ethnicid": 6, "label": "Two or More Ethnicities", "ls_race_id": 8, "value": 8 },
                    "White": { "key": "White", "kw_ethnicid": 5, "label": "White/Caucasian", "ls_race_id": 1, "value": 3 },
                    "__is_enum": true
                },
                "Gender": {
                    "__is_enum": true,
                    "adrogenous": { "honorific": "Mr./Ms.", "key": "adrogenous", "label": "Unknown", "pronoun": "he/she", "pronoun_object": "his/her", "pronoun_possessive": "his/her", "show_in_enumeration": false, "slug": "andy", "value": 5 },
                    "female": { "honorific": "Ms.", "key": "female", "label": "Female", "pronoun": "she", "pronoun_object": "her", "pronoun_possessive": "her", "show_in_enumeration": true, "slug": "female", "value": 2 },
                    "male": { "honorific": "Mr.", "key": "male", "label": "Male", "pronoun": "he", "pronoun_object": "him", "pronoun_possessive": "his", "show_in_enumeration": true, "slug": "male", "value": 1 },
                    "mostly_female": { "honorific": "Ms.", "key": "mostly_female", "label": "Likely Female", "pronoun": "she", "pronoun_object": "her", "pronoun_possessive": "her", "show_in_enumeration": false, "slug": "mostly_female", "value": 4 },
                    "mostly_male": { "honorific": "Mr.", "key": "mostly_male", "label": "Likely Male", "pronoun": "he", "pronoun_object": "him", "pronoun_possessive": "his", "show_in_enumeration": false, "slug": "mostly_male", "value": 3 },
                    "none": { "honorific": "Mr./Ms.", "key": "none", "label": "N/A", "pronoun": "he/she", "pronoun_object": "his/her", "pronoun_possessive": "his/her", "show_in_enumeration": false, "slug": "na", "value": 0 }
                },
                "LegislativeSeniority": {
                    "__is_enum": true,
                    "first_term": {
                        "key": "first_term",
                        "label": "First Term",
                        "supported_regions": [1, 10000],
                        "tip": "Members serving for the first time in their currently elected position.",
                        "value": 2
                    },
                    "freshman": {
                        "key": "freshman",
                        "label": "Freshman",
                        "supported_regions": [1, 10000],
                        "tip": "Members newly elected for the current legislative session.",
                        "value": 1
                    },
                    "multiple_terms": {
                        "key": "multiple_terms",
                        "label": "Multiple Terms",
                        "supported_regions": [1, 10000],
                        "tip": "Members who have previously served a term in their currently elected position.",
                        "value": 3
                    }
                },
                "Occupations": {
                    "Actor": { "abbrev": "ACT", "key": "Actor", "label": "Actor/Entertainer", "shortname": "an actor/entertainer", "value": 1 },
                    "Aeronautics": { "abbrev": "AER", "key": "Aeronautics", "label": "Aeronautics", "shortname": "involved with aeronautics", "value": 2 },
                    "Agriculture": { "abbrev": "AGR", "key": "Agriculture", "label": "Agriculture", "shortname": "involved in agriculture", "value": 3 },
                    "Banker": { "abbrev": "BAN", "key": "Banker", "label": "Banker", "shortname": "a banker", "value": 4 },
                    "Broadcaster": { "abbrev": "BRO", "key": "Broadcaster", "label": "Broadcaster", "shortname": "a broadcaster", "value": 5 },
                    "Business": { "abbrev": "BUS", "key": "Business", "label": "Business", "shortname": "involved in business", "value": 6 },
                    "Clergy": { "abbrev": "CLE", "key": "Clergy", "label": "Clergy", "shortname": "a member of the clergy", "value": 7 },
                    "Education": { "abbrev": "EDU", "key": "Education", "label": "Education", "shortname": "involved in education", "value": 8 },
                    "Engineering": { "abbrev": "ENG", "key": "Engineering", "label": "Engineering", "shortname": "involved in engineering", "value": 9 },
                    "Entertainment": { "abbrev": "ENT", "key": "Entertainment", "label": "Entertainment", "shortname": "involved in entertainment", "value": 21 },
                    "Homemaker": { "abbrev": "HOM", "key": "Homemaker", "label": "Homemaker", "shortname": "a homemaker", "value": 10 },
                    "Journalism": { "abbrev": "JOU", "key": "Journalism", "label": "Journalism", "shortname": "a journalist", "value": 11 },
                    "Labor": { "abbrev": "LAB", "key": "Labor", "label": "Labor", "shortname": "involved with labor", "value": 12 },
                    "LawEnforcement": { "abbrev": "LEN", "key": "LawEnforcement", "label": "Law Enforcement", "shortname": "involved with law enforcement", "value": 13 },
                    "Legal": { "abbrev": "LAW", "key": "Legal", "label": "Legal", "shortname": "involved with the legal industry", "value": 15 },
                    "Lobbyist": { "abbrev": "LOB", "key": "Lobbyist", "label": "Lobbyist", "shortname": "a government relations professional", "value": 14 },
                    "Medicine": { "abbrev": "MED", "key": "Medicine", "label": "Medicine", "shortname": "involved in medicine", "value": 16 },
                    "Military": { "abbrev": "MIL", "key": "Military", "label": "Military", "shortname": "served in the military", "value": 17 },
                    "NULL": { "abbrev": "NULL", "key": "NULL", "label": "Null", "shortname": "not available", "value": 0 },
                    "Other": { "abbrev": "OTH", "key": "Other", "label": "Other", "shortname": "", "value": 23 },
                    "Public": { "abbrev": "PUB", "key": "Public", "label": "Public Official", "shortname": "a public official", "value": 19 },
                    "RealEstate": { "abbrev": "REL", "key": "RealEstate", "label": "Real Estate", "shortname": "involved in real estate", "value": 20 },
                    "Sports": { "abbrev": "PRO", "key": "Sports", "label": "Professional Sports", "shortname": "a professional athlete", "value": 18 },
                    "Volunteer": { "abbrev": "VOL", "key": "Volunteer", "label": "Volunteer", "shortname": "involved in the non-profit sector", "value": 22 },
                    "__is_enum": true
                },
                "OfficeType": {
                    "Campaign": { "icon": "fa-flag", "key": "Campaign", "label": "Campaign Office", "value": 4 },
                    "Capitol": { "icon": "fa-bank", "key": "Capitol", "label": "Capitol Office", "value": 1 },
                    "District": { "icon": "fa-users", "key": "District", "label": "District Office", "value": 2 },
                    "Executive": { "icon": "fa-star", "key": "Executive", "label": "Executive Office", "value": 5 },
                    "LocalExecutive": { "icon": "", "key": "LocalExecutive", "label": "Local Executive Office", "value": 6 },
                    "Transition": { "icon": "fa-users", "key": "Transition", "label": "Transition Office", "value": 3 },
                    "Unknown": { "icon": "", "key": "Unknown", "label": "" },
                    "__is_enum": true
                },
                "Party": {
                    "Bipartisan": {
                        "abbrev": "BP",
                        "class_name": "bipartisan",
                        "color": "#b4bcc2",
                        "key": "Bipartisan",
                        "label": "Bipartisan",
                        "order": 6,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 6,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Democrat": {
                        "abbrev": "D",
                        "class_name": "democrat",
                        "color": "#1f77b4",
                        "key": "Democrat",
                        "label": "Democrat",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 1,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Independent": {
                        "abbrev": "I",
                        "class_name": "independent",
                        "color": "#8C564B",
                        "key": "Independent",
                        "label": "Independent",
                        "order": 2,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 3,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Libertarian": {
                        "abbrev": "LIB",
                        "class_name": "libertarian",
                        "color": "#b4bcc2",
                        "key": "Libertarian",
                        "label": "Libertarian",
                        "order": 21,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 21,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "NoParty": {
                        "abbrev": "Non-Designated",
                        "class_name": "defaultPartyClass",
                        "color": "#b4bcc1",
                        "key": "NoParty",
                        "label": "Non-Designated",
                        "order": 7,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 0,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Other": {
                        "abbrev": "O",
                        "class_name": "other",
                        "color": "#b4bcc2",
                        "key": "Other",
                        "label": "Other",
                        "order": 4,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 4,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Republican": {
                        "abbrev": "R",
                        "class_name": "republican",
                        "color": "#D62728",
                        "key": "Republican",
                        "label": "Republican",
                        "order": 3,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 2,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "Shared": {
                        "abbrev": "S",
                        "class_name": "both",
                        "color": "#b4bcc2",
                        "key": "Shared",
                        "label": "Both",
                        "order": 5,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 5,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "__is_enum": true,
                    "alde": {
                        "abbrev": "RENEW",
                        "class_name": "alliance-of-liberals-and-democrats",
                        "color": "#FFD700",
                        "key": "alde",
                        "label": "Renew Europe Group",
                        "order": 21,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 11,
                        "wiw_abbrev": "RENEW",
                        "wiw_name": "Alliance of Liberals and Democrats for Europe"
                    },
                    "ecr": {
                        "abbrev": "ECR",
                        "class_name": "european-conservatives-and-reformists",
                        "color": "#0000FF",
                        "key": "ecr",
                        "label": "European Conservatives and Reformists Group",
                        "order": 20,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 10,
                        "wiw_abbrev": "ECR",
                        "wiw_name": "European Conservatives and Reformists Group"
                    },
                    "efdd": {
                        "abbrev": "EFDD",
                        "class_name": "europe-of-free-and-direct-democracy",
                        "color": "#24B9B9",
                        "key": "efdd",
                        "label": "Europe of Freedom and Direct Democracy",
                        "order": 24,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 14,
                        "wiw_abbrev": "EFD",
                        "wiw_name": "Europe of Freedom and Direct Democracy Group"
                    },
                    "enl": {
                        "abbrev": "ID",
                        "class_name": "europe-of-nations-and-freedom",
                        "color": "#2B3856",
                        "key": "enl",
                        "label": "Identity and Democracy Group",
                        "order": 25,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 15,
                        "wiw_abbrev": "ID",
                        "wiw_name": "Identity and Democracy Group"
                    },
                    "epp": {
                        "abbrev": "EPP",
                        "class_name": "european-peoples-party",
                        "color": "#3399FF",
                        "key": "epp",
                        "label": "European People's Party",
                        "order": 17,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 7,
                        "wiw_abbrev": "PPE",
                        "wiw_name": "Group of the European People\u2019s Party (Christian Democrats)"
                    },
                    "esn": {
                        "abbrev": "ESN",
                        "class_name": "europe-of-sovereign-nations",
                        "color": "#1F578A",
                        "key": "esn",
                        "label": "Europe of Sovereign Nations",
                        "order": 28,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 23,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "greens_efa": {
                        "abbrev": "Greens-EFA",
                        "class_name": "greens-european-free-alliance",
                        "color": "#009900",
                        "key": "greens_efa",
                        "label": "The Greens-European Free Alliance",
                        "order": 23,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 13,
                        "wiw_abbrev": "GREEN_EFA",
                        "wiw_name": "Group of the Greens/European Free Alliance"
                    },
                    "gue_ngl": {
                        "abbrev": "GUE-NGL",
                        "class_name": "european-united-left-nordic-green_left",
                        "color": "#990000",
                        "key": "gue_ngl",
                        "label": "The Left group in the European Parliament",
                        "order": 22,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 12,
                        "wiw_abbrev": "GUE_NGL",
                        "wiw_name": "The Left group in the European Parliament \u2014 GUE/NGL (The Left)"
                    },
                    "ni": {
                        "abbrev": "NI",
                        "class_name": "non-inscrits",
                        "color": "#ccc",
                        "key": "ni",
                        "label": "Non-Inscrits",
                        "order": 26,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 16,
                        "wiw_abbrev": "NI",
                        "wiw_name": "Non-attached Members"
                    },
                    "pfe": {
                        "abbrev": "PfE",
                        "class_name": "patriots-for-europe",
                        "color": "#2F1C59",
                        "key": "pfe",
                        "label": "Patriots for Europe",
                        "order": 27,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 22,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "pip": {
                        "abbrev": "PIP",
                        "class_name": "puerto-rican-independence-party",
                        "color": "#227d16",
                        "key": "pip",
                        "label": "Puerto Rican Independence Party",
                        "order": 29,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 19,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "pnp": {
                        "abbrev": "PNP",
                        "class_name": "new-progressive-party",
                        "color": "#203d8a",
                        "key": "pnp",
                        "label": "New Progressive Party",
                        "order": 27,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 17,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "ppd": {
                        "abbrev": "PPD",
                        "class_name": "popular-democratic-party",
                        "color": "#e81728",
                        "key": "ppd",
                        "label": "Popular Democratic Party",
                        "order": 28,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 18,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "ppt": {
                        "abbrev": "PPT",
                        "class_name": "working-peoples-party",
                        "color": "#62378d",
                        "key": "ppt",
                        "label": "Working People's Party",
                        "order": 30,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 20,
                        "wiw_abbrev": "",
                        "wiw_name": ""
                    },
                    "sd": {
                        "abbrev": "S&D",
                        "class_name": "socialists-and-democrats",
                        "color": "#FF0000",
                        "key": "sd",
                        "label": "Progressive Alliance of Socialists and Democrats",
                        "order": 18,
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 8,
                        "wiw_abbrev": "SD",
                        "wiw_name": "Group of the Progressive Alliance of Socialists and Democrats in the European Parliament"
                    }
                },
                "PayScaleType": {
                    "ExecutiveSchedule": { "abbrev": "EX", "key": "ExecutiveSchedule", "label": "Executive Schedule (EX)", "lc_payscale_id": 15, "order": 1, "value": 1 },
                    "GeneralSchedule14": { "abbrev": "GS-14", "key": "GeneralSchedule14", "label": "General Schedule 14 (GS-14)", "lc_payscale_id": 1411, "order": 4, "value": 5 },
                    "GeneralSchedule15": { "abbrev": "GS-15", "key": "GeneralSchedule15", "label": "General Schedule 15 (GS-15)", "lc_payscale_id": 17, "order": 3, "value": 3 },
                    "SeniorExecutiveService": { "abbrev": "ES", "key": "SeniorExecutiveService", "label": "Senior Executive Service (ES)", "lc_payscale_id": 16, "order": 2, "value": 2 },
                    "SeniorForeignService": { "abbrev": "FE", "key": "SeniorForeignService", "label": "Senior Foreign Service (FE)", "lc_payscale_id": 18, "order": 5, "value": 4 },
                    "__is_enum": true
                },
                "PersonBiographyType": {
                    "__is_enum": true,
                    "almanac_biography": { "display_text": "Expanded", "key": "almanac_biography", "label": "Almanac Biography", "value": 7 },
                    "custom": { "display_text": "Custom", "key": "custom", "label": "Custom", "value": 6 },
                    "declaration_of_interest": { "display_text": "Declaration of Interests", "key": "declaration_of_interest", "label": "Declaration of Interests", "value": 5 },
                    "eu_biography": { "display_text": "Official", "key": "eu_biography", "label": "European Union Biography", "value": 2 },
                    "eu_cv": { "display_text": "CV", "key": "eu_cv", "label": "European Union CV", "value": 8 },
                    "eu_responsibilities": { "display_text": "Responsibilities", "key": "eu_responsibilities", "label": "European Union Responsibilities", "value": 4 },
                    "ie_biography": { "display_text": "Official", "key": "ie_biography", "label": "International Biography", "value": 9 },
                    "intrado_biography": { "display_text": "Biography", "key": "intrado_biography", "label": "Intrado Biography", "value": 10 },
                    "kw_biography": { "display_text": "Official", "key": "kw_biography", "label": "Know Who Biography", "value": 1 },
                    "quorum_biography": { "display_text": "Quorum", "key": "quorum_biography", "label": "Quorum Biography", "value": 3 }
                },
                "PersonGeneralRole": {
                    "__is_enum": true,
                    "administrator": {
                        "feature_flags": ["ff_lc_kw_failover"],
                        "key": "administrator",
                        "label": "Other Administrators",
                        "order": 38,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 36
                    },
                    "assistant_secretary": {
                        "key": "assistant_secretary",
                        "label": "Assistant Secretary",
                        "order": 19,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 19
                    },
                    "attorney_general": {
                        "key": "attorney_general",
                        "label": "Attorney General",
                        "order": 16,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [12],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 16
                    },
                    "campaign_staffer": {
                        "feature_flags": ["ff_lc_kw_failover"],
                        "key": "campaign_staffer",
                        "label": "Campaign Staff",
                        "order": 24,
                        "outbox": true,
                        "person_type": 2,
                        "role_sub_type": 5,
                        "role_types": [10],
                        "staffer_type": 5,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 24
                    },
                    "city_admin": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "city_admin",
                        "label": "City Administrator",
                        "order": 37,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 40
                    },
                    "city_clerk": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "city_clerk",
                        "label": "City Clerk",
                        "order": 40,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 42
                    },
                    "city_county_executive": {
                        "key": "city_county_executive",
                        "label": "County Executive",
                        "order": 33,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 34
                    },
                    "city_police_chief": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "city_police_chief",
                        "label": "City Police Chief",
                        "order": 42,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 44
                    },
                    "committee_staffer": {
                        "key": "committee_staffer",
                        "label": "Committee Staff",
                        "order": 12,
                        "outbox": true,
                        "person_type": 2,
                        "role_sub_type": 3,
                        "role_types": [10],
                        "staffer_type": 3,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 12
                    },
                    "county_admin": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "county_admin",
                        "label": "County Administrator",
                        "order": 36,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 39
                    },
                    "county_clerk": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "county_clerk",
                        "label": "County Clerk",
                        "order": 39,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 41
                    },
                    "county_legislator": {
                        "key": "county_legislator",
                        "label": "County Legislator",
                        "order": 5,
                        "outbox": false,
                        "person_type": 1,
                        "role_types": [23],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 5
                    },
                    "county_sheriff": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "key": "county_sheriff",
                        "label": "County Sheriff",
                        "order": 41,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 43
                    },
                    "department_secretary": {
                        "key": "department_secretary",
                        "label": "Department Secretary",
                        "order": 17,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 17
                    },
                    "deputy_assistant_secretary": {
                        "key": "deputy_assistant_secretary",
                        "label": "Deputy Assistant Secretary",
                        "order": 20,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 20
                    },
                    "deputy_secretary": {
                        "key": "deputy_secretary",
                        "label": "Deputy Secretary",
                        "order": 18,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 18
                    },
                    "deputy_under_secretary": {
                        "key": "deputy_under_secretary",
                        "label": "Deputy Under Secretary",
                        "order": 22,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 22
                    },
                    "eu_commissioner": {
                        "key": "eu_commissioner",
                        "label": "Commissioner",
                        "order": 28,
                        "outbox": false,
                        "person_type": 3,
                        "role_types": [25],
                        "supported_regions": [106],
                        "value": 28
                    },
                    "eu_council_minister": {
                        "key": "eu_council_minister",
                        "label": "Council of the EU Minister",
                        "order": 31,
                        "outbox": false,
                        "person_type": 3,
                        "role_types": [27],
                        "supported_regions": [106],
                        "value": 31
                    },
                    "eu_councilmember": {
                        "key": "eu_councilmember",
                        "label": "European Council Member",
                        "order": 30,
                        "outbox": false,
                        "person_type": 3,
                        "role_types": [26],
                        "supported_regions": [106],
                        "value": 30
                    },
                    "eu_mep": {
                        "key": "eu_mep",
                        "label": "MEP",
                        "order": 29,
                        "outbox": false,
                        "person_type": 1,
                        "role_types": [28],
                        "supported_regions": [106],
                        "value": 29
                    },
                    "eu_mep_candidate": {
                        "key": "eu_mep_candidate",
                        "label": "MEP Candidate",
                        "order": 38,
                        "outbox": false,
                        "person_type": 1,
                        "role_types": [38],
                        "supported_regions": [106],
                        "value": 38
                    },
                    "eu_permanent_representative": {
                        "key": "eu_permanent_representative",
                        "label": "Permanent Representation",
                        "order": 32,
                        "outbox": false,
                        "person_type": 3,
                        "role_types": [30],
                        "supported_regions": [106],
                        "value": 32
                    },
                    "executive_staffer": {
                        "key": "executive_staffer",
                        "label": "Executive Staff",
                        "order": 13,
                        "outbox": true,
                        "person_type": 2,
                        "role_sub_type": 4,
                        "role_types": [10],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 13
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislative",
                            "values": [1, 2, 3, 4, 6, 5]
                        },
                        {
                            "display": "list",
                            "title": "Executive",
                            "values": [17, 18, 19, 20, 21, 22, 23, 10, 15, 16, 23, 34, 33, 35, 39, 40, 36, 41, 42, 43, 44]
                        },
                        {
                            "display": "list",
                            "title": "Officials",
                            "values": [28, 29, 38, 30, 31, 32]
                        },
                        {
                            "display": "list",
                            "title": "Staffers",
                            "values": [11, 12, 13, 14]
                        }
                    ],
                    "governor": {
                        "key": "governor",
                        "label": "Governor",
                        "order": 10,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [12],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 10
                    },
                    "judiciary_law_enforcement": {
                        "feature_flags": ["ff_lc_kw_failover"],
                        "key": "judiciary_law_enforcement",
                        "label": "Judiciary / Law Enforcement",
                        "order": 35,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 35
                    },
                    "leadership_staffer": {
                        "key": "leadership_staffer",
                        "label": "Leadership Staff",
                        "order": 14,
                        "outbox": true,
                        "person_type": 2,
                        "role_sub_type": 2,
                        "role_types": [10],
                        "staffer_type": 2,
                        "supported_regions": [1, 10000],
                        "value": 14
                    },
                    "legislator_staffer": {
                        "key": "legislator_staffer",
                        "label": "Legislative Staff",
                        "order": 11,
                        "outbox": true,
                        "person_type": 2,
                        "role_sub_type": 1,
                        "role_types": [10],
                        "staffer_type": 1,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 11
                    },
                    "lt_governor": {
                        "key": "lt_governor",
                        "label": "Lt. Governor",
                        "order": 15,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [12],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 15
                    },
                    "mayor": {
                        "key": "mayor",
                        "label": "City Mayor",
                        "order": 34,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [21, 22],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 33
                    },
                    "municipal_legislator": {
                        "key": "municipal_legislator",
                        "label": "City Legislator",
                        "order": 6,
                        "outbox": true,
                        "person_type": 1,
                        "role_types": [24],
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 6
                    },
                    "other_executive": {
                        "key": "other_executive",
                        "label": "Other",
                        "order": 43,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11, 12, 21, 22, 25, 29, 30, 26, 27],
                        "value": 37
                    },
                    "region_groups": [
                        {
                            "display": "list",
                            "key": "legislators_all",
                            "regions": ["all"],
                            "title": "Legislators",
                            "values": [1, 2, 3, 4, 6, 5]
                        },
                        {
                            "display": "list",
                            "key": "legislators_federal",
                            "regions": ["us"],
                            "title": "Legislators",
                            "values": [1, 2]
                        },
                        {
                            "display": "list",
                            "key": "legislators_states",
                            "regions": ["states"],
                            "title": "Legislators",
                            "values": [3, 4]
                        },
                        {
                            "display": "list",
                            "key": "legislators_local",
                            "regions": ["local"],
                            "title": "Legislators",
                            "values": [6, 5]
                        },
                        {
                            "display": "list",
                            "key": "executives_all",
                            "regions": ["all"],
                            "title": "Executives",
                            "values": [17, 18, 19, 20, 21, 22, 23, 10, 15, 16, 23, 34, 33, 35, 39, 40, 36, 41, 42, 43, 44]
                        },
                        {
                            "display": "list",
                            "key": "execs_federal",
                            "regions": ["us"],
                            "title": "Executives",
                            "values": [17, 18, 19, 20, 21, 22, 23]
                        },
                        {
                            "display": "list",
                            "key": "execs_states",
                            "regions": ["states"],
                            "title": "Executives",
                            "values": [10, 15, 16, 23]
                        },
                        {
                            "display": "list",
                            "key": "executives_local",
                            "regions": ["local"],
                            "title": "Executives",
                            "values": [34, 33, 35, 39, 40, 36, 41, 42, 43, 44]
                        },
                        {
                            "display": "list",
                            "key": "eu_all",
                            "regions": ["eu"],
                            "title": "EU Officials",
                            "values": [28, 29, 38, 30, 31, 32]
                        },
                        {
                            "display": "list",
                            "key": "staffers_all",
                            "regions": ["us", "states", "all"],
                            "title": "Staffers",
                            "values": [11, 12, 13, 14]
                        }
                    ],
                    "representative": {
                        "key": "representative",
                        "label": "Representative",
                        "order": 2,
                        "outbox": false,
                        "person_type": 1,
                        "role_types": [2],
                        "supported_regions": [1, 10000],
                        "value": 2
                    },
                    "senator": {
                        "key": "senator",
                        "label": "Senator",
                        "order": 1,
                        "outbox": false,
                        "person_type": 1,
                        "role_types": [1],
                        "supported_regions": [1, 10000],
                        "value": 1
                    },
                    "state_rep_assembly": {
                        "key": "state_rep_assembly",
                        "label": "State Representative",
                        "order": 4,
                        "outbox": true,
                        "person_type": 1,
                        "role_types": [6, 9, 8],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "state_senator_council": {
                        "key": "state_senator_council",
                        "label": "State Senator",
                        "order": 3,
                        "outbox": true,
                        "person_type": 1,
                        "role_types": [5, 7],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "treasurer": {
                        "key": "treasurer",
                        "label": "Treasurer",
                        "order": 23,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [12, 11],
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 23
                    },
                    "under_secretary": {
                        "key": "under_secretary",
                        "label": "Under Secretary",
                        "order": 21,
                        "outbox": true,
                        "person_type": 3,
                        "role_types": [11],
                        "supported_regions": [1, 10000],
                        "value": 21
                    }
                },
                "PersonLeadershipType": {
                    "__is_enum": true,
                    "caucus_leader": {
                        "include_regex": "Caucus|Conference|Chair",
                        "key": "caucus_leader",
                        "label": "Caucus or Conference Leader",
                        "party_based": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Filters for party leadership that isn't represented by the other options. Includes Conference Chairs, Vice Chairs, Caucus Chairs, etc.",
                        "value": 9
                    },
                    "majority_leader": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )(?<!Counsel to the  )Majority (Floor )?Leader(?![^,]*(Pro Tem|Emeritus))",
                        "key": "majority_leader",
                        "label": "Majority Leader",
                        "party_based": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "majority_whip": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )Majority Whip(?![^,]*(Pro Tem|Emeritus))|(Assistant|Deputy) Majority Leader(?![^,]*(Pro Tem|Emeritus))",
                        "key": "majority_whip",
                        "label": "Majority Whip / Assistant Leader",
                        "party_based": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 7
                    },
                    "minority_leader": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )(?<!Counsel to the )Minority (Floor )?Leader(?![^,]*(Pro Tem|Emeritus))",
                        "key": "minority_leader",
                        "label": "Minority Leader",
                        "party_based": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6
                    },
                    "minority_whip": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )Minority Whip(?![^,]*(Pro Tem|Emeritus))|(Assistant|Deputy) Minority Leader(?![^,]*(Pro Tem|Emeritus))",
                        "key": "minority_whip",
                        "label": "Minority Whip / Assistant Leader",
                        "party_based": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 8
                    },
                    "other": {
                        "include_regex": ".*",
                        "key": "other",
                        "label": "Other Leadership Role",
                        "party_based": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "tip": "Filters for any type of leadership role including Associates and other not listed types.",
                        "value": 10
                    },
                    "president": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )President(?![^,]*(Pro Tem|Emeritus))",
                        "key": "president",
                        "label": "Senate President",
                        "party_based": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "president_pro_tempore": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )President[^,]*Pro Temp?o?r?e?(?![^,]*Emeritus)",
                        "key": "president_pro_tempore",
                        "label": "President Pro Tempore",
                        "party_based": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "speaker": {
                        "include_regex": "^(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )Speaker(?![^,]*(Pro Tem|Emeritus))",
                        "key": "speaker",
                        "label": "Speaker",
                        "party_based": false,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "speaker_pro_tempore": {
                        "include_regex": "(?<!Assistant )(?<!Deputy )(?<!Vice )(?<!Associate )Speaker[^,]*Pro Temp?o?r?e?(?![^,]*Emeritus)",
                        "key": "speaker_pro_tempore",
                        "label": "Speaker Pro Tempore",
                        "party_based": false,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    }
                },
                "PersonStatus": {
                    "__is_enum": true,
                    "active": { "key": "active", "label": "Continuing", "value": 1 },
                    "former": { "key": "former", "label": "Former", "value": 4 },
                    "incoming": { "key": "incoming", "label": "Incoming", "value": 2 },
                    "leaving": { "key": "leaving", "label": "Outgoing", "value": 3 }
                },
                "PersonType": {
                    "__is_enum": true,
                    "eu_person": { "is_official": true, "key": "eu_person", "label": "Person", "permission_name": "qp_legislators", "proxy": "Person", "quorum_data_type": 1, "value": 7 },
                    "executive": { "is_official": true, "key": "executive", "label": "Executive", "permission_name": "qp_executives", "proxy": "Executive", "quorum_data_type": 30, "value": 3 },
                    "judiciary": { "is_official": true, "key": "judiciary", "label": "Judiciary", "permission_name": "qp_legislative_data", "proxy": "Person", "quorum_data_type": 1, "value": 8 },
                    "local_member": { "is_official": true, "key": "local_member", "label": "Local Member", "permission_name": "qp_legislators", "proxy": "LocalMember", "quorum_data_type": 33, "value": 6 },
                    "member": { "is_official": true, "key": "member", "label": "Member", "permission_name": "qp_legislators", "proxy": "Member", "quorum_data_type": 29, "value": 1 },
                    "press_contact": { "is_official": false, "key": "press_contact", "label": "Press Contact", "permission_name": "qp_media_relations", "proxy": "Person", "quorum_data_type": 120, "value": 9 },
                    "staffer": { "is_official": false, "key": "staffer", "label": "Staffer", "permission_name": "qp_staffers", "proxy": "NewStaffer", "quorum_data_type": 8, "value": 2 }
                },
                "PublicOrganizationType": {
                    "__is_enum": true,
                    "_ph_caucus": {
                        "key": "_ph_caucus",
                        "kw_code": "",
                        "label": "Caucus",
                        "supported_regions": [],
                        "value": 1049
                    },
                    "_ph_committee": {
                        "key": "_ph_committee",
                        "kw_code": "",
                        "label": "Committee",
                        "supported_regions": [],
                        "value": 1020
                    },
                    "_ph_county_office": {
                        "key": "_ph_county_office",
                        "kw_code": "",
                        "label": "County Office",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 1003
                    },
                    "_ph_fed_campaign_office": {
                        "key": "_ph_fed_campaign_office",
                        "kw_code": "",
                        "label": "Federal Campaign Office",
                        "supported_regions": [],
                        "value": 1050
                    },
                    "_ph_fed_exec_candidacy": {
                        "key": "_ph_fed_exec_candidacy",
                        "kw_code": "",
                        "label": "Federal Executive Candidacy",
                        "supported_regions": [],
                        "value": 1047
                    },
                    "_ph_fed_leg_candidacy": {
                        "key": "_ph_fed_leg_candidacy",
                        "kw_code": "",
                        "label": "Federal Legislative Candidacy",
                        "supported_regions": [],
                        "value": 1045
                    },
                    "_ph_federal_legislative_leadership_office": {
                        "key": "_ph_federal_legislative_leadership_office",
                        "kw_code": "",
                        "label": "Federal Legislative Leadership Office",
                        "supported_regions": [],
                        "value": 1001
                    },
                    "_ph_muni_office": {
                        "key": "_ph_muni_office",
                        "kw_code": "",
                        "label": "Municipal Office",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 1004
                    },
                    "_ph_only": {
                        "key": "_ph_only",
                        "kw_code": "",
                        "label": "N/A",
                        "supported_regions": [],
                        "value": 999
                    },
                    "_ph_sta_campaign": {
                        "key": "_ph_sta_campaign",
                        "kw_code": "",
                        "label": "State Campaign",
                        "supported_regions": [],
                        "value": 1052
                    },
                    "_ph_sta_campaign_office": {
                        "key": "_ph_sta_campaign_office",
                        "kw_code": "",
                        "label": "State Campaign Office",
                        "supported_regions": [],
                        "value": 1051
                    },
                    "_ph_sta_exec_candidacy": {
                        "key": "_ph_sta_exec_candidacy",
                        "kw_code": "",
                        "label": "State Executive Candidacy",
                        "supported_regions": [],
                        "value": 1048
                    },
                    "_ph_sta_leg_candidacy": {
                        "key": "_ph_sta_leg_candidacy",
                        "kw_code": "",
                        "label": "State Legislative Candidacy",
                        "supported_regions": [],
                        "value": 1046
                    },
                    "_ph_state_legislative_leadership_office": {
                        "key": "_ph_state_legislative_leadership_office",
                        "kw_code": "",
                        "label": "State Legislative Leadership Office",
                        "supported_regions": [],
                        "value": 1002
                    },
                    "charity": {
                        "key": "charity",
                        "kw_code": "",
                        "label": "Charity",
                        "permission_enum": [214],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 36
                    },
                    "council_configuration": {
                        "key": "council_configuration",
                        "kw_code": "",
                        "label": "Council Configuration",
                        "supported_regions": [106],
                        "value": 27
                    },
                    "council_preparatory_body": {
                        "key": "council_preparatory_body",
                        "kw_code": "",
                        "label": "Council Preparatory Body",
                        "supported_regions": [106],
                        "value": 28
                    },
                    "county": {
                        "key": "county",
                        "kw_code": "",
                        "label": "County",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 16
                    },
                    "county_executive": {
                        "key": "county_executive",
                        "kw_code": "",
                        "label": "County Executive",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 18
                    },
                    "county_judicial": {
                        "key": "county_judicial",
                        "kw_code": "",
                        "label": "County Judicial",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 20
                    },
                    "county_legislative": {
                        "key": "county_legislative",
                        "kw_code": "",
                        "label": "County Legislative",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 19
                    },
                    "custom": {
                        "key": "custom",
                        "kw_code": "",
                        "label": "Custom",
                        "permission_enum": [204],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 1
                    },
                    "directorate_general": {
                        "key": "directorate_general",
                        "kw_code": "",
                        "label": "Directorate General",
                        "supported_regions": [106],
                        "value": 15
                    },
                    "eu_general_institution": {
                        "key": "eu_general_institution",
                        "kw_code": "",
                        "label": "EU Institution",
                        "supported_regions": [106],
                        "value": 13
                    },
                    "federal_executive": {
                        "key": "federal_executive",
                        "kw_code": "",
                        "label": "Federal Executive Branch",
                        "permission_enum": [301],
                        "supported_regions": [1, 10000],
                        "value": 24
                    },
                    "federal_executive_agency": {
                        "key": "federal_executive_agency",
                        "kw_code": "FEA",
                        "label": "Federal Executive Agency",
                        "permission_enum": [301],
                        "supported_regions": [1, 10000],
                        "value": 9
                    },
                    "federal_executive_department": {
                        "key": "federal_executive_department",
                        "kw_code": "FED",
                        "label": "Federal Executive Department",
                        "permission_enum": [301],
                        "supported_regions": [1, 10000],
                        "value": 8
                    },
                    "federal_executive_office": {
                        "key": "federal_executive_office",
                        "kw_code": "FEO",
                        "label": "Federal Executive Office",
                        "permission_enum": [301],
                        "supported_regions": [1, 10000],
                        "value": 7
                    },
                    "federal_judiciary": {
                        "key": "federal_judiciary",
                        "kw_code": "",
                        "label": "Federal Judicial Branch",
                        "supported_regions": [],
                        "value": 29
                    },
                    "federal_legislative_office": {
                        "key": "federal_legislative_office",
                        "kw_code": "",
                        "label": "Federal Legislative Office",
                        "permission_enum": [300],
                        "supported_regions": [1, 10000],
                        "value": 5
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Custom",
                            "values": [1]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Bodies",
                            "values": [2, 3, 4]
                        },
                        {
                            "display": "list",
                            "title": "Legislative Offices",
                            "values": [5, 6]
                        },
                        {
                            "display": "list",
                            "title": "Executive Organizations",
                            "values": [24, 7, 9, 8, 25, 10, 12, 11]
                        },
                        {
                            "display": "list",
                            "title": "Institutions",
                            "values": [13, 14, 15, 27, 28]
                        },
                        {
                            "display": "list",
                            "title": "Local Organizations",
                            "values": [16, 1003, 17, 1004, 37]
                        }
                    ],
                    "government": {
                        "key": "government",
                        "kw_code": "",
                        "label": "Government (all branches)",
                        "permission_enum": [300, 301],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 1, 10000],
                        "value": 26
                    },
                    "legislative_body": {
                        "key": "legislative_body",
                        "kw_code": "",
                        "label": "Legislative Body",
                        "permission_enum": [300],
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "lower_legislative_body": {
                        "key": "lower_legislative_body",
                        "kw_code": "",
                        "label": "Lower Legislative Body",
                        "permission_enum": [300],
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "municipality": {
                        "key": "municipality",
                        "kw_code": "",
                        "label": "Municipality",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 17
                    },
                    "municipality_executive": {
                        "key": "municipality_executive",
                        "kw_code": "",
                        "label": "Municipality Executive",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 21
                    },
                    "municipality_judicial": {
                        "key": "municipality_judicial",
                        "kw_code": "",
                        "label": "Municipality Judicial",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 23
                    },
                    "municipality_legislative": {
                        "key": "municipality_legislative",
                        "kw_code": "",
                        "label": "Municipality Legislative",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 22
                    },
                    "outlet": {
                        "key": "outlet",
                        "kw_code": "",
                        "label": "Media Outlet",
                        "permission_enum": [105],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 35
                    },
                    "school_district_office": {
                        "key": "school_district_office",
                        "kw_code": "",
                        "label": "School District Office",
                        "supported_regions": [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 10002, 10000],
                        "value": 37
                    },
                    "secretariat_general": {
                        "key": "secretariat_general",
                        "kw_code": "",
                        "label": "Secretariat General",
                        "supported_regions": [106],
                        "value": 14
                    },
                    "state_executive": {
                        "key": "state_executive",
                        "kw_code": "",
                        "label": "State Executive Branch",
                        "permission_enum": [301],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 25
                    },
                    "state_executive_agency": {
                        "key": "state_executive_agency",
                        "kw_code": "SEA",
                        "label": "State Executive Agency",
                        "permission_enum": [301],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 12
                    },
                    "state_executive_department": {
                        "key": "state_executive_department",
                        "kw_code": "SED",
                        "label": "State Executive Department",
                        "permission_enum": [301],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 11
                    },
                    "state_executive_office": {
                        "key": "state_executive_office",
                        "kw_code": "SEO",
                        "label": "State Executive Office",
                        "permission_enum": [301],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 10
                    },
                    "state_judiciary": {
                        "key": "state_judiciary",
                        "kw_code": "",
                        "label": "State Judicial Branch",
                        "supported_regions": [],
                        "value": 30
                    },
                    "state_legislative_office": {
                        "key": "state_legislative_office",
                        "kw_code": "",
                        "label": "State Legislative Office",
                        "permission_enum": [300],
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6
                    },
                    "upper_legislative_body": {
                        "key": "upper_legislative_body",
                        "kw_code": "",
                        "label": "Upper Legislative Body",
                        "permission_enum": [300],
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    }
                },
                "Religion": {
                    "AfricanMethodist": { "icon": "&#10013;", "key": "AfricanMethodist", "kw_religionid": 2, "label": "African Methodist Episcopal", "value": 5 },
                    "Anglican": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "Anglican",
                        "kw_religionid": 43,
                        "label": "Anglican Catholic",
                        "value": 18
                    },
                    "AnglicanCatholic": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "AnglicanCatholic",
                        "kw_religionid": 48,
                        "label": "Anglican Catholic",
                        "value": 49
                    },
                    "Apostolic": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "Apostolic",
                        "kw_religionid": 3,
                        "label": "Apostolic Christian",
                        "value": 37
                    },
                    "AssemblyofGod": { "icon": "&#10013;", "key": "AssemblyofGod", "kw_religionid": 4, "label": "Assembly of God", "value": 32 },
                    "Atheist": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "Atheist",
                        "kw_religionid": 44,
                        "label": "Atheist",
                        "value": 35
                    },
                    "Baptist": { "icon": "&#10013;", "key": "Baptist", "kw_religionid": 5, "label": "Baptist", "value": 16 },
                    "BrethrenChurch": { "icon": "", "key": "BrethrenChurch", "kw_religionid": 45, "label": "Church of the Brethren", "value": 47 },
                    "Buddhism": { "icon": "&#9775;", "key": "Buddhism", "kw_religionid": 7, "label": "Buddhism", "value": 26 },
                    "Catholic": { "icon": "&#10013;", "key": "Catholic", "kw_religionid": 6, "label": "Catholic", "value": 1 },
                    "ChristianChurch": { "icon": "&#10013;", "key": "ChristianChurch", "kw_religionid": 8, "label": "Christian Church", "value": 19 },
                    "ChristianReformed": { "icon": "&#10013;", "key": "ChristianReformed", "kw_religionid": 9, "label": "Christian Reformed Church", "value": 10 },
                    "ChristianScientist": { "icon": "&#10013;", "key": "ChristianScientist", "kw_religionid": 10, "label": "Christian Scientist", "value": 28 },
                    "ChurchUnitedBrethren": { "icon": "", "key": "ChurchUnitedBrethren", "kw_religionid": 52, "label": "Church of the United Brethren in Christ", "value": 51 },
                    "ChurchofBrethren": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "ChurchofBrethren",
                        "kw_religionid": 37,
                        "label": "Church of the Brethren",
                        "value": 39
                    },
                    "ChurchofChrist": { "icon": "&#10013;", "key": "ChurchofChrist", "kw_religionid": 11, "label": "Church of Christ", "value": 34 },
                    "ChurchofGod": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "ChurchofGod",
                        "kw_religionid": 50,
                        "label": "Church of God",
                        "value": 7
                    },
                    "CommunityofChrist": { "icon": "&#10013;", "key": "CommunityofChrist", "kw_religionid": 47, "label": "Community of Christ", "value": 41 },
                    "Congregationalist": { "icon": "&#10013;", "key": "Congregationalist", "kw_religionid": 12, "label": "Congregationalist", "value": 22 },
                    "DisciplesofChrist": { "icon": "&#10013;", "key": "DisciplesofChrist", "kw_religionid": 13, "label": "Disciples of Christ", "value": 14 },
                    "EasternOrthodox": { "icon": "&#10013;", "key": "EasternOrthodox", "kw_religionid": 14, "label": "Eastern Orthodox", "value": 30 },
                    "Episcopalian": { "icon": "&#10013;", "key": "Episcopalian", "kw_religionid": 15, "label": "Episcopalian", "value": 2 },
                    "Evangelical": { "icon": "&#10013;", "key": "Evangelical", "kw_religionid": 42, "label": "Evangelical", "value": 15 },
                    "Foursquare": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "Foursquare",
                        "kw_religionid": 40,
                        "label": "Foursquare Church",
                        "value": 45
                    },
                    "FrenchHuguenot": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "FrenchHuguenot",
                        "kw_religionid": 16,
                        "label": "French Huguenot",
                        "value": 44
                    },
                    "FriedensthalMoravian": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "FriedensthalMoravian",
                        "kw_religionid": 17,
                        "label": "Friedensthal Moravian Church",
                        "value": 43
                    },
                    "GreekOrthodox": { "icon": "&#10013;", "key": "GreekOrthodox", "kw_religionid": 18, "label": "Greek Orthodox", "value": 3 },
                    "Hinduism": { "icon": "&#9784;", "key": "Hinduism", "kw_religionid": 19, "label": "Hinduism", "value": 6 },
                    "IndependentBibleChurch": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "IndependentBibleChurch",
                        "kw_religionid": 20,
                        "label": "Independent Bible Church",
                        "value": 42
                    },
                    "Islam": { "icon": "&#9770;", "key": "Islam", "kw_religionid": 22, "label": "Islam", "value": 13 },
                    "Jewish": { "icon": "&#10017;", "key": "Jewish", "kw_religionid": 21, "label": "Jewish", "value": 8 },
                    "LatterDaySaints": { "icon": "", "key": "LatterDaySaints", "kw_religionid": 53, "label": "Latter-Day Saints (LDS)", "value": 52 },
                    "Lutheran": { "icon": "&#10013;", "key": "Lutheran", "kw_religionid": 23, "label": "Lutheran", "value": 31 },
                    "Mennonite": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "Mennonite",
                        "kw_religionid": 39,
                        "label": "Mennonite",
                        "value": 36
                    },
                    "Methodist": { "icon": "&#10013;", "key": "Methodist", "kw_religionid": 24, "label": "Methodist", "value": 25 },
                    "Mormon": { "icon": "&#10013;", "key": "Mormon", "kw_religionid": 25, "label": "Mormon", "value": 9 },
                    "Nazarene": { "icon": "&#10013;", "key": "Nazarene", "kw_religionid": 26, "label": "Nazarene", "value": 20 },
                    "NoReligion": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "NoReligion",
                        "kw_religionid": 49,
                        "label": "None",
                        "value": 50
                    },
                    "NonDenominationalChristian": { "icon": "&#10013;", "key": "NonDenominationalChristian", "kw_religionid": 51, "label": "Christian - Non-Denominational", "value": 17 },
                    "Pentecostal": { "icon": "&#10013;", "key": "Pentecostal", "kw_religionid": 27, "label": "Pentecostal", "value": 23 },
                    "Presbyterian": { "icon": "&#10013;", "key": "Presbyterian", "kw_religionid": 28, "label": "Presbyterian", "value": 33 },
                    "Protestant": { "icon": "&#10013;", "key": "Protestant", "kw_religionid": 29, "label": "Protestant - Unspecified Christian", "value": 21 },
                    "Quaker": { "icon": "&#10013;", "key": "Quaker", "kw_religionid": 30, "label": "Quaker", "value": 40 },
                    "RLDS": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "RLDS",
                        "kw_religionid": 31,
                        "label": "Reorganized Church of Jesus Christ of Latter Day Saints",
                        "value": 48
                    },
                    "RomanCatholic": { "icon": "&#10013;", "key": "RomanCatholic", "kw_religionid": 32, "label": "Roman Catholic", "value": 12 },
                    "SeventhDayAdventist": { "icon": "&#10013;", "key": "SeventhDayAdventist", "kw_religionid": 33, "label": "Seventh-Day Adventist", "value": 11 },
                    "ShekinahFellowship": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "ShekinahFellowship",
                        "kw_religionid": 41,
                        "label": "Shekinah Fellowship",
                        "value": 46
                    },
                    "SouthernBaptist": { "icon": "&#10013;", "key": "SouthernBaptist", "kw_religionid": 46, "label": "Southern Baptist", "value": 29 },
                    "Unitarian": { "icon": "&#10013;", "key": "Unitarian", "kw_religionid": 34, "label": "Unitarian", "value": 4 },
                    "UnitedChurchChrist": { "icon": "&#10013;", "key": "UnitedChurchChrist", "kw_religionid": 35, "label": "United Church of Christ", "value": 27 },
                    "Unspecified": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "Unspecified",
                        "kw_religionid": 1,
                        "label": "Unspecified/Other",
                        "value": 38
                    },
                    "Wesleyan": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "&#10013;",
                        "key": "Wesleyan",
                        "kw_religionid": 38,
                        "label": "Wesleyan",
                        "value": 24
                    },
                    "_None": {
                        "hide_feature_flags": ["ff_lc_kw_failover"],
                        "icon": "",
                        "key": "_None",
                        "kw_religionid": 0,
                        "label": "None",
                        "value": 53
                    },
                    "__is_enum": true
                },
                "RoleType": {
                    "__is_enum": true,
                    "_ph_only": { "key": "_ph_only", "kw_code": "", "label": "PH Only Enum", "long_title": "", "precedence": 2, "profile_download": false, "short_title": "PH only enum", "state_id": "", "value": 999 },
                    "county_executive": { "geography_key": "most_recent_county", "geography_model": "County", "geography_model_full_path": "app.geography.models.County", "key": "county_executive", "kw_code": "", "label": "County Executive", "long_title": "", "person_type": 3, "precedence": 3, "primary_geo_shape_type": 4, "profile_download": true, "short_title": "", "staffer_type": 4, "state_id": "County Executive", "value": 21 },
                    "county_legislator": { "chamber": 3, "geography_key": "most_recent_county", "geography_model": "County", "geography_model_full_path": "app.geography.models.County", "key": "county_legislator", "kw_code": "", "label": "County Legislator", "long_title": "Councilor", "person_type": 6, "precedence": 3, "primary_geo_shape_type": 4, "profile_download": true, "short_title": "CM", "state_id": "", "value": 23 },
                    "eu_commissioner": { "key": "eu_commissioner", "kw_code": "", "label": "Commissioner", "long_title": "", "person_type": 3, "precedence": 1, "profile_download": false, "short_title": "", "staffer_type": 106, "state_id": "", "value": 25 },
                    "eu_council_minister": { "key": "eu_council_minister", "kw_code": "", "label": "Minister of the Council of the EU", "long_title": "", "person_type": 3, "precedence": 2, "profile_download": false, "short_title": "Minister", "state_id": "", "value": 27 },
                    "eu_councilmember": { "key": "eu_councilmember", "kw_code": "", "label": "European Council Representative", "long_title": "", "person_type": 3, "precedence": 2, "profile_download": false, "short_title": "", "state_id": "", "value": 26 },
                    "eu_mep": { "key": "eu_mep", "kw_code": "", "label": "MEP", "long_title": "", "person_type": 1, "precedence": 1, "primary_geo_shape_type": 1, "profile_download": false, "short_title": "MEP", "state_id": "", "value": 28 },
                    "eu_mep_candidate": { "key": "eu_mep_candidate", "kw_code": "", "label": "MEP Candidate", "long_title": "", "person_type": 1, "precedence": 2, "profile_download": false, "short_title": "MEP Candidate", "state_id": "", "value": 38 },
                    "eu_permanent_representative": { "key": "eu_permanent_representative", "kw_code": "", "label": "Permanent Representation", "long_title": "", "person_type": 3, "precedence": 2, "profile_download": false, "short_title": "", "state_id": "", "value": 30 },
                    "eu_person": { "key": "eu_person", "kw_code": "", "label": "EU Person", "long_title": "", "person_type": 3, "precedence": 8, "profile_download": false, "short_title": "", "state_id": "", "value": 29 },
                    "federal_executive": { "key": "federal_executive", "kw_code": "", "label": "Federal Executive", "long_title": "", "person_type": 3, "precedence": 1, "primary_geo_shape_type": 1, "profile_download": true, "short_title": "", "staffer_type": 4, "state_id": "Federal Executive", "value": 11 },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Federal Legislators",
                            "values": [1, 2]
                        },
                        {
                            "display": "list",
                            "title": "State Legislators",
                            "values": [5, 6, 7, 8, 9]
                        },
                        {
                            "display": "list",
                            "title": "Executives",
                            "values": [11, 12, 21, 22, 25, 29, 30, 26, 27]
                        },
                        {
                            "display": "list",
                            "title": "Staffers",
                            "values": [10]
                        },
                        {
                            "display": "list",
                            "title": "Person With Stats",
                            "values": [1, 2, 5, 6, 7, 8, 9, 11, 12]
                        },
                        {
                            "display": "list",
                            "title": "Local People",
                            "values": [21, 22, 23, 24]
                        }
                    ],
                    "municipal_executive": { "geography_key": "most_recent_municipality", "geography_model": "Municipality", "geography_model_full_path": "app.geography.models.Municipality", "key": "municipal_executive", "kw_code": "", "label": "Municipal Executive", "long_title": "", "person_type": 3, "precedence": 5, "primary_geo_shape_type": 7, "profile_download": true, "short_title": "", "staffer_type": 4, "state_id": "Municipal Executive", "value": 22 },
                    "municipal_legislator": { "chamber": 3, "geography_key": "most_recent_municipality", "geography_model": "Municipality", "geography_model_full_path": "app.geography.models.Municipality", "key": "municipal_legislator", "kw_code": "", "label": "City Council Member", "long_title": "Councilor", "person_type": 6, "precedence": 4, "primary_geo_shape_type": 7, "profile_download": true, "short_title": "CM", "state_id": "", "value": 24 },
                    "none": { "key": "none", "kw_code": "", "label": "No type found", "long_title": "", "precedence": 10, "profile_download": false, "short_title": "", "state_id": "" },
                    "pol_party_mem": { "key": "pol_party_mem", "kw_code": "", "label": "Political Party Member", "long_title": "", "person_type": 1, "precedence": 3, "profile_download": false, "short_title": "", "state_id": "", "value": 39 },
                    "representative": { "chamber": 2, "geography_key": "most_recent_district", "geography_model": "District", "geography_model_full_path": "app.geography.models.District", "geography_stats_model": "app.geography.models.DistrictStats", "key": "representative", "kw_code": "FH", "label": "Representative", "long_title": "Representative", "person_type": 1, "precedence": 1, "primary_geo_shape_type": 3, "profile_download": true, "short_title": "Rep.", "staffer_type": 1, "state_id": "", "value": 2 },
                    "senator": { "chamber": 1, "geography_key": "most_recent_state", "geography_model": "State", "geography_model_full_path": "app.geography.models.State", "geography_stats_model": "app.geography.models.StateStats", "key": "senator", "kw_code": "FS", "label": "Senator", "long_title": "Senator", "person_type": 1, "precedence": 1, "primary_geo_shape_type": 2, "profile_download": true, "short_title": "Sen.", "staffer_type": 1, "state_id": "", "value": 1 },
                    "staffer": { "key": "staffer", "kw_code": "", "label": "Staffer", "long_title": "", "person_type": 2, "precedence": 7, "profile_download": false, "short_title": "", "state_id": "Staffer", "value": 10 },
                    "state_assemblymember": { "chamber": 2, "geography_key": "most_recent_lower_district", "geography_model": "LowerLD", "geography_model_full_path": "app.geography.models.LowerLD", "geography_stats_model": "app.geography.models.LowerLDStats", "key": "state_assemblymember", "kw_code": "", "label": "Assembly Member", "long_title": "Assembly Member", "person_type": 1, "precedence": 3, "primary_geo_shape_type": 6, "profile_download": true, "short_title": "Assemb.", "staffer_type": 1, "state_id": "Assembly Member", "value": 9 },
                    "state_councilmember": { "chamber": 1, "geography_key": "most_recent_upper_district", "geography_model": "UpperLD", "geography_model_full_path": "app.geography.models.UpperLD", "geography_stats_model": "app.geography.models.UpperLDStats", "key": "state_councilmember", "kw_code": "", "label": "Council Member", "long_title": "Councilmember", "person_type": 1, "precedence": 2, "primary_geo_shape_type": 5, "profile_download": true, "short_title": "CM", "staffer_type": 1, "state_id": "Council Member", "value": 7 },
                    "state_delegate": { "chamber": 2, "geography_key": "most_recent_lower_district", "geography_model": "LowerLD", "geography_model_full_path": "app.geography.models.LowerLD", "geography_stats_model": "app.geography.models.LowerLDStats", "key": "state_delegate", "kw_code": "", "label": "Delegate", "long_title": "Delegate", "person_type": 1, "precedence": 2, "primary_geo_shape_type": 6, "profile_download": true, "short_title": "Del.", "staffer_type": 1, "state_id": "Delegate", "value": 8 },
                    "state_executive": { "geography_key": "most_recent_state", "geography_model": "State", "geography_model_full_path": "app.geography.models.State", "geography_stats_model": "app.geography.models.StateStats", "key": "state_executive", "kw_code": "", "label": "State Executive", "long_title": "", "person_type": 3, "precedence": 3, "primary_geo_shape_type": 2, "profile_download": true, "short_title": "", "staffer_type": 4, "state_id": "State Executive", "value": 12 },
                    "state_representative": { "chamber": 2, "geography_key": "most_recent_lower_district", "geography_model": "LowerLD", "geography_model_full_path": "app.geography.models.LowerLD", "geography_stats_model": "app.geography.models.LowerLDStats", "key": "state_representative", "kw_code": "SH", "label": "Representative ", "long_title": "Representative", "person_type": 1, "precedence": 2, "primary_geo_shape_type": 6, "profile_download": true, "short_title": "Rep.", "staffer_type": 1, "state_id": "Representative", "value": 6 },
                    "state_senator": { "chamber": 1, "geography_key": "most_recent_upper_district", "geography_model": "UpperLD", "geography_model_full_path": "app.geography.models.UpperLD", "geography_stats_model": "app.geography.models.UpperLDStats", "key": "state_senator", "kw_code": "SS", "label": "Senator ", "long_title": "Senator", "person_type": 1, "precedence": 2, "primary_geo_shape_type": 5, "profile_download": true, "short_title": "Sen.", "staffer_type": 1, "state_id": "Senator", "value": 5 }
                },
                "SenatorRank": {
                    "__is_enum": true,
                    "junior": { "key": "junior", "label": "Junior", "value": 2 },
                    "senior": { "key": "senior", "label": "Senior", "value": 1 }
                },
                "SpecificExecutiveRoleType": {
                    "__is_enum": true,
                    "adjutant_general": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "adjutant_general", "kw_code": "ADJGEN", "label": "Adjutant General", "rank": 1000, "show_in_quicksearch": false, "value": 142 },
                    "administrator": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "administrator", "kw_code": "ADMIN", "label": "Administrator", "rank": 1000, "show_in_quicksearch": false, "value": 143 },
                    "administrator_executive_director_ceo_chair": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "administrator_executive_director_ceo_chair", "kw_code": "CEOCHAIR", "label": "Administrator / Executive Director / CEO / Chair", "rank": 1000, "show_in_quicksearch": false, "value": 75 },
                    "advisor_counselor_analyst": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "advisor_counselor_analyst", "kw_code": "ADV", "label": "Advisor / Counselor / Analyst", "rank": 1000, "show_in_quicksearch": false, "value": 110 },
                    "agent": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "agent", "label": "Agent", "rank": 1000, "show_in_quicksearch": true, "value": 188 },
                    "agriculture_commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "agriculture_commissioner", "kw_code": "AGRI", "label": "Agriculture Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 144 },
                    "ambassador": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "ambassador", "label": "Ambassador", "rank": 1000, "show_in_quicksearch": true, "value": 183 },
                    "assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "assistant", "kw_code": "ASST", "label": "Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 72 },
                    "assistant_administrator_deputy_administrator": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "assistant_administrator_deputy_administrator", "kw_code": "AADA", "label": "Assistant Administrator / Deputy Administrator", "rank": 1000, "show_in_quicksearch": false, "value": 76 },
                    "assistant_associate_director": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "assistant_associate_director", "kw_code": "ASSOCDIR", "label": "Assistant Associate Director", "rank": 25, "show_in_quicksearch": false, "value": 18 },
                    "assistant_commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "assistant_commissioner", "kw_code": "ACOMM", "label": "Assistant Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 105 },
                    "assistant_director_deputy_director": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "assistant_director_deputy_director", "kw_code": "ADDD", "label": "Assistant Director / Deputy Director", "rank": 1000, "show_in_quicksearch": false, "value": 102 },
                    "assistant_manager": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "assistant_manager", "kw_code": "ASSTMGR", "label": "Assistant Manager", "rank": 1000, "show_in_quicksearch": false, "value": 93 },
                    "assistant_press_secretary": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "assistant_press_secretary", "kw_code": "ASSTPS", "label": "Assistant Press Secretary", "rank": 120, "show_in_quicksearch": false, "value": 40 },
                    "assistant_secretary": { "exec_role_type": 7, "has_individual_search_filter": true, "key": "assistant_secretary", "kw_code": "ASSTSEC", "label": "Assistant Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 89 },
                    "assistant_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "assistant_to_the_president", "kw_code": "PRES07", "label": "Assistant to the President", "rank": 10, "show_in_quicksearch": true, "value": 6 },
                    "assistant_to_the_vice_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "assistant_to_the_vice_president", "kw_code": "PRES10", "label": "Assistant to the Vice President", "rank": 10, "show_in_quicksearch": true, "value": 9 },
                    "assistant_trade_representative": { "exec_role_type": 4, "has_individual_search_filter": false, "key": "assistant_trade_representative", "kw_code": "ASSTUSTREP", "label": "Assistant Trade Representative", "rank": 51, "show_in_quicksearch": false, "value": 33 },
                    "assistant_treasurer_assistant_controller": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "assistant_treasurer_assistant_controller", "kw_code": "ATREAS", "label": "Assistant Treasurer / Assistant Controller", "rank": 1000, "show_in_quicksearch": false, "value": 99 },
                    "associate_counsel": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "associate_counsel", "kw_code": "ASSOCCNSL", "label": "Associate Counsel", "rank": 52, "show_in_quicksearch": false, "value": 27 },
                    "associate_director": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "associate_director", "kw_code": "ASSTDIR", "label": "Associate Director", "rank": 22, "show_in_quicksearch": false, "value": 17 },
                    "attorney_general": { "exec_role_type": 14, "has_individual_search_filter": true, "key": "attorney_general", "kw_code": "ATTYGEN", "label": "Attorney General", "rank": 10, "show_in_quicksearch": false, "value": 145 },
                    "attorney_general_other_administrator": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "attorney_general_other_administrator", "label": "Attorney General Other Administrator", "rank": 1000, "show_in_quicksearch": false, "value": 196 },
                    "auditor": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "auditor", "kw_code": "AUDIT", "label": "Auditor", "rank": 1000, "show_in_quicksearch": false, "value": 146 },
                    "branch_chief": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "branch_chief", "kw_code": "BRCHF", "label": "Branch Chief", "rank": 22, "show_in_quicksearch": false, "value": 24 },
                    "branch_manager": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "branch_manager", "kw_code": "BRMGR", "label": "Branch Manager", "rank": 1000, "show_in_quicksearch": false, "value": 95 },
                    "campaign_director": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "campaign_director", "kw_code": "CMD", "label": "Campaign Director", "rank": 1000, "show_in_quicksearch": false, "value": 121 },
                    "chairman": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "chairman", "kw_code": "CHM", "label": "Chairman", "rank": 20, "show_in_quicksearch": false, "value": 19 },
                    "chief": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "chief", "kw_code": "CHF", "label": "Chief", "rank": 20, "show_in_quicksearch": false, "value": 22 },
                    "chief_acquisitions_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_acquisitions_officer", "kw_code": "CAO", "label": "Chief Acquisitions Officer", "rank": 1000, "show_in_quicksearch": false, "value": 56 },
                    "chief_administrative_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_administrative_officer", "kw_code": "CMO", "label": "Chief Administrative Officer", "rank": 1000, "show_in_quicksearch": false, "value": 57 },
                    "chief_counsel_legal_affairs": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "chief_counsel_legal_affairs", "kw_code": "SC", "label": "Chief Counsel / Legal Affairs", "rank": 1000, "show_in_quicksearch": false, "value": 66 },
                    "chief_economist": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_economist", "kw_code": "CHFECON", "label": "Chief Economist", "rank": 100, "show_in_quicksearch": false, "value": 36 },
                    "chief_executive_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_executive_officer", "kw_code": "CEO", "label": "Chief Executive Officer", "rank": 1000, "show_in_quicksearch": false, "value": 147 },
                    "chief_financial_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_financial_officer", "kw_code": "CFO", "label": "Chief Financial Officer", "rank": 1000, "show_in_quicksearch": false, "value": 58 },
                    "chief_human_capital_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_human_capital_officer", "kw_code": "CHCO", "label": "Chief Human Capital Officer", "rank": 1000, "show_in_quicksearch": false, "value": 59 },
                    "chief_information_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_information_officer", "kw_code": "CIO", "label": "Chief Information Officer", "rank": 1000, "show_in_quicksearch": false, "value": 60 },
                    "chief_negotiator": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_negotiator", "kw_code": "CHFNEG", "label": "Chief Negotiator", "rank": 100, "show_in_quicksearch": false, "value": 34 },
                    "chief_of_staff_administration_management": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "chief_of_staff_administration_management", "kw_code": "COSADMIN", "label": "Chief of Staff / Administration / Management", "rank": 1000, "show_in_quicksearch": true, "value": 78 },
                    "chief_of_staff_deputy_chief_of_staff": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "chief_of_staff_deputy_chief_of_staff", "kw_code": "COS", "label": "Chief of Staff / Deputy Chief of Staff", "rank": 1000, "show_in_quicksearch": true, "value": 63 },
                    "chief_of_staff_executive_clerk": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "chief_of_staff_executive_clerk", "kw_code": "EC", "label": "Chief of Staff / Executive Clerk", "rank": 1000, "show_in_quicksearch": true, "value": 44 },
                    "chief_of_staff_president_vice_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "chief_of_staff_president_vice_president", "kw_code": "PRES05", "label": "Chief of Staff (President / Vice President)", "rank": 5, "show_in_quicksearch": true, "value": 4 },
                    "chief_technology_officer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "chief_technology_officer", "kw_code": "CTO", "label": "Chief Technology Officer", "rank": 1000, "show_in_quicksearch": false, "value": 61 },
                    "clerk": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "clerk", "label": "Clerk", "rank": 1000, "show_in_quicksearch": true, "value": 187 },
                    "commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "commissioner", "kw_code": "COMM", "label": "Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 104 },
                    "commissioner_superintendent": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "commissioner_superintendent", "kw_code": "COMSUP", "label": "Commissioner / Superintendent", "rank": 1000, "show_in_quicksearch": false, "value": 148 },
                    "committee_treasurer": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "committee_treasurer", "kw_code": "CT", "label": "Committee Treasurer", "rank": 1000, "show_in_quicksearch": false, "value": 125 },
                    "communications_director": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "communications_director", "kw_code": "COMDIR", "label": "Communications Director", "rank": 1000, "show_in_quicksearch": false, "value": 100 },
                    "communications_director_2": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "communications_director_2", "kw_code": "CD", "label": "Communications Director", "rank": 1000, "show_in_quicksearch": false, "value": 124 },
                    "congressional_legislative_intergovernmental_affairs": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "congressional_legislative_intergovernmental_affairs", "kw_code": "CONGAFRS", "label": "Congressional / Legislative / Intergovernmental Affairs", "rank": 1000, "show_in_quicksearch": false, "value": 62 },
                    "congressional_liaison": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "congressional_liaison", "kw_code": "LIAISON", "label": "Congressional Liaison", "rank": 1000, "show_in_quicksearch": false, "value": 97 },
                    "constituent_services_caseworker": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "constituent_services_caseworker", "kw_code": "CS", "label": "Constituent Services / Caseworker", "rank": 1000, "show_in_quicksearch": false, "value": 140 },
                    "controller_comptroller": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "controller_comptroller", "kw_code": "CONCOMP", "label": "Controller / Comptroller", "rank": 1000, "show_in_quicksearch": false, "value": 149 },
                    "coordinator": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "coordinator", "label": "Coordinator", "rank": 1000, "show_in_quicksearch": true, "value": 184 },
                    "council_chairman": { "exec_role_type": 12, "has_individual_search_filter": false, "key": "council_chairman", "kw_code": "CCHM", "label": "Council Chairman", "rank": 11, "show_in_quicksearch": false, "value": 129 },
                    "council_member": { "exec_role_type": 12, "has_individual_search_filter": false, "key": "council_member", "kw_code": "CMEM", "label": "Council Member", "rank": 15, "show_in_quicksearch": false, "value": 131 },
                    "council_vice_chairman": { "exec_role_type": 12, "has_individual_search_filter": false, "key": "council_vice_chairman", "kw_code": "CVCHM", "label": "Council Vice Chairman", "rank": 12, "show_in_quicksearch": false, "value": 130 },
                    "counsel": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "counsel", "kw_code": "CNSL", "label": "Counsel", "rank": 50, "show_in_quicksearch": false, "value": 25 },
                    "dc_district_director": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "dc_district_director", "kw_code": "DCDIR", "label": "DC District Director", "rank": 1000, "show_in_quicksearch": false, "value": 133 },
                    "department_director": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "department_director", "kw_code": "DD", "label": "Department Director", "rank": 1000, "show_in_quicksearch": false, "value": 138 },
                    "department_secretary": { "exec_role_type": 1, "has_individual_search_filter": true, "key": "department_secretary", "kw_code": "SEC", "label": "Department Secretary", "rank": 18, "show_in_quicksearch": true, "value": 85 },
                    "deputy_assistant_secretary": { "exec_role_type": 7, "has_individual_search_filter": true, "key": "deputy_assistant_secretary", "kw_code": "DEPASSTSEC", "label": "Deputy Assistant Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 90 },
                    "deputy_assistant_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "deputy_assistant_to_the_president", "kw_code": "PRES08", "label": "Deputy Assistant to the President", "rank": 1, "show_in_quicksearch": true, "value": 7 },
                    "deputy_assistant_to_the_vice_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "deputy_assistant_to_the_vice_president", "kw_code": "PRES11", "label": "Deputy Assistant to the Vice President", "rank": 1, "show_in_quicksearch": true, "value": 10 },
                    "deputy_attorney_general": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "deputy_attorney_general", "label": "Deputy Attorney General", "rank": 15, "show_in_quicksearch": false, "value": 170 },
                    "deputy_cfo_cio_cto": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "deputy_cfo_cio_cto", "kw_code": "DEPCFO", "label": "Deputy CFO / CIO / CTO", "rank": 1000, "show_in_quicksearch": false, "value": 69 },
                    "deputy_chief": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "deputy_chief", "kw_code": "DEPCHF", "label": "Deputy Chief", "rank": 21, "show_in_quicksearch": false, "value": 23 },
                    "deputy_chief_of_staff": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "deputy_chief_of_staff", "kw_code": "DEPCOS", "label": "Deputy Chief of Staff", "rank": 1000, "show_in_quicksearch": true, "value": 67 },
                    "deputy_chief_of_staff_deputy_executive_clerk": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "deputy_chief_of_staff_deputy_executive_clerk", "kw_code": "DEPEC", "label": "Deputy Chief of Staff / Deputy Executive Clerk", "rank": 1000, "show_in_quicksearch": true, "value": 45 },
                    "deputy_chief_of_staff_president_vice_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "deputy_chief_of_staff_president_vice_president", "kw_code": "PRES06", "label": "Deputy Chief of Staff (President / Vice President)", "rank": 6, "show_in_quicksearch": true, "value": 5 },
                    "deputy_counsel": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "deputy_counsel", "kw_code": "DEPCNSL", "label": "Deputy Counsel", "rank": 51, "show_in_quicksearch": false, "value": 26 },
                    "deputy_director": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "deputy_director", "kw_code": "DEPDIR", "label": "Deputy Director", "rank": 21, "show_in_quicksearch": false, "value": 16 },
                    "deputy_director_advisor_assistant_counsel": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "deputy_director_advisor_assistant_counsel", "kw_code": "DDAAC", "label": "Deputy Director / Advisor / Assistant / Counsel", "rank": 1000, "show_in_quicksearch": false, "value": 68 },
                    "deputy_director_general": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "deputy_director_general", "label": "Deputy Director General", "rank": 1000, "show_in_quicksearch": true, "value": 180 },
                    "deputy_press_secretary": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "deputy_press_secretary", "kw_code": "DEPPS", "label": "Deputy Press Secretary", "rank": 110, "show_in_quicksearch": false, "value": 39 },
                    "deputy_prime_minister": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "deputy_prime_minister", "label": "Deputy Prime Minister", "rank": 1000, "show_in_quicksearch": true, "value": 178 },
                    "deputy_secretary": { "exec_role_type": 7, "has_individual_search_filter": true, "key": "deputy_secretary", "kw_code": "DEPSEC", "label": "Deputy Secretary", "rank": 30, "show_in_quicksearch": false, "value": 86 },
                    "deputy_secretary_general": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "deputy_secretary_general", "label": "Deputy Secretary General", "rank": 1000, "show_in_quicksearch": true, "value": 179 },
                    "deputy_social_secretary": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "deputy_social_secretary", "kw_code": "DEPSOSECY", "label": "Deputy Social Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 48 },
                    "deputy_staff_secretary": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "deputy_staff_secretary", "kw_code": "DEPSSECY", "label": "Deputy Staff Secretary", "rank": 51, "show_in_quicksearch": false, "value": 30 },
                    "deputy_state_minister": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "deputy_state_minister", "label": "Deputy Minister", "rank": 1000, "show_in_quicksearch": true, "value": 175 },
                    "deputy_state_secretary": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "deputy_state_secretary", "label": "Deputy State Secretary", "rank": 1000, "show_in_quicksearch": true, "value": 173 },
                    "deputy_under_secretary": { "exec_role_type": 7, "has_individual_search_filter": true, "key": "deputy_under_secretary", "kw_code": "DEPUNDSEC", "label": "Deputy Under Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 88 },
                    "director": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "director", "kw_code": "DIR", "label": "Director", "rank": 20, "show_in_quicksearch": false, "value": 15 },
                    "director_general": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "director_general", "label": "Director General", "rank": 1000, "show_in_quicksearch": true, "value": 181 },
                    "director_of_economic_development": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_economic_development", "kw_code": "DIRECON", "label": "Director of Economic Development", "rank": 1000, "show_in_quicksearch": false, "value": 150 },
                    "director_of_environment": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_environment", "kw_code": "ENVIRON", "label": "Director of Environment", "rank": 1000, "show_in_quicksearch": false, "value": 151 },
                    "director_of_housing_and_community_development": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_housing_and_community_development", "kw_code": "HOUSING", "label": "Director of Housing and Community Development", "rank": 1000, "show_in_quicksearch": false, "value": 152 },
                    "director_of_human_services": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_human_services", "kw_code": "HUMAN", "label": "Director of Human Services", "rank": 1000, "show_in_quicksearch": false, "value": 153 },
                    "director_of_public_safety": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_public_safety", "kw_code": "PUBSAFE", "label": "Director of Public Safety", "rank": 1000, "show_in_quicksearch": false, "value": 154 },
                    "director_of_public_works_transportation": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_public_works_transportation", "kw_code": "PUBWORKS", "label": "Director of Public Works / Transportation", "rank": 1000, "show_in_quicksearch": false, "value": 155 },
                    "director_of_tourism": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "director_of_tourism", "kw_code": "TOUR", "label": "Director of Tourism", "rank": 1000, "show_in_quicksearch": false, "value": 156 },
                    "director_staff_director": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "director_staff_director", "kw_code": "DIRSD", "label": "Director / Staff Director", "rank": 1000, "show_in_quicksearch": false, "value": 77 },
                    "district_office_director": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "district_office_director", "kw_code": "DISTDIR", "label": "District Office Director", "rank": 1000, "show_in_quicksearch": false, "value": 132 },
                    "economist": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "economist", "kw_code": "ECON", "label": "Economist", "rank": 1000, "show_in_quicksearch": false, "value": 107 },
                    "elections_director": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "elections_director", "kw_code": "ELECT", "label": "Elections Director", "rank": 1000, "show_in_quicksearch": false, "value": 157 },
                    "engineer": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "engineer", "kw_code": "ENG", "label": "Engineer", "rank": 1000, "show_in_quicksearch": false, "value": 108 },
                    "equal_employment_opportunity": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "equal_employment_opportunity", "kw_code": "EEOC", "label": "Equal Employment Opportunity", "rank": 1000, "show_in_quicksearch": false, "value": 83 },
                    "executive_assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "executive_assistant", "kw_code": "EA", "label": "Executive Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 52 },
                    "executive_assistant_personal_assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "executive_assistant_personal_assistant", "kw_code": "EAPA", "label": "Executive Assistant / Personal Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 139 },
                    "executive_secretary": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "executive_secretary", "kw_code": "ES", "label": "Executive Secretary", "rank": 52, "show_in_quicksearch": false, "value": 31 },
                    "federal_chancellor": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "federal_chancellor", "label": "Federal Chancellor", "rank": 1000, "show_in_quicksearch": true, "value": 177 },
                    "finance_director": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "finance_director", "kw_code": "FD", "label": "Finance Director", "rank": 1000, "show_in_quicksearch": false, "value": 122 },
                    "first_lady": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "first_lady", "kw_code": "PRES02", "label": "First Lady", "rank": 3, "show_in_quicksearch": false, "value": 1 },
                    "gaming_commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "gaming_commissioner", "kw_code": "GAMING", "label": "Gaming Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 158 },
                    "general_counsel": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "general_counsel", "kw_code": "GENCOUN", "label": "General Counsel", "rank": 1000, "show_in_quicksearch": false, "value": 80 },
                    "general_election_winner": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "general_election_winner", "kw_code": "GW", "label": "General Election Winner", "rank": 1000, "show_in_quicksearch": false, "value": 113 },
                    "governor": { "exec_role_type": 12, "has_individual_search_filter": true, "key": "governor", "kw_code": "GOVNR", "label": "Governor", "rank": 10, "show_in_quicksearch": true, "value": 126 },
                    "governor_elect": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "governor_elect", "kw_code": "GE", "label": "Governor Elect", "rank": 11, "show_in_quicksearch": false, "value": 166 },
                    "head_of_office": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "head_of_office", "label": "Head of Office", "rank": 1000, "show_in_quicksearch": true, "value": 193 },
                    "head_of_service": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "head_of_service", "label": "Head of Service", "rank": 1000, "show_in_quicksearch": true, "value": 191 },
                    "head_of_unit": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "head_of_unit", "label": "Head of Unit", "rank": 1000, "show_in_quicksearch": true, "value": 182 },
                    "human_resources": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "human_resources", "kw_code": "HUMRES", "label": "Human Resources", "rank": 1000, "show_in_quicksearch": false, "value": 82 },
                    "inspector_general": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "inspector_general", "kw_code": "INSPGEN", "label": "Inspector General", "rank": 1000, "show_in_quicksearch": false, "value": 79 },
                    "insurance_commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "insurance_commissioner", "kw_code": "INSUR", "label": "Insurance Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 159 },
                    "judge_law_judge": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "judge_law_judge", "kw_code": "JUDGE", "label": "Judge / Law Judge", "rank": 1000, "show_in_quicksearch": false, "value": 106 },
                    "jurisconsult": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "jurisconsult", "label": "Jurisconsult", "rank": 1000, "show_in_quicksearch": true, "value": 190 },
                    "legal_assistant": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "legal_assistant", "kw_code": "CNSLASST", "label": "Legal Assistant", "rank": 55, "show_in_quicksearch": false, "value": 28 },
                    "legislative_assistant_policy_analyst": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "legislative_assistant_policy_analyst", "kw_code": "LA", "label": "Legislative Assistant / Policy Analyst", "rank": 1000, "show_in_quicksearch": false, "value": 136 },
                    "legislative_director_policy_director": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "legislative_director_policy_director", "kw_code": "LD", "label": "Legislative Director / Policy Director", "rank": 1000, "show_in_quicksearch": false, "value": 134 },
                    "lt_governor": { "exec_role_type": 12, "has_individual_search_filter": true, "key": "lt_governor", "kw_code": "LTGOV", "label": "Lt. Governor", "rank": 11, "show_in_quicksearch": false, "value": 127 },
                    "lt_governor_elect": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "lt_governor_elect", "kw_code": "LGE", "label": "Lt. Governor Elect", "rank": 16, "show_in_quicksearch": false, "value": 167 },
                    "manager": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "manager", "label": "Manager", "rank": 1000, "show_in_quicksearch": true, "value": 189 },
                    "manager_project_leader_team_leader": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "manager_project_leader_team_leader", "kw_code": "MGR", "label": "Manager / Project Leader / Team Leader", "rank": 1000, "show_in_quicksearch": false, "value": 92 },
                    "mayor": { "exec_role_type": 12, "has_individual_search_filter": false, "key": "mayor", "kw_code": "MAYOR", "label": "Mayor", "rank": 10, "show_in_quicksearch": false, "value": 128 },
                    "member": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "member", "kw_code": "MBR", "label": "Member", "rank": 1000, "show_in_quicksearch": false, "value": 21 },
                    "negotiator": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "negotiator", "kw_code": "NEG", "label": "Negotiator", "rank": 110, "show_in_quicksearch": false, "value": 35 },
                    "other_department_role": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "other_department_role", "kw_code": "OTHDEPT", "label": "Other Department Role", "rank": 1000, "show_in_quicksearch": false, "value": 165 },
                    "other_judicial_role": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "other_judicial_role", "kw_code": "OTHJUD", "label": "Other Judicial Role", "rank": 1000, "show_in_quicksearch": false, "value": 141 },
                    "other_unspecified_role": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "other_unspecified_role", "kw_code": "OTHER", "label": "Other Unspecified Role", "rank": 1000, "show_in_quicksearch": false, "value": 101 },
                    "policy_director": { "exec_role_type": 13, "has_individual_search_filter": false, "key": "policy_director", "kw_code": "PD", "label": "Policy Director", "rank": 1000, "show_in_quicksearch": false, "value": 123 },
                    "policy_officer": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "policy_officer", "label": "Policy Officer", "rank": 1000, "show_in_quicksearch": true, "value": 185 },
                    "president": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "president", "kw_code": "PRES", "label": "President", "rank": 14, "show_in_quicksearch": false, "value": 160 },
                    "president_elect": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "president_elect", "kw_code": "PE", "label": "President Elect", "rank": 1000, "show_in_quicksearch": false, "value": 111 },
                    "president_of_the_united_states": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "president_of_the_united_states", "kw_code": "PRES01", "label": "President of the United States", "rank": 1, "show_in_quicksearch": true, "value": 0 },
                    "press_assistant": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "press_assistant", "kw_code": "PASST", "label": "Press Assistant", "rank": 130, "show_in_quicksearch": false, "value": 43 },
                    "press_secretary": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "press_secretary", "kw_code": "PS", "label": "Press Secretary", "rank": 100, "show_in_quicksearch": false, "value": 38 },
                    "press_secretary_communications": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "press_secretary_communications", "kw_code": "PSC", "label": "Press Secretary / Communications", "rank": 1000, "show_in_quicksearch": false, "value": 70 },
                    "primary_election_winner": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "primary_election_winner", "kw_code": "PW", "label": "Primary Election Winner", "rank": 1000, "show_in_quicksearch": false, "value": 116 },
                    "prime_minister": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "prime_minister", "label": "Prime Minister", "rank": 1000, "show_in_quicksearch": true, "value": 176 },
                    "principal_advisor_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "principal_advisor_to_the_president", "kw_code": "PRES14", "label": "Principal Advisor to the President", "rank": 10, "show_in_quicksearch": true, "value": 13 },
                    "procurement_acquisition": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "procurement_acquisition", "kw_code": "PROCURE", "label": "Procurement / Acquisition", "rank": 1000, "show_in_quicksearch": false, "value": 84 },
                    "project_manager": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "project_manager", "kw_code": "PM", "label": "Project Manager", "rank": 1000, "show_in_quicksearch": false, "value": 137 },
                    "project_manager_regional_director": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "project_manager_regional_director", "kw_code": "PMRD", "label": "Project Manager / Regional Director", "rank": 1000, "show_in_quicksearch": false, "value": 71 },
                    "public_affairs_external_relations": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "public_affairs_external_relations", "kw_code": "PUBAFRS", "label": "Public Affairs / External Relations", "rank": 1000, "show_in_quicksearch": false, "value": 81 },
                    "qualified_candidate": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "qualified_candidate", "kw_code": "QC", "label": "Qualified Candidate", "rank": 1000, "show_in_quicksearch": false, "value": 119 },
                    "regional_chief": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "regional_chief", "kw_code": "REGCHF", "label": "Regional Chief", "rank": 1000, "show_in_quicksearch": false, "value": 96 },
                    "regional_director": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "regional_director", "kw_code": "DIRREG", "label": "Regional Director", "rank": 1000, "show_in_quicksearch": false, "value": 91 },
                    "regional_manager": { "exec_role_type": 10, "has_individual_search_filter": false, "key": "regional_manager", "kw_code": "REGMGR", "label": "Regional Manager", "rank": 1000, "show_in_quicksearch": false, "value": 94 },
                    "registered_candidate": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "registered_candidate", "kw_code": "RC", "label": "Registered Candidate", "rank": 1000, "show_in_quicksearch": false, "value": 120 },
                    "research_assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "research_assistant", "kw_code": "RA", "label": "Research Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 54 },
                    "runoff_election_winner": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "runoff_election_winner", "kw_code": "RW", "label": "Runoff Election Winner", "rank": 1000, "show_in_quicksearch": false, "value": 115 },
                    "scheduler": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "scheduler", "kw_code": "SCH", "label": "Scheduler", "rank": 1000, "show_in_quicksearch": false, "value": 46 },
                    "secretary_of_state": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "secretary_of_state", "kw_code": "STATE", "label": "Secretary of State", "rank": 15, "show_in_quicksearch": true, "value": 161 },
                    "secretary_receptionist": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "secretary_receptionist", "kw_code": "SECY", "label": "Secretary / Receptionist", "rank": 1000, "show_in_quicksearch": false, "value": 74 },
                    "securities_commissioner": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "securities_commissioner", "kw_code": "SECURE", "label": "Securities Commissioner", "rank": 1000, "show_in_quicksearch": false, "value": 162 },
                    "senior_advance_rep": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "senior_advance_rep", "kw_code": "SNRADVR", "label": "Senior Advance Rep", "rank": 1000, "show_in_quicksearch": false, "value": 49 },
                    "senior_advisor": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "senior_advisor", "kw_code": "SADV", "label": "Senior Advisor", "rank": 1000, "show_in_quicksearch": false, "value": 64 },
                    "senior_advisor_senior_assistant": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "senior_advisor_senior_assistant", "kw_code": "SADVASST", "label": "Senior Advisor / Senior Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 135 },
                    "senior_advisor_senior_counselor_senior_analyst": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "senior_advisor_senior_counselor_senior_analyst", "kw_code": "SNRADV", "label": "Senior Advisor / Senior Counselor Senior Analyst", "rank": 1000, "show_in_quicksearch": false, "value": 109 },
                    "senior_advisor_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "senior_advisor_to_the_president", "kw_code": "PRES13", "label": "Senior Advisor to the President", "rank": 10, "show_in_quicksearch": true, "value": 12 },
                    "senior_assistant": { "exec_role_type": 8, "has_individual_search_filter": false, "key": "senior_assistant", "kw_code": "SASST", "label": "Senior Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 65 },
                    "senior_assistant_attorney_general": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "senior_assistant_attorney_general", "label": "Senior Assistant Attorney General", "rank": 1000, "show_in_quicksearch": false, "value": 171 },
                    "senior_economist": { "exec_role_type": 9, "has_individual_search_filter": false, "key": "senior_economist", "kw_code": "SNRECON", "label": "Senior Economist", "rank": 110, "show_in_quicksearch": false, "value": 37 },
                    "senior_trip_coordinator": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "senior_trip_coordinator", "kw_code": "SNRTRP", "label": "Senior Trip Coordinator", "rank": 1000, "show_in_quicksearch": false, "value": 50 },
                    "social_secretary": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "social_secretary", "kw_code": "SOSECY", "label": "Social Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 47 },
                    "solicitor_general": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "solicitor_general", "label": "Solicitor General", "rank": 20, "show_in_quicksearch": false, "value": 169 },
                    "special_advisor_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "special_advisor_to_the_president", "kw_code": "PRES15", "label": "Special Advisor to the President", "rank": 10, "show_in_quicksearch": true, "value": 14 },
                    "special_assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "special_assistant", "kw_code": "SA", "label": "Special Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 53 },
                    "special_assistant_to_the_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "special_assistant_to_the_president", "kw_code": "PRES09", "label": "Special Assistant to the President", "rank": 10, "show_in_quicksearch": true, "value": 8 },
                    "special_assistant_to_the_vice_president": { "exec_role_type": 5, "has_individual_search_filter": false, "key": "special_assistant_to_the_vice_president", "kw_code": "PRES12", "label": "Special Assistant to the Vice President", "rank": 10, "show_in_quicksearch": true, "value": 11 },
                    "special_counsel": { "exec_role_type": 6, "has_individual_search_filter": false, "key": "special_counsel", "kw_code": "SPC", "label": "Special Counsel", "rank": 1000, "show_in_quicksearch": false, "value": 73 },
                    "special_election_winner": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "special_election_winner", "kw_code": "SW", "label": "Special Election Winner", "rank": 1000, "show_in_quicksearch": false, "value": 114 },
                    "speechwriter": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "speechwriter", "kw_code": "SW", "label": "Speechwriter", "rank": 130, "show_in_quicksearch": false, "value": 41 },
                    "spokesperson": { "exec_role_type": 3, "has_individual_search_filter": false, "key": "spokesperson", "kw_code": "SPK", "label": "Spokesperson", "rank": 130, "show_in_quicksearch": false, "value": 42 },
                    "spouse_of_the_vice_president": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "spouse_of_the_vice_president", "kw_code": "PRES04", "label": "Spouse of the Vice President", "rank": 4, "show_in_quicksearch": false, "value": 3 },
                    "staff_assistant": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "staff_assistant", "kw_code": "STA", "label": "Staff Assistant", "rank": 1000, "show_in_quicksearch": false, "value": 55 },
                    "staff_secretary": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "staff_secretary", "kw_code": "SSECY", "label": "Staff Secretary", "rank": 50, "show_in_quicksearch": false, "value": 29 },
                    "state_executive_elect": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "state_executive_elect", "kw_code": "SEE", "label": "State Executive Elect", "rank": 1000, "show_in_quicksearch": false, "value": 168 },
                    "state_minister": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "state_minister", "label": "Minister", "rank": 1000, "show_in_quicksearch": true, "value": 174 },
                    "state_prosecutor": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "state_prosecutor", "label": "State Prosecutor", "rank": 1000, "show_in_quicksearch": false, "value": 195 },
                    "state_secretary": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "state_secretary", "label": "State Secretary", "rank": 1000, "show_in_quicksearch": true, "value": 172 },
                    "state_solicitor": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "state_solicitor", "label": "State Solicitor", "rank": 1000, "show_in_quicksearch": false, "value": 194 },
                    "superintendent_of_corrections": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "superintendent_of_corrections", "kw_code": "CORRECT", "label": "Superintendent of Corrections", "rank": 1000, "show_in_quicksearch": false, "value": 163 },
                    "superintendent_of_schools": { "exec_role_type": 14, "has_individual_search_filter": false, "key": "superintendent_of_schools", "kw_code": "SUPER", "label": "Superintendent of Schools", "rank": 1000, "show_in_quicksearch": false, "value": 164 },
                    "team_lead": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "team_lead", "label": "Team Lead", "rank": 1000, "show_in_quicksearch": true, "value": 186 },
                    "treasurer_comptroller_controller": { "exec_role_type": 14, "has_individual_search_filter": true, "key": "treasurer_comptroller_controller", "kw_code": "TREAS", "label": "Treasurer / Comptroller/ Controller", "rank": 1000, "show_in_quicksearch": false, "value": 98 },
                    "trip_coordinator": { "exec_role_type": 7, "has_individual_search_filter": false, "key": "trip_coordinator", "kw_code": "TRP", "label": "Trip Coordinator", "rank": 1000, "show_in_quicksearch": false, "value": 51 },
                    "under_secretary": { "exec_role_type": 7, "has_individual_search_filter": true, "key": "under_secretary", "kw_code": "UNDERSEC", "label": "Under Secretary", "rank": 1000, "show_in_quicksearch": false, "value": 87 },
                    "unopposed_candidate": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "unopposed_candidate", "kw_code": "UC", "label": "Unopposed Candidate", "rank": 1000, "show_in_quicksearch": false, "value": 117 },
                    "us_trade_representative": { "exec_role_type": 4, "has_individual_search_filter": false, "key": "us_trade_representative", "kw_code": "USTREP", "label": "US Trade Representative", "rank": 50, "show_in_quicksearch": false, "value": 32 },
                    "vice_chairman": { "exec_role_type": 2, "has_individual_search_filter": false, "key": "vice_chairman", "kw_code": "VCHM", "label": "Vice Chairman", "rank": 21, "show_in_quicksearch": false, "value": 20 },
                    "vice_president": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "vice_president", "kw_code": "VPRES", "label": "Vice President", "rank": 1000, "show_in_quicksearch": false, "value": 103 },
                    "vice_president_of_the_united_states": { "exec_role_type": 1, "has_individual_search_filter": false, "key": "vice_president_of_the_united_states", "kw_code": "PRES03", "label": "Vice President of the United States", "rank": 2, "show_in_quicksearch": true, "value": 2 },
                    "vicepresident_elect": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "vicepresident_elect", "kw_code": "VPE", "label": "Vice-President Elect", "rank": 1000, "show_in_quicksearch": false, "value": 112 },
                    "writein_candidate": { "exec_role_type": 11, "has_individual_search_filter": false, "key": "writein_candidate", "kw_code": "WC", "label": "Write-In Candidate", "rank": 1000, "show_in_quicksearch": false, "value": 118 }
                },
                "SpecificLocalExecutiveRoleType": {
                    "__is_enum": true,
                    "city_administrator": { "is_administrator": true, "is_judiciary": false, "key": "city_administrator", "label": "City Administrator", "value": 10 },
                    "city_county_executive": { "is_administrator": false, "is_judiciary": false, "key": "city_county_executive", "label": "County Executive", "value": 2 },
                    "clerk": { "is_administrator": true, "is_judiciary": false, "key": "clerk", "label": "Clerk", "value": 9 },
                    "county_administrator": { "is_administrator": true, "is_judiciary": false, "key": "county_administrator", "label": "County Administrator", "value": 11 },
                    "district_attorney": { "is_administrator": false, "is_judiciary": true, "key": "district_attorney", "label": "District Attorney", "value": 4 },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Judiciary / Law Enforcement",
                            "values": [3, 6, 7, 8]
                        },
                        {
                            "display": "list",
                            "title": "Administrators",
                            "values": [9, 10, 11, 12, 13]
                        }
                    ],
                    "judge": { "is_administrator": false, "is_judiciary": true, "key": "judge", "label": "Judge", "value": 3 },
                    "law_enforcement_officer": { "is_administrator": false, "is_judiciary": true, "key": "law_enforcement_officer", "label": "Law Enforcement Officer", "value": 8 },
                    "mayor": { "is_administrator": false, "is_judiciary": false, "key": "mayor", "label": "City Mayor", "value": 1 },
                    "other_administrator": { "is_administrator": true, "is_judiciary": false, "key": "other_administrator", "label": "Other Administrator", "value": 13 },
                    "police_chief": { "is_administrator": false, "is_judiciary": true, "key": "police_chief", "label": "Police Chief", "value": 6 },
                    "prosecuting_attorney": { "is_administrator": false, "is_judiciary": true, "key": "prosecuting_attorney", "label": "Prosecuting Attorney", "value": 5 },
                    "region_groups": [
                        {
                            "display": "list",
                            "key": "judiciary",
                            "regions": ["all", "local"],
                            "title": "Judiciary / Law Enforcement",
                            "values": [3, 6, 7, 8]
                        },
                        {
                            "display": "list",
                            "key": "adminstrators",
                            "regions": ["all", "local"],
                            "title": "Administrators",
                            "values": [9, 10, 11, 12, 13]
                        }
                    ],
                    "sheriff": { "is_administrator": false, "is_judiciary": true, "key": "sheriff", "label": "Sheriff", "value": 7 },
                    "town_administrator": { "is_administrator": true, "is_judiciary": false, "key": "town_administrator", "label": "Town Administrator", "value": 12 }
                },
                "StafferType": {
                    "Campaign": {
                        "key": "Campaign",
                        "label": "Campaign",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "Committee": {
                        "key": "Committee",
                        "label": "Committee",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "Executive": {
                        "key": "Executive",
                        "label": "Executive",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "Member": {
                        "key": "Member",
                        "label": "Member",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "Officer": {
                        "key": "Officer",
                        "label": "Officer",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "__is_enum": true,
                    "commission_cabinet_staff": {
                        "key": "commission_cabinet_staff",
                        "label": "Commission Cabinet Staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 106
                    },
                    "commission_staff": {
                        "key": "commission_staff",
                        "label": "Commission Staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 107
                    },
                    "committee_secretariat": {
                        "key": "committee_secretariat",
                        "label": "Committee Secretariat",
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 103
                    },
                    "council_president_cabinet_staff": {
                        "key": "council_president_cabinet_staff",
                        "label": "Council President Cabinet Staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 108
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Parliament Staff",
                            "values": [101, 105, 104, 102]
                        },
                        {
                            "display": "list",
                            "title": "Commission Staff",
                            "values": [106, 107]
                        },
                        {
                            "display": "list",
                            "title": "Council Staff",
                            "values": [108, 109]
                        }
                    ],
                    "joint_council_secretariat_staff": {
                        "key": "joint_council_secretariat_staff",
                        "label": "Joint Council Secretariat Staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 109
                    },
                    "other_mep_staff": {
                        "key": "other_mep_staff",
                        "label": "Other MEP staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 105
                    },
                    "parliament_secretariat": {
                        "key": "parliament_secretariat",
                        "label": "Parliament Secretariat",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 104
                    },
                    "parliamentary_assistant": {
                        "key": "parliamentary_assistant",
                        "label": "Accredited Parliamentary Assistant",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 101
                    },
                    "permanent_representation_staff": {
                        "key": "permanent_representation_staff",
                        "label": "Permanent Representation Staff",
                        "show_in_enumeration": false,
                        "supported_regions": [106],
                        "value": 110
                    },
                    "political_group_staff": {
                        "key": "political_group_staff",
                        "label": "Political Group Staff",
                        "show_in_enumeration": true,
                        "supported_regions": [106],
                        "value": 102
                    }
                },
                "TagType": {
                    "__is_enum": true,
                    "boolean": { "client_facing_label": "Yes/No (for example, Part of Ambassador Program or Registered Through Event)", "column_data_type": "boolean", "display_order": 1, "key": "boolean", "label": "Boolean", "short_client_facing_label": "Yes/No", "slug": "boolean", "value": 6 },
                    "date": { "client_facing_label": "Date (for example, Time of Last Meeting)", "column_data_type": "integer", "display_order": 6, "key": "date", "label": "Date", "short_client_facing_label": "Date", "slug": "date", "value": 8 },
                    "multi_options_list": { "client_facing_label": "Options (for example, Contact Type or Division), choose multiple options", "column_data_type": "string", "display_order": 5, "key": "multi_options_list", "label": "Multiple Options", "short_client_facing_label": "Choose Many", "slug": "multi_option", "value": 7 },
                    "number": { "client_facing_label": "Number (for example, Supporter Score or Total Donations)", "column_data_type": "integer", "display_order": 2, "key": "number", "label": "Number", "short_client_facing_label": "Number", "slug": "number", "value": 1 },
                    "power_search": { "client_facing_label": "Power Search", "column_data_type": "string", "display_order": 7, "key": "power_search", "label": "Power Search", "short_client_facing_label": "Power Search", "slug": "power_search", "value": 9 },
                    "single_option_list": { "client_facing_label": "Options (for example, Contact Type or Division), choose one option", "column_data_type": "string", "display_order": 4, "key": "single_option_list", "label": "Single Option", "short_client_facing_label": "Choose One", "slug": "options", "value": 5 },
                    "string": { "client_facing_label": "Text (for example, Supervisor Name or Preferred Name)", "column_data_type": "string", "display_order": 3, "key": "string", "label": "String", "short_client_facing_label": "Text", "slug": "text", "value": 2 }
                },
                "TerminalDegree": {
                    "G": { "abbrev": "G", "key": "G", "label": "Graduate", "order": 1, "value": 2 },
                    "N": { "abbrev": "N", "key": "N", "label": "None", "order": 4, "value": 0 },
                    "P": { "abbrev": "P", "key": "P", "label": "Professional", "order": 2, "value": 3 },
                    "PHD": { "abbrev": "D", "key": "PHD", "label": "Doctorate", "order": 3, "value": 4 },
                    "UG": { "abbrev": "U", "key": "UG", "label": "Undergraduate", "order": 0, "value": 1 },
                    "__is_enum": true
                }
            }
        },
        "reg": {
            "models": {
                "Agency": {
                    "__is_model": true,
                    "__name__": "Agency",
                    "data_model": "app.reg.models.Agency",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/regulationagency/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The Public Org (Agency) primarily responsible for this regulation.",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        { "field_type": 3, "help_text": "The raw name of this agency, straight from the official website.", "name": "agency_name", "verbose_name": "agency name" },
                        { "field_type": 3, "help_text": "A slightly more informative version of the name of this agency that we will display on the frontend. If this Agency has a public_organization, this is that PublicOrganization's name; if not, we clean up the raw agency_name and throw the region into the name if it isn't referenced.", "name": "enhanced_agency_name", "verbose_name": "enhanced agency name" },
                        { "field_type": 3, "help_text": "An abbreviation for the agency's name.", "name": "abbrev", "verbose_name": "abbrev" },
                        {
                            "field_type": 7,
                            "help_text": "The Regulation sponsored by this agency!",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Docket sponsored by this agency!",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region this Agency is associated with.",
                            "name": "region",
                            "verbose_name": "region"
                        }
                    ]
                },
                "Docket": {
                    "__is_model": true,
                    "__name__": "Docket",
                    "data_model": "app.reg.models.Docket",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/regulationdocket/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 3, "help_text": "The ID of this docket. This is a text field because it could be anything.", "name": "docket_id", "verbose_name": "docket id" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "DocketType" },
                            "field_type": 4,
                            "help_text": "The type of this docket.",
                            "name": "docket_type",
                            "verbose_name": "docket type"
                        },
                        { "field_type": 3, "help_text": "The title of this docket.", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "The URL where this docket can be found.", "name": "source_link", "verbose_name": "source link" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region of this docket. Intended to be Federal only at the moment.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 3, "help_text": "Longer description of the Docket.", "name": "description", "verbose_name": "description" },
                        { "field_type": 3, "help_text": "The Regulation Identifier Number (RIN) assigned to this Docket from regulations.gov, if any.", "name": "rin", "verbose_name": "rin" },
                        { "field_type": null, "help_text": "Contact data for this Docket, if any.", "name": "contact_data", "verbose_name": "contact data" },
                        { "field_type": null, "help_text": "Additional details and less structured data for this Docket.", "name": "extra_details", "verbose_name": "extra details" },
                        { "field_type": null, "help_text": "", "name": "title_index", "verbose_name": "title index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": null, "help_text": "Represents the current state of this Docket, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "DocketMissingDataCode" },
                            "field_type": 4,
                            "help_text": "Enum describing the state of missing data (if any) on this object.",
                            "name": "missing_data_code",
                            "verbose_name": "Docket Missing Data Status"
                        }
                    ]
                },
                "RegComment": {
                    "__is_model": true,
                    "__name__": "RegComment",
                    "data_model": "app.reg.models.RegComment",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/regcomment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "document",
                            "related_model": { "__module__": "app.document.models", "__name__": "RegDocument" },
                            "verbose_name": "document"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "RegCommentSourceType" },
                            "field_type": 4,
                            "help_text": "The system we got this Comment from.",
                            "name": "source_type",
                            "verbose_name": "Comment Source Type"
                        },
                        { "field_type": 3, "help_text": "The URL where we found this comment.", "name": "source_link", "verbose_name": "source link" },
                        { "field_type": 3, "help_text": "The title given to the comment, if any.", "name": "title", "verbose_name": "title" },
                        { "field_type": 3, "help_text": "The text of the comment filled in on a comment form. This does NOT include the content of any attachments to the comment.", "name": "comment_text", "verbose_name": "comment text" },
                        { "field_type": 3, "help_text": "The full text content of the comment, including comment_text and  any attachments to the comment. This is the field that should be used for snippets.", "name": "content", "verbose_name": "content" },
                        { "field_type": null, "help_text": "A list of dictionaries with basic information about attachments included when this comment was made.", "name": "attachment_data", "verbose_name": "attachment data" },
                        { "field_type": null, "help_text": "A list of dictionaries with metadata about unconverted attachments downloaded from regulations.gov. Should not be exposed via the API.", "name": "unconverted_attachment_metadata", "verbose_name": "unconverted attachment metadata" },
                        { "field_type": null, "help_text": "A list of binary payloads from unconverted regulations.gov attachments. The ith element of this array should be the binary content corresponding to the ith element of unconverted_attachment_metadata.", "name": "unconverted_attachment_data", "verbose_name": "unconverted attachment data" },
                        { "field_type": 3, "help_text": "The name attached to this comment, if any.", "name": "commenter_name", "verbose_name": "commenter name" },
                        { "field_type": 3, "help_text": "The category this comment falls into, given to us by its source website.", "name": "category", "verbose_name": "category" },
                        { "field_type": 3, "help_text": "If the commenter indicated that they made their comment on behalf of an organization, the name of that comment is stored here.", "name": "organization_name", "verbose_name": "organization name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region of this docket. Intended to be Federal only at the moment.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 21, "help_text": "A timestamp indicating when the agency received this comment.", "name": "received_by_agency_datetime", "verbose_name": "received by agency datetime" },
                        { "field_type": 21, "help_text": "A timestamp indicating when the agency chose to post this comment on their site.", "name": "posted_by_agency_datetime", "verbose_name": "posted by agency datetime" },
                        { "field_type": 4, "help_text": "Some commenting platforms aggregate multiple comments of a similar format (e.g. form letters) into a single posting. This number is how many comments are represented by that agency posting.", "name": "num_items_received", "verbose_name": "num items received" },
                        { "field_type": null, "help_text": "Tracking numnbers or other uniquely identifying information for this comment from its source site. What we store here differs between commenting platforms.", "name": "unique_identifiers", "verbose_name": "unique identifiers" },
                        { "field_type": null, "help_text": "Other extra or unstructured data that doesn't fit elsewhere on the model.", "name": "extra_details", "verbose_name": "extra details" },
                        { "field_type": null, "help_text": "Represents the current state of this RegComment, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "RegCommentMissingDataCode" },
                            "field_type": 4,
                            "help_text": "Enum describing the state of missing data (if any) on this object.",
                            "name": "missing_data_code",
                            "verbose_name": "RegComment Missing Data Status"
                        }
                    ]
                },
                "Regulation": {
                    "__is_model": true,
                    "__name__": "Regulation",
                    "data_model": "app.reg.models.Regulation",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/regulation/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region of this regulation.",
                            "name": "region",
                            "verbose_name": "Region"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "GeneralRegStatus" },
                            "field_type": 4,
                            "help_text": "The general status of this regulation.",
                            "name": "general_status",
                            "sheet_column": true,
                            "sheets_subcategory": 10,
                            "verbose_name": "Status"
                        },
                        { "field_type": 5, "help_text": "The date of the action at which the current general status was achieved.", "name": "general_status_date", "sheet_column": true, "sheets_subcategory": 10, "verbose_name": "Status Date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "DetailedRegStatus" },
                            "field_type": 4,
                            "help_text": "The detailed status of this regulation.",
                            "name": "detailed_status",
                            "verbose_name": "detailed status"
                        },
                        { "field_type": 5, "help_text": "The date of the action at which the current detailed status was achieved.", "name": "detailed_status_date", "verbose_name": "Current Detailed Status Date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "RegType" },
                            "field_type": 4,
                            "help_text": "The type of this Regulation.",
                            "name": "reg_type",
                            "sheet_column": true,
                            "sheets_subcategory": 8,
                            "verbose_name": "Regulation Type"
                        },
                        { "field_type": 1, "help_text": "Whether we are able to capture information about this regulation that enables us to track it from proposal to final. If True, we require that the Regulation have a proposal_date or pre_proposal_date.", "name": "trackable", "verbose_name": "trackable" },
                        { "field_type": 1, "help_text": "Whether this Regulation is deemed significant under EO 12866. Does not apply to state regs.", "name": "eo_12866_significant", "verbose_name": "Federal EO 12866 Significant" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.reg.types", "__name__": "RegEO13771Type" },
                            "field_type": 4,
                            "help_text": "This federal Regulation's designation under EO 13771. Does not apply to state regs.",
                            "name": "eo_13771_designation",
                            "verbose_name": "Federal EO 13771 Designation"
                        },
                        { "field_type": 3, "help_text": "The title of this regulation", "name": "title", "sheet_column": true, "sheets_subcategory": 8, "verbose_name": "Title" },
                        { "field_type": 3, "help_text": "The URL where this regulation lives", "name": "source_link", "overriden_column_data_type": 11, "sheet_column": true, "sheets_subcategory": 8, "verbose_name": "Source Link" },
                        { "field_type": null, "help_text": "HTTP POST data to be submitted to source_link to get the regulation on its source site", "name": "source_post_data", "verbose_name": "source post data" },
                        { "field_type": 3, "help_text": "Full description of where this found. 'Register Issue 23, page 1123 or agency site xxx...'", "name": "source_text", "sheet_column": true, "sheets_subcategory": 8, "verbose_name": "Text" },
                        { "field_type": null, "help_text": "A dictionary of unique identifiers of this regulation.", "name": "unique_identifiers", "verbose_name": "unique identifiers" },
                        { "field_type": 3, "help_text": "A description of this regulation", "name": "description", "sheet_column": true, "sheets_subcategory": 8, "verbose_name": "Official Description" },
                        { "field_type": null, "help_text": "A dictionary of extra information for this regulation. This information could be different for each state.", "name": "extra_details", "verbose_name": "extra details" },
                        { "field_type": 3, "help_text": "Text of the Authority of this regulation.", "name": "authority", "verbose_name": "authority" },
                        { "field_type": 3, "help_text": "The specific piece of code that is affected by the regulation.", "name": "citation", "sheet_column": true, "sheets_subcategory": 8, "verbose_name": "Citation" },
                        { "field_type": 3, "help_text": "The most recent full text of the regulation, for searching", "name": "most_recent_text", "verbose_name": "most recent text" },
                        { "field_type": 4, "help_text": "Number of words in this regulation's most recent text. Useful for FTS vector heuristics.", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        { "field_type": null, "help_text": "", "name": "title_index", "verbose_name": "title index" },
                        { "field_type": null, "help_text": "A full entity cache of relevant entities captured when we last scraped this reg.", "name": "cached_data", "verbose_name": "cached data" },
                        { "field_type": null, "help_text": "Represents the current state of this Regulation, used in alert processing.", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 5, "help_text": "The date this Regulation was prefiled, if applicable.", "name": "pre_proposal_date", "verbose_name": "pre proposal date" },
                        { "field_type": 5, "help_text": "The date this Regulation was first proposed, sometimes called Notice or Filed date.", "name": "proposal_date", "verbose_name": "proposal date" },
                        { "field_type": 5, "help_text": "The date this Regulation takes effect.", "name": "effective_date", "verbose_name": "effective date" },
                        { "field_type": 5, "help_text": "The date this Regulation expires, if applicable", "name": "expiration_date", "verbose_name": "expiration date" },
                        { "field_type": 5, "help_text": "The date comments on this regulation close.", "name": "comment_close_date", "verbose_name": "comment close date" },
                        { "field_type": null, "help_text": "All the major actions this regulation has gone through.", "name": "major_actions", "verbose_name": "major actions" },
                        { "field_type": null, "help_text": "Relevant contact information for this regulation.", "name": "contact_data", "verbose_name": "contact data" },
                        { "field_type": 5, "help_text": "The most recent date of a regulation update", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        {
                            "field_type": 8,
                            "help_text": "The Dockets this regulation belongs to.",
                            "name": "dockets",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "dockets"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The Registers this regulation appears in.",
                            "name": "registers",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Register" },
                            "verbose_name": "registers"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this regulation has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                }
            },
            "types": {
                "DetailedRegStatus": {
                    "__is_enum": true,
                    "adopted": {
                        "general_status": 10,
                        "key": "adopted",
                        "label": "Adopted",
                        "order": 200,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 101
                    },
                    "adopted_permanently": {
                        "general_status": 10,
                        "key": "adopted_permanently",
                        "label": "Adopted Permanently",
                        "order": 210,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 104
                    },
                    "adopted_temporarily": {
                        "general_status": 10,
                        "key": "adopted_temporarily",
                        "label": "Adopted Temporarily",
                        "order": 190,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 103
                    },
                    "adopted_with_changes": {
                        "general_status": 11,
                        "key": "adopted_with_changes",
                        "label": "Adopted With Changes",
                        "order": 200,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 102
                    },
                    "amendment_passed": {
                        "general_status": 2,
                        "key": "amendment_passed",
                        "label": "Amendment Passed",
                        "order": 200,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 62
                    },
                    "amendment_proposed": {
                        "general_status": 2,
                        "key": "amendment_proposed",
                        "label": "Amendment Proposed",
                        "order": 30,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 61
                    },
                    "approved_by_governor": {
                        "general_status": 10,
                        "key": "approved_by_governor",
                        "label": "Approved by Governor",
                        "order": 135,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 54
                    },
                    "attorney_general_decision": {
                        "general_status": 2,
                        "key": "attorney_general_decision",
                        "label": "Attorney General Decision",
                        "order": 125,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 52
                    },
                    "brazil_adopted": {
                        "general_status": 124,
                        "key": "brazil_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 1210
                    },
                    "canada_adopted": {
                        "general_status": 123,
                        "key": "canada_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 1203
                    },
                    "canada_proposed": {
                        "general_status": 122,
                        "key": "canada_proposed",
                        "label": "Proposed",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 1202
                    },
                    "changes_requested": {
                        "general_status": 3,
                        "key": "changes_requested",
                        "label": "Changes Requested",
                        "order": 111,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 68
                    },
                    "closed_for_comment": {
                        "general_status": 3,
                        "key": "closed_for_comment",
                        "label": "Closed for Comment",
                        "order": 80,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 42
                    },
                    "comment_period_extended": {
                        "general_status": 2,
                        "key": "comment_period_extended",
                        "label": "Comment Period Extended",
                        "order": 79,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 43
                    },
                    "corrected": {
                        "general_status": 100,
                        "key": "corrected",
                        "label": "Corrected",
                        "order": 35,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "effective": {
                        "general_status": 10,
                        "key": "effective",
                        "label": "Effective",
                        "order": 250,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 120
                    },
                    "expired": {
                        "general_status": 21,
                        "key": "expired",
                        "label": "Expired",
                        "order": 275,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 65
                    },
                    "filed": {
                        "general_status": 10,
                        "key": "filed",
                        "label": "Filed",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 55
                    },
                    "france_adopted": {
                        "general_status": 127,
                        "key": "france_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [205],
                        "value": 1240
                    },
                    "germany_adopted": {
                        "general_status": 126,
                        "key": "germany_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 1221
                    },
                    "germany_proposed": {
                        "general_status": 125,
                        "key": "germany_proposed",
                        "label": "Proposed",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 1220
                    },
                    "global_adopted": { "general_status": 131, "key": "global_adopted", "label": "Adopted", "order": 1, "show_in_enumeration": false, "value": 1231 },
                    "global_proposed": { "general_status": 130, "key": "global_proposed", "label": "Proposed", "order": 0, "show_in_enumeration": false, "value": 1230 },
                    "hearing_announced": {
                        "general_status": 2,
                        "key": "hearing_announced",
                        "label": "Hearing Announced",
                        "order": 40,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 21
                    },
                    "hearing_date_changed": {
                        "general_status": 2,
                        "key": "hearing_date_changed",
                        "label": "Hearing Date Changed",
                        "order": 43,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 23
                    },
                    "hearing_held": {
                        "general_status": 2,
                        "key": "hearing_held",
                        "label": "Hearing Held",
                        "order": 45,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 22
                    },
                    "oira_final_review": {
                        "general_status": 3,
                        "key": "oira_final_review",
                        "label": "OIRA Final Review",
                        "order": 140,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 1121
                    },
                    "oira_prerule_review": {
                        "general_status": 1,
                        "key": "oira_prerule_review",
                        "label": "OIRA Pre-Proposal Review",
                        "order": 10,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 1101
                    },
                    "oira_proposal_review": {
                        "general_status": 1,
                        "key": "oira_proposal_review",
                        "label": "OIRA Proposal Review",
                        "order": 25,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "value": 1111
                    },
                    "open_for_comment": {
                        "general_status": 2,
                        "key": "open_for_comment",
                        "label": "Open for Comment",
                        "order": 31,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 41
                    },
                    "other": {
                        "general_status": 100,
                        "key": "other",
                        "label": "Other",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 500
                    },
                    "pre_proposed": {
                        "general_status": 1,
                        "key": "pre_proposed",
                        "label": "Pre-Proposed",
                        "order": 20,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "process_terminated": {
                        "general_status": 20,
                        "key": "process_terminated",
                        "label": "Process Terminated",
                        "order": 180,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 63
                    },
                    "proposed": {
                        "general_status": 2,
                        "key": "proposed",
                        "label": "Proposed",
                        "order": 30,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "received_by_attorney_general": {
                        "general_status": 2,
                        "key": "received_by_attorney_general",
                        "label": "Received by Attorney General",
                        "order": 120,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 51
                    },
                    "received_by_governor": {
                        "general_status": 2,
                        "key": "received_by_governor",
                        "label": "Received by Governor",
                        "order": 130,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 53
                    },
                    "repealing": {
                        "general_status": 10,
                        "key": "repealing",
                        "label": "Repealing",
                        "order": 200,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 105
                    },
                    "rules_council_approved": {
                        "general_status": 3,
                        "key": "rules_council_approved",
                        "label": "Rules Council Approved",
                        "order": 112,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 67
                    },
                    "rules_council_review": {
                        "general_status": 3,
                        "key": "rules_council_review",
                        "label": "Rules Council Review",
                        "order": 110,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 66
                    },
                    "spain_effective": {
                        "general_status": 134,
                        "key": "spain_effective",
                        "label": "Adopted",
                        "order": 2,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 1252
                    },
                    "spain_introduced": {
                        "general_status": 132,
                        "key": "spain_introduced",
                        "label": "Introduced",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 1250
                    },
                    "spain_published": {
                        "general_status": 133,
                        "key": "spain_published",
                        "label": "Published",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 1251
                    },
                    "superseded": {
                        "general_status": 100,
                        "key": "superseded",
                        "label": "Superseded by Permanent Rule",
                        "order": 300,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 64
                    },
                    "uk_in_force": {
                        "general_status": 121,
                        "key": "uk_in_force",
                        "label": "In Force",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 1201
                    },
                    "uk_introduced": {
                        "general_status": 120,
                        "key": "uk_introduced",
                        "label": "Introduced",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 1200
                    },
                    "unified_agenda_first_appearance": {
                        "general_status": 1,
                        "key": "unified_agenda_first_appearance",
                        "label": "First Published in the Unified Agenda",
                        "order": 5,
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "value": 1001
                    }
                },
                "DocketRelationType": {
                    "__is_enum": true,
                    "related": { "description": "Related to", "is_symmetric": true, "key": "related", "label": "Related", "reverse_description": "Related to", "value": 1 }
                },
                "DocketType": {
                    "__is_enum": true,
                    "internal_agency": {
                        "key": "internal_agency",
                        "label": "Internal to Agency",
                        "order": 101,
                        "regulations_gov_tracked": false,
                        "search_filter_label": "Internal to Agency",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "tip": "Dockets not hosted on regulations.gov. Used internally by federal agencies to track their own regulatory processes.",
                        "value": 101
                    },
                    "nonrulemaking": {
                        "key": "nonrulemaking",
                        "label": "Regulations.gov - Nonrulemaking",
                        "order": 2,
                        "regulations_gov_tracked": true,
                        "search_filter_label": "Nonrulemaking",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Dockets hosted on regulations.gov and labeled on that site as \u201cNonrulemaking\u201d. In practice, federal agencies often still use these dockets to track regulatory activity.",
                        "value": 2
                    },
                    "other": {
                        "key": "other",
                        "label": "Other",
                        "order": 999,
                        "regulations_gov_tracked": false,
                        "search_filter_label": "Other",
                        "show_in_enumeration": false,
                        "supported_regions": [1, 10000],
                        "value": 999
                    },
                    "rulemaking": {
                        "key": "rulemaking",
                        "label": "Regulations.gov - Rulemaking",
                        "order": 1,
                        "regulations_gov_tracked": true,
                        "search_filter_label": "Rulemaking",
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000],
                        "tip": "Dockets hosted on regulations.gov and labeled on that site as \u201cRulemaking\u201d.",
                        "value": 1
                    }
                },
                "GeneralRegStatus": {
                    "__is_enum": true,
                    "adopted": {
                        "global_status": 2,
                        "key": "adopted",
                        "label": "Adopted",
                        "order": 13,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 10
                    },
                    "adopted_with_changes": {
                        "global_status": 2,
                        "key": "adopted_with_changes",
                        "label": "Adopted With Changes",
                        "order": 13,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 11
                    },
                    "brazil_adopted": {
                        "global_status": 2,
                        "key": "brazil_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [208],
                        "value": 124
                    },
                    "canada_adopted": {
                        "global_status": 2,
                        "key": "canada_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 123
                    },
                    "canada_proposed": {
                        "global_status": 1,
                        "key": "canada_proposed",
                        "label": "Proposed",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [201],
                        "value": 122
                    },
                    "comment_closed": {
                        "global_status": 1,
                        "key": "comment_closed",
                        "label": "Comment Period Closed",
                        "order": 11,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "expired": {
                        "global_status": 2,
                        "key": "expired",
                        "label": "Expired",
                        "order": 14,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 21
                    },
                    "france_adopted": {
                        "global_status": 2,
                        "key": "france_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [205],
                        "value": 127
                    },
                    "germany_adopted": {
                        "global_status": 2,
                        "key": "germany_adopted",
                        "label": "Adopted",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 126
                    },
                    "germany_proposed": {
                        "global_status": 1,
                        "key": "germany_proposed",
                        "label": "Proposed",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [203],
                        "value": 125
                    },
                    "global_adopted": { "global_status": 2, "key": "global_adopted", "label": "Adopted", "order": 1, "show_in_enumeration": false, "value": 131 },
                    "global_proposed": { "global_status": 1, "key": "global_proposed", "label": "Proposed", "order": 0, "show_in_enumeration": false, "value": 130 },
                    "other": {
                        "global_status": 1,
                        "key": "other",
                        "label": "Other",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 100
                    },
                    "pre_proposed": {
                        "global_status": 1,
                        "key": "pre_proposed",
                        "label": "Pre-Proposed",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "proposed": {
                        "global_status": 1,
                        "key": "proposed",
                        "label": "Proposed",
                        "order": 2,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "spain_effective": {
                        "global_status": 2,
                        "key": "spain_effective",
                        "label": "Effective",
                        "order": 2,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 134
                    },
                    "spain_introduced": {
                        "global_status": 1,
                        "key": "spain_introduced",
                        "label": "Introduced",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 132
                    },
                    "spain_published": {
                        "global_status": 2,
                        "key": "spain_published",
                        "label": "Published",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [211],
                        "value": 133
                    },
                    "temporary": {
                        "global_status": 2,
                        "key": "temporary",
                        "label": "Temporary",
                        "order": 13,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 12
                    },
                    "terminated": {
                        "global_status": 1,
                        "key": "terminated",
                        "label": "Terminated",
                        "order": 12,
                        "show_in_enumeration": true,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 20
                    },
                    "uk_in_force": {
                        "global_status": 2,
                        "key": "uk_in_force",
                        "label": "In Force",
                        "order": 1,
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 121
                    },
                    "uk_introduced": {
                        "global_status": 1,
                        "key": "uk_introduced",
                        "label": "Introduced",
                        "order": 0,
                        "show_in_enumeration": true,
                        "supported_regions": [204],
                        "value": 120
                    }
                },
                "GlobalRegStatus": {
                    "__is_enum": true,
                    "adopted": { "key": "adopted", "label": "Adopted", "value": 2 },
                    "proposed": { "key": "proposed", "label": "Proposed", "value": 1 }
                },
                "RegCommentSourceType": {
                    "__is_enum": true,
                    "fcc_ecfs": { "key": "fcc_ecfs", "label": "FCC Electronic Comment Filing System", "show_in_enumeration": false, "tip": "Comments made using the Federal Communications Commission's Electronic Comment Filing System.", "value": 2 },
                    "other": { "key": "other", "label": "Other/Unknown", "show_in_enumeration": false, "tip": "Comment types that could not be categorized.", "value": 99999 },
                    "regulations_gov": { "key": "regulations_gov", "label": "Regulations.gov", "show_in_enumeration": true, "tip": "Comments made using the Regulations.gov eRulemaking system.", "value": 1 }
                },
                "RegEO13771Type": {
                    "__is_enum": true,
                    "deregulatory": { "key": "deregulatory", "label": "Deregulatory", "order": 1, "tip": "Regulations with total regulatory cost less than zero.", "value": 1 },
                    "exempt": { "key": "exempt", "label": "Exempt", "order": 3, "tip": "Regulations with exemptions from EO 13771 offset requirements, or with insignificant impact.", "value": 3 },
                    "other": { "key": "other", "label": "Other", "order": 5, "tip": "Regulations without EO 13771 designation due to lack of information or precluding circumstances in analysis.", "value": 5 },
                    "regulatory": { "key": "regulatory", "label": "Regulatory", "order": 2, "tip": "Regulations with total regulatory cost greater than zero.", "value": 2 },
                    "waived": { "key": "waived", "label": "Waived", "order": 4, "tip": "Regulations having received OMB or statutory waivers granting exemption from EO 13771 offset requirements.", "value": 4 }
                },
                "RegStatus": { "__is_enum": true },
                "RegType": {
                    "__is_enum": true,
                    "brazil_regulation": {
                        "key": "brazil_regulation",
                        "label": "Regulation",
                        "order": 0,
                        "supported_regions": [208],
                        "value": 122
                    },
                    "canada_regulation": {
                        "key": "canada_regulation",
                        "label": "Regulation",
                        "order": 0,
                        "supported_regions": [201],
                        "value": 121
                    },
                    "correction": {
                        "key": "correction",
                        "label": "Correction",
                        "order": 999,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "direct_final": {
                        "key": "direct_final",
                        "label": "Direct Final",
                        "order": 4,
                        "supported_regions": [1, 10000],
                        "value": 102
                    },
                    "emergency": {
                        "key": "emergency",
                        "label": "Emergency",
                        "order": 2,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "expedited": {
                        "key": "expedited",
                        "label": "Expedited",
                        "order": 5,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "france_regulation": {
                        "key": "france_regulation",
                        "label": "Regulation",
                        "order": 0,
                        "supported_regions": [205],
                        "value": 124
                    },
                    "germany_regulation": {
                        "key": "germany_regulation",
                        "label": "Regulation",
                        "order": 0,
                        "supported_regions": [203],
                        "value": 123
                    },
                    "interim_final": {
                        "key": "interim_final",
                        "label": "Interim Final",
                        "order": 3,
                        "supported_regions": [1, 10000],
                        "value": 101
                    },
                    "readoption": {
                        "key": "readoption",
                        "label": "Readoption",
                        "order": 6,
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "regular": {
                        "key": "regular",
                        "label": "Regular",
                        "order": 1,
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "spain_regulation": {
                        "key": "spain_regulation",
                        "label": "Regulation",
                        "order": 0,
                        "supported_regions": [211],
                        "value": 125
                    },
                    "uk_statutory_instrument": {
                        "key": "uk_statutory_instrument",
                        "label": "Statutory Instrument",
                        "order": 0,
                        "supported_regions": [204],
                        "value": 120
                    }
                }
            }
        },
        "search": {
            "bulkactions": {
                "models": {
                    "BulkAction": {
                        "__is_model": true,
                        "__name__": "BulkAction",
                        "data_model": "app.search.bulkactions.models.BulkAction",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/bulkaction/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": null, "help_text": "A cache of all IDs the Bulk Action was performed upon (bigint so it can handle Article IDs).", "name": "all_ids", "verbose_name": "all ids" },
                            { "field_type": null, "help_text": "User-generated input arguments ({{stance: 2}}, {{officials: [300002, 400013, 412251])}}, {{confirmed: True}}", "name": "args", "verbose_name": "args" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.search.bulkactions.types", "__name__": "BulkActionType" },
                                "field_type": 4,
                                "help_text": "The type of action performed by this BulkAction",
                                "name": "bulk_action_type",
                                "verbose_name": "Bulk Action Type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "The data type of this Bulk Action",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The user that was logged into the backend, if any, when this BulkAction was created",
                                "name": "logged_in_as_user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "logged in as user"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.search.bulkactions.types", "__name__": "BulkActionStatus" },
                                "field_type": 4,
                                "help_text": "Whether or not this BulkAction is currently being processed (or if it ran into an error on its previous run)",
                                "name": "processing_status",
                                "verbose_name": "processing status"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The saved search that the BulkAction will be processed from",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The user instantiating the Bulk Action",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            }
                        ]
                    }
                },
                "types": {
                    "AssignmentInputType": {
                        "__is_enum": true,
                        "supporter": { "icon": "fa-child", "key": "supporter", "label": "Contacts", "value": 2 },
                        "user": { "icon": "fa-user", "key": "user", "label": "Team Members", "value": 1 }
                    },
                    "AssignmentSelectType": {
                        "__is_enum": true,
                        "add": { "icon": "fa-plus", "key": "add", "label": "Add Assignment(s)", "value": 1 },
                        "clear": { "icon": "fa-eraser", "key": "clear", "label": "Clear Existing Assignment(s)", "value": 3 },
                        "remove": { "icon": "fa-minus", "key": "remove", "label": "Remove Assignment(s)", "value": 2 }
                    },
                    "BulkActionLimits": {
                        "__is_enum": true,
                        "hard_limit_high": { "key": "hard_limit_high", "label": "Hard Limit High", "limit": 1000000, "value": 1 },
                        "hard_limit_low": { "key": "hard_limit_low", "label": "Hard Limit Low", "limit": 100000, "value": 3 },
                        "hard_limit_medium": { "key": "hard_limit_medium", "label": "Hard Limit Medium", "limit": 500000, "value": 2 },
                        "high_limit": { "key": "high_limit", "label": "High Limit", "limit": 100000, "value": 4 },
                        "low_limit": { "key": "low_limit", "label": "Limit Low", "limit": 10000, "value": 6 },
                        "medium_limit": { "key": "medium_limit", "label": "Medium Limit", "limit": 50000, "value": 5 }
                    },
                    "BulkActionType": {
                        "__is_enum": true,
                        "alignment": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-user-plus",
                            "key": "alignment",
                            "label": "Alignment",
                            "limit": 100000,
                            "submit_label": "Submit",
                            "supported_data_types": [1, 8, 12, 120],
                            "value": 13
                        },
                        "approve": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-check",
                            "key": "approve",
                            "label": "Approve",
                            "limit": 50000,
                            "submit_label": "Approve",
                            "supported_data_types": [69],
                            "value": 4
                        },
                        "archive": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-trash",
                            "key": "archive",
                            "label": "Archive",
                            "limit": 50000,
                            "submit_label": "Archive",
                            "supported_data_types": [12, 20, 42, 44, 49, 62, 69, 73, 74, 78, 83, 85, 87, 89, 91, 96, 98, 100, 104, 106, 116, 118, 130, 131],
                            "value": 3
                        },
                        "assign": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 500000,
                            "icon": "fa-star",
                            "key": "assign",
                            "label": "Assign",
                            "limit": 50000,
                            "submit_label": "Assign",
                            "supported_data_types": [1, 2, 3, 4, 8, 12, 15, 29, 42, 49, 66, 80, 85, 88, 120],
                            "value": 5
                        },
                        "custom_field": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 500000,
                            "icon": "fa-address-card-o",
                            "key": "custom_field",
                            "label": "Custom Field",
                            "limit": 50000,
                            "submit_label": "Update the Custom Fields on",
                            "supported_data_types": [1, 2, 8, 12, 15, 20, 42, 69, 80, 83, 85, 120],
                            "value": 6
                        },
                        "external_contact": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-child",
                            "key": "external_contact",
                            "label": "External Contact",
                            "limit": 100000,
                            "submit_label": "Set Visibility in External Logger on",
                            "supported_data_types": [12],
                            "value": 12
                        },
                        "issue": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-thumb-tack",
                            "key": "issue",
                            "label": "Issue",
                            "limit": 100000,
                            "submit_label": "Set the Issue(s) on",
                            "supported_data_types": [1, 2, 3, 4, 8, 12, 15, 16, 20, 25, 28, 29, 42, 44, 66, 80, 85, 105, 113, 120],
                            "value": 7
                        },
                        "merge": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 10,
                            "icon": "fa-random",
                            "key": "merge",
                            "label": "Merge",
                            "limit": 5,
                            "submit_label": "Merge",
                            "supported_data_types": [12, 42],
                            "value": 10
                        },
                        "organization": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-building-o",
                            "key": "organization",
                            "label": "Organization",
                            "limit": 100000,
                            "submit_label": "Set the Organization(s) on",
                            "supported_data_types": [12],
                            "value": 9
                        },
                        "permission": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-users",
                            "key": "permission",
                            "label": "Permissions",
                            "limit": 50000,
                            "submit_label": "Set the Team Permission(s) on",
                            "supported_data_types": [12, 20, 42, 44, 47, 49, 62, 70, 73, 78, 79, 83, 85, 87, 96, 98, 100, 113, 115, 118, 119],
                            "value": 8
                        },
                        "priority": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-sort-numeric-asc",
                            "key": "priority",
                            "label": "Priority",
                            "limit": 100000,
                            "submit_label": "Set the Priority on",
                            "supported_data_types": [1, 2, 8, 12, 49, 80, 88, 105, 120],
                            "value": 2
                        },
                        "stance": {
                            "admin": false,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-thumbs-up",
                            "key": "stance",
                            "label": "Stance",
                            "limit": 100000,
                            "submit_label": "Set the Stance on",
                            "supported_data_types": [2, 3, 4, 25, 49, 80, 88, 105],
                            "value": 1
                        },
                        "unsuppress": {
                            "admin": true,
                            "chunk_limit": 5000,
                            "hard_limit": 1000000,
                            "icon": "fa-envelope",
                            "key": "unsuppress",
                            "label": "Unsuppress",
                            "limit": 100000,
                            "submit_label": "Unsuppress",
                            "supported_data_types": [66, 29, 1, 8, 12, 120],
                            "value": 11
                        }
                    },
                    "CustomFieldSelectType": {
                        "__is_enum": true,
                        "add": { "icon": "fa-plus", "key": "add", "label": "Set Value", "multi_select_label": "Add Value(s)", "value": 1 },
                        "clear": { "icon": "fa-eraser", "key": "clear", "label": "Clear Existing Value", "multi_select_label": "Clear Existing Value(s)", "value": 3 },
                        "remove": { "icon": "fa-minus", "key": "remove", "label": "Remove Value(s)", "value": 2 }
                    },
                    "ExternalContactType": {
                        "__is_enum": true,
                        "hide": { "icon": "fa-minus", "key": "hide", "label": "Hide", "value": 1 },
                        "show": { "icon": "fa-plus", "key": "show", "label": "Show", "value": 2 }
                    },
                    "IssueSelectType": {
                        "__is_enum": true,
                        "add": { "icon": "fa-plus", "key": "add", "label": "Add to Issues", "value": 1 },
                        "clear": { "icon": "fa-eraser", "key": "clear", "label": "Clear all Issues", "value": 3 },
                        "remove": { "icon": "fa-minus", "key": "remove", "label": "Remove from Issues", "value": 2 }
                    },
                    "OrganizationSelectType": {
                        "__is_enum": true,
                        "add": { "icon": "fa-plus", "key": "add", "label": "Add to Organizations", "value": 1 },
                        "clear": { "icon": "fa-eraser", "key": "clear", "label": "Clear all Organizations", "value": 3 },
                        "remove": { "icon": "fa-minus", "key": "remove", "label": "Remove from Organizations", "value": 2 }
                    },
                    "TeamSelectType": {
                        "__is_enum": true,
                        "delimit": { "icon": "fa-minus", "key": "delimit", "label": "Remove from Teams", "value": 2 },
                        "everyone": { "icon": "fa-eraser", "key": "everyone", "label": "Make Available to Everyone", "value": 3 },
                        "limit": { "icon": "fa-plus", "key": "limit", "label": "Limit to Teams", "value": 1 }
                    }
                }
            },
            "types": {
                "QuorumDataTypeOrdering": {
                    "__is_enum": true,
                    "amendment_introduced_ascending": { "default": false, "enum_case": null, "key": "amendment_introduced_ascending", "label": "Introduced Date (Oldest to Newest)", "qdt": 4, "value": "amendment_introduced_ascending" },
                    "amendment_introduced_descending": { "default": true, "enum_case": null, "key": "amendment_introduced_descending", "label": "Introduced Date (Newest to Oldest) - Default", "qdt": 4, "value": "amendment_introduced_descending" },
                    "amendment_number_ascending": { "default": false, "enum_case": null, "key": "amendment_number_ascending", "label": "Amendment Number (Low to High)", "qdt": 4, "value": "amendment_number_ascending" },
                    "amendment_number_descending": { "default": false, "enum_case": null, "key": "amendment_number_descending", "label": "Amendment Number (High to Low)", "qdt": 4, "value": "amendment_number_descending" },
                    "attachment_added_ascending": { "default": false, "enum_case": null, "key": "attachment_added_ascending", "label": "Date Added (Oldest to Newest)", "qdt": 62, "value": "attachment_added_ascending" },
                    "attachment_added_descending": { "default": true, "enum_case": null, "key": "attachment_added_descending", "label": "Date Added (Newest to Oldest) - Default", "qdt": 62, "value": "attachment_added_descending" },
                    "bill_alphanumeric_ascending": {
                        "default": false,
                        "enum_case": ["bill_type", "full_name"],
                        "key": "bill_alphanumeric_ascending",
                        "label": "Alphanumeric (A to Z, Low to High)",
                        "qdt": 2,
                        "value": "bill_alphanumeric_ascending"
                    },
                    "bill_alphanumeric_descending": {
                        "default": false,
                        "enum_case": ["bill_type", "full_name"],
                        "key": "bill_alphanumeric_descending",
                        "label": "Alphanumeric (Z to A, High to Low)",
                        "qdt": 2,
                        "value": "bill_alphanumeric_descending"
                    },
                    "bill_current_status_date_ascending": { "default": false, "enum_case": null, "key": "bill_current_status_date_ascending", "label": "Last Action (Least Recent to Most Recent)", "qdt": 2, "value": "bill_current_status_date_ascending" },
                    "bill_current_status_date_descending": { "default": true, "enum_case": null, "key": "bill_current_status_date_descending", "label": "Last Action (Most Recent to Least Recent) - Default", "qdt": 2, "value": "bill_current_status_date_descending" },
                    "bill_introduced_date_ascending": { "default": false, "enum_case": null, "key": "bill_introduced_date_ascending", "label": "Introduced Date (Oldest to Newest)", "qdt": 2, "value": "bill_introduced_date_ascending" },
                    "bill_introduced_date_descending": { "default": false, "enum_case": null, "key": "bill_introduced_date_descending", "label": "Introduced Date (Newest to Oldest)", "qdt": 2, "value": "bill_introduced_date_descending" },
                    "bill_numeric_ascending": { "default": false, "enum_case": null, "key": "bill_numeric_ascending", "label": "Numeric (Low to High)", "qdt": 2, "value": "bill_numeric_ascending" },
                    "bill_numeric_descending": { "default": false, "enum_case": null, "key": "bill_numeric_descending", "label": "Numeric (High to Low)", "qdt": 2, "value": "bill_numeric_descending" },
                    "by_data_type": { "105": {
                        "keys": ["media_date_descending", "media_date_ascending"]
                    }, "119": {
                        "keys": ["send_sms_sent_descending", "send_sms_sent_ascending"]
                    }, "12": {
                        "keys": ["supporter_created_descending", "supporter_created_ascending", "supporter_updated_descending", "supporter_updated_ascending"]
                    }, "134": {
                        "keys": ["send_email_archived_sent_descending", "send_email_archived_sent_ascending"]
                    }, "2": {
                        "keys": ["bill_alphanumeric_ascending", "bill_alphanumeric_descending", "bill_numeric_ascending", "bill_numeric_descending", "bill_current_status_date_descending", "bill_current_status_date_ascending", "bill_introduced_date_descending", "bill_introduced_date_ascending"]
                    }, "20": {
                        "keys": ["note_date_descending", "note_date_ascending", "note_created_descending", "note_created_ascending"]
                    }, "25": {
                        "keys": ["document_date_time_descending", "document_date_time_ascending"]
                    }, "28": {
                        "keys": ["event_when_descending", "event_when_ascending", "event_created_descending", "event_created_ascending"]
                    }, "3": {
                        "keys": ["vote_created_descending", "vote_created_ascending"]
                    }, "4": {
                        "keys": ["amendment_number_ascending", "amendment_number_descending", "amendment_introduced_descending", "amendment_introduced_ascending"]
                    }, "42": {
                        "keys": ["public_organization_created_descending", "public_organization_created_ascending", "public_organization_updated_descending", "public_organization_updated_ascending", "public_organization_name_weighted_ascending", "public_organization_name_weighted_descending", "public_organization_name_ascending", "public_organization_name_descending"]
                    }, "45": {
                        "keys": ["send_email_sent_descending", "send_email_sent_ascending"]
                    }, "62": {
                        "keys": ["attachment_added_descending", "attachment_added_ascending"]
                    }, "80": {
                        "keys": ["regulation_detailed_status_date_descending", "regulation_detailed_status_date_ascending", "regulation_detailed_status_date_id_descending", "regulation_detailed_status_date_id_ascending", "regulation_proposal_date_descending", "regulation_proposal_date_ascending"]
                    }, "88": {
                        "keys": ["docket_created_descending", "docket_created_ascending"]
                    } },
                    "by_data_type_date_range": { "1": "alignment_date_range", "101": "date_range", "105": "estimated_published_date_range", "107": "occurred_date_range", "114": "date_range", "12": "created_date_range", "134": "date_range", "2": "current_status_date_range", "20": "date_range", "25": "date_range", "28": "date_range", "3": "date_range", "4": "status_date_range", "44": "date_range", "45": "date_range", "62": "date_range", "69": "date_range", "74": "date_range", "8": "alignment_date_range", "80": "date_range_current_status", "86": "event_date_time", "88": "date_range", "95": "date_range_posted_by_agency" },
                    "by_data_type_default_date": { "1": "effective_start_date", "105": "estimated_published_date", "107": "occurred_time", "114": "cycle_year_datetime", "12": "created", "134": "sent_datetime", "2": "most_recent_action_date", "20": "date", "25": "date_time", "28": "when", "3": "created", "4": "status_date", "42": "created", "45": "sent_datetime", "62": "created", "69": "date", "8": "effective_start_date", "80": "detailed_status_date", "88": "created" },
                    "docket_created_ascending": { "default": false, "enum_case": null, "key": "docket_created_ascending", "label": "Date Created (Oldest to Newest)", "qdt": 88, "value": "docket_created_ascending" },
                    "docket_created_descending": { "default": true, "enum_case": null, "key": "docket_created_descending", "label": "Date Created (Newest to Oldest) - Default", "qdt": 88, "value": "docket_created_descending" },
                    "document_date_time_ascending": { "default": false, "enum_case": null, "key": "document_date_time_ascending", "label": "Date (Oldest to Newest)", "qdt": 25, "value": "document_date_time_ascending" },
                    "document_date_time_descending": { "default": true, "enum_case": null, "key": "document_date_time_descending", "label": "Date (Newest to Oldest) - Default", "qdt": 25, "value": "document_date_time_descending" },
                    "event_created_ascending": { "default": false, "enum_case": null, "key": "event_created_ascending", "label": "Created Date (Oldest to Newest)", "qdt": 28, "value": "event_created_ascending" },
                    "event_created_descending": { "default": false, "enum_case": null, "key": "event_created_descending", "label": "Created Date (Newest to Oldest)", "qdt": 28, "value": "event_created_descending" },
                    "event_when_ascending": { "default": false, "enum_case": null, "key": "event_when_ascending", "label": "Event Date (Oldest to Newest)", "qdt": 28, "value": "event_when_ascending" },
                    "event_when_descending": { "default": true, "enum_case": null, "key": "event_when_descending", "label": "Event Date (Newest to Oldest) - Default", "qdt": 28, "value": "event_when_descending" },
                    "media_date_ascending": { "default": false, "enum_case": null, "key": "media_date_ascending", "label": "Date (Oldest to Newest)", "qdt": 105, "value": "media_date_ascending" },
                    "media_date_descending": { "default": true, "enum_case": null, "key": "media_date_descending", "label": "Date (Newest to Oldest) - Default", "qdt": 105, "value": "media_date_descending" },
                    "note_created_ascending": { "default": false, "enum_case": null, "key": "note_created_ascending", "label": "Created Date (Oldest to Newest)", "qdt": 20, "value": "note_created_ascending" },
                    "note_created_descending": { "default": false, "enum_case": null, "key": "note_created_descending", "label": "Created Date (Newest to Oldest)", "qdt": 20, "value": "note_created_descending" },
                    "note_date_ascending": { "default": false, "enum_case": null, "key": "note_date_ascending", "label": "Note Date (Oldest to Newest)", "qdt": 20, "value": "note_date_ascending" },
                    "note_date_descending": { "default": true, "enum_case": null, "key": "note_date_descending", "label": "Note Date (Newest to Oldest) - Default", "qdt": 20, "value": "note_date_descending" },
                    "public_organization_created_ascending": { "default": false, "enum_case": null, "key": "public_organization_created_ascending", "label": "Date Created (Oldest to Newest)", "qdt": 42, "value": "public_organization_created_ascending" },
                    "public_organization_created_descending": { "default": false, "enum_case": null, "key": "public_organization_created_descending", "label": "Date Created (Newest to Oldest)", "qdt": 42, "value": "public_organization_created_descending" },
                    "public_organization_name_ascending": { "default": false, "enum_case": null, "key": "public_organization_name_ascending", "label": "Name (A to Z)", "qdt": 42, "value": "public_organization_name_ascending" },
                    "public_organization_name_descending": { "default": false, "enum_case": null, "key": "public_organization_name_descending", "label": "Name (Z to A)", "qdt": 42, "value": "public_organization_name_descending" },
                    "public_organization_name_weighted_ascending": { "default": true, "enum_case": null, "key": "public_organization_name_weighted_ascending", "label": "Name (A to Z, Weighted) - Default", "qdt": 42, "value": "public_organization_name_weighted_ascending" },
                    "public_organization_name_weighted_descending": { "default": false, "enum_case": null, "key": "public_organization_name_weighted_descending", "label": "Name (Z to A, Weighted)", "qdt": 42, "value": "public_organization_name_weighted_descending" },
                    "public_organization_updated_ascending": { "default": false, "enum_case": null, "key": "public_organization_updated_ascending", "label": "Date Updated (Oldest to Newest)", "qdt": 42, "value": "public_organization_updated_ascending" },
                    "public_organization_updated_descending": { "default": false, "enum_case": null, "key": "public_organization_updated_descending", "label": "Date Updated (Newest to Oldest)", "qdt": 42, "value": "public_organization_updated_descending" },
                    "regulation_detailed_status_date_ascending": { "default": false, "enum_case": null, "key": "regulation_detailed_status_date_ascending", "label": "Last Action (Least Recent to Most Recent)", "qdt": 80, "value": "regulation_detailed_status_date_ascending" },
                    "regulation_detailed_status_date_descending": { "default": false, "enum_case": null, "key": "regulation_detailed_status_date_descending", "label": "Last Action (Most Recent to Least Recent)", "qdt": 80, "value": "regulation_detailed_status_date_descending" },
                    "regulation_detailed_status_date_id_ascending": { "default": false, "enum_case": null, "key": "regulation_detailed_status_date_id_ascending", "label": "Last Action (Least Recent to Most Recent, Date Created)", "qdt": 80, "value": "regulation_detailed_status_date_id_ascending" },
                    "regulation_detailed_status_date_id_descending": { "default": true, "enum_case": null, "key": "regulation_detailed_status_date_id_descending", "label": "Last Action (Most Recent to Least Recent, Date Created) - Default", "qdt": 80, "value": "regulation_detailed_status_date_id_descending" },
                    "regulation_proposal_date_ascending": { "default": false, "enum_case": null, "key": "regulation_proposal_date_ascending", "label": "Proposal/Filed Date (Oldest to Newest)", "qdt": 80, "value": "regulation_proposal_date_ascending" },
                    "regulation_proposal_date_descending": { "default": false, "enum_case": null, "key": "regulation_proposal_date_descending", "label": "Proposal/Filed Date (Newest to Oldest)", "qdt": 80, "value": "regulation_proposal_date_descending" },
                    "send_email_archived_sent_ascending": { "default": false, "enum_case": null, "key": "send_email_archived_sent_ascending", "label": "Sent (Oldest to Newest)", "qdt": 134, "value": "send_email_archived_sent_ascending" },
                    "send_email_archived_sent_descending": { "default": false, "enum_case": null, "key": "send_email_archived_sent_descending", "label": "Sent (Newest to Oldest)", "qdt": 134, "value": "send_email_archived_sent_descending" },
                    "send_email_sent_ascending": { "default": false, "enum_case": null, "key": "send_email_sent_ascending", "label": "Sent (Oldest to Newest)", "qdt": 45, "value": "send_email_sent_ascending" },
                    "send_email_sent_descending": { "default": false, "enum_case": null, "key": "send_email_sent_descending", "label": "Sent (Newest to Oldest)", "qdt": 45, "value": "send_email_sent_descending" },
                    "send_sms_sent_ascending": { "default": false, "enum_case": null, "key": "send_sms_sent_ascending", "label": "Sent (Oldest to Newest)", "qdt": 119, "value": "send_sms_sent_ascending" },
                    "send_sms_sent_descending": { "default": false, "enum_case": null, "key": "send_sms_sent_descending", "label": "Sent (Newest to Oldest)", "qdt": 119, "value": "send_sms_sent_descending" },
                    "supporter_created_ascending": { "default": false, "enum_case": null, "key": "supporter_created_ascending", "label": "Date Created (Oldest to Newest)", "qdt": 12, "value": "supporter_created_ascending" },
                    "supporter_created_descending": { "default": false, "enum_case": null, "key": "supporter_created_descending", "label": "Date Created (Newest to Oldest)", "qdt": 12, "value": "supporter_created_descending" },
                    "supporter_updated_ascending": { "default": false, "enum_case": null, "key": "supporter_updated_ascending", "label": "Date Updated (Oldest to Newest)", "qdt": 12, "value": "supporter_updated_ascending" },
                    "supporter_updated_descending": { "default": false, "enum_case": null, "key": "supporter_updated_descending", "label": "Date Updated (Newest to Oldest)", "qdt": 12, "value": "supporter_updated_descending" },
                    "vote_created_ascending": { "default": false, "enum_case": null, "key": "vote_created_ascending", "label": "Date (Oldest to Newest)", "qdt": 3, "value": "vote_created_ascending" },
                    "vote_created_descending": { "default": true, "enum_case": null, "key": "vote_created_descending", "label": "Date (Newest to Oldest) - Default", "qdt": 3, "value": "vote_created_descending" }
                }
            }
        },
        "social": {
            "models": {
                "FacebookAccountType": {
                    "__is_enum": true,
                    "page": { "key": "page", "label": "page", "value": 1 },
                    "user": { "key": "user", "label": "user", "value": 2 }
                },
                "SocialUser": {
                    "__is_model": true,
                    "__name__": "SocialUser",
                    "data_model": "app.social.models.SocialUser",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/socialuser/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": null, "help_text": "json list of all scores for retweets of users for updating", "name": "all_retweets", "verbose_name": "all retweets" },
                        { "field_type": null, "help_text": "json list of the top TwitterUsers retweets", "name": "user_retweets", "verbose_name": "user retweets" },
                        { "field_type": 4, "help_text": "The number of followers this account has", "name": "followers_count", "verbose_name": "followers count" },
                        { "field_type": 4, "help_text": "The number of friends this account has", "name": "friends_count", "verbose_name": "friends count" },
                        { "field_type": 4, "help_text": "The number of retweets this account has", "name": "retweet_count", "verbose_name": "retweet count" },
                        { "field_type": 4, "help_text": "The number of tweets this account has", "name": "tweet_count", "verbose_name": "tweet count" },
                        { "field_type": 3, "help_text": "Twitter's profile photo url location, as one would find on twitter.com", "name": "social_profile_picture_url", "verbose_name": "social profile picture url" },
                        { "field_type": 2, "help_text": "The name that appears on this facebook page", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.social.models", "__name__": "FacebookAccountType" },
                            "field_type": 4,
                            "help_text": "The specific type of Facebook account to aid in parsing (user vs None vs page)",
                            "name": "facebook_account_type",
                            "verbose_name": "facebook account type"
                        },
                        { "field_type": 2, "help_text": "", "name": "custom_medium_feed_url", "verbose_name": "custom medium feed url" },
                        {
                            "field_type": 7,
                            "help_text": "The person object associated with this social user account.",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The committee associated with this social user account",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The Public Organization associated with this social user account.",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The quorum user objects associated with this social user account",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        { "field_type": null, "help_text": "json list of all scores for mentions of users for updating", "name": "all_mentions", "verbose_name": "all mentions" },
                        { "field_type": null, "help_text": "JSON list of top mentions of SocialUsers of this type", "name": "user_mentions", "verbose_name": "user mentions" },
                        { "field_type": 1, "help_text": "True if we made a request to determine if this account was valid", "name": "was_validated", "verbose_name": "was validated" },
                        { "field_type": 1, "help_text": "Set to True if this is a valid account, meaning we can scrape it", "name": "is_valid", "verbose_name": "is valid" },
                        { "field_type": 1, "help_text": "Boolean if this account is currently active and we should scrape it", "name": "is_active", "verbose_name": "is active" },
                        { "field_type": null, "help_text": "", "name": "supporters", "verbose_name": "supporters" },
                        { "field_type": null, "help_text": "", "name": "public_organizations", "verbose_name": "public organizations" },
                        { "field_type": null, "help_text": "", "name": "custom_persons", "verbose_name": "custom persons" },
                        { "field_type": null, "help_text": "", "name": "organizations", "verbose_name": "organizations" },
                        { "field_type": 1, "help_text": "Determines if we should save all documents associated with this SocialUser", "name": "should_save_documents", "verbose_name": "should save documents" },
                        { "field_type": 1, "help_text": "If true, scrape old docs from this account next parser run", "name": "save_old_docs", "verbose_name": "save old docs" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.social.models", "__name__": "SocialUserType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "social_user_type",
                            "verbose_name": "social user type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.statements.models", "__name__": "PressReleaseType" },
                            "field_type": 4,
                            "help_text": "The subtype of this user object (Person, Campaign, House Majority, etc)",
                            "name": "social_user_subtype",
                            "verbose_name": "social user subtype"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region a SocialUser user belongs to.",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 4, "help_text": "The PK of the old object this belongs to. Used for creating.", "name": "legacy_pk", "verbose_name": "legacy pk" },
                        { "field_type": 2, "help_text": "The absolute URL of this SocialUser", "name": "url", "verbose_name": "url" },
                        { "field_type": 2, "help_text": "The unique stable ID for this SocialUser", "name": "userid", "verbose_name": "userid" },
                        { "field_type": 3, "help_text": "The username of this SocialUser", "name": "username", "verbose_name": "username" },
                        { "field_type": null, "help_text": "", "name": "prev_usernames_array", "verbose_name": "prev usernames array" },
                        { "field_type": 4, "help_text": "The average number of docs this account produces per month, for the last 3 months", "name": "average_documents", "verbose_name": "average documents" },
                        { "field_type": 3, "help_text": "The about section of the Social Account", "name": "social_biography", "verbose_name": "social biography" },
                        { "field_type": 1, "help_text": "If set to True, we will _never_ parse this account's Documents (tweets, posts, etc).We _may_ still parse their account's stats (followers_count, social_biography, profile_picture, etc).", "name": "skip_document_parsing", "verbose_name": "skip document parsing" },
                        { "field_type": 16, "help_text": "The next time this SocialUser will be parsed", "name": "next_check", "verbose_name": "next check" },
                        { "field_type": 1, "help_text": "Set to True if account is verified", "name": "is_verified", "verbose_name": "is verified" },
                        { "field_type": null, "help_text": "To maintain the history of error api response", "name": "parsing_error_history", "verbose_name": "parsing error history" },
                        { "field_type": 16, "help_text": "The last time this TwitterUser was mark inactive", "name": "inactivated", "verbose_name": "inactivated" },
                        { "field_type": 1, "help_text": "Will this social user be deprecated under the Twitter v2 API", "name": "to_be_deprecated", "verbose_name": "to be deprecated" }
                    ]
                },
                "SocialUserType": {
                    "__is_enum": true,
                    "facebook_user": { "canonical_url": "Facebook.com", "color": "#1877F2", "document_type": 9, "faIcon": "fa-facebook", "icon": "facebook-square", "icon_family": "fab", "key": "facebook_user", "label": "Facebook User", "parser_name": "facebook", "platform_key": "facebook", "platform_name": "Facebook", "profile_url": "https://facebook.com/", "proxy": "NewFacebookUser", "value": 2 },
                    "instagram_user": { "canonical_url": "Instagram.com", "color": "#515BD4", "document_type": 39, "faIcon": "fa-instagram", "icon": "instagram-square", "icon_family": "fab", "key": "instagram_user", "label": "Instagram User", "parser_name": "instagram", "platform_key": "instagram", "platform_name": "Instagram", "profile_url": "https://instagram.com/", "proxy": "NewInstagramUser", "value": 4 },
                    "medium_user": { "canonical_url": "Medium.com", "color": "#495057", "document_type": 38, "faIcon": "fa-medium", "icon": "medium", "icon_family": "fab", "key": "medium_user", "label": "Medium User", "parser_name": "medium", "platform_key": "medium", "platform_name": "Medium", "profile_url": "https://medium.com/@", "proxy": "NewMediumUser", "value": 3 },
                    "twitter_user": { "canonical_url": "X.com", "color": "#1DA1F2", "document_type": 6, "faIcon": "fa-twitter", "icon": "twitter-square", "icon_family": "fab", "key": "twitter_user", "label": "Twitter User", "parser_name": "social", "platform_key": "twitter", "platform_name": "X (Formerly Twitter)", "profile_url": "https://x.com/", "proxy": "NewTwitterUser", "value": 1 },
                    "youtube_user": { "canonical_url": "Youtube.com", "color": "#FF0000", "document_type": 41, "faIcon": "fa-youtube", "icon": "youtube-square", "icon_family": "fab", "key": "youtube_user", "label": "YouTube User", "parser_name": "youtube", "platform_key": "youtube", "platform_name": "Youtube", "profile_url": "https://youtube.com/user/", "proxy": "NewYouTubeUser", "value": 5 }
                },
                "SocialUserValidationErrors": {
                    "__is_enum": true,
                    "already_validated": { "key": "already_validated", "label": "Already Validated", "swal_message": "This account was already validated.", "value": 7 },
                    "duplicate_owner": { "key": "duplicate_owner", "label": "Duplicate Owner", "swal_message": "This account is already owned by someone else in your organization.", "value": 6 },
                    "internal_error": { "key": "internal_error", "label": "Internal Error", "swal_message": "Sorry, there was an internal error.", "value": 4 },
                    "invalid_format": { "key": "invalid_format", "label": "Invalid Format", "swal_message": "Sorry, that is an invalid format.", "value": 1 },
                    "invalid_username": { "key": "invalid_username", "label": "Invalid Username", "swal_message": "Sorry, that is not a valid username.", "value": 2 },
                    "not_supported": { "key": "not_supported", "label": "Not Supported", "swal_message": "This social media type is not supported.", "value": 5 },
                    "out_of_accounts": { "key": "out_of_accounts", "label": "Out of Accounts", "swal_message": "You've reached your account limit, please reach out to your CSM to increase your limit.", "value": 8 },
                    "quorum_owner": { "key": "quorum_owner", "label": "Quorum Owner", "swal_message": "This account already belongs to a Quorum data set. Please contact support for more information.", "value": 9 },
                    "try_again_later": { "key": "try_again_later", "label": "Try Again Later", "swal_message": "Sorry, try accessing this social media service later.", "value": 3 }
                }
            }
        },
        "statements": {
            "models": {
                "PressReleaseType": {
                    "Campaign": { "display": "Campaign Post", "inline_display": "Campaign", "key": "Campaign", "label": "Campaign", "value": 16 },
                    "Committee": { "display": "Committee", "inline_display": "", "key": "Committee", "label": "Committee", "value": 27 },
                    "CommitteeFull": { "display": "Committee Full", "inline_display": "Full", "key": "CommitteeFull", "label": "CommitteeFull", "value": 4 },
                    "CommitteeMajority": { "display": "Committee Majority", "inline_display": "Majority", "key": "CommitteeMajority", "label": "CommitteeMajority", "value": 2 },
                    "CommitteeMinority": { "display": "Committee Minority", "inline_display": "Minority", "key": "CommitteeMinority", "label": "CommitteeMinority", "value": 3 },
                    "Democrat": { "display": "Democrat", "inline_display": "Democrats", "key": "Democrat", "label": "Democrat", "value": 25 },
                    "FederalOrganization": { "display": "Federal Organization", "inline_display": "", "key": "FederalOrganization", "label": "FederalOrganization", "value": 19 },
                    "HouseDemocrat": { "display": "House Democrats", "inline_display": "Democrats", "key": "HouseDemocrat", "label": "HouseDemocrat", "value": 7 },
                    "HouseRepublican": { "display": "House Republicans", "inline_display": "", "key": "HouseRepublican", "label": "HouseRepublican", "value": 23 },
                    "NoneGiven": { "display": "None", "inline_display": "None", "key": "NoneGiven", "label": "Other" },
                    "Other": { "display": "Other", "inline_display": "Other", "key": "Other", "label": "Other", "value": 6 },
                    "Person": { "display": "Person", "inline_display": "Person", "key": "Person", "label": "Person", "value": 1 },
                    "Personal": { "display": "Personal Post", "inline_display": "Personal", "key": "Personal", "label": "Personal", "value": 17 },
                    "PositionRelease": { "display": "Position Release", "inline_display": "Position Release", "key": "PositionRelease", "label": "PositionRelease", "value": 5 },
                    "PublicOrganization": { "display": "Public Organization", "inline_display": "Public Organization", "key": "PublicOrganization", "label": "PublicOrganization", "value": 20 },
                    "Republican": { "display": "Republican", "inline_display": "Republicans", "key": "Republican", "label": "Republican", "value": 26 },
                    "SenateDemocrat": { "display": "Senate Democrats", "inline_display": "", "key": "SenateDemocrat", "label": "SenateDemocrat", "value": 21 },
                    "SenateRepublican": { "display": "Senate Republicans", "inline_display": "", "key": "SenateRepublican", "label": "SenateRepublican", "value": 22 },
                    "StateAttorneyGeneral": { "display": "State Attorney General", "inline_display": "Attorney General", "key": "StateAttorneyGeneral", "label": "AttorneyGeneral", "value": 18 },
                    "StateGovernor": { "display": "State Governor", "inline_display": "Governor", "key": "StateGovernor", "label": "StateGovernor", "value": 8 },
                    "StateHouseAll": { "display": "State House All", "inline_display": "", "key": "StateHouseAll", "label": "StateHouseAll", "value": 14 },
                    "StateHouseDemocrat": { "display": "State House Democrats", "inline_display": "Democrats", "key": "StateHouseDemocrat", "label": "StateHouseDemocrat", "value": 11 },
                    "StateHouseRepublican": { "display": "State House Republicans", "inline_display": "Republicans", "key": "StateHouseRepublican", "label": "StateHouseRepublican", "value": 12 },
                    "StateLegislatureAll": { "display": "State Legislature All", "inline_display": "", "key": "StateLegislatureAll", "label": "StateLegislatureAll", "value": 15 },
                    "StateSenateAll": { "display": "State Senate All", "inline_display": "", "key": "StateSenateAll", "label": "StateSenateAll", "value": 13 },
                    "StateSenateDemocrat": { "display": "State Senate Democrats", "inline_display": "Democrats", "key": "StateSenateDemocrat", "label": "StateSenateDemocrat", "value": 9 },
                    "StateSenateRepublican": { "display": "State Senate Republicans", "inline_display": "Republicans", "key": "StateSenateRepublican", "label": "StateSenateRepublican", "value": 10 },
                    "WhiteHouse": { "display": "White House", "inline_display": "", "key": "WhiteHouse", "label": "WhiteHouse", "value": 24 },
                    "__is_enum": true,
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Congress",
                            "values": [1, 7, 5]
                        },
                        {
                            "display": "list",
                            "title": "State",
                            "values": [8, 15, 13, 9, 10, 14, 11, 12, 18]
                        },
                        {
                            "display": "list",
                            "title": "Committee",
                            "values": [4, 2, 3, 25, 26, 27]
                        }
                    ]
                }
            }
        },
        "stats": {
            "models": {
                "ModelNames": {
                    "__is_enum": true,
                    "accessattempt": { "key": "accessattempt", "label": "Accessattempt", "value": 10 },
                    "accesslog": { "key": "accesslog", "label": "Accesslog", "value": 11 },
                    "activationkey": { "key": "activationkey", "label": "Activationkey", "value": 99 },
                    "admin": { "key": "admin", "label": "Admin", "value": 29 },
                    "amendment": { "key": "amendment", "label": "Amendment", "value": 12 },
                    "amendmentlist": { "key": "amendmentlist", "label": "Amendmentlist", "readable_label": "Amendment Statistics", "value": 100 },
                    "assignment": { "key": "assignment", "label": "Assignment", "value": 101 },
                    "autocolumn": { "key": "autocolumn", "label": "Autocolumn", "value": 102 },
                    "bannedip": { "key": "bannedip", "label": "Bannedip", "value": 93 },
                    "bill": { "key": "bill", "label": "Bill", "value": 13 },
                    "billlink": { "key": "billlink", "label": "Billlink", "value": 14 },
                    "billlist": { "key": "billlist", "label": "Billlist", "readable_label": "Bill Statistics", "value": 103 },
                    "billsummary": { "key": "billsummary", "label": "Billsummary", "value": 15 },
                    "billterm": { "key": "billterm", "label": "Billterm", "value": 16 },
                    "billtext": { "key": "billtext", "label": "Billtext", "value": 17 },
                    "bulkemail": { "key": "bulkemail", "label": "Bulkemail", "value": 106 },
                    "censustract": { "key": "censustract", "label": "Censustract", "value": 38 },
                    "censustractstats": { "key": "censustractstats", "label": "Censustractstats", "value": 39 },
                    "column": { "key": "column", "label": "Column", "value": 107 },
                    "comment": { "key": "comment", "label": "Comment", "value": 108 },
                    "committee": { "key": "committee", "label": "Committee", "value": 24 },
                    "committeedocument": { "key": "committeedocument", "label": "Committeedocument", "value": 25 },
                    "committeemeeting": { "key": "committeemeeting", "label": "Committeemeeting", "value": 26 },
                    "committeemember": { "key": "committeemember", "label": "Committeemember", "value": 27 },
                    "committeeprofiledata": { "key": "committeeprofiledata", "label": "Committeeprofiledata", "value": 81 },
                    "committeestats": { "key": "committeestats", "label": "Committeestats", "value": 82 },
                    "committeewitness": { "key": "committeewitness", "label": "Committeewitness", "value": 28 },
                    "congress": { "key": "congress", "label": "Congress", "value": 83 },
                    "congressionalrecord": { "key": "congressionalrecord", "label": "Congressionalrecord", "value": 74 },
                    "congressionalrecordsubsection": { "key": "congressionalrecordsubsection", "label": "Congressionalrecordsubsection", "value": 75 },
                    "congressstats": { "key": "congressstats", "label": "Congressstats", "value": 84 },
                    "contact": { "key": "contact", "label": "Contact", "value": 109 },
                    "content": { "key": "content", "label": "Content", "value": 30 },
                    "cookpvi": { "key": "cookpvi", "label": "Cookpvi", "value": 40 },
                    "cookseatrace": { "key": "cookseatrace", "label": "Cookseatrace", "value": 41 },
                    "cosponsor": { "key": "cosponsor", "label": "Cosponsor", "value": 18 },
                    "cosponsor_boxes": { "key": "cosponsor_boxes", "label": "Cosponsor Boxes", "value": 140 },
                    "cron": { "key": "cron", "label": "Cron", "value": 31 },
                    "dcletter": { "key": "dcletter", "label": "Dcletter", "value": 76 },
                    "dcterm": { "key": "dcterm", "label": "Dcterm", "value": 77 },
                    "defaultamendmentlist": { "key": "defaultamendmentlist", "label": "Defaultamendmentlist", "value": 110 },
                    "defaultbilllist": { "key": "defaultbilllist", "label": "Defaultbilllist", "value": 111 },
                    "defaultpersonlist": { "key": "defaultpersonlist", "label": "Defaultpersonlist", "value": 112 },
                    "defaultvotelist": { "key": "defaultvotelist", "label": "Defaultvotelist", "value": 113 },
                    "district": { "key": "district", "label": "District", "value": 42 },
                    "districtstats": { "key": "districtstats", "label": "Districtstats", "value": 43 },
                    "districtvisdata": { "key": "districtvisdata", "label": "Districtvisdata", "value": 44 },
                    "donation": { "key": "donation", "label": "Donation", "value": 114 },
                    "electionresults": { "key": "electionresults", "label": "Electionresults", "value": 45 },
                    "esri": { "key": "esri", "label": "Esri", "readable_label": "Esri Statistics", "value": 133 },
                    "event": { "key": "event", "label": "Event", "value": 35 },
                    "exploredata": { "key": "exploredata", "label": "Exploredata", "value": 85 },
                    "facebookcomment": { "key": "facebookcomment", "label": "Facebookcomment", "value": 66 },
                    "facebookpage": { "key": "facebookpage", "label": "Facebookpage", "value": 67 },
                    "facebookpagestats": { "key": "facebookpagestats", "label": "Facebookpagestats", "readable_label": "Facebook Statistics", "value": 139 },
                    "facebookpost": { "key": "facebookpost", "label": "Facebookpost", "value": 68 },
                    "feed": { "key": "feed", "label": "Feed", "value": 36 },
                    "feeditem": { "key": "feeditem", "label": "Feeditem", "value": 115 },
                    "feedobject": { "key": "feedobject", "label": "Feedobject", "value": 116 },
                    "feedsubscriber": { "key": "feedsubscriber", "label": "Feedsubscriber", "value": 117 },
                    "file": { "key": "file", "label": "File", "value": 56 },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislative",
                            "values": [92, 100, 136, 103]
                        },
                        {
                            "display": "list",
                            "title": "Geographic",
                            "values": [0, 133]
                        },
                        {
                            "display": "list",
                            "title": "Social",
                            "values": [139, 72]
                        }
                    ],
                    "finance": { "key": "finance", "label": "Finance", "value": 23 },
                    "floorstatement": { "key": "floorstatement", "label": "Floorstatement", "value": 78 },
                    "generalstatement": { "key": "generalstatement", "label": "Generalstatement", "value": 79 },
                    "geography": { "key": "geography", "label": "geography", "readable_label": "Geographic Statistics", "value": 0 },
                    "group": { "key": "group", "label": "Group", "value": 7 },
                    "hashtag": { "key": "hashtag", "label": "Hashtag", "value": 69 },
                    "helpquestions": { "key": "helpquestions", "label": "Helpquestions", "value": 1 },
                    "interaction": { "key": "interaction", "label": "Interaction", "value": 119 },
                    "issueprofiledata": { "key": "issueprofiledata", "label": "Issueprofiledata", "value": 86 },
                    "issuestats": { "key": "issuestats", "label": "Issuestats", "value": 87 },
                    "listitem": { "key": "listitem", "label": "Listitem", "value": 120 },
                    "memberoffice": { "key": "memberoffice", "label": "Memberoffice", "value": 58 },
                    "memberprofiledata": { "key": "memberprofiledata", "label": "Memberprofiledata", "value": 88 },
                    "memberprofilevalues": { "key": "memberprofilevalues", "label": "Memberprofilevalues", "value": 89 },
                    "migrationhistory": { "key": "migrationhistory", "label": "Migrationhistory", "value": 73 },
                    "migrations": { "key": "migrations", "label": "Migrations", "value": 32 },
                    "nation": { "key": "nation", "label": "Nation", "value": 46 },
                    "nationalstats": { "key": "nationalstats", "label": "Nationalstats", "value": 47 },
                    "network": { "key": "network", "label": "Network", "value": 51 },
                    "networkd3": { "key": "networkd3", "label": "Networkd3", "value": 52 },
                    "networkedge": { "key": "networkedge", "label": "Networkedge", "value": 53 },
                    "networkedgeweight": { "key": "networkedgeweight", "label": "Networkedgeweight", "value": 54 },
                    "networknodestats": { "key": "networknodestats", "label": "Networknodestats", "value": 90 },
                    "networkstats": { "key": "networkstats", "label": "Networkstats", "value": 91 },
                    "networkweightcondition": { "key": "networkweightcondition", "label": "Networkweightcondition", "value": 55 },
                    "note": { "key": "note", "label": "Note", "value": 121 },
                    "objectfollower": { "key": "objectfollower", "label": "Objectfollower", "value": 122 },
                    "organization": { "key": "organization", "label": "Organization", "value": 123 },
                    "overview_boxes": { "key": "overview_boxes", "label": "Overview Boxes", "value": 141 },
                    "pageprogramcontact": { "key": "pageprogramcontact", "label": "Pageprogramcontact", "value": 124 },
                    "pagetutorial": { "key": "pagetutorial", "label": "Pagetutorial", "value": 2 },
                    "parentlistfeed": { "key": "parentlistfeed", "label": "Parentlistfeed", "value": 125 },
                    "permission": { "key": "permission", "label": "Permission", "value": 8 },
                    "person": { "key": "person", "label": "Person", "value": 59 },
                    "personbiography": { "key": "personbiography", "label": "Personbiography", "value": 60 },
                    "personlist": { "key": "personlist", "label": "Personlist", "value": 126 },
                    "personrole": { "key": "personrole", "label": "Personrole", "value": 61 },
                    "personstats": { "key": "personstats", "label": "Personstats", "readable_label": "Person Statistics", "value": 92 },
                    "personupdate": { "key": "personupdate", "label": "Personupdate", "value": 57 },
                    "phrasemention": { "key": "phrasemention", "label": "Phrasemention", "value": 127 },
                    "post": { "key": "post", "label": "Post", "value": 21 },
                    "posttopic": { "key": "posttopic", "label": "Posttopic", "value": 22 },
                    "pressrelease": { "key": "pressrelease", "label": "Pressrelease", "value": 80 },
                    "registrationprofile": { "key": "registrationprofile", "label": "Registrationprofile", "value": 65 },
                    "relatedbill": { "key": "relatedbill", "label": "Relatedbill", "value": 19 },
                    "savedsearch": { "key": "savedsearch", "label": "Savedsearch", "value": 128 },
                    "sendemail": { "key": "sendemail", "label": "Sendemail", "value": 129 },
                    "sendemailopenstats": { "key": "sendemailopenstats", "label": "Sendemailopenstats", "value": 130 },
                    "session": { "key": "session", "label": "Session", "value": 33 },
                    "shortenedlink": { "key": "shortenedlink", "label": "Shortenedlink", "value": 3 },
                    "socialdata": { "key": "socialdata", "label": "Socialdata", "value": 70 },
                    "spreadsheet": { "key": "spreadsheet", "label": "Spreadsheet", "value": 131 },
                    "spreadsheetinfo": { "key": "spreadsheetinfo", "label": "Spreadsheetinfo", "value": 132 },
                    "staffer": { "key": "staffer", "label": "Staffer", "value": 62 },
                    "staffercolumn": { "key": "staffercolumn", "label": "Staffercolumn", "readable_label": "Staffer Column", "value": 142 },
                    "stafferterm": { "key": "stafferterm", "label": "Stafferterm", "value": 63 },
                    "stafftitle": { "key": "stafftitle", "label": "Stafftitle", "value": 64 },
                    "state": { "key": "state", "label": "State", "value": 48 },
                    "statestats": { "key": "statestats", "label": "Statestats", "value": 49 },
                    "statevisdata": { "key": "statevisdata", "label": "Statevisdata", "value": 50 },
                    "subscriptionlist": { "key": "subscriptionlist", "label": "Subscriptionlist", "value": 37 },
                    "summernote": { "key": "summernote", "label": "Summernote", "value": 34 },
                    "travel": { "key": "travel", "label": "Travel", "value": 96 },
                    "traveldestination": { "key": "traveldestination", "label": "Traveldestination", "value": 97 },
                    "travelsponsor": { "key": "travelsponsor", "label": "Travelsponsor", "value": 98 },
                    "tutorialstep": { "key": "tutorialstep", "label": "Tutorialstep", "value": 4 },
                    "tutorialview": { "key": "tutorialview", "label": "Tutorialview", "value": 5 },
                    "tweet": { "key": "tweet", "label": "Tweet", "value": 71 },
                    "twitteruser": { "key": "twitteruser", "label": "Twitteruser", "readable_label": "Twitter Statistics", "value": 72 },
                    "untrackeduseragent": { "key": "untrackeduseragent", "label": "Untrackeduseragent", "value": 94 },
                    "uscsection": { "key": "uscsection", "label": "Uscsection", "value": 20 },
                    "user": { "key": "user", "label": "User", "value": 9 },
                    "useralert": { "key": "useralert", "label": "Useralert", "value": 134 },
                    "usercode": { "key": "usercode", "label": "Usercode", "value": 6 },
                    "userinfo": { "key": "userinfo", "label": "Userinfo", "value": 135 },
                    "visitor": { "key": "visitor", "label": "Visitor", "value": 95 },
                    "vote": { "key": "vote", "label": "Vote", "value": 137 },
                    "vote_boxes": { "key": "vote_boxes", "label": "Vote Boxes", "value": 143 },
                    "votebill": { "key": "votebill", "label": "Votebill", "value": 138 },
                    "votelist": { "key": "votelist", "label": "Votelist", "readable_label": "Vote Statistics", "value": 136 }
                },
                "PersonStats": {
                    "__is_model": true,
                    "__name__": "PersonStats",
                    "data_model": "app.stats.models.PersonStats",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/personstats/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the amendment was introduced.",
                            "name": "session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "session"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "region",
                            "verbose_name": "region"
                        },
                        { "field_type": 1, "help_text": "", "name": "all_sessions", "verbose_name": "all sessions" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "term",
                            "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                            "verbose_name": "term"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "StatsType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "stats_type",
                            "verbose_name": "stats type"
                        },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_bill", "verbose_name": "num sponsored bill" },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_no_cosponsors_bill", "verbose_name": "num sponsored no cosponsors bill" },
                        { "field_type": 6, "help_text": "", "name": "percent_sponsored_no_cosponsors_bill", "verbose_name": "percent sponsored no cosponsors bill" },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_no_opp_cosponsors_bill", "verbose_name": "num sponsored no opp cosponsors bill" },
                        { "field_type": 6, "help_text": "", "name": "percent_sponsored_no_opp_cosponsors_bill", "verbose_name": "percent sponsored no opp cosponsors bill" },
                        { "field_type": 6, "help_text": "", "name": "avg_cosponsors_per_sponsored_bill", "verbose_name": "avg cosponsors per sponsored bill" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_enacted_bill", "verbose_name": "sponsored num enacted bill" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_left_committee_bill", "verbose_name": "sponsored num left committee bill" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_pass_original_chamber_bill", "verbose_name": "sponsored num pass original chamber bill" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_pass_second_chamber_bill", "verbose_name": "sponsored num pass second chamber bill" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_enacted_bill", "verbose_name": "sponsored percent enacted bill" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_left_committee_bill", "verbose_name": "sponsored percent left committee bill" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_pass_original_chamber_bill", "verbose_name": "sponsored percent pass original chamber bill" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_pass_second_chamber_bill", "verbose_name": "sponsored percent pass second chamber bill" },
                        { "field_type": 6, "help_text": "", "name": "avg_amendments_per_sponsored_bill", "verbose_name": "avg amendments per sponsored bill" },
                        { "field_type": 6, "help_text": "", "name": "avg_dem_cosponsors_per_sponsored_bill", "verbose_name": "avg dem cosponsors per sponsored bill" },
                        { "field_type": 6, "help_text": "", "name": "avg_rep_cosponsors_per_sponsored_bill", "verbose_name": "avg rep cosponsors per sponsored bill" },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_resolution", "verbose_name": "num sponsored resolution" },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_no_cosponsors_resolution", "verbose_name": "num sponsored no cosponsors resolution" },
                        { "field_type": 6, "help_text": "", "name": "percent_sponsored_no_cosponsors_resolution", "verbose_name": "percent sponsored no cosponsors resolution" },
                        { "field_type": 4, "help_text": "", "name": "num_sponsored_no_opp_cosponsors_resolution", "verbose_name": "num sponsored no opp cosponsors resolution" },
                        { "field_type": 6, "help_text": "", "name": "percent_sponsored_no_opp_cosponsors_resolution", "verbose_name": "percent sponsored no opp cosponsors resolution" },
                        { "field_type": 6, "help_text": "", "name": "avg_cosponsors_per_sponsored_resolution", "verbose_name": "avg cosponsors per sponsored resolution" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_enacted_resolution", "verbose_name": "sponsored num enacted resolution" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_left_committee_resolution", "verbose_name": "sponsored num left committee resolution" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_pass_original_chamber_resolution", "verbose_name": "sponsored num pass original chamber resolution" },
                        { "field_type": 4, "help_text": "", "name": "sponsored_num_pass_second_chamber_resolution", "verbose_name": "sponsored num pass second chamber resolution" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_enacted_resolution", "verbose_name": "sponsored percent enacted resolution" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_left_committee_resolution", "verbose_name": "sponsored percent left committee resolution" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_pass_original_chamber_resolution", "verbose_name": "sponsored percent pass original chamber resolution" },
                        { "field_type": 6, "help_text": "", "name": "sponsored_percent_pass_second_chamber_resolution", "verbose_name": "sponsored percent pass second chamber resolution" },
                        { "field_type": 6, "help_text": "", "name": "avg_amendments_per_sponsored_resolution", "verbose_name": "avg amendments per sponsored resolution" },
                        { "field_type": 6, "help_text": "", "name": "avg_dem_cosponsors_per_sponsored_resolution", "verbose_name": "avg dem cosponsors per sponsored resolution" },
                        { "field_type": 6, "help_text": "", "name": "avg_rep_cosponsors_per_sponsored_resolution", "verbose_name": "avg rep cosponsors per sponsored resolution" },
                        { "field_type": 4, "help_text": "", "name": "num_cosponsored_bills", "verbose_name": "num cosponsored bills" },
                        { "field_type": 4, "help_text": "", "name": "num_cosponsored_bills_opp_sponsor", "verbose_name": "num cosponsored bills opp sponsor" },
                        { "field_type": 6, "help_text": "", "name": "percent_cosponsored_bills_opp_sponsor", "verbose_name": "percent cosponsored bills opp sponsor" },
                        { "field_type": 4, "help_text": "", "name": "num_unique_sponsors", "verbose_name": "num unique sponsors" },
                        { "field_type": 6, "help_text": "", "name": "avg_cosponsors_per_cosponsored_bill", "verbose_name": "avg cosponsors per cosponsored bill" },
                        { "field_type": 4, "help_text": "", "name": "num_amendments", "verbose_name": "num amendments" },
                        { "field_type": 4, "help_text": "", "name": "num_amendments_fail", "verbose_name": "num amendments fail" },
                        { "field_type": 4, "help_text": "", "name": "num_amendments_pass", "verbose_name": "num amendments pass" },
                        { "field_type": 4, "help_text": "", "name": "num_amendments_withdrawn", "verbose_name": "num amendments withdrawn" },
                        { "field_type": 4, "help_text": "", "name": "num_amendments_to_opp_bill", "verbose_name": "num amendments to opp bill" },
                        { "field_type": 6, "help_text": "", "name": "percent_amendments_fail", "verbose_name": "percent amendments fail" },
                        { "field_type": 6, "help_text": "", "name": "percent_amendments_pass", "verbose_name": "percent amendments pass" },
                        { "field_type": 6, "help_text": "", "name": "percent_amendments_withdrawn", "verbose_name": "percent amendments withdrawn" },
                        { "field_type": 6, "help_text": "", "name": "percent_amendments_to_opp_bill", "verbose_name": "percent amendments to opp bill" },
                        { "field_type": 4, "help_text": "", "name": "num_votes", "verbose_name": "num votes" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_with_majority", "verbose_name": "num votes with majority" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_with_party", "verbose_name": "num votes with party" },
                        { "field_type": 6, "help_text": "", "name": "percent_missed_votes", "verbose_name": "percent missed votes" },
                        { "field_type": 6, "help_text": "", "name": "percent_nay_votes", "verbose_name": "percent nay votes" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_with_majority", "verbose_name": "percent votes with majority" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_with_party", "verbose_name": "percent votes with party" },
                        { "field_type": 6, "help_text": "", "name": "percent_yea_votes", "verbose_name": "percent yea votes" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_against_majority", "verbose_name": "num votes against majority" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_against_party", "verbose_name": "num votes against party" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_against_party", "verbose_name": "percent votes against party" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_against_majority", "verbose_name": "percent votes against majority" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_on_opp_amendments", "verbose_name": "num votes on opp amendments" },
                        { "field_type": 4, "help_text": "", "name": "num_votes_on_opp_bills", "verbose_name": "num votes on opp bills" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_on_opp_amendments", "verbose_name": "percent votes on opp amendments" },
                        { "field_type": 6, "help_text": "", "name": "percent_votes_on_opp_bills", "verbose_name": "percent votes on opp bills" },
                        { "field_type": 6, "help_text": "", "name": "percent_present_votes", "verbose_name": "percent present votes" },
                        { "field_type": 4, "help_text": "", "name": "num_yea_votes", "verbose_name": "num yea votes" },
                        { "field_type": 4, "help_text": "", "name": "num_nay_votes", "verbose_name": "num nay votes" },
                        { "field_type": 4, "help_text": "", "name": "num_missed_votes", "verbose_name": "num missed votes" },
                        { "field_type": 4, "help_text": "", "name": "num_present_votes", "verbose_name": "num present votes" },
                        { "field_type": 4, "help_text": "", "name": "num_committees", "verbose_name": "num committees" },
                        { "field_type": 4, "help_text": "", "name": "num_chairman_committees", "verbose_name": "num chairman committees" },
                        { "field_type": 4, "help_text": "", "name": "num_vice_chairman_committees", "verbose_name": "num vice chairman committees" },
                        { "field_type": 4, "help_text": "", "name": "num_subcommittees_chairman", "verbose_name": "num subcommittees chairman" },
                        { "field_type": 4, "help_text": "", "name": "num_subcommittees_vice_chairman", "verbose_name": "num subcommittees vice chairman" },
                        { "field_type": 4, "help_text": "", "name": "num_subcommittees_leadership", "verbose_name": "num subcommittees leadership" },
                        { "field_type": 4, "help_text": "", "name": "num_caucuses", "verbose_name": "num caucuses" },
                        { "field_type": 4, "help_text": "", "name": "num_chairman_caucuses", "verbose_name": "num chairman caucuses" },
                        { "field_type": 4, "help_text": "", "name": "num_press_releases", "verbose_name": "num press releases" },
                        { "field_type": 4, "help_text": "", "name": "press_num_rep_mentions", "verbose_name": "press num rep mentions" },
                        { "field_type": 4, "help_text": "", "name": "press_num_dem_mentions", "verbose_name": "press num dem mentions" },
                        { "field_type": 4, "help_text": "", "name": "press_times_mentioned", "verbose_name": "press times mentioned" },
                        { "field_type": 4, "help_text": "", "name": "press_times_rep_mentioned", "verbose_name": "press times rep mentioned" },
                        { "field_type": 4, "help_text": "", "name": "press_times_dem_mentioned", "verbose_name": "press times dem mentioned" },
                        { "field_type": 4, "help_text": "", "name": "num_statements", "verbose_name": "num statements" },
                        { "field_type": 4, "help_text": "", "name": "statements_num_rep_mentions", "verbose_name": "statements num rep mentions" },
                        { "field_type": 4, "help_text": "", "name": "statements_num_dem_mentions", "verbose_name": "statements num dem mentions" },
                        { "field_type": 4, "help_text": "", "name": "statements_times_mentioned", "verbose_name": "statements times mentioned" },
                        { "field_type": 4, "help_text": "", "name": "statements_times_rep_mentioned", "verbose_name": "statements times rep mentioned" },
                        { "field_type": 4, "help_text": "", "name": "statements_times_dem_mentioned", "verbose_name": "statements times dem mentioned" },
                        { "field_type": 4, "help_text": "", "name": "num_dear_colleague", "verbose_name": "num dear colleague" },
                        { "field_type": 4, "help_text": "", "name": "dear_colleague_num_rep_mentions", "verbose_name": "dear colleague num rep mentions" },
                        { "field_type": 4, "help_text": "", "name": "dear_colleague_num_dem_mentions", "verbose_name": "dear colleague num dem mentions" },
                        { "field_type": 4, "help_text": "", "name": "dear_colleague_times_mentioned", "verbose_name": "dear colleague times mentioned" },
                        { "field_type": 4, "help_text": "", "name": "dear_colleague_times_rep_mentioned", "verbose_name": "dear colleague times rep mentioned" },
                        { "field_type": 4, "help_text": "", "name": "dear_colleague_times_dem_mentioned", "verbose_name": "dear colleague times dem mentioned" },
                        { "field_type": 4, "help_text": "", "name": "num_twitter", "verbose_name": "num twitter" },
                        { "field_type": 4, "help_text": "", "name": "twitter_num_rep_mentions", "verbose_name": "twitter num rep mentions" },
                        { "field_type": 4, "help_text": "", "name": "twitter_num_dem_mentions", "verbose_name": "twitter num dem mentions" },
                        { "field_type": 4, "help_text": "", "name": "twitter_times_mentioned", "verbose_name": "twitter times mentioned" },
                        { "field_type": 4, "help_text": "", "name": "twitter_times_rep_mentioned", "verbose_name": "twitter times rep mentioned" },
                        { "field_type": 4, "help_text": "", "name": "twitter_times_dem_mentioned", "verbose_name": "twitter times dem mentioned" },
                        { "field_type": 6, "help_text": "", "name": "influence", "verbose_name": "influence" },
                        { "field_type": 6, "help_text": "", "name": "bipartisanship", "verbose_name": "bipartisanship" },
                        { "field_type": 6, "help_text": "", "name": "liberalism", "verbose_name": "liberalism" },
                        { "field_type": 6, "help_text": "", "name": "conservatism", "verbose_name": "conservatism" },
                        { "field_type": 6, "help_text": "", "name": "mean_geodesic", "verbose_name": "mean geodesic" },
                        { "field_type": 6, "help_text": "", "name": "closeness_centrality", "verbose_name": "closeness centrality" },
                        { "field_type": 3, "help_text": "", "name": "single_person_network", "verbose_name": "single person network" },
                        { "field_type": 4, "help_text": "", "name": "num_passed_bills", "verbose_name": "num passed bills" },
                        { "field_type": 4, "help_text": "", "name": "num_vetoed_bills", "verbose_name": "num vetoed bills" },
                        { "field_type": 4, "help_text": "", "name": "num_overridden_bills", "verbose_name": "num overridden bills" },
                        { "field_type": 6, "help_text": "", "name": "percent_passed_bills", "verbose_name": "percent passed bills" },
                        { "field_type": 6, "help_text": "", "name": "percent_vetoed_bills", "verbose_name": "percent vetoed bills" },
                        { "field_type": 4, "help_text": "", "name": "num_passed_bills_own_party", "verbose_name": "num passed bills own party" },
                        { "field_type": 4, "help_text": "", "name": "num_vetoed_bills_own_party", "verbose_name": "num vetoed bills own party" },
                        { "field_type": 4, "help_text": "", "name": "num_passed_bills_opp_party", "verbose_name": "num passed bills opp party" },
                        { "field_type": 4, "help_text": "", "name": "num_vetoed_bills_opp_party", "verbose_name": "num vetoed bills opp party" },
                        { "field_type": 6, "help_text": "", "name": "percent_passed_bills_own_party", "verbose_name": "percent passed bills own party" },
                        { "field_type": 6, "help_text": "", "name": "percent_vetoed_bills_own_party", "verbose_name": "percent vetoed bills own party" },
                        { "field_type": 6, "help_text": "", "name": "percent_passed_bills_opp_party", "verbose_name": "percent passed bills opp party" },
                        { "field_type": 6, "help_text": "", "name": "percent_vetoed_bills_opp_party", "verbose_name": "percent vetoed bills opp party" }
                    ]
                },
                "StatCategory": {
                    "__is_model": true,
                    "__name__": "StatCategory",
                    "data_model": "app.stats.models.StatCategory",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/statcategory/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "The name of the stat category", "name": "slug_name", "verbose_name": "slug name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "ModelNames" },
                            "field_type": 4,
                            "help_text": "Enum for the model where the category is located",
                            "name": "from_model",
                            "verbose_name": "from model"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "TopicAreas" },
                            "field_type": 4,
                            "help_text": "Enum for the topic area of the category ie - Demographic = 1",
                            "name": "topic_area",
                            "verbose_name": "topic area"
                        },
                        { "field_type": 4, "help_text": "Number for how to position the category within other categories", "name": "position", "verbose_name": "position" },
                        { "field_type": 2, "help_text": "The full displayed name of their statistic", "name": "full_name", "verbose_name": "full name" },
                        { "field_type": 2, "help_text": "The shortened name of the statistic - ie SEN ", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "The shortest name of the statistic, ie S instead of senator", "name": "short_name", "verbose_name": "short name" },
                        { "field_type": 3, "help_text": "The shortened name of the statistic, ie SNOCAPI instead of the long name", "name": "description", "verbose_name": "description" },
                        {
                            "field_type": 7,
                            "help_text": "foreign key to the category that holds this category, if in cat, gets.subcats.all()",
                            "name": "category",
                            "related_model": { "__module__": "app.stats.models", "__name__": "StatCategory" },
                            "verbose_name": "category"
                        },
                        {
                            "field_type": 8,
                            "help_text": "The stat_names belonging to the category.",
                            "name": "stat_names",
                            "related_model": { "__module__": "app.stats.models", "__name__": "StatName" },
                            "verbose_name": "stat names"
                        }
                    ]
                },
                "StatName": {
                    "__is_model": true,
                    "__name__": "StatName",
                    "data_model": "app.stats.models.StatName",
                    "default_exclude_filters": { "full_name": "", "stat_category__full_name": "" },
                    "default_filters": {
                        "archived": false,
                        "full_name__isnull": false,
                        "stat_category__full_name__isnull": false,
                        "topic_area__in": [1, 4]
                    },
                    "endpoint": "/api/statname/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "The name of the stat category", "name": "slug_name", "verbose_name": "slug name" },
                        { "field_type": 4, "help_text": "Number for how to position the stat within other stats", "name": "position", "verbose_name": "position" },
                        {
                            "field_type": 7,
                            "help_text": "The related bill term.",
                            "name": "stat_category",
                            "related_model": { "__module__": "app.stats.models", "__name__": "StatCategory" },
                            "verbose_name": "stat category"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "TopicAreas" },
                            "field_type": 4,
                            "help_text": "Enum for the topic area of the stat ie - Demographic = 1",
                            "name": "topic_area",
                            "verbose_name": "topic area"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "ModelNames" },
                            "field_type": 4,
                            "help_text": "Enum for the model where the stat is located",
                            "name": "from_model",
                            "verbose_name": "from model"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.stats.models", "__name__": "NumberType" },
                            "field_type": 4,
                            "help_text": "Enum for type of digit used. Percent, date, etc.",
                            "name": "num_type",
                            "verbose_name": "num type"
                        },
                        { "field_type": 2, "help_text": "The full displayed name of their statistic", "name": "full_name", "verbose_name": "full name" },
                        { "field_type": 2, "help_text": "The shortened name of the statistic - ie SEN ", "name": "abbrev", "verbose_name": "abbrev" },
                        { "field_type": 2, "help_text": "The shortest name of the statistic, ie S instead of senator", "name": "short_name", "verbose_name": "short name" },
                        { "field_type": 2, "help_text": "The other name of the stat", "name": "alt_name", "verbose_name": "alt name" },
                        { "field_type": 3, "help_text": "The shortened name of the statistic, ie SNOCAPI instead of the long name", "name": "description", "verbose_name": "description" },
                        { "field_type": 2, "help_text": "Comma separated string of regions a user has permissions to.", "name": "allowed_regions", "verbose_name": "allowed regions" },
                        { "field_type": 1, "help_text": "Whether or not this stat is relevant for historical members for all sessions profiles.", "name": "hide_for_historic", "verbose_name": "hide for historic" }
                    ]
                },
                "StatsMatrixType": {
                    "__is_enum": true,
                    "amendment_votes": { "display": false, "key": "amendment_votes", "label": "Shared Amendment Votes", "slug": "amendment_votes", "title_label": "Times Voting with ** on Amendments", "value": 11 },
                    "amendment_votes_for": { "display": false, "key": "amendment_votes_for", "label": "Directed Voting on Amendments", "slug": "amendment_votes_for", "title_label": "Times Voted for **'s Amendments", "value": 15 },
                    "bill_votes": { "display": false, "key": "bill_votes", "label": "Shared Bill Votes", "slug": "bill_votes", "title_label": "Times Voted with ** on Bills", "value": 16 },
                    "caucus": { "display": true, "key": "caucus", "label": "Number of Shared Caucuses", "slug": "caucus", "title_label": "Num. Shared Caucuses with **", "value": 10 },
                    "committee": { "display": true, "key": "committee", "label": "Number of Shared Committees", "slug": "committee", "title_label": "Num. Shared Committees with **", "value": 9 },
                    "cosponsor_to_cosponsor": { "display": true, "key": "cosponsor_to_cosponsor", "label": "Number of Times Cosponsored with Legislator", "slug": "cosponsor_to_cosponsor", "title_label": "Times Cosponsored With **", "value": 1 },
                    "floor_statement": { "display": false, "key": "floor_statement", "label": "Floor Statement Mentions", "slug": "floor_statement", "title_label": "Times mentioned in **'s Floor Statements", "value": 8 },
                    "press_release_mentions": { "display": false, "key": "press_release_mentions", "label": "Press Release Mentions", "slug": "press_release_mentions", "title_label": "Times Mentioned In **'s Press Releases", "value": 7 },
                    "procedural_votes": { "display": false, "key": "procedural_votes", "label": "Shared Procedural Votes", "slug": "procedural_votes", "title_label": "Times Voted for **'s Procedural Items", "value": 17 },
                    "sponsor_to_cosponsor": { "display": true, "key": "sponsor_to_cosponsor", "label": "Number of Times Legislator Cosponsored", "slug": "sponsor_to_cosponsor", "title_label": "Times Cosponsoring **'s Bills", "value": 2 },
                    "sponsor_to_original": { "display": true, "key": "sponsor_to_original", "label": "Number of Times Legislator was Originally Cosponsored", "slug": "sponsor_to_original", "title_label": "Times Originally Cosponsored **'s Bills", "value": 3 },
                    "sponsor_to_sponsor": { "display": false, "key": "sponsor_to_sponsor", "label": "Shared Sponsorship", "slug": "sponsor_to_sponsor", "title_label": "Times Sponsoring with **", "value": 18 },
                    "sub_committee": { "display": false, "key": "sub_committee", "label": "Number of shared sub committees", "slug": "sub_committee", "title_label": "Num. Shared Sub Committees with **", "value": 13 },
                    "top_committee": { "display": false, "key": "top_committee", "label": "Number of shared top committees", "slug": "top_committee", "title_label": "Num. Shared Top Committees with **", "value": 12 },
                    "twitter_mentions": { "display": false, "key": "twitter_mentions", "label": "Twitter Mentions", "slug": "twitter_mentions", "title_label": "Times Mentioned In **'s Tweets", "value": 6 },
                    "votes": { "display": true, "key": "votes", "label": "Number of Times Voted Together", "slug": "votes", "title_label": "Times Voted With **", "value": 5 },
                    "votes_for": { "display": false, "key": "votes_for", "label": "Directed Voting", "slug": "votes_for", "title_label": "Times Voting for **'s Sponsored Bills", "value": 14 },
                    "weighted_cosponsor": { "display": false, "key": "weighted_cosponsor", "label": "Weighted cosponsor relation", "slug": "weighted_cosponsor", "title_label": "", "value": 4 }
                },
                "TopicAreas": {
                    "__is_enum": true,
                    "biographical": { "key": "biographical", "label": "Biographical", "value": 2 },
                    "custom_data": { "key": "custom_data", "label": "Custom Data", "value": 8 },
                    "demographic": { "key": "demographic", "label": "Demographic", "value": 4 },
                    "legislative": { "key": "legislative", "label": "Legislative", "value": 1 },
                    "legislative_lists": { "key": "legislative_lists", "label": "Legislative Lists", "value": 5 },
                    "misc": { "key": "misc", "label": "Misc", "value": 6 },
                    "relationships": { "key": "relationships", "label": "Relationships", "value": 7 },
                    "social": { "key": "social", "label": "Social", "value": 3 }
                }
            },
            "types": {
                "NewStatsFormat": {
                    "__is_enum": true,
                    "list_stat": { "key": "list_stat", "label": "List Stats", "value": 2 },
                    "raw_stat": { "key": "raw_stat", "label": "Raw Stats", "value": 1 },
                    "relationship_stat": { "key": "relationship_stat", "label": "Relationship Stats", "value": 3 }
                },
                "NewStatsType": {
                    "__is_enum": true,
                    "cosponsors_most": {
                        "help_text": "Members whose bills this member cosponsors most often.",
                        "key": "cosponsors_most",
                        "label": "Cosponsors Most",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "cosponsors_most",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 201
                    },
                    "mentioned_by_most_in_document": {
                        "help_text": "Members who mention this member in documents most often.",
                        "key": "mentioned_by_most_in_document",
                        "label": "Mentioned by Most in Documents",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "mentioned_by_most_in_document",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199, 21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 206
                    },
                    "mentions_most_in_document": {
                        "help_text": "Members who are mentioned in documents by this member most often.",
                        "key": "mentions_most_in_document",
                        "label": "Mentions Most in Documents",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "mentions_most_in_document",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199, 21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 205
                    },
                    "most_cosponsored_by": {
                        "help_text": "Members that most often cosponsor this member's bills.",
                        "key": "most_cosponsored_by",
                        "label": "Most Cosponsored By",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "most_cosponsored_by",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 202
                    },
                    "most_sponsoring_enacted": {
                        "help_text": "Members whose sponsored bills are most enacted by this governor.",
                        "key": "most_sponsoring_enacted",
                        "label": "Most Sponsoring Enacted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "most_sponsoring_enacted",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 250
                    },
                    "most_sponsoring_vetoed": {
                        "help_text": "Members whose sponsored bills are most vetoed by this governor.",
                        "key": "most_sponsoring_vetoed",
                        "label": "Most Sponsoring Vetoed",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "most_sponsoring_vetoed",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 251
                    },
                    "num_cosponsored_bills": {
                        "help_text": "",
                        "key": "num_cosponsored_bills",
                        "label": "Number of Cosponsored Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_cosponsored_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 20
                    },
                    "num_enacted_bills": {
                        "help_text": "",
                        "key": "num_enacted_bills",
                        "label": "Number of Enacted Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_enacted_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 50
                    },
                    "num_overridden_bills": {
                        "help_text": "",
                        "key": "num_overridden_bills",
                        "label": "Number of Veto Overrides",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_overridden_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 54
                    },
                    "num_primary_cosponsorships": {
                        "help_text": "",
                        "key": "num_primary_cosponsorships",
                        "label": "Number of Primary Cosponsorships",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_primary_cosponsorships",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 22
                    },
                    "num_proposed_amendments": {
                        "help_text": "",
                        "key": "num_proposed_amendments",
                        "label": "Number of Proposed Amendments",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_proposed_amendments",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 30
                    },
                    "num_proposed_amendments_adopted": {
                        "help_text": "",
                        "key": "num_proposed_amendments_adopted",
                        "label": "Number of Proposed Amendments Adopted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_proposed_amendments_adopted",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 31
                    },
                    "num_sponsored_bills": {
                        "help_text": "",
                        "key": "num_sponsored_bills",
                        "label": "Number of Sponsored Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_sponsored_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 1
                    },
                    "num_sponsored_bills_enacted": {
                        "help_text": "",
                        "key": "num_sponsored_bills_enacted",
                        "label": "Number of Sponsored Bills Enacted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_sponsored_bills_enacted",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 6
                    },
                    "num_sponsored_bills_out_of_chamber": {
                        "help_text": "",
                        "key": "num_sponsored_bills_out_of_chamber",
                        "label": "Number of Sponsored Bills Out of Chamber",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_sponsored_bills_out_of_chamber",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 4
                    },
                    "num_sponsored_bills_out_of_committee": {
                        "help_text": "",
                        "key": "num_sponsored_bills_out_of_committee",
                        "label": "Number of Sponsored Bills Out of Committee",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_sponsored_bills_out_of_committee",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 2
                    },
                    "num_vetoed_bills": {
                        "help_text": "",
                        "key": "num_vetoed_bills",
                        "label": "Number of Vetoed Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "num_vetoed_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 51
                    },
                    "percent_cosponsored_bills_with_opposite_party_sponsor": {
                        "help_text": "",
                        "key": "percent_cosponsored_bills_with_opposite_party_sponsor",
                        "label": "Percent of Cosponsored Bills With Opposite Party Sponsor",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_cosponsored_bills_with_opposite_party_sponsor",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 21
                    },
                    "percent_enacted_bills": {
                        "help_text": "",
                        "key": "percent_enacted_bills",
                        "label": "Percent of Enacted Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_enacted_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 52
                    },
                    "percent_enacted_bills_opp_party": {
                        "help_text": "",
                        "key": "percent_enacted_bills_opp_party",
                        "label": "Percent of Enacted Bills from Opposite Party",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_enacted_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 57
                    },
                    "percent_enacted_bills_own_party": {
                        "help_text": "",
                        "key": "percent_enacted_bills_own_party",
                        "label": "Percent of Enacted Bills from Own Party",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_enacted_bills_own_party",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 55
                    },
                    "percent_missed_votes": {
                        "help_text": "",
                        "key": "percent_missed_votes",
                        "label": "Percent of Missed Votes",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_missed_votes",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 10000],
                        "use_in_sheets": true,
                        "value": 42
                    },
                    "percent_proposed_amendments_adopted": {
                        "help_text": "",
                        "key": "percent_proposed_amendments_adopted",
                        "label": "Percent of Proposed Amendments Adopted",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_proposed_amendments_adopted",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 32
                    },
                    "percent_sponsored_bills_enacted": {
                        "help_text": "",
                        "key": "percent_sponsored_bills_enacted",
                        "label": "Percent of Sponsored Bills Enacted",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_sponsored_bills_enacted",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 7
                    },
                    "percent_sponsored_bills_out_of_chamber": {
                        "help_text": "",
                        "key": "percent_sponsored_bills_out_of_chamber",
                        "label": "Percent of Sponsored Bills Out of Chamber",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_sponsored_bills_out_of_chamber",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 5
                    },
                    "percent_sponsored_bills_out_of_committee": {
                        "help_text": "",
                        "key": "percent_sponsored_bills_out_of_committee",
                        "label": "Percent of Sponsored Bills Out of Committee",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_sponsored_bills_out_of_committee",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 3
                    },
                    "percent_vetoed_bills": {
                        "help_text": "",
                        "key": "percent_vetoed_bills",
                        "label": "Percent of Vetoed Bills",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_vetoed_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 53
                    },
                    "percent_vetoed_bills_opp_party": {
                        "help_text": "",
                        "key": "percent_vetoed_bills_opp_party",
                        "label": "Percent of Vetoed Bills from Opposite Party",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_vetoed_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 58
                    },
                    "percent_vetoed_bills_own_party": {
                        "help_text": "",
                        "key": "percent_vetoed_bills_own_party",
                        "label": "Percent of Vetoed Bills from Own Party",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "percent_vetoed_bills",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 56
                    },
                    "percent_votes_against_party": {
                        "help_text": "",
                        "key": "percent_votes_against_party",
                        "label": "Percent of Votes Against Party",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_votes_against_party",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 41
                    },
                    "percent_votes_with_party": {
                        "help_text": "",
                        "key": "percent_votes_with_party",
                        "label": "Percent of Votes With Party",
                        "qdt": 1,
                        "sheets_data_type": 5,
                        "slug": "percent_votes_with_party",
                        "stats_type": "Raw Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": true,
                        "value": 40
                    },
                    "shared_caucuses": {
                        "help_text": "Members that sit on the most caucuses with this member.",
                        "key": "shared_caucuses",
                        "label": "Shared Caucuses",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "shared_caucuses",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 208
                    },
                    "shared_committees": {
                        "help_text": "Members that sit on the most committees with this member.",
                        "key": "shared_committees",
                        "label": "Shared Committees",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "shared_committees",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 207
                    },
                    "sponsors_with_most": {
                        "help_text": "Members that most often sponsor this member's bills.",
                        "key": "sponsors_with_most",
                        "label": "Sponsors with Most",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "sponsors_with_most",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 200
                    },
                    "top_issues_cosponsored": {
                        "help_text": "Issue areas this member has cosponsored bills in most often.",
                        "key": "top_issues_cosponsored",
                        "label": "Top Issues Cosponsored",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_cosponsored",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 101
                    },
                    "top_issues_enacted": {
                        "help_text": "Issue areas this governor has enacted bills in most often.",
                        "key": "top_issues_enacted",
                        "label": "Top Issues Enacted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_enacted",
                        "stats_type": "List Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 150
                    },
                    "top_issues_sponsored": {
                        "help_text": "Issue areas this member has sponsored bills in most often.",
                        "key": "top_issues_sponsored",
                        "label": "Top Issues Sponsored",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 100
                    },
                    "top_issues_sponsored_enacted": {
                        "help_text": "Issue areas this member has sponsored bills that were enacted in most often.",
                        "key": "top_issues_sponsored_enacted",
                        "label": "Top Issues Sponsored Enacted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored_enacted",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 104
                    },
                    "top_issues_sponsored_or_cosponsored": {
                        "help_text": "Issue areas this member has sponsored or cosponsored bills in most often.",
                        "key": "top_issues_sponsored_or_cosponsored",
                        "label": "Top Issues Sponsored or Cosponsored",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored_or_cosponsored",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 102
                    },
                    "top_issues_sponsored_or_cosponsored_enacted": {
                        "help_text": "Issue areas this member has sponsored or cosponsored bills that were enacted in most often.",
                        "key": "top_issues_sponsored_or_cosponsored_enacted",
                        "label": "Top Issues Sponsored or Cosponsored Enacted",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored_or_cosponsored_enacted",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 106
                    },
                    "top_issues_sponsored_or_cosponsored_out_of_committee": {
                        "help_text": "Issue areas this member has sponsored or cosponsored bills that left committee in most often.",
                        "key": "top_issues_sponsored_or_cosponsored_out_of_committee",
                        "label": "Top Issues Sponsored or Cosponsored Left Committee",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored_or_cosponsored_out_of_committee",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 105
                    },
                    "top_issues_sponsored_out_of_committee": {
                        "help_text": "Issue areas this member has sponsored bills that left committee in most often.",
                        "key": "top_issues_sponsored_out_of_committee",
                        "label": "Top Issues Sponsored Left Committee",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_sponsored_out_of_committee",
                        "stats_type": "List Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 103
                    },
                    "top_issues_vetoed": {
                        "help_text": "Issue areas this governor has vetoed bills in most often.",
                        "key": "top_issues_vetoed",
                        "label": "Top Issues Vetoed",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "top_issues_vetoed",
                        "stats_type": "List Stats",
                        "supported_person_types": [21],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 151
                    },
                    "top_members_cosponsored": {
                        "help_text": "Members whose cosponsored bills are most in this issue area.",
                        "key": "top_members_cosponsored",
                        "label": "Top Members Cosponsored",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "top_members_cosponsored",
                        "stats_type": "List Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 301
                    },
                    "top_members_sponsored": {
                        "help_text": "Members whose sponsored bills are most in this issue area.",
                        "key": "top_members_sponsored",
                        "label": "Top Members Sponsored",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "top_members_sponsored",
                        "stats_type": "List Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 300
                    },
                    "top_members_sponsored_enacted": {
                        "help_text": "Members whose sponsored bills that were enacted are most in this issue area.",
                        "key": "top_members_sponsored_enacted",
                        "label": "Top Members Sponsored Enacted",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "top_members_sponsored_enacted",
                        "stats_type": "List Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 304
                    },
                    "top_members_sponsored_or_cosponsored": {
                        "help_text": "Members whose sponsored or cosponsored bills are most in this issue area.",
                        "key": "top_members_sponsored_or_cosponsored",
                        "label": "Top Members Sponsored or Cosponsored",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "top_members_sponsored_or_cosponsored",
                        "stats_type": "List Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 302
                    },
                    "top_members_sponsored_out_of_committee": {
                        "help_text": "Members whose sponsored bills that left committee are most in this issue area,",
                        "key": "top_members_sponsored_out_of_committee",
                        "label": "Top Members Sponsored Out of Committee",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "top_members_sponsored_out_of_committee",
                        "stats_type": "List Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 303
                    },
                    "votes_with_most": {
                        "help_text": "Members that this member votes with most frequently.",
                        "key": "votes_with_most",
                        "label": "Votes with Most",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "votes_with_most",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 204
                    },
                    "worked_together_on_legislation": {
                        "help_text": "Members who work together most in this issue area.",
                        "key": "worked_together_on_legislation",
                        "label": "Worked Together on Legislation",
                        "qdt": 14,
                        "sheets_data_type": 4,
                        "slug": "worked_together_on_legislation",
                        "stats_type": "Relationship Stats",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 400
                    },
                    "works_on_legislation_with_most": {
                        "help_text": "Members that have the highest total number of sponsored or cosponsored bills with this member.",
                        "key": "works_on_legislation_with_most",
                        "label": "Works on Legislation with Most",
                        "qdt": 1,
                        "sheets_data_type": 4,
                        "slug": "works_on_legislation_with_most",
                        "stats_type": "Relationship Stats",
                        "supported_person_types": [5, 6, 7, 8, 9, 199],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "use_in_sheets": false,
                        "value": 203
                    }
                }
            }
        },
        "texting": {
            "models": {
                "BulkSMS": {
                    "__is_model": true,
                    "__name__": "BulkSMS",
                    "data_model": "app.texting.models.BulkSMS",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/bulksms/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "User id of the person that created the sms",
                            "name": "creator",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "sheets_subcategory": 8,
                            "sheets_tooltip_text": "The creator of this text",
                            "verbose_name": "Creator"
                        },
                        {
                            "field_type": 7,
                            "help_text": "FK of the last user that edited this email in any way.",
                            "name": "last_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "last user"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "TextDeliveryStatus" },
                            "field_type": 4,
                            "help_text": "The current status of an bulkSMS",
                            "name": "current_status",
                            "verbose_name": "current status"
                        },
                        { "field_type": 21, "help_text": "the database datetime object", "name": "sent_time", "sheet_column": true, "sheets_column_order": 3, "sheets_subcategory": 8, "sheets_tooltip_text": "The sent time of this message", "verbose_name": "Date Sent" },
                        { "field_type": 21, "help_text": "The datetime this BulkSMS was scheduled to be sent", "name": "scheduled_time", "verbose_name": "scheduled time" },
                        { "field_type": 3, "help_text": "The text of the bulkSMS", "name": "text", "sheet_column": true, "sheets_column_order": 6, "sheets_subcategory": 8, "sheets_tooltip_text": "The content of this message", "verbose_name": "Content" },
                        { "field_type": null, "help_text": "Array of media urls associated with the BulkSMS", "name": "media_urls", "verbose_name": "media urls" },
                        { "field_type": 3, "help_text": "\n            A description of the BulkSMS used only within Quorum for users to\n            name and differentiate between BulkSMSs\n            ", "name": "description", "sheet_column": true, "sheets_column_order": 1, "sheets_subcategory": 8, "sheets_tooltip_text": "The internal name of this message", "verbose_name": "Internal Name" },
                        { "field_type": 4, "help_text": "\n            Number of recipients associated with this BulkSMS; before the BulkSMS is processed,\n            holds the estimated count from searchify when the BulkSMS draft was last saved\n            ", "name": "recipient_count", "sheet_column": true, "sheets_column_order": 5, "sheets_subcategory": 8, "sheets_tooltip_text": "The number of messages sent", "verbose_name": "Number of Messages Sent" },
                        { "field_type": 4, "help_text": "Number of recipients excluded from this BulkSMS", "name": "excluded_count", "verbose_name": "excluded count" },
                        {
                            "field_type": 7,
                            "help_text": "FK of the organization that send the BulkSMS",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 4, "help_text": "Number of SendSMS sent from this BulkSMS with clicks/opens of short links", "name": "opens", "sheet_column": true, "sheets_column_order": 4, "sheets_subcategory": 8, "sheets_tooltip_text": "The number of clicks for this text", "verbose_name": "Number of Clicks" },
                        { "field_type": 4, "help_text": "Aggregate number of replies to the individual SendSMS messages of this BulkSMS", "name": "replies", "verbose_name": "replies" },
                        { "field_type": 4, "help_text": "Number of recipients who responded with a message to unsubscribe from communications to this BulkSMS (e.g. STOP)", "name": "unsubscribes", "sheet_column": true, "sheets_column_order": 7, "sheets_subcategory": 8, "sheets_tooltip_text": "The number of recipients who responded with a message to unsubscribe", "verbose_name": "Number of Unsubscribes" },
                        { "field_type": 4, "help_text": "How many grassroots supporter actions made from links in the messages", "name": "actions_taken_via_message_links", "verbose_name": "actions taken via message links" },
                        { "field_type": 1, "help_text": "Whether the message contains any shortlinks", "name": "has_shortlink", "verbose_name": "has shortlink" },
                        { "field_type": 1, "help_text": "Whether the message contains placeholder values", "name": "has_placeholders", "verbose_name": "has placeholders" },
                        { "field_type": null, "help_text": "JSON of searchify selection from the front end", "name": "recipient_selection", "verbose_name": "recipient selection" },
                        {
                            "field_type": 7,
                            "help_text": "The PhoneNumber object this BulkSMS will be sent from",
                            "name": "phone_number",
                            "related_model": { "__module__": "app.texting.models", "__name__": "PhoneNumber" },
                            "verbose_name": "phone number"
                        },
                        { "field_type": 1, "help_text": "Whether a sent message has any recipients for which sending failed", "name": "has_failed_recipients", "verbose_name": "has failed recipients" },
                        { "field_type": 2, "help_text": "The phone number digits the BulkSMS will be sent from", "name": "from_number", "verbose_name": "from number" },
                        { "field_type": 4, "help_text": "Aggregate amount charged for the individual SMS messages                    in units of dollars * 1000", "name": "total_amount", "verbose_name": "total amount" },
                        { "field_type": 4, "help_text": "Aggregate number of units of the individual SendSMSs", "name": "total_message_units", "verbose_name": "total message units" },
                        { "field_type": null, "help_text": "Array of plivo id's (external) of the individual SMSMessages", "name": "message_uuid", "verbose_name": "message uuid" },
                        { "field_type": 4, "help_text": "Number of supporters that acted on a linked campaign from this BulkSMS", "name": "conversions", "verbose_name": "conversions" },
                        { "field_type": 4, "help_text": "Number of SendSMS that were sent or delivered successfully", "name": "success_count", "verbose_name": "success count" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "ChargedStatus" },
                            "field_type": 4,
                            "help_text": "Whether the BulkSMS has been charged for or if it should not be charged",
                            "name": "charged_status",
                            "verbose_name": "charged status"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this BulkSMS has been tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "PhoneNumber": {
                    "__is_model": true,
                    "__name__": "PhoneNumber",
                    "data_model": "app.texting.models.PhoneNumber",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/phonenumber/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "The phone number digits associated with this phone number", "name": "associated_number", "verbose_name": "associated number" },
                        {
                            "field_type": 7,
                            "help_text": "organization id related to this number",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "PhoneNumberType" },
                            "field_type": 4,
                            "help_text": "The type of phone number",
                            "name": "number_type",
                            "verbose_name": "number type"
                        },
                        { "field_type": 1, "help_text": "Whether a phone number is active or not", "name": "is_active", "verbose_name": "is active" },
                        { "field_type": 1, "help_text": "Whether a phone number is sms enabled or not", "name": "sms_enabled", "verbose_name": "sms enabled" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "PhoneNumberDirection" },
                            "field_type": 4,
                            "help_text": "The direction of the messages which this number is used for",
                            "name": "direction",
                            "verbose_name": "direction"
                        }
                    ]
                },
                "SMSMessage": {
                    "__is_model": true,
                    "__name__": "SMSMessage",
                    "data_model": "app.texting.models.SMSMessage",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/smsmessage/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "TextDeliveryStatus" },
                            "field_type": 4,
                            "help_text": "The current status of a SMSMessage",
                            "name": "current_status",
                            "verbose_name": "current status"
                        },
                        { "field_type": 3, "help_text": "The text of the message", "name": "message_content", "verbose_name": "message content" },
                        { "field_type": 21, "help_text": "The timestamp of the most recent update from plivo for this message", "name": "timestamp", "verbose_name": "timestamp" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "MessageDirection" },
                            "field_type": 4,
                            "help_text": "The direction of this message.",
                            "name": "message_direction",
                            "verbose_name": "message direction"
                        },
                        { "field_type": 2, "help_text": "The phone number associated with this SMSMessage (Non-Quorum)", "name": "associated_number", "verbose_name": "associated number" },
                        { "field_type": null, "help_text": "The dict with the information for the particular supporter this was sent to (eg. placeholder information)", "name": "rcpt_dict", "verbose_name": "rcpt dict" },
                        { "field_type": null, "help_text": "the queued event of the message from Plivo ", "name": "queued_event", "verbose_name": "queued event" },
                        { "field_type": null, "help_text": "the sent event of the message from Plivo ", "name": "sent_event", "verbose_name": "sent event" },
                        { "field_type": null, "help_text": "the failed event of the message from Plivo ", "name": "failed_event", "verbose_name": "failed event" },
                        { "field_type": null, "help_text": "the delivered event of the message from Plivo ", "name": "delivered_event", "verbose_name": "delivered event" },
                        { "field_type": null, "help_text": "the undelivered event of the message from Plivo ", "name": "undelivered_event", "verbose_name": "undelivered event" },
                        { "field_type": null, "help_text": "the rejected event of the message from Plivo ", "name": "rejected_event", "verbose_name": "rejected event" },
                        { "field_type": 2, "help_text": "The unique plivo id associated with this SMSMessage (Non-Quorum)", "name": "message_uuid", "verbose_name": "message uuid" },
                        { "field_type": 4, "help_text": "Number of texts actually sent (multipart) from this SMSMessage", "name": "effective_message_count", "verbose_name": "effective message count" },
                        { "field_type": 21, "help_text": "The timestamp of when the message was sent.", "name": "send_time", "verbose_name": "send time" },
                        {
                            "field_type": 7,
                            "help_text": "BulkSMS id related to this message",
                            "name": "bulk_sms",
                            "related_model": { "__module__": "app.texting.models", "__name__": "BulkSMS" },
                            "verbose_name": "bulk sms"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Supporter id related to this message",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "organization id related to this message",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        }
                    ]
                },
                "SendSMS": {
                    "__is_model": true,
                    "__name__": "SendSMS",
                    "data_model": "app.texting.models.SendSMS",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/sendsms/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "TextDeliveryStatus" },
                            "field_type": 4,
                            "help_text": "The current status of a SMSMessage",
                            "name": "current_status",
                            "verbose_name": "current status"
                        },
                        { "field_type": 3, "help_text": "The text of the message", "name": "message_content", "verbose_name": "message content" },
                        { "field_type": 21, "help_text": "The timestamp of the most recent update from plivo for this message", "name": "timestamp", "verbose_name": "timestamp" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.texting.types", "__name__": "MessageDirection" },
                            "field_type": 4,
                            "help_text": "The direction of this message.",
                            "name": "message_direction",
                            "verbose_name": "message direction"
                        },
                        { "field_type": 2, "help_text": "The phone number associated with this SMSMessage (Non-Quorum)", "name": "associated_number", "verbose_name": "associated number" },
                        { "field_type": null, "help_text": "The dict with the information for the particular supporter this was sent to (eg. placeholder information)", "name": "rcpt_dict", "verbose_name": "rcpt dict" },
                        { "field_type": null, "help_text": "the queued event of the message from Plivo ", "name": "queued_event", "verbose_name": "queued event" },
                        { "field_type": null, "help_text": "the sent event of the message from Plivo ", "name": "sent_event", "verbose_name": "sent event" },
                        { "field_type": null, "help_text": "the failed event of the message from Plivo ", "name": "failed_event", "verbose_name": "failed event" },
                        { "field_type": null, "help_text": "the delivered event of the message from Plivo ", "name": "delivered_event", "verbose_name": "delivered event" },
                        { "field_type": null, "help_text": "the undelivered event of the message from Plivo ", "name": "undelivered_event", "verbose_name": "undelivered event" },
                        { "field_type": null, "help_text": "the rejected event of the message from Plivo ", "name": "rejected_event", "verbose_name": "rejected event" },
                        { "field_type": 2, "help_text": "The unique plivo id associated with this SMSMessage (Non-Quorum)", "name": "message_uuid", "verbose_name": "message uuid" },
                        { "field_type": 4, "help_text": "Number of texts actually sent (multipart) from this SMSMessage", "name": "effective_message_count", "verbose_name": "effective message count" },
                        { "field_type": 21, "help_text": "The timestamp of when the message was sent.", "name": "send_time", "verbose_name": "send time" },
                        {
                            "field_type": 7,
                            "help_text": "BulkSMS id related to this message",
                            "name": "bulk_sms",
                            "related_model": { "__module__": "app.texting.models", "__name__": "BulkSMS" },
                            "verbose_name": "bulk sms"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Supporter id related to this message",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "organization id related to this message",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 4, "help_text": "How many times links associated with the SendSMS have been opened/clicked", "name": "opens", "verbose_name": "opens" },
                        { "field_type": 1, "help_text": "Whether the message was converted on a campaign action or not", "name": "converted", "verbose_name": "converted" }
                    ]
                }
            },
            "types": {
                "ChargedStatus": {
                    "__is_enum": true,
                    "charged": { "key": "charged", "label": "Charged", "tip": "This BulkSMS has been charged for.", "value": 3 },
                    "do_not_charge": { "key": "do_not_charge", "label": "Do not charge", "tip": "This BulkSMS should not be charged. Used for BulkSMS created before ff_ngg_texting_credits was enabled.", "value": 1 },
                    "not_charged": { "key": "not_charged", "label": "Not Charged", "tip": "This BulkSMS has not been charged for yet.", "value": 2 }
                },
                "MessageDirection": {
                    "__is_enum": true,
                    "inbound": { "key": "inbound", "label": "Inbound", "value": 1 },
                    "outbound": { "key": "outbound", "label": "Outbound", "value": 2 }
                },
                "PhoneNumberDirection": {
                    "__is_enum": true,
                    "inbound": { "key": "inbound", "label": "Inbound", "value": 1 },
                    "outbound": { "key": "outbound", "label": "Outbound", "value": 2 }
                },
                "PhoneNumberType": {
                    "__is_enum": true,
                    "fixed": { "key": "fixed", "label": "Fixed", "value": 3 },
                    "local": { "key": "local", "label": "Local", "value": 1 },
                    "mobile": { "key": "mobile", "label": "Mobile", "value": 4 },
                    "national": { "key": "national", "label": "National", "value": 5 },
                    "shortcode": { "key": "shortcode", "label": "Short Code", "value": 6 },
                    "tollfree": { "key": "tollfree", "label": "Toll-Free", "value": 2 }
                },
                "SelectionType": {
                    "__is_enum": true,
                    "excludes": { "key": "excludes", "label": "Excludes", "value": 2 },
                    "includes": { "key": "includes", "label": "Includes", "value": 1 }
                },
                "SubscriptionStatus": {
                    "__is_enum": true,
                    "not_yet_subscribed": { "key": "not_yet_subscribed", "label": "Not yet subscribed", "value": 3 },
                    "subscribed": { "key": "subscribed", "label": "Subscribed", "value": 1 },
                    "unsubscribed": { "key": "unsubscribed", "label": "Unsubscribed", "value": 2 }
                },
                "TextDeliveryStatus": {
                    "__is_enum": true,
                    "delivered": { "json_field": "delivered_event", "key": "delivered", "label": "Delivered", "value": 5 },
                    "draft": { "key": "draft", "label": "Draft", "value": 1 },
                    "failed": { "json_field": "failed_event", "key": "failed", "label": "Failed", "value": 4 },
                    "failed_to_send": { "key": "failed_to_send", "label": "Failed to send", "value": 14 },
                    "failed_validation": { "key": "failed_validation", "label": "A SendSMS that failed Plivo validation", "value": 17 },
                    "generating_messages": { "key": "generating_messages", "label": "Generating messages", "value": 11 },
                    "processed": { "key": "processed", "label": "A BulkSMS that has been processed and is ready for sending", "value": 15 },
                    "processing_recipients": { "key": "processing_recipients", "label": "Processing recipients", "value": 10 },
                    "queued": { "json_field": "queued_event", "key": "queued", "label": "Queued", "value": 2 },
                    "received": { "json_field": "delivered_event", "key": "received", "label": "Received", "value": 8 },
                    "rejected": { "json_field": "rejected_event", "key": "rejected", "label": "Rejected", "value": 7 },
                    "relegated": { "key": "relegated", "label": "A SendSMS that we set aside because we re-processed its BulkSMS", "value": 16 },
                    "sending": { "key": "sending", "label": "Sending SMS", "value": 13 },
                    "sent": { "json_field": "sent_event", "key": "sent", "label": "Sent", "value": 3 },
                    "to_be_processed": { "key": "to_be_processed", "label": "To be processed", "value": 9 },
                    "to_be_queued": { "key": "to_be_queued", "label": "To be queued", "value": 12 },
                    "undelivered": { "json_field": "undelivered_event", "key": "undelivered", "label": "Undelivered", "value": 6 }
                }
            }
        },
        "tracking_dashboards": {
            "models": {
                "TrackingDashboard": {
                    "__is_model": true,
                    "__name__": "TrackingDashboard",
                    "data_model": "app.tracking_dashboards.models.TrackingDashboard",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/trackingboard/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": null, "help_text": "A set of instructions to configure the dashboard from the frontend. See docstring for more details.", "name": "configuration", "verbose_name": "configuration" },
                        { "field_type": null, "help_text": "The history of configuration objects", "name": "configuration_history", "verbose_name": "configuration history" },
                        {
                            "field_type": 7,
                            "help_text": "Tracking Boards results can be filtered by the user to a custom searchify selection. See docstring for more detail.",
                            "name": "global_saved_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "global saved search"
                        },
                        { "field_type": 1, "help_text": "whether a tracking board has reduced editing permissions for users who aren't admins", "name": "is_locked_for_editing", "verbose_name": "is locked for editing" },
                        {
                            "field_type": 7,
                            "help_text": "A Saved Search representing the Issues a user would like to add to the dashboard",
                            "name": "issue_saved_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "issue saved search"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Tracking projects are organized by the Data Type they represent, such as Bill, Regulation, etc",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        { "field_type": 3, "help_text": "The name of the Tracking Project", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this dashboard belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The User who created the sheet",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        { "field_type": 4, "help_text": "Relevant for Bill tracking projects, which are organized by the year of the legislation", "name": "year", "verbose_name": "year" },
                        {
                            "field_type": 7,
                            "help_text": "The user that was logged into the backend, if any, when this Tracking Dashboard was created",
                            "name": "logged_in_as_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "logged in as user"
                        },
                        { "field_type": 1, "help_text": "Whether frontend queries from the widgets in a tracking dashboard are disabled", "name": "disabled", "verbose_name": "disabled" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                }
            },
            "types": {
                "BoardType": {
                    "__is_enum": true,
                    "assignment": { "data_type_specific_label": "Bills by assignment", "key": "assignment", "label": "Assignment", "new_order": 5, "order": 14, "value": 20 },
                    "high_priority_by_status": { "dashboard_name": "High Priority | Status", "data_type_specific_label": "High priority bills by status", "key": "high_priority_by_status", "label": "High Priority | Status", "new_order": 10, "order": 9, "value": 13 },
                    "issue": { "data_type_specific_label": "Bills by issue", "key": "issue", "label": "Issue", "new_order": 4, "order": 2, "value": 5 },
                    "opposed_by_status": { "dashboard_name": "Opposed | Status", "data_type_specific_label": "Opposed bills by status", "key": "opposed_by_status", "label": "Opposed | Status", "new_order": 12, "order": 11, "value": 12 },
                    "priority": { "data_type_specific_label": "Bills by priority", "key": "priority", "label": "Priority", "new_order": 3, "order": 4, "value": 4 },
                    "region_with_issues": { "dashboard_name": "Issues | Region", "data_type_specific_label": "Bills with an issue by region", "key": "region_with_issues", "label": "Issues | Region", "new_order": 9, "order": 8, "value": 10 },
                    "region_with_priorities": { "dashboard_name": "Priorities | Region", "data_type_specific_label": "Bills with a priority by region", "key": "region_with_priorities", "label": "with a Priority | By Region", "new_order": 101, "order": 8, "value": 8 },
                    "region_with_stances": { "dashboard_name": "Stances | Region", "data_type_specific_label": "Bills with a stance by region", "key": "region_with_stances", "label": "Stances | Region", "new_order": 7, "order": 6, "value": 6 },
                    "search_term": { "data_type_specific_label": "Unreviewed bills", "key": "search_term", "label": "Search Term", "new_order": 1, "order": 1, "value": 1 },
                    "stance": { "data_type_specific_label": "Bills by stance", "key": "stance", "label": "Stance", "new_order": 2, "order": 3, "value": 2 },
                    "status_with_issues": { "dashboard_name": "Issues | Status", "data_type_specific_label": "Bills with an issue by status", "key": "status_with_issues", "label": "Issues | Status", "new_order": 8, "order": 7, "value": 9 },
                    "status_with_priorities": { "dashboard_name": "Priorities | Status", "data_type_specific_label": "Bills with a priority by status", "key": "status_with_priorities", "label": "with a Priority | By Status", "new_order": 100, "order": 100, "value": 7 },
                    "status_with_stances": { "dashboard_name": "Stances | Status", "data_type_specific_label": "Bills with a stance by status", "key": "status_with_stances", "label": "Stances | Status", "new_order": 6, "order": 5, "value": 3 },
                    "supported_by_status": { "dashboard_name": "Supported | Status", "data_type_specific_label": "Supported bills by status", "key": "supported_by_status", "label": "Supported | Status", "new_order": 11, "order": 10, "value": 11 }
                },
                "SearchTermBoardReviewType": {
                    "__is_enum": true,
                    "reviewed_by_me": { "display_text": "reviewed by me", "key": "reviewed_by_me", "label": "Reviewed by me", "order": 1, "value": 1 },
                    "reviewed_by_org": { "display_text": "reviewed by anyone", "key": "reviewed_by_org", "label": "Reviewed by organization", "order": 2, "value": 3 },
                    "reviewed_by_team": { "display_text": "reviewed by team", "key": "reviewed_by_team", "label": "Reviewed by team", "order": 3, "value": 2 }
                },
                "SearchTermBoardSelectionCriteriaType": {
                    "__is_enum": true,
                    "assignment": {
                        "display_text": "are given an assignment",
                        "key": "assignment",
                        "label": "Assignment",
                        "order": 4,
                        "supported_data_types": [2, 80, 4],
                        "value": 4
                    },
                    "issue": {
                        "display_text": "are given an issue",
                        "key": "issue",
                        "label": "Issue",
                        "order": 3,
                        "supported_data_types": [2, 25, 105, 80, 4],
                        "value": 3
                    },
                    "priority": {
                        "display_text": "are given a priority",
                        "key": "priority",
                        "label": "Priority",
                        "order": 2,
                        "supported_data_types": [2, 105, 80, 4],
                        "value": 2
                    },
                    "stance": {
                        "display_text": "are given a stance",
                        "key": "stance",
                        "label": "Stance",
                        "order": 1,
                        "supported_data_types": [2, 25, 105, 80, 4],
                        "tip": "When the stance option is selected, Bills with unimportant stance will always clear even if other options, like Priority or Assignment, are selected as part of the tracking workflow.",
                        "value": 1
                    }
                }
            }
        },
        "types": {
            "CustomEventPageEnum": { "__is_enum": true },
            "NewGrassrootsEnum": { "__is_enum": true },
            "UnsubscribedEnum": { "__is_enum": true }
        },
        "us": {
            "USState": {
                "AK": { "abbr": "Alaska", "apportionment": 1, "key": "AK", "label": "Alaska", "value": "AK" },
                "AL": { "abbr": "Ala.", "apportionment": 7, "key": "AL", "label": "Alabama", "value": "AL" },
                "AR": { "abbr": "Ark.", "apportionment": 4, "key": "AR", "label": "Arkansas", "value": "AR" },
                "AS": { "abbr": "A.S.", "key": "AS", "label": "American Samoa", "value": "AS" },
                "AZ": { "abbr": "Ariz.", "apportionment": 9, "key": "AZ", "label": "Arizona", "value": "AZ" },
                "CA": { "abbr": "Calif.", "apportionment": 53, "key": "CA", "label": "California", "value": "CA" },
                "CO": { "abbr": "Colo.", "apportionment": 7, "key": "CO", "label": "Colorado", "value": "CO" },
                "CT": { "abbr": "Conn.", "apportionment": 5, "key": "CT", "label": "Connecticut", "value": "CT" },
                "DC": { "abbr": "D.C.", "key": "DC", "label": "District of Columbia", "value": "DC" },
                "DE": { "abbr": "Del.", "apportionment": 1, "key": "DE", "label": "Delaware", "value": "DE" },
                "DK": { "abbr": "", "key": "DK", "label": "Dakota Territory", "value": "DK" },
                "FL": { "abbr": "Fla.", "apportionment": 27, "key": "FL", "label": "Florida", "value": "FL" },
                "GA": { "abbr": "Ga.", "apportionment": 14, "key": "GA", "label": "Georgia", "value": "GA" },
                "GU": { "abbr": "Guam", "key": "GU", "label": "Guam", "value": "GU" },
                "HI": { "abbr": "Hawaii", "apportionment": 2, "key": "HI", "label": "Hawaii", "value": "HI" },
                "IA": { "abbr": "Iowa", "apportionment": 4, "key": "IA", "label": "Iowa", "value": "IA" },
                "ID": { "abbr": "Idaho", "apportionment": 2, "key": "ID", "label": "Idaho", "value": "ID" },
                "IL": { "abbr": "Ill.", "apportionment": 18, "key": "IL", "label": "Illinois", "value": "IL" },
                "IN": { "abbr": "Ind.", "apportionment": 9, "key": "IN", "label": "Indiana", "value": "IN" },
                "KS": { "abbr": "Kan.", "apportionment": 4, "key": "KS", "label": "Kansas", "value": "KS" },
                "KY": { "abbr": "Ky.", "apportionment": 6, "key": "KY", "label": "Kentucky", "value": "KY" },
                "LA": { "abbr": "La.", "apportionment": 6, "key": "LA", "label": "Louisiana", "value": "LA" },
                "MA": { "abbr": "Mass.", "apportionment": 9, "key": "MA", "label": "Massachusetts", "value": "MA" },
                "MD": { "abbr": "Md.", "apportionment": 8, "key": "MD", "label": "Maryland", "value": "MD" },
                "ME": { "abbr": "Maine", "apportionment": 2, "key": "ME", "label": "Maine", "value": "ME" },
                "MI": { "abbr": "Mich.", "apportionment": 14, "key": "MI", "label": "Michigan", "value": "MI" },
                "MN": { "abbr": "Minn.", "apportionment": 8, "key": "MN", "label": "Minnesota", "value": "MN" },
                "MO": { "abbr": "Mo.", "apportionment": 8, "key": "MO", "label": "Missouri", "value": "MO" },
                "MP": { "abbr": "M.P.", "key": "MP", "label": "Northern Mariana Islands", "value": "MP" },
                "MS": { "abbr": "Miss.", "apportionment": 4, "key": "MS", "label": "Mississippi", "value": "MS" },
                "MT": { "abbr": "Mont.", "apportionment": 1, "key": "MT", "label": "Montana", "value": "MT" },
                "NC": { "abbr": "N.C.", "apportionment": 13, "key": "NC", "label": "North Carolina", "value": "NC" },
                "ND": { "abbr": "N.D.", "apportionment": 1, "key": "ND", "label": "North Dakota", "value": "ND" },
                "NE": { "abbr": "Neb.", "apportionment": 3, "key": "NE", "label": "Nebraska", "value": "NE" },
                "NH": { "abbr": "N.H.", "apportionment": 2, "key": "NH", "label": "New Hampshire", "value": "NH" },
                "NJ": { "abbr": "N.J.", "apportionment": 12, "key": "NJ", "label": "New Jersey", "value": "NJ" },
                "NM": { "abbr": "N.M.", "apportionment": 3, "key": "NM", "label": "New Mexico", "value": "NM" },
                "NV": { "abbr": "Nev.", "apportionment": 4, "key": "NV", "label": "Nevada", "value": "NV" },
                "NY": { "abbr": "N.Y.", "apportionment": 27, "key": "NY", "label": "New York", "value": "NY" },
                "OH": { "abbr": "Ohio", "apportionment": 16, "key": "OH", "label": "Ohio", "value": "OH" },
                "OK": { "abbr": "Okla.", "apportionment": 5, "key": "OK", "label": "Oklahoma", "value": "OK" },
                "OL": { "abbr": "", "key": "OL", "label": "Territory of Orleans", "value": "OL" },
                "OR": { "abbr": "Ore.", "apportionment": 5, "key": "OR", "label": "Oregon", "value": "OR" },
                "PA": { "abbr": "Pa.", "apportionment": 18, "key": "PA", "label": "Pennsylvania", "value": "PA" },
                "PI": { "abbr": "", "key": "PI", "label": "Philippines Territory/Commonwealth", "value": "PI" },
                "PR": { "abbr": "P.R.", "key": "PR", "label": "Puerto Rico", "value": "PR" },
                "RI": { "abbr": "R.I.", "apportionment": 2, "key": "RI", "label": "Rhode Island", "value": "RI" },
                "SC": { "abbr": "S.C.", "apportionment": 7, "key": "SC", "label": "South Carolina", "value": "SC" },
                "SD": { "abbr": "S.D.", "apportionment": 1, "key": "SD", "label": "South Dakota", "value": "SD" },
                "TN": { "abbr": "Tenn.", "apportionment": 9, "key": "TN", "label": "Tennessee", "value": "TN" },
                "TX": { "abbr": "Texas", "apportionment": 36, "key": "TX", "label": "Texas", "value": "TX" },
                "UT": { "abbr": "Utah", "apportionment": 4, "key": "UT", "label": "Utah", "value": "UT" },
                "VA": { "abbr": "Va.", "apportionment": 11, "key": "VA", "label": "Virginia", "value": "VA" },
                "VI": { "abbr": "V.I.", "key": "VI", "label": "Virgin Islands", "value": "VI" },
                "VT": { "abbr": "Vt.", "apportionment": 1, "key": "VT", "label": "Vermont", "value": "VT" },
                "WA": { "abbr": "Wash.", "apportionment": 10, "key": "WA", "label": "Washington", "value": "WA" },
                "WI": { "abbr": "Wis.", "apportionment": 8, "key": "WI", "label": "Wisconsin", "value": "WI" },
                "WV": { "abbr": "W.Va.", "apportionment": 3, "key": "WV", "label": "West Virginia", "value": "WV" },
                "WY": { "abbr": "Wyo.", "apportionment": 1, "key": "WY", "label": "Wyoming", "value": "WY" },
                "__is_enum": true
            }
        },
        "useractions": {
            "models": {
                "UserAction": {
                    "__is_model": true,
                    "__name__": "UserAction",
                    "data_model": "app.useractions.models.UserAction",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/useraction/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "staffer"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "attachment",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                            "verbose_name": "attachment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "political_committee",
                            "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                            "verbose_name": "political committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "election",
                            "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                            "verbose_name": "election"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "document",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "document"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization that owns this UserAction",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.useractions.types", "__name__": "UserActionType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "action_type",
                            "verbose_name": "action type"
                        },
                        { "field_type": 2, "help_text": "", "name": "current_url", "verbose_name": "current url" },
                        { "field_type": 2, "help_text": "", "name": "description", "verbose_name": "description" },
                        { "field_type": null, "help_text": "", "name": "request_meta", "verbose_name": "request meta" },
                        { "field_type": 1, "help_text": "", "name": "sent_to_pendo", "verbose_name": "sent to pendo" },
                        { "field_type": 1, "help_text": "", "name": "sent_to_gainsight", "verbose_name": "sent to gainsight" },
                        { "field_type": 3, "help_text": "Search term corresponding to user action in quick search bar", "name": "query", "verbose_name": "query" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Data type corresponding to user action",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Saved search corresponding to the user action",
                            "name": "safedsearch",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "safedsearch"
                        },
                        { "field_type": 1, "help_text": "Whether this user has chosen to favorite this action for easy return in the future", "name": "is_favorited", "verbose_name": "is favorited" },
                        { "field_type": 2, "help_text": "Humanized version of the action to explain what search filters or profile fk's are involved", "name": "humanized_text", "verbose_name": "humanized text" },
                        { "field_type": null, "help_text": "List of current region values", "name": "current_regions", "verbose_name": "current regions" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region of the object, if any, this UserAction is against",
                            "name": "object_region",
                            "verbose_name": "object region"
                        },
                        { "field_type": null, "help_text": "The regions of the object, if any, this UserAction is against", "name": "object_regions", "verbose_name": "object regions" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.useractions.types", "__name__": "PlatformType" },
                            "field_type": 4,
                            "help_text": "Platform UserAction was fired from",
                            "name": "platform",
                            "verbose_name": "platform"
                        },
                        { "field_type": 4, "help_text": "", "name": "article", "verbose_name": "article" }
                    ]
                }
            },
            "types": {
                "PlatformType": {
                    "__is_enum": true,
                    "desktop": { "key": "desktop", "label": "Desktop", "value": 3 },
                    "mobile": { "key": "mobile", "label": "Mobile", "value": 2 },
                    "web": { "key": "web", "label": "Web", "value": 1 }
                },
                "UserActionType": {
                    "__is_enum": true,
                    "add_new_grassroots": {
                        "churn_zero": true,
                        "key": "add_new_grassroots",
                        "label": "add_new_grassroots",
                        "name": "Add a new grassroots action",
                        "pendo": true,
                        "pendo_label": "Grassroots | Add new grassroots",
                        "use_cases": [],
                        "value": 51
                    },
                    "add_new_note": {
                        "churn_zero": true,
                        "key": "add_new_note",
                        "label": "add_new_note",
                        "name": "Add a note",
                        "pendo": true,
                        "pendo_label": "Note | Add a new note",
                        "use_cases": [],
                        "value": 50
                    },
                    "add_to_issue": {
                        "churn_zero": true,
                        "key": "add_to_issue",
                        "label": "add_to_issue",
                        "name": "Add to Issue",
                        "pendo": false,
                        "use_cases": [],
                        "value": 500
                    },
                    "add_to_list": {
                        "churn_zero": true,
                        "key": "add_to_list",
                        "label": "add_to_list",
                        "name": "Add to List",
                        "pendo": false,
                        "use_cases": [],
                        "value": 520
                    },
                    "backend_error": {
                        "churn_zero": true,
                        "key": "backend_error",
                        "label": "backend_error",
                        "name": "Error",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 1200
                    },
                    "bill_added_to_categories": {
                        "churn_zero": false,
                        "key": "bill_added_to_categories",
                        "label": "bill_added_to_categories",
                        "name": "Bill Added to Categories",
                        "pendo": false,
                        "use_cases": [3],
                        "value": 13
                    },
                    "bill_added_to_issue": {
                        "churn_zero": true,
                        "key": "bill_added_to_issue",
                        "label": "bill_added_to_issue",
                        "name": "Bill Added to Issue",
                        "parent": 500,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [],
                        "value": 510
                    },
                    "bulk_upload": {
                        "churn_zero": true,
                        "key": "bulk_upload",
                        "label": "bulk_upload",
                        "name": "Bulk Upload",
                        "pendo": false,
                        "use_cases": [],
                        "value": 904
                    },
                    "business_card_scanned": {
                        "churn_zero": true,
                        "key": "business_card_scanned",
                        "label": "business_card_scanned",
                        "name": "Business Card Scanned",
                        "pendo": false,
                        "use_cases": [20],
                        "value": 24
                    },
                    "campaign_visited": {
                        "churn_zero": true,
                        "key": "campaign_visited",
                        "label": "campaign_visited",
                        "name": "Campaign Profile Visited",
                        "pendo": false,
                        "use_cases": [16],
                        "value": 301
                    },
                    "change_region": {
                        "churn_zero": true,
                        "key": "change_region",
                        "label": "change_region",
                        "name": "Region Changed",
                        "pendo": false,
                        "use_cases": [],
                        "value": 1100
                    },
                    "clicked_email_alert": {
                        "churn_zero": true,
                        "key": "clicked_email_alert",
                        "label": "clicked_email_alert",
                        "name": "Clicked a Link in an Email Alert",
                        "pendo": false,
                        "use_cases": [2, 19],
                        "value": 28
                    },
                    "clicked_howto_use": {
                        "churn_zero": true,
                        "key": "clicked_howto_use",
                        "label": "clicked_howto_use",
                        "name": "Clicked \"How to use feature\" button",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4100
                    },
                    "copilot_sent_message": {
                        "churn_zero": false,
                        "key": "copilot_sent_message",
                        "label": "copilot_sent_message",
                        "name": "Sent a message in Copilot Analyze",
                        "pendo": true,
                        "pendo_label": "Copilot Analyze | Message Sent",
                        "use_cases": [],
                        "value": 4501
                    },
                    "create_assignment": {
                        "churn_zero": true,
                        "key": "create_assignment",
                        "label": "create_assignment",
                        "name": "Create Assignment",
                        "pendo": false,
                        "use_cases": [4],
                        "value": 110
                    },
                    "create_campaign": {
                        "churn_zero": true,
                        "key": "create_campaign",
                        "label": "create_campaign",
                        "name": "New Campaign",
                        "pendo": false,
                        "use_cases": [12],
                        "value": 300
                    },
                    "create_email_alert": {
                        "churn_zero": true,
                        "key": "create_email_alert",
                        "label": "create_email_alert",
                        "name": "Email Alert Created",
                        "pendo": false,
                        "use_cases": [2, 19],
                        "value": 25
                    },
                    "create_email_template": {
                        "churn_zero": true,
                        "key": "create_email_template",
                        "label": "create_email_template",
                        "name": "Create Email Template",
                        "pendo": false,
                        "use_cases": [],
                        "value": 403
                    },
                    "create_grassroots_page": {
                        "churn_zero": true,
                        "key": "create_grassroots_page",
                        "label": "create_grassroots_page",
                        "name": "New Grassroots Page",
                        "pendo": false,
                        "use_cases": [12],
                        "value": 304
                    },
                    "create_list": {
                        "churn_zero": true,
                        "key": "create_list",
                        "label": "create_list",
                        "name": "New List Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 20
                    },
                    "create_new_download": {
                        "churn_zero": true,
                        "key": "create_new_download",
                        "label": "create_new_download",
                        "name": "Create a New Download",
                        "pendo": false,
                        "use_cases": [6],
                        "value": 212
                    },
                    "create_new_user": {
                        "churn_zero": true,
                        "key": "create_new_user",
                        "label": "create_new_user",
                        "name": "New User Created",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 21
                    },
                    "create_registration": {
                        "churn_zero": true,
                        "key": "create_registration",
                        "label": "create_registration",
                        "name": "New Registration Form",
                        "pendo": false,
                        "use_cases": [12],
                        "value": 302
                    },
                    "created_dashboard": {
                        "churn_zero": true,
                        "key": "created_dashboard",
                        "label": "created_dashboard",
                        "name": "Created a Dashboard",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4201
                    },
                    "created_dashboard_widget": {
                        "churn_zero": true,
                        "key": "created_dashboard_widget",
                        "label": "created_dashboard_widget",
                        "name": "Created a Dashboard Widget",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4202
                    },
                    "custom_description_created": {
                        "churn_zero": true,
                        "key": "custom_description_created",
                        "label": "custom_description_created",
                        "name": "Custom Description Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2300
                    },
                    "custom_description_created_bill": {
                        "churn_zero": true,
                        "key": "custom_description_created_bill",
                        "label": "custom_description_created_bill",
                        "name": "Bill Custom Description Created",
                        "parent": 2300,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [3],
                        "value": 2302
                    },
                    "custom_description_created_person": {
                        "churn_zero": true,
                        "key": "custom_description_created_person",
                        "label": "custom_description_created_person",
                        "name": "Official Custom Description Created",
                        "parent": 2300,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [6],
                        "value": 2301
                    },
                    "custom_description_created_public_organization": {
                        "churn_zero": true,
                        "key": "custom_description_created_public_organization",
                        "label": "custom_description_created_public_organization",
                        "name": "Organization Custom Description Created",
                        "parent": 2300,
                        "pendo": false,
                        "quorum_data_type": 42,
                        "use_cases": [],
                        "value": 2304
                    },
                    "custom_description_created_supporter": {
                        "churn_zero": true,
                        "key": "custom_description_created_supporter",
                        "label": "custom_description_created_supporter",
                        "name": "Contact Custom Description Created",
                        "parent": 2300,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [15],
                        "value": 2303
                    },
                    "custom_description_edited": {
                        "churn_zero": true,
                        "key": "custom_description_edited",
                        "label": "custom_description_edited",
                        "name": "Custom Description Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2310
                    },
                    "custom_description_edited_bill": {
                        "churn_zero": true,
                        "key": "custom_description_edited_bill",
                        "label": "custom_description_edited_bill",
                        "name": "Bill Custom Description Edited",
                        "parent": 2310,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [3],
                        "value": 2312
                    },
                    "custom_description_edited_person": {
                        "churn_zero": true,
                        "key": "custom_description_edited_person",
                        "label": "custom_description_edited_person",
                        "name": "Official Custom Description Edited",
                        "parent": 2310,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [6],
                        "value": 2311
                    },
                    "custom_description_edited_public_organization": {
                        "churn_zero": true,
                        "key": "custom_description_edited_public_organization",
                        "label": "custom_description_edited_public_organization",
                        "name": "Organization Custom Description Edited",
                        "parent": 2310,
                        "pendo": false,
                        "quorum_data_type": 42,
                        "use_cases": [],
                        "value": 2314
                    },
                    "custom_description_edited_supporter": {
                        "churn_zero": true,
                        "key": "custom_description_edited_supporter",
                        "label": "custom_description_edited_supporter",
                        "name": "Contact Custom Description Edited",
                        "parent": 2310,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [15],
                        "value": 2313
                    },
                    "custom_event_created": {
                        "churn_zero": true,
                        "key": "custom_event_created",
                        "label": "custom_event_created",
                        "name": "New Event",
                        "pendo": false,
                        "use_cases": [],
                        "value": 40
                    },
                    "custom_region_created": {
                        "churn_zero": true,
                        "key": "custom_region_created",
                        "label": "custom_region_created",
                        "name": "Custom Region Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 1101
                    },
                    "dashboard_created": {
                        "churn_zero": true,
                        "key": "dashboard_created",
                        "label": "dashboard_created",
                        "name": "Dashboard Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2501
                    },
                    "delete_list": {
                        "churn_zero": false,
                        "key": "delete_list",
                        "label": "delete_list",
                        "name": "List Deleted",
                        "pendo": false,
                        "use_cases": [],
                        "value": 17
                    },
                    "duplicated_2019_bill_tracking_project": {
                        "churn_zero": false,
                        "key": "duplicated_2019_bill_tracking_project",
                        "label": "duplicated_2019_bill_tracking_project",
                        "name": "Duplicated Project for 2019 Bill Tracking",
                        "pendo": false,
                        "use_cases": [],
                        "value": 14
                    },
                    "duplicated_next_year_bill_tracking_project": {
                        "churn_zero": false,
                        "key": "duplicated_next_year_bill_tracking_project",
                        "label": "duplicated_next_year_bill_tracking_project",
                        "name": "Duplicated Project for 2018 Bill Tracking",
                        "pendo": false,
                        "use_cases": [],
                        "value": 12
                    },
                    "edit_grassroots_page": {
                        "churn_zero": true,
                        "key": "edit_grassroots_page",
                        "label": "edit_grassroots_page",
                        "name": "Edit Grassroots Page",
                        "pendo": false,
                        "use_cases": [12],
                        "value": 305
                    },
                    "edit_project": {
                        "churn_zero": false,
                        "key": "edit_project",
                        "label": "edit_project",
                        "name": "Project Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 11
                    },
                    "edit_registration": {
                        "churn_zero": true,
                        "key": "edit_registration",
                        "label": "edit_registration",
                        "name": "Edit Registration Form",
                        "pendo": false,
                        "use_cases": [12],
                        "value": 303
                    },
                    "email_alert_failed_delivery": {
                        "churn_zero": true,
                        "key": "email_alert_failed_delivery",
                        "label": "email_alert_failed_delivery",
                        "name": "Email alert delivery failed.",
                        "pendo": false,
                        "use_cases": [],
                        "value": 29
                    },
                    "file_downloaded": {
                        "churn_zero": true,
                        "key": "file_downloaded",
                        "label": "file_downloaded",
                        "name": "File Downloaded",
                        "pendo": false,
                        "use_cases": [9, 18],
                        "value": 31
                    },
                    "file_uploaded": {
                        "churn_zero": false,
                        "key": "file_uploaded",
                        "label": "file_uploaded",
                        "name": "File Uploaded",
                        "pendo": false,
                        "use_cases": [9, 18],
                        "value": 30
                    },
                    "forwarded_email_but_does_not_have_stakeholder": {
                        "churn_zero": true,
                        "key": "forwarded_email_but_does_not_have_stakeholder",
                        "label": "forwarded_email_but_does_not_have_stakeholder",
                        "name": "Clients Forwarded Email or BCC to forwards@quorum.us but does not have Stakeholder",
                        "pendo": false,
                        "use_cases": [],
                        "value": 112
                    },
                    "gamification_activated": {
                        "churn_zero": true,
                        "key": "gamification_activated",
                        "label": "gamification_activated",
                        "name": "Gamification Activated",
                        "pendo": false,
                        "use_cases": [],
                        "value": 310
                    },
                    "gamification_deactivated": {
                        "churn_zero": true,
                        "key": "gamification_deactivated",
                        "label": "gamification_deactivated",
                        "name": "Gamification Deactivated",
                        "pendo": false,
                        "use_cases": [],
                        "value": 311
                    },
                    "graph_download": {
                        "churn_zero": true,
                        "key": "graph_download",
                        "label": "graph_download",
                        "name": "Graph Download",
                        "pendo": false,
                        "use_cases": [],
                        "value": 901
                    },
                    "help_center": {
                        "churn_zero": true,
                        "key": "help_center",
                        "label": "toolbar_help_dropdown_help_center",
                        "name": "Help Center",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 101
                    },
                    "help_center_read_article": {
                        "churn_zero": true,
                        "key": "help_center_read_article",
                        "label": "help_center_read_article",
                        "name": "Read Help Center Article",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 105
                    },
                    "help_center_search_term": {
                        "churn_zero": true,
                        "key": "help_center_search_term",
                        "label": "help_center_search_term",
                        "name": "Help Center Search Term",
                        "pendo": false,
                        "use_cases": [],
                        "value": 104
                    },
                    "help_tutorial": {
                        "churn_zero": true,
                        "key": "help_tutorial",
                        "label": "toolbar_help_dropdown_tutorial",
                        "name": "Help Tutorial",
                        "pendo": false,
                        "use_cases": [],
                        "value": 102
                    },
                    "helpcenter_contact": {
                        "churn_zero": true,
                        "key": "helpcenter_contact",
                        "label": "helpcenter_contact",
                        "name": "Contact page visited",
                        "parent": 101,
                        "pendo": false,
                        "use_cases": [],
                        "value": 4006
                    },
                    "helpcenter_feature_detail": {
                        "churn_zero": true,
                        "key": "helpcenter_feature_detail",
                        "label": "helpcenter_feature_detail",
                        "name": "Feature detail page visited",
                        "parent": 101,
                        "pendo": false,
                        "use_cases": [],
                        "value": 4005
                    },
                    "helpcenter_feature_list": {
                        "churn_zero": true,
                        "key": "helpcenter_feature_list",
                        "label": "helpcenter_feature_list",
                        "name": "Feature list page visited",
                        "parent": 101,
                        "pendo": false,
                        "use_cases": [],
                        "value": 4004
                    },
                    "helpcenter_tutorial_detail": {
                        "churn_zero": true,
                        "key": "helpcenter_tutorial_detail",
                        "label": "helpcenter_tutorial_detail",
                        "name": "Tutorial detail page visited",
                        "parent": 101,
                        "pendo": false,
                        "use_cases": [],
                        "value": 4003
                    },
                    "helpcenter_tutorial_list": {
                        "churn_zero": true,
                        "key": "helpcenter_tutorial_list",
                        "label": "helpcenter_tutorial_list",
                        "name": "Tutorial list page visited",
                        "parent": 101,
                        "pendo": false,
                        "use_cases": [],
                        "value": 4002
                    },
                    "ignored_duplicate": {
                        "churn_zero": true,
                        "key": "ignored_duplicate",
                        "label": "ignored_duplicate",
                        "name": "Ignored a Duplicate object",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4301
                    },
                    "issue_created": {
                        "churn_zero": true,
                        "key": "issue_created",
                        "label": "issue_created",
                        "name": "Issue Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 501
                    },
                    "issue_edited": {
                        "churn_zero": false,
                        "key": "issue_edited",
                        "label": "issue_edited",
                        "name": "Issue Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 502
                    },
                    "item_limited_to_team": {
                        "churn_zero": true,
                        "key": "item_limited_to_team",
                        "label": "item_limited_to_team",
                        "name": "Item limited to Team",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2402
                    },
                    "live_chat": {
                        "churn_zero": true,
                        "key": "live_chat",
                        "label": "toolbar_help_dropdown_live_chat",
                        "name": "Live Chat",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 103
                    },
                    "merged_duplicate": {
                        "churn_zero": true,
                        "key": "merged_duplicate",
                        "label": "merged_duplicate",
                        "name": "Merged a Duplicate object",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4300
                    },
                    "mobile_wake": {
                        "churn_zero": true,
                        "key": "mobile_wake",
                        "label": "mobile_wake",
                        "name": "Mobile App Wake",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 1400
                    },
                    "new_comment": {
                        "churn_zero": true,
                        "key": "new_comment",
                        "label": "new_comment",
                        "name": "New Comment",
                        "pendo": false,
                        "use_cases": [4, 20],
                        "value": 109
                    },
                    "new_forwarded_email": {
                        "churn_zero": true,
                        "key": "new_forwarded_email",
                        "label": "new_forwarded_email",
                        "name": "New Forwarded Email or BCC to forwards@quorum.us",
                        "pendo": false,
                        "use_cases": [],
                        "value": 111
                    },
                    "new_interaction": {
                        "churn_zero": true,
                        "key": "new_interaction",
                        "label": "new_interaction",
                        "name": "New Interaction",
                        "pendo": false,
                        "use_cases": [4, 20],
                        "value": 107
                    },
                    "new_relationship": {
                        "churn_zero": true,
                        "key": "new_relationship",
                        "label": "new_relationship",
                        "name": "New Relationship",
                        "pendo": false,
                        "use_cases": [4, 20],
                        "value": 108
                    },
                    "open_existing_download": {
                        "churn_zero": true,
                        "key": "open_existing_download",
                        "label": "open_existing_download",
                        "name": "Open an Existing Download",
                        "pendo": false,
                        "use_cases": [6],
                        "value": 213
                    },
                    "opened_email_alert": {
                        "churn_zero": true,
                        "key": "opened_email_alert",
                        "label": "opened_email_alert",
                        "name": "Opened an Email Alert",
                        "pendo": true,
                        "pendo_label": "Alerts | Opened Alert",
                        "use_cases": [2, 19],
                        "value": 27
                    },
                    "outbox_click_new_email": {
                        "churn_zero": false,
                        "key": "outbox_click_new_email",
                        "label": "outbox_click_new_email",
                        "name": "Clicked New Email in Outbox",
                        "pendo": false,
                        "use_cases": [],
                        "value": 407
                    },
                    "outbox_details_page_visited": {
                        "churn_zero": true,
                        "key": "outbox_details_page_visited",
                        "label": "outbox_details_page_visited",
                        "name": "Outbox Details Page Visited",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 44,
                        "use_cases": [5, 13],
                        "value": 404
                    },
                    "outbox_emails_contacts": {
                        "churn_zero": true,
                        "key": "outbox_emails_contacts",
                        "label": "outbox_emails_contacts",
                        "name": "Outbox emails to Contacts",
                        "pendo": false,
                        "use_cases": [5, 13],
                        "value": 405
                    },
                    "outbox_emails_officials_staff": {
                        "churn_zero": true,
                        "key": "outbox_emails_officials_staff",
                        "label": "outbox_emails_officials_staff",
                        "name": "Outbox emails to Officials & Staff",
                        "pendo": false,
                        "use_cases": [5, 13],
                        "value": 406
                    },
                    "pdf_download": {
                        "churn_zero": true,
                        "key": "pdf_download",
                        "label": "pdf_download",
                        "name": "PDF Download",
                        "pendo": false,
                        "use_cases": [6],
                        "value": 200
                    },
                    "pdf_download_bill": {
                        "churn_zero": true,
                        "key": "pdf_download_bill",
                        "label": "pdf_download_bill",
                        "name": "Bill PDF Download",
                        "parent": 200,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [6, 11],
                        "value": 202
                    },
                    "pdf_download_person": {
                        "churn_zero": true,
                        "key": "pdf_download_person",
                        "label": "pdf_download_person",
                        "name": "Official PDF Download",
                        "parent": 200,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [6, 11],
                        "value": 201
                    },
                    "priority_taken": {
                        "churn_zero": true,
                        "key": "priority_taken",
                        "label": "priority_taken",
                        "name": "Priority Taken",
                        "pendo": false,
                        "use_cases": [2, 3],
                        "value": 703
                    },
                    "priority_updated": {
                        "churn_zero": true,
                        "key": "priority_updated",
                        "label": "priority_updated",
                        "name": "Priority Updated",
                        "pendo": false,
                        "use_cases": [2, 3],
                        "value": 704
                    },
                    "product_interest": {
                        "churn_zero": true,
                        "key": "product_interest",
                        "label": "product_interest",
                        "name": "Product Interest",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 1111
                    },
                    "profile_edited": {
                        "churn_zero": true,
                        "key": "profile_edited",
                        "label": "profile_edited",
                        "name": "Profile Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2220
                    },
                    "profile_visited": {
                        "churn_zero": true,
                        "key": "profile_visited",
                        "label": "profile_visited",
                        "name": "Profile Visited",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 2200
                    },
                    "profile_visited_bill": {
                        "churn_zero": true,
                        "key": "profile_visited_bill",
                        "label": "profile_visited_bill",
                        "name": "Bill Profile Visited",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [1, 3],
                        "value": 2202
                    },
                    "profile_visited_campaign": {
                        "churn_zero": true,
                        "key": "profile_visited_campaign",
                        "label": "profile_visited_campaign",
                        "name": "Campaign Profile Visited",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 47,
                        "use_cases": [1, 16],
                        "value": 2203
                    },
                    "profile_visited_issue": {
                        "churn_zero": true,
                        "key": "profile_visited_issue",
                        "label": "profile_visited_issue",
                        "name": "Issue Viewed",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 14,
                        "use_cases": [],
                        "value": 2204
                    },
                    "profile_visited_issue_management": {
                        "churn_zero": true,
                        "key": "profile_visited_issue_management",
                        "label": "profile_visited_issue_management",
                        "name": "Issue Management Viewed",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 83,
                        "use_cases": [],
                        "value": 2205
                    },
                    "profile_visited_media_article": {
                        "churn_zero": true,
                        "key": "profile_visited_media_article",
                        "label": "profile_visited_media_article",
                        "name": "Media Article Viewed",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 105,
                        "use_cases": [21],
                        "value": 2206
                    },
                    "profile_visited_person": {
                        "churn_zero": true,
                        "key": "profile_visited_person",
                        "label": "profile_visited_person",
                        "name": "Official Profile Visited",
                        "parent": 2200,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [1, 6],
                        "value": 2201
                    },
                    "profile_visited_project": {
                        "churn_zero": false,
                        "key": "profile_visited_project",
                        "label": "profile_visited_project",
                        "name": "Project Profile Visited",
                        "pendo": false,
                        "use_cases": [1, 9],
                        "value": 2210
                    },
                    "project_created": {
                        "churn_zero": false,
                        "key": "project_created",
                        "label": "project_created",
                        "name": "Project Created",
                        "pendo": false,
                        "use_cases": [9],
                        "value": 10
                    },
                    "push_notification_alert_failed_delivery": {
                        "churn_zero": true,
                        "key": "push_notification_alert_failed_delivery",
                        "label": "push_notification_alert_failed_delivery",
                        "name": "Push notification alert delivery failed.",
                        "pendo": false,
                        "use_cases": [],
                        "value": 35
                    },
                    "received_email_alert": {
                        "churn_zero": true,
                        "key": "received_email_alert",
                        "label": "received_email_alert",
                        "name": "Was Sent an Email Alert",
                        "pendo": true,
                        "pendo_label": "Alerts | Was Sent Alert",
                        "use_cases": [2, 19],
                        "value": 26
                    },
                    "received_push_notification_alert": {
                        "churn_zero": true,
                        "key": "received_push_notification_alert",
                        "label": "received_push_notification_alert",
                        "name": "Was Sent a Push Notification Alert",
                        "pendo": false,
                        "use_cases": [2, 19],
                        "value": 34
                    },
                    "remove_assignment": {
                        "churn_zero": true,
                        "key": "remove_assignment",
                        "label": "remove_assignment",
                        "name": "Remove Assignment",
                        "pendo": false,
                        "use_cases": [],
                        "value": 113
                    },
                    "remove_from_issue": {
                        "churn_zero": true,
                        "key": "remove_from_issue",
                        "label": "remove_from_issue",
                        "name": "Remove from Issue",
                        "pendo": false,
                        "use_cases": [],
                        "value": 503
                    },
                    "remove_from_list": {
                        "churn_zero": true,
                        "key": "remove_from_list",
                        "label": "remove_from_list",
                        "name": "Remove from List",
                        "pendo": false,
                        "use_cases": [],
                        "value": 521
                    },
                    "reset_password_email_sent": {
                        "churn_zero": true,
                        "key": "reset_password_email_sent",
                        "label": "reset_password_email_sent",
                        "name": "Reset Password Email Sent",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 33
                    },
                    "resize_list": {
                        "churn_zero": false,
                        "key": "resize_list",
                        "label": "resize_list",
                        "name": "Resize List",
                        "pendo": false,
                        "use_cases": [],
                        "value": 19
                    },
                    "search_created": {
                        "churn_zero": true,
                        "key": "search_created",
                        "label": "search_created",
                        "name": "Search Created",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 1000
                    },
                    "search_created_bill": {
                        "churn_zero": true,
                        "key": "search_created_bill",
                        "label": "search_created_bill",
                        "name": "Bill Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [1, 3, 11],
                        "value": 1002
                    },
                    "search_created_document": {
                        "churn_zero": true,
                        "key": "search_created_document",
                        "label": "search_created_document",
                        "name": "Document Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 25,
                        "use_cases": [1, 2, 11, 19],
                        "value": 1004
                    },
                    "search_created_grassroots_action": {
                        "churn_zero": true,
                        "key": "search_created_grassroots_action",
                        "label": "search_created_grassroots_action",
                        "name": "Grassroots Action Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 69,
                        "use_cases": [1, 16],
                        "value": 1007
                    },
                    "search_created_note": {
                        "churn_zero": true,
                        "key": "search_created_note",
                        "label": "search_created_note",
                        "name": "Note Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 20,
                        "use_cases": [1, 4, 20],
                        "value": 1005
                    },
                    "search_created_person": {
                        "churn_zero": true,
                        "key": "search_created_person",
                        "label": "search_created_person",
                        "name": "Official Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [1],
                        "value": 1001
                    },
                    "search_created_supporter": {
                        "churn_zero": true,
                        "key": "search_created_supporter",
                        "label": "search_created_supporter",
                        "name": "Contact Search Created",
                        "parent": 1000,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [1, 15],
                        "value": 1003
                    },
                    "search_download": {
                        "churn_zero": true,
                        "key": "search_download",
                        "label": "search_download",
                        "name": "Search Download",
                        "pendo": false,
                        "use_cases": [],
                        "value": 900
                    },
                    "search_download_bill": {
                        "churn_zero": true,
                        "key": "search_download_bill",
                        "label": "search_download_bill",
                        "name": "Bill Search Download",
                        "parent": 900,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [3],
                        "value": 910
                    },
                    "search_download_document": {
                        "churn_zero": true,
                        "key": "search_download_document",
                        "label": "search_download_document",
                        "name": "Document Search Download",
                        "parent": 900,
                        "pendo": false,
                        "quorum_data_type": 25,
                        "use_cases": [2, 19],
                        "value": 911
                    },
                    "search_download_grassroots_action": {
                        "churn_zero": true,
                        "key": "search_download_grassroots_action",
                        "label": "search_download_grassroots_action",
                        "name": "Grassroots Action Search Download",
                        "parent": 900,
                        "pendo": false,
                        "quorum_data_type": 69,
                        "use_cases": [16],
                        "value": 914
                    },
                    "search_download_supporter": {
                        "churn_zero": true,
                        "key": "search_download_supporter",
                        "label": "search_download_supporter",
                        "name": "Contact Search Download",
                        "parent": 900,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [15],
                        "value": 912
                    },
                    "search_inline_clicked": {
                        "churn_zero": true,
                        "key": "search_inline_clicked",
                        "label": "search_inline_clicked",
                        "name": "Search Inline clicked",
                        "pendo": false,
                        "use_cases": [],
                        "value": 1020
                    },
                    "search_media_article_inline_clicked": {
                        "churn_zero": true,
                        "key": "search_media_article_inline_clicked",
                        "label": "search_media_article_inline_clicked",
                        "name": "Media Article \"See More\" Clicked",
                        "pendo": false,
                        "quorum_data_type": 105,
                        "use_cases": [21],
                        "value": 1021
                    },
                    "secure_upload": {
                        "churn_zero": true,
                        "key": "secure_upload",
                        "label": "secure_upload",
                        "name": "Secure Upload",
                        "pendo": false,
                        "use_cases": [],
                        "value": 903
                    },
                    "send_email": {
                        "churn_zero": false,
                        "key": "send_email",
                        "label": "send_email",
                        "name": "Send Email",
                        "pendo": false,
                        "use_cases": [5, 13],
                        "value": 402
                    },
                    "set_issue_on_bills": {
                        "churn_zero": true,
                        "key": "set_issue_on_bills",
                        "label": "issue_set_on_bills",
                        "name": "Issue set on Bills",
                        "pendo": true,
                        "pendo_label": "Issue set on Bills",
                        "use_cases": [],
                        "value": 47
                    },
                    "set_issue_on_documents": {
                        "churn_zero": true,
                        "key": "set_issue_on_documents",
                        "label": "issue_set_on_documents",
                        "name": "Issue set on Documents",
                        "pendo": true,
                        "pendo_label": "Issue set on Documents",
                        "use_cases": [],
                        "value": 48
                    },
                    "set_issue_on_regulations": {
                        "churn_zero": true,
                        "key": "set_issue_on_regulations",
                        "label": "issue_set_on_regulations",
                        "name": "Issue set on Regulations",
                        "pendo": true,
                        "pendo_label": "Issue set on Regulations",
                        "use_cases": [],
                        "value": 49
                    },
                    "set_priority_on_bills": {
                        "churn_zero": true,
                        "key": "set_priority_on_bills",
                        "label": "priority_set_on_bills",
                        "name": "Priority set on Bills",
                        "pendo": true,
                        "pendo_label": "Priority set on Bills",
                        "use_cases": [],
                        "value": 44
                    },
                    "set_priority_on_documents": {
                        "churn_zero": true,
                        "key": "set_priority_on_documents",
                        "label": "priority_set_on_documents",
                        "name": "Priority set on Documents",
                        "pendo": true,
                        "pendo_label": "Priority set on Documents",
                        "use_cases": [],
                        "value": 45
                    },
                    "set_priority_on_regulations": {
                        "churn_zero": true,
                        "key": "set_priority_on_regulations",
                        "label": "priority_set_on_regulations",
                        "name": "Priority set on Regulations",
                        "pendo": true,
                        "pendo_label": "Priority set on Regulations",
                        "use_cases": [],
                        "value": 46
                    },
                    "set_stance_on_bills": {
                        "churn_zero": true,
                        "key": "set_stance_on_bills",
                        "label": "stance_set_on_bills",
                        "name": "Stance set on Bills",
                        "pendo": true,
                        "pendo_label": "Stance set on Bills",
                        "use_cases": [],
                        "value": 41
                    },
                    "set_stance_on_documents": {
                        "churn_zero": true,
                        "key": "set_stance_on_documents",
                        "label": "stance_set_on_documents",
                        "name": "Stance set on Documents",
                        "pendo": true,
                        "pendo_label": "Stance set on Documents",
                        "use_cases": [],
                        "value": 42
                    },
                    "set_stance_on_regulations": {
                        "churn_zero": true,
                        "key": "set_stance_on_regulations",
                        "label": "stance_set_on_regulations",
                        "name": "Stance set on Regulations",
                        "pendo": true,
                        "pendo_label": "Stance set on Regulations",
                        "use_cases": [],
                        "value": 43
                    },
                    "sheet_column_created": {
                        "churn_zero": true,
                        "key": "sheet_column_created",
                        "label": "sheet_column_created",
                        "name": "Sheet Column Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 620
                    },
                    "sheet_column_created_bill": {
                        "churn_zero": true,
                        "key": "sheet_column_created_bill",
                        "label": "sheet_column_created_bill",
                        "name": "Bill Sheet Column Created",
                        "parent": 620,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [],
                        "value": 622
                    },
                    "sheet_column_created_person": {
                        "churn_zero": true,
                        "key": "sheet_column_created_person",
                        "label": "sheet_column_created_person",
                        "name": "Official Sheet Column Created",
                        "parent": 620,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [6],
                        "value": 621
                    },
                    "sheet_column_created_supporter": {
                        "churn_zero": true,
                        "key": "sheet_column_created_supporter",
                        "label": "sheet_column_created_supporter",
                        "name": "Contact Sheet Column Created",
                        "parent": 620,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [],
                        "value": 623
                    },
                    "sheet_created": {
                        "churn_zero": true,
                        "key": "sheet_created",
                        "label": "sheet_created",
                        "name": "Sheet Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 600
                    },
                    "sheet_downloaded": {
                        "churn_zero": true,
                        "key": "sheet_downloaded",
                        "label": "sheet_downloaded",
                        "name": "Sheet Downloaded",
                        "pendo": false,
                        "use_cases": [],
                        "value": 624
                    },
                    "sheet_edited": {
                        "churn_zero": true,
                        "key": "sheet_edited",
                        "label": "sheet_edited",
                        "name": "Sheet Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 601
                    },
                    "sheet_viewed": {
                        "churn_zero": true,
                        "key": "sheet_viewed",
                        "label": "sheet_viewed",
                        "name": "Sheet Viewed",
                        "pendo": false,
                        "use_cases": [],
                        "value": 602
                    },
                    "sheet_viewed_bill": {
                        "churn_zero": true,
                        "key": "sheet_viewed_bill",
                        "label": "sheet_viewed_bill",
                        "name": "Bill Sheet Viewed",
                        "parent": 602,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [3],
                        "value": 604
                    },
                    "sheet_viewed_custom_event": {
                        "churn_zero": true,
                        "key": "sheet_viewed_custom_event",
                        "label": "sheet_viewed_custom_event",
                        "name": "Visit Event Management Feature",
                        "parent": 602,
                        "pendo": false,
                        "quorum_data_type": 85,
                        "use_cases": [],
                        "value": 606
                    },
                    "sheet_viewed_person": {
                        "churn_zero": true,
                        "key": "sheet_viewed_person",
                        "label": "sheet_viewed_person",
                        "name": "Official Sheet Viewed",
                        "parent": 602,
                        "pendo": false,
                        "quorum_data_type": 1,
                        "use_cases": [6],
                        "value": 603
                    },
                    "sheet_viewed_supporter": {
                        "churn_zero": true,
                        "key": "sheet_viewed_supporter",
                        "label": "sheet_viewed_supporter",
                        "name": "Contact Sheet Viewed",
                        "parent": 602,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [15],
                        "value": 605
                    },
                    "show_in_search_list": {
                        "churn_zero": false,
                        "key": "show_in_search_list",
                        "label": "show_in_search_list",
                        "name": "Show in search",
                        "pendo": false,
                        "use_cases": [],
                        "value": 18
                    },
                    "spreadsheet_download": {
                        "churn_zero": true,
                        "key": "spreadsheet_download",
                        "label": "spreadsheet_download",
                        "name": "Spreadsheet Download",
                        "pendo": false,
                        "use_cases": [],
                        "value": 902
                    },
                    "stance_taken": {
                        "churn_zero": true,
                        "key": "stance_taken",
                        "label": "stance_taken",
                        "name": "Stance Taken",
                        "pendo": false,
                        "use_cases": [2, 3],
                        "value": 700
                    },
                    "stance_updated": {
                        "churn_zero": true,
                        "key": "stance_updated",
                        "label": "stance_updated",
                        "name": "Stance Updated",
                        "pendo": false,
                        "use_cases": [2, 3],
                        "value": 701
                    },
                    "team_created": {
                        "churn_zero": true,
                        "key": "team_created",
                        "label": "team_created",
                        "name": "Team Created",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2400
                    },
                    "team_edited": {
                        "churn_zero": true,
                        "key": "team_edited",
                        "label": "team_edited",
                        "name": "Team Edited",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2401
                    },
                    "toolbar_Q": {
                        "churn_zero": false,
                        "key": "toolbar_Q",
                        "label": "toolbar_Q",
                        "name": "Q at the top left corner",
                        "pendo": false,
                        "use_cases": [],
                        "value": 0
                    },
                    "user_activated": {
                        "churn_zero": true,
                        "key": "user_activated",
                        "label": "user_activated",
                        "name": "User Activated Account",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 32
                    },
                    "user_deactivated": {
                        "churn_zero": true,
                        "key": "user_deactivated",
                        "label": "user_deactivated",
                        "name": "User Deactivated",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 22
                    },
                    "user_is_created": {
                        "churn_zero": true,
                        "key": "user_is_created",
                        "label": "user_is_created",
                        "name": "Is Alive",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 23
                    },
                    "viewed_dashboard": {
                        "churn_zero": true,
                        "key": "viewed_dashboard",
                        "label": "viewed_dashboard",
                        "name": "Viewed a Dashboard",
                        "pendo": false,
                        "use_cases": [],
                        "value": 4200
                    },
                    "visit_download_center": {
                        "churn_zero": true,
                        "key": "visit_download_center",
                        "label": "visit_download_center",
                        "name": "Visit Download Center",
                        "pendo": false,
                        "use_cases": [6],
                        "value": 210
                    },
                    "visit_feature_account": {
                        "churn_zero": false,
                        "key": "visit_feature_account",
                        "label": "visit_feature_account",
                        "name": "Visited Account Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3010
                    },
                    "visit_feature_action_center": {
                        "churn_zero": true,
                        "feature": 1,
                        "key": "visit_feature_action_center",
                        "label": "visit_feature_action_center",
                        "name": "Visited Action Center Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3020
                    },
                    "visit_feature_bulk_actions": {
                        "churn_zero": false,
                        "key": "visit_feature_bulk_actions",
                        "label": "visit_feature_bulk_actions",
                        "name": "Visited Bulk Actions Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3030
                    },
                    "visit_feature_bulk_uploads": {
                        "churn_zero": true,
                        "key": "visit_feature_bulk_uploads",
                        "label": "visit_feature_bulk_uploads",
                        "name": "Visited Bulk Uploads Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3040
                    },
                    "visit_feature_contacts": {
                        "churn_zero": false,
                        "key": "visit_feature_contacts",
                        "label": "visit_feature_contacts",
                        "name": "Visited Contacts Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3050
                    },
                    "visit_feature_custom_fields": {
                        "churn_zero": true,
                        "key": "visit_feature_custom_fields",
                        "label": "visit_feature_custom_fields",
                        "name": "Visited Custom Fields Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3060
                    },
                    "visit_feature_dashboard": {
                        "churn_zero": true,
                        "feature": 16,
                        "key": "visit_feature_dashboard",
                        "label": "visit_feature_dashboard",
                        "name": "Visited Dashboard Feature",
                        "pendo": false,
                        "quorum_data_type": 104,
                        "use_cases": [],
                        "value": 2500
                    },
                    "visit_feature_data": {
                        "churn_zero": false,
                        "key": "visit_feature_data",
                        "label": "visit_feature_data",
                        "name": "Visited Data Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3070
                    },
                    "visit_feature_download_center": {
                        "churn_zero": true,
                        "feature": 4,
                        "key": "visit_feature_download_center",
                        "label": "visit_feature_download_center",
                        "name": "Visited Download Center Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3080
                    },
                    "visit_feature_email_alerts": {
                        "churn_zero": false,
                        "key": "visit_feature_email_alerts",
                        "label": "visit_feature_email_alerts",
                        "name": "Visited Email Alerts Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3090
                    },
                    "visit_feature_event_management": {
                        "churn_zero": true,
                        "feature": 6,
                        "key": "visit_feature_event_management",
                        "label": "visit_feature_event_management",
                        "name": "Visited Event Management Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3100
                    },
                    "visit_feature_issue_management": {
                        "churn_zero": true,
                        "feature": 7,
                        "key": "visit_feature_issue_management",
                        "label": "visit_feature_issue_management",
                        "name": "Visited Issue Management Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3110
                    },
                    "visit_feature_mobile": {
                        "churn_zero": false,
                        "key": "visit_feature_mobile",
                        "label": "visit_feature_mobile",
                        "name": "Visited Mobile Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3120
                    },
                    "visit_feature_notes": {
                        "churn_zero": false,
                        "key": "visit_feature_notes",
                        "label": "visit_feature_notes",
                        "name": "Visited Notes Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3130
                    },
                    "visit_feature_outbound_texting": {
                        "churn_zero": true,
                        "feature": 17,
                        "key": "visit_feature_outbound_texting",
                        "label": "visit_feature_outbound_texting",
                        "name": "Visited Outbound Texting Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3180
                    },
                    "visit_feature_outbox": {
                        "churn_zero": true,
                        "feature": 8,
                        "key": "visit_feature_outbox",
                        "label": "visit_feature_outbox",
                        "name": "Visited Outbox Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3140
                    },
                    "visit_feature_pac": {
                        "churn_zero": false,
                        "feature": 19,
                        "key": "visit_feature_pac",
                        "label": "visit_feature_pac",
                        "name": "Visited PAC Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3190
                    },
                    "visit_feature_search": {
                        "churn_zero": false,
                        "feature": 9,
                        "key": "visit_feature_search",
                        "label": "visit_feature_search",
                        "name": "Visited Search Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3150
                    },
                    "visit_feature_sheets": {
                        "churn_zero": true,
                        "feature": 10,
                        "key": "visit_feature_sheets",
                        "label": "visit_feature_sheets",
                        "name": "Visited Sheets Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3160
                    },
                    "visit_feature_tracking_dashboards": {
                        "churn_zero": true,
                        "feature": 11,
                        "key": "visit_feature_tracking_dashboards",
                        "label": "visit_feature_tracking_dashboards",
                        "name": "Visited Tracking Boards Feature",
                        "pendo": false,
                        "quorum_data_type": 93,
                        "use_cases": [],
                        "value": 3170
                    },
                    "visit_media_article_search": {
                        "churn_zero": true,
                        "key": "visit_media_article_search",
                        "label": "visit_media_article_search",
                        "name": "Visited Media Article Search",
                        "parent": 3150,
                        "pendo": false,
                        "quorum_data_type": 105,
                        "use_cases": [21],
                        "value": 3151
                    },
                    "visit_new_download_center": {
                        "churn_zero": true,
                        "key": "visit_new_download_center",
                        "label": "visit_new_download_center",
                        "name": "Visit New Download Center",
                        "pendo": false,
                        "use_cases": [6],
                        "value": 211
                    },
                    "visit_whats_new_blog": {
                        "churn_zero": true,
                        "key": "visit_whats_new_blog",
                        "label": "visit_whats_new_blog",
                        "name": "Visited What's New Blog",
                        "pendo": false,
                        "use_cases": [1],
                        "value": 106
                    },
                    "visualization_opened": {
                        "churn_zero": true,
                        "key": "visualization_opened",
                        "label": "visualization_opened",
                        "name": "Visualization Opened",
                        "pendo": false,
                        "use_cases": [],
                        "value": 2100
                    },
                    "visualization_opened_bill": {
                        "churn_zero": true,
                        "key": "visualization_opened_bill",
                        "label": "visualization_opened_bill",
                        "name": "Bill Visualization Opened",
                        "parent": 2100,
                        "pendo": false,
                        "quorum_data_type": 2,
                        "use_cases": [3],
                        "value": 2106
                    },
                    "visualization_opened_document": {
                        "churn_zero": true,
                        "key": "visualization_opened_document",
                        "label": "visualization_opened_document",
                        "name": "Document Visualization Opened",
                        "parent": 2100,
                        "pendo": false,
                        "quorum_data_type": 25,
                        "use_cases": [2, 11, 19],
                        "value": 2101
                    },
                    "visualization_opened_grassroots_action": {
                        "churn_zero": true,
                        "key": "visualization_opened_grassroots_action",
                        "label": "visualization_opened_grassroots_action",
                        "name": "Grassroots Action Visualization Opened",
                        "parent": 2100,
                        "pendo": false,
                        "quorum_data_type": 69,
                        "use_cases": [16],
                        "value": 2105
                    },
                    "visualization_opened_note": {
                        "churn_zero": true,
                        "key": "visualization_opened_note",
                        "label": "visualization_opened_note",
                        "name": "Note Visualization Opened",
                        "parent": 2100,
                        "pendo": false,
                        "quorum_data_type": 20,
                        "use_cases": [4, 20],
                        "value": 2103
                    },
                    "visualization_opened_supporter": {
                        "churn_zero": true,
                        "key": "visualization_opened_supporter",
                        "label": "visualization_opened_supporter",
                        "name": "Contact Visualization Opened",
                        "parent": 2100,
                        "pendo": false,
                        "quorum_data_type": 12,
                        "use_cases": [15],
                        "value": 2102
                    }
                }
            }
        },
        "userdata": {
            "alerts": {
                "models": {
                    "Alert": {
                        "__is_model": true,
                        "__name__": "Alert",
                        "data_model": "app.userdata.alerts.models.Alert",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/alert/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "User who owns this Alert",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "User who created this alert",
                                "name": "creator",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 3, "help_text": "The title of this Alert", "name": "title", "verbose_name": "title" },
                            { "field_type": 1, "help_text": "If True, this Alert is a default, Quorum-created alert", "name": "default", "verbose_name": "default" },
                            { "field_type": 1, "help_text": "If True, this Alert is paused and will not create FeedItems", "name": "paused", "verbose_name": "paused" },
                            { "field_type": 1, "help_text": "If True, this Alert will have its cache re-populated on the next run and no FeedItems will be created. If False, behave as normal.", "name": "needs_recache", "verbose_name": "needs recache" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.alerts.types", "__name__": "AlertStatus" },
                                "field_type": 4,
                                "help_text": "Whether or not this alert is currently being processed, or if it ran into an error on it's previous run.",
                                "name": "processing_status",
                                "verbose_name": "processing status"
                            },
                            { "field_type": 4, "help_text": "The number of times this alert has failed since last successful run.", "name": "error_count", "verbose_name": "error count" },
                            { "field_type": 21, "help_text": "The time that this alert should retry processing.", "name": "next_retry_time", "verbose_name": "next retry time" },
                            {
                                "field_type": 7,
                                "help_text": "The Alert Group this Alert belongs to",
                                "name": "alert_group",
                                "related_model": { "__module__": "app.userdata.alerts.models", "__name__": "AlertGroup" },
                                "verbose_name": "alert group"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The project associated with this Alert, if applicable",
                                "name": "project",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "project"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The tracking board associated with this Alert, if applicable.",
                                "name": "tracking_dashboard",
                                "related_model": { "__module__": "app.tracking_dashboards.models", "__name__": "TrackingDashboard" },
                                "verbose_name": "tracking dashboard"
                            },
                            { "field_type": 3, "help_text": "The slug of a search term board for this alert. May be null.", "name": "search_term_board", "verbose_name": "search term board" },
                            {
                                "field_type": 7,
                                "help_text": "The SafedSearch this alert is tied to",
                                "name": "safed_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "safed search"
                            },
                            {
                                "field_type": 7,
                                "help_text": "Optional CustomRegionSelection for this alert's regions",
                                "name": "custom_region_selection",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "CustomRegionSelection" },
                                "verbose_name": "custom region selection"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "SupportedRegion" },
                                "field_type": 4,
                                "help_text": "The type of object this alert is for",
                                "name": "supported_region",
                                "verbose_name": "supported region"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The bill tied to this alert",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The regulation tied to this alert",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            { "field_type": null, "help_text": "The types of updates to receive on this alert", "name": "update_types", "verbose_name": "update types" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "The type of object this alert is for",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "The media of delivery for this Alert", "name": "media", "verbose_name": "media" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.alerts.types", "__name__": "AlertTier" },
                                "field_type": 4,
                                "help_text": "The Tier of this alert, which marks the size of it's cache",
                                "name": "tier",
                                "verbose_name": "tier"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.alerts.types", "__name__": "Velocity" },
                                "field_type": 4,
                                "help_text": "The velocity of this alert in forward process. Only used for calculating immediate alert speed.",
                                "name": "velocity",
                                "verbose_name": "velocity"
                            },
                            { "field_type": null, "help_text": "The cache of the current state of this Alert, used when computing FeedItems", "name": "cached_results", "verbose_name": "cached results" },
                            { "field_type": null, "help_text": "Metadata about the size of the cache, used for determining the tier", "name": "cache_metadata", "verbose_name": "cache metadata" },
                            { "field_type": 21, "help_text": "The last time this Alert was re-cached", "name": "last_recache", "verbose_name": "last recache" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.alerts.types", "__name__": "AlertFrequency" },
                                "field_type": 4,
                                "help_text": "The frequency this Alert goes out",
                                "name": "frequency",
                                "verbose_name": "frequency"
                            },
                            { "field_type": 21, "help_text": "The last time this Alert was processed", "name": "last_processed", "verbose_name": "last processed" },
                            { "field_type": null, "help_text": "The days of the week to send this alert, if applicable.", "name": "send_days", "verbose_name": "send days" },
                            { "field_type": 15, "help_text": "The time of day to send this Alert, if applicable", "name": "send_time", "verbose_name": "send time" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "Timezones" },
                                "field_type": 4,
                                "help_text": "The Timezones relevant to this alert, if applicable.",
                                "name": "timezone",
                                "verbose_name": "timezone"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "LegislativeStanceType" },
                                "field_type": 4,
                                "help_text": "The value of the stance used to filter to the alert, if it is a default alert",
                                "name": "stance",
                                "verbose_name": "stance"
                            },
                            {
                                "field_type": 8,
                                "help_text": "All users will have this alert duplicated for them",
                                "name": "duplicate_users",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "duplicate users"
                            }
                        ]
                    },
                    "AlertGroup": {
                        "__is_model": true,
                        "__name__": "AlertGroup",
                        "data_model": "app.userdata.alerts.models.AlertGroup",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/alertgroup/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "User who owns this Alert Group",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            { "field_type": 3, "help_text": "The title of this Alert Group", "name": "title", "verbose_name": "title" }
                        ]
                    },
                    "FeedItem": {
                        "__is_model": true,
                        "__name__": "FeedItem",
                        "data_model": "app.userdata.alerts.models.FeedItem",
                        "default_exclude_filters": {},
                        "default_filters": { "current_user": true },
                        "endpoint": "/api/feeditem/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "User who owns this FeedItem",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "Organization whose user owns this feed item",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The Alert from whence this FeedItem came",
                                "name": "alert",
                                "related_model": { "__module__": "app.userdata.alerts.models", "__name__": "Alert" },
                                "verbose_name": "alert"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling bill for this FeedItem",
                                "name": "underlying_bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "underlying bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling amendment for this FeedItem",
                                "name": "underlying_amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "underlying amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling document for this FeedItem",
                                "name": "underlying_document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "underlying document"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling contact for this FeedItem",
                                "name": "underlying_supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "underlying supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling person for this FeedItem",
                                "name": "underlying_person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "underlying person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling note for this FeedItem",
                                "name": "underlying_note",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "Note" },
                                "verbose_name": "underlying note"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling vote for this FeedItem",
                                "name": "underlying_vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "underlying vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling event for this FeedItem",
                                "name": "underlying_event",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "underlying event"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling Assignment for this FeedItem",
                                "name": "underlying_assignment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Assignment" },
                                "verbose_name": "underlying assignment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underling Regulation for this FeedItem",
                                "name": "underlying_regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "underlying regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underlying Docket for this Docket",
                                "name": "underlying_docket",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "underlying docket"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The underlying RegComment for this FeedItem",
                                "name": "underlying_reg_comment",
                                "related_model": { "__module__": "app.reg.models", "__name__": "RegComment" },
                                "verbose_name": "underlying reg comment"
                            },
                            { "field_type": 4, "help_text": "The underlying Article for this FeedItem", "name": "underlying_article", "verbose_name": "underlying article" },
                            {
                                "field_type": 7,
                                "help_text": "The underlying SendEmail for this FeedItem",
                                "name": "underlying_send_email",
                                "related_model": { "__module__": "app.userdata.outbox.models.send_email", "__name__": "SendEmail" },
                                "verbose_name": "underlying send email"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.alerts.types", "__name__": "NewUpdateType" },
                                "field_type": 4,
                                "help_text": "The type of update this FeedItem is",
                                "name": "update_type",
                                "verbose_name": "update type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "The type of object this FeedItem is",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "The region(s) of the underlying object. Can be null for custom things", "name": "regions", "verbose_name": "regions" },
                            { "field_type": null, "help_text": "The media of delivery for this FeedItem", "name": "media", "verbose_name": "media" },
                            { "field_type": 1, "help_text": "Create a deliverable for this guy if True", "name": "should_be_delivered", "verbose_name": "should be delivered" },
                            { "field_type": 4, "help_text": "Number of times this FeedItem has thrown errors in alert processing", "name": "error_count", "verbose_name": "error count" },
                            { "field_type": null, "help_text": "The cache of relevant data required to turn a FeedItem into a Deliverable", "name": "item_cache", "verbose_name": "item cache" },
                            { "field_type": null, "help_text": "The big cache of this FeedItem, ready for deliverables and search.", "name": "big_cache", "verbose_name": "big cache" },
                            { "field_type": 3, "help_text": "The title of this feed item, indexed for searching!", "name": "title", "verbose_name": "title" },
                            { "field_type": 21, "help_text": "The time that this feed item was scheduled to be created", "name": "alert_scheduled_time", "verbose_name": "alert scheduled time" },
                            { "field_type": 21, "help_text": "The time that the processing run that created this feed item began", "name": "alert_process_start_time", "verbose_name": "alert process start time" },
                            {
                                "field_type": 8,
                                "help_text": "The Deliverables that contain this FeedItem",
                                "name": "deliverables",
                                "related_model": { "__module__": "app.userdata.outbox.models.send_email", "__name__": "SendEmail" },
                                "verbose_name": "deliverables"
                            }
                        ]
                    }
                },
                "types": {
                    "AlertFrequency": {
                        "__is_enum": true,
                        "day": { "buffer": 30, "key": "day", "label": "At Most Once a Day", "short_label": "Daily or Weekly", "value": 6 },
                        "four_hours": { "buffer": 20, "hours": 4, "key": "four_hours", "label": "At Most Every Four Hours", "short_label": "Every Four Hours", "value": 3 },
                        "immediate": { "buffer": 0, "key": "immediate", "label": "As Soon as Quorum Has It", "short_label": "As Soon as Quorum Has It", "value": 1 },
                        "six_hours": { "buffer": 20, "hours": 6, "key": "six_hours", "label": "At Most Every Six Hours", "short_label": "Every Six Hours", "value": 4 },
                        "twelve_hours": { "buffer": 20, "hours": 12, "key": "twelve_hours", "label": "At Most Every Twelve Hours", "short_label": "Every Twelve Hours", "value": 5 },
                        "two_hours": { "buffer": 10, "hours": 2, "key": "two_hours", "label": "At Most Every Two Hours", "short_label": "Every Two Hours", "value": 2 }
                    },
                    "AlertTier": {
                        "__is_enum": true,
                        "four": {
                            "default_update_types": [2],
                            "key": "four",
                            "label": "Tier Four",
                            "lower_bound": 10000,
                            "upper_bound": 999999999999999,
                            "value": 4
                        },
                        "one": {
                            "default_update_types": [2, 3, 6],
                            "key": "one",
                            "label": "Tier One",
                            "lower_bound": 0,
                            "upper_bound": 250,
                            "value": 1
                        },
                        "three": {
                            "default_update_types": [2, 3],
                            "key": "three",
                            "label": "Tier Three",
                            "lower_bound": 2500,
                            "upper_bound": 10000,
                            "value": 3
                        },
                        "two": {
                            "default_update_types": [2, 3, 6],
                            "key": "two",
                            "label": "Tier Two",
                            "lower_bound": 250,
                            "upper_bound": 2500,
                            "value": 2
                        }
                    },
                    "DeliveryMedium": {
                        "__is_enum": true,
                        "email": { "disabled": false, "key": "email", "label": "Email", "order": 1, "tip": "By default, this alert will be delivered to your email. De-select \"Email\" if you only want to see this alert in your Alerts Feed.", "value": 1 },
                        "feed": { "disabled": true, "key": "feed", "label": "Alert Feed", "order": 0, "tip": "Use the Alerts Feed to search through, and filter your alerts in Quorum or on the mobile app.", "value": 2 },
                        "push_notification": { "disabled": false, "key": "push_notification", "label": "Mobile Push Notification", "order": 2, "tip": "Receive push notifications via the Quorum mobile app for this alert.", "value": 3 }
                    },
                    "NewUpdateType": {
                        "__is_enum": true,
                        "csv_download": {
                            "frontend_order": 0,
                            "key": "csv_download",
                            "label": "CSV Download",
                            "max_tier": 1,
                            "multi": true,
                            "order": 7,
                            "separated": false,
                            "supported_data_types": [1, 8, 2, 25, 12, 80],
                            "tip": "Receive a CSV of all objects with this.",
                            "value": 7
                        },
                        "everything": {
                            "frontend_order": 4,
                            "help_text": "Fill",
                            "key": "everything",
                            "label": "Everything",
                            "max_tier": 1,
                            "multi": false,
                            "order": 1,
                            "search_label": "Report",
                            "separated": true,
                            "short_label": "Item",
                            "supported_data_types": [4, 75, 2, 88, 25, 28, 105, 20, 1, 120, 80, 95, 45, 8, 12, 3],
                            "tip": "Filter by alerts sent as a Report from a particular data type. This is useful when you'd like to be reminded of something at a set interval. This is frequently used to create a daily or weekly report of upcoming hearings on priority bills or a group of a certain data type that you need to follow up on.",
                            "value": 1
                        },
                        "meta_updates": { "key": "meta_updates", "label": "Meta Updates", "max_tier": 0, "multi": false, "order": 100, "tip": "Filter by updates on the Alert itself", "value": 100 },
                        "new_things": {
                            "frontend_order": 1,
                            "help_text": "Me",
                            "key": "new_things",
                            "label": "New Things",
                            "max_tier": 4,
                            "multi": true,
                            "order": 2,
                            "search_label": "New",
                            "separated": true,
                            "short_label": "New",
                            "supported_data_types": [4, 75, 2, 88, 25, 28, 105, 20, 1, 120, 80, 95, 45, 8, 12, 3],
                            "tip": "Filter by alerts sent when data of a particular data type matches your search.",
                            "value": 2
                        },
                        "removed_things": {
                            "frontend_order": 2,
                            "help_text": "In",
                            "key": "removed_things",
                            "label": "Removed Things",
                            "max_tier": 3,
                            "multi": true,
                            "order": 3,
                            "search_label": "Removed",
                            "separated": false,
                            "short_label": "Removed",
                            "supported_data_types": [1, 8],
                            "tip": "Filter by alerts sent when data of a particular data type no longer matches your search.",
                            "value": 3
                        },
                        "updates_high": {
                            "frontend_order": 5,
                            "group": 1002,
                            "help_text": "Team",
                            "key": "updates_high",
                            "label": "All Changes",
                            "max_tier": 2,
                            "multi": false,
                            "order": 6,
                            "relevant_fields": {
                                "1": ["relevant_data_descriptions"],
                                "105": [],
                                "12": ["tag_dict"],
                                "2": ["texts", "amendments", "current_general_status", "event_mentions", "votes", "major_actions", "title", "committees", "sponsors", "relatedbills", "document_mentions"],
                                "80": ["texts", "general_status", "related_events", "title", "major_actions", "registers", "agencies"]
                            },
                            "search_label": "Every Change",
                            "separated": false,
                            "short_label": "Update",
                            "supported_data_types": [2, 80],
                            "tip": "Filter by alerts sent when data of a particular data type matching your search undergoes a change.\nIn the case of bills, you will receive alerts when:\n\t1) New versions of bill text are published\n\t2) The overall status of a bill changes\n\t3) New hearings are scheduled on a bill\n\t4) A vote has occurred on a bill\n\t5) The timeline of a bill changes\n\t6) New sponsors / cosponsors are added\n\t7) New committees are added\n\t8) New companion bills are added\n\t9) The title of a bill changes\n",
                            "value": 6
                        },
                        "updates_low": {
                            "frontend_order": 7,
                            "group": 1002,
                            "help_text": "Front",
                            "key": "updates_low",
                            "label": "Major Changes",
                            "max_tier": 2,
                            "multi": false,
                            "order": 4,
                            "relevant_fields": {
                                "1": ["relevant_data_descriptions"],
                                "12": ["tag_dict"],
                                "2": ["texts"],
                                "80": ["texts"]
                            },
                            "search_label": "Only Major Changes",
                            "separated": false,
                            "short_label": "Updates",
                            "supported_data_types": [2, 80],
                            "tip": "Filter by alerts sent when data of a particular data type undergoes a major change. In the case of bills, you will only receive an alert whenever new versions of bill text are published. We typically find that users set this alert for bills they have deemed unimportant but want to know if the text changes suddenly.",
                            "value": 4
                        },
                        "updates_medium": {
                            "frontend_order": 6,
                            "group": 1002,
                            "help_text": "End",
                            "key": "updates_medium",
                            "label": "Some Changes",
                            "max_tier": 2,
                            "multi": false,
                            "order": 5,
                            "relevant_fields": {
                                "1": ["relevant_data_descriptions"],
                                "12": ["tag_dict"],
                                "2": ["texts", "amendments", "current_general_status", "event_mentions", "votes"],
                                "80": ["texts", "general_status", "related_events"]
                            },
                            "search_label": "Most Changes",
                            "separated": false,
                            "short_label": "Updates",
                            "supported_data_types": [2, 80],
                            "tip": "Filter by alerts sent when data of a particular data type undergoes a major or intermediate change.\nIn the case of bills, you will receive alerts when:\n\t1) New versions of bill text are published\n\t2) The overall status of a bill changes\n\t3) New hearings are scheduled on a bill\n\t4) A vote has occurred on a bill\n",
                            "value": 5
                        }
                    },
                    "UpdateTypeGroups": {
                        "__is_enum": true,
                        "changes": {
                            "frontend_order": 3,
                            "key": "changes",
                            "label": "Changes",
                            "max_tier": 2,
                            "multi": true,
                            "separated": false,
                            "supported_data_types": [2, 80],
                            "value": 1002
                        },
                        "updates": {
                            "frontend_order": 0,
                            "key": "updates",
                            "label": "Updates",
                            "max_tier": 2,
                            "separated": false,
                            "supported_data_types": [],
                            "value": 1001
                        }
                    }
                }
            },
            "download": {
                "models": {
                    "DownloadTemplate": {
                        "__is_model": true,
                        "__name__": "DownloadTemplate",
                        "data_model": "app.userdata.download.models.DownloadTemplate",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/downloadtemplate/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "creator",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "creator"
                            },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 2, "help_text": "The name of the template", "name": "name", "verbose_name": "name" },
                            { "field_type": 3, "help_text": "HTML content of the template", "name": "html_content", "verbose_name": "html content" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "last_editor",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "last editor"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            { "field_type": null, "help_text": "the selected json", "name": "json_content", "verbose_name": "json content" },
                            { "field_type": 2, "help_text": "The url of the screenshot image.", "name": "template_screenshot_url", "verbose_name": "template screenshot url" },
                            { "field_type": 2, "help_text": "", "name": "slug", "verbose_name": "slug" },
                            { "field_type": 1, "help_text": "Quorum Provides a few default templates that are visible for any Organization", "name": "default_template", "verbose_name": "default template" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            }
                        ]
                    }
                }
            },
            "models": {
                "Assignment": {
                    "__is_model": true,
                    "__name__": "Assignment",
                    "data_model": "app.userdata.models.Assignment",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/assignment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "AssignmentType" },
                            "field_type": 4,
                            "help_text": "The type of assignment that this is.",
                            "name": "assignment_type",
                            "verbose_name": "assignment type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Who created this assignment -- if made automatically is usually the same as the recipient.",
                            "name": "creator",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "creator"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization this assignment was created in.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The user object that is assigned to this thing -- i.e. if Joe is assigned to Lamar, this is Joe",
                            "name": "recipient",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "recipient"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The supporter object that is assigned to this thing -- i.e. if Joe is assigned to Lamar, this is Joe",
                            "name": "recipient_supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "recipient supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "member",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "member"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        {
                            "field_type": 7,
                            "help_text": "the CustomEvent associated with this assignment",
                            "name": "custom_event",
                            "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                            "verbose_name": "custom event"
                        },
                        {
                            "field_type": 7,
                            "help_text": "the Committee associated with this assignment",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        { "field_type": 1, "help_text": "Whether this assignment is the primary assignment for the assignment member/supporter/org/etc", "name": "is_primary", "verbose_name": "is primary" }
                    ]
                },
                "Attachment": {
                    "__is_model": true,
                    "__name__": "Attachment",
                    "data_model": "app.userdata.models.Attachment",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/attachment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        { "field_type": 2, "help_text": "the file name of the attachment", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "AttachmentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "type",
                            "verbose_name": "type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization of the User that created this attachment",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 3, "help_text": "", "name": "short_description", "verbose_name": "short description" },
                        { "field_type": 1, "help_text": "Whether the upload was not an outbox attachment.", "name": "non_outbox_upload", "verbose_name": "non outbox upload" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "email",
                            "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                            "verbose_name": "email"
                        },
                        { "field_type": 1, "help_text": "Whether this attachment is publicly accessible. Files that are publicly accessible are uploaded to BUCKET_NAME.Files that are not publicly accessible are uploaded to multiple other buckets.Note that at the moment, this field cannot be toggled on and off because we have no logic that switches thefiles between buckets", "name": "is_public", "verbose_name": "is public" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "template",
                            "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                            "verbose_name": "template"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "note",
                            "related_model": { "__module__": "app.userdata.notes.models", "__name__": "Note" },
                            "verbose_name": "note"
                        },
                        { "field_type": 2, "help_text": "the MIME type of the attachment", "name": "mime_type", "verbose_name": "mime type" },
                        { "field_type": 3, "help_text": "the content of the attachment as a base64-encoded string", "name": "content", "verbose_name": "content" },
                        { "field_type": 4, "help_text": "the size of the file", "name": "size", "verbose_name": "size" },
                        { "field_type": 1, "help_text": "Whether this attachment has been added to the note's raw content for full-text search", "name": "added_to_fts", "verbose_name": "added to fts" },
                        { "field_type": 2, "help_text": "", "name": "raw_s3_url", "verbose_name": "raw s3 url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_s3_url", "verbose_name": "pdf s3 url" },
                        { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 4, "help_text": "Number of words in this Attachment text, useful for fts vector heuristics", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 7,
                            "help_text": "The Attachment that this attachment is a duplicate of. Used for linking ABTested BulkEmail attachments.",
                            "name": "duplicated_from",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                            "verbose_name": "duplicated from"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "CustomRegionSelection": {
                    "__is_model": true,
                    "__name__": "CustomRegionSelection",
                    "data_model": "app.userdata.models.CustomRegionSelection",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/customregionselection/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The User that created this object",
                            "name": "creator",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "Whether or not this object is limited to its creator", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "The organization this selection is for.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": null, "help_text": "Regions this selection contains as a list of abbreviations.", "name": "regions", "verbose_name": "regions" },
                        { "field_type": null, "help_text": "Regions this selection contains as a list of values.", "name": "region_values", "verbose_name": "region values" },
                        {
                            "field_type": 7,
                            "help_text": "The user info this selection is for.",
                            "name": "user_info",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "UserInfo" },
                            "verbose_name": "user info"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "DataDescription": {
                    "__is_model": true,
                    "__name__": "DataDescription",
                    "data_model": "app.userdata.models.DataDescription",
                    "default_exclude_filters": {},
                    "default_filters": { "order_by": "-updated" },
                    "endpoint": "/api/datadescription/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "staffer",
                            "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                            "verbose_name": "staffer"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "public_organization",
                            "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                            "verbose_name": "public organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "document",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "document"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "attachment",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                            "verbose_name": "attachment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "committee",
                            "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                            "verbose_name": "committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "political_committee",
                            "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                            "verbose_name": "political committee"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "election",
                            "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                            "verbose_name": "election"
                        },
                        { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                        { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The last user to modify (or create) this object. In the case of automated creation, just use a randomly-selected user object from the organization above.",
                            "name": "last_user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "last user"
                        },
                        { "field_type": 3, "help_text": "Preferred name for Officials & Staff. Custom Title for Bills", "name": "preferred_name", "verbose_name": "preferred name" },
                        { "field_type": 16, "help_text": "The time that the text of the datadescription was last updated", "name": "text_last_updated", "verbose_name": "Text Last Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The last user to modify (or create) the text of this object.",
                            "name": "last_text_updated_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "last text updated user"
                        },
                        { "field_type": 2, "help_text": "Custom Status for Bill", "name": "custom_status", "verbose_name": "custom status" },
                        { "field_type": 2, "help_text": "Personal email", "name": "personal_email", "verbose_name": "personal email" },
                        { "field_type": 2, "help_text": "Personal phone number", "name": "personal_phone_number", "verbose_name": "personal phone number" },
                        { "field_type": 1, "help_text": "If the Official is unsubscribed to outbox emails", "name": "is_unsubscribed", "verbose_name": "is unsubscribed" },
                        { "field_type": 1, "help_text": "If Outbox should use the personal email (if specified) over the original email address", "name": "should_use_personal_email", "verbose_name": "should use personal email" },
                        { "field_type": 2, "help_text": "AWS S3 URL of custom user-uploaded image", "name": "custom_image_s3_url", "verbose_name": "custom image s3 url" },
                        { "field_type": 4, "help_text": "The PACC ID for this client-specific record.", "name": "pacc_id", "verbose_name": "pacc id" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        { "field_type": null, "help_text": "For PAC Classic models that are PAC specific as well as Client specific, the dictionaryof LedgerSettings PACC PAC ID (the id in PAC Classic) to PACC ID and Version", "name": "pacc_pac_specific_ids", "verbose_name": "pacc pac specific ids" },
                        {
                            "field_type": 8,
                            "help_text": "The Bulk Upload Files that have created/updated this object",
                            "name": "bulk_upload_files",
                            "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                            "verbose_name": "bulk upload files"
                        }
                    ]
                },
                "GrassrootsIssue": {
                    "__is_model": true,
                    "__name__": "GrassrootsIssue",
                    "data_model": "app.userdata.models.GrassrootsIssue",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/grassrootsissue/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": 1, "help_text": "Marks the object to be visible to users thatare on the partner organizations (organization.partners M2M)as well as the normal limited_to_teams users", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                        { "field_type": null, "help_text": "", "name": "search_terms", "verbose_name": "search terms" },
                        { "field_type": null, "help_text": "", "name": "categories", "verbose_name": "categories" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "project_type",
                            "verbose_name": "project type"
                        },
                        { "field_type": 4, "help_text": "", "name": "year", "verbose_name": "year" },
                        {
                            "field_type": 7,
                            "help_text": "This field stores the organization to which this Project belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "User id of the project creator",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "Whether this project appears in theproject_prioritization page or not", "name": "shown_in_table", "verbose_name": "shown in table" },
                        { "field_type": 1, "help_text": "Whether other users may edit project settings", "name": "creator_edit_only", "verbose_name": "creator edit only" },
                        { "field_type": 1, "help_text": "Whether or not to show carryover legislation", "name": "is_carryover", "verbose_name": "is carryover" },
                        { "field_type": 1, "help_text": "Whether a search terms list will show bills with a stance", "name": "remove_with_stance", "verbose_name": "remove with stance" },
                        { "field_type": 3, "help_text": "Name of the project", "name": "name", "verbose_name": "name" },
                        { "field_type": null, "help_text": "A cache of the teams currently on this project.", "name": "team_cache", "verbose_name": "team cache" },
                        { "field_type": 1, "help_text": "Whether or not this a default project", "name": "default", "verbose_name": "default" },
                        { "field_type": 1, "help_text": "", "name": "converted", "verbose_name": "converted" },
                        { "field_type": 2, "help_text": "", "name": "screenshot_url", "verbose_name": "screenshot url" },
                        { "field_type": 3, "help_text": "html text of the page", "name": "long_description", "verbose_name": "long description" },
                        { "field_type": 2, "help_text": "The region field", "name": "region_tag", "verbose_name": "Region Tag" },
                        { "field_type": 3, "help_text": "A field for regions related to the project.", "miscellaneous": 49, "name": "related_region", "sheet_column": true, "verbose_name": "Project Region" },
                        { "field_type": 4, "help_text": "Cost of the project", "miscellaneous": 49, "name": "cost", "patch": true, "sheet_column": true, "verbose_name": "Cost" },
                        { "field_type": 2, "help_text": "Due date for project", "miscellaneous": 49, "name": "due_date", "patch": true, "sheet_column": true, "verbose_name": "Due Date" },
                        { "field_type": 16, "help_text": "", "name": "deadline", "verbose_name": "Deadline" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectRating" },
                            "field_type": 4,
                            "help_text": "The project's priority score",
                            "miscellaneous": 49,
                            "name": "priority",
                            "patch": true,
                            "sheet_column": true,
                            "verbose_name": "Priority"
                        },
                        {
                            "field_type": 7,
                            "help_text": "default owner of the project",
                            "name": "owner",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "owner"
                        },
                        { "field_type": 2, "help_text": "The name of the person who is the most knowledgeable in this issue area.", "miscellaneous": 49, "name": "issue_expert", "patch": true, "sheet_column": true, "verbose_name": "Issue Expert" },
                        {
                            "field_type": 7,
                            "help_text": "The parent of this project",
                            "name": "parent",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "parent"
                        },
                        { "field_type": null, "help_text": "JSON to store ratings for influencability, urgency, and importance", "name": "management_statistics", "verbose_name": "management statistics" },
                        { "field_type": 3, "help_text": "A short description of the project", "miscellaneous": 49, "name": "short_description", "patch": true, "sheet_column": true, "verbose_name": "Short Description" },
                        { "field_type": 2, "help_text": "The string of the icon related to this project.", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 1, "help_text": "", "name": "is_grassroots_issue", "verbose_name": "is grassroots issue" },
                        { "field_type": 4, "help_text": "", "name": "grassroots_order", "verbose_name": "grassroots order" },
                        { "field_type": 2, "help_text": "The slug that will appear in grassroots URL, if desired. If not, use the id.", "name": "grassroots_vanity_url_slug", "verbose_name": "grassroots vanity url slug" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignPageLayout" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "grassroots_page_layout_type",
                            "verbose_name": "grassroots page layout type"
                        },
                        { "field_type": 1, "help_text": "Whether this issue should be an option for tagging interactions to", "name": "can_be_tagged_to_interactions", "verbose_name": "can be tagged to interactions" },
                        { "field_type": 1, "help_text": "Whether this issue should be an option within custom events", "name": "can_be_tagged_to_events", "verbose_name": "can be tagged to events" },
                        { "field_type": 1, "help_text": "", "name": "is_issue", "verbose_name": "is issue" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Ids of the organizations that were added to the project",
                            "name": "organizations",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organizations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "User id of the project participants",
                            "name": "participants",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "participants"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Team id of associated teams",
                            "name": "teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "teams"
                        }
                    ],
                    "proxy_endpoint": "/api/project/"
                },
                "IssueManagement": {
                    "__is_model": true,
                    "__name__": "IssueManagement",
                    "data_model": "app.userdata.models.IssueManagement",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/issuemanagement/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": 1, "help_text": "Marks the object to be visible to users thatare on the partner organizations (organization.partners M2M)as well as the normal limited_to_teams users", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                        { "field_type": null, "help_text": "", "name": "search_terms", "verbose_name": "search terms" },
                        { "field_type": null, "help_text": "", "name": "categories", "verbose_name": "categories" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "project_type",
                            "verbose_name": "project type"
                        },
                        { "field_type": 4, "help_text": "", "name": "year", "verbose_name": "year" },
                        {
                            "field_type": 7,
                            "help_text": "This field stores the organization to which this Project belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "User id of the project creator",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "Whether this project appears in theproject_prioritization page or not", "name": "shown_in_table", "verbose_name": "shown in table" },
                        { "field_type": 1, "help_text": "Whether other users may edit project settings", "name": "creator_edit_only", "verbose_name": "creator edit only" },
                        { "field_type": 1, "help_text": "Whether or not to show carryover legislation", "name": "is_carryover", "verbose_name": "is carryover" },
                        { "field_type": 1, "help_text": "Whether a search terms list will show bills with a stance", "name": "remove_with_stance", "verbose_name": "remove with stance" },
                        { "field_type": 3, "help_text": "Name of the project", "name": "name", "verbose_name": "name" },
                        { "field_type": null, "help_text": "A cache of the teams currently on this project.", "name": "team_cache", "verbose_name": "team cache" },
                        { "field_type": 1, "help_text": "Whether or not this a default project", "name": "default", "verbose_name": "default" },
                        { "field_type": 1, "help_text": "", "name": "converted", "verbose_name": "converted" },
                        { "field_type": 2, "help_text": "", "name": "screenshot_url", "verbose_name": "screenshot url" },
                        { "field_type": 3, "help_text": "html text of the page", "name": "long_description", "verbose_name": "long description" },
                        { "field_type": 2, "help_text": "The region field", "name": "region_tag", "verbose_name": "Region Tag" },
                        { "field_type": 3, "help_text": "A field for regions related to the project.", "miscellaneous": 49, "name": "related_region", "sheet_column": true, "verbose_name": "Project Region" },
                        { "field_type": 4, "help_text": "Cost of the project", "miscellaneous": 49, "name": "cost", "patch": true, "sheet_column": true, "verbose_name": "Cost" },
                        { "field_type": 2, "help_text": "Due date for project", "miscellaneous": 49, "name": "due_date", "patch": true, "sheet_column": true, "verbose_name": "Due Date" },
                        { "field_type": 16, "help_text": "", "name": "deadline", "verbose_name": "Deadline" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectRating" },
                            "field_type": 4,
                            "help_text": "The project's priority score",
                            "miscellaneous": 49,
                            "name": "priority",
                            "patch": true,
                            "sheet_column": true,
                            "verbose_name": "Priority"
                        },
                        {
                            "field_type": 7,
                            "help_text": "default owner of the project",
                            "name": "owner",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "owner"
                        },
                        { "field_type": 2, "help_text": "The name of the person who is the most knowledgeable in this issue area.", "miscellaneous": 49, "name": "issue_expert", "patch": true, "sheet_column": true, "verbose_name": "Issue Expert" },
                        {
                            "field_type": 7,
                            "help_text": "The parent of this project",
                            "name": "parent",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "parent"
                        },
                        { "field_type": null, "help_text": "JSON to store ratings for influencability, urgency, and importance", "name": "management_statistics", "verbose_name": "management statistics" },
                        { "field_type": 3, "help_text": "A short description of the project", "miscellaneous": 49, "name": "short_description", "patch": true, "sheet_column": true, "verbose_name": "Short Description" },
                        { "field_type": 2, "help_text": "The string of the icon related to this project.", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 1, "help_text": "", "name": "is_grassroots_issue", "verbose_name": "is grassroots issue" },
                        { "field_type": 4, "help_text": "", "name": "grassroots_order", "verbose_name": "grassroots order" },
                        { "field_type": 2, "help_text": "The slug that will appear in grassroots URL, if desired. If not, use the id.", "name": "grassroots_vanity_url_slug", "verbose_name": "grassroots vanity url slug" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignPageLayout" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "grassroots_page_layout_type",
                            "verbose_name": "grassroots page layout type"
                        },
                        { "field_type": 1, "help_text": "Whether this issue should be an option for tagging interactions to", "name": "can_be_tagged_to_interactions", "verbose_name": "can be tagged to interactions" },
                        { "field_type": 1, "help_text": "Whether this issue should be an option within custom events", "name": "can_be_tagged_to_events", "verbose_name": "can be tagged to events" },
                        { "field_type": 1, "help_text": "", "name": "is_issue", "verbose_name": "is issue" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Ids of the organizations that were added to the project",
                            "name": "organizations",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organizations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "User id of the project participants",
                            "name": "participants",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "participants"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Team id of associated teams",
                            "name": "teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "teams"
                        }
                    ],
                    "proxy_endpoint": "/api/project/"
                },
                "LegislativePriority": {
                    "__is_model": true,
                    "__name__": "LegislativePriority",
                    "data_model": "app.userdata.models.LegislativePriority",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/legislativepriority/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "LegislativePriorityType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "priority",
                            "verbose_name": "priority"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Priorities can be on a subset of QuorumDataType",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "last_user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "last user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        { "field_type": 4, "help_text": "", "name": "article", "verbose_name": "article" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "supporter",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                            "verbose_name": "supporter"
                        }
                    ]
                },
                "LegislativeStance": {
                    "__is_model": true,
                    "__name__": "LegislativeStance",
                    "data_model": "app.userdata.models.LegislativeStance",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/legislativestance/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "regulation",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                            "verbose_name": "regulation"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "docket",
                            "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                            "verbose_name": "docket"
                        },
                        {
                            "field_type": 7,
                            "help_text": " which organization is taking this stance",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "StanceType" },
                            "field_type": 4,
                            "help_text": "The type of stance",
                            "name": "stance_type",
                            "verbose_name": "stance type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "Stances can be on a subset of QuorumDataType",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The last user to update this stance",
                            "name": "last_user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "last user"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "LegislativeStanceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "stance",
                            "verbose_name": "stance"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "document",
                            "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                            "verbose_name": "document"
                        },
                        { "field_type": 4, "help_text": "", "name": "article", "verbose_name": "article" }
                    ]
                },
                "LegislativeStanceCustomLabel": {
                    "__is_model": true,
                    "__name__": "LegislativeStanceCustomLabel",
                    "data_model": "app.userdata.models.LegislativeStanceCustomLabel",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/legislativestancecustomlabel/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 3, "help_text": "custom label used to describe this stance on the frontend", "name": "label", "verbose_name": "label" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "LegislativeStanceType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "stance",
                            "verbose_name": "stance"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Denormalized copy of the Organization also available on user.organization",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        }
                    ]
                },
                "LiteQuorumUser": {
                    "__is_model": true,
                    "__name__": "LiteQuorumUser",
                    "data_model": "app.userdata.models.LiteQuorumUser",
                    "default_exclude_filters": {},
                    "default_filters": { "default_for_user": true, "is_active": true, "users_on_teams": true },
                    "endpoint": "/api/liteuser/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 2, "help_text": "", "name": "password" },
                        { "field_type": 16, "help_text": "", "name": "last_login" },
                        { "field_type": 1, "name": "is_superuser" },
                        { "field_type": 2, "name": "username" },
                        { "field_type": 2, "help_text": "", "name": "first_name" },
                        { "field_type": 2, "help_text": "", "name": "last_name" },
                        { "field_type": 2, "help_text": "", "name": "email" },
                        { "field_type": 1, "name": "is_staff" },
                        { "field_type": 1, "name": "is_active" },
                        { "field_type": 16, "help_text": "", "name": "date_joined" },
                        {
                            "field_type": 8,
                            "name": "groups",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "Group" }
                        },
                        {
                            "field_type": 8,
                            "name": "user_permissions",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "Permission" }
                        }
                    ],
                    "proxy_endpoint": "/api/user/"
                },
                "NewList": {
                    "__is_model": true,
                    "__name__": "NewList",
                    "data_model": "app.userdata.models.NewList",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/newlist/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "Name given by the user of the list.", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "What qdt this new list stores a search for",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The SafedSearch representing the items in the list",
                            "name": "saved_search",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "saved search"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The user that created this list",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        { "field_type": 1, "help_text": "Whether users other than the list's creator can modify it", "name": "locked", "verbose_name": "locked" }
                    ]
                },
                "NonOutboxAttachment": {
                    "__is_model": true,
                    "__name__": "NonOutboxAttachment",
                    "data_model": "app.userdata.models.NonOutboxAttachment",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/nonoutboxattachment/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.custom_fts.types", "__name__": "FTSStripLevel" },
                            "field_type": 4,
                            "help_text": "The level of resolution reduction applied to this object'sFTS index so that it fits in the DB.",
                            "name": "fts_strip_level",
                            "verbose_name": "fts strip level"
                        },
                        { "field_type": 2, "help_text": "the file name of the attachment", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "AttachmentType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "type",
                            "verbose_name": "type"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The organization of the User that created this attachment",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 3, "help_text": "", "name": "short_description", "verbose_name": "short description" },
                        { "field_type": 1, "help_text": "Whether the upload was not an outbox attachment.", "name": "non_outbox_upload", "verbose_name": "non outbox upload" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "email",
                            "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                            "verbose_name": "email"
                        },
                        { "field_type": 1, "help_text": "Whether this attachment is publicly accessible. Files that are publicly accessible are uploaded to BUCKET_NAME.Files that are not publicly accessible are uploaded to multiple other buckets.Note that at the moment, this field cannot be toggled on and off because we have no logic that switches thefiles between buckets", "name": "is_public", "verbose_name": "is public" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "template",
                            "related_model": { "__module__": "app.userdata.outbox.models.email_template", "__name__": "EmailTemplate" },
                            "verbose_name": "template"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "project"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "note",
                            "related_model": { "__module__": "app.userdata.notes.models", "__name__": "Note" },
                            "verbose_name": "note"
                        },
                        { "field_type": 2, "help_text": "the MIME type of the attachment", "name": "mime_type", "verbose_name": "mime type" },
                        { "field_type": 3, "help_text": "the content of the attachment as a base64-encoded string", "name": "content", "verbose_name": "content" },
                        { "field_type": 4, "help_text": "the size of the file", "name": "size", "verbose_name": "size" },
                        { "field_type": 1, "help_text": "Whether this attachment has been added to the note's raw content for full-text search", "name": "added_to_fts", "verbose_name": "added to fts" },
                        { "field_type": 2, "help_text": "", "name": "raw_s3_url", "verbose_name": "raw s3 url" },
                        { "field_type": 2, "help_text": "", "name": "pdf_s3_url", "verbose_name": "pdf s3 url" },
                        { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                        { "field_type": 4, "help_text": "Number of words in this Attachment text, useful for fts vector heuristics", "name": "word_count", "verbose_name": "word count" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 7,
                            "help_text": "The Attachment that this attachment is a duplicate of. Used for linking ABTested BulkEmail attachments.",
                            "name": "duplicated_from",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                            "verbose_name": "duplicated from"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ],
                    "proxy_endpoint": "/api/attachment/"
                },
                "Organization": {
                    "__is_model": true,
                    "__name__": "Organization",
                    "data_model": "app.userdata.models.Organization",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/organization/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "", "name": "qp_federal", "verbose_name": "qp federal" },
                        { "field_type": 1, "help_text": "", "name": "qp_eu", "verbose_name": "qp eu" },
                        { "field_type": null, "help_text": "Array of International Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_international", "verbose_name": "qp international" },
                        { "field_type": null, "help_text": "Array of Grassroots Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_grassroots", "verbose_name": "qp grassroots" },
                        { "field_type": null, "help_text": "Array of States Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_states", "verbose_name": "qp states" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_local", "verbose_name": "qp local" },
                        { "field_type": null, "help_text": "Array of School Board Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_school_boards", "verbose_name": "qp school boards" },
                        { "field_type": 1, "help_text": "", "name": "qp_stakeholder", "verbose_name": "qp stakeholder" },
                        { "field_type": 1, "help_text": "", "name": "qp_campaign_finance", "verbose_name": "qp campaign finance" },
                        { "field_type": 1, "help_text": "This field states whether or not the permissions are 'factory' settings based on billed products.", "name": "qp_custom_permissions", "verbose_name": "qp custom permissions" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_legislators", "verbose_name": "qp legislators" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_executives", "verbose_name": "qp executives" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_staffers", "verbose_name": "qp staffers" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_legislative_data", "verbose_name": "qp legislative data" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_legislative_profiles", "verbose_name": "qp legislative profiles" },
                        { "field_type": null, "help_text": "Array of Local Products which the user has. These are stored by their key in Enums for ease of use.", "name": "qp_official_documents", "verbose_name": "qp official documents" },
                        { "field_type": null, "help_text": "Array of regions in which a user has access to regulations", "name": "qp_regulations", "verbose_name": "qp regulations" },
                        { "field_type": null, "help_text": "Array of region sets that decide what articles a Media Monitoring user can see.", "name": "qp_media_monitoring", "verbose_name": "qp media monitoring" },
                        { "field_type": null, "help_text": "Array of region sets that decide what press contacts a Media Relations user should see", "name": "qp_media_relations", "verbose_name": "qp media relations" },
                        { "field_type": 1, "help_text": "", "name": "qp_custom_data", "verbose_name": "qp custom data" },
                        { "field_type": 1, "help_text": "", "name": "qp_external_relationship", "verbose_name": "qp external relationship" },
                        { "field_type": 1, "help_text": "", "name": "qp_external_interactions", "verbose_name": "qp external interactions" },
                        { "field_type": 1, "help_text": "", "name": "qp_internal_relationship", "verbose_name": "qp internal relationship" },
                        { "field_type": 1, "help_text": "", "name": "qp_action_center", "verbose_name": "qp action center" },
                        { "field_type": 1, "help_text": "", "name": "qp_action_center_campaigns", "verbose_name": "qp action center campaigns" },
                        { "field_type": 1, "help_text": "", "name": "qp_officials_outbox", "verbose_name": "qp officials outbox" },
                        { "field_type": 1, "help_text": "", "name": "qp_legislation_page", "verbose_name": "qp legislation page" },
                        { "field_type": 1, "help_text": "", "name": "qp_custom_contacts", "verbose_name": "qp custom contacts" },
                        { "field_type": 1, "help_text": "", "name": "qp_custom_outbox", "verbose_name": "qp custom outbox" },
                        { "field_type": 1, "help_text": "", "name": "qp_custom_events", "verbose_name": "qp custom events" },
                        { "field_type": 1, "help_text": "", "name": "qp_contacts_documents", "verbose_name": "qp contacts documents" },
                        { "field_type": 1, "help_text": "", "name": "qp_project_management", "verbose_name": "qp project management" },
                        { "field_type": 1, "help_text": "", "name": "qp_unique_ids_in_downloads", "verbose_name": "qp unique ids in downloads" },
                        { "field_type": 1, "help_text": "", "name": "qp_consultants", "verbose_name": "qp consultants" },
                        { "field_type": 1, "help_text": "", "name": "qp_live_chat", "verbose_name": "qp live chat" },
                        { "field_type": 1, "help_text": "", "name": "qp_local_agendas", "verbose_name": "qp local agendas" },
                        { "field_type": 1, "help_text": "", "name": "qp_qpac_v1", "verbose_name": "qp qpac v1" },
                        { "field_type": 1, "help_text": "", "name": "qp_pac_state_and_local_committees", "verbose_name": "qp pac state and local committees" },
                        { "field_type": 1, "help_text": "", "name": "qp_pac_match", "verbose_name": "qp pac match" },
                        { "field_type": 1, "help_text": "", "name": "qp_pac_sync_supporter_from_pacc", "verbose_name": "qp pac sync supporter from pacc" },
                        { "field_type": 1, "help_text": "", "name": "qp_pac_hybrid", "verbose_name": "qp pac hybrid" },
                        { "field_type": 1, "help_text": "", "name": "qp_custom_docket", "verbose_name": "qp custom docket" },
                        { "field_type": 1, "help_text": "", "name": "qp_copilot_analyze", "verbose_name": "qp copilot analyze" },
                        { "field_type": 1, "help_text": "", "name": "qp_ai_summaries", "verbose_name": "qp ai summaries" },
                        { "field_type": 1, "help_text": "", "name": "qp_ai_outbox_suggestions", "verbose_name": "qp ai outbox suggestions" },
                        { "field_type": 1, "help_text": "", "name": "qp_ai_grassroots_messages", "verbose_name": "qp ai grassroots messages" },
                        { "field_type": 1, "help_text": "", "name": "qp_ai_tracking_boards", "verbose_name": "qp ai tracking boards" },
                        { "field_type": 1, "help_text": "", "name": "qp_copilot_grassroots", "verbose_name": "qp copilot grassroots" },
                        { "field_type": 1, "help_text": "", "name": "qp_copilot_pac", "verbose_name": "qp copilot pac" },
                        { "field_type": 1, "help_text": "", "name": "qp_hide_stance", "verbose_name": "qp hide stance" },
                        { "field_type": 1, "help_text": "", "name": "qp_hide_priority", "verbose_name": "qp hide priority" },
                        { "field_type": 1, "help_text": "", "name": "qp_hide_alignment", "verbose_name": "qp hide alignment" },
                        { "field_type": 1, "help_text": "", "name": "qp_hide_assignment", "verbose_name": "qp hide assignment" },
                        { "field_type": 1, "help_text": "", "name": "qp_hide_review_status", "verbose_name": "qp hide review status" },
                        { "field_type": 1, "help_text": "", "name": "qp_collaborators", "verbose_name": "qp collaborators" },
                        { "field_type": 4, "help_text": "", "name": "max_csv_size", "verbose_name": "max csv size" },
                        { "field_type": 2, "help_text": "the organization's default domain", "name": "default_domain", "verbose_name": "default domain" },
                        { "field_type": null, "help_text": "the key <domain> : value <whether it should route>", "name": "outbox_domain_dict", "verbose_name": "outbox domain dict" },
                        { "field_type": null, "help_text": "Whitelist of email domains that new users should match against", "name": "allowed_user_domains", "verbose_name": "allowed user domains" },
                        { "field_type": 1, "help_text": "Whether users in the organization should only be able to see users they share teams with", "name": "should_show_only_users_on_teams", "verbose_name": "should show only users on teams" },
                        { "field_type": 1, "help_text": "Whether new notes are is_visible_to_partners by default", "name": "should_share_with_partners_by_default", "verbose_name": "should share with partners by default" },
                        { "field_type": 2, "help_text": "The name of the organization", "name": "name", "verbose_name": "name" },
                        { "field_type": 4, "help_text": "", "name": "max_members", "verbose_name": "max members" },
                        { "field_type": 4, "help_text": "", "name": "max_contacts", "verbose_name": "max contacts" },
                        { "field_type": 4, "help_text": "", "name": "max_email_alerts", "verbose_name": "max email alerts" },
                        { "field_type": 4, "help_text": "", "name": "max_projects", "verbose_name": "max projects" },
                        { "field_type": 4, "help_text": "", "name": "max_social_accounts", "verbose_name": "max social accounts" },
                        { "field_type": 2, "help_text": "The subdomain for logging external interactions.", "name": "subdomain", "verbose_name": "subdomain" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "AccountType" },
                            "field_type": 4,
                            "help_text": "Type of account",
                            "name": "account_type",
                            "verbose_name": "account type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "OnboardingType" },
                            "field_type": 4,
                            "help_text": "Type of onboarding",
                            "name": "onboarding_type",
                            "verbose_name": "onboarding type"
                        },
                        { "field_type": 5, "help_text": "", "name": "trial_expiration", "verbose_name": "trial expiration" },
                        { "field_type": 4, "help_text": "this is the total number of emails that can be sent per the last 30 days (last month)", "name": "email_limit", "verbose_name": "email limit" },
                        { "field_type": null, "help_text": "allowed domains to sign in", "name": "allowed_domains", "verbose_name": "allowed domains" },
                        { "field_type": null, "help_text": "Regex of IP addresses of the org", "name": "ip_addresses", "verbose_name": "ip addresses" },
                        { "field_type": 1, "help_text": "Whether this organization is allowed to use our non-shared sending domain no matter the size of the send.", "name": "is_approved", "verbose_name": "is approved" },
                        { "field_type": 1, "help_text": "Whether this organization is allowed to use independent campaigns in grassroots.", "name": "can_use_independent_campaigns", "verbose_name": "can use independent campaigns" },
                        { "field_type": 6, "help_text": "", "name": "lower_tier_bound", "verbose_name": "lower tier bound" },
                        { "field_type": 6, "help_text": "", "name": "upper_tier_bound", "verbose_name": "upper tier bound" },
                        {
                            "field_type": 7,
                            "help_text": "person who receives any emails without a proper recipient",
                            "name": "default_forward_recipient",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "default forward recipient"
                        },
                        { "field_type": 1, "help_text": "", "name": "deliver_supporter_messages", "verbose_name": "deliver supporter messages" },
                        { "field_type": 1, "help_text": "Whether or not this organization is an active client (i.e. events should be included in client analytics). NOTE: Organizations can still be active in Quorum with this flag set to false! If you need to test whether an org is truly active, use the archived flag.", "name": "active_client", "verbose_name": "active client" },
                        { "field_type": 1, "help_text": "Whether or not we want to pad the supporters' unique IDs with leading 0s for CSV conversion", "name": "pad_unique_identifier", "verbose_name": "pad unique identifier" },
                        { "field_type": 1, "help_text": "Whether or not all users within the organization should see every custom region created by every user in the organization.", "name": "share_all_custom_regions", "verbose_name": "share all custom regions" },
                        { "field_type": 1, "help_text": "Whether or not all supporters added to the system should be passed through the FullContact/Covve enrichment system", "name": "auto_enrich_supporters", "verbose_name": "auto enrich supporters" },
                        { "field_type": 1, "help_text": "Whether this organization is part of i360 and therefore should not show the Action Center tab nor have an action center anywhere.", "name": "i360_organization", "verbose_name": "i360 organization" },
                        { "field_type": 1, "help_text": "If this organization is a Quorum client as well as an i360 client, we should show them in the management pages etc. This flag should only be true if i360_organization is true.", "name": "i360_organization_and_quorum_client", "verbose_name": "i360 organization and quorum client" },
                        { "field_type": null, "help_text": "Setting this field with an array of interaction types overrides the selector for the interaction types internal to the system.", "name": "internal_interaction_types", "verbose_name": "internal interaction types" },
                        { "field_type": null, "help_text": "Setting this field with an array of relationship types overrides the selector for the relationship types internal to the system.", "name": "internal_relationship_types", "verbose_name": "internal relationship types" },
                        { "field_type": 1, "help_text": "If this flag is set to true, only the CS managers for that organizations & any superusers (CSSes, engineers, etc.) will able allowedto log into the accounts of the users of this organization. This will also block those users from editing this organization.", "name": "limit_to_cs_managers", "verbose_name": "limit to cs managers" },
                        { "field_type": 1, "help_text": "If enabled, all users in organization will be using SSO. If disabled, users will only use SSO if `single_login` flag on user info is True", "name": "sso_enabled_for_all_users", "verbose_name": "sso enabled for all users" },
                        { "field_type": 1, "help_text": "If enabled, users on this org can see users from this orgs partners", "name": "can_see_partners_users", "verbose_name": "can see partners users" },
                        { "field_type": 5, "help_text": "The date this organization was archived.", "name": "date_archived", "verbose_name": "date archived" },
                        { "field_type": 2, "help_text": "", "name": "plivo_auth_id", "verbose_name": "plivo auth id" },
                        { "field_type": 2, "help_text": "", "name": "plivo_auth_token", "verbose_name": "plivo auth token" },
                        { "field_type": 3, "help_text": "The authentication token plivo needs to send a webhook response", "name": "plivo_webhook_token", "verbose_name": "plivo webhook token" },
                        { "field_type": null, "help_text": "Maps a QDT to a string to use in order_by when sorting feed items for alerts.", "name": "custom_alert_orderings", "verbose_name": "custom alert orderings" },
                        {
                            "field_type": 7,
                            "help_text": "User on this org that is used for user fks on objects created/logic used by integrations like Salesforce",
                            "name": "integration_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "integration user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "User on this org that opted into texting for this organization",
                            "name": "agreed_to_texting_user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "agreed to texting user"
                        },
                        { "field_type": 21, "help_text": "The datetime this organization agreed to the texting terms and conditions.", "name": "datetime_agreed_to_texting", "verbose_name": "datetime agreed to texting" },
                        { "field_type": 3, "help_text": "The token that Zapier uses to authenticate our users Apps", "name": "zapier_token", "verbose_name": "zapier token" },
                        { "field_type": 4, "help_text": "this is the number of sent emails as a percentage of the email limit for the last 30 days (last month)", "name": "email_limit_percentage", "verbose_name": "email limit percentage" },
                        { "field_type": null, "help_text": "Array of fields for oob Custom Event Form, Profile, etc.", "name": "custom_event_json", "verbose_name": "custom event json" },
                        { "field_type": 4, "help_text": "total number of SMS messages that can be sent in a (calendar) month", "name": "sms_limit", "verbose_name": "sms limit" },
                        { "field_type": 4, "help_text": "The number of SMS messages used toward the organization SMS limit over a rolling 30 days", "name": "sms_messages_toward_limit", "verbose_name": "sms messages toward limit" },
                        { "field_type": 4, "help_text": "The number of additional credits the organization has purchased", "name": "sms_additional_credits", "verbose_name": "sms additional credits" },
                        { "field_type": 4, "help_text": "The number of additional credits the organization has already used", "name": "sms_additional_credits_usage", "verbose_name": "sms additional credits usage" },
                        { "field_type": 5, "help_text": "The date the SMS credits will renew", "name": "sms_renew_date", "verbose_name": "sms renew date" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "CreditsAutoRenewType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "sms_renew_type",
                            "verbose_name": "sms renew type"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "CreditsRenewCycle" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "sms_renew_cycle",
                            "verbose_name": "sms renew cycle"
                        },
                        { "field_type": 1, "help_text": "If GrassrootsSupporterActions of interaction type 'Registered on Registration Form' should be displayed in search", "name": "should_display_grassroots_registration_actions", "verbose_name": "should display grassroots registration actions" },
                        { "field_type": 1, "help_text": "If enabled, users that are organization administrators of this organization can see all organization data.", "name": "should_org_admin_see_all_org_data", "verbose_name": "should org admin see all org data" },
                        { "field_type": 1, "help_text": "If true, users of this org can only edit notes if they created them or are an admin.", "name": "should_limit_editing_notes_to_admins_and_creators", "verbose_name": "should limit editing notes to admins and creators" },
                        { "field_type": 4, "help_text": "Override the TTL (in seconds) of the Session Cookie for members of this Organization.", "name": "custom_session_timeout", "verbose_name": "custom session timeout" },
                        { "field_type": 1, "help_text": "If the interaction logger forms should require adding an issue in order to be submitted", "name": "require_issue_on_interaction", "verbose_name": "require issue on interaction" },
                        { "field_type": 1, "help_text": "If users will be required to attach an issue to each newly created outbox email.", "name": "require_issue_on_outbox", "verbose_name": "require issue on outbox" },
                        { "field_type": 4, "help_text": "The CompanyID (PK) from PACC, if this client record was imported", "name": "pacc_companyid", "verbose_name": "PACC CompanyID" },
                        { "field_type": 3, "help_text": "The Company Login Name from PACC, for hybrid PAC organizations", "name": "pacc_companyloginname", "verbose_name": "PACC Company Login Name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.pac_classic.types", "__name__": "PacClassicSourceSchema" },
                            "field_type": 2,
                            "help_text": "The source PACC database/Quorum schema of the PACC Company",
                            "name": "pacc_source_schema",
                            "verbose_name": "PACC Source Schema"
                        },
                        { "field_type": 1, "help_text": "If enabled, for PAC 2.0 create new Quorum Supporters for any Individuals that do not have an existing Supporter linked.", "name": "pac_hybrid_autocreate_supporters_from_individuals", "verbose_name": "Auto-create Supporters from Individuals" },
                        { "field_type": null, "help_text": "Array of fields for Log Interaction Form.", "name": "log_interaction_json", "verbose_name": "log interaction json" },
                        { "field_type": null, "help_text": "Dictionary with persona enum as key and dashboard id as value. This is the reference to persona dashboard for an org.", "name": "persona_dashboards", "verbose_name": "persona dashboards" },
                        { "field_type": 3, "help_text": "The organization's custom unsubscribe link text", "name": "unsubscribe_link_text", "verbose_name": "unsubscribe link text" },
                        {
                            "field_type": 7,
                            "help_text": "The default Grassroots Persona Dashboard for this Organization",
                            "name": "ngg_home_dashboard",
                            "related_model": { "__module__": "app.widgets.models", "__name__": "Dashboard" },
                            "verbose_name": "ngg home dashboard"
                        },
                        { "field_type": null, "help_text": "An array of P2A organization IDs, if this client has a P2A Account(s)", "name": "p2a_organization_ids", "verbose_name": "p2a organization ids" },
                        { "field_type": 1, "help_text": "If enabled, organization admins can log in as any non-admin user in the organization", "name": "admin_can_log_in_as_user", "verbose_name": "admin can log in as user" },
                        { "field_type": 1, "help_text": "If enabled, organization admins can create custom officials", "name": "admin_can_create_custom_official", "verbose_name": "admin can create custom official" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "UnsubscribeSettings" },
                            "field_type": 4,
                            "help_text": "Default unsubscribe setting for each new outbox email",
                            "name": "default_unsubscribe_setting",
                            "verbose_name": "default unsubscribe setting"
                        },
                        { "field_type": 1, "help_text": "If enabled, the automatic login to Action Center link will be disabled in all outgoing emails and texting messages.", "name": "disable_action_center_magic_link", "verbose_name": "disable action center magic link" },
                        {
                            "field_type": 8,
                            "help_text": "Organizations that Quorum has been instructed to pair your organization with",
                            "name": "partners",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "partners"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Organizations that share everything that partners do but are effectively shared on the default project.",
                            "name": "superpartners",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "superpartners"
                        },
                        {
                            "field_type": 8,
                            "help_text": "User Ids of the Customer Success Managers covering the organization",
                            "name": "cs_managers",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "cs managers"
                        }
                    ]
                },
                "OrganizationDesign": {
                    "__is_model": true,
                    "__name__": "OrganizationDesign",
                    "data_model": "app.userdata.models.OrganizationDesign",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/organizationdesign/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this design is connected to.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 1, "help_text": "Stores whether this design is the default for this particular organization.", "name": "default", "verbose_name": "default" },
                        { "field_type": 1, "help_text": "Stores whether a given design object should be used for grassroots. Only one should be true -- the first will be used.", "name": "for_grassroots", "verbose_name": "for grassroots" },
                        { "field_type": 1, "help_text": "Stores whether a given design object should be used for the pdf page. Only one should be true -- the first will be used.", "name": "for_pdfs", "verbose_name": "for pdfs" },
                        { "field_type": 2, "help_text": "", "name": "design_name", "verbose_name": "design name" },
                        { "field_type": 2, "help_text": "The full-color logo of this organization.", "name": "normal_logo", "verbose_name": "normal logo" },
                        { "field_type": 2, "help_text": "The full-color logo of this organization.", "name": "white_logo", "verbose_name": "white logo" },
                        { "field_type": 2, "help_text": "", "name": "background_image", "verbose_name": "background image" },
                        { "field_type": 2, "help_text": "", "name": "fav_icon", "verbose_name": "fav icon" },
                        { "field_type": 2, "help_text": "The base color -- top bar, stat boxes, etc.", "name": "primary_color", "verbose_name": "primary color" },
                        { "field_type": 2, "help_text": "A lighter version of the primary color.", "name": "lighter_primary", "verbose_name": "lighter primary" },
                        { "field_type": 2, "help_text": "A darker version of the primary color.", "name": "darker_primary", "verbose_name": "darker primary" },
                        { "field_type": 2, "help_text": "The secondary color.", "name": "secondary_color", "verbose_name": "secondary color" },
                        { "field_type": 2, "help_text": "The background color.", "name": "background_color", "verbose_name": "background color" },
                        { "field_type": 2, "help_text": "Light grey -- backgrounds etc.", "name": "light_grey", "verbose_name": "light grey" },
                        { "field_type": 2, "help_text": "Dark grey.", "name": "dark_grey", "verbose_name": "dark grey" },
                        { "field_type": 2, "help_text": "Dark grey.", "name": "darker_grey", "verbose_name": "darker grey" },
                        { "field_type": 2, "help_text": "Darkest grey for body text etc.", "name": "black", "verbose_name": "black" },
                        { "field_type": 1, "help_text": "Specify if organization prefers using a solid color for the action center header (replacing background image)", "name": "should_use_action_center_header_color", "verbose_name": "should use action center header color" },
                        { "field_type": 2, "help_text": "Color for the action center header (replacing the background image)", "name": "action_center_header_color", "verbose_name": "action center header color" },
                        { "field_type": 2, "help_text": "The CSS font-face name for the desired font. Most will be Quorum's default.", "name": "font_family", "verbose_name": "font family" },
                        { "field_type": 2, "help_text": "The full link of the font.", "name": "font_link", "verbose_name": "font link" },
                        { "field_type": 2, "help_text": "", "name": "stylesheet_path", "verbose_name": "stylesheet path" },
                        { "field_type": 2, "help_text": "", "name": "pdf_stylesheet_path", "verbose_name": "pdf stylesheet path" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "Persona": {
                    "__is_enum": true,
                    "communications": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["all"],
                        "default": false,
                        "default_search_data_type": 105,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "microphone",
                        "icon_family": "fad",
                        "key": "communications",
                        "label": "Communications",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 8,
                        "permission_enum": 105,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [120, 42, 105, 20, 45, 12],
                        "short_label": "Comms",
                        "sidebar_settings_list": [21, 1, 17, 2, 21, 12, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 9,
                        "vote_default_search_filters": []
                    },
                    "default": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["all"],
                        "default": true,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "key": "default",
                        "label": "Default",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 0,
                        "permission_enum": 0,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [2, 25, 1, 8, 12, 20, 69, 28, 3, 4, 80, 15, 16, 62, 42, 107, 114, 119, 123, 134, 135, 138, 140, 141, 74, 45, 88, 105, 126, 125, 120],
                        "short_label": "Default",
                        "sidebar_settings_list": [17, 19, 1, 21, 12, 2, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 1,
                        "vote_default_search_filters": []
                    },
                    "eu": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["eu"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "eu-stars",
                        "icon_family": "q",
                        "key": "eu",
                        "label": "European Union",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 7,
                        "permission_enum": 2,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [25, 1, 42, 12, 20],
                        "short_label": "European Union",
                        "sidebar_settings_list": [17, 19, 1, 2, 21, 12, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 5,
                        "vote_default_search_filters": []
                    },
                    "federal": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["us"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "landmark",
                        "icon_family": "fad",
                        "key": "federal",
                        "label": "Federal",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 1,
                        "permission_enum": 1,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [2, 25, 1, 8, 20, 15],
                        "short_label": "Federal",
                        "sidebar_settings_list": [17, 1, 21, 12, 2, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 2,
                        "vote_default_search_filters": []
                    },
                    "grassroots": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["all"],
                        "default": false,
                        "default_search_data_type": 12,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "bullhorn",
                        "icon_family": "fad",
                        "key": "grassroots",
                        "label": "Grassroots",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 3,
                        "permission_enum": 102,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [12, 1, 8, 69, 42],
                        "short_label": "Grassroots",
                        "sidebar_settings_list": [11, 21, 12, 10, 1, 17],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 6,
                        "vote_default_search_filters": []
                    },
                    "international": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["international"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "map",
                        "icon_family": "fad",
                        "key": "international",
                        "label": "International",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 6,
                        "permission_enum": 103,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [25, 1, 8, 20, 42, 62, 28, 45],
                        "short_label": "International",
                        "sidebar_settings_list": [17, 1, 2, 21, 12, 10, 18],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 8,
                        "vote_default_search_filters": []
                    },
                    "local": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["local"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "building",
                        "icon_family": "fad",
                        "key": "local",
                        "label": "Local",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 5,
                        "permission_enum": 101,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [25, 1, 8, 12, 20],
                        "short_label": "Local",
                        "sidebar_settings_list": [17, 1, 2, 21, 12, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 4,
                        "vote_default_search_filters": []
                    },
                    "pac": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["us"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "landmark",
                        "icon_family": "fad",
                        "key": "pac",
                        "label": "PAC",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 9,
                        "permission_enum": 218,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [2, 114, 25, 20, 1, 8],
                        "short_label": "PAC",
                        "sidebar_settings_list": [1, 22, 17, 20, 10, 21, 12],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 10,
                        "vote_default_search_filters": []
                    },
                    "school_boards": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["local"],
                        "default": false,
                        "default_search_data_type": 1,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "building",
                        "icon_family": "fad",
                        "key": "school_boards",
                        "label": "School Boards",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 10,
                        "permission_enum": 107,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [25, 1, 8, 12, 20],
                        "short_label": "SBs",
                        "sidebar_settings_list": [17, 1, 2, 21, 12, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 11,
                        "vote_default_search_filters": []
                    },
                    "stakeholder": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["all"],
                        "default": false,
                        "default_search_data_type": 12,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [
                            { "source_type__in": 16 }
                        ],
                        "icon": "handshake",
                        "icon_family": "fad",
                        "key": "stakeholder",
                        "label": "Stakeholder Engagement",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 4,
                        "permission_enum": 3,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [
                            { "organization_type__in": 1 }
                        ],
                        "search_data_type_order": [20, 12, 42, 25, 28],
                        "short_label": "Stakeholder",
                        "sidebar_settings_list": [17, 1, 21, 12, 10, 16],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 7,
                        "vote_default_search_filters": []
                    },
                    "states": {
                        "alert_default_search_filters": [
                            { "current_user": false }
                        ],
                        "amendment_default_search_filters": [],
                        "article_default_search_filters": [
                            { "language": 1 }
                        ],
                        "attachment_default_search_filters": [],
                        "bill_default_search_filters": [],
                        "current_regions": ["states"],
                        "default": false,
                        "default_search_data_type": 2,
                        "document_default_search_filters": [],
                        "event_default_search_filters": [],
                        "icon": "compass",
                        "icon_family": "fad",
                        "key": "states",
                        "label": "States",
                        "legislator_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "note_default_search_filters": [],
                        "order": 2,
                        "permission_enum": 100,
                        "person_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "press_contact_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "public_organization_default_search_filters": [],
                        "search_data_type_order": [2, 25, 1, 8, 12, 20],
                        "short_label": "State",
                        "sidebar_settings_list": [17, 19, 1, 2, 21, 12, 10, 20],
                        "staffer_default_search_filters": [
                            { "ph_current": true }
                        ],
                        "supporter_default_search_filters": [],
                        "value": 3,
                        "vote_default_search_filters": []
                    }
                },
                "Project": {
                    "__is_model": true,
                    "__name__": "Project",
                    "data_model": "app.userdata.models.Project",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/project/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": 1, "help_text": "Marks the object to be visible to users thatare on the partner organizations (organization.partners M2M)as well as the normal limited_to_teams users", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                        { "field_type": null, "help_text": "", "name": "search_terms", "verbose_name": "search terms" },
                        { "field_type": null, "help_text": "", "name": "categories", "verbose_name": "categories" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "project_type",
                            "verbose_name": "project type"
                        },
                        { "field_type": 4, "help_text": "", "name": "year", "verbose_name": "year" },
                        {
                            "field_type": 7,
                            "help_text": "This field stores the organization to which this Project belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "User id of the project creator",
                            "name": "creator",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "creator"
                        },
                        { "field_type": 1, "help_text": "Whether this project appears in theproject_prioritization page or not", "name": "shown_in_table", "verbose_name": "shown in table" },
                        { "field_type": 1, "help_text": "Whether other users may edit project settings", "name": "creator_edit_only", "verbose_name": "creator edit only" },
                        { "field_type": 1, "help_text": "Whether or not to show carryover legislation", "name": "is_carryover", "verbose_name": "is carryover" },
                        { "field_type": 1, "help_text": "Whether a search terms list will show bills with a stance", "name": "remove_with_stance", "verbose_name": "remove with stance" },
                        { "field_type": 3, "help_text": "Name of the project", "name": "name", "verbose_name": "name" },
                        { "field_type": null, "help_text": "A cache of the teams currently on this project.", "name": "team_cache", "verbose_name": "team cache" },
                        { "field_type": 1, "help_text": "Whether or not this a default project", "name": "default", "verbose_name": "default" },
                        { "field_type": 1, "help_text": "", "name": "converted", "verbose_name": "converted" },
                        { "field_type": 2, "help_text": "", "name": "screenshot_url", "verbose_name": "screenshot url" },
                        { "field_type": 3, "help_text": "html text of the page", "name": "long_description", "verbose_name": "long description" },
                        { "field_type": 2, "help_text": "The region field", "name": "region_tag", "verbose_name": "Region Tag" },
                        { "field_type": 3, "help_text": "A field for regions related to the project.", "miscellaneous": 49, "name": "related_region", "sheet_column": true, "verbose_name": "Project Region" },
                        { "field_type": 4, "help_text": "Cost of the project", "miscellaneous": 49, "name": "cost", "patch": true, "sheet_column": true, "verbose_name": "Cost" },
                        { "field_type": 2, "help_text": "Due date for project", "miscellaneous": 49, "name": "due_date", "patch": true, "sheet_column": true, "verbose_name": "Due Date" },
                        { "field_type": 16, "help_text": "", "name": "deadline", "verbose_name": "Deadline" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "ProjectRating" },
                            "field_type": 4,
                            "help_text": "The project's priority score",
                            "miscellaneous": 49,
                            "name": "priority",
                            "patch": true,
                            "sheet_column": true,
                            "verbose_name": "Priority"
                        },
                        {
                            "field_type": 7,
                            "help_text": "default owner of the project",
                            "name": "owner",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "owner"
                        },
                        { "field_type": 2, "help_text": "The name of the person who is the most knowledgeable in this issue area.", "miscellaneous": 49, "name": "issue_expert", "patch": true, "sheet_column": true, "verbose_name": "Issue Expert" },
                        {
                            "field_type": 7,
                            "help_text": "The parent of this project",
                            "name": "parent",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "parent"
                        },
                        { "field_type": null, "help_text": "JSON to store ratings for influencability, urgency, and importance", "name": "management_statistics", "verbose_name": "management statistics" },
                        { "field_type": 3, "help_text": "A short description of the project", "miscellaneous": 49, "name": "short_description", "patch": true, "sheet_column": true, "verbose_name": "Short Description" },
                        { "field_type": 2, "help_text": "The string of the icon related to this project.", "name": "icon", "verbose_name": "icon" },
                        { "field_type": 2, "help_text": "Cached path of image url", "name": "image_url", "verbose_name": "image url" },
                        { "field_type": 1, "help_text": "", "name": "is_grassroots_issue", "verbose_name": "is grassroots issue" },
                        { "field_type": 4, "help_text": "", "name": "grassroots_order", "verbose_name": "grassroots order" },
                        { "field_type": 2, "help_text": "The slug that will appear in grassroots URL, if desired. If not, use the id.", "name": "grassroots_vanity_url_slug", "verbose_name": "grassroots vanity url slug" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.grassroots.campaign.types", "__name__": "CampaignPageLayout" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "grassroots_page_layout_type",
                            "verbose_name": "grassroots page layout type"
                        },
                        { "field_type": 1, "help_text": "Whether this issue should be an option for tagging interactions to", "name": "can_be_tagged_to_interactions", "verbose_name": "can be tagged to interactions" },
                        { "field_type": 1, "help_text": "Whether this issue should be an option within custom events", "name": "can_be_tagged_to_events", "verbose_name": "can be tagged to events" },
                        { "field_type": 1, "help_text": "", "name": "is_issue", "verbose_name": "is issue" },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Ids of the organizations that were added to the project",
                            "name": "organizations",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organizations"
                        },
                        {
                            "field_type": 8,
                            "help_text": "User id of the project participants",
                            "name": "participants",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "participants"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Team id of associated teams",
                            "name": "teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "teams"
                        }
                    ]
                },
                "QuorumUser": {
                    "__is_model": true,
                    "__name__": "QuorumUser",
                    "data_model": "app.userdata.models.QuorumUser",
                    "default_exclude_filters": {},
                    "default_filters": { "default_for_user": true, "is_active": true, "users_on_teams": true },
                    "endpoint": "/api/user/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 2, "help_text": "", "name": "password" },
                        { "field_type": 16, "help_text": "", "name": "last_login" },
                        { "field_type": 1, "name": "is_superuser" },
                        { "field_type": 2, "name": "username" },
                        { "field_type": 2, "help_text": "", "name": "first_name" },
                        { "field_type": 2, "help_text": "", "name": "last_name" },
                        { "field_type": 2, "help_text": "", "name": "email" },
                        { "field_type": 1, "name": "is_staff" },
                        { "field_type": 1, "name": "is_active" },
                        { "field_type": 16, "help_text": "", "name": "date_joined" },
                        {
                            "field_type": 8,
                            "name": "groups",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "Group" }
                        },
                        {
                            "field_type": 8,
                            "name": "user_permissions",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "Permission" }
                        }
                    ]
                },
                "ReleaseNote": {
                    "__is_model": true,
                    "__name__": "ReleaseNote",
                    "data_model": "app.userdata.models.ReleaseNote",
                    "default_exclude_filters": {},
                    "default_filters": { "is_published": true },
                    "endpoint": "/api/releasenote/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                        { "field_type": 1, "help_text": "", "name": "is_published", "verbose_name": "is published" },
                        { "field_type": 2, "help_text": "", "name": "release_number", "verbose_name": "release number" },
                        { "field_type": 3, "help_text": "Release notes go here", "name": "content", "verbose_name": "content" },
                        { "field_type": null, "help_text": "Which personas is this update relevant to?", "name": "personas", "verbose_name": "personas" }
                    ]
                },
                "SafedSearch": {
                    "__is_model": true,
                    "__name__": "SafedSearch",
                    "data_model": "app.userdata.models.SafedSearch",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/search/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 2, "help_text": "", "name": "reference_hash", "verbose_name": "reference hash" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "data_type",
                            "verbose_name": "data type"
                        },
                        { "field_type": 1, "help_text": "Should the user see this saved search", "name": "display", "verbose_name": "display" },
                        { "field_type": null, "help_text": "An array of dictionaries that store a representation of a collection of results", "name": "filters", "verbose_name": "filters" },
                        { "field_type": null, "help_text": "", "name": "added_ids", "verbose_name": "added ids" },
                        { "field_type": null, "help_text": "", "name": "deleted_ids", "verbose_name": "deleted ids" },
                        { "field_type": null, "help_text": "If a saved search is created with a set of always_forced_regions, it will always return the resultsfor those regions no matter what.", "name": "always_forced_regions", "verbose_name": "always forced regions" },
                        { "field_type": null, "help_text": "If a saved search is created with a set of created_regions, never return more regions than specifiedby this field", "name": "created_regions", "verbose_name": "created regions" },
                        { "field_type": null, "help_text": "Metadata about this safed search. Includes average calculation times and possibly more information like average size or evaluation frequency.", "name": "metadata", "verbose_name": "metadata" },
                        { "field_type": null, "help_text": "A collection of all ids in this safed_search, to be used and calculated only by the lfr system", "name": "lists_for_resource_id_cache", "verbose_name": "lists for resource id cache" },
                        { "field_type": 21, "help_text": "The last time lists_for_resource_id_cache was populated. A null value indicates an invalid (or unused cache)", "name": "lists_for_resource_cache_updated", "verbose_name": "lists for resource cache updated" },
                        { "field_type": 21, "help_text": "The last time lists_for_resource_id_cache was populated. A null value indicates an invalid (or unused cache)", "name": "lists_for_resource_caching_failed_at", "verbose_name": "lists for resource caching failed at" }
                    ]
                },
                "Team": {
                    "__is_model": true,
                    "__name__": "Team",
                    "data_model": "app.userdata.models.Team",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false, "default_for_user": true },
                    "endpoint": "/api/team/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 1, "help_text": "Whether or not this is a default team", "name": "default", "verbose_name": "default" },
                        {
                            "field_type": 8,
                            "help_text": "",
                            "name": "members",
                            "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                            "verbose_name": "members"
                        }
                    ]
                },
                "UserInfo": {
                    "__is_model": true,
                    "__name__": "UserInfo",
                    "data_model": "app.userdata.models.UserInfo",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/userinfo/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "The default bill filters to apply in search.",
                            "name": "bill_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "bill default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default document filters to apply in search.",
                            "name": "document_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "document default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default person filters to apply in search.",
                            "name": "person_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "person default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default person filters to apply in search.",
                            "name": "staffer_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "staffer default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default legislator filters to apply in search.",
                            "name": "legislator_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "legislator default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default contact filters to apply in search.",
                            "name": "supporter_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "supporter default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default note filters to apply in search.",
                            "name": "note_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "note default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default event filters to apply in search.",
                            "name": "event_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "event default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default vote filters to apply in search.",
                            "name": "vote_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "vote default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default amendment filters to apply in search.",
                            "name": "amendment_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "amendment default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default public organization filters to apply in search.",
                            "name": "public_organization_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "public organization default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default file filters to apply in search.",
                            "name": "attachment_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "attachment default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default regulation filters to apply in search.",
                            "name": "regulation_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "regulation default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default alert filters to apply in search.",
                            "name": "alert_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "alert default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default article filters to apply in search.",
                            "name": "article_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "article default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default press contact filters to apply in search.",
                            "name": "press_contact_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "press contact default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default election filters to apply in search.",
                            "name": "election_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "election default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default political committee filters to apply in search.",
                            "name": "political_committee_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "political committee default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default transaction filters to apply in search.",
                            "name": "transaction_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "transaction default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default receipt filters to apply in search.",
                            "name": "receipt_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "receipt default search filters"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The default disbursement filters to apply in search.",
                            "name": "disbursement_default_search_filters",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                            "verbose_name": "disbursement default search filters"
                        },
                        { "field_type": 1, "help_text": "Whether this user has permission to change any Team Permissioning information about objects they create", "name": "should_hide_team_permissionining_in_forms", "verbose_name": "should hide team permissionining in forms" },
                        { "field_type": 1, "help_text": "Whether this user should use SSO to access Quorum.", "name": "single_login", "verbose_name": "single login" },
                        { "field_type": 1, "help_text": "Whether or not the related user is the organization administrator", "name": "org_admin", "verbose_name": "org admin" },
                        {
                            "field_type": 7,
                            "help_text": "The id of the related user",
                            "name": "user",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "user"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Id of the organization the user is a part of",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 2, "help_text": "The initials of the user", "name": "initials", "verbose_name": "initials" },
                        { "field_type": 2, "help_text": "The first + last name of the user", "name": "full_name", "verbose_name": "full name" },
                        {
                            "field_type": 7,
                            "help_text": "the project the user is currently in",
                            "name": "current_project",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "current project"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "TwoFactorStatus" },
                            "field_type": 4,
                            "help_text": "",
                            "name": "two_factor_status",
                            "verbose_name": "two factor status"
                        },
                        { "field_type": 2, "help_text": "The secret key of the TOTP Generator", "name": "totp_secret", "verbose_name": "totp secret" },
                        { "field_type": 2, "help_text": "Phone number for SMS verification", "name": "phone_number", "verbose_name": "phone number" },
                        { "field_type": null, "help_text": "The list of values of the sidebar for the side of the page of the site", "name": "sidebar_settings_list", "verbose_name": "sidebar settings list" },
                        { "field_type": null, "help_text": "The order the user wants the types in the top of search to appear", "name": "search_data_type_order", "verbose_name": "search data type order" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                            "field_type": 4,
                            "help_text": "A global override of which search type should show up first for this user",
                            "name": "default_search_data_type",
                            "verbose_name": "default search data type"
                        },
                        { "field_type": 1, "help_text": "Whether the user is currently viewing search results in the table view", "name": "search_is_table_view", "verbose_name": "search is table view" },
                        { "field_type": 1, "help_text": "Whether the user is currently hiding filters in search", "name": "search_should_hide_filters", "verbose_name": "search should hide filters" },
                        { "field_type": null, "help_text": "Array of regions a user has permissions to.", "name": "permissioned_regions", "verbose_name": "permissioned regions" },
                        { "field_type": null, "help_text": "Current regions (in string format).", "name": "current_regions", "verbose_name": "current regions" },
                        { "field_type": 2, "help_text": "If a user is in a custom preset region, this gives the name.", "name": "current_preset_name", "verbose_name": "current preset name" },
                        { "field_type": 4, "help_text": "", "name": "fb_id", "verbose_name": "Facebook ID" },
                        { "field_type": 4, "help_text": "The persona of the user to group account settings", "name": "persona", "verbose_name": "persona" },
                        { "field_type": null, "help_text": "Array of primary and secondary user personas", "name": "other_personas", "verbose_name": "other personas" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "UserPersona" },
                            "field_type": 4,
                            "help_text": "The current Persona of the user",
                            "name": "user_persona",
                            "verbose_name": "user persona"
                        },
                        { "field_type": 1, "help_text": "Whether a user has access to all the regions that the user's organization has access to", "name": "can_access_all_org_regions", "verbose_name": "can access all org regions" },
                        { "field_type": 1, "help_text": "If an org has outbox and allows the user to access feature", "name": "can_access_outbox", "verbose_name": "can access outbox" },
                        { "field_type": 1, "help_text": "If an org has outbox and allows the user to send an Outbox email from any other account", "name": "can_send_from_any_outbox", "verbose_name": "can send from any outbox" },
                        { "field_type": 1, "help_text": "If an org has outbox and allows the user to any previously sent Outbox email", "name": "can_see_any_previous_outbox_email", "verbose_name": "can see any previous outbox email" },
                        { "field_type": 1, "help_text": "Whether a user has access to texting features", "name": "can_access_texting", "verbose_name": "can access texting" },
                        { "field_type": 1, "help_text": "If an org has texting and allows the user to see any previously sent outbound texts", "name": "can_see_any_previous_outbound_texts", "verbose_name": "can see any previous outbound texts" },
                        { "field_type": 1, "help_text": "If an org has grassroots and allows the user to access feature", "name": "can_access_grassroots", "verbose_name": "can access grassroots" },
                        { "field_type": 1, "help_text": "If an org has grassroots and allows the user to edit action center settings", "name": "can_change_action_center_settings", "verbose_name": "can change action center settings" },
                        { "field_type": 1, "help_text": "If an org has grassroots and allows the user to see all campaigns created by organization", "name": "can_see_all_campaigns", "verbose_name": "can see all campaigns" },
                        { "field_type": 1, "help_text": "If an org has notes and allows the user to access feature", "name": "can_access_notes", "verbose_name": "can access notes" },
                        { "field_type": 1, "help_text": "If an org has PAC and allows the user to access feature", "name": "can_access_pac", "verbose_name": "can access pac" },
                        { "field_type": 1, "help_text": "If an org has PAC Management and allows the user to access feature", "name": "can_access_pac_management", "verbose_name": "can access pac management" },
                        { "field_type": 1, "help_text": "Whether this user is allowed to see all of the other users in the organization or not.", "name": "can_see_all_users", "verbose_name": "can see all users" },
                        { "field_type": 1, "help_text": "Whether this user is allowed to see all of the files that the organization has uploaded or not.", "name": "can_see_all_files", "verbose_name": "can see all files" },
                        { "field_type": 1, "help_text": "Whether this user is allowed to see all of the events that the organization has created or not.", "name": "can_see_all_events", "verbose_name": "can see all events" },
                        { "field_type": 1, "help_text": "Whether a user is allowed to make Bulk Uploads. Can still access Uploads tab with past uploads.", "name": "can_access_bulk_uploads", "verbose_name": "can access bulk uploads" },
                        { "field_type": 1, "help_text": "Whether a user is allowed to access Axios articles in the Documents dataset.", "name": "can_access_axios_articles", "verbose_name": "can access axios articles" },
                        { "field_type": 1, "help_text": "Whether a user has access to the custom fields management page", "name": "can_access_custom_fields_management", "verbose_name": "can access custom fields management" },
                        { "field_type": 1, "help_text": "Whether a user has access to contacts and custom organizations for their organization.", "name": "can_see_supporters_and_custom_orgs", "verbose_name": "can see supporters and custom orgs" },
                        { "field_type": 1, "help_text": "Whether a user has access to Media Relations if their Org does as well.", "name": "can_access_media_monitoring", "verbose_name": "can access media monitoring" },
                        { "field_type": 1, "help_text": "Whether a user has access to Media Monitoring if their Org does as well.", "name": "can_access_media_relations", "verbose_name": "can access media relations" },
                        { "field_type": 1, "help_text": "Whether a user has access to issue management resource table and profile.", "name": "can_access_issue_management", "verbose_name": "can access issue management" },
                        { "field_type": 1, "help_text": "Whether a user has access to campaign finance resource table and profile.", "name": "can_access_campaign_finance", "verbose_name": "can access campaign finance" },
                        { "field_type": 1, "help_text": "Whether a user has access to PAC Receipts.", "name": "can_view_pac_receipts", "verbose_name": "can view pac receipts" },
                        { "field_type": 1, "help_text": "Whether a user has access to PAC Disbursements.", "name": "can_view_pac_disbursements", "verbose_name": "can view pac disbursements" },
                        { "field_type": 1, "help_text": "Whether a user has access to PAC Transactions.", "name": "can_alter_pac_transactions", "verbose_name": "can alter pac transactions" },
                        { "field_type": 1, "help_text": "Whether this user is able to access the default project of their organization", "name": "limit_from_default_project", "verbose_name": "limit from default project" },
                        { "field_type": 1, "help_text": "If a user can access mobile developer tools", "name": "can_access_mobile_developer_tools", "verbose_name": "can access mobile developer tools" },
                        { "field_type": 1, "help_text": "User accepted our terms and conditions during registration and is allowed access", "name": "accepted_terms_and_conditions", "verbose_name": "accepted terms and conditions" },
                        { "field_type": 16, "help_text": "The date that the client accepted our terms and conditions. This will be None for clients who registered before the new registration page", "name": "date_accepted_terms_and_conditions", "verbose_name": "date accepted terms and conditions" },
                        { "field_type": 3, "help_text": "the email signature of a user", "name": "email_signature", "verbose_name": "email signature" },
                        { "field_type": 3, "help_text": "The unique identifier for each employee of their organization", "name": "employee_id", "verbose_name": "employee id" },
                        { "field_type": 4, "help_text": "The maximum number of selections/SafedSearch objects a User can perform a BulkAction upon", "name": "bulk_action_max_size", "verbose_name": "bulk action max size" },
                        { "field_type": 1, "help_text": "Whether this user can see supporters that do not match their teams provided those supporters belong to states this user can see", "name": "can_see_supporters_based_on_region", "verbose_name": "can see supporters based on region" },
                        { "field_type": 1, "help_text": "If true, this user can only create is_limited_to_creator issues, and cannot change the permissioning of any issue", "name": "can_only_create_single_user_issues", "verbose_name": "can only create single user issues" },
                        { "field_type": null, "help_text": "Mapping of device id to hashes of permament login tokens", "name": "permanent_mobile_login_tokens", "verbose_name": "permanent mobile login tokens" },
                        { "field_type": 4, "help_text": "The number of push notification a user has not yet seen", "name": "push_notification_unseen_count", "verbose_name": "push notification unseen count" },
                        { "field_type": null, "help_text": "Map of Quorum Features and whether they have been visited recently", "name": "visited_feature_cache", "verbose_name": "visited feature cache" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.userdata.types", "__name__": "UserRole" },
                            "field_type": 4,
                            "help_text": "The level of access granted to this user",
                            "name": "user_role",
                            "verbose_name": "user role"
                        },
                        {
                            "field_type": 7,
                            "help_text": "ID of the dashboard user has as their homepage",
                            "name": "homepage_dashboard",
                            "related_model": { "__module__": "app.widgets.models", "__name__": "Dashboard" },
                            "verbose_name": "homepage dashboard"
                        },
                        { "field_type": 1, "help_text": "The user acknowledged our welcome message for the mobile experience", "name": "acknowledged_mobile_welcome", "verbose_name": "acknowledged mobile welcome" },
                        { "field_type": 1, "help_text": "The sidebar collapsed/expanded state", "name": "sidebar_collapsed", "verbose_name": "sidebar collapsed" },
                        { "field_type": 5, "help_text": "The last time the user made a request", "name": "last_activity", "verbose_name": "last activity" },
                        { "field_type": 1, "help_text": "Whether an alert should be triggered when this user is deactivated. Useful for service accounts whose deactivation would cause an outage", "name": "alert_on_deactivation", "verbose_name": "alert on deactivation" },
                        { "field_type": 4, "help_text": "The PACC UserID for this user.", "name": "pacc_userid", "verbose_name": "pacc userid" },
                        { "field_type": 3, "help_text": "The User's login name from PACC, for hybrid PAC users", "name": "pacc_username", "verbose_name": "pacc username" },
                        { "field_type": 4, "help_text": "The PACC Classic Version number, for identifying change conflicts in PAC Classic", "name": "pacc_version", "verbose_name": "pacc version" },
                        {
                            "field_type": 7,
                            "help_text": "The current PACC ID the user is currently accessing.",
                            "name": "current_pacc_pac",
                            "related_model": { "__module__": "app.pac_classic.models.pac", "__name__": "PacClassicPac" },
                            "verbose_name": "current pacc pac"
                        },
                        { "field_type": 3, "help_text": "json_string of campaign columns for a user", "name": "campaign_columns_list", "verbose_name": "campaign columns list" },
                        {
                            "field_type": 8,
                            "help_text": "The default teams that should be tagged to objects created by this Userby default. These are automatically added to the limited_to_teams field when creating new objects.",
                            "name": "default_limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "default limited to teams"
                        }
                    ]
                }
            },
            "notes": {
                "models": {
                    "CustomInteractionType": {
                        "__is_model": true,
                        "__name__": "CustomInteractionType",
                        "data_model": "app.userdata.notes.models.CustomInteractionType",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/custominteractiontype/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 3, "help_text": "Name of CustomInteractionType", "name": "title", "verbose_name": "title" },
                            { "field_type": 3, "help_text": "standard text to use in inline", "name": "description", "verbose_name": "description" },
                            { "field_type": 3, "help_text": "preposition (typically last word of the 'description'. Stripped out when the interaction includes only one person?", "name": "divider", "verbose_name": "divider" },
                            { "field_type": 3, "help_text": "text to use in inline when the interaction has not taken place yet", "name": "future_description", "verbose_name": "future description" },
                            { "field_type": 3, "help_text": "FontAwesome icon to display inline", "name": "icon", "verbose_name": "icon" },
                            { "field_type": 4, "help_text": "place this should show up in interaction logger (or None if the type shouldn't in default_interaction_types)", "name": "order", "verbose_name": "order" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "InteractionType" },
                                "field_type": 4,
                                "help_text": "Preserve the value of the enum seeded CustomInteractionTypes were generated from",
                                "name": "generated_from_interaction_type",
                                "verbose_name": "generated from interaction type"
                            }
                        ]
                    },
                    "GrassrootsAction": {
                        "__is_model": true,
                        "__name__": "GrassrootsAction",
                        "data_model": "app.userdata.notes.models.GrassrootsAction",
                        "default_exclude_filters": {
                            "interaction_type__in": [12, 13, 34, 22, 23, 32, 24, 81]
                        },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/grassrootsaction/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "docket",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "docket"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer",
                                "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                "verbose_name": "staffer"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "document"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "attachment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                                "verbose_name": "attachment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "committee",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                                "verbose_name": "committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "political_committee",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "political committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "election"
                            },
                            { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                            { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                                "field_type": 4,
                                "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                                "miscellaneous": 12,
                                "name": "source_type",
                                "sheet_column": true,
                                "sheets_subcategory": 12,
                                "sheets_tooltip_text": "The Source of this Contact",
                                "verbose_name": "Source Type"
                            },
                            { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                            { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                            { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                            { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                            { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                            { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                            { "field_type": 3, "help_text": "", "name": "text_with_html", "verbose_name": "text with html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "", "name": "cache_json", "verbose_name": "cache json" },
                            { "field_type": null, "help_text": "", "name": "frozen_cache_json", "verbose_name": "frozen cache json" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "assignment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Assignment" },
                                "verbose_name": "assignment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bulk_email",
                                "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                "verbose_name": "bulk email"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "project",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "project"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PrivacyType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "privacy",
                                "verbose_name": "privacy"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "NoteType" },
                                "field_type": 4,
                                "help_text": "The type of note logged (e.g. Comment, Relationship, etc.)",
                                "name": "note_type",
                                "sheet_column": true,
                                "verbose_name": "Note Type"
                            },
                            { "field_type": 3, "help_text": "The text of this note.", "name": "text", "verbose_name": "Text" },
                            { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                            { "field_type": 1, "help_text": "", "name": "auto_created", "verbose_name": "auto created" },
                            { "field_type": null, "help_text": "The regions represented by all of the different ", "name": "regions", "verbose_name": "regions" },
                            { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                            { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                            { "field_type": 16, "help_text": "The date this happened.", "name": "date", "sheet_column": true, "verbose_name": "Date" },
                            { "field_type": 2, "help_text": "", "name": "searchable_date", "verbose_name": "searchable date" },
                            { "field_type": 1, "help_text": "", "name": "from_knowlegis", "verbose_name": "from knowlegis" },
                            { "field_type": 1, "help_text": "", "name": "from_highrise", "verbose_name": "from highrise" },
                            { "field_type": 1, "help_text": "", "name": "from_notes", "verbose_name": "from notes" },
                            { "field_type": 1, "help_text": "", "name": "from_qnotes", "verbose_name": "from qnotes" },
                            { "field_type": 1, "help_text": "", "name": "from_grassroots", "verbose_name": "from grassroots" },
                            { "field_type": 1, "help_text": "", "name": "from_parser", "verbose_name": "from parser" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_type",
                                "verbose_name": "comment type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "RelationshipType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "relationship_type",
                                "verbose_name": "relationship type"
                            },
                            { "field_type": 1, "help_text": "Current or former relationship", "name": "relationship_status", "verbose_name": "relationship status" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PossibleDurations" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "duration",
                                "sheet_column": true,
                                "sheets_tooltip_text": "Duration of interaction in minutes.",
                                "verbose_name": "Duration"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "InteractionType" },
                                "field_type": 4,
                                "help_text": "The specific type of interaction logged (e.g meeting, phone call, etc)",
                                "name": "interaction_type",
                                "verbose_name": "Interaction Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_interaction_type",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                                "verbose_name": "custom interaction type"
                            },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to shareNotes with people outside of their organization. Notes will only be visible to users thatare on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            { "field_type": 1, "help_text": "", "name": "is_ical", "verbose_name": "is ical" },
                            { "field_type": 2, "help_text": "Ical id of the icalendar event", "name": "ical_id", "verbose_name": "ical id" },
                            { "field_type": null, "help_text": "A list of Article IDs that make up the fake Many to Many relationship", "name": "article_ids", "verbose_name": "article ids" },
                            { "field_type": 4, "help_text": "The number of members related to this note", "name": "members_count", "verbose_name": "members count" },
                            { "field_type": 4, "help_text": "The number of team members related to this note", "name": "team_members_count", "verbose_name": "team members count" },
                            { "field_type": 4, "help_text": "The number of public organizations related to this note", "name": "public_organizations_count", "verbose_name": "public organizations count" },
                            { "field_type": 4, "help_text": "The number of supporters related to this note", "name": "supporters_count", "verbose_name": "supporters count" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "event",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "event"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_stance",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativeStance" },
                                "verbose_name": "legislative stance"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_priority",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativePriority" },
                                "verbose_name": "legislative priority"
                            },
                            { "field_type": 6, "help_text": "The monetary amount (usually USD) in donation/transaction", "name": "amount", "sheet_column": true, "verbose_name": "Donation Amount" },
                            { "field_type": 2, "help_text": "Check # used to make donation", "name": "check_number", "sheet_column": true, "verbose_name": "Check Number" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "campaign",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaign"
                            },
                            { "field_type": 2, "help_text": "Subject of Message", "name": "subject", "sheet_column": true, "verbose_name": "Subject" },
                            { "field_type": 2, "help_text": "", "name": "submitting_org_name", "verbose_name": "submitting org name" },
                            { "field_type": 3, "help_text": "", "name": "message", "verbose_name": "message" },
                            { "field_type": 2, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "", "name": "confirmed", "verbose_name": "confirmed" },
                            { "field_type": 1, "help_text": "", "name": "delivered", "verbose_name": "delivered" },
                            { "field_type": 1, "help_text": "", "name": "failed_delivery", "verbose_name": "failed delivery" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "supporter_action_type",
                                "verbose_name": "supporter action type"
                            },
                            { "field_type": 2, "help_text": "", "name": "delivery_id", "verbose_name": "delivery id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SocialMediaType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "social_media_type",
                                "verbose_name": "social media type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "issue"
                            },
                            { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                            { "field_type": null, "help_text": "The results from the delivery of the supporter action", "name": "audit_trail", "verbose_name": "audit trail" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionStatus" },
                                "field_type": 4,
                                "help_text": "The current status of this supporter action",
                                "name": "message_status",
                                "verbose_name": "message status"
                            },
                            { "field_type": null, "help_text": "Various timestamps collected every time an action has been attempted to be delivered", "name": "timestamp", "verbose_name": "timestamp" },
                            { "field_type": 4, "help_text": "The number of delivery attempts on a suporter action", "name": "num_attempts", "verbose_name": "num attempts" },
                            { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "verbose_name": "opens" },
                            { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "verbose_name": "clicks" },
                            { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                            { "field_type": 16, "help_text": "timestamp for when the first open occurred", "name": "first_open", "verbose_name": "first open" },
                            {
                                "field_type": 7,
                                "help_text": "the custom event associated with this Note",
                                "name": "custom_event",
                                "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                "verbose_name": "custom event"
                            },
                            { "field_type": null, "help_text": "Array of ids of teams this Note is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                            {
                                "field_type": 8,
                                "help_text": "The Bulk Upload Files that have created/updated this object",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "mentions",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "mentions"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "members",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "team_members",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "team members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "public_organizations",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organizations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "votes",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "votes"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "amendments",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendments"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "documents",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "documents"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "dockets",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "dockets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "offices",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "offices"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "teams"
                            }
                        ],
                        "proxy_endpoint": "/api/note/"
                    },
                    "Interaction": {
                        "__is_model": true,
                        "__name__": "Interaction",
                        "data_model": "app.userdata.notes.models.Interaction",
                        "default_exclude_filters": {
                            "interaction_type__in": [12, 13, 34, 22, 23, 32, 24, 81]
                        },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/interaction/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "docket",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "docket"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer",
                                "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                "verbose_name": "staffer"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "document"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "attachment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                                "verbose_name": "attachment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "committee",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                                "verbose_name": "committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "political_committee",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "political committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "election"
                            },
                            { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                            { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                                "field_type": 4,
                                "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                                "miscellaneous": 12,
                                "name": "source_type",
                                "sheet_column": true,
                                "sheets_subcategory": 12,
                                "sheets_tooltip_text": "The Source of this Contact",
                                "verbose_name": "Source Type"
                            },
                            { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                            { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                            { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                            { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                            { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                            { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                            { "field_type": 3, "help_text": "", "name": "text_with_html", "verbose_name": "text with html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "", "name": "cache_json", "verbose_name": "cache json" },
                            { "field_type": null, "help_text": "", "name": "frozen_cache_json", "verbose_name": "frozen cache json" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "assignment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Assignment" },
                                "verbose_name": "assignment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bulk_email",
                                "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                "verbose_name": "bulk email"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "project",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "project"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PrivacyType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "privacy",
                                "verbose_name": "privacy"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "NoteType" },
                                "field_type": 4,
                                "help_text": "The type of note logged (e.g. Comment, Relationship, etc.)",
                                "name": "note_type",
                                "sheet_column": true,
                                "verbose_name": "Note Type"
                            },
                            { "field_type": 3, "help_text": "The text of this note.", "name": "text", "verbose_name": "Text" },
                            { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                            { "field_type": 1, "help_text": "", "name": "auto_created", "verbose_name": "auto created" },
                            { "field_type": null, "help_text": "The regions represented by all of the different ", "name": "regions", "verbose_name": "regions" },
                            { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                            { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                            { "field_type": 16, "help_text": "The date this happened.", "name": "date", "sheet_column": true, "verbose_name": "Date" },
                            { "field_type": 2, "help_text": "", "name": "searchable_date", "verbose_name": "searchable date" },
                            { "field_type": 1, "help_text": "", "name": "from_knowlegis", "verbose_name": "from knowlegis" },
                            { "field_type": 1, "help_text": "", "name": "from_highrise", "verbose_name": "from highrise" },
                            { "field_type": 1, "help_text": "", "name": "from_notes", "verbose_name": "from notes" },
                            { "field_type": 1, "help_text": "", "name": "from_qnotes", "verbose_name": "from qnotes" },
                            { "field_type": 1, "help_text": "", "name": "from_grassroots", "verbose_name": "from grassroots" },
                            { "field_type": 1, "help_text": "", "name": "from_parser", "verbose_name": "from parser" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_type",
                                "verbose_name": "comment type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "RelationshipType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "relationship_type",
                                "verbose_name": "relationship type"
                            },
                            { "field_type": 1, "help_text": "Current or former relationship", "name": "relationship_status", "verbose_name": "relationship status" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PossibleDurations" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "duration",
                                "sheet_column": true,
                                "sheets_tooltip_text": "Duration of interaction in minutes.",
                                "verbose_name": "Duration"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "InteractionType" },
                                "field_type": 4,
                                "help_text": "The specific type of interaction logged (e.g meeting, phone call, etc)",
                                "name": "interaction_type",
                                "verbose_name": "Interaction Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_interaction_type",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                                "verbose_name": "custom interaction type"
                            },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to shareNotes with people outside of their organization. Notes will only be visible to users thatare on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            { "field_type": 1, "help_text": "", "name": "is_ical", "verbose_name": "is ical" },
                            { "field_type": 2, "help_text": "Ical id of the icalendar event", "name": "ical_id", "verbose_name": "ical id" },
                            { "field_type": null, "help_text": "A list of Article IDs that make up the fake Many to Many relationship", "name": "article_ids", "verbose_name": "article ids" },
                            { "field_type": 4, "help_text": "The number of members related to this note", "name": "members_count", "verbose_name": "members count" },
                            { "field_type": 4, "help_text": "The number of team members related to this note", "name": "team_members_count", "verbose_name": "team members count" },
                            { "field_type": 4, "help_text": "The number of public organizations related to this note", "name": "public_organizations_count", "verbose_name": "public organizations count" },
                            { "field_type": 4, "help_text": "The number of supporters related to this note", "name": "supporters_count", "verbose_name": "supporters count" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "event",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "event"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_stance",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativeStance" },
                                "verbose_name": "legislative stance"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_priority",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativePriority" },
                                "verbose_name": "legislative priority"
                            },
                            { "field_type": 6, "help_text": "The monetary amount (usually USD) in donation/transaction", "name": "amount", "sheet_column": true, "verbose_name": "Donation Amount" },
                            { "field_type": 2, "help_text": "Check # used to make donation", "name": "check_number", "sheet_column": true, "verbose_name": "Check Number" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "campaign",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaign"
                            },
                            { "field_type": 2, "help_text": "Subject of Message", "name": "subject", "sheet_column": true, "verbose_name": "Subject" },
                            { "field_type": 2, "help_text": "", "name": "submitting_org_name", "verbose_name": "submitting org name" },
                            { "field_type": 3, "help_text": "", "name": "message", "verbose_name": "message" },
                            { "field_type": 2, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "", "name": "confirmed", "verbose_name": "confirmed" },
                            { "field_type": 1, "help_text": "", "name": "delivered", "verbose_name": "delivered" },
                            { "field_type": 1, "help_text": "", "name": "failed_delivery", "verbose_name": "failed delivery" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "supporter_action_type",
                                "verbose_name": "supporter action type"
                            },
                            { "field_type": 2, "help_text": "", "name": "delivery_id", "verbose_name": "delivery id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SocialMediaType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "social_media_type",
                                "verbose_name": "social media type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "issue"
                            },
                            { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                            { "field_type": null, "help_text": "The results from the delivery of the supporter action", "name": "audit_trail", "verbose_name": "audit trail" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionStatus" },
                                "field_type": 4,
                                "help_text": "The current status of this supporter action",
                                "name": "message_status",
                                "verbose_name": "message status"
                            },
                            { "field_type": null, "help_text": "Various timestamps collected every time an action has been attempted to be delivered", "name": "timestamp", "verbose_name": "timestamp" },
                            { "field_type": 4, "help_text": "The number of delivery attempts on a suporter action", "name": "num_attempts", "verbose_name": "num attempts" },
                            { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "verbose_name": "opens" },
                            { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "verbose_name": "clicks" },
                            { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                            { "field_type": 16, "help_text": "timestamp for when the first open occurred", "name": "first_open", "verbose_name": "first open" },
                            {
                                "field_type": 7,
                                "help_text": "the custom event associated with this Note",
                                "name": "custom_event",
                                "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                "verbose_name": "custom event"
                            },
                            { "field_type": null, "help_text": "Array of ids of teams this Note is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                            {
                                "field_type": 8,
                                "help_text": "The Bulk Upload Files that have created/updated this object",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "mentions",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "mentions"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "members",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "team_members",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "team members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "public_organizations",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organizations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "votes",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "votes"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "amendments",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendments"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "documents",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "documents"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "dockets",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "dockets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "offices",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "offices"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "teams"
                            }
                        ],
                        "proxy_endpoint": "/api/note/"
                    },
                    "Note": {
                        "__is_model": true,
                        "__name__": "Note",
                        "data_model": "app.userdata.notes.models.Note",
                        "default_exclude_filters": {
                            "interaction_type__in": [12, 13, 34, 22, 23, 32, 24, 81]
                        },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/note/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "docket",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "docket"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer",
                                "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                "verbose_name": "staffer"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "document"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "attachment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                                "verbose_name": "attachment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "committee",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                                "verbose_name": "committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "political_committee",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "political committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "election"
                            },
                            { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                            { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                                "field_type": 4,
                                "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                                "miscellaneous": 12,
                                "name": "source_type",
                                "sheet_column": true,
                                "sheets_subcategory": 12,
                                "sheets_tooltip_text": "The Source of this Contact",
                                "verbose_name": "Source Type"
                            },
                            { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                            { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                            { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                            { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                            { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                            { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                            { "field_type": 3, "help_text": "", "name": "text_with_html", "verbose_name": "text with html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "", "name": "cache_json", "verbose_name": "cache json" },
                            { "field_type": null, "help_text": "", "name": "frozen_cache_json", "verbose_name": "frozen cache json" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "assignment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Assignment" },
                                "verbose_name": "assignment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bulk_email",
                                "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                "verbose_name": "bulk email"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "project",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "project"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PrivacyType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "privacy",
                                "verbose_name": "privacy"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "NoteType" },
                                "field_type": 4,
                                "help_text": "The type of note logged (e.g. Comment, Relationship, etc.)",
                                "name": "note_type",
                                "sheet_column": true,
                                "verbose_name": "Note Type"
                            },
                            { "field_type": 3, "help_text": "The text of this note.", "name": "text", "verbose_name": "Text" },
                            { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                            { "field_type": 1, "help_text": "", "name": "auto_created", "verbose_name": "auto created" },
                            { "field_type": null, "help_text": "The regions represented by all of the different ", "name": "regions", "verbose_name": "regions" },
                            { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                            { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                            { "field_type": 16, "help_text": "The date this happened.", "name": "date", "sheet_column": true, "verbose_name": "Date" },
                            { "field_type": 2, "help_text": "", "name": "searchable_date", "verbose_name": "searchable date" },
                            { "field_type": 1, "help_text": "", "name": "from_knowlegis", "verbose_name": "from knowlegis" },
                            { "field_type": 1, "help_text": "", "name": "from_highrise", "verbose_name": "from highrise" },
                            { "field_type": 1, "help_text": "", "name": "from_notes", "verbose_name": "from notes" },
                            { "field_type": 1, "help_text": "", "name": "from_qnotes", "verbose_name": "from qnotes" },
                            { "field_type": 1, "help_text": "", "name": "from_grassroots", "verbose_name": "from grassroots" },
                            { "field_type": 1, "help_text": "", "name": "from_parser", "verbose_name": "from parser" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_type",
                                "verbose_name": "comment type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "RelationshipType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "relationship_type",
                                "verbose_name": "relationship type"
                            },
                            { "field_type": 1, "help_text": "Current or former relationship", "name": "relationship_status", "verbose_name": "relationship status" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PossibleDurations" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "duration",
                                "sheet_column": true,
                                "sheets_tooltip_text": "Duration of interaction in minutes.",
                                "verbose_name": "Duration"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "InteractionType" },
                                "field_type": 4,
                                "help_text": "The specific type of interaction logged (e.g meeting, phone call, etc)",
                                "name": "interaction_type",
                                "verbose_name": "Interaction Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_interaction_type",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                                "verbose_name": "custom interaction type"
                            },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to shareNotes with people outside of their organization. Notes will only be visible to users thatare on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            { "field_type": 1, "help_text": "", "name": "is_ical", "verbose_name": "is ical" },
                            { "field_type": 2, "help_text": "Ical id of the icalendar event", "name": "ical_id", "verbose_name": "ical id" },
                            { "field_type": null, "help_text": "A list of Article IDs that make up the fake Many to Many relationship", "name": "article_ids", "verbose_name": "article ids" },
                            { "field_type": 4, "help_text": "The number of members related to this note", "name": "members_count", "verbose_name": "members count" },
                            { "field_type": 4, "help_text": "The number of team members related to this note", "name": "team_members_count", "verbose_name": "team members count" },
                            { "field_type": 4, "help_text": "The number of public organizations related to this note", "name": "public_organizations_count", "verbose_name": "public organizations count" },
                            { "field_type": 4, "help_text": "The number of supporters related to this note", "name": "supporters_count", "verbose_name": "supporters count" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "event",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "event"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_stance",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativeStance" },
                                "verbose_name": "legislative stance"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_priority",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativePriority" },
                                "verbose_name": "legislative priority"
                            },
                            { "field_type": 6, "help_text": "The monetary amount (usually USD) in donation/transaction", "name": "amount", "sheet_column": true, "verbose_name": "Donation Amount" },
                            { "field_type": 2, "help_text": "Check # used to make donation", "name": "check_number", "sheet_column": true, "verbose_name": "Check Number" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "campaign",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaign"
                            },
                            { "field_type": 2, "help_text": "Subject of Message", "name": "subject", "sheet_column": true, "verbose_name": "Subject" },
                            { "field_type": 2, "help_text": "", "name": "submitting_org_name", "verbose_name": "submitting org name" },
                            { "field_type": 3, "help_text": "", "name": "message", "verbose_name": "message" },
                            { "field_type": 2, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "", "name": "confirmed", "verbose_name": "confirmed" },
                            { "field_type": 1, "help_text": "", "name": "delivered", "verbose_name": "delivered" },
                            { "field_type": 1, "help_text": "", "name": "failed_delivery", "verbose_name": "failed delivery" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "supporter_action_type",
                                "verbose_name": "supporter action type"
                            },
                            { "field_type": 2, "help_text": "", "name": "delivery_id", "verbose_name": "delivery id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SocialMediaType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "social_media_type",
                                "verbose_name": "social media type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "issue"
                            },
                            { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                            { "field_type": null, "help_text": "The results from the delivery of the supporter action", "name": "audit_trail", "verbose_name": "audit trail" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionStatus" },
                                "field_type": 4,
                                "help_text": "The current status of this supporter action",
                                "name": "message_status",
                                "verbose_name": "message status"
                            },
                            { "field_type": null, "help_text": "Various timestamps collected every time an action has been attempted to be delivered", "name": "timestamp", "verbose_name": "timestamp" },
                            { "field_type": 4, "help_text": "The number of delivery attempts on a suporter action", "name": "num_attempts", "verbose_name": "num attempts" },
                            { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "verbose_name": "opens" },
                            { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "verbose_name": "clicks" },
                            { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                            { "field_type": 16, "help_text": "timestamp for when the first open occurred", "name": "first_open", "verbose_name": "first open" },
                            {
                                "field_type": 7,
                                "help_text": "the custom event associated with this Note",
                                "name": "custom_event",
                                "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                "verbose_name": "custom event"
                            },
                            { "field_type": null, "help_text": "Array of ids of teams this Note is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                            {
                                "field_type": 8,
                                "help_text": "The Bulk Upload Files that have created/updated this object",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "mentions",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "mentions"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "members",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "team_members",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "team members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "public_organizations",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organizations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "votes",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "votes"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "amendments",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendments"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "documents",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "documents"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "dockets",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "dockets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "offices",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "offices"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "teams"
                            }
                        ]
                    },
                    "Relationship": {
                        "__is_model": true,
                        "__name__": "Relationship",
                        "data_model": "app.userdata.notes.models.Relationship",
                        "default_exclude_filters": {
                            "interaction_type__in": [12, 13, 34, 22, 23, 32, 24, 81]
                        },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/relationship/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "docket",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "docket"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer",
                                "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                "verbose_name": "staffer"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "public_organization",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "document"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "attachment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Attachment" },
                                "verbose_name": "attachment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "committee",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                                "verbose_name": "committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "political_committee",
                                "related_model": { "__module__": "app.pac.models.political_committee", "__name__": "PoliticalCommittee" },
                                "verbose_name": "political committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "election",
                                "related_model": { "__module__": "app.pac.models.election", "__name__": "Election" },
                                "verbose_name": "election"
                            },
                            { "field_type": null, "help_text": "Stores the custom field information for the object", "name": "tag_dict", "verbose_name": "tag dict" },
                            { "field_type": null, "help_text": "Stores the custom field history for the object", "name": "custom_field_history", "verbose_name": "custom field history" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.types", "__name__": "UTMSourceType" },
                                "field_type": 4,
                                "help_text": "Our best guess as to the source of a particular thing, whether internal to Quorum, a particular website, etc.",
                                "miscellaneous": 12,
                                "name": "source_type",
                                "sheet_column": true,
                                "sheets_subcategory": 12,
                                "sheets_tooltip_text": "The Source of this Contact",
                                "verbose_name": "Source Type"
                            },
                            { "field_type": 3, "help_text": "What exact page this particular action / supporter came from when they registered or took action", "name": "http_referer", "verbose_name": "http referer" },
                            { "field_type": 2, "help_text": "Identifies which site sent the traffic, and is a required UTM parameter.", "name": "utm_source", "verbose_name": "utm source" },
                            { "field_type": 2, "help_text": "Identifies what type of link was used, such as cost per click or email.", "name": "utm_medium", "verbose_name": "utm medium" },
                            { "field_type": 2, "help_text": "Identifies a specific product promotion or strategic campaign.", "name": "utm_campaign", "verbose_name": "utm campaign" },
                            { "field_type": 2, "help_text": "Identifies search terms.", "name": "utm_term", "verbose_name": "utm term" },
                            { "field_type": 2, "help_text": "Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link.", "name": "utm_content", "verbose_name": "utm content" },
                            { "field_type": 3, "help_text": "", "name": "text_with_html", "verbose_name": "text with html" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": null, "help_text": "", "name": "cache_json", "verbose_name": "cache json" },
                            { "field_type": null, "help_text": "", "name": "frozen_cache_json", "verbose_name": "frozen cache json" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "user"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "assignment",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Assignment" },
                                "verbose_name": "assignment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bulk_email",
                                "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                "verbose_name": "bulk email"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "project",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "project"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PrivacyType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "privacy",
                                "verbose_name": "privacy"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "NoteType" },
                                "field_type": 4,
                                "help_text": "The type of note logged (e.g. Comment, Relationship, etc.)",
                                "name": "note_type",
                                "sheet_column": true,
                                "verbose_name": "Note Type"
                            },
                            { "field_type": 3, "help_text": "The text of this note.", "name": "text", "verbose_name": "Text" },
                            { "field_type": 3, "help_text": "", "name": "raw_content", "verbose_name": "raw content" },
                            { "field_type": 1, "help_text": "", "name": "auto_created", "verbose_name": "auto created" },
                            { "field_type": null, "help_text": "The regions represented by all of the different ", "name": "regions", "verbose_name": "regions" },
                            { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                            { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                            { "field_type": 16, "help_text": "The date this happened.", "name": "date", "sheet_column": true, "verbose_name": "Date" },
                            { "field_type": 2, "help_text": "", "name": "searchable_date", "verbose_name": "searchable date" },
                            { "field_type": 1, "help_text": "", "name": "from_knowlegis", "verbose_name": "from knowlegis" },
                            { "field_type": 1, "help_text": "", "name": "from_highrise", "verbose_name": "from highrise" },
                            { "field_type": 1, "help_text": "", "name": "from_notes", "verbose_name": "from notes" },
                            { "field_type": 1, "help_text": "", "name": "from_qnotes", "verbose_name": "from qnotes" },
                            { "field_type": 1, "help_text": "", "name": "from_grassroots", "verbose_name": "from grassroots" },
                            { "field_type": 1, "help_text": "", "name": "from_parser", "verbose_name": "from parser" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "comment_type",
                                "verbose_name": "comment type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "RelationshipType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "relationship_type",
                                "verbose_name": "relationship type"
                            },
                            { "field_type": 1, "help_text": "Current or former relationship", "name": "relationship_status", "verbose_name": "relationship status" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "PossibleDurations" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "duration",
                                "sheet_column": true,
                                "sheets_tooltip_text": "Duration of interaction in minutes.",
                                "verbose_name": "Duration"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "InteractionType" },
                                "field_type": 4,
                                "help_text": "The specific type of interaction logged (e.g meeting, phone call, etc)",
                                "name": "interaction_type",
                                "verbose_name": "Interaction Type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_interaction_type",
                                "related_model": { "__module__": "app.userdata.notes.models", "__name__": "CustomInteractionType" },
                                "verbose_name": "custom interaction type"
                            },
                            { "field_type": 1, "help_text": "Only relevant for organizations that have partners. This flag allows users to shareNotes with people outside of their organization. Notes will only be visible to users thatare on the partner organizations (organization.partners M2M)", "name": "is_visible_to_partners", "verbose_name": "is visible to partners" },
                            { "field_type": 1, "help_text": "", "name": "is_ical", "verbose_name": "is ical" },
                            { "field_type": 2, "help_text": "Ical id of the icalendar event", "name": "ical_id", "verbose_name": "ical id" },
                            { "field_type": null, "help_text": "A list of Article IDs that make up the fake Many to Many relationship", "name": "article_ids", "verbose_name": "article ids" },
                            { "field_type": 4, "help_text": "The number of members related to this note", "name": "members_count", "verbose_name": "members count" },
                            { "field_type": 4, "help_text": "The number of team members related to this note", "name": "team_members_count", "verbose_name": "team members count" },
                            { "field_type": 4, "help_text": "The number of public organizations related to this note", "name": "public_organizations_count", "verbose_name": "public organizations count" },
                            { "field_type": 4, "help_text": "The number of supporters related to this note", "name": "supporters_count", "verbose_name": "supporters count" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "event",
                                "related_model": { "__module__": "app.events.models", "__name__": "Event" },
                                "verbose_name": "event"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_stance",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativeStance" },
                                "verbose_name": "legislative stance"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "legislative_priority",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "LegislativePriority" },
                                "verbose_name": "legislative priority"
                            },
                            { "field_type": 6, "help_text": "The monetary amount (usually USD) in donation/transaction", "name": "amount", "sheet_column": true, "verbose_name": "Donation Amount" },
                            { "field_type": 2, "help_text": "Check # used to make donation", "name": "check_number", "sheet_column": true, "verbose_name": "Check Number" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "campaign",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaign"
                            },
                            { "field_type": 2, "help_text": "Subject of Message", "name": "subject", "sheet_column": true, "verbose_name": "Subject" },
                            { "field_type": 2, "help_text": "", "name": "submitting_org_name", "verbose_name": "submitting org name" },
                            { "field_type": 3, "help_text": "", "name": "message", "verbose_name": "message" },
                            { "field_type": 2, "help_text": "The external (e.g. Salesforce ID) unique identifier", "name": "unique_identifier", "verbose_name": "Unique Identifier" },
                            { "field_type": 1, "help_text": "", "name": "confirmed", "verbose_name": "confirmed" },
                            { "field_type": 1, "help_text": "", "name": "delivered", "verbose_name": "delivered" },
                            { "field_type": 1, "help_text": "", "name": "failed_delivery", "verbose_name": "failed delivery" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "supporter_action_type",
                                "verbose_name": "supporter action type"
                            },
                            { "field_type": 2, "help_text": "", "name": "delivery_id", "verbose_name": "delivery id" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SocialMediaType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "social_media_type",
                                "verbose_name": "social media type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "issue"
                            },
                            { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                            { "field_type": null, "help_text": "The results from the delivery of the supporter action", "name": "audit_trail", "verbose_name": "audit trail" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.grassroots.enums", "__name__": "SupporterActionStatus" },
                                "field_type": 4,
                                "help_text": "The current status of this supporter action",
                                "name": "message_status",
                                "verbose_name": "message status"
                            },
                            { "field_type": null, "help_text": "Various timestamps collected every time an action has been attempted to be delivered", "name": "timestamp", "verbose_name": "timestamp" },
                            { "field_type": 4, "help_text": "The number of delivery attempts on a suporter action", "name": "num_attempts", "verbose_name": "num attempts" },
                            { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "verbose_name": "opens" },
                            { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "verbose_name": "clicks" },
                            { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                            { "field_type": 16, "help_text": "timestamp for when the first open occurred", "name": "first_open", "verbose_name": "first open" },
                            {
                                "field_type": 7,
                                "help_text": "the custom event associated with this Note",
                                "name": "custom_event",
                                "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                "verbose_name": "custom event"
                            },
                            { "field_type": null, "help_text": "Array of ids of teams this Note is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                            {
                                "field_type": 8,
                                "help_text": "The Bulk Upload Files that have created/updated this object",
                                "name": "bulk_upload_files",
                                "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                "verbose_name": "bulk upload files"
                            },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "campaigns",
                                "related_model": { "__module__": "app.grassroots.campaign.models", "__name__": "Campaign" },
                                "verbose_name": "campaigns"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "mentions",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "mentions"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "members",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "team_members",
                                "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                "verbose_name": "team members"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "supporters",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporters"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "public_organizations",
                                "related_model": { "__module__": "app.person.models", "__name__": "PublicOrganization" },
                                "verbose_name": "public organizations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "bills",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bills"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "votes",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "votes"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "amendments",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendments"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "documents",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "documents"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "regulations",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulations"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "dockets",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Docket" },
                                "verbose_name": "dockets"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "offices",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "offices"
                            },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "teams"
                            }
                        ],
                        "proxy_endpoint": "/api/note/"
                    },
                    "SupporterAction": {
                        "__is_model": true,
                        "__name__": "SupporterAction",
                        "data_model": "app.userdata.notes.models.SupporterAction",
                        "default_exclude_filters": {
                            "interaction_type__in": [12, 13, 34, 22, 23, 32, 24, 81]
                        },
                        "default_filters": { "archived": false },
                        "endpoint": "/api/oldsupporteraction/",
                        "proxy_endpoint": "/api/interaction/"
                    }
                }
            },
            "outbox": {
                "models": {
                    "ab_test": {
                        "ABTest": {
                            "__is_model": true,
                            "__name__": "ABTest",
                            "data_model": "app.userdata.outbox.models.ab_test.ABTest",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/abtest/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "field_type": 7,
                                    "help_text": "User who created the ABTest",
                                    "name": "user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "user"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "Organization associated with the ABTest",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "The BulkEmail that will represent the AB Test to the end user",
                                    "name": "bulk_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "bulk email"
                                },
                                { "field_type": 3, "help_text": "Human readable name for this test", "name": "name", "verbose_name": "name" },
                                { "field_type": 3, "help_text": "Short description of the test", "name": "description", "verbose_name": "description" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "ABTestMode" },
                                    "field_type": 4,
                                    "help_text": "The type of test being run",
                                    "name": "test_mode",
                                    "verbose_name": "test mode"
                                },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "ABTestVariable" },
                                    "field_type": 4,
                                    "help_text": "The independent variable being manipulated",
                                    "name": "test_variable",
                                    "verbose_name": "test variable"
                                },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "ABTestMetric" },
                                    "field_type": 4,
                                    "help_text": "The dependent variable measured to determine the best variant",
                                    "name": "win_condition",
                                    "verbose_name": "win condition"
                                },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "ABTestStatus" },
                                    "field_type": 4,
                                    "help_text": "The current status of the AB test",
                                    "name": "current_status",
                                    "sheet_column": true,
                                    "verbose_name": "current status"
                                },
                                { "field_type": 21, "help_text": "The datetime this AB Test is set to begin", "name": "start_time", "verbose_name": "start time" },
                                { "field_type": 21, "help_text": "The datetime this AB Test is set to end", "name": "end_time", "verbose_name": "end time" },
                                { "field_type": null, "help_text": "Mapping of variant IDs to BulkEmail stats, as frozen at the end of the test period", "name": "stat_snapshot", "verbose_name": "stat snapshot" },
                                { "field_type": null, "help_text": "Array of dicts with a percentage value that instruct how recipients will be distributed between variants", "name": "distribution", "verbose_name": "distribution" },
                                { "field_type": null, "help_text": "Array of percentage values that instruct how recipients will be distributed between variants", "name": "distribution_model", "verbose_name": "distribution model" },
                                { "field_type": 4, "help_text": "Number of emails sent by all variants and the winner", "name": "aggregate_email_count", "sheet_column": true, "verbose_name": "aggregate email count" },
                                { "field_type": 4, "help_text": "Number of opens in all variants and the winner", "name": "aggregate_opens", "sheet_column": true, "verbose_name": "aggregate opens" },
                                { "field_type": 6, "help_text": "Opened emails divided by sent emails, both include all variants and winner", "name": "aggregate_open_rate", "sheet_column": true, "verbose_name": "aggregate open rate" },
                                { "field_type": 4, "help_text": "Number of opens including prefetched opens in all variants and the winner", "name": "aggregate_opens_with_prefetched", "sheet_column": true, "verbose_name": "aggregate opens with prefetched" },
                                { "field_type": 4, "help_text": "Number of emails in all variants and winner that have been clicked", "name": "aggregate_clicks", "sheet_column": true, "verbose_name": "aggregate clicks" },
                                { "field_type": 6, "help_text": "Clicked emails divided by sent emails, both include all variants and winner", "name": "aggregate_click_rate", "sheet_column": true, "verbose_name": "aggregate click rate" },
                                { "field_type": 4, "help_text": "Number of contacts unsubscribed from Outbox through link in any variant or winner", "name": "aggregate_unsubscribes", "sheet_column": true, "verbose_name": "aggregate unsubscribes" },
                                { "field_type": 4, "help_text": "Number of bounced emails from all variants and the winner", "name": "aggregate_bounces", "sheet_column": true, "verbose_name": "aggregate bounces" },
                                { "field_type": 4, "help_text": "Number of replies to all variants and the winner", "name": "aggregate_reply_count", "sheet_column": true, "verbose_name": "aggregate reply count" }
                            ]
                        }
                    },
                    "bulk_email": {
                        "BulkEmail": {
                            "__is_model": true,
                            "__name__": "BulkEmail",
                            "data_model": "app.userdata.outbox.models.bulk_email.BulkEmail",
                            "default_exclude_filters": {},
                            "default_filters": { "archived": false, "variant_of__isnull": true, "winner_of__isnull": true },
                            "endpoint": "/api/bulkemail/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "field_type": 7,
                                    "help_text": "User id of the person that created the email; not always the same as the from_user (the email sender)",
                                    "name": "user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "user"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "User id of the email sender; not always the same as the user_id (the email creator)",
                                    "name": "from_user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "from user"
                                },
                                { "field_type": 2, "help_text": "The name that is shown in the Email from field. Defaults to quorum user", "name": "from_name", "sheet_column": true, "verbose_name": "from name" },
                                { "field_type": 2, "help_text": "address email was sent from", "name": "from_address", "verbose_name": "from address" },
                                {
                                    "field_type": 7,
                                    "help_text": "id of the person receiving reply emails",
                                    "name": "reply_to_user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "reply to user"
                                },
                                { "field_type": 2, "help_text": "name of person getting reply", "name": "reply_to_name", "verbose_name": "reply to name" },
                                { "field_type": 2, "help_text": "Email address that responses are directed to", "name": "reply_to_address", "verbose_name": "reply to address" },
                                { "field_type": null, "help_text": "array holding email addresses for bcc recipients", "name": "bcc_rcpts", "verbose_name": "bcc rcpts" },
                                { "field_type": null, "help_text": "array holding email addresses for cc recipients", "name": "cc_rcpts", "verbose_name": "cc rcpts" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "EmailStatus" },
                                    "field_type": 4,
                                    "help_text": "The current status of an email",
                                    "name": "current_status",
                                    "sheet_column": true,
                                    "verbose_name": "current status"
                                },
                                { "field_type": 1, "help_text": "Marks whether the email is a draft", "name": "is_draft", "sheet_column": true, "verbose_name": "is draft" },
                                { "field_type": 1, "help_text": "Have this email's send_emails been archived", "name": "is_moved", "verbose_name": "is moved" },
                                { "field_type": 1, "help_text": "Have this email's message_events been archived", "name": "is_message_events_archived", "verbose_name": "is message events archived" },
                                { "field_type": 1, "help_text": "Have this email's feed_items been archived", "name": "is_feed_events_archived", "verbose_name": "is feed events archived" },
                                { "field_type": 1, "help_text": "Marks whether the email has had a user save, if this isfalse, the message was created, but had no user input", "name": "saved_by_user", "verbose_name": "saved by user" },
                                { "field_type": 1, "help_text": "Marks whether or not the message will have an unsubscribe", "name": "unsubscribe_enabled", "verbose_name": "unsubscribe enabled" },
                                { "field_type": 1, "help_text": "Marks if the unsubscribe text link will use the custom version set in org settings", "name": "is_custom_unsubscribe", "verbose_name": "is custom unsubscribe" },
                                { "field_type": 1, "help_text": "Marks whether or not the sending of the email was delayed", "name": "is_scheduled", "verbose_name": "is scheduled" },
                                { "field_type": 2, "help_text": "The YYYY-mm-ddThh:mm:ss-hh:mm string of whento send the email. ", "name": "scheduled_send_time", "verbose_name": "scheduled send time" },
                                { "field_type": 16, "help_text": "The time the bulk email is scheduled to be sent. If scheduled to be sent now, then set to current time", "name": "sent_datetime", "sheet_column": true, "verbose_name": "sent datetime" },
                                { "field_type": 1, "help_text": "This bool indicates if the email is pre outbox 2.0", "name": "old_outbox_email", "verbose_name": "old outbox email" },
                                { "field_type": 1, "help_text": "Marks whether the email is currently updating", "name": "is_updating", "verbose_name": "is updating" },
                                { "field_type": 1, "help_text": "Indicates whether the personal email of a Person should be used", "name": "use_personal_email", "verbose_name": "use personal email" },
                                { "field_type": 1, "help_text": "Indicates whether all cc'd recipients should receive and email", "name": "should_cc_all", "verbose_name": "should cc all" },
                                { "field_type": 16, "help_text": "the time the email was last updated", "name": "last_updated", "sheet_column": true, "verbose_name": "last updated" },
                                { "field_type": 4, "help_text": "Indicates whether this email experienced a SparkpostException and how many times we have tried to resend it using ResendFailedRecipientBulkEmailsCronJob. If you want to repurpose this field, PLEASE make sure it still serves its purpose in the cron", "name": "attempted_resend_count", "verbose_name": "attempted resend count" },
                                { "field_type": null, "help_text": "This is the array of variables in the email, limit 30", "name": "merge_variables", "verbose_name": "merge variables" },
                                { "field_type": null, "help_text": "the selected json", "name": "selection_json", "verbose_name": "selection json" },
                                { "field_type": null, "help_text": "the new selected json", "name": "selection_json_old", "verbose_name": "selection json old" },
                                { "field_type": null, "help_text": "the excludes json", "name": "excludes_json", "verbose_name": "excludes json" },
                                { "field_type": null, "help_text": "the excludes json", "name": "excludes_json_old", "verbose_name": "excludes json old" },
                                { "field_type": 2, "help_text": "The subject of the email", "name": "subject", "verbose_name": "subject" },
                                { "field_type": 2, "help_text": "the type of compose tool used", "name": "compose_tool", "verbose_name": "compose tool" },
                                { "field_type": 3, "help_text": "The pure text of the email", "name": "text", "verbose_name": "text" },
                                { "field_type": 3, "help_text": "html content of the email", "name": "html_content", "verbose_name": "html content" },
                                { "field_type": null, "help_text": "json from the email template if they choose to use one", "name": "json_content", "verbose_name": "json content" },
                                { "field_type": 4, "help_text": "Number of emails sent in the bulk email", "name": "email_count", "sheet_column": true, "verbose_name": "email count" },
                                { "field_type": 4, "help_text": "Number of supporters selected", "name": "supporter_count", "sheet_column": true, "verbose_name": "supporter count" },
                                { "field_type": 4, "help_text": "Number of people selected", "name": "person_count", "sheet_column": true, "verbose_name": "person count" },
                                { "field_type": 4, "help_text": "Number of press contacts selected", "name": "press_count", "sheet_column": true, "verbose_name": "press count" },
                                { "field_type": 4, "help_text": "Number of emails excluded in the bulk email", "name": "excluded_email_count", "sheet_column": true, "verbose_name": "excluded email count" },
                                { "field_type": 4, "help_text": "Number of supporters excluded", "name": "excluded_supporter_count", "sheet_column": true, "verbose_name": "excluded supporter count" },
                                { "field_type": 4, "help_text": "Number of people excluded", "name": "excluded_person_count", "sheet_column": true, "verbose_name": "excluded person count" },
                                { "field_type": 4, "help_text": "Number of press contacts excluded", "name": "excluded_press_count", "sheet_column": true, "verbose_name": "excluded press count" },
                                { "field_type": 4, "help_text": "How many emails sent by the bulk email have been opened", "name": "opens", "sheet_column": true, "verbose_name": "opens" },
                                { "field_type": 4, "help_text": "Number of emails sent by the bulk email with initial_open events (top pixel opens)", "name": "initial_opens", "verbose_name": "initial opens" },
                                { "field_type": 4, "help_text": "Number of MessageEvents with prefetched_open event names for this bulk email", "name": "prefetched_opens", "sheet_column": true, "verbose_name": "prefetched opens" },
                                { "field_type": 4, "help_text": "How many emails sent by the bulk email have been opened, including prefetched opens", "name": "opens_with_prefetched", "sheet_column": true, "verbose_name": "opens with prefetched" },
                                { "field_type": 6, "help_text": "Number of opened emails divided by the number sent.", "name": "open_rate", "sheet_column": true, "verbose_name": "open rate" },
                                { "field_type": 6, "help_text": "Number of opened emails, including prefetched opens, divided by the number sent", "name": "open_rate_with_prefetched", "sheet_column": true, "verbose_name": "open rate with prefetched" },
                                { "field_type": 4, "help_text": "How many emails sent by the bulk email have been clicked", "name": "clicks", "sheet_column": true, "verbose_name": "clicks" },
                                { "field_type": 6, "help_text": "Number of clicked emails divided by the number sent.", "name": "click_rate", "sheet_column": true, "verbose_name": "click rate" },
                                { "field_type": 4, "help_text": "How many contacts unsubscribed from Outbox emails through a link on this email", "name": "unsubscribes", "sheet_column": true, "verbose_name": "unsubscribes" },
                                { "field_type": 4, "help_text": "How many emails sent by the bulk email have bounced", "name": "bounces", "verbose_name": "bounces" },
                                { "field_type": 4, "help_text": "How many emails sent by the bulk email to supporters have bounced", "name": "supporter_bounces", "verbose_name": "supporter bounces" },
                                { "field_type": 4, "help_text": "How many grassroots actions took place as a direct result of the links in this email", "name": "actions", "sheet_column": true, "verbose_name": "actions" },
                                { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                                { "field_type": 4, "help_text": "the number of replies to a bulkemail", "name": "reply_count", "sheet_column": true, "verbose_name": "reply count" },
                                { "field_type": null, "help_text": "the sparkpost transmissions", "name": "transmission_json", "verbose_name": "transmission json" },
                                { "field_type": null, "help_text": "the failed rcpt chunks for any large emails (>7500)", "name": "failed_recipients", "verbose_name": "failed recipients" },
                                {
                                    "field_type": 7,
                                    "help_text": "the organization associated with a bulk_email",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                { "field_type": 2, "help_text": "A custom field that allows users to match this bulk email to a bulk email in an external system.", "name": "external_id", "verbose_name": "external id" },
                                {
                                    "field_type": 7,
                                    "help_text": "the CustomEvent associated with this BulkEmail",
                                    "name": "custom_event",
                                    "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                    "verbose_name": "custom event"
                                },
                                { "field_type": 1, "help_text": "Determine whether the email should be sent from recipients' assignments", "name": "send_from_assignments", "verbose_name": "send from assignments" },
                                { "field_type": 1, "help_text": "Determine whether the email should reply to recipients' assignments", "name": "reply_to_assignments", "verbose_name": "reply to assignments" },
                                { "field_type": null, "help_text": "store the ai suggestions requested for this email", "name": "ai_suggestion", "verbose_name": "ai suggestion" },
                                {
                                    "field_type": 7,
                                    "help_text": "FK of the last user that edited this email in any way.",
                                    "name": "last_user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "last user"
                                },
                                { "field_type": 4, "help_text": "Version number of the bulk email's content.This value is incremented on every succesful save, to prevent concurrent saves erasing someones work.If a client attempts to save a BulkEmail without the passing in the current content_version, there is a potential save conflict.", "name": "content_version", "verbose_name": "content version" },
                                {
                                    "field_type": 7,
                                    "help_text": "AB tested BulkEmail that this BulkEmail is a variant of",
                                    "name": "variant_of",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "variant of"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "AB Test Variant that this email is copied from, which we may send later as the winner",
                                    "name": "winner_of",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "winner of"
                                },
                                { "field_type": 1, "help_text": "Determine whether the email should have a staggered send cadence", "name": "should_stagger_send", "verbose_name": "should stagger send" },
                                { "field_type": 1, "help_text": "Whether the record was created via an import to the system.", "name": "was_imported", "verbose_name": "was imported" },
                                {
                                    "field_type": 8,
                                    "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                    "name": "limited_to_teams",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                    "verbose_name": "limited to teams"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "",
                                    "name": "selected_searches",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                    "verbose_name": "selected searches"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "",
                                    "name": "excluded_searches",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                    "verbose_name": "excluded searches"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "The project for which the email was sent",
                                    "name": "projects",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                    "verbose_name": "projects"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "All the Bulk Upload Files that created/modified this record.",
                                    "name": "bulk_upload_files",
                                    "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                    "verbose_name": "bulk upload files"
                                }
                            ]
                        }
                    },
                    "email_domain": {
                        "EmailDomain": {
                            "__is_model": true,
                            "__name__": "EmailDomain",
                            "data_model": "app.userdata.outbox.models.email_domain.EmailDomain",
                            "default_exclude_filters": {},
                            "default_filters": { "archived": false },
                            "endpoint": "/api/emaildomain/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "Associated private IP Pool",
                                    "name": "ip_pool",
                                    "related_model": { "__module__": "app.userdata.outbox.models.ip_pool", "__name__": "IPPool" },
                                    "verbose_name": "ip pool"
                                },
                                { "field_type": 2, "help_text": "The name of the domain (ex: walmart.quorum.us)", "name": "domain", "verbose_name": "domain" },
                                { "field_type": 1, "help_text": "Whether emails should be routed (through Quorum), Should be True for domains that end with 'quorum.us'", "name": "should_route", "verbose_name": "should route" },
                                { "field_type": 2, "help_text": "The name of the bounce domain (ex: bounces.quorumoutbox.com)", "name": "bounce_domain", "verbose_name": "bounce domain" },
                                { "field_type": 1, "help_text": "Whether the domain can be used - only true if domain and dkim are verified", "name": "is_active", "verbose_name": "is active" },
                                { "field_type": 5, "help_text": "The date the last status checks of domain, dkim, and bounce domain.", "name": "date_verified", "verbose_name": "date verified" },
                                { "field_type": 1, "help_text": "Whether the domain has been verified for sending by Sparkpost", "name": "is_domain_verified", "verbose_name": "is domain verified" },
                                { "field_type": 1, "help_text": "Whether the domain has been verified with DKIM-Signing by Sparkpost", "name": "is_dkim_verified", "verbose_name": "is dkim verified" },
                                { "field_type": 1, "help_text": "Whether the domain has a SPF record, checked by Sparkpost", "name": "is_spf_verified", "verbose_name": "is spf verified" },
                                { "field_type": 1, "help_text": "Whether the domain has an A record, checked by dnspython", "name": "is_a_record_verified", "verbose_name": "is a record verified" },
                                { "field_type": 1, "help_text": "Whether the domain is an inbound domain, checked by Sparkpost", "name": "is_inbound_domain_verified", "verbose_name": "is inbound domain verified" },
                                { "field_type": 1, "help_text": "Whether the domain has a relay webhook, checked by Sparkpost", "name": "is_relay_webhook_verified", "verbose_name": "is relay webhook verified" },
                                { "field_type": 1, "help_text": "Whether the mx records for the domain has been verified, checked by dnspython", "name": "is_mx_verified", "verbose_name": "is mx verified" },
                                { "field_type": 1, "help_text": "Whether the bounce domain has been verified by Sparkpost", "name": "is_bounce_verified", "verbose_name": "is bounce verified" },
                                { "field_type": 1, "help_text": "Whether the domain has a high bounce rates or otherwise bad rep, if so use default/public IP Pool", "name": "has_bad_reputation", "verbose_name": "has bad reputation" }
                            ]
                        }
                    },
                    "email_template": {
                        "EmailTemplate": {
                            "__is_model": true,
                            "__name__": "EmailTemplate",
                            "data_model": "app.userdata.outbox.models.email_template.EmailTemplate",
                            "default_exclude_filters": {},
                            "default_filters": { "archived": false },
                            "endpoint": "/api/emailtemplate/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "creator",
                                    "related_model": { "__module__": "django.contrib.auth.models", "__name__": "User" },
                                    "verbose_name": "creator"
                                },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                { "field_type": 2, "help_text": "The name of the template", "name": "name", "verbose_name": "name" },
                                { "field_type": 3, "help_text": "HTML content of the template", "name": "html_content", "verbose_name": "html content" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "last_editor",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "last editor"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                { "field_type": null, "help_text": "the selected json", "name": "json_content", "verbose_name": "json content" },
                                { "field_type": 2, "help_text": "The url of the screenshot image.", "name": "template_screenshot_url", "verbose_name": "template screenshot url" },
                                { "field_type": 2, "help_text": "the type of compose tool used", "name": "compose_tool", "verbose_name": "compose tool" },
                                {
                                    "field_type": 8,
                                    "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                    "name": "limited_to_teams",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                    "verbose_name": "limited to teams"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "",
                                    "name": "projects",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                    "verbose_name": "projects"
                                }
                            ]
                        }
                    },
                    "message_event": {
                        "MessageEvent": {
                            "__is_model": true,
                            "__name__": "MessageEvent",
                            "data_model": "app.userdata.outbox.models.message_event.MessageEvent",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/messageevent/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "bulk_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "bulk email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "send_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.send_email", "__name__": "SendEmail" },
                                    "verbose_name": "send email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "pdf_email",
                                    "related_model": { "__module__": "app.generatepdf.models", "__name__": "PDFEmail" },
                                    "verbose_name": "pdf email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "csv_email",
                                    "related_model": { "__module__": "app.generatepdf.models", "__name__": "CSVEmail" },
                                    "verbose_name": "csv email"
                                },
                                { "field_type": null, "help_text": "the event info", "name": "event_json", "verbose_name": "event json" },
                                { "field_type": 2, "help_text": "this is the grouping of events (Event Type on Sparkpost)", "name": "event_type", "verbose_name": "event type" },
                                { "field_type": 2, "help_text": "this is the name of a specific event (ex. click, called Event on Sparkpost)", "name": "event_name", "verbose_name": "event name" },
                                { "field_type": 2, "help_text": "unique event identifier generated by sparkpost", "name": "event_id", "verbose_name": "event id" },
                                { "field_type": 16, "help_text": "timestamp for when the event occurred", "name": "event_timestamp", "verbose_name": "event timestamp" },
                                {
                                    "field_type": 7,
                                    "help_text": "the message event for the supporter action",
                                    "name": "supporter_action",
                                    "related_model": { "__module__": "app.grassroots.models", "__name__": "GrassrootsSupporterAction" },
                                    "verbose_name": "supporter action"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "the message event for the original supporter action",
                                    "name": "old_supporter_action",
                                    "related_model": { "__module__": "app.userdata.notes.models", "__name__": "Note" },
                                    "verbose_name": "old supporter action"
                                }
                            ]
                        }
                    },
                    "reply_email": {
                        "ReplyEmail": {
                            "__is_model": true,
                            "__name__": "ReplyEmail",
                            "data_model": "app.userdata.outbox.models.reply_email.ReplyEmail",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/replyemail/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                { "field_type": 2, "help_text": "email address the message came from", "name": "from_address", "verbose_name": "from address" },
                                { "field_type": 2, "help_text": "email address being that receives the email", "name": "forward_address", "verbose_name": "forward address" },
                                { "field_type": 2, "help_text": "email address being sent to", "name": "to_address", "verbose_name": "to address" },
                                { "field_type": 3, "help_text": "html content of the email", "name": "html_content", "verbose_name": "html content" },
                                { "field_type": 3, "help_text": "the actual body of the email", "name": "text", "verbose_name": "text" },
                                { "field_type": 2, "help_text": "subject of the email", "name": "subject", "verbose_name": "subject" },
                                { "field_type": 3, "help_text": "MIME content for the reply email", "name": "email_mime", "verbose_name": "email mime" },
                                {
                                    "field_type": 7,
                                    "help_text": "the associated bulk email (the one being replied to)",
                                    "name": "bulk_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "bulk email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "the associated send email (the one being replied to)",
                                    "name": "send_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.send_email", "__name__": "SendEmail" },
                                    "verbose_name": "send email"
                                },
                                { "field_type": null, "help_text": "store the entirety of the information from the reply email", "name": "full_content", "verbose_name": "full content" },
                                { "field_type": null, "help_text": "array holding email addresses for to recipients", "name": "to_list", "verbose_name": "to list" },
                                { "field_type": null, "help_text": "array holding email addresses for cc recipients", "name": "cc_list", "verbose_name": "cc list" },
                                { "field_type": 1, "help_text": "This indicates whether the message sent", "name": "sent", "verbose_name": "sent" }
                            ]
                        }
                    },
                    "send_email": {
                        "SendEmail": {
                            "__is_model": true,
                            "__name__": "SendEmail",
                            "data_model": "app.userdata.outbox.models.send_email.SendEmail",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/sendemail/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.alerts.types", "__name__": "DeliveryMedium" },
                                    "field_type": 4,
                                    "help_text": "The medium of delivery of a Deliverable. Default is email.",
                                    "name": "medium",
                                    "verbose_name": "medium"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "The PushNotificationToken we sent the notification to",
                                    "name": "push_notification_token",
                                    "related_model": { "__module__": "app.userdata.push_notifs.models", "__name__": "PushNotificationToken" },
                                    "verbose_name": "push notification token"
                                },
                                { "field_type": null, "help_text": "The extra dict that we're passing along in the push notification", "name": "push_notification_extra", "verbose_name": "push notification extra" },
                                { "field_type": 4, "help_text": "The status code we received from the delivery network if there was an error", "name": "push_notification_error_status_code", "verbose_name": "push notification error status code" },
                                { "field_type": 3, "help_text": "The error message we received from the delivery network if there was one", "name": "push_notification_error_info", "verbose_name": "push notification error info" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.push_notifs.types", "__name__": "PushNotificationError" },
                                    "field_type": 4,
                                    "help_text": "The enum for the corresponding exception we received while sending this notification",
                                    "name": "push_notification_error_enum",
                                    "verbose_name": "push notification error enum"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "TODO",
                                    "name": "staffer",
                                    "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                    "verbose_name": "staffer"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "User who is receiving the message / user who sent it",
                                    "name": "user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "user"
                                },
                                { "field_type": 1, "help_text": "", "name": "instant", "verbose_name": "instant" },
                                { "field_type": 2, "help_text": "Send to email address.  Nullable because push notifications don't use this.", "name": "email_address", "sheet_column": true, "verbose_name": "email address" },
                                { "field_type": 2, "help_text": "First and last name of email recipient", "name": "recipient_name", "sheet_column": true, "verbose_name": "recipient name" },
                                {
                                    "field_type": 7,
                                    "help_text": "Organization that owns this sendemail",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                { "field_type": null, "help_text": "Array of ids of teams this SendEmail is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                                { "field_type": 1, "help_text": "Whether this send used a PAC email address", "name": "is_pac_email", "verbose_name": "is pac email" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "EmailAddressSource" },
                                    "field_type": 4,
                                    "help_text": "Source of the email address used for this send",
                                    "name": "email_address_source",
                                    "verbose_name": "email address source"
                                },
                                { "field_type": null, "help_text": "The dict needed for sending in sparkpost", "name": "rcpt_dict", "verbose_name": "rcpt dict" },
                                { "field_type": 1, "help_text": "Whether the SendEmail has been sent", "name": "sent", "verbose_name": "sent" },
                                { "field_type": 16, "help_text": "The datetime that this deliverable was sent", "name": "sent_datetime", "verbose_name": "sent datetime" },
                                { "field_type": 2, "help_text": "Status given by Sparkpost after email is sent", "name": "sparkpost_status", "sheet_column": true, "verbose_name": "sparkpost status" },
                                { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "sheet_column": true, "verbose_name": "opens" },
                                { "field_type": 4, "help_text": "Number of initial_open events (top pixel opens) for this email", "name": "initial_opens", "verbose_name": "initial opens" },
                                { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "sheet_column": true, "verbose_name": "clicks" },
                                { "field_type": 4, "help_text": "Number of times this email bounced", "name": "bounces", "verbose_name": "bounces" },
                                { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                                { "field_type": 16, "help_text": "timestamp for when the event occurred", "name": "first_open", "verbose_name": "first open" },
                                { "field_type": 16, "help_text": "timestamp for when the event occurred", "name": "first_click", "verbose_name": "first click" },
                                { "field_type": 1, "help_text": "", "name": "did_reply", "sheet_column": true, "verbose_name": "did reply" },
                                { "field_type": 2, "help_text": "Reject reason given by Sparkpost if email is sent and rejected", "name": "sparkpost_reject_reason", "verbose_name": "sparkpost reject reason" },
                                { "field_type": 2, "help_text": "Unique id generated by Sparkpost after the email is sent", "name": "sparkpost_id", "verbose_name": "sparkpost id" },
                                { "field_type": 2, "help_text": "Unique transmission id generated by Sparkpost after the email is sent", "name": "transmission_id", "verbose_name": "transmission id" },
                                { "field_type": 1, "help_text": "", "name": "email_alert", "verbose_name": "email alert" },
                                { "field_type": null, "help_text": "A cache of alerts information on this deliverable. Includes the IDs of all AlertGroups, Alerts, and FeedItems in the body of this message.  Additionally, for SendEmail Alerts, this is used for no-alerts overrides.", "name": "alert_cache", "verbose_name": "alert cache" },
                                { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                                { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                                { "field_type": 2, "help_text": "Unique view_in_browser_id generated for each SendEmail", "name": "view_in_browser_id", "verbose_name": "view in browser id" },
                                { "field_type": 1, "help_text": "Whether the record was created via an import to the system.", "name": "was_imported", "verbose_name": "was imported" },
                                { "field_type": 2, "help_text": "A field that allows users to match this send email to a sent email in an external system.", "name": "external_id", "verbose_name": "external id" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "bulk_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "bulk email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "person",
                                    "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                    "verbose_name": "person"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "supporter",
                                    "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                    "verbose_name": "supporter"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "All the Bulk Upload Files that created/modified this record.",
                                    "name": "bulk_upload_files",
                                    "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                    "verbose_name": "bulk upload files"
                                }
                            ]
                        },
                        "SendEmailArchived": {
                            "__is_model": true,
                            "__name__": "SendEmailArchived",
                            "data_model": "app.userdata.outbox.models.send_email.SendEmailArchived",
                            "default_exclude_filters": {},
                            "default_filters": {},
                            "endpoint": "/api/sendemailarchived/",
                            "fields": [
                                { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                                { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                                { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                                { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.alerts.types", "__name__": "DeliveryMedium" },
                                    "field_type": 4,
                                    "help_text": "The medium of delivery of a Deliverable. Default is email.",
                                    "name": "medium",
                                    "verbose_name": "medium"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "The PushNotificationToken we sent the notification to",
                                    "name": "push_notification_token",
                                    "related_model": { "__module__": "app.userdata.push_notifs.models", "__name__": "PushNotificationToken" },
                                    "verbose_name": "push notification token"
                                },
                                { "field_type": null, "help_text": "The extra dict that we're passing along in the push notification", "name": "push_notification_extra", "verbose_name": "push notification extra" },
                                { "field_type": 4, "help_text": "The status code we received from the delivery network if there was an error", "name": "push_notification_error_status_code", "verbose_name": "push notification error status code" },
                                { "field_type": 3, "help_text": "The error message we received from the delivery network if there was one", "name": "push_notification_error_info", "verbose_name": "push notification error info" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.push_notifs.types", "__name__": "PushNotificationError" },
                                    "field_type": 4,
                                    "help_text": "The enum for the corresponding exception we received while sending this notification",
                                    "name": "push_notification_error_enum",
                                    "verbose_name": "push notification error enum"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "TODO",
                                    "name": "staffer",
                                    "related_model": { "__module__": "app.person.models", "__name__": "Staffer" },
                                    "verbose_name": "staffer"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "User who is receiving the message / user who sent it",
                                    "name": "user",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                    "verbose_name": "user"
                                },
                                { "field_type": 1, "help_text": "", "name": "instant", "verbose_name": "instant" },
                                { "field_type": 2, "help_text": "Send to email address.  Nullable because push notifications don't use this.", "name": "email_address", "sheet_column": true, "verbose_name": "email address" },
                                { "field_type": 2, "help_text": "First and last name of email recipient", "name": "recipient_name", "sheet_column": true, "verbose_name": "recipient name" },
                                {
                                    "field_type": 7,
                                    "help_text": "Organization that owns this sendemail",
                                    "name": "organization",
                                    "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                    "verbose_name": "organization"
                                },
                                { "field_type": null, "help_text": "Array of ids of teams this SendEmail is permissioned to", "name": "cached_limited_to_teams", "verbose_name": "cached limited to teams" },
                                { "field_type": 1, "help_text": "Whether this send used a PAC email address", "name": "is_pac_email", "verbose_name": "is pac email" },
                                {
                                    "_is_enum_field": true,
                                    "choices": { "__module__": "app.userdata.outbox.types", "__name__": "EmailAddressSource" },
                                    "field_type": 4,
                                    "help_text": "Source of the email address used for this send",
                                    "name": "email_address_source",
                                    "verbose_name": "email address source"
                                },
                                { "field_type": null, "help_text": "The dict needed for sending in sparkpost", "name": "rcpt_dict", "verbose_name": "rcpt dict" },
                                { "field_type": 1, "help_text": "Whether the SendEmail has been sent", "name": "sent", "verbose_name": "sent" },
                                { "field_type": 16, "help_text": "The datetime that this deliverable was sent", "name": "sent_datetime", "verbose_name": "sent datetime" },
                                { "field_type": 2, "help_text": "Status given by Sparkpost after email is sent", "name": "sparkpost_status", "sheet_column": true, "verbose_name": "sparkpost status" },
                                { "field_type": 4, "help_text": "Number of times email has been opened", "name": "opens", "sheet_column": true, "verbose_name": "opens" },
                                { "field_type": 4, "help_text": "Number of initial_open events (top pixel opens) for this email", "name": "initial_opens", "verbose_name": "initial opens" },
                                { "field_type": 4, "help_text": "Number of times links in email have been clicked", "name": "clicks", "sheet_column": true, "verbose_name": "clicks" },
                                { "field_type": 4, "help_text": "Number of times this email bounced", "name": "bounces", "verbose_name": "bounces" },
                                { "field_type": null, "help_text": "the link -> count key", "name": "link_dict", "verbose_name": "link dict" },
                                { "field_type": 16, "help_text": "timestamp for when the event occurred", "name": "first_open", "verbose_name": "first open" },
                                { "field_type": 16, "help_text": "timestamp for when the event occurred", "name": "first_click", "verbose_name": "first click" },
                                { "field_type": 1, "help_text": "", "name": "did_reply", "sheet_column": true, "verbose_name": "did reply" },
                                { "field_type": 2, "help_text": "Reject reason given by Sparkpost if email is sent and rejected", "name": "sparkpost_reject_reason", "verbose_name": "sparkpost reject reason" },
                                { "field_type": 2, "help_text": "Unique id generated by Sparkpost after the email is sent", "name": "sparkpost_id", "verbose_name": "sparkpost id" },
                                { "field_type": 2, "help_text": "Unique transmission id generated by Sparkpost after the email is sent", "name": "transmission_id", "verbose_name": "transmission id" },
                                { "field_type": 1, "help_text": "", "name": "email_alert", "verbose_name": "email alert" },
                                { "field_type": null, "help_text": "A cache of alerts information on this deliverable. Includes the IDs of all AlertGroups, Alerts, and FeedItems in the body of this message.  Additionally, for SendEmail Alerts, this is used for no-alerts overrides.", "name": "alert_cache", "verbose_name": "alert cache" },
                                { "field_type": 2, "help_text": "", "name": "title", "verbose_name": "title" },
                                { "field_type": 3, "help_text": "", "name": "text", "verbose_name": "text" },
                                { "field_type": 2, "help_text": "Unique view_in_browser_id generated for each SendEmail", "name": "view_in_browser_id", "verbose_name": "view in browser id" },
                                { "field_type": 1, "help_text": "Whether the record was created via an import to the system.", "name": "was_imported", "verbose_name": "was imported" },
                                { "field_type": 2, "help_text": "A field that allows users to match this send email to a sent email in an external system.", "name": "external_id", "verbose_name": "external id" },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "bulk_email",
                                    "related_model": { "__module__": "app.userdata.outbox.models.bulk_email", "__name__": "BulkEmail" },
                                    "verbose_name": "bulk email"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "person",
                                    "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                    "verbose_name": "person"
                                },
                                {
                                    "field_type": 7,
                                    "help_text": "",
                                    "name": "supporter",
                                    "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                    "verbose_name": "supporter"
                                },
                                {
                                    "field_type": 8,
                                    "help_text": "All the Bulk Upload Files that created/modified this record.",
                                    "name": "bulk_upload_files",
                                    "related_model": { "__module__": "app.custom_data.models", "__name__": "BulkUploadFile" },
                                    "verbose_name": "bulk upload files"
                                }
                            ]
                        }
                    }
                },
                "types": {
                    "ABTestMetric": {
                        "__is_enum": true,
                        "click_open_rate": { "description": "CTOR measures the percentage of recipients who open the email and click on the call-to-action link.", "key": "click_open_rate", "label": "Click to Open Rate (CTOR)", "value": 3 },
                        "click_rate": { "description": "CTR measures the number of clicks your emails got divided by the number of emails delivered.", "key": "click_rate", "label": "Click-Through Rate (CTR)", "value": 2 },
                        "open_rate": { "description": "Open Rate measures how many emails were opened divided by how many were delivered.", "key": "open_rate", "label": "Open Rate", "value": 1 }
                    },
                    "ABTestMode": {
                        "__is_enum": true,
                        "learning": { "description": "At the end of the test, you may review the results, and decide which variant performed best.", "key": "learning", "label": "Send Without a Winner", "value": 1 },
                        "send_best": { "description": "At the end of the test, Quorum will automatically determine the best performing variant, and send it to the remaining recipients.", "key": "send_best", "label": "Send With a Winner", "value": 2 }
                    },
                    "ABTestStatus": {
                        "__is_enum": true,
                        "complete": { "help_text": "The test has been concluded.", "key": "complete", "label": "Complete", "value": 7 },
                        "delivering": { "help_text": "The first emails are being delivered.", "key": "delivering", "label": "Delivering", "value": 5 },
                        "draft": { "help_text": "The AB test has not yet been started.", "key": "draft", "label": "Draft", "value": 1 },
                        "errored": { "help_text": "There was an error while processing the AB test.", "key": "errored", "label": "Errored", "value": 8 },
                        "processing": { "help_text": "The AB test is being processed by Quorum, and BulkEmails are being scheduled.", "key": "processing", "label": "Processing", "value": 3 },
                        "running": { "help_text": "All emails have been delivered, and Quorum is gathering results.", "key": "running", "label": "Running", "value": 6 },
                        "scheduled": { "help_text": "All BulkEmails have been scheduled and the test is waiting to begin.", "key": "scheduled", "label": "Scheduled", "value": 4 },
                        "unprocessed": { "help_text": "The AB test has been started, and we are waiting for Quorum to begin processing it.", "key": "unprocessed", "label": "Unprocessed", "value": 2 }
                    },
                    "ABTestVariable": {
                        "__is_enum": true,
                        "body": {
                            "field": "text",
                            "fields": ["compose_tool", "html_content", "json_content"],
                            "help_text": "Test a maximum of 2 email types with this test type. Change anything within the body of the email.",
                            "key": "body",
                            "label": "Email Content",
                            "tip": "Tests different email content with different audiences \u2014 one of which sees one email, and the second group sees the other.",
                            "value": 2
                        },
                        "from_address": {
                            "field": "from_address",
                            "fields": ["from_address", "from_name", "from_user"],
                            "help_text": "Test a maximum of 2 sender emails with this test type.",
                            "key": "from_address",
                            "label": "Sender Email",
                            "tip": "Tests the same email to different audiences \u2014 one of which sees one sender email, and the second group sees the other.",
                            "value": 3
                        },
                        "subject": {
                            "field": "subject",
                            "fields": ["subject"],
                            "help_text": "Test a maximum of 2 subject lines with this test type.",
                            "key": "subject",
                            "label": "Subject Line",
                            "tip": "Tests the same email to different audiences \u2014 one of which sees one subject line, and the second group sees the other.",
                            "value": 1
                        }
                    },
                    "EmailAddressSource": {
                        "__is_enum": true,
                        "pac": { "help_text": "Email address from PAC data", "key": "pac", "label": "pac", "value": 2, "verbose_name": "PAC Email" },
                        "primary": { "help_text": "The primary email address stored in Quorum", "key": "primary", "label": "primary", "value": 1, "verbose_name": "Primary Email" }
                    },
                    "EmailReport": {
                        "__is_enum": true,
                        "all_message_events": {
                            "display_fields": [],
                            "download": "All Email Events",
                            "grouping_fields": [],
                            "help_text": "This will generate a report that will show every open and click event that took place on your emails.",
                            "key": "all_message_events",
                            "label": "all_message_events",
                            "override_url": "/api/messageevent/?bulk_email__in=BULK_EMAIL_IDS&format=csv",
                            "show_in_detail_page": true,
                            "show_in_overview_page": false,
                            "value": 4,
                            "verbose_name": "Full event report"
                        },
                        "bulk_email": {
                            "display_fields": [],
                            "download": "Per Email Report",
                            "grouping_fields": ["id"],
                            "help_text": "This will generate a report that will show the aggregrated email statistics for each of your emails",
                            "key": "bulk_email",
                            "label": "per_bulk_email",
                            "show_in_detail_page": false,
                            "show_in_overview_page": true,
                            "value": 3,
                            "verbose_name": "Per email report"
                        },
                        "message_preview": {
                            "display_fields": [],
                            "download": "Message Preview",
                            "grouping_fields": [],
                            "help_text": "This will generate a PDF of the message that you can then download",
                            "key": "message_preview",
                            "label": "message_preview",
                            "override_url": "/api/bulkemail/BULK_EMAIL_IDS/view_pdf_in_browser/",
                            "show_in_detail_page": true,
                            "show_in_overview_page": false,
                            "value": 5,
                            "verbose_name": "Message Preview"
                        },
                        "organization": {
                            "display_fields": ["supporter__public_organization__name", "person__primary_organization__name"],
                            "download": "Per Organization Report",
                            "grouping_fields": ["supporter__public_organization_id", "person__primary_organization_id"],
                            "help_text": "This will generate a report that shows the email statistics grouped by organization / office",
                            "key": "organization",
                            "label": "per_organization",
                            "show_in_detail_page": true,
                            "show_in_overview_page": true,
                            "value": 2,
                            "verbose_name": "Per organization / office report"
                        },
                        "recipient": {
                            "display_fields": ["recipient_name", "email_address"],
                            "download": "Per Recipient Report",
                            "grouping_fields": ["email_address"],
                            "help_text": "This will generate a report that shows the email statistics for each recipient",
                            "key": "recipient",
                            "label": "per_recipient",
                            "show_in_detail_page": true,
                            "show_in_overview_page": true,
                            "value": 1,
                            "verbose_name": "Per recipient report"
                        }
                    },
                    "EmailStatus": {
                        "__is_enum": true,
                        "cancelled": { "help_text": "Message has been cancelled", "key": "cancelled", "label": "cancelled", "scheduled_name": "Cancelled", "scheduled_text": "Message has been cancelled", "value": 8, "verbose_name": "Cancelled" },
                        "delivered": { "help_text": "Message has been delivered", "key": "delivered", "label": "delivered", "scheduled_name": "Delivered", "scheduled_text": "Message has been delivered", "value": 9, "verbose_name": "Delivered" },
                        "draft": { "help_text": "Message is saved as a Draft", "key": "draft", "label": "draft", "scheduled_name": "Draft", "scheduled_text": "Message is saved as a Draft", "value": 1, "verbose_name": "Draft" },
                        "errored": { "help_text": "This email has errored", "key": "errored", "label": "errored", "scheduled_name": "Errored", "scheduled_text": "This email has errored", "value": 12, "verbose_name": "Errored" },
                        "flagged_as_duplicate": { "help_text": "This email has been flagged as a duplicate.", "key": "flagged_as_duplicate", "label": "flagged_as_duplicate", "scheduled_name": "flagged_as_duplicate", "scheduled_text": "This email has been flagged as a duplicate.", "value": 13, "verbose_name": "Flagged as Duplicate" },
                        "injected": { "help_text": "Email is picked up by the sending cron and is in process of being sent to SparkPost", "key": "injected", "label": "injected", "scheduled_name": "Injected", "scheduled_text": "Message has been received by Quorum's Servers", "value": 4, "verbose_name": "Injected" },
                        "injecting": { "help_text": "Email is waiting to be picked up by the sending cron to be sent to SparkPost", "key": "injecting", "label": "injecting", "scheduled_name": "Injecting", "scheduled_text": "Quorum's servers are receiving the message", "value": 3, "verbose_name": "Injecting" },
                        "invalid_email_address": { "help_text": "This email's supporter has an invalid email address.", "key": "invalid_email_address", "label": "invalid_email_address", "scheduled_name": "invalid_email_address", "scheduled_text": "This email's supporter has an invalid email address.", "value": 15, "verbose_name": "Invalid Email Address" },
                        "processing": { "help_text": "Message is being processed by Quorum's Servers", "key": "processing", "label": "processing", "scheduled_name": "Processing", "scheduled_text": "Message is being processed by Quorum's Servers", "value": 5, "verbose_name": "Processing" },
                        "resending": { "help_text": "Message is being resent", "key": "resending", "label": "resending", "scheduled_name": "Resending", "scheduled_text": "Message is being resent", "value": 10, "verbose_name": "Resending" },
                        "scheduled": { "help_text": "This email has been scheduled to send.", "key": "scheduled", "label": "scheduled", "scheduled_name": "Scheduled", "scheduled_text": "This email has been scheduled to send.", "value": 14, "verbose_name": "Scheduled" },
                        "sending": { "help_text": "Message is being sent", "key": "sending", "label": "sending", "scheduled_name": "Scheduling", "scheduled_text": "Message is being scheduled", "value": 6, "verbose_name": "Sending" },
                        "sent": { "help_text": "Email passed checks in Quorum and was sent to SparkPost This does NOT mean it was delivered to the recipients", "key": "sent", "label": "sent", "scheduled_name": "Injected", "scheduled_text": "Message has been scheduled", "value": 7, "verbose_name": "Injected" },
                        "testing": { "help_text": "A test email is being built", "key": "testing", "label": "testing", "scheduled_name": "Testing", "scheduled_text": "A test email is being built", "value": 2, "verbose_name": "Testing" },
                        "unprocessed": { "help_text": "This email is currently unprocessed", "key": "unprocessed", "label": "unprocessed", "scheduled_name": "Unprocessed", "scheduled_text": "This email is currently unprocessed", "value": 11, "verbose_name": "Unprocessed" }
                    },
                    "PlaceholderType": {
                        "__is_enum": true,
                        "committee_staffer": { "key": "committee_staffer", "label": "Committee Staffer", "value": 5 },
                        "confirmation_email": { "key": "confirmation_email", "label": "confirmation_email", "value": 9 },
                        "executive": { "key": "executive", "label": "Executive", "value": 1 },
                        "executive_staffer": { "key": "executive_staffer", "label": "Executive Staffer", "value": 3 },
                        "filter_groups": [
                            {
                                "display": "list",
                                "title": "officials",
                                "values": [1, 2]
                            },
                            {
                                "display": "list",
                                "title": "legislative",
                                "values": [2, 4, 5]
                            },
                            {
                                "display": "list",
                                "title": "staffers",
                                "values": [3, 4, 5]
                            },
                            {
                                "display": "list",
                                "title": "people",
                                "values": [1, 2, 3, 4, 5, 10]
                            },
                            {
                                "display": "list",
                                "title": "all_types",
                                "values": [1, 2, 3, 4, 5, 10, 6]
                            }
                        ],
                        "grassroots_contact": { "key": "grassroots_contact", "label": "Contact", "value": 7 },
                        "grassroots_target": { "key": "grassroots_target", "label": "Target", "value": 8 },
                        "legislative_staffer": { "key": "legislative_staffer", "label": "Legislative Staffer", "value": 4 },
                        "legislator": { "key": "legislator", "label": "Legislator", "value": 2 },
                        "press_contact": { "key": "press_contact", "label": "Press Contact", "value": 10 },
                        "supporter": { "key": "supporter", "label": "Supporter", "value": 6 }
                    },
                    "SentToType": {
                        "__is_enum": true,
                        "to_contact": {
                            "key": "to_contact",
                            "label": "Sent to Contact",
                            "person_types": [],
                            "value": 4
                        },
                        "to_official": {
                            "key": "to_official",
                            "label": "Sent to Official",
                            "person_types": [1, 3, 6, 7, 8],
                            "value": 1
                        },
                        "to_press": {
                            "key": "to_press",
                            "label": "Sent to Press",
                            "person_types": [9],
                            "value": 3
                        },
                        "to_staffer": {
                            "key": "to_staffer",
                            "label": "Sent to Staffer",
                            "person_types": [2],
                            "value": 2
                        }
                    }
                }
            },
            "push_notifs": {
                "models": {
                    "MobileOS": {
                        "__is_enum": true,
                        "android": { "default_delivery_network": 2, "key": "android", "label": "Android", "value": 2 },
                        "ios": { "default_delivery_network": 2, "key": "ios", "label": "iOS", "value": 1 }
                    }
                }
            },
            "review": {
                "models": {
                    "Review": {
                        "__is_model": true,
                        "__name__": "Review",
                        "data_model": "app.userdata.review.models.Review",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/review/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "regulation",
                                "related_model": { "__module__": "app.reg.models", "__name__": "Regulation" },
                                "verbose_name": "regulation"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "document",
                                "related_model": { "__module__": "app.document.models", "__name__": "Document" },
                                "verbose_name": "document"
                            },
                            { "field_type": 4, "help_text": "", "name": "article", "verbose_name": "article" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            }
                        ]
                    }
                }
            },
            "spreadsheet": {
                "data_types": {
                    "ColumnDataType": {
                        "__is_enum": true,
                        "boolean": { "help_text": "", "key": "boolean", "label": "Boolean", "should_show_column_math": false, "value": 1 },
                        "currency": { "help_text": "Support the ability to sort and filter currency in sheets.", "key": "currency", "label": "currency", "should_show_column_math": true, "value": 14 },
                        "date": { "help_text": "", "key": "date", "label": "Date", "should_show_column_math": false, "value": 7 },
                        "decimal": { "help_text": "", "key": "decimal", "label": "Decimal", "should_show_column_math": true, "value": 4 },
                        "enum_value": { "help_text": "", "key": "enum_value", "label": "Enum Value", "should_show_column_math": false, "value": 9 },
                        "field": { "help_text": "", "key": "field", "label": "Field", "should_show_column_math": false, "value": 10 },
                        "integer": { "help_text": "", "key": "integer", "label": "Integer", "should_show_column_math": true, "value": 3 },
                        "json": { "help_text": "", "key": "json", "label": "JSON", "should_show_column_math": false, "value": 6 },
                        "link": { "help_text": "", "key": "link", "label": "Link", "should_show_column_math": false, "value": 11 },
                        "long": { "help_text": "\n            Support the ability to show currency in Sheets. Amounts are represented in the smallest denomination of the currency\n        ", "key": "long", "label": "long", "should_show_column_math": true, "value": 13 },
                        "percent": { "help_text": "", "key": "percent", "label": "Percent", "should_show_column_math": false, "value": 5 },
                        "string": { "help_text": "", "key": "string", "label": "String", "should_show_column_math": false, "value": 2 },
                        "year": { "help_text": "", "key": "year", "label": "Year", "should_show_column_math": false, "value": 12 }
                    }
                },
                "models": {
                    "Column": {
                        "__is_model": true,
                        "__name__": "Column",
                        "data_model": "app.userdata.spreadsheet.models.Column",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/column/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "bill",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                                "verbose_name": "bill"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "vote",
                                "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                                "verbose_name": "vote"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "amendment",
                                "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                                "verbose_name": "amendment"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "sheet",
                                "related_model": { "__module__": "app.userdata.spreadsheet.models", "__name__": "Sheet" },
                                "verbose_name": "sheet"
                            },
                            { "field_type": 4, "help_text": "", "name": "order", "verbose_name": "order" },
                            { "field_type": 2, "help_text": "", "name": "name", "verbose_name": "name" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.spreadsheet.types", "__name__": "SheetColumnType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "column_type",
                                "verbose_name": "column type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            { "field_type": 4, "help_text": "", "name": "width", "verbose_name": "width" },
                            { "field_type": 2, "help_text": "", "name": "field", "verbose_name": "field" },
                            { "field_type": null, "help_text": "", "name": "batch_fields", "verbose_name": "batch fields" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "source_newlist",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "NewList" },
                                "verbose_name": "source newlist"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "first_column",
                                "related_model": { "__module__": "app.userdata.spreadsheet.models", "__name__": "Column" },
                                "verbose_name": "first column"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "second_column",
                                "related_model": { "__module__": "app.userdata.spreadsheet.models", "__name__": "Column" },
                                "verbose_name": "second column"
                            },
                            {
                                "field_type": 7,
                                "help_text": "If not null, stores data that this particular column can reference. For example, for the LastInteractionColumn, the source_saved_search stores the selection of Notes for which this column should base its generate method on",
                                "name": "source_saved_search",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "source saved search"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "source_action_center",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                                "verbose_name": "source action center"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "session",
                                "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                                "verbose_name": "session"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.bill.models", "__name__": "BillTerm" },
                                "verbose_name": "issue"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "stat_name",
                                "related_model": { "__module__": "app.stats.models", "__name__": "StatName" },
                                "verbose_name": "stat name"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.stats.types", "__name__": "NewStatsType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "stat_enum",
                                "verbose_name": "stat enum"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "committee",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Committee" },
                                "verbose_name": "committee"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "caucus",
                                "related_model": { "__module__": "app.committee.models", "__name__": "Caucus" },
                                "verbose_name": "caucus"
                            },
                            { "field_type": 2, "help_text": "", "name": "search_term", "verbose_name": "search term" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_event",
                                "related_model": { "__module__": "app.custom_event.models", "__name__": "CustomEvent" },
                                "verbose_name": "custom event"
                            },
                            { "field_type": 4, "help_text": "", "name": "note_selection_criteria" },
                            { "field_type": null, "help_text": "Allows the user to change the value of the columns. Keyed by the object id and valued by the user's custom value.", "name": "custom_values", "verbose_name": "custom values" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.spreadsheet.types", "__name__": "StafferColumnType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "staffer_column_type",
                                "verbose_name": "staffer column type"
                            },
                            { "field_type": null, "help_text": "", "name": "staffer_fields", "verbose_name": "staffer fields" },
                            { "field_type": null, "help_text": "Allows the frontend to set the staffer field columns that should be created when this column is", "name": "staffer_column_settings", "verbose_name": "staffer column settings" },
                            { "field_type": null, "help_text": "\n            The years for which the column is responsible for generating transactions. For example, a TransactionAggregationColumn\n            representing the total transactions from supporter X will have transaction_years to indicate for which years to sum transactions\n            Only relevant for PAC clients.\n        ", "name": "transaction_years", "verbose_name": "transaction years" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_data",
                                "related_model": { "__module__": "app.custom_data.manage_data.models", "__name__": "CustomData" },
                                "verbose_name": "custom data"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.custom_data.manage_data.models", "__name__": "CustomDataQueryOperations" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "custom_data_query_operation",
                                "verbose_name": "custom data query operation"
                            },
                            { "field_type": 2, "help_text": "", "name": "custom_data_field_of_interest", "verbose_name": "custom data field of interest" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "related_person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "related person"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.stats.models", "__name__": "StatsMatrixType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "stats_matrix_type",
                                "verbose_name": "stats matrix type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "parent_column",
                                "related_model": { "__module__": "app.userdata.spreadsheet.models", "__name__": "Column" },
                                "verbose_name": "parent column"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer_title",
                                "related_model": { "__module__": "app.person.models", "__name__": "StaffTitle" },
                                "verbose_name": "staffer title"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "staffer_term",
                                "related_model": { "__module__": "app.person.models", "__name__": "StafferTerm" },
                                "verbose_name": "staffer term"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.spreadsheet.data_types", "__name__": "ColumnDataType" },
                                "field_type": 4,
                                "help_text": "the type of the the data - see the ColumnDataType enum for examples",
                                "name": "column_data_type",
                                "verbose_name": "column data type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.types", "__name__": "ProjectStatType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "project_stat_type",
                                "verbose_name": "project stat type"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "legislation_type",
                                "verbose_name": "legislation type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "custom_tag",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "CustomTag" },
                                "verbose_name": "custom tag"
                            },
                            { "field_type": 1, "help_text": "whether a column should display the rounded value", "name": "should_round_cell_value", "verbose_name": "should round cell value" },
                            { "field_type": 1, "help_text": "whether a column should display as currency (as opposed to a discrete count), i.e. general math columns.Note: non-ambiguous columns will always display as currency, and do not need this flag.", "name": "should_force_display_as_currency", "verbose_name": "should force display as currency" },
                            { "field_type": 1, "help_text": "whether a column should be hidden on its public sheet, if available publicly", "name": "should_hide_column_on_public", "verbose_name": "should hide column on public" },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.userdata.spreadsheet.types", "__name__": "SheetSortType" },
                                "field_type": 4,
                                "help_text": "Whether sheets should be sorted by this column. Only one column per sheet should have a non-zero value.",
                                "name": "default_sort_type",
                                "verbose_name": "default sort type"
                            },
                            { "field_type": null, "help_text": "A mapping representing the colors that this column's cells should have in the site and downloads.", "name": "custom_color_settings", "verbose_name": "custom color settings" },
                            { "field_type": null, "help_text": "\n            A cache of the generated column data for internal sheets.\n            \"This is distinct from 'public_cache' as it is partitioned by the user's ID: [current regions].\n            Cache for Last Note Text\n            {\n                \"123: [1,2,3,4]\": {\n                    \"created\": \"2021-09-03 09:48\",\n                    \"value\": {\n                        \"55\": \"This was such a nice note\",\n                        \"56\": \"Really Great Stuff\"\n                    }\n                },\n                # Some other user with different regions that might see different results\n                \"456: [1,2,3]\": {\n                    \"created\": \"2021-09-03 09:50\",\n                    \"value\": {\n                        \"55\": \"Amazing Note\",\n                        \"56\": \"Really Great Stuff\"\n                    }\n                }\n            }\n            ", "name": "column_cache", "verbose_name": "column cache" },
                            { "field_type": null, "help_text": "\n            A cache of the generated column data for public sheets.\n            This is distinct from 'colum_cache' as the regions are always the same.\n            {\n                \"created\": \"2021-09-03 09:48\",\n                \"value\": {\n                    \"55\": \"This was such a nice note\",\n                    \"56\": \"Really Great Stuff\"\n                }\n            }\n            ", "name": "public_cache", "verbose_name": "public cache" },
                            {
                                "field_type": 8,
                                "help_text": "",
                                "name": "source_columns",
                                "related_model": { "__module__": "app.userdata.spreadsheet.models", "__name__": "Column" },
                                "verbose_name": "source columns"
                            }
                        ]
                    },
                    "Sheet": {
                        "__is_model": true,
                        "__name__": "Sheet",
                        "data_model": "app.userdata.spreadsheet.models.Sheet",
                        "default_exclude_filters": {},
                        "default_filters": { "archived": false },
                        "endpoint": "/api/sheet/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            {
                                "field_type": 7,
                                "help_text": "The User who created the sheet",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            { "field_type": 1, "help_text": "Whether or not this Sheet object is limited to its creator", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                            {
                                "field_type": 7,
                                "help_text": "The sheets created by members of this organization",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "The design used for this sheet",
                                "name": "organization_design",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "OrganizationDesign" },
                                "verbose_name": "organization design"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "rows",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "SafedSearch" },
                                "verbose_name": "rows"
                            },
                            {
                                "_is_enum_field": true,
                                "choices": { "__module__": "app.models", "__name__": "QuorumDataType" },
                                "field_type": 4,
                                "help_text": "",
                                "name": "data_type",
                                "verbose_name": "data type"
                            },
                            { "field_type": 2, "help_text": "The name of the sheet", "name": "name", "verbose_name": "name" },
                            { "field_type": 4, "help_text": "The width of the column that represents the data of the sheet. This column is one to right of the index column", "name": "datum_column_width", "verbose_name": "datum column width" },
                            { "field_type": 1, "help_text": "whether a sheet has reduced editing permissions for users who aren't the creator", "name": "is_locked", "verbose_name": "is locked" },
                            { "field_type": 1, "help_text": "whether a sheet is publicly accessible. These are also called externally shared sheets on the application.", "name": "is_public", "verbose_name": "is public" },
                            { "field_type": 1, "help_text": "If true displays a stat bar showing various math information about the table. If false it is hidden", "name": "should_display_math_bar", "verbose_name": "should display math bar" },
                            { "field_type": 2, "help_text": "an id to be used in /spreadsheet/external/[public_slug] to share spreadsheets", "name": "public_slug", "verbose_name": "public slug" },
                            { "field_type": 2, "help_text": "The password used to protect access to an externally shared sheet. Stored in plaintext so we can display back to end users -- the frontend explains that this shouldn't be a personal password.", "name": "public_password", "verbose_name": "public password" },
                            { "field_type": null, "help_text": "The regions assigned to an external (public) sheet", "name": "external_regions", "verbose_name": "external regions" },
                            {
                                "field_type": 7,
                                "help_text": "Custom region used for external sheet",
                                "name": "external_custom_region_selection",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "CustomRegionSelection" },
                                "verbose_name": "external custom region selection"
                            },
                            { "field_type": 4, "help_text": "The relative height of each row in the sheet - increments by factors of 1", "name": "row_height_factor", "verbose_name": "row height factor" },
                            { "field_type": 1, "help_text": "boolean to indicate whether we should show a map in public bill sheets", "name": "show_map", "verbose_name": "show map" },
                            { "field_type": 1, "help_text": "boolean to indicate whether we should show the datum column in public sheets", "name": "show_datum_column", "verbose_name": "show datum column" },
                            { "field_type": 1, "help_text": "boolean to show a text box in public sheets", "name": "should_show_description", "verbose_name": "should show description" },
                            { "field_type": 3, "help_text": "The text that should be shown on the public sheet if should_show_description is True", "name": "description", "verbose_name": "description" },
                            { "field_type": 1, "help_text": "boolean to indicate whether we should should allow users to reorder columns in public sheets", "name": "allow_public_sheet_reorder_columns", "verbose_name": "allow public sheet reorder columns" },
                            { "field_type": 1, "help_text": "boolean to indicate whether public sheets should use the organization's default design", "name": "use_organization_design", "verbose_name": "use organization design" },
                            { "field_type": 1, "help_text": "whether this sheet should be publicly-indexable by google and other bots. This is set manually.", "name": "allow_index", "verbose_name": "allow index" },
                            { "field_type": 1, "help_text": "whether this sheet is marked as a favorite, appearing first", "name": "is_favorite", "verbose_name": "is favorite" },
                            {
                                "field_type": 8,
                                "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                                "name": "limited_to_teams",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                                "verbose_name": "limited to teams"
                            },
                            {
                                "field_type": 8,
                                "help_text": "The issues associated with this Sheet",
                                "name": "projects",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "projects"
                            },
                            {
                                "field_type": 8,
                                "help_text": "The users that have personally pinned this sheet",
                                "name": "pinned_users",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "pinned users"
                            }
                        ]
                    }
                },
                "types": {
                    "ColumnCategory": {
                        "__is_enum": true,
                        "campaign_finance": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 114, 12],
                            "hidden": false,
                            "key": "campaign_finance",
                            "label": "Campaign Finance",
                            "permission_enum": [9, 1007],
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create columns for your Campaign Finance data",
                            "value": 37
                        },
                        "caucuses": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1],
                            "hidden": false,
                            "key": "caucuses",
                            "label": "Caucus Membership",
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 9999, 10002, 10003, 10004, 10005, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 1000],
                            "tip": "Create columns that show membership in caucuses.",
                            "value": 12
                        },
                        "committees": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1],
                            "hidden": false,
                            "key": "committees",
                            "label": "Committee Membership",
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create columns that show membership on committees.",
                            "value": 7
                        },
                        "contacts": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1],
                            "hidden": false,
                            "key": "contacts",
                            "label": "Contacts",
                            "required_fields": [],
                            "sheets_column_order": 11.5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that shows a custom selection of contacts for this official",
                            "value": 36
                        },
                        "custom": {
                            "all": true,
                            "create_source_saved_search": false,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "hidden": false,
                            "key": "custom",
                            "label": "Blank Fields, Lists, & Math",
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns based on data you've created in Quorum.",
                            "value": 6
                        },
                        "custom_data": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [1, 82, 109],
                            "hidden": false,
                            "key": "custom_data",
                            "label": "Footprint Data",
                            "required_fields": ["custom_data_id"],
                            "sheets_column_order": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns based on your footprint data",
                            "value": 11
                        },
                        "custom_data_representatives": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [79],
                            "hidden": false,
                            "key": "custom_data_representatives",
                            "label": "Representation",
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns that show the representatives corresponding to the region of the data point",
                            "value": 21
                        },
                        "custom_events": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [12, 1, 8, 120],
                            "hidden": false,
                            "key": "custom_events",
                            "label": "Custom Events",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns that show how each person has interacted with your events",
                            "value": 23
                        },
                        "custom_field_from_note": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 12, 120],
                            "hidden": false,
                            "key": "custom_field_from_note",
                            "label": "Custom Field from Note",
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns from custom fields on a note the rows participate in.",
                            "value": 28
                        },
                        "custom_fields": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [12, 1, 2, 42, 8, 83, 80, 20, 120],
                            "hidden": false,
                            "key": "custom_fields",
                            "label": "Custom Fields",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns from your custom fields",
                            "value": 19
                        },
                        "documents": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 2],
                            "hidden": false,
                            "key": "documents",
                            "label": "Documents",
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Add columns based on the documents connected to the data in the rows of your sheet.",
                            "value": 8
                        },
                        "field": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [1, 49, 12, 2, 42, 3, 4, 79, 8, 47, 82, 83, 80, 20, 109, 114, 107, 120, 113],
                            "hidden": false,
                            "key": "field",
                            "label": "Basic Info",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Add columns of basic information about each row in the sheet.",
                            "value": 1
                        },
                        "grassroots": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [12, 1, 83],
                            "hidden": false,
                            "key": "grassroots",
                            "label": "Actions",
                            "required_fields": [],
                            "sheets_column_order": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create columns related to grassroots campaign participation by officials or your supporters",
                            "value": 14
                        },
                        "grassroots_for_pub_orgs": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [42],
                            "hidden": false,
                            "key": "grassroots_for_pub_orgs",
                            "label": "Grassroots",
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns related to contacts associated to organizations and their grassroots actions",
                            "value": 27
                        },
                        "grassroots_gamification": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [12],
                            "hidden": false,
                            "key": "grassroots_gamification",
                            "label": "Grassroots Gamification",
                            "required_fields": ["source_action_center_id"],
                            "sheets_column_order": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 29
                        },
                        "in_issue": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 2, 25, 8, 80, 12, 4, 3, 42, 47, 20, 120],
                            "hidden": false,
                            "key": "in_issue",
                            "label": "Issues",
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to see what issues each row is connected to",
                            "value": 24
                        },
                        "interactions": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [2, 83, 1, 49, 42, 8, 12, 59, 120],
                            "hidden": false,
                            "key": "interactions",
                            "label": "Notes & Interactions",
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count your interactions and show your notes relevant to each row.",
                            "value": 3
                        },
                        "issue_counts": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [83],
                            "hidden": false,
                            "key": "issue_counts",
                            "label": "Count of Select Related Items",
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to see the count of a subset of resources tagged to each Issue",
                            "value": 25
                        },
                        "legislation": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1],
                            "hidden": false,
                            "key": "legislation",
                            "label": "Legislation",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns for either Votes or Bills with various options, such as the number of yea votes or the sponsorship record.",
                            "value": 2
                        },
                        "miscellaneous": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [12, 1, 2, 49, 114],
                            "hidden": true,
                            "key": "miscellaneous",
                            "label": "Miscellaneous",
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 9
                        },
                        "news": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1],
                            "hidden": false,
                            "key": "news",
                            "label": "News Mentions",
                            "permission_enum": [104],
                            "required_fields": [],
                            "sheets_column_order": 32,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Search for mentions across Quorum's database of news articles!",
                            "value": 30
                        },
                        "news_articles": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [120],
                            "hidden": false,
                            "key": "news_articles",
                            "label": "News Articles",
                            "permission_enum": [105],
                            "required_fields": [],
                            "sheets_column_order": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Associated News Articles",
                            "value": 35
                        },
                        "outbox": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 12, 8, 42, 120],
                            "hidden": false,
                            "key": "outbox",
                            "label": "Outbox",
                            "required_fields": [],
                            "sheets_column_order": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns based on the Outbox emails that people have received, opened, clicked, or replied to.",
                            "value": 15
                        },
                        "pac_transactions": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [114, 12],
                            "hidden": false,
                            "key": "pac_transactions",
                            "label": "PAC Transactions",
                            "permission_enum": [8],
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create columns for your PAC Transactions",
                            "value": 33
                        },
                        "relationships": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [1],
                            "hidden": true,
                            "key": "relationships",
                            "label": "Relationships",
                            "required_fields": ["related_person_id"],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Compute relationship scores with selected members.",
                            "value": 10
                        },
                        "social_documents": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [12],
                            "hidden": false,
                            "key": "social_documents",
                            "label": "Social Mentions",
                            "permission_enum": [207],
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Search for mentions in social media posts",
                            "value": 20
                        },
                        "social_media_accounts": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [121, 120],
                            "hidden": false,
                            "key": "social_media_accounts",
                            "label": "Social Media Accounts",
                            "permission_enum": [105],
                            "required_fields": [],
                            "sheets_column_order": 17,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Link to associated social media accounts",
                            "value": 34
                        },
                        "staffers": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [1],
                            "hidden": false,
                            "key": "staffers",
                            "label": "Staffers",
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Show the names and information of each member's staffers, optionally filtered to a role or issue.",
                            "value": 5
                        },
                        "state_relationships": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [82],
                            "hidden": false,
                            "key": "state_relationships",
                            "label": "State Counts",
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns based on the number of results matching your search in each state (i.e. # of supported bills filed, # of supported bills enacted, # of female legislators).",
                            "value": 22
                        },
                        "statistics": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [1, 49],
                            "hidden": false,
                            "key": "statistics",
                            "label": "Statistics",
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Add a column of legislative or demographic statistics to your sheet, including # of Sponsored Bills, Percent of Time Voting with Party, major industries, poverty levels, and more.",
                            "value": 4
                        },
                        "supporter_representation": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [12],
                            "hidden": false,
                            "key": "supporter_representation",
                            "label": "Representation",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create columns that show your supporters' representatives",
                            "value": 18
                        },
                        "texting": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [12],
                            "hidden": false,
                            "key": "texting",
                            "label": "Texting",
                            "permission_enum": [216],
                            "required_fields": [],
                            "sheets_column_order": 30,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create columns for your Texting data",
                            "value": 38
                        },
                        "total_issue_counts": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [83],
                            "hidden": false,
                            "key": "total_issue_counts",
                            "label": "Aggregate Count of Related Items",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to see the total count of resources tagged to each Issue",
                            "value": 26
                        },
                        "user_assignments": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [59],
                            "hidden": false,
                            "key": "user_assignments",
                            "label": "Assignments",
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create columns that show your users' assignments",
                            "value": 17
                        },
                        "user_field": {
                            "all": false,
                            "create_source_saved_search": false,
                            "data_types": [59],
                            "hidden": false,
                            "key": "user_field",
                            "label": "Basic Info",
                            "required_fields": ["batch_fields"],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns of basic information about each row in the sheet.",
                            "value": 16
                        },
                        "user_issue_counts": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [59],
                            "hidden": false,
                            "key": "user_issue_counts",
                            "label": "Issue Counts",
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to see the count of a subset of resources tagged to each Team Member",
                            "value": 31
                        },
                        "user_stances_and_alignments": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [59],
                            "hidden": false,
                            "key": "user_stances_and_alignments",
                            "label": "Stances / Alignments",
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to see the count of stances or alignments each Team Member has taken",
                            "value": 32
                        },
                        "vote_direction": {
                            "all": false,
                            "create_source_saved_search": true,
                            "data_types": [3],
                            "hidden": false,
                            "key": "vote_direction",
                            "label": "Vote Direction",
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns that show how a member voted on a particular vote",
                            "value": 13
                        }
                    },
                    "ColumnSubCategory": {
                        "__is_enum": true,
                        "address": {
                            "category": 1,
                            "data_types": [107],
                            "display_name": "Address",
                            "key": "address",
                            "label": "Address",
                            "sheets_column_order": 2,
                            "tooltip_is_link": false,
                            "value": 20
                        },
                        "agency_contact": {
                            "category": 1,
                            "data_types": [80],
                            "display_name": "Agency/Contact Info",
                            "key": "agency_contact",
                            "label": "Agency/Contact Info",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 15
                        },
                        "basic": {
                            "category": 1,
                            "data_types": [2, 79, 83, 80, 20],
                            "display_name": "",
                            "key": "basic",
                            "label": "Basic",
                            "sheets_column_order": 1,
                            "tooltip_is_link": false,
                            "value": 8
                        },
                        "biography": {
                            "category": 1,
                            "data_types": [1],
                            "display_name": "Biography",
                            "key": "biography",
                            "label": "Biography",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 2
                        },
                        "campaign_finance": {
                            "category": 1,
                            "data_types": [12],
                            "display_name": "Campaign Finance Research",
                            "key": "campaign_finance",
                            "label": "Campaign Finance Research",
                            "sheets_column_order": 5,
                            "tooltip_is_link": false,
                            "value": 23
                        },
                        "candidate_information": {
                            "category": 1,
                            "data_types": [114],
                            "display_name": "Candidate Information",
                            "key": "candidate_information",
                            "label": "Candidate Information",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 18
                        },
                        "contact": {
                            "category": 1,
                            "data_types": [1, 12],
                            "display_name": "Contact",
                            "key": "contact",
                            "label": "Contact",
                            "sheets_column_order": 1,
                            "tooltip_is_link": false,
                            "value": 3
                        },
                        "contribution_details": {
                            "category": 1,
                            "data_types": [12],
                            "display_name": "Contribution Details",
                            "key": "contribution_details",
                            "label": "Contribution Details",
                            "sheets_column_order": 6,
                            "tooltip_is_link": false,
                            "value": 24
                        },
                        "district": {
                            "category": 1,
                            "data_types": [1],
                            "display_name": "District",
                            "key": "district",
                            "label": "District",
                            "sheets_column_order": 5,
                            "tooltip_is_link": false,
                            "value": 4
                        },
                        "election": {
                            "category": 1,
                            "data_types": [1],
                            "display_name": "Election Data",
                            "key": "election",
                            "label": "Election",
                            "sheets_column_order": 4,
                            "tooltip_is_link": false,
                            "value": 5
                        },
                        "election_information": {
                            "category": 1,
                            "data_types": [107],
                            "display_name": "Election Information",
                            "key": "election_information",
                            "label": "Election Information",
                            "sheets_column_order": 6,
                            "tooltip_is_link": false,
                            "value": 26
                        },
                        "geographic": {
                            "category": 1,
                            "data_types": [79],
                            "display_name": "Geographic Data",
                            "key": "geographic",
                            "label": "Geographic Data",
                            "sheets_column_order": 2,
                            "tooltip_is_link": false,
                            "value": 14
                        },
                        "member": {
                            "category": 1,
                            "data_types": [1],
                            "display_name": "Official Info",
                            "key": "member",
                            "label": "Member",
                            "sheets_column_order": 2,
                            "tooltip_is_link": false,
                            "value": 6
                        },
                        "other": { "display_name": "Other", "key": "other", "label": "Other", "sheets_column_order": 100, "tooltip_is_link": false, "value": 1 },
                        "pac": {
                            "category": 1,
                            "data_types": [12],
                            "display_name": "PAC",
                            "key": "pac",
                            "label": "PAC",
                            "sheets_column_order": 7,
                            "tooltip_is_link": false,
                            "value": 25
                        },
                        "participants": {
                            "category": 9,
                            "data_types": [20],
                            "display_name": "Participants and Associated Items",
                            "key": "participants",
                            "label": "Participants",
                            "sheets_column_order": 2,
                            "tooltip_is_link": false,
                            "value": 16
                        },
                        "payment_information": {
                            "category": 1,
                            "data_types": [107],
                            "display_name": "Transaction Information",
                            "key": "payment_information",
                            "label": "Payment Information",
                            "sheets_column_order": 1,
                            "tooltip_is_link": false,
                            "value": 19
                        },
                        "political_committee": {
                            "category": 1,
                            "data_types": [107],
                            "display_name": "Political Committee",
                            "key": "political_committee",
                            "label": "Political Committee",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 21
                        },
                        "political_committee_information": {
                            "category": 1,
                            "data_types": [114],
                            "display_name": "Political Committee Information",
                            "key": "political_committee_information",
                            "label": "Political Committee Information",
                            "sheets_column_order": 2,
                            "tooltip_is_link": false,
                            "value": 17
                        },
                        "quorum": {
                            "category": 1,
                            "data_types": [12],
                            "display_name": "Quorum Generated",
                            "key": "quorum",
                            "label": "Quorum Generated",
                            "sheets_column_order": 2,
                            "tooltip": "Information on the contact specific to Quorum and its products",
                            "tooltip_is_link": false,
                            "value": 12
                        },
                        "region": {
                            "category": 1,
                            "data_types": [12],
                            "display_name": "Region",
                            "key": "region",
                            "label": "Region",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 13
                        },
                        "sponsors": {
                            "category": 1,
                            "data_types": [2],
                            "display_name": "Sponsorship Info",
                            "key": "sponsors",
                            "label": "Sponsors",
                            "sheets_column_order": 3,
                            "tooltip_is_link": false,
                            "value": 11
                        },
                        "statistics": {
                            "category": 1,
                            "data_types": [1],
                            "display_name": "Stats",
                            "key": "statistics",
                            "label": "Statistics",
                            "sheets_column_order": 6,
                            "tooltip_is_link": false,
                            "value": 7
                        },
                        "supporter": {
                            "category": 1,
                            "data_types": [107],
                            "display_name": "Contact",
                            "key": "supporter",
                            "label": "Contact",
                            "sheets_column_order": 4,
                            "tooltip_is_link": false,
                            "value": 22
                        },
                        "timeline": {
                            "category": 1,
                            "data_types": [2, 80],
                            "display_name": "Timeline",
                            "key": "timeline",
                            "label": "Timeline",
                            "sheets_column_order": 2,
                            "tooltip": "https://www.quorum.us/help/how-to/19/use-sheets-to-track-bills",
                            "tooltip_is_link": true,
                            "value": 10
                        },
                        "tracking": {
                            "category": 1,
                            "data_types": [2, 83, 1, 80, 8, 12],
                            "display_name": "Tracking Info",
                            "key": "tracking",
                            "label": "Tracking",
                            "sheets_column_order": 4,
                            "tooltip_is_link": false,
                            "value": 9
                        }
                    },
                    "FieldOptionType": {
                        "__is_enum": true,
                        "region_abbrev_bill": { "enum_field": "abbrev", "field": "region", "key": "region_abbrev_bill", "label": "201", "value": 201 },
                        "region_abbrev_person": { "enum_field": "abbrev", "field": "most_recent_region", "key": "region_abbrev_person", "label": "200", "value": 200 }
                    },
                    "PacAmountAggregationPeriodType": {
                        "__is_enum": true,
                        "election": {
                            "columns": [458, 460, 459, 457],
                            "key": "election",
                            "label": "Election",
                            "value": 2
                        },
                        "year": {
                            "columns": [458, 460, 459, 457, 401, 402, 400],
                            "key": "year",
                            "label": "Year",
                            "value": 1
                        }
                    },
                    "PersonLegislationColumnType": {
                        "__is_enum": true,
                        "abstention_votes": {
                            "blacklist": [2, 4],
                            "column_generation_order": 5,
                            "key": "abstention_votes",
                            "label": "# of Abstentions",
                            "sheets_column_order": 4,
                            "tip": "Create a single column that shows the sum of abstained votes you have chosen",
                            "value": 139
                        },
                        "against_us": {
                            "blacklist": [2, 4],
                            "column_generation_order": 2,
                            "key": "against_us",
                            "label": "# of Votes Against",
                            "sheets_column_order": 8,
                            "tip": "Create a single columns that shows the sum of votes opposing your organization's stances",
                            "value": 14
                        },
                        "nay_votes": {
                            "blacklist": [2, 4],
                            "column_generation_order": 4,
                            "key": "nay_votes",
                            "label": "# of Nay Votes",
                            "sheets_column_order": 3,
                            "tip": "Create a single column that shows the sum of nay votes you have chosen",
                            "value": 80
                        },
                        "number_of_times_cosponsored": {
                            "blacklist": [3],
                            "column_generation_order": 4,
                            "key": "number_of_times_cosponsored",
                            "label": "# of times cosponsored",
                            "sheets_column_order": 4,
                            "tip": "The number of times this person has cosponsored the selected legislation",
                            "value": 82
                        },
                        "number_of_times_sponsored": {
                            "blacklist": [3],
                            "column_generation_order": 3,
                            "key": "number_of_times_sponsored",
                            "label": "# of times sponsored",
                            "sheets_column_order": 3,
                            "tip": "The number of times this person has sponsored the selected legislation",
                            "value": 81
                        },
                        "number_of_times_sponsored_and_cosponsored": {
                            "blacklist": [3],
                            "column_generation_order": 5,
                            "key": "number_of_times_sponsored_and_cosponsored",
                            "label": "# of times sponsored & cosponsored",
                            "sheets_column_order": 5,
                            "tip": "The number of times this person has sponsored and cosponsored the selected legislation",
                            "value": 83
                        },
                        "other_votes": {
                            "blacklist": [2, 4],
                            "column_generation_order": 6,
                            "key": "other_votes",
                            "label": "# of Missed/Other Votes",
                            "sheets_column_order": 5,
                            "tip": "Create a single column that shows the sum of votes you have chosen that were missed or otherwise unknown",
                            "value": 140
                        },
                        "sponsorship_date": {
                            "blacklist": [3],
                            "column_generation_order": 2,
                            "key": "sponsorship_date",
                            "label": "Sponsorship Date",
                            "sheets_column_order": 2,
                            "tip": "The date in which this person sponsored this bill",
                            "value": 134
                        },
                        "sponsorship_record": {
                            "blacklist": [3],
                            "column_generation_order": 1,
                            "key": "sponsorship_record",
                            "label": "Sponsorship Record",
                            "sheets_column_order": 1,
                            "tip": "Create a set of columns to show each member's sponsorship of selected bills",
                            "value": 34
                        },
                        "stance_record": {
                            "blacklist": [2, 4],
                            "column_generation_order": 7,
                            "key": "stance_record",
                            "label": "Individual Votes (With/Against)",
                            "sheets_column_order": 6,
                            "tip": "Create columns to show the stance of the row in your sheet relative to your organization's stance",
                            "value": 28
                        },
                        "voting_record": {
                            "blacklist": [2, 4],
                            "column_generation_order": 8,
                            "key": "voting_record",
                            "label": "Individual Vote(s) (Yea/Nay)",
                            "sheets_column_order": 1,
                            "tip": "Create a set of columns to show the way each member voted on a given item",
                            "value": 35
                        },
                        "with_us": {
                            "blacklist": [2, 4],
                            "column_generation_order": 1,
                            "key": "with_us",
                            "label": "# of Votes With",
                            "sheets_column_order": 7,
                            "tip": "Create a single column that shows the sum of votes in line with your organization's stances",
                            "value": 15
                        },
                        "yea_votes": {
                            "blacklist": [2, 4],
                            "column_generation_order": 3,
                            "key": "yea_votes",
                            "label": "# of Yea Votes",
                            "sheets_column_order": 2,
                            "tip": "Create a single column that shows the sum of yea votes you have chosen",
                            "value": 79
                        }
                    },
                    "SheetColumnType": {
                        "__is_enum": true,
                        "abstention_votes": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "abstention_votes",
                            "label": "# of Abstentions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfAbstentionVotesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of times this person has been present but abstained from the votes selected",
                            "value": 139
                        },
                        "age": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "age",
                            "label": "Age",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MemberAgeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 28,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing the age of the officals in your sheet.",
                            "value": 119
                        },
                        "all_lists": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 83, 20, 42, 107, 109, 47, 113, 114, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "all_lists",
                            "label": "All Lists",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "AllListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "All of the lists that this row has been added to.",
                            "value": 124
                        },
                        "all_lists_basic": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "all_lists_basic",
                            "label": "All Lists ",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AllListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "All of the lists that this row has been added to.",
                            "value": 175
                        },
                        "appropriate_greeting": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "appropriate_greeting",
                            "label": "Appropriate Greeting",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AppropriateGreetingColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The Quorum-generated greeting for this person.",
                            "value": 295
                        },
                        "assignment": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [2, 1, 42, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "assignment",
                            "label": "User Assignment",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The team member assigned (no need to select notes for this column)",
                            "value": 16
                        },
                        "assignment_primary": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [2, 1, 42, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "assignment_primary",
                            "label": "Primary User Assignment",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PrimaryUserAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The primary team member assigned (no need to select notes for this column)",
                            "value": 276
                        },
                        "assignments_grassroots_actions": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "assignments_grassroots_actions",
                            "label": "Assignments' Grassroots Actions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssignmentsGrassrootsActionsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of Grassroots actions this user's assignments are associated with",
                            "value": 297
                        },
                        "associated_amendments": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_amendments",
                            "label": "Associated Amendments",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedAmendmentsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Amendments being commented on.",
                            "value": 267
                        },
                        "associated_bills": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_bills",
                            "label": "Associated Bills",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedBillsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Bills being commented on.",
                            "value": 620
                        },
                        "associated_dockets": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_dockets",
                            "label": "Associated Dockets",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedDocketsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Dockets being commented on.",
                            "value": 272
                        },
                        "associated_documents": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_documents",
                            "label": "Associated Documents",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedDocumentsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Documents being commented on.",
                            "value": 268
                        },
                        "associated_projects": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_projects",
                            "label": "Associated Issues",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedProjectsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Issues related to the note.",
                            "value": 273
                        },
                        "associated_regulations": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_regulations",
                            "label": "Associated Regulations",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedRegulationsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Regulations being commented on.",
                            "value": 270
                        },
                        "associated_votes": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "associated_votes",
                            "label": "Associated Votes",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AssociatedVotesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Votes being commented on.",
                            "value": 266
                        },
                        "bill_committees": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "bill_committees",
                            "label": "Committees",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 17,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The name of the committee(s) to which a bill has been referred",
                            "value": 111
                        },
                        "bill_priority": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "bill_priority",
                            "label": "Your Organization's Priority",
                            "master_column": false,
                            "miscellaneous": [4, 2, 83, 1, 80, 8, 12],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PriorityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your Organization's priority on this row",
                            "value": 59
                        },
                        "bill_stance": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "bill_stance",
                            "label": "Your Organization's Stance",
                            "master_column": false,
                            "miscellaneous": [2, 83, 80, 4],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StanceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your Organization's stance on this row",
                            "value": 58
                        },
                        "bill_status_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "bill_status_date",
                            "label": "Status Date",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StatusDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 10,
                            "tip": "",
                            "value": 131
                        },
                        "bill_terms": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "bill_terms",
                            "label": "Legislative Issues",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 18,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The issue areas assigned to this Bill",
                            "value": 151
                        },
                        "bill_title_only": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "bill_title_only",
                            "label": "Title (no number)",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "BillTitleOnlyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The bill's primary display title, excluding its number.",
                            "value": 125
                        },
                        "caucus_list": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "caucus_list",
                            "label": "Caucus List",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CaucusListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 22,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The list of caucuses they are a member of.",
                            "value": 248
                        },
                        "caucus_membership": {
                            "category": 12,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "caucus_membership",
                            "label": "Caucus Membership",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CaucusMembershipColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 37
                        },
                        "chamber": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "chamber",
                            "label": "Chamber",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ChamberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 18,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The chamber that the member is in.",
                            "value": 39
                        },
                        "collaborator_external_bill_profile_link": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_contributor_license_addon",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "collaborator_external_bill_profile_link",
                            "label": "External Bill Profile Link",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [221],
                            "proxy": "ExternalBillProfileLinkColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 20,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column showing the external bill profile link for the bills in your sheet.",
                            "value": 676
                        },
                        "committee_membership": {
                            "category": 7,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "committee_membership",
                            "label": "Committee Membership",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CommitteeMembershipColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 12
                        },
                        "companion_bills": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "companion_bills",
                            "label": "Companion Bill",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CompanionBillsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 19,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The companion bill(s) for this bill, if applicable",
                            "value": 478
                        },
                        "contact_campaign_finance_political_committee": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contact_campaign_finance_political_committee",
                            "label": "Total Amount Contributed to Political Committee",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceContactPoliticalCommitteeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 611,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money contributed to a selected political committee",
                            "value": 611
                        },
                        "contact_organizations": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": true,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contact_organizations",
                            "label": "Organization Names",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ContactOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A contact's organization",
                            "value": 463
                        },
                        "contacts_campaign_finance_available_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_campaign_finance_available_amount_for_years",
                            "label": "Total Amount Contributed by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceContactYearsSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 609,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money donated from each contact in the selected year(s)",
                            "value": 609
                        },
                        "contacts_contribution_details_first_receipt_amount": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_contribution_details_first_receipt_amount",
                            "label": "First Receipt Amount",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterPacContributionDetailsFirstReceiptAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 31,
                            "sheets_subcategory": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Amount of the first PAC Receipt by the contact in your PAC transaction data",
                            "value": 633
                        },
                        "contacts_contribution_details_first_receipt_date": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_contribution_details_first_receipt_date",
                            "label": "First Receipt Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterPacContributionDetailsFirstReceiptDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 30,
                            "sheets_subcategory": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Date of the first PAC Receipt by the contact in your PAC transaction data",
                            "value": 632
                        },
                        "contacts_contribution_details_last_receipt_amount": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_contribution_details_last_receipt_amount",
                            "label": "Last Receipt Amount",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterPacContributionDetailsLastReceiptAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 29,
                            "sheets_subcategory": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Amount of the last PAC Receipt by the contact",
                            "value": 631
                        },
                        "contacts_contribution_details_last_receipt_date": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_contribution_details_last_receipt_date",
                            "label": "Last Receipt Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterPacContributionDetailsLastReceiptDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 28,
                            "sheets_subcategory": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Date of the last PAC Receipt by the contact",
                            "value": 630
                        },
                        "contacts_contribution_details_master_column": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_contribution_details_master_column",
                            "label": "Contact contribution details Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 634
                        },
                        "contacts_first_contribution_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_first_contribution_date",
                            "label": "First Contribution Date",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceContactsFirstContributionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 617,
                            "sheets_subcategory": 23,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing first contribution date of your contacts",
                            "value": 617
                        },
                        "contacts_last_contribution_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "contacts_last_contribution_date",
                            "label": "Last Contribution Date",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceContactsLastContributionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 618,
                            "sheets_subcategory": 23,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing last contribution date of your contacts",
                            "value": 618
                        },
                        "cook_pvi": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "cook_pvi",
                            "label": "Partisan Voting Index (PVI)",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CookPVIColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 13,
                            "sheets_subcategory": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The member's partisan voting index (PVI)",
                            "value": 41
                        },
                        "cosponsors_list": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "cosponsors_list",
                            "label": "Cosponsors List",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CosponsorsListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The cosponsors of this bill",
                            "value": 49
                        },
                        "count_of_amendment_stances_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_amendment_stances_per_user",
                            "label": "Count of Amendment Stances",
                            "master_column": false,
                            "miscellaneous": 4,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "TeamMemberAmendmentStanceCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 10000],
                            "tip": "Count of stances taken on Amendments per Team Member",
                            "value": 438
                        },
                        "count_of_amendments_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_amendments_per_issue",
                            "label": "Count of Amendments",
                            "master_column": false,
                            "miscellaneous": 4,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfAmendmentsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Amendments tagged with this Issue",
                            "value": 222
                        },
                        "count_of_amendments_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_amendments_per_user",
                            "label": "Count of Amendments",
                            "master_column": false,
                            "miscellaneous": 4,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Amendments tagged with this Team Member",
                            "value": 335
                        },
                        "count_of_articles_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_articles_per_issue",
                            "label": "Count of Articles",
                            "master_column": false,
                            "miscellaneous": 105,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [104],
                            "proxy": "CountOfArticlesTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Articles tagged with this Issue",
                            "value": 327
                        },
                        "count_of_articles_per_press_contact": {
                            "category": 35,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_articles_per_press_contact",
                            "label": "Number of Articles",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountOfArticlesPerPressContactColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Number of Articles by this Author",
                            "value": 473
                        },
                        "count_of_bill_stances_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_bill_stances_per_user",
                            "label": "Count of Bill Stances",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "TeamMemberBillStanceCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106, 201, 203, 204, 208, 205, 211, 1000],
                            "tip": "Count of stances taken on Bills per Team Member",
                            "value": 435
                        },
                        "count_of_bills_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_bills_per_issue",
                            "label": "Count of Bills",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfBillsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Bills tagged with this Issue",
                            "value": 216
                        },
                        "count_of_bills_per_state": {
                            "category": 22,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_bills_per_state",
                            "label": "Count of Bills",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountRelatedForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 171
                        },
                        "count_of_bills_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_bills_per_user",
                            "label": "Count of Bills",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Bills tagged with this Team Member",
                            "value": 329
                        },
                        "count_of_campaigns_per_project": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_campaigns_per_project",
                            "label": "Number of Campaigns",
                            "master_column": false,
                            "miscellaneous": 49,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCampaignsPerProjectColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many campaigns are attached to each project",
                            "value": 179
                        },
                        "count_of_contacts_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_contacts_per_issue",
                            "label": "Count of Contacts ",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [204],
                            "proxy": "CountOfContactsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Contacts tagged with this Issue",
                            "value": 220
                        },
                        "count_of_contacts_per_public_organization": {
                            "category": 27,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_contacts_per_public_organization",
                            "label": "Number of Contacts",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountOfContactsPerPublicOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "source_saved_search": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of contacts for each organization",
                            "value": 246
                        },
                        "count_of_contacts_per_state": {
                            "category": 22,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_contacts_per_state",
                            "label": "Count of Contacts",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountRelatedForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 173
                        },
                        "count_of_contacts_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_contacts_per_user",
                            "label": "Count of Contacts ",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [204],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Contacts tagged with this Team Member",
                            "value": 333
                        },
                        "count_of_documents_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_documents_per_issue",
                            "label": "Count of Documents",
                            "master_column": false,
                            "miscellaneous": 25,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [305, 207, 105],
                            "proxy": "CountOfDocumentsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Documents tagged with this Issue",
                            "value": 217
                        },
                        "count_of_documents_per_state": {
                            "category": 22,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_documents_per_state",
                            "label": "Count of Documents",
                            "master_column": false,
                            "miscellaneous": 25,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountRelatedForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 172
                        },
                        "count_of_documents_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_documents_per_user",
                            "label": "Count of Documents",
                            "master_column": false,
                            "miscellaneous": 25,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [305, 207, 105],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Documents tagged with this Team Member",
                            "value": 330
                        },
                        "count_of_grassroots_action_for_pub_org_contacts": {
                            "category": 27,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_grassroots_action_for_pub_org_contacts",
                            "label": "Number of Grassroots Actions",
                            "master_column": false,
                            "miscellaneous": 69,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountOfGrassrootsActionsPerOrganizationsContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "source_saved_search": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of grassroots actions for each organization",
                            "value": 247
                        },
                        "count_of_grassroots_actions_per_project": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_grassroots_actions_per_project",
                            "label": "Number of Grassroots Actions",
                            "master_column": false,
                            "miscellaneous": 49,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfGrassrootsActionsPerProjectColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many grassroots actions are associated with each project",
                            "value": 180
                        },
                        "count_of_grassroots_visits_per_project": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_grassroots_visits_per_project",
                            "label": "Number of Grassroots Visits",
                            "master_column": false,
                            "miscellaneous": 49,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfGrassrootsVisitsPerProjectColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many times each issue page was visited",
                            "value": 178
                        },
                        "count_of_officials_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_officials_per_issue",
                            "label": "Count of Officials",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [300],
                            "proxy": "CountOfOfficialsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Officials tagged with this Issue",
                            "value": 218
                        },
                        "count_of_officials_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_officials_per_user",
                            "label": "Count of Officials",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [300],
                            "proxy": "CountOfOfficialsTaggedToUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Officials tagged with this Team Member",
                            "value": 331
                        },
                        "count_of_person_alignments_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_person_alignments_per_user",
                            "label": "Count of Official Alignments",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [300],
                            "proxy": "TeamMemberPersonAlignmentCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of alignments taken on Officials per Team Member",
                            "value": 432
                        },
                        "count_of_press_contacts_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_press_contacts_per_issue",
                            "label": "Count of Press",
                            "master_column": false,
                            "miscellaneous": 120,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "CountOfPressContactsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of selected Press tagged with this Issue",
                            "value": 451
                        },
                        "count_of_press_contacts_per_public_organization": {
                            "category": 27,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_press_contacts_per_public_organization",
                            "label": "Number of Press Contacts",
                            "master_column": false,
                            "miscellaneous": 120,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountOfPressContactsPerPublicOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "source_saved_search": true,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of press contacts for each organization",
                            "value": 471
                        },
                        "count_of_regs_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_regs_per_issue",
                            "label": "Count of Regulations",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [310],
                            "proxy": "CountOfRegulationsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Regulations tagged with this Issue",
                            "value": 223
                        },
                        "count_of_regs_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_regs_per_user",
                            "label": "Count of Regulations",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [310],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Regulations tagged with this Team Member",
                            "value": 336
                        },
                        "count_of_regulation_stances_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_regulation_stances_per_user",
                            "label": "Count of Regulation Stances",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [310],
                            "proxy": "TeamMemberRegulationStanceCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 1, 204, 201, 203, 208, 205, 211],
                            "tip": "Count of stances taken on Regulations per Team Member",
                            "value": 436
                        },
                        "count_of_representatives_per_state": {
                            "category": 22,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_representatives_per_state",
                            "label": "Count of Officials",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CountRepresentativesForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 177
                        },
                        "count_of_staffer_alignments_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_staffer_alignments_per_user",
                            "label": "Count of Staffer Alignments",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [302],
                            "proxy": "TeamMemberStafferAlignmentCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                            "tip": "Count of alignments taken on Staffers per Team Member",
                            "value": 433
                        },
                        "count_of_staffers_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_staffers_per_issue",
                            "label": "Count of Staffers",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [302],
                            "proxy": "CountOfStaffersTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Staffers tagged with this Issue",
                            "value": 219
                        },
                        "count_of_staffers_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_staffers_per_user",
                            "label": "Count of Staffers",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [302],
                            "proxy": "CountOfStaffersTaggedToUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Staffers tagged with this Team Member",
                            "value": 332
                        },
                        "count_of_supporter_alignments_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_supporter_alignments_per_user",
                            "label": "Count of Contact Alignments",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [204],
                            "proxy": "TeamMemberSupporterAlignmentCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of alignments taken on Contacts per Team Member",
                            "value": 434
                        },
                        "count_of_vote_stances_per_user": {
                            "category": 32,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_vote_stances_per_user",
                            "label": "Count of Vote Stances",
                            "master_column": false,
                            "miscellaneous": 3,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "TeamMemberVoteStanceCountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                            "tip": "Count of stances taken on Votes per Team Member",
                            "value": 437
                        },
                        "count_of_votes_per_issue": {
                            "category": 25,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_votes_per_issue",
                            "label": "Count of Votes",
                            "master_column": false,
                            "miscellaneous": 3,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfVotesTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Votes tagged with this Issue",
                            "value": 221
                        },
                        "count_of_votes_per_user": {
                            "category": 31,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "count_of_votes_per_user",
                            "label": "Count of Votes",
                            "master_column": false,
                            "miscellaneous": 3,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfItemsTaggedUsersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of selected Votes tagged with this Team Member",
                            "value": 334
                        },
                        "custom_contacts_in_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_contacts_in_district",
                            "label": "Custom Contacts In District",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomContactsInDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 24,
                            "sheets_subcategory": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of your custom contacts that reside in each member's district.",
                            "value": 45
                        },
                        "custom_contacts_subset_in_district": {
                            "category": 36,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_contacts_subset_in_district",
                            "label": "Custom Contacts In District",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomContactsSubsetInDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 24,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of your custom contacts that reside in each member's district.",
                            "value": 479
                        },
                        "custom_data": {
                            "category": 11,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data",
                            "label": "Footprint Data",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 24
                        },
                        "custom_data_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_address",
                            "label": "Address",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataAddressField",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 169
                        },
                        "custom_data_count_for_district": {
                            "category": 11,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [109],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_count_for_district",
                            "label": "Footprint Data for District",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataForDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": ["custom_data_id"],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 325
                        },
                        "custom_data_count_for_states": {
                            "category": 11,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [82],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_count_for_states",
                            "label": "Footprint Data for State",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": ["custom_data_id"],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 236
                        },
                        "custom_data_field": {
                            "category": 1,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_field",
                            "label": "Footprint Data Field",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 176
                        },
                        "custom_data_geo_country": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_country",
                            "label": "Country",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataCountryColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 168
                        },
                        "custom_data_geo_county": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_county",
                            "label": "County",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataCountyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 166
                        },
                        "custom_data_geo_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_district",
                            "label": "District",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 163
                        },
                        "custom_data_geo_lowerld": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_lowerld",
                            "label": "Lower Legislative District",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataLowerLDColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 165
                        },
                        "custom_data_geo_municipality": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_municipality",
                            "label": "Municipality",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataMunicipalityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 167
                        },
                        "custom_data_geo_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_state",
                            "label": "State",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 162
                        },
                        "custom_data_geo_upperld": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_geo_upperld",
                            "label": "Upper Legislative District",
                            "master_column": false,
                            "miscellaneous": 79,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataUpperLDColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 14,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 164
                        },
                        "custom_data_list": {
                            "category": 11,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_list",
                            "label": "Footprint Data | List",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 144
                        },
                        "custom_data_person_county_legislator": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_county_legislator",
                            "label": "County Legislator",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonCountyLegislatorColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 160
                        },
                        "custom_data_person_master": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_master",
                            "label": "Footprint Data Representative Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 170
                        },
                        "custom_data_person_municipal_legislator": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_municipal_legislator",
                            "label": "City Council Members",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonMunicipalLegislatorColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 161
                        },
                        "custom_data_person_representative": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_representative",
                            "label": "Representative for District",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonRepresentativeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 154
                        },
                        "custom_data_person_senator": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_senator",
                            "label": "Senators for State",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonSenatorColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 153
                        },
                        "custom_data_person_state_assemblymember": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_state_assemblymember",
                            "label": "Assembly Member",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonAssemblyMemberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 159
                        },
                        "custom_data_person_state_councilmember": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_state_councilmember",
                            "label": "Council Members",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonCouncilMemberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 157
                        },
                        "custom_data_person_state_delegate": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_state_delegate",
                            "label": "State Delegates",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonStateDelegateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 158
                        },
                        "custom_data_person_state_representative": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_state_representative",
                            "label": "State Representative for District",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonStateRepresentativeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 156
                        },
                        "custom_data_person_state_senator": {
                            "category": 21,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [79],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_data_person_state_senator",
                            "label": "State Senator for District",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDataPersonStateSenatorColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 155
                        },
                        "custom_description_updated_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_description_updated_date",
                            "label": "Date of Custom Bio",
                            "master_column": false,
                            "miscellaneous": [1, 8, 120],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomDescriptionUpdatedDate",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 15,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last time the custom description of each row was updated",
                            "value": 245
                        },
                        "custom_events_master": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_events_master",
                            "label": "Custom Events Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 193
                        },
                        "custom_field_from_note": {
                            "category": 28,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [1, 12],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_field_from_note",
                            "label": "Custom Field from Note",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomFieldFromNoteColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Custom field from a note this person participated in.",
                            "value": 275
                        },
                        "custom_link": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_link",
                            "label": "Custom Link",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "CustomLinkColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "An empty column that will render the text you enter as a link",
                            "value": 123
                        },
                        "custom_list": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 1,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 83, 20, 42, 107, 109, 47, 49, 113, 114, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_list",
                            "label": "Custom List",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "InListColumn",
                            "region_specific_dict": {},
                            "required_fields": ["source_newlist_id"],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 4
                        },
                        "custom_number": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_number",
                            "label": "Custom Number",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "CustomNumberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A completely empty column that you can add custom numbers to.",
                            "value": 10
                        },
                        "custom_personal_email": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_personal_email",
                            "label": "Personal Email",
                            "master_column": false,
                            "miscellaneous": [1, 8, 120],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomPersonalEmailColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 14,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's set personal email for this person",
                            "value": 238
                        },
                        "custom_personal_phone_number": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1, 8],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_personal_phone_number",
                            "label": "Personal Phone Number",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomPersonalPhoneNumberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 14,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's set personal phone number for this person",
                            "value": 237
                        },
                        "custom_preferred_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_preferred_name",
                            "label": "Preferred Name",
                            "master_column": false,
                            "miscellaneous": [1, 8, 120],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomPreferredNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 14,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's set preferred name for this person",
                            "value": 239
                        },
                        "custom_tag": {
                            "category": 19,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_tag",
                            "label": "Custom Fields",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomTagColumn",
                            "region_specific_dict": {},
                            "required_fields": ["batch_fields"],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 36
                        },
                        "custom_text": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_text",
                            "label": "Custom Text",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "CustomTextColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A completely empty column that you can write in.",
                            "value": 3
                        },
                        "custom_thumb": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": true,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "custom_thumb",
                            "label": "Custom Thumbs Up/Down",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "CustomThumbColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Set a custom Thumbs Up/Thumbs Down/Neutral value.",
                            "value": 304
                        },
                        "date_of_last_outbox_sent_email": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "date_of_last_outbox_sent_email",
                            "label": "Date of last outbox email sent (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The date of the last outbox email sent to each row of your sheet in last 12 months",
                            "proxy": "DateOfLastOutboxEmailSentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date of the last outbox email sent to each row of your sheet",
                            "value": 311
                        },
                        "date_of_last_outbox_sent_email_office": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "date_of_last_outbox_sent_email_office",
                            "label": "Date of last outbox email sent (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The date of the last outbox email sent to the office of each row of your sheet in last 12 months",
                            "proxy": "DateOfLastOutboxEmailSentOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date of the last outbox email sent to the office of each row of your sheet",
                            "value": 312
                        },
                        "date_of_last_outbox_sent_email_organization": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "date_of_last_outbox_sent_email_organization",
                            "label": "Date of last outbox email sent (organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The date of the last outbox email sent to the organization of each row of your sheet in last 12 months",
                            "proxy": "DateOfLastOutboxEmailSentOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date of the last outbox email sent to the organization of each row of your sheet",
                            "value": 443
                        },
                        "date_of_last_public_mention": {
                            "category": 8,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "date_of_last_public_mention",
                            "label": "Date Official Last Mentioned",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DateOfLastPublicMentionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 100,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The date when the official was last mentioned by others in your selection of documents.",
                            "value": 420
                        },
                        "days_inactive": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_inactive",
                            "label": "Days Inactive (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysInactiveColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of days it has been since you last interacted with the data in each row.",
                            "value": 21
                        },
                        "days_inactive_issue": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_inactive_issue",
                            "label": "Days Inactive",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysInactiveIssueColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many days it has been since the last interaction involving each issue",
                            "value": 241
                        },
                        "days_inactive_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_inactive_office",
                            "label": "Days Inactive (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysInactiveOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of days since you have interacted with the official or their staff.",
                            "value": 22
                        },
                        "days_inactive_org": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_inactive_org",
                            "label": "Days Inactive (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysInactiveOrganization",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of days since you have interacted with the press contact's organization.",
                            "value": 445
                        },
                        "days_inactive_org_contacts": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_inactive_org_contacts",
                            "label": "Days Inactive (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysInactiveContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of days it has been since you last interacted with the contacts for each organization.",
                            "value": 229
                        },
                        "days_since_introduced": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_since_introduced",
                            "label": "Days Since Introduced",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysSinceIntroducedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of days since the bill has been introduced",
                            "value": 51
                        },
                        "days_since_last_grassroots_action": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_since_last_grassroots_action",
                            "label": "Days Since Last Action",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysSinceLastGrassrootsActionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The days since the last action of each row of your sheet has participated in",
                            "value": 62
                        },
                        "days_since_major_action": {
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "days_since_major_action",
                            "label": "Days Since Major Action",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DaysSinceMajorActionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of days since a last major action was taken on the bill.",
                            "value": 65
                        },
                        "demographic_stat": {
                            "category": 1,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "demographic_stat",
                            "label": "Demographics",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DemographicStatColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 8
                        },
                        "description": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 83, 20, 42, 107, 109, 47, 113, 114, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "description",
                            "label": "Description",
                            "master_column": false,
                            "miscellaneous": [1, 8, 2, 12, 80, 42, 120],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DescriptionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 14,
                            "sheets_subcategory": [2, 8, 3],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's custom description. You do not need to choose Notes for this column.",
                            "value": 6
                        },
                        "detailed_status_text": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "detailed_status_text",
                            "label": "Detailed Status",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DetailedStatusTextColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 10,
                            "tip": "",
                            "value": 132
                        },
                        "difference_of_columns": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "difference_of_columns",
                            "label": "Difference Of Columns",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "DifferenceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Computes the difference between two columns that are already in the sheet.",
                            "value": 53
                        },
                        "district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "district",
                            "label": "District",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 25,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The official's district",
                            "value": 113
                        },
                        "district_controlling_party": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [109],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "district_controlling_party",
                            "label": "District Controlling Party",
                            "master_column": false,
                            "miscellaneous": 109,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DistrictControllingPartyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 26,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 324
                        },
                        "district_number": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "district_number",
                            "label": "District Number",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "null_cell_value": "N/A",
                            "outbox_perform_tip": "",
                            "proxy": "DistrictNumberColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 26,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The official's district number",
                            "value": 121
                        },
                        "district_office_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": true,
                            "key": "district_office_address",
                            "label": "District Office Address",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DistrictOfficeAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 22,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The address of the district office",
                            "value": 47
                        },
                        "district_office_phone": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": true,
                            "key": "district_office_phone",
                            "label": "District Office Phone Number",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DistrictOfficePhoneColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 22,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The phone number for the district office",
                            "value": 174
                        },
                        "district_representative": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [109],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "district_representative",
                            "label": "District Representative",
                            "master_column": false,
                            "miscellaneous": 109,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DistrictRepresentativeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 27,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 328
                        },
                        "division_of_columns": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "division_of_columns",
                            "label": "Division Of Columns",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "DivisionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Computes the division of any set of numerical columns that are already in the sheet.",
                            "value": 77
                        },
                        "document_mention": {
                            "category": 8,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "document_mention",
                            "label": "Number of Documents",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DocumentMentionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "1": "source_members" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 7
                        },
                        "document_mention_for_bills": {
                            "category": 8,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "document_mention_for_bills",
                            "label": "Document Mentions For Bills",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DocumentMentionForBillsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "about_bill" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 141
                        },
                        "donations_since_last_election": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "donations_since_last_election",
                            "label": "Value of Donations Since First Elected Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [6, 5, 7],
                            "proxy": "ValueOfDonationsSinceElectionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The total value of donations that have been given to this individual since they were first elected to their current role.",
                            "value": 87
                        },
                        "duration_interaction_public_organization": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "duration_interaction_public_organization",
                            "label": "Duration of Interactions (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DurationOfInteractionsPublicOrgColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total duration of interactions that were logged involving the organization in each row in your sheet, in minutes.",
                            "value": 470
                        },
                        "duration_interactions_member": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "duration_interactions_member",
                            "label": "Duration of Interactions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DurationOfInteractionsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "involving_member" },
                            "sheets_column_order": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total duration of interactions that were logged involving a row in your sheet, in minutes.",
                            "value": 205
                        },
                        "duration_interactions_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "duration_interactions_office",
                            "label": "Duration of Interactions (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "DurationOfInteractionsByOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "involving_office" },
                            "sheets_column_order": 17,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total duration of interactions that were logged involving this official or their staff, in minutes.",
                            "value": 206
                        },
                        "email": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "email",
                            "label": "Email",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The email of the user",
                            "value": 99
                        },
                        "end_of_session_text": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "end_of_session_text",
                            "label": "End of Session",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "EndOfSessionTextColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 11,
                            "sheets_subcategory": 10,
                            "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                            "tip": "",
                            "value": 318
                        },
                        "european_commission_dg": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "european_commission_dg",
                            "label": "European Commission DG",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "EuropeanCommissionDGColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 32,
                            "sheets_subcategory": 6,
                            "supported_regions": [106],
                            "tip": "Create a column to show the official's European Directorate-General",
                            "value": 424
                        },
                        "events_added_to_list": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "events_added_to_list",
                            "label": "Events Added To List",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomEventsAddedListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The list of custom events this person has been added to as a participant.",
                            "value": 285
                        },
                        "events_attended_list": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "events_attended_list",
                            "label": "Events Attended List",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomEventsAttendedListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The list of custom events this person has been marked 'attended' on.",
                            "value": 283
                        },
                        "events_emailed_list": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "events_emailed_list",
                            "label": "Events Emailed About List",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomEventsEmailedListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The list of custom events this person has been emailed about.",
                            "value": 282
                        },
                        "events_not_attended_list": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "events_not_attended_list",
                            "label": "Events Not Attended List",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CustomEventsNotAttendedListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The list of custom events this person has been marked 'not attended' on.",
                            "value": 284
                        },
                        "facebook_handles_column": {
                            "category": 34,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [121, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "facebook_handles_column",
                            "label": "Facebook",
                            "master_column": false,
                            "miscellaneous": 42,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "FacebookHandlesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column that links to all associated Facebook profiles",
                            "value": 462
                        },
                        "field": {
                            "category": 1,
                            "coloring_enabled": true,
                            "column_data_type": 10,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 83, 20, 42, 107, 109, 47, 49, 113, 114, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "field",
                            "label": "Field Column",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "FieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 1
                        },
                        "first_assumed_office": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 12,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_first_assumed_office",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "first_assumed_office",
                            "label": "First Assumed Office",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "FirstAssumedOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 5,
                            "supported_regions": [1, 9999, 10002, 10003, 10004, 10005, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 1000],
                            "tip": "The date the member first assumed public office",
                            "value": 40
                        },
                        "first_name": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "first_name",
                            "label": "First Name",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The first name of the user",
                            "value": 97
                        },
                        "future_hearing_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "future_hearing_date",
                            "label": "Future Hearing Dates",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "FutureBillHearingDatesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "sheets_subcategory": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date(s) when hearings will take place on this bill.",
                            "value": 423
                        },
                        "gamification_levels": {
                            "category": 29,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "gamification_levels",
                            "label": "Grassroots Level",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "GrassrootsGamificationLevelsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 278
                        },
                        "gamification_points_for_supporter": {
                            "category": 29,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "gamification_points_for_supporter",
                            "label": "Grassroots Points",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "GrassrootsGamificationPointsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 277
                        },
                        "governor_for_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "governor_for_state",
                            "label": "Governor",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "GovernorForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 18,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 293
                        },
                        "governors_party_for_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "governors_party_for_state",
                            "label": "Governor's Party",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "GovernorsPartyForStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 19,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 294
                        },
                        "grassroots": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "grassroots",
                            "label": "Grassroots Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 84
                        },
                        "grassroots_gamification": {
                            "category": 29,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "grassroots_gamification",
                            "label": "Grassroots Gamification Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 279
                        },
                        "hearing_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "hearing_date",
                            "label": "Hearing Dates",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AllBillHearingDatesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "sheets_subcategory": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date(s) when hearings will take place or did take place on this bill.",
                            "value": 202
                        },
                        "in_issue": {
                            "category": 24,
                            "coloring_enabled": false,
                            "column_data_type": 2,
                            "data_types": [1, 2, 25, 8, 80, 12, 4, 3, 42, 47],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "in_issue",
                            "label": "Issues",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "InIssueColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "What issues is this row connected to",
                            "value": 199
                        },
                        "interactions_master": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "interactions_master",
                            "label": "Interactions Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 86
                        },
                        "internal_link": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 83, 20, 42, 107, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "internal_link",
                            "label": "Internal Quorum Link",
                            "master_column": false,
                            "miscellaneous": [1, 2, 3, 4, 8, 12, 79, 80, 83, 20, 42, 107, 47, 49, 113, 114, 120, 59],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "InternalLinkColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 99,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column showing a clickable link to the internal resources of the sheet",
                            "value": 300
                        },
                        "issue_assignment": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "issue_assignment",
                            "label": "Assignments",
                            "master_column": false,
                            "miscellaneous": 83,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "IssueAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Contacts and users assiged to an issue",
                            "value": 185
                        },
                        "issue_description": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "issue_description",
                            "label": "Issue Description",
                            "master_column": false,
                            "miscellaneous": 83,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "IssueDescriptionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 186
                        },
                        "issue_parent": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "issue_parent",
                            "label": "Primary Issue",
                            "master_column": false,
                            "miscellaneous": 83,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "IssueParentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Shows the name of the primary issue if the row is a subissue",
                            "value": 187
                        },
                        "issue_priority": {
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "issue_priority",
                            "label": "Priority",
                            "master_column": false,
                            "miscellaneous": 83,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "IssuePriorityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's priority regarding an issue",
                            "value": 184
                        },
                        "issue_stance": {
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "issue_stance",
                            "label": "Stance",
                            "master_column": false,
                            "miscellaneous": 83,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "IssueStanceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Your organization's stance towards an issue",
                            "value": 183
                        },
                        "last_authorized_amount": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_authorized_amount",
                            "label": "Last Authorized Amount",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastAuthorizedAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last authorized amount of each row of your sheet has participated in",
                            "value": 646
                        },
                        "last_authorized_payment_method": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_authorized_payment_method",
                            "label": "Last Authorized Payment Method",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastAuthorizedPaymentMethodColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last authorized payment method of each row of your sheet has participated in.",
                            "value": 645
                        },
                        "last_interaction": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction",
                            "label": "Date and Time of Last Note (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The date and time of the last interaction or comment that was logged involving the data in each row.",
                            "value": 17
                        },
                        "last_interaction_date_only": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_date_only",
                            "label": "Date of Last Note (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionDateOnlyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last interaction or comment that was logged involving the data in each row.",
                            "value": 280
                        },
                        "last_interaction_issue": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_issue",
                            "label": "Date of Last Note",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionIssueColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Date of the last interaction involving each issue",
                            "value": 242
                        },
                        "last_interaction_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_office",
                            "label": "Date and Time of Last Note (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The date and time of the last interaction that was logged involving this official or their staff.",
                            "value": 55
                        },
                        "last_interaction_office_date_only": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_office_date_only",
                            "label": "Date of Last Note (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionOfficeDateOnlyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The last interaction that was logged involving this official or their staff.",
                            "value": 281
                        },
                        "last_interaction_org_contacts": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_org_contacts",
                            "label": "Date of Last Note (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last interaction or comment that was logged involving a contact from each organization",
                            "value": 230
                        },
                        "last_interaction_org_date": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_org_date",
                            "label": "Date of Last Note (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionDateOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last interaction or comment that was logged involving a press contact from each organization",
                            "value": 448
                        },
                        "last_interaction_press_org": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_press_org",
                            "label": "Date of Last Note (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionPressOrgColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last interaction that was logged involving a contact from each organization",
                            "value": 449
                        },
                        "last_interaction_public_organization": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_public_organization",
                            "label": "Date and Time of Last Note (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionPublicOrgColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The date and time of the last interaction or comment that was logged involving the organization in each row.",
                            "value": 467
                        },
                        "last_interaction_type": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_type",
                            "label": "Type of Last Note (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionTypeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last type of interaction that was logged involving the data in each row.",
                            "value": 249
                        },
                        "last_interaction_type_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_type_office",
                            "label": "Type of Last Note (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionTypeOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The last type of interaction that was logged involving this official or their staff.",
                            "value": 250
                        },
                        "last_interaction_type_public_organization": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_interaction_type_public_organization",
                            "label": "Type of Last Note (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastInteractionTypePublicOrgColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last type of interaction that was logged involving the organization in each row.",
                            "value": 468
                        },
                        "last_name": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_name",
                            "label": "Last Name",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The last name of the user",
                            "value": 98
                        },
                        "last_note": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_note",
                            "label": "Last Note Text (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastNoteColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The text of the most recent note entered about the data in each row.",
                            "value": 23
                        },
                        "last_note_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_note_office",
                            "label": "Last Note Text (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastNoteOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The text of the most recent note / interaction / relationship entered about each official or their staff.",
                            "value": 91
                        },
                        "last_note_text_public_organization": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_note_text_public_organization",
                            "label": "Last Note Text (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastNoteTextPublicOrgColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The text of the most recent note entered about the organization in each row.",
                            "value": 469
                        },
                        "last_reg_timeline_action_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_reg_timeline_action_date",
                            "label": "Last Timeline Action Date",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastRegTimelineActionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 33,
                            "sheets_subcategory": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column to show a Regulation's Last Timeline Action Date",
                            "value": 452
                        },
                        "last_timeline_action": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_timeline_action",
                            "label": "Last Timeline Action",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastTimelineActionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 10,
                            "tip": "The Most Recent Timeline Action for the bills in your sheet",
                            "value": 129
                        },
                        "last_timeline_action_date": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "last_timeline_action_date",
                            "label": "Last Timeline Action Date",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastTimelineActionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 10,
                            "tip": "The Most Recent Timeline Action Date for this sheets' set of bills",
                            "value": 130
                        },
                        "legislation": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "legislation",
                            "label": "Legislation Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LegislationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 78
                        },
                        "level_of_official": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "level_of_official",
                            "label": "Official's Level",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "OfficialsLevelColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 31,
                            "sheets_subcategory": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "The level of the officials in this sheet ('Federal', 'State', 'Local')",
                            "value": 133
                        },
                        "mailing_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": true,
                            "key": "mailing_address",
                            "label": "Mailing Address",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MailingAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 23,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The mailing address of the relevant person.",
                            "value": 150
                        },
                        "member_birth_month_day": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "member_birth_month_day",
                            "label": "Birth Month & Day",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 29,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing the birth month and day of a legislator.",
                            "value": 126
                        },
                        "member_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 8,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "member_name",
                            "label": "Member's Name",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 40,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Which member this person works for",
                            "value": 136
                        },
                        "member_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 8,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "member_state",
                            "label": "Member's State",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 41,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The state of the member this person works for",
                            "value": 296
                        },
                        "member_website": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [1, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": true,
                            "key": "member_website",
                            "label": "Website",
                            "master_column": false,
                            "miscellaneous": [1, 8, 120],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 25,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The member's website",
                            "value": 112
                        },
                        "most_recent_article_date_per_press_contact": {
                            "category": 35,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_article_date_per_press_contact",
                            "label": "Most Recent Date of Publication",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "MostRecentArticlePublishedDatePerPressContactColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Most recent published article's date by author",
                            "value": 475
                        },
                        "most_recent_article_title_per_press_contact": {
                            "category": 35,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_article_title_per_press_contact",
                            "label": "Most Recent Publication Title",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "MostRecentArticlePublishedTitlePerPressContactColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Most recent published article's title by author",
                            "value": 474
                        },
                        "most_recent_bill_ai_summary": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_bill_ai_summary",
                            "label": "AI Summary",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MostRecentAISummaryColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The AI generated summary of the bill.",
                            "value": 666
                        },
                        "most_recent_date_participated_campaign": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_date_participated_campaign",
                            "label": "Date of Most Recent Participated Campaign",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MostRecentDateParticipatedCampaignColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The date of the most of recent campaign each row of your sheet has participated in",
                            "value": 61
                        },
                        "most_recent_description": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_description",
                            "label": "Official Summary",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MostRecentDescriptionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The official summary of the bill.",
                            "value": 50
                        },
                        "most_recent_text_grassroots_action": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_text_grassroots_action",
                            "label": "Text of Last Action",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MostRecentTextGrassrootsActionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The text of the most recent grassroots action that each row of your sheet has participated in",
                            "value": 64
                        },
                        "most_recent_type_grassroots_action": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "most_recent_type_grassroots_action",
                            "label": "Type of Last Action",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MostRecentTypeGrassrootsActionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The type of last action that each row of your sheet has participated in",
                            "value": 63
                        },
                        "multiplication_of_columns": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "multiplication_of_columns",
                            "label": "Multiplication Of Columns",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "MultiplicationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Computes the multiplication of any set of numerical columns that are already in the sheet.",
                            "value": 76
                        },
                        "nay_votes": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "nay_votes",
                            "label": "# of Nay Votes",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfNayVotesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "nay_voters_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of nay votes this person has voted for",
                            "value": 80
                        },
                        "news_articles_master": {
                            "category": 35,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "news_articles_master",
                            "label": "News Article Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 472
                        },
                        "news_mention": {
                            "category": 30,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "news_mention",
                            "label": "News Mentions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NewsMentionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "1": "mentions_officials" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 31
                        },
                        "next_interaction": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "next_interaction",
                            "label": "Next Interaction Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NextInteractionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The next interaction that is scheduled involving the data in each row.",
                            "value": 18
                        },
                        "next_interaction_issue": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "next_interaction_issue",
                            "label": "Date of Next Note",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NextInteractionIssueColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Date of the next interaction involving each issue",
                            "value": 243
                        },
                        "next_interaction_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "next_interaction_office",
                            "label": "Next Interaction Date (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NextInteractionOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The next interaction that is scheduled involving the office of the official in each row.",
                            "value": 313
                        },
                        "none": {
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "none",
                            "label": "None",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "Column",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": ""
                        },
                        "note_interaction_type": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_interaction_type",
                            "label": "Interaction Type",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteInteractionTypeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Interaction Type of the Note.",
                            "value": 422
                        },
                        "note_participants": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_participants",
                            "label": "Participant List (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteParticipantsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of all the team members, contacts, officials, organizations, etc. that participated in the selected notes with each row.",
                            "value": 88
                        },
                        "note_participants_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_participants_office",
                            "label": "Participant List (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteParticipantsOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "A list of all the team members, contacts, officials, organizations, etc. that have some relationship with the Official in each row.",
                            "value": 89
                        },
                        "note_participants_org": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_participants_org",
                            "label": "Participant List (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteParticipantsOrganziationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "A list of all the organizations that have some relationship with the press contact in each row.",
                            "value": 447
                        },
                        "note_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_state",
                            "label": "State",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteStatesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The state(s) of the participants on the note.",
                            "value": 675
                        },
                        "note_text": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "note_text",
                            "label": "Text",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NoteTextColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The text of the note.",
                            "value": 271
                        },
                        "num_of_events_added_to": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_added_to",
                            "label": "Number of Events Added To",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsAddedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 188
                        },
                        "num_of_events_attended": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_attended",
                            "label": "Number of Events Attended",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsAttendedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 192
                        },
                        "num_of_events_emailed_about": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_emailed_about",
                            "label": "Number of Events Emailed About",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsEmailedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 189
                        },
                        "num_of_events_not_attended": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_not_attended",
                            "label": "Number of Events Not Attended",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsNotAttendedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 286
                        },
                        "num_of_events_rsvp_no": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_rsvp_no",
                            "label": "Number of Events RSVPed 'No'",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsRsvpNoColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 191
                        },
                        "num_of_events_rsvp_yes": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [8, 29, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "num_of_events_rsvp_yes",
                            "label": "Number of Events RSVPed 'Yes'",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfCustomEventsRsvpYesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 190
                        },
                        "number_of_campaign_actions": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_campaign_actions",
                            "label": "Number of Actions",
                            "master_column": false,
                            "miscellaneous": 47,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfActionsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many actions have been taken in the campaign",
                            "value": 143
                        },
                        "number_of_campaign_page_visits": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_campaign_page_visits",
                            "label": "Number of Visits",
                            "master_column": false,
                            "miscellaneous": 47,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfPageVisitsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many times the campaign page was visited",
                            "value": 152
                        },
                        "number_of_campaign_participants": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_campaign_participants",
                            "label": "Number of Participants",
                            "master_column": false,
                            "miscellaneous": 47,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfParticipantsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How many participants the campaign has",
                            "value": 142
                        },
                        "number_of_emails_clicked": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 12, 8],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_clicked",
                            "label": "Number of Emails Clicked (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails that each row of your sheet has clicked in last 12 months",
                            "proxy": "NumberOfEmailsClickedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails that each row of your sheet has clicked",
                            "value": 71
                        },
                        "number_of_emails_clicked_office": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_clicked_office",
                            "label": "Number of Emails Clicked (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails that each row of your sheet's office has clicked in last 12 months",
                            "proxy": "NumberOfEmailsClickedOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails that each row of your sheet's office has clicked",
                            "value": 72
                        },
                        "number_of_emails_clicked_org_contacts": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_clicked_org_contacts",
                            "label": "Number of Emails Clicked (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsClickedContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails contacts of each organization of your sheet has clicked",
                            "value": 233
                        },
                        "number_of_emails_clicked_org_press": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_clicked_org_press",
                            "label": "Number of Emails Clicked (Press)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "NumberOfEmailsClickedPressContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails press contacts of each organization of your sheet has clicked",
                            "value": 455
                        },
                        "number_of_emails_clicked_organization": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_clicked_organization",
                            "label": "Number of Emails Clicked (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsClickedOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails that each row of your sheet's office has clicked",
                            "value": 441
                        },
                        "number_of_emails_opened": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_opened",
                            "label": "Number of Emails Opened (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails each row of your sheet has opened in last 12 months",
                            "proxy": "NumberOfEmailsOpenedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails each row of your sheet has opened",
                            "value": 69
                        },
                        "number_of_emails_opened_office": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_opened_office",
                            "label": "Number of Emails Opened (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails each office of the row of your sheet has opened in last 12 months",
                            "proxy": "NumberOfEmailsOpenedOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails each office of the row of your sheet has opened",
                            "value": 70
                        },
                        "number_of_emails_opened_org_contacts": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_opened_org_contacts",
                            "label": "Number of Emails Opened (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsOpenedContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails contacts of each organization of your sheet has opened",
                            "value": 232
                        },
                        "number_of_emails_opened_org_press": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_opened_org_press",
                            "label": "Number of Emails Opened (Press)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "NumberOfEmailsOpenedPressContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails press contacts of each organization of your sheet has opened",
                            "value": 454
                        },
                        "number_of_emails_opened_organization": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_opened_organization",
                            "label": "Number of Emails Opened (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsOpenedOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails each organization of the row of your sheet has opened",
                            "value": 440
                        },
                        "number_of_emails_received": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_received",
                            "label": "Number of Emails Received (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails each row of your sheet has received in last 12 months",
                            "proxy": "NumberOfEmailsReceivedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails each row of your sheet has received",
                            "value": 67
                        },
                        "number_of_emails_received_office": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_received_office",
                            "label": "Number of Emails Received (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of office emails each official has received in last 12 months",
                            "proxy": "NumberOfEmailsReceivedOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of office emails each official has received",
                            "value": 68
                        },
                        "number_of_emails_received_org_contacts": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_received_org_contacts",
                            "label": "Number of Emails Received (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsReceivedContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails contacts of each organization of your sheet has received",
                            "value": 234
                        },
                        "number_of_emails_received_org_press": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_received_org_press",
                            "label": "Number of Emails Received (Press)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "NumberOfEmailsReceivedPressContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails press contacts of each organization of your sheet has received",
                            "value": 453
                        },
                        "number_of_emails_received_organization": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_received_organization",
                            "label": "Number of Emails Received (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsReceivedOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of office emails each organization has received",
                            "value": 439
                        },
                        "number_of_emails_replied": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 12, 8, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_replied",
                            "label": "Number of Emails Replied (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails that each row of your sheet has clicked in last 12 months",
                            "proxy": "NumberOfEmailsRepliedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails that each row of your sheet has clicked",
                            "value": 73
                        },
                        "number_of_emails_replied_office": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_replied_office",
                            "label": "Number of Emails Replied (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "The number of emails that each row of your sheet's office has clicked in last 12 months",
                            "proxy": "NumberOfEmailsRepliedOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails that each row of your sheet's office has clicked",
                            "value": 74
                        },
                        "number_of_emails_replied_org_contacts": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_replied_org_contacts",
                            "label": "Number of Emails Replied (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsRepliedContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails contacts of each organization of your sheet has replied",
                            "value": 235
                        },
                        "number_of_emails_replied_org_press": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_replied_org_press",
                            "label": "Number of Emails Replied (Press)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "NumberOfEmailsRepliedPressContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of emails press contacts of each organization of your sheet has replied",
                            "value": 456
                        },
                        "number_of_emails_replied_organization": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_emails_replied_organization",
                            "label": "Number of Emails Replied (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfEmailsRepliedOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of emails that each row of your sheet's organization has clicked",
                            "value": 442
                        },
                        "number_of_grassroots_actions": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_grassroots_actions",
                            "label": "Number of Grassroots Actions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfGrassrootsActionsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "1": "involving_member", "12": "involving_supporter" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of grassroots actions each row of your sheet has participated in ",
                            "value": 66
                        },
                        "number_of_participated_campaigns": {
                            "category": 14,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_participated_campaigns",
                            "label": "Number of Participated Campaigns",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfParticipatedCampaignsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of campaigns each row of your sheet has participated in ",
                            "value": 60
                        },
                        "number_of_sponsors": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_sponsors",
                            "label": "Number of Sponsors",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfSponsorsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Number of Sponsors",
                            "value": 46
                        },
                        "number_of_texts_clicked": {
                            "category": 38,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_texts_clicked",
                            "label": "Number of Texts Clicked",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTextsClickedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 668
                        },
                        "number_of_texts_failed": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [113],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_texts_failed",
                            "label": "Number of Texts Failed",
                            "master_column": false,
                            "miscellaneous": 113,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTextsFailedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 672
                        },
                        "number_of_texts_received": {
                            "category": 38,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_texts_received",
                            "label": "Number of Texts Received",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTextsReceivedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 667
                        },
                        "number_of_texts_unsubscribed": {
                            "category": 38,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_texts_unsubscribed",
                            "label": "Number of Texts Unsubscribed",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTextsUnsubscribedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 669
                        },
                        "number_of_times_cosponsored": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_times_cosponsored",
                            "label": "# of times cosponsored",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTimesCoSponsorsedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "cosponsored_by_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of times this person has cosponsored the selected legislation",
                            "value": 82
                        },
                        "number_of_times_sponsored": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_times_sponsored",
                            "label": "# of times sponsored",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTimesSponsorsedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "sponsored_by_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of times this person has sponsored the selected legislation",
                            "value": 81
                        },
                        "number_of_times_sponsored_and_cosponsored": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "number_of_times_sponsored_and_cosponsored",
                            "label": "# of times sponsored & cosponsored",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfTimesSponsorsedAndCosponsoredColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "sponsored_or_cosponsored_by_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of times this person has sponsored and cosponsored the selected legislation",
                            "value": 83
                        },
                        "official_campaign_finance_itemized_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "official_campaign_finance_itemized_amount_for_years",
                            "label": "Total Itemized Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceOfficialYearsItemizedSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of itemized receipts in dollar amount received by each official in the selected year(s)",
                            "value": 608
                        },
                        "official_campaign_finance_political_committee": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "official_campaign_finance_political_committee",
                            "label": "Total Amount Received by Political Committee",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceOfficialPoliticalCommitteeSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 610,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount received from a selected political committee",
                            "value": 610
                        },
                        "official_campaign_finance_total_available_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "official_campaign_finance_total_available_amount_for_years",
                            "label": "Total Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceOfficialTotalYearsSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of itemized and unitemized contributions in dollar amount received from each official in the selected year(s)",
                            "value": 644
                        },
                        "official_campaign_finance_unitemized_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "official_campaign_finance_unitemized_amount_for_years",
                            "label": "Total UnItemized Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceOfficialYearsUnitemizedSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of unitemized contributions received by each officials' Federal Candidate Committee in the selected year(s).",
                            "value": 643
                        },
                        "organization_assignment": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "organization_assignment",
                            "label": "Related Contacts",
                            "master_column": false,
                            "miscellaneous": 42,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "OrganizationAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The contacts that are associated with each organization.",
                            "value": 75
                        },
                        "organization_name": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "organization_name",
                            "label": "Organization",
                            "master_column": false,
                            "miscellaneous": 59,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The user's organization",
                            "value": 100
                        },
                        "organization_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "organization_state",
                            "label": "Organization's State",
                            "master_column": false,
                            "miscellaneous": 42,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Shows the in which state the organization resides.",
                            "value": 227
                        },
                        "organizations_for_people": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "organizations_for_people",
                            "label": "Organizations",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 106],
                            "tip": "",
                            "value": 251
                        },
                        "other_votes": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "other_votes",
                            "label": "# of Missed/Other Votes",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfOtherVotesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "missed_voters_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of times votes this person has missed or otherwise did not vote (or abstain)",
                            "value": 140
                        },
                        "outbox": {
                            "category": 15,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "outbox",
                            "label": "Outbox Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 85
                        },
                        "outlet_mailing_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "outlet_mailing_address",
                            "label": "Outlet Mailing Address",
                            "master_column": false,
                            "miscellaneous": 120,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The address of the outlet.",
                            "value": 464
                        },
                        "parent_organization": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "parent_organization",
                            "label": "Parent Organization",
                            "master_column": false,
                            "miscellaneous": 42,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Shows the name of the primary organization of each row",
                            "value": 224
                        },
                        "participating_contacts": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_contacts",
                            "label": "Participating Contacts",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Contacts participating in the interaction.",
                            "value": 262
                        },
                        "participating_offices": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_offices",
                            "label": "Associated Offices",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingOfficesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Officials whose Offices are participating in the interaction.",
                            "value": 269
                        },
                        "participating_officials": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_officials",
                            "label": "Participating Officials",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingOfficialsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Officials participating in the interaction.",
                            "value": 263
                        },
                        "participating_public_organizations": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_public_organizations",
                            "label": "Participating Organizations",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingPublicOrganizationsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Organizations participating in the interaction.",
                            "value": 265
                        },
                        "participating_staffers": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_staffers",
                            "label": "Participating Staffers",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingStaffersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of staffers participating in the interaction.",
                            "value": 264
                        },
                        "participating_team_members": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [20],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "participating_team_members",
                            "label": "Participating Team Members",
                            "master_column": false,
                            "miscellaneous": 20,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ParticipatingTeamMembersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 16,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "A list of Team Members participating in the interaction.",
                            "value": 261
                        },
                        "parties": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "parties",
                            "label": "Parties",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 26,
                            "sheets_subcategory": 6,
                            "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                            "tip": "A list of all the parties this person is affiliated with",
                            "value": 260
                        },
                        "percentage_of_columns": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "percentage_of_columns",
                            "label": "Percentage of Columns",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "PercentageColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Compute the percentage of any 2 columns in your sheet.",
                            "value": 182
                        },
                        "percentage_of_texts_clicked": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [113],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "percentage_of_texts_clicked",
                            "label": "% of Texts Clicked",
                            "master_column": false,
                            "miscellaneous": 113,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PercentageOfTextsClickedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 673
                        },
                        "percentage_of_texts_unsubscribed": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [113],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "percentage_of_texts_unsubscribed",
                            "label": "% of Texts Unsubscribed",
                            "master_column": false,
                            "miscellaneous": 113,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PercentageOfTextsUnsubscribedColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 671
                        },
                        "person_military": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 1,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "person_military",
                            "label": "Military Experience",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 40,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "If this person has any military experience",
                            "value": 135
                        },
                        "person_stat": {
                            "category": 4,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "person_stat",
                            "label": "Person Stat",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PersonStatColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 2
                        },
                        "political_committee_candidate": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_candidate",
                            "label": "Candidate Name",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeCandidateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 99,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The candidate name associated with the political committee, if any.",
                            "value": 411
                        },
                        "political_committee_candidate_first_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_candidate_first_name",
                            "label": "Candidate First Name",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeCandidateFirstNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 100,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Candidate's first name",
                            "value": 621
                        },
                        "political_committee_candidate_last_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_candidate_last_name",
                            "label": "Candidate Last Name",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeCandidateLastNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 101,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Candidate's last name",
                            "value": 622
                        },
                        "political_committee_candidate_office_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_candidate_office_state",
                            "label": "Office State",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeCandidateOfficeStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 102,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Candidate's office state",
                            "value": 623
                        },
                        "political_committee_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_district",
                            "label": "Committee District",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 32,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column to show the district sought",
                            "value": 430
                        },
                        "political_committee_fec_candidacy": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_fec_candidacy",
                            "label": "FEC Candidacy",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeFECCandidacyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 99,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The FEC Candidacy associated with the political committee, if any.",
                            "value": 412
                        },
                        "political_committee_next_election_year": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 12,
                            "data_types": [],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_next_election_year",
                            "label": "Next Election Year",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeNextElectionCycleYearColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 32,
                            "sheets_subcategory": 18,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column to show the next election cycle year",
                            "value": 431
                        },
                        "political_committee_transaction_affiliated_sum_for_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_affiliated_sum_for_elections",
                            "label": "Total Affiliated Amount by Elections",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAffiliatedAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 603,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money given to affiliated political committees in selected elections",
                            "value": 603
                        },
                        "political_committee_transaction_affiliated_sum_for_years": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_affiliated_sum_for_years",
                            "label": "Total Affiliated Amount by Years",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAffiliatedAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 602,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money given to affiliated political committees in selected years",
                            "value": 602
                        },
                        "political_committee_transaction_affiliated_sum_for_years_or_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [],
                            "deprecated": true,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_affiliated_sum_for_years_or_elections",
                            "label": "Total Affiliated Amount by Elections/Years",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAffiliatedAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the total amount of money given to affiliated political committees in the years or elections you have selected",
                            "value": 458
                        },
                        "political_committee_transaction_available_amount_for_election": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_available_amount_for_election",
                            "label": "Total Available Amount by Election",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationAvailableAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 607,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money available to each political committee in the selected election",
                            "value": 607
                        },
                        "political_committee_transaction_available_amount_for_year": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_available_amount_for_year",
                            "label": "Total Available Amount by Year",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationAvailableAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 606,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money available to each political committee in the selected year",
                            "value": 606
                        },
                        "political_committee_transaction_available_amount_for_years_or_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [],
                            "deprecated": true,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_available_amount_for_years_or_elections",
                            "label": "Total Available Amount by Election/Year",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationAvailableAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the total amount of money available to each political committee in the year or election you have selected",
                            "value": 460
                        },
                        "political_committee_transaction_limit_amount_for_election": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_limit_amount_for_election",
                            "label": "Limit Amount by Election",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationLimitColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 605,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the FEC limit for each political committee for the selected election",
                            "value": 605
                        },
                        "political_committee_transaction_limit_amount_for_year": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_limit_amount_for_year",
                            "label": "Limit Amount by Year",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationLimitColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 604,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the FEC limit for each political committee in the selected year",
                            "value": 604
                        },
                        "political_committee_transaction_limit_amount_for_years_or_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [],
                            "deprecated": true,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_limit_amount_for_years_or_elections",
                            "label": "Limit Amount by Election/Year",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationLimitColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the FEC limit for each political committee in the year or election you have selected",
                            "value": 459
                        },
                        "political_committee_transaction_sum_for_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_sum_for_elections",
                            "label": "Total Amount by Elections",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 601,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money given to each political committee in selected elections",
                            "value": 601
                        },
                        "political_committee_transaction_sum_for_years": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [114],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_sum_for_years",
                            "label": "Total Amount by Years",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 600,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Compute the total amount of money given to each political committee in selected years",
                            "value": 600
                        },
                        "political_committee_transaction_sum_for_years_or_elections": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [],
                            "deprecated": true,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committee_transaction_sum_for_years_or_elections",
                            "label": "Total Amount by Elections/Years",
                            "master_column": false,
                            "miscellaneous": 114,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PoliticalCommitteeTransactionAggregationTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the total amount of money given to each political committee in the years or elections you have selected",
                            "value": 457
                        },
                        "political_committees_campaign_finance_available_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_available_amount_for_years",
                            "label": "Total Itemized Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteesYearsItemizedSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of itemized receipts in dollar amount received by each political committee in the selected year(s)",
                            "value": 612
                        },
                        "political_committees_campaign_finance_available_total_amount_received": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_available_total_amount_received",
                            "label": "Total Amount Received by Political Committee",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteeTotalAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 613,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money received from a selected political committee",
                            "value": 613
                        },
                        "political_committees_campaign_finance_disbursed_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_disbursed_amount_for_years",
                            "label": "Total Amount Disbursed by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteesDisbursedYearsSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 616,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount of money disbursed by each political committee in the selected year(s)",
                            "value": 616
                        },
                        "political_committees_campaign_finance_disbursements_sum": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_disbursements_sum",
                            "label": "Total Amount Disbursed to Political Committee",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinanceOfficialPoliticalCommitteesDisbursedFromCommitteeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 619,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Computes the total amount disbursed to a selected political committee",
                            "value": 619
                        },
                        "political_committees_campaign_finance_first_contribution_date": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_first_contribution_date",
                            "label": "First Contribution Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteeFirstContributionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 614,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "First contribution date of a selected political committee",
                            "value": 614
                        },
                        "political_committees_campaign_finance_last_contribution_date": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_last_contribution_date",
                            "label": "Last Contribution Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteeLastContributionDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 615,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Last contribution date of a selected political committee",
                            "value": 615
                        },
                        "political_committees_campaign_finance_total_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_total_amount_for_years",
                            "label": "Total Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteesYearsTotalSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of unitemized and itemized contributions in dollar amount received by each political committee in the selected year(s)",
                            "value": 642
                        },
                        "political_committees_campaign_finance_unitemized_amount_for_years": {
                            "category": 37,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": 114,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "political_committees_campaign_finance_unitemized_amount_for_years",
                            "label": "Total UnItemized Amount Received by Year",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CampaignFinancePoliticalCommitteesYearsUnitemizedSumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Sum of unitemized receipts in dollar amount received by each political committee in the selected year(s)",
                            "value": 641
                        },
                        "press_location": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "press_location",
                            "label": "Location",
                            "master_column": false,
                            "miscellaneous": 120,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The location of the person's most recent role.",
                            "value": 465
                        },
                        "press_type_role": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "press_type_role",
                            "label": "Type",
                            "master_column": false,
                            "miscellaneous": 120,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The person's role type.",
                            "value": 466
                        },
                        "primary_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": true,
                            "key": "primary_address",
                            "label": "Capitol Office Address",
                            "master_column": false,
                            "miscellaneous": [1, 8],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "CapitalAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 22,
                            "sheets_subcategory": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The primary address of the relevant person.",
                            "value": 92
                        },
                        "priority_modified_by": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2, 80, 83, 4],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "priority_modified_by",
                            "label": "Priority Modified (User)",
                            "master_column": false,
                            "miscellaneous": [2, 80, 83, 4],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PriorityModifiedByColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Who last modified your Organization's priority",
                            "value": 148
                        },
                        "priority_modified_when": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [2, 80, 83, 4],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "priority_modified_when",
                            "label": "Priority Modified (Date)",
                            "master_column": false,
                            "miscellaneous": [2, 80, 83, 4],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PriorityModifiedWhenColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "When your Organization's priority on this was changed",
                            "value": 149
                        },
                        "project_stats": {
                            "category": 4,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "project_stats",
                            "label": "Project Statistics",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ProjectStatsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 30
                        },
                        "quorum_biography": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 1,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "quorum_biography",
                            "label": "Quorum Biography",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 41,
                            "sheets_subcategory": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "A person's biography as generated by Quorum",
                            "value": 137
                        },
                        "quorum_id": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2, 1, 120, 42, 8, 12, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "quorum_id",
                            "label": "Quorum ID",
                            "master_column": false,
                            "miscellaneous": [2, 1, 120, 42, 8, 12, 59],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "QuorumIdColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The row's Quorum ID",
                            "value": 181
                        },
                        "reg_agency_names": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_agency_names",
                            "label": "Agency Name(s)",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 15,
                            "sheets_subcategory": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Name of the agencies for this regulation",
                            "value": 194
                        },
                        "reg_contact_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_contact_address",
                            "label": "Contact - Address",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 18,
                            "sheets_subcategory": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Address of the contact for this regulation",
                            "value": 197
                        },
                        "reg_contact_email": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_contact_email",
                            "label": "Contact - Email",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 17,
                            "sheets_subcategory": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Email of the contact for this regulation",
                            "value": 196
                        },
                        "reg_contact_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_contact_name",
                            "label": "Contact - Name",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "sheets_subcategory": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Name of the contact for this regulation",
                            "value": 195
                        },
                        "reg_contact_phone": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_contact_phone",
                            "label": "Contact - Phone",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 19,
                            "sheets_subcategory": 15,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Phone of the contact for this regulation",
                            "value": 198
                        },
                        "reg_last_timeline_action": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "reg_last_timeline_action",
                            "label": "Last Timeline Action",
                            "master_column": false,
                            "miscellaneous": [80],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "LastTimelineActionRegsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 204
                        },
                        "region_abbrev_bill": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [2, 80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "region_abbrev_bill",
                            "label": "Region Abbreviation ",
                            "master_column": false,
                            "miscellaneous": [2, 80],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "BillRegionAbbreviationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column of the abbreviation of the most recent legislature this legislation originated from",
                            "value": 201
                        },
                        "region_abbrev_person": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "region_abbrev_person",
                            "label": "Region Abbreviation",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "PersonRegionAbbreviationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 16,
                            "sheets_subcategory": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column of the abbreviation of the most recent legislature the person has been a part of",
                            "value": 200
                        },
                        "region_label": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "region_label",
                            "label": "Region",
                            "master_column": false,
                            "miscellaneous": [80],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RegionNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 203
                        },
                        "regulations_assignment": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [80],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "regulations_assignment",
                            "label": "Regulation User Assignment",
                            "master_column": false,
                            "miscellaneous": 80,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 15,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The team member assigned",
                            "value": 315
                        },
                        "relationship": {
                            "category": 10,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "relationship",
                            "label": "Relationship",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelationshipColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 26
                        },
                        "representatives_house": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "representatives_house",
                            "label": "Contacts' Representative",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RepRepresentationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create a column showing your contacts' Representative",
                            "value": 116
                        },
                        "representatives_mayors": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "representatives_mayors",
                            "label": "Contacts' Mayor",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MayorRepresentationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' Mayor",
                            "value": 314
                        },
                        "representatives_senators": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "representatives_senators",
                            "label": "Contacts' Senators",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SenateRepresentationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create a column showing your contacts' Senators",
                            "value": 115
                        },
                        "representatives_state_rep": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "representatives_state_rep",
                            "label": "Contacts' State Representative",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StateRepRepresentationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create a column showing your contacts' State representative",
                            "value": 118
                        },
                        "representatives_state_senators": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "representatives_state_senators",
                            "label": "Contacts' State Senator",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StateSenatorRepresentationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Create a column showing your contacts' State Senator",
                            "value": 117
                        },
                        "represented_by": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "represented_by",
                            "label": "All Representatives",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "AllRepresentativesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column showing all of your contacts' representatives",
                            "value": 52
                        },
                        "rsvp_status_of_custom_event": {
                            "category": 23,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [1, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "rsvp_status_of_custom_event",
                            "label": "RSVP Status",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RSVPStatusOfCustomEventColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The RSVP Status of a person to a custom event",
                            "value": 274
                        },
                        "social_bio": {
                            "category": 34,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [120, 121],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "social_bio",
                            "label": "Twitter Biography",
                            "master_column": false,
                            "miscellaneous": [120, 121],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "SocialBioColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The about section of their most popular Twitter account",
                            "value": 476
                        },
                        "social_followers": {
                            "category": 34,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120, 121],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "social_followers",
                            "label": "Twitter Followers",
                            "master_column": false,
                            "miscellaneous": [120, 121],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "SocialFollowersColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Total Twitter followers across all accounts",
                            "value": 477
                        },
                        "social_mention": {
                            "category": 20,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": 12,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "social_mention",
                            "label": "Social Media Mentions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SocialMentionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 138
                        },
                        "source_link": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "source_link",
                            "label": "Source Link",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SourceLinkColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 20,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column showing the source link of the bills in your sheet",
                            "value": 120
                        },
                        "sponsors_list": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "sponsors_list",
                            "label": "Sponsors List",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SponsorsListColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 11,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The sponsors of this bill",
                            "value": 48
                        },
                        "sponsorship_date": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "sponsorship_date",
                            "label": "Sponsorship Date",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SponsorshipDateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The date in which this person sponsored this bill",
                            "value": 134
                        },
                        "sponsorship_record": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "sponsorship_record",
                            "label": "Sponsorship Record",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SponsorshipRecordColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 34
                        },
                        "staffer": {
                            "category": 5,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "staffer",
                            "label": "Staffers",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StafferColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 9
                        },
                        "staffer_field": {
                            "category": 5,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "staffer_field",
                            "label": "Staffer Field",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StafferFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 32
                        },
                        "staffer_works_for_committee": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 8,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "staffer_works_for_committee",
                            "label": "Works For (Committee)",
                            "master_column": false,
                            "miscellaneous": 8,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 41,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Which committee this staffer works for",
                            "value": 145
                        },
                        "stakeholder_alignment": {
                            "category": 9,
                            "coloring_enabled": false,
                            "column_data_type": 3,
                            "data_types": [1, 8, 12],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "stakeholder_alignment",
                            "label": "Stakeholder Alignment",
                            "master_column": false,
                            "miscellaneous": [1, 8, 12],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StakeholderAlignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 0,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The Stakeholder Alignment of this Person.",
                            "value": 421
                        },
                        "stance_modified_by": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2, 80, 83, 4],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "stance_modified_by",
                            "label": "Stance Modified (User)",
                            "master_column": false,
                            "miscellaneous": [2, 80, 83, 4],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StanceModifiedByColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Who last modified your Organization's stance",
                            "value": 146
                        },
                        "stance_modified_when": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": [2, 80, 83, 4],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "stance_modified_when",
                            "label": "Stance Modified (Date)",
                            "master_column": false,
                            "miscellaneous": [2, 80, 83, 4],
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StanceModifiedWhenColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "When your Organization's stance on this changed last",
                            "value": 147
                        },
                        "stance_record": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": true,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "stance_record",
                            "label": "Individual Votes (With/Against)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StanceRecordColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to show the stance of the row in your sheet relative to your organization's stance",
                            "value": 28
                        },
                        "start_of_session_text": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 7,
                            "data_types": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "start_of_session_text",
                            "label": "Start of Session",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StartOfSessionTextColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "sheets_subcategory": 10,
                            "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                            "tip": "",
                            "value": 317
                        },
                        "state_abbrev_bill_label_column": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [2],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_abbrev_bill_label_column",
                            "label": "State Abbreviation and Bill Label",
                            "master_column": false,
                            "miscellaneous": 2,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StateAbbrevBillLabelColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4.5,
                            "sheets_subcategory": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The State Abbreviation and Bill Label",
                            "value": 501
                        },
                        "state_legislature_house_controlling_party": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_house_controlling_party",
                            "label": "State House Controlling Party",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StateLegislatureHouseMajorityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 21,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 288
                        },
                        "state_legislature_house_dem_percentage": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_house_dem_percentage",
                            "label": "% of State House Controlled by Democrats",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StatePercentageOfDemocratsInHouseColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 24,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 291
                        },
                        "state_legislature_house_rep_percentage": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_house_rep_percentage",
                            "label": "% of State House Controlled by Republicans",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StatePercentageOfRepublicansInHouseColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 25,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 292
                        },
                        "state_legislature_senate_controlling_party": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_senate_controlling_party",
                            "label": "State Senate Controlling Party",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StateLegislatureSenateMajorityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 20,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 287
                        },
                        "state_legislature_senate_dem_percentage": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_senate_dem_percentage",
                            "label": "% of State Senate Controlled by Democrats",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StatePercentageOfDemocratsInSenateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 22,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 289
                        },
                        "state_legislature_senate_rep_percentage": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 5,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "state_legislature_senate_rep_percentage",
                            "label": "% of State Senate Controlled by Republicans",
                            "master_column": false,
                            "miscellaneous": 1,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "StatePercentageOfRepublicansInSenateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 23,
                            "sheets_subcategory": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 290
                        },
                        "sum_of_columns": {
                            "category": 6,
                            "coloring_enabled": true,
                            "column_data_type": 4,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": true,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "sum_of_columns",
                            "label": "Sum Of Columns",
                            "master_column": false,
                            "notify_on_remove": true,
                            "outbox_perform_tip": "",
                            "proxy": "SumColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Computes the sum of any set of numerical columns that are already in the sheet.",
                            "value": 5
                        },
                        "supporter_action_center_source": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_action_center_source",
                            "label": "Action Center Source",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ActionCenterSourceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 42,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The action center where this supporter originated from.",
                            "value": 301
                        },
                        "supporter_assignment": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 6,
                            "data_types": [2, 1, 42, 12, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_assignment",
                            "label": "Contact Assignment",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 15,
                            "source_saved_search": false,
                            "tip": "The contact assigned (no need to select notes for this column)",
                            "value": 127
                        },
                        "supporter_charity_additional_info": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flag_slug": "ff_pac_charitable_match_search",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_charity_additional_info",
                            "label": "Charity Additional Information",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCharityAdditionalInfoColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 639,
                            "sheets_subcategory": 25,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "PAC Charitable Match - Additional Information",
                            "value": 639
                        },
                        "supporter_charity_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac_charitable_match_search",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_charity_address",
                            "label": "Charity Address",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCharityAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 636,
                            "sheets_subcategory": 25,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "PAC Charitable Match - Charity Address",
                            "value": 636
                        },
                        "supporter_charity_anonymous": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 1,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": true,
                            "feature_flag_slug": "ff_pac_charitable_match_search",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_charity_anonymous",
                            "label": "Charity Remain Anonymous",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCharityAnonymousColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 640,
                            "sheets_subcategory": 25,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "PAC Charitable Match - Remain Anonymous",
                            "value": 640
                        },
                        "supporter_charity_ein": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac_charitable_match_search",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_charity_ein",
                            "label": "Charity EIN",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCharityEINColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 637,
                            "sheets_subcategory": 25,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "PAC Charitable Match - Charity EIN",
                            "value": 637
                        },
                        "supporter_charity_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac_charitable_match_search",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_charity_name",
                            "label": "Charity Name",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCharityNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 635,
                            "sheets_subcategory": 25,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "PAC Charitable Match - Charity Name",
                            "value": 635
                        },
                        "supporter_congressional_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_congressional_district",
                            "label": "Congressional State District",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCongressionalDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' congressional District",
                            "value": 307
                        },
                        "supporter_country": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_country",
                            "label": "Country",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCountryColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column showing your contacts' country",
                            "value": 310
                        },
                        "supporter_county": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_county",
                            "label": "County",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterCountyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' county",
                            "value": 309
                        },
                        "supporter_lower_state_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_lower_state_district",
                            "label": "Lower State District",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterLowerStateDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' Lower State District",
                            "value": 306
                        },
                        "supporter_municipality": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_municipality",
                            "label": "Municipality",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterMunicipalityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' municipality",
                            "value": 316
                        },
                        "supporter_pac_eligibility": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": ["ff_pac", "ff_restricted_gr_pages"],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_pac_eligibility",
                            "label": "PAC Eligibility",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterPACEligibilityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 99,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "\n            Yes if the supporter is PAC eligible, No if not eligible.\n            If you have more than 1 PAC, a comma separated list of the PAC's this supporter is PAC eligible for.\n        ",
                            "value": 410
                        },
                        "supporter_registered_with_keyword": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_registered_with_keyword",
                            "label": "Registered with SMS Keyword",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RegisteredWithKeywordColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 42,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The SMS keyword that this supporter registered with.",
                            "value": 303
                        },
                        "supporter_registration_form_source": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_registration_form_source",
                            "label": "Registration Form Source",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RegistrationFormSourceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 42,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The registration page where this supporter came from.",
                            "value": 302
                        },
                        "supporter_representation_master": {
                            "category": 18,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_representation_master",
                            "label": "Supporter Representation Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 114
                        },
                        "supporter_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_state",
                            "label": "State",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' state",
                            "value": 308
                        },
                        "supporter_transaction_available_amount_for_year": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_transaction_available_amount_for_year",
                            "label": "Total $ Amount Available in Year",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterTransactionAggregationAvailableAmountInYearColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 28,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the total amount of money available to each supporter to give in the year you have selected",
                            "value": 401
                        },
                        "supporter_transaction_limit_amount_for_year": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_transaction_limit_amount_for_year",
                            "label": "$ Limit in year",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterTransactionAggregationLimitInYearColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 28,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the FEC limit for each supporter in the year you have selected",
                            "value": 402
                        },
                        "supporter_transaction_sum_for_years": {
                            "category": 33,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_transaction_sum_for_years",
                            "label": "Total $ Amount of Transactions For Years",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterTransactionAggregationTotalAmountInYearsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 27,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column that computes the total amount of money received from each supporter in the years you have selected",
                            "value": 400
                        },
                        "supporter_upper_state_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [12],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "supporter_upper_state_district",
                            "label": "Upper State District",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "SupporterUpperStateDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 13,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Create a column showing your contacts' Upper State District",
                            "value": 305
                        },
                        "teams": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "teams",
                            "label": "Teams",
                            "master_column": false,
                            "miscellaneous": 49,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "This project's teams",
                            "value": 54
                        },
                        "texting": {
                            "category": 38,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "texting",
                            "label": "Texting Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 670
                        },
                        "texting_creator": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [113],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "texting_creator",
                            "label": "Creator",
                            "master_column": false,
                            "miscellaneous": 113,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TextingCreatorColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 674
                        },
                        "total_count_of_amendments_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_amendments_per_issue",
                            "label": "Total Count of Amendments",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfAmendmentsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of Amendments tagged with this Issue",
                            "value": 213
                        },
                        "total_count_of_articles_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_articles_per_issue",
                            "label": "Total Count of Articles",
                            "master_column": false,
                            "miscellaneous": 105,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [104],
                            "proxy": "CountOfArticlesTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of Articles tagged with this Issue",
                            "value": 326
                        },
                        "total_count_of_bills_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_bills_per_issue",
                            "label": "Total Count of Bills",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfBillsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of Bills tagged with this Issue",
                            "value": 207
                        },
                        "total_count_of_contacts_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_contacts_per_issue",
                            "label": "Total Count of Contacts",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [204],
                            "proxy": "CountOfContactsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of Contacts tagged with this Issue",
                            "value": 211
                        },
                        "total_count_of_documents_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_documents_per_issue",
                            "label": "Total Count of Documents",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [305, 207, 105],
                            "proxy": "CountOfDocumentsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of Documents tagged with this Issue",
                            "value": 208
                        },
                        "total_count_of_officials_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_officials_per_issue",
                            "label": "Total Count of Officials",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [300],
                            "proxy": "CountOfOfficialsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of Officials tagged with this Issue",
                            "value": 209
                        },
                        "total_count_of_press_contacts_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_press_contacts_per_issue",
                            "label": "Total Count of Press",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "CountOfPressContactsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Count of Press tagged with this Issue",
                            "value": 450
                        },
                        "total_count_of_regs_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_regs_per_issue",
                            "label": "Total Count of Regulations",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [310],
                            "proxy": "CountOfRegulationsTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of Regulations tagged with this Issue",
                            "value": 214
                        },
                        "total_count_of_staffers_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_staffers_per_issue",
                            "label": "Total Count of Staffers",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [302],
                            "proxy": "CountOfStaffersTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of Staffers tagged with this Issue",
                            "value": 210
                        },
                        "total_count_of_votes_per_issue": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_count_of_votes_per_issue",
                            "label": "Total Count of Votes",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [304],
                            "proxy": "CountOfVotesTaggedToIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "Count of Votes tagged with this Issue",
                            "value": 212
                        },
                        "total_interactions": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 42, 107, 109, 47, 49, 113, 114, 120, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_interactions",
                            "label": "Number of Notes & Interactions (Individual)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TotalInteractionsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "1": "involving_member", "12": "involving_supporter", "59": "involving_user", "83": "for_project_and_subprojects" },
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total number of notes & interactions that have been logged involving the data in each row.",
                            "value": 19
                        },
                        "total_interactions_issue": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_interactions_issue",
                            "label": "Number of Notes & Interactions",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TotalInteractionsIssuesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "in_issue_or" },
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total number of interactions that were logged involving a row in your sheet, in minutes.",
                            "value": 240
                        },
                        "total_interactions_office": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_interactions_office",
                            "label": "Number of Notes & Interactions (Office)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TotalInteractionsOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "involving_office" },
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The total number of interactions that were logged involving this official or their staff.",
                            "value": 90
                        },
                        "total_interactions_org": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_interactions_org",
                            "label": "Number of Notes & Interactions (Organization)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TotalInteractionsOrganization",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "involving_office" },
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The total number of interactions that were logged involving press contact's organization.",
                            "value": 444
                        },
                        "total_interactions_org_contacts": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [42],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_interactions_org_contacts",
                            "label": "Number of Notes & Interactions (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TotalInteractionsContactsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The total number of notes & interactions that have been logged involving the contacts for each organization",
                            "value": 228
                        },
                        "total_issue_counts_master": {
                            "category": 26,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_issue_counts_master",
                            "label": "Total Issue Counts Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 215
                        },
                        "total_page_visits": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "total_page_visits",
                            "label": "Total Page Visits",
                            "master_column": false,
                            "miscellaneous": 12,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "GrassrootsPageVisitsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_subcategory": 12,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "The number of times this supporter has visited your action center",
                            "value": 38
                        },
                        "transaction_address_city": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_address_city",
                            "label": "City",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAddressCityColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 484
                        },
                        "transaction_address_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_address_state",
                            "label": "State",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAddressStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 487
                        },
                        "transaction_address_street_1": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_address_street_1",
                            "label": "Address 1",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAddressStreet1Column",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 482
                        },
                        "transaction_address_street_2": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_address_street_2",
                            "label": "Address 2",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAddressStreet2Column",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 483
                        },
                        "transaction_address_zip": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_address_zip",
                            "label": "Zip Code",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAddressZipColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 488
                        },
                        "transaction_alternate_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_alternate_address",
                            "label": "Alternate Address",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAlternateAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "An alternate address entered for the Contact; note that this field is not Geocoded.",
                            "value": 624
                        },
                        "transaction_bank_account": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_bank_account",
                            "label": "Bank Account",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionBankAccountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 425
                        },
                        "transaction_batch": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_batch",
                            "label": "Batch Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 428
                        },
                        "transaction_city_state_zip": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_city_state_zip",
                            "label": "City, State Zip",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionCityStateZipColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 485
                        },
                        "transaction_credit_ledger_account_type": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_credit_ledger_account_type",
                            "label": "Credited Account Type",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 426
                        },
                        "transaction_debit_ledger_account_type": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_debit_ledger_account_type",
                            "label": "Debited Account Type",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 427
                        },
                        "transaction_election": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_election",
                            "label": "Election",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "RelatedModelMiscColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 429
                        },
                        "transaction_election_year_and_type": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": 2,
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_election_year_and_type",
                            "label": "Election Year and Type",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "ElectionYearAndTypeTransactioColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 99,
                            "sheets_subcategory": 26,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The Election Year and Election Type",
                            "value": 638
                        },
                        "transaction_entity_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_entity_name",
                            "label": "Entity Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionEntityNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 12,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 481
                        },
                        "transaction_formatted_amount": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 14,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_formatted_amount",
                            "label": "Amount",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionAmountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Amount of the transaction in US dollars.",
                            "value": 413
                        },
                        "transaction_full_address": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_full_address",
                            "label": "Full Address",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionFullAddressColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 20,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 486
                        },
                        "transaction_non_bank_account": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_non_bank_account",
                            "label": "Transaction Type",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionNonBankAccountColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 201,
                            "sheets_subcategory": 19,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "",
                            "value": 480
                        },
                        "transaction_political_committee_candidate_first_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_candidate_first_name",
                            "label": "Candidate First Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeCandidateFirstNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Candidate First Name",
                            "value": 628
                        },
                        "transaction_political_committee_candidate_last_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_candidate_last_name",
                            "label": "Candidate Last Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeCandidateLastNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Candidate Last Name",
                            "value": 629
                        },
                        "transaction_political_committee_candidate_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_candidate_name",
                            "label": "Candidate Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeCandidateNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The name of a candidate associated with a political committee associated with a transaction.",
                            "value": 489
                        },
                        "transaction_political_committee_committee_type": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_committee_type",
                            "label": "Committee Type",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeCommitteeTypeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The committee type of a political committee associated a transaction.",
                            "value": 492
                        },
                        "transaction_political_committee_district": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_district",
                            "label": "District",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeDistrictColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The district of a political committee associated with a transaction.",
                            "value": 493
                        },
                        "transaction_political_committee_fec_committee_id": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_fec_committee_id",
                            "label": "Committee ID",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeFecCommitteeIdColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The FEC committee ID of a political committee associated with a transaction.",
                            "value": 490
                        },
                        "transaction_political_committee_is_active": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_is_active",
                            "label": "Committee Status",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeIsActiveColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Whether the political committee associated with a transaction is active.",
                            "value": 491
                        },
                        "transaction_political_committee_office": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_office",
                            "label": "Office",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeOfficeColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The office of a political committee associated with a transaction.",
                            "value": 494
                        },
                        "transaction_political_committee_office_state": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_office_state",
                            "label": "Office State",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteeOfficeStateColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The office state of a political committee associated with a transaction.",
                            "value": 495
                        },
                        "transaction_political_committee_party": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_political_committee_party",
                            "label": "Party",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionPoliticalCommitteePartyColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "sheets_subcategory": 21,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The party of a political committee associated with a transaction.",
                            "value": 496
                        },
                        "transaction_supporter_employer": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_employer",
                            "label": "Employer",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterEmployerColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The employer of a supporter associated with a transaction.",
                            "value": 497
                        },
                        "transaction_supporter_first_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_first_name",
                            "label": "Contact First Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterFirstNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Contact First Name",
                            "value": 625
                        },
                        "transaction_supporter_is_pac_eligible": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_is_pac_eligible",
                            "label": "Is PAC Eligible",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterIsPacEligibleColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Whether the supporter associated with a transaction is a PAC eligible.",
                            "value": 498
                        },
                        "transaction_supporter_last_name": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_last_name",
                            "label": "Contact Last Name",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterLastNameColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Contact Last Name",
                            "value": 626
                        },
                        "transaction_supporter_occupation": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_occupation",
                            "label": "Occupation",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterOccupationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "Contact's Occupation",
                            "value": 627
                        },
                        "transaction_supporter_title": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_title",
                            "label": "Title",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterTitleColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The title of a supporter associated with a transaction.",
                            "value": 499
                        },
                        "transaction_supporter_unique_identifier": {
                            "category": 9,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [107],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flag_slug": "ff_pac",
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "transaction_supporter_unique_identifier",
                            "label": "Unique Identifier",
                            "master_column": false,
                            "miscellaneous": 107,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TransactionSupporterUniqueIdentifierColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "sheets_subcategory": 22,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The unique identifier of a supporter associated with a transaction.",
                            "value": 500
                        },
                        "twitter_handles_column": {
                            "category": 34,
                            "coloring_enabled": true,
                            "column_data_type": 11,
                            "data_types": [121, 120],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "twitter_handles_column",
                            "label": "Twitter",
                            "master_column": false,
                            "miscellaneous": 42,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [105],
                            "proxy": "TwitterHandlesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create a column that links to all associated Twitter handles",
                            "value": 461
                        },
                        "user_assignments_master": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_assignments_master",
                            "label": "Users Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 102
                        },
                        "user_bill_assignments": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_bill_assignments",
                            "label": "Assignments (Bills)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {
                                "belgium": { "label": "Assignments (Legislation)" },
                                "czechia": { "label": "Assignments (Legislation)" },
                                "denmark": { "label": "Assignments (Legislation)" },
                                "eu": { "label": "Assignments (Legislation)" },
                                "france": { "label": "Assignments (Legislation)" },
                                "germany": { "label": "Assignments (Legislation)" },
                                "ireland": { "label": "Assignments (Legislation)" },
                                "italy": { "label": "Assignments (Legislation)" },
                                "netherlands": { "label": "Assignments (Legislation)" },
                                "poland": { "label": "Assignments (Legislation)" },
                                "spain": { "label": "Assignments (Legislation)" },
                                "sweden": { "label": "Assignments (Legislation)" }
                            },
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "The Bills this user is assigned to",
                            "value": 107
                        },
                        "user_bill_assignments_count": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_bill_assignments_count",
                            "label": "Assignments Count (Bills)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {
                                "belgium": { "label": "Assignments Count (Legislation)" },
                                "czechia": { "label": "Assignments Count (Legislation)" },
                                "denmark": { "label": "Assignments Count (Legislation)" },
                                "eu": { "label": "Assignments Count (Legislation)" },
                                "france": { "label": "Assignments Count (Legislation)" },
                                "germany": { "label": "Assignments Count (Legislation)" },
                                "ireland": { "label": "Assignments Count (Legislation)" },
                                "italy": { "label": "Assignments Count (Legislation)" },
                                "netherlands": { "label": "Assignments Count (Legislation)" },
                                "poland": { "label": "Assignments Count (Legislation)" },
                                "spain": { "label": "Assignments Count (Legislation)" },
                                "sweden": { "label": "Assignments Count (Legislation)" }
                            },
                            "required_fields": [],
                            "sheets_column_order": 6,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 9999, 10000, 10001, 10002, 10003, 10004, 10005, 1000],
                            "tip": "The number of Bills this user is assigned to",
                            "value": 108
                        },
                        "user_member_assignments": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_member_assignments",
                            "label": "Assignments (Officials)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 1,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The Officials this user is assigned to",
                            "value": 103
                        },
                        "user_member_assignments_count": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_member_assignments_count",
                            "label": "Assignments Count (Officials)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 2,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of Officials this user is assigned to",
                            "value": 104
                        },
                        "user_organization_assignments": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_organization_assignments",
                            "label": "Assignments (Organizations)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 7,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The Organizations this user is assigned to",
                            "value": 109
                        },
                        "user_organization_assignments_count": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_organization_assignments_count",
                            "label": "Assignments Count (Organizations)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 8,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of Organizations this user is assigned to",
                            "value": 110
                        },
                        "user_staffer_assignments": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_staffer_assignments",
                            "label": "Assignments (Staffers)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 9,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The Staffers this user is assigned to",
                            "value": 298
                        },
                        "user_staffer_assignments_count": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_staffer_assignments_count",
                            "label": "Assignments Count (Staffers)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The number of Staffers this user is assigned to",
                            "value": 299
                        },
                        "user_supporter_assignments": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_supporter_assignments",
                            "label": "Assignments (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 3,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The Contacts this user is assigned to",
                            "value": 105
                        },
                        "user_supporter_assignments_count": {
                            "category": 17,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_supporter_assignments_count",
                            "label": "Assignments Count (Contacts)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserSheetAssignmentColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of Contacts this user is assigned to",
                            "value": 106
                        },
                        "user_teams": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "user_teams",
                            "label": "Teams",
                            "master_column": false,
                            "miscellaneous": 59,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "TeamsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The teams this user is on",
                            "value": 101
                        },
                        "username": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 2,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "username",
                            "label": "Username",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "UserFieldColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 4,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The username of the user",
                            "value": 96
                        },
                        "users_master": {
                            "category": 16,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "users_master",
                            "label": "Users Master Column",
                            "master_column": true,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "MasterColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 95
                        },
                        "value_of_donations": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [1, 2, 3, 4, 8, 12, 79, 80, 82, 20, 107, 109, 47, 49, 113, 114, 59],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "value_of_donations",
                            "label": "Value of Donations",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [6, 5, 7],
                            "proxy": "ValueOfDonationsColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 10,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                            "tip": "The total value of all donations involving the data in each row.",
                            "value": 20
                        },
                        "value_of_donations_issue": {
                            "category": 3,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [83],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "value_of_donations_issue",
                            "label": "Value of Donations per Issue",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "permission_enum": [6, 5, 7],
                            "proxy": "ValueOfDonationsIssueColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "sheets_column_order": 5,
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Total value of all donations associated with each issue",
                            "value": 244
                        },
                        "vote_direction": {
                            "category": 13,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "vote_direction",
                            "label": "Yea/Nay",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "VoteDirectionColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "How this member voted on a selection of votes",
                            "value": 56
                        },
                        "vote_stance": {
                            "category": 13,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": true,
                            "is_contact_info": false,
                            "key": "vote_stance",
                            "label": "With/Against",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "VoteStanceColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Whether or not this member's vote is in line with your organization's stance",
                            "value": 57
                        },
                        "votes_against_organization": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "votes_against_organization",
                            "label": "# of Votes Against",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "VotesAgainstOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 14
                        },
                        "votes_with_organization": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "votes_with_organization",
                            "label": "# of Votes With",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "VotesWithOrganizationColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "",
                            "value": 15
                        },
                        "voting_record": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 9,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": true,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "voting_record",
                            "label": "Individual Vote(s) (Yea/Nay)",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "VotingRecordColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "Create columns to show how the row of your sheet has voted",
                            "value": 35
                        },
                        "yea_votes": {
                            "category": 2,
                            "coloring_enabled": true,
                            "column_data_type": 3,
                            "data_types": [4, 2, 113, 47, 79, 109, 83, 20, 1, 114, 120, 49, 42, 80, 8, 82, 12, 107, 59, 3],
                            "deprecated": false,
                            "derived": false,
                            "editable": false,
                            "feature_flags": [],
                            "generates_non_scalar_values": false,
                            "generates_searchify_columns": false,
                            "invert_sorting": false,
                            "is_contact_info": false,
                            "key": "yea_votes",
                            "label": "# of Yea Votes",
                            "master_column": false,
                            "notify_on_remove": false,
                            "outbox_perform_tip": "",
                            "proxy": "NumberOfYeaVotesColumn",
                            "region_specific_dict": {},
                            "required_fields": [],
                            "search_filters": { "any": "yea_voters_or" },
                            "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "tip": "The number of yea votes this person has voted for",
                            "value": 79
                        }
                    },
                    "SheetDataType": {
                        "__is_enum": true,
                        "amendment": { "datum_key": "title", "datum_search_key": "title", "key": "amendment", "label": "4", "plural": "Amendments", "value": 4 },
                        "bill": { "datum_key": "title", "datum_search_key": "title", "key": "bill", "label": "2", "plural": "Bills", "value": 2 },
                        "campaign": { "datum_key": "name", "datum_search_key": "name", "key": "campaign", "label": "47", "plural": "Campaigns", "value": 47 },
                        "custom_data": { "datum_key": "name", "key": "custom_data", "label": "79", "plural": "Footprint Data", "value": 79 },
                        "district": { "datum_key": "name", "datum_search_key": "name", "key": "district", "label": "109", "plural": "Districts", "value": 109 },
                        "issue_management": { "datum_key": "name", "datum_search_key": "name", "key": "issue_management", "label": "83", "plural": "Issues", "value": 83 },
                        "note": { "datum_key": "raw_content", "datum_search_key": "raw_content", "key": "note", "label": "20", "plural": "Notes", "value": 20 },
                        "person": { "datum_key": "name", "datum_search_key": "name", "key": "person", "label": "1", "plural": "Officials", "value": 1 },
                        "political_committee": { "datum_key": "name", "datum_search_key": "name", "key": "political_committee", "label": "114", "plural": "Political Committees", "value": 114 },
                        "press_contact": { "datum_key": "name", "datum_search_key": "name", "key": "press_contact", "label": "120", "plural": "Press Contacts", "value": 120 },
                        "project": { "datum_key": "name", "datum_search_key": "name", "key": "project", "label": "49", "plural": "Issues", "value": 49 },
                        "public_organization": { "datum_key": "name", "datum_search_key": "title", "key": "public_organization", "label": "42", "plural": "Organizations", "value": 42 },
                        "regulation": { "datum_key": "title", "datum_search_key": "title", "key": "regulation", "label": "80", "plural": "Regulations", "value": 80 },
                        "staffer": { "datum_key": "name", "datum_search_key": "name", "key": "staffer", "label": "8", "plural": "Staffers", "value": 8 },
                        "state": { "datum_key": "name", "datum_search_key": "name", "key": "state", "label": "82", "plural": "States", "value": 82 },
                        "supporter": { "datum_key": "name", "datum_search_key": "name", "key": "supporter", "label": "12", "plural": "Contacts", "value": 12 },
                        "texting": { "datum_key": "description", "datum_search_key": "description", "key": "texting", "label": "113", "plural": "Texts", "value": 113 },
                        "transaction": { "datum_key": "description", "datum_search_key": "description", "key": "transaction", "label": "107", "plural": "PAC Transactions", "value": 107 },
                        "user": { "datum_key": "user_info__full_name", "key": "user", "label": "59", "plural": "Team Members", "value": 59 },
                        "vote": { "datum_key": "display_name", "datum_search_key": "question", "key": "vote", "label": "3", "plural": "Votes", "value": 3 }
                    },
                    "SheetNoteSelectionCriteria": {
                        "__is_enum": true,
                        "least_recent": { "key": "least_recent", "label": "Least Recent", "value": 2 },
                        "most_recent": { "key": "most_recent", "label": "Most Recent", "value": 1 }
                    },
                    "SheetSortType": {
                        "__is_enum": true,
                        "ascending": { "icon": "fa-sort-amount-asc", "key": "ascending", "label": "Ascending", "next_public_sort_type": 0, "next_sort_type": 2, "public_icon": "fa-sort-amount-asc", "public_tooltip": "The public version of this sheet is currently sorted by this column ascending. Click to clear the sorting of the public sheet, or click twice to switch to descending.", "tooltip": "Click to Reverse Sort", "value": 1 },
                        "descending": { "icon": "fa-sort-amount-desc", "key": "descending", "label": "Descending", "next_public_sort_type": 1, "next_sort_type": 1, "public_icon": "fa-sort-amount-desc", "public_tooltip": "The public version of this sheet is currently sorted by this column descending. Click to switch to ascending, or click twice to clear the default sorting.", "tooltip": "Click to Reverse Sort", "value": 2 },
                        "none": { "icon": "fa-sort", "key": "none", "label": "Not Sorted", "next_public_sort_type": 2, "next_sort_type": 2, "public_icon": "fa-globe", "public_tooltip": "Click to set a default sort for this sheet when it is viewed publicly.", "tooltip": "Sort", "value": 0 }
                    },
                    "StafferColumnType": {
                        "__is_enum": true,
                        "custom": { "key": "custom", "label": "Custom", "tip": "A blank column that allows you to choose the staffer you care about for each official.", "value": 4 },
                        "highest_ranking": { "key": "highest_ranking", "label": "Highest Rank", "tip": "Show the overall highest ranking staffer in the office.", "value": 3 },
                        "issue": { "key": "issue", "label": "Issue", "tip": "Show the highest ranking staffer in each office that works in a selected issue", "value": 2 },
                        "title": { "key": "title", "label": "Title", "tip": "Show the staffer in each office with a selected title.", "value": 1 }
                    },
                    "StatisticColumnCategory": {
                        "__is_enum": true,
                        "general": { "key": "general", "label": "General", "tip": "Select from Quorum's database of statistics.", "value": 1 },
                        "mentions": { "key": "mentions", "label": "Mentions", "tip": "Compute the number of times a search term was mentioned across a selection of documents.", "value": 3 },
                        "relationships": { "key": "relationships", "label": "Relationships", "tip": "Add the relationship scores between specific members", "value": 2 }
                    },
                    "ThumbType": {
                        "__is_enum": true,
                        "neutral": { "cell_tip": "Neutral", "icon": "fa-minus-circle", "key": "neutral", "label": "Neutral", "value": 0 },
                        "thumbs_down": { "cell_tip": "Thumbs Down", "icon": "fa-thumbs-down", "key": "thumbs_down", "label": "Thumbs Down", "value": 2 },
                        "thumbs_up": { "cell_tip": "Thumbs Up", "icon": "fa-thumbs-up", "key": "thumbs_up", "label": "Thumbs Up", "value": 1 }
                    },
                    "UserSheetColumnOptionType": {
                        "__is_enum": true,
                        "user_bill_assignments": { "key": "user_bill_assignments", "label": "107", "related_field": "title", "related_model": "bill", "related_model_value": 2, "value": 107 },
                        "user_bill_assignments_count": { "key": "user_bill_assignments_count", "label": "108", "related_field": "title", "related_model": "bill", "related_model_value": 2, "value": 108 },
                        "user_member_assignments": { "key": "user_member_assignments", "label": "103", "related_field": "name", "related_model": "member", "related_model_value": 1, "value": 103 },
                        "user_member_assignments_count": { "key": "user_member_assignments_count", "label": "104", "related_field": "name", "related_model": "member", "related_model_value": 1, "value": 104 },
                        "user_organization_assignments": { "key": "user_organization_assignments", "label": "109", "related_field": "name", "related_model": "public_organization", "related_model_value": 42, "value": 109 },
                        "user_organization_assignments_count": { "key": "user_organization_assignments_count", "label": "110", "related_field": "name", "related_model": "public_organization", "related_model_value": 42, "value": 110 },
                        "user_staffer_assignments": { "key": "user_staffer_assignments", "label": "298", "related_field": "name", "related_model": "member", "related_model_value": 8, "value": 298 },
                        "user_staffer_assignments_count": { "key": "user_staffer_assignments_count", "label": "299", "related_field": "name", "related_model": "member", "related_model_value": 8, "value": 299 },
                        "user_supporter_assignments": { "key": "user_supporter_assignments", "label": "105", "related_field": "name", "related_model": "supporter", "related_model_value": 12, "value": 105 },
                        "user_supporter_assignments_count": { "key": "user_supporter_assignments_count", "label": "106", "related_field": "name", "related_model": "supporter", "related_model_value": 12, "value": 106 }
                    }
                }
            },
            "stakeholder": {
                "models": {
                    "AlignmentAction": {
                        "__is_model": true,
                        "__name__": "AlignmentAction",
                        "data_model": "app.userdata.stakeholder.models.AlignmentAction",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/alignmentaction/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "person",
                                "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                                "verbose_name": "person"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "supporter",
                                "related_model": { "__module__": "app.grassroots.models", "__name__": "Supporter" },
                                "verbose_name": "supporter"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "issue",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                                "verbose_name": "issue"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "alignment_type",
                                "related_model": { "__module__": "app.userdata.stakeholder.models", "__name__": "AlignmentType" },
                                "verbose_name": "alignment type"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            },
                            { "field_type": 16, "help_text": "The time when this action became current", "name": "effective_start_date", "verbose_name": "effective start date" },
                            { "field_type": 16, "help_text": "The time when this action was superseded by another action", "name": "effective_end_date", "verbose_name": "effective end date" }
                        ]
                    },
                    "AlignmentType": {
                        "__is_model": true,
                        "__name__": "AlignmentType",
                        "data_model": "app.userdata.stakeholder.models.AlignmentType",
                        "default_exclude_filters": {},
                        "default_filters": {},
                        "endpoint": "/api/alignmenttype/",
                        "fields": [
                            { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                            { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                            { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                            { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                            { "field_type": 3, "help_text": "Label used to describe this alignment on the frontend", "name": "label", "verbose_name": "label" },
                            { "field_type": 4, "help_text": "Magnitude and direction of alignment. Negative values indicate net detractors - positive values indicate net supporters.             Distance from 0 represents relative magnitude of alignment.", "name": "value", "verbose_name": "value" },
                            { "field_type": 3, "help_text": "FontAwesome 5 icon representing this AlignmentType", "name": "icon", "verbose_name": "icon" },
                            { "field_type": 3, "help_text": "FontAwesome 5 icon family representing this AlignmentType", "name": "icon_family", "verbose_name": "icon family" },
                            {
                                "field_type": 7,
                                "help_text": "Denormalized copy of the Organization also available on user.user_info.organization",
                                "name": "organization",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                                "verbose_name": "organization"
                            },
                            {
                                "field_type": 7,
                                "help_text": "",
                                "name": "user",
                                "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                                "verbose_name": "user"
                            }
                        ]
                    }
                }
            },
            "types": {
                "AccountSettingsForOtherUserType": {
                    "__is_enum": true,
                    "my_information": {
                        "alt": "my_information_button_link",
                        "content": "Update the user's personal information.",
                        "dataCy": "informationLink",
                        "feature_flags": [],
                        "icon": "user-alt",
                        "key": "my_information",
                        "label": "Edit Information Settings",
                        "rel_url": "/settings/my_information/user/:targetUserId",
                        "value": 1
                    },
                    "search": {
                        "alt": "search_settings_button_link",
                        "content": "Fine tune how the user's search experience works here.",
                        "dataCy": "searchLink",
                        "feature_flags": [],
                        "icon": "search",
                        "key": "search",
                        "label": "Edit Search Settings",
                        "rel_url": "/settings/search/user/:targetUserId",
                        "value": 3
                    },
                    "sidebar": {
                        "alt": "my_sidebar_button_link",
                        "content": "Personalize what appears on the user's left hand sidebar.",
                        "dataCy": "sidebarLink",
                        "feature_flags": [],
                        "icon": "th-list",
                        "key": "sidebar",
                        "label": "Edit Sidebar Settings",
                        "rel_url": "/settings/sidebar/user/:targetUserId",
                        "value": 2
                    }
                },
                "AccountSettingsType": {
                    "__is_enum": true,
                    "my_information": {
                        "alt": "my_information_button_link",
                        "content": "Update your personal information.",
                        "dataCy": "informationLink",
                        "feature_flags": [],
                        "icon": "user-alt",
                        "key": "my_information",
                        "label": "My Information",
                        "rel_url": "/settings/my_information/",
                        "value": 2
                    },
                    "region": {
                        "alt": "region_settings_button_link",
                        "content": "Create custom grouping of regions that are important to you.",
                        "dataCy": "regionLink",
                        "feature_flags": [],
                        "icon": "map-marked-alt",
                        "key": "region",
                        "label": "Custom Regions",
                        "rel_url": "/custom_regions/",
                        "value": 5
                    },
                    "search": {
                        "alt": "search_settings_button_link",
                        "content": "Fine tune how your search experience works here.",
                        "dataCy": "searchLink",
                        "feature_flags": [],
                        "icon": "search",
                        "key": "search",
                        "label": "Search Settings",
                        "rel_url": "/settings/search/",
                        "value": 4
                    },
                    "security": {
                        "alt": "security_button_link",
                        "content": "Reset your password and manage two factor authentication.",
                        "dataCy": "securityLink",
                        "feature_flags": [],
                        "icon": "lock-alt",
                        "key": "security",
                        "label": "Security & Privacy",
                        "rel_url": "/settings/security/",
                        "value": 1
                    },
                    "sidebar": {
                        "alt": "my_sidebar_button_link",
                        "content": "Personalize what appears on your left hand sidebar.",
                        "dataCy": "sidebarLink",
                        "feature_flags": [],
                        "icon": "th-list",
                        "key": "sidebar",
                        "label": "My Sidebar",
                        "rel_url": "/settings/sidebar/",
                        "value": 3
                    }
                },
                "AccountType": {
                    "__is_enum": true,
                    "free_trial": { "key": "free_trial", "label": "Free Trial", "value": 2 },
                    "inactive": { "key": "inactive", "label": "Inactive", "value": 5 },
                    "ip_based": { "key": "ip_based", "label": "IP Based", "value": 6 },
                    "limited": { "key": "limited", "label": "Limited (Consultant)", "value": 3 },
                    "limited_trial": { "key": "limited_trial", "label": "Limited Trial", "value": 4 },
                    "normal": { "key": "normal", "label": "Normal", "value": 1 }
                },
                "AssignmentType": {
                    "__is_enum": true,
                    "amendment": { "key": "amendment", "label": "Amendment", "order": 9, "qdt_field": "amendment", "quorum_data_type": 4, "value": 7 },
                    "bill": { "key": "bill", "label": "Bill", "order": 2, "qdt_field": "bill", "quorum_data_type": 2, "value": 5 },
                    "committee": { "key": "committee", "label": "Committee", "order": 13, "qdt_field": "committee", "quorum_data_type": 15, "value": 16 },
                    "custom_event": { "key": "custom_event", "label": "Custom Event", "order": 11, "qdt_field": "custom_event", "quorum_data_type": 85, "value": 13 },
                    "docket": { "key": "docket", "label": "Docket", "order": 7, "qdt_field": "docket", "quorum_data_type": 88, "value": 14 },
                    "member": { "key": "member", "label": "Official", "order": 1, "qdt_field": "member", "quorum_data_type": 1, "value": 3 },
                    "press_contact": { "key": "press_contact", "label": "Press Contact", "order": 100, "qdt_field": "member", "quorum_data_type": 120, "value": 17 },
                    "project": { "key": "project", "label": "Project", "order": 10, "qdt_field": "project", "quorum_data_type": 49, "value": 12 },
                    "public_organization": { "key": "public_organization", "label": "Organization", "order": 4, "qdt_field": "public_organization", "quorum_data_type": 42, "value": 10 },
                    "regulation": { "key": "regulation", "label": "Regulation", "order": 6, "qdt_field": "regulation", "quorum_data_type": 80, "value": 11 },
                    "staffer": { "key": "staffer", "label": "Staffer", "order": 5, "qdt_field": "member", "quorum_data_type": 8, "value": 4 },
                    "supporter": { "key": "supporter", "label": "Contact", "order": 3, "qdt_field": "supporter", "quorum_data_type": 12, "value": 9 },
                    "vote": { "key": "vote", "label": "Vote", "order": 8, "qdt_field": "vote", "quorum_data_type": 3, "value": 6 }
                },
                "AttachmentType": {
                    "__is_enum": true,
                    "email": { "help_text": "", "key": "email", "label": "Email", "value": 1 },
                    "file_upload": { "help_text": "Files that are uploaded via Search using the Add File form. TODO use this enum value", "key": "file_upload", "label": "File", "value": 5 },
                    "note": { "help_text": "", "key": "note", "label": "Note", "value": 2 },
                    "project": { "help_text": "", "key": "project", "label": "Project", "value": 4 },
                    "test": { "help_text": "", "key": "test", "label": "Test Attachment", "value": 66 }
                },
                "CreditsAutoRenewType": {
                    "__is_enum": true,
                    "disabled": { "key": "disabled", "label": "Disabled", "value": 0 },
                    "reload": { "key": "reload", "label": "Enabled (no rollover)", "value": 1 },
                    "reload_rollover": { "key": "reload_rollover", "label": "Enabled (with rollover)", "value": 2 }
                },
                "CreditsRenewCycle": {
                    "__is_enum": true,
                    "month": { "key": "month", "label": "month", "value": 0 },
                    "year": { "key": "year", "label": "year", "value": 1 }
                },
                "CustomEventFieldType": {
                    "__is_enum": true,
                    "address": { "archived": false, "key": "address", "label": "Venue Location", "value": 4 },
                    "contact_participants": { "archived": false, "key": "contact_participants", "label": "Contact Participants", "qdt": 12, "value": 25 },
                    "custom_field": { "archived": false, "key": "custom_field", "label": "Custom Field", "value": 21 },
                    "end_date": { "archived": false, "key": "end_date", "label": "End Date", "value": 7 },
                    "end_time": { "archived": false, "key": "end_time", "label": "End Time", "value": 9 },
                    "name": { "archived": false, "key": "name", "label": "Name", "value": 1 },
                    "official_participants": { "archived": false, "key": "official_participants", "label": "Official Participants", "qdt": 1, "value": 24 },
                    "projects": { "archived": false, "key": "projects", "label": "Issues", "value": 11 },
                    "publically_accessible": { "archived": false, "key": "publically_accessible", "label": "Type", "value": 2 },
                    "publically_available_description": { "archived": false, "key": "publically_available_description", "label": "Note", "value": 28 },
                    "staffer_participants": { "archived": false, "key": "staffer_participants", "label": "Staffer Participants", "qdt": 8, "value": 27 },
                    "start_date": { "archived": false, "key": "start_date", "label": "Start Date", "value": 6 },
                    "start_time": { "archived": false, "key": "start_time", "label": "Start Time", "value": 8 },
                    "team_member_participants": { "archived": false, "key": "team_member_participants", "label": "Team Member Participants", "qdt": 59, "value": 26 },
                    "timezone": { "archived": false, "key": "timezone", "label": "Timezone", "value": 10 },
                    "venue_name": { "archived": false, "key": "venue_name", "label": "Venue Name", "value": 3 }
                },
                "EmptySettingsCardSingleton": {
                    "__is_enum": true,
                    "invisible": {
                        "alt": "",
                        "content": "",
                        "dataCy": "",
                        "feature_flags": [],
                        "icon": "",
                        "invisible": true,
                        "key": "invisible",
                        "label": "",
                        "rel_url": "/home/",
                        "value": 1
                    }
                },
                "FilesViewStatus": {
                    "__is_enum": true,
                    "downloads": { "key": "downloads", "label": "Downloads", "value": 0 },
                    "secure_uploads": { "key": "secure_uploads", "label": "Secure Uploads", "value": 2 },
                    "uploads": { "key": "uploads", "label": "Uploads", "value": 1 }
                },
                "GrassrootsInteractionType": {
                    "__is_enum": true,
                    "authorized_contribution": {
                        "description": "submitted an authorized contribution",
                        "editable": false,
                        "future_description": "will submit an authorized contribution",
                        "grassroots": true,
                        "grassroots_description": "submitted an authorized contribution",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-pencil-square-o",
                        "key": "authorized_contribution",
                        "label": "Authorized Contribution",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 11,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 108
                    },
                    "briefing": {
                        "description": "attended a briefing with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a briefing with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "briefing",
                        "label": "Briefing",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 19,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 36
                    },
                    "clicked_link": {
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "clicked your link",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-mouse-pointer",
                        "key": "clicked_link",
                        "label": "Clicked Link",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 10,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 34
                    },
                    "commented_on_regulation": {
                        "description": "commented on a regulation",
                        "editable": false,
                        "future_description": "will comment on a regulation",
                        "grassroots": false,
                        "grassroots_description": "commented on a regulation for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-envelope-o",
                        "key": "commented_on_regulation",
                        "label": "Commented on Regulation",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 11,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 44
                    },
                    "contact_us": {
                        "description": "contacted your organization",
                        "editable": false,
                        "future_description": "will contact your ogranization",
                        "grassroots": true,
                        "grassroots_description": "contacted your organization",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "contact_us",
                        "label": "Contact Us",
                        "loggable": false,
                        "magic_lists": false,
                        "mobile_order": 19,
                        "order": 27,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 109
                    },
                    "discussion": {
                        "description": "had an in-person discussion with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have an in-person discussion with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "discussion",
                        "label": "Discussion",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 9,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 21
                    },
                    "donation_given": {
                        "description": "gave a donation to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will give a donation to",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "donation_given",
                        "label": "Donation Given",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 3,
                        "order": 6,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 7
                    },
                    "email": {
                        "description": "emailed",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will email",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "email",
                        "label": "Email Sent",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 5,
                        "order": 3,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 11
                    },
                    "email_exchange": {
                        "description": "exchanged an email with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will exchange an email with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "email_exchange",
                        "label": "Email Exchange",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 5,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 35
                    },
                    "event_attended": {
                        "associated_QDT": 28,
                        "description": "attended an event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend an event with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-calendar",
                        "key": "event_attended",
                        "label": "Event Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 4,
                        "order": 4,
                        "qcal_class": "note-cal-events",
                        "replace_with_name": "an event",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 1
                    },
                    "facility_visit": {
                        "description": "visited a facility with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will visit a facility with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-industry",
                        "key": "facility_visit",
                        "label": "Facility Visit",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 20,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 37
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Grassroots",
                            "values": [25, 50, 26, 27, 28, 29, 30, 31, 45, 44, 46, 48, 85, 108, 104, 105, 106, 107, 109]
                        }
                    ],
                    "fundraiser_attended": {
                        "description": "attended a fundraiser with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a fundraiser with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-usd",
                        "key": "fundraiser_attended",
                        "label": "Fundraiser Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 10,
                        "order": 18,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 6
                    },
                    "grassroots_phone_call": {
                        "description": "spoke on the phone with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak on the phone with",
                        "grassroots": true,
                        "grassroots_description": "called for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-phone",
                        "key": "grassroots_phone_call",
                        "label": "Call a Number",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 3,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 50
                    },
                    "in_district_interaction": {
                        "description": "had an in-district interaction with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have an in-district interaction with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-map",
                        "key": "in_district_interaction",
                        "label": "In-District Interaction",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 23,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 43
                    },
                    "meeting": {
                        "description": "met with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will meet with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "meeting",
                        "label": "Meeting",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 1,
                        "order": 0,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 4
                    },
                    "multi_campaigned": {
                        "description": "participated in a combined campaign",
                        "editable": false,
                        "future_description": "intends to participate in a combined campaign",
                        "grassroots": true,
                        "grassroots_description": "participated in the combined campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-share-alt",
                        "key": "multi_campaigned",
                        "label": "Combined Campaign",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 24,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 48
                    },
                    "office_visit": {
                        "description": "visited the office of",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will visit the office of",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-bank",
                        "key": "office_visit",
                        "label": "Office Visit",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 15,
                        "order": 23,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 51
                    },
                    "outbox_email": {
                        "associated_QDT": 44,
                        "description": "sent an Outbox email to",
                        "divider": "with",
                        "editable": false,
                        "future_description": "will send an Outbox email to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "outbox_email",
                        "label": "Outbox Email",
                        "loggable": false,
                        "magic_lists": true,
                        "mobile_order": 6.5,
                        "order": 5.5,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 49
                    },
                    "personal_interaction": {
                        "description": "had a personal interaction with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a personal interaction with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-hand-paper-o",
                        "key": "personal_interaction",
                        "label": "Personal Interaction",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 16,
                        "order": 24,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 52
                    },
                    "personalized_message": {
                        "description": "wrote a personalized message",
                        "editable": false,
                        "future_description": "will write a personalized message",
                        "grassroots": false,
                        "grassroots_description": "wrote a personalized message for the campaign",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-magic",
                        "key": "personalized_message",
                        "label": "Personalized a message",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 1,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 53
                    },
                    "phone_call": {
                        "description": "spoke on the phone with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak on the phone with",
                        "grassroots": false,
                        "grassroots_description": "called for the campaign",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-phone",
                        "key": "phone_call",
                        "label": "Phone Call",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 2,
                        "order": 1,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 3
                    },
                    "received_points": {
                        "description": "received points on",
                        "divider": "on",
                        "editable": false,
                        "future_description": "will receive points on",
                        "grassroots": true,
                        "grassroots_description": "received custom points",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-star",
                        "key": "received_points",
                        "label": "Received points",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 11,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 104
                    },
                    "registered": {
                        "description": "registered for your fly in",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "registered for your fly in",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-plane",
                        "key": "registered",
                        "label": "Registered for Fly In",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 3,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 27
                    },
                    "registration_form_registered": {
                        "description": "registered on",
                        "divider": "on",
                        "editable": false,
                        "future_description": "will register on",
                        "grassroots": false,
                        "grassroots_description": "registered with your registration form",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-pencil-square-o",
                        "key": "registration_form_registered",
                        "label": "Registered on Registration Form",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 10,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 85
                    },
                    "scheduled": {
                        "description": "scheduled a meeting with",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-calendar",
                        "key": "scheduled",
                        "label": "Schedule",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 7,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 31
                    },
                    "share": {
                        "description": "shared the link in your campaign",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "shared the link in your campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-bullhorn",
                        "key": "share",
                        "label": "Shared a Link",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 6,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 30
                    },
                    "signature": {
                        "description": "participated",
                        "editable": false,
                        "future_description": "will participate",
                        "grassroots": false,
                        "grassroots_description": "participated in campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-pencil",
                        "key": "signature",
                        "label": "Custom Call to Action",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 4,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 28
                    },
                    "submit_election_info": {
                        "description": "submitted Election Info widget",
                        "editable": false,
                        "future_description": "will submit Election Info widget",
                        "grassroots": true,
                        "grassroots_description": "submitted Election Info widget",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-sticky-note-o",
                        "key": "submit_election_info",
                        "label": "Submit Election Info Widget",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 14,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 107
                    },
                    "submit_gotv": {
                        "description": "submitted GOTV widget",
                        "editable": false,
                        "future_description": "will submit GOTV widget",
                        "grassroots": true,
                        "grassroots_description": "submitted GOTV widget",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-sticky-note-o",
                        "key": "submit_gotv",
                        "label": "Submit GOTV Widget",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 12,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 105
                    },
                    "submit_voter_registration": {
                        "description": "submitted Voter Registration widget",
                        "editable": false,
                        "future_description": "will submit Voter Registration widget",
                        "grassroots": true,
                        "grassroots_description": "submitted Voter Registration widget",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-sticky-note-o",
                        "key": "submit_voter_registration",
                        "label": "Submit Voter Registration Widget",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 13,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 106
                    },
                    "told_grassroots_story": {
                        "description": "told a Grassroots story",
                        "editable": false,
                        "future_description": "will tell a grassroots story",
                        "grassroots": false,
                        "grassroots_description": "shared a story",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-user",
                        "key": "told_grassroots_story",
                        "label": "Tell Us Your Story",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 12,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 45
                    },
                    "tweet": {
                        "description": "tweeted at",
                        "editable": false,
                        "future_description": "will tweet at",
                        "grassroots": false,
                        "grassroots_description": "tweeted for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-twitter",
                        "key": "tweet",
                        "label": "Post at Someone",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 5,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 29
                    },
                    "visit": {
                        "description": "visited",
                        "editable": false,
                        "future_description": "will visit",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-suitcase",
                        "key": "visit",
                        "label": "Request a Visit",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 2,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 26
                    },
                    "wrote_letter": {
                        "description": "wrote a letter to",
                        "editable": false,
                        "future_description": "will write a letter to",
                        "grassroots": false,
                        "grassroots_description": "wrote a letter for the campaign",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "wrote_letter",
                        "label": "Write a Letter",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 1,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 25
                    },
                    "wrote_white_house": {
                        "description": "wrote to the White House",
                        "editable": false,
                        "future_description": "will write to the White House",
                        "grassroots": false,
                        "grassroots_description": "wrote the White House",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "wrote_white_house",
                        "label": "Write to the White House",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 13,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 46
                    }
                },
                "InteractionType": {
                    "__is_enum": true,
                    "article": {
                        "deprecated": true,
                        "description": "published an article with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will publish an article with",
                        "grassroots": false,
                        "icon": "fa-newspaper-o",
                        "key": "article",
                        "label": "Article",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 95
                    },
                    "assignment_created": {
                        "deprecated": false,
                        "description": "was assigned to",
                        "divider": "with",
                        "editable": false,
                        "future_description": "will be assigned to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-star",
                        "key": "assignment_created",
                        "label": "Assignment Created",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 12
                    },
                    "assignment_deleted": {
                        "deprecated": false,
                        "description": "was unassigned from",
                        "divider": "with",
                        "editable": false,
                        "future_description": "will be unassigned from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-star-o",
                        "key": "assignment_deleted",
                        "label": "Assignment Removed",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 13
                    },
                    "attend_formal_public_meeting": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "attended a formal public meeting with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a formal public meeting with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "attend_formal_public_meeting",
                        "label": "Attend Formal Public Meeting",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 103
                    },
                    "authorized_contribution": {
                        "deprecated": false,
                        "description": "submitted an authorized contribution",
                        "editable": false,
                        "feature_flags": ["ff_pac"],
                        "future_description": "will submit an authorized contribution",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-pencil-square-o",
                        "key": "authorized_contribution",
                        "label": "Authorized Contribution",
                        "loggable": true,
                        "magic_lists": false,
                        "order": 1,
                        "permission_enum": [8],
                        "qcal_class": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 108
                    },
                    "blog_post": {
                        "deprecated": true,
                        "description": "published a Blog Post with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will publish a Blog Post with",
                        "grassroots": false,
                        "icon": "fa-book",
                        "key": "blog_post",
                        "label": "Blog Post",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 94
                    },
                    "briefing": {
                        "deprecated": true,
                        "description": "attended a briefing with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a briefing with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "briefing",
                        "label": "Briefing",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 19,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 36
                    },
                    "casework": {
                        "deprecated": true,
                        "description": "did casework with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will do casework with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "casework",
                        "label": "Casework",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 71
                    },
                    "clicked_link": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "clicked your link",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-mouse-pointer",
                        "key": "clicked_link",
                        "label": "Clicked Link",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 10,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 34
                    },
                    "collateral": {
                        "deprecated": true,
                        "description": "released material with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will release material with",
                        "grassroots": false,
                        "icon": "fa-bar-chart",
                        "key": "collateral",
                        "label": "Collateral",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 98
                    },
                    "commented_on_regulation": {
                        "deprecated": false,
                        "description": "commented on a regulation",
                        "editable": false,
                        "future_description": "will comment on a regulation",
                        "grassroots": false,
                        "grassroots_description": "commented on a regulation for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-envelope-o",
                        "key": "commented_on_regulation",
                        "label": "Comment on Regulation",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 11,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 44
                    },
                    "committee_statement": {
                        "deprecated": true,
                        "description": "has a committee statement with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a committee statement with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-bullhorn",
                        "key": "committee_statement",
                        "label": "Committee Statement",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 79
                    },
                    "congress_delegation": {
                        "deprecated": true,
                        "description": "attended a congressional delegation",
                        "editable": true,
                        "future_description": "will attend a congressional delegation",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "congress_delegation",
                        "label": "Congressional Delegation",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 69
                    },
                    "contact_us": {
                        "deprecated": false,
                        "description": "contacted your organization",
                        "editable": false,
                        "future_description": "will contact your ogranization",
                        "grassroots": true,
                        "grassroots_description": "contacted your organization",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "contact_us",
                        "label": "Contact Us",
                        "loggable": false,
                        "magic_lists": false,
                        "mobile_order": 19,
                        "order": 27,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 109
                    },
                    "contacted_constituent": {
                        "deprecated": true,
                        "description": "contacted a constituent of",
                        "divider": "of",
                        "editable": true,
                        "future_description": "will contact a constituent of",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-street-view",
                        "key": "contacted_constituent",
                        "label": "Contacted Constituent",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 15,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 17
                    },
                    "dc_event": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "attended a DC event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a DC event with",
                        "icon": "fa-calendar",
                        "key": "dc_event",
                        "label": "DC Event",
                        "loggable": true,
                        "magic_lists": false,
                        "qcal_class": "note-cal-events",
                        "replace_with_name": "an event",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 91
                    },
                    "dc_meeting": {
                        "deprecated": true,
                        "description": "attended a DC meeting with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a DC meeting with",
                        "icon": "fa-check",
                        "key": "dc_meeting",
                        "label": "DC Meeting",
                        "loggable": true,
                        "magic_lists": false,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 90
                    },
                    "default": {
                        "deprecated": false,
                        "description": "interacted with",
                        "editable": true,
                        "future_description": "will interact with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-handshake-o",
                        "key": "default",
                        "label": "Default",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 110
                    },
                    "discussion": {
                        "deprecated": true,
                        "description": "had an in-person discussion with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have an in-person discussion with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "discussion",
                        "label": "Discussion",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 9,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 21
                    },
                    "donation_given": {
                        "deprecated": false,
                        "description": "gave a donation to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will give a donation to",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "donation_given",
                        "label": "Donation Given",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 3,
                        "order": 6,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 7
                    },
                    "donation_received": {
                        "deprecated": false,
                        "description": "received a donation from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will receive a donation from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "donation_received",
                        "label": "Donation Received",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 7,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 8
                    },
                    "donation_rejected": {
                        "deprecated": false,
                        "description": "rejected a donation from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will reject a letter from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "donation_rejected",
                        "label": "Donation Rejected",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 60
                    },
                    "drop_off_materials": {
                        "deprecated": true,
                        "description": "dropped materials off with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will drop off materials with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "drop_off_materials",
                        "label": "Drop Off Materials",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 82
                    },
                    "email": {
                        "deprecated": true,
                        "description": "emailed",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will email",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "email",
                        "label": "Email Sent",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 5,
                        "order": 3,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 11
                    },
                    "email_exchange": {
                        "deprecated": false,
                        "description": "exchanged an email with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will exchange an email with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "email_exchange",
                        "label": "Email Exchange",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 5,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 35
                    },
                    "email_received": {
                        "deprecated": true,
                        "description": "received an email from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will receive an email from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "email_received",
                        "label": "Email Received",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 6,
                        "order": 4,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 16
                    },
                    "endorsement_given": {
                        "deprecated": true,
                        "description": "endorsed",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will endorse",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-heart",
                        "key": "endorsement_given",
                        "label": "Endorsement Given",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 9,
                        "order": 10,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 18
                    },
                    "endorsement_received": {
                        "deprecated": true,
                        "description": "received an endorsement from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will receive an endorsement from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-heart-o",
                        "key": "endorsement_received",
                        "label": "Endorsement Received",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 11,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 19
                    },
                    "event_attended": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "attended an event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend an event with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-calendar",
                        "key": "event_attended",
                        "label": "Event Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 4,
                        "order": 4,
                        "qcal_class": "note-cal-events",
                        "replace_with_name": "an event",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 1
                    },
                    "event_hosted": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "hosted an event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will host an event with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-calendar",
                        "key": "event_hosted",
                        "label": "Event Hosted",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 11,
                        "order": 5,
                        "qcal_class": "note-cal-events",
                        "replace_with_name": "an event",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 2
                    },
                    "event_registered": {
                        "deprecated": true,
                        "description": "registered for an event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will register for an event with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-square",
                        "key": "event_registered",
                        "label": "Registered for an Event",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 17,
                        "order": 25,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 53
                    },
                    "exchanged_letter": {
                        "deprecated": true,
                        "description": "exchanged a letter with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will exchange a letter with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "exchanged_letter",
                        "label": "Letter Exchanged",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 57
                    },
                    "facility_visit": {
                        "deprecated": true,
                        "description": "visited a facility with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will visit a facility with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-industry",
                        "key": "facility_visit",
                        "label": "Facility Visit",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 20,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 37
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Correspondence",
                            "values": [95, 94, 36, 71, 98, 17, 90, 21, 82, 35, 16, 11, 57, 88, 89, 58, 67, 4, 61, 51, 33, 64, 49, 52, 3, 93, 92, 39, 86, 59, 9, 63, 73, 62, 54, 84, 72, 74, 66, 100, 101, 10, 65, 97, 38]
                        },
                        {
                            "display": "list",
                            "title": "Events",
                            "values": [69, 91, 7, 8, 60, 18, 19, 1, 2, 53, 37, 6, 5, 56, 80, 20, 87, 43, 47, 15, 14, 75, 55, 68, 99, 96, 83, 70, 102, 103]
                        },
                        {
                            "display": "list",
                            "title": "Grassroots",
                            "values": [25, 50, 26, 27, 28, 29, 30, 31, 34, 45, 44, 46, 48, 85, 109]
                        }
                    ],
                    "fundraiser_attended": {
                        "deprecated": true,
                        "description": "attended a fundraiser with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a fundraiser with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-usd",
                        "key": "fundraiser_attended",
                        "label": "Fundraiser Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 10,
                        "order": 18,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 6
                    },
                    "fundraiser_thrown": {
                        "deprecated": true,
                        "description": "threw a fundraiser with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will throw a fundraiser with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-usd",
                        "key": "fundraiser_thrown",
                        "label": "Fundraiser Thrown",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 17,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 5
                    },
                    "grant": {
                        "deprecated": false,
                        "description": "gave a grant to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will give a grant to",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "grant",
                        "label": "Grant",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 4,
                        "order": 8,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 56
                    },
                    "grassroots_phone_call": {
                        "deprecated": false,
                        "description": "spoke on the phone with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak on the phone with",
                        "grassroots": true,
                        "grassroots_description": "called for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-phone",
                        "key": "grassroots_phone_call",
                        "label": "Called By Phone",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 3,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 50
                    },
                    "health_center_visit": {
                        "deprecated": true,
                        "description": "visited a health center with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will visit a health center with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-hospital-o",
                        "key": "health_center_visit",
                        "label": "Health Center Visit",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 80
                    },
                    "hearing_attended": {
                        "deprecated": true,
                        "description": "attended a hearing with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a hearing with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "hearing_attended",
                        "label": "Hearing Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 12,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 20
                    },
                    "high_priority": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-arrow-cirle-up",
                        "key": "high_priority",
                        "label": "High priority",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 40
                    },
                    "host_formal_public_meeting": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "hosted a formal public meeting with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will host a formal public meeting with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "host_formal_public_meeting",
                        "label": "Host Formal Public Meeting",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 102
                    },
                    "in_district_event": {
                        "associated_QDT": 28,
                        "deprecated": true,
                        "description": "attended an in-district event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend an in-district event with",
                        "icon": "fa-calendar",
                        "key": "in_district_event",
                        "label": "In-District Event",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 87
                    },
                    "in_district_interaction": {
                        "deprecated": true,
                        "description": "had an in-district interaction with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have an in-district interaction with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-map",
                        "key": "in_district_interaction",
                        "label": "In-District Interaction",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 14,
                        "order": 23,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 43
                    },
                    "in_district_meeting": {
                        "deprecated": true,
                        "description": "attended an in-district meeting with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend an in-district meeting with",
                        "icon": "fa-check",
                        "key": "in_district_meeting",
                        "label": "In-District Meeting",
                        "loggable": true,
                        "magic_lists": false,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 88
                    },
                    "intended_donation": {
                        "deprecated": false,
                        "description": "pledged to donate to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will pledge to donate to",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-credit-card",
                        "key": "intended_donation",
                        "label": "Pledged Donation",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 3,
                        "order": 6,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 47
                    },
                    "intercept": {
                        "deprecated": true,
                        "description": "intercepted",
                        "divider": "intercepted",
                        "editable": true,
                        "future_description": "will intercept",
                        "icon": "fa-flag-o",
                        "key": "intercept",
                        "label": "Intercepted",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 89
                    },
                    "invitation_sent": {
                        "deprecated": true,
                        "description": "sent an invitation to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will send an invitation to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "invitation_sent",
                        "label": "Invitation Sent",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 58
                    },
                    "legislative_ask": {
                        "deprecated": true,
                        "description": "made a legislative ask from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will make a legislative ask from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "legislative_ask",
                        "label": "Legislative Ask",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 67
                    },
                    "low_priority": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-arrow-cirle-down",
                        "key": "low_priority",
                        "label": "Low priority",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 42
                    },
                    "medium_priority": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-minus-square",
                        "key": "medium_priority",
                        "label": "Medium priority",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 41
                    },
                    "meeting": {
                        "deprecated": true,
                        "description": "met with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will meet with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "meeting",
                        "label": "Meeting",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 1,
                        "order": 0,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 4
                    },
                    "multi_campaigned": {
                        "deprecated": false,
                        "description": "participated in a combined campaign",
                        "editable": false,
                        "future_description": "intends to participate in a combined campaign",
                        "grassroots": true,
                        "grassroots_description": "participated in the combined campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-share-alt",
                        "key": "multi_campaigned",
                        "label": "Participated in Combined Campaign",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 24,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 48
                    },
                    "news_received": {
                        "deprecated": true,
                        "description": "received news clips concerning",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will receive news clips concerning",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "news_received",
                        "label": "Critical Clips",
                        "loggable": true,
                        "magic_lists": true,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 61
                    },
                    "offered_amendment": {
                        "deprecated": true,
                        "description": "offered an amendment with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will offer an amendment with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "offered_amendment",
                        "label": "Offered Amendment",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 81
                    },
                    "office_visit": {
                        "deprecated": true,
                        "description": "visited the office of",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will visit the office of",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-bank",
                        "key": "office_visit",
                        "label": "Office Visit",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 15,
                        "order": 23,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 51
                    },
                    "op_ed_published": {
                        "deprecated": true,
                        "description": "published an op-ed with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will publish an op-ed with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-newspaper-o",
                        "key": "op_ed_published",
                        "label": "Op-Ed Published",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 78
                    },
                    "opened_email": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-folder-open",
                        "key": "opened_email",
                        "label": "Opened Email",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 9,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 33
                    },
                    "oppose": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-thumbs-down",
                        "key": "oppose",
                        "label": "Oppose",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 23
                    },
                    "other": {
                        "deprecated": true,
                        "description": "interacted with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will interact with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-handshake-o",
                        "key": "other",
                        "label": "Other",
                        "loggable": true,
                        "magic_lists": true,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 64
                    },
                    "outbox_email": {
                        "associated_QDT": 44,
                        "deprecated": false,
                        "description": "sent an Outbox email to",
                        "divider": "with",
                        "editable": false,
                        "future_description": "will send an Outbox email to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "outbox_email",
                        "label": "Outbox Email",
                        "loggable": false,
                        "magic_lists": true,
                        "mobile_order": 6.5,
                        "order": 5.5,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 49
                    },
                    "personal_interaction": {
                        "deprecated": true,
                        "description": "had a personal interaction with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a personal interaction with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-hand-paper-o",
                        "key": "personal_interaction",
                        "label": "Personal Interaction",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 16,
                        "order": 24,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 52
                    },
                    "phone_call": {
                        "deprecated": true,
                        "description": "spoke on the phone with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak on the phone with",
                        "grassroots": false,
                        "grassroots_description": "called for the campaign",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-phone",
                        "key": "phone_call",
                        "label": "Phone Call",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 2,
                        "order": 1,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 3
                    },
                    "placed_ad": {
                        "deprecated": true,
                        "description": "placed an Ad with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will place an Ad with",
                        "grassroots": false,
                        "icon": "fa-address-card-o",
                        "key": "placed_ad",
                        "label": "Placed an Ad",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 93
                    },
                    "press_conference_attended": {
                        "deprecated": true,
                        "description": "attended a press conference with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a press conference with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-microphone",
                        "key": "press_conference_attended",
                        "label": "Press Conference Attended",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 12,
                        "order": 14,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 15
                    },
                    "press_conference_held": {
                        "deprecated": true,
                        "description": "held a press conference with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will hold a press conference with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-microphone",
                        "key": "press_conference_held",
                        "label": "Press Conference Held",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 13,
                        "order": 13,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 14
                    },
                    "press_conference_speaking_role": {
                        "deprecated": true,
                        "description": "has a press conference speaking role with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a press conference speaking role with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-bullhorn",
                        "key": "press_conference_speaking_role",
                        "label": "Press Conference Speaking Role",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 75
                    },
                    "press_quote": {
                        "deprecated": true,
                        "description": "has a press quote with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a press quote with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-newspaper-o",
                        "key": "press_quote",
                        "label": "Press Quote",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 77
                    },
                    "press_release_issued": {
                        "deprecated": true,
                        "description": "issued a press release with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will issue a press release with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-newspaper-o",
                        "key": "press_release_issued",
                        "label": "Press Release Issued",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 76
                    },
                    "public_consultation": {
                        "deprecated": true,
                        "description": "consulted with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will consult with",
                        "grassroots": false,
                        "icon": "fa-comments-o",
                        "key": "public_consultation",
                        "label": "Public Consultation",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [106],
                        "value": 92
                    },
                    "received_letter": {
                        "deprecated": true,
                        "description": "received a letter from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will receive a letter from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "received_letter",
                        "label": "Received Letter",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 22,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 39
                    },
                    "registered": {
                        "deprecated": false,
                        "description": "registered for your fly in",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "registered for your fly in",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-plane",
                        "key": "registered",
                        "label": "Registered for Fly In",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 3,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 27
                    },
                    "registration_form_registered": {
                        "deprecated": false,
                        "description": "registered on",
                        "divider": "on",
                        "editable": false,
                        "future_description": "will register on",
                        "grassroots": false,
                        "grassroots_description": "registered with your registration form",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-pencil-square-o",
                        "key": "registration_form_registered",
                        "label": "Registered on Registration Form",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 10,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 85
                    },
                    "requested_in_district_meeting": {
                        "deprecated": true,
                        "description": "requested an in-district meeting with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will request an in-district meeting with",
                        "icon": "fa-check",
                        "key": "requested_in_district_meeting",
                        "label": "Requested In-District Meeting",
                        "loggable": true,
                        "magic_lists": false,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 86
                    },
                    "scheduled": {
                        "deprecated": false,
                        "description": "scheduled a meeting with",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-calendar",
                        "key": "scheduled",
                        "label": "Schedule",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 7,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 31
                    },
                    "sent_letter": {
                        "deprecated": true,
                        "description": "sent a letter to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will send a letter to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "sent_letter",
                        "label": "Sent Letter",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 59
                    },
                    "share": {
                        "deprecated": false,
                        "description": "shared on social media",
                        "editable": false,
                        "grassroots": false,
                        "grassroots_description": "shared the link in your campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-bullhorn",
                        "key": "share",
                        "label": "Shared on Social Media",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 6,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 30
                    },
                    "sighting": {
                        "deprecated": true,
                        "description": "saw",
                        "divider": "of",
                        "editable": true,
                        "future_description": "will see",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-eye",
                        "key": "sighting",
                        "label": "Sighting",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 7,
                        "order": 16,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 9
                    },
                    "signature": {
                        "deprecated": false,
                        "description": "participated",
                        "editable": false,
                        "future_description": "will participate",
                        "grassroots": false,
                        "grassroots_description": "participated in campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-pencil",
                        "key": "signature",
                        "label": "Custom Call to Action",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 4,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 28
                    },
                    "signed_amicus_brief": {
                        "deprecated": true,
                        "description": "signed an amicus brief with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will sign an amicus brief with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "signed_amicus_brief",
                        "label": "Signed Amicus Brief",
                        "loggable": true,
                        "magic_lists": true,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 63
                    },
                    "signed_coalition_letter": {
                        "deprecated": true,
                        "description": "signed a coalition letter with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will sign a coalition letter with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "signed_coalition_letter",
                        "label": "Signed Coalition Letter",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 73
                    },
                    "signed_group_letter": {
                        "deprecated": true,
                        "description": "signed a group letter with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will sign a group letter with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "signed_group_letter",
                        "label": "Signed Group Letter",
                        "loggable": true,
                        "magic_lists": true,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 62
                    },
                    "signed_letter": {
                        "deprecated": true,
                        "description": "recorded that a Letter was signed by",
                        "divider": "by",
                        "editable": true,
                        "future_description": "recorded that a Letter will be signed by",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-pencil-square-o",
                        "key": "signed_letter",
                        "label": "Signed a Letter",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 18,
                        "order": 26,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 54
                    },
                    "social_media_post": {
                        "deprecated": true,
                        "description": "interacted on social media with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will interact on social media with",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-share-square-o",
                        "key": "social_media_post",
                        "label": "Social Media",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 84
                    },
                    "spoke_at_briefing": {
                        "deprecated": true,
                        "description": "spoke at a briefing with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak at a briefing with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "spoke_at_briefing",
                        "label": "Spoke at Briefing",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 72
                    },
                    "spoke_at_event": {
                        "deprecated": true,
                        "description": "spoke at an event with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak at an event with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-bullhorn",
                        "key": "spoke_at_event",
                        "label": "Spoke at Event",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 74
                    },
                    "sponsorship": {
                        "deprecated": false,
                        "description": "sponsored",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will sponsor",
                        "grassroots": true,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gift",
                        "key": "sponsorship",
                        "label": "Sponsorship",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 4,
                        "order": 8,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": true,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "supporter": false,
                        "value": 55
                    },
                    "staff_delegation": {
                        "deprecated": true,
                        "description": "attended a staff delegation",
                        "editable": true,
                        "future_description": "will attend a staff delegation",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "staff_delegation",
                        "label": "Staff Delegation",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 68
                    },
                    "support": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-thumbs-up",
                        "key": "support",
                        "label": "Support",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 22
                    },
                    "tele_town_hall": {
                        "deprecated": true,
                        "description": "hosted a tele-town hall with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will host a tele-town hall with",
                        "grassroots": false,
                        "icon": "fa-comments-o",
                        "key": "tele_town_hall",
                        "label": "Tele-Town Hall",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 99
                    },
                    "teleconference": {
                        "deprecated": true,
                        "description": "had a teleconference with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will have a teleconference with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "teleconference",
                        "label": "Teleconference",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 66
                    },
                    "testified": {
                        "deprecated": true,
                        "description": "testified at",
                        "divider": "at",
                        "editable": true,
                        "future_description": "will testify at",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-gavel",
                        "key": "testified",
                        "label": "Testified",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 83
                    },
                    "text_received": {
                        "deprecated": true,
                        "description": "received a text from",
                        "divider": "from",
                        "editable": true,
                        "future_description": "will receive a text from",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "text_received",
                        "label": "Text Received",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 100
                    },
                    "text_sent": {
                        "deprecated": true,
                        "description": "sent a text to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will send a text to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "text_sent",
                        "label": "Text Sent",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 101
                    },
                    "told_grassroots_story": {
                        "deprecated": false,
                        "description": "told a Grassroots story",
                        "editable": false,
                        "future_description": "will tell a grassroots story",
                        "grassroots": false,
                        "grassroots_description": "shared a story",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-user",
                        "key": "told_grassroots_story",
                        "label": "Submitted Grassroots Story",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 12,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 45
                    },
                    "training": {
                        "deprecated": true,
                        "description": "attended a training with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will attend a training with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-briefcase",
                        "key": "training",
                        "label": "Training",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 70
                    },
                    "tv_radio": {
                        "deprecated": true,
                        "description": "spoke on the TV/Radio with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will speak on the TV/Radio with",
                        "grassroots": false,
                        "icon": "fa-television",
                        "key": "tv_radio",
                        "label": "TV/Radio",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 96
                    },
                    "tweet": {
                        "deprecated": false,
                        "description": "tweeted at",
                        "editable": false,
                        "future_description": "will tweet at",
                        "grassroots": false,
                        "grassroots_description": "tweeted for the campaign",
                        "grassroots_note_takes_campaign": true,
                        "icon": "fa-twitter",
                        "key": "tweet",
                        "label": "Sent a Tweet",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 5,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 29
                    },
                    "unexpected_interaction": {
                        "deprecated": true,
                        "description": "unexpectedly saw",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will unexpectedly see",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-flag-o",
                        "key": "unexpected_interaction",
                        "label": "Unexpected Interaction",
                        "loggable": true,
                        "magic_lists": true,
                        "mobile_order": 8,
                        "order": 8,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 10
                    },
                    "unimportant": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-circle-thin",
                        "key": "unimportant",
                        "label": "Irrelevant",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 0,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 24
                    },
                    "virtual_meeting": {
                        "deprecated": true,
                        "description": "virtually met with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will virtually meet with",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-check",
                        "key": "virtual_meeting",
                        "label": "Virtual Meeting",
                        "loggable": true,
                        "magic_lists": true,
                        "qcal_class": "note-cal-correspondence",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": false,
                        "value": 65
                    },
                    "visit": {
                        "deprecated": false,
                        "description": "visited",
                        "editable": false,
                        "future_description": "will visit",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-suitcase",
                        "key": "visit",
                        "label": "Visited Office",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 2,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 26
                    },
                    "watching": {
                        "deprecated": false,
                        "editable": false,
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-eye",
                        "key": "watching",
                        "label": "Watching",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 8,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 32
                    },
                    "white_paper_research": {
                        "deprecated": true,
                        "description": "released research with",
                        "divider": "with",
                        "editable": true,
                        "future_description": "will release research with",
                        "grassroots": false,
                        "icon": "fa-flask",
                        "key": "white_paper_research",
                        "label": "White Paper/Research",
                        "loggable": true,
                        "magic_lists": false,
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 97
                    },
                    "wrote_letter": {
                        "deprecated": false,
                        "description": "wrote a letter to",
                        "editable": false,
                        "future_description": "will write a letter to",
                        "grassroots": false,
                        "grassroots_description": "wrote a letter for the campaign",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "wrote_letter",
                        "label": "Wrote Letter",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 13,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 25
                    },
                    "wrote_site_letter": {
                        "deprecated": true,
                        "description": "wrote a site letter to",
                        "divider": "to",
                        "editable": true,
                        "future_description": "will write a site letter to",
                        "grassroots": false,
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope",
                        "key": "wrote_site_letter",
                        "label": "Wrote a Site Letter",
                        "loggable": true,
                        "magic_lists": true,
                        "order": 21,
                        "qcal_class": "note-cal-events",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 38
                    },
                    "wrote_white_house": {
                        "deprecated": false,
                        "description": "wrote to the White House",
                        "editable": false,
                        "future_description": "will write to the White House",
                        "grassroots": false,
                        "grassroots_description": "wrote the White House",
                        "grassroots_note_takes_campaign": false,
                        "icon": "fa-envelope-o",
                        "key": "wrote_white_house",
                        "label": "Wrote to the White House",
                        "loggable": false,
                        "magic_lists": false,
                        "order": 13,
                        "qcal_class": "note-cal-grassroots",
                        "should_display_amount": false,
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "supporter": true,
                        "value": 46
                    }
                },
                "LegislativePriorityType": {
                    "__is_enum": true,
                    "high_priority": { "fa5_icon": "arrow-circle-up", "icon": "fa-arrow-circle-up", "key": "high_priority", "label": "High Priority", "show_list": true, "value": 1 },
                    "low_priority": { "fa5_icon": "arrow-circle-down", "icon": "fa-arrow-circle-down", "key": "low_priority", "label": "Low Priority", "show_list": true, "value": 3 },
                    "medium_priority": { "fa5_icon": "arrow-circle-right", "icon": "fa-minus-square", "key": "medium_priority", "label": "Medium Priority", "show_list": true, "value": 2 },
                    "no_priority": { "fa5_icon": "circle", "key": "no_priority", "label": "No Priority", "show_list": true, "value": 0 }
                },
                "LegislativeStanceType": {
                    "__is_enum": true,
                    "no_stance": { "bill_sheet_tip": "We do not have a stance on this bill.", "fa5_icon": "circle", "key": "no_stance", "label": "No Stance", "list_name": "No Stance", "order": 0, "show_list": false, "value": 0, "verb": "" },
                    "oppose": { "bill_sheet_tip": "We oppose this bill", "cell_tip": "This person voted in opposition of our stance.", "fa5_icon": "thumbs-down", "icon": "fa-thumbs-down", "key": "oppose", "label": "Oppose", "list_name": "Opposed", "order": 2, "show_list": true, "value": 2, "verb": "opposes" },
                    "support": { "bill_sheet_tip": "We support this bill", "cell_tip": "This person voted in support of our stance.", "fa5_icon": "thumbs-up", "icon": "fa-thumbs-up", "key": "support", "label": "Support", "list_name": "Supported", "order": 1, "show_list": true, "value": 1, "verb": "supports" },
                    "unimportant": { "bill_sheet_tip": "We don't find this bill important", "fa5_icon": "minus-circle", "icon": "fa-circle-thin", "key": "unimportant", "label": "Unimportant", "list_name": "Unimportant", "order": 4, "show_list": false, "value": 3, "verb": "is not concerned with" },
                    "watching": { "bill_sheet_tip": "We are watching this bill", "fa5_icon": "eye", "icon": "fa-eye", "key": "watching", "label": "Watching", "list_name": "Watching", "order": 3, "show_list": true, "value": 4, "verb": "is watching" }
                },
                "ManuallyChangedListIds": {
                    "__is_enum": true,
                    "added": { "desc": "Items manually added to this List", "key": "added", "label": "Manually Added to List", "value": 1 },
                    "deleted": { "desc": "Items manually deleted from this List", "key": "deleted", "label": "Manually Deleted from List", "value": 2 }
                },
                "NoteFieldDefaultProp": {
                    "__is_enum": true,
                    "button_text": { "key": "button_text", "label": "Button Text", "value": 5 },
                    "custom_field_slug": { "key": "custom_field_slug", "label": "Custom Field", "value": 7 },
                    "has_create_button": { "key": "has_create_button", "label": "Has Create Button", "value": 6 },
                    "label": { "key": "label", "label": "Label", "value": 1 },
                    "placeholder": { "key": "placeholder", "label": "Placeholder", "value": 4 },
                    "required": { "key": "required", "label": "Is Required", "value": 3 },
                    "tooltip": { "key": "tooltip", "label": "Tooltip", "value": 2 }
                },
                "NoteFieldType": {
                    "__is_enum": true,
                    "attachment": {
                        "default_props": [5, 1, 3, 2],
                        "key": "attachment",
                        "label": "Attachments Button",
                        "value": 12
                    },
                    "bill": {
                        "default_props": [1, 2, 3, 4],
                        "key": "bill",
                        "label": "Related Bills",
                        "value": 11
                    },
                    "contact": {
                        "default_props": [1, 2, 3, 4, 6, 5],
                        "key": "contact",
                        "label": "Contacts",
                        "value": 8
                    },
                    "custom_field": {
                        "default_props": [7],
                        "key": "custom_field",
                        "label": "Custom Field",
                        "value": 14
                    },
                    "duration": {
                        "default_props": [1, 2, 3, 4],
                        "key": "duration",
                        "label": "Duration",
                        "value": 3
                    },
                    "issue": {
                        "default_props": [1, 2, 3, 4],
                        "key": "issue",
                        "label": "Issues",
                        "value": 13
                    },
                    "manage_custom_field": {
                        "default_props": [5],
                        "key": "manage_custom_field",
                        "label": "Manage Custom Field Button",
                        "value": 15
                    },
                    "member": {
                        "default_props": [1, 2, 3, 4],
                        "key": "member",
                        "label": "Team Members",
                        "value": 7
                    },
                    "note": {
                        "default_props": [1, 2, 3, 4],
                        "key": "note",
                        "label": "Notes",
                        "value": 10
                    },
                    "official": {
                        "default_props": [1, 2, 3, 4],
                        "key": "official",
                        "label": "Officials",
                        "value": 4
                    },
                    "organization": {
                        "default_props": [1, 2, 3, 4, 6, 5],
                        "key": "organization",
                        "label": "Organizations",
                        "value": 9
                    },
                    "participants": {
                        "default_props": [1, 2, 3, 4],
                        "key": "participants",
                        "label": "Persons",
                        "value": 16
                    },
                    "press": {
                        "default_props": [1, 2, 3, 4],
                        "key": "press",
                        "label": "Press Contacts",
                        "value": 6
                    },
                    "staffer": {
                        "default_props": [1, 2, 3, 4],
                        "key": "staffer",
                        "label": "Staffers",
                        "value": 5
                    },
                    "type": {
                        "default_props": [1, 2, 3, 4],
                        "key": "type",
                        "label": "Type",
                        "value": 1
                    },
                    "when": {
                        "default_props": [1, 2, 3],
                        "key": "when",
                        "label": "When",
                        "value": 2
                    }
                },
                "NoteSourceType": {
                    "__is_enum": true,
                    "consultants": {
                        "key": "consultants",
                        "label": "Consultants",
                        "permission_enum": [210],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 3
                    },
                    "grassroots": {
                        "key": "grassroots",
                        "label": "Action Center",
                        "permission_enum": [5, 7],
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002],
                        "value": 2
                    },
                    "user_team": {
                        "key": "user_team",
                        "label": "My Organization",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                        "value": 1
                    }
                },
                "NoteType": {
                    "__is_enum": true,
                    "comment": { "key": "comment", "label": "Comment", "order": 3, "value": 1 },
                    "interaction": { "key": "interaction", "label": "Interaction", "order": 1, "value": 2 },
                    "relationship": { "key": "relationship", "label": "Relationship", "order": 2, "value": 3 }
                },
                "OnboardingType": {
                    "__is_enum": true,
                    "accelerator": { "disabled": true, "key": "accelerator", "label": "[DEP] Accelerator", "value": 3 },
                    "launchpad": { "disabled": true, "key": "launchpad", "label": "[DEP] Launchpad", "value": 2 },
                    "launchpad_v2": { "disabled": false, "key": "launchpad_v2", "label": "Launchpad V2", "value": 6 },
                    "ngg_upgrade": { "disabled": false, "key": "ngg_upgrade", "label": "NGG Upgrade", "value": 5 },
                    "none": { "disabled": false, "key": "none", "label": "N/A", "value": 1 },
                    "premier": { "disabled": false, "key": "premier", "label": "Premier", "value": 4 }
                },
                "OrgAdminSettingsType": {
                    "__is_enum": true,
                    "alignment_types": {
                        "alt": "org_alignment_type_settings_button_link",
                        "content": "Customize your stakeholder alignment tags to match your organization's terminology.",
                        "dataCy": "orgAlignmentTypeLink",
                        "feature_flags": [],
                        "icon": "user-check",
                        "key": "alignment_types",
                        "label": "Manage Stakeholder Alignment",
                        "rel_url": "/alignmenttypes/",
                        "value": 9
                    },
                    "custom_interaction_types": {
                        "alt": "org_interaction_type_settings_button_link",
                        "content": "Manage types of interactions that your team members participate in.",
                        "dataCy": "orgCustomInteractionTypeLink",
                        "feature_flags": [],
                        "icon": "handshake",
                        "key": "custom_interaction_types",
                        "label": "Manage Interaction Types",
                        "rel_url": "/interactiontypes/",
                        "value": 7
                    },
                    "design": {
                        "alt": "org_design_settings_button_link",
                        "content": "Set up your organization's designs and branding.",
                        "dataCy": "orgDesignLink",
                        "feature_flags": [],
                        "icon": "paint-brush-alt",
                        "key": "design",
                        "label": "Design Settings",
                        "rel_url": "/design/edit/",
                        "value": 2
                    },
                    "fields": {
                        "alt": "org_fields_settings_button_link",
                        "content": "Add, edit and manage organizational custom fields.",
                        "dataCy": "orgFieldsLink",
                        "feature_flags": [],
                        "icon": "address-card",
                        "key": "fields",
                        "label": "Manage Custom Fields",
                        "rel_url": "/customfields/",
                        "value": 5
                    },
                    "general": {
                        "alt": "general_org_settings_button_link",
                        "content": "Manage your organization's configuration settings.",
                        "dataCy": "orgGeneralLink",
                        "feature_flags": [],
                        "icon": "cog",
                        "key": "general",
                        "label": "Organization Settings",
                        "rel_url": "/settings/organization/",
                        "value": 1
                    },
                    "integrations_management": {
                        "alt": "org_integrations_management_button_link",
                        "content": "Manage and add integrations between Quorum and third party systems.",
                        "dataCy": "orgIntegrationManagementTypeLink",
                        "feature_flags": ["ff_integrations_frontend"],
                        "icon": "chart-network",
                        "key": "integrations_management",
                        "label": "Integration Management",
                        "rel_url": "/integration_management/",
                        "value": 8
                    },
                    "stance_settings": {
                        "alt": "org_stance_labels_settings_button_link",
                        "content": "Customize your stance options to match your organization's terminology.",
                        "dataCy": "orgStanceCustomLabelsLink",
                        "feature_flags": [],
                        "icon": "thumbs-up",
                        "key": "stance_settings",
                        "label": "Manage Stance",
                        "rel_url": "/stance_settings/",
                        "value": 10
                    },
                    "teams": {
                        "alt": "org_teams_settings_button_link",
                        "content": "Manage team permissions and settings.",
                        "dataCy": "orgTeamsLink",
                        "feature_flags": [],
                        "icon": "users-cog",
                        "key": "teams",
                        "label": "Manage Teams",
                        "rel_url": "/settings/organization/teams/",
                        "value": 4
                    },
                    "users": {
                        "alt": "org_user_settings_button_link",
                        "content": "Manage user accounts and users' information.",
                        "dataCy": "orgUsersLink",
                        "feature_flags": [],
                        "icon": "user-cog",
                        "key": "users",
                        "label": "Manage Users",
                        "rel_url": "/settings/organization/users/",
                        "value": 3
                    }
                },
                "OrgMemberSettingsType": {
                    "__is_enum": true,
                    "design": {
                        "alt": "org_design_settings_button_link",
                        "content": "Set up your organization's designs and branding.",
                        "dataCy": "orgDesignLink",
                        "feature_flags": [],
                        "icon": "paint-brush-alt",
                        "key": "design",
                        "label": "Design Settings",
                        "rel_url": "/design/edit/",
                        "should_show_to_all_org_members": true,
                        "value": 1
                    },
                    "fields": {
                        "alt": "org_fields_settings_button_link",
                        "content": "Add, edit and manage organizational custom fields.",
                        "dataCy": "orgFieldsLink",
                        "feature_flags": [],
                        "icon": "address-card",
                        "key": "fields",
                        "label": "Manage Custom Fields",
                        "rel_url": "/customfields/",
                        "should_show_to_all_org_members": false,
                        "value": 2
                    }
                },
                "OrgMemberToolsType": {
                    "__is_enum": true,
                    "archive": {
                        "alt": "org_archive_settings_button_link",
                        "content": "Recover items in Quorum that you or your team have archived.",
                        "dataCy": "orgArchiveLink",
                        "feature_flags": [],
                        "icon": "recycle",
                        "key": "archive",
                        "label": "Recover Archived Items",
                        "rel_url": "/unarchive/",
                        "should_show_to_all_org_members": false,
                        "value": 1
                    },
                    "duplicate_management": {
                        "alt": "org_duplicate_management_settings_button_link",
                        "content": "Manage and merge potential duplicate profiles in Quorum.",
                        "dataCy": "orgDeduplicateLink",
                        "feature_flags": [],
                        "icon": "object-ungroup",
                        "key": "duplicate_management",
                        "label": "Duplicate Management",
                        "permission_enum": [3, 1005],
                        "rel_url": "/duplicate_management/",
                        "should_show_to_all_org_members": true,
                        "value": 2
                    }
                },
                "PossibleDurations": {
                    "__is_enum": true,
                    "fifteen_minutes": { "default": false, "in_minutes": 15, "key": "fifteen_minutes", "label": "15 mins", "order": 2, "value": 15 },
                    "five_days": { "default": false, "in_minutes": 7200, "key": "five_days", "label": "5 days", "order": 22, "value": 46 },
                    "five_minutes": { "default": false, "in_minutes": 5, "key": "five_minutes", "label": "5 mins", "order": 1, "value": 5 },
                    "four_days": { "default": false, "in_minutes": 5760, "key": "four_days", "label": "4 days", "order": 21, "value": 36 },
                    "four_hours": { "default": false, "in_minutes": 240, "key": "four_hours", "label": "4 hrs", "order": 17, "value": 4 },
                    "fourty_five_minutes": { "default": false, "in_minutes": 45, "key": "fourty_five_minutes", "label": "45 mins", "order": 4, "value": 45 },
                    "ninety_minutes": { "default": false, "in_minutes": 90, "key": "ninety_minutes", "label": "1.5 hrs", "order": 7, "value": 90 },
                    "none": { "default": false, "in_minutes": 0, "key": "none", "label": "N/A", "order": 25 },
                    "one_day": { "default": false, "in_minutes": 1440, "key": "one_day", "label": "1 day", "order": 18, "value": 9 },
                    "one_hour": { "default": false, "in_minutes": 60, "key": "one_hour", "label": "1 hr", "order": 5, "value": 1 },
                    "one_hour_fifteen_minutes": { "default": false, "in_minutes": 75, "key": "one_hour_fifteen_minutes", "label": "1.25 hrs", "order": 6, "value": 75 },
                    "one_hour_forty_five_minutes": { "default": false, "in_minutes": 105, "key": "one_hour_forty_five_minutes", "label": "1.75 hrs", "order": 8, "value": 105 },
                    "seven_days": { "default": false, "in_minutes": 10080, "key": "seven_days", "label": "7 days", "order": 24, "value": 63 },
                    "six_days": { "default": false, "in_minutes": 8640, "key": "six_days", "label": "6 days", "order": 23, "value": 54 },
                    "thirty_minutes": { "default": true, "in_minutes": 30, "key": "thirty_minutes", "label": "30 mins", "order": 3, "value": 30 },
                    "three_days": { "default": false, "in_minutes": 4320, "key": "three_days", "label": "3 days", "order": 20, "value": 27 },
                    "three_hours": { "default": false, "in_minutes": 180, "key": "three_hours", "label": "3 hrs", "order": 13, "value": 3 },
                    "three_hours_fifteen_minutes": { "default": false, "in_minutes": 195, "key": "three_hours_fifteen_minutes", "label": "3.25 hrs", "order": 14, "value": 195 },
                    "three_hours_fourty_five_minutes": { "default": false, "in_minutes": 225, "key": "three_hours_fourty_five_minutes", "label": "3.75 hrs", "order": 16, "value": 225 },
                    "three_hours_thirty_minutes": { "default": false, "in_minutes": 210, "key": "three_hours_thirty_minutes", "label": "3.5 hrs", "order": 15, "value": 210 },
                    "two_days": { "default": false, "in_minutes": 2880, "key": "two_days", "label": "2 days", "order": 19, "value": 18 },
                    "two_hours": { "default": false, "in_minutes": 120, "key": "two_hours", "label": "2 hrs", "order": 9, "value": 2 },
                    "two_hours_fifteen_minutes": { "default": false, "in_minutes": 135, "key": "two_hours_fifteen_minutes", "label": "2.25 hrs", "order": 10, "value": 135 },
                    "two_hours_fourty_five_minutes": { "default": false, "in_minutes": 165, "key": "two_hours_fourty_five_minutes", "label": "2.75 hrs", "order": 12, "value": 165 },
                    "two_hours_thirty_minutes": { "default": false, "in_minutes": 150, "key": "two_hours_thirty_minutes", "label": "2.5 hrs", "order": 11, "value": 150 },
                    "zero": { "default": false, "in_minutes": 0, "key": "zero", "label": "Not Applicable (N/A)", "order": 0, "value": 0 }
                },
                "PrivacyType": {
                    "__is_enum": true,
                    "organization": { "board_display": "", "board_icon": "fa-globe", "key": "organization", "label": "Organization", "value": 3 },
                    "private": { "board_display": "Private", "board_icon": "fa-lock", "key": "private", "label": "Private", "value": 1 },
                    "public": { "board_display": "Organization", "board_icon": "fa-globe", "key": "public", "label": "Public", "value": 2 },
                    "shared": { "board_display": "", "board_icon": "fa-globe", "key": "shared", "label": "Shared", "value": 4 }
                },
                "ProjectStatType": {
                    "__is_enum": true,
                    "all_organizations": { "key": "all_organizations", "label": "All Organizations", "tip": "Average this statistic across all organizations in this project.", "value": 3, "visible": false },
                    "average": { "key": "average", "label": "Average", "tip": "Average this statistic across the users in each project.", "value": 4, "visible": true },
                    "organization": { "key": "organization", "label": "Organization", "project_stats_key": "org_statistics", "tip": "Your organization's value for this statistic.", "value": 2, "visible": true },
                    "user": { "key": "user", "label": "User", "project_stats_key": "personal_statistics", "tip": "Your value for this statistic.", "value": 1, "visible": true }
                },
                "ProjectType": {
                    "__is_enum": true,
                    "bill_tracking": {
                        "key": "bill_tracking",
                        "label": "Bill Tracking",
                        "permission_enum": [304],
                        "proxy": "Project",
                        "tip": "Automatically find all bills matching your keywords, then sort by stance, priority, and status.",
                        "value": 2
                    },
                    "custom": { "key": "custom", "label": "Custom", "proxy": "Project", "tip": "Create a blank workspace to build your own boards and lists.", "value": 1 },
                    "dialogue_tracking": {
                        "key": "dialogue_tracking",
                        "label": "Dialogue Tracking",
                        "permission_enum": [304],
                        "proxy": "Project",
                        "tip": "Create a search universe that automatically finds all mentions of your keywords in documents throughout Quorum's database.",
                        "value": 3
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Type",
                            "values": [1, 2, 3]
                        }
                    ]
                },
                "RelationshipType": {
                    "__is_enum": true,
                    "ambassador_donor": { "divider": "with", "grouped": "have a relationship through a donation", "icon": "fa-gift", "key": "ambassador_donor", "label": "Donor Relationship", "past_grouped": "had a relationship through a donation", "past_third_person": "had a relationship through a donation", "plural_label": "Donor Relationship", "second_person": "have a relationship through a donation", "survey_question": "Are you a donor", "third_person": "has a relationship through a donation", "value": 12 },
                    "board": { "divider": "of", "grouped": "sit on a board", "icon": "fa-user-circle", "key": "board", "label": "Board", "mobile_order": 8, "order": 8, "past_grouped": "sat on a board", "past_third_person": "sat on a board", "plural_label": "Sit on a board", "second_person": "sit on a board", "survey_question": "Do you sit on a board", "third_person": "sits on a board", "value": 11 },
                    "classmate": { "divider": "of", "grouped": "are classmates", "icon": "fa-graduation-cap", "key": "classmate", "label": "Classmate", "mobile_order": 4, "order": 4, "past_grouped": "are classmates", "past_third_person": "are classmates", "plural_label": "Classmates", "second_person": "are a classmate", "survey_question": "Are you a classmate", "third_person": "is a classmate", "value": 6 },
                    "colleague": { "divider": "of", "grouped": "are colleagues", "icon": "fa-briefcase", "key": "colleague", "label": "Colleague", "mobile_order": 3, "order": 3, "past_grouped": "were colleagues", "past_third_person": "were colleagues", "plural_label": "Colleagues", "second_person": "are a colleague", "survey_question": "Are you a colleague", "third_person": "is a colleague", "value": 5 },
                    "custom": { "divider": "with", "grouped": "have a relationship", "icon": "fa-exchange", "key": "custom", "label": "Other", "mobile_order": 9, "order": 9, "past_grouped": "had a relationship", "past_third_person": "had a relationship", "plural_label": "Other", "second_person": "have a relationship", "survey_question": "Do you have any other relationships or connections", "third_person": "has a relationship", "value": 1 },
                    "family": { "divider": "with", "grouped": "are connected through family", "icon": "fa-sign-language", "key": "family", "label": "Family Connection", "mobile_order": 6, "order": 6, "past_grouped": "were connected through family", "past_third_person": "were connected through family", "plural_label": "Family Connection", "second_person": "have a family connection", "survey_question": "Do you share a family connection", "third_person": "has a family connection", "value": 8 },
                    "friend": { "divider": "of", "grouped": "are friends", "icon": "fa-hand-peace-o", "key": "friend", "label": "Friend", "mobile_order": 5, "order": 5, "past_grouped": "are friends", "past_third_person": "are friends", "plural_label": "Friends", "second_person": "are a friend", "survey_question": "Are you a friend", "third_person": "is a friend", "value": 7 },
                    "neighbor": { "divider": "with", "grouped": "are neighbors", "icon": "fa-home", "key": "neighbor", "label": "Neighbor", "mobile_order": 7, "order": 7, "past_grouped": "were neighbors", "past_third_person": "were neighbors", "plural_label": "Neighbors", "second_person": "are neighbors", "survey_question": "Are you neighbors", "third_person": "is neighbors", "value": 9 },
                    "none": { "divider": "with", "grouped": "have no relationship", "icon": "fa-user-times", "key": "none", "label": "No Relationship", "mobile_order": 10, "order": 10, "past_grouped": "had no relationship", "past_third_person": "had no relationship", "plural_label": "No Relationship", "second_person": "have no relationship", "survey_question": "Do you have no relationship", "third_person": "has no relationship", "value": 10 },
                    "political": { "divider": "with", "grouped": "are political acquaintances", "icon": "fa-handshake-o", "key": "political", "label": "Political Acquaintance", "mobile_order": 1, "order": 1, "past_grouped": "were political acquaintances", "past_third_person": "were political acquaintances", "plural_label": "Political Acquaintances", "second_person": "are politically acquainted", "survey_question": "Are you politically acquainted", "third_person": "is politically acquainted", "value": 3 },
                    "professional": { "divider": "with", "grouped": "are professional acquaintances", "icon": "fa-address-card-o", "key": "professional", "label": "Professional Acquaintance", "mobile_order": 0, "order": 0, "past_grouped": "were professional acquaintances", "past_third_person": "were professional acquaintances", "plural_label": "Professional Acquaintances", "second_person": "are professionally acquainted", "survey_question": "Are you professionally acquainted", "third_person": "is professionally acquainted", "value": 2 },
                    "social": { "divider": "with", "grouped": "are social acquaintances", "icon": "fa-coffee", "key": "social", "label": "Social Acquaintance", "mobile_order": 2, "order": 2, "past_grouped": "were social acquaintances", "past_third_person": "were social acquaintances", "plural_label": "Social Acquaintances", "second_person": "are socially acquainted", "survey_question": "Are you socially acquainted", "third_person": "is socially acquainted", "value": 4 },
                    "willing_to_call": { "divider": "", "grouped": "are willing to call", "icon": "fa-phone", "key": "willing_to_call", "label": "Willing to Call", "past_grouped": "were willing to call", "past_third_person": "was willing to call", "plural_label": "Willing to Call", "second_person": "are willing to call", "survey_question": "Are you willing to call", "third_person": "is willing to call", "value": 13 },
                    "willing_to_email": { "divider": "to", "grouped": "are willing to send a personal email", "icon": "fa-envelope-o", "key": "willing_to_email", "label": "Willing to Send Personal Email", "past_grouped": "were willing to send a personal email", "past_third_person": "was willing to send a personal email", "plural_label": "Willing to Send Personal Email", "second_person": "are willing to send a personal email", "survey_question": "Are you willing to send a personal email", "third_person": "is willing to send a personal email", "value": 15 },
                    "willing_to_visit": { "divider": "", "grouped": "are willing to visit", "icon": "fa-handshake-o", "key": "willing_to_visit", "label": "Willing to Visit", "past_grouped": "were willing to visit", "past_third_person": "was willing to visit", "plural_label": "Willing to Visit", "second_person": "are willing to visit", "survey_question": "Are you willing to visit", "third_person": "is willing to visit", "value": 14 }
                },
                "SheetStanceVoteResultType": {
                    "__is_enum": true,
                    "delegate": { "cell_tip": "This is a Delegate (a member of the House of Representatives that cannot vote but can sponsor legislation).", "icon": "fa-certificate", "key": "delegate", "label": "Delegate", "order": 8, "show_list": false, "value": 8 },
                    "missed": { "cell_tip": "This person was eligible to vote but was not present and missed the vote.", "icon": "fa-circle-thin", "key": "missed", "label": "Missed", "order": 6, "show_list": false, "value": 6 },
                    "oppose": { "bill_sheet_tip": "We oppose this bill", "cell_tip": "This person voted in opposition of our stance.", "fa5_icon": "thumbs-down", "icon": "fa-thumbs-down", "key": "oppose", "label": "Oppose", "list_name": "Opposed", "order": 2, "show_list": true, "value": 2, "verb": "opposes" },
                    "present": { "cell_tip": "This person voted Present and did not vote with or against our stance.", "icon": "fa-circle", "key": "present", "label": "Present", "order": 5, "show_list": false, "value": 5 },
                    "speaker": { "cell_tip": "This is the Speaker of the House and traditionally does not vote.", "icon": "fa-gavel", "key": "speaker", "label": "Speaker", "order": 7, "show_list": false, "value": 7 },
                    "support": { "bill_sheet_tip": "We support this bill", "cell_tip": "This person voted in support of our stance.", "fa5_icon": "thumbs-up", "icon": "fa-thumbs-up", "key": "support", "label": "Support", "list_name": "Supported", "order": 1, "show_list": true, "value": 1, "verb": "supports" }
                },
                "StanceType": {
                    "__is_enum": true,
                    "legislative": { "key": "legislative", "label": "Legislative", "value": 1 },
                    "regulatory": { "key": "regulatory", "label": "Regulatory", "value": 2 }
                },
                "Timezones": {
                    "__is_enum": true,
                    "alaska": { "daylight_savings_offset": -8, "jstz": 540, "key": "alaska", "label": "Alaska Time", "order": 5, "pytz": "US/Alaska", "standard_offset": -9, "value": 5 },
                    "atlantic": { "daylight_savings_offset": -3, "jstz": 240, "key": "atlantic", "label": "Atlantic Time", "order": 13, "pytz": "America/Puerto_Rico", "standard_offset": -4, "value": 13 },
                    "british": { "daylight_savings_offset": 0, "jstz": 0, "key": "british", "label": "Greenwich Mean Time", "order": 7, "pytz": "Europe/London", "standard_offset": 0, "value": 7 },
                    "central": { "daylight_savings_offset": -5, "jstz": 360, "key": "central", "label": "Central Time", "order": 2, "pytz": "US/Central", "standard_offset": -6, "value": 2 },
                    "central_european": { "daylight_savings_offset": 2, "jstz": -60, "key": "central_european", "label": "Central European Time", "order": 8, "pytz": "Europe/Brussels", "standard_offset": 1, "value": 8 },
                    "chamorro": { "daylight_savings_offset": 10, "jstz": 600, "key": "chamorro", "label": "Chamorro Standard Time", "order": 12, "pytz": "Pacific/Guam", "standard_offset": 10, "value": 12 },
                    "eastern": { "daylight_savings_offset": -4, "jstz": 300, "key": "eastern", "label": "Eastern Time", "order": 1, "pytz": "US/Eastern", "standard_offset": -5, "value": 1 },
                    "eastern_european": { "daylight_savings_offset": 3, "jstz": -120, "key": "eastern_european", "label": "Eastern European Time", "order": 9, "pytz": "Europe/Helsinki", "standard_offset": 2, "value": 9 },
                    "hawaii": { "daylight_savings_offset": -9, "jstz": 600, "key": "hawaii", "label": "Hawaii Aleutian Time", "order": 6, "pytz": "US/Hawaii", "standard_offset": -10, "value": 6 },
                    "mountain": { "daylight_savings_offset": -6, "jstz": 420, "key": "mountain", "label": "Mountain Time", "order": 3, "pytz": "US/Mountain", "standard_offset": -7, "value": 3 },
                    "newfoundland": { "daylight_savings_offset": -2.5, "jstz": 210, "key": "newfoundland", "label": "Newfoundland Time", "order": 14, "pytz": "America/St_Johns", "standard_offset": -3.5, "value": 14 },
                    "pacific": { "daylight_savings_offset": -7, "jstz": 480, "key": "pacific", "label": "Pacific Time", "order": 4, "pytz": "US/Pacific", "standard_offset": -8, "value": 4 },
                    "samoa": { "daylight_savings_offset": 0, "jstz": 660, "key": "samoa", "label": "Samoa Standard Time", "order": 11, "pytz": "Pacific/Apia", "standard_offset": -11, "value": 11 },
                    "western_european": { "daylight_savings_offset": 1, "jstz": 60, "key": "western_european", "label": "Western European Time", "order": 10, "pytz": "Europe/Lisbon", "standard_offset": 0, "value": 10 }
                },
                "TwoFactorStatus": {
                    "__is_enum": true,
                    "activated_app_only": { "key": "activated_app_only", "label": "Activated only google authenticator", "value": 4 },
                    "activated_both": { "key": "activated_both", "label": "Activated for both sms and google authenticator", "value": 3 },
                    "activated_sms_only": { "key": "activated_sms_only", "label": "Activated for sms only", "value": 2 },
                    "disabled": { "key": "disabled", "label": "Disabled", "value": 1 }
                },
                "UnsubscribeSettings": {
                    "__is_enum": true,
                    "customized": { "key": "customized", "label": "Show Customized Unsubscribe Link", "value": 2 },
                    "dont_show": { "key": "dont_show", "label": "Don't Show Unsubscribe Link", "value": 3 },
                    "preconfigured": { "key": "preconfigured", "label": "Show Preconfigured Unsubscribe Link", "value": 1 }
                },
                "UploadsViewStatus": {
                    "__is_enum": true,
                    "regular": { "key": "regular", "label": "Regular", "value": 0 },
                    "secure": { "key": "secure", "label": "Secure", "value": 1 }
                },
                "UserPersona": {
                    "__is_enum": true,
                    "generic": {
                        "icon": "ban",
                        "key": "generic",
                        "label": "Generic",
                        "org_admin_only": false,
                        "permissions": [],
                        "summary": "I <strong>do not wish to personalize my Quorum experience</strong> based on my role.",
                        "value": 1
                    },
                    "grassroots_associate": {
                        "icon": "seedling",
                        "key": "grassroots_associate",
                        "label": "Grassroots Associate",
                        "org_admin_only": false,
                        "permissions": [102],
                        "summary": "I <strong>assist in growing our Grassroots</strong> campaign audience.",
                        "value": 9
                    },
                    "grassroots_corp_director": {
                        "icon": "building",
                        "key": "grassroots_corp_director",
                        "label": "Grassroots Corp Director",
                        "org_admin_only": false,
                        "permissions": [102],
                        "summary": "I develop and <strong>direct Corporate Grassroots</strong> initiatives.",
                        "value": 8
                    },
                    "grassroots_nonprofit_director": {
                        "icon": "ribbon",
                        "key": "grassroots_nonprofit_director",
                        "label": "Grassroots Non-Profit Director",
                        "org_admin_only": false,
                        "permissions": [102],
                        "summary": "I develop and <strong>direct Non-Profit Grassroots</strong> initiatives.",
                        "value": 7
                    },
                    "legislative_admin": {
                        "icon": "analytics",
                        "key": "legislative_admin",
                        "label": "Legislative Admin",
                        "org_admin_only": true,
                        "permissions": [1, 100, 101],
                        "summary": "I'm the <strong>Quorum admin supporting staff who track and report on legislation</strong>.",
                        "value": 2
                    },
                    "legislative_relationship_manager": {
                        "icon": "comments",
                        "key": "legislative_relationship_manager",
                        "label": "Legislative Relationship Manager",
                        "org_admin_only": false,
                        "permissions": [1, 2, 100, 101, 103, 9],
                        "summary": "I report and <strong>track meetings and interactions with officials and staffers</strong>.",
                        "value": 4
                    },
                    "legislative_tracker": {
                        "icon": "search",
                        "key": "legislative_tracker",
                        "label": "Legislative Tracker",
                        "org_admin_only": false,
                        "permissions": [1, 2, 100, 101, 103, 9],
                        "summary": "I <strong>monitor, track, and report on legislation</strong>, regulations, and dialogue.",
                        "value": 3
                    },
                    "pac_manager": {
                        "icon": "bullseye-arrow",
                        "key": "pac_manager",
                        "label": "PAC Manager",
                        "org_admin_only": false,
                        "permissions": [8, 215],
                        "summary": "I <strong>manage a PAC</strong> including fundraising, compliance, and reporting.",
                        "value": 10
                    },
                    "pac_treasurer": {
                        "icon": "shield-check",
                        "key": "pac_treasurer",
                        "label": "PAC Treasurer",
                        "org_admin_only": false,
                        "permissions": [8, 215],
                        "summary": "I <strong>ensure PAC financial data</strong> is accurate and compliant.",
                        "value": 11
                    },
                    "stakeholder_admin": {
                        "icon": "cog",
                        "key": "stakeholder_admin",
                        "label": "Stakeholder Admin",
                        "org_admin_only": true,
                        "permissions": [3],
                        "summary": "I'm the <strong>Quorum admin supporting staff who manage relationships with stakeholders</strong>.",
                        "value": 5
                    },
                    "stakeholder_relationship_manager": {
                        "icon": "handshake",
                        "key": "stakeholder_relationship_manager",
                        "label": "Stakeholder Relationship Manager",
                        "org_admin_only": false,
                        "permissions": [3],
                        "summary": "I build and <strong>maintain relationships with stakeholders</strong>.",
                        "value": 6
                    }
                },
                "UserRole": {
                    "__is_enum": true,
                    "csm": { "key": "csm", "label": "Quorum CSM", "value": 3 },
                    "employee": { "key": "employee", "label": "Quorum Employee", "value": 2 },
                    "engineer": { "key": "engineer", "label": "Quorum Engineer", "value": 5 },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Superuser",
                            "values": [3, 4, 5]
                        },
                        {
                            "display": "list",
                            "title": "Staff",
                            "values": [2, 3, 4, 5]
                        }
                    ],
                    "support": { "key": "support", "label": "Quorum Support", "value": 4 },
                    "user": { "key": "user", "label": "User", "value": 1 }
                },
                "Weekdays": {
                    "__is_enum": true,
                    "friday": { "key": "friday", "label": "Weekly Alerts on Friday", "short_label": "Friday", "value": 5 },
                    "monday": { "key": "monday", "label": "Weekly Alerts on Monday", "short_label": "Monday", "value": 1 },
                    "saturday": { "key": "saturday", "label": "Weekly Alerts on Saturday", "short_label": "Saturday", "value": 6 },
                    "sunday": { "key": "sunday", "label": "Weekly Alerts on Sunday", "short_label": "Sunday", "value": 7 },
                    "thursday": { "key": "thursday", "label": "Weekly Alerts on Thursday", "short_label": "Thursday", "value": 4 },
                    "tuesday": { "key": "tuesday", "label": "Weekly Alerts on Tuesday", "short_label": "Tuesday", "value": 2 },
                    "wednesday": { "key": "wednesday", "label": "Weekly Alerts on Wednesday", "short_label": "Wednesday", "value": 3 }
                }
            }
        },
        "vote": {
            "models": {
                "QuickVote": {
                    "__is_model": true,
                    "__name__": "QuickVote",
                    "data_model": "app.vote.models.QuickVote",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/quickvote/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the vote was made.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        { "field_type": 2, "help_text": "Within each Congress there are sessions. In recent history the sessionscorrespond to calendar years and are named accordingly. However, in historical datathe sessions may be named in completely other ways, such as with letters A, B, and C.Session names are unique *within* a Congress.", "name": "session", "verbose_name": "Session" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CongressChamber" },
                            "field_type": 4,
                            "help_text": "The chamber in which the vote was held, House or Senate.",
                            "name": "chamber",
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "verbose_name": "Chamber"
                        },
                        { "field_type": 4, "help_text": "The number of the vote, unique to a Congress, session, and chamber.", "name": "number", "verbose_name": "Vote Number" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteSource" },
                            "field_type": 4,
                            "help_text": "The source of the vote information.",
                            "name": "source",
                            "verbose_name": "source"
                        },
                        { "field_type": 21, "help_text": "The date (and in recent history also time) on which the vote was held.", "name": "created", "verbose_name": "created" },
                        { "field_type": 21, "help_text": "Created date and time for vote", "name": "created_at", "verbose_name": "created at" },
                        { "field_type": 21, "help_text": "Last updated date and time for vote", "name": "updated_at", "verbose_name": "updated at" },
                        { "field_type": 2, "help_text": "Descriptive text for the type of the vote.", "name": "vote_type", "verbose_name": "vote type" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteCategory" },
                            "field_type": 4,
                            "help_text": "The type of the vote.",
                            "name": "category",
                            "verbose_name": "category"
                        },
                        { "field_type": 3, "help_text": "Descriptive text for what the vote was about.", "name": "question", "sheet_column": true, "sheets_column_order": 0, "verbose_name": "Question" },
                        { "field_type": 2, "help_text": "A code indicating what number of votes was required for success. Often '1/2' or '3/5'. This field should be interpreted with care. It comes directly from the upstream source and may need some 'unpacking.' For instance, while 1/2 always mean 1/2 of those voting (i.e. excluding absent and abstain), 3/5 in some cases means to include absent/abstain and in other cases to exclude.", "name": "required", "verbose_name": "required" },
                        { "field_type": 4, "help_text": "The total number of votes that were cast.", "name": "total_all", "sheet_column": true, "sheets_column_order": 6, "verbose_name": "Total Votes" },
                        { "field_type": 4, "help_text": "The total number of positive votes (aye/yea) that were cast.", "name": "total_plus", "sheet_column": true, "sheets_column_order": 7, "verbose_name": "Total Yea Votes" },
                        { "field_type": 4, "help_text": "The total number of of negative votes (nay/no) that were cast.", "name": "total_minus", "sheet_column": true, "sheets_column_order": 8, "verbose_name": "Total Nay Votes" },
                        { "field_type": 4, "help_text": "The total number of of abstention votes that were cast.", "name": "total_abstain", "sheet_column": true, "sheets_column_order": 15, "verbose_name": "Total Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent voters.", "name": "total_other", "verbose_name": "total other" },
                        { "field_type": 4, "help_text": "The total count of all Republican votes that were cast.", "name": "total_rep_all", "sheet_column": true, "sheets_column_order": 12, "verbose_name": "Total Republican Votes" },
                        { "field_type": 4, "help_text": "The count of positive Republican votes (aye/yea) that were cast.", "name": "total_rep_plus", "sheet_column": true, "sheets_column_order": 13, "verbose_name": "Total Republican Yea Votes" },
                        { "field_type": 4, "help_text": "The count of negative Republican votes (nay/no) that were cast.", "name": "total_rep_minus", "sheet_column": true, "sheets_column_order": 14, "verbose_name": "Total Republican Nay Votes" },
                        { "field_type": 4, "help_text": "The count of abstention Republican votes (nay/no).", "name": "total_rep_abstain", "sheet_column": true, "sheets_column_order": 17, "verbose_name": "Total Republican Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent Republican voters.", "name": "total_rep_other", "verbose_name": "total rep other" },
                        { "field_type": 4, "help_text": "The count of all Democrat votes that were cast.", "name": "total_dem_all", "sheet_column": true, "sheets_column_order": 9, "verbose_name": "Total Democrat Votes" },
                        { "field_type": 4, "help_text": "The count of positive Democrat votes (aye/yea).", "name": "total_dem_plus", "sheet_column": true, "sheets_column_order": 10, "verbose_name": "Total Democrat Yea Votes" },
                        { "field_type": 4, "help_text": "The count of negative Democrat votes (nay/no).", "name": "total_dem_minus", "sheet_column": true, "sheets_column_order": 11, "verbose_name": "Total Democrat Nay Votes" },
                        { "field_type": 4, "help_text": "The count of abstention Democrat votes (nay/no).", "name": "total_dem_abstain", "sheet_column": true, "sheets_column_order": 16, "verbose_name": "Total Democrat Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent Democrat voters.", "name": "total_dem_other", "verbose_name": "total dem other" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the most republicans voted for",
                            "name": "republican_result",
                            "sheet_column": true,
                            "sheets_column_order": 5,
                            "verbose_name": "Republican Result"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the most democrats voted for",
                            "name": "democrat_result",
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "verbose_name": "Democrat Result"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the majority voted for",
                            "name": "majority_result",
                            "verbose_name": "Majority Result"
                        },
                        { "field_type": 3, "help_text": "Descriptive text for the result of the vote.", "name": "result", "verbose_name": "result" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result of the vote.",
                            "name": "result_type",
                            "sheet_column": true,
                            "sheets_column_order": 3,
                            "verbose_name": "Result"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "related bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "related amendment"
                        },
                        { "field_type": 1, "help_text": "If we should revisit the file.", "name": "missing_data", "verbose_name": "missing data" },
                        { "field_type": 3, "help_text": "Additional descriptive text for what the vote was about.", "name": "question_details", "verbose_name": "question details" },
                        { "field_type": 2, "help_text": "A link to the page on the primary source website for this vote", "name": "source_link", "overriden_column_data_type": 11, "sheet_column": true, "sheets_column_order": 18, "verbose_name": "Source Link" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region the vote occurred in.",
                            "name": "region",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the vote was made.",
                            "name": "region_session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "region session"
                        },
                        { "field_type": 2, "help_text": "The openstates_id for state votes.", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 3, "help_text": "Temporary field to help with parsing vote questions.", "name": "original_question", "verbose_name": "original question" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 5, "help_text": "The most recent date of a Vote update", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted in this vote.",
                            "name": "all_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "all votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted positive in this vote.",
                            "name": "yea_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "yea votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted negative in this vote.",
                            "name": "nay_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "nay votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who were present but did not vote in this vote.",
                            "name": "present_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "present votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who were not present and did not vote in this vote.",
                            "name": "missed_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "missed votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the votes other than yea or nay -- when present or missing unknown",
                            "name": "other_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "other votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this vote is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ],
                    "proxy_endpoint": "/api/vote/"
                },
                "Vote": {
                    "__is_model": true,
                    "__name__": "Vote",
                    "data_model": "app.vote.models.Vote",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/vote/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        {
                            "field_type": 7,
                            "help_text": "The Congress object in which the vote was made.",
                            "name": "congress",
                            "related_model": { "__module__": "app.models", "__name__": "Congress" },
                            "verbose_name": "congress"
                        },
                        { "field_type": 4, "help_text": "The number of the congress (for indexing, etc.)", "name": "congress_number", "verbose_name": "congress number" },
                        { "field_type": 2, "help_text": "Within each Congress there are sessions. In recent history the sessionscorrespond to calendar years and are named accordingly. However, in historical datathe sessions may be named in completely other ways, such as with letters A, B, and C.Session names are unique *within* a Congress.", "name": "session", "verbose_name": "Session" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "CongressChamber" },
                            "field_type": 4,
                            "help_text": "The chamber in which the vote was held, House or Senate.",
                            "name": "chamber",
                            "sheet_column": true,
                            "sheets_column_order": 2,
                            "verbose_name": "Chamber"
                        },
                        { "field_type": 4, "help_text": "The number of the vote, unique to a Congress, session, and chamber.", "name": "number", "verbose_name": "Vote Number" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteSource" },
                            "field_type": 4,
                            "help_text": "The source of the vote information.",
                            "name": "source",
                            "verbose_name": "source"
                        },
                        { "field_type": 21, "help_text": "The date (and in recent history also time) on which the vote was held.", "name": "created", "verbose_name": "created" },
                        { "field_type": 21, "help_text": "Created date and time for vote", "name": "created_at", "verbose_name": "created at" },
                        { "field_type": 21, "help_text": "Last updated date and time for vote", "name": "updated_at", "verbose_name": "updated at" },
                        { "field_type": 2, "help_text": "Descriptive text for the type of the vote.", "name": "vote_type", "verbose_name": "vote type" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteCategory" },
                            "field_type": 4,
                            "help_text": "The type of the vote.",
                            "name": "category",
                            "verbose_name": "category"
                        },
                        { "field_type": 3, "help_text": "Descriptive text for what the vote was about.", "name": "question", "sheet_column": true, "sheets_column_order": 0, "verbose_name": "Question" },
                        { "field_type": 2, "help_text": "A code indicating what number of votes was required for success. Often '1/2' or '3/5'. This field should be interpreted with care. It comes directly from the upstream source and may need some 'unpacking.' For instance, while 1/2 always mean 1/2 of those voting (i.e. excluding absent and abstain), 3/5 in some cases means to include absent/abstain and in other cases to exclude.", "name": "required", "verbose_name": "required" },
                        { "field_type": 4, "help_text": "The total number of votes that were cast.", "name": "total_all", "sheet_column": true, "sheets_column_order": 6, "verbose_name": "Total Votes" },
                        { "field_type": 4, "help_text": "The total number of positive votes (aye/yea) that were cast.", "name": "total_plus", "sheet_column": true, "sheets_column_order": 7, "verbose_name": "Total Yea Votes" },
                        { "field_type": 4, "help_text": "The total number of of negative votes (nay/no) that were cast.", "name": "total_minus", "sheet_column": true, "sheets_column_order": 8, "verbose_name": "Total Nay Votes" },
                        { "field_type": 4, "help_text": "The total number of of abstention votes that were cast.", "name": "total_abstain", "sheet_column": true, "sheets_column_order": 15, "verbose_name": "Total Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent voters.", "name": "total_other", "verbose_name": "total other" },
                        { "field_type": 4, "help_text": "The total count of all Republican votes that were cast.", "name": "total_rep_all", "sheet_column": true, "sheets_column_order": 12, "verbose_name": "Total Republican Votes" },
                        { "field_type": 4, "help_text": "The count of positive Republican votes (aye/yea) that were cast.", "name": "total_rep_plus", "sheet_column": true, "sheets_column_order": 13, "verbose_name": "Total Republican Yea Votes" },
                        { "field_type": 4, "help_text": "The count of negative Republican votes (nay/no) that were cast.", "name": "total_rep_minus", "sheet_column": true, "sheets_column_order": 14, "verbose_name": "Total Republican Nay Votes" },
                        { "field_type": 4, "help_text": "The count of abstention Republican votes (nay/no).", "name": "total_rep_abstain", "sheet_column": true, "sheets_column_order": 17, "verbose_name": "Total Republican Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent Republican voters.", "name": "total_rep_other", "verbose_name": "total rep other" },
                        { "field_type": 4, "help_text": "The count of all Democrat votes that were cast.", "name": "total_dem_all", "sheet_column": true, "sheets_column_order": 9, "verbose_name": "Total Democrat Votes" },
                        { "field_type": 4, "help_text": "The count of positive Democrat votes (aye/yea).", "name": "total_dem_plus", "sheet_column": true, "sheets_column_order": 10, "verbose_name": "Total Democrat Yea Votes" },
                        { "field_type": 4, "help_text": "The count of negative Democrat votes (nay/no).", "name": "total_dem_minus", "sheet_column": true, "sheets_column_order": 11, "verbose_name": "Total Democrat Nay Votes" },
                        { "field_type": 4, "help_text": "The count of abstention Democrat votes (nay/no).", "name": "total_dem_abstain", "sheet_column": true, "sheets_column_order": 16, "verbose_name": "Total Democrat Abstaining Votes" },
                        { "field_type": 4, "help_text": "The count of absent Democrat voters.", "name": "total_dem_other", "verbose_name": "total dem other" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the most republicans voted for",
                            "name": "republican_result",
                            "sheet_column": true,
                            "sheets_column_order": 5,
                            "verbose_name": "Republican Result"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the most democrats voted for",
                            "name": "democrat_result",
                            "sheet_column": true,
                            "sheets_column_order": 4,
                            "verbose_name": "Democrat Result"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result that the majority voted for",
                            "name": "majority_result",
                            "verbose_name": "Majority Result"
                        },
                        { "field_type": 3, "help_text": "Descriptive text for the result of the vote.", "name": "result", "verbose_name": "result" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result of the vote.",
                            "name": "result_type",
                            "sheet_column": true,
                            "sheets_column_order": 3,
                            "verbose_name": "Result"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "related bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "",
                            "name": "related_amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "related amendment"
                        },
                        { "field_type": 1, "help_text": "If we should revisit the file.", "name": "missing_data", "verbose_name": "missing data" },
                        { "field_type": 3, "help_text": "Additional descriptive text for what the vote was about.", "name": "question_details", "verbose_name": "question details" },
                        { "field_type": 2, "help_text": "A link to the page on the primary source website for this vote", "name": "source_link", "overriden_column_data_type": 11, "sheet_column": true, "sheets_column_order": 18, "verbose_name": "Source Link" },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.models", "__name__": "Region" },
                            "field_type": 4,
                            "help_text": "The region the vote occurred in.",
                            "name": "region",
                            "sheet_column": true,
                            "sheets_column_order": 1,
                            "verbose_name": "Region"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The LegSession object in which the vote was made.",
                            "name": "region_session",
                            "related_model": { "__module__": "app.models", "__name__": "LegSession" },
                            "verbose_name": "region session"
                        },
                        { "field_type": 2, "help_text": "The openstates_id for state votes.", "name": "openstates_id", "verbose_name": "openstates id" },
                        { "field_type": 3, "help_text": "Temporary field to help with parsing vote questions.", "name": "original_question", "verbose_name": "original question" },
                        { "field_type": null, "help_text": "Represents the current state of this object. Used in alert processing", "name": "alert_cache", "verbose_name": "alert cache" },
                        { "field_type": 5, "help_text": "The most recent date of a Vote update", "name": "last_quorum_update", "verbose_name": "last quorum update" },
                        { "field_type": 1, "help_text": "", "name": "newly_index", "verbose_name": "newly index" },
                        { "field_type": null, "help_text": "", "name": "fts_index", "verbose_name": "fts index" },
                        { "field_type": null, "help_text": "", "name": "exact_index", "verbose_name": "exact index" },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted in this vote.",
                            "name": "all_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "all votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted positive in this vote.",
                            "name": "yea_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "yea votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who voted negative in this vote.",
                            "name": "nay_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "nay votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who were present but did not vote in this vote.",
                            "name": "present_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "present votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the individuals who were not present and did not vote in this vote.",
                            "name": "missed_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "missed votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "All the votes other than yea or nay -- when present or missing unknown",
                            "name": "other_votes",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "other votes"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Which issues this vote is tagged with",
                            "name": "issues",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Project" },
                            "verbose_name": "issues"
                        }
                    ]
                },
                "VoteCategory": {
                    "__is_enum": true,
                    "amendment": {
                        "key": "amendment",
                        "label": "Amendment",
                        "search_help_text": "Votes on accepting or rejecting amendments to bills and resolutions.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 1
                    },
                    "cloture": {
                        "key": "cloture",
                        "label": "Cloture",
                        "search_help_text": "Votes to end debate and move to a vote, i.e. to end a filibuster.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 4
                    },
                    "committee": {
                        "key": "committee",
                        "label": "Committee Vote",
                        "search_help_text": "In states, votes held within committees.",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 14
                    },
                    "conviction": {
                        "key": "conviction",
                        "label": "Impeachment Conviction",
                        "search_help_text": "Votes in the Senate to convict an office holder of impeachment.",
                        "supported_regions": [1, 10000],
                        "value": 11
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Legislation",
                            "values": [3, 5, 2, 10, 1]
                        },
                        {
                            "display": "list",
                            "title": "Procedure",
                            "values": [7, 4, 13, 11]
                        },
                        {
                            "display": "list",
                            "title": "Approvals",
                            "values": [16, 12, 6]
                        },
                        {
                            "display": "list",
                            "title": "States",
                            "values": [14, 15]
                        }
                    ],
                    "floor_vote": {
                        "key": "floor_vote",
                        "label": "Floor Vote",
                        "search_help_text": "In states, votes on the floor.",
                        "supported_regions": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 15
                    },
                    "impeachment": {
                        "key": "impeachment",
                        "label": "Impeachment Proposal",
                        "search_help_text": "Votes in the House to impeach an office holder.",
                        "supported_regions": [1, 10000],
                        "value": 13
                    },
                    "nomination": {
                        "key": "nomination",
                        "label": "Nomination",
                        "search_help_text": "Senate votes on presidential nominations.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 6
                    },
                    "other": {
                        "key": "other",
                        "label": "Other",
                        "search_help_text": "A variety of uncategorized votes.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 8
                    },
                    "passage": {
                        "key": "passage",
                        "label": "Passage",
                        "search_help_text": "Votes on passing or failing bills and resolutions and on agreeing to conference reports.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 3
                    },
                    "passage_part": {
                        "key": "passage_part",
                        "label": "Passage (Part)",
                        "search_help_text": "Votes on the passage of parts of legislation.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 5
                    },
                    "passage_suspension": {
                        "key": "passage_suspension",
                        "label": "Passage under Suspension",
                        "search_help_text": "Fast-tracked votes on the passage of bills requiring a 2/3rds majority.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 2
                    },
                    "procedural": {
                        "key": "procedural",
                        "label": "Procedural",
                        "search_help_text": "A variety of procedural votes such as quorum calls.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 7
                    },
                    "ratification": {
                        "key": "ratification",
                        "label": "Treaty Ratification",
                        "search_help_text": "Senate votes to ratify treaties.",
                        "supported_regions": [1, 10000],
                        "value": 12
                    },
                    "treaty": {
                        "key": "treaty",
                        "label": "Treaty",
                        "search_help_text": "A vote on a treaty.",
                        "supported_regions": [1, 10000],
                        "value": 16
                    },
                    "unknown": {
                        "key": "unknown",
                        "label": "Unknown Category",
                        "search_help_text": "A variety of uncategorized votes.",
                        "supported_regions": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000],
                        "value": 9
                    },
                    "veto_override": {
                        "key": "veto_override",
                        "label": "Veto Override",
                        "search_help_text": "Votes to override a presidential veto.",
                        "supported_regions": [1, 10000],
                        "value": 10
                    }
                },
                "VoteResult": {
                    "__is_model": true,
                    "__name__": "VoteResult",
                    "data_model": "app.vote.models.VoteResult",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/voteresult/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        {
                            "field_type": 7,
                            "help_text": "The person casting the vote",
                            "name": "person",
                            "related_model": { "__module__": "app.person.models", "__name__": "Person" },
                            "verbose_name": "person"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The role of the person at the time of casting the vote",
                            "name": "person_most_recent_role",
                            "related_model": { "__module__": "app.person.models", "__name__": "PersonRole" },
                            "verbose_name": "person most recent role"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.person.types", "__name__": "Party" },
                            "field_type": 4,
                            "help_text": "The most recent party of the person casting the vote, useful for calculating stats without a join",
                            "name": "person_most_recent_party",
                            "verbose_name": "person most recent party"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The vote where this VoteResult originated from",
                            "name": "vote",
                            "related_model": { "__module__": "app.vote.models", "__name__": "Vote" },
                            "verbose_name": "vote"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The bill where this VoteResult was casted on",
                            "name": "bill",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Bill" },
                            "verbose_name": "bill"
                        },
                        {
                            "field_type": 7,
                            "help_text": "The amendment where this VoteResult was casted on",
                            "name": "amendment",
                            "related_model": { "__module__": "app.bill.models", "__name__": "Amendment" },
                            "verbose_name": "amendment"
                        },
                        {
                            "_is_enum_field": true,
                            "choices": { "__module__": "app.vote.models", "__name__": "VoteResultType" },
                            "field_type": 4,
                            "help_text": "The result of the vote as an enum",
                            "name": "vote_result_type",
                            "verbose_name": "vote result type"
                        },
                        { "field_type": 2, "help_text": "The name of the voter in the event we can't match them to an existing Person object", "name": "voter_name", "verbose_name": "voter name" },
                        { "field_type": 5, "help_text": "The most recent date of a VoteResult update", "name": "last_quorum_update", "verbose_name": "last quorum update" }
                    ]
                },
                "VoteResultType": {
                    "__is_enum": true,
                    "missed": { "fa5_color": "VoteMissedColor", "fa5_icon": "arrows-alt-h", "full_phrase": "Was Absent", "icon": "fa-arrows-h", "icon_url": "img/icons_png/success/arrows-h.png", "key": "missed", "label": "Missed", "related_name": "missed_votes", "slug": "missed", "value": 4 },
                    "nay": { "fa5_color": "VoteFailedColor", "fa5_icon": "times", "full_phrase": "Voted Nay", "icon": "fa-times", "icon_url": "img/icons_png/success/times.png", "key": "nay", "label": "Nay", "related_name": "nay_votes", "slug": "nay", "value": 2 },
                    "present": { "fa5_color": "VotePresentColor", "fa5_icon": "arrows-alt-h", "full_phrase": "Was Present", "icon": "fa-arrows-h", "icon_url": "img/icons_png/success/arrows-h.png", "key": "present", "label": "Present", "related_name": "present_votes", "slug": "present", "value": 3 },
                    "unknown": { "fa5_color": "VoteUnknownColor", "fa5_icon": "arrows-alt-h", "full_phrase": "Other", "icon": "fa-arrows-h", "icon_url": "img/icons_png/success/arrows-h.png", "key": "unknown", "label": "Unknown", "related_name": "other_votes", "slug": "unknown", "value": 5 },
                    "yea": { "fa5_color": "VotePassedColor", "fa5_icon": "check", "full_phrase": "Voted Yea", "icon": "fa-check", "icon_url": "img/icons_png/success/check.png", "key": "yea", "label": "Yea", "related_name": "yea_votes", "slug": "yea", "value": 1 }
                },
                "VoterGroup": {
                    "__is_enum": true,
                    "chamber": { "key": "chamber", "label": "Chamber", "value": 3 },
                    "dems": { "key": "dems", "label": "Democrats", "value": 1 },
                    "reps": { "key": "reps", "label": "Republicans", "value": 2 }
                }
            }
        },
        "widgets": {
            "models": {
                "Dashboard": {
                    "__is_model": true,
                    "__name__": "Dashboard",
                    "data_model": "app.widgets.models.Dashboard",
                    "default_exclude_filters": {},
                    "default_filters": { "archived": false },
                    "endpoint": "/api/dashboard/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 16, "help_text": "", "name": "created", "sheet_column": true, "verbose_name": "Created" },
                        { "field_type": 16, "help_text": "", "name": "updated", "sheet_column": true, "verbose_name": "Updated" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 1, "help_text": "Used to permission objects to only the creator of the object", "name": "is_limited_to_creator", "verbose_name": "is limited to creator" },
                        { "field_type": 3, "help_text": "Dashboard's name", "name": "name", "verbose_name": "name" },
                        {
                            "field_type": 7,
                            "help_text": "The organization that this dashboard belongs to",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        {
                            "field_type": 7,
                            "help_text": "Creator of dashboard",
                            "name": "creator",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "QuorumUser" },
                            "verbose_name": "creator"
                        },
                        { "field_type": null, "help_text": "Configuration JSON blob where widgets are stored", "name": "widgets", "verbose_name": "widgets" },
                        { "field_type": null, "help_text": "used to keep track of the fields", "name": "widget_history", "verbose_name": "widget history" },
                        { "field_type": null, "help_text": "shape tbd. This is used to save the position of each widget in this dashboard", "name": "positions", "verbose_name": "positions" },
                        { "field_type": 1, "help_text": "whether a dashboard is being shared externally", "name": "is_external", "verbose_name": "is external" },
                        { "field_type": 1, "help_text": "whether downloads are enabled on the frontend for external dashboards", "name": "external_downloads_disabled", "verbose_name": "external downloads disabled" },
                        { "field_type": 3, "help_text": "an id to be used in /spreadsheet/external/[external_slug] to share dashboards", "name": "external_slug", "verbose_name": "external slug" },
                        { "field_type": 3, "help_text": "stores the hash of the password for an external dashboard, if it exists (otherwise this should be null)", "name": "external_password", "verbose_name": "external password" },
                        { "field_type": null, "help_text": "The regions assigned to external dashboard", "name": "external_regions", "verbose_name": "external regions" },
                        {
                            "field_type": 7,
                            "help_text": "Custom region used for external dashboard",
                            "name": "external_custom_region_selection",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "CustomRegionSelection" },
                            "verbose_name": "external custom region selection"
                        },
                        {
                            "field_type": 8,
                            "help_text": "Used to permission objects. If the User's Teams intersect with the teams associatedwith these teams, the User can see this object",
                            "name": "limited_to_teams",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Team" },
                            "verbose_name": "limited to teams"
                        }
                    ]
                },
                "DashboardTemplate": {
                    "__is_model": true,
                    "__name__": "DashboardTemplate",
                    "data_model": "app.widgets.models.DashboardTemplate",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/dashboardtemplate/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "Name of the template to be displayed", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "Description used on widget creation", "name": "description", "verbose_name": "description" },
                        { "field_type": 3, "help_text": "Icon used on template selection", "name": "icon", "verbose_name": "icon" },
                        { "field_type": null, "help_text": "definition of the widgets to be copied over into the dashboard to be", "name": "widgets", "verbose_name": "widgets" },
                        { "field_type": null, "help_text": "definition of the positions of the widgets to be copied over into the dashboard to be", "name": "positions", "verbose_name": "positions" },
                        { "field_type": null, "help_text": "The qps that apply to this template", "name": "permission_enums", "verbose_name": "permission enums" },
                        { "field_type": null, "help_text": "The user personas that utilizes this template", "name": "user_personas", "verbose_name": "user personas" },
                        { "field_type": 3, "help_text": "Slug used for internal categorization", "name": "slug", "verbose_name": "slug" },
                        { "field_type": 1, "help_text": "Whether this is a demo template that is available for superusers and demo accounts", "name": "not_demo_template", "verbose_name": "not demo template" }
                    ]
                },
                "WidgetTemplate": {
                    "__is_model": true,
                    "__name__": "WidgetTemplate",
                    "data_model": "app.widgets.models.WidgetTemplate",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/widgettemplate/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 1, "help_text": "", "name": "archived", "verbose_name": "archived" },
                        { "field_type": 3, "help_text": "Name of the template to be displayed", "name": "name", "verbose_name": "name" },
                        { "field_type": 3, "help_text": "Description used on widget creation", "name": "description", "verbose_name": "description" },
                        { "field_type": 3, "help_text": "Icon used on template selection", "name": "icon", "verbose_name": "icon" },
                        { "field_type": null, "help_text": "definition of the widget to be copied over into a dashboards", "name": "widget", "verbose_name": "widget" },
                        { "field_type": null, "help_text": "The qps that apply to this template", "name": "permission_enums", "verbose_name": "permission enums" }
                    ]
                }
            },
            "templates": {
                "DashboardTemplates": {
                    "__is_enum": true,
                    "blank": {
                        "icon": "plus",
                        "icon_family": "",
                        "icon_size": "2x",
                        "key": "blank",
                        "label": "Blank",
                        "positions": [],
                        "sort": 0,
                        "text": "Already know what you want to monitor and report on? Start with a blank dashboard and add your own widgets to create a truly customized report.",
                        "value": 1,
                        "widgets": {}
                    },
                    "eu_impact_dashboard": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "eu_impact_dashboard",
                        "label": "EU: Impact Dashboard",
                        "permission_enum": [2],
                        "positions": [
                            { "h": 4, "i": "CEc5", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 9, "i": "1r2T", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 13, "i": "t50Y", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 9, "i": "XP5s", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 17, "i": "fB7w", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 13 },
                            { "h": 9, "i": "N1Rj", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 3, "y": 30 },
                            { "h": 2, "i": "d7kZ", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 2, "i": "K9mN", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 2, "i": "MZjM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 2, "i": "ndKK", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 },
                            { "h": 9, "i": "oF2q", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 30 }
                        ],
                        "sort": 12,
                        "text": "Designed to help senior leaders establish goals based on insights from data collected over time.",
                        "value": 15,
                        "widgets": {
                            "1r2T": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of interactions by all team members in the past week.", "id": "1r2T", "labels": null, "text": "List of interactions in past week", "widget_type": 1 }
                            },
                            "4vH1": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "4vH1",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "CEc5": {
                                "meta": { "colors": null, "description": "Welcome to the European Union Impact Dashboard! This template will help you keep track of the work your team is doing on a day to day basis and help you draw insight from their engagement with key officials and legislation.", "id": "CEc5", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "K9mN": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "K9mN",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 6, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "MZjM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "MZjM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "N1Rj": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false,
                                                                "parent__isnull": true
                                                            }
                                                        ],
                                                        "searchifyCount": 88
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false,
                                                                "parent__isnull": false
                                                            }
                                                        ],
                                                        "searchifyCount": 56
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#4e30a1" },
                                    "description": "",
                                    "id": "N1Rj",
                                    "labels": ["Primary Issues Interactions", "Sub-Issues Interactions"],
                                    "text": "Interactions by Issue",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "X7Od": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "X7Od",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "XP5s": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "XP5s",
                                    "labels": ["Number of interactions in past 3 months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "aSdG": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "aSdG",
                                    "labels": null,
                                    "quicklink": { "text": "This Week's Committee Schedule", "type": 1, "url": "https://www.quorum.us/search/events/?date_range=5" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "d7kZ": {
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "d7kZ",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "quicklink": { "text": "Notes Logged", "type": 2, "url": null },
                                    "text": "Notes Logged",
                                    "widget_type": 4
                                }
                            },
                            "fB7w": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 11, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54" },
                                    "description": null,
                                    "id": "fB7w",
                                    "labels": ["Interactions"],
                                    "text": "Interactions taken in the past month by team",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "ndKK": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "ndKK",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "oF2q": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 8, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_public_organization_and_associated_individuals": {
                                                        "addedIds": [142818],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 8, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_public_organization_and_associated_individuals": {
                                                        "addedIds": [159077],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 8, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_public_organization_and_associated_individuals": {
                                                        "addedIds": [140095],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD", "1": "#503ABD", "2": "#503ABD" },
                                    "description": "",
                                    "id": "oF2q",
                                    "labels": ["European Parliament", "Council of the EU", "European Commission"],
                                    "text": "Interactions by EU Institution",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "pirJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                },
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#1fc155", "1": "#8f0c0a", "2": "#595e69" },
                                    "description": "",
                                    "id": "pirJ",
                                    "labels": ["Support", "Oppose", "Watching"],
                                    "text": "Legsilation We've Taken a Stance On",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "t50Y": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of legislative files your organization has marked as high priority.", "id": "t50Y", "labels": null, "text": "High priority Legislation", "widget_type": 1 }
                            }
                        }
                    },
                    "eu_operational_dashboard": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "eu_operational_dashboard",
                        "label": "EU: Operational Dashboard",
                        "permission_enum": [2],
                        "positions": [
                            { "h": 4, "i": "KIQ7", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 11, "i": "BwKY", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 22 },
                            { "h": 13, "i": "J01B", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 9, "i": "g5D1", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 13, "i": "fKFJ", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 33 },
                            { "h": 11, "i": "gGpA", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 22 },
                            { "h": 9, "i": "Pssi", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 13 },
                            { "h": 2, "i": "7mVI", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 2, "i": "IacM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 2, "i": "vuMU", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 9, "i": "13Oi", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 13 },
                            { "h": 15, "i": "ldbc", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 46 },
                            { "h": 2, "i": "oAAh", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 },
                            { "h": 9, "i": "CdpX", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 }
                        ],
                        "sort": 12,
                        "text": "Review updates, monitor KPIs, & identify trends for specific issues",
                        "value": 14,
                        "widgets": {
                            "13Oi": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                    "most_recent_party__in": [7],
                                                    "ph_minor_role_type": [37],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                    "most_recent_party__in": [8],
                                                    "ph_minor_role_type": [37],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#2f6bca", "1": "#d14747" },
                                    "description": "",
                                    "id": "13Oi",
                                    "labels": ["EPP Group", "S&D Group"],
                                    "text": "Number of MEPs by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "7mVI": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "7mVI",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "BwKY": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "BwKY", "labels": null, "text": "List of Officials assigned to me", "widget_type": 1 }
                            },
                            "CdpX": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 7,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "CdpX",
                                    "labels": ["Officials Interacted w/ Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "IacM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "IacM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "J01B": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [2458428],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "J01B", "labels": null, "text": "High Priority Legislation", "widget_type": 1 }
                            },
                            "KIQ7": {
                                "meta": { "colors": null, "description": "Welcome to this European Union Operational Dashboard! These widgets are here to help you stay on top of your important Officials, their activity, and for you to complete the tasks you need to do in Quorum.", "id": "KIQ7", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "Pssi": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "116th congress",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "wind power",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "hydropower",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#a88f4d", "2": "#7259ef" },
                                    "description": "",
                                    "id": "Pssi",
                                    "labels": ["116th Congress", "Wind Power", "Hydropower"],
                                    "text": "Issue Mentions on Social",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "W9oS": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "date_range": 7,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 67
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "W9oS",
                                    "labels": ["Interactions w/ assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "XJuS": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "XJuS", "labels": null, "text": "2021 Incoming Officials", "widget_type": 1 }
                            },
                            "ZZtd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1377
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "ZZtd",
                                    "labels": ["Data Selection 1"],
                                    "text": "Officials we have met with in past month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "fKFJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 1378
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 201
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "date_range": 6,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 17
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 5
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4569c4", "1": "#deb84f" },
                                    "description": null,
                                    "id": "fKFJ",
                                    "labels": ["Officials we've met with by issue total", "Officials we've met with in past month"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "g5D1": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "g5D1",
                                    "labels": ["Total Interactions Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "gGpA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "in_issue_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["parent_name", "alignment_type_icon"]
                                                            }
                                                        ],
                                                        "searchifyCount": 155
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "gGpA", "labels": null, "text": "Documents Tagged to Issue", "widget_type": 1 }
                            },
                            "ldbc": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [3635342],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8477],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "ldbc",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "text": "Notes Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "oAAh": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "oAAh",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "vuMU": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "vuMU",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "ydNg": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#db3333", "1": "#3537d0", "2": "#3568e9" },
                                    "description": "This chart will automatically update as election results are confirmed.",
                                    "id": "ydNg",
                                    "labels": ["Democrat", "Independent", "Republican"],
                                    "text": "2021 Incoming Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            }
                        }
                    },
                    "federal_impact": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "federal_impact",
                        "label": "Federal: Impact Dashboard",
                        "permission_enum": [1],
                        "positions": [
                            { "h": 4, "i": "CEc5", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 9, "i": "1r2T", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 13, "i": "t50Y", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 9, "i": "XP5s", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 17, "i": "fB7w", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 23 },
                            { "h": 10, "i": "N1Rj", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 13 },
                            { "h": 10, "i": "pirJ", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 13 },
                            { "h": 2, "i": "d7kZ", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 2, "i": "K9mN", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 2, "i": "MZjM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 2, "i": "ndKK", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 }
                        ],
                        "sort": 6,
                        "text": "Designed to help leaders determine strategy and communicate the impact of the federal team.",
                        "value": 7,
                        "widgets": {
                            "1r2T": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of interactions by all team members in the past week.", "id": "1r2T", "labels": null, "text": "List of interactions in past week", "widget_type": 1 }
                            },
                            "4vH1": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "4vH1",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "CEc5": {
                                "meta": { "colors": null, "description": "<div>This customizable template is designed to give leaders a high-level overview of everything your team is doing and communicate the impact of your efforts.&nbsp; To make the most of this template:<br></div><div><br></div><ol><li>Edit widgets to make them specific to your goals and priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first</li><li>Download or share this Dashboard for presentation-ready reports<br></li></ol>", "id": "CEc5", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "K9mN": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "K9mN",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 6, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "MZjM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "MZjM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "N1Rj": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false,
                                                                "parent__isnull": true
                                                            }
                                                        ],
                                                        "searchifyCount": 88
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false,
                                                                "parent__isnull": false
                                                            }
                                                        ],
                                                        "searchifyCount": 56
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#4e30a1" },
                                    "description": "",
                                    "id": "N1Rj",
                                    "labels": ["Primary Issues Interactions", "Sub-Issues Interactions"],
                                    "text": "Interactions by Issue",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "X7Od": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "X7Od",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "XP5s": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "XP5s",
                                    "labels": ["Number of interactions in past 3 months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "aSdG": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "aSdG",
                                    "labels": null,
                                    "quicklink": { "text": "This Week's Committee Schedule", "type": 1, "url": "https://www.quorum.us/search/events/?date_range=5" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "d7kZ": {
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "d7kZ",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "quicklink": { "text": "Notes Logged", "type": 2, "url": null },
                                    "text": "Notes Logged",
                                    "widget_type": 4
                                }
                            },
                            "fB7w": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 11, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54" },
                                    "description": null,
                                    "id": "fB7w",
                                    "labels": ["Interactions"],
                                    "text": "Interactions taken in the past month by team",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "ndKK": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "ndKK",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "pirJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                },
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#1fc155", "1": "#8f0c0a", "2": "#595e69" },
                                    "description": "",
                                    "id": "pirJ",
                                    "labels": ["Support", "Oppose", "Watching"],
                                    "text": "Bills We've Taken a Stance On",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "t50Y": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of bills your organization has marked as high priority.", "id": "t50Y", "labels": null, "text": "High priority bills", "widget_type": 1 }
                            }
                        }
                    },
                    "federal_operational": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "federal_operational",
                        "label": "Federal: Operational Template",
                        "permission_enum": [1],
                        "positions": [
                            { "h": 4, "i": "KIQ7", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 11, "i": "BwKY", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 22 },
                            { "h": 13, "i": "J01B", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 9, "i": "g5D1", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 13, "i": "fKFJ", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 33 },
                            { "h": 11, "i": "gGpA", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 22 },
                            { "h": 11, "i": "ydNg", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 22 },
                            { "h": 9, "i": "Pssi", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 13 },
                            { "h": 2, "i": "7mVI", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 2, "i": "IacM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 2, "i": "vuMU", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 9, "i": "13Oi", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 13 },
                            { "h": 15, "i": "ldbc", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 46 },
                            { "h": 2, "i": "oAAh", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 },
                            { "h": 9, "i": "CdpX", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 }
                        ],
                        "sort": 3,
                        "text": "Our most popular reporting widgets for monitoring day to day developments, trends, and tasks at the federal level.",
                        "value": 4,
                        "widgets": {
                            "13Oi": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0048ff", "1": "#ff0000", "2": "#fbff00" },
                                    "description": "",
                                    "id": "13Oi",
                                    "labels": ["Democrat", "Republican", "Independent"],
                                    "text": "Number of Federal Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "7mVI": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "7mVI",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "BwKY": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "BwKY", "labels": null, "text": "List of Officials assigned to me", "widget_type": 1 }
                            },
                            "CdpX": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 7,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "CdpX",
                                    "labels": ["Officials Interacted w/ Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "IacM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "IacM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "J01B": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "J01B", "labels": null, "text": "High Priority Bills", "widget_type": 1 }
                            },
                            "KIQ7": {
                                "meta": { "colors": null, "description": "<div>This customizable template is made up of best practice widgets to help you manage your day to day legislative activity like bill tracking, legislator activity, and keeping up with outstanding tasks in Quorum. To make the most of this template:<br></div><div><br></div><ol><li>Update or edit widgets to make them specific to your priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first<br></li></ol>", "id": "KIQ7", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "Pssi": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "116th congress",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "wind power",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "hydropower",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#a88f4d", "2": "#7259ef" },
                                    "description": "",
                                    "id": "Pssi",
                                    "labels": ["116th Congress", "Wind Power", "Hydropower"],
                                    "text": "Issue Mentions on Social",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "W9oS": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "date_range": 7,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 67
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "W9oS",
                                    "labels": ["Interactions w/ assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "XJuS": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "XJuS", "labels": null, "text": "2021 Incoming Officials", "widget_type": 1 }
                            },
                            "ZZtd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1377
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "ZZtd",
                                    "labels": ["Data Selection 1"],
                                    "text": "Officials we have met with in past month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "fKFJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 1378
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 201
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "date_range": 6,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 17
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 5
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4569c4", "1": "#deb84f" },
                                    "description": null,
                                    "id": "fKFJ",
                                    "labels": ["Officials we've met with by issue total", "Officials we've met with in past month"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "g5D1": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "g5D1",
                                    "labels": ["Total Interactions Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "gGpA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "gGpA", "labels": null, "text": "Legislation in Committee", "widget_type": 1 }
                            },
                            "ldbc": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [3635342],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8477],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "ldbc",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "text": "Notes Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "oAAh": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "oAAh",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "vuMU": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "vuMU",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "ydNg": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#db3333", "1": "#3537d0", "2": "#3568e9" },
                                    "description": "This chart will automatically update as election results are confirmed.",
                                    "id": "ydNg",
                                    "labels": ["Democrat", "Independent", "Republican"],
                                    "text": "2021 Incoming Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            }
                        }
                    },
                    "federal_operational_dashboard_2": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "federal_operational_dashboard_2",
                        "label": "Federal: Operational Dashboard #2",
                        "permission_enum": [1],
                        "positions": [
                            { "h": 4, "i": "XCEt", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 9, "i": "xnPV", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 5 },
                            { "h": 14, "i": "FAtl", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 25 },
                            { "h": 12, "i": "e9V5", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 10, "i": "sA1g", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 15 },
                            { "h": 2, "i": "OXNb", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 0, "y": 4 },
                            { "h": 2, "i": "LaiS", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 12 },
                            { "h": 2, "i": "htGl", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 12 },
                            { "h": 2, "i": "hho9", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 1, "y": 4 },
                            { "h": 9, "i": "uZsX", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 6 },
                            { "h": 9, "i": "dSus", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 39 },
                            { "h": 14, "i": "LGNe", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 39 },
                            { "h": 14, "i": "EpOs", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 25 },
                            { "h": 13, "i": "YJfV", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 61 },
                            { "h": 5, "i": "O6ZX", "minH": 5, "moved": false, "static": false, "w": 1, "x": 4, "y": 0 },
                            { "h": 13, "i": "LJK7", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 48 },
                            { "h": 5, "i": "6gz9", "minH": 5, "moved": false, "static": false, "w": 1, "x": 5, "y": 0 },
                            { "h": 11, "i": "OPRT", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 14 },
                            { "h": 11, "i": "ZHWd", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 53 },
                            { "h": 11, "i": "dSe1", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 53 },
                            { "h": 10, "i": "bnzh", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 64 }
                        ],
                        "sort": 11,
                        "text": "Designed to give a Federal policy manager quick insight into their issues, legislation, upcoming hearings, and stakeholder engagement strategy.",
                        "value": 12,
                        "widgets": {
                            "1um4": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [3]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#535383", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "1um4",
                                    "labels": ["High priority bills", "Medium priority bills", "Low priority"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "6gz9": {
                                "colors": { "0": "#5239ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "6gz9",
                                    "labels": ["Key Officials Met With (Last 3 Months)"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "EpOs": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "about_bill": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 577
                                                    },
                                                    "date__isnull": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Month", "id": "EpOs", "labels": null, "text": "Social Media Mentions of Tracked Bills", "widget_type": 1 }
                            },
                            "FAtl": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef" },
                                    "description": "",
                                    "id": "FAtl",
                                    "labels": ["Supported Bills", "Opposed Bills"],
                                    "text": "Bills by Issue",
                                    "vis_options": { "bar_visualization_display_style": 2, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "LGNe": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 5, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_user": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "LGNe",
                                    "labels": ["My Meetings"],
                                    "text": "My Meetings (Last Three Months)",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "LJK7": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "in_issue_or": {
                                                        "addedIds": [14018],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "LJK7", "labels": null, "text": "[ISSUE] bills", "widget_type": 1 }
                            },
                            "LaiS": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "LaiS",
                                    "labels": null,
                                    "quicklink": { "text": "[ISSUE] Bill Sheet", "type": 1, "url": "https://www.quorum.us/sheet/41398/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "NySj": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 1, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": []
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "NySj",
                                    "labels": ["Data Selection 1"],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "O6ZX": {
                                "colors": { "0": "#5239ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "O6ZX",
                                    "labels": ["Interactions (Last Month)"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "OPRT": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 8,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_user": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 8,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#5239ef", "1": "#503ABD" },
                                    "description": "",
                                    "id": "OPRT",
                                    "labels": ["My Meetings", "All Meetings"],
                                    "text": "Meetings",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "OXNb": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "OXNb",
                                    "labels": null,
                                    "quicklink": { "text": "Key Legislation", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "XCEt": {
                                "meta": { "colors": null, "description": "<div>Welcome! This template will give you quick insight what your team is doing and key legislative priorities.\u00a0</div><div><br></div><div><b>Action Items for You:</b></div><ul><li>All references to \u201cKey Officials\u201d or \u201cKey Staffers\u201d use the assignment filter and are set to filter for all officials or staffers assigned to you. \u00a0 that have an assignment. Make sure to use the assignment filter, or update the widget filters to point at your key officials using another filter type.</li><li>Update the \u201c@mentions of Me\u201d widget to filter for mentions referencing you.</li><li>Add hyperlinks to the button widgets to connect them to your key legislation, key stakeholders, and issue-specific bill sheets. </li><li>Click into the issue-specific widgets and make sure to select a group of bills tagged to your priority issue.</li><li>Edit the COVID dialogue widget to track your priority issue area.</li><li>Delete this text box once you're done!</li></ul>", "id": "XCEt", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "YJfV": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [1],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [2],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [3],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [4, 5],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#d5dcef", "3": "#4e30a1", "4": "#a88f4d" },
                                    "description": "",
                                    "id": "YJfV",
                                    "labels": ["Introduced", "Out of Committee", "Passed First Chamber", "Passed Second Chamber", "Enacted"],
                                    "text": "Supported Bills by Status",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "ZHWd": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 8,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "current": true,
                                                    "dehydrate_extra": ["committee", "location", "most_recent_role", "person"],
                                                    "hygiene_staffer_types": true,
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "ZHWd", "labels": null, "text": "Key Staffers", "widget_type": 1 }
                            },
                            "ZxkM": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 15, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "ZxkM",
                                    "labels": ["Data Selection 1"],
                                    "text": "High Priority bills by state",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "aib0": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "aib0",
                                    "labels": ["Supported Bills Enacted"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "bnzh": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "covid",
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "bnzh", "labels": null, "text": "Mentions of COVID", "widget_type": 1 }
                            },
                            "dSe1": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "dSe1", "labels": null, "text": "Key Officials", "widget_type": 1 }
                            },
                            "dSus": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 28,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "about_bill": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 112
                                                    },
                                                    "archived": false,
                                                    "date_range": 2,
                                                    "dehydrate_extra": ["committee"],
                                                    "event_type__in": [4, 1],
                                                    "excluding_custom_events": true,
                                                    "full_events": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "dSus", "labels": null, "text": "Upcoming Hearings on Tracked Bills", "widget_type": 1 }
                            },
                            "dn7y": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 253
                                                    },
                                                    "status_date_range": [8]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "introduced_date_range": 8,
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 281
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#ff0000", "1": "#503ABD" },
                                    "description": "",
                                    "id": "dn7y",
                                    "labels": ["Republican sponsored bills last year", "Democrat sponsored bills last year"],
                                    "text": "Party Bills Sponsored in Last Year",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "e9V5": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "assigned_to_me": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "is_assigned": true,
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 27
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "e9V5", "labels": null, "text": "Dialogue by Key Legislators", "widget_type": 1 }
                            },
                            "hho9": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "hho9",
                                    "labels": null,
                                    "quicklink": { "text": "Key Stakeholders", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "htGl": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "htGl",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "sA1g": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1105
                                                    },
                                                    "involving_user": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1349
                                                    },
                                                    "involving_user": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0000ff", "1": "#ff0000" },
                                    "description": "",
                                    "id": "sA1g",
                                    "labels": ["Meetings with Dems", "Meetings with GOP"],
                                    "text": "My Meetings by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "uZsX": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "mentions_user_or": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "uZsX", "labels": null, "text": "@mentions of Me", "widget_type": 1 }
                            },
                            "xnPV": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_session": true,
                                                    "for_years": [2020],
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "xnPV", "labels": null, "text": "High Priority Bills", "widget_type": 1 }
                            }
                        }
                    },
                    "gr_operational": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "gr_operational",
                        "label": "Grassroots: Operational Dashboard",
                        "permission_enum": [201],
                        "positions": [
                            { "h": 5, "i": "1SkX", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 5, "i": "h1as", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 9 },
                            { "h": 5, "i": "pu6G", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 9 },
                            { "h": 2, "i": "mt4V", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 4, "i": "z1hj", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 5, "i": "cUgB", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 2, "i": "SOiP", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 2 },
                            { "h": 9, "i": "BorX", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 14 },
                            { "h": 15, "i": "wXz7", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 23 },
                            { "h": 9, "i": "uZK3", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 14 },
                            { "h": 14, "i": "bZXl", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 15, "i": "w3Pj", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 23 }
                        ],
                        "sort": 1,
                        "text": "Get started with our most popular widgets for monitoring day to day grassroots activity like actions taken, most active advocates, and more.",
                        "value": 2,
                        "widgets": {
                            "1SkX": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "1SkX",
                                    "labels": ["Contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "6Htd": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "6Htd",
                                    "labels": null,
                                    "quicklink": { "text": "Quorum Marketing Site", "type": 1, "url": "https://www.quorum.us/about/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "BorX": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["campaign"]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["campaign"],
                                                    "interaction_type__in": [25]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#a88f4d" },
                                    "description": null,
                                    "id": "BorX",
                                    "labels": ["All Advocate Actions", "Wrote a Letter"],
                                    "text": "Advocate Action on Campaigns",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "GNOZ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 2, "frequency_tuple_field": null, "interval": 1 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "campaign_confirmed": true,
                                                    "dehydrate_extra": ["campaign"]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "GNOZ",
                                    "labels": [],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "P4aM": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "grassroots_supporter": true }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "P4aM",
                                    "labels": ["Grassroots Supporters"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "SOiP": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "SOiP",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 7, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "bZXl": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "interacted_date_range": 6 }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "We have reached out and interacted with these supporters in the last month.", "id": "bZXl", "labels": null, "text": "Supporters Interacted With Recently", "widget_type": 1 }
                            },
                            "cUgB": {
                                "colors": { "0": "#221f54" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4, 1, 2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "cUgB",
                                    "labels": ["Bills w/ a Stance"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "h1as": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "action_center_source": {
                                                        "addedIds": [476],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "archived": false
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "h1as",
                                    "labels": ["New Contacts from AC"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "mt4V": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "mt4V",
                                    "labels": null,
                                    "quicklink": { "text": "Quicklink to Action Center", "type": 1, "url": null },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "pu6G": {
                                "colors": { "0": "#535383" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3142
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "pu6G",
                                    "labels": ["Outbox Open Rates"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "uZK3": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["campaign"],
                                                    "interaction_type__in": [25]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["campaign"],
                                                    "interaction_type__in": [28]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 69,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["campaign"],
                                                    "interaction_type__in": [30, 29, 26, 34, 85, 44, 45, 46, 48]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": null,
                                    "id": "uZK3",
                                    "labels": ["Wrote a Letter", "Custom Call to Action", "Other"],
                                    "text": "Grassroots Action Types",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "w3Pj": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 30, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4e30a1" },
                                    "description": null,
                                    "id": "w3Pj",
                                    "labels": ["Contacts"],
                                    "text": "Contact Acquisition Method",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "wXz7": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 2 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#a88f4d" },
                                    "description": null,
                                    "id": "wXz7",
                                    "labels": ["New Contacts"],
                                    "text": "Contact Acquisition Over Time",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "z1hj": {
                                "meta": { "colors": null, "description": "<div>This customizable template is made up of best practice widgets to help you manage your day to day grassroots activity - including advocates, trends, and calculating ROI. To make the most of this template: <br></div><div><br></div><ol><li>Edit widgets to make them more specific for you<br></li><li>Delete any widgets you don't need<br></li><li>Add new widgets as needed <br></li><li>Rearrange the widgets to show your most important information first<br></li></ol>", "id": "z1hj", "labels": null, "text": null, "widget_type": 3 }
                            }
                        }
                    },
                    "international_impact_dashboard": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "international_impact_dashboard",
                        "label": "International: Impact Dashboard",
                        "permission_enum": [103],
                        "positions": [
                            { "h": 5, "i": "KIQ7", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 12, "i": "BwKY", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 16 },
                            { "h": 12, "i": "J01B", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 2 },
                            { "h": 5, "i": "g5D1", "minH": 5, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 15, "i": "gGpA", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 23 },
                            { "h": 9, "i": "Pssi", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 14 },
                            { "h": 2, "i": "oAAh", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 4, "y": 0 },
                            { "h": 2, "i": "DtOF", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 5, "y": 0 },
                            { "h": 9, "i": "ULg3", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 5 },
                            { "h": 2, "i": "O0pP", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 0, "y": 14 },
                            { "h": 15, "i": "yMyI", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 23 },
                            { "h": 2, "i": "Blau", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 1, "y": 14 },
                            { "h": 5, "i": "0C6m", "minH": 5, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 10, "i": "CS2h", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 28 }
                        ],
                        "sort": 12,
                        "text": "Designed to give an international policy decision-maker quick insight into key dialogue on their issues and their team's stakeholder engagement.",
                        "value": 13,
                        "widgets": {
                            "0C6m": {
                                "colors": { "0": "#7239ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "involving_member": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                                "is_assigned": true,
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 4
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "0C6m",
                                    "labels": ["Interactions w/ Key Officials (3 months)"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "Blau": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "Blau",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "BwKY": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                    "is_assigned": true,
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "BwKY", "labels": null, "text": "Key Officials", "widget_type": 1 }
                            },
                            "CS2h": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                    "interacted_date_range": 7,
                                                    "is_assigned": true,
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                    "is_assigned": true,
                                                    "not_interacted_date_range": 7,
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7239ef", "1": "#221f54" },
                                    "description": "",
                                    "id": "CS2h",
                                    "labels": ["Key Officials Met With", "Key Officials Not Met With"],
                                    "text": "Interactions with Key Officials (Last 3 Months)",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "DtOF": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "DtOF",
                                    "labels": null,
                                    "quicklink": { "text": "Stakeholder Engagement", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "J01B": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "is_assigned": true,
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 4
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Month", "id": "J01B", "labels": null, "text": "Dialogue by Key Officials", "widget_type": 1 }
                            },
                            "KIQ7": {
                                "meta": { "colors": null, "description": "<div>Welcome! These widgets are here to help you stay on top of important stakeholders, significant dialogue, and your activity.\u00a0</div><div><br></div><div><b>Action Items for You:\u00a0</b></div><div><ul><li>All references to key officials use the assignment filter and are set to filter for all officials that have an assignment. Ensure that your team is using the assignment filter, or update the widget filters to point at your key officials.\u00a0</li><li>Add hyperlinks to the button widgets to connect them to your stakeholder engagement sheets.</li><li>Update the selections in the \u201cInteractions by Type\u201d widget so that you are distinguishing between the interaction types most important to you. \u00a0</li><li>Update the \u201cLeadership Mentions of COVID\u201d to filter for the dialogue most important to you. You can update the keyword and the source selection.\u00a0</li><li>Delete this text box once you're done!\u00a0</li></ul></div>", "id": "KIQ7", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "O0pP": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "O0pP",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "Pssi": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 12, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 12, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [9253],
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 12, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8484, 8479, 8477],
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 12, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8473, 1100],
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 12, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8954, 8955, 8956, 1347, 8655, 8492, 8491, 8490, 8489, 8488, 8487, 8486, 8485, 8474, 8475, 8480, 8478, 8654, 8482, 8481, 8483, 8476, 8472, 8493, 10010, 9267],
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#4e30a1", "2": "#d5ecef", "3": "#a88f4d", "4": "#7239ef" },
                                    "description": "",
                                    "id": "Pssi",
                                    "labels": ["Meetings", "Zoom Call", "Email Exchange", "Call", "Other Interactions"],
                                    "text": "Interactions by Type",
                                    "vis_options": { "bar_visualization_display_style": 2, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "ULg3": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 8,
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "involving_member": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role", "most_recent_country"],
                                                                "is_assigned": true,
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 4
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef" },
                                    "description": "Last Year",
                                    "id": "ULg3",
                                    "labels": ["All Interactions", "Interactions with Key Officials"],
                                    "text": "Team Interactions ",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "W9oS": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "date_range": 7,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 67
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "W9oS",
                                    "labels": ["Interactions w/ assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "XJuS": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "XJuS", "labels": null, "text": "2021 Incoming Officials", "widget_type": 1 }
                            },
                            "ZZtd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1377
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "ZZtd",
                                    "labels": ["Data Selection 1"],
                                    "text": "Officials we have met with in past month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "g5D1": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "g5D1",
                                    "labels": ["All Interactions (Last 3 months)"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "gGpA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "covid",
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "ph_major_role_type": [54, 1, 2],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 129
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "gGpA", "labels": null, "text": "Leadership Mentions of COVID", "widget_type": 1 }
                            },
                            "oAAh": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "oAAh",
                                    "labels": null,
                                    "quicklink": { "text": "Key Stakeholders", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "yMyI": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["bills", "issues"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Month", "id": "yMyI", "labels": null, "text": "Recent Interactions", "widget_type": 1 }
                            }
                        }
                    },
                    "operational_dashboard": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "operational_dashboard",
                        "label": "Local: Operational Dashboard",
                        "permission_enum": [101],
                        "positions": [
                            { "h": 5, "i": "KIQ7", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 10, "i": "BwKY", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 23 },
                            { "h": 11, "i": "J01B", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 7 },
                            { "h": 2, "i": "IacM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 21 },
                            { "h": 2, "i": "vuMU", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 0, "y": 5 },
                            { "h": 15, "i": "Ef6v", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 33 },
                            { "h": 10, "i": "tgX2", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 11, "i": "8HmV", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 11, "i": "ZqQn", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 10 },
                            { "h": 10, "i": "H1s2", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 11 },
                            { "h": 15, "i": "d48i", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 33 },
                            { "h": 2, "i": "shvY", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 1, "y": 5 },
                            { "h": 2, "i": "3PE7", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 21 },
                            { "h": 10, "i": "SxKb", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 23 },
                            { "h": 12, "i": "ehZ2", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 21 },
                            { "h": 5, "i": "S5OA", "minH": 5, "moved": false, "static": false, "w": 1, "x": 1, "y": 18 },
                            { "h": 5, "i": "GiBW", "minH": 5, "moved": false, "static": false, "w": 1, "x": 0, "y": 18 }
                        ],
                        "sort": 10,
                        "text": "Designed to give a local policy manager quick insight into their issues, upcoming meetings, and stakeholder engagement strategy.",
                        "value": 11,
                        "widgets": {
                            "13Oi": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0048ff", "1": "#ff0000", "2": "#fbff00" },
                                    "description": "",
                                    "id": "13Oi",
                                    "labels": ["Democrat", "Republican", "Independent"],
                                    "text": "Number of Federal Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "3PE7": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "3PE7",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "7mVI": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "7mVI",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "8HmV": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "mentions_user_or": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "8HmV", "labels": null, "text": "@mentions of Me", "widget_type": 1 }
                            },
                            "BwKY": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "is_assigned": true,
                                                    "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "BwKY", "labels": null, "text": "Key Legislators", "widget_type": 1 }
                            },
                            "CdpX": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 7,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "CdpX",
                                    "labels": ["Officials Interacted w/ Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "Ef6v": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "is_assigned": true,
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 273
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "Ef6v", "labels": null, "text": "Dialogue by Key Legislators", "widget_type": 1 }
                            },
                            "GiBW": {
                                "colors": { "0": "#7239ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3235
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "GiBW",
                                    "labels": ["# of Officials who've Opened Emails"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "H1s2": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 28,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 2,
                                                    "dehydrate_extra": ["committee"],
                                                    "event_type__in": [31, 32],
                                                    "excluding_custom_events": true,
                                                    "full_events": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "H1s2", "labels": null, "text": "Upcoming City and County Meetings", "widget_type": 1 }
                            },
                            "IacM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "IacM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "J01B": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "covid",
                                                    "date__isnull": false,
                                                    "date_range": 2,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [1014, 1018]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Upcoming Meetings", "id": "J01B", "labels": null, "text": "Local Agendas Mentioning COVID", "widget_type": 1 }
                            },
                            "KIQ7": {
                                "meta": { "colors": null, "description": "<div>Welcome! These widgets are here to help you stay on top of important stakeholders, significant dialogue, and your activity.\u00a0</div><div><br></div><div><div><b>Action Items for You:</b></div><ul><li>Add hyperlinks to the button widgets to connect them to your key issue and stakeholder sheets.</li><li>Update the \u201c@mentions of Me\u201d widget to filter for mentions referencing you.\u00a0</li><li>Update the search term (currently COVID) in the local agendas and local meeting minute widgets to your primary issue area.\u00a0</li><li>All references to key officials use the assignment filter and are set to filter for all officials that have an assignment. Update those widgets so that they are narrowed to only show officials assigned to you.\u00a0</li><li>Delete this text box once you're done!</li></ul></div>", "id": "KIQ7", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "Pssi": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "116th congress",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "wind power",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "hydropower",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#a88f4d", "2": "#7259ef" },
                                    "description": "",
                                    "id": "Pssi",
                                    "labels": ["116th Congress", "Wind Power", "Hydropower"],
                                    "text": "Issue Mentions on Social",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "S5OA": {
                                "colors": { "0": "#7239ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "received_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 0
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "S5OA",
                                    "labels": ["# of Officials Emailed"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "SxKb": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [9, 6, 3, 8, 1, 7],
                                                                "ph_minor_role_type": [198],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 4721
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "SxKb", "labels": null, "text": "Recent Dialogue by Mayors", "widget_type": 1 }
                            },
                            "W9oS": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "date_range": 7,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 67
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "W9oS",
                                    "labels": ["Interactions w/ assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "XJuS": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "XJuS", "labels": null, "text": "2021 Incoming Officials", "widget_type": 1 }
                            },
                            "ZZtd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1377
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "ZZtd",
                                    "labels": ["Data Selection 1"],
                                    "text": "Officials we have met with in past month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "ZqQn": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_creator": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD", "1": "#7259ef" },
                                    "description": "Last Three Months",
                                    "id": "ZqQn",
                                    "labels": ["All Meetings", "Meetings logged by me"],
                                    "text": "Interactions Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "d48i": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 8,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_user": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 8,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#503ABD" },
                                    "description": "Last Year",
                                    "id": "d48i",
                                    "labels": ["My Meetings", "All Meetings"],
                                    "text": "Meetings by Issue",
                                    "vis_options": { "bar_visualization_display_style": 2, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "ehZ2": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 7737
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_member": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 8315
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0000ff", "1": "#ff0000" },
                                    "description": "All Time",
                                    "id": "ehZ2",
                                    "labels": ["Dems", "GOP"],
                                    "text": "Meetings by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "fKFJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 1378
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 201
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "date_range": 6,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 17
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 5
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4569c4", "1": "#deb84f" },
                                    "description": null,
                                    "id": "fKFJ",
                                    "labels": ["Officials we've met with by issue total", "Officials we've met with in past month"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "gGpA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "gGpA", "labels": null, "text": "Legislation in Committee", "widget_type": 1 }
                            },
                            "ldbc": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [3635342],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8477],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "ldbc",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "text": "Notes Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "oAAh": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "oAAh",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "shvY": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "shvY",
                                    "labels": null,
                                    "quicklink": { "text": "Key Issues", "type": 1, "url": "https://www.quorum.us/sheets" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "tgX2": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "covid",
                                                    "date__isnull": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [1015, 1019]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Month", "id": "tgX2", "labels": null, "text": "Local Meeting Minutes Mentioning COVID", "widget_type": 1 }
                            },
                            "uBqT": {
                                "meta": { "colors": null, "description": "testing whether or not this will save", "id": "uBqT", "labels": null, "text": "New Text Widget Name", "widget_type": 3 }
                            },
                            "vuMU": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "vuMU",
                                    "labels": null,
                                    "quicklink": { "text": "Key Stakeholders", "type": 1, "url": "https://www.quorum.us/sheets" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "ydNg": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#db3333", "1": "#3537d0", "2": "#3568e9" },
                                    "description": "This chart will automatically update as election results are confirmed.",
                                    "id": "ydNg",
                                    "labels": ["Democrat", "Independent", "Republican"],
                                    "text": "2021 Incoming Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            }
                        }
                    },
                    "stakeholder_impact": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "stakeholder_impact",
                        "label": "Stakeholder: Impact Dashboard",
                        "permission_enum": [3],
                        "positions": [
                            { "h": 4, "i": "56nI", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 8, "i": "VFgP", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 8, "i": "iqDk", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 19, "i": "9YTt", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 24 },
                            { "h": 2, "i": "4445", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 12, "i": "NFkf", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 12 },
                            { "h": 12, "i": "bVyL", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 12 },
                            { "h": 2, "i": "ONZo", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 },
                            { "h": 2, "i": "FjbA", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 12, "i": "qxka", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 }
                        ],
                        "sort": 7,
                        "text": "Designed to help leaders determine strategy and communicate the impact of their stakeholder engagement.",
                        "value": 8,
                        "widgets": {
                            "4445": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "4445",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL Here!", "type": 1, "url": null },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "56nI": {
                                "meta": { "colors": null, "description": "<div>This customizable template is designed to give leaders a high-level overview of everything your team is doing and communicate the impact of your efforts.&nbsp; To make the most of this template:<br></div><div><br></div><ol><li>Edit widgets to make them specific to your goals and priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first</li><li>Download or share this Dashboard for presentation-ready reports<br></li></ol>", "id": "56nI", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "9YTt": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false
                                                            }
                                                        ],
                                                        "searchifyCount": 143
                                                    },
                                                    "involving_creator": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "default_for_user": true, "is_active": true, "users_on_teams": true }
                                                        ],
                                                        "searchifyCount": 102
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "for_project_and_subprojects": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "can_be_tagged_to_interactions": true,
                                                                "dehydrate_extra": ["parent_name"],
                                                                "is_limited_to_creator": false
                                                            }
                                                        ],
                                                        "searchifyCount": 143
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#4e30a1" },
                                    "description": null,
                                    "id": "9YTt",
                                    "labels": ["Meetings by issue in the past month", "Meetings by issue overall"],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "FjbA": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "FjbA",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "NFkf": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "date_range": 8 }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#535383", "1": "#a88f4d" },
                                    "description": "",
                                    "id": "NFkf",
                                    "labels": ["Contacts Added", "Contacts Updated"],
                                    "text": "Our Total Stakeholders Over Time",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "ONZo": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "ONZo",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "VFgP": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "is_assigned": true }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "is_assigned": false }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "VFgP",
                                    "labels": ["Percentage of assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "YzAA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "YzAA",
                                    "labels": ["Notes"],
                                    "text": "Notes Logged Over Time",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "bVyL": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [3],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [1],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#4e30a1", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "bVyL",
                                    "labels": ["Interactions", "Relationships", "Comments"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "iqDk": {
                                "colors": { "0": "#aa3909", "100": "#4ad36a", "49": "#eee84f" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "iqDk",
                                    "labels": ["Interactions in Past Month"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "qxka": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "interacted_date_range": 5 }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Contacts we've interacted with in the last week", "id": "qxka", "labels": null, "text": "Recent Interactions", "widget_type": 1 }
                            },
                            "wTxZ": {
                                "colors": { "0": "#5474c4" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3148
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "received_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3148
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "wTxZ",
                                    "labels": ["Percentage of opened emails - contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            }
                        }
                    },
                    "stakeholder_operational": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "stakeholder_operational",
                        "label": "Stakeholder: Operational Dashboard",
                        "permission_enum": [3],
                        "positions": [
                            { "h": 4, "i": "Uzh8", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 11, "i": "5iJo", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 11 },
                            { "h": 11, "i": "Wdc8", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 11 },
                            { "h": 7, "i": "XIhL", "minH": 5, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 15, "i": "60gj", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 22 },
                            { "h": 2, "i": "PBah", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 11, "i": "nJea", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 11 },
                            { "h": 9, "i": "8oqa", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 37 },
                            { "h": 9, "i": "3FLd", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 37 },
                            { "h": 2, "i": "MhSW", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 2 },
                            { "h": 2, "i": "mLHy", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 2 },
                            { "h": 7, "i": "P98b", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 11, "i": "T6OU", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 }
                        ],
                        "sort": 4,
                        "text": "Our most popular reporting widgets for monitoring day to day developments, trends, and tasks related to your stakeholders.",
                        "value": 5,
                        "widgets": {
                            "3FLd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [3],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [1],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "3FLd",
                                    "labels": ["Interactions", "Relationships", "Comments"],
                                    "text": "Note Types",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "5iJo": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "5iJo", "labels": null, "text": "Contacts Assigned to \"Me\"", "widget_type": 1 }
                            },
                            "60gj": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_creator": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "default_for_user": true, "is_active": true, "users_on_teams": true }
                                                        ],
                                                        "searchifyCount": 102
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_creator": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "default_for_user": true, "is_active": true, "users_on_teams": true }
                                                        ],
                                                        "searchifyCount": 102
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#535383", "1": "#a88f4d" },
                                    "description": "Visualization of meetings taken by issue overall vs meetings taken by an issue in the past month. Add a filter for specific team members!",
                                    "id": "60gj",
                                    "labels": ["Total number of meetings by issue", "Meetings by issue in past month"],
                                    "text": "Meetings Taken by Issue",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "8oqa": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4e30a1" },
                                    "description": "",
                                    "id": "8oqa",
                                    "labels": ["Notes "],
                                    "text": "Notes Over Time",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "J1fA": {
                                "colors": { "0": "#4fd4e8" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "date_range": 6,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 0
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "date_range": 6,
                                                    "received_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3148
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "J1fA",
                                    "labels": ["% of open emails in past month"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "MhSW": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "MhSW",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "P98b": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "date_range": 5, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 16
                                                    }
                                                },
                                                {
                                                    "archived": false,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "date_range": 5, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 16
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "date_range": 6, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 45
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "P98b",
                                    "labels": ["Opened Email in Last Month vs 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "PBah": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "PBah",
                                    "labels": null,
                                    "quicklink": { "text": "Quicklink to a Sheet", "type": 1, "url": "https://www.quorum.us/sheet/39579/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "T6OU": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 2 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "created_date_range": 6 }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#535383" },
                                    "description": "",
                                    "id": "T6OU",
                                    "labels": ["Contacts"],
                                    "text": "Contacts Created Over Last Month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "UgOE": {
                                "meta": { "colors": null, "description": "", "id": "UgOE", "labels": null, "text": "New Text Widget Name", "widget_type": 3 }
                            },
                            "Uzh8": {
                                "meta": { "colors": null, "description": "<div>This customizable template is made up of best practice widgets to help you manage your day to day stakeholder activity like contacts, outreach, and keeping up with outstanding tasks in Quorum. To make the most of this template:<br></div><div><br></div><ol><li>Edit widgets to make them specific to your priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first<br></li></ol>", "id": "Uzh8", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "WKle": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#ff0000" },
                                    "description": null,
                                    "id": "WKle",
                                    "labels": ["notes over time"],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "Wdc8": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "Wdc8", "labels": null, "text": "Officials Assigned to \"Me\"", "widget_type": 1 }
                            },
                            "XFku": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 1, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": []
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "XFku",
                                    "labels": ["Data Selection 1"],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "XIhL": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_creator": {
                                                        "addedIds": [13090339],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "XIhL",
                                    "labels": ["Total number of interactions logged"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "mLHy": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "mLHy",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "nJea": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Over the past month", "id": "nJea", "labels": null, "text": "Recent Interactions", "widget_type": 1 }
                            }
                        }
                    },
                    "state_2020_legislative_impact": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "state_2020_legislative_impact",
                        "label": "State: 2020 Legislative Impact Dashboard",
                        "permission_enum": [100],
                        "positions": [
                            { "h": 4, "i": "XCEt", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 14, "i": "xnPV", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 14, "i": "eIEu", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 43 },
                            { "h": 15, "i": "FAtl", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 2, "y": 14 },
                            { "h": 17, "i": "e9V5", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 57 },
                            { "h": 5, "i": "ySlh", "minH": 5, "moved": false, "static": false, "w": 1, "x": 5, "y": 0 },
                            { "h": 9, "i": "sA1g", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 56 },
                            { "h": 9, "i": "8quf", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 65 },
                            { "h": 2, "i": "OXNb", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 0, "y": 4 },
                            { "h": 2, "i": "LaiS", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 41 },
                            { "h": 2, "i": "htGl", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 41 },
                            { "h": 2, "i": "hho9", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 1, "y": 4 },
                            { "h": 9, "i": "uZsX", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 5 },
                            { "h": 13, "i": "dSus", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 16 },
                            { "h": 12, "i": "LGNe", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 29 },
                            { "h": 14, "i": "EpOs", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 29 },
                            { "h": 10, "i": "YJfV", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 6 },
                            { "h": 5, "i": "O6ZX", "minH": 5, "moved": false, "static": false, "w": 1, "x": 4, "y": 0 },
                            { "h": 15, "i": "LJK7", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 41 },
                            { "h": 15, "i": "fnEr", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 57 },
                            { "h": 2, "i": "zl8T", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 4, "y": 72 },
                            { "h": 2, "i": "YsXE", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 5, "y": 72 }
                        ],
                        "sort": 8,
                        "text": "Designed to give you quick insight into your 2020 legislative priorities and results.",
                        "value": 9,
                        "widgets": {
                            "1um4": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [3]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#535383", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "1um4",
                                    "labels": ["High priority bills", "Medium priority bills", "Low priority"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "8quf": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2],
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 3478
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2],
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 3823
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0000ff", "1": "#ff0000" },
                                    "description": "",
                                    "id": "8quf",
                                    "labels": ["Dem-sponsored", "GOP-sponsored"],
                                    "text": "Opposed Bills by Sponsor Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "EpOs": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "about_bill": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 577
                                                    },
                                                    "date__isnull": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Month", "id": "EpOs", "labels": null, "text": "Social Media Mentions of Tracked Bills", "widget_type": 1 }
                            },
                            "FAtl": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef" },
                                    "description": "",
                                    "id": "FAtl",
                                    "labels": ["Supported Bills", "Opposed Bills"],
                                    "text": "Bills by Issue",
                                    "vis_options": { "bar_visualization_display_style": 2, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "LGNe": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "in_issue_or": {
                                                        "addedIds": [14018],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "in_issue_or": {
                                                        "addedIds": [14018],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD", "1": "#7259ef" },
                                    "description": "",
                                    "id": "LGNe",
                                    "labels": ["[Priority Issue] bills filed", "[Priority Issue] bills enacted"],
                                    "text": "[ISSUE] bills filed vs. enacted",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "LJK7": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "in_issue_or": {
                                                        "addedIds": [14018],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "LJK7", "labels": null, "text": "[ISSUE] bills", "widget_type": 1 }
                            },
                            "LaiS": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "LaiS",
                                    "labels": null,
                                    "quicklink": { "text": "[ISSUE] Bill Sheet", "type": 1, "url": "https://www.quorum.us/sheet/41398/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "NySj": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 1, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": []
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "NySj",
                                    "labels": ["Data Selection 1"],
                                    "text": "New Visualization Widget Name",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "O6ZX": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "O6ZX",
                                    "labels": ["Filed", "Enacted"],
                                    "text": "Supported Bills",
                                    "widget_type": 2
                                },
                                "operation": 1
                            },
                            "OXNb": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "OXNb",
                                    "labels": null,
                                    "quicklink": { "text": "State Legislative Tracker", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "XCEt": {
                                "meta": { "colors": null, "description": "<div>Welcome! This template will give you quick insight what your team is doing and key legislative priorities. Data selections are set to 2020 unless otherwise specified.</div><div><br></div><div><b>Action Items for You:</b></div><ul><li>Add hyperlinks to the button widgets to connect them to your 2020 bill tracking board, 2020 bill tracking sheet, 2020 key stakeholder sheet, and issue specific sheet.</li><li>Click into the issue-specific widgets and make sure to select a group of bills tagged to your priority issue.</li><li>Delete this text box once you're done!</li></ul>", "id": "XCEt", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "YJfV": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [1],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [2],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [3],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [4, 5],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#d5dcef", "3": "#4e30a1", "4": "#a88f4d" },
                                    "description": "",
                                    "id": "YJfV",
                                    "labels": ["Introduced", "Out of Committee", "Passed First Chamber", "Passed Second Chamber", "Enacted"],
                                    "text": "Supported Bills by Status",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "YsXE": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "YsXE",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "ZxkM": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 15, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": "",
                                    "id": "ZxkM",
                                    "labels": ["Data Selection 1"],
                                    "text": "High Priority bills by state",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "aib0": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "aib0",
                                    "labels": ["Supported Bills Enacted"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "dSus": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 28,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "about_bill": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 577
                                                    },
                                                    "archived": false,
                                                    "date_range": 2,
                                                    "dehydrate_extra": ["committee"],
                                                    "event_type__in": [4],
                                                    "excluding_custom_events": true,
                                                    "full_events": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "dSus", "labels": null, "text": "Upcoming Hearings on Tracked Bills", "widget_type": 1 }
                            },
                            "dn7y": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 253
                                                    },
                                                    "status_date_range": [8]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "introduced_date_range": 8,
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 281
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#ff0000", "1": "#503ABD" },
                                    "description": "",
                                    "id": "dn7y",
                                    "labels": ["Republican sponsored bills last year", "Democrat sponsored bills last year"],
                                    "text": "Party Bills Sponsored in Last Year",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "e9V5": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "e9V5", "labels": null, "text": "High Priority Enacted Bills", "widget_type": 1 }
                            },
                            "eIEu": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD", "1": "#7259ef" },
                                    "description": "",
                                    "id": "eIEu",
                                    "labels": ["Supported Bills", "Opposed Bills"],
                                    "text": "Tracked Bills by Status",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "fnEr": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_tracking_dashboards": {
                                                        "addedIds": [9845],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "my_stance": [0]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#000022", "1": "#4e30a1", "2": "#7259ef", "3": "#a88f4d" },
                                    "description": "",
                                    "id": "fnEr",
                                    "labels": ["Unreviewed Bills", "Opposed bills", "Supported bills", "Watched bills"],
                                    "text": "Bills by stance",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "hho9": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "hho9",
                                    "labels": null,
                                    "quicklink": { "text": "Key Stakeholders", "type": 1, "url": "https://www.quorum.us/sheets/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "htGl": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "htGl",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "sA1g": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1],
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 3478
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [1],
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 3823
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0000ff", "1": "#ff0000" },
                                    "description": "",
                                    "id": "sA1g",
                                    "labels": ["Dem-sponsored", "GOP-sponsored"],
                                    "text": "Supported Bills by Sponsor Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "uZsX": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_bills": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 577
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "uZsX", "labels": null, "text": "All Notes on Tracked Bills", "widget_type": 1 }
                            },
                            "xnPV": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_priority": [1],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "xnPV", "labels": null, "text": "High Priority Opposed Bills", "widget_type": 1 }
                            },
                            "ySlh": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2020],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "ySlh",
                                    "labels": ["Filed", "Enacted"],
                                    "text": "Opposed Bills",
                                    "widget_type": 2
                                },
                                "operation": 1
                            },
                            "zl8T": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "zl8T",
                                    "labels": null,
                                    "quicklink": { "text": "2020 Tracking Board", "type": 1, "url": "https://www.quorum.us/tracking_boards/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            }
                        }
                    },
                    "state_2021_policy_manager_dashboard": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "state_2021_policy_manager_dashboard",
                        "label": "State: 2021 Policy Manager Dashboard",
                        "permission_enum": [100],
                        "positions": [
                            { "h": 4, "i": "KIQ7", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 11, "i": "BwKY", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 23 },
                            { "h": 11, "i": "J01B", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 16 },
                            { "h": 5, "i": "g5D1", "minH": 5, "moved": false, "static": false, "w": 1, "x": 2, "y": 11 },
                            { "h": 2, "i": "IacM", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 5, "y": 21 },
                            { "h": 2, "i": "vuMU", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 0, "y": 4 },
                            { "h": 11, "i": "Ef6v", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 10 },
                            { "h": 10, "i": "tgX2", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 11, "i": "8HmV", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 11, "i": "ZqQn", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 16 },
                            { "h": 10, "i": "H1s2", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 0, "y": 6 },
                            { "h": 16, "i": "d48i", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 4, "x": 0, "y": 27 },
                            { "h": 5, "i": "nSBm", "minH": 5, "moved": false, "static": false, "w": 1, "x": 3, "y": 11 },
                            { "h": 2, "i": "shvY", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 1, "y": 4 },
                            { "h": 2, "i": "3PE7", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 4, "y": 21 },
                            { "h": 10, "i": "SxKb", "minH": 6, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 43 },
                            { "h": 12, "i": "ehZ2", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 34 },
                            { "h": 5, "i": "S5OA", "minH": 5, "moved": false, "static": false, "w": 1, "x": 3, "y": 43 },
                            { "h": 5, "i": "GiBW", "minH": 5, "moved": false, "static": false, "w": 1, "x": 3, "y": 48 }
                        ],
                        "sort": 9,
                        "text": "Designed to give a state or regional policy manager quick insight into their legislative priorities, upcoming hearings, and stakeholder engagement strategy.",
                        "value": 10,
                        "widgets": {
                            "13Oi": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0048ff", "1": "#ff0000", "2": "#fbff00" },
                                    "description": "",
                                    "id": "13Oi",
                                    "labels": ["Democrat", "Republican", "Independent"],
                                    "text": "Number of Federal Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "3PE7": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "3PE7",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "7mVI": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "7mVI",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 2, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "8HmV": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "mentions_user_or": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "8HmV", "labels": null, "text": "@mentions of Me", "widget_type": 1 }
                            },
                            "BwKY": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "assigned_to_me": true,
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "BwKY", "labels": null, "text": "Key Legislators", "widget_type": 1 }
                            },
                            "CdpX": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 7,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "CdpX",
                                    "labels": ["Officials Interacted w/ Past 3 Months"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "Ef6v": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "assigned_to_me": true,
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 3
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Three Months", "id": "Ef6v", "labels": null, "text": "Dialogue by Key Legislators", "widget_type": 1 }
                            },
                            "GiBW": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "opened_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 3235
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "GiBW",
                                    "labels": ["# of Officials who've Opened Emails"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "H1s2": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 28,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "about_bill": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_stance": [1, 2, 4]
                                                            }
                                                        ],
                                                        "searchifyCount": 689
                                                    },
                                                    "archived": false,
                                                    "date_range": 2,
                                                    "dehydrate_extra": ["committee"],
                                                    "event_type__in": [4],
                                                    "excluding_custom_events": true,
                                                    "full_events": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "H1s2", "labels": null, "text": "Upcoming Hearings on Tracked Bills", "widget_type": 1 }
                            },
                            "IacM": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "IacM",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 12, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "J01B": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "J01B", "labels": null, "text": "High Priority Bills", "widget_type": 1 }
                            },
                            "KIQ7": {
                                "meta": { "colors": null, "description": "<div>Welcome! These widgets are here to help you stay on top of key legislation, important stakeholders, significant dialogue, and your activity. Selections set for 2021 unless otherwise specified.\u00a0</div><div><br></div><div><div><b>Action Items for You:</b></div><ul><li>Add hyperlinks to the button widgets to connect them to your 2021 bill tracking board and 2021 bill tracking sheet.</li><li>Delete this text box once you're done!</li></ul></div>", "id": "KIQ7", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "Pssi": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "116th congress",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "wind power",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 7, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "advanced_search": "hydropower",
                                                    "date__isnull": false,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "document_type__in": [6, 9, 38, 39, 41]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#a88f4d", "2": "#7259ef" },
                                    "description": "",
                                    "id": "Pssi",
                                    "labels": ["116th Congress", "Wind Power", "Hydropower"],
                                    "text": "Issue Mentions on Social",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "S5OA": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "received_bulk_email": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "archived": false, "is_draft": false, "is_scheduled": false }
                                                        ],
                                                        "searchifyCount": 0
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "S5OA",
                                    "labels": ["# of Officials Emailed"],
                                    "text": " ",
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "SxKb": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 25,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "date__isnull": false,
                                                    "date_range": 5,
                                                    "dehydrate_extra": ["committee_meeting", "official_image"],
                                                    "source_members": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "ph_minor_role_type": [21],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 55
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "Last Week", "id": "SxKb", "labels": null, "text": "Recent Dialogue by Governors", "widget_type": 1 }
                            },
                            "W9oS": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "assigned_to_me": true,
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "date_range": 7,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 67
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 12,
                                            "deleted_ids": [],
                                            "filters": [
                                                { "archived": false, "assigned_to_me": true }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "W9oS",
                                    "labels": ["Interactions w/ assigned contacts"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "XJuS": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "XJuS", "labels": null, "text": "2021 Incoming Officials", "widget_type": 1 }
                            },
                            "ZZtd": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "interacted_date_range": 6,
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "participated_in_notes": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["bills"],
                                                                "plain": true,
                                                                "remove_resource_excludes": true
                                                            }
                                                        ],
                                                        "searchifyCount": 1377
                                                    },
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD" },
                                    "description": null,
                                    "id": "ZZtd",
                                    "labels": ["Data Selection 1"],
                                    "text": "Officials we have met with in past month",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "ZqQn": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 7,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_creator": {
                                                        "addedIds": [748980],
                                                        "deletedIds": [],
                                                        "querysetList": [],
                                                        "searchifyCount": 1
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#503ABD", "1": "#7259ef" },
                                    "description": "Last Three Months",
                                    "id": "ZqQn",
                                    "labels": ["All Meetings", "Meetings logged by me"],
                                    "text": "Interactions Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "d48i": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#503ABD", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "d48i",
                                    "labels": ["Supported Bills", "Opposed Bills", "Watching Bills"],
                                    "text": "Bills by Issue",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "ehZ2": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 7737
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_member": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 8315
                                                    },
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0000ff", "1": "#ff0000" },
                                    "description": "All Time",
                                    "id": "ehZ2",
                                    "labels": ["Dems", "GOP"],
                                    "text": "Meetings by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "fKFJ": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 1378
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 201
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "date_range": 6,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_office": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "participated_in_notes": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "date_range": 6,
                                                                            "dehydrate_extra": ["bills"],
                                                                            "plain": true,
                                                                            "remove_resource_excludes": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 17
                                                                },
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 5
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4569c4", "1": "#deb84f" },
                                    "description": null,
                                    "id": "fKFJ",
                                    "labels": ["Officials we've met with by issue total", "Officials we've met with in past month"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "g5D1": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2021],
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "g5D1",
                                    "labels": ["Filed", "Enacted"],
                                    "text": "Supported Bills",
                                    "widget_type": 2
                                },
                                "operation": 1
                            },
                            "gGpA": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "gGpA", "labels": null, "text": "Legislation in Committee", "widget_type": 1 }
                            },
                            "ldbc": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [3635342],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [8477],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "ldbc",
                                    "labels": ["Total Notes", "Meetings", "Emailed"],
                                    "text": "Notes Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": true },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "nSBm": {
                                "colors": { "0": "#503ABD" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "for_years": [2021],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "for_years": [2021],
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "nSBm",
                                    "labels": ["Filed", "Enacted"],
                                    "text": "Opposed Bills",
                                    "widget_type": 2
                                },
                                "operation": 1
                            },
                            "oAAh": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "oAAh",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 10, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "shvY": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "shvY",
                                    "labels": null,
                                    "quicklink": { "text": "2021 Bill Sheet", "type": 1, "url": "https://www.quorum.us/sheet/41398/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "tgX2": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2],
                                                    "status_date_range": [6]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "", "id": "tgX2", "labels": null, "text": "Opposed Bills That Moved in the Last Month", "widget_type": 1 }
                            },
                            "uBqT": {
                                "meta": { "colors": null, "description": "testing whether or not this will save", "id": "uBqT", "labels": null, "text": "New Text Widget Name", "widget_type": 3 }
                            },
                            "vuMU": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "vuMU",
                                    "labels": null,
                                    "quicklink": { "text": "2021 State Tracking Board", "type": 1, "url": "https://www.quorum.us/tracking_board/9845/" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "ydNg": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "status__in": [2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#db3333", "1": "#3537d0", "2": "#3568e9" },
                                    "description": "This chart will automatically update as election results are confirmed.",
                                    "id": "ydNg",
                                    "labels": ["Democrat", "Independent", "Republican"],
                                    "text": "2021 Incoming Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            }
                        }
                    },
                    "state_impact": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "state_impact",
                        "label": "State & Local: Impact Dashboard",
                        "permission_enum": [100, 101],
                        "positions": [
                            { "h": 5, "i": "XCEt", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 12, "i": "xnPV", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 0 },
                            { "h": 7, "i": "aib0", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 5 },
                            { "h": 16, "i": "eIEu", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 12 },
                            { "h": 18, "i": "FAtl", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 37 },
                            { "h": 12, "i": "e9V5", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 9, "i": "1um4", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 28 },
                            { "h": 9, "i": "dn7y", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 28 }
                        ],
                        "sort": 5,
                        "text": "Designed to help leaders determine strategy and communicate the impact of their state and local teams.",
                        "value": 6,
                        "widgets": {
                            "1um4": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_priority": [3]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#535383", "2": "#a88f4d" },
                                    "description": "",
                                    "id": "1um4",
                                    "labels": ["High priority bills", "Medium priority bills", "Low priority"],
                                    "text": null,
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "FAtl": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "in_issue_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["parent_name"]
                                                            }
                                                        ],
                                                        "searchifyCount": 148
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "status_date_range": [6]
                                                },
                                                {
                                                    "current_general_status__in": [6],
                                                    "status_date_range": [7]
                                                },
                                                {
                                                    "current_general_status__in": [6],
                                                    "status_date_range": [8]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#7259ef", "1": "#535383" },
                                    "description": "Bar graph of the total number of bills tagged to our organisation's issues.",
                                    "id": "FAtl",
                                    "labels": ["Bills tagged to our issues", "Bills enacted in the last year"],
                                    "text": "Bills tagged to our issues",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "XCEt": {
                                "meta": { "colors": null, "description": "<div>This customizable template is designed to give leaders a high-level overview of everything your team is doing and communicate the impact of your efforts.&nbsp; To make the most of this template:<br></div><div><br></div><ol><li>Edit widgets to make them specific to your goals and priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first</li><li>Download or share this Dashboard for presentation-ready reports<br></li></ol>", "id": "XCEt", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "aib0": {
                                "colors": { "0": "#4e30a1" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current_general_status__in": [6],
                                                    "my_stance": [1, 2, 4]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1, 2, 4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "aib0",
                                    "labels": ["Bills w/ Stance + Enacted"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 2
                            },
                            "dn7y": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [2],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 253
                                                    },
                                                    "status_date_range": [8]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 4, "frequency_tuple_field": null, "interval": 3 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "introduced_date_range": 8,
                                                    "sponsored_by_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "most_recent_party__in": [1],
                                                                "most_recent_person_type__in": [1, 6],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 281
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#ff0000", "1": "#503ABD" },
                                    "description": "",
                                    "id": "dn7y",
                                    "labels": ["Republican sponsored bills last year", "Democrat sponsored bills last year"],
                                    "text": "Party Bills Sponsored in Last Year",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "e9V5": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of bills our organization supports.", "id": "e9V5", "labels": null, "text": "Bills We Support", "widget_type": 1 }
                            },
                            "eIEu": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#1fc155", "1": "#8f0c0a", "2": "#595e69" },
                                    "description": "Bills that your organizations has set a stance on (support, oppose, watching) and their current status.",
                                    "id": "eIEu",
                                    "labels": ["Bills we support", "Bills we oppose", "Bills we are watching"],
                                    "text": "Bills with a Stance + Current Status",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "xnPV": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "most_recent_action_date_range": 5,
                                                    "my_stance": [1, 2, 4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "This is a list of the bills your organization has taken a stance on and has had movement in the past week.", "id": "xnPV", "labels": null, "text": "Bills with Stance + Movement", "widget_type": 1 }
                            }
                        }
                    },
                    "state_operational": {
                        "icon": "dashboard",
                        "icon_family": "q",
                        "icon_size": "2x",
                        "key": "state_operational",
                        "label": "State & Local: Operational Dashboard",
                        "permission_enum": [100, 101],
                        "positions": [
                            { "h": 12, "i": "W9eu", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 4 },
                            { "h": 6, "i": "uEls", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 10 },
                            { "h": 6, "i": "lcEc", "minH": 5, "moved": false, "static": false, "w": 2, "x": 0, "y": 4 },
                            { "h": 11, "i": "4EJH", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 16 },
                            { "h": 13, "i": "UBW1", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 0, "y": 45 },
                            { "h": 18, "i": "8H9J", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 27 },
                            { "h": 16, "i": "UJjP", "maxW": 3, "minH": 6, "minW": 2, "moved": false, "static": false, "w": 2, "x": 4, "y": 0 },
                            { "h": 19, "i": "vwte", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 6, "x": 0, "y": 58 },
                            { "h": 4, "i": "F89k", "minH": 4, "moved": false, "static": false, "w": 2, "x": 0, "y": 0 },
                            { "h": 2, "i": "J62t", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 2, "y": 0 },
                            { "h": 2, "i": "iv5e", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 2, "x": 2, "y": 2 },
                            { "h": 2, "i": "VUig", "maxH": 2, "minH": 2, "moved": false, "static": false, "w": 1, "x": 3, "y": 0 },
                            { "h": 13, "i": "DIGb", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 45 },
                            { "h": 11, "i": "RF2P", "minH": 9, "minW": 2, "moved": false, "static": false, "w": 3, "x": 3, "y": 16 }
                        ],
                        "sort": 2,
                        "text": "Our most popular reporting widgets for monitoring day to day developments, trends, and tasks related to your state or local region.",
                        "value": 3,
                        "widgets": {
                            "4EJH": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 22, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 22, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 22, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#1fc155", "1": "#8f0c0a", "2": "#595e69" },
                                    "description": null,
                                    "id": "4EJH",
                                    "labels": ["Bills we support", "Bills we oppose", "Bills we are watching"],
                                    "text": "Bills with a Stance",
                                    "vis_options": { "bar_visualization_display_style": 2, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "8H9J": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "in_issue_or": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "archived": false,
                                                                "dehydrate_extra": ["parent_name"]
                                                            }
                                                        ],
                                                        "searchifyCount": 148
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54" },
                                    "description": "Total number of bills tagged to our organization's issues",
                                    "id": "8H9J",
                                    "labels": ["Bills by issue"],
                                    "text": "Bills by Issue",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "DIGb": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": 1, "frequency_tuple_field": null, "interval": 4 },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#4e40a1", "1": "#a88f4d" },
                                    "description": "",
                                    "id": "DIGb",
                                    "labels": ["Notes", "Interactions"],
                                    "text": "Notes Logged",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": false },
                                    "vis_subtype": 3,
                                    "widget_type": 5
                                }
                            },
                            "F89k": {
                                "meta": { "colors": null, "description": "<div>This customizable template is made up of best practice widgets to help you manage your day to day legislative activity like bill tracking, monitoring trends, and keeping up with outstanding tasks in Quorum. To make the most of this template: <br></div><div><br></div><ol><li>Update or edit widgets to make them specific to your region and priorities<br></li><li>Explore and add new widgets<br></li><li>Delete widgets as needed <br></li><li>Rearrange the widgets to show your most important information first<br></li></ol>", "id": "F89k", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "J62t": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "J62t",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 5, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "RF2P": {
                                "colors": null,
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [1],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [3],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_party__in": [2],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#0048ff", "1": "#bbff00", "2": "#ff0000" },
                                    "description": "",
                                    "id": "RF2P",
                                    "labels": ["Democrat", "Independent", "Republican"],
                                    "text": "Number of State Officials by Party",
                                    "vis_options": { "bar_visualization_display_style": null, "cumulative": null },
                                    "vis_subtype": 2,
                                    "widget_type": 5
                                },
                                "operation": null
                            },
                            "UBW1": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [2]
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 21, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#1fc155", "1": "#8f0c0a", "2": "#595e69" },
                                    "description": null,
                                    "id": "UBW1",
                                    "labels": ["Bills we support", "Bills we oppose", "Bills we are watching"],
                                    "text": "Bills with a Stance + Current Status",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            },
                            "UJjP": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [1]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": null, "id": "UJjP", "labels": null, "text": "Bills We Support", "widget_type": 1 }
                            },
                            "VUig": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "VUig",
                                    "labels": null,
                                    "quicklink": { "text": "Add Custom Quicklink URL", "type": 3, "url": "" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "Vnc8": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "most_recent_action_date_range": 5,
                                                    "stance_last_user": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            { "default_for_user": true, "is_active": true, "users_on_teams": true }
                                                        ],
                                                        "searchifyCount": 102
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of bills that your organization as taken a stance on that have had movement in the past week.", "id": "Vnc8", "labels": null, "text": "List of Bills with Stance + Movement", "widget_type": 1 }
                            },
                            "W9eu": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "limit": null,
                                        "offset": null,
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 1,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "current": true,
                                                    "dehydrate_extra": ["most_recent_role"],
                                                    "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                    "show_in_quicksearch": true,
                                                    "sponsored_bills": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "my_priority": [1]
                                                            }
                                                        ],
                                                        "searchifyCount": 206
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "dehydrate_extra": null,
                                "meta": { "colors": null, "description": "List of the sponsoros of the bills your organization has marked as high priority.", "id": "W9eu", "labels": null, "text": "Sponsors of High Priority Bills", "widget_type": 1 }
                            },
                            "iv5e": {
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "iv5e",
                                    "labels": null,
                                    "quicklink": { "text": "State Legislative Calendar", "type": 1, "url": "https://info.quorum.us/hubfs/12WCPI/state%20leg%20update%202020.pdf?utm_campaign=August%202019%20States%20Theme&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz--02eswu36WMyWZQ4qDi8boTDBxYXeOcG1zDRjq5l32pPgndxy-GHIxdmOY7awUNTZq3Z_G" },
                                    "text": null,
                                    "widget_type": 4
                                }
                            },
                            "kYWv": {
                                "meta": { "colors": null, "description": "This dashboard will help you keep track of your day to day workflow in Quorum.", "id": "kYWv", "labels": null, "text": null, "widget_type": 3 }
                            },
                            "lcEc": {
                                "colors": { "0": "#221f54" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "custom_interaction_type__in": [1098],
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": null,
                                    "id": "lcEc",
                                    "labels": ["Meetings", "Notes"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": 1
                            },
                            "uEls": {
                                "colors": { "0": "#7259ef" },
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "count": true,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 2,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "my_stance": [4, 1, 2]
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": null,
                                    "description": "",
                                    "id": "uEls",
                                    "labels": ["Bills with a stance"],
                                    "text": null,
                                    "widget_type": 2
                                },
                                "operation": null
                            },
                            "vwte": {
                                "data_sources": [
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "note_type__in": [2],
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        "additional_filters": null,
                                        "group_by": { "date_field": null, "frequency_tuple_field": 24, "interval": null },
                                        "order_by": null,
                                        "safed_search": {
                                            "added_ids": [],
                                            "data_type": 20,
                                            "deleted_ids": [],
                                            "filters": [
                                                {
                                                    "archived": false,
                                                    "dehydrate_extra": ["bills"],
                                                    "involving_member": {
                                                        "addedIds": [],
                                                        "deletedIds": [],
                                                        "querysetList": [
                                                            {
                                                                "current": true,
                                                                "dehydrate_extra": ["most_recent_role"],
                                                                "in_issue_or": {
                                                                    "addedIds": [],
                                                                    "deletedIds": [],
                                                                    "querysetList": [
                                                                        {
                                                                            "archived": false,
                                                                            "dehydrate_extra": ["parent_name"],
                                                                            "parent__isnull": true
                                                                        }
                                                                    ],
                                                                    "searchifyCount": 89
                                                                },
                                                                "most_recent_person_type__in": [6, 3, 8, 1, 7],
                                                                "show_in_quicksearch": true
                                                            }
                                                        ],
                                                        "searchifyCount": 14
                                                    },
                                                    "remove_resource_excludes": true
                                                }
                                            ]
                                        }
                                    }
                                ],
                                "meta": {
                                    "colors": { "0": "#221f54", "1": "#7259ef" },
                                    "description": null,
                                    "id": "vwte",
                                    "labels": ["Interactions", "Interactions w/ Officials"],
                                    "text": "Notes with Issues",
                                    "vis_options": { "bar_visualization_display_style": 1, "cumulative": null },
                                    "vis_subtype": 1,
                                    "widget_type": 5
                                }
                            }
                        }
                    }
                }
            },
            "types": {
                "AggregationFields": {
                    "__is_enum": true,
                    "amount": {
                        "aggregation_type": 1,
                        "filter_keys": { "107": "amount" },
                        "key": "amount",
                        "label": "Total Sum Amount (USD)",
                        "permission_enum": [8],
                        "qdts": [107],
                        "querymethod": { "107": "sum_aggregation" },
                        "value": 1
                    },
                    "amount_pac_v2": {
                        "aggregation_type": 1,
                        "filter_keys": { "135": "amount" },
                        "key": "amount_pac_v2",
                        "label": "Total Sum Amount (USD)",
                        "permission_enum": [215],
                        "qdts": [135],
                        "querymethod": { "135": "sum_aggregation" },
                        "value": 2
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "What",
                            "values": [1, 2]
                        }
                    ],
                    "valid_qdts": [107, 135]
                },
                "AggregationTypes": {
                    "__is_enum": true,
                    "count": { "key": "count", "label": "Count", "value": 2 },
                    "sum": { "key": "sum", "label": "Sum", "value": 1 }
                },
                "BarVisualizationDirection": {
                    "__is_enum": true,
                    "horizontal": { "key": "horizontal", "label": "Horizontal", "value": 1 },
                    "vertical": { "key": "vertical", "label": "Vertical", "value": 2 }
                },
                "BarVisualizationDisplayStyle": {
                    "__is_enum": true,
                    "one_hundred_percent_stacked": { "key": "one_hundred_percent_stacked", "label": "100% Stacked", "value": 3 },
                    "regular": { "key": "regular", "label": "Regular", "value": 1 },
                    "stacked": { "key": "stacked", "label": "Stacked", "value": 2 }
                },
                "DashboardWidgetType": {
                    "__is_enum": true,
                    "calendar_widget": { "feature_flags": null, "icon": "list", "initialH": 11, "initialW": 2, "key": "calendar_widget", "label": "Calendar Events", "maxH": null, "maxW": null, "minH": 6, "minW": 2, "permission_enum": null, "shape": "(((dehydrate_extra?:dehydrate_extra&format?:format)&data_sources:[list_widget_data_source])&meta:meta)", "sort": 0, "tip": "List of upcoming calendar events.", "uses_widget_engine": true, "value": 9 },
                    "favorites_widget": { "feature_flags": null, "icon": "star", "initialH": 7, "initialW": 1, "key": "favorites_widget", "label": "Favorite Searches Widget", "maxH": null, "maxW": null, "minH": 7, "minW": 1, "permission_enum": null, "shape": "meta:meta", "sort": 6, "tip": "Keeps track of your favorited searches.", "uses_widget_engine": false, "value": 6 },
                    "list_widget": { "feature_flags": null, "icon": "list", "initialH": 11, "initialW": 2, "key": "list_widget", "label": "List Widget", "maxH": null, "maxW": null, "minH": 6, "minW": 2, "permission_enum": null, "shape": "(((dehydrate_extra?:dehydrate_extra&format?:format)&data_sources:[list_widget_data_source])&meta:meta)", "sort": 0, "tip": "Keep the most important things like stakeholders, events, or bills right at at your fingertips in an auto-updating list.", "uses_widget_engine": true, "value": 1 },
                    "number_widget": { "feature_flags": null, "icon": "hashtag", "initialH": 11, "initialW": 2, "key": "number_widget", "label": "Number Widget", "maxH": null, "maxW": null, "minH": 5, "minW": null, "permission_enum": null, "shape": "((colors?:colors&(data_sources:[number_widget_data_source]&operation?:operation))&meta:meta)", "sort": 1, "tip": "Easily keep track of counts on campaigns, votes, participants, etc. These can be displayed as a count, percentage, or fraction.", "uses_widget_engine": true, "value": 2 },
                    "quicklink_widget": { "feature_flags": null, "icon": "link", "initialH": 2, "initialW": 1, "key": "quicklink_widget", "label": "Quicklink", "maxH": 2, "maxW": null, "minH": 2, "minW": null, "permission_enum": null, "shape": "meta:quicklink_meta", "sort": 5, "tip": "Create buttons that link quickly to your favorite searches, sheets, or external URLs.", "uses_widget_engine": false, "value": 4 },
                    "recents_widget": { "feature_flags": null, "icon": "star", "initialH": 7, "initialW": 1, "key": "recents_widget", "label": "Recent Searches Widget", "maxH": null, "maxW": null, "minH": 7, "minW": 1, "permission_enum": null, "shape": "meta:meta", "sort": 7, "tip": "Keeps track of your most recent searches.", "uses_widget_engine": false, "value": 7 },
                    "text_widget": { "feature_flags": null, "icon": "text", "initialH": 7, "initialW": 2, "key": "text_widget", "label": "Text Widget", "maxH": null, "maxW": null, "minH": 4, "minW": null, "permission_enum": null, "shape": "meta:meta", "sort": 2, "tip": "A plain text box that is good for instructions, insights, or inspirational quotes.", "uses_widget_engine": false, "value": 3 },
                    "trending_widget": {
                        "feature_flags": null,
                        "icon": "chart-line",
                        "initialH": 10,
                        "initialW": 1,
                        "key": "trending_widget",
                        "label": "Trending Topics Widget",
                        "maxH": null,
                        "maxW": null,
                        "minH": 10,
                        "minW": 1,
                        "permission_enum": [104],
                        "shape": "(data_sources:[trending_data_source]&meta:meta)",
                        "sort": 8,
                        "tip": "Create this widget in order to stay up to date on news that is currently trending.",
                        "uses_widget_engine": true,
                        "value": 8
                    },
                    "visualization_widget": { "feature_flags": null, "icon": "chart-bar", "initialH": 9, "initialW": 3, "key": "visualization_widget", "label": "Visualization Widget", "maxH": null, "maxW": null, "minH": 9, "minW": 2, "permission_enum": null, "shape": "((data_sources:[group_by_data_source]&meta:vis_meta)|((colors?:colors&(data_sources:[number_widget_data_source]&operation?:operation))&meta:vis_meta))", "sort": 4, "tip": "Choose from line, pie, maps, or bar charts to compare data, monitor trends, and discover insights.", "uses_widget_engine": true, "value": 5 }
                },
                "DateFields": {
                    "__is_enum": true,
                    "alignment_over_time": {
                        "key": "alignment_over_time",
                        "label": "Alignment Over Time",
                        "qdts": [1, 8, 12, 120],
                        "querymethod": "alignment_over_time_frequency_tuples",
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 20
                    },
                    "comment_close_date": {
                        "field": "comment_close_date",
                        "key": "comment_close_date",
                        "label": "Comment Close Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 17
                    },
                    "created": {
                        "field": "created",
                        "key": "created",
                        "label": "Created",
                        "qdts": [62, 69, 45, 119, 134, 12, 3],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 1
                    },
                    "current_status_date": {
                        "field": "current_status_date",
                        "key": "current_status_date",
                        "label": "Current Status Date",
                        "qdts": [2],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 4
                    },
                    "date": {
                        "field": "date",
                        "key": "date",
                        "label": "Date",
                        "qdts": [69, 20],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 19
                    },
                    "date_time": {
                        "field": "date_time",
                        "key": "date_time",
                        "label": "Date",
                        "qdts": [25],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 7
                    },
                    "detailed_status_date": {
                        "field": "detailed_status_date",
                        "key": "detailed_status_date",
                        "label": "Detailed Status Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 12
                    },
                    "effective_date": {
                        "field": "effective_date",
                        "key": "effective_date",
                        "label": "Effective Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 15
                    },
                    "election_year": {
                        "key": "election_year",
                        "label": "Election Year",
                        "qdts": [114],
                        "querymethod": "year_frequency_tuples",
                        "supported_line_graph_time_intervals": [5],
                        "value": 21
                    },
                    "end": {
                        "field": "end",
                        "key": "end",
                        "label": "End",
                        "qdts": [28],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 9
                    },
                    "estimated_published_date": {
                        "field": "estimated_published_date",
                        "key": "estimated_published_date",
                        "label": "Published Date",
                        "qdts": [105],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 18
                    },
                    "expiration_date": {
                        "field": "expiration_date",
                        "key": "expiration_date",
                        "label": "Expiration Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 16
                    },
                    "general_status_date": {
                        "field": "general_status_date",
                        "key": "general_status_date",
                        "label": "General Status Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 11
                    },
                    "introduced_date": {
                        "field": "introduced_date",
                        "key": "introduced_date",
                        "label": "Introduced Date",
                        "qdts": [2],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 5
                    },
                    "most_recent_action_date": {
                        "field": "most_recent_action_date",
                        "key": "most_recent_action_date",
                        "label": "Latest Action Date",
                        "qdts": [2],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 6
                    },
                    "occurred_time": {
                        "db_column": "creation_time",
                        "field": "occurred_time",
                        "key": "occurred_time",
                        "label": "Occurred Time",
                        "qdts": [107],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 22
                    },
                    "pre_proposal_date": {
                        "field": "pre_proposal_date",
                        "key": "pre_proposal_date",
                        "label": "Pre Proposal Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 13
                    },
                    "processed": {
                        "field": "processed",
                        "key": "processed",
                        "label": "Processed",
                        "qdts": [],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 10
                    },
                    "proposal_date": {
                        "field": "proposal_date",
                        "key": "proposal_date",
                        "label": "Proposal Date",
                        "qdts": [80],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 14
                    },
                    "status_date": {
                        "field": "status_date",
                        "key": "status_date",
                        "label": "Last Acted Upon",
                        "qdts": [4],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 3
                    },
                    "sum_aggregation": {
                        "key": "sum_aggregation",
                        "label": "Sum ($)",
                        "qdts": [107],
                        "querymethod": "sum_aggregation_frequency_tuples",
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 23
                    },
                    "sum_aggregation_pacv2": {
                        "key": "sum_aggregation_pacv2",
                        "label": "Sum ($)",
                        "qdts": [135],
                        "querymethod": "sum_aggregation_frequency_tuples",
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 25
                    },
                    "transaction_date": {
                        "db_column": "TransactionDate",
                        "field": "transaction_date",
                        "key": "transaction_date",
                        "label": "Transaction Date",
                        "qdts": [135],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 24
                    },
                    "updated": {
                        "field": "updated",
                        "key": "updated",
                        "label": "Updated",
                        "qdts": [69, 12],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 2
                    },
                    "valid_qdts": [1, 2, 3, 4, 134, 135, 8, 12, 20, 25, 28, 45, 62, 69, 80, 105, 107, 114, 119, 120],
                    "when": {
                        "field": "when",
                        "key": "when",
                        "label": "When",
                        "qdts": [28],
                        "supported_line_graph_time_intervals": [1, 2, 3, 4, 5],
                        "value": 8
                    }
                },
                "FrequencyTupleFields": {
                    "__is_enum": true,
                    "actions": {
                        "filter_keys": {},
                        "key": "actions",
                        "label": "Actions",
                        "qdts": [44],
                        "querymethod": "actions_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 45,
                        "visualization_subtype": 1
                    },
                    "agencies": {
                        "filter_keys": { "80": "public_org_associated_with_agency" },
                        "key": "agencies",
                        "label": "Agencies",
                        "qdts": [80],
                        "querymethod": "agency_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 14,
                        "visualization_subtype": 1
                    },
                    "author": {
                        "filter_keys": {},
                        "key": "author",
                        "label": "Authors",
                        "qdts": [105],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": {
                            "exclude": ["Unknown", "admin"],
                            "field_name": "author__name"
                        },
                        "supported_regions_qdt": {},
                        "value": 62,
                        "visualization_subtype": 1
                    },
                    "bill_types": {
                        "enum": { "2": "app.bill.models.BillType" },
                        "filter_keys": { "2": "bill_type__in" },
                        "key": "bill_types",
                        "label": "Bill Types",
                        "qdts": [2],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 20,
                        "visualization_subtype": 1
                    },
                    "bounces": {
                        "filter_keys": {},
                        "key": "bounces",
                        "label": "Bounces",
                        "qdts": [44],
                        "querymethod": "bounces_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 43,
                        "visualization_subtype": 1
                    },
                    "campaign_confirmation_emails": {
                        "filter_keys": {},
                        "key": "campaign_confirmation_emails",
                        "label": "Confirmation Emails",
                        "qdts": [47],
                        "querymethod": "confirmation_email_campaign_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 47,
                        "visualization_subtype": 1
                    },
                    "category": {
                        "filter_keys": {},
                        "key": "category",
                        "label": "Categories",
                        "qdts": [105],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": { "field_name": "source__category", "postprocess_func": "postprocess_category_frequency_tuples" },
                        "supported_regions_qdt": {},
                        "value": 66,
                        "visualization_subtype": 1
                    },
                    "caucuses": {
                        "filter_keys": { "25": "source_caucus_filter" },
                        "key": "caucuses",
                        "label": "Caucuses",
                        "qdts": [25],
                        "querymethod": "caucus_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 6,
                        "visualization_subtype": 1
                    },
                    "click_rate": {
                        "filter_keys": {},
                        "key": "click_rate",
                        "label": "Click Rate",
                        "qdts": [44, 113],
                        "querymethod": "click_rate_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 41,
                        "visualization_subtype": 1
                    },
                    "clicks": {
                        "filter_keys": {},
                        "key": "clicks",
                        "label": "Clicked",
                        "qdts": [44, 113],
                        "querymethod": "clicks_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 40,
                        "visualization_subtype": 1
                    },
                    "committees": {
                        "filter_keys": { "2": "from_committee", "25": "source_committee_filter" },
                        "key": "committees",
                        "label": "Committees",
                        "qdts": [2, 25],
                        "querymethod": "committee_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 4,
                        "visualization_subtype": 1
                    },
                    "contacts": {
                        "filter_keys": { "20": "involving_supporter", "25": "associated_with_supporter", "69": "involving_supporter" },
                        "key": "contacts",
                        "label": "Contacts",
                        "qdts": [25, 69, 20, 107, 135],
                        "querymethod": "contact_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 7,
                        "visualization_subtype": 1
                    },
                    "conversions": {
                        "filter_keys": {},
                        "key": "conversions",
                        "label": "Conversions",
                        "qdts": [113],
                        "querymethod": "conversions_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 80,
                        "visualization_subtype": 1
                    },
                    "cosponsors": {
                        "filter_keys": { "2": "cosponsored_by_or" },
                        "key": "cosponsors",
                        "label": "Co-Sponsors",
                        "qdts": [2],
                        "querymethod": "cosponsor_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 2,
                        "visualization_subtype": 1
                    },
                    "counties": {
                        "filter_keys": { "25": "for_counties" },
                        "key": "counties",
                        "label": "Counties",
                        "qdts": [25],
                        "querymethod": "county_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 16,
                        "visualization_subtype": 1
                    },
                    "country": {
                        "filter_keys": {},
                        "key": "country",
                        "label": "Countries",
                        "qdts": [105, 120],
                        "querymethod": { "105": "term_frequency_tuples", "120": "country_frequency_tuples" },
                        "querymethod_kwargs": { "field_name": "source__country", "postprocess_func": "postprocess_country_frequency_tuples" },
                        "supported_regions_qdt": {},
                        "value": 64,
                        "visualization_subtype": 1
                    },
                    "created_by_user": {
                        "filter_keys": {},
                        "key": "created_by_user",
                        "label": "Team Member Created",
                        "qdts": [44, 113],
                        "querymethod": "created_by_user_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 48,
                        "visualization_subtype": 1
                    },
                    "creators": {
                        "filter_keys": { "20": "involving_creator" },
                        "key": "creators",
                        "label": "Creators",
                        "qdts": [20],
                        "querymethod": "creator_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 12,
                        "visualization_subtype": 1
                    },
                    "custom": {
                        "filter_keys": {},
                        "key": "custom",
                        "label": "Custom",
                        "qdts": [],
                        "supported_regions_qdt": {},
                        "value": 61,
                        "visualization_subtype": 4
                    },
                    "date_fields": [32, 33, 34, 35],
                    "document_types": {
                        "enum": { "25": "app.document.models.DocumentType" },
                        "filter_keys": { "25": "document_type__in" },
                        "key": "document_types",
                        "label": "Types",
                        "qdts": [25],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 25,
                        "visualization_subtype": 1
                    },
                    "election": {
                        "filter_keys": { "107": "transaction_election", "135": "transaction_election" },
                        "key": "election",
                        "label": "Election",
                        "qdts": [107, 135],
                        "querymethod": "election_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 77,
                        "visualization_subtype": 1
                    },
                    "email_count": {
                        "filter_keys": {},
                        "key": "email_count",
                        "label": "Sent",
                        "qdts": [44],
                        "querymethod": "email_count_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 37,
                        "visualization_subtype": 1
                    },
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Who",
                            "values": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 62, 63, 74, 81]
                        },
                        {
                            "display": "list",
                            "title": "Where",
                            "values": [15, 16, 17, 59, 60, 61, 64]
                        },
                        {
                            "display": "list",
                            "title": "What",
                            "values": [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 65, 66, 67, 68, 69, 70, 72, 71, 73, 75, 76, 77, 78, 79, 80]
                        },
                        {
                            "display": "list",
                            "title": "When",
                            "values": [32, 33, 34, 35]
                        }
                    ],
                    "grassroots_note_types": {
                        "enum": { "69": "app.userdata.types.InteractionType" },
                        "filter_keys": { "69": "interaction_type__in" },
                        "key": "grassroots_note_types",
                        "label": "Types",
                        "qdts": [69],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 27,
                        "visualization_subtype": 1
                    },
                    "hashtags": {
                        "filter_keys": { "25": "contains_hashtags" },
                        "key": "hashtags",
                        "label": "Hashtags",
                        "qdts": [25],
                        "querymethod": "hashtag_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 29,
                        "visualization_subtype": 1
                    },
                    "heat": {
                        "filter_keys": {
                            "1": { "2": "for_supported_regions" },
                            "10000": { "1": "representing_state", "105": "for_states", "12": "representing_state", "120": "representing_state", "2": "for_supported_regions", "20": "for_regions", "25": "for_regions", "42": "for_regions", "69": "for_regions", "8": "representing_state", "80": "for_regions" },
                            "10001": { "2": "for_supported_regions" },
                            "10003": { "1": "representing_country", "105": "for_countries", "12": "representing_country", "120": "representing_country", "20": "for_countries", "25": "for_countries", "42": "for_countries", "69": "for_countries" },
                            "106": { "1": "representing_country", "105": "for_countries", "12": "representing_country", "120": "representing_country", "2": "for_countries", "20": "for_countries", "25": "for_countries", "42": "for_countries", "69": "for_countries" }
                        },
                        "key": "heat",
                        "label": "Heat",
                        "qdts": [2, 25, 12, 69, 1, 42, 80, 20, 105, 8, 120],
                        "querymethod": "region_frequency_tuples",
                        "supported_regions_qdt": {
                            "1": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "105": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "12": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "120": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "2": [1, 10000, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 10001, 10000, 106, 201, 203, 204, 208, 205, 211, 1000],
                            "20": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "25": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "42": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "69": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "80": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 107, 108, 109, 110, 1, 204, 201, 203, 208, 205, 211]
                        },
                        "value": 59,
                        "visualization_subtype": 4
                    },
                    "international_party": {
                        "filter_keys": { "20": null, "25": "party" },
                        "key": "international_party",
                        "label": "Party",
                        "qdts": [25, 20],
                        "querymethod": "international_party_frequency_tuples",
                        "supported_regions": [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241],
                        "supported_regions_qdt": {},
                        "value": 81,
                        "visualization_subtype": 1
                    },
                    "issue_priority": {
                        "filter_keys": {},
                        "key": "issue_priority",
                        "label": "Priorities",
                        "qdts": [105, 120],
                        "querymethod": "in_issue_frequency_tuples",
                        "querymethod_kwargs": { "issue_display_field": "priority" },
                        "supported_regions_qdt": {},
                        "value": 69,
                        "visualization_subtype": 1
                    },
                    "issues": {
                        "filter_keys": { "1": "in_issue_or", "105": "in_issue_or", "114": "in_issue_or", "12": "in_issue_or", "120": "in_issue_or", "15": "in_issue_or", "16": "in_issue_or", "2": "in_issue_or", "20": "for_project_and_subprojects", "25": "in_issue_or", "28": "in_issue_or", "3": "in_issue_or", "4": "in_issue_or", "42": "in_issue_or", "8": "in_issue_or", "80": "in_issue_or" },
                        "key": "issues",
                        "label": "Issues",
                        "qdts": [4, 2, 44, 16, 15, 25, 28, 105, 20, 1, 114, 120, 42, 80, 8, 12, 3],
                        "querymethod": "in_issue_frequency_tuples",
                        "querymethod_kwargs": { "issue_display_field": "name" },
                        "supported_regions_qdt": {},
                        "value": 24,
                        "visualization_subtype": 1
                    },
                    "language": {
                        "enum": { "105": "app.document.types.Language" },
                        "filter_keys": { "105": "language" },
                        "key": "language",
                        "label": "Language",
                        "qdts": [],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": { "field_name": "language" },
                        "supported_regions_qdt": {},
                        "value": 36,
                        "visualization_subtype": 1
                    },
                    "leg_stance": {
                        "filter_keys": {},
                        "key": "leg_stance",
                        "label": "Stance",
                        "qdts": [105, 120],
                        "querymethod": "stance_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 71,
                        "visualization_subtype": 1
                    },
                    "lists": {
                        "filter_keys": {},
                        "key": "lists",
                        "label": "Lists",
                        "qdts": [105],
                        "querymethod": "in_issue_frequency_tuples",
                        "querymethod_kwargs": { "issue_display_field": "new_lists__name" },
                        "supported_regions_qdt": {},
                        "value": 70,
                        "visualization_subtype": 1
                    },
                    "media_type": {
                        "filter_keys": {},
                        "key": "media_type",
                        "label": "Media Types",
                        "qdts": [105],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": { "field_name": "source__media_type", "postprocess_func": "postprocess_media_type_frequency_tuples" },
                        "supported_regions_qdt": {},
                        "value": 67,
                        "visualization_subtype": 1
                    },
                    "mentions": {
                        "filter_keys": { "25": "contains_mentions" },
                        "key": "mentions",
                        "label": "Mentions",
                        "qdts": [25],
                        "querymethod": "mention_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 10,
                        "visualization_subtype": 1
                    },
                    "month": {
                        "filter_keys": { "105": null, "107": null, "12": null, "135": null, "2": null, "20": null, "25": null, "28": null, "3": null, "4": null, "62": null, "69": null, "80": null },
                        "key": "month",
                        "label": "Months",
                        "qdts": [4, 62, 2, 25, 28, 69, 105, 20, 80, 12, 107, 135, 3],
                        "supported_regions_qdt": {},
                        "value": 32,
                        "visualization_subtype": 1
                    },
                    "municipalities": {
                        "filter_keys": { "25": "for_municipalities" },
                        "key": "municipalities",
                        "label": "Municipalities",
                        "qdts": [25],
                        "querymethod": "municipality_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 17,
                        "visualization_subtype": 1
                    },
                    "note_custom_interaction_types": {
                        "filter_keys": { "20": "custom_interaction_type__in" },
                        "key": "note_custom_interaction_types",
                        "label": "Types",
                        "qdts": [20],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 28,
                        "visualization_subtype": 1
                    },
                    "note_types": {
                        "enum": { "20": "app.userdata.types.InteractionType" },
                        "filter_keys": { "20": "interaction_type__in" },
                        "key": "note_types",
                        "label": "Donation Types",
                        "qdts": [20],
                        "querymethod": "donation_type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 26,
                        "visualization_subtype": 1
                    },
                    "offices": {
                        "filter_keys": { "20": "involving_office" },
                        "key": "offices",
                        "label": "Offices",
                        "qdts": [20],
                        "querymethod": "office_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 13,
                        "visualization_subtype": 1
                    },
                    "official_clicks": {
                        "filter_keys": {},
                        "key": "official_clicks",
                        "label": "Official Clicks",
                        "qdts": [44],
                        "querymethod": "clicked_by_official_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 56,
                        "visualization_subtype": 1
                    },
                    "official_opens": {
                        "filter_keys": {},
                        "key": "official_opens",
                        "label": "Official Opens",
                        "qdts": [44],
                        "querymethod": "opened_by_official_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 53,
                        "visualization_subtype": 1
                    },
                    "official_received": {
                        "filter_keys": {},
                        "key": "official_received",
                        "label": "Official Received",
                        "qdts": [44],
                        "querymethod": "received_by_official_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 50,
                        "visualization_subtype": 1
                    },
                    "officials": {
                        "filter_keys": { "20": "involving_member", "25": "source_members", "69": "involving_member" },
                        "key": "officials",
                        "label": "Officials",
                        "qdts": [25, 69, 20],
                        "querymethod": "person_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 5,
                        "visualization_subtype": 1
                    },
                    "open_rate": {
                        "filter_keys": {},
                        "key": "open_rate",
                        "label": "Open Rate",
                        "qdts": [44],
                        "querymethod": "open_rate_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 39,
                        "visualization_subtype": 1
                    },
                    "opens": {
                        "filter_keys": {},
                        "key": "opens",
                        "label": "Opened",
                        "qdts": [44],
                        "querymethod": "opens_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 38,
                        "visualization_subtype": 1
                    },
                    "organizations": {
                        "filter_keys": { "20": "involving_public_organization_and_associated_individuals", "25": "searchify_source_public_organization" },
                        "key": "organizations",
                        "label": "Organizations",
                        "qdts": [25, 20, 107, 135],
                        "querymethod": { "107": "public_organization_frequency_tuples", "135": "public_organization_frequency_tuples", "20": "public_organization_frequency_tuples", "25": "organization_frequency_tuples" },
                        "supported_regions_qdt": {},
                        "value": 8,
                        "visualization_subtype": 1
                    },
                    "outlet": {
                        "filter_keys": { "105": "source__name" },
                        "key": "outlet",
                        "label": "Outlets",
                        "qdts": [105, 120],
                        "querymethod": { "105": "term_frequency_tuples", "120": "outlet_frequency_tuples" },
                        "querymethod_kwargs": { "field_name": "source__name" },
                        "supported_regions_qdt": {},
                        "value": 63,
                        "visualization_subtype": 1
                    },
                    "participants": {
                        "filter_keys": { "20": "involving_user" },
                        "key": "participants",
                        "label": "Participants",
                        "qdts": [20],
                        "querymethod": "team_member_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 11,
                        "visualization_subtype": 1
                    },
                    "party": {
                        "enum": { "107": "app.pac.types.FecParty", "114": "app.pac.types.FecParty", "135": "app.pac_classic.types.PacClassicPartyType", "2": "app.person.types.Party", "20": "app.person.types.Party", "25": "app.person.types.Party", "69": "app.person.types.Party" },
                        "filter_keys": { "114": "party__in", "2": "for_parties", "20": null, "25": "party", "69": null },
                        "key": "party",
                        "label": "Party",
                        "qdts": [2, 25, 69, 20, 114, 107, 135],
                        "querymethod": "party_frequency_tuples",
                        "supported_regions": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 106],
                        "supported_regions_qdt": {},
                        "value": 3,
                        "visualization_subtype": 1
                    },
                    "point": {
                        "filter_keys": { "12": "id__in", "69": "id__in" },
                        "key": "point",
                        "label": "Point",
                        "qdts": [79, 69, 12],
                        "querymethod": "point_frequency_tuples",
                        "supported_regions_qdt": {
                            "12": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "69": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 1000, 9999, 10000, 10001, 10002, 10003, 10004, 10005],
                            "79": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 10000, 10001, 10002]
                        },
                        "value": 60,
                        "visualization_subtype": 4
                    },
                    "political_committee": {
                        "filter_keys": {},
                        "key": "political_committee",
                        "label": "Political Committee",
                        "qdts": [107],
                        "querymethod": "political_committee_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 74,
                        "visualization_subtype": 1
                    },
                    "political_committee_types": {
                        "enum": { "114": "app.pac.types.PoliticalCommitteeType" },
                        "filter_keys": { "114": "committee_type__in" },
                        "key": "political_committee_types",
                        "label": "Political Committee Type",
                        "qdts": [114],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 73,
                        "visualization_subtype": 1
                    },
                    "priority": {
                        "enum": { "2": "app.userdata.types.LegislativePriorityType", "80": "app.userdata.types.LegislativePriorityType" },
                        "filter_keys": { "2": "my_priority", "80": "my_priority" },
                        "key": "priority",
                        "label": "Priority",
                        "qdts": [2, 80],
                        "querymethod": "priority_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 23,
                        "visualization_subtype": 1
                    },
                    "quarter": {
                        "filter_keys": { "105": null, "107": null, "12": null, "135": null, "2": null, "20": null, "25": null, "28": null, "3": null, "4": null, "62": null, "69": null, "80": null },
                        "key": "quarter",
                        "label": "Quarters",
                        "qdts": [4, 62, 2, 25, 28, 69, 105, 20, 80, 12, 107, 135, 3],
                        "supported_regions_qdt": {},
                        "value": 34,
                        "visualization_subtype": 1
                    },
                    "rank": {
                        "filter_keys": { "105": "source__rank__in" },
                        "key": "rank",
                        "label": "Rank",
                        "qdts": [105],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": { "field_name": "source__rank" },
                        "supported_regions_qdt": {},
                        "value": 65,
                        "visualization_subtype": 1
                    },
                    "regulation_types": {
                        "enum": { "80": "app.reg.types.RegType" },
                        "filter_keys": { "80": "reg_type__in" },
                        "key": "regulation_types",
                        "label": "Regulation Types",
                        "qdts": [80],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 31,
                        "visualization_subtype": 1
                    },
                    "reply_count": {
                        "filter_keys": {},
                        "key": "reply_count",
                        "label": "Replies",
                        "qdts": [44],
                        "querymethod": "reply_count_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 46,
                        "visualization_subtype": 1
                    },
                    "retweets": {
                        "filter_keys": { "25": "retweet_sources" },
                        "key": "retweets",
                        "label": "Retweets",
                        "qdts": [25],
                        "querymethod": "retweet_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 9,
                        "visualization_subtype": 1
                    },
                    "role_type": {
                        "filter_keys": {},
                        "key": "role_type",
                        "label": "Types",
                        "qdts": [120],
                        "querymethod": "role_type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 72,
                        "visualization_subtype": 1
                    },
                    "sent_by_user": {
                        "filter_keys": {},
                        "key": "sent_by_user",
                        "label": "Team Member Sent",
                        "qdts": [44],
                        "querymethod": "sent_by_user_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 49,
                        "visualization_subtype": 1
                    },
                    "sms_count": {
                        "filter_keys": {},
                        "key": "sms_count",
                        "label": "Sent",
                        "qdts": [113],
                        "querymethod": "sms_count_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 79,
                        "visualization_subtype": 1
                    },
                    "source_industries": {
                        "filter_keys": { "105": "for_article_source_editorial_topics" },
                        "key": "source_industries",
                        "label": "Source Industries",
                        "qdts": [105],
                        "querymethod": "term_frequency_tuples",
                        "querymethod_kwargs": { "field_name": "source__editorial_topics" },
                        "supported_regions_qdt": {},
                        "value": 68,
                        "visualization_subtype": 1
                    },
                    "sources": {
                        "filter_keys": { "12": "source_type__in", "69": "source_type__in" },
                        "key": "sources",
                        "label": "Sources",
                        "qdts": [69, 12],
                        "querymethod": "source_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 30,
                        "visualization_subtype": 1
                    },
                    "sponsors": {
                        "filter_keys": { "2": "sponsored_or_cosponsored_by_or" },
                        "key": "sponsors",
                        "label": "Sponsors",
                        "qdts": [2],
                        "querymethod": "person_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 1,
                        "visualization_subtype": 1
                    },
                    "staffer_clicks": {
                        "filter_keys": {},
                        "key": "staffer_clicks",
                        "label": "Staffer Clicks",
                        "qdts": [44],
                        "querymethod": "clicked_by_staffer_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 57,
                        "visualization_subtype": 1
                    },
                    "staffer_opens": {
                        "filter_keys": {},
                        "key": "staffer_opens",
                        "label": "Staffer Opens",
                        "qdts": [44],
                        "querymethod": "opened_by_staffer_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 54,
                        "visualization_subtype": 1
                    },
                    "staffer_received": {
                        "filter_keys": {},
                        "key": "staffer_received",
                        "label": "Staffer Received",
                        "qdts": [44],
                        "querymethod": "received_by_staffer_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 51,
                        "visualization_subtype": 1
                    },
                    "stance": {
                        "enum": { "2": "app.userdata.types.LegislativeStanceType", "80": "app.userdata.types.LegislativeStanceType" },
                        "filter_keys": { "2": "my_stance", "80": "my_stance" },
                        "key": "stance",
                        "label": "Stance",
                        "qdts": [2, 80],
                        "querymethod": "stance_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 22,
                        "visualization_subtype": 1
                    },
                    "states": {
                        "filter_keys": { "105": "for_states", "107": "for_regions", "114": "for_regions", "120": "for_regions", "2": "for_supported_regions", "20": "for_regions", "25": "for_regions", "69": "for_regions", "80": "for_regions" },
                        "key": "states",
                        "label": "States",
                        "qdts": [2, 25, 69, 105, 20, 114, 120, 80, 107, 135],
                        "querymethod": "state_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 15,
                        "visualization_subtype": 1
                    },
                    "status": {
                        "enum": { "2": "app.bill.status.GeneralBillStatus", "80": "app.reg.types.GeneralRegStatus" },
                        "filter_keys": { "2": "current_general_status__in", "80": "general_status__in" },
                        "key": "status",
                        "label": "Status",
                        "qdts": [2, 80],
                        "querymethod": "status_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 21,
                        "visualization_subtype": 1
                    },
                    "supporter_bounces": {
                        "filter_keys": {},
                        "key": "supporter_bounces",
                        "label": "Bounces (Contacts)",
                        "qdts": [44],
                        "querymethod": "supporter_bounces_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 44,
                        "visualization_subtype": 1
                    },
                    "supporter_clicks": {
                        "filter_keys": {},
                        "key": "supporter_clicks",
                        "label": "Contact Clicks",
                        "qdts": [44, 113],
                        "querymethod": "clicked_by_supporter_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 58,
                        "visualization_subtype": 1
                    },
                    "supporter_opens": {
                        "filter_keys": {},
                        "key": "supporter_opens",
                        "label": "Contact Opens",
                        "qdts": [44],
                        "querymethod": "opened_by_supporter_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 55,
                        "visualization_subtype": 1
                    },
                    "supporter_received": {
                        "filter_keys": {},
                        "key": "supporter_received",
                        "label": "Contact Received",
                        "qdts": [44, 113],
                        "querymethod": "received_by_supporter_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 52,
                        "visualization_subtype": 1
                    },
                    "texts_failures": {
                        "filter_keys": {},
                        "key": "texts_failures",
                        "label": "Failures",
                        "qdts": [113],
                        "querymethod": "failures_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 78,
                        "visualization_subtype": 1
                    },
                    "transaction_method": {
                        "enum": { "107": "app.ledger.types.TransactionMethodType", "135": "app.pac_classic.types.PacClassicTransactionMethodType" },
                        "filter_keys": { "107": "transaction_method__in", "135": "transaction_method__in" },
                        "key": "transaction_method",
                        "label": "Transaction Method",
                        "qdts": [107, 135],
                        "querymethod": "method_type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 75,
                        "visualization_subtype": 1
                    },
                    "transaction_types": {
                        "enum": { "107": "app.ledger.types.TransactionType", "135": "app.pac_classic.types.PacClassicTransactionType" },
                        "filter_keys": { "107": "transaction_type__in", "135": "transaction_type__in" },
                        "key": "transaction_types",
                        "label": "Transaction Type",
                        "qdts": [107, 135],
                        "querymethod": "type_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 76,
                        "visualization_subtype": 1
                    },
                    "unsubscribes": {
                        "filter_keys": {},
                        "key": "unsubscribes",
                        "label": "Unsubscribes",
                        "qdts": [44, 113],
                        "querymethod": "unsubscribes_frequency_tuples",
                        "supported_regions_qdt": {},
                        "value": 42,
                        "visualization_subtype": 1
                    },
                    "valid_bar_qdts": [1, 2, 3, 4, 135, 8, 12, 15, 16, 20, 25, 28, 42, 44, 47, 62, 69, 80, 105, 107, 113, 114, 120],
                    "valid_map_qdts": [1, 2, 69, 8, 105, 42, 12, 79, 80, 20, 120, 25],
                    "week": {
                        "filter_keys": { "105": null, "107": null, "12": null, "135": null, "2": null, "20": null, "25": null, "28": null, "3": null, "4": null, "62": null, "69": null, "80": null },
                        "key": "week",
                        "label": "Weeks",
                        "qdts": [4, 62, 2, 25, 28, 69, 105, 20, 80, 12, 107, 3, 135],
                        "supported_regions_qdt": {},
                        "value": 33,
                        "visualization_subtype": 1
                    },
                    "year": {
                        "filter_keys": { "105": null, "107": null, "114": null, "12": null, "135": null, "2": null, "20": null, "25": null, "28": null, "3": null, "4": null, "62": null, "69": null, "80": null },
                        "key": "year",
                        "label": "Years",
                        "qdts": [4, 62, 2, 25, 28, 69, 20, 105, 114, 80, 12, 107, 135, 3],
                        "supported_regions_qdt": {},
                        "value": 35,
                        "visualization_subtype": 1
                    }
                },
                "LineGraphTimeIntervals": {
                    "__is_enum": true,
                    "day": {
                        "key": "day",
                        "label": "Days",
                        "trunc": "day",
                        "ttl": { "hours": 6 },
                        "value": 1
                    },
                    "month": {
                        "key": "month",
                        "label": "Months",
                        "trunc": "month",
                        "ttl": { "days": 2 },
                        "value": 3
                    },
                    "quarter": {
                        "key": "quarter",
                        "label": "Quarters",
                        "trunc": "quarter",
                        "ttl": { "days": 2 },
                        "value": 4
                    },
                    "week": {
                        "key": "week",
                        "label": "Weeks",
                        "trunc": "week",
                        "ttl": { "days": 1 },
                        "value": 2
                    },
                    "year": {
                        "key": "year",
                        "label": "Years",
                        "trunc": "year",
                        "ttl": { "days": 7 },
                        "value": 5
                    }
                },
                "MapVisualizationHeatColorScale": {
                    "__is_enum": true,
                    "quantize": { "d3_key": "scaleQuantize", "key": "quantize", "label": "Quantize", "value": 2 },
                    "sequential": { "d3_key": "scaleSequential", "key": "sequential", "label": "Sequential", "value": 1 }
                },
                "MapVisualizationHeatColorType": {
                    "__is_enum": true,
                    "custom": { "key": "custom", "label": "Custom", "value": 2 },
                    "default": { "key": "default", "label": "Default", "value": 1 }
                },
                "MapVisualizationHeatInterpolationColorSpace": {
                    "__is_enum": true,
                    "cube_helix": { "d3_key": "interpolateCubehelix", "key": "cube_helix", "label": "Cube Helix", "value": 7 },
                    "cube_helix_long": { "d3_key": "interpolateCubehelixLong", "key": "cube_helix_long", "label": "Cube Helix Long", "value": 8 },
                    "hcl": { "d3_key": "interpolateHcl", "key": "hcl", "label": "HCL", "value": 5 },
                    "hcl_long": { "d3_key": "interpolateHclLong", "key": "hcl_long", "label": "HCL Long", "value": 6 },
                    "hsl": { "d3_key": "interpolateHsl", "key": "hsl", "label": "HSL", "value": 2 },
                    "hsl_long": { "d3_key": "interpolateHslLong", "key": "hsl_long", "label": "HSL Long", "value": 3 },
                    "lab": { "d3_key": "interpolateLab", "key": "lab", "label": "LAB", "value": 4 },
                    "rgb": { "d3_key": "interpolateRgb", "key": "rgb", "label": "RGB", "value": 1 }
                },
                "MapVisualizationHeatInterpolationColors": {
                    "__is_enum": true,
                    "blue": { "d3_quantize_key": "schemeBlues", "d3_sequential_key": "interpolateBlues", "key": "blue", "label": "Blue", "type": "single", "value": 10 },
                    "blue_green": { "d3_quantize_key": "schemeBuGn", "d3_sequential_key": "interpolateBuGn", "key": "blue_green", "label": "Blue Green", "type": "multi", "value": 25 },
                    "blue_purple": { "d3_quantize_key": "schemeBuPu", "d3_sequential_key": "interpolateBuPu", "key": "blue_purple", "label": "Blue Purple", "type": "multi", "value": 26 },
                    "brown_blue_green": { "d3_quantize_key": "schemeBrBG", "d3_sequential_key": "interpolateBrBG", "key": "brown_blue_green", "label": "Brown Blue Green", "type": "diverging", "value": 1 },
                    "cividis": { "d3_sequential_key": "interpolateCividis", "key": "cividis", "label": "Cividis", "type": "multi", "value": 21 },
                    "cool": { "d3_sequential_key": "interpolateCool", "key": "cool", "label": "Cool", "type": "multi", "value": 23 },
                    "cube_helix_default": { "d3_sequential_key": "interpolateCubehelixDefault", "key": "cube_helix_default", "label": "Cube Helix Default", "type": "multi", "value": 24 },
                    "cyclical": [37, 38],
                    "diverging": [1, 2, 3, 4, 5, 6, 7, 8, 9],
                    "filter_groups": [
                        {
                            "display": "list",
                            "title": "Diverging",
                            "values": [1, 2, 3, 4, 5, 6, 7, 8, 9]
                        },
                        {
                            "display": "list",
                            "title": "Single",
                            "values": [10, 11, 12, 13, 14, 15]
                        },
                        {
                            "display": "list",
                            "title": "Multi",
                            "values": [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]
                        },
                        {
                            "display": "list",
                            "title": "Cyclical",
                            "values": [37, 38]
                        }
                    ],
                    "green": { "d3_quantize_key": "schemeGreens", "d3_sequential_key": "interpolateGreens", "key": "green", "label": "Green", "type": "single", "value": 11 },
                    "green_blue": { "d3_quantize_key": "schemeGnBu", "d3_sequential_key": "interpolateGnBu", "key": "green_blue", "label": "Green Blue", "type": "multi", "value": 27 },
                    "grey": { "d3_quantize_key": "schemeGreys", "d3_sequential_key": "interpolateGreys", "key": "grey", "label": "Grey", "type": "single", "value": 12 },
                    "inferno": { "d3_sequential_key": "interpolateInferno", "key": "inferno", "label": "Inferno", "type": "multi", "value": 18 },
                    "magma": { "d3_sequential_key": "interpolateMagma", "key": "magma", "label": "Magma", "type": "multi", "value": 19 },
                    "multi": [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
                    "orange": { "d3_quantize_key": "schemeOranges", "d3_sequential_key": "interpolateOranges", "key": "orange", "label": "Orange", "type": "single", "value": 13 },
                    "orange_red": { "d3_quantize_key": "schemeOrRd", "d3_sequential_key": "interpolateOrRd", "key": "orange_red", "label": "Orange Red", "type": "multi", "value": 28 },
                    "pink_yellow_green": { "d3_quantize_key": "schemePiYG", "d3_sequential_key": "interpolatePiYG", "key": "pink_yellow_green", "label": "Pink Yellow Green", "type": "diverging", "value": 3 },
                    "plasma": { "d3_sequential_key": "interpolatePlasma", "key": "plasma", "label": "Plasma", "type": "multi", "value": 20 },
                    "purple": { "d3_quantize_key": "schemePurples", "d3_sequential_key": "interpolatePurples", "key": "purple", "label": "Purple", "type": "single", "value": 14 },
                    "purple_blue": { "d3_quantize_key": "schemePuBu", "d3_sequential_key": "interpolatePuBu", "key": "purple_blue", "label": "Purple Blue", "type": "multi", "value": 30 },
                    "purple_blue_green": { "d3_quantize_key": "schemePuBuGn", "d3_sequential_key": "interpolatePuBuGn", "key": "purple_blue_green", "label": "Purple Blue Green", "type": "multi", "value": 29 },
                    "purple_green": { "d3_quantize_key": "schemePRGn", "d3_sequential_key": "interpolatePRGn", "key": "purple_green", "label": "Purple Green", "type": "diverging", "value": 2 },
                    "purple_orange": { "d3_quantize_key": "schemePuOr", "d3_sequential_key": "interpolatePuOr", "key": "purple_orange", "label": "Purple Orange", "type": "diverging", "value": 4 },
                    "purple_red": { "d3_quantize_key": "schemePuRd", "d3_sequential_key": "interpolatePuRd", "key": "purple_red", "label": "Purple Red", "type": "multi", "value": 31 },
                    "rainbow": { "d3_sequential_key": "interpolateRainbow", "key": "rainbow", "label": "Rainbow", "type": "cyclical", "value": 37 },
                    "red": { "d3_quantize_key": "schemeReds", "d3_sequential_key": "interpolateReds", "key": "red", "label": "Red", "type": "single", "value": 15 },
                    "red_blue": { "d3_quantize_key": "schemeRdBu", "d3_sequential_key": "interpolateRdBu", "key": "red_blue", "label": "Red Blue", "type": "diverging", "value": 5 },
                    "red_grey": { "d3_quantize_key": "schemeRdGy", "d3_sequential_key": "interpolateRdGy", "key": "red_grey", "label": "Red Grey", "type": "diverging", "value": 6 },
                    "red_purple": { "d3_quantize_key": "schemeRdPu", "d3_sequential_key": "interpolateRdPu", "key": "red_purple", "label": "Red Purple", "type": "multi", "value": 32 },
                    "red_yellow_blue": { "d3_quantize_key": "schemeRdYlBu", "d3_sequential_key": "interpolateRdYlBu", "key": "red_yellow_blue", "label": "Red Yellow Blue", "type": "diverging", "value": 7 },
                    "red_yellow_green": { "d3_quantize_key": "schemeRdYlGn", "d3_sequential_key": "interpolateRdYlGn", "key": "red_yellow_green", "label": "Red Yellow Green", "type": "diverging", "value": 8 },
                    "sinebow": { "d3_sequential_key": "interpolateSinebow", "key": "sinebow", "label": "Sinebow", "type": "cyclical", "value": 38 },
                    "single": [10, 11, 12, 13, 14, 15],
                    "spectral": { "d3_quantize_key": "schemeSpectral", "d3_sequential_key": "interpolateSpectral", "key": "spectral", "label": "Spectral", "type": "diverging", "value": 9 },
                    "turbo": { "d3_sequential_key": "interpolateTurbo", "key": "turbo", "label": "Turbo", "type": "multi", "value": 16 },
                    "viridis": { "d3_sequential_key": "interpolateViridis", "key": "viridis", "label": "Viridis", "type": "multi", "value": 17 },
                    "warm": { "d3_sequential_key": "interpolateWarm", "key": "warm", "label": "Warm", "type": "multi", "value": 22 },
                    "yellow_green": { "d3_quantize_key": "schemeYlGn", "d3_sequential_key": "interpolateYlGn", "key": "yellow_green", "label": "Yellow Green", "type": "multi", "value": 34 },
                    "yellow_green_blue": { "d3_quantize_key": "schemeYlGnBu", "d3_sequential_key": "interpolateYlGnBu", "key": "yellow_green_blue", "label": "Yellow Green Blue", "type": "multi", "value": 33 },
                    "yellow_orange_brown": { "d3_quantize_key": "schemeYlOrBr", "d3_sequential_key": "interpolateYlOrBr", "key": "yellow_orange_brown", "label": "Yellow Orange Brown", "type": "multi", "value": 35 },
                    "yellow_orange_red": { "d3_quantize_key": "schemeYlOrRd", "d3_sequential_key": "interpolateYlOrRd", "key": "yellow_orange_red", "label": "Yellow Orange Red", "type": "multi", "value": 36 }
                },
                "MapVisualizationRegion": {
                    "__is_enum": true,
                    "eu": { "d3_projection": "geoAzimuthalEqualArea", "d3_topology_key": "NUTS_RG_10M_2021_4326", "d3_url": "https://gisco-services.ec.europa.eu/distribution/v2/nuts/topojson/NUTS_RG_10M_2021_4326_LEVL_0.json", "key": "eu", "label": "European Union (EU)", "supported_region": 106, "value": 3 },
                    "us": { "d3_projection": "geoAlbersUsa", "d3_topology_key": "states", "d3_url": "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json", "key": "us", "label": "United States", "supported_region": 10000, "value": 2 },
                    "world": { "d3_projection": "geoEqualEarth", "d3_topology_key": "countries", "d3_url": "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json", "key": "world", "label": "World", "supported_region": 10003, "value": 1 }
                },
                "NumberWidgetDisplayType": {
                    "__is_enum": true,
                    "count": { "icon": "hashtag", "key": "count", "label": "Count", "value": 1 },
                    "fraction": { "icon": "divide", "key": "fraction", "label": "Fraction", "operation": 1, "value": 3 },
                    "percentage": { "icon": "percent", "key": "percentage", "label": "Percentage", "operation": 2, "value": 2 },
                    "sum": {
                        "feature_flags": ["ff_pac"],
                        "icon": "plus",
                        "key": "sum",
                        "label": "Sum",
                        "permission_enum": [8, 215],
                        "value": 4
                    }
                },
                "QuicklinkType": {
                    "__is_enum": true,
                    "custom": { "key": "custom", "label": "Add Your Custom Quicklink", "sort": -1, "value": 1 },
                    "new_campaign": {
                        "key": "new_campaign",
                        "label": "New Campaign",
                        "permission_enum": [201],
                        "sort": 5,
                        "url": "/action_centers/",
                        "value": 7
                    },
                    "new_contact": {
                        "key": "new_contact",
                        "label": "Add Contact",
                        "permission_enum": [3, 102],
                        "sort": 8,
                        "url": "/edit_contact/",
                        "value": 10
                    },
                    "new_disbursement": {
                        "feature_flags": ["ff_pac"],
                        "key": "new_disbursement",
                        "label": "New Disbursement",
                        "permission_enum": [8],
                        "sort": 12,
                        "url": "/pacinternal/:ledgerSettingsId/transactions/disbursement/new/",
                        "value": 14
                    },
                    "new_download": { "key": "new_download", "label": "New Download", "sort": 4, "url": "/download_center/", "value": 6 },
                    "new_email": { "key": "new_email", "label": "New Email", "sort": 0, "url": "/outbox/compose/", "value": 2 },
                    "new_event": {
                        "key": "new_event",
                        "label": "New Event",
                        "permission_enum": [3],
                        "sort": 2,
                        "url": "/edit_custom_event/",
                        "value": 4
                    },
                    "new_file": {
                        "key": "new_file",
                        "label": "Add File",
                        "permission_enum": [3],
                        "sort": 7,
                        "url": "/search/files/",
                        "value": 9
                    },
                    "new_issue": { "key": "new_issue", "label": "New Issue", "sort": 1, "url": "/issue_management/new/", "value": 3 },
                    "new_note": { "key": "new_note", "label": "Add Note", "sort": 10, "url": "/log_interaction/", "value": 12 },
                    "new_org": { "key": "new_org", "label": "Create Organization", "sort": 9, "url": "/edit_organization/", "value": 11 },
                    "new_receipt": {
                        "feature_flags": ["ff_pac"],
                        "key": "new_receipt",
                        "label": "New Receipt",
                        "permission_enum": [8],
                        "sort": 11,
                        "url": "/pacinternal/:ledgerSettingsId/transactions/receipt/new/",
                        "value": 13
                    },
                    "new_sheet": { "key": "new_sheet", "label": "New Sheet", "sort": 3, "url": "/sheets/new/", "value": 5 },
                    "new_tracking_dashboard": {
                        "key": "new_tracking_dashboard",
                        "label": "New Tracking Board",
                        "permission_enum": [1, 2, 100, 101, 103],
                        "sort": 6,
                        "url": "/tracking_board/new/",
                        "value": 8
                    }
                },
                "ReactGridLayoutTypes": {
                    "__is_enum": true,
                    "free": { "key": "free", "label": "free", "value": 3 },
                    "horizontal": { "compactType": "horizontal", "key": "horizontal", "label": "horizontal", "value": 2 },
                    "vertical": { "compactType": "vertical", "key": "vertical", "label": "vertical", "value": 1 }
                },
                "VisualizationSubtype": {
                    "__is_enum": true,
                    "bar": { "icon": "chart-bar", "icon_family": "far", "key": "bar", "label": "Bar", "value": 1 },
                    "line": { "icon": "chart-line", "icon_family": "far", "key": "line", "label": "Line", "value": 3 },
                    "map": { "icon": "map", "icon_family": "far", "key": "map", "label": "Map", "value": 4 },
                    "pie": { "icon": "chart-pie", "icon_family": "fas", "key": "pie", "label": "Pie", "value": 2 }
                },
                "WidgetOperation": {
                    "__is_enum": true,
                    "fraction": { "key": "fraction", "label": "Fraction", "number_of_data_sources": 2, "value": 1 },
                    "percentage": { "key": "percentage", "label": "Percentage", "number_of_data_sources": 2, "value": 2 }
                }
            }
        }
    },
    "djangio": {
        "types": {
            "FieldType": {
                "AutoField": { "key": "AutoField", "label": "AutoField", "should_show_column_math": false, "value": 9 },
                "BinaryField": { "key": "BinaryField", "label": "BinaryField", "should_show_column_math": false, "value": 10 },
                "BooleanField": { "category": "bool", "key": "BooleanField", "label": "BooleanField", "should_show_column_math": false, "value": 1 },
                "CharField": { "category": "string", "key": "CharField", "label": "CharField", "should_show_column_math": false, "value": 2 },
                "DateField": { "category": "date", "key": "DateField", "label": "DateField", "should_show_column_math": false, "value": 5 },
                "DateTimeField": { "key": "DateTimeField", "label": "DateTimeField", "should_show_column_math": false, "value": 16 },
                "DecimalField": { "category": "number", "key": "DecimalField", "label": "DecimalField", "should_show_column_math": true, "value": 6 },
                "DurationField": { "key": "DurationField", "label": "DurationField", "should_show_column_math": false, "value": 12 },
                "FileField": { "key": "FileField", "label": "FileField", "should_show_column_math": false, "value": 17 },
                "FilePathField": { "key": "FilePathField", "label": "FilePathField", "should_show_column_math": false, "value": 18 },
                "FloatField": { "category": "number", "key": "FloatField", "label": "FloatField", "should_show_column_math": true, "value": 13 },
                "ForeignKey": { "key": "ForeignKey", "label": "ForeignKey", "should_show_column_math": false, "value": 7 },
                "GenericIPAddressField": { "key": "GenericIPAddressField", "label": "GenericIPAddressField", "should_show_column_math": false, "value": 20 },
                "IPAddressField": { "key": "IPAddressField", "label": "IPAddressField", "should_show_column_math": false, "value": 19 },
                "IntegerField": { "category": "number", "key": "IntegerField", "label": "IntegerField", "should_show_column_math": true, "value": 4 },
                "ManyToManyField": { "key": "ManyToManyField", "label": "ManyToManyField", "should_show_column_math": false, "value": 8 },
                "NullBooleanField": { "key": "NullBooleanField", "label": "NulLBooleanField", "should_show_column_math": false, "value": 11 },
                "QuorumDateTimeField": { "category": "date", "key": "QuorumDateTimeField", "label": "QuorumDateTimeField", "should_show_column_math": false, "value": 21 },
                "TextField": { "category": "string", "key": "TextField", "label": "TextField", "should_show_column_math": false, "value": 3 },
                "TimeField": { "key": "TimeField", "label": "TimeField", "should_show_column_math": false, "value": 15 },
                "UUIDField": { "key": "UUIDField", "label": "UUIDField", "should_show_column_math": false, "value": 14 },
                "__is_enum": true
            }
        }
    },
    "quorum": {
        "sso": {
            "models": {
                "SSOProfile": {
                    "__is_model": true,
                    "__name__": "SSOProfile",
                    "data_model": "quorum.sso.models.SSOProfile",
                    "default_exclude_filters": {},
                    "default_filters": {},
                    "endpoint": "/api/ssoprofile/",
                    "fields": [
                        { "field_type": 9, "help_text": "", "name": "id", "verbose_name": "ID" },
                        { "field_type": 2, "help_text": "The name of the organization, will be set in the ACS (Assertion Consumer Service) URL. ex: https://www.quorum.us/login/sso/acs/{org_name}/", "name": "name", "verbose_name": "name" },
                        { "field_type": 2, "help_text": "Profile Entity ID, for organzations with more than one profile (up to 9 are possible). If blank, entity ID is https://www.quorum.usNOTE: The CA Signed entity ID uses a special certificate signed by a commercial Certificate Authority - it expires EVERY YEAR. Use it only if you are absolutely CERTAIN you need to.", "name": "entity_id", "verbose_name": "entity id" },
                        { "field_type": 1, "help_text": "If an organization only has one SSO profile, this should be True. If multiple profiles, only True for one profile used for the Quorum Platform (not the Grassoots Action Center", "name": "is_default_profile", "verbose_name": "is default profile" },
                        { "field_type": 3, "help_text": "Stringified XML of the Identity Provider's metadata sent to us", "name": "metadata", "verbose_name": "metadata" },
                        {
                            "field_type": 7,
                            "help_text": "The Organization that this identity provider is associated with.",
                            "name": "organization",
                            "related_model": { "__module__": "app.userdata.models", "__name__": "Organization" },
                            "verbose_name": "organization"
                        },
                        { "field_type": 1, "help_text": "Is this SSO Profile for signing into Grassroots Action Centers? (Otherwise, it is for the Quorum Platform)", "name": "for_grassroots", "verbose_name": "for grassroots" },
                        { "field_type": 1, "help_text": "Should use SHA-256 as the signing algorithm (alternative is SHA-1) Default True", "name": "should_use_default_signing_algorithm", "verbose_name": "should use default signing algorithm" },
                        { "field_type": 1, "help_text": "Should check if the X509 certificate in the metadata matches the certificate in the response. Default True", "name": "should_validate_certificate", "verbose_name": "should validate certificate" },
                        { "field_type": 1, "help_text": "When navigating to grassroots and action center is not publicly accessible, should redirect to SSO login if enabled. Default True", "name": "should_auto_grassroots_login", "verbose_name": "should auto grassroots login" },
                        { "field_type": 3, "help_text": "The attribute we will use as the unique identifier / employee id to login the user (If not using NameID)", "name": "login_attribute", "verbose_name": "login attribute" },
                        { "field_type": 1, "help_text": "If true, the SP will allow unsolicited SAML Responses (Responses for which it has not sent a respective SAML Request). Default True", "name": "allow_unsolicited", "verbose_name": "allow unsolicited" },
                        { "field_type": 1, "help_text": "Indicates if the Authentication Requests sent by this SP should be signed by default. Default True", "name": "authn_requests_signed", "verbose_name": "authn requests signed" },
                        { "field_type": 1, "help_text": "Indicates if this entity will sign the Logout Requests originated from it. Default True", "name": "logout_requests_signed", "verbose_name": "logout requests signed" },
                        { "field_type": 1, "help_text": "Indicates if this SP wants the IdP to send the assertions signed. Default True", "name": "want_assertions_signed", "verbose_name": "want assertions signed" },
                        { "field_type": 1, "help_text": "Indicates that Authentication Responses to this SP must be signed. Default False", "name": "want_response_signed", "verbose_name": "want response signed" },
                        { "field_type": null, "help_text": "Whitelist of redirect urls to be used for SSO redirection", "name": "allowed_redirect_domains", "verbose_name": "allowed redirect domains" },
                        { "field_type": 1, "help_text": "Disable SSO login flow for the mobile app, allowing users to log in via username/password.Allows clients with strict mobile device SSO policies to still use SSO for the web app.", "name": "disable_sso_on_mobile", "verbose_name": "disable sso on mobile" },
                        { "field_type": 2, "help_text": "Custom label for the SSO login button in Action Centers", "name": "button_label", "verbose_name": "button label" },
                        {
                            "field_type": 8,
                            "help_text": "Action Centers that are associated with this SSO profile.",
                            "name": "action_centers",
                            "related_model": { "__module__": "app.grassroots.models", "__name__": "ActionCenterSettings" },
                            "verbose_name": "action centers"
                        }
                    ]
                }
            }
        },
        "types": {
            "LoginType": {
                "__is_enum": true,
                "blacklisted_browser": { "key": "blacklisted_browser", "label": "Blacklisted Browser", "path": "/login/blacklisted/", "value": 2 },
                "forgot_password": { "key": "forgot_password", "label": "Forgot Password", "path": "/recover/", "value": 9 },
                "forgot_password_invalid_email": { "key": "forgot_password_invalid_email", "label": "Forgot Password Invalid Email", "value": 20 },
                "forgot_password_sent": { "key": "forgot_password_sent", "label": "Forgot Password Sent", "path": "/login/sent/", "value": 10 },
                "invalid_login": { "key": "invalid_login", "label": "Invalid Login", "path": "/login/invalid/", "value": 1 },
                "invalid_registration_link": { "key": "invalid_registration_link", "label": "Invalid Registration Link", "path": "/login/invalid-registration-link/", "value": 18 },
                "invalid_reset_password_two_factor": { "key": "invalid_reset_password_two_factor", "label": "Invalid Reset Password Two Factor", "path": "/login/invalid-two-factor/", "value": 25 },
                "invalid_single_sign_on": { "key": "invalid_single_sign_on", "label": "Invalid Single Sign On", "path": "/login/invalid-single-sign-on/", "value": 22 },
                "invalid_two_factor": { "key": "invalid_two_factor", "label": "Invalid Two Factor", "path": "/login/invalid-two-factor/", "value": 23 },
                "ip_not_allowed": { "key": "ip_not_allowed", "label": "Forgot Password Sent", "path": "/login/ip-not-allowed/", "value": 11 },
                "limited_login_error": { "key": "limited_login_error", "label": "Limited Login Error", "path": "/login/limited-login/", "value": 12 },
                "logged_out": { "key": "logged_out", "label": "Logged Out", "path": "/logout/", "value": 14 },
                "login": { "key": "login", "label": "Login", "path": "/login/", "value": 4 },
                "max_members_exceeded": { "key": "max_members_exceeded", "label": "Max Members Exceeded", "path": "/login/max-members-exceeded/", "value": 19 },
                "password": { "key": "password", "label": "Password", "path": "/login/password/", "value": 6 },
                "password_before_two_factor": { "key": "password_before_two_factor", "label": "Password Form Before Two Factor", "path": "/login/password/", "value": 7 },
                "reset_password": { "key": "reset_password", "label": "Reset Password", "value": 15 },
                "reset_password_fail": { "key": "reset_password_fail", "label": "Reset Password Fail", "value": 16 },
                "reset_password_success": { "key": "reset_password_success", "label": "Reset Password Success", "path": "/login/", "value": 17 },
                "reset_password_two_factor": { "key": "reset_password_two_factor", "label": "Reset Password Two Factor", "path": "/login/two-factor/", "value": 24 },
                "single_sign_on": { "key": "single_sign_on", "label": "Single Sign On", "path": "/login/single-sign-on/", "value": 21 },
                "success": { "key": "success", "label": "Successful Login", "value": 3 },
                "trial_expired": { "key": "trial_expired", "label": "Trial Expired", "path": "/login/trial-expired/", "value": 13 },
                "two_factor": { "key": "two_factor", "label": "Two Factor", "path": "/login/two-factor/", "value": 8 },
                "unsupported_browser_login": { "key": "unsupported_browser_login", "label": "Unsupported Browser Login", "path": "/login/unsupported/", "value": 5 }
            }
        }
    }
} as const

export type DjangIOType = typeof DjangIOCache
